/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/
var ShowModalResultType;
(function (ShowModalResultType) {
    // The dialog was not shown because the host has not provided support for it.
    ShowModalResultType["NotImplemented"] = "not_implemented";
    // The user followed the dialog flow to completion.
    ShowModalResultType["Success"] = "success";
    // The user canceled the dialog.
    ShowModalResultType["Cancel"] = "cancel";
    // The user interacted with the host in a way that closed the dialog (e.g. pressing escape,
    // clicking outside the dialog, or clicking the close button at the top right).
    ShowModalResultType["Close"] = "close";
    // The dialog was closed as part of an error flow, typically accompanied by a toast.
    ShowModalResultType["Error"] = "error";
})(ShowModalResultType || (ShowModalResultType = {}));
// TODO: https://jira.corp.adobe.com/browse/CCXCD-14030
// Import these types and enums below from component-types into CDO/UAB
/* eslint-disable @typescript-eslint/no-namespace */
var CDO;
(function (CDO) {
    (function (ActionType) {
        /** Default action type. This action is shown for each asset in the Action menu, Context Menu and Action Bar */
        ActionType["Asset"] = "asset";
        /** This action applies to the currently navigated route in CDO. It will be rendered in the Header of the provided route/tab
         * Example: New Folder, Upload, etc.
         */
        ActionType["Route"] = "route";
    })(CDO.ActionType || (CDO.ActionType = {}));
    (function (ClickSelectType) {
        ClickSelectType["Single"] = "single";
        ClickSelectType["Double"] = "double";
        ClickSelectType["None"] = "none";
    })(CDO.ClickSelectType || (CDO.ClickSelectType = {}));
})(CDO || (CDO = {}));
var ContentViewType;
(function (ContentViewType) {
    ContentViewType["CloudDocuments"] = "cloud-documents";
    ContentViewType["Deleted"] = "deleted";
    ContentViewType["SharedWithYou"] = "shared-with-you";
    ContentViewType["Recents"] = "recents";
    ContentViewType["ReviewLinks"] = "review-links";
    ContentViewType["ConvertToSketch"] = "sketch";
    ContentViewType["Libraries"] = "libraries";
    ContentViewType["Local"] = "local";
    ContentViewType["Projects"] = "projects";
    ContentViewType["Project"] = "project";
    ContentViewType["GenerationHistory"] = "generation-history";
    ContentViewType["Favorites"] = "favorites";
})(ContentViewType || (ContentViewType = {}));
var OtherFileTypeValues;
(function (OtherFileTypeValues) {
    OtherFileTypeValues["AllFiles"] = "ALL_FILES";
    OtherFileTypeValues["Folder"] = "FOLDER";
    OtherFileTypeValues["Project"] = "PROJECT";
    OtherFileTypeValues["ReviewLink"] = "REVIEW_LINK";
})(OtherFileTypeValues || (OtherFileTypeValues = {}));
var GenericFileTypeValues;
(function (GenericFileTypeValues) {
    GenericFileTypeValues["Assets3d"] = "ASSETS_3D";
    GenericFileTypeValues["Images"] = "IMAGES";
    GenericFileTypeValues["Videos"] = "VIDEOS";
    GenericFileTypeValues["Audio"] = "AUDIO";
})(GenericFileTypeValues || (GenericFileTypeValues = {}));
var AdobeFileTypeValues;
(function (AdobeFileTypeValues) {
    AdobeFileTypeValues["Photoshop"] = "PHOTOSHOP";
    AdobeFileTypeValues["Illustrator"] = "ILLUSTRATOR";
    AdobeFileTypeValues["Express"] = "EXPRESS";
    AdobeFileTypeValues["Acrobat"] = "PDF";
    AdobeFileTypeValues["InDesign"] = "INDESIGN";
    AdobeFileTypeValues["Aero"] = "AERO";
    AdobeFileTypeValues["XD"] = "XD";
    AdobeFileTypeValues["Concept"] = "CONCEPT";
    AdobeFileTypeValues["Squirrel"] = "SQUIRREL";
})(AdobeFileTypeValues || (AdobeFileTypeValues = {}));
var LibrariesAndBrandsTypeValues;
(function (LibrariesAndBrandsTypeValues) {
    LibrariesAndBrandsTypeValues["Libraries"] = "LIBRARIES";
    LibrariesAndBrandsTypeValues["Brands"] = "BRANDS";
})(LibrariesAndBrandsTypeValues || (LibrariesAndBrandsTypeValues = {}));
var FireflyGenerationTypeValues;
(function (FireflyGenerationTypeValues) {
    FireflyGenerationTypeValues["GenerationAll"] = "FIREFLY_GENERATION_ALL";
    FireflyGenerationTypeValues["GenerationImage"] = "FIREFLY_GENERATION_IMAGE";
    FireflyGenerationTypeValues["GenerationVideo"] = "FIREFLY_GENERATION_VIDEO";
})(FireflyGenerationTypeValues || (FireflyGenerationTypeValues = {}));
Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, GenericFileTypeValues), AdobeFileTypeValues), OtherFileTypeValues), LibrariesAndBrandsTypeValues), FireflyGenerationTypeValues);
var SAMLogLevel;
(function (SAMLogLevel) {
    SAMLogLevel[SAMLogLevel["Off"] = 0] = "Off";
    SAMLogLevel[SAMLogLevel["Medium"] = 1] = "Medium";
    SAMLogLevel[SAMLogLevel["High"] = 2] = "High";
})(SAMLogLevel || (SAMLogLevel = {}));
var CDOLogLevel;
(function (CDOLogLevel) {
    CDOLogLevel[CDOLogLevel["DEBUG"] = 0] = "DEBUG";
    CDOLogLevel[CDOLogLevel["INFO"] = 1] = "INFO";
    CDOLogLevel[CDOLogLevel["WARN"] = 2] = "WARN";
    CDOLogLevel[CDOLogLevel["ERROR"] = 3] = "ERROR";
    CDOLogLevel[CDOLogLevel["DISABLED"] = 4] = "DISABLED";
})(CDOLogLevel || (CDOLogLevel = {}));
var AccountType;
(function (AccountType) {
    AccountType["Personal"] = "type1";
    AccountType["Enterprise"] = "type2";
    AccountType["Business"] = "type3";
    AccountType["Federated"] = "type2e";
})(AccountType || (AccountType = {}));
/**
 * PickerMode is an enum for quickly configuring parts of CDP UI to show/hide various
 * features including tabs, buttons, and behvaioral changes. Modes can be sent through several APIs including through
 * Panel.tsx, Commands.tsx, and WebCommands.tsx, returned from host.getPickerInfo() calls and
 * through a PICKERSTATECHANGED event sent from UXP which provides the new mode.
 * The mode is also sent through executeValidPickerAction call into the host.
 */
var PickerMode;
(function (PickerMode) {
    /**
     * Place mode that is for the 2021 Place workflow. This mode will be just like Open but will have different
     * analytics and a different callback.
     */
    PickerMode["placeLinkOrEmbed"] = "placeLinkOrEmbed";
    /**
     * Link Assets mode that is primarily used with XD. This mode is not considered a "Save As" mode meaning
     * it's primarily used for "Opening Documents" scenarios.
     * Visible Tabs - Cloud Documents, Shared With You, Convert To Sketch Libraries.
     */
    PickerMode["linkAssets"] = "linkAssets";
    /**
     * The primary mode for users when selecting documents to open. When a document is clicked, it's
     * selected and then highlights the "Open" button so the user can opened the selected document.
     * This mode is not considered a "Save As" view mode.
     * Visible Tabs - Recent Tab, Cloud Documents Tab, Shared With you tab.
     */
    PickerMode["open"] = "open";
    /**
     * The primary mode for CDP when Saving Documents to the host application. Shows the "Save As" header
     * with an input for the user to type. This mode is unlike "Opening" modes in that the users is supposed
     * to provide a name for the file to be saved. It  shows a "Save" Button and no "On Your Computer"
     * buttons. When an item is clicked, we set the Save As Input field to the name of the item that was clicked.
     */
    PickerMode["saveAs"] = "saveAs";
    /**
     * This is another "Save As" mode that shoud be identical to PickerMode.saveAs. The main difference
     * here is for the host app to know when a user invoked Save As Copy instead of just a plain
     * Save As. When an item is clicked, we set the Save As Input field to the name of the item that was clicked.
     */
    PickerMode["saveAsCopy"] = "saveAsCopy";
    PickerMode["saveToFolder"] = "saveToFolder";
    /**
     * This is another "Save As" mode that shoud be similar (not identical) to PickerMode.saveAs. Header and
     * primaryButton labels will display 'export' specific labelling. Like "Save As", user can update the name of
     * exported asset and choose the export format.
     */
    PickerMode["export"] = "export";
    /**
     * Copy items to Projects or Cloud Documents.
     */
    PickerMode["copy"] = "copy";
    /**
     * Generic move for moving items to new location.
     */
    PickerMode["move"] = "move";
    /**
     * Move item(s) to a target location. (e.g. assets from Files to Projects)
     */
    PickerMode["moveFrom"] = "moveFrom";
    /**
     * Generic mode for selecting an asset and returning it to the caller
     */
    PickerMode["add"] = "add";
})(PickerMode || (PickerMode = {}));
var GetBlockedAssetsResponse;
(function (GetBlockedAssetsResponse) {
    /**
     * Proceed with the operation
     */
    GetBlockedAssetsResponse["Ok"] = "ok";
    /**
     * Skip the operation for this asset, perhaps because the host application
     * performs the operation instead, or the operation is not supported or
     * some other reason
     */
    GetBlockedAssetsResponse["Cancel"] = "cancel";
    /**
     * Skip the operation for this asset, and notify the user that it could not
     * be performed because the asset is open in the host application
     */
    GetBlockedAssetsResponse["CancelBecauseOpen"] = "cancel-open";
})(GetBlockedAssetsResponse || (GetBlockedAssetsResponse = {}));
var Capability;
(function (Capability) {
    Capability["ShareSheetInvite"] = "invite";
    Capability["ShareSheetLink"] = "getLink";
    Capability["ShareSheetAction"] = "share";
})(Capability || (Capability = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/
/**
 * TODO - pull in LinkStatus from SAM.js (wait until SAM.js converts to enums)
 */
var LinkStatus;
(function (LinkStatus) {
    LinkStatus["UpToDate"] = "UpToDate";
    LinkStatus["OutOfDate"] = "OutOfDate";
    LinkStatus["MetadataOutOfDate"] = "MetadataOutOfDate";
    LinkStatus["Restricted"] = "Restricted";
    LinkStatus["Discarded"] = "Discarded";
    LinkStatus["Broken"] = "Broken";
})(LinkStatus || (LinkStatus = {}));
var Role;
(function (Role) {
    Role["Edit"] = "Edit";
    Role["View"] = "View";
    Role["None"] = "None";
})(Role || (Role = {}));
/**
 * Message types used in CCLibrariesInterface
 */
var MessageType$1;
(function (MessageType) {
    MessageType["assets"] = "ccac.dap.in.notify.assets";
    MessageType["update"] = "ccac.dap.out.notify.update";
    MessageType["config"] = "ccac.dap.in.notify.config";
    MessageType["showShare"] = "ccac.dap.out.notify.showShare";
    MessageType["requestAction"] = "ccac.libraries.out.request.action";
    MessageType["requestUpdate"] = "ccac.libraries.in.request.update";
    MessageType["applyElements"] = "ccac.libraries.out.request.apply";
})(MessageType$1 || (MessageType$1 = {}));
/**
 * Action types for 'ccac.libraries.out.request.action' message type
 */
var RequestActionTypes;
(function (RequestActionTypes) {
    RequestActionTypes["openPicker"] = "openPicker";
    RequestActionTypes["openShareSheet"] = "openShareSheet";
    RequestActionTypes["openPreview"] = "openPreview";
})(RequestActionTypes || (RequestActionTypes = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/
// Types related to the libraries and document assets data models
/**
 * TODO: Should pull these in from the Libraries API type definitions
 */
var ElementType;
(function (ElementType) {
    ElementType["animation"] = "application/vnd.adobe.element.animation+dcx";
    ElementType["audio"] = "application/vnd.adobe.element.audio+dcx";
    ElementType["brush"] = "application/vnd.adobe.element.brush+dcx";
    ElementType["characterstyle"] = "application/vnd.adobe.element.characterstyle+dcx";
    ElementType["color"] = "application/vnd.adobe.element.color+dcx";
    ElementType["colortheme"] = "application/vnd.adobe.element.colortheme+dcx";
    ElementType["component"] = "application/vnd.adobe.element.component+dcx";
    ElementType["font"] = "application/vnd.adobe.element.font+dcx";
    ElementType["gradient"] = "application/vnd.adobe.element.gradient+dcx";
    ElementType["graphic"] = "application/vnd.adobe.element.image+dcx";
    ElementType["layerstyle"] = "application/vnd.adobe.element.layerstyle+dcx";
    ElementType["light"] = "application/vnd.adobe.element.light+dcx";
    ElementType["look"] = "application/vnd.adobe.element.look+dcx";
    ElementType["material"] = "application/vnd.adobe.element.material+dcx";
    ElementType["model"] = "application/vnd.adobe.element.3d+dcx";
    ElementType["mogrt"] = "application/vnd.adobe.element.graphic+dcx";
    ElementType["multicolorswatch"] = "application/vnd.adobe.element.multicolorswatch+dcx";
    ElementType["paragraphstyle"] = "application/vnd.adobe.element.paragraphstyle+dcx";
    ElementType["pattern"] = "application/vnd.adobe.element.pattern+dcx";
    ElementType["template"] = "application/vnd.adobe.element.template+dcx";
    ElementType["text"] = "application/vnd.adobe.element.text+dcx";
    ElementType["video"] = "application/vnd.adobe.element.video+dcx";
    ElementType["artifact"] = "application/vnd.adobe.element.artifact+dcx";
})(ElementType || (ElementType = {}));
/**
 * TODO: Should pull these in from the Libraries API type definitions
 */
var Relationship;
(function (Relationship) {
    Relationship["primary"] = "primary";
    Relationship["rendition"] = "rendition";
})(Relationship || (Relationship = {}));

/**
 * @deprecated -- will be removed on or after 2024-10-01. Clients should use {@link AdobeAsset.isFolder} etc. instead.
 */
var AssetType$1;
(function (AssetType) {
    AssetType[AssetType["Folder"] = 256] = "Folder";
    AssetType[AssetType["File"] = 512] = "File";
    AssetType[AssetType["Composite"] = 1024] = "Composite";
})(AssetType$1 || (AssetType$1 = {}));
var AssetSyncStatus$1;
(function (AssetSyncStatus) {
    AssetSyncStatus[AssetSyncStatus["InSync"] = 0] = "InSync";
    AssetSyncStatus[AssetSyncStatus["OutOfSync"] = 1] = "OutOfSync";
    AssetSyncStatus[AssetSyncStatus["SyncConflict"] = 2] = "SyncConflict";
    AssetSyncStatus[AssetSyncStatus["SyncError"] = 3] = "SyncError";
    AssetSyncStatus[AssetSyncStatus["Syncing"] = 4] = "Syncing";
})(AssetSyncStatus$1 || (AssetSyncStatus$1 = {}));
var AssetSyncSuspensionReason$1;
(function (AssetSyncSuspensionReason) {
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["None"] = 0] = "None";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["CloudContentCorrupted"] = 1] = "CloudContentCorrupted";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["LocalContentCorrupted"] = 2] = "LocalContentCorrupted";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["HasTooManyComponents"] = 3] = "HasTooManyComponents";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["HasTooManyChildren"] = 4] = "HasTooManyChildren";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["MaximumSizeExceeded"] = 5] = "MaximumSizeExceeded";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["Unknown"] = 6] = "Unknown";
})(AssetSyncSuspensionReason$1 || (AssetSyncSuspensionReason$1 = {}));
/**
 * Response from the server for the commit request.
 **/
var CommitStatus$1;
(function (CommitStatus) {
    CommitStatus[CommitStatus["NoErr"] = 0] = "NoErr";
    CommitStatus[CommitStatus["Conflict"] = 1] = "Conflict";
    CommitStatus[CommitStatus["DeleteConflict"] = 2] = "DeleteConflict";
    CommitStatus[CommitStatus["ParentDeletedConflict"] = 3] = "ParentDeletedConflict";
})(CommitStatus$1 || (CommitStatus$1 = {}));

var CloudSyncStatus$1;
(function (CloudSyncStatus) {
    CloudSyncStatus[CloudSyncStatus["Initializing"] = 0] = "Initializing";
    CloudSyncStatus[CloudSyncStatus["Offline"] = 1] = "Offline";
    CloudSyncStatus[CloudSyncStatus["NotStarted"] = 2] = "NotStarted";
    CloudSyncStatus[CloudSyncStatus["Disabled"] = 3] = "Disabled";
    CloudSyncStatus[CloudSyncStatus["Synchronized"] = 4] = "Synchronized";
    CloudSyncStatus[CloudSyncStatus["InProgress"] = 5] = "InProgress";
    CloudSyncStatus[CloudSyncStatus["ErrorQuotaExceeded"] = 6] = "ErrorQuotaExceeded";
    CloudSyncStatus[CloudSyncStatus["ErrorSyncDown"] = 7] = "ErrorSyncDown";
    CloudSyncStatus[CloudSyncStatus["ErrorOther"] = 8] = "ErrorOther";
})(CloudSyncStatus$1 || (CloudSyncStatus$1 = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Enum for network status currently only used with the Native Bindings
 * so this has been migrated from AssetContext to help avoid importing
 * AssetContext directly instead of by type.
 *
 * @note Must be kept in sync with NetworkStatus in AssetContext.h
 */
var NetworkStatus$2;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["Offline"] = 0] = "Offline";
    NetworkStatus[NetworkStatus["Wan"] = 1] = "Wan";
    NetworkStatus[NetworkStatus["Cellular"] = 2] = "Cellular";
    NetworkStatus[NetworkStatus["OnlineUnknown"] = 3] = "OnlineUnknown";
})(NetworkStatus$2 || (NetworkStatus$2 = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var AvatarSizes$1;
(function (AvatarSizes) {
    AvatarSizes["Size50"] = "50";
    AvatarSizes["Size100"] = "100";
    AvatarSizes["Size115"] = "115";
    AvatarSizes["Size230"] = "230";
    AvatarSizes["Size138"] = "138";
    AvatarSizes["Size276"] = "276";
})(AvatarSizes$1 || (AvatarSizes$1 = {}));

var Env$1;
(function (Env) {
    Env[Env["Stage"] = 0] = "Stage";
    Env[Env["Production"] = 1] = "Production";
})(Env$1 || (Env$1 = {}));

var AssetListStatus$1;
(function (AssetListStatus) {
    AssetListStatus[AssetListStatus["NotStarted"] = 1] = "NotStarted";
    AssetListStatus[AssetListStatus["HadLoaderErrors"] = 2] = "HadLoaderErrors";
    AssetListStatus[AssetListStatus["Loading"] = 3] = "Loading";
    AssetListStatus[AssetListStatus["ReadyHasMorePages"] = 4] = "ReadyHasMorePages";
    AssetListStatus[AssetListStatus["ReadyFullyLoaded"] = 5] = "ReadyFullyLoaded";
})(AssetListStatus$1 || (AssetListStatus$1 = {}));

var OrderDirection$1;
(function (OrderDirection) {
    OrderDirection[OrderDirection["Ascending"] = 0] = "Ascending";
    OrderDirection[OrderDirection["Descending"] = 1] = "Descending";
})(OrderDirection$1 || (OrderDirection$1 = {}));
var OrderField$1;
(function (OrderField) {
    OrderField[OrderField["Name"] = 0] = "Name";
    OrderField[OrderField["Modified"] = 1] = "Modified";
    OrderField[OrderField["Created"] = 2] = "Created";
    OrderField[OrderField["Shared"] = 3] = "Shared";
})(OrderField$1 || (OrderField$1 = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var LogLevel$2;
(function (LogLevel) {
    LogLevel[LogLevel["Off"] = 0] = "Off";
    LogLevel[LogLevel["Err"] = 1] = "Err";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel$2 || (LogLevel$2 = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var SAMErrorCode$1;
(function (SAMErrorCode) {
    SAMErrorCode[SAMErrorCode["UNKNOWN"] = 1] = "UNKNOWN";
    SAMErrorCode[SAMErrorCode["FULL_LOCAL_DISK_SPACE"] = 2] = "FULL_LOCAL_DISK_SPACE";
    SAMErrorCode[SAMErrorCode["FULL_CLOUD_STORAGE"] = 3] = "FULL_CLOUD_STORAGE";
    SAMErrorCode[SAMErrorCode["DEVICE_OFFLINE"] = 4] = "DEVICE_OFFLINE";
    SAMErrorCode[SAMErrorCode["NETWORK_ERROR"] = 5] = "NETWORK_ERROR";
    SAMErrorCode[SAMErrorCode["REQUEST_TIMED_OUT"] = 6] = "REQUEST_TIMED_OUT";
    SAMErrorCode[SAMErrorCode["USER_CANCELLED"] = 7] = "USER_CANCELLED";
    SAMErrorCode[SAMErrorCode["CORESYNC_FAILURE"] = 8] = "CORESYNC_FAILURE";
    /**
     * CoreSync is in a paused state.
     */
    SAMErrorCode[SAMErrorCode["SYNC_PAUSED"] = 9] = "SYNC_PAUSED";
    SAMErrorCode[SAMErrorCode["USER_ALREADY_REGISTERED"] = 10] = "USER_ALREADY_REGISTERED";
    SAMErrorCode[SAMErrorCode["PENDING_UNCOMMITTED_CHANGES_FROM_THIS_APP"] = 11] = "PENDING_UNCOMMITTED_CHANGES_FROM_THIS_APP";
    SAMErrorCode[SAMErrorCode["PENDING_UNCOMMITTED_CHANGES_FROM_ANOTHER_APP"] = 12] = "PENDING_UNCOMMITTED_CHANGES_FROM_ANOTHER_APP";
    SAMErrorCode[SAMErrorCode["INTERNAL_ERROR"] = 13] = "INTERNAL_ERROR";
    SAMErrorCode[SAMErrorCode["OPERATION_IGNORED"] = 14] = "OPERATION_IGNORED";
    /**
     * Indicates that the request could not be processed because of conflict
     * in the current state of the resource.
     * <br>Client Action: Resolve conflict and try again.
     */
    SAMErrorCode[SAMErrorCode["CONFLICT"] = 15] = "CONFLICT";
    /**
     * Happens when interacting with an asset the user no longer has access to.
     */
    SAMErrorCode[SAMErrorCode["ACCESS_DENIED"] = 16] = "ACCESS_DENIED";
    SAMErrorCode[SAMErrorCode["UNSUPPORTED"] = 17] = "UNSUPPORTED";
    SAMErrorCode[SAMErrorCode["ASSET_NOT_IN_SYNC"] = 18] = "ASSET_NOT_IN_SYNC";
    SAMErrorCode[SAMErrorCode["BAD_REQUEST"] = 19] = "BAD_REQUEST";
    /**
     * Happens if asset failed to sync.
     * There are associated sub-codes relating to this error which may have
     * more information
     */
    SAMErrorCode[SAMErrorCode["SYNC_ERROR"] = 20] = "SYNC_ERROR";
    /**
     * Happens if requests is made for an asset that cannot be found.
     */
    SAMErrorCode[SAMErrorCode["NOT_FOUND"] = 21] = "NOT_FOUND";
    /**
     * Happens when there is authorization error while performing the request
     * for e.g. if requests are made which require user to be registered with
     * ACPL, but user is not registered.
     */
    SAMErrorCode[SAMErrorCode["AUTHORIZATION_ERROR"] = 22] = "AUTHORIZATION_ERROR";
    /**
     * Happens while performing an invalid operation for e.g. when attempting
     * to migrate an asset to RepoNaming that has already been migrated
     */
    SAMErrorCode[SAMErrorCode["INVALID_OPERATION"] = 23] = "INVALID_OPERATION";
    /**
     * Happens when a method is called on a asset that require that the
     * asset have a context, but none is present or the asset does not
     * belong to specified context.
     */
    SAMErrorCode[SAMErrorCode["INVALID_CONTEXT"] = 24] = "INVALID_CONTEXT";
    /**
     * An error occured during committing changes.
     * Error sub-code may have more information around this
     */
    SAMErrorCode[SAMErrorCode["COMMIT_ERROR"] = 25] = "COMMIT_ERROR";
    /**
     *  Parent not found for the asset
     */
    SAMErrorCode[SAMErrorCode["PARENT_NOT_FOUND"] = 26] = "PARENT_NOT_FOUND";
    /**
     * Parent folder is discarded
     */
    SAMErrorCode[SAMErrorCode["PARENT_DISCARDED"] = 27] = "PARENT_DISCARDED";
    /**
     * Project limit exceeded
     */
    SAMErrorCode[SAMErrorCode["PROJECT_LIMIT_EXCEEDED"] = 28] = "PROJECT_LIMIT_EXCEEDED";
    /**
     * The user or organization is not provisioned
     * for the requested service access.
     */
    SAMErrorCode[SAMErrorCode["SERVICE_NOT_PROVISIONED"] = 29] = "SERVICE_NOT_PROVISIONED";
})(SAMErrorCode$1 || (SAMErrorCode$1 = {}));
var SAMErrorSubCode$1;
(function (SAMErrorSubCode) {
    SAMErrorSubCode[SAMErrorSubCode["NONE"] = 0] = "NONE";
    SAMErrorSubCode[SAMErrorSubCode["CORESYNC_NOT_REACHABLE"] = 1] = "CORESYNC_NOT_REACHABLE";
    SAMErrorSubCode[SAMErrorSubCode["CORESYNC_NOT_COMPATIBLE"] = 2] = "CORESYNC_NOT_COMPATIBLE";
    /**
     * Happens if CoreSync binary is not present.  Ask end user install coresync
     */
    SAMErrorSubCode[SAMErrorSubCode["CORESYNC_BINARY_NOT_FOUND"] = 3] = "CORESYNC_BINARY_NOT_FOUND";
    /**
     * Happens if CoreSync is not installed. Ask end user to install/upgrade coresync.
     */
    SAMErrorSubCode[SAMErrorSubCode["CORESYNC_NOT_INSTALLED"] = 4] = "CORESYNC_NOT_INSTALLED";
    /**
     * Happens if asset failed to sync. Sync will be retried by ACPL.
     * Cient may wait for subsequent sync notification for the asset or retry
     * the operation.
     */
    SAMErrorSubCode[SAMErrorSubCode["SYNC_FAILED"] = 5] = "SYNC_FAILED";
    /**
     * Syncing the asset failed due to an EditEdit conflict, but the conflict
     * was resolved
     */
    SAMErrorSubCode[SAMErrorSubCode["SYNC_FAILED_EDIT_EDIT_RESOLVED"] = 6] = "SYNC_FAILED_EDIT_EDIT_RESOLVED";
    /**
     * Syncing the asset failed due to an EditDelete conflict, but the conflict
     * was resolved
     */
    SAMErrorSubCode[SAMErrorSubCode["SYNC_FAILED_EDIT_DELETE_RESOLVED"] = 7] = "SYNC_FAILED_EDIT_DELETE_RESOLVED";
    /**
     * An error occured while moving an orphan to the root folder.
     */
    SAMErrorSubCode[SAMErrorSubCode["COMMIT_ON_ORPHAN_ERROR"] = 8] = "COMMIT_ON_ORPHAN_ERROR";
    /**
     * Admin disabled creation of Projects
     * https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=assetscollab&title=Proposal%3A+Project+API+V3+-+Capability
     */
    SAMErrorSubCode[SAMErrorSubCode["PROJECTS_ADMIN_ONLY"] = 9] = "PROJECTS_ADMIN_ONLY";
    /**
     * 404 specific projects errors.
     * https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=assetscollab&title=Proposal%3A+Project+API+V3+-+Capability
     */
    SAMErrorSubCode[SAMErrorSubCode["PROJECTS_INVALID_REPOSITORY"] = 10] = "PROJECTS_INVALID_REPOSITORY";
    SAMErrorSubCode[SAMErrorSubCode["PROJECTS_NO_HOME_REPOSITORY"] = 11] = "PROJECTS_NO_HOME_REPOSITORY";
})(SAMErrorSubCode$1 || (SAMErrorSubCode$1 = {}));
var ProblemType$1;
(function (ProblemType) {
    ProblemType["LIMIT_CHANGELOGRETENTION"] = "http://ns.adobe.com/adobecloud/problem/limit/changelogretention";
    ProblemType["OPERATION_FAILED"] = "adobecloud/problem/operation_failed";
    ProblemType["SUBSCRIPTION_COUNT"] = "http://ns.adobe.com/adobecloud/problem/limit/subscriptioncount";
    ProblemType["QUOTA_EXCEEDED"] = "http://ns.adobe.com/adobecloud/problem/quotaexceeded";
    ProblemType["CHILDREN_LIMIT_EXCEEDED"] = "http://ns.adobe.com/adobecloud/problem/limit/childrencount";
    ProblemType["NO_HOME_REPOSITORY"] = "http://ns.adobe.com/projects/problem/no-home-repository";
    ProblemType["INVALID_HOME_REPOSITORY"] = "http://ns.adobe.com/projects/problem/invalid-repository";
    ProblemType["ADMIN_ONLY"] = "http://ns.adobe.com/projects/problem/admin-only";
    ProblemType["ACCESS_DENIED"] = "http://ns.adobe.com/adobecloud/problem/accessdenied";
})(ProblemType$1 || (ProblemType$1 = {}));

var IFrameioAuthenticationStatus$1;
(function (IFrameioAuthenticationStatus) {
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authLoggedOut"] = 0] = "authLoggedOut";
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authLoggedIn"] = 1] = "authLoggedIn";
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authExpired"] = 2] = "authExpired";
})(IFrameioAuthenticationStatus$1 || (IFrameioAuthenticationStatus$1 = {}));

var CustomModelPublishedState$3;
(function (CustomModelPublishedState) {
    CustomModelPublishedState["DRAFT"] = "draft";
    CustomModelPublishedState["READY"] = "ready";
    CustomModelPublishedState["PUBLISHED"] = "published";
    CustomModelPublishedState["UNPUBLISHED"] = "unpublished";
    CustomModelPublishedState["QUEUED"] = "queued";
    CustomModelPublishedState["TRAINING"] = "training";
    CustomModelPublishedState["FAILED"] = "failed";
    CustomModelPublishedState["CANCELLED"] = "cancelled";
    CustomModelPublishedState["ALL"] = "all";
})(CustomModelPublishedState$3 || (CustomModelPublishedState$3 = {}));
var CustomModelOrderBy$3;
(function (CustomModelOrderBy) {
    CustomModelOrderBy["MODIFY_DATE"] = "modifyDate";
    CustomModelOrderBy["CREATE_DATE"] = "createDate";
    CustomModelOrderBy["NAME"] = "name";
})(CustomModelOrderBy$3 || (CustomModelOrderBy$3 = {}));

var CustomModelPublishedState$2;
(function (CustomModelPublishedState) {
    CustomModelPublishedState["NEVER"] = "never";
    CustomModelPublishedState["PUBLISHED"] = "published";
    CustomModelPublishedState["UNPUBLISHED"] = "unpublished";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["DRAFT"] = "draft";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["READY"] = "ready";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["QUEUED"] = "queued";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["TRAINING"] = "training";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["FAILED"] = "failed";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["CANCELLED"] = "cancelled";
    /**
     * @deprecated use {@link PUBLISHED} | {@link UNPUBLISHED} | {@link NEVER}
     */
    CustomModelPublishedState["ALL"] = "all";
})(CustomModelPublishedState$2 || (CustomModelPublishedState$2 = {}));
var CustomModelOrderBy$2;
(function (CustomModelOrderBy) {
    CustomModelOrderBy["MODIFY_DATE"] = "modified_date";
    CustomModelOrderBy["CREATE_DATE"] = "created_date";
    CustomModelOrderBy["NAME"] = "name";
})(CustomModelOrderBy$2 || (CustomModelOrderBy$2 = {}));

var RelType$1;
(function (RelType) {
    RelType["PRIMARY"] = "http://ns.adobe.com/adobecloud/rel/primary";
    RelType["ID"] = "http://ns.adobe.com/adobecloud/rel/id";
    RelType["PATH"] = "http://ns.adobe.com/adobecloud/rel/path";
    RelType["RENDITION"] = "http://ns.adobe.com/adobecloud/rel/rendition";
    RelType["COMPONENT_RENDITION"] = "http://ns.adobe.com/adobecloud/rel/componentRendition";
    RelType["MANIFEST"] = "http://ns.adobe.com/adobecloud/rel/manifest";
    RelType["QUOTA"] = "http://ns.adobe.com/adobecloud/rel/quota";
    RelType["COMPONENT"] = "http://ns.adobe.com/adobecloud/rel/component";
    RelType["PAGE"] = "http://ns.adobe.com/adobecloud/rel/page";
    RelType["DISCARD"] = "http://ns.adobe.com/adobecloud/rel/discard";
    RelType["RESTORE"] = "http://ns.adobe.com/adobecloud/rel/restore";
    RelType["DIRECTORY"] = "http://ns.adobe.com/adobecloud/rel/directory";
    RelType["DIRECTORY_BASE"] = "http://ns.adobe.com/adobecloud/rel/directory/base";
    RelType["AC_EFFECTIVE"] = "http://ns.adobe.com/adobecloud/rel/ac/effective";
    RelType["AC_POLICY"] = "http://ns.adobe.com/adobecloud/rel/ac/policy";
    RelType["AC_CHECK"] = "http://ns.adobe.com/adobecloud/rel/ac/check";
    RelType["CREATE"] = "http://ns.adobe.com/adobecloud/rel/create";
    RelType["REPOSITORY"] = "http://ns.adobe.com/adobecloud/rel/repository";
    RelType["RESOLVE_ID"] = "http://ns.adobe.com/adobecloud/rel/resolve/id";
    RelType["RESOLVE_PATH"] = "http://ns.adobe.com/adobecloud/rel/resolve/path";
    RelType["OPS"] = "http://ns.adobe.com/adobecloud/rel/ops";
    RelType["BLOCK_INITIALIZE"] = "http://ns.adobe.com/adobecloud/rel/block/init";
    RelType["BLOCK_TRANSFER"] = "http://ns.adobe.com/adobecloud/rel/block/transfer";
    RelType["BLOCK_FINALIZE"] = "http://ns.adobe.com/adobecloud/rel/block/finalize";
    RelType["REPO_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/repository";
    RelType["APP_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/application";
    RelType["EMBEDDED_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/embedded";
    RelType["PERUSER_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/peruser";
    RelType["ANNOTATIONS"] = "http://ns.adobe.com/adobecloud/rel/annotations";
    RelType["DOWNLOAD"] = "http://ns.adobe.com/adobecloud/rel/download";
    RelType["DESCRIBED_BY"] = "describedBy";
    RelType["VERSION"] = "version-history";
    RelType["SUBSCRIPTION_CREATE"] = "subscription/create";
    RelType["NOTIFICATIONS_LONGPOLL"] = "notifications/longpoll";
    RelType["ONS_CHANGELOG"] = "ons/changelog";
    RelType["REPOSITORIES_PAGE"] = "http://ns.adobe.com/repositories/rel/page";
    RelType["TEAMS_CREATE"] = "http://ns.adobe.com/teams/rel/create";
    RelType["TEAMS_DISCARD"] = "http://ns.adobe.com/teams/rel/discard";
    RelType["TEAMS_RESTORE"] = "http://ns.adobe.com/teams/rel/restore";
    RelType["TEAMS_RENAME"] = "http://ns.adobe.com/teams/rel/rename";
    RelType["TEAMS_PROPERTIES"] = "http://ns.adobe.com/teams/rel/properties";
    RelType["TEAMS_PAGE"] = "http://ns.adobe.com/teams/rel/page";
    RelType["TEAMS_PRIMARY"] = "http://ns.adobe.com/teams/rel/primary";
    RelType["TEAM_PROVISION"] = "http://ns.adobe.com/teams/rel/provision";
    RelType["WORKSPACES_CONTEXT"] = "http://ns.adobe.com/ccprojects/rel/context";
    RelType["WORKSPACES_BOOKMARKS_BATCH"] = "http://ns.adobe.com/ccprojects/rel/bookmarks/batch";
    RelType["WORKSPACES_PRIMARY"] = "http://ns.adobe.com/ccprojects/rel/primary";
    RelType["WORKSPACES_CREATE"] = "http://ns.adobe.com/ccprojects/rel/create";
    RelType["WORKSPACES_PAGE"] = "http://ns.adobe.com/ccprojects/rel/page";
    RelType["PROJECTS_LIBRARIES_PAGE"] = "http://ns.adobe.com/ccprojects/rel/libraries/page";
    RelType["PROJECTS_LIBRARIES_CREATE"] = "http://ns.adobe.com/ccprojects/rel/libraries/create";
    RelType["PROJECTS_LIBRARIES_BATCH"] = "http://ns.adobe.com/ccprojects/rel/libraries/batch";
    RelType["GENERIC_PAGE"] = "page";
    RelType["GENERIC_NEXT"] = "next";
    RelType["ATS_MOVE"] = "http://ns.adobe.com/ats/rel/move";
    RelType["REVIEW_SERVICE_PROVISION"] = "http://ns.adobe.com/ccassetreview/rel/provision";
    RelType["REVIEW_SERVICE_DISCARD"] = "http://ns.adobe.com/ccassetreview/rel/discard";
    RelType["REVIEW_SERVICE_OUTPUTS"] = "http://ns.adobe.com/ccassetreview/rel/outputs";
    RelType["REVIEW_SERIVCE_HAS_OUTPUTS"] = "http://ns.adobe.com/ccassetreview/rel/hasoutputs";
    RelType["PROJECTS_CONTEXT"] = "http://ns.adobe.com/projects/rel/context";
    RelType["PROJECTS_PRIMARY"] = "http://ns.adobe.com/projects/rel/primary";
    RelType["PROJECTS_COLLECTION"] = "http://ns.adobe.com/projects/rel/collection";
    RelType["PROJECTS_CREATE"] = "http://ns.adobe.com/projects/rel/create";
    RelType["PROJECTS_RENAME"] = "http://ns.adobe.com/projects/rel/rename";
    RelType["PROJECTS_CREATOR"] = "http://ns.adobe.com/projects/rel/creator";
    RelType["PROJECTS_GRADIENTS_COLLECTION"] = "http://ns.adobe.com/gradients/rel/collection";
    RelType["PROJECTS_CAPABILITY"] = "http://ns.adobe.com/projects/rel/capability";
    RelType["ORGANIZATIONS_COLLECTION"] = "http://ns.adobe.com/organizations/rel/collection";
    RelType["PROJECTS_RECENT"] = "http://ns.adobe.com/projects/rel/recent";
    RelType["ASSIGNMENTS_ASSIGN"] = "http://ns.adobe.com/assignments/rel/assign";
    RelType["ASSIGNMENTS_CODE"] = "http://ns.adobe.com/assignments/rel/code";
    RelType["ASSIGNMENTS_COLLECTION"] = "http://ns.adobe.com/assignments/rel/collection";
    RelType["ASSIGNMENTS_CREATE"] = "http://ns.adobe.com/assignments/rel/create";
    RelType["ASSIGNMENTS_PRIMARY"] = "http://ns.adobe.com/assignments/rel/primary";
    RelType["ASSIGNMENTS_RETURN"] = "http://ns.adobe.com/assignments/rel/return";
    RelType["ASSIGNMENTS_START"] = "http://ns.adobe.com/assignments/rel/start";
    RelType["ASSIGNMENTS_SUBMIT"] = "http://ns.adobe.com/assignments/rel/submit";
    RelType["STUDENT_ASSIGNMENTS_COLLECTION"] = "http://ns.adobe.com/studentAssignments/rel/collection";
    RelType["STUDENT_ASSIGNMENTS_PRIMARY"] = "http://ns.adobe.com/studentAssignments/rel/primary";
})(RelType$1 || (RelType$1 = {}));

var IProjectPatchKeys$1;
(function (IProjectPatchKeys) {
    IProjectPatchKeys["GRADIENT_ID"] = "/project:rendition/gradientId";
})(IProjectPatchKeys$1 || (IProjectPatchKeys$1 = {}));
var ProjectViews$1;
(function (ProjectViews) {
    /**
     * Combination of Projects returned from yours and sharedWithYou.
     */
    ProjectViews[ProjectViews["All"] = 0] = "All";
    /**
     *  Only the Projects that are considered yours:
     *  For CCI profile, only the projects within /projects directory are returned.
     *  For CCT/CCE profile, a combination of projects within the assigned user storage for the profile,
     *  and the shared storage of Org are returned. If the profile only has access to the
     *  Project via inheritance or through orgEverybody group, then it will not be included.
     */
    ProjectViews[ProjectViews["Yours"] = 1] = "Yours";
    /**
     * Only the Projects that are shared with the requestor. For both CCI and CCT/CCE profiles,
     * the collection would be the negation of yours with the exception that the Projects shared
     * via orgEverybody group are still not included.
     */
    ProjectViews[ProjectViews["SWY"] = 2] = "SWY";
    /**
     * The full list of Projects regardless of how it is accessed. This includes Projects accessible
     * via inheritance and shared via orgEverybody group.
     */
    ProjectViews[ProjectViews["Admin"] = 3] = "Admin";
    /**
     * All projects that match a particluar organization specified in ProjectFilter.organizationID
     */
    ProjectViews[ProjectViews["Organization"] = 4] = "Organization";
    /**
     * The list of recent projects. This is determined by the lastAccessedDate of the project.
     */
    ProjectViews[ProjectViews["Recent"] = 5] = "Recent";
})(ProjectViews$1 || (ProjectViews$1 = {}));
var ProjectCapabilities$1;
(function (ProjectCapabilities) {
    ProjectCapabilities["CREATE"] = "create";
})(ProjectCapabilities$1 || (ProjectCapabilities$1 = {}));
var ProjectLeaveReason$1;
(function (ProjectLeaveReason) {
    ProjectLeaveReason[ProjectLeaveReason["PENDING"] = 0] = "PENDING";
    ProjectLeaveReason[ProjectLeaveReason["CAN_LEAVE"] = 1] = "CAN_LEAVE";
    /**
     * All false reasons.
     */
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_NO_COLLABORATORS"] = 2] = "CANNOT_LEAVE_NO_COLLABORATORS";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER"] = 3] = "CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_COLLABORATOR"] = 4] = "CANNOT_LEAVE_LAST_COLLABORATOR";
    /**
     * @deprecated -- will be and removed on or after 2024-10-01.
     */
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_DIRECT_COLLABORATOR"] = 5] = "CANNOT_LEAVE_LAST_DIRECT_COLLABORATOR";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_IS_ADMIN_OF_PROJECT"] = 6] = "CANNOT_LEAVE_IS_ADMIN_OF_PROJECT";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_DIRECT_COLLAB_WITH_SHARE_PERMISSION"] = 7] = "CANNOT_LEAVE_LAST_DIRECT_COLLAB_WITH_SHARE_PERMISSION";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_IS_OWNER"] = 8] = "CANNOT_LEAVE_IS_OWNER";
})(ProjectLeaveReason$1 || (ProjectLeaveReason$1 = {}));
/**
 * Reasons for why the user can or cannot create a project.
 */
var CanCreateProjectReason$1;
(function (CanCreateProjectReason) {
    CanCreateProjectReason[CanCreateProjectReason["UNKNOWN"] = 0] = "UNKNOWN";
    CanCreateProjectReason[CanCreateProjectReason["ALLOWED"] = 1] = "ALLOWED";
    CanCreateProjectReason[CanCreateProjectReason["ADMIN_DISABLED"] = 2] = "ADMIN_DISABLED";
    CanCreateProjectReason[CanCreateProjectReason["INVALID_REPOSITORY"] = 3] = "INVALID_REPOSITORY";
    CanCreateProjectReason[CanCreateProjectReason["NO_HOME_REPOSITORY"] = 4] = "NO_HOME_REPOSITORY";
})(CanCreateProjectReason$1 || (CanCreateProjectReason$1 = {}));
/**
 * The enumerated values for the `project:directorySubType` metadata field.
 */
var ProjectDirectorySubtype$1;
(function (ProjectDirectorySubtype) {
    ProjectDirectorySubtype["WF_PORTFOLIO"] = "wfPortfolio";
    ProjectDirectorySubtype["WF_PROGRAM"] = "wfProgram";
    ProjectDirectorySubtype["WF_PROJECT"] = "wfProject";
    ProjectDirectorySubtype["CC_PROJECTS"] = "ccProject";
})(ProjectDirectorySubtype$1 || (ProjectDirectorySubtype$1 = {}));

var Permission$1;
(function (Permission) {
    Permission[Permission["None"] = 0] = "None";
    Permission[Permission["Ack"] = 1] = "Ack";
    Permission[Permission["Read"] = 2] = "Read";
    Permission[Permission["Write"] = 4] = "Write";
    Permission[Permission["Delete"] = 8] = "Delete";
    Permission[Permission["Share"] = 16] = "Share";
    Permission[Permission["Rename"] = 32] = "Rename";
    Permission[Permission["Move"] = 64] = "Move";
    Permission[Permission["Discard"] = 128] = "Discard";
    Permission[Permission["Restore"] = 256] = "Restore";
    Permission[Permission["Duplicate"] = 512] = "Duplicate";
    Permission[Permission["ReadAppMetadata"] = 1024] = "ReadAppMetadata";
    Permission[Permission["WriteComment"] = 2048] = "WriteComment";
})(Permission$1 || (Permission$1 = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var AssignmentStatus$1;
(function (AssignmentStatus) {
    AssignmentStatus["DRAFT"] = "DRAFT";
    AssignmentStatus["ASSIGNED"] = "ASSIGNED";
})(AssignmentStatus$1 || (AssignmentStatus$1 = {}));
var AssignmentSubmissionOwnershipEnums$1;
(function (AssignmentSubmissionOwnershipEnums) {
    AssignmentSubmissionOwnershipEnums["ANY"] = "ANY";
    AssignmentSubmissionOwnershipEnums["NONE"] = "NONE";
    AssignmentSubmissionOwnershipEnums["SELF"] = "SELF";
})(AssignmentSubmissionOwnershipEnums$1 || (AssignmentSubmissionOwnershipEnums$1 = {}));
var AssignmentTaskIDEnums$1;
(function (AssignmentTaskIDEnums) {
    AssignmentTaskIDEnums["albumCover"] = "album-cover";
    AssignmentTaskIDEnums["animatedCharacter"] = "animated-character";
    AssignmentTaskIDEnums["bannerPrint"] = "banner-print";
    AssignmentTaskIDEnums["bannerWeb"] = "banner-web";
    AssignmentTaskIDEnums["blogGraphic"] = "blog-graphic";
    AssignmentTaskIDEnums["blogHeader"] = "blog-header";
    AssignmentTaskIDEnums["bookCover"] = "book-cover";
    AssignmentTaskIDEnums["bookmark"] = "bookmark";
    AssignmentTaskIDEnums["brochure"] = "brochure";
    AssignmentTaskIDEnums["businessCard"] = "business-card";
    AssignmentTaskIDEnums["calendar"] = "calendar";
    AssignmentTaskIDEnums["cardGreeting"] = "card-greeting";
    AssignmentTaskIDEnums["certificate"] = "certificate";
    AssignmentTaskIDEnums["checklist"] = "checklist";
    AssignmentTaskIDEnums["classSchedule"] = "class-schedule";
    AssignmentTaskIDEnums["comicStrip"] = "comic-strip";
    AssignmentTaskIDEnums["conceptMap"] = "concept-map";
    AssignmentTaskIDEnums["couponSheet"] = "coupon-sheet";
    AssignmentTaskIDEnums["coverPage"] = "cover-page";
    AssignmentTaskIDEnums["deviceCameraRecording"] = "device-camera-recording";
    AssignmentTaskIDEnums["displayAd"] = "display-ad";
    AssignmentTaskIDEnums["dividerPage"] = "divider-page";
    AssignmentTaskIDEnums["drawing"] = "drawing";
    AssignmentTaskIDEnums["drawingWorksheet"] = "drawing-worksheet";
    AssignmentTaskIDEnums["ebookCover"] = "ebook-cover";
    AssignmentTaskIDEnums["emailHeader"] = "email-header";
    AssignmentTaskIDEnums["etsyShopBanner"] = "etsy-shop-banner";
    AssignmentTaskIDEnums["etsyShopCover"] = "etsy-shop-cover";
    AssignmentTaskIDEnums["eventbriteHeader"] = "eventbrite-header";
    AssignmentTaskIDEnums["facebookAd"] = "facebook-ad";
    AssignmentTaskIDEnums["facebookEventCover"] = "facebook-event-cover";
    AssignmentTaskIDEnums["facebookGroupCover"] = "facebook-group-cover";
    AssignmentTaskIDEnums["facebookPageCover"] = "facebook-page-cover";
    AssignmentTaskIDEnums["facebookPost"] = "facebook-post";
    AssignmentTaskIDEnums["facebookProfileCover"] = "facebook-profile-cover";
    AssignmentTaskIDEnums["facebookShopCover"] = "facebook-shop-cover";
    AssignmentTaskIDEnums["facebookStory"] = "facebook-story";
    AssignmentTaskIDEnums["flashCard"] = "flash-card";
    AssignmentTaskIDEnums["flashCardSheet"] = "flash-card-sheet";
    AssignmentTaskIDEnums["flyer"] = "flyer";
    AssignmentTaskIDEnums["generatedImage"] = "generated-image";
    AssignmentTaskIDEnums["giftCertificate"] = "gift-certificate";
    AssignmentTaskIDEnums["giftTag"] = "gift-tag";
    AssignmentTaskIDEnums["googleClassroomBanner"] = "google-classroom-banner";
    AssignmentTaskIDEnums["graph"] = "graph";
    AssignmentTaskIDEnums["graphicOrganizer"] = "graphic-organizer";
    AssignmentTaskIDEnums["idCard"] = "id-card";
    AssignmentTaskIDEnums["infographic"] = "infographic";
    AssignmentTaskIDEnums["instagramAd"] = "instagram-ad";
    AssignmentTaskIDEnums["instagramCarousel"] = "instagram-carousel";
    AssignmentTaskIDEnums["instagramLandscapePost"] = "instagram-landscape-post";
    AssignmentTaskIDEnums["instagramPortraitPost"] = "instagram-portrait-post";
    AssignmentTaskIDEnums["instagramReel"] = "instagram-reel";
    AssignmentTaskIDEnums["instagramSquarePost"] = "instagram-square-post";
    AssignmentTaskIDEnums["instagramStory"] = "instagram-story";
    AssignmentTaskIDEnums["instagramStoryAd"] = "instagram-story-ad";
    AssignmentTaskIDEnums["invitation"] = "invitation";
    AssignmentTaskIDEnums["invoice"] = "invoice";
    AssignmentTaskIDEnums["journal"] = "journal";
    AssignmentTaskIDEnums["label"] = "label";
    AssignmentTaskIDEnums["labelSheet"] = "label-sheet";
    AssignmentTaskIDEnums["leafletTrifold"] = "leaflet-trifold";
    AssignmentTaskIDEnums["lessonPlan"] = "lesson-plan";
    AssignmentTaskIDEnums["letter"] = "letter";
    AssignmentTaskIDEnums["letterhead"] = "letterhead";
    AssignmentTaskIDEnums["lineAdSmall"] = "line-ad-small";
    AssignmentTaskIDEnums["lineAdSquare"] = "line-ad-square";
    AssignmentTaskIDEnums["lineAdSquareVideo"] = "line-ad-square-video";
    AssignmentTaskIDEnums["lineAdVertical"] = "line-ad-vertical";
    AssignmentTaskIDEnums["lineRichMenuLarge"] = "line-rich-menu-large";
    AssignmentTaskIDEnums["lineRichMenuSmall"] = "line-rich-menu-small";
    AssignmentTaskIDEnums["lineRichMessage"] = "line-rich-message";
    AssignmentTaskIDEnums["linkedinBlogPost"] = "linkedin-blog-post";
    AssignmentTaskIDEnums["linkedinPost"] = "linkedin-post";
    AssignmentTaskIDEnums["linkedinProfileCover"] = "linkedin-profile-cover";
    AssignmentTaskIDEnums["logo"] = "logo";
    AssignmentTaskIDEnums["magazine"] = "magazine";
    AssignmentTaskIDEnums["mediaKit"] = "media-kit";
    AssignmentTaskIDEnums["meme"] = "meme";
    AssignmentTaskIDEnums["memo"] = "memo";
    AssignmentTaskIDEnums["menu"] = "menu";
    AssignmentTaskIDEnums["mindmap"] = "mindmap";
    AssignmentTaskIDEnums["mobileVideo"] = "mobile-video";
    AssignmentTaskIDEnums["mug"] = "mug";
    AssignmentTaskIDEnums["nameTag"] = "name-tag";
    AssignmentTaskIDEnums["newsletter"] = "newsletter";
    AssignmentTaskIDEnums["noteHeaderImage"] = "note-header-image";
    AssignmentTaskIDEnums["onlineNewsletter"] = "online-newsletter";
    AssignmentTaskIDEnums["onlineReport"] = "online-report";
    AssignmentTaskIDEnums["pamphlet"] = "pamphlet";
    AssignmentTaskIDEnums["photoBook"] = "photo-book";
    AssignmentTaskIDEnums["pinterestIdeaPin"] = "pinterest-idea-pin";
    AssignmentTaskIDEnums["pinterestPost"] = "pinterest-post";
    AssignmentTaskIDEnums["pinterestSquare"] = "pinterest-square";
    AssignmentTaskIDEnums["pinterestVertical"] = "pinterest-vertical";
    AssignmentTaskIDEnums["placeCard"] = "place-card";
    AssignmentTaskIDEnums["planner"] = "planner";
    AssignmentTaskIDEnums["playlistCover"] = "playlist-cover";
    AssignmentTaskIDEnums["podcastCover"] = "podcast-cover";
    AssignmentTaskIDEnums["postcard"] = "postcard";
    AssignmentTaskIDEnums["poster"] = "poster";
    AssignmentTaskIDEnums["presentation"] = "presentation";
    AssignmentTaskIDEnums["printAd"] = "print-ad";
    AssignmentTaskIDEnums["program"] = "program";
    AssignmentTaskIDEnums["proposal"] = "proposal";
    AssignmentTaskIDEnums["recipeCard"] = "recipe-card";
    AssignmentTaskIDEnums["redditCover"] = "reddit-cover";
    AssignmentTaskIDEnums["report"] = "report";
    AssignmentTaskIDEnums["reportCard"] = "report-card";
    AssignmentTaskIDEnums["resume"] = "resume";
    AssignmentTaskIDEnums["rubric"] = "rubric";
    AssignmentTaskIDEnums["snapchatAd"] = "snapchat-ad";
    AssignmentTaskIDEnums["snapchatFilter"] = "snapchat-filter";
    AssignmentTaskIDEnums["soundcloudBanner"] = "soundcloud-banner";
    AssignmentTaskIDEnums["tableOfContents"] = "table-of-contents";
    AssignmentTaskIDEnums["ticket"] = "ticket";
    AssignmentTaskIDEnums["tiktokAd"] = "tiktok-ad";
    AssignmentTaskIDEnums["tiktokVideo"] = "tiktok-video";
    AssignmentTaskIDEnums["tshirt"] = "tshirt";
    AssignmentTaskIDEnums["tumblrBanner"] = "tumblr-banner";
    AssignmentTaskIDEnums["twitchBanner"] = "twitch-banner";
    AssignmentTaskIDEnums["twitchOverlay"] = "twitch-overlay";
    AssignmentTaskIDEnums["twitterHeader"] = "twitter-header";
    AssignmentTaskIDEnums["twitterPost"] = "twitter-post";
    AssignmentTaskIDEnums["twitterVideo"] = "twitter-video";
    AssignmentTaskIDEnums["video"] = "video";
    AssignmentTaskIDEnums["wallpaperDesktop"] = "wallpaper-desktop";
    AssignmentTaskIDEnums["wallpaperMobile"] = "wallpaper-mobile";
    AssignmentTaskIDEnums["webpage"] = "webpage";
    AssignmentTaskIDEnums["webpageJournal"] = "webpage-journal";
    AssignmentTaskIDEnums["worksheet"] = "worksheet";
    AssignmentTaskIDEnums["youtubeBanner"] = "youtube-banner";
    AssignmentTaskIDEnums["youtubeDisplayAds"] = "youtube-display-ads";
    AssignmentTaskIDEnums["youtubeProfilePhoto"] = "youtube-profile-photo";
    AssignmentTaskIDEnums["youtubeShorts"] = "youtube-shorts";
    AssignmentTaskIDEnums["youtubeThumbnail"] = "youtube-thumbnail";
    AssignmentTaskIDEnums["youtubeVideo"] = "youtube-video";
    AssignmentTaskIDEnums["youtubeVideoAd"] = "youtube-video-ad";
    AssignmentTaskIDEnums["zoomBackground"] = "zoom-background";
})(AssignmentTaskIDEnums$1 || (AssignmentTaskIDEnums$1 = {}));

var ClassroomMemberRole$1;
(function (ClassroomMemberRole) {
    ClassroomMemberRole["STUDENT"] = "student";
    ClassroomMemberRole["TEACHER"] = "teacher";
    ClassroomMemberRole["NONE"] = "none";
})(ClassroomMemberRole$1 || (ClassroomMemberRole$1 = {}));
var ClassroomMemberStatus$1;
(function (ClassroomMemberStatus) {
    ClassroomMemberStatus["ACTIVE"] = "ACTIVE";
    ClassroomMemberStatus["DECLINED"] = "DECLINED";
    ClassroomMemberStatus["INACTIVE"] = "INACTIVE";
    ClassroomMemberStatus["INVITED"] = "INVITED";
    ClassroomMemberStatus["IN_REVIEW"] = "IN_REVIEW";
    ClassroomMemberStatus["NOT_A_MEMBER"] = "NOT_A_MEMBER";
    ClassroomMemberStatus["OWNER"] = "OWNER";
})(ClassroomMemberStatus$1 || (ClassroomMemberStatus$1 = {}));
var ClassroomMemberInviteSource$1;
(function (ClassroomMemberInviteSource) {
    ClassroomMemberInviteSource["CLASSLINK"] = "CLASSLINK";
    ClassroomMemberInviteSource["CLEVER"] = "CLEVER";
    ClassroomMemberInviteSource["EMAIL"] = "EMAIL";
    ClassroomMemberInviteSource["GOOGLE_CLASSROOM"] = "GOOGLE_CLASSROOM";
    ClassroomMemberInviteSource["NONE"] = "NONE";
})(ClassroomMemberInviteSource$1 || (ClassroomMemberInviteSource$1 = {}));

var LearningManagementSystems$1;
(function (LearningManagementSystems) {
    LearningManagementSystems["GC"] = "GC";
})(LearningManagementSystems$1 || (LearningManagementSystems$1 = {}));
var LearningManagementSystemRoles$1;
(function (LearningManagementSystemRoles) {
    LearningManagementSystemRoles["STUDENT"] = "STUDENT";
    LearningManagementSystemRoles["TEACHER"] = "TEACHER";
})(LearningManagementSystemRoles$1 || (LearningManagementSystemRoles$1 = {}));
var RosterImportState$1;
(function (RosterImportState) {
    RosterImportState["BLOCKED"] = "BLOCKED";
    RosterImportState["INVITED"] = "INVITED";
    RosterImportState["JOINED"] = "JOINED";
    RosterImportState["NOT_ENROLLED"] = "NOT_ENROLLED";
    RosterImportState["REMOVED"] = "REMOVED";
})(RosterImportState$1 || (RosterImportState$1 = {}));
var ImportSourceType$1;
(function (ImportSourceType) {
    ImportSourceType["CLEVER"] = "clever";
    ImportSourceType["CLASS_LINK"] = "classlink";
})(ImportSourceType$1 || (ImportSourceType$1 = {}));
var ClassroomStatus$1;
(function (ClassroomStatus) {
    ClassroomStatus["ACTIVE"] = "ACTIVE";
    ClassroomStatus["ARCHIVED"] = "ARCHIVED";
})(ClassroomStatus$1 || (ClassroomStatus$1 = {}));
var ClassroomType$1;
(function (ClassroomType) {
    /** Allowed classrooms for Top Down organization users */
    ClassroomType["TRUE"] = "TRUE";
    /** Allowed classrooms for Bottom up organization users */
    ClassroomType["RESTRICTED"] = "RESTRICTED";
    /** Allowed classrooms for users on their personal account */
    ClassroomType["UNRESTRICTED"] = "UNRESTRICTED";
    /** Not allowed classrooms */
    ClassroomType["NONE"] = "NONE";
})(ClassroomType$1 || (ClassroomType$1 = {}));
var SubjectTypes$1;
(function (SubjectTypes) {
    SubjectTypes["noSubject"] = "";
    SubjectTypes["allsubjects"] = "allsubjects";
    SubjectTypes["careersTechnicalEducation"] = "careersTechnicalEducation";
    SubjectTypes["computerScience"] = "computerScience";
    SubjectTypes["english"] = "english";
    SubjectTypes["math"] = "math";
    SubjectTypes["otherLanguages"] = "otherLanguages";
    SubjectTypes["others"] = "others";
    SubjectTypes["science"] = "science";
    SubjectTypes["socialStudies"] = "socialStudies";
    SubjectTypes["visualPerformingArts"] = "visualPerformingArts";
})(SubjectTypes$1 || (SubjectTypes$1 = {}));
var ClassroomRole$1;
(function (ClassroomRole) {
    ClassroomRole["STUDENT"] = "STUDENT";
    ClassroomRole["TEACHER"] = "TEACHER";
})(ClassroomRole$1 || (ClassroomRole$1 = {}));
var BlockApiSuccessResponses$1;
(function (BlockApiSuccessResponses) {
    BlockApiSuccessResponses["REMOVE_STUDENT_SUCCESS"] = "REMOVE_STUDENT_SUCCESS";
    BlockApiSuccessResponses["BLOCK_STUDENT_SUCCESS"] = "BLOCK_STUDENT_SUCCESS";
    BlockApiSuccessResponses["UNBLOCK_STUDENT_SUCCESS"] = "UNBLOCK_STUDENT_SUCCESS";
    BlockApiSuccessResponses["DELETE_DOMAIN_MAPPING_ACCEPTED"] = "DELETE_DOMAIN_MAPPING_ACCEPTED";
    BlockApiSuccessResponses["REMOVE_TEACHER_SUCCESS"] = "REMOVE_TEACHER_SUCCESS";
})(BlockApiSuccessResponses$1 || (BlockApiSuccessResponses$1 = {}));
var MembershipStatus$1;
(function (MembershipStatus) {
    MembershipStatus["OWNER"] = "OWNER";
    MembershipStatus["ACTIVE"] = "ACTIVE";
    MembershipStatus["INACTIVE"] = "INACTIVE";
    MembershipStatus["INVITED"] = "INVITED";
    MembershipStatus["IN_REVIEW"] = "IN_REVIEW";
    MembershipStatus["DECLINED"] = "DECLINED";
    MembershipStatus["NOT_A_MEMBER"] = "NOT_A_MEMBER";
})(MembershipStatus$1 || (MembershipStatus$1 = {}));
var CoTeacherEligibilityStatus$1;
(function (CoTeacherEligibilityStatus) {
    CoTeacherEligibilityStatus["ALLOWED"] = "ALLOWED";
    CoTeacherEligibilityStatus["NOT_ALLOWED"] = "NOT_ALLOWED";
})(CoTeacherEligibilityStatus$1 || (CoTeacherEligibilityStatus$1 = {}));
var CoTeacherIneligibilityReason$1;
(function (CoTeacherIneligibilityReason) {
    CoTeacherIneligibilityReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    CoTeacherIneligibilityReason["STUDENT_IN_CLASSROOM"] = "STUDENT_IN_CLASSROOM";
    CoTeacherIneligibilityReason["TEACHER_IN_CLASSROOM"] = "TEACHER_IN_CLASSROOM";
})(CoTeacherIneligibilityReason$1 || (CoTeacherIneligibilityReason$1 = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var GenerationHistoryAssetType$1;
(function (GenerationHistoryAssetType) {
    GenerationHistoryAssetType["IMAGE"] = "image";
    GenerationHistoryAssetType["VIDEO"] = "video";
})(GenerationHistoryAssetType$1 || (GenerationHistoryAssetType$1 = {}));
var GenerationHistoryAssetOrderBy$1;
(function (GenerationHistoryAssetOrderBy) {
    GenerationHistoryAssetOrderBy["CREATE_DATE"] = "created_date";
})(GenerationHistoryAssetOrderBy$1 || (GenerationHistoryAssetOrderBy$1 = {}));
var GenerationHistoryAssetState$1;
(function (GenerationHistoryAssetState) {
    GenerationHistoryAssetState["QUEUED"] = "queued";
    GenerationHistoryAssetState["IN_PROGRESS"] = "inProgress";
    GenerationHistoryAssetState["SUCCESS"] = "success";
    GenerationHistoryAssetState["FAILED"] = "failed";
    GenerationHistoryAssetState["CANCELLED"] = "cancelled";
})(GenerationHistoryAssetState$1 || (GenerationHistoryAssetState$1 = {}));

var LibraryOrderBy$1;
(function (LibraryOrderBy) {
    LibraryOrderBy["MODIFIED_DATE"] = "modified_date";
    LibraryOrderBy["CREATED_DATE"] = "created_date";
    LibraryOrderBy["NAME"] = "name";
})(LibraryOrderBy$1 || (LibraryOrderBy$1 = {}));
/**
 * Enum for library owner filter
 * (If you update this list, also update LibraryFilter.matches/getRelationToFilter.)
 * @enum {string}
 */
var LibraryOwnerFilter$1;
(function (LibraryOwnerFilter) {
    /**
     * Personal libraries created in User Storage that are specifically stored inside the sync group: `/assets/adobe-libraries`
     * Excludes CCI Project Libraries.
     */
    LibraryOwnerFilter["Personal"] = "private";
    /**
     * Bookmarked public libraries.
     * Currently will be ignored if combined with other ownership types.
     */
    LibraryOwnerFilter["Public"] = "public";
    /**
     * Bookmarked incoming libraries. This includes:
     * - Libraries shared directly with the user that the user has accepted the invite to
     * - CCI Project Libraries which live in User Storage (`/users/{userId}` in ESM, `/` in USM and for unified users)
     * - Project Libraries the user has followed (After SMU, these will all live in `/projects/{projectName}`)
     */
    LibraryOwnerFilter["Incoming"] = "incoming";
    /**
     * Everything the user has acccess to that is not in User Storage, except public libraries.
     * Includes: Project libraries, Incoming libraries (except CCI Project Libraries since they are in User Storage)
     * Excludes: Public libraries, CCI Project Libraries, Private Libraries
     */
    LibraryOwnerFilter["Discovery"] = "discovery";
    /**
     * A subset of 'discovery' that excludes already bookmarked libraries.
     */
    /**
     * All of the above except public libraries currently (until supported by USS).
     * If combined with other owner types, the others will be ignored.
     */
    LibraryOwnerFilter["All"] = "all";
})(LibraryOwnerFilter$1 || (LibraryOwnerFilter$1 = {}));
var LibraryProjectFilterEnum$1;
(function (LibraryProjectFilterEnum) {
    /**
     * Include all project libraries.
     */
    LibraryProjectFilterEnum["All"] = "all";
    /**
     * Do not include any project libraries.
     */
    LibraryProjectFilterEnum["None"] = "none";
})(LibraryProjectFilterEnum$1 || (LibraryProjectFilterEnum$1 = {}));
var LibraryRolesFilter$1;
(function (LibraryRolesFilter) {
    /**
     * Include libraries that have no roles
     */
    LibraryRolesFilter["None"] = "none";
    /**
     * Include libraries that have at least one role where role.type === 'brand'
     */
    LibraryRolesFilter["Brand"] = "brand";
    /**
     * Include training set libraries. Currently the default, as it is the only option.
     */
    LibraryRolesFilter["TrainingSet"] = "cm_training_set";
})(LibraryRolesFilter$1 || (LibraryRolesFilter$1 = {}));

var MoveWarning$1;
(function (MoveWarning) {
    MoveWarning[MoveWarning["None"] = 0] = "None";
    MoveWarning[MoveWarning["CollaboratorMaybeEditing"] = 1] = "CollaboratorMaybeEditing";
    MoveWarning[MoveWarning["OwnerChange"] = 2] = "OwnerChange";
})(MoveWarning$1 || (MoveWarning$1 = {}));
var CannotMoveReason$1;
(function (CannotMoveReason) {
    CannotMoveReason[CannotMoveReason["DifferentOwner"] = 1] = "DifferentOwner";
    CannotMoveReason[CannotMoveReason["PermissionDeniedDestination"] = 2] = "PermissionDeniedDestination";
    CannotMoveReason[CannotMoveReason["PermissionDeniedSource"] = 3] = "PermissionDeniedSource";
    CannotMoveReason[CannotMoveReason["NotAFolder"] = 4] = "NotAFolder";
    CannotMoveReason[CannotMoveReason["CrossBucketMoveDisabled"] = 5] = "CrossBucketMoveDisabled";
})(CannotMoveReason$1 || (CannotMoveReason$1 = {}));

var StudentAssignmentStatus$1;
(function (StudentAssignmentStatus) {
    StudentAssignmentStatus["NOT_STARTED"] = "NOT_STARTED";
    StudentAssignmentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    StudentAssignmentStatus["RETURNED"] = "RETURNED";
    StudentAssignmentStatus["SUBMITTED"] = "SUBMITTED";
})(StudentAssignmentStatus$1 || (StudentAssignmentStatus$1 = {}));
var StudentAssignmentOwner$1;
(function (StudentAssignmentOwner) {
    StudentAssignmentOwner["Any"] = "ANY";
    StudentAssignmentOwner["Self"] = "SELF";
})(StudentAssignmentOwner$1 || (StudentAssignmentOwner$1 = {}));

var RenditionStatus$1;
(function (RenditionStatus) {
    /**
     * Initial status
     */
    RenditionStatus[RenditionStatus["NotStarted"] = 0] = "NotStarted";
    RenditionStatus[RenditionStatus["Fetching"] = 1] = "Fetching";
    RenditionStatus[RenditionStatus["Done"] = 2] = "Done";
    /**
     * Occurs when there are any errors around fetching the
     * rendition from the service, AdobeAsset.clearRenditionError can
     * be used to clear the error and fetch again.
     */
    RenditionStatus[RenditionStatus["Error"] = 3] = "Error";
})(RenditionStatus$1 || (RenditionStatus$1 = {}));
var RenditionSize$1;
(function (RenditionSize) {
    RenditionSize[RenditionSize["Size64"] = 64] = "Size64";
    RenditionSize[RenditionSize["Size128"] = 128] = "Size128";
    RenditionSize[RenditionSize["Size256"] = 256] = "Size256";
    RenditionSize[RenditionSize["Size512"] = 512] = "Size512";
    RenditionSize[RenditionSize["Size1024"] = 1024] = "Size1024";
})(RenditionSize$1 || (RenditionSize$1 = {}));
var RenditionType$1;
(function (RenditionType) {
    RenditionType["PNG"] = "image/png";
    RenditionType["JPEG"] = "image/jpeg";
})(RenditionType$1 || (RenditionType$1 = {}));

var Mode;
(function (Mode) {
    Mode["MOBILE"] = "mobile";
    Mode["DESKTOP"] = "desktop";
})(Mode || (Mode = {}));
var View;
(function (View) {
    View["WEB"] = "web";
    View["MOBILE"] = "mobile";
})(View || (View = {}));
var MessageType;
(function (MessageType) {
    MessageType["OpenDocumentVersion"] = "onOpenDocumentVersion";
    MessageType["OpenDeepLinkVersion"] = "onOpenDeepLinkVersion";
    MessageType["VersionSelection"] = "onVersionSelection";
    MessageType["RestoreVersion"] = "onRestoreVersion";
    MessageType["Upgrade"] = "onUpgrade";
    MessageType["CreateCopy"] = "onCreateCopy";
    MessageType["Refresh"] = "onRefresh";
    MessageType["ModeChange"] = "onModeChange";
    MessageType["ThemeChange"] = "onThemeChange";
    MessageType["ClosePanel"] = "onClosePanel";
    MessageType["Error"] = "onError";
    MessageType["VersionBookmark"] = "onVersionBookmark";
    MessageType["VersionUnBookmark"] = "onVersionUnBookmark";
    MessageType["VersionBookmarkStart"] = "onVersionBookmarkStart";
    MessageType["VersionUnBookmarkStart"] = "onVersionUnBookmarkStart";
    MessageType["PermanentlyDeleteScreen"] = "onPermanentlyDeleteScreen";
    MessageType["PermanentlyDeleteVersion"] = "onPermanentlyDeleteVersion";
    MessageType["VersioningPanelLoadComplete"] = "onVersioningPanelLoadComplete";
    MessageType["PreviewThumbnailReceived"] = "onPreviewThumbnailReceived";
})(MessageType || (MessageType = {}));
/* eslint-enable @typescript-eslint/no-namespace */

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const SAMErrorCode = SAMErrorCode$1;
const SAMErrorSubCode = SAMErrorSubCode$1;
const errorCodeInfos = new Map([
    [401, { code: SAMErrorCode.AUTHORIZATION_ERROR, message: (href) => `Authorization error: ${href}` }],
    // @note Maybe consider renaming this to FORBIDDEN_OPERATION instead of ACCESS_DENIED since
    // that more closely aligns with the actual HTTP Status Code for 403
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Status/403
    [403, { code: SAMErrorCode.ACCESS_DENIED, message: (href) => `Access to resource denied: ${href}` }],
    [404, { code: SAMErrorCode.NOT_FOUND, message: (href) => `Resource not found: ${href}` }],
    [409, { code: SAMErrorCode.CONFLICT, message: () => `Resource has a naming conflict.` }],
    [412, { code: SAMErrorCode.CONFLICT, message: () => `Resource has a conflict. Etag mismatch.` }],
]);
/**
 * Convert server error codes to regular HTTP number codes.
 * '4041' -> 404
 * '404.1' -> 404
 * 4041 -> 404
 * 404 -> 404
 *
 * @param code from server
 * @returns http error code
 */
function validateRepositoryCode(code) {
    // Repo APIs return string codes instead of numbers. In that case
    if (typeof code === 'string') {
        code = parseInt(code);
    }
    // Remove any extra floating point.
    code = Math.floor(code);
    // HTTP error codes only use 3 digits, but repo APIs can have even 5 digits.
    // We only care about the most significant 3 digits though.
    // https://git.corp.adobe.com/DMA/dcx-lib/blob/729085f1ed77936a1718377ea6cd5e3b16f6aada/lib/dcxlib/src/main/java/com/adobe/dcx/storagesession/StorageErrorCode.java#L12
    while (code > 999) {
        code = Math.floor(code / 10);
    }
    return code;
}
var ProblemType;
(function (ProblemType) {
    ProblemType["LIMIT_CHANGELOGRETENTION"] = "http://ns.adobe.com/adobecloud/problem/limit/changelogretention";
    ProblemType["OPERATION_FAILED"] = "adobecloud/problem/operation_failed";
    ProblemType["SUBSCRIPTION_COUNT"] = "http://ns.adobe.com/adobecloud/problem/limit/subscriptioncount";
    ProblemType["QUOTA_EXCEEDED"] = "http://ns.adobe.com/adobecloud/problem/quotaexceeded";
    ProblemType["CHILDREN_LIMIT_EXCEEDED"] = "http://ns.adobe.com/adobecloud/problem/limit/childrencount";
    ProblemType["NO_HOME_REPOSITORY"] = "http://ns.adobe.com/projects/problem/no-home-repository";
    ProblemType["INVALID_HOME_REPOSITORY"] = "http://ns.adobe.com/projects/problem/invalid-repository";
    ProblemType["ADMIN_ONLY"] = "http://ns.adobe.com/projects/problem/admin-only";
    ProblemType["ACCESS_DENIED"] = "http://ns.adobe.com/adobecloud/problem/accessdenied";
    ProblemType["LAST_VERSION_LEFT"] = "http://ns.adobe.com/adobecloud/problem/noversionleft";
})(ProblemType || (ProblemType = {}));
function formatUnderlyingError(underlyingError) {
    let errorStr = '';
    if (underlyingError !== null && underlyingError !== undefined) {
        try {
            errorStr = ` -> ${String(underlyingError)}`;
        }
        catch (_a) {
        }
    }
    return errorStr;
}
const SAMErrorName = 'SAMError';
/**
 * SAM.js would always throw back SAMError even when it is powered via SAM.cpp
 * The clients must rely only on `code` and `subCode` in order to write their business logic.
 * `description` can be used for logging purposes.
 * `_additionalInfo` should only be used for debugging purpose and there should not be any reference
 * to it in the code base.
 */
class SAMError extends Error {
    constructor(code, description, additionalInfo = {}, subCode) {
        // NOTE: clients should not rely on SAMError.message for fine-grain error handling; instead, use `code` and `subcode`.
        const message = `[${SAMErrorCode[code]}${subCode === undefined ? '' : '-' + SAMErrorSubCode[subCode]}] ${description}${formatUnderlyingError(additionalInfo.underlyingError)}`;
        if (additionalInfo.underlyingError !== undefined) {
            // When SAM rethrows errors, it wraps the caught error with
            // a SAMError, preserving the caught error as underlyingError.
            //
            // Unfortunately Sentry isn't aware of underlyingError,
            // so we loose valuable debugging information. Sentry
            // is aware of Error.cause ( ES2022 ), which is another
            // way to specify the caught error when rethrowing.
            //
            // So when there's an underlyingError, I'm setting both
            // to improve debugging in Sentry while preserving legacy
            // behaviour.
            super(message, { cause: additionalInfo.underlyingError });
        }
        else {
            super(message);
        }
        this.code = code;
        this.subCode = subCode;
        this.description = description;
        this._additionalInfo = additionalInfo;
    }
    get name() {
        return SAMErrorName;
    }
    static wrapErrorIfNeeded(code, description, underlyingError, subCode) {
        if (underlyingError instanceof SAMError) {
            return underlyingError;
        }
        return new SAMError(code, description, { underlyingError }, subCode);
    }
    static create(code, description, additionalInfo, subCode) {
        return new SAMError(code, description, additionalInfo, subCode);
    }
    static createWithResponse(response, href) {
        var _a, _b;
        const { status } = response;
        const info = errorCodeInfos.get(validateRepositoryCode(status));
        const responseUrl = href !== null && href !== void 0 ? href : response.url;
        const reqId = response.headers.get('X-Request-Id') || '';
        return new SAMError((_a = info === null || info === void 0 ? void 0 : info.code) !== null && _a !== void 0 ? _a : SAMErrorCode.UNKNOWN, ((_b = info === null || info === void 0 ? void 0 : info.message(href !== null && href !== void 0 ? href : responseUrl)) !== null && _b !== void 0 ? _b : `Unexpected response status: ${status} for ${responseUrl}`)
            + ` reqId: ${reqId}`, { response, reqId }, info === null || info === void 0 ? void 0 : info.subCode);
    }
    static createWithResponseAndDescription(response, description) {
        var _a;
        const info = errorCodeInfos.get(validateRepositoryCode(response.status));
        return new SAMError((_a = info === null || info === void 0 ? void 0 : info.code) !== null && _a !== void 0 ? _a : SAMErrorCode.UNKNOWN, description, { response }, info === null || info === void 0 ? void 0 : info.subCode);
    }
    static createWithRepositoryCode(code, problemType, description) {
        var _a;
        // Look out for Quota Exceeded errors.
        // RAPI returns 403 with problemType = http://ns.adobe.com/adobecloud/problem/quotaexceeded for such errors.
        // We want to return a more specific error code for this case.
        if (problemType === ProblemType.QUOTA_EXCEEDED) {
            return new SAMError(SAMErrorCode.FULL_CLOUD_STORAGE, description, { problemType });
        }
        const validHTTPCode = validateRepositoryCode(code);
        const info = code ? errorCodeInfos.get(validHTTPCode) : undefined;
        return new SAMError((_a = info === null || info === void 0 ? void 0 : info.code) !== null && _a !== void 0 ? _a : SAMErrorCode.UNKNOWN, description, { problemType }, info === null || info === void 0 ? void 0 : info.subCode);
    }
    static createWithApolloError(error) {
        var _a;
        if (error.networkError) {
            const response = error.networkError.response;
            if (response) {
                return SAMError.createWithResponse(response);
            }
        }
        if (((_a = error.graphQLErrors) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return SAMError.createWithGraphQLError(error.graphQLErrors[0]);
        }
        return SAMError.create(SAMErrorCode.UNKNOWN, error.message);
    }
    static createWithGraphQLError(error) {
        var _a;
        // As per the discussion with asset subgraph team, the errors are RAPI compliant and
        // would be returned in the extensions field of the error
        // Apollo client returns an array of graphQLErrors but it seems we will only have one error
        // from the asset subgraph
        const extensions = error.extensions;
        if (extensions) {
            return SAMError.createWithRepositoryCode(extensions.httpErrorCode, (_a = extensions.problemType) === null || _a === void 0 ? void 0 : _a.type, error.message);
        }
        return SAMError.create(SAMErrorCode.UNKNOWN, error.message);
    }
}
/**
 * Throws SAMAssertionError when `assertedCondition` is false.
 * @param assertedCondition
 * @param message
 */
function assert$1(assertedCondition, message) {
    if (!assertedCondition) {
        throw SAMError.create(SAMErrorCode.UNKNOWN, message);
    }
}
/**
 * Helper function used to accurately determine if an error
 * is a SAMError and not a plain Error.
 *
 * @param error An Error type object
 * @returns
 */
function isSAMError(error) {
    return error && error.name === SAMErrorName;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$2(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __values$1(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values$1 === "function" ? __values$1(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const KeysProperty = Symbol('@key parameterMap');
// @key decorator is used to indicate the argument to the @cache and @synchronized decorators
var key = (target, propertyKey, parameterIndex) => {
    const map = target[KeysProperty] = target[KeysProperty] || new Map;
    if (map.has(propertyKey)) {
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, '@key cannot be applied to more than one parameter');
    }
    map.set(propertyKey, parameterIndex);
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Caches the result of the method, using the argument decorated with '@key' as the key (multiple arguments can also be
 * used, and they will be appended together). This ensures that the result is cached in memory and shared if multiple
 * people call the API at once. Once the value expires, it will be recomputed.
 *
 * Note:
 * 1) Keys are global, so different cached methods should use different key domains unless it's intended to be shared.
 *    We typically use URLs as keys to avoid such conflicts.
 * 2) Decorators are not passed the default value of parameters, so you can't write f(@key x = 'defaultValue') - you need
 *    to make sure the value is always passed in.
 */
function cacheImpl(validate) {
    return (target, propertyKey, descriptor) => {
        const method = descriptor.value;
        if (!method) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, '@cache decorator can only be applied to a method');
        }
        const newMethod = async function (...args) {
            var _a;
            const keyIndex = (_a = this[KeysProperty]) === null || _a === void 0 ? void 0 : _a.get(propertyKey);
            if (keyIndex === undefined) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, '@cache decorator requires one of the parameters to be labelled with @key');
            }
            const key = args[keyIndex];
            return this._core._environment.cache.getItem(key, () => method.apply(this, args), validate);
        };
        descriptor.value = newMethod;
    };
}
function cache(arg1, arg2, arg3) {
    if (!arg2) {
        return cacheImpl(arg1);
    }
    // No parameter - invoke without validation
    // (allows using @cache without any parameters)
    return cacheImpl()(arg1, arg2, arg3);
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Memoize the value of a getter or method - this just caches the return value
// forever, so it doesn't get recomputed each time it's called
var memoize$1 = (target, propertyKey, descriptor) => {
    const memo = Symbol(`@memoize ${propertyKey}`);
    const property = descriptor.get ? 'get' : 'value';
    const method = descriptor[property];
    descriptor[property] = function (...args) {
        if (!Object.prototype.hasOwnProperty.call(this, memo)) {
            this[memo] = method.call(this, ...args);
        }
        return this[memo];
    };
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Base class for all events sent out from SAMJS.
 */
class SAMEvent {
    constructor(_type) {
        this._type = _type;
    }
    get type() {
        return this._type;
    }
    toString() {
        return `SAMEvent(${this._type})`;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const CHANGE = 'change';
class ChangeEvent extends SAMEvent {
    constructor() {
        super(CHANGE);
    }
}
const SharedChangeEvent = new ChangeEvent();

const $OBSERVABLE_MAP = Symbol('$OBSERVABLE_MAP');
function getEventForProp(obj, prop) {
    var _a;
    return (_a = (obj[$OBSERVABLE_MAP] || undefined)) === null || _a === void 0 ? void 0 : _a.get(prop);
}
function setEventForProp(obj, prop, event) {
    let map;
    // Detect if a map exists and whether or not it is inherited
    if (Object.getOwnPropertyDescriptor(obj, $OBSERVABLE_MAP)) {
        // not inherited, and it already exists
        map = obj[$OBSERVABLE_MAP];
    }
    else if (obj[$OBSERVABLE_MAP]) {
        // Inherited, and it exists on the parent. The properties of the child class should not be mapped in the parent
        // class, but the child class should have all the mapped properties of the parent class. So create a new map
        // for the child that is a copy of the parent's map.
        map = new Map(obj[$OBSERVABLE_MAP]);
        obj[$OBSERVABLE_MAP] = map;
    }
    else {
        // Not inherited, and it does not exist
        map = new Map();
        obj[$OBSERVABLE_MAP] = map;
    }
    // TODO: warn if event is changed for a prop?
    map.set(prop, event);
}
function observableImpl(event, privatePropNames) {
    return (target, key, descriptor) => {
        if (descriptor.get || descriptor.value) {
            privatePropNames === null || privatePropNames === void 0 ? void 0 : privatePropNames.forEach(prop => setEventForProp(target, prop, event));
        }
        if (descriptor.get) {
            const getter = descriptor.get;
            descriptor.get = function () {
                this._core._environment.mobx.reportObserved(this, event.type);
                return getter.call(this);
            };
        }
        else if (descriptor.value) {
            const method = descriptor.value;
            const newMethod = function (...args) {
                this._core._environment.mobx.reportObserved(this, event.type);
                return method.apply(this, args);
            };
            descriptor.value = newMethod;
        }
        else {
            throw new Error('@observable decorator can only be used with `getters` or `methods`.');
        }
    };
}
function observable$1(arg1, arg2, arg3) {
    // @observable without parens
    if (arg1 && arg2 && arg3) {
        return observableImpl(SharedChangeEvent)(arg1, arg2, arg3);
    }
    // @observable(SomeEvent)
    // @observable(SomeEvent, '_prop1')
    // @observable(SomeEvent, ['_prop1', '_prop2'])
    if (typeof arg1.type === 'string' && (typeof arg2 === 'string' || typeof arg2 === 'undefined' || Array.isArray(arg2))) {
        arg2 = arg2 ? [].concat(arg2) : undefined;
        return observableImpl(arg1, arg2);
    }
    throw new Error('Invalid arguments for @observable');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var uriTemplates$1 = {exports: {}};

(function (module) {
(function (global, factory) {
	if (module.exports){
		module.exports = factory();
	} else {
		global.UriTemplate = factory();
	}
})(commonjsGlobal, function () {
	var uriTemplateGlobalModifiers = {
		"+": true,
		"#": true,
		".": true,
		"/": true,
		";": true,
		"?": true,
		"&": true
	};
	var uriTemplateSuffices = {
		"*": true
	};

	function notReallyPercentEncode(string) {
		return encodeURI(string).replace(/%25[0-9][0-9]/g, function (doubleEncoded) {
			return "%" + doubleEncoded.substring(3);
		});
	}

	function isPercentEncoded(string) {
		string = string.replace(/%../g, '');
		return encodeURIComponent(string) === string;
	}

	function uriTemplateSubstitution(spec) {
		var modifier = "";
		if (uriTemplateGlobalModifiers[spec.charAt(0)]) {
			modifier = spec.charAt(0);
			spec = spec.substring(1);
		}
		var separator = "";
		var prefix = "";
		var shouldEscape = true;
		var showVariables = false;
		var trimEmptyString = false;
		if (modifier == '+') {
			shouldEscape = false;
		} else if (modifier == ".") {
			prefix = ".";
			separator = ".";
		} else if (modifier == "/") {
			prefix = "/";
			separator = "/";
		} else if (modifier == '#') {
			prefix = "#";
			shouldEscape = false;
		} else if (modifier == ';') {
			prefix = ";";
			separator = ";",
			showVariables = true;
			trimEmptyString = true;
		} else if (modifier == '?') {
			prefix = "?";
			separator = "&",
			showVariables = true;
		} else if (modifier == '&') {
			prefix = "&";
			separator = "&",
			showVariables = true;
		}

		var varNames = [];
		var varList = spec.split(",");
		var varSpecs = [];
		var varSpecMap = {};
		for (var i = 0; i < varList.length; i++) {
			var varName = varList[i];
			var truncate = null;
			if (varName.indexOf(":") != -1) {
				var parts = varName.split(":");
				varName = parts[0];
				truncate = parseInt(parts[1]);
			}
			var suffices = {};
			while (uriTemplateSuffices[varName.charAt(varName.length - 1)]) {
				suffices[varName.charAt(varName.length - 1)] = true;
				varName = varName.substring(0, varName.length - 1);
			}
			var varSpec = {
				truncate: truncate,
				name: varName,
				suffices: suffices
			};
			varSpecs.push(varSpec);
			varSpecMap[varName] = varSpec;
			varNames.push(varName);
		}
		var subFunction = function (valueFunction) {
			var result = "";
			var startIndex = 0;
			for (var i = 0; i < varSpecs.length; i++) {
				var varSpec = varSpecs[i];
				var value = valueFunction(varSpec.name);
				if (value == null || (Array.isArray(value) && value.length == 0) || (typeof value == 'object' && Object.keys(value).length == 0)) {
					startIndex++;
					continue;
				}
				if (i == startIndex) {
					result += prefix;
				} else {
					result += (separator || ",");
				}
				if (Array.isArray(value)) {
					if (showVariables) {
						result += varSpec.name + "=";
					}
					for (var j = 0; j < value.length; j++) {
						if (j > 0) {
							result += varSpec.suffices['*'] ? (separator || ",") : ",";
							if (varSpec.suffices['*'] && showVariables) {
								result += varSpec.name + "=";
							}
						}
						result += shouldEscape ? encodeURIComponent(value[j]).replace(/!/g, "%21") : notReallyPercentEncode(value[j]);
					}
				} else if (typeof value == "object") {
					if (showVariables && !varSpec.suffices['*']) {
						result += varSpec.name + "=";
					}
					var first = true;
					for (var key in value) {
						if (!first) {
							result += varSpec.suffices['*'] ? (separator || ",") : ",";
						}
						first = false;
						result += shouldEscape ? encodeURIComponent(key).replace(/!/g, "%21") : notReallyPercentEncode(key);
						result += varSpec.suffices['*'] ? '=' : ",";
						result += shouldEscape ? encodeURIComponent(value[key]).replace(/!/g, "%21") : notReallyPercentEncode(value[key]);
					}
				} else {
					if (showVariables) {
						result += varSpec.name;
						if (!trimEmptyString || value != "") {
							result += "=";
						}
					}
					if (varSpec.truncate != null) {
						value = value.substring(0, varSpec.truncate);
					}
					result += shouldEscape ? encodeURIComponent(value).replace(/!/g, "%21"): notReallyPercentEncode(value);
				}
			}
			return result;
		};
		var guessFunction = function (stringValue, resultObj, strict) {
			if (prefix) {
				stringValue = stringValue.substring(prefix.length);
			}
			if (varSpecs.length == 1 && varSpecs[0].suffices['*']) {
				var varSpec = varSpecs[0];
				var varName = varSpec.name;
				var arrayValue = varSpec.suffices['*'] ? stringValue.split(separator || ",") : [stringValue];
				var hasEquals = (shouldEscape && stringValue.indexOf('=') != -1);	// There's otherwise no way to distinguish between "{value*}" for arrays and objects
				for (var i = 1; i < arrayValue.length; i++) {
					var stringValue = arrayValue[i];
					if (hasEquals && stringValue.indexOf('=') == -1) {
						// Bit of a hack - if we're expecting "=" for key/value pairs, and values can't contain "=", then assume a value has been accidentally split
						arrayValue[i - 1] += (separator || ",") + stringValue;
						arrayValue.splice(i, 1);
						i--;
					}
				}
				for (var i = 0; i < arrayValue.length; i++) {
					var stringValue = arrayValue[i];
					if (shouldEscape && stringValue.indexOf('=') != -1) {
						hasEquals = true;
					}
					var innerArrayValue = stringValue.split(",");
					if (innerArrayValue.length == 1) {
						arrayValue[i] = innerArrayValue[0];
					} else {
						arrayValue[i] = innerArrayValue;
					}
				}

				if (showVariables || hasEquals) {
					var objectValue = resultObj[varName] || {};
					for (var j = 0; j < arrayValue.length; j++) {
						var innerValue = stringValue;
						if (showVariables && !innerValue) {
							// The empty string isn't a valid variable, so if our value is zero-length we have nothing
							continue;
						}
						if (typeof arrayValue[j] == "string") {
							var stringValue = arrayValue[j];
							var innerVarName = stringValue.split("=", 1)[0];
							var stringValue = stringValue.substring(innerVarName.length + 1);
							if (shouldEscape) {
								if (strict && !isPercentEncoded(stringValue)) {
									return;
								}
								stringValue = decodeURIComponent(stringValue);
							}
							innerValue = stringValue;
						} else {
							var stringValue = arrayValue[j][0];
							var innerVarName = stringValue.split("=", 1)[0];
							var stringValue = stringValue.substring(innerVarName.length + 1);
							if (shouldEscape) {
								if (strict && !isPercentEncoded(stringValue)) {
									return;
								}
								stringValue = decodeURIComponent(stringValue);
							}
							arrayValue[j][0] = stringValue;
							innerValue = arrayValue[j];
						}
						if (shouldEscape) {
							if (strict && !isPercentEncoded(innerVarName)) {
								return;
							}
							innerVarName = decodeURIComponent(innerVarName);
						}

						if (objectValue[innerVarName] !== undefined) {
							if (Array.isArray(objectValue[innerVarName])) {
								objectValue[innerVarName].push(innerValue);
							} else {
								objectValue[innerVarName] = [objectValue[innerVarName], innerValue];
							}
						} else {
							objectValue[innerVarName] = innerValue;
						}
					}
					if (Object.keys(objectValue).length == 1 && objectValue[varName] !== undefined) {
						resultObj[varName] = objectValue[varName];
					} else {
						resultObj[varName] = objectValue;
					}
				} else {
					if (shouldEscape) {
						for (var j = 0; j < arrayValue.length; j++) {
							var innerArrayValue = arrayValue[j];
							if (Array.isArray(innerArrayValue)) {
								for (var k = 0; k < innerArrayValue.length; k++) {
									if (strict && !isPercentEncoded(innerArrayValue[k])) {
										return;
									}
									innerArrayValue[k] = decodeURIComponent(innerArrayValue[k]);
								}
							} else {
								if (strict && !isPercentEncoded(innerArrayValue)) {
									return;
								}
								arrayValue[j] = decodeURIComponent(innerArrayValue);
							}
						}
					}

					if (resultObj[varName] !== undefined) {
						if (Array.isArray(resultObj[varName])) {
							resultObj[varName] = resultObj[varName].concat(arrayValue);
						} else {
							resultObj[varName] = [resultObj[varName]].concat(arrayValue);
						}
					} else {
						if (arrayValue.length == 1 && !varSpec.suffices['*']) {
							resultObj[varName] = arrayValue[0];
						} else {
							resultObj[varName] = arrayValue;
						}
					}
				}
			} else {
				var arrayValue = (varSpecs.length == 1) ? [stringValue] : stringValue.split(separator || ",");
				var specIndexMap = {};
				for (var i = 0; i < arrayValue.length; i++) {
					// Try from beginning
					var firstStarred = 0;
					for (; firstStarred < varSpecs.length - 1 && firstStarred < i; firstStarred++) {
						if (varSpecs[firstStarred].suffices['*']) {
							break;
						}
					}
					if (firstStarred == i) {
						// The first [i] of them have no "*" suffix
						specIndexMap[i] = i;
						continue;
					} else {
						// Try from the end
						for (var lastStarred = varSpecs.length - 1; lastStarred > 0 && (varSpecs.length - lastStarred) < (arrayValue.length - i); lastStarred--) {
							if (varSpecs[lastStarred].suffices['*']) {
								break;
							}
						}
						if ((varSpecs.length - lastStarred) == (arrayValue.length - i)) {
							// The last [length - i] of them have no "*" suffix
							specIndexMap[i] = lastStarred;
							continue;
						}
					}
					// Just give up and use the first one
					specIndexMap[i] = firstStarred;
				}
				for (var i = 0; i < arrayValue.length; i++) {
					var stringValue = arrayValue[i];
					if (!stringValue && showVariables) {
						// The empty string isn't a valid variable, so if our value is zero-length we have nothing
						continue;
					}
					var innerArrayValue = stringValue.split(",");
					var hasEquals = false;

					if (showVariables) {
						var stringValue = innerArrayValue[0]; // using innerArrayValue
						var varName = stringValue.split("=", 1)[0];
						var stringValue = stringValue.substring(varName.length + 1);
						innerArrayValue[0] = stringValue;
						var varSpec = varSpecMap[varName] || varSpecs[0];
					} else {
						var varSpec = varSpecs[specIndexMap[i]];
						var varName = varSpec.name;
					}

					for (var j = 0; j < innerArrayValue.length; j++) {
						if (shouldEscape) {
							if (strict && !isPercentEncoded(innerArrayValue[j])) {
								return;
							}
							innerArrayValue[j] = decodeURIComponent(innerArrayValue[j]);
						}
					}

					if ((showVariables || varSpec.suffices['*'])&& resultObj[varName] !== undefined) {
						if (Array.isArray(resultObj[varName])) {
							resultObj[varName] = resultObj[varName].concat(innerArrayValue);
						} else {
							resultObj[varName] = [resultObj[varName]].concat(innerArrayValue);
						}
					} else {
						if (innerArrayValue.length == 1 && !varSpec.suffices['*']) {
							resultObj[varName] = innerArrayValue[0];
						} else {
							resultObj[varName] = innerArrayValue;
						}
					}
				}
			}
			return 1;
		};
		return {
			varNames: varNames,
			prefix: prefix,
			substitution: subFunction,
			unSubstitution: guessFunction
		};
	}

	function UriTemplate(template) {
		if (!(this instanceof UriTemplate)) {
			return new UriTemplate(template);
		}
		var parts = template.split("{");
		var textParts = [parts.shift()];
		var prefixes = [];
		var substitutions = [];
		var unSubstitutions = [];
		var varNames = [];
		while (parts.length > 0) {
			var part = parts.shift();
			var spec = part.split("}")[0];
			var remainder = part.substring(spec.length + 1);
			var funcs = uriTemplateSubstitution(spec);
			substitutions.push(funcs.substitution);
			unSubstitutions.push(funcs.unSubstitution);
			prefixes.push(funcs.prefix);
			textParts.push(remainder);
			varNames = varNames.concat(funcs.varNames);
		}
		this.fill = function (valueFunction) {
			if (valueFunction && typeof valueFunction !== 'function') {
				var value = valueFunction;
				valueFunction = function (varName) {
					return value[varName];
				};
			}

			var result = textParts[0];
			for (var i = 0; i < substitutions.length; i++) {
				var substitution = substitutions[i];
				result += substitution(valueFunction);
				result += textParts[i + 1];
			}
			return result;
		};
		this.fromUri = function (substituted, options) {
			options = options || {};
			var result = {};
			for (var i = 0; i < textParts.length; i++) {
				var part = textParts[i];
				if (substituted.substring(0, part.length) !== part) {
					return /*undefined*/;
				}
				substituted = substituted.substring(part.length);
				if (i >= textParts.length - 1) {
					// We've run out of input - is there any template left?
					if (substituted == "") {
						break;
					} else {
						return /*undefined*/;
					}
				}

				var prefix = prefixes[i];
				if (prefix && substituted.substring(0, prefix.length) !== prefix) {
					// All values are optional - if we have a prefix and it doesn't match, move along
					continue;
				}

				// Find the next part to un-substitute
				var nextPart = textParts[i + 1];
				var offset = i;
				while (true) {
					if (offset == textParts.length - 2) {
						var endPart = substituted.substring(substituted.length - nextPart.length);
						if (endPart !== nextPart) {
							return /*undefined*/;
						}
						var stringValue = substituted.substring(0, substituted.length - nextPart.length);
						substituted = endPart;
					} else if (nextPart) {
						var nextPartPos = substituted.indexOf(nextPart);
						var stringValue = substituted.substring(0, nextPartPos);
						substituted = substituted.substring(nextPartPos);
					} else if (prefixes[offset + 1]) {
						var nextPartPos = substituted.indexOf(prefixes[offset + 1]);
						if (nextPartPos === -1) nextPartPos = substituted.length;
						var stringValue = substituted.substring(0, nextPartPos);
						substituted = substituted.substring(nextPartPos);
					} else if (textParts.length > offset + 2) {
						// If the separator between this variable and the next is blank (with no prefix), continue onwards
						offset++;
						nextPart = textParts[offset + 1];
						continue;
					} else {
						var stringValue = substituted;
						substituted = "";
					}
					break;
				}
				if (!unSubstitutions[i](stringValue, result, options.strict)) {
					return /*undefined*/;
				}
			}
			return result;
		};
		this.varNames = varNames;
		this.template = template;
	}
	UriTemplate.prototype = {
		toString: function () {
			return this.template;
		},
		fillFromObject: function (obj) {
			return this.fill(obj);
		},
		test: function (uri, options) {
			return !!this.fromUri(uri, options)
		}
	};

	return UriTemplate;
});
}(uriTemplates$1));

var uriTemplates = uriTemplates$1.exports;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const JSON_MIME_TYPE = 'application/json';
const JSON_PATCH_MIME_TYPE = 'application/json-patch+json';
var RelType;
(function (RelType) {
    // Repository API
    RelType["PRIMARY"] = "http://ns.adobe.com/adobecloud/rel/primary";
    // @deprecated - Not required
    RelType["ID"] = "http://ns.adobe.com/adobecloud/rel/id";
    // @deprecated - Not required
    RelType["PATH"] = "http://ns.adobe.com/adobecloud/rel/path";
    RelType["RENDITION"] = "http://ns.adobe.com/adobecloud/rel/rendition";
    RelType["COMPONENT_RENDITION"] = "http://ns.adobe.com/adobecloud/rel/componentRendition";
    RelType["MANIFEST"] = "http://ns.adobe.com/adobecloud/rel/manifest";
    RelType["QUOTA"] = "http://ns.adobe.com/adobecloud/rel/quota";
    RelType["COMPONENT"] = "http://ns.adobe.com/adobecloud/rel/component";
    RelType["PAGE"] = "http://ns.adobe.com/adobecloud/rel/page";
    RelType["DISCARD"] = "http://ns.adobe.com/adobecloud/rel/discard";
    RelType["RESTORE"] = "http://ns.adobe.com/adobecloud/rel/restore";
    RelType["DIRECTORY"] = "http://ns.adobe.com/adobecloud/rel/directory";
    // @deprecated - Not required
    RelType["DIRECTORY_BASE"] = "http://ns.adobe.com/adobecloud/rel/directory/base";
    RelType["AC_EFFECTIVE"] = "http://ns.adobe.com/adobecloud/rel/ac/effective";
    RelType["AC_POLICY"] = "http://ns.adobe.com/adobecloud/rel/ac/policy";
    // @deprecated -- Not required
    RelType["AC_CHECK"] = "http://ns.adobe.com/adobecloud/rel/ac/check";
    RelType["CREATE"] = "http://ns.adobe.com/adobecloud/rel/create";
    RelType["REPOSITORY"] = "http://ns.adobe.com/adobecloud/rel/repository";
    RelType["RESOLVE_ID"] = "http://ns.adobe.com/adobecloud/rel/resolve/id";
    RelType["RESOLVE_PATH"] = "http://ns.adobe.com/adobecloud/rel/resolve/path";
    RelType["OPS"] = "http://ns.adobe.com/adobecloud/rel/ops";
    RelType["BLOCK_INITIALIZE"] = "http://ns.adobe.com/adobecloud/rel/block/init";
    RelType["BLOCK_TRANSFER"] = "http://ns.adobe.com/adobecloud/rel/block/transfer";
    RelType["BLOCK_FINALIZE"] = "http://ns.adobe.com/adobecloud/rel/block/finalize";
    RelType["REPO_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/repository";
    RelType["APP_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/application";
    RelType["EMBEDDED_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/embedded";
    RelType["PERUSER_METADATA"] = "http://ns.adobe.com/adobecloud/rel/metadata/peruser";
    RelType["ANNOTATIONS"] = "http://ns.adobe.com/adobecloud/rel/annotations";
    RelType["DOWNLOAD"] = "http://ns.adobe.com/adobecloud/rel/download";
    RelType["DESCRIBED_BY"] = "describedBy";
    // Versions
    RelType["VERSION"] = "version-history";
    // ONS
    RelType["SUBSCRIPTION_CREATE"] = "subscription/create";
    RelType["NOTIFICATIONS_LONGPOLL"] = "notifications/longpoll";
    RelType["ONS_CHANGELOG"] = "ons/changelog";
    // Projects API
    RelType["REPOSITORIES_PAGE"] = "http://ns.adobe.com/repositories/rel/page";
    RelType["TEAMS_CREATE"] = "http://ns.adobe.com/teams/rel/create";
    RelType["TEAMS_DISCARD"] = "http://ns.adobe.com/teams/rel/discard";
    RelType["TEAMS_RESTORE"] = "http://ns.adobe.com/teams/rel/restore";
    RelType["TEAMS_RENAME"] = "http://ns.adobe.com/teams/rel/rename";
    RelType["TEAMS_PROPERTIES"] = "http://ns.adobe.com/teams/rel/properties";
    RelType["TEAMS_PAGE"] = "http://ns.adobe.com/teams/rel/page";
    RelType["TEAMS_PRIMARY"] = "http://ns.adobe.com/teams/rel/primary";
    RelType["TEAM_PROVISION"] = "http://ns.adobe.com/teams/rel/provision";
    RelType["WORKSPACES_CONTEXT"] = "http://ns.adobe.com/ccprojects/rel/context";
    RelType["WORKSPACES_BOOKMARKS_BATCH"] = "http://ns.adobe.com/ccprojects/rel/bookmarks/batch";
    RelType["WORKSPACES_PRIMARY"] = "http://ns.adobe.com/ccprojects/rel/primary";
    RelType["WORKSPACES_CREATE"] = "http://ns.adobe.com/ccprojects/rel/create";
    RelType["WORKSPACES_PAGE"] = "http://ns.adobe.com/ccprojects/rel/page";
    RelType["PROJECTS_LIBRARIES_PAGE"] = "http://ns.adobe.com/ccprojects/rel/libraries/page";
    RelType["PROJECTS_LIBRARIES_CREATE"] = "http://ns.adobe.com/ccprojects/rel/libraries/create";
    RelType["PROJECTS_LIBRARIES_BATCH"] = "http://ns.adobe.com/ccprojects/rel/libraries/batch";
    RelType["GENERIC_PAGE"] = "page";
    RelType["GENERIC_NEXT"] = "next";
    // Asset Transfer Service
    RelType["ATS_MOVE"] = "http://ns.adobe.com/ats/rel/move";
    // Review Service
    RelType["REVIEW_SERVICE_PROVISION"] = "http://ns.adobe.com/ccassetreview/rel/provision";
    RelType["REVIEW_SERVICE_DISCARD"] = "http://ns.adobe.com/ccassetreview/rel/discard";
    RelType["REVIEW_SERVICE_OUTPUTS"] = "http://ns.adobe.com/ccassetreview/rel/outputs";
    RelType["REVIEW_SERIVCE_HAS_OUTPUTS"] = "http://ns.adobe.com/ccassetreview/rel/hasoutputs";
    // Projects service v3
    RelType["PROJECTS_CONTEXT"] = "http://ns.adobe.com/projects/rel/context";
    RelType["PROJECTS_PRIMARY"] = "http://ns.adobe.com/projects/rel/primary";
    RelType["PROJECTS_COLLECTION"] = "http://ns.adobe.com/projects/rel/collection";
    RelType["PROJECTS_CREATE"] = "http://ns.adobe.com/projects/rel/create";
    RelType["PROJECTS_RENAME"] = "http://ns.adobe.com/projects/rel/rename";
    RelType["PROJECTS_CREATOR"] = "http://ns.adobe.com/projects/rel/creator";
    RelType["PROJECTS_GRADIENTS_COLLECTION"] = "http://ns.adobe.com/gradients/rel/collection";
    RelType["PROJECTS_CAPABILITY"] = "http://ns.adobe.com/projects/rel/capability";
    RelType["ORGANIZATIONS_COLLECTION"] = "http://ns.adobe.com/organizations/rel/collection";
    RelType["PROJECTS_RECENT"] = "http://ns.adobe.com/projects/rel/recent";
    // Assignment service
    RelType["ASSIGNMENTS_ASSIGN"] = "http://ns.adobe.com/assignments/rel/assign";
    RelType["ASSIGNMENTS_CODE"] = "http://ns.adobe.com/assignments/rel/code";
    RelType["ASSIGNMENTS_COLLECTION"] = "http://ns.adobe.com/assignments/rel/collection";
    RelType["ASSIGNMENTS_CREATE"] = "http://ns.adobe.com/assignments/rel/create";
    RelType["ASSIGNMENTS_PRIMARY"] = "http://ns.adobe.com/assignments/rel/primary";
    RelType["ASSIGNMENTS_RETURN"] = "http://ns.adobe.com/assignments/rel/return";
    RelType["ASSIGNMENTS_START"] = "http://ns.adobe.com/assignments/rel/start";
    RelType["ASSIGNMENTS_SUBMIT"] = "http://ns.adobe.com/assignments/rel/submit";
    // Boards service
    RelType["BOARDS_COLLECTION"] = "http://ns.adobe.com/boards/rel/collection";
    RelType["BOARDS_CREATE"] = "http://ns.adobe.com/boards/rel/create";
    RelType["BOARDS_PRIMARY"] = "http://ns.adobe.com/boards/rel/primary";
    // StudentAssignment Service
    RelType["STUDENT_ASSIGNMENTS_COLLECTION"] = "http://ns.adobe.com/studentAssignments/rel/collection";
    RelType["STUDENT_ASSIGNMENTS_PRIMARY"] = "http://ns.adobe.com/studentAssignments/rel/primary";
    // Mellville
    RelType["MELVILLE_FIREFLY_GENERATION_CANCEL"] = "http://ns.adobe.com/firefly/rel/cancel";
    RelType["MELVILLE_FIREFLY_GENERATION_RESULT"] = "http://ns.adobe.com/firefly/rel/result";
})(RelType || (RelType = {}));
function validateLinkParameters(links, key, params) {
    try {
        const templateString = getTemplateFromLinks(links, key);
        const template = uriTemplates(templateString);
        // Check that required arguments are available.
        return params.every((param) => template.varNames.indexOf(param) !== -1);
    }
    catch (_a) {
        // We only care if the link is valid. If it is not valid, then we will return false,
        // so that our caches could be invalidated correctly.
        return false;
    }
}
function validateLinks(links, requirements) {
    if (links === undefined) {
        return true;
    }
    if (Object(links) !== links) {
        return false;
    }
    // All links should have an href
    const hasMissingHrefs = Object.keys(links).some(key => {
        const link = links[key];
        if (!Array.isArray(link)) {
            return typeof link.href !== 'string';
        }
        return link.some(({ href }) => typeof href !== 'string');
    });
    if (hasMissingHrefs) {
        return false;
    }
    if (requirements) {
        const keys = Object.keys(requirements);
        const hasAllParameters = keys.every((key) => validateLinkParameters(links, key, requirements[key]));
        if (!hasAllParameters) {
            return false;
        }
    }
    return true;
}
function getLink(links, key) {
    let link = links && links[key];
    if (!link || (Array.isArray(link) && link.length === 0)) {
        // The callers of these methods would fail without an actual URL.
        // It is better to fail early by throwing a proper exception.
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Missing link for relationship type: ${key}.`);
    }
    if (Array.isArray(link)) {
        link = link[0];
    }
    return link;
}
function getTemplateFromLinks(links, key) {
    return getLink(links, key).href;
}
function getURLFromLinks(links, key, params = {}) {
    const templateString = getTemplateFromLinks(links, key);
    const template = uriTemplates(templateString);
    const preparedParams = JSON.parse(JSON.stringify(params, (key, val) => (typeof val === 'boolean') ? val.toString() : val));
    return template && template.fill(preparedParams);
}
const RETRY_RANDOM_SECONDS = 30; // Choose random seconds between [0,x] for retry-after as a date
function getRetryAfterHeader(headers) {
    const retryAfterHeader = headers && headers.get('Retry-After');
    if (retryAfterHeader) {
        try {
            // First, try to parse it as a number (retry time in seconds)
            const retryTime = parseInt(retryAfterHeader, 10);
            if (retryTime) {
                return Math.max(0, retryTime);
            }
            // If that fails, try to parse it as a date
            const retryDate = Date.parse(retryAfterHeader);
            if (retryDate) {
                // Need to add a randomised element to ensure requests don't all come back at the same time
                const now = Date.now();
                const retrySeconds = Math.max(0, retryDate - now) / 1000;
                const retryRandom = Math.floor(Math.random() * RETRY_RANDOM_SECONDS);
                return retrySeconds + retryRandom;
            }
        }
        catch (e) {
            // ignore
        }
    }
    return 0;
}
/**
 * Add query parameters to a url from an object.
 * @param url
 * @param queryParams
 * @returns encoded url with query params
 */
function fillURLTemplate$1(url, queryParams) {
    const template = uriTemplates(`${url}{?queryParams*}`);
    return template.fillFromObject({ queryParams });
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const VALID_HTTP_RESPONSE_CODES = [200];
// See https://git.corp.adobe.com/pages/caf/api-spec/chapters/responses/service_responses.html
const RETRY_HTTP_RESPONSE_CODES = [
    429,
    500,
    // 501 -- Not implemented -- client must not retry
    502, 503, 504 // Upstream service (gateways/proxies) errors -- may be transient, client can retry
    // >=505 -- other non-retryable errors
];

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Support retrying an asynchronous method on failure, with a backoff
var retry = (target, propertyKey, descriptor) => {
    const timeout = Symbol(`@retry ${propertyKey}`);
    const method = descriptor.value;
    descriptor.value = async function (attempt = 0) {
        var _a, _b;
        const timeoutId = this[timeout];
        if (timeoutId) {
            clearTimeout(timeoutId);
            this[timeout] = undefined;
        }
        try {
            await method.call(this);
        }
        catch (e) {
            let interval = 0;
            const response = (_a = e._additionalInfo) === null || _a === void 0 ? void 0 : _a.response;
            if (RETRY_HTTP_RESPONSE_CODES.includes(response === null || response === void 0 ? void 0 : response.status)) {
                // InterfaceBase already auto-retried, so back off using the maximum retry interval.
                interval = this._core._environment.getValue('MAX_RETRY_INTERVAL') || 20000;
            }
            else {
                // Retry all other errors, but at a different interval
                const retryAfter = ((_b = e._additionalInfo) === null || _b === void 0 ? void 0 : _b.response) ? getRetryAfterHeader(e._additionalInfo.response.headers) * 1000 : 0;
                // If we're unable to resolve (unable to connect to services or unexpected response), we schedule a retry
                interval = Math.max(this._core._environment.getRetryInterval(attempt), retryAfter);
            }
            this._core._environment.log(`Retrying ${propertyKey} in ${interval}ms`);
            this[timeout] = setTimeout(() => descriptor.value.call(this, attempt + 1), interval);
        }
    };
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * The synchronized decorator ensures that only one caller can be executing the method at once,
 * similar to the synchronized keyword in Java for critical blocks. This only makes sense
 * to apply to asynchronous methods, since JavaScript is single-threaded.
 *
 * If an @synchronized method is called while another caller is already executing it, the second
 * caller will wait until the first caller finishes (regardless of whether the promise rejects or succeeds),
 * before executing.
 *
 * A parameter can be marked as @key, allowing multiple concurrent calls so long as the keys are different
 * (this is similar to passing a value to synchronized() in Java).
 */
var synchronized = (target, propertyKey, descriptor) => {
    const promisesMapProperty = Symbol(`@synchronized ${propertyKey}`);
    const method = descriptor.value;
    if (!method) {
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, '@synchronized decorator can only be applied to a method');
    }
    descriptor.value = async function (...args) {
        var _a;
        const keyIndex = (_a = this[KeysProperty]) === null || _a === void 0 ? void 0 : _a.get(propertyKey);
        const key = keyIndex === undefined ? 'default' : args[keyIndex];
        const map = this[promisesMapProperty] || (this[promisesMapProperty] = new Map);
        let promise;
        do {
            promise = map.get(key);
            if (promise) {
                // Somebody else was already executing, so we wait for that to finish first
                try {
                    await promise;
                }
                catch (e) {
                    // Ignore any errors - we'll execute after the existing caller resolves or rejects
                }
            }
        } while (promise);
        // Now enter the critical block ourself - record the promise so others need to wait.
        // Note that we use different promise so that we ensure other callers continue only after
        // we've deleted the previous promise.
        // eslint-disable-next-line
        let outerResolve = (value) => { };
        map.set(key, new Promise(resolve => outerResolve = resolve));
        try {
            return await method.apply(this, args);
        }
        finally {
            // Always delete the promise even if we reject, to allow others to continue
            map.delete(key);
            outerResolve(undefined);
        }
    };
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const $WeakCacheProperty = Symbol('WeakCacheProperty');
function stringifyWithSortedKeys(input) {
    if (typeof input === 'string' || typeof input === 'number' || input instanceof Date || typeof input === 'boolean') {
        return JSON.stringify(input);
    }
    else if (typeof input === 'object' && input !== null) {
        const sortedObject = Object.keys(input).sort().reduce((newObj, key) => {
            newObj[key] = input[key];
            return newObj;
        }, {});
        return JSON.stringify(sortedObject);
    }
    throw new Error(`Unsupported input type (${input})`);
}
function isPrimitive$1(value) {
    return value === null || (typeof value !== 'object' && typeof value !== 'function');
}
/**
 * Cache the result of the method given a set of arguments. The cache is weak, meaning that the object will be garbage collected.
 * Therefore, it's recommended to use @keepAlive decorator to keep the object alive in memory.
 * This decorator will not work with method that returns primitive types (e.g. string, number, boolean, etc).
 * A parameter of the target function can be marked as @key to use as the key for the cache. If no parameter is marked as @key, the default key is 'default'.
 *
 * If the parameter, which is attached with @key, is explicitly set to null or undefined, the decorator will throw an error.
 * For example:
 *   @weakCache
 *   exampleFunction(@key value?: string) {}
 *   exampleFunction(null); // This would throw an error
 *
 */
var weakCache = (target, propertyKey, descriptor) => {
    var _a;
    const originalFn = descriptor.value;
    if (!originalFn) {
        throw new Error('@weakCache decorator can only be applied to a method');
    }
    // this is to avoid unexpected side-effects between unrelated target objects with the same property name (i.e. propertyKey)
    const cache = (_a = target[$WeakCacheProperty]) !== null && _a !== void 0 ? _a : (target[$WeakCacheProperty] = new Map());
    descriptor.value = function (...args) {
        var _a, _b;
        const keyIndex = (_a = this[KeysProperty]) === null || _a === void 0 ? void 0 : _a.get(propertyKey);
        const keyArgs = keyIndex === undefined || args.length === 0 ? 'default' : args[keyIndex];
        // we need to sort the keys of keyArgs in case it is an object to ensure that the cache key is consistent
        // For example, do(@key {a: 1, b: 2}) and do(@key {b: 2, a: 1}) should have the same cache key
        const key = `${propertyKey} (${stringifyWithSortedKeys(keyArgs)})`;
        let result = (_b = cache.get(key)) === null || _b === void 0 ? void 0 : _b.deref();
        if (result) {
            return result;
        }
        result = originalFn.call(this, ...args);
        if (isPrimitive$1(result)) {
            throw new Error('Cannot cache primitive types');
        }
        cache.set(key, new WeakRef(result));
        return result;
    };
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * The @consolidated decorator is for async methods where multiple calls in parallel can be combined into one
 * call. E.g., if caller1 is waiting for a response and caller2 makes a call, caller2 will receive the same
 * response as caller1.
 *
 * Often used in lazy-load cases where the data needs to be fetched only once initially, and only once when
 * it needs refreshing.
 **
 * A parameter can be marked as @key, allowing multiple concurrent calls so long as the keys are different.
 */
var consolidated = (target, propertyKey, descriptor) => {
    const promisesMapProperty = Symbol(`@consolidated ${propertyKey}`);
    const method = descriptor.value;
    if (!method) {
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, '@consolidated decorator can only be applied to a method');
    }
    descriptor.value = async function (...args) {
        var _a;
        const keyIndex = (_a = this[KeysProperty]) === null || _a === void 0 ? void 0 : _a.get(propertyKey);
        const key = keyIndex === undefined ? 'default' : args[keyIndex];
        const map = this[promisesMapProperty] || (this[promisesMapProperty] = new Map);
        const promise = map.get(key);
        // Another call is pending, so piggy-back on it
        if (promise) {
            return promise;
        }
        else {
            // Track this call so other callers can piggy-back on it
            const promise = method.apply(this, args);
            map.set(key, promise);
            promise.finally(() => {
                map.delete(key);
            });
            return promise;
        }
    };
};

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2024 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
const DEFAULT_CACHE_KEEP_ALIVE_TTL = 10 * 60 * 1000; // 10 minutes
/**
 * @description KeepAliveManager -- a singleton class that will keep a hard reference to objects passed to it.
 * This decorator should be used on all public context methods that return an AdobAsset.
 */
class KeepAliveManager {
    constructor(_ttl = DEFAULT_CACHE_KEEP_ALIVE_TTL) {
        this._ttl = _ttl;
        this._keepAliveMap = new Map();
    }
    /**
     * @description Get the singleton instance of the KeepAliveManager.
     */
    static getInstance() {
        if (!KeepAliveManager._instance) {
            KeepAliveManager._instance = new KeepAliveManager(DEFAULT_CACHE_KEEP_ALIVE_TTL);
        }
        return KeepAliveManager._instance;
    }
    /**
     * @description Set the time to live for objects in the KeepAliveManager.
     * @param ttl The time to live in milliseconds as a non-zero integer.
     * @throws Error if ttl is less than 0.
     */
    static setTTL(ttl) {
        if (ttl < 0) {
            throw SAMError.create(SAMErrorCode.UNKNOWN, 'TTL must be greater than or equal to 0');
        }
        KeepAliveManager.getInstance()._ttl = ttl;
    }
    /**
     * @description Add an object to the KeepAliveManager.
     * @param obj The object to keep alive.
     */
    add(obj) {
        if (this._ttl === 0) {
            return; // Not enabled by config
        }
        const existingTimer = this._keepAliveMap.get(obj);
        if (existingTimer) {
            clearTimeout(existingTimer);
        }
        this._keepAliveMap.set(obj, setTimeout(() => {
            this._keepAliveMap.delete(obj);
        }, this._ttl));
    }
}
/**
 * @description decorator to prevent garbage collection of a returned object for a certain amount of time.
 */
function keepAlive(target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args) {
        const value = originalMethod.apply(this, args);
        if (value instanceof Promise) {
            value.then((v) => KeepAliveManager.getInstance().add(v)).catch(() => {
                // Do not re-throw.  The error will still bubble up through the decorated function
            });
        }
        else if ((value !== null && value !== void 0 ? value : null) !== null) {
            KeepAliveManager.getInstance().add(value);
        }
        return value;
    };
}

/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * @copyright 2015 Toru Nagashima. All rights reserved.
 * See LICENSE file in root directory for full license.
 */
/**
 * @typedef {object} PrivateData
 * @property {EventTarget} eventTarget The event target.
 * @property {{type:string}} event The original event object.
 * @property {number} eventPhase The current event phase.
 * @property {EventTarget|null} currentTarget The current event target.
 * @property {boolean} canceled The flag to prevent default.
 * @property {boolean} stopped The flag to stop propagation.
 * @property {boolean} immediateStopped The flag to stop propagation immediately.
 * @property {Function|null} passiveListener The listener if the current listener is passive. Otherwise this is null.
 * @property {number} timeStamp The unix time.
 * @private
 */

/**
 * Private data for event wrappers.
 * @type {WeakMap<Event, PrivateData>}
 * @private
 */
const privateData = new WeakMap();

/**
 * Cache for wrapper classes.
 * @type {WeakMap<Object, Function>}
 * @private
 */
const wrappers = new WeakMap();

/**
 * Get private data.
 * @param {Event} event The event object to get private data.
 * @returns {PrivateData} The private data of the event.
 * @private
 */
function pd(event) {
    const retv = privateData.get(event);
    console.assert(
        retv != null,
        "'this' is expected an Event object, but got",
        event
    );
    return retv
}

/**
 * https://dom.spec.whatwg.org/#set-the-canceled-flag
 * @param data {PrivateData} private data.
 */
function setCancelFlag(data) {
    if (data.passiveListener != null) {
        if (
            typeof console !== "undefined" &&
            typeof console.error === "function"
        ) {
            console.error(
                "Unable to preventDefault inside passive event listener invocation.",
                data.passiveListener
            );
        }
        return
    }
    if (!data.event.cancelable) {
        return
    }

    data.canceled = true;
    if (typeof data.event.preventDefault === "function") {
        data.event.preventDefault();
    }
}

/**
 * @see https://dom.spec.whatwg.org/#interface-event
 * @private
 */
/**
 * The event wrapper.
 * @constructor
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Event|{type:string}} event The original event to wrap.
 */
function Event$1(eventTarget, event) {
    privateData.set(this, {
        eventTarget,
        event,
        eventPhase: 2,
        currentTarget: eventTarget,
        canceled: false,
        stopped: false,
        immediateStopped: false,
        passiveListener: null,
        timeStamp: event.timeStamp || Date.now(),
    });

    // https://heycam.github.io/webidl/#Unforgeable
    Object.defineProperty(this, "isTrusted", { value: false, enumerable: true });

    // Define accessors
    const keys = Object.keys(event);
    for (let i = 0; i < keys.length; ++i) {
        const key = keys[i];
        if (!(key in this)) {
            Object.defineProperty(this, key, defineRedirectDescriptor(key));
        }
    }
}

// Should be enumerable, but class methods are not enumerable.
Event$1.prototype = {
    /**
     * The type of this event.
     * @type {string}
     */
    get type() {
        return pd(this).event.type
    },

    /**
     * The target of this event.
     * @type {EventTarget}
     */
    get target() {
        return pd(this).eventTarget
    },

    /**
     * The target of this event.
     * @type {EventTarget}
     */
    get currentTarget() {
        return pd(this).currentTarget
    },

    /**
     * @returns {EventTarget[]} The composed path of this event.
     */
    composedPath() {
        const currentTarget = pd(this).currentTarget;
        if (currentTarget == null) {
            return []
        }
        return [currentTarget]
    },

    /**
     * Constant of NONE.
     * @type {number}
     */
    get NONE() {
        return 0
    },

    /**
     * Constant of CAPTURING_PHASE.
     * @type {number}
     */
    get CAPTURING_PHASE() {
        return 1
    },

    /**
     * Constant of AT_TARGET.
     * @type {number}
     */
    get AT_TARGET() {
        return 2
    },

    /**
     * Constant of BUBBLING_PHASE.
     * @type {number}
     */
    get BUBBLING_PHASE() {
        return 3
    },

    /**
     * The target of this event.
     * @type {number}
     */
    get eventPhase() {
        return pd(this).eventPhase
    },

    /**
     * Stop event bubbling.
     * @returns {void}
     */
    stopPropagation() {
        const data = pd(this);

        data.stopped = true;
        if (typeof data.event.stopPropagation === "function") {
            data.event.stopPropagation();
        }
    },

    /**
     * Stop event bubbling.
     * @returns {void}
     */
    stopImmediatePropagation() {
        const data = pd(this);

        data.stopped = true;
        data.immediateStopped = true;
        if (typeof data.event.stopImmediatePropagation === "function") {
            data.event.stopImmediatePropagation();
        }
    },

    /**
     * The flag to be bubbling.
     * @type {boolean}
     */
    get bubbles() {
        return Boolean(pd(this).event.bubbles)
    },

    /**
     * The flag to be cancelable.
     * @type {boolean}
     */
    get cancelable() {
        return Boolean(pd(this).event.cancelable)
    },

    /**
     * Cancel this event.
     * @returns {void}
     */
    preventDefault() {
        setCancelFlag(pd(this));
    },

    /**
     * The flag to indicate cancellation state.
     * @type {boolean}
     */
    get defaultPrevented() {
        return pd(this).canceled
    },

    /**
     * The flag to be composed.
     * @type {boolean}
     */
    get composed() {
        return Boolean(pd(this).event.composed)
    },

    /**
     * The unix time of this event.
     * @type {number}
     */
    get timeStamp() {
        return pd(this).timeStamp
    },

    /**
     * The target of this event.
     * @type {EventTarget}
     * @deprecated
     */
    get srcElement() {
        return pd(this).eventTarget
    },

    /**
     * The flag to stop event bubbling.
     * @type {boolean}
     * @deprecated
     */
    get cancelBubble() {
        return pd(this).stopped
    },
    set cancelBubble(value) {
        if (!value) {
            return
        }
        const data = pd(this);

        data.stopped = true;
        if (typeof data.event.cancelBubble === "boolean") {
            data.event.cancelBubble = true;
        }
    },

    /**
     * The flag to indicate cancellation state.
     * @type {boolean}
     * @deprecated
     */
    get returnValue() {
        return !pd(this).canceled
    },
    set returnValue(value) {
        if (!value) {
            setCancelFlag(pd(this));
        }
    },

    /**
     * Initialize this event object. But do nothing under event dispatching.
     * @param {string} type The event type.
     * @param {boolean} [bubbles=false] The flag to be possible to bubble up.
     * @param {boolean} [cancelable=false] The flag to be possible to cancel.
     * @deprecated
     */
    initEvent() {
        // Do nothing.
    },
};

// `constructor` is not enumerable.
Object.defineProperty(Event$1.prototype, "constructor", {
    value: Event$1,
    configurable: true,
    writable: true,
});

// Ensure `event instanceof window.Event` is `true`.
if (typeof window !== "undefined" && typeof window.Event !== "undefined") {
    Object.setPrototypeOf(Event$1.prototype, window.Event.prototype);

    // Make association for wrappers.
    wrappers.set(window.Event.prototype, Event$1);
}

/**
 * Get the property descriptor to redirect a given property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to redirect the property.
 * @private
 */
function defineRedirectDescriptor(key) {
    return {
        get() {
            return pd(this).event[key]
        },
        set(value) {
            pd(this).event[key] = value;
        },
        configurable: true,
        enumerable: true,
    }
}

/**
 * Get the property descriptor to call a given method property.
 * @param {string} key Property name to define property descriptor.
 * @returns {PropertyDescriptor} The property descriptor to call the method property.
 * @private
 */
function defineCallDescriptor(key) {
    return {
        value() {
            const event = pd(this).event;
            return event[key].apply(event, arguments)
        },
        configurable: true,
        enumerable: true,
    }
}

/**
 * Define new wrapper class.
 * @param {Function} BaseEvent The base wrapper class.
 * @param {Object} proto The prototype of the original event.
 * @returns {Function} The defined wrapper class.
 * @private
 */
function defineWrapper(BaseEvent, proto) {
    const keys = Object.keys(proto);
    if (keys.length === 0) {
        return BaseEvent
    }

    /** CustomEvent */
    function CustomEvent(eventTarget, event) {
        BaseEvent.call(this, eventTarget, event);
    }

    CustomEvent.prototype = Object.create(BaseEvent.prototype, {
        constructor: { value: CustomEvent, configurable: true, writable: true },
    });

    // Define accessors.
    for (let i = 0; i < keys.length; ++i) {
        const key = keys[i];
        if (!(key in BaseEvent.prototype)) {
            const descriptor = Object.getOwnPropertyDescriptor(proto, key);
            const isFunc = typeof descriptor.value === "function";
            Object.defineProperty(
                CustomEvent.prototype,
                key,
                isFunc
                    ? defineCallDescriptor(key)
                    : defineRedirectDescriptor(key)
            );
        }
    }

    return CustomEvent
}

/**
 * Get the wrapper class of a given prototype.
 * @param {Object} proto The prototype of the original event to get its wrapper.
 * @returns {Function} The wrapper class.
 * @private
 */
function getWrapper(proto) {
    if (proto == null || proto === Object.prototype) {
        return Event$1
    }

    let wrapper = wrappers.get(proto);
    if (wrapper == null) {
        wrapper = defineWrapper(getWrapper(Object.getPrototypeOf(proto)), proto);
        wrappers.set(proto, wrapper);
    }
    return wrapper
}

/**
 * Wrap a given event to management a dispatching.
 * @param {EventTarget} eventTarget The event target of this dispatching.
 * @param {Object} event The event to wrap.
 * @returns {Event} The wrapper instance.
 * @private
 */
function wrapEvent(eventTarget, event) {
    const Wrapper = getWrapper(Object.getPrototypeOf(event));
    return new Wrapper(eventTarget, event)
}

/**
 * Get the immediateStopped flag of a given event.
 * @param {Event} event The event to get.
 * @returns {boolean} The flag to stop propagation immediately.
 * @private
 */
function isStopped(event) {
    return pd(event).immediateStopped
}

/**
 * Set the current event phase of a given event.
 * @param {Event} event The event to set current target.
 * @param {number} eventPhase New event phase.
 * @returns {void}
 * @private
 */
function setEventPhase(event, eventPhase) {
    pd(event).eventPhase = eventPhase;
}

/**
 * Set the current target of a given event.
 * @param {Event} event The event to set current target.
 * @param {EventTarget|null} currentTarget New current target.
 * @returns {void}
 * @private
 */
function setCurrentTarget(event, currentTarget) {
    pd(event).currentTarget = currentTarget;
}

/**
 * Set a passive listener of a given event.
 * @param {Event} event The event to set current target.
 * @param {Function|null} passiveListener New passive listener.
 * @returns {void}
 * @private
 */
function setPassiveListener(event, passiveListener) {
    pd(event).passiveListener = passiveListener;
}

/**
 * @typedef {object} ListenerNode
 * @property {Function} listener
 * @property {1|2|3} listenerType
 * @property {boolean} passive
 * @property {boolean} once
 * @property {ListenerNode|null} next
 * @private
 */

/**
 * @type {WeakMap<object, Map<string, ListenerNode>>}
 * @private
 */
const listenersMap = new WeakMap();

// Listener types
const CAPTURE = 1;
const BUBBLE = 2;
const ATTRIBUTE = 3;

/**
 * Check whether a given value is an object or not.
 * @param {any} x The value to check.
 * @returns {boolean} `true` if the value is an object.
 */
function isObject(x) {
    return x !== null && typeof x === "object" //eslint-disable-line no-restricted-syntax
}

/**
 * Get listeners.
 * @param {EventTarget} eventTarget The event target to get.
 * @returns {Map<string, ListenerNode>} The listeners.
 * @private
 */
function getListeners(eventTarget) {
    const listeners = listenersMap.get(eventTarget);
    if (listeners == null) {
        throw new TypeError(
            "'this' is expected an EventTarget object, but got another value."
        )
    }
    return listeners
}

/**
 * Get the property descriptor for the event attribute of a given event.
 * @param {string} eventName The event name to get property descriptor.
 * @returns {PropertyDescriptor} The property descriptor.
 * @private
 */
function defineEventAttributeDescriptor(eventName) {
    return {
        get() {
            const listeners = getListeners(this);
            let node = listeners.get(eventName);
            while (node != null) {
                if (node.listenerType === ATTRIBUTE) {
                    return node.listener
                }
                node = node.next;
            }
            return null
        },

        set(listener) {
            if (typeof listener !== "function" && !isObject(listener)) {
                listener = null; // eslint-disable-line no-param-reassign
            }
            const listeners = getListeners(this);

            // Traverse to the tail while removing old value.
            let prev = null;
            let node = listeners.get(eventName);
            while (node != null) {
                if (node.listenerType === ATTRIBUTE) {
                    // Remove old value.
                    if (prev !== null) {
                        prev.next = node.next;
                    } else if (node.next !== null) {
                        listeners.set(eventName, node.next);
                    } else {
                        listeners.delete(eventName);
                    }
                } else {
                    prev = node;
                }

                node = node.next;
            }

            // Add new value.
            if (listener !== null) {
                const newNode = {
                    listener,
                    listenerType: ATTRIBUTE,
                    passive: false,
                    once: false,
                    next: null,
                };
                if (prev === null) {
                    listeners.set(eventName, newNode);
                } else {
                    prev.next = newNode;
                }
            }
        },
        configurable: true,
        enumerable: true,
    }
}

/**
 * Define an event attribute (e.g. `eventTarget.onclick`).
 * @param {Object} eventTargetPrototype The event target prototype to define an event attrbite.
 * @param {string} eventName The event name to define.
 * @returns {void}
 */
function defineEventAttribute(eventTargetPrototype, eventName) {
    Object.defineProperty(
        eventTargetPrototype,
        `on${eventName}`,
        defineEventAttributeDescriptor(eventName)
    );
}

/**
 * Define a custom EventTarget with event attributes.
 * @param {string[]} eventNames Event names for event attributes.
 * @returns {EventTarget} The custom EventTarget.
 * @private
 */
function defineCustomEventTarget(eventNames) {
    /** CustomEventTarget */
    function CustomEventTarget() {
        EventTarget.call(this);
    }

    CustomEventTarget.prototype = Object.create(EventTarget.prototype, {
        constructor: {
            value: CustomEventTarget,
            configurable: true,
            writable: true,
        },
    });

    for (let i = 0; i < eventNames.length; ++i) {
        defineEventAttribute(CustomEventTarget.prototype, eventNames[i]);
    }

    return CustomEventTarget
}

/**
 * EventTarget.
 *
 * - This is constructor if no arguments.
 * - This is a function which returns a CustomEventTarget constructor if there are arguments.
 *
 * For example:
 *
 *     class A extends EventTarget {}
 *     class B extends EventTarget("message") {}
 *     class C extends EventTarget("message", "error") {}
 *     class D extends EventTarget(["message", "error"]) {}
 */
function EventTarget() {
    /*eslint-disable consistent-return */
    if (this instanceof EventTarget) {
        listenersMap.set(this, new Map());
        return
    }
    if (arguments.length === 1 && Array.isArray(arguments[0])) {
        return defineCustomEventTarget(arguments[0])
    }
    if (arguments.length > 0) {
        const types = new Array(arguments.length);
        for (let i = 0; i < arguments.length; ++i) {
            types[i] = arguments[i];
        }
        return defineCustomEventTarget(types)
    }
    throw new TypeError("Cannot call a class as a function")
    /*eslint-enable consistent-return */
}

// Should be enumerable, but class methods are not enumerable.
EventTarget.prototype = {
    /**
     * Add a given listener to this event target.
     * @param {string} eventName The event name to add.
     * @param {Function} listener The listener to add.
     * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
     * @returns {void}
     */
    addEventListener(eventName, listener, options) {
        if (listener == null) {
            return
        }
        if (typeof listener !== "function" && !isObject(listener)) {
            throw new TypeError("'listener' should be a function or an object.")
        }

        const listeners = getListeners(this);
        const optionsIsObj = isObject(options);
        const capture = optionsIsObj
            ? Boolean(options.capture)
            : Boolean(options);
        const listenerType = capture ? CAPTURE : BUBBLE;
        const newNode = {
            listener,
            listenerType,
            passive: optionsIsObj && Boolean(options.passive),
            once: optionsIsObj && Boolean(options.once),
            next: null,
        };

        // Set it as the first node if the first node is null.
        let node = listeners.get(eventName);
        if (node === undefined) {
            listeners.set(eventName, newNode);
            return
        }

        // Traverse to the tail while checking duplication..
        let prev = null;
        while (node != null) {
            if (
                node.listener === listener &&
                node.listenerType === listenerType
            ) {
                // Should ignore duplication.
                return
            }
            prev = node;
            node = node.next;
        }

        // Add it.
        prev.next = newNode;
    },

    /**
     * Remove a given listener from this event target.
     * @param {string} eventName The event name to remove.
     * @param {Function} listener The listener to remove.
     * @param {boolean|{capture?:boolean,passive?:boolean,once?:boolean}} [options] The options for this listener.
     * @returns {void}
     */
    removeEventListener(eventName, listener, options) {
        if (listener == null) {
            return
        }

        const listeners = getListeners(this);
        const capture = isObject(options)
            ? Boolean(options.capture)
            : Boolean(options);
        const listenerType = capture ? CAPTURE : BUBBLE;

        let prev = null;
        let node = listeners.get(eventName);
        while (node != null) {
            if (
                node.listener === listener &&
                node.listenerType === listenerType
            ) {
                if (prev !== null) {
                    prev.next = node.next;
                } else if (node.next !== null) {
                    listeners.set(eventName, node.next);
                } else {
                    listeners.delete(eventName);
                }
                return
            }

            prev = node;
            node = node.next;
        }
    },

    /**
     * Dispatch a given event.
     * @param {Event|{type:string}} event The event to dispatch.
     * @returns {boolean} `false` if canceled.
     */
    dispatchEvent(event) {
        if (event == null || typeof event.type !== "string") {
            throw new TypeError('"event.type" should be a string.')
        }

        // If listeners aren't registered, terminate.
        const listeners = getListeners(this);
        const eventName = event.type;
        let node = listeners.get(eventName);
        if (node == null) {
            return true
        }

        // Since we cannot rewrite several properties, so wrap object.
        const wrappedEvent = wrapEvent(this, event);

        // This doesn't process capturing phase and bubbling phase.
        // This isn't participating in a tree.
        let prev = null;
        while (node != null) {
            // Remove this listener if it's once
            if (node.once) {
                if (prev !== null) {
                    prev.next = node.next;
                } else if (node.next !== null) {
                    listeners.set(eventName, node.next);
                } else {
                    listeners.delete(eventName);
                }
            } else {
                prev = node;
            }

            // Call this listener
            setPassiveListener(
                wrappedEvent,
                node.passive ? node.listener : null
            );
            if (typeof node.listener === "function") {
                try {
                    node.listener.call(this, wrappedEvent);
                } catch (err) {
                    if (
                        typeof console !== "undefined" &&
                        typeof console.error === "function"
                    ) {
                        console.error(err);
                    }
                }
            } else if (
                node.listenerType !== ATTRIBUTE &&
                typeof node.listener.handleEvent === "function"
            ) {
                node.listener.handleEvent(wrappedEvent);
            }

            // Break if `event.stopImmediatePropagation` was called.
            if (isStopped(wrappedEvent)) {
                break
            }

            node = node.next;
        }
        setPassiveListener(wrappedEvent, null);
        setEventPhase(wrappedEvent, 0);
        setCurrentTarget(wrappedEvent, null);

        return !wrappedEvent.defaultPrevented
    },
};

// `constructor` is not enumerable.
Object.defineProperty(EventTarget.prototype, "constructor", {
    value: EventTarget,
    configurable: true,
    writable: true,
});

// Ensure `eventTarget instanceof window.EventTarget` is `true`.
if (
    typeof window !== "undefined" &&
    typeof window.EventTarget !== "undefined"
) {
    Object.setPrototypeOf(EventTarget.prototype, window.EventTarget.prototype);
}

/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 * See LICENSE file in root directory for full license.
 */

/**
 * The signal class.
 * @see https://dom.spec.whatwg.org/#abortsignal
 */
class AbortSignal extends EventTarget {
    /**
     * AbortSignal cannot be constructed directly.
     */
    constructor() {
        super();
        throw new TypeError("AbortSignal cannot be constructed directly");
    }
    /**
     * Returns `true` if this `AbortSignal`'s `AbortController` has signaled to abort, and `false` otherwise.
     */
    get aborted() {
        const aborted = abortedFlags.get(this);
        if (typeof aborted !== "boolean") {
            throw new TypeError(`Expected 'this' to be an 'AbortSignal' object, but got ${this === null ? "null" : typeof this}`);
        }
        return aborted;
    }
}
defineEventAttribute(AbortSignal.prototype, "abort");
/**
 * Create an AbortSignal object.
 */
function createAbortSignal() {
    const signal = Object.create(AbortSignal.prototype);
    EventTarget.call(signal);
    abortedFlags.set(signal, false);
    return signal;
}
/**
 * Abort a given signal.
 */
function abortSignal(signal) {
    if (abortedFlags.get(signal) !== false) {
        return;
    }
    abortedFlags.set(signal, true);
    signal.dispatchEvent({ type: "abort" });
}
/**
 * Aborted flag for each instances.
 */
const abortedFlags = new WeakMap();
// Properties should be enumerable.
Object.defineProperties(AbortSignal.prototype, {
    aborted: { enumerable: true },
});
// `toString()` should return `"[object AbortSignal]"`
if (typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol") {
    Object.defineProperty(AbortSignal.prototype, Symbol.toStringTag, {
        configurable: true,
        value: "AbortSignal",
    });
}

/**
 * The AbortController.
 * @see https://dom.spec.whatwg.org/#abortcontroller
 */
class AbortController$1 {
    /**
     * Initialize this controller.
     */
    constructor() {
        signals.set(this, createAbortSignal());
    }
    /**
     * Returns the `AbortSignal` object associated with this object.
     */
    get signal() {
        return getSignal(this);
    }
    /**
     * Abort and signal to any observers that the associated activity is to be aborted.
     */
    abort() {
        abortSignal(getSignal(this));
    }
}
/**
 * Associated signals.
 */
const signals = new WeakMap();
/**
 * Get the associated signal of a given controller.
 */
function getSignal(controller) {
    const signal = signals.get(controller);
    if (signal == null) {
        throw new TypeError(`Expected 'this' to be an 'AbortController' object, but got ${controller === null ? "null" : typeof controller}`);
    }
    return signal;
}
// Properties should be enumerable.
Object.defineProperties(AbortController$1.prototype, {
    signal: { enumerable: true },
    abort: { enumerable: true },
});
if (typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol") {
    Object.defineProperty(AbortController$1.prototype, Symbol.toStringTag, {
        configurable: true,
        value: "AbortController",
    });
}

/*globals self, window */

/*eslint-disable @mysticatea/prettier */
const g =
    typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    typeof global !== "undefined" ? global :
    /* otherwise */ undefined;
/*eslint-enable @mysticatea/prettier */

if (g) {
    if (typeof g.AbortController === "undefined") {
        g.AbortController = AbortController$1;
    }
    if (typeof g.AbortSignal === "undefined") {
        g.AbortSignal = AbortSignal;
    }
}

var rngBrowser = {exports: {}};

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  rngBrowser.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  rngBrowser.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid$2(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

var bytesToUuid_1 = bytesToUuid$2;

var rng$1 = rngBrowser.exports;
var bytesToUuid$1 = bytesToUuid_1;

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1$1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng$1();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid$1(b);
}

var v1_1 = v1$1;

var rng = rngBrowser.exports;
var bytesToUuid = bytesToUuid_1;

function v4$1(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

var v4_1 = v4$1;

var v1 = v1_1;
var v4 = v4_1;

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

var uuid_1 = uuid;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// NOTE: since UXP doesn't provide `window.crypto` (https://jira.corp.adobe.com/browse/UXP-12909), SAM.js must include
// an old version of uuid (3.3.2) that does not require `window.crypto` at all. Otherwise, each host app has to
// inject the crypto API, which is not ideal, as it then becomes a hidden dependency for SAM.js. Host apps may still
// choose to provide the crypto API for more cryptographically secure uuid, but there does not appear to be any
// security holes in SAM.js using the older algorithm.
function samJsUuid() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return uuid_1.v4();
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Manager for observability via MobX - classes should call reportObserved
 * for any getters or methods that should be observable if used in the context
 * of MobX. Since SAM.js does not include MobX, clients need to makeObservable()
 * with their MobX instance
 */
class MobX {
    constructor() {
        this._contexts = new Map();
    }
    /**
     * Register a MobX instance to make SAM.js observable.
     * Returns a function that can be called to unregister.
     */
    register(createAtom) {
        // It can be the case the register is called multiple times with the same createAtom function,
        // which can happen if multiple components are using SAM.js but sharing the same MobX instance.
        // In this case, we don't want to create more atoms than necessary since that would cause performance
        // problems - instead, we detect if the createAtom was already registered, and just keep a reference
        // count instead of registering it multiple times.
        let instanceInfo = this._contexts.get(createAtom);
        if (!instanceInfo) {
            instanceInfo = { id: samJsUuid(), references: new Set() };
            this._contexts.set(createAtom, instanceInfo);
        }
        const refId = samJsUuid();
        instanceInfo.references.add(refId);
        return () => {
            const instanceInfo = this._contexts.get(createAtom);
            if (instanceInfo) {
                instanceInfo.references.delete(refId);
                if (instanceInfo.references.size === 0) {
                    this._contexts.delete(createAtom);
                }
            }
        };
    }
    /**
     * Called to report an observation on an object. Any reaction that observes this
     * will be triggered whenever the given change event on the object triggers.
     * In the simple case where we only have one change event for an object ('change'),
     * getters and methods can be instrumented with just _environment.mobx.reportObserved(this).
     */
    reportObserved(object, event = 'change') {
        for (const [createAtom, { id }] of this._contexts) {
            const key = `_atom_${id}_${event}`;
            let atom = object[key];
            if (!atom) {
                const onChange = () => atom.reportChanged();
                atom = createAtom(`${object.constructor.name}_${event}`, () => {
                    object.on(event, onChange);
                }, () => {
                    object.off(event, onChange);
                });
                object[key] = atom;
            }
            atom.reportObserved();
        }
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const NotFound$1 = Symbol('NotFound');
// Persistent cache based on indexedDB
class IndexedDBCache {
    constructor(_name, _core) {
        this._name = _name;
        this._core = _core;
    }
    static isSupported() {
        if (typeof window === 'undefined' || !window.indexedDB) {
            return false;
        }
        try {
            const request = window.indexedDB.open('sam_indexeddb_test', 1);
            request.onsuccess = () => request.result.close();
            return true;
        }
        catch (error) {
            return false;
        }
    }
    async _transaction(transactionType, requestsFn) {
        const database = await this._connect();
        if (!database) {
            return;
        }
        return new Promise((resolve) => {
            try {
                const transaction = database.transaction(this._name, transactionType);
                const objectStore = transaction.objectStore(this._name);
                const promResult = requestsFn(objectStore);
                transaction.onerror = (err) => {
                    this._core._environment.error(`transaction error: ${err}`);
                    resolve(undefined);
                };
                transaction.oncomplete = () => {
                    resolve(promResult);
                };
            }
            catch (ex) {
                // this can happens due to version upgrade when we close db.
                this._core._environment.error(`transaction exception: ${ex}`);
                resolve(undefined);
            }
        });
    }
    async getItem(itemKey) {
        return this._transaction('readonly', async (objectStore) => {
            return new Promise((resolve) => {
                const request = objectStore.get(itemKey);
                request.onsuccess = () => {
                    resolve(request.result ? {
                        value: request.result.value,
                        expiry: request.result.expiry
                    } : undefined);
                };
            });
        });
    }
    async setItem(itemKey, value, expiry) {
        return this._transaction('readwrite', (objectStore) => {
            objectStore.put({ id: itemKey, expiry, value });
            return;
        });
    }
    async deleteItem(itemKey) {
        return this._transaction('readwrite', (objectStore) => {
            objectStore.delete(itemKey);
            return;
        });
    }
    async _connect() {
        if (this._database) {
            return this._database;
        }
        const version = this._core._environment.getValue('INDEXED_DB_VERSION');
        const request = window.indexedDB.open(this._name, version);
        return new Promise((resolve) => {
            request.onerror = (err) => {
                this._core._environment.error(`CONNECTION_FAILED Unable to connect to IndexedDB: ${this._name}, error: ${err}`);
                resolve(undefined);
            };
            request.onupgradeneeded = () => {
                const database = request.result;
                if (database.objectStoreNames.contains(this._name)) {
                    database.deleteObjectStore(this._name);
                }
                database.createObjectStore(this._name, { keyPath: 'id' });
            };
            request.onsuccess = () => {
                const database = this._database = request.result;
                database.onversionchange = (evt) => {
                    this._core._environment.error(`IndexedDb version changed detected ${this._name}.${version}, ${evt}`);
                    // close current db connection allowing the other client to upgrade a version
                    database.close();
                    database.onversionchange = null;
                    this._database = undefined;
                };
                resolve(database);
            };
        });
    }
    // @ts-expect-error -- for use in console debugging
    async _clear() {
        return this._transaction('readwrite', async (objectStore) => {
            return new Promise((resolve) => {
                const request = objectStore.clear();
                request.onsuccess = () => {
                    // eslint-disable-next-line no-console
                    console.log('localDB cleared for', objectStore.name);
                    resolve(undefined);
                };
            });
        });
    }
}
// Persistent cache based on localStorage
class LocalStorageCache {
    constructor(_name, _core) {
        this._name = _name;
        this._core = _core;
    }
    static isSupported() {
        try {
            return typeof window !== 'undefined' && !!window.localStorage;
        }
        catch (e) {
            // Firefox throws an exception when accessing localStorage in private mode
            return false;
        }
    }
    _getKey(itemKey) {
        return `${this._name}#${itemKey}`;
    }
    async getItem(itemKey) {
        const storedValue = window.localStorage.getItem(this._getKey(itemKey));
        if (storedValue) {
            try {
                const { value, expiry } = JSON.parse(storedValue);
                return {
                    value,
                    expiry: expiry ? new Date(expiry) : undefined
                };
            }
            catch (e) {
                // ignore
            }
        }
        return undefined;
    }
    async setItem(itemKey, value, expiry) {
        const storedValue = JSON.stringify({ expiry, value });
        window.localStorage.setItem(this._getKey(itemKey), storedValue);
    }
    async deleteItem(itemKey) {
        window.localStorage.removeItem(this._getKey(itemKey));
    }
}
/**
 * An in-memory cache that automatically expires items after a certain time,
 * so as to avoid memory growing unbounded. Items will be evicted after
 * MAX_TIME_IN_MEMORY_MS or the expiry time, whichever is sooner.
 * In the implementation in SAM, this is mostly just a performance optimization,
 * because entries will still be included in the persistent cache.
 */
class InMemoryCache$1 {
    constructor() {
        this.items = new Map();
    }
    getItem(itemKey) {
        return this.items.get(itemKey);
    }
    setItem(itemKey, value, expiry) {
        var _a;
        const existingItem = this.items.get(itemKey);
        if (existingItem) {
            clearTimeout(existingItem.cleanupTimeout);
        }
        const requestedExpiry = (_a = expiry === null || expiry === void 0 ? void 0 : expiry.getTime()) !== null && _a !== void 0 ? _a : Date.now() + InMemoryCache$1.MAX_TIME_IN_MEMORY_MS;
        const cleanupTime = Math.min(InMemoryCache$1.MAX_TIME_IN_MEMORY_MS, requestedExpiry - Date.now());
        const cleanupTimeout = setTimeout(() => {
            this.deleteItem(itemKey);
        }, cleanupTime);
        this.items.set(itemKey, { value, expiry, cleanupTimeout });
    }
    deleteItem(itemKey) {
        const item = this.items.get(itemKey);
        if (item) {
            clearTimeout(item.cleanupTimeout);
        }
        this.items.delete(itemKey);
    }
}
InMemoryCache$1.MAX_TIME_IN_MEMORY_MS = 60 * 1000; // 1 minute
/**
 * Persistent cache of values using indexedDB - if the browser doesn't support indexedDB it falls back to localStorage,
 * and if neither is supported it'll just use a local in-memory cache that doesn't persist between sessions.
 */
class Cache {
    constructor(_userId, _core, _persistentCache) {
        this._userId = _userId;
        this._core = _core;
        // Local cache layer - this is an optimization if there's no persistent cache layer
        this._localCache = new InMemoryCache$1();
        this._name = 'SAM.js-' + this._userId;
        if (_persistentCache) {
            // Clients can override SAM.js to use their own caching layer if required
            this._persistentCache = _persistentCache;
        }
        else if (IndexedDBCache.isSupported()) {
            this._persistentCache = new IndexedDBCache(this._name, _core);
        }
        else if (LocalStorageCache.isSupported()) {
            this._persistentCache = new LocalStorageCache(this._name, _core);
        }
    }
    get name() {
        return this._name;
    }
    async getItem(itemKey, computeValue, validateValue, expiryMs) {
        let cachedItem = this._localCache.getItem(itemKey);
        if (!cachedItem && this._persistentCache) {
            cachedItem = await this._persistentCache.getItem(itemKey);
        }
        // Check if the cached item expired or invalid - if so, ignore it
        const isInvalid = validateValue && cachedItem && !validateValue(cachedItem.value);
        const isExpired = (cachedItem === null || cachedItem === void 0 ? void 0 : cachedItem.expiry) && cachedItem.expiry <= new Date(Date.now());
        if (isInvalid || isExpired) {
            await this.deleteItem(itemKey);
            cachedItem = undefined;
        }
        // If we're passed in a computeValue function, use it to update the cache if there's no
        // cached value (or it expired)
        if (!cachedItem && computeValue) {
            const value = await computeValue();
            if (validateValue && !validateValue(value)) {
                throw SAMError.create(SAMErrorCode.UNKNOWN, `Value for cache key ${itemKey} is invalid: ${JSON.stringify(value)}`);
            }
            await this.setItem(itemKey, value, expiryMs);
            return value;
        }
        return cachedItem ? cachedItem.value : NotFound$1;
    }
    async setItem(itemKey, value, expirationDurMsec = this._core._environment.getValue('CACHE_DEFAULT_TTL')) {
        const expiry = expirationDurMsec ? new Date(Date.now() + expirationDurMsec) : undefined;
        // NOTE: _localCache has its own eviction policy that takes priority if it is < expiry. This
        // keeps _localCache from growing unbounded during a session, while still optimizing reads
        // from persistent cache.
        this._localCache.setItem(itemKey, value, expiry);
        if (this._persistentCache) {
            await this._persistentCache.setItem(itemKey, value, expiry);
        }
    }
    async deleteItem(itemKey) {
        this._localCache.deleteItem(itemKey);
        if (this._persistentCache) {
            await this._persistentCache.deleteItem(itemKey);
        }
    }
}
__decorate([
    synchronized,
    __param(0, key)
], Cache.prototype, "getItem", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const ITEM_LIST_STATE_CHANGED = 'itemListStateChanged';
const MESSAGE_LOGGED = 'messageLogged';
const CONFIG_CHANGE = 'configChanged';
class ItemListStateChangedEvent extends Event {
    constructor(list) {
        super(ITEM_LIST_STATE_CHANGED);
        this.list = list;
    }
}
class MessageLoggedEvent extends Event {
    constructor(message, logLevel) {
        super(MESSAGE_LOGGED);
        this.message = message;
        this.logLevel = logLevel;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const COLLABORATOR_CHANGED = 'collaborator_changed';
class CollaboratorChangedEvent extends SAMEvent {
    constructor() {
        super(COLLABORATOR_CHANGED);
    }
}
const SharedCollaboratorChangedEvent = new CollaboratorChangedEvent();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Top-level application metadata fields that should be embedded in all R-API and USS listings
const AppMetadataField = {
    SHELL_VISIBILITY: 'shell:visibility',
    CC_INHERITED: 'cc:inherited',
    REVIEW_SOURCE_ASSET: 'review:sourceAsset',
    CONVERTED_TO: 'convertedTo',
    NON_AUTO_MIGRATABLE: 'ccx:nonAutoMigratableCopiedFromId',
    COPIED_IN_LEGACY_SPARK_TO: 'ccx:copiedLegacySparkId',
    CC_INHERITABLE: 'cc:inheritable',
    PROJECT_RENDITION: 'project:rendition',
    FIREFLY: 'firefly' // Firefly boards
};
const RapiAppMetadataWildcardNamespaces = {
    CC: 'cc',
    CLASSROOM_ASSIGNMENTS: 'assignment',
    CCX: 'ccx',
    HZ: 'hz'
};
// This should be fix once https://jira.corp.adobe.com/browse/SEARCH-45142 is done
const NewFormatAppMetadataField = {
    HZ_DOCUMENT_METADATA: 'hz:documentMetadata',
    CC_CREATED_FROM_UPLOAD: 'cc:createdFromUpload'
};
// The following fields must be escaped as-is to get all fields in the namespace
// See: https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=CA&title=Proposal%3A+Enhanced+Filtering+and+Embedding+Support+for+JSON+Resources#Proposal:EnhancedFilteringandEmbeddingSupportforJSONResources-Selectors
// eslint-disable-next-line no-useless-escape
const AppMetadataNamespacesRapiFormat = Object.values(RapiAppMetadataWildcardNamespaces).map((element) => `\"${element}:\"*`);
// Rapi and USS have different formats for these core AppMetadataFields
const EmbedAppMetadataFieldsRapiFormat = Object.values(AppMetadataField)
    .concat(Object.values(NewFormatAppMetadataField))
    .filter((element) => {
    // Filter out all single field selectors that will be included by a wildcard selector
    const ns = element.split(':')[0];
    return !Object.values(RapiAppMetadataWildcardNamespaces).includes(ns);
})
    .map((element) => '"' + element + '"')
    .concat(AppMetadataNamespacesRapiFormat);
const EmbedAppMetadataFieldsUSSFormat = Object.values(AppMetadataField).map((element) => {
    return ('app_metadata$$' + element);
}).concat(Object.values(NewFormatAppMetadataField).map((element) => {
    return ('api:metadata/application$$' + element);
}));
function getRapiAppMetadataSelectors() {
    return EmbedAppMetadataFieldsRapiFormat;
}
// USSFetchFields should be embedded in USS calls only
const USSFetchField = {
    COLLABORATION_METADATA: 'collaboration_metadata',
    COLLABMETADATA_MINE: 'collab_metadata#mine',
    REPO_CREATED_BY_CLIENT_ID: 'repo:createdByClientId',
};
const USSFetchFields = Array.from(Object.values(USSFetchField));
// Include all fields from AppMetadataFields and FetchFields in USS search results.
function getUSSFetchFields() {
    return [...EmbedAppMetadataFieldsUSSFormat, ...USSFetchFields];
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
const Permission = Permission$1;
// All permissions except Ack
const PERMISSION_ALL = Object.entries(Permission$1).reduce(
// Note: the keys that are the reverse-lookup entries for the values get accumulated, while the keys that are
//           the enum keys do not, because `n | NaN` returns `n`.
(acc, [key]) => (key === Permission.Ack.toString(10)) ? acc : acc | parseInt(key, 10), Permission.None);
function parseEffectivePermissions(permissions) {
    // https://git.corp.adobe.com/pages/caf/api-spec/chapters/concepts/access.html#privileges
    // Each permission type should look for its relevant key first, then fall back to "*" entry.
    const primary = permissions[RelType.PRIMARY] || permissions['*'] || []; // permissions directly on this obj
    const policy = permissions[RelType.AC_POLICY] || permissions['*'] || []; // contains "share" permission
    const directory = permissions[RelType.DIRECTORY] || permissions['*'] || []; // parent folder's permissions
    const appMetadata = permissions[RelType.APP_METADATA] || permissions['*'] || []; // application metadata's permissions
    const annotations = permissions[RelType.ANNOTATIONS] || permissions['*'] || []; // contains commenting permissions
    let mask = Permission.None;
    primary.forEach((perm) => {
        switch (perm) {
            case 'ack':
                mask |= Permission.Ack;
                break;
            case 'read':
                mask |= Permission.Read;
                if (directory.includes('write')) {
                    // Can duplicate this file in its current directory
                    mask |= Permission.Duplicate;
                }
                break;
            case 'write':
                // Clients need 'write' permission to edit the contents of a file, and they
                // need 'write' permission on the parent folder to rename, discard, or restore
                mask |= Permission.Write;
                if (directory.includes('write')) {
                    mask |= Permission.Discard;
                    mask |= Permission.Restore;
                }
                break;
            case 'delete':
                // Clients need Delete permission on the asset and Write permission on the
                // parent directory in order to delete an asset.
                if (directory.includes('write')) {
                    mask |= Permission.Delete;
                }
                break;
        }
    });
    // synthetic permission
    if (policy.includes('write')) {
        mask |= Permission.Share;
    }
    // appmetadata permission
    if (appMetadata.includes('read')) {
        mask |= Permission.ReadAppMetadata;
    }
    if (annotations.includes('write')) {
        mask |= Permission.WriteComment;
    }
    if (directory.includes('write') && primary.includes('read') && primary.includes('write')) {
        mask |= Permission.Rename; // Rename requires read and write permissions on primary and write permission on the parent directory
        if (primary.includes('delete')) {
            mask |= Permission.Move; // Move requires read, write and delete permissions on primary and write permission on the parent directory
        }
    }
    return mask;
}
const CLOUD_CONTENT_ROOT_FOLDER = '/cloud-content';

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const PROJECTS_INDEX_LINKS = {
    [RelType.PROJECTS_PRIMARY]: ['assetId', 'embed'],
    [RelType.PROJECTS_COLLECTION]: ['embed', 'limit', 'orderBy', 'start', 'view'],
    [RelType.PROJECTS_CREATE]: ['embed'],
    [RelType.RESOLVE_PATH]: ['path'],
    [RelType.PROJECTS_GRADIENTS_COLLECTION]: [],
    [RelType.PROJECTS_CONTEXT]: [],
    [RelType.PROJECTS_CAPABILITY]: ['privilege'],
    [RelType.ORGANIZATIONS_COLLECTION]: [],
    [RelType.PROJECTS_RECENT]: ['embed', 'after', 'first']
};
var IProjectPatchKeys;
(function (IProjectPatchKeys) {
    IProjectPatchKeys["GRADIENT_ID"] = "/project:rendition/gradientId";
})(IProjectPatchKeys || (IProjectPatchKeys = {}));
function _projectLinkKeys() {
    return [RelType.CREATE, RelType.RESTORE, RelType.DISCARD, RelType.PROJECTS_RENAME, RelType.PAGE];
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
const ProjectViews = ProjectViews$1;
const PROJECT_VIEW_TO_SERVICE_MAP = {
    [ProjectViews.All]: 'all',
    [ProjectViews.Yours]: 'yours',
    [ProjectViews.SWY]: 'sharedWithYou',
    [ProjectViews.Admin]: 'admin',
    [ProjectViews.Organization]: 'all',
    [ProjectViews.Recent]: 'all'
};
function parseProjectEffectivePermissions(permissions) {
    // We get special permissions for projects which are present in the project primary relation
    const projectPrimary = permissions[RelType.PROJECTS_PRIMARY] || permissions['*'] || []; // permissions on the project
    const primary = permissions[RelType.PRIMARY] || permissions['*'] || []; // permissions on the folder representing the project
    const directory = permissions[RelType.DIRECTORY] || permissions['*'] || []; // parent folder's permissions
    const annotations = permissions[RelType.ANNOTATIONS] || permissions['*'] || []; // contains commenting permissions
    const policy = permissions[RelType.AC_POLICY] || permissions['*'] || []; // contains "share" permission
    let mask = Permission.None;
    // We get the 'ack', 'read', 'rename', 'discard', 'restore' permissions from the project primary relation
    projectPrimary.forEach((perm) => {
        switch (perm) {
            case 'ack':
                mask |= Permission.Ack;
                break;
            case 'read':
                mask |= Permission.Read;
                break;
            case 'rename':
                mask |= Permission.Rename;
                break;
            case 'discard':
                mask |= Permission.Discard;
                break;
            case 'restore':
                mask |= Permission.Restore;
                break;
        }
    });
    // We get the 'write' and 'delete' permissions from the folder representing the project and the parent folder
    primary.forEach((perm) => {
        switch (perm) {
            case 'write':
                mask |= Permission.Write;
                break;
            case 'delete':
                if (directory.includes('write')) {
                    mask |= Permission.Delete;
                }
                break;
        }
    });
    if (policy.includes('write')) {
        mask |= Permission.Share;
    }
    if (annotations.includes('write')) {
        mask |= Permission.WriteComment;
    }
    return mask;
}
var ProjectCapabilities;
(function (ProjectCapabilities) {
    ProjectCapabilities["CREATE"] = "create";
})(ProjectCapabilities || (ProjectCapabilities = {}));
var ProjectLeaveReason;
(function (ProjectLeaveReason) {
    ProjectLeaveReason[ProjectLeaveReason["PENDING"] = 0] = "PENDING";
    ProjectLeaveReason[ProjectLeaveReason["CAN_LEAVE"] = 1] = "CAN_LEAVE";
    /**
     * All false reasons.
     */
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_NO_COLLABORATORS"] = 2] = "CANNOT_LEAVE_NO_COLLABORATORS";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER"] = 3] = "CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_COLLABORATOR"] = 4] = "CANNOT_LEAVE_LAST_COLLABORATOR";
    /**
     * @deprecated -- will be and removed on or after 2024-10-01.
     */
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_DIRECT_COLLABORATOR"] = 5] = "CANNOT_LEAVE_LAST_DIRECT_COLLABORATOR";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_IS_ADMIN_OF_PROJECT"] = 6] = "CANNOT_LEAVE_IS_ADMIN_OF_PROJECT";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_LAST_DIRECT_COLLAB_WITH_SHARE_PERMISSION"] = 7] = "CANNOT_LEAVE_LAST_DIRECT_COLLAB_WITH_SHARE_PERMISSION";
    ProjectLeaveReason[ProjectLeaveReason["CANNOT_LEAVE_IS_OWNER"] = 8] = "CANNOT_LEAVE_IS_OWNER";
})(ProjectLeaveReason || (ProjectLeaveReason = {}));
/**
 * Reasons for why the user can or cannot create a project.
 */
var CanCreateProjectReason;
(function (CanCreateProjectReason) {
    CanCreateProjectReason[CanCreateProjectReason["UNKNOWN"] = 0] = "UNKNOWN";
    CanCreateProjectReason[CanCreateProjectReason["ALLOWED"] = 1] = "ALLOWED";
    CanCreateProjectReason[CanCreateProjectReason["ADMIN_DISABLED"] = 2] = "ADMIN_DISABLED";
    CanCreateProjectReason[CanCreateProjectReason["INVALID_REPOSITORY"] = 3] = "INVALID_REPOSITORY";
    CanCreateProjectReason[CanCreateProjectReason["NO_HOME_REPOSITORY"] = 4] = "NO_HOME_REPOSITORY";
})(CanCreateProjectReason || (CanCreateProjectReason = {}));
// eslint-disable-next-line @typescript-eslint/no-redeclare
const ProjectDirectorySubtype = ProjectDirectorySubtype$1;
const projectDirectorySubTypes = [
    'wfPortfolio',
    'wfProgram',
    'wfProject',
    'ccProject'
];

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const CUSTOM_MODEL_MEDIA_TYPE = 'application/vnd.adobe.ffmodel+dcx';
const CUSTOM_MODEL_RESTRICTED_METADATA_KEYS = ['cme:training'];
// Due to CustomModelPublishedState type alias, we need to maintain TS behavior of exporting enum as a runtime value
// eslint-disable-next-line @typescript-eslint/no-redeclare
const CustomModelPublishedState$1 = CustomModelPublishedState$2;
var CustomModelOrderBy$1;
(function (CustomModelOrderBy) {
    CustomModelOrderBy["MODIFY_DATE"] = "modified_date";
    CustomModelOrderBy["CREATE_DATE"] = "created_date";
    CustomModelOrderBy["NAME"] = "name";
})(CustomModelOrderBy$1 || (CustomModelOrderBy$1 = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const FIREFLY_GENERATIONS_DIRECTORY = 'appassets/firefly-generations';
const GENERATION_HISTORY_IMAGE_MEDIA_TYPE = 'application/vnd.adobe.firefly-generation-image+dcx';
const GENERATION_HISTORY_VIDEO_MEDIA_TYPE = 'application/vnd.adobe.firefly-generation-video+dcx';
var GenerationHistoryAssetType;
(function (GenerationHistoryAssetType) {
    GenerationHistoryAssetType["IMAGE"] = "image";
    GenerationHistoryAssetType["VIDEO"] = "video";
})(GenerationHistoryAssetType || (GenerationHistoryAssetType = {}));
var GenerationHistoryAssetOrderBy;
(function (GenerationHistoryAssetOrderBy) {
    GenerationHistoryAssetOrderBy["CREATE_DATE"] = "created_date";
})(GenerationHistoryAssetOrderBy || (GenerationHistoryAssetOrderBy = {}));
var GenerationHistoryAssetState;
(function (GenerationHistoryAssetState) {
    GenerationHistoryAssetState["QUEUED"] = "queued";
    GenerationHistoryAssetState["IN_PROGRESS"] = "inProgress";
    GenerationHistoryAssetState["SUCCESS"] = "success";
    GenerationHistoryAssetState["FAILED"] = "failed";
    GenerationHistoryAssetState["CANCELLED"] = "cancelled";
})(GenerationHistoryAssetState || (GenerationHistoryAssetState = {}));
const MEDIA_TO_HISTORY_ASSET_TYPE = {
    'application/vnd.adobe.firefly-generation-image+dcx': GenerationHistoryAssetType.IMAGE,
    'application/vnd.adobe.firefly-generation-video+dcx': GenerationHistoryAssetType.VIDEO
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var CustomModelPublishedState;
(function (CustomModelPublishedState) {
    CustomModelPublishedState["DRAFT"] = "draft";
    CustomModelPublishedState["READY"] = "ready";
    CustomModelPublishedState["PUBLISHED"] = "published";
    CustomModelPublishedState["UNPUBLISHED"] = "unpublished";
    CustomModelPublishedState["QUEUED"] = "queued";
    CustomModelPublishedState["TRAINING"] = "training";
    CustomModelPublishedState["FAILED"] = "failed";
    CustomModelPublishedState["CANCELLED"] = "cancelled";
    CustomModelPublishedState["ALL"] = "all";
})(CustomModelPublishedState || (CustomModelPublishedState = {}));
var CustomModelOrderBy;
(function (CustomModelOrderBy) {
    CustomModelOrderBy["MODIFY_DATE"] = "modifyDate";
    CustomModelOrderBy["CREATE_DATE"] = "createDate";
    CustomModelOrderBy["NAME"] = "name";
})(CustomModelOrderBy || (CustomModelOrderBy = {}));

function isStrictEqual(a, b) {
    return a === b;
}
function deepClone(value) {
    return JSON.parse(JSON.stringify(value));
}
/**
 * Compares two items, including all their iterable properties, and all their nested properties.
 *
 * @note isDeepEqual(a, b) is O(n)
 * @note isDeepEqual(a, b, true) is O(n log n)
 * @note isDeepEqual(a, b, false, true) is O(n^2) -- use sparingly!
 * @note isDeepEqual(a, b, true, true) is O(n^3) -- use sparingly!
 *
 * @param {any} a is compared to b
 * @param {any} b is compared to a
 * @param {boolean} ignoreArrayOrder (optional) when true, order of arrays does not matter.
 * @param {boolean} partialMatch (optional) when true, all properties of `a` must match `b`, but `b`
 *      can contain additional properties not in `a`.
 * @return {boolean} true if they match
 */
function isDeepEqual(a, b, ignoreArrayOrder = false, partialMatch = false) {
    if (a === b) {
        return true;
    }
    if (typeof a !== typeof b || a.constructor !== b.constructor) {
        return false;
    }
    if (a instanceof Date) {
        return a.toISOString() === b.toISOString();
    }
    if (Array.isArray(a)) {
        if (!partialMatch && a.length !== b.length) {
            return false;
        }
        if (partialMatch && a.length > b.length) {
            return false;
        }
        let arry1 = a;
        let arry2 = b;
        if (ignoreArrayOrder) {
            // copy array to avoid mutating the original arrays
            // .slice(0) is fastest, even faster than .slice()
            // Note: this only works on sortable values (not Maps, Sets, Objects, or Arrays)
            arry1 = a.slice(0).sort();
            arry2 = b.slice(0).sort();
        }
        let i = 0;
        let j = 0;
        for (;;) {
            // we've matched everything in a
            if (i === arry1.length) {
                return true;
            }
            // we've run out of b before matching everything in a
            if (j === arry2.length) {
                return false;
            }
            if (isDeepEqual(arry1[i], arry2[j], ignoreArrayOrder, partialMatch)) {
                // advance our index in a and b after a match
                i = i + 1;
                j = j + 1;
                continue;
            }
            if (partialMatch) {
                // advance our index in b, and try again
                j = j + 1;
                continue;
            }
            // when not partialMatch, the first mismatch is a failure to match.
            return false;
        }
    }
    if (a instanceof Set) {
        if (!partialMatch && a.size !== b.size) {
            return false;
        }
        if (partialMatch && a.size > b.size) {
            return false;
        }
        // Note: only works for strings/numbers/booleans, not objects
        for (const key of a.keys()) {
            if (!b.has(key)) {
                return false;
            }
        }
        return true;
    }
    if (a instanceof Map) {
        if (!partialMatch && a.size !== b.size) {
            return false;
        }
        if (partialMatch && a.size > b.size) {
            return false;
        }
        for (const key of a.keys()) {
            if (!b.has(key)) {
                return false;
            }
            if (!isDeepEqual(a.get(key), b.get(key), ignoreArrayOrder, partialMatch)) {
                return false;
            }
        }
        return true;
    }
    if (typeof a === 'object') {
        const keysA = new Set(Object.keys(a));
        const keysB = new Set(Object.keys(b));
        if (!partialMatch && keysA.size !== keysB.size) {
            return false;
        }
        if (partialMatch && keysA.size > keysB.size) {
            return false;
        }
        for (const key of keysA) {
            if (!keysB.has(key)) {
                return false;
            }
            if (!isDeepEqual(a[key], b[key], ignoreArrayOrder, partialMatch)) {
                return false;
            }
        }
        return true;
    }
    // We don't support other types.
    return false;
}
const secondsPerHour = 60 * 60;
const millisecondsPerHour = secondsPerHour * 1000;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Converts a UTF-8 string to an ArrayBuffer.
 * This function uses TextEncoder if available, otherwise it falls back
 * to a custom implementation to support UXP environments.
 */
function utf8ToArrayBuffer(str) {
    if (typeof TextEncoder !== 'undefined') {
        return new TextEncoder().encode(str).buffer;
    }
    else {
        return utf8ToArrayBufferWithoutTextEncoder(str);
    }
}
/**
 * Converts an ArrayBuffer to a UTF-8 string.
 * This function uses TextDecoder if available, otherwise it falls back
 * to a custom implementation to support UXP environments. For that reason, this version is async.
 */
async function arrayBufferToUtf8(buffer) {
    if (typeof TextDecoder !== 'undefined') {
        return new TextDecoder().decode(buffer);
    }
    else {
        // UXP does not expose TextDecoder, but does support async decoding via Response.
        return new Response(buffer).text();
    }
}
/**
 * Converts a UTF-8 string to an ArrayBuffer without using TextEncoder,
 * which UXP doesn't support.
 */
function utf8ToArrayBufferWithoutTextEncoder(str) {
    // Implementation of UTF-8 encoding as described in this algorithm:
    // https://encoding.spec.whatwg.org/#utf-8-encoder
    // See public domain example: https://gist.github.com/Yaffle/5458286
    const octets = [];
    const length = str.length;
    let i = 0;
    while (i < length) {
        const codePoint = str.codePointAt(i);
        let c = 0;
        let bits = 0;
        if (codePoint <= 0x0000007f) {
            c = 0;
            bits = 0x00;
        }
        else if (codePoint <= 0x000007ff) {
            c = 6;
            bits = 0xc0;
        }
        else if (codePoint <= 0x0000ffff) {
            c = 12;
            bits = 0xe0;
        }
        else if (codePoint <= 0x001fffff) {
            c = 18;
            bits = 0xf0;
        }
        octets.push(bits | (codePoint >> c));
        c -= 6;
        while (c >= 0) {
            octets.push(0x80 | ((codePoint >> c) & 0x3f));
            c -= 6;
        }
        i += codePoint >= 0x10000 ? 2 : 1;
    }
    return new Uint8Array(octets).buffer;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * A CacheableResponse is a Response that can be serialized and deserialized.
 * It is useful for caching responses in a persistent cache, and for passing
 * responses around, where we may want to read the response body more than once.
 */
class CacheableResponse {
    constructor(url, headers, status, statusText, body) {
        this.url = url;
        this.headers = headers;
        this.status = status;
        this.statusText = statusText;
        this._body = typeof body === 'string' ? utf8ToArrayBuffer(body) : body;
    }
    static async fromResponse(response) {
        if (response instanceof CacheableResponse) {
            return response;
        }
        let body;
        // We must take care to not read `arrayBuffer()` if body is null, because UXP throws an error in that case.
        if (response.body) {
            body = await response.arrayBuffer();
        }
        else {
            body = new ArrayBuffer(0);
        }
        return new CacheableResponse(response.url, response.headers, response.status, response.statusText, body);
    }
    static async deserialize(json) {
        return new CacheableResponse(json.url, new Headers(json.headers), json.status, json.statusText, base64ToBytes(json.body).buffer);
    }
    /**
     * Serialize the CachedResponse to a JSON object that can be stored in a PersistentCache.
     * The body is currently stored as a base64-encoded string, which is not the most efficient,
     * but it allows us to use the Cache API as-is. A future enhancement could store these bodies
     * in a separate binary IndexedDB store, for instance.
     */
    serialize() {
        return {
            url: this.url,
            status: this.status,
            statusText: this.statusText,
            headers: headersToObject(this.headers),
            body: bytesToBase64(new Uint8Array(this._body))
        };
    }
    async matches(other) {
        if (!other) {
            return false;
        }
        else if (this.headers.has('etag') && other.headers.has('etag')) {
            return this.headers.get('etag') === other.headers.get('etag');
        }
        else {
            const [buffer1, buffer2] = await Promise.all([this.arrayBuffer(), other.arrayBuffer()]);
            const array1 = new Uint8Array(buffer1);
            const array2 = new Uint8Array(buffer2);
            return array1.byteLength === array2.byteLength && array1.every((value, index) => value === array2[index]);
        }
    }
    get ok() {
        const { status } = this;
        return status >= 200 && status <= 299;
    }
    get redirected() {
        return false;
    }
    get type() {
        return 'basic';
    }
    async json() {
        try {
            return JSON.parse(await this.text());
        }
        catch (err) {
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, `Failed to parse JSON response from '${this.url}' async request.`, { underlyingError: err });
        }
    }
    async bytes() {
        return new Uint8Array(this._body);
    }
    async text() {
        return arrayBufferToUtf8(this._body);
    }
    clone() {
        const clonedHeaders = new Headers();
        this.headers.forEach((value, key) => clonedHeaders.set(key, value));
        return new CacheableResponse(this.url, clonedHeaders, this.status, this.statusText, this._body);
    }
    get bodyUsed() {
        return false; // The body can always be read from a CacheableResponse.
    }
    get body() {
        throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'AsyncResponse.body not implemented.');
    }
    async arrayBuffer() {
        return this._body;
    }
    async blob() {
        var _a;
        return new Blob([this._body], { type: (_a = this.headers.get('content-type')) !== null && _a !== void 0 ? _a : undefined });
    }
    async formData() {
        throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'AsyncResponse.formData not implemented.');
    }
}
// TS is configured with ES2015, which doesn't define Header's iterators,
// so this function does the job:
function headersToObject(headers) {
    const responseHeaders = {};
    headers.forEach((value, key) => {
        responseHeaders[key] = value;
    });
    return responseHeaders;
}
// Sample implementation from https://developer.mozilla.org/en-US/docs/Glossary/Base64
function base64ToBytes(base64) {
    const binString = atob(base64);
    return Uint8Array.from(binString, (m) => { var _a; return (_a = m.codePointAt(0)) !== null && _a !== void 0 ? _a : 0; });
}
function bytesToBase64(bytes) {
    const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join('');
    return btoa(binString);
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ResponseCache {
    constructor(_core) {
        this._core = _core;
    }
    getCacheKey(key) {
        return `InterfaceBase-cache-${key}`;
    }
    async getCachedResponse(key) {
        const cachedResponseData = await this._core._environment.cache.getItem(this.getCacheKey(key));
        if (cachedResponseData === NotFound$1) {
            return undefined;
        }
        return CacheableResponse.deserialize(cachedResponseData);
    }
    async saveResponseToCache(key, response) {
        // If the value changed, save the new value to the cache and notify the caller.
        await this._core._environment.cache.setItem(this.getCacheKey(key), response.serialize(), ResponseCache.CACHE_LIFETIME);
    }
}
ResponseCache.CACHE_LIFETIME = 7 * 24 * 60 * 60 * 1000; // 7 days

// Utility for combining multiple signals:
const combineSignals$1 = (options, ...signals) => {
    const controller = new AbortController();
    const removeListeners = () => {
        signals.forEach(signal => signal.removeEventListener('abort', onAbort));
    };
    const onAbort = () => {
        controller.abort();
        removeListeners();
    };
    if (signals.some(signal => signal.aborted)) {
        onAbort();
    }
    else {
        signals.forEach(signal => signal.addEventListener('abort', onAbort));
    }
    options.signal = controller.signal;
    return removeListeners;
};
var Env;
(function (Env) {
    Env[Env["Stage"] = 0] = "Stage";
    Env[Env["Production"] = 1] = "Production";
})(Env || (Env = {}));
const DEFAULT_HOST_PRODUCT_DATA = {
    PRODUCT_ID: '',
    PRODUCT_LOCATION: ''
};
// Default settings
const DEFAULT_CONFIG = {
    USER_ID: '',
    USER_EMAIL: '',
    CLIENT_ID: '',
    ACCESS_TOKEN: '',
    ENVIRONMENT: Env.Production,
    HOST_PRODUCT_DATA: DEFAULT_HOST_PRODUCT_DATA,
    FETCH_REQUEST_TIMEOUT: 60 * 1000,
    ASYNC_DEFAULT_DELAY: 1 * 1000,
    CACHE_DEFAULT_TTL: 30 * 24 * 60 * 60 * 1000,
    CACHE_KEEP_ALIVE_TTL: DEFAULT_CACHE_KEEP_ALIVE_TTL,
    MIN_RETRY_INTERVAL: 1 * 1000,
    MAX_RETRY_INTERVAL: 2 * 60 * 1000,
    ONS_DOCUMENT_VISIBILITY_TIMEOUT: 10 * 1000,
    ONS_DEFAULT_MAX_SUBSCRIPTIONS: 5,
    ONS_DEFAULT_MAX_ASSETS_PER_SUBSCRIPTION: 100,
    // @TODO Since we are creating more subscriptions more often due to
    // us no longer caching subscriptions we will need to set
    // the TTL to a more recent time in order for subscriptions
    // to get garbage collected faster. We should update this once
    // SAM-2845 is done. Generally, web clients should leave it at the default. Clients like the Library
    // Process need longer timeouts since it stays open longer, thus reducing the frequency of
    // renewing subscriptions.
    ONS_SUBSCRIPTION_TIME_TO_LIVE: 1000 * 60 * 60 * 6,
    ONS_SUBSCRIPTION_RENEW_TIME: 1000 * 60 * 5,
    INDEXED_DB_VERSION: 1,
    PROJECTS_LIST_UPDATE_LATENCY: 3000,
    PROJECTS_ITEM_UPDATE_LATENCY: 1000,
    CLASSROOMS_LIST_UPDATE_LATENCY: 3000,
    ASSETS_LIST_UPDATE_LATENCY: 100,
    USS_LIST_UPDATE_LATENCY: 3000,
    VERSIONS_LIST_UPDATE_LATENCY: 100,
    GQL_LIST_UPDATE_LATENCY: 100,
    ASSET_COPY_NAME_FORMAT: '%@ copy (%d)',
    ASSET_CONFLICT_NAME_FORMAT: '%@ (%d)',
    DISABLE_ONS: false,
    ENABLE_ONS_CACHE: false,
    _VERSION_OVERRIDE_FOR_TEST: '',
    HIGH_PRIORITY_RAPI_REQUESTS: false,
    LOCALE: 'en-US',
    SESSION_TYPE: 'logged-in',
    ONS_OVER_AXON: false,
    FEATURE_FLAGS: {
        'enable-x-bucket-move': false,
        'enable-response-cache': false,
        'move-capabilities': {
            'enable-CCI-CCI-move': false
        },
        'use-graphql': false,
        'enable-acpl-next-polyfills': false,
        'disable-sam-cpp-models': false
    },
    REQUEST_EDGE_BASED_PUBLISHED_LINKS: false,
};
const ENVIRONMENTS = {
    [Env.Stage]: {
        LABEL: 'Staging',
        ACP_CS_HOST: 'platform-cs-stage.adobe.io',
        SYNC_SERVICE_HOST: 'acp-ss-stage.adobe.io',
        PROJECTS_HOST: 'ccprojects-stage.adobe.io',
        ASSIGNMENTS_HOST: 'hume-stage.adobe.io',
        INVITATIONS_HOST: 'invitations-stage.adobe.io',
        TRANSFER_SERVICE_HOST: 'ats-stage.adobe.io',
        USS_HOST: 'adobesearch-stage.adobe.io',
        XDCE_HOST: 'xdce-stage.adobe.io',
        REVIEW_SERVICE_HOST: 'ccassetreview-stage.adobe.io',
        MELVILLE_HOST: 'ccx-melville-stage.adobe.io',
        // TODO: get final endpoint that doesn't reference ax-projects
        USSv3_HOST: 'ax-projects-search-stage.adobe.io',
        PPS_HOST: 'pps-stage.adobe.io',
        BEHANCE_HOST: 'cc-api-behance-stage.adobe.io',
        CLASSROOMS_HOST: 'edu-classrooms-stage.adobe.io',
        COMMENT_HOST: 'comments-stage.adobe.io',
        AXON_HOST: 'axon.stg.aws.adobess.com',
        ACPC_SUPERGRAPH_HOST: 'platform-cs-stage.adobe.io/graphql',
        ACPC_SUPERGRAPH_EDGE_HOST: 'platform-cs-edge-stage.adobe.io/graphql',
        ABS_HOST: 'ab-stg.adobe-identity.com',
        WORKFRONT_HOST: 'workfront-stage.adobe.io'
    },
    [Env.Production]: {
        LABEL: 'Production',
        ACP_CS_HOST: 'platform-cs.adobe.io',
        SYNC_SERVICE_HOST: 'acp-ss.adobe.io',
        PROJECTS_HOST: 'ccprojects.adobe.io',
        ASSIGNMENTS_HOST: 'hume.adobe.io',
        INVITATIONS_HOST: 'invitations.adobe.io',
        TRANSFER_SERVICE_HOST: 'ats.adobe.io',
        USS_HOST: 'adobesearch.adobe.io',
        XDCE_HOST: 'xdce.adobe.io',
        REVIEW_SERVICE_HOST: 'ccassetreview.adobe.io',
        MELVILLE_HOST: 'libraries.adobe.io',
        // TODO: get final endpoint that doesn't reference ax-projects
        USSv3_HOST: 'ax-projects-search.adobe.io',
        PPS_HOST: 'pps.adobe.io',
        BEHANCE_HOST: 'cc-api-behance.adobe.io',
        CLASSROOMS_HOST: 'edu-classrooms.adobe.io',
        COMMENT_HOST: 'comments.adobe.io',
        AXON_HOST: 'axon.adobess.com',
        ACPC_SUPERGRAPH_HOST: 'platform-cs.adobe.io/graphql',
        ACPC_SUPERGRAPH_EDGE_HOST: 'platform-cs-edge.adobe.io/graphql',
        ABS_HOST: 'ab.adobe-identity.com',
        WORKFRONT_HOST: 'workfront.adobe.io'
    }
};
const isNonEmptyString = (x) => (typeof x === 'string') && Boolean(x);
const isNumber = (x) => (typeof x === 'number');
const configItemValidators = [{
        key: 'CLIENT_ID',
        validator: isNonEmptyString
    }, {
        key: 'USER_ID',
        validator: isNonEmptyString
    }, {
        key: 'ENVIRONMENT',
        validator: (x) => isNumber(x) && (x in Env)
    }, {
        key: 'HOST_PRODUCT_DATA',
        validator(hostProductData) {
            if (!hostProductData) {
                return false;
            }
            const { PRODUCT_ID } = hostProductData;
            // required for USS queries
            return isNonEmptyString(PRODUCT_ID);
        }
    }];
// Only allow one retry on a 401 response to avoid getting into an infinite loop if we keep being given an invalid access token
const MAX_401_RETRIES = 1;
class Environment {
    constructor(_core, userConfig, _hooks) {
        this._core = _core;
        this._hooks = _hooks;
        /**
         * @package -- for use in SAM.js only
         */
        this._isTokenInvalid = true;
        this.mobx = new MobX;
        const featureFlagsConfig = Object.assign({}, DEFAULT_CONFIG.FEATURE_FLAGS, userConfig.FEATURE_FLAGS);
        const config = Object.assign({}, DEFAULT_CONFIG, userConfig);
        config.FEATURE_FLAGS = featureFlagsConfig;
        const invalidOptions = configItemValidators.filter(({ key, validator }) => !validator(config[key]));
        if (invalidOptions.length) {
            const invalidKeys = invalidOptions.map(({ key }) => key).join(', ');
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Invalid required options: ${invalidKeys}`);
        }
        if (config.ACCESS_TOKEN) {
            this._isTokenInvalid = false;
        }
        else if (!_hooks.refreshAccessToken) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `refreshAccessToken hook must be provided if ACCESS_TOKEN is not set`);
        }
        this._config = config;
        this._cache = new Cache(config.USER_ID, _core, _hooks.persistentCache);
        if (this.getValue('FEATURE_FLAGS')['enable-response-cache']) {
            this._responseCache = new ResponseCache(this._core);
        }
    }
    get cache() {
        return this._cache;
    }
    getValue(key) {
        return this._config[key];
    }
    /**
     * Set the _environment global configuration value.
     *
     * @param key Configuration KeyName
     * @param value The value of the Configuration.
     * @event IEvent Dispatches an event when a particular key has changed.
     */
    setValue(key, value) {
        this._config[key] = value;
        const event = {
            type: CONFIG_CHANGE
        };
        const eventPayload = {
            configurationKeyName: key
        };
        this._core.dispatch(event, eventPayload);
    }
    get endpoints() {
        const env = this._config.ENVIRONMENT;
        return ENVIRONMENTS[env];
    }
    // Returns a unique device id for the client - this can be provided as a config option, or a guid can
    // be generated (which will be cached across instances for the same user). Note that if a value is passed in,
    // this takes precedence even if there's a cached device id.
    async getDeviceId() {
        return this._config['DEVICE_ID'] || await this.cache.getItem('DEVICE_ID', async () => samJsUuid(), (value) => typeof value === 'string');
    }
    getUserId() {
        return this.getValue('USER_ID');
    }
    /**
     * The maximum number of retries for any network operation.
     * @internal
     */
    get _maxNumberOfRetries() {
        return MAX_401_RETRIES;
    }
    // This is a convenience method for clients to use the SAM.js logger, which will handle
    // logging messages at different levels.
    // TODO: [SHARED-4061] Refactor to avoid bind() calls in a getter as this, as it could affect memory consumption if accessed many times.
    get logSink() {
        return {
            error: this.error.bind(this),
            warn: this.warn.bind(this),
            info: this.log.bind(this),
            debug: this.debug.bind(this)
        };
    }
    _loggerEvent(message, level) {
        if (this._core.listenerCount(MESSAGE_LOGGED) > 0) {
            this._core.emit(MESSAGE_LOGGED, new MessageLoggedEvent(message, level));
        }
    }
    // Reserve for informational messages that may be useful in debugging infrequent but major
    // SAM.js system events, such as initializing, or refreshing auth token.
    log(message) {
        this._loggerEvent(message, LogLevel.Info);
    }
    // Reserve for detailed messages about complex coordinated async processes, such as List loading, that
    // are difficult to trace without log messages, but are too noisy to include in regular production apps.
    debug(message) {
        this._loggerEvent(message, LogLevel.Debug);
    }
    // For error conditions that do not warrant throwing an exception that bubbles to the client, but could be
    // useful for debugging purposes. E.g., an ItemUpdater failing to parse a field from a service response --
    // devs should see and fix these errors immediately and have unit tests to validate it, but the same error
    // in a production system should not necessarily be raised to the user.
    error(message) {
        this._loggerEvent(message, LogLevel.Err);
    }
    // For deprecation notices and possibly (but not definitively) bad configuration options, etc. These sorts of
    // messages should include instructions on how to resolve the issue. E.g. how React treats warnings about missing
    // `key` on children -- this isn't necessarily a breaking condition but often can cause bugs; since they are
    // entirely avoidable, devs should work to eradicate the warnings so they do not become red herrings that must
    // be investigated when an unrelated bug emerges.
    warn(message) {
        this._loggerEvent(message, LogLevel.Warn);
    }
    /**
     * @internal
     */
    async _refreshAccessToken() {
        if (this._config.SESSION_TYPE !== 'logged-out' && this._isTokenInvalid) {
            if (!this._hooks.refreshAccessToken) {
                // If a refresh hook wasn't provided, we just clear the token so we don't keep on
                // attempting requests with an invalid token
                return '';
            }
            this.log(`Refreshing access token from host...`);
            try {
                this._config.ACCESS_TOKEN = await this._hooks.refreshAccessToken(this._config.ACCESS_TOKEN);
            }
            catch (e) {
                // The error could already be a SAM error due to the recursive fetch calls above.
                throw SAMError.wrapErrorIfNeeded(SAMErrorCode.AUTHORIZATION_ERROR, 'Failed to refresh access token', e);
            }
            this._isTokenInvalid = false;
            this.log(`Refreshing access token ${this._config.ACCESS_TOKEN ? 'successful' : 'unsuccessful'}`);
        }
        return this._config.ACCESS_TOKEN;
    }
    async fetch(url, options = {}, numRetries = 0) {
        var _a;
        if ((_a = this._hooks) === null || _a === void 0 ? void 0 : _a.fetch) {
            return this._hooks.fetch(url, options);
        }
        const session = this._config.SESSION_TYPE;
        // If the access token is invalid, we wait for it to be refreshed:
        const token = this._isTokenInvalid ? await this._refreshAccessToken() : this._config.ACCESS_TOKEN;
        if ((session !== 'logged-out') && !token) {
            throw SAMError.create(SAMErrorCode.AUTHORIZATION_ERROR, `Unable to obtain access token - did you provide a refreshAccessToken hook?`);
        }
        // Extract parameters that won't be passed to `fetch`, and clone the ones that will so that a) there are no
        // side-effects to the caller, and b) 401 retries can use the same `options` as the original request.
        const { headers = {}, authHeader, noOtherHeaders, requestTimeoutMs, noApiKeyHeader } = options, requestInit = __rest$2(options, ["headers", "authHeader", "noOtherHeaders", "requestTimeoutMs", "noApiKeyHeader"]);
        // ONS uses a different auth header from other services, so this needs to be configurable
        const authorizationHeader = 'Authorization';
        const auth = (session !== 'logged-out')
            ? { [authHeader || authorizationHeader]: `${(session === 'guest') ? 'AnonBearer' : 'Bearer'} ${token}` }
            : {};
        // After this line, `requestHeaders` and `headers` should not be modified to avoid side-effects for the caller.
        // deepClone removes headers with undefined values -- this makes it easier to assemble Headers where some
        // headers could be optional.
        const requestHeaders = noOtherHeaders ? deepClone(headers) : Object.assign(Object.assign(Object.assign({}, deepClone(headers)), auth), (noApiKeyHeader) ? {} : { 'X-Api-Key': this._config.CLIENT_ID });
        // Include a timeout on the request (fetch doesn't have a timeout, so it will never resolve if the socket hangs up)
        const abortController = new AbortController();
        let uncombineSignals = () => { };
        if (requestInit.signal) {
            uncombineSignals = combineSignals$1(requestInit, requestInit.signal, abortController.signal);
        }
        else {
            requestInit.signal = abortController.signal;
        }
        const timeoutLength = requestTimeoutMs || this.getValue('FETCH_REQUEST_TIMEOUT');
        const timeout = setTimeout(() => abortController.abort(), timeoutLength);
        const startTime = Date.now();
        try {
            const response = await fetch(url, Object.assign(Object.assign({}, requestInit), { headers: requestHeaders }));
            const requestId = response.headers.get('X-Request-Id');
            const requestIdString = requestId || `no requestId`;
            this.debug(`[${requestIdString}] ${options.method || 'GET'} ${url} ${response.status} (${Date.now() - startTime}ms)`);
            clearTimeout(timeout);
            if (response.status === 401) {
                // If we get a 401 response it usually means that access token has expired.
                if (token !== this._config.ACCESS_TOKEN) {
                    // If the access token was already refreshed during the request, just retry and
                    // it will pick up the new token.
                    // NOTE: We are not using await here to avoid capturing the errors in the parent try block.
                    // NOTE: using `options` instead of `requestInit` so the retry will use the same settings as the original request.
                    return this.fetch(url, options, numRetries + 1);
                }
                else {
                    // Otherwise it means we discovered the current token is invalid. We need to invalidate the token and retry. The retry
                    // will detect that the token is invalid and refresh it (if the host has provided a hook).
                    this._isTokenInvalid = true;
                    if (numRetries < this._maxNumberOfRetries) {
                        // NOTE: We are not using await here to avoid capturing the errors in the parent try block.
                        // NOTE: using `options` instead of `requestInit` so the retry will use the same settings as the original request.
                        return this.fetch(url, options, numRetries + 1);
                    }
                }
            }
            return response;
        }
        catch (e) {
            this.debug(`Error - ${e} (${Date.now() - startTime}ms)`);
            throw SAMError.wrapErrorIfNeeded(SAMErrorCode.NETWORK_ERROR, `Failed network request when fetching: ${url}`, e);
        }
        finally {
            // If we combined signals, we need to uncombine after the request is done, otherwise we'll continue to add
            // event listeners to the original signal and hit the maximum limit. This would both be a memory leak and
            // result in some aborts not being handled.
            uncombineSignals();
        }
    }
    // Returns a retry time based on the retry attempt number.
    // For now, this uses the minimum retry interval a few times, before jumping to the maximum interval.
    // We may want to change this to an exponential or Fibonacci backoff in future.
    getRetryInterval(attempt) {
        // We retry quickly a few times on failure, before backing off to a slower interval:
        return this.getValue(attempt < 3 ? 'MIN_RETRY_INTERVAL' : 'MAX_RETRY_INTERVAL');
    }
}
__decorate([
    memoize$1
], Environment.prototype, "getDeviceId", null);
__decorate([
    synchronized
], Environment.prototype, "_refreshAccessToken", null);

var domain;

// This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function EventHandlers() {}
EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
}

// nodejs oddity
// require('events') === require('events').EventEmitter
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.usingDomains = false;

EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function() {
  this.domain = null;
  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active ) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  domain = this.domain;

  // If there is no 'error' event listener then throw.
  if (doError) {
    er = arguments[1];
    if (domain) {
      if (!er)
        er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] :
                                          [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
                            existing.length + ' ' + type + ' listeners added. ' +
                            'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}
function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function _onceWrap(target, type, listener) {
  var fired = false;
  function g() {
    target.removeListener(type, g);
    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }
  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || (list.listener && list.listener === listener)) {
        if (--this._eventsCount === 0)
          this._events = new EventHandlers();
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length; i-- > 0;) {
          if (list[i] === listener ||
              (list[i].listener && list[i].listener === listener)) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (list.length === 1) {
          list[0] = undefined;
          if (--this._eventsCount === 0) {
            this._events = new EventHandlers();
            return this;
          } else {
            delete events[type];
          }
        } else {
          spliceOne(list, position);
        }

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };
    
// Alias for removeListener added in NodeJS 10.0
// https://nodejs.org/api/events.html#events_emitter_off_eventname_listener
EventEmitter.prototype.off = function(type, listener){
    return this.removeListener(type, listener);
};

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = new EventHandlers();
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = new EventHandlers();
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        for (var i = 0, key; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new EventHandlers();
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        do {
          this.removeListener(type, listeners[listeners.length - 1]);
        } while (listeners[0]);
      }

      return this;
    };

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;

  if (!events)
    ret = [];
  else {
    evlistener = events[type];
    if (!evlistener)
      ret = [];
    else if (typeof evlistener === 'function')
      ret = [evlistener.listener || evlistener];
    else
      ret = unwrapListeners(evlistener);
  }

  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);
  while (i--)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const BECOME_OBSERVED = 'observed';
const BECOME_UNOBSERVED = 'unobserved';
/**
 * Base class that can be used to create Typed SAMEvent Emitters.
 * @example:
 * class ClickEvent extends SAMEvent {
 *     myClickProp: string;
 *     constructor() {
 *         super('click');
 *     }
 * }
 *
 * class MyClass extends TypedEventEmitter<{ click: ClickEvent }>() {
 *     baseProp : string;
 * }
 *
 * const obj = new MyClass();
 * obj.on('click', (ev, sender, payload) => {
 *     // The ev object is typed based on the 'click' event.
 *     ev.myClickProp;
 * });
 *
 * subClass.dispatch(new ClickEvent());
 */
class TypedEventEmitter extends EventEmitter {
    dispatch(ev, payload) {
        return super.emit(ev.type, ev, this, payload);
    }
    once(type, callback) {
        const result = super.once(type, callback);
        this._onEventListenerAdded();
        return result;
    }
    on(type, callback) {
        // Prevent adding duplicate listeners
        if (this.listeners(type).includes(callback)) {
            return this;
        }
        const result = super.on(type, callback);
        if (type !== BECOME_OBSERVED && type !== BECOME_UNOBSERVED) {
            this._onEventListenerAdded();
            if (this.listenerCount(type) === 1) {
                this.emit(BECOME_OBSERVED, type);
            }
        }
        return result;
    }
    off(type, callback) {
        const result = super.off(type, callback);
        if (type !== BECOME_OBSERVED && type !== BECOME_UNOBSERVED) {
            this._onEventListenerRemoved();
            if (this.listenerCount(type) === 0) {
                this.emit(BECOME_UNOBSERVED, type);
            }
        }
        return result;
    }
    // Called when a new event listener is added on the object.
    _onEventListenerAdded() {
    }
    _onEventListenerRemoved() {
    }
}

var name = "@ccx-public/shared-asset-model-js";
var version$1 = "10.0.368";
var publishConfig = {
	registry: "https://artifactory.corp.adobe.com/artifactory/api/npm/npm-adobe-release-local/",
	scope: "@ccx-public"
};
var repository = {
	type: "git",
	url: "https://git.corp.adobe.com/ccx/shared-asset-model"
};
var license = "Apache-2.0";
var main = "./dist/cjs/src/index.js";
var module$1 = "./dist/mjs/src/index.js";
var types = "./dist/mjs/src/index.d.ts";
var exports = {
	".": {
		"import": "./dist/mjs/src/index.js",
		require: "./dist/cjs/src/index.js"
	}
};
var dependencies = {
	"@apollo/client": "^3.11.1",
	"@ccx-public/component-types": "^1.0.302",
	"@formatjs/intl": "^2.6.5",
	"@opentelemetry/api": "1.7.0",
	"@types/json-patch": "0.0.30",
	"@types/semver": "^7.3.13",
	"abort-controller": "3.0.0",
	events: "3.0.0",
	"gql-query-builder": "^3.8.0",
	graphql: "^16.9.0",
	"http-link-header": "1.1.0",
	"isomorphic-ws": "^5.0.0",
	md5: "^2.3.0",
	microdiff: "1.3.1",
	"path-browserify": "^1.0.1",
	"query-string": "7.0.0",
	"uri-templates": "0.2.0",
	uuid: "3.3.2",
	ws: "^8.18.0"
};
var engines = {
	node: ">=18",
	npm: ">=8.0.0"
};
var devDependencies = {
	"@graphql-codegen/cli": "^5.0.5",
	"@graphql-codegen/typescript": "^4.1.5",
	"@graphql-codegen/typescript-operations": "^4.5.1",
	"@relative-ci/agent": "^4.2.3",
	"@rollup/plugin-alias": "^5.1.1",
	"@rollup/plugin-commonjs": "^20.0.0",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-node-resolve": "^13.0.4",
	"@swc/core": "1.11.7",
	"@swc/jest": "0.2.37",
	"@types/classnames": "^2.2.7",
	"@types/events": "^3.0.0",
	"@types/http-link-header": "1.0.3",
	"@types/istanbul-lib-report": "^3.0.3",
	"@types/jest": "^29.5.14",
	"@types/md5": "^2.3.1",
	"@types/node": "20.12.0",
	"@types/node-fetch": "^2.5.10",
	"@types/path-browserify": "^1.0.2",
	"@types/uri-templates": "file:@types/uri-templates",
	"@types/uuid": "^3.3.2",
	"@types/ws": "^8.5.12",
	"@typescript-eslint/eslint-plugin": "^5.62.0",
	"@typescript-eslint/parser": "^5.62.0",
	classnames: "^2.2.6",
	"cross-env": "^7.0.3",
	"cross-fetch": "^4.0.0",
	eslint: "^8.3.0",
	"eslint-config-prettier": "^8.3.0",
	"eslint-plugin-diff": "^2.0.3",
	"fake-indexeddb": "^4.0.2",
	http: "^0.0.1-security",
	husky: "4.3.3",
	jest: "^29.7.0",
	"jest-environment-jsdom": "^29.7.0",
	"jest-junit": "^16.0.0",
	"jest-mock": "^29.7.0",
	"jest-websocket-mock": "^2.5.0",
	"lint-staged": "^10.3.0",
	"merge-dirs": "^0.2.1",
	mobx: "^6.3.2",
	"mock-socket": "^9.3.1",
	nock: "^13.5.5",
	postcss: "^8.3.6",
	prettier: "^2.8.8",
	react: "^17.0.2",
	"react-dom": "^17.0.2",
	rollup: "^2.56.2",
	"rollup-plugin-mv": "^0.0.2",
	"rollup-plugin-polyfill-node": "^0.11.0",
	"rollup-plugin-typescript2": "^0.36.0",
	"rollup-plugin-webpack-stats": "^0.2.3",
	swc_mut_cjs_exports: "8.0.1",
	"ts-node": "^9.0.0",
	tslib: "^2.1.0",
	typedoc: "^0.27.9",
	"typedoc-plugin-external-module-name": "^4.0.3",
	typescript: "^4.9.5",
	"typescript-plugin-css-modules": "^3.4.0",
	xml2js: "^0.6.2",
	yargs: "^17.7.2"
};
var scripts = {
	pretest: "yarn tsc -p ./__tests__/tsconfig.json --noEmit",
	test: "node --expose-gc --allow-natives-syntax ../../node_modules/jest/bin/jest.js --logHeapUsage",
	"test:debugnock": "DEBUG=nock.* yarn test",
	"test:watch": "node --allow-natives-syntax ../../node_modules/jest/bin/jest.js --watchAll --no-cache",
	lint: "eslint --ext .ts,.tsx,.js --quiet ./src",
	"lint:fix": "eslint --fix --ext .ts,.tsx,.js --quiet ./src",
	prebuild: "yarn tsc --build --force",
	build: "yarn rollup -c ./rollup.config.js",
	postbuild: "node ./scripts/postbuild.js && npx relative-ci-agent",
	watch: "yarn rollup -c ./rollup.config.js --watch",
	codegen: "graphql-codegen"
};
var husky = {
	hooks: {
		"pre-commit": "lint-staged"
	}
};
var packageJSON = {
	name: name,
	version: version$1,
	"private": false,
	publishConfig: publishConfig,
	repository: repository,
	license: license,
	main: main,
	module: module$1,
	types: types,
	exports: exports,
	dependencies: dependencies,
	engines: engines,
	devDependencies: devDependencies,
	scripts: scripts,
	husky: husky,
	"lint-staged": {
	"**/*.{ts,tsx,js}": [
		"eslint --fix",
		"yarn test --bail --coverage=false --onlyChanged --findRelatedTests --passWithNoTests"
	]
}
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// NOTE: since previous versions of SAM.js used override_map, this cannot be changed to override_set,
//       or it would defeat the purpose of tracking overrides applied by different versions of SAM.js.
const $OVERRIDE_SET = Symbol.for('com.adobe.ccac.samjs.extendclass.override_map');
const $EXTENSION_SET = Symbol.for('com.adobe.ccac.samjs.extendclass.extension_set');
const $OBSERVABLE_SET = Symbol.for('com.adobe.ccac.samjs.extendclass.observable_set');
const $EMITTER = Symbol.for('com.adobe.ccac.samjs.extendclass.emitter');
const $OVERRIDDEN_GETTERS = Symbol.for('com.adobe.ccac.samjs.extendclass.overridden_getters');
/**
 * Extends the provided `klass` with the properties with new behaviors, and ensures it supports the
 * EventEmitter interface. Optionally, it will make all getter properties observable.
 *
 * @param options: IExtendClassOptions
 * @example
 *     class MyClass {
 *         private _foo = 32;
 *         private _bar = 99;
 *         private _baz = {};
 *         refreshBaz(x) { some impl }
 *         get foo() { return this._foo; }
 *         get bar() { return this._bar; }
 *         get baz() { return this.baz; }
 *     }
 *     ExtendClass({
 *         klass: MyClass,
 *         extensions: {
 *             refreshBaz(x) { return x * 2; },       // ignored because it exists on MyClass
 *             newFn() { return this._foo; }          // Added
 *             // Getters/setters must use PropertyDescriptor syntax
 *             // NOTE: won't be automatically made observable
 *             aliasForFoo: {
 *                 get() {
 *                     // make this getter alias observable
 *                     this._core._environment.mobx.reportObserved('change');
 *                     return this._foo;
 *                 }
 *             }
 *         },
 *         overrides: {
 *             // replaces original refreshBaz
 *             refreshBaz(x) {
 *                 // Use the added TypedEventEmitter.dispatch()
 *                 this.dispatch({ type: 'bazRefresh' });
 *                 // invoke original oldFn
 *                 return this.oldFn.original(x);
 *             }
 *         },
 *         // When client subscribes to 'change' event, the extended class will proxy that event handler to the
 *         // 'incrementFoo' and 'incrementBar' events that the native implementation emits.
 *         eventMap: { change: [ 'incrementFoo', 'incrementBar' ] },
 *         observableMap: {
 *             // the `baz` getter will be made observable, bound to the 'bazRefresh' event
 *             'bazRefresh': [ 'baz' ]
 *         }
 *         // `foo` and `bar` getter will be made observable, bound to the 'change' event;
 *         defaultObservableEvent: 'change',
 *     });
 */
function ExtendClass({ klass, core, extensions = {}, overrides = {}, eventMap = {}, defaultObservableEvent, observableMap = {} }) {
    const originalProps = Object.getOwnPropertyDescriptors(klass.prototype);
    // SAM.cpp EventEmitter-ish interface is on the prototype's prototype
    let emitterProps = originalProps;
    if (typeof emitterProps.on === 'undefined') {
        emitterProps = Object.getOwnPropertyDescriptors(Object.getPrototypeOf(klass.prototype));
    }
    // Add reference to shared core if not already defined
    if (!originalProps._core) {
        Object.defineProperty(klass.prototype, '_core', { value: core });
    }
    // When overriding a getter, patch code may need access to the original using
    //    this[$OVERRIDDEN_GETTERS]['someProp'].call(this)
    if (!Object.getOwnPropertyDescriptor(klass.prototype, $OVERRIDDEN_GETTERS)) {
        Object.defineProperty(klass.prototype, $OVERRIDDEN_GETTERS, { value: {} });
    }
    // Some SAM.cpp classes (AssetList) have an event handling API similar to EventEmitter, and some don't
    // (Asset). Meanwhile, most SAM.js classes implement TypedEventEmitter. This section patches the
    // prototype to match the TypedEventEmitter API. If the SAM.cpp class doesn't have an event-handling
    // API, an actual instance of EventEmitter is used instead.
    if (!Object.getOwnPropertyDescriptor(klass.prototype, $EMITTER)) {
        Object.defineProperties(klass.prototype, {
            [$EMITTER]: {
                get() {
                    var _a;
                    // Redefine the $EMITTER getter property for `this` instance to an actual EventEmitter, or an
                    // adapter to the SAM.cpp equivalent. The $EMITTER getter on the prototype remains unchanged
                    // so the next instance will get its own properly bound $EMITTER.
                    let emitter;
                    if (typeof ((_a = emitterProps.on) === null || _a === void 0 ? void 0 : _a.value) === 'function') {
                        // SAM.cpp class has an event handling API already, so create an adapter bound
                        // to the SAM.cpp implementation
                        emitter = {
                            on: emitterProps.on.value.bind(this),
                            off: emitterProps.off.value.bind(this),
                            emit: emitterProps.trigger.value.bind(this),
                            addListener: emitterProps.on.value.bind(this),
                            removeListener: emitterProps.off.value.bind(this)
                        };
                    }
                    else {
                        // SAM.cpp class has no event handling API, so use an actual EventEmitter
                        emitter = new EventEmitter();
                    }
                    Object.defineProperty(this, $EMITTER, { value: emitter });
                    return this[$EMITTER];
                }
            },
            on: {
                value(eventName, ...rest) {
                    var _a;
                    // Some SAM.cpp events map to multiple SAM.js events. If there's no mapping, then subscribe
                    // to `eventName` only.
                    const mappedEvents = (_a = eventMap[eventName]) !== null && _a !== void 0 ? _a : [eventName];
                    mappedEvents.forEach(mappedEventName => this[$EMITTER].on(mappedEventName, ...rest));
                    return this;
                }
            },
            addListener: {
                value(...args) { return this.on(...args); }
            },
            off: {
                value(eventName, ...rest) {
                    var _a;
                    // Some SAM.cpp events map to multiple SAM.js events. If there's no mapping, then unsubscribe
                    // from `eventName` only.
                    const mappedEvents = (_a = eventMap[eventName]) !== null && _a !== void 0 ? _a : [eventName];
                    mappedEvents.forEach(mappedEventName => this[$EMITTER].off(mappedEventName, ...rest));
                    return this;
                }
            },
            removeListener: {
                value(...args) { return this.off(...args); }
            },
            emit: {
                value(...args) {
                    return this[$EMITTER].emit(...args);
                }
            },
            // SAM.js TypedEventEmitter behavior
            dispatch: {
                value(event) { return this.emit(event.type, event, this); }
            }
        });
    }
    // Allow shortcut of { someMethod(): {} } instead of { someMethod: { value: function() {} } }
    function makePropertyDesc(map, key) {
        const propertyDesc = map[key];
        if (typeof map[key] === 'function') {
            return { value: propertyDesc };
        }
        else if (['string', 'boolean', 'number'].includes(typeof map[key])) {
            // TypeScript doesn't block clients from passing a primitive, and
            // Object.defineProperty(obj, key, primitive) is a no-op.
            throw new Error('Cannot use primitives for PropertyDescriptor');
        }
        else {
            // An object. TypeScript will verify that it is a valid PropertyDescriptor.
            return propertyDesc;
        }
    }
    // Track which properties have been handled in this call to ExtendClass
    const handledProps = new Set();
    // Extensions should handle their own observability, thus should not be made observable automatically,
    // so extensions must be tracked across calls to ExtendClass.
    const extendedProps = klass.prototype[$EXTENSION_SET] || new Set();
    Object.keys(extensions).forEach(propertyName => {
        // cannot override existing properties with extensions
        if (originalProps[propertyName]) {
            return;
        }
        const propertyDesc = makePropertyDesc(extensions, propertyName);
        Object.defineProperty(klass.prototype, propertyName, propertyDesc);
        handledProps.add(propertyName);
        extendedProps.add(propertyName);
    });
    klass.prototype[$EXTENSION_SET] = extendedProps;
    const overriddenProps = klass.prototype[$OVERRIDE_SET] || new Set();
    Object.keys(overrides).forEach(propertyName => {
        if (overriddenProps.has(propertyName)) {
            // Overrides from a previous call to ExtendClass should not be overridden again, but this
            // is not an error.
            return;
        }
        if (handledProps.has(propertyName) || extendedProps.has(propertyName)) {
            throw new Error(`[ExtendClass] cannot override property '${propertyName}' because it is an extension.`);
        }
        // Since overridden functions might expect to use `this.originalFn.original()`, it's not safe to treat the
        // override as an extension. Different hosts could have different versions of SAM.cpp, so patching code should
        // be aware of what is needed.
        if (!originalProps[propertyName]) {
            throw new Error(`[ExtendClass] target class does not have property '${propertyName}' so it cannot `
                + 'be overridden.');
        }
        const propertyDesc = makePropertyDesc(overrides, propertyName);
        const original = originalProps[propertyName].value;
        if (typeof original === 'function') {
            // Replace the the original method with the override, then attach the original
            // to the override so you can call it with `this.override.original()`
            Object.defineProperty(klass.prototype, propertyName, {
                get() {
                    // Ensure `original` is bound to correct `this`
                    propertyDesc.value.original = original.bind(this);
                    return propertyDesc.value;
                }
            });
        }
        else {
            if (originalProps[propertyName].get) {
                klass.prototype[$OVERRIDDEN_GETTERS][propertyName] = originalProps[propertyName].get;
            }
            Object.defineProperty(klass.prototype, propertyName, propertyDesc);
        }
        overriddenProps.add(propertyName);
        handledProps.add(propertyName);
    });
    klass.prototype[$OVERRIDE_SET] = overriddenProps;
    // Validate the passed-in observableMap config does not contain coding errors. If a config defines
    // two events for the same property, or defines an event for an extension/override, that is likely
    // a bug.
    const propToEventMap = {};
    Object.keys(observableMap).reduce((seenPropNames, eventName) => {
        observableMap[eventName].forEach(propName => {
            // If a property is mapped multiple times, or was extended/overwritten, treat as a coding error,
            // otherwise the result would be difficult to debug
            if (seenPropNames.has(propName)) {
                throw new Error(`[ExtendClass] cannot have the same property (${propName}) appear multiple times in observableMap`);
            }
            if (handledProps.has(propName)) {
                throw new Error(`[ExtendClass] cannot make property (${propName}) observable as it was defined in extensions/overrides`);
            }
            seenPropNames.add(propName);
            propToEventMap[propName] = eventName;
        });
        return seenPropNames;
    }, new Set());
    // Add properties to be observed using the defaultObservableEvent to propToEventMap
    if (defaultObservableEvent) {
        Object.keys(originalProps)
            // only collect getter properties
            .filter(propName => !!originalProps[propName].get)
            .forEach(propName => propToEventMap[propName] = defaultObservableEvent);
    }
    // Get already-wrapped properties that were made observable by previous calls to ExtendClass, if any,
    // so that they won't be wrapped again.
    const observedProps = klass.prototype[$OBSERVABLE_SET] || new Set();
    // merge all extended/overridden/observed props (including from previous calls to ExtendClass) into handledProps
    [...extendedProps, ...overriddenProps, ...observedProps].forEach(propName => handledProps.add(propName));
    Object.entries(propToEventMap).forEach(([propName, eventName]) => {
        var _a;
        // Only wrap getters, and properties that have not already been patched, either from this
        // call to ExtendClass, or a previous call. If it is from a previous call, then this is not
        // error.
        if (!((_a = originalProps[propName]) === null || _a === void 0 ? void 0 : _a.get) || handledProps.has(propName)) {
            return;
        }
        Object.defineProperty(klass.prototype, propName, {
            get() {
                this._core._environment.mobx.reportObserved(this, eventName);
                return originalProps[propName].get.call(this);
            }
        });
        observedProps.add(propName);
    });
    klass.prototype[$OBSERVABLE_SET] = observedProps;
}

function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) ; else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

var pathBrowserify = posix;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ItemExclusiveTaskChain {
    constructor(task, onGotOwnership) {
        this.task = task;
        this.onGotOwnership = onGotOwnership;
    }
    // Add the task at the end of the linked list.
    registerNewTask(newTask) {
        let itemTask = this;
        while (itemTask) {
            const next = itemTask.next;
            if (!next) {
                // We've found the first empty slot.
                itemTask.next = newTask;
                return;
            }
            // Keep going till the end.
            itemTask = next;
        }
    }
}
/**
 * Base object used for all assets, teams, spaces etc.
 */
class ItemBase extends TypedEventEmitter {
    constructor(_core, id) {
        super();
        this._core = _core;
        this.id = id;
    }
    get lastKnownClientMutation() {
        return this._lastKnownClientMutation;
    }
    updateLastKnownClientMutation() {
        this._lastKnownClientMutation = Date.now();
    }
    /**
     * Waits for at least `delay` ms since the last known asset mutation.
     * @param delay
     */
    async waitForMutationPropagationIfNeeded(delay) {
        const mutation = this._lastKnownClientMutation;
        if (mutation) {
            const waitTime = mutation + delay - Date.now();
            if (waitTime > 0) {
                // We still have some time left before the asset change is propagated for sure.
                await new Promise((resolve) => setTimeout(resolve, waitTime));
            }
        }
    }
    get exclusiveTask() {
        var _a;
        return (_a = this._exclusiveTaskChain) === null || _a === void 0 ? void 0 : _a.task;
    }
    _setExclusiveTaskChain(itemTaskChain) {
        this._exclusiveTaskChain = itemTaskChain;
        this.dispatch(SharedChangeEvent);
    }
    /**
     * @package -- only for use by UpdateSession
     */
    _setId(newId) {
        // @ts-expect-error -- this is the only place where ID can be changed.
        this.id = newId;
    }
    /**
     * Locks exclusive ownership for a subset of items during execution of the `schedule`.
     * It is guaranteed that the `schedule` method will receive ownership of the items
     * before it starts execution and all the way up to the point when the returned promise
     * gets resolved.
     *
     * Multiple tasks can run at the same time as long as they do not share any of their items.
     * For example, task A working with assets (i1, i2) will be scheduled to run in parallel with
     * task B with assets (i3, i4).
     *
     * If multiple tasks are registered on same items, the tasks will be executed in their
     * order of scheduling. For example, task C working with assets (i1, i2) will not be allowed
     * to run at the same time with task D that needs assets (i2, i3). Task D will only schedule
     * once all the previously scheduled tasks have released ownership of i2 and i3.
     *
     * Recursivity is not supported, a task should not lock same items again while it holds ownership.
     *
     * A single item can only be part of a single exclusive task at any moment of time.
     *
     * @param name Name of the task to schedule. Useful for debugging.
     * @param items The items to lock during the execution of the task.
     * @param schedule The function to execute once the task has ownership of the items.
     * @returns A promise resolved once the task is complete. The value of the returned promise
     * is propagated from the promise returned by the `schedule` function.
     */
    static runExclusiveTask(name, items, schedule) {
        return new Promise((resolve) => {
            const task = { name, items };
            const runTask = () => resolve(schedule(task).finally(() => {
                // Make sure all the items pick up their next task
                // before we give up ownership.
                for (const item of items) {
                    // We know the item must have a task. We just finished it.
                    const next = item._exclusiveTaskChain.next;
                    // Assign ownership to the next waiting task.
                    // If tasks are still pending, then there should
                    // never be a gap of of ownership on the item,
                    // to avoid letting other tasks inject themselves
                    //in the middle. The tasks needs to execute in the order
                    // of scheduling to avoid interlacing issues.
                    item._setExclusiveTaskChain(next);
                    // Let the next task know it received the ownership now.
                    // Once the next task acquires all the locks, then it will
                    // continue with its own execution.
                    // Note that the callback uses use a timer once the execution
                    // actually starts to avoid crashing this promise chain.
                    next === null || next === void 0 ? void 0 : next.onGotOwnership();
                }
            }));
            // We don't want to schedule the task until all the items are ready to execute the task.
            let waitCount = 0;
            const onGotOwnership = () => {
                // Wait for all other task to finish first.
                if (--waitCount === 0) {
                    // Using a separate stack to avoid crashing the previous task
                    // that might have invoked the `onGotOwnership` method.
                    setTimeout(runTask, 0);
                }
            };
            for (const item of items) {
                // Each item gets its own task object. We cannot share the objects as
                // we require strict task ordering for each individual item.
                const newTask = new ItemExclusiveTaskChain(task, onGotOwnership);
                const itemTask = item._exclusiveTaskChain;
                if (!itemTask) {
                    // Assign the new task right away. The task will maintain
                    // owneship until it gets scheduled.
                    item._setExclusiveTaskChain(newTask);
                    continue;
                }
                // Increment the number of items that we are still waiting ownership for.
                ++waitCount;
                // Register the task to be executed immediately after the last task in this item's task chain.
                itemTask.registerNewTask(newTask);
            }
            if (waitCount === 0) {
                // We've got owernship of all the required assets already,
                // we can proceed with running the task.
                runTask();
            }
        });
    }
}
__decorate([
    observable$1
], ItemBase.prototype, "exclusiveTask", null);

var COMPATIBLE_ENCODING_PATTERN = /^utf-?8|ascii|utf-?16-?le|ucs-?2|base-?64|latin-?1$/i;
var WS_TRIM_PATTERN = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
var WS_CHAR_PATTERN = /\s|\uFEFF|\xA0/;
var WS_FOLD_PATTERN = /\r?\n[\x20\x09]+/g;
var DELIMITER_PATTERN = /[;,"]/;
var WS_DELIMITER_PATTERN = /[;,"]|\s/;

/**
 * Token character pattern
 * @type {RegExp}
 * @see https://tools.ietf.org/html/rfc7230#section-3.2.6
 */
var TOKEN_PATTERN = /^[!#$%&'*+\-\.^_`|~\da-zA-Z]+$/;

var STATE = {
  IDLE: 1 << 0,
  URI: 1 << 1,
  ATTR: 1 << 2,
};

function trim( value ) {
  return value.replace( WS_TRIM_PATTERN, '' )
}

function hasWhitespace( value ) {
  return WS_CHAR_PATTERN.test( value )
}

function skipWhitespace( value, offset ) {
  while( hasWhitespace( value[offset] ) ) {
    offset++;
  }
  return offset
}

function needsQuotes( value ) {
  return WS_DELIMITER_PATTERN.test( value ) ||
    !TOKEN_PATTERN.test( value )
}

/**
 * Shallow compares two objects to check if their properties match.
 * @param {object} object1 First object to compare.
 * @param {object} object2 Second object to compare.
 * @returns {boolean} Do the objects have matching properties.
 */
function shallowCompareObjects( object1, object2 ) {
  return (
    Object.keys( object1 ).length === Object.keys( object2 ).length &&
    Object.keys( object1 ).every(
      ( key ) => key in object2 && object1[ key ] === object2[ key ]
    )
  );
}

class Link {

  /**
   * Link
   * @constructor
   * @param {String} [value]
   * @returns {Link}
   */
  constructor( value ) {

    /** @type {Array} URI references */
    this.refs = [];

    if( value ) {
      this.parse( value );
    }

  }

  /**
   * Get refs with given relation type
   * @param {String} value
   * @returns {Array<Object>}
   */
  rel( value ) {

    var links = [];
    var type = value.toLowerCase();

    for( var i = 0; i < this.refs.length; i++ ) {
      if( this.refs[ i ].rel.toLowerCase() === type ) {
        links.push( this.refs[ i ] );
      }
    }

    return links

  }

  /**
   * Get refs where given attribute has a given value
   * @param {String} attr
   * @param {String} value
   * @returns {Array<Object>}
   */
  get( attr, value ) {

    attr = attr.toLowerCase();

    var links = [];

    for( var i = 0; i < this.refs.length; i++ ) {
      if( this.refs[ i ][ attr ] === value ) {
        links.push( this.refs[ i ] );
      }
    }

    return links

  }

  /** Sets a reference. */
  set( link ) {
    this.refs.push( link );
    return this
  }

  /**
   * Sets a reference if a reference with similar properties isn’t already set.
   */
  setUnique( link ) {

    if( !this.refs.some(( ref ) => shallowCompareObjects( ref, link )) ) {
      this.refs.push( link );
    }

    return this

  }

  has( attr, value ) {

    attr = attr.toLowerCase();

    for( var i = 0; i < this.refs.length; i++ ) {
      if( this.refs[ i ][ attr ] === value ) {
        return true
      }
    }

    return false

  }

  parse( value, offset ) {

    offset = offset || 0;
    value = offset ? value.slice( offset ) : value;

    // Trim & unfold folded lines
    value = trim( value ).replace( WS_FOLD_PATTERN, '' );

    var state = STATE.IDLE;
    var length = value.length;
    var offset = 0;
    var ref = null;

    while( offset < length ) {
      if( state === STATE.IDLE ) {
        if( hasWhitespace( value[offset] ) ) {
          offset++;
          continue
        } else if( value[offset] === '<' ) {
          if( ref != null ) {
            ref.rel != null ?
              this.refs.push( ...Link.expandRelations( ref ) ) :
              this.refs.push( ref );
          }
          var end = value.indexOf( '>', offset );
          if( end === -1 ) throw new Error( 'Expected end of URI delimiter at offset ' + offset )
          ref = { uri: value.slice( offset + 1, end ) };
          // this.refs.push( ref )
          offset = end;
          state = STATE.URI;
        } else {
          throw new Error( 'Unexpected character "' + value[offset] + '" at offset ' + offset )
        }
        offset++;
      } else if( state === STATE.URI ) {
        if( hasWhitespace( value[offset] ) ) {
          offset++;
          continue
        } else if( value[offset] === ';' ) {
          state = STATE.ATTR;
          offset++;
        } else if( value[offset] === ',' ) {
          state = STATE.IDLE;
          offset++;
        } else {
          throw new Error( 'Unexpected character "' + value[offset] + '" at offset ' + offset )
        }
      } else if( state === STATE.ATTR ) {
        if( value[offset] ===';' || hasWhitespace( value[offset] ) ) {
          offset++;
          continue
        }
        var end = value.indexOf( '=', offset );
        if( end === -1 ) throw new Error( 'Expected attribute delimiter at offset ' + offset )
        var attr = trim( value.slice( offset, end ) ).toLowerCase();
        var attrValue = '';
        offset = end + 1;
        offset = skipWhitespace( value, offset );
        if( value[offset] === '"' ) {
          offset++;
          while( offset < length ) {
            if( value[offset] === '"' ) {
              offset++; break
            }
            if( value[offset] === '\\' ) {
              offset++;
            }
            attrValue += value[offset];
            offset++;
          }
        } else {
          var end = offset + 1;
          while( !DELIMITER_PATTERN.test( value[end] ) && end < length ) {
            end++;
          }
          attrValue = value.slice( offset, end );
          offset = end;
        }
        if( ref[ attr ] && Link.isSingleOccurenceAttr( attr ) ) ; else if( attr[ attr.length - 1 ] === '*' ) {
          ref[ attr ] = Link.parseExtendedValue( attrValue );
        } else {
          attrValue = attr === 'type' ?
            attrValue.toLowerCase() : attrValue;
          if( ref[ attr ] != null ) {
            if( Array.isArray( ref[ attr ] ) ) {
              ref[ attr ].push( attrValue );
            } else {
              ref[ attr ] = [ ref[ attr ], attrValue ];
            }
          } else {
            ref[ attr ] = attrValue;
          }
        }
        switch( value[offset] ) {
          case ',': state = STATE.IDLE; break
          case ';': state = STATE.ATTR; break
        }
        offset++;
      } else {
        throw new Error( 'Unknown parser state "' + state + '"' )
      }
    }

    if( ref != null ) {
      ref.rel != null ?
        this.refs.push( ...Link.expandRelations( ref ) ) :
        this.refs.push( ref );
    }

    ref = null;

    return this

  }

  toString() {

    var refs = [];
    var link = '';
    var ref = null;

    for( var i = 0; i < this.refs.length; i++ ) {
      ref = this.refs[i];
      link = Object.keys( this.refs[i] ).reduce( function( link, attr ) {
        if( attr === 'uri' ) return link
        return link + '; ' + Link.formatAttribute( attr, ref[ attr ] )
      }, '<' + ref.uri + '>' );
      refs.push( link );
    }

    return refs.join( ', ' )

  }

}

/**
 * Determines whether an encoding can be
 * natively handled with a `Buffer`
 * @param {String} value
 * @returns {Boolean}
 */
Link.isCompatibleEncoding = function( value ) {
  return COMPATIBLE_ENCODING_PATTERN.test( value )
};

Link.parse = function( value, offset ) {
  return new Link().parse( value, offset )
};

Link.isSingleOccurenceAttr = function( attr ) {
  return attr === 'rel' || attr === 'type' || attr === 'media' ||
    attr === 'title' || attr === 'title*'
};

Link.isTokenAttr = function( attr ) {
  return attr === 'rel' || attr === 'type' || attr === 'anchor'
};

Link.escapeQuotes = function( value ) {
  return value.replace( /"/g, '\\"' )
};

Link.expandRelations = function( ref ) {
  var rels = ref.rel.split( ' ' );
  return rels.map( function( rel ) {
    var value = Object.assign( {}, ref );
    value.rel = rel;
    return value
  })
};

/**
 * Parses an extended value and attempts to decode it
 * @internal
 * @param {String} value
 * @return {Object}
 */
Link.parseExtendedValue = function( value ) {
  var parts = /([^']+)?(?:'([^']*)')?(.+)/.exec( value );
  return {
    language: parts[2].toLowerCase(),
    encoding: Link.isCompatibleEncoding( parts[1] ) ?
      null : parts[1].toLowerCase(),
    value: Link.isCompatibleEncoding( parts[1] ) ?
      decodeURIComponent( parts[3] ) : parts[3]
  }
};

/**
 * Format a given extended attribute and it's value
 * @param {String} attr
 * @param {Object} data
 * @return {String}
 */
Link.formatExtendedAttribute = function( attr, data ) {

  var encoding = ( data.encoding || 'utf-8' ).toUpperCase();
  var language = data.language || 'en';

  var encodedValue = '';

  if( Buffer.isBuffer( data.value ) && Link.isCompatibleEncoding( encoding ) ) {
    encodedValue = data.value.toString( encoding );
  } else if( Buffer.isBuffer( data.value ) ) {
    encodedValue = data.value.toString( 'hex' )
      .replace( /[0-9a-f]{2}/gi, '%$1' );
  } else {
    encodedValue = encodeURIComponent( data.value );
  }

  return attr + '=' + encoding + '\'' +
    language + '\'' + encodedValue

};

/**
 * Format a given attribute and it's value
 * @param {String} attr
 * @param {String|Object} value
 * @return {String}
 */
Link.formatAttribute = function( attr, value ) {

  if( Array.isArray( value ) ) {
    return value.map(( item ) => {
      return Link.formatAttribute( attr, item )
    }).join( '; ' )
  }

  if( attr[ attr.length - 1 ] === '*' || typeof value !== 'string' ) {
    return Link.formatExtendedAttribute( attr, value )
  }

  if( Link.isTokenAttr( attr ) ) {
    value = needsQuotes( value ) ?
      '"' + Link.escapeQuotes( value ) + '"' :
      Link.escapeQuotes( value );
  } else if( needsQuotes( value ) ) {
    value = encodeURIComponent( value );
    // We don't need to escape <SP> <,> <;> within quotes
    value = value
      .replace( /%20/g, ' ' )
      .replace( /%2C/g, ',' )
      .replace( /%3B/g, ';' );

    value = '"' + value + '"';
  }

  return attr + '=' + value

};

var link = Link;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// https://www.w3.org/Protocols/rfc2616/rfc2616-sec2.html#sec2.1
// OCTET          = <any 8-bit sequence of data>
// CHAR           = <any US-ASCII character (octets 0 - 127)>
// CTL            = <any US-ASCII control character
//                  (octets 0 - 31) and DEL (127)>
// SP             = <US-ASCII SP, space (32)>
// HT             = <US-ASCII HT, horizontal-tab (9)>
// separators     = "(" | ")" | "<" | ">" | "@"
//                | "," | ";" | ":" | "\" | <">
//                | "/" | "[" | "]" | "?" | "="
//                | "{" | "}" | SP | HT
// token          = 1*<any CHAR except CTLs or separators>
// A header is just a <token>, the char ':' and the value.
function createHeaderRegexp$1() {
    const separators = '()<@,;:"/[]={}';
    // Start from the first character that is accepted by the <token>.
    let start = 33;
    const regexp = ['^(['];
    for (let i = 34; i <= 127; ++i) {
        // We know 127 is not accepted, so we use it as a terminator for our regexp segments.
        // None of the separators are allowed.
        if (i === 127 || separators.indexOf(String.fromCharCode(i)) !== -1) {
            regexp.push('\\' + start.toString(8));
            if (start < i - 1) {
                regexp.push('-\\' + (i - 1).toString(8));
            }
            start = i + 1;
        }
    }
    regexp.push(']+):(.*)$');
    return new RegExp(regexp.join(''));
}
const END_OF_LINE$1 = '\n';
const CR$1 = '\r';
const headerRegexp$1 = createHeaderRegexp$1();
const statusRegexp$1 = /^[^\s]+\s+(\d+)\s*(.*)$/;
class HttpResponseParser$1 {
    constructor(_text) {
        this._text = _text;
        this._index = 0;
    }
    readLine() {
        const { _index, _text } = this;
        // The standard expects lines to end with CRLF by default.
        // However, it recommends to accept a single LF as well,
        // just in case some implementations do not implement the
        // standard correctly.
        // Async responses only use LF.
        const endOfLine = _text.indexOf(END_OF_LINE$1, _index);
        if (endOfLine === -1) {
            // We're done.
            return;
        }
        this._index = endOfLine + END_OF_LINE$1.length;
        let line = _text.slice(_index, endOfLine);
        if (line.endsWith(CR$1)) {
            // If we have the CR just before the LF, then we want to skip it too.
            line = line.slice(0, -1);
        }
        return line;
    }
    get remainderText() {
        return this._text.slice(this._index);
    }
}
/**
 * Implements parsing of the async response body.
 * https://git.corp.adobe.com/pages/caf/api-spec/chapters/advanced/asynchronous_invocation.html
 *
 * The caller should check for status code 202 then call this method to extract the contents
 * of final async result. The actual result is very similar to a nested HTTP reply inside the body
 * of the initial request.
 *
 */
function parseAsyncResponse$1(originalUrl, body) {
    if (!body) {
        throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Invalid async response body.');
    }
    const parser = new HttpResponseParser$1(body);
    let status;
    let statusText;
    const statusLine = parser.readLine();
    if (!statusLine) {
        // throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Could not find async response status line.');
        // TODO: R-API does not return the status line for operations api. Any errors are reported in data section.
        // When this is fixed, then missing status line should be an error.
        // https://developers.corp.adobe.com/supplemental-resources/docs/async-invocation.md/#operations-api-exception
        status = 200;
        statusText = '';
    }
    else {
        // The status line has 3 parts separated by spaces.
        // Example status line: HTTP/1.1 200 Status text
        const statusMatch = statusLine.match(statusRegexp$1);
        if (!statusMatch) {
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Invalid status line for async response.');
        }
        // The status code is the second element
        status = parseInt(statusMatch[1], 10);
        if (!status) {
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Could not find status code for async response.');
        }
        statusText = statusMatch[2];
    }
    // Now we extract the headers line by line.
    const headers = [];
    let headerName;
    for (;;) {
        const headerLine = parser.readLine();
        if (!headerLine) {
            break;
        }
        const match = headerLine.match(headerRegexp$1);
        if (!match) {
            if (headerName) {
                // If this is not a token, then we just continue with the value.
                headers.push([headerName, headerLine]);
            }
            continue;
        }
        headerName = match[1];
        headers.push([headerName, match[2]]);
    }
    // 1. The last `readLine()` call above will actually jump over the empty
    // line that separates the headers from the data section.
    // 2. The Headers constructor below takes care of multiple headers with the
    // same name and concatenates them as necessary.
    return new CacheableResponse(originalUrl, new Headers(headers), status, statusText, parser.remainderText);
}

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2023 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
function clamp(value, min, max) {
    if (min !== undefined && value < min) {
        return min;
    }
    if (max !== undefined && value > max) {
        return max;
    }
    return value;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class SAMObjectEventEmitter extends TypedEventEmitter {
    constructor(_core) {
        super();
        this._core = _core;
    }
}
class SAMObjectUntypedEventEmitter extends EventEmitter {
    constructor(_core) {
        super();
        this._core = _core;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * A resource wraps a response that can be loaded from the server. It can be observed for changes.
 * It can either be configured to fetch its own data (with `loadData`), or its data can be set
 * externally (with a fetch request, or via _setData).
 *
 * Resource works in tandem with the ResponseCache, if enabled, to support requests that may resolve
 * with more than one response:
 *
 *   (1) the initial response from cache
 *   (2) the updated response from the server, *if* it has changed.
 *
 * Consumers should use `.get()` to fetch the data, which will load it if necessary.
 */
class Resource extends SAMObjectEventEmitter {
    constructor(
    /** @package */
    _core, _options = {}) {
        super(_core);
        this._core = _core;
        this._options = _options;
        this._isLoaded = false;
        this._etag = '';
        /**
         * A resource should be marked dirty if its value is _known_ to be outdated.
         * This will force the next load to fetch the data from the server, ignoring the cache.
         * The next successful response will mark the resource as clean.
         */
        this.isDirty = false;
        /** Track active revalidations to ensure we don't revalidate the same page concurrently. */
        this._activeRevalidations = new Map();
    }
    async _loadData() {
        var _a, _b;
        // Resources could be loaded from an external source, via onResponse.
        // Subclasses might want to have a way to load data here.
        return (_b = (_a = this._options).loadData) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    async _onChange() {
        var _a, _b;
        await ((_b = (_a = this._options).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, this.data));
        this.emit('change');
    }
    /**
     * Load the resource, even if it has already been loaded.
     * If an error occurs right away, it will be thrown.
     */
    async load() {
        await this._loadData();
    }
    /**
     * Get the data for the resource. The data will be fetched if one of the following is true:
     *   - it hasn't been loaded yet
     *   - it has been marked isDirty
     *   - forceRefresh is true
     */
    async get(options) {
        if (options.forceRefresh || !this.isLoaded || this.isDirty) {
            await this.load();
        }
        return this.data;
    }
    /**
     * TODO_Deprecation: To be marked deprecated on or after 2025-03-01. When there are multiple
     * clients of a SAM instance, some wanting a Resource loaded and others wanting to unload, then that
     * creates an unresolvable conflict. SAM can use its lazy-loading pattern to ensures Resources are
     * only refreshed when there are clients that need it. For resources with large payloads, the data
     * should be stored as a WeakRef with `@keepAlive` decorator.
     */
    async unload() {
        this._data = undefined;
        this._etag = '';
        this._error = undefined;
        this._isLoaded = false;
        await this._onChange();
    }
    /**
     * Returns true if the data has been loaded. (Excludes updates from _mergeData.)
     */
    get isLoaded() {
        return this._isLoaded;
    }
    /** The data for the resource. Accessing this does not fetch it; prefer .get() if needed. */
    get data() {
        return this._data;
    }
    /** The etag of the most recent Response (from its headers), otherwise an empty string. */
    get etag() {
        return this._etag || '';
    }
    get error() {
        return this._error;
    }
    /**
     * @package -- for use in SAM.js only
     */
    async _setData(data, etag) {
        this._data = data;
        this._etag = etag || '';
        this._error = undefined;
        this._isLoaded = true;
        await this._onChange();
    }
    /**
     * Merge new data into existing. Supports cases where data sources might not include all fields,
     * such as for appMetadata in listings, typically called by ItemUpdaters. This does not affect the load
     * status or dirty status, because it's not known whether the data is stale after merging possibly incomplete data.
     * @package -- for use in SAM.js only
     */
    async _mergeData(data) {
        this._data = Object.assign(Object.assign({}, (this._data || {})), (data || {}));
        this._etag = ''; // Assume the etag is not valid if we've changed the data elsewhere
        await this._onChange();
    }
    /**
     * Handle a response from a fetch request. The response will be parsed and set on the resource.
     * The ResponseFlags indicate whether this was a preliminary response, and whether the data changed
     * from the previous response, if so.
     */
    async handleFetchResponse(response, flags) {
        var _a, _b, _c, _d, _e;
        const parsedValue = (_c = await ((_b = (_a = this._options).parseResponse) === null || _b === void 0 ? void 0 : _b.call(_a, response))) !== null && _c !== void 0 ? _c : await response.json();
        await this._setData(parsedValue, response.headers.get('ETag') || '');
        await ((_e = (_d = this._options).onResponse) === null || _e === void 0 ? void 0 : _e.call(_d, response, flags));
    }
    static getDefaultCacheKey(method, href, body) {
        if (body && typeof body !== 'string') {
            // Non-string bodies (such as Streams, if we ever use them) are not currently cacheable.
            return undefined;
        }
        return `${method}-${href}-${body !== null && body !== void 0 ? body : ''}`;
    }
    /**
     * Perform a fetch request, intercepting the response to handle caching and revalidation.
     * If a cached response is available, it will be returned immediately. Unless the Resource
     * uses skipRevalidation(), the request will be revalidated in the background, and the Resource
     * will be updated with the new response when it arrives.
     *
     * @package
     */
    async _interceptFetch(method, href, body, performFetch) {
        var _a, _b, _c, _d, _e;
        // NOTE: Environment._responseCache will be undefined if ResponseCache is disabled.
        const responseCache = this._core._environment._responseCache;
        let cacheKey;
        let cachedResponse;
        if (!this._options.skipCache) {
            cacheKey = (_c = (_b = (_a = this._options).getCacheKey) === null || _b === void 0 ? void 0 : _b.call(_a, method, href, body)) !== null && _c !== void 0 ? _c : Resource.getDefaultCacheKey(method, href, body);
            cachedResponse = (this.isDirty || !cacheKey) ? undefined : await (responseCache === null || responseCache === void 0 ? void 0 : responseCache.getCachedResponse(cacheKey));
        }
        const subsequentResponseExpected = cachedResponse && !((_e = (_d = this._options).skipRevalidation) === null || _e === void 0 ? void 0 : _e.call(_d));
        const performRevalidation = async () => {
            var _a, _b;
            let response;
            try {
                response = await performFetch();
                // Save the response to the cache whether it matches or not, to ensure the TTL gets extended.
                if (cacheKey && responseCache) {
                    await (responseCache === null || responseCache === void 0 ? void 0 : responseCache.saveResponseToCache(cacheKey, response));
                }
                const matches = await response.matches(cachedResponse);
                await this.handleFetchResponse(response, {
                    changed: subsequentResponseExpected && !matches,
                    preliminary: false
                });
                return response;
            }
            catch (error) {
                try {
                    // Set the error state on the resource first, whether or not we have an onError handler.
                    // If the onError handler wants to treat this as a successful response,
                    // it can call _setData() to clear the error on the resource.
                    this._error = error;
                    await ((_b = (_a = this._options).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, !!cachedResponse));
                }
                catch (e) {
                    // If the error handler throws an error, store that one as the resource's error.
                    this._error = e;
                }
                // The error handler could have cleared the error (e.g. with `this._setData()`),
                // such as in cases where a 404 is expected and handled as a successful response.
                if (!this._error) {
                    // A fetch might've returned a SAMError but then been handled as a successful response.
                    return new Response();
                }
                else {
                    throw this._error;
                }
            }
        };
        // Track revalidations to prevent multiple concurrent revalidations for the same cache key.
        const revalidate = async () => {
            const existingPromise = cacheKey && this._activeRevalidations.get(cacheKey);
            if (existingPromise) {
                return await existingPromise;
            }
            try {
                const promise = performRevalidation();
                if (cacheKey) {
                    this._activeRevalidations.set(cacheKey, promise);
                }
                return await promise;
            }
            finally {
                if (cacheKey) {
                    this._activeRevalidations.delete(cacheKey);
                }
            }
        };
        if (cachedResponse) {
            // If we're going to revalidate, kick it off in the background, and return the cached response in the meantime.
            if (subsequentResponseExpected) {
                void revalidate();
            }
            await this.handleFetchResponse(cachedResponse, {
                changed: false,
                preliminary: subsequentResponseExpected
            });
            return cachedResponse;
        }
        else {
            return revalidate();
        }
    }
}
__decorate([
    observable$1
], Resource.prototype, "isLoaded", null);
__decorate([
    observable$1
], Resource.prototype, "data", null);
__decorate([
    observable$1
], Resource.prototype, "etag", null);
__decorate([
    observable$1
], Resource.prototype, "error", null);
/**
 * A Passthrough Resource doesn't cache responses.
 * It is used for requests that do not provide their own Resource,
 * where we haven't explicitly set up a Resource to handle a cached response.
 * Providing a Resource allows us to handle requests with the same codepath whether attached to a Resource or not.
 */
class PassthroughResource extends Resource {
    constructor(_core) {
        super(_core, {
            parseResponse: async (response) => response,
            skipCache: () => true,
        });
        this._core = _core;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Make 1 request, then MAX_ERROR_RETRIES retries
const MAX_ERROR_RETRIES = 5;
/**
 * InterfaceBase and its subclasses are abstractions around calling into a service (not to be confused with typescript
 * interfaces). It extends fetch to provide retry and error handling logic.
 */
class InterfaceBase {
    constructor(_core) {
        this._core = _core;
        this._useHighPriorityRequestsIfEnabled = false;
        this._sharedResponses = new Map;
    }
    async _fetch(href, options = {
        successResponseCodes: VALID_HTTP_RESPONSE_CODES
    }) {
        var _a;
        // Ensure we remove any non-fetch-related options before passing to fetch,
        // as the nock library will hold references to these (and cause GC tests to fail).
        const { resource = new PassthroughResource(this._core) } = options, fetchOptions = __rest$2(options, ["resource"]);
        const performFetch = () => this._fetchImpl(href, fetchOptions, 0).then(CacheableResponse.fromResponse);
        return await resource._interceptFetch((_a = options.method) !== null && _a !== void 0 ? _a : 'GET', href, options.body, performFetch);
    }
    async _fetchImpl(href, options, retryCount) {
        const { additionalRetryErrorCodes, successResponseCodes = VALID_HTTP_RESPONSE_CODES } = options, 
        // fetchOptions should only contain IFetchOptions
        fetchOptions = __rest$2(options, ["additionalRetryErrorCodes", "successResponseCodes"]);
        const retryErrorCodes = [...RETRY_HTTP_RESPONSE_CODES, ...(additionalRetryErrorCodes || [])];
        const overrides = await this._getFetchOptionOverrides(href, fetchOptions);
        let response = await this._core._environment.fetch(overrides.href, overrides.options);
        const { status } = response;
        if (status === 202) {
            response = await this._monitorResponse(response);
        }
        // If the Retry-After header is present, then retry regardless of status code.
        if (status >= 400 && getRetryAfterHeader(response.headers)
            // Always retry the retryErrorCodes
            || retryErrorCodes.includes(status)) {
            if (retryCount < MAX_ERROR_RETRIES) {
                const delay = this._getRetryErrorDelay(response, retryCount);
                this._core._environment.log(`Retryable error ${status} retrying in ${delay}ms, ${retryCount} retries so far`);
                await new Promise(resolve => setTimeout(resolve, delay));
                return await this._fetchImpl(href, options, retryCount + 1);
            }
            else {
                this._core._environment.log(`Retryable error ${status} attempt ${retryCount} exceeded ${MAX_ERROR_RETRIES} retries`);
            }
        }
        if (successResponseCodes !== 'any') {
            this._checkResponseStatus(response, href, successResponseCodes);
        }
        return response;
    }
    _checkResponseStatus(response, href, successResponseCodes) {
        if (!successResponseCodes.includes(response.status)) {
            const error = SAMError.createWithResponse(response, href);
            this._core._environment.error(`InterfaceBase error ${error}`);
            throw error;
        }
    }
    async _monitorResponse(response) {
        let href = response.headers.get('location');
        if (!href) {
            const json = await response.json();
            if (!json) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Failed to parse content for 202 monitor response.');
            }
            href = json.href;
            if (!href) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Missing href property for 202 monitor response.');
            }
        }
        const delay = this._getMonitorRetryAfter(response.headers);
        return this._fetchMonitorResponse(response.url, href, delay);
    }
    async _fetchMonitorResponse(originalUrl, asyncUrl, delay) {
        var _a;
        if (delay) {
            // Wait before trying again.
            await new Promise((resolve) => setTimeout(resolve, delay));
        }
        const asyncResponse = await this._core._environment.fetch(asyncUrl);
        const body = await asyncResponse.text();
        const shouldRetry = this._shouldRetryMonitorResponse(asyncResponse, body);
        if (shouldRetry) {
            // Try again later.
            const newDelay = this._getMonitorRetryAfter(asyncResponse.headers);
            return this._fetchMonitorResponse(originalUrl, asyncUrl, newDelay);
        }
        // If the response was recently returned and it's now a JSON response
        // let's just parse it and return the result, otherwise it's not going to
        // have a standard response body that parseAsyncResponse can handle.
        if ((_a = asyncResponse.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
            return new CacheableResponse(originalUrl, new Headers(asyncResponse.headers), asyncResponse.status, asyncResponse.statusText, body);
        }
        // Parse the response from the async call.
        return parseAsyncResponse$1(originalUrl, body);
    }
    /**
     * Determines whether or not the response indicates the server-side async process is still underway.
     */
    // Overrides can use `body`
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _shouldRetryMonitorResponse(asyncResponse, body) {
        return asyncResponse.status === 202;
    }
    /**
     * Calculate how long of a delay before re-requesting the status of a server-side async process.
     */
    _getMonitorRetryAfter(headers) {
        return getRetryAfterHeader(headers) * 1000 || this._core._environment.getValue('ASYNC_DEFAULT_DELAY');
    }
    /**
     * Calculate how long of a delay before retrying a request that failed
     */
    _getRetryErrorDelay(response, retryCount) {
        const min = this._core._environment.getValue('MIN_RETRY_INTERVAL');
        const max = this._core._environment.getValue('MAX_RETRY_INTERVAL');
        const delay = (response && getRetryAfterHeader(response.headers) || Math.pow(2, retryCount)) * 1000;
        return clamp(delay, min, max);
    }
    /**
     * Make a GET request to the Platform API.
     * @param href for request
     * @param additionalFetchOptions {InterfaceBaseFetchOptions} (optional)
     */
    async _doGet(href, additionalFetchOptions) {
        return this._fetch(href, Object.assign({ method: 'GET', successResponseCodes: VALID_HTTP_RESPONSE_CODES }, additionalFetchOptions));
    }
    /**
     * Make a HEAD request to the Platform API.
     * @param href for request
     * @param headers for request
     */
    async _doHead(href, headers = {}) {
        return this._fetch(href, { method: 'HEAD', headers });
    }
    /**
     * Make a POST request to the Platform API.
     * @param href for request
     * @param headers for request
     * @param body for request
     * @param successResponseCodes for request. Most POST requests that create something will return a 201 success
     *     code, but sometimes a different success code is used (e.g. 204 for discard/restore).
     */
    async _doPost(href, headers = {}, body, successResponseCodes = [201], noOtherHeaders = false, resource) {
        return this._fetch(href, { method: 'POST', headers, noOtherHeaders, body, successResponseCodes, resource });
    }
    /**
     * Make a PATCH request to the Platform API.
     * @param href for request
     * @param headers for request
     * @param body for request
     * @param successResponseCodes for request.
     */
    async _doPatch(href, headers = {}, body, successResponseCodes = [200]) {
        return this._fetch(href, { method: 'PATCH', headers, body, successResponseCodes });
    }
    /**
     * Make a PUT request to the Platform API.
     * @param href for request
     * @param headers for request
     * @param body for request
     * @param successResponseCodes for request.
     */
    async _doPut(href, headers = {}, body, successResponseCodes = [201], noOtherHeaders = false) {
        return this._fetch(href, { method: 'PUT', headers, body, noOtherHeaders, successResponseCodes });
    }
    /**
     * Make a DELETE request to the Platform API.
     * @param href for request
     * @param headers for request
     * @param successResponseCodes for request.
     */
    async _doDelete(href, headers = {}, successResponseCodes = [200], noOtherHeaders = false) {
        return this._fetch(href, { method: 'DELETE', headers, noOtherHeaders, successResponseCodes });
    }
    /**
     * Get a JSON resource from the platform API - handles parsing the response as JSON
     * @param href for request
     * @param additionalFetchOptions {InterfaceBaseFetchOptions} (optional)
     */
    async _getResponse(href, additionalFetchOptions) {
        const response = await this._doGet(href, additionalFetchOptions);
        return response.json();
    }
    /**
     * The same as _getResponse, except that it allows piggybacking on a request if it's
     * already in-flight. This is useful when we have multiple places in the code that
     * depend on data from the same request (e.g. getting both collaborators and invitations
     * from the same API), and we want to avoid making repeated requests.
     *
     * @param href for request
     * @param headers for request
     */
    async _getSharedResponse(href, headers = {}) {
        let response = this._sharedResponses.get(href);
        if (!response) {
            response = this._getResponse(href, { headers });
            this._sharedResponses.set(href, response);
            response.finally(() => this._sharedResponses.delete(href));
        }
        return response;
    }
    /**
     * Make a request to the Platform API. If it is paged, provide a next callback
     * @param href for page
     * @param headers to send with request
     */
    async _getPagedResponse(href, headers = {}) {
        var _a, _b;
        const result = await this._getResponse(href, headers);
        if (((_a = result === null || result === void 0 ? void 0 : result._page) === null || _a === void 0 ? void 0 : _a.next) && ((_b = result === null || result === void 0 ? void 0 : result._links) === null || _b === void 0 ? void 0 : _b[RelType.PAGE])) {
            const template = uriTemplates(result._links[RelType.PAGE].href);
            const nextHref = template.fill(Object.assign(Object.assign({}, result._page), { start: result._page.next, resource: RelType.PRIMARY }));
            const next = () => this._getPagedResponse(nextHref, headers);
            return { result, next };
        }
        return { result };
    }
    /**
     * Get all of the pages of a page (or not) Platform API request
     * @param href starting href
     * @param headers to send along with the requests
     */
    _getAllPages(href, headers = {}) {
        let fullResult;
        const readPages = async (requestFn) => {
            const result = await requestFn();
            const children = result && result.result && result.result.children;
            if (!children) {
                return fullResult;
            }
            if (!fullResult) {
                fullResult = result.result;
            }
            else {
                fullResult.children = fullResult.children.concat(children);
            }
            return result.next ? readPages(result.next) : fullResult;
        };
        return readPages(() => this._getPagedResponse(href, headers));
    }
    /**
     * Get and parse the links header for an object in the Platform API
     * @param href of the object
     */
    _getLinksFromHeaders(headers) {
        const linkHeader = headers && headers.get('Link');
        if (!linkHeader) {
            throw SAMError.create(SAMErrorCode.UNKNOWN, 'HEAD request did not return link header');
        }
        const link$1 = link.parse(linkHeader);
        return (link$1
            && link$1.refs.reduce((memo, _a) => {
                var { rel, uri } = _a, otherData = __rest$2(_a, ["rel", "uri"]);
                if (rel) {
                    memo[rel] = memo[rel] || [];
                    memo[rel].push(Object.assign({ href: uri }, otherData));
                }
                return memo;
            }, {}));
    }
    // Sub-classes can refine requests if needed
    async _getFetchOptionOverrides(href, options) {
        if (this._useHighPriorityRequestsIfEnabled && this._core._environment.getValue('HIGH_PRIORITY_RAPI_REQUESTS')) {
            // See https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=CA&title=Proposal%3A+Priority+Header#Proposal:PriorityHeader-UrgencySummary
            //
            // If enabled, R-API requests will be made using with Priority u=1 header to enable HTTP/2 and HTTP/3, and
            // to direct R-API to optimize calls for response time. HTTP/2+ reduces delays caused by too many
            // connections open on the same domain. Currently, this can only be done on the edge network (CDN), which
            // incurs some cost, but will likely be brought in-house.
            //
            // User-facing web clients SHOULD typically enable this to optimize user experience, but is off by default
            // so that clients take responsibility for determining what priority to use.
            href = !href.includes('platform-cs-edge')
                ? href.replace('platform-cs', 'platform-cs-edge')
                : href;
            options.headers = Object.assign(Object.assign({}, (options.headers || {})), { 'Priority': 'u=1' });
        }
        // See https://wiki.corp.adobe.com/display/CA/Proposal%3A+Storage+Model+Unification+Detailed+Design#Proposal:StorageModelUnificationDetailedDesign-AdministratorACEs
        // If ADMIN_MODE_ORG_ID is set, we need to add a header value to all service requests
        // that contains the orgID provided by the Admin Console.
        const adminModeOrgID = this._core._environment.getValue('ADMIN_MODE_ORG_ID');
        if (adminModeOrgID) {
            options.headers = Object.assign(Object.assign({}, (options.headers || {})), { 'X-ACP-ADMIN-PRIVILEGES': adminModeOrgID });
        }
        // See https://wiki.corp.adobe.com/display/CA/Support+scalability+in+serving+public+content+in+alignment+with+Community+Platform+Advancement#SupportscalabilityinservingpubliccontentinalignmentwithCommunityPlatformAdvancement-DetailedDesign
        // If REQUEST_EDGE_BASED_PUBLISHED_LINKS is true and we're making a R-API request, we need to
        // add a header value to all service requests so that RAPI returns edge-accelerated links for
        // public assets,even when the originating service endpoint is not edge-accelerated.
        if (this._core._environment.getValue('REQUEST_EDGE_BASED_PUBLISHED_LINKS') && href.startsWith('https://platform-cs')) {
            options.headers = Object.assign(Object.assign({}, (options.headers || {})), { 'acpc-published-links': 'true' });
        }
        // When set, all requests will include a User-Id header with the value of REQUEST_AS_USER_ID.
        // This is primarily used for services who are acting on behalf of a user, such as
        // Workfront.
        const requestAsUserID = this._core._environment.getValue('REQUEST_AS_USER_ID');
        if (requestAsUserID) {
            options.headers = Object.assign(Object.assign({}, (options.headers || {})), { 'User-Id': requestAsUserID });
        }
        return { href, options };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// @TODO Verify this solution and address the following task.
// We should also write unit tests precisely verifying this behavior.
// https://jira.corp.adobe.com/browse/SAM-2677
const finalizationRegistry = new FinalizationRegistry(objUrl => {
    URL.revokeObjectURL(objUrl);
});
var RenditionStatus;
(function (RenditionStatus) {
    /**
     * Initial status
     */
    RenditionStatus[RenditionStatus["NotStarted"] = 0] = "NotStarted";
    RenditionStatus[RenditionStatus["Fetching"] = 1] = "Fetching";
    RenditionStatus[RenditionStatus["Done"] = 2] = "Done";
    /**
     * Occurs when there are any errors around fetching the
     * rendition from the service, AdobeAsset.clearRenditionError can
     * be used to clear the error and fetch again.
     */
    RenditionStatus[RenditionStatus["Error"] = 3] = "Error";
})(RenditionStatus || (RenditionStatus = {}));
var RenditionSize;
(function (RenditionSize) {
    RenditionSize[RenditionSize["Size64"] = 64] = "Size64";
    RenditionSize[RenditionSize["Size128"] = 128] = "Size128";
    RenditionSize[RenditionSize["Size256"] = 256] = "Size256";
    RenditionSize[RenditionSize["Size512"] = 512] = "Size512";
    RenditionSize[RenditionSize["Size1024"] = 1024] = "Size1024";
})(RenditionSize || (RenditionSize = {}));
var RenditionType;
(function (RenditionType) {
    RenditionType["PNG"] = "image/png";
    RenditionType["JPEG"] = "image/jpeg";
})(RenditionType || (RenditionType = {}));
const THUMBNAIL_SIZE = RenditionSize.Size512; // matches ACPL/SAM.cpp thumbnail size
const SUPPORTED_SIZES = [
    RenditionSize.Size64,
    RenditionSize.Size128,
    RenditionSize.Size256,
    RenditionSize.Size512,
    RenditionSize.Size1024
];
class RenditionFetcher extends TypedEventEmitter {
    constructor(_core, _availableSizes, _fetchRenditionBlob) {
        super();
        this._core = _core;
        this._availableSizes = _availableSizes;
        this._fetchRenditionBlob = _fetchRenditionBlob;
        this._entries = [];
        this._versionToken = '';
    }
    /**
     * Given any number, this method will return a predefined
     * size that is greater than or equal to the target size.
     * You may also specify an existing sizes array.
     *
     * @param targetSize The preferred or target size.
     * @param sizes An array of sizes to sort and find.
     * @returns
     */
    _getStandardSize(targetSize, sizes = this._availableSizes) {
        // Clone the provided array so we don't alter it.
        const sortedArray = [...sizes].sort((a, b) => a - b);
        const index = sortedArray.findIndex((s) => s >= targetSize);
        // If no sizes are large enough, return the largest
        if (index === -1) {
            return sortedArray[sortedArray.length - 1];
        }
        return sortedArray[index];
    }
    _findURLEntry(size, type) {
        const clampedSize = this._getStandardSize(size);
        if (this._entries.length > 0) {
            return this._entries.find((u) => u.size === clampedSize && u.type === type && u.status !== RenditionStatus.Error);
        }
        return undefined;
    }
    /**
     * Removes all entries matching the provided outdated
     * versionToken.
     *
     * @param outdatedVersionToken
     */
    _clearStaleEntries(outdatedVersionToken) {
        const filteredEntries = this._entries.filter((entry) => {
            if (entry.versionToken === outdatedVersionToken) {
                URL.revokeObjectURL(entry.url);
                return false;
            }
            return true;
        });
        this._entries = filteredEntries;
    }
    /**
     * Finds an entry based on the provided size/type and returns
     * a fallback size that is greater than the target, if available.
     *
     * @param size
     * @param type
     * @returns {IURLEntry}
     */
    _getEntryWithFallback(size, type) {
        const foundEntry = this._findURLEntry(size, type);
        if (foundEntry) {
            return foundEntry;
        }
        // If the exact size is not available and there
        // are other sizes and types, return the size
        // that is at-least greater than or equal to the current size.
        const sizesArray = this._entries.map((entry) => entry.size);
        if (this._entries.length > 0) {
            // Since we are passing in our own sizes array
            // this should return the closest size already
            // available.
            const foundSize = this._getStandardSize(size, sizesArray);
            return this._entries.find(s => s.size === foundSize);
        }
        return undefined;
    }
    /**
     * Returns the download status of the requested rendition.
     *
     * @param size
     * @param type
     * @param versionToken // Either an etag or a rendition url (in the case of Library element renditions)
     * @returns
     */
    renditionURLStatus(size, type, versionToken) {
        var _a;
        const clampedSize = this._getStandardSize(size);
        const urlStatus = this._entries.find(e => e.versionToken === versionToken
            && e.size >= clampedSize
            && e.type === type);
        return (_a = (urlStatus && urlStatus.status)) !== null && _a !== void 0 ? _a : RenditionStatus.NotStarted;
    }
    get versionToken() {
        return this._versionToken;
    }
    /**
     *
     * @param size Target size for the rendition
     * @param type String type for example image/png.
     * @param versionToken Either an etag or a rendition url (in the case of Library element renditions)
     * @returns {string} The URL for the rendition.
     */
    getURL(size, type, versionToken) {
        const versionTokenChanged = versionToken !== this.versionToken;
        const renditionEntry = this._getEntryWithFallback(size, type);
        const clampedSize = this._getStandardSize(size);
        // If we do have a rendition wether it be exact or a fallback
        // we could return it but if the requested size is larger
        // than the one we have in the cache we will need to add a new entry
        // and start fetching.
        if (renditionEntry && renditionEntry.size >= clampedSize && !versionTokenChanged) {
            return renditionEntry.url;
        }
        const newEntry = {
            size: clampedSize,
            status: RenditionStatus.Fetching,
            url: '',
            type,
            versionToken
        };
        // If we find an existing entry that exactly matches our new
        // entry then we wont need to fetch again.
        const recentlyAddedEntry = this._entries.find(e => isDeepEqual(e, newEntry)
            // We also want to check if there is an identical entry
            // but with an error so that we don't keep fetching over and
            // over again in case of a thumbnail fetching error.
            || isDeepEqual(e, Object.assign(Object.assign({}, newEntry), { status: RenditionStatus.Error })));
        // If we know we have an existing entry and we have
        // a new entry that was recently added but it's state
        // is loading then we need to just return the existing url
        // until this is no longer true.
        // @note Without this logic, the ui will go into an infinite
        // loop causing the browser to crash because we are fetching
        // and pushing change notifications over and over again.
        if (renditionEntry && recentlyAddedEntry) {
            return renditionEntry.url;
        }
        this._entries.push(newEntry);
        this._fetch(newEntry);
        // If we have a rendition entry after starting to fetch
        // it means that we have a new size requested with a fallback.
        // Return the fallback while the new size is fetching.
        if (renditionEntry) {
            return renditionEntry.url;
        }
        // If the versionToken hasn't changed and we have an entry we should
        // return the existing entry while waiting for the new one.
        return newEntry.url;
    }
    // First we find if there is an existing entry
    // then if there isn't, we create one
    // if there is, we update the existing entry
    async _fetch(entry) {
        const { size, type, versionToken } = entry;
        this.dispatch({ type: 'change' });
        // We want to fetch the URL contents and create an objectURL and return the path
        // to clients instead of the raw URL because services in future will not
        // allow the authorization token to be passed directly in the rendition URL
        try {
            const renditionBlob = await this._fetchRenditionBlob(size, type);
            // If there is a new versionToken all the old URLS that are now
            // out of date so let's remove the existing ones.
            if (versionToken && versionToken !== this._versionToken) {
                this._clearStaleEntries(this._versionToken);
                this._versionToken = versionToken;
            }
            entry.size = size;
            entry.type = type;
            entry.url = URL.createObjectURL(renditionBlob);
            finalizationRegistry.register(this, entry.url, entry);
            entry.status = RenditionStatus.Done;
            entry.versionToken = versionToken;
            this.dispatch({ type: 'change' });
        }
        catch (e) {
            // IF there was an error fetching the thumbnail, we don't
            // want clients stuck in a bad state so we set the rendition
            // to an error dispatch a change event.
            entry.status = RenditionStatus.Error;
            this.dispatch({ type: 'change' });
        }
    }
    /**
     * Resets the rendition status on the requested rendition to RenditionStatus.NotStarted
     */
    clearRenditionError(size, type, versionToken) {
        const clampedSize = this._getStandardSize(size);
        // Find an entry that has all the properties
        // of the request one including the error status.
        // Leaving out the URL case if for some reason it has a value
        // but we still want to reset the error.
        const foundErrorEntryIndex = this._entries.findIndex(e => e.size >= clampedSize
            && e.type === type
            && e.versionToken === versionToken
            && e.status === RenditionStatus.Error);
        if (foundErrorEntryIndex === -1) {
            return;
        }
        // Remove the entry so that when getURL is called again
        // it will add a new entry and begin the fetch process
        // again.
        this._entries.splice(foundErrorEntryIndex, 1);
        this.dispatch({ type: 'change' });
    }
    release() {
        if (this._entries.length === 0) {
            return;
        }
        this._entries.forEach((value) => {
            URL.revokeObjectURL(value.url);
            finalizationRegistry.unregister(this);
        });
        this._entries = [];
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const MAX_LENGTH = 255;
const RESERVED_NAME_REGEX = /^(CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])$/i;
const RESERVED_CHAR_REGEX = /[\\/:*?"|><]/;
function validatePlatformRepoName(name) {
    return (name.length > 0
        && name.length <= MAX_LENGTH
        && !RESERVED_NAME_REGEX.test(name)
        && !RESERVED_CHAR_REGEX.test(name));
}
const PATH_REGEX$1 = /^(.*\/)?(.*?)(?:[\u00A0][^.]*)?(\.[^.]*)?$/;
/**
 * Called by SAM to get new name according to the specified format and counter
 * @param fullPath path of the asset, it can be full path/relative path/filename
 * @param format format should contain %@ and %d
 *      %@ to be replace with filename
 *      %d to be replace with supplied counter. counter value will change in following cases:
 *          - filename matches the format and counter supplied. counter will increment by 1
 *          - filename matches the formatWithoutCount and counter = 0. counter will be made 1
 *            e.g name = test copy, format = %@ copy %d, counter = 0 -> newName = test copy 1, countUsed = 1
 * @param counter count to be used in newName
 * @returns the IFormatFileNameResult object which contains new name and count used in new name
 */
function formatFileName(fullPath, format, counter) {
    // create regex from client passed format
    function getRegexFormat(format, extPresent) {
        // replace '(', ')' with backspace '\(', '\)'
        let regexFormat = format.replace(/[()]/g, '\\$&');
        // insert match patern for %d and %@
        regexFormat = regexFormat.replace('%d', '([0-9]+)');
        regexFormat = regexFormat.replace('%@', '(.*)?');
        // if extPresent is true, we expect to find extension, otherwise it is optional
        regexFormat = regexFormat + (extPresent ? '(\\.[^.]*)$' : '(\\.[^.]*)?$');
        return regexFormat;
    }
    const extPresent = fullPath.lastIndexOf('.') > fullPath.lastIndexOf('/');
    const regexFormat = getRegexFormat(format, extPresent);
    // remove count from string
    const formatWithoutCount = format.replace(/ [^ ]*$/, '');
    const regexFormatWithoutCount = getRegexFormat(formatWithoutCount, extPresent);
    // get parsed result
    let result = fullPath.match(regexFormat);
    let resultMatchedRegexWithoutCount = false;
    if (result === null) {
        result = fullPath.match(regexFormatWithoutCount);
        resultMatchedRegexWithoutCount = result !== null;
    }
    let newPath = '';
    let fileExtension = '';
    if (result) {
        let path = '';
        let extension = '';
        let currentCount = '';
        if (resultMatchedRegexWithoutCount) {
            [, path, extension] = result;
        }
        else {
            [, path, currentCount, extension] = result;
        }
        newPath = path;
        fileExtension = extension;
        if (resultMatchedRegexWithoutCount && counter === 0) {
            // since the name does not contain the count
            // but matches the regex without count, so
            // if counter=0, next name in iteration is with counter=1
            counter = 1;
        }
        else if (!resultMatchedRegexWithoutCount && parseInt(currentCount) === counter) {
            // since the name matches the format with count
            // we should skip the counter that matches the current name
            counter += 1;
        }
    }
    else {
        const [, directory, filename, extension] = fullPath.match(PATH_REGEX$1); // All strings match the regexp above
        newPath = `${directory || ''}${filename || ''}`;
        fileExtension = extension;
    }
    let newName = '';
    if (counter !== 0) {
        newName = format.replace('%@', `${newPath || ''}`);
        newName = newName.replace('%d', counter.toString());
    }
    else {
        newName = formatWithoutCount.replace('%@', `${newPath || ''}`);
    }
    return {
        newName: `${newName || ''}${fileExtension || ''}`,
        countUsed: counter
    };
}
/**
 * Called to get newName as per format in case of batch ops. It considers name of other files as well in the operation for finding conflicts
 * @param core SAMCore
 * @param assetId Asset Id
 * @param newName FileName
 * @param sameFolder true if copying in same folder
 * @param assetConflictMap It saves the newName and count used for all files in batch
 */
function batchFormatFileName(core, assetId, newName, sameFolder, assetConflictMap) {
    var _a;
    let localCounter = ((_a = assetConflictMap.get(assetId)) === null || _a === void 0 ? void 0 : _a.countUsed) || 0;
    let conflictWithOtherFilesInBatch = false;
    const conflictedAssetIds = [];
    // check if we are copying in the same folder
    // if yes, then it should follow ASSET_COPY_NAME_FORMAT i.e. %@ copy (%d)
    // if no and conflict, then it should follow ASSET_CONFLICT_NAME_FORMAT i.e. %@ (%d)
    do {
        const formatFileResult = sameFolder ? formatFileName(newName, core._environment.getValue('ASSET_COPY_NAME_FORMAT'), localCounter)
            : (localCounter > 0 ? formatFileName(newName, core._environment.getValue('ASSET_CONFLICT_NAME_FORMAT'), localCounter) : { newName, countUsed: localCounter });
        newName = formatFileResult.newName;
        localCounter = formatFileResult.countUsed;
        conflictWithOtherFilesInBatch = false;
        for (const [key, value] of assetConflictMap) {
            if (value.newName === newName) {
                conflictWithOtherFilesInBatch = true;
                conflictedAssetIds.push(key);
                break;
            }
        }
        if (conflictWithOtherFilesInBatch) {
            localCounter++;
        }
        else {
            assetConflictMap.set(assetId, formatFileResult);
        }
    } while (conflictWithOtherFilesInBatch);
    for (const id of conflictedAssetIds) {
        // we should update count of all files which this file conflicted with
        // so that they also start with the new count next time
        const currentValue = assetConflictMap.get(id);
        assetConflictMap.set(id, { newName: currentValue.newName, countUsed: localCounter });
    }
    return newName;
}
const ARCHIVE_GUID_REGEX = /^(.*)\^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[12345][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
// Archived assets get a guid suffix appended, so need to remove it when restoring
function removeArchiveGuidFromName(name) {
    const match = name.match(ARCHIVE_GUID_REGEX);
    return match ? match[1] : name;
}
// Clients that haven't yet migrated to R-API still use the old archive locations when deleting assets (as a 2-step delete).
// These locations are treated as discarded by SAM.js, but to implement recover() we need to know where to move the assets back to.
// This is a mapping from the archive location to the restore location.
const ARCHIVE_TO_RESTORE_LOCATION = {
    'cloud-content-archive': 'cloud-content',
    'assets-archive': 'assets',
    'archive': 'files'
};
function getRestorePath(path, newName) {
    const newPath = path.split('/');
    // Paths always start with "/" so newPath[0] is ''
    // ESM paths are of the form /users/<userid>/...
    const archiveIndex = newPath[1] === 'users' ? 3 : 1;
    const restoreFolder = ARCHIVE_TO_RESTORE_LOCATION[newPath[archiveIndex]];
    if (!restoreFolder) {
        // Not archived, so no restore location
        return undefined;
    }
    newPath[archiveIndex] = restoreFolder;
    newPath[newPath.length - 1] = newName || removeArchiveGuidFromName(newPath[newPath.length - 1]);
    return newPath.join('/');
}
/**
 * Replaces the ending filename in a path with the newName
 * and returns the result as a single string.
 *
 * @param newName
 * @param asset
 * @returns
 */
function renameFileInPath(newName, asset) {
    const path = asset.repoPath.split('/').slice(0, -1);
    path.push(newName);
    return path.join('/');
}
function updateCachedDescendents(params) {
    const { assetPool, asset, session, operation, assetContext } = params;
    if (!asset.isFolder || !asset.repoPath.trim()) {
        // The asset must be a folder with a non-empty path
        return;
    }
    // make sure we update the repo:path of all the descendants of this folder
    assetPool.forEach(item => {
        var _a;
        if (item.repoPath.startsWith(asset.repoPath + '/') // make sure the item is a descendant of the asset
        ) {
            switch (operation.type) {
                case 'rename': {
                    // Used by both rename and move operations.
                    // Checking if the item's repoPath starts with the folder's repo:path with '/' appended
                    // this also rules out the folder itself.
                    if (!item.repoPath.startsWith(operation.newPath)) {
                        // We need to take care of recursive folders with the same name as well
                        const newChildPath = item.repoPath.replace(asset.repoPath, operation.newPath);
                        assetContext._adobeAssetUpdater.updateLocalItem(session, item, { 'repo:path': newChildPath });
                    }
                    break;
                }
                case 'discard': {
                    // If item is a descendant of the asset and it is ACTIVE, set repo:state to DISCARDED_PARENT.
                    // We do not want to modify the repo:state of assets that were directly discarded (DISCARDED),
                    // and we don't need to update the repo:state of assets that are already discarded with parent (DISCARDED_PARENT).
                    if (((_a = item.ancestorIDs) === null || _a === void 0 ? void 0 : _a.includes(asset.id)) && !item.isDiscarded) {
                        assetContext._adobeAssetUpdater.updateLocalItem(session, item, { 'repo:state': 'DISCARDED_PARENT' });
                    }
                    break;
                }
                case 'restore': {
                    // Restore operations for assets may include a new path to restore to,
                    // due to unarchiving the parent folder or a name conflict upon parent folder restore.
                    if (operation.newPath) {
                        assetContext._adobeAssetUpdater.updateLocalItem(session, item, { 'repo:path': item.repoPath.replace(asset.repoPath, operation.newPath) });
                    }
                    // If any children were originally discarded along with the parent folder ('repo:state': 'DISCARDED_PARENT'),
                    // update their repo:state to 'ACTIVE'. Children that were directly discarded should remain 'DISCARDED'.
                    if (item._isDiscardedWithParent()) {
                        assetContext._adobeAssetUpdater.updateLocalItem(session, item, { 'repo:state': 'ACTIVE' });
                    }
                    break;
                }
            }
        }
    });
}
const getBatchRenamedAssetName = (item, map) => {
    return map.has(item.id) ? map.get(item.id) : item.name;
};
/**
     * Creates the jsonParams array for milestone operations
     * @param versionId The version ID to set the milestone on
     * @param hasExistingMilestone Whether the version already has a milestone
     * @param label The milestone label
     * @param description The milestone description
     * @returns The jsonParams array for the patch operation
     * @package -- only for use in SAM.js
     */
function createMilestoneJsonParams(versionId, hasExistingMilestone, label, description) {
    return [{
            op: hasExistingMilestone ? VersionPatchTypes.replace : VersionPatchTypes.add,
            path: `/children/version=${versionId}/milestone`,
            value: { label, description }
        }];
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * In UXP `url.searchParams` does not save parameters correctly.
 * This function applies the search parameters to the URL in a UXP-safe way.
 * @see https://jira.corp.adobe.com/browse/UXP-19246
 */
function setURLSearchParams(url, params) {
    // UXP's .searchParams doesn't save when the URL points to an external resource,
    // but we can create URLSearchParams unattached to a URL, and then apply it.
    const searchParams = new URLSearchParams(url.search);
    for (const [key, value] of Object.entries(params)) {
        searchParams.set(key, value);
    }
    url.search = searchParams.toString();
    return url;
}

function getBlockTransferThreshold(links, preferredThreshold) {
    // Get min and max single transfer sizes from links to use as limits.
    const blockInitLink = links[RelType.BLOCK_INITIALIZE] ? getLink(links, RelType.BLOCK_INITIALIZE) : undefined;
    const lowerLimit = blockInitLink ? blockInitLink['repo:minsingletransfersize'] : DEFAULT_MIN_SINGLE_TRANSFER_SIZE;
    const upperLimit = blockInitLink ? blockInitLink['repo:maxsingletransfersize'] : DEFAULT_MAX_SINGLE_TRANSFER_SIZE;
    // If provided, clamp preferred size to platform-defined limits to ensure a valid transfer size,
    // else return platform-defined upper limit.
    return preferredThreshold ? clamp(preferredThreshold, lowerLimit, upperLimit) : upperLimit;
}
const FOLDER_TYPE = 'application/vnd.adobecloud.directory+json';
const FOLDER_ALTERNATE_TYPE = 'application/x-sharedcloud-collection+json';
const BLOCK_SIZE = 6000000;
const BULK_TRANSFER_MIME_TYPE = 'application/vnd.adobecloud.bulk-transfer+json';
const DENY_SHARE_ACE = {
    'repo:principal': 'all',
    'repo:modifier': 'deny',
    'repo:privileges': [
        'write'
    ],
    'repo:relations': [RelType.AC_POLICY],
    'repo:inheritance': 'deep'
};
const DENY_EDIT_ACE = {
    'repo:principal': 'all',
    'repo:modifier': 'deny',
    'repo:privileges': ['write', 'delete'],
    'repo:relations': [
        RelType.ANNOTATIONS,
        RelType.APP_METADATA,
        RelType.EMBEDDED_METADATA,
        RelType.REPO_METADATA,
        RelType.PRIMARY,
        RelType.RENDITION
    ],
    'repo:inheritance': 'deep'
};
function getRestrictEditUserGrantACEs(userId) {
    return [{
            'repo:principal': {
                'xdm:provider': { '@id': 'https://ims-na1.adobelogin.com/' },
                '@id': userId,
                '@type': 'https://ns.adobe.com/adobecloudplatform/ims/user'
            },
            'repo:modifier': 'grant',
            'repo:privileges': ['read', 'write'],
            'repo:relations': ['http://ns.adobe.com/adobecloud/rel/ac/policy'],
            'repo:inheritance': 'deep'
        },
        {
            'repo:principal': {
                'xdm:provider': { '@id': 'https://ims-na1.adobelogin.com/' },
                '@id': userId,
                '@type': 'https://ns.adobe.com/adobecloudplatform/ims/user'
            },
            'repo:modifier': 'grant',
            'repo:privileges': ['read', 'write', 'delete'],
            'repo:relations': [
                'http://ns.adobe.com/adobecloud/rel/annotations',
                'http://ns.adobe.com/adobecloud/rel/metadata/application',
                'http://ns.adobe.com/adobecloud/rel/metadata/embedded',
                'http://ns.adobe.com/adobecloud/rel/metadata/repository',
                'http://ns.adobe.com/adobecloud/rel/primary',
                'http://ns.adobe.com/adobecloud/rel/rendition'
            ],
            'repo:inheritance': 'deep'
        }];
}
var VersionPatchTypes;
(function (VersionPatchTypes) {
    VersionPatchTypes["add"] = "add";
    VersionPatchTypes["remove"] = "remove";
    VersionPatchTypes["replace"] = "replace";
})(VersionPatchTypes || (VersionPatchTypes = {}));
const DefaultAssetsListingOptions = {
    orderDirection: 'descending',
    orderBy: 'storage:deviceModifyDate',
    start: '',
    limit: 0
};
const DefaultVersionsListingOptions = {
    orderDirection: 'descending',
    orderBy: 'created',
    start: '',
    limit: 0,
    version: ''
};
function createVersionTemplate(options) {
    const userOptions = Object.assign(Object.assign({}, DefaultVersionsListingOptions), options);
    const templateValues = createPageTemplate$3(userOptions);
    templateValues.orderBy = getDirectionValue$8(userOptions);
    templateValues.resource = RelType.VERSION;
    return templateValues;
}
function createPageTemplate$3(options) {
    const templateValues = {};
    const { start, limit, version } = options;
    if (start) {
        templateValues.start = start;
    }
    if (limit) {
        templateValues.limit = limit;
    }
    if (version) {
        templateValues.version = version;
    }
    return templateValues;
}
function getDirectionValue$8(userOptions) {
    const directionFlag = userOptions.orderDirection === 'ascending' ? '+' : '-';
    return directionFlag + userOptions.orderBy;
}
function getAssetsListingURL(links, options) {
    const userOptions = Object.assign(Object.assign({}, DefaultAssetsListingOptions), options);
    const templateValues = createPageTemplate$3(userOptions);
    templateValues.orderBy = getDirectionValue$8(userOptions);
    templateValues.type = userOptions.type;
    templateValues.embed = JSON.stringify(userOptions.embed);
    return getURLFromLinks(links, RelType.PAGE, templateValues);
}
function getAssetVersionsListingURL(links, options) {
    const templateValues = createVersionTemplate(options);
    return getURLFromLinks(links, RelType.PAGE, templateValues);
}
class AssetInterface extends InterfaceBase {
    constructor(_rapi, _assetId, _links, _etag) {
        super(_rapi._core);
        this._rapi = _rapi;
        this._assetId = _assetId;
        this._links = _links;
        this._etag = _etag;
        this._useHighPriorityRequestsIfEnabled = true;
    }
    get assetID() {
        return this._assetId;
    }
    get links() {
        return this._links;
    }
    get etag() {
        return this._etag;
    }
    async getChildAssets(options, resource) {
        const href = getAssetsListingURL(this._links, options);
        const response = await this._doGet(href, {
            // Ensure browser doesn't automatically add If-None-Match, otherwise
            // service may respond with cached data FROM ANOTHER USER.
            // https://jira.corp.adobe.com/browse/ACPCSS-5544
            // Also causes SAM-1813, SAM-2066
            headers: { ['Cache-Control']: 'no-cache, no-store, max-age=0' },
            resource
        });
        return response.json();
    }
    async getRepoMetadata(resource) {
        const href = getURLFromLinks(this._links, RelType.REPO_METADATA);
        await this._doGet(href, { resource });
        // Note: Do NOT use the ETag header in the repo metadata response, because that's the ETag for the repo metadata
        // resource, not the asset itself. The ETag of the asset itself is inside the repo metadata response:
        this._etag = resource.data['repo:etag'];
    }
    async getEmbeddedMetadata(resource) {
        const href = getURLFromLinks(this._links, RelType.EMBEDDED_METADATA);
        // Embedded metadata is returned as application/rdf+xml by default - switch to JSON-LD
        await this._doGet(href, { headers: { Accept: JSON_MIME_TYPE }, resource });
    }
    async getAppMetadata(resource) {
        const href = getURLFromLinks(this._links, RelType.APP_METADATA);
        await this._doGet(href, { resource });
    }
    async patchAppMetadata(body) {
        const href = getURLFromLinks(this._links, RelType.APP_METADATA);
        return await this._doPatch(href, {
            'Content-Type': JSON_PATCH_MIME_TYPE
        }, JSON.stringify(body), [204]);
    }
    async getEffectivePermissions(resource) {
        const href = getURLFromLinks(this._links, RelType.AC_EFFECTIVE);
        await this._doGet(href, { resource });
    }
    async getAssetPolicy() {
        const href = getURLFromLinks(this._links, RelType.AC_POLICY);
        return await this._doGet(href);
    }
    async getManifest(resource) {
        const href = getURLFromLinks(this._links, RelType.MANIFEST);
        const headers = {};
        await this._doGet(href, {
            headers,
            resource
        });
    }
    async getVersions(options) {
        const href = getAssetVersionsListingURL(this._links, options);
        const response = await this._doGet(href);
        return response.json();
    }
    async getPerUserMetadata(resource) {
        const href = getURLFromLinks(this._links, RelType.PERUSER_METADATA);
        await this._doGet(href, { headers: { 'Content-Type': JSON_MIME_TYPE }, resource });
    }
    async restoreVersionManifest(versionManifestLink) {
        // first fetch the version manifest
        const response = await this._doGet(versionManifestLink, {});
        const versionManifest = await response.json();
        //doput to current asset manifest url
        const assetManifest = getURLFromLinks(this.links, RelType.MANIFEST);
        await this._doPut(assetManifest, {
            'Content-Type': 'application/vnd.adobe.dcx-manifest+json',
            'If-Match': '*'
        }, JSON.stringify(versionManifest), [204]);
    }
    async getVersion(versionId) {
        const href = getAssetVersionsListingURL(this._links, { version: versionId });
        const response = await this._doGet(href);
        return response.json();
    }
    async patchVersion(body) {
        const href = getURLFromLinks(this.links, RelType.VERSION);
        const response = await this._doPatch(href, {
            'Content-Type': JSON_PATCH_MIME_TYPE
        }, JSON.stringify(body), [204]);
        return response;
    }
    async createFolder(relativePath) {
        const href = getURLFromLinks(this._links, RelType.CREATE, { path: relativePath, intermediates: 'true', respondWith: RelType.REPO_METADATA });
        const response = await this._doPost(href, {
            'Content-Type': FOLDER_TYPE
        }, undefined, [200, 201]);
        // when 200 that means asset created, but error while fetching metadata
        return response.status === 201 ? await response.json() : undefined;
    }
    async _uploadIndividualBlock(href, file, start, end) {
        const headers = {};
        return await this._doPut(href, headers, file.slice(start, end), [200], true /* noOtherHeaders */);
    }
    async _blockUpload(file, relativePath, mediaType, isUpdate) {
        const blockUploadInfoResult = await this.getBlockUploadInfo(relativePath, file.size, isUpdate, mediaType);
        const uploadRequests = [];
        blockUploadInfoResult.transferInfo.forEach((transfer) => {
            uploadRequests.push([transfer.url.href, file, transfer.start, transfer.end]);
        });
        // Only send a max of 3 blocks simultaneously, so the browser's request queue doesn't get
        // over-saturated, and intermittent outages (like wifi blips) will only cause up to 3 requests to
        // need retries.
        const MAX_SIMULTANEOUS_BLOCKS = 3;
        while (uploadRequests.length) {
            await Promise.all(uploadRequests.splice(0, MAX_SIMULTANEOUS_BLOCKS).map(args => this._uploadIndividualBlock(...args)));
        }
        return await this.finalizeBlockUpload(blockUploadInfoResult.finalizeHref, blockUploadInfoResult.initResponse, isUpdate);
    }
    async importFile(file, relativePath, mediaType, preferredBlockTransferThreshold = DEFAULT_MAX_SINGLE_TRANSFER_SIZE) {
        // check if the size of the file to be imported is greater than maximum allowed transfer size.
        const blockUploadTransferThreshold = getBlockTransferThreshold(this._links, preferredBlockTransferThreshold);
        if (file.size >= blockUploadTransferThreshold) {
            // The platform requires a block upload for components greater than threshold.
            // See https://git.corp.adobe.com/pages/CAF/api-spec/#block-upload
            return this._blockUpload(file, relativePath, mediaType !== null && mediaType !== void 0 ? mediaType : file.type, false);
        }
        const href = getURLFromLinks(this._links, RelType.CREATE, { path: relativePath, respondWith: RelType.REPO_METADATA });
        const response = await this._doPost(href, {
            'Content-Type': mediaType !== null && mediaType !== void 0 ? mediaType : file.type
        }, file, [200, 201]);
        // when 200 that means asset created, but error while fetching metadata
        return response.status === 201 ? await response.json() : undefined;
    }
    async updateFile(file, mediaType, preferredBlockTransferThreshold = DEFAULT_MAX_SINGLE_TRANSFER_SIZE) {
        // check if the size of the file to be imported is greater than maximum allowed transfer size.
        const blockUploadTransferThreshold = getBlockTransferThreshold(this._links, preferredBlockTransferThreshold);
        if (file.size >= blockUploadTransferThreshold) {
            // The platform requires a block upload for components greater than threshold.
            // See https://git.corp.adobe.com/pages/CAF/api-spec/#block-upload
            return this._blockUpload(file, '', mediaType !== null && mediaType !== void 0 ? mediaType : file.type, true);
        }
        else {
            const { metaData } = await this.commitFileChanges(file, this.etag);
            if (!metaData) {
                // If we didn't get metadata in the response, fetch it
                const href = getURLFromLinks(this._links, RelType.REPO_METADATA);
                const response = await this._doGet(href);
                return response.json();
            }
            return metaData;
        }
    }
    async getBlockUploadInfo(name, size, isUpdate, mediaType) {
        const initialBlockUploadHref = getURLFromLinks(this._links, RelType.BLOCK_INITIALIZE);
        const initBody = JSON.stringify({
            'repo:size': size,
            'repo:blocksize': BLOCK_SIZE,
            'repo:reltype': RelType.PRIMARY,
            'dc:format': mediaType // Required for updates, optional for new uploads
        });
        const initResponse = await this._doPost(initialBlockUploadHref, {
            'Content-Type': BULK_TRANSFER_MIME_TYPE
        }, initBody, [200]);
        const blockUploadInfo = await initResponse.json();
        const { 'repo:blocksize': blockSize, _links } = blockUploadInfo;
        // Calculate the start and end of each block.
        const transferInfo = _links[RelType.BLOCK_TRANSFER].map((link, index) => {
            const start = index * BLOCK_SIZE;
            const end = Math.min(size, start + BLOCK_SIZE);
            return { url: link, start, end };
        });
        const finalizeHref = getURLFromLinks(_links, RelType.BLOCK_FINALIZE, Object.assign({ respondWith: RelType.REPO_METADATA }, (!isUpdate ? { path: name } : {})));
        return {
            blockSize,
            transferInfo,
            finalizeHref,
            initResponse: blockUploadInfo
        };
    }
    async finalizeBlockUpload(finalizeHref, initResponse, isUpdate) {
        const response = await this._doPost(finalizeHref, {
            'Content-Type': BULK_TRANSFER_MIME_TYPE
        }, JSON.stringify(initResponse), [200, 201]);
        return isUpdate ? undefined : response.json();
    }
    async getBlockDownloadURL(url) {
        const response = await this._doGet(url);
        const json = await response.json();
        if (!(json === null || json === void 0 ? void 0 : json.href)) {
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Cannot get block download URL');
        }
        return json.href;
    }
    async getContent(resource) {
        const href = getURLFromLinks(this._links, RelType.PRIMARY);
        await this._doGet(href, { resource });
    }
    async commitFileChanges(file, localETag) {
        const href = getURLFromLinks(this._links, RelType.PRIMARY);
        const headers = {
            'Content-type': file.type
        };
        localETag && (headers['If-Match'] = localETag);
        const response = await this._doPut(href, headers, file, [200, 201, 204]);
        return { metaData: response.status === 201 ? await response.json() : undefined, eTag: response.headers.get('ETag') };
    }
    async restore(name, _counter = 0) {
        const operation = {
            op: 'restore',
            target: { 'repo:assetId': this.assetID },
            name
        };
        try {
            const repoMetadata = (await this.runOperation(operation)).asset;
            return repoMetadata;
        }
        catch (error) {
            if (error.code === SAMErrorCode.CONFLICT) {
                const { newName, countUsed } = formatFileName(name, this._core._environment.getValue('ASSET_CONFLICT_NAME_FORMAT'), _counter);
                return this.restore(newName, countUsed);
            }
            throw error;
        }
    }
    async discard() {
        const operation = {
            op: 'discard',
            target: { 'repo:assetId': this.assetID }
        };
        const { asset } = await this.runOperation(operation);
        return asset;
    }
    // Last access date is a string so replace has the same effect as add.
    async patchLastAccessed(date) {
        const href = getURLFromLinks(this._links, RelType.PERUSER_METADATA);
        const bodyData = [];
        // We should always perform an add and not a replace as a replace will cause a 400 bad request
        // if the property is not present.
        // As we don't have ONS notifications for the PUPA metadata yet we should always do an add
        // as it will have the same effect as replace.
        bodyData.push({
            op: date ? 'add' : 'remove',
            value: date === null || date === void 0 ? void 0 : date.toISOString(),
            path: '/shell:lastAccessDate'
        });
        return await this._doPatch(href, {
            'Content-Type': JSON_PATCH_MIME_TYPE,
            // Required for making future migration of these calls to Label Service smoother
            // https://wiki.corp.adobe.com/display/CSA/Proposal%3A+Personalized+Listing+Service+interaction+with+PUPA+Service
            // We need to notify clients to add the header in access-control-request-headers header
            'X-Metadata-Field': 'lastAccessDate'
        }, JSON.stringify(bodyData), [204]);
    }
    async runOperation(op) {
        const response = await this._rapi.runOperation(op);
        const { asset, error } = response[0];
        if (!(asset || error)) {
            throw SAMError.wrapErrorIfNeeded(SAMErrorCode.UNKNOWN, 'Missing Asset metadata in operation response', error);
        }
        else if (error) {
            throw error;
        }
        return response[0];
    }
    async runOperationWithEmptyResponse(op) {
        await this._rapi.runOperation(op);
    }
    async getRendition(size, type) {
        const renditionURL = getURLFromLinks(this._links, RelType.RENDITION, {
            size: String(size),
            type
        });
        const newURL = new URL(renditionURL);
        setURLSearchParams(newURL, { etag: this.etag });
        const response = await this._doGet(newURL.toString());
        return await response.blob();
    }
    /**
     * Use case: When clients need to fine tune the rendition requests for cases other than the lazy-load and cache
     * mechanism in SAM. Clients are responsible for
     *   1. Determining when these requests should be made – SAM will not attempt to automatically download renditions
     *      requested with this method when etag or whatnot changes
     *   2. Ensuring efficient use of server resources – clients should only make requests as needed and avoid papering
     *      over issues with repeated calls
     *   3. Parsing the Response – the image in the Response.body and any additional metadata embedded by the server
     *   4. Caching the response – clients will need to use URL.createObjectURL() to make the response usable to render
     *      in DOM. This causes the browser to keep the rendition in memory until they call URL.releaseObjectURL(url).
     *      Failing to do so could cause memory leaks. To fine-tune the browser caching behavior, clients will need to
     *      set explicit caching headers in the `additionalHeaders` parameter rather than relying on adding
     *      cache-busting fake parameters to the URL.
     *
     * SAM.js will
     *   1. Get the correct URL template for the AdobeAsset or AssetVersion and fill it with metadata from the
     *      Asset/Version, plus additional data from `urlTemplateOptions`
     *   2. Add the API key and auth token headers, as well as additional headers specified in `additionalHeaders`
     *   3. Handle some auto-retries for error responses
     *   4. Reject with SAMError if there is a service error that can't be resolved with retry
     *
     * @param size
     * @param type
     * @param urlTemplateOptions
     * @param additionalHeaders
     */
    async getCustomRendition({ size = THUMBNAIL_SIZE, type = RenditionType.PNG, urlTemplateOptions = {}, additionalHeaders }) {
        const url = getURLFromLinks(this._links, RelType.RENDITION, Object.assign({ size: String(size), type }, urlTemplateOptions));
        return await this._doGet(url, { headers: additionalHeaders });
    }
    /**
     * Clients may have a requirement to get the JSON object describing all the available sizes, rather than returning
     * a JSON object describing only the specified size. Especially useful in case of fetching rendition resource of
     * type "application/vnd.adobe.ccv.videometadata" for video assets
     * @param type
     * @param urlTemplateOptions
     * @param additionalHeaders
     */
    async getAllCustomRenditions({ type, urlTemplateOptions = {}, additionalHeaders }) {
        const url = type ? getURLFromLinks(this._links, RelType.RENDITION, Object.assign({ type }, urlTemplateOptions)) : getURLFromLinks(this._links, RelType.RENDITION, Object.assign({}, urlTemplateOptions));
        return await this._doGet(url, { headers: additionalHeaders });
    }
    async getAccessControlList() {
        const accessControlHref = getURLFromLinks(this._links, RelType.AC_POLICY);
        const response = await this._doGet(accessControlHref, {
            headers: {
                'Content-Type': 'application/vnd.adobecloud.policy+json',
                'If-Match': '*'
            }
        });
        const responseJson = await response.json();
        const accessControlResponse = {
            'etag': response.headers.get('ETag') || '',
            'repo:acl': responseJson['repo:acl']
        };
        return accessControlResponse;
    }
    /**
     * @pacakge - used internally
     */
    _getACPatchData(ace) {
        return {
            'repo:principal': ace.principal,
            'repo:privileges': ace.privileges,
            'repo:modifier': ace.modifier,
            'repo:inheritance': ace.inheritance,
            'repo:relations': ace.relations
        };
    }
    async addAccessControlEntries(aces, aclEtag) {
        const acesJSONPatch = aces.map((ace) => {
            return {
                op: 'add',
                path: `/repo:acl/-`,
                value: this._getACPatchData(ace)
            };
        });
        await this._patchACL(acesJSONPatch, aclEtag);
    }
    async updateAccessControlList(aces, aclEtag) {
        const acesJSONPatch = aces.map((ace) => {
            return {
                op: 'replace',
                path: `/repo:acl/${ace.id}`,
                value: this._getACPatchData(ace)
            };
        });
        await this._patchACL(acesJSONPatch, aclEtag);
    }
    async deleteAccessControlEntries(aces, aclEtag) {
        const acesJSONPatch = aces.map((ace) => {
            return {
                op: 'remove',
                path: `/repo:acl/${ace.id}`,
                value: this._getACPatchData(ace)
            };
        });
        await this._patchACL(acesJSONPatch, aclEtag);
    }
    async setEditingInheritanceRestricted(restrictEdit, addCurrentUserAsEditor) {
        // API documentation: https://developers.corp.adobe.com/acp/acl-front-service/documentation/src/main/docs/swagger.json#operation/jsonPatchPolicy
        const userId = this._core._environment.getValue('USER_ID');
        if (restrictEdit) {
            // NOTE: attempting to add these ACEs when they are already set has no effect
            const addPatches = [{
                    op: 'add',
                    // Index for 'add' probably doesn't matter
                    path: '/repo:acl/0',
                    value: DENY_EDIT_ACE
                }, {
                    op: 'add',
                    path: '/repo:acl/1',
                    value: DENY_SHARE_ACE
                }];
            if (addCurrentUserAsEditor) {
                const userACEs = getRestrictEditUserGrantACEs(userId);
                addPatches.push({ op: 'add', path: '/repo:acl/2', value: userACEs[0] });
                addPatches.push({ op: 'add', path: '/repo:acl/3', value: userACEs[1] });
            }
            await this._patchACL(addPatches);
        }
        else {
            // Find the index of the deny ACEs. This is critical to ensure only the desired ACEs get removed.
            const { policyResponse, denyEditAceIndex, denyShareAceIndex } = await this._getEditingInheritanceRestrictedInfo();
            // If either or both ACE is missing, the toggle is not on
            if (denyEditAceIndex < 0 || denyShareAceIndex < 0) {
                return;
            }
            const removePatches = [{
                    op: 'remove',
                    path: `/repo:acl/${denyShareAceIndex}`
                }, {
                    op: 'remove',
                    path: `/repo:acl/${denyEditAceIndex}`
                }];
            // The patches must be sorted by index descending or else the wrong items will be removed, because they
            // are applied in order. If we have acl = [A, B, C] and try to remove index 0 before 1, it will first remove
            // A, making B be index 0; removing index 1 after that will erroneously remove C. Instead, removing 1 first
            // will result in [A, C] and then removing index 0 will leave the desired [C] remaining.
            removePatches.sort((ace1, ace2) => ace1.path < ace2.path ? 0 : -1);
            await this._patchACL(removePatches, policyResponse.headers.get('etag') || undefined);
        }
    }
    async _patchACL(patches, etag) {
        const url = getURLFromLinks(this._links, RelType.AC_POLICY);
        await this._doPatch(url, {
            'Content-Type': 'application/json-patch+json',
            'If-Match': etag
        }, JSON.stringify(patches), [200]);
    }
    async getEditingInheritanceRestricted() {
        const { denyEditAceIndex, denyShareAceIndex } = await this._getEditingInheritanceRestrictedInfo();
        // both must be present for the toggle to be on
        return denyEditAceIndex >= 0 && denyShareAceIndex >= 0;
    }
    async _getEditingInheritanceRestrictedInfo() {
        const policyResponse = await this.getAssetPolicy();
        const acl = (await policyResponse.json())['repo:acl'];
        // Note: array order does not matter. To count as being on, all properties in DENY_EDIT_ACE and DENY_SHARE_ACE
        // must be present, but additional properties can be present that are not in the constants.
        const denyEditAce = acl.find(ace => isDeepEqual(DENY_EDIT_ACE, ace, true, true));
        const denyShareAce = acl.find(ace => isDeepEqual(DENY_SHARE_ACE, ace, true, true));
        return {
            policyResponse,
            denyEditAceIndex: acl.indexOf(denyEditAce),
            denyShareAceIndex: acl.indexOf(denyShareAce)
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const shownWarnings = new Set();
/**
 * A utility logging function that warns a client once per page load using
 * the params provided by the caller.
 * @param topic
 * @param message
 */
function oneTimeWarning(topic, message) {
    if (shownWarnings.has(topic)) {
        return;
    }
    console.warn('One time warning (%s): %s', topic, message);
    shownWarnings.add(topic);
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Simplfies cases where a Promise needs to be resolved or rejected externally from the Promise itself.
 */
class ManagedPromise {
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}

const $LAZY_LOAD_MANAGERS = Symbol('$LAZY_LOAD_MANAGERS');
var LoadStatus;
(function (LoadStatus) {
    LoadStatus[LoadStatus["NotLoaded"] = 1] = "NotLoaded";
    LoadStatus[LoadStatus["Pending"] = 2] = "Pending";
    LoadStatus[LoadStatus["Loading"] = 3] = "Loading";
    LoadStatus[LoadStatus["Loaded"] = 4] = "Loaded";
    LoadStatus[LoadStatus["Error"] = 5] = "Error";
})(LoadStatus || (LoadStatus = {}));
const MAX_RETRIES = 5;
const FETCH_START_DELAY_MS = 100;
/**
 * For managing lazy loading of data throughout SAM.js in a consistent manner. This involves
 *
 * 1. A new custom event for the data that is lazily fetched should be created. While it can work with the default
 *    'change' event, using a custom event will allow SAM.js to track what lazy-loaded data is actively being
 *    monitored by clients so that it only fetches when necessary.
 * 2. The class that has lazy-loaded data should call static method LazyLoadManager.manageLazyLoading() to instantiate
 *    the LazyLoadManager(s) and annotate the getters for the lazy-loaded data with @lazyLoaded
 *
 * @package -- only for use in SAM.js
 */
class LazyLoadManager {
    constructor({ target, event, fetchData, prefetchTimeout = FETCH_START_DELAY_MS, retryErrorTimeout = Number.POSITIVE_INFINITY, cancelFetchData, }) {
        this._loadStatus = LoadStatus.NotLoaded;
        this._prefetchTimeout = FETCH_START_DELAY_MS;
        this._retryErrorTimeout = Number.POSITIVE_INFINITY;
        this._retriesRemaining = MAX_RETRIES;
        this._onBecomeUnobserved = (eventName) => {
            if (eventName !== this._event.type) {
                return;
            }
            if (this._loadStatus === LoadStatus.Pending) {
                this._prefetchResolve(true);
                return;
            }
            // Only cancel fetching if it is loading and there is a way to do it
            if (this._loadStatus === LoadStatus.Loading && this._cancelFetchData) {
                // _cancelFetchData returns true if cancel succeeds
                if (this._cancelFetchData.call(this._target)) {
                    this.setLoadStatus(LoadStatus.NotLoaded);
                }
            }
        };
        this._target = target;
        this._event = event;
        this._fetchData = fetchData;
        this._prefetchTimeout = prefetchTimeout;
        this._retryErrorTimeout = retryErrorTimeout;
        this._cancelFetchData = cancelFetchData;
        this._target.on(BECOME_UNOBSERVED, this._onBecomeUnobserved);
    }
    /**
     * Ideal way for client classes to instantiate LazyLoadManager(s)
     *
     * @example```ts
     * class MyClass extends SAMObjectEventEmitter {
     *    private _lazyLoadVal?: number;
     *
     *    constructor() {
     *        LazyLoadManager.manageLazyLoading(this, [{
     *            event: MyEventInstance,
     *            fetchData: this._fetchData
     *        }]);
     *    }
     *
     *    @lazyLoaded(MyEventInstance, '_lazyLoadVal')
     *    get lazyLoadVal(): number | undefined {
     *        return this._lazyLoadVal;
     *    }
     *
     *    private async _fetchData(): void {
     *        this._lazyLoadValue = await this._core.someContext.fetchData();
     *    }
     * }
     *```
     * @param {SAMObjectEventEmitter} target  the class instance that has lazy-loaded data to manage
     * @param {ILazyLoadConfig[]} configs the config for each LazyLoadManager
     */
    static manageLazyLoading(target, configs) {
        const instance = target;
        instance[$LAZY_LOAD_MANAGERS] = instance[$LAZY_LOAD_MANAGERS] || new Map();
        configs.forEach((cfg) => {
            const manager = new LazyLoadManager(Object.assign({ target: instance }, cfg));
            instance[$LAZY_LOAD_MANAGERS].set(cfg.event, manager);
        });
    }
    /**
     * Primarily for internal use/testing. Finds the relevant LazyLoadManager for a specific event (by name or
     * by shared SAMEvent instance).
     *
     * @param target {SAMObjectEventEmitter} the class instance that has lazy-loaded data to manage
     * @param event {IEvent|string} the SAMEvent instance or name
     */
    static getManager(target, event) {
        const map = target[$LAZY_LOAD_MANAGERS];
        let foundEvent;
        if (typeof event === 'string') {
            foundEvent = [...map.keys()].find(e => e.type === event);
        }
        else {
            foundEvent = event;
        }
        const manager = map.get(foundEvent);
        if (!manager) {
            throw new Error(`Target does not have a LazyLoadManager for event ${event}`);
        }
        return manager;
    }
    /**
     * For external code to check if a LazyLoadManager exists for a specific event.
     * @param target {SAMObjectEventEmitter} the class instance that has lazy-loaded data to manage
     * @param event {IEvent|string} the SAMEvent instance or name
     */
    static hasManager(target, event) {
        try {
            return LazyLoadManager.getManager(target, event) !== undefined;
        }
        catch (e) {
            return false;
        }
    }
    /**
     * Used by code outside the _fetchData method that needs to modify the loadStatus.
     *
     * @param target {SAMObjectEventEmitter} the target instance that has lazy-loaded data
     * @param event {string | IEvent} the event name or instance tied to the lazy-loaded data
     * @param loadStatus {LoadStatus} the new LoadStatus
     */
    static setLoadStatus(target, event, loadStatus) {
        const manager = LazyLoadManager.getManager(target, event);
        manager.setLoadStatus(loadStatus);
    }
    /**
     * For external code to check load status.
     *
     * @param target {SAMObjectEventEmitter} the target instance that has lazy-loaded data
     * @param event {string | IEvent} the event name tied to the lazy-loaded data
     * @return LoadStatus
     */
    static getLoadStatus(target, event) {
        const manager = LazyLoadManager.getManager(target, event);
        return manager.loadStatus;
    }
    static fetchIfNeeded(target, event) {
        const manager = LazyLoadManager.getManager(target, event);
        return manager.fetchIfNeeded();
    }
    /**
     * For cases where code modifies the lazy-load data outside of fetching. Ensures the correct LoadStatus is set and
     * the appropriate event is fired.
     *
     * @param target {SAMObjectEventEmitter} the target instance that has lazy-loaded data
     * @param event {string | IEvent} the event name or instance tied to the lazy-loaded data
     */
    static updatedExternally(target, event) {
        const manager = LazyLoadManager.getManager(target, event);
        manager.updatedExternally();
    }
    /**
     * For cases where an ItemUpdater is used where it is guaranteed that the lazy-loaded data is
     * now up-to-date, so only the load status needs updating, and no events need to be fired
     * because UpdateSession.commit() was just called or will soon be called.
     *
     * @param target {SAMObjectEventEmitter} the target instance that has lazy-loaded data
     * @param event {string | IEvent} the event name or instance tied to the lazy-loaded data
     */
    static updatedByItemUpdater(target, event) {
        const manager = LazyLoadManager.getManager(target, event);
        manager.updatedByItemUpdater();
    }
    get loadStatus() {
        return this._loadStatus;
    }
    async _prefetchDelay() {
        return new Promise((resolve) => {
            this._prefetchResolve = resolve;
            this.setLoadStatus(LoadStatus.Pending);
            setTimeout(() => {
                resolve(false);
                this._prefetchResolve = undefined;
            }, this._prefetchTimeout);
        });
    }
    onPropertyAccess() {
        this.fetchIfNeeded();
    }
    // Fetch data, set load status, and emit event
    async fetchIfNeeded() {
        var _a;
        if (this._loadStatus === LoadStatus.NotLoaded) {
            this._pendingFetchPromise = new ManagedPromise();
            if (this._prefetchTimeout) {
                const cancelled = await this._prefetchDelay();
                if (cancelled) {
                    this.setLoadStatus(LoadStatus.NotLoaded);
                    this._pendingFetchPromise.resolve();
                    return;
                }
            }
            try {
                this._loadStatus = LoadStatus.Loading;
                // Note: uses `call` for better memory footprint. That way, the _fetchData implementation can be a
                // single instance of a function on the class prototype, rather than a method bound (via `=>` or
                // `.bind()`) on each instance of the class.
                await this._fetchData.call(this._target);
                // Don't transition to Loaded if it was cancelled
                if (this._loadStatus === LoadStatus.Loading) {
                    this.setLoadStatus(LoadStatus.Loaded);
                    this._pendingFetchPromise.resolve();
                }
            }
            catch (e) {
                this.setLoadStatus(LoadStatus.Error);
                // Rejecting here seems to cause an unhandled error that prevents tests from working,
                // but might cause runtime issues as well. For now, it's up to the client to check
                // for error status if they're expecting that the fetch succeeded.
                this._pendingFetchPromise.resolve();
            }
        }
        await ((_a = this._pendingFetchPromise) === null || _a === void 0 ? void 0 : _a.promise);
    }
    // Set load status and emit event
    setLoadStatus(loadStatus) {
        if (this._loadStatus === loadStatus) {
            return;
        }
        this._loadStatus = loadStatus;
        // Transitioning to NotLoaded means the data still needs to be loaded, so listeners should be notified so
        // they can trigger lazy-loading if they want.
        if (loadStatus === LoadStatus.NotLoaded || loadStatus === LoadStatus.Loaded) {
            // Reset remaining retries on successful load
            if (loadStatus === LoadStatus.Loaded) {
                this._retriesRemaining = MAX_RETRIES;
            }
            this._target.dispatch(this._event);
        }
        else if (loadStatus === LoadStatus.Error
            && this._retryErrorTimeout < Number.POSITIVE_INFINITY
            && this._retriesRemaining > 0) {
            // If retry-able, wait the designated time and then set back to NotLoaded, which will notify clients
            // so they can kick-off lazy loading again if desired
            setTimeout(() => {
                this._retriesRemaining--;
                if (this._loadStatus === LoadStatus.Error) {
                    this.setLoadStatus(LoadStatus.NotLoaded);
                }
            }, this._retryErrorTimeout);
        }
    }
    /**
     * For cases when something updates lazy-loaded data outside of a lazy-load fetch (such as mutating the value of a
     * field as part of a service operation), where the event must be fired and the loadStatus should be set to Loaded
     */
    updatedExternally() {
        if (this._loadStatus !== LoadStatus.Loaded) {
            // setLoadStatus will fire the event
            this.setLoadStatus(LoadStatus.Loaded);
        }
        else {
            this._target.dispatch(this._event);
        }
    }
    /**
     *  @see LazyLoadManager.updateByItemUpdater
     */
    updatedByItemUpdater() {
        if (this._loadStatus === LoadStatus.Pending) {
            this._prefetchResolve(true); // cancel fetch
        }
        // It should now be safe to change to Loaded:
        // LoadStatus.Pending -- the prefetchDelay was cancelled above
        // LoadStatus.NotLoaded -- nothing is happening asynchronously
        // LoadStatus.Error -- if a retry timer is pending, it will not retry b/c the status
        //      will be Loaded
        // LoadStatus.Loading -- when the fetch completes, it will not fire a duplicate event
        //      b/c the status will already be Loaded
        this._loadStatus = LoadStatus.Loaded;
    }
}
/**
 * Annotation for marking a getter as the entry point for clients to access lazy-loaded fields, which
 * makes them observed and starts lazy-loading if needed.
 *
 * @param event {IEvent} the event instance that will be fired when the lazy-loaded data changes
 * @param privatePropNames {string[]} an array of the private property names that the annotated getter references.
 *        When ItemUpdater modifies one of these private fields, it will fire the event specified, rather than the
 *        default event for the ItemUpdater.
 */
function lazyLoaded(event, privatePropNames) {
    return function (target, key, descriptor) {
        if (descriptor.get) {
            const getter = descriptor.get;
            descriptor.get = function () {
                const manager = LazyLoadManager.getManager(this, event);
                if (!manager) {
                    throw new Error(`@lazyLoaded target is missing LazyLoadManager for event ${event.type}. Use`
                        + ' LazyLoadManager.manageLazyLoading() in constructor to configure');
                }
                manager.onPropertyAccess();
                return getter.call(this);
            };
        }
        else if (typeof descriptor.value === 'function') {
            const method = descriptor.value;
            const newMethod = function (...args) {
                const manager = LazyLoadManager.getManager(this, event);
                if (!manager) {
                    throw new Error(`@lazyLoaded target is missing LazyLoadManager for event ${event.type}. Use`
                        + ' LazyLoadManager.manageLazyLoading() in constructor to configure');
                }
                manager.onPropertyAccess();
                return method.apply(this, args);
            };
            descriptor.value = newMethod;
        }
        else {
            throw new Error('@lazyLoaded only works with getters and methods');
        }
        // layer @observable on top of @lazyLoaded
        privatePropNames = [].concat(privatePropNames);
        observableImpl(event, privatePropNames)(target, key, descriptor);
    };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ShareableItem extends ItemBase {
    constructor(core, id) {
        super(core, id);
        this._collaboratorsArray = [];
        this._shareFlagsAreDirty = true;
        this._itemPoolDelegate = {
            onItemsUpdated: () => {
                this._setCollaboratorData();
                // This code path is not governed by LazyLoadManager, but LLM still needs to be informed of the update.
                LazyLoadManager.updatedExternally(this, SharedCollaboratorChangedEvent);
            }
        };
        LazyLoadManager.manageLazyLoading(this, [{
                event: SharedCollaboratorChangedEvent,
                fetchData: this._queueCollaborators,
                prefetchTimeout: 0,
                cancelFetchData: this._dequeueCollaborators
            }]);
    }
    get isShared() {
        this._fetchShareFlagsIfNeeded();
        return this._isShared;
    }
    get isSharedWithYouAsset() {
        this._fetchShareFlagsIfNeeded();
        return this._isSharedWithYouAsset;
    }
    get directCollaboratorCount() {
        this._fetchShareFlagsIfNeeded();
        return this._directCollaboratorCount;
    }
    get isPublicLink() {
        this._fetchShareFlagsIfNeeded();
        return this._isPublicLink;
    }
    /**
     * @package, used internally by filters, tests, etc.
     */
    get _isSWYAsset_NoLazyLoad() {
        return this._isSharedWithYouAsset;
    }
    /**
     * @package, used internally by filters, tests, etc.
     */
    get _isShared_NoLazyLoad() {
        return this._isShared;
    }
    /**
     * @package, used internally by filters, tests, etc.
     */
    get _directCollaboratorCount_NoLazyLoad() {
        return this._directCollaboratorCount;
    }
    /**
     * @package, used internally by filters, tests, etc.
     */
    get _isPublicLink_NoLazyLoad() {
        return this._isPublicLink;
    }
    /**
     * @deprecated Please use isSharedWithYouAsset -- will be removed on or after 2024-10-01
     */
    get isSharedWithMe() {
        oneTimeWarning('isSharedWithMe', 'isSharedWithMe is deprecated and will be removed on or after'
            + ' 2024-10-01. Please use isSharedWithYouAsset instead.');
        return this.isSharedWithYouAsset;
    }
    /**
     * @package -- used internally to check if collaborator data has been lazy-loaded without triggering lazy-loading.
     */
    get _isCollaboratorDataLoaded() {
        return LazyLoadManager.getLoadStatus(this, SharedCollaboratorChangedEvent.type) === LoadStatus.Loaded;
    }
    _fetchShareFlagsIfNeeded() {
        if (this._shareFlagsAreDirty) {
            LazyLoadManager.fetchIfNeeded(this, SharedCollaboratorChangedEvent);
        }
    }
    /**
     * @package used internally.
     */
    _queueCollaborators() {
        return this._core.collaborationContext._collaboratorRequestQueue.enqueue(this);
    }
    _dequeueCollaborators() {
        return this._core.collaborationContext._collaboratorRequestQueue.dequeue(this);
    }
    get collaboratorArray() {
        return this._collaboratorsArray;
    }
    get collaborators() {
        if (!this._collaboratorSources) {
            this._collaboratorSources = this._core.collaborationContext._getCollaboratorSources(this.id);
            this._collaboratorSources.collaboratorPool.addDelegate(this._itemPoolDelegate, 'context');
        }
        return this._collaboratorSources.collaboratorSource;
    }
    async removeCollaborator(collaborator) {
        await this._core.collaborationContext._removeCollaborator(this.id, collaborator);
    }
    async removeCurrentUserFromCollaborationList() {
        return this._core.collaborationContext._removeCurrentUserFromCollaborationList(this);
    }
    async createPublicLink(canComment = true) {
        const publicLinkCollaborator = {
            recipient: 'all',
            role: 'viewer',
            canShare: false,
            canComment
        };
        this._core.collaborationContext._addCollaborators(this.id, [publicLinkCollaborator]);
    }
    async removePublicLink() {
        if (!this._isCollaboratorDataLoaded) {
            // Queue up fetching collaborators
            await this._queueCollaborators();
            await new Promise((resolve) => {
                this.on(COLLABORATOR_CHANGED, () => {
                    // check that the data has loaded again in case there is some other
                    // field loading that finished first and fired this event.
                    if (this._isCollaboratorDataLoaded) {
                        resolve();
                    }
                });
            });
        }
        const predefinedPrincipal = this.collaboratorArray.find(collaborator => collaborator.id === 'all');
        if (predefinedPrincipal) {
            this._core.collaborationContext._removeCollaborator(this.id, predefinedPrincipal);
        }
    }
    /**
     * @TODO_Deprecation -- will be marked deprecated on or after 2024-10-01, and removed on or after 2025-01-01.
     *   Only used in admin console for managing Teams, which is already deprecated.
     *
     * @returns {InvitedCollaboratorSource}
     */
    get invitedCollaborators() {
        if (!this._collaboratorSources) {
            this._collaboratorSources = this._core.collaborationContext._getCollaboratorSources(this.id);
        }
        return this._collaboratorSources.invitedCollaboratorSource;
    }
    /**
     * @TODO_Deprecation -- will be marked deprecated on or after 2024-10-01, and removed on or after 2025-01-01.
     *   Only used in admin console for managing Teams, which is already deprecated.
     *
     * @param {InvitedCollaborator} invitedCollaborator
     * @returns {Promise<void>}
     */
    removeInvitedCollaborator(invitedCollaborator) {
        return this._core.collaborationContext.removeInvitedCollaborator(this.id, invitedCollaborator);
    }
    /**
     * @package Internal use only
     *
     * @param sources
     * @param collaborators
     */
    _setCollaboratorData(collaborators) {
        this._collaboratorSources = this._core.collaborationContext._getCollaboratorSources(this.id);
        const collaboratorItemPool = this._collaboratorSources.collaboratorPool;
        this._collaboratorsArray = collaborators !== null && collaborators !== void 0 ? collaborators : collaboratorItemPool.toArray();
        this._shareFlagsAreDirty = false;
        // set the isShared flag. The collaborators array contains the owner of the asset
        // as well the organization that owns the asset.
        // We use the isDirect flag to determine if the asset is explicitly shared or not.
        this._isShared = this._collaboratorsArray.some((collaborator) => {
            return collaborator.isDirect;
        });
        // set the isSharedWithYouAsset flag
        const isCurrentUserDirectCollaborator = this._collaboratorsArray.some((collaborator) => {
            return collaborator.isDirect && collaborator.isCurrentUser;
        });
        this._isSharedWithYouAsset = this._isSWYGroup || isCurrentUserDirectCollaborator;
        // set the isPublicLink flag
        this._isPublicLink = this._collaboratorsArray.some((collaborator) => {
            return collaborator.id === 'all';
        });
        // calculate the number of direct collaborators
        this._directCollaboratorCount = this._collaboratorsArray.filter(collaborator => collaborator.isDirect).length;
    }
}
__decorate([
    observable$1(SharedCollaboratorChangedEvent, '_isShared')
], ShareableItem.prototype, "isShared", null);
__decorate([
    observable$1(SharedCollaboratorChangedEvent, '_isSharedWithYouAsset')
], ShareableItem.prototype, "isSharedWithYouAsset", null);
__decorate([
    observable$1(SharedCollaboratorChangedEvent, '_directCollaboratorCount')
], ShareableItem.prototype, "directCollaboratorCount", null);
__decorate([
    observable$1(SharedCollaboratorChangedEvent, '_isPublicLink')
], ShareableItem.prototype, "isPublicLink", null);
__decorate([
    lazyLoaded(SharedCollaboratorChangedEvent, '_collaboratorsArray')
], ShareableItem.prototype, "collaboratorArray", null);
__decorate([
    memoize$1
], ShareableItem.prototype, "collaborators", null);
__decorate([
    memoize$1
], ShareableItem.prototype, "invitedCollaborators", null);

/**
 * A Resource for a specific AdobeAsset, which only revalidates requests if ONS is inactive.
 * The resource's associated asset may be set after initialization.
 */
class AdobeAssetResource extends Resource {
    constructor(_core, _parent, options = {}) {
        super(_core, Object.assign(Object.assign({}, options), { 
            // If ONS is active and this resource is attached to a parent asset,
            // we can skip revalidation because ONS will notify us of any changes.
            // Any assets in the pool should either be monitored directly with ONS
            // or through the watch on their parent directory.
            skipRevalidation: () => { var _a; return Boolean(this._parent && ((_a = this._core.hostAssetContext.onsContext) === null || _a === void 0 ? void 0 : _a.isActive)); } }));
        this._core = _core;
        this._parent = _parent;
        this._parent = _parent;
    }
    /** Set the parent asset for this resource. */
    setParent(parentAsset) {
        this._parent = parentAsset;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class EmbeddedMetadataResource extends AdobeAssetResource {
    constructor(_core, _parent) {
        super(_core, _parent, {
            onError: async (error) => {
                if (error.code === SAMErrorCode.NOT_FOUND) {
                    // If an asset doesn't have embedded metadata, just return empty metadata rather than
                    // treating it as a failure.
                    await this._setData({});
                }
            }
        });
        this._core = _core;
        this._parent = _parent;
    }
    async _loadData() {
        await this._parent._ensureLink(RelType.EMBEDDED_METADATA);
        const assetInterface = await this._parent._getAssetInterface();
        await assetInterface.getEmbeddedMetadata(this);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AppMetadataResource extends AdobeAssetResource {
    constructor(_core, _parent) {
        super(_core, _parent, {
            onError: async (error) => {
                if (error.code === SAMErrorCode.NOT_FOUND) {
                    // If an asset doesn't have app metadata, just return empty metadata rather than
                    // treating it as a failure. (Setting the data here clears the error.)
                    await this._setData({});
                }
            }
        });
        this._core = _core;
    }
    /*
        A note regarding the following commented code:

        While the code below is what we want, the issue is that, at the time load() is being called,
        the parent's permissions have not been set yet.

        In AdobeAsset _load(), the permissions are updated by AdobeAssetUpdater.updateLocalItem at the end,
        but AppMetadataResource/load() is being called by await Promise.all(resourcesToReload.map(resource => resource.load()));
        that happens before.

        As long as we do not have a better mechanism to handle the permissions, we have to unsatisfy this request from
        https://jira.corp.adobe.com/browse/SAM-3326:

        6. Update `AppMetadataResource._loadData()` to check the permission on the parent, and if it does not have Permission.ReadAppMetadata, throw ACCESS_DENIED error instead of making the call.
    */
    // async load() {
    //     if (this._parent.hasPermission(Permission.ReadAppMetadata)) {
    //         await super.load();
    //     } else {
    //         throw SAMErrorCode.ACCESS_DENIED;
    //     }
    // }
    async _loadData() {
        var _a, _b;
        await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._ensureLink(RelType.APP_METADATA));
        const assetInterface = await ((_b = this._parent) === null || _b === void 0 ? void 0 : _b._getAssetInterface());
        await (assetInterface === null || assetInterface === void 0 ? void 0 : assetInterface.getAppMetadata(this));
    }
    /**
     * @package to be used internally by SAM.js
     */
    async _patch(patches) {
        var _a, _b;
        // TODO: check for graphQL
        await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._ensureLink(RelType.APP_METADATA));
        const assetInterface = await ((_b = this._parent) === null || _b === void 0 ? void 0 : _b._getAssetInterface());
        await (assetInterface === null || assetInterface === void 0 ? void 0 : assetInterface.patchAppMetadata(patches));
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// ManifestResource is a Resource that represents the manifest of an AdobeAsset or AssetVersion.
class ManifestResource extends Resource {
    constructor(_core, _parent) {
        super(_core);
        this._core = _core;
        this._parent = _parent;
    }
    async _loadData() {
        // TODO: check for graphQL
        const assetInterface = await this._parent._getAssetInterface();
        await assetInterface.getManifest(this);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const AssetClassChoices = ['file', 'composite', 'directory', 'entity', 'element'];
const AssetStateChoices = ['ACTIVE', 'DISCARDED', 'DISCARDED_PARENT'];
var MoveWarning;
(function (MoveWarning) {
    MoveWarning[MoveWarning["None"] = 0] = "None";
    MoveWarning[MoveWarning["CollaboratorMaybeEditing"] = 1] = "CollaboratorMaybeEditing";
    MoveWarning[MoveWarning["OwnerChange"] = 2] = "OwnerChange";
})(MoveWarning || (MoveWarning = {}));
var CannotMoveReason;
(function (CannotMoveReason) {
    CannotMoveReason[CannotMoveReason["DifferentOwner"] = 1] = "DifferentOwner";
    CannotMoveReason[CannotMoveReason["PermissionDeniedDestination"] = 2] = "PermissionDeniedDestination";
    CannotMoveReason[CannotMoveReason["PermissionDeniedSource"] = 3] = "PermissionDeniedSource";
    CannotMoveReason[CannotMoveReason["NotAFolder"] = 4] = "NotAFolder";
    CannotMoveReason[CannotMoveReason["CrossBucketMoveDisabled"] = 5] = "CrossBucketMoveDisabled";
})(CannotMoveReason || (CannotMoveReason = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class LocalItemUpdater {
    constructor(options) {
        this._propertyUpdater = options.propertyUpdater;
        this._changeEvent = options.changeEvent || SharedChangeEvent;
        this._changeEventsMap = options.changeEventMap;
    }
    /**
     * Update the local item with values from the remote item.
     * @param localItem
     * @param remoteItem
     */
    updateLocalItem(updateSession, localItem, remoteItem) {
        if (!updateSession.checkIfItemAllowsMutations(localItem)) {
            // The item had local changes that we don't want to overwrite because
            // the server might not yet be consistent with the change.
            return;
        }
        // If the item is not already added, add it to the list.
        updateSession.ensureItemIsAdded(localItem);
        const changedFields = this._propertyUpdater.update(localItem, remoteItem);
        const changeEvents = new Set(changedFields
            .map(changedProperty => {
            var _a, _b, _c;
            return (_c = (_b = (_a = this._changeEventsMap) === null || _a === void 0 ? void 0 : _a.get(changedProperty)) !== null && _b !== void 0 ? _b : getEventForProp(localItem, changedProperty)) !== null && _c !== void 0 ? _c : this._changeEvent;
        }));
        if (changedFields.length) {
            updateSession.queueChangedItem(localItem, [...changeEvents]);
        }
    }
}
// Adds on remote id and placeholder ("alternate") id handling to the LocalItemUpdater
class ItemUpdaterBase extends LocalItemUpdater {
    constructor(options) {
        super(options);
        this._localItemType = options.localItemType;
        this._getRemoteId = options.getRemoteId;
        this._getAlternateId = options.getAlternateId || (() => undefined);
    }
    /**
     * If you have an instance of the item already (such `this` in the item class), use updateLocalItem directly.
     * If you don't, use this method to create a new instance of the item from the remote data and update it locally.
     */
    updateRemoteItem(updateSession, remoteItem // server response data
    ) {
        const id = this._getRemoteId(remoteItem);
        const altId = this._getAlternateId(remoteItem);
        if (!id && !altId) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'An ID or alternate ID must exist on the remote item structure.');
        }
        let localItem = id ? updateSession.getItemById(id) : undefined;
        // Item is not cached by primary ID so check if it has been cached by an alt ID
        if (!localItem && altId) {
            localItem = updateSession.getItemById(altId);
            if (localItem) {
                if (id) {
                    // Re-index cached item with its new preferred ID (altId was a placeholder)
                    updateSession.reindexItem(localItem, altId, id);
                }
            }
        }
        // Item is not cached at all so create a new instance
        if (!localItem) {
            const LocalItemType = this._localItemType;
            // The primary altId is the first ID in the array
            localItem = new LocalItemType(updateSession._core, id || altId);
        }
        // Inject remote data.
        this.updateLocalItem(updateSession, localItem, remoteItem);
        return localItem;
    }
    updateRemoteItems(updateSession, remoteItems) {
        if (!Array.isArray(remoteItems)) {
            // Invalid remote data provided.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid data received, expected list of items.');
        }
        return remoteItems.map((remoteItem) => this.updateRemoteItem(updateSession, remoteItem));
    }
}
// Adds the ability to customize the remote id property that is used to get the remote id to ItemUpdaterBase
class ItemUpdater extends ItemUpdaterBase {
    constructor(options) {
        super(Object.assign({
            getRemoteId(remoteItem) {
                // The generic types in TS are not lazy evaluated, so TS will try to resolve this based entirely
                // on the constraints added to the generic type. Maybe one day TS will be able to evaluate
                // based on the actual interface that is passed as the `RemoteType` and we could fix this model.
                // As a result, we have use `any` because TS doesn't know the type of the generic RemoteType.
                return remoteItem[options.remoteIdProperty];
            },
        }, options));
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const NotFound = Symbol('NotFound');
const formats = {
    string: {
        // In general, parse strings as strings, but special case null's as undefined, and undefined's as undefined since String() will convert them to "undefined".
        parse: (value) => (value === null) || (value === undefined) ? undefined : String(value),
        isEqual: isStrictEqual
    },
    number: {
        parse: Number,
        isEqual: isStrictEqual
    },
    date: {
        parse: (value) => {
            if (value === null) {
                return undefined;
            }
            if (value === undefined || value instanceof Date) {
                return value;
            }
            return new Date(String(value));
        },
        isEqual: (a, b) => (a === null || a === void 0 ? void 0 : a.toISOString()) === (b === null || b === void 0 ? void 0 : b.toISOString())
    },
    // Some APIs like the invitation service return dates as a number (Unix epoch time) rather than a string
    // These still map onto the JS Date object, but need to be parsed differently.
    date_as_number: {
        parse: (value) => value === undefined ? undefined : new Date(Number(value)),
        isEqual: (a, b) => (a === null || a === void 0 ? void 0 : a.toISOString()) === (b === null || b === void 0 ? void 0 : b.toISOString())
    },
    // Support actual booleans, the string 'true', or non-zero numbers.
    boolean: {
        parse: (value) => value === true
            || (typeof value === 'string' && value.toLowerCase() === 'true')
            || (typeof value === 'number' && Boolean(value)),
        isEqual: isStrictEqual
    },
    object: {
        // Make a deep copy of the object if it is defined.
        parse: (value) => value !== undefined ? deepClone(value) : undefined,
        isEqual: isDeepEqual
    },
    // Sometimes the source data is only going to be merged into the destination property, so
    // comparison only needs to happen among the top-level keys that are present in the source.
    object_subset: {
        parse: deepClone,
        isEqual(destObj, sourceObj) {
            // if both are undefined, then they are equal
            if (destObj === sourceObj) {
                return true;
            }
            // if destObj is undefined, then it can be overwritten with sourceObj
            // NOTE: sourceObj is expected to not be undefined because JSON doesn't support undefined properties,
            // and so will get skipped since the sourceObj will be NotFound.
            if (destObj === undefined) {
                return false;
            }
            // Fix for https://jira.corp.adobe.com/browse/SHARED-2096
            //
            // Although we don't expect our servers to return null's,
            // we are receiving repometadata with :
            //   "_embedded": {
            //      "http://ns.adobe.com/adobecloud/rel/metadata/application": null
            //   }
            //
            // which reaches this code as (sourceObj === null),
            // which causes Object.keys(null) to throw
            //   TypeError: Cannot convert undefined or null to object
            //
            // The code below would return true for sourceObj = {},
            // so it makes sense to have an early return of true for sourceObj = null.
            //
            // NOTE: At the moment, the only client of 'object_subset' is '_appMetadata._data',
            // which would work with returning true ( the setter isn't invoked because sourceObj
            // isEqual() to the existing data ) or false ( the setter is invoked, but _mergeData(null)
            // is the same as _mergeData( {} ), which doesn't add anything to data ). The difference
            // is the setter would also emit('change') despite nothing changing.
            //
            // ALSO NOTE: Some servers might meaningfully provide (sourceObj === null) to have us
            // delete local data, but our server's don't, and if they did, our use of 'object_subset'
            // would have to be re-written to handle this as _mergeData(null) doesn't. But if they
            // did, we'd need to return false for this case. Until then, we're returning true
            // to avoid the unnecessary change event.
            if (!sourceObj) {
                return true;
            }
            const sourceKeys = Object.keys(sourceObj);
            const destObjSubset = sourceKeys.reduce((result, key) => {
                result[key] = destObj[key];
                return result;
            }, {});
            return isDeepEqual(destObjSubset, sourceObj);
        }
    }
};
const KEY_REGEXP = /([^.[]+)|(\[[^\]]+\])/g;
function getKeys(name) {
    const keys = name.match(KEY_REGEXP) || [];
    if (!keys.length) {
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Un-parseable key ${name}`);
    }
    const newKeys = keys.map(key => {
        // Remove brackets
        if (key[0] === '[' && key.slice(-1) === ']') {
            return key.slice(1, -1);
        }
        return key;
    });
    return newKeys;
}
function makeGetFn(name) {
    const keys = getKeys(name);
    return (source) => {
        let value = source;
        for (const key of keys) {
            if (!Object.prototype.hasOwnProperty.call(value, key)) {
                return NotFound;
            }
            value = value[key];
        }
        return value;
    };
}
function makeSetFn(name) {
    if (name.includes('.')) {
        // For complex properties of the Item being updated, assumptions can't be made about how to set them,
        // because some might be a class instance.
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Cannot use dot delimiter (${name}) without a custom setter`);
    }
    return (parsedSource, dest) => {
        dest[name] = parsedSource;
    };
}
function makeMergeSetFn(name) {
    if (name.includes('.')) {
        // For complex properties of the Item being updated, assumptions can't be made about how to set them,
        // because some might be a class instance.
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Cannot use dot delimiter (${name}) without a custom setter`);
    }
    return (parsedSource, dest) => {
        var _a;
        dest[name] = Object.assign(Object.assign({}, ((_a = dest[name]) !== null && _a !== void 0 ? _a : {})), (parsedSource !== null && parsedSource !== void 0 ? parsedSource : {}));
    };
}
function normalizeFormat(name, format, mapByKey) {
    if (!format) {
        // When we use mapByKey, the format is always an object as needs to have the actual mapByKey property.
        return mapByKey ? formats.object : formats.string;
    }
    if (typeof format === 'string') {
        if (!Object.prototype.hasOwnProperty.call(formats, format)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Unexpected type format ${format} for ${name} property updater.`);
        }
        return formats[format];
    }
    return format;
}
function normalizeType(key, type) {
    // When the property type is a simple string, then the source property is a simple
    // string parameter
    if (typeof type === 'string') {
        return {
            name: key,
            format: formats.string,
            get: makeGetFn(type),
            set: makeSetFn(key),
            isArray: false
        };
    }
    const { name, format, choices, get, set, isArray, mapByKey } = type;
    const sourceName = name !== null && name !== void 0 ? name : key;
    return {
        name: sourceName,
        format: normalizeFormat(sourceName, format, mapByKey),
        choices,
        mapByKey,
        isArray: isArray !== null && isArray !== void 0 ? isArray : false,
        get: get !== null && get !== void 0 ? get : makeGetFn(name !== null && name !== void 0 ? name : key),
        set: set !== null && set !== void 0 ? set : (format === 'object_subset' ? makeMergeSetFn(key) : makeSetFn(key))
    };
}
function validateValue(dest, name, choices, value) {
    if (choices && !choices.includes(value)) {
        dest._core._environment.error(`Invalid value ${value} passed for the ${name} property. Expected one of ${choices.join(', ')}.`);
        return false;
    }
    return true;
}
function createPropertyUpdater(key, userType) {
    const type = normalizeType(key, userType);
    const { name, format, choices, get, set, isArray, mapByKey } = type;
    return (dest, source) => {
        const anyDest = dest;
        const destValGetter = makeGetFn(key);
        // If the dest property does not exist, treat it as undefined so it can be updated
        // This prevents the `a.toISOString is not a function` error for date fields
        const destVal = (destValGetter(anyDest) === NotFound ? undefined : destValGetter(anyDest));
        let value = get(source, dest);
        if (value === NotFound) {
            return false;
        }
        if (mapByKey) {
            /**
             * The input value is just an array like the following example:
             *
             * [
             *     {
             *         name: 'working_files',
             *         id: 'urn:1'
             *     },
             *     {
             *         name: 'canvases',
             *         id: 'urn:2'
             *     }
             * ]
             *
             * The result will be a Map object like the following:
             *
             *  'working_files' => {
             *      name: 'working_files',
             *      id: 'urn:1'
             *  },
             *  'canvases' => {
             *      name: 'canvases',
             *      id: 'urn:1'
             *  },
             *
             * - In this case the 'name' property becomes the key of the map. The caller can change the key using the
             * `mapByKey` variable.
             * - The actual value of the map entries is just the object itself.
             * - This value can be customized using the `format.parse` function provided by the caller.
             * - The parsed value can be validated against a predefined list of `choices` provided by the caller.
             */
            if (!Array.isArray(value)) {
                dest._core._environment.error(`Invalid value ${value} passed for the ${name} property. Expected an array.`);
                return false;
            }
            const map = new Map();
            for (const item of value) {
                if (!Object.prototype.hasOwnProperty.call(item, mapByKey)) {
                    dest._core._environment.error(`Invalid item passed for the ${name} array property. Missing ${mapByKey} property on the item of the array.`);
                    continue;
                }
                const key = item[mapByKey];
                const parsedItem = format.parse(item);
                if (!validateValue(dest, name, choices, parsedItem)) {
                    continue;
                }
                map.set(key, parsedItem);
            }
            if (isDeepEqual(destVal, map)) {
                return false;
            }
            value = map;
        }
        else if (isArray) {
            if (!Array.isArray(value)) {
                dest._core._environment.error(`Invalid value ${value} passed for the ${name} property. Expected an array.`);
                return false;
            }
            // Arrays must make a copy of their initial content to avoid mutations
            // of the original array after the value is stored inside the object.
            const array = [];
            for (const item of value) {
                const parsedItem = format.parse(item);
                if (validateValue(dest, name, choices, parsedItem)) {
                    array.push(parsedItem);
                }
            }
            if (isDeepEqual(destVal, value)) {
                return false;
            }
            value = array;
        }
        else {
            value = format.parse(value);
            if (!validateValue(dest, name, choices, value)) {
                return false;
            }
            if (format.isEqual(destVal, value)) {
                return false;
            }
        }
        set(value, anyDest);
        return true;
    };
}
class PropertyUpdater {
    constructor(map) {
        this._updaters = Object.keys(map).map((key) => {
            return {
                updater: createPropertyUpdater(key, map[key]),
                key
            };
        });
    }
    update(dest, source) {
        const propertyChanges = [];
        for (const updateObj of this._updaters) {
            const { updater, key } = updateObj;
            if (updater(dest, source)) {
                propertyChanges.push(key);
            }
        }
        return propertyChanges;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Class for handling common filtering for AdobeAsset ItemSources. All implicit filters for AdobeAsset
 * should extend this class.
 */
class ImplicitAdobeAssetFilterBase {
    constructor(options) {
        this._isDiscarded = false;
        this._isPublished = false;
        this._isSharedWithYou = false;
        this._includeHiddenRecursive = false;
        this._includeHiddenRecursive = !!(options === null || options === void 0 ? void 0 : options._includeHiddenRecursive);
        this._isDiscarded = !!(options === null || options === void 0 ? void 0 : options._isDiscarded);
        this._isPublished = !!(options === null || options === void 0 ? void 0 : options._isPublished);
        this._isSharedWithYou = !!(options === null || options === void 0 ? void 0 : options._isSharedWithYou);
    }
    matches(item) {
        // If a Composite has zero size, it's probably an intermediate that is pending content, so
        // it should not be visible until the content is available. Client apps are responsible for cleaning
        // up Composites that never get content.
        // Typically, zero-byte composites are placeholders that should always be filtered out of listings.
        // However, new Libraries always have correct size from Melville, but sometimes the first ONS notification
        // does not reflect the Library contents being written yet. Allow zero-byte Libraries so that they
        // do not disappear & reappear in listings as the notifications settle.
        if (item.isComposite && item.sizeInBytes === 0 && !item.isLibrary) {
            return false;
        }
        if (item.isDiscarded !== this._isDiscarded) {
            return false;
        }
        if ((item._isSWYAsset_NoLazyLoad) && item._isSWYAsset_NoLazyLoad !== this._isSharedWithYou) {
            return false;
        }
        // Do not include children of directly discarded Assets in isDiscarded
        if (this._isDiscarded && item['_assetState'] === 'DISCARDED_PARENT') {
            return false;
        }
        if (item.isPublished !== this._isPublished) {
            return false;
        }
        // ONS subscriptions may cause loading of /cloud-content-archive or /archive when monitoring discardSource list
        // items but these folders should never appear in any list.
        if (item.repoPath === '/cloud-content-archive' || item.repoPath === '/archive') {
            return false;
        }
        // For all sources of AdobeAsset, the shellVisibility field dictates whether it can be seen in UI,
        // except for when items in hidden folders (hiddenRecursive) must be included.
        return !((item.shellVisibility === 'hiddenSelf' || (item.shellVisibility === 'hiddenRecursive' && !this._includeHiddenRecursive)));
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AdobeAssetSearchFilter extends ImplicitAdobeAssetFilterBase {
    constructor(options) {
        super();
        this._query = options === null || options === void 0 ? void 0 : options.query;
        this._deepSearch = options === null || options === void 0 ? void 0 : options.deepSearch;
        this._asset = options === null || options === void 0 ? void 0 : options.asset;
    }
    get deepSearch() {
        return this._deepSearch;
    }
    get asset() {
        return this._asset;
    }
    get query() {
        return this._query;
    }
    // The matching rules USS are deceptively complex, and could change over time. Attempting to
    // replicate here could result in items being incorrectly filtered out or incorrectly included.
    // Search Lists should not try to share items from Lists with similar queries, other
    // than treating the queries as case-insensitve.
    // TODO: Lists filtered with AdobeAssetSearchFilter currently take on unwanted items:
    // https://jira.corp.adobe.com/browse/SAM-3118
    matches(item) {
        // USS does not give repository id of an item. So compare repository id
        // only when it is available on both assets
        if (this.asset && this.asset.repositoryID && item.repositoryID
            && this.asset.repositoryID !== item.repositoryID) {
            return false;
        }
        // If asset is set, check whether item should belong this search or not based on
        // deep search. If deep search is true this asset should be container for incoming
        // item else this asset should be immediate parent of incoming asset
        if (this.asset && this.asset.repoPath && item.repoPath) {
            const assetRepoPath = this.asset.repoPath;
            if (this.deepSearch) {
                if (!item.repoPath.startsWith(pathBrowserify.join(assetRepoPath, '/'))) {
                    return false;
                }
            }
            else if (assetRepoPath !== item.repoPath.substring(0, item.repoPath.lastIndexOf('/'))) {
                return false;
            }
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function compareStrings(a, b) {
    return a.localeCompare(b);
}
function compareValues(a, b) {
    if (a === b) {
        return 0;
    }
    return a < b ? -1 : 1;
}
function reverseComparator(comparator) {
    return (a, b) => -comparator(a, b);
}
class ItemOrder {
    constructor(direction, field, comparator) {
        this.direction = direction;
        this.field = field;
        this.comparator = comparator;
    }
    get hash() {
        return this.direction + ':' + this.field;
    }
    sortItems(items) {
        items.sort(this.comparator);
    }
}
function createItemOrderFactory(comparatorMap) {
    return class extends ItemOrder {
        constructor(direction, field) {
            let comparator = comparatorMap[field];
            if (direction === 'descending') {
                comparator = reverseComparator(comparator);
            }
            super(direction, field, comparator);
        }
    };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToIAdobeAssetOrderBy = {
    'name': 'repo:name',
    'created': 'storage:deviceCreateDate',
    'modified': 'storage:deviceModifyDate',
    // R-API doesn't sort on share date
    'shared': 'storage:deviceModifyDate'
};
const OrderFieldToComparator$p = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    },
    modified(a, b) {
        return compareValues(a.modified, b.modified);
    },
    shared(a, b) {
        return compareValues(a.shared, b.shared);
    }
};
class AdobeAssetOrder extends createItemOrderFactory(OrderFieldToComparator$p) {
}
AdobeAssetOrder.default = new AdobeAssetOrder('descending', 'modified');

var AdobeAssetOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    OrderFieldToIAdobeAssetOrderBy: OrderFieldToIAdobeAssetOrderBy,
    'default': AdobeAssetOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const STORAGE_ASSIGNEE_CHANGED = 'storage_assignee_changed';
class StorageAssigneeChangedEvent extends SAMEvent {
    constructor() {
        super(STORAGE_ASSIGNEE_CHANGED);
    }
}
const SharedStorageAssigneeChangedEvent = new StorageAssigneeChangedEvent();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AdobeAssetDirectoryLoader {
    constructor(_assetPool, _asset, _core, _includePermissions, _loadLibraryData) {
        this._assetPool = _assetPool;
        this._asset = _asset;
        this._core = _core;
        this._includePermissions = _includePermissions;
        this._loadLibraryData = _loadLibraryData;
    }
    supportsFilter(filter) {
        // TODO: ?? can be undefined but can't be undefined ??
        return filter !== undefined;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, start) {
        const { order, limit, filter, implicitFilter, resource } = options;
        const mediaTypes = [...(('mediaTypes' in implicitFilter && implicitFilter['mediaTypes']) || ('mediaTypes' in filter && filter['mediaTypes'])
                || [])];
        /* Note: re-evaluate this after we have more data about the Project.libraries use case
         * We're currently calling for melville data for every page load.
         * We don't think it's a problem because it reduces code complexity and
         * we predict the standard use case to be just one page of libraries.
         * If that changes in future, we should re-evaluate this strategy.
         */
        let librariesDataPromise = undefined;
        if (this._loadLibraryData) {
            if (!this._asset.isProject) {
                throw SAMError.create(SAMErrorCode.UNSUPPORTED, `Asking for child libraries from non-project asset with id: ${this._asset.id}`);
            }
            else {
                // TODO [SHARED-975]: This doesn't fetch subsequent pages (max list of 50). Needs to go through the LibraryListLoader.
                librariesDataPromise = this._core.hostAssetContext._libraryInterface.getLibrariesForProject(this._asset.id);
            }
        }
        // We will ignore the update if we had local changes sooner than this timestamp.
        const latency = this._assetPool._core._environment.getValue('ASSETS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const embed = [{
                'resource': {
                    'reltype': RelType.APP_METADATA
                },
                'selectors': getRapiAppMetadataSelectors()
            }];
        if (this._includePermissions) {
            embed.push({
                'resource': {
                    'reltype': RelType.AC_EFFECTIVE
                }
            });
        }
        // SAM-3087: USS doesn't include PAGE link
        await this._asset._ensureLink(RelType.PAGE);
        const assetInterface = await this._asset._getAssetInterface();
        const rapiPage = await assetInterface.getChildAssets({
            orderBy: OrderFieldToIAdobeAssetOrderBy[order.field],
            orderDirection: order.direction,
            start,
            limit,
            type: mediaTypes,
            embed
        }, resource);
        // A "mutation" session is used here to track the time when a change is made to an Asset that is known to be
        // fresh (since it came from R-API). This helps avoid problems where fresh data from R-API gets overwritten by
        // stale data (e.g. from USS due to indexing lag). It also should use createLoaderMutationSession
        // (SAM-2973, SAM-3017).
        const session = this._assetPool.createLoaderMutationSession();
        if (this._asset.isProject) {
            // Update the project's children with the repo:ancestors from the parent project. This is to ensure that
            // the user's root and the project's root are included in the child's repo:ancestors. This is only an issue
            // for children of Project, so restricting this to only Projects.
            this._core.hostAssetContext._adobeAssetUpdater.updateLocalItem(session, this._asset, { 'repo:ancestors': rapiPage['repo:ancestors'] });
        }
        const libraryContext = await this._core.getLibraryContext();
        const items = this._core._adobeAssetFactory.assetsFromRepoMetadata(session, rapiPage.children.map((item) => {
            var _a;
            // Directory listings don't include repo:ancestors, but since we know the parent asset,
            // we can construct it based on the parent's repo:ancestors
            if (!item['repo:ancestors']) {
                item['repo:ancestors'] = [...((_a = this._asset.ancestorIDs) !== null && _a !== void 0 ? _a : []), this._asset.id];
            }
            return item;
        }), libraryContext);
        let librariesInPage;
        if (this._loadLibraryData) {
            librariesInPage = items.filter((item) => item.isLibrary);
            librariesInPage.forEach(library => library._setLibraryLoadState('LOADING'));
        }
        // Notify LLM that storageAssignee is loaded for entries that have it
        items.forEach(item => {
            if (item._storageAssignee_NoLazyLoad.id) {
                LazyLoadManager.updatedByItemUpdater(item, SharedStorageAssigneeChangedEvent);
            }
        });
        session.commit();
        if (this._loadLibraryData) {
            librariesDataPromise
                .then((librariesData) => this._updateLibrariesData(librariesInPage, librariesData));
        }
        // Check if we have another page to load.
        let loadNextPage;
        const nextStart = rapiPage._page.next;
        if (nextStart) {
            loadNextPage = (options) => this._loadPage(options, nextStart);
        }
        return {
            items,
            loadNextPage,
            mostRecentValidMutation
        };
    }
    // Libraries listing may have stale data due to USS indexing delays. Thus, this method
    // retrieves LibrarySpecificData from LibraryData, which is always safe to use as it will not overwrite RAPI data.
    // TODO [SHARED-902]: Move to LibraryUtils
    _getSafeLibraryData(libraryData) {
        if (!libraryData) {
            return {};
        }
        const { library_urn, id, bookmark, name, ownership, roles, rendition_grid } = libraryData;
        return { library_urn, id, bookmark, name, ownership, roles, rendition_grid };
    }
    /**
     * Given a set of libraries that have been loading, update their data and loading state with the data from Melville.
     */
    async _updateLibrariesData(librariesToUpdate, librariesData) {
        const session = this._core.hostAssetContext._assetPool.createUpdateSession();
        const libraryContext = await this._core.getLibraryContext();
        librariesToUpdate.forEach(library => {
            const libraryData = librariesData.find(item => item.library_urn === library.id);
            if (libraryData) {
                const librarySpecificData = this._getSafeLibraryData(libraryData);
                libraryContext._libraryUpdater.updateLocalItem(session, library, librarySpecificData);
                library._setLibraryLoadState('LOADED');
            }
            else {
                // USS indexing delays may cause Melville non-public libraries listing data to be stale.
                // Thus it is possible that we have RAPI data for a new library but no matching melville data in the listing.
                // Setting the library to NOT_LOADED will trigger lazy loading if the library is being used,
                // which will cause Melville to pull the up-to-date data for this library from platform.
                library._setLibraryLoadState('NOT_LOADED');
            }
        });
        session.commit();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var SearchProps;
(function (SearchProps) {
    SearchProps["STORAGE_ASSIGNEE_TYPE"] = "storage:assignee$$type";
    SearchProps["VISIBILITY"] = "app_metadata$$shell:visibility";
    SearchProps["CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME"] = "creative_cloud_toplevel_collection_name";
    SearchProps["FIELD_EXISTS"] = "op_field_exists";
    SearchProps["FIELD_MATCHES"] = "op_field_matches";
    SearchProps["INCLUDES"] = "includes";
    SearchProps["TYPE"] = "type";
    SearchProps["STORAGE_ASSIGNEE_ID"] = "storage:assignee$$id";
    SearchProps["SHARED_VIA_INVITE"] = "shared_via_invite";
    SearchProps["OP_AND"] = "op_and";
    SearchProps["OP_OR"] = "op_or";
    SearchProps["REPO_ACL_MODIFIER"] = "repo:acl$$repo:modifier";
    SearchProps["REPO_ACL_PRIVILEGES"] = "repo:acl$$repo:privileges";
    SearchProps["REPO_ACL_RELATIONS"] = "repo:acl$$repo:relations";
    SearchProps["CREATED_FROM_UPLOAD"] = "app_metadata$$cc:createdFromUpload";
    SearchProps["CREATED_BY_CLIENT_ID"] = "repo:createdByClientId";
})(SearchProps || (SearchProps = {}));
const USS_ARTIFACT_MEDIATYPE = 'app_metadata$$review:sourceAsset$$dc:format';
const LastAccessedOrderField = 'api:metadata/peruser#mine$$shell:lastAccessDate';
const OrderByToUSSOrderBy = {
    name: 'asset_name',
    created: 'create_date',
    modified: 'modify_date',
    shared: 'shared_date',
    lastAccessed: LastAccessedOrderField
};

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2023 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
var USSv3OrderField;
(function (USSv3OrderField) {
    // TODO: need last access date before switching RecentsMRU to USSv3
    USSv3OrderField["Created"] = "rm.storage:deviceCreateDate";
    USSv3OrderField["Modified"] = "rm.storage:deviceModifyDate";
    USSv3OrderField["Name"] = "rm.repo:name";
})(USSv3OrderField || (USSv3OrderField = {}));
var USSv3OrderDir;
(function (USSv3OrderDir) {
    USSv3OrderDir["Ascending"] = "ASC";
    USSv3OrderDir["Descending"] = "DESC";
})(USSv3OrderDir || (USSv3OrderDir = {}));
var USSv3FilterField;
(function (USSv3FilterField) {
    USSv3FilterField["MEDIA_TYPE"] = "rm.dc:format";
    USSv3FilterField["DIRECTORY_TYPE"] = "am.project:directoryType";
    USSv3FilterField["INHERITANCE_TYPE"] = "function:missing";
})(USSv3FilterField || (USSv3FilterField = {}));
var FetchFields;
(function (FetchFields) {
    FetchFields["SharedBy"] = "cm.sharedBy";
    FetchFields["LastAccessDate"] = "am.shell:lastActivity.date";
    FetchFields["Collaborator"] = "cm.collaborator";
    FetchFields["PublicCollaborator"] = "cm.publicCollaborator";
    FetchFields["ParentProjectId"] = "am.cc:inherited.cc:team.repo:assetId";
    FetchFields["StudentAssignmentAssetId"] = "am.cc:inherited.cc:studentAssignment.repo:assetId";
    FetchFields["StudentAssignmentDirectoryId"] = "am.cc:inheritable.cc:studentAssignment.repo:assetId";
    // We need both projects and its children to show up in global search
    FetchFields["CCInherited"] = "am.cc:inherited";
    FetchFields["CCInheritable"] = "am.cc:inheritable";
    // App metadata field required for Express
    FetchFields["HzDocumentMetadata"] = "am.hz:documentMetadata";
    FetchFields["CreatedFromUpload"] = "am.cc:createdFromUpload";
    FetchFields["CreatedByClientId"] = "rm.createdByClientId";
})(FetchFields || (FetchFields = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToIUSSAdobeAssetOrderBy = {
    'name': 'asset_name',
    'created': 'create_date',
    'modified': 'modify_date',
    'lastAccessed': LastAccessedOrderField
};
const OrderFieldToUSSv3OrderField = {
    'name': USSv3OrderField.Name,
    'created': USSv3OrderField.Created,
    'modified': USSv3OrderField.Modified,
    // TODO: update with correct field once V3 supports it
    'lastAccessed': USSv3OrderField.Modified
};
const OrderFieldToComparator$o = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    },
    modified(a, b) {
        return compareValues(a.modified, b.modified);
    },
    lastAccessed(a, b) {
        return compareValues(a.lastAccessed, b.lastAccessed);
    }
};
class USSAdobeAssetOrder extends createItemOrderFactory(OrderFieldToComparator$o) {
}
USSAdobeAssetOrder.default = new USSAdobeAssetOrder('descending', 'modified');

var USSAdobeAssetOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    OrderFieldToIUSSAdobeAssetOrderBy: OrderFieldToIUSSAdobeAssetOrderBy,
    OrderFieldToUSSv3OrderField: OrderFieldToUSSv3OrderField,
    'default': USSAdobeAssetOrder
});

const USSAssetFilterName = 'USSAdobeAssetFilter';

const DEFAULT_LIMIT$1 = 50;
/**
 * AdobeAsset Loader classes should use this class to do the page loading. Using composition rather
 * than inheritance because a base USSLoader class was causing circular dependencies at runtime that
 * would cause the base USSLoader class to be undefined when the Loader class that was extending it
 * was declared.
 */
class USSLoaderHelper {
    constructor(_assetPool, _core, _loader) {
        this._assetPool = _assetPool;
        this._core = _core;
        this._loader = _loader;
    }
    async loadPage(options, start) {
        var _a, _b;
        const { order, limit = DEFAULT_LIMIT$1, filter, implicitFilter, resource } = options;
        const latency = this._core._environment.getValue('USS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        start = start || 0;
        const adobeAssetFilter = filter;
        const { mediaTypes, excludeMediaTypes } = adobeAssetFilter;
        let uploadedFrom;
        let userId;
        if (adobeAssetFilter.name === USSAssetFilterName) {
            const ussAssetFilter = adobeAssetFilter;
            uploadedFrom = ussAssetFilter.uploadedFrom;
            userId = ussAssetFilter.userId;
        }
        const result = await this._loader._getUSSResults(Object.assign(Object.assign({ order,
            limit,
            filter,
            implicitFilter,
            resource,
            start, mediaTypes: Array.from(mediaTypes !== null && mediaTypes !== void 0 ? mediaTypes : []), excludeMediaTypes: Array.from(excludeMediaTypes !== null && excludeMediaTypes !== void 0 ? excludeMediaTypes : []) }, (uploadedFrom ? { uploadedFrom } : {})), (userId ? { userId } : {})));
        const resultSet = result.result_sets[0];
        const session = this._assetPool.createLoaderUpdateSession(mostRecentValidMutation);
        const items = this._extractItems(session, resultSet.items);
        let loadNextPage;
        const total = resultSet.total_items || 0;
        const pageItemCount = resultSet.items.length;
        // [SEARCH-30755] -- May be caused by USS filtering out items due to permissions for the
        // current user, which aren't subtracted from the total. Try to ensure that the Loader paginates
        // as though the total_items is correct.
        const nextStartIndex = (pageItemCount === 0 ? start + limit : start + pageItemCount);
        if (nextStartIndex < total) {
            loadNextPage = (options) => this.loadPage(options, nextStartIndex);
        }
        const page = {
            items,
            total,
            loadNextPage,
            mostRecentValidMutation
        };
        // allow Loader to do additional internal state management (optional)
        (_b = (_a = this._loader)._postProcessPage) === null || _b === void 0 ? void 0 : _b.call(_a, options, page);
        // Mark storage assignee as loaded to prevent lazy loading
        for (const item of items) {
            LazyLoadManager.updatedByItemUpdater(item, STORAGE_ASSIGNEE_CHANGED);
        }
        session.commit();
        return page;
    }
    _getItemData(item) {
        let publicLink = false;
        let directCount = 0;
        const collaboration_metadata = item['collaboration_metadata'];
        if (collaboration_metadata !== undefined) {
            publicLink = collaboration_metadata.some((collaborator) => {
                return collaborator.collaborator_id === 'all';
            });
            directCount = collaboration_metadata.length;
        }
        const collabMetadataMine = item['collab_metadata#mine'];
        return Object.assign(Object.assign({}, item), { 
            // Presence of collab_metadata#mine indicates that the item is shared with the user via an invite
            sharedViaInvite: collabMetadataMine !== undefined, 
            // absence of coallb_metadata#mine.type means the user belongs to a group on this Asset
            // Invitation service cannot detect this case, so lazy-loading collaborator data should
            // never override isSWYAsset when isSWYGroup is true.
            isSWYGroup: collabMetadataMine !== undefined && !collabMetadataMine.type, isShared: directCount > 0, isPublicLink: publicLink, directCollaboratorCount: directCount, 
            // No need to refresh collaborators for share flags, directCollaboratorCount, since they are computed
            // above. Not clearing the collaboratorDataIsDirty flag, because we cannot populate collaboratorArray
            // from USS.
            shareFlagsAreDirty: false });
    }
    /**
     * @package -- for use by USSLoaderHelper
     */
    _extractItems(session, items) {
        return this._core._adobeAssetFactory.assetsFromUSSMetadata(session, items, this._loader._getItemData || this._getItemData, this._loader._libraryContext, this._loader._customModelContext);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AdobeAssetDirectorySearchLoader {
    constructor(assetPool, core, _adobeAssetSearchInterface, _asset, _implicitFilter) {
        this._adobeAssetSearchInterface = _adobeAssetSearchInterface;
        this._asset = _asset;
        this._implicitFilter = _implicitFilter;
        /**
         * @package -- only for use by USSLoaderHelper
         */
        this._getItemData = this._getItemDataWithRepoId(this._asset.repositoryID);
        this._ussLoaderHelper = new USSLoaderHelper(assetPool, core, this);
    }
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    async loadPage(options) {
        return this._ussLoaderHelper.loadPage(options);
    }
    /**
     * @package -- only for use by USSLoaderHelper
     */
    async _getUSSResults({ start, limit, order, mediaTypes, excludeMediaTypes, filter }) {
        var _a;
        const query = (_a = this._implicitFilter) === null || _a === void 0 ? void 0 : _a._query;
        const deepSearch = Boolean(this._implicitFilter.deepSearch);
        const options = {
            orderBy: OrderFieldToIUSSAdobeAssetOrderBy[order.field],
            orderDirection: order.direction,
            start,
            limit,
            mediaTypes,
            excludeMediaTypes,
            query,
            deepSearch,
            assetId: this._asset.cloudID
        };
        if (filter.name === USSAssetFilterName) {
            const ussFilter = filter;
            options.userId = ussFilter.userId;
            options.uploadedFrom = ussFilter.uploadedFrom;
        }
        return this._adobeAssetSearchInterface.getFilteredAssets(options);
    }
    /**
     * @package -- only for use by USSLoaderHelper
     */
    _getItemDataWithRepoId(repoID) {
        // TODO: Patching should be removed once https://jira.corp.adobe.com/browse/SRCH-1989 is fixed
        //       and re-indexing is finished, which has ETA of Feb 28 2023
        return (item) => {
            return Object.assign(Object.assign({}, item), { 'repo:repositoryId': repoID });
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function getFiltersRelation(requestedFilter, other) {
    if (requestedFilter === other) {
        // If the exact same filter is given, then it must be a complete list.
        return 'subset';
    }
    if (requestedFilter && other) {
        // If the hash is the same, then we have the same filter.
        if (requestedFilter.hash === other.hash) {
            return 'subset';
        }
        // Since the hashes don't match, they aren't both EverythingFilter. So if `other`
        // is everything filter, then the requested filter is a subset.
        if (other.hash === 'everything') {
            return 'subset';
        }
        // If requested filter is the EverythingFilter, then it is a superset
        if (requestedFilter.hash === 'everything') {
            return 'unknown';
        }
        return requestedFilter.getRelationToFilter(other);
    }
    // If we have a filter, it means the other list had no filter, so this is a complete subset of an unfiltered list.
    if (requestedFilter) {
        return 'subset';
    }
    // If the other list had a filter and this new list doesn't have a filter, then this new list will be incomplete.
    return 'unknown';
}
/**
 * Useful for when you have an array as a value in a filter
 * and you want to compare the existing filter array value
 * with the new array value to see if they share some or all of their
 * items or even none.
 */
function compareFilterArrayValues(arry1, arry2) {
    // If either array is undefined there will be nothing to compare against
    // so this means it's 'none'
    if (arry1 === undefined || arry2 === undefined) {
        return 'none';
    }
    let lengthOfSharedElements = 0;
    arry1.forEach((element1) => {
        if (arry2.find((element2) => element1 === element2)) {
            lengthOfSharedElements++;
        }
    });
    if (lengthOfSharedElements === arry1.length && lengthOfSharedElements === arry2.length) {
        return 'all';
    }
    if (lengthOfSharedElements > 0) {
        return 'some';
    }
    return 'none';
}
/** Determine whether two date ranges overlap and return their filter relation
 * Default values chosen to functionally represent -Inf and Inf if any param is undefined
 * @param startThis
 * @param endThis
 * @param startOther
 * @param endOther
 */
function getDateRangeRelation(startThis = new Date(-9999, 0, 1), endThis = new Date(9999, 0, 1), startOther = new Date(-9999, 0, 1), endOther = new Date(9999, 0, 1)) {
    //  startOther ---- startThis ---- endThis --- endOther
    //  A is completely within B
    if (startThis >= startOther && endThis <= endOther) {
        return 'subset';
    }
    // startThis --- endThis --- startOther ---- endOther
    // or
    // startOther --- endOther --- startThis --- endThis
    // A and B have no overlap
    if (startThis > endOther || endThis < startOther) {
        return 'disjoint';
    }
    // startThis --- startOther --- endThis --- startOther
    // or
    // startOther --- startThis --- endOther --- endThis
    // or
    // startThis --- startOther --- endOther --- endThis
    // A and B have some overlap, but A is not a subset
    return 'unknown';
}

// Must match GenericListStatus enum from SAM.cpp
var AssetListStatus;
(function (AssetListStatus) {
    AssetListStatus[AssetListStatus["NotStarted"] = 1] = "NotStarted";
    AssetListStatus[AssetListStatus["HadLoaderErrors"] = 2] = "HadLoaderErrors";
    AssetListStatus[AssetListStatus["Loading"] = 3] = "Loading";
    AssetListStatus[AssetListStatus["ReadyHasMorePages"] = 4] = "ReadyHasMorePages";
    AssetListStatus[AssetListStatus["ReadyFullyLoaded"] = 5] = "ReadyFullyLoaded";
})(AssetListStatus || (AssetListStatus = {}));
const LOADER_STATE_CHANGED = 'loaderStateChanged';
const LOADER_REFRESH_NEEDED = 'loaderRefreshNeeded';
class ItemLoaderStateChangeEvent extends SAMEvent {
    constructor(hasUpdatedItems = false) {
        super(LOADER_STATE_CHANGED);
        this.hasUpdatedItems = hasUpdatedItems;
    }
}
class ItemLoaderRefreshNeededEvent extends SAMEvent {
    constructor(revalidateAtPage = 0) {
        super(LOADER_REFRESH_NEEDED);
        this.revalidateAtPage = revalidateAtPage;
    }
}
const SharedEventWithoutItemChanges = new ItemLoaderStateChangeEvent(false);
const SharedEventWithItemChanges = new ItemLoaderStateChangeEvent(true);
/**
 * This is the structure of a page in memory.
 */
class ItemLoaderPage {
    constructor() {
        this.startedGeneration = 0;
        this.loadedGeneration = 0;
    }
}
/**
 * A list can have multiple loaders that provide items.
 * The ItemLoaderState maintains the state of each loader attached in a list:
 * - The loaded pages and their items
 * - The error state if we had one
 * - The next available page if any
 *
 * The Loader can also refresh the items starting with page 0. The items
 * in the pre-loaded pages will only refresh once those pages are fully loaded again.
 *
 * If a previous pending request is finished after we start a refresh cycle, then
 * the items in that page will update if and only if the new cycle didn't fetch that page yet.
 */
class ItemLoaderState extends TypedEventEmitter {
    constructor(_core, _loader, _order, _implicitFilter, _filter) {
        super();
        this._core = _core;
        this._loader = _loader;
        this._order = _order;
        this._implicitFilter = _implicitFilter;
        this._filter = _filter;
        this.status = AssetListStatus.NotStarted;
        this._pages = [];
        /**
         * Each new refresh of the pages increments the generation index.
         * We use this to differentiate between async network calls that
         * might end up providing content after a new refresh has already
         * been scheduled.
         */
        this._generation = 0;
        /**
         * Store the index and link of the next page. Once we reach
         * the last page, the callback will become null.
         */
        this._nextPageIndex = 0;
        this._revalidateAtPage = 0;
        /**
         * Flag used to automatically load all pages without waiting for user intervention.
         * This is useful for cases when all items are needed. For example, in the sidebar
         * we want to display all the teams and bookmarked spaces.
         */
        this._loadAllPages = false;
    }
    get mostRecentValidMutation() {
        return this._mostRecentValidMutation;
    }
    /**
     * Triggers a new generation of loading.
     * @param generation    The generation index. This number must always increment for new loads.
     * @param loadAllPages  Forces loading all the pages in the chain.
     * @param limit (optional) override default items per page
     * @param revalidateAtPage (optional) revalidate pages starting at this index.
     * @returns Promise that can be used to know when the entire loading chain finished.
     */
    async load(generation, loadAllPages, limit, revalidateAtPage = 0) {
        this._loadAllPages = loadAllPages;
        // If we were loading something before, we are aborting
        // that in favor of the new generation.
        // Reset the previous page token.
        this._generation = generation;
        this._nextPageCallback = undefined;
        this._nextPageIndex = 0;
        this._pendingLoad = undefined;
        this._revalidateAtPage = revalidateAtPage;
        await this._loadPage(limit);
    }
    /**
     * Load the next page.
     * @returns Promise that can be used to know when the entire loading chain finished.
     */
    async loadNextPage(limit) {
        await this._loadPage(limit);
    }
    /**
     * Load all the remaining pages.
     * @returns Promise that can be used to know when the entire loading chain finished.
     */
    async loadAllPages(limit) {
        this._loadAllPages = true;
        await this._loadPage(limit);
    }
    /**
     * Pushes the items from all the loaded pages into the provided `dest` set.
     *
     * @param dest Set object that is populated with items from all the pages.
     */
    collectAllItems(dest) {
        for (const page of this._pages) {
            if (page && page.items) {
                for (const item of page.items) {
                    dest.add(item);
                }
            }
        }
    }
    /**
     * Loads or creates a page at the specified index.
     * @param pageIndex
     * @returns The page at index `pageIndex`.
     */
    _ensurePage(pageIndex) {
        let page = this._pages[pageIndex];
        if (!page) {
            page = new ItemLoaderPage();
            this._pages[pageIndex] = page;
        }
        return page;
    }
    /**
     * Handle only one page load at a time by storing the promise and waiting on the same
     * promise.
     *
     * Note that the promise chain can still be restarted via the `load()` method which
     * starts loading everything from the first page again.
     */
    async _loadPage(limit) {
        // Check if there is a load already in progress. We wait on that one before making more loads.
        // This should prevent users from trying to load too many pages ahead of time.
        let pendingLoad = this._pendingLoad;
        if (!pendingLoad) {
            // We don't have anything in progress, we can go ahead and load the page.
            pendingLoad = this._loadPageImpl(limit);
            // Store the pending load to make sure no requests are executed at the same time.
            this._pendingLoad = pendingLoad;
        }
        // Wait for this load to finish.
        await pendingLoad;
        if (this._pendingLoad === pendingLoad) {
            // If the load is still relevant for this generation of loading,
            // then we can go ahead and remove the promise. Note that we will
            // have to do this for all returning cases, even the paths that didn't
            // actually trigger a load above. That's because we don't know which path
            // continues the execution first and we want to make the caller can initiate
            // another call immediately.
            this._pendingLoad = undefined;
        }
    }
    /**
     * Loads the next page queued up for the loader.
     * It will also update the current page and recursively call
     * itself to load the next page if needed.
     */
    async _loadPageImpl(limit) {
        const nextPageCallback = this._nextPageCallback;
        const pageIndex = this._nextPageIndex;
        // If this is not the first page and we don't have a callback, then we are out of pages to load.
        if (pageIndex && !nextPageCallback) {
            return;
        }
        // Ensure we have the next page in memory.
        const page = this._ensurePage(pageIndex);
        // Store the generation that we are in when the loading starts. If the results
        // come by the time we've already switched to a new generation, then we will
        // ignore the errors and keep the results only if no other newer generation has
        // finished loading the same page already.
        const startGeneration = this._generation;
        if (page.startedGeneration >= startGeneration) {
            // We've already loaded this or a newer generation in a different loading chain.
            return;
        }
        // Make sure the page knows we are about to reload content using the new generation.
        const previousPageGeneration = page.startedGeneration;
        page.startedGeneration = startGeneration;
        page.validatedPromise = undefined;
        // Remove the error state in case we had one before.
        this.error = null;
        // Update the status to loading state before we start loading.
        this._updateStatus(AssetListStatus.Loading);
        let result;
        let loaderError;
        let revalidationPromise;
        try {
            const pageLimit = limit !== null && limit !== void 0 ? limit : page.limit;
            const options = {
                order: this._order,
                implicitFilter: this._implicitFilter,
                filter: this._filter,
                limit: pageLimit,
                resource: new Resource(this._core, {
                    parseResponse: async (response) => response,
                    // If we have already revalidated earlier pages, we don't want to revalidate them again
                    // even if they change. Otherwise we could refresh pages infinitely if responses are not stable.
                    skipRevalidation: () => pageIndex < this._revalidateAtPage,
                    // When we fetch a page, if the cache is enabled, we may get a cached response immediately,
                    // followed by a subsequent response _if_ the cache was outdated. For instance, we might have
                    // loaded several pages, and one of the pages turns out to differ. If that happens, we want
                    // the list to refresh itself from the beginning. The second time around, the list will quickly
                    // resolve with the cached pages that still match, followed by a new fetch for the page that changed.
                    // To ensure that we don't get stuck in a continuous loop refreshing the list,
                    // we skip revalidating the pages we've already revalidated during this process.
                    onResponse: async (response, flags) => {
                        // A cached (preliminary) response will not error, because we only store successful responses.
                        if (flags.preliminary) {
                            revalidationPromise = new ManagedPromise();
                            page.validatedPromise = revalidationPromise.promise;
                        }
                        else {
                            revalidationPromise === null || revalidationPromise === void 0 ? void 0 : revalidationPromise.resolve();
                            if (page.startedGeneration !== startGeneration) {
                                return;
                            }
                            // If the real response has changed, we want to refresh the list from the beginning.
                            if (flags.changed) {
                                // Start from the beginning. We should fetch the first page again.
                                // It will hit cache, which has been updated with this response.
                                // Then we wait for any more pages like normal.
                                this.dispatch(new ItemLoaderRefreshNeededEvent(pageIndex + 1));
                            }
                        }
                    },
                    // If an error occurs during the revalidation fetch:
                    onError: async (error, followsCachedResponse) => {
                        revalidationPromise === null || revalidationPromise === void 0 ? void 0 : revalidationPromise.reject(error);
                        if (!followsCachedResponse) {
                            return; // This error will be handled by the normal list logic below.
                        }
                        if (page.startedGeneration !== startGeneration) {
                            return;
                        }
                        // If we were loading other pages (e.g. later cached pages), we want to stop loading them.
                        this._nextPageCallback = undefined;
                        this.error = error;
                        this.status = AssetListStatus.HadLoaderErrors;
                        if (error.code === SAMErrorCode.NOT_FOUND) {
                            // Clear the list, as we would've been loading pages that are no longer valid.
                            this._pages = [];
                            this.dispatch(SharedEventWithItemChanges);
                        }
                        else {
                            this.status = AssetListStatus.HadLoaderErrors;
                            this.dispatch(SharedEventWithoutItemChanges);
                        }
                    },
                })
            };
            if (nextPageCallback) {
                result = await nextPageCallback(options);
                // We delete the callback only after the page fully loaded.
                // That's so that we can retry the load if the first try fails.
                this._nextPageCallback = undefined;
            }
            else {
                // Load the first page.
                result = await this._loader.loadPage(options);
                // We can update the window of valid changes at this point.
                // Note that we don't want to update the value for the rest of the pages
                // as we would still have items from the first page that might not be included yet.
                // For example, if a new asset is created and it shows up on the first page,
                // but the server didn't know about it just yet, then follow up pages
                // are not allowed to change this value until we do another reload cycle.
                this._mostRecentValidMutation = result.mostRecentValidMutation;
            }
            // Once the page is loaded, save the limit we've used for that particular page.
            // If we refresh the page we want to run it with the same page limit.
            page.limit = pageLimit;
        }
        catch (err) {
            loaderError = err;
        }
        if (page.loadedGeneration >= startGeneration) {
            // Ignore the results as a newer loader generation already finished loading this page.
            return;
        }
        if (loaderError) {
            if (page.startedGeneration !== startGeneration) {
                // Note that we only revert if this load is still the most recent generation
                // that started the load. Otherwise, we let the newer loader handle it eventually.
                // Note that we return early in here to avoid bubbling up the error state while
                // the newer loader is still in progress.
                return;
            }
            // Revert the status of the page back to the original generation before we've started.
            // This is needed so that we can retry loading this page again next time.
            page.startedGeneration = previousPageGeneration;
        }
        else if (result) {
            // Note that we still use the results of the page even if the client started a new generation of loading.
            // If we've reached this point, it means that the newer generation of loading has not yet reached this page.
            // In that case, the result we just received is still new enough to considering it better than what we had before.
            page.items = result.items.filter(item => this._implicitFilter.matches(item) && this._filter.matches(item));
            this.total = result.total;
            page.loadedGeneration = startGeneration;
        }
        // Update the state before sending any events.
        const loadMorePages = await this._updateStatusAndLinkToNextPage(startGeneration, pageIndex, result, loaderError);
        // If we decided to load more pages, this is a good time to make that recursive async call.
        if (loadMorePages) {
            await this._loadPageImpl(limit);
        }
    }
    /**
     * Checks if the loader result can be used to load the next page.
     * @param startGeneration   The generation that started this loader session.
     * @param pageIndex         The index of the loaded page.
     * @param result            The result received from the loader.
     * @param loaderError       The error caught during the execution of the loader, if any.
     * @returns true if the caller should continue loading the next page automatically.
     */
    async _updateStatusAndLinkToNextPage(startGeneration, pageIndex, result, loaderError) {
        if (this._generation !== startGeneration || this._nextPageIndex !== pageIndex) {
            // If the result is from a previous generation, we cannot update the `next page` link because we
            // reserve the page chaining only to the current generation of the loader. We don't want to keep
            // loading pages using the previous generation anyway, so this is where we bail out
            // that previous generation.
            if (result) {
                // If we had a result and we got as far as this point, then we have new items
                // already injected. However, there's a newer load already in progress, so there's no actual
                // state change here. We only want to inform of the possibility of new items
                // being added to the page, so we dispatch an event to let the ItemList update its 'items' contents
                // to the most recent version loaded in this load chain.
                this.dispatch(SharedEventWithItemChanges);
            }
            return false;
        }
        if (!result) {
            // This page failed to load, so loading any other pages is compromised too.
            this.error = loaderError;
            this._updateStatus(AssetListStatus.HadLoaderErrors);
            return false;
        }
        // Increment the page index and store the link to the next page that we've received from the loader.
        this._nextPageIndex = pageIndex + 1;
        this._nextPageCallback = result.loadNextPage;
        if (result.loadNextPage) {
            // If we have a `loadNextPage` callback available then it means there are more pages to load.
            this._updateStatus(AssetListStatus.ReadyHasMorePages);
        }
        else {
            // There are no other pages left. If we had any pages beyond this point
            // before, this is a good time to remove them.
            this._pages.splice(this._nextPageIndex);
            try {
                // If any pages are waiting for validation, we want to wait for them to finish
                // before we're truly ReadyFullyLoaded. If we will be waiting, though, we should
                // emit SharedEventWithItemChanges so that the ItemList can update its items.
                // Otherwise we can skip right to ReadyFullyLoaded.
                // Some use cases call for waiting on a list to fully load in a multi-step process.
                // Before ResponseCache, that would mean the list is up-to-date with fresh info,
                // so to maintain backward-compatibility, the ReadyFullyLoaded state shouldn't
                // be broadcast until the cache is validated.
                const pagesAwaitingValidation = this._pages.map(page => page.validatedPromise).filter(Boolean);
                if (pagesAwaitingValidation.length) {
                    this.dispatch(SharedEventWithItemChanges);
                    await Promise.all(pagesAwaitingValidation);
                }
                this._updateStatus(AssetListStatus.ReadyFullyLoaded);
            }
            catch (error) {
                this.error = error;
                this._updateStatus(AssetListStatus.HadLoaderErrors);
                return false;
            }
        }
        // There are two cases when we want to automatically load the next pages:
        // 1) If the client requested to load all pages automatically via the `this._loadAllPages` flag.
        // 2) If the client already requested these pages before in a previous generation, we will keep reloading
        //    the pages automatically. This is the use-case when the client already scrolled past the first page and
        //    the client triggers a refresh of the list in the background. In that case the list must automatically
        //    update up-to the last scroll position. The pages will refresh one-by-one until all new items are available.
        // If the page was loaded before (case #2 above), then the page must be in the list of pages already.
        // That means the page index is lower than the size of the pages array.
        const didLoadNextPageBefore = this._nextPageIndex < this._pages.length;
        return this._loadAllPages || didLoadNextPageBefore;
    }
    /**
     * Triggers a status update event.
     * @param newStatus
     */
    _updateStatus(newStatus) {
        // We always want to send an event when we have item changes,
        // so that the ItemList can update the item list even if the status didn't change.
        const hasItemChanges = newStatus === AssetListStatus.ReadyFullyLoaded || newStatus === AssetListStatus.ReadyHasMorePages;
        if (hasItemChanges || newStatus !== this.status) {
            this.status = newStatus;
            this.dispatch(hasItemChanges ? SharedEventWithItemChanges : SharedEventWithoutItemChanges);
        }
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
* A special filter used as a default to simplify logic around filtering rather than having special cases
* for filter being undefined.
*/
class EverythingFilter {
    constructor() {
    }
    get hash() {
        return 'everything';
    }
    matches(item) {
        return item !== undefined;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getRelationToFilter(other) {
        return 'subset';
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// STATE_CHANGED must be a different than the SAM.cpp equivalent so that patchAssetList can throttle
// the SAM.cpp notifications, and map the SAM.js event listeners to the throttled pseudo-events.
const STATE_CHANGED = 'status_changed';
const LIST_CHANGED = 'listChanged';
// NOTE: listFullyLoaded should only be fired when its loaders completed a page and no more pages are available.
//       It should *not* be fired for any other reason that list status changes to ReadyFullyLoaded.
const LIST_FULLY_LOADED = 'listFullyLoaded';
// For identifying updates of ItemList that originate from ItemLoaders. ONLY ItemLoaders should
// use this updateContext.
const LOADER_UPDATE_CONTEXT = 'LoaderUpdateContext';
class StateChangedEvent extends SAMEvent {
    constructor() {
        super(STATE_CHANGED);
    }
}
class ListChangedEvent extends SAMEvent {
    constructor() {
        super(LIST_CHANGED);
    }
}
const SharedListChangedEvent = new ListChangedEvent();
const SharedStateChangedEvent = new StateChangedEvent();
let GlobalGeneration = 0;
/**
 * Make sure we can sort lists based on how recent they've
 * started their server load. The more recent loads will have higher
 * priority over lists that have not been updated in a while.
 */
function allocGenerationIndex() {
    return ++GlobalGeneration;
}
class ItemList extends TypedEventEmitter {
    constructor(_itemPool, loaders, order, implicitFilter, filter = new EverythingFilter(), similarItemList, _loadOptions) {
        super();
        this._itemPool = _itemPool;
        this.order = order;
        this.implicitFilter = implicitFilter;
        this.filter = filter;
        this._loadOptions = _loadOptions;
        this._status = AssetListStatus.NotStarted;
        this._items = [];
        // Every time we refresh the list we increment the generation. This is used
        // to make sure that older lists are updated once the new pages are loaded.
        this._generation = 0;
        this._completedGeneration = 0;
        this._loaderStates = [];
        this._lastFetchTime = 0;
        this._needsRefresh = false;
        // We will have to keep the client side items around until we fully fetch again the entire list.
        // Example: We fetched the latest favorite spaces for the sidebar. Then we add a new space and make it favorite.
        // The new space will be added to the list automatically without doing another fetch from the server.
        // This list will refresh in the background eventually. Once the fetch is complete (ie. all pages are loaded),
        // we can get rid of the assets added in the previous generation. At that point we can know for sure,
        // that the items added in the previous generation have already been captured in the new generation of loaded pages.
        // If an item is created after the load started, we have to keep it around until the next generation ends.
        // That's because the initial pages might have contained the item, but we've started the load too early and the
        // item might not be captured in the result yet.
        // NOTE: only external changes, such as ONS refreshes, should cause entries to be made in _itemUpdatesByGeneration.
        //       Changes from an ItemLoader loading a page should NOT be reflected here. To avoid that, ItemLoader should
        //       always use `createUpdateSession()` or `createMutationSession()` with an `updateContext`.
        this._itemUpdatesByGeneration = new Map();
        this._listId = samJsUuid();
        // In case there is an error in load/loadNextPage that does not come from the Loader,
        // append the error to the errors list.
        this._onUnhandledPromiseError = (err) => {
            var _a;
            this._updateListStatusFromItemLoaderStates();
            if (!((_a = this._errors) === null || _a === void 0 ? void 0 : _a.length)) {
                this._errors = [];
            }
            this._errors.push(err);
            this._status = AssetListStatus.HadLoaderErrors;
            this.emit(STATE_CHANGED);
        };
        this._handlePendingLoad = async () => {
            const pendingLoad = this._pendingLoad;
            if (pendingLoad) {
                const { loadAllPages, limit, revalidateAtPage } = pendingLoad;
                this._pendingLoad = undefined;
                this._debug('_handlePendingLoad() awaiting _runLoaders for loaderState.load');
                await this._runLoaders((loaderState) => loaderState.load(this._generation, loadAllPages, limit, revalidateAtPage));
            }
        };
        this._onItemLoaderStateChanged = (ev) => {
            const { hasUpdatedItems } = ev;
            this._cleanPreviousGenerationItemsIfNeeded();
            // Only dispatch ItemsChanged events in response to ItemLoaderState events. ItemList will broadcast the
            // StatusChanged event when exiting the load/loadNextPage methods so that all ItemList state is settled
            // when the StatusChanged event fires.
            if (hasUpdatedItems) {
                this._updateListItemsFromItemLoaderStates();
            }
        };
        this._onItemLoaderRefreshNeeded = (ev) => {
            const { revalidateAtPage } = ev;
            this._updateListItemsFromItemLoaderStates();
            this._needsRefresh = true;
            this._loadAsync(this._loadOptions, revalidateAtPage).catch(this._onUnhandledPromiseError);
        };
        // Reusable event that we use to avoid creating a new event object all the times.
        this._globalStateChangedEvent = new ItemListStateChangedEvent(this);
        /**
         * Handles the change notifications from the pool.
         * This method executes until the GC collects the List reference.
         * This handler must be as quick as possible and postpone any list
         * updates until the items are actually needed by the client.
         * @param ev
         */
        this._itemPoolDelegate = {
            onItemsUpdated: (event) => {
                if (event.updateContext === LOADER_UPDATE_CONTEXT) {
                    // Ignore changes from ItemLoaders, which are handled in _updateListItemsFromItemLoaderStates
                    // but not _applyItemsChangedEvents. This is so partially loaded lists can maintain independence
                    // from other partially loaded lists whose filters intersect. E.g., if listA has items sorted ascending,
                    // and listB has the same filter but sorted descending, loading a page from listA won't add items to
                    // listB, and vice versa. Updates still go through ItemPool, so if both lists have loaded the same item,
                    // there will only be one instance of the item.
                    return;
                }
                let pendingNotifications = this._pendingNotifications;
                if (!pendingNotifications) {
                    pendingNotifications = [];
                    this._pendingNotifications = pendingNotifications;
                }
                pendingNotifications.push({
                    generation: this._generation,
                    event
                });
                this._updateListItemsFromItemLoaderStates();
            }
        };
        for (const loader of loaders) {
            if (loader.supportsFilter && !loader.supportsFilter(filter)) {
                // We don't want to use loaders that do not support the filters.
                // Otherwise, we are better off running this list entirely on the client side.
                // For example, the discarded items are better handled on the client for now.
                continue;
            }
            const state = new ItemLoaderState(this._core, loader, order, implicitFilter, filter);
            state.on(LOADER_STATE_CHANGED, this._onItemLoaderStateChanged);
            state.on(LOADER_REFRESH_NEEDED, this._onItemLoaderRefreshNeeded);
            this._loaderStates.push(state);
        }
        if (similarItemList) {
            this._copyInitialItemsFrom(similarItemList);
        }
        _itemPool.addDelegate(this._itemPoolDelegate, 'list');
    }
    _debug(msg) {
        this._core._environment.debug(`[ItemList ${this._itemPool.type} ${this._listId.slice(-4)}] ${msg}`);
    }
    /**
     * When client calls `Source.getList()` and an existing List is returned, the existing List's
     * loadOptions might be different than the loadOptions that were requested. ItemSource calls
     * this method to allow some adjustments.
     *
     * @package -- only to be used internally by SAM.js
     */
    _updateLoadOptions(loadOptions = {}) {
        var _a, _b;
        if (!this._loadOptions) {
            this._loadOptions = {};
        }
        // Can only increase the limit if there is a limit set, otherwise keep the default limit
        // because it's not possible to tell if it is being increased or decreased since it could
        // be defined on the service and not anywhere in SAM.js.
        if (this._loadOptions.limit && loadOptions.limit && this._loadOptions.limit < loadOptions.limit) {
            this._loadOptions.limit = loadOptions.limit;
        }
        // Can turn on loadAllPages, but cannot turn it off
        if (!this._loadOptions.loadAllPages && loadOptions.loadAllPages) {
            this._loadOptions.loadAllPages = loadOptions.loadAllPages;
        }
        // It can only lower the refreshTimeout duration. Annoyingly, -1 means "infinite future", while 0 means "now".
        if (loadOptions.refreshTimeout !== -1
            && (this._loadOptions.refreshTimeout === -1
                || ((_a = this._loadOptions.refreshTimeout) !== null && _a !== void 0 ? _a : 0) >= ((_b = loadOptions.refreshTimeout) !== null && _b !== void 0 ? _b : 0))) {
            this._loadOptions.refreshTimeout = loadOptions.refreshTimeout;
        }
        this._loadAsync(Object.assign(Object.assign({}, this._loadOptions), { 
            // if new refreshTimeout is -1, then it shouldn't refresh, but it can still turn on
            // loadAllPages, which might require loading more pages.
            refreshTimeout: loadOptions.refreshTimeout === -1 ? -1 : this._loadOptions.refreshTimeout })).catch(this._onUnhandledPromiseError);
    }
    get type() {
        return this._itemPool.type;
    }
    get generation() {
        return this._generation;
    }
    get completedGeneration() {
        return this._completedGeneration;
    }
    get hasLoaders() {
        return this._loaderStates.length > 0;
    }
    get lastFetchTime() {
        return this._lastFetchTime;
    }
    get _core() {
        return this._itemPool._core;
    }
    /**
     * In many cases the items already exist in a different list,
     * we just need to reorder the items or just apply a different filter.
     * In that case, we can bootstrap the list with items borrowed from a different
     * list until the items are refreshed in the background if necessary.
     * @package -- only for use in SAM.js
     * @param other
     */
    _copyInitialItemsFrom(other) {
        const itemGeneration = new Map();
        const filter = this.filter;
        for (const item of other.items) {
            if (this.implicitFilter.matches(item) && filter.matches(item)) {
                itemGeneration.set(item, true);
            }
        }
        // Inject the items as if they were just new items.
        // These items will be invalidated once the next generation loads,
        // which happened when `load()` finishes to load all pages.
        // This list starts with the items from a previously downloaded list,
        // so it inherits the generation from the other list too.
        this._generation = other.generation;
        this._completedGeneration = other.completedGeneration;
        this._itemUpdatesByGeneration.set(this._generation, itemGeneration);
        // Set the status to ready if other list is also set to ready and the other
        // list matches the filtering of this list.
        if (other.status === AssetListStatus.ReadyFullyLoaded && getFiltersRelation(filter, other.filter) === 'subset') {
            this._status = AssetListStatus.ReadyFullyLoaded;
            // SAM should copy the lastFetchTime from the other list as it is Fully loaded.
            // Essentially, the same items sorted in a different direction should be just as stale as the source list.
            this._lastFetchTime = other.lastFetchTime;
        }
        // Make sure we recompute the items once the user calls the `items` getter.
        this._updateListItemsFromItemLoaderStates();
    }
    /**
     * When a list completely loads, its items can be copied to other compatible lists. E.g., ListA and ListB have the
     * same filter and both are partially loaded. When ListA finishes loading, all of its items can be copied to
     * ListB, and ListB can be considered fully loaded.
     *
     * @package -- only for use in SAM.js
     */
    _applyListItemsFrom(other) {
        if (other.status !== AssetListStatus.ReadyFullyLoaded) {
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, '_applyListItems other list must be fully loaded');
        }
        if (getFiltersRelation(this.filter, other.filter) !== 'subset') {
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, '_applyListItems other list must be subset');
        }
        this._items = other.items.filter(item => this.implicitFilter.matches(item) && this.filter.matches(item));
        this.order.sortItems(this._items);
        this._dispatchItemsChangedEvent();
        if (this._status !== AssetListStatus.ReadyFullyLoaded) {
            this._status = AssetListStatus.ReadyFullyLoaded;
            this._dispatchStateChangedEvents();
        }
    }
    get status() {
        if (!this._loaderStates.length) {
            // If we don't have any loaders, we always use the in-memory data for this list.
            return AssetListStatus.ReadyFullyLoaded;
        }
        return this._status;
    }
    get errors() {
        return this._errors;
    }
    get items() {
        return this._items;
    }
    get total() {
        return this._total;
    }
    _cleanPreviousGenerationItemsIfNeeded() {
        // Check if all loaders are fully loaded and trim our previous generations.
        let globalMostRecentValidMutation;
        for (const loader of this._loaderStates) {
            const { status, mostRecentValidMutation } = loader;
            if (status === AssetListStatus.NotStarted || loader.status === AssetListStatus.HadLoaderErrors) {
                // Ignore loaders that are not available.
                continue;
            }
            if (status === AssetListStatus.Loading || status === AssetListStatus.ReadyHasMorePages) {
                // We cannot trim any of the local items just yet. There are still more pages to load.
                return;
            }
            // This loader is ready to trim some pages.
            if (mostRecentValidMutation) {
                // We have to take the minimum timestamps of all the loaders.
                // If we have two loaders that have different latencies, then we have to keep items
                // in the list until the most latent on has a chance to validate our local changes.
                // The most recent mutations that we can eliminate from the local
                // list are the ones outside of any latency window. The minimum is the most recent
                // timestamp that is known to be valid across all loaders. Anything more recent than that
                // would remove changes that were not yet replicated on at least one of the loaders.
                globalMostRecentValidMutation = globalMostRecentValidMutation
                    ? Math.min(globalMostRecentValidMutation, mostRecentValidMutation)
                    : mostRecentValidMutation;
            }
        }
        // We've loaded the entire set of pages, we are now ready to
        // throw away the items that were added on the client side in
        // the previous generations. These items should have been
        // captured already by the new fetches from the server.
        this._cleanPreviousGenerationItems(globalMostRecentValidMutation);
    }
    /**
     * Removes items from the previous generations.
     */
    _cleanPreviousGenerationItems(mostRecentValidMutation) {
        // Convert any pending events into actual maps to make the changes available below.
        this._applyItemsChangedEvents();
        const currentGeneration = this._generation;
        this._completedGeneration = currentGeneration;
        // Pick all items added in the previous generations. If these items were indeed added, the updated
        // lists should already contain the new items and we can go ahead and remove them from our in-memory store.
        // Note that we cannot remove items added in the current generation as those were added
        // after we've fetched the requests from the server and might not be up-to-date yet.
        const newState = new Map();
        let hadChanges = false;
        let mostRecentDeletedGeneration = 0;
        for (const [key, generation] of this._itemUpdatesByGeneration) {
            if (key >= currentGeneration) {
                continue;
            }
            // Deletes in JS Maps do not break the iterators, so it should be safe to delete generations while reading the map.
            hadChanges = true;
            this._itemUpdatesByGeneration.delete(key);
            mostRecentDeletedGeneration = Math.max(mostRecentDeletedGeneration, key);
            // If we have a most recent valid mutation timeframe, then we need to look for items that
            // might still be inside that update time window.
            if (mostRecentValidMutation) {
                // Consolidate all the pending changes into a single generation.
                for (const [item, state] of generation) {
                    const { lastKnownClientMutation } = item;
                    // If the item was already added to the list, then we have to keep updating its final state.
                    if (newState.has(item) || lastKnownClientMutation && lastKnownClientMutation > mostRecentValidMutation) {
                        // This item had a mutation too close to the last reload, so we cannot trust
                        // that the listing returns the most up-to-date values. We have to preserve the item state (added / deleted)
                        // until a future refresh.
                        newState.set(item, state);
                    }
                }
            }
        }
        if (newState.size) {
            // Inject the new state in place of the most recent deleted generation.
            this._itemUpdatesByGeneration.set(mostRecentDeletedGeneration, newState);
        }
        if (hadChanges) {
            // Let the clients know the list must be recomputed.
            this._dispatchItemsChangedEvent();
        }
    }
    refresh() {
        this._loadAsync(this._loadOptions).catch(this._onUnhandledPromiseError);
    }
    /**
     * @deprecated -- Use {@link ItemList.refresh} instead. Will be removed on or after 2024-10-01.
     */
    load(options) {
        oneTimeWarning('ItemList.load', 'ItemList.load() is deprecated and will be removed on or after'
            + ' 2024-10-01. Use ItemList.refresh() instead. List load parameters are passed as the 3rd parameter to'
            + ' ItemSource.getList(), which now automatically starts loading.');
        // Previously, `ItemList.load()` with no parameters would always refresh the list because it implied a default
        // value for `options.refreshTimeout` of `0` ("refresh now"). However, `_updateLoadOptions` assumes a
        // default value for `options.refreshTimeout` of `-1` ("never refresh"). For better backward-compatibility,
        // force a default for refreshTimeout of `0`. A defined value for refreshTimeout will override.
        options = Object.assign({ refreshTimeout: 0 }, options);
        this._updateLoadOptions(options);
    }
    /**
     * Other internal SAM.js code relies on getting a Promise.
     * This should only be used inside SAM.js, not by clients.
     * @package
     */
    async _loadAsync(options, revalidateAtPage) {
        var _a, _b;
        if (!this._loaderStates.length) {
            // We don't have any loaders.
            return;
        }
        const refreshTimeout = (_a = options === null || options === void 0 ? void 0 : options.refreshTimeout) !== null && _a !== void 0 ? _a : 0;
        const loadAllPages = (_b = options === null || options === void 0 ? void 0 : options.loadAllPages) !== null && _b !== void 0 ? _b : false;
        // Check if the list needs to be refreshed:
        // 1. The user didn't provide a refresh timeout, meaning we always load the contents.
        // 2. There is a need to refresh the contents because the list has changed outside of SAMJS.
        // 3. There's a refresh timeout and the timeout expired. We can use this mechanism to prevent using
        //    data that is considered to be too old without forcing a refresh all the times.
        // 4. refreshTimeout === -1 means the client does NOT want to refresh, only wait for existing
        //    load requests to finish, possibly for the purpose of modifying other loadOptions like limit
        //    or loadAllPages.
        const lastFetchTime = this._lastFetchTime;
        if (this._needsRefresh || !lastFetchTime || !refreshTimeout || (refreshTimeout !== -1 && lastFetchTime + refreshTimeout < Date.now())) {
            this._debug(`_loadAsync() calling _load(): _needsRefresh: ${this._needsRefresh}, lastFetchTime: ${lastFetchTime}`
                + ` refreshTimeout: ${refreshTimeout}`);
            await this._load(loadAllPages, options === null || options === void 0 ? void 0 : options.limit, revalidateAtPage);
            return;
        }
        else {
            this._debug(`_loadAsync() not time to refresh: _needsRefresh: ${this._needsRefresh}, lastFetchTime: ${lastFetchTime}`
                + ` refreshTimeout: ${refreshTimeout}`);
        }
        // If there's a pending load, wait until it's finished.
        const previousLoadPromise = this._previousLoadPromise;
        if (previousLoadPromise) {
            // Wait until the previous load is complete.
            this._debug('_loadAsync() awaiting previousLoadPromise');
            await previousLoadPromise;
        }
        if (loadAllPages) {
            // Make sure the previous load didn't load just the first page.
            await this._ensureAllPagesAreLoaded(options === null || options === void 0 ? void 0 : options.limit);
        }
    }
    async _load(loadAllPages, limit, revalidateAtPage = 0) {
        // Make sure we don't keep refreshing this list.
        this._needsRefresh = false;
        // Coalesce multiple load requests into one.
        let pendingLoad = this._pendingLoad;
        if (!pendingLoad) {
            // Since _handlePendingLoad execution is deferred, control is returned to the caller where it
            // should expect the List to already be loading, even though the Loader hasn't actually
            // started.
            this._status = AssetListStatus.Loading;
            // _lastFetchTime must be defined now, because the _handlePendingLoad execution is deferred, which
            // causes control to be passed back to the client. If the client then calls getList(), the refreshTimeout
            // option would not be evaluated properly since _lastFetchTime would be stale.
            this._lastFetchTime = Date.now();
            // We use the generation to ignore results that are still in-flight.
            // When a new load is issued, we will slowly cleanup the
            // results as soon as the prior loading actions finish.
            this._generation = allocGenerationIndex();
            this._debug('_load() creating _pendingLoad');
            this._pendingLoad = pendingLoad = {
                loadAllPages,
                limit,
                revalidateAtPage,
                // Make sure the load executes after the stack unrolls.
                promise: Promise.resolve().then(this._handlePendingLoad)
            };
            // Alert clients of state change
            this._dispatchStateChangedEvents();
        }
        else if (loadAllPages) {
            // Make sure that the pending load fetches all the pages.
            pendingLoad.loadAllPages = true;
        }
        this._debug('_load() awaiting _pendingLoad');
        await pendingLoad.promise;
    }
    loadNextPage(loadOptions) {
        this._loadNextPageAsync(loadOptions || this._loadOptions).catch(this._onUnhandledPromiseError);
    }
    /**
     * Other internal SAM.js code relies on getting a Promise.
     * This should only be used inside SAM.js, not by clients.
     * @package
     */
    async _loadNextPageAsync(options) {
        if (!this._loaderStates.length) {
            // We don't have any loaders.
            return;
        }
        if (this._pendingLoad) {
            this._debug('_loadNextPageAsync() awaiting _pendingLoad');
            await this._pendingLoad.promise;
        }
        else {
            // Since _loadAsync doesn't immediately start loading, but it does update its status and broadcast the
            // status change event, _loadNextPageAsync must do the same. It can't be handled in _runLoaders only,
            // because without the status event fired in _loadAsync, it'd be fired too late; with the status event
            // fired in _loadAsync, it'd be fired redundantly.
            this._status = AssetListStatus.Loading;
            this._dispatchStateChangedEvents();
            this._debug('_loadNextPageAsync() awaiting _runLoaders for loaderState.loadNextPage');
            await this._runLoaders((loaderState) => loaderState.loadNextPage(options === null || options === void 0 ? void 0 : options.limit));
        }
    }
    async _runLoaders(fn) {
        // We need to update this first to avoid multiple calls to load
        // from trying to load too often.
        this._lastFetchTime = Date.now();
        // Save the promise that triggered the last load.
        const promise = Promise.all(this._loaderStates.map(fn));
        this._previousLoadPromise = promise;
        try {
            this._debug('_runLoaders() awaiting loaders');
            await promise;
        }
        finally {
            this._debug('_runLoaders() loaders complete');
            // Remove the load promise.
            this._previousLoadPromise = undefined;
            // Notify listeners that the List.status has changed (computed from ItemLoaders). This must be the
            // last line processed that alters any state in List, so that event listeners can immediately utilize
            // the List in a completely settled state.
            this._updateListStatusFromItemLoaderStates();
            this._dispatchStateChangedEvents();
            // Notify ItemSource that it can copy this list to other compatible lists.
            // NOTE: this event not intended for clients.
            if (this._status === AssetListStatus.ReadyFullyLoaded) {
                this.emit(LIST_FULLY_LOADED);
            }
        }
    }
    setNeedsRefresh() {
        if (this.status === AssetListStatus.NotStarted || !this._loaderStates.length) {
            // List has never been loaded, so doesn't need refresh
            return;
        }
        if (this.listenerCount(LIST_CHANGED)) {
            // We have listeners waiting for changes, so go ahead and reload this list now.
            this._needsRefresh = true;
            this.refresh();
            return;
        }
        // There are no listeners, we will keep a note to refresh this list
        // once the list becomes active again.
        this._needsRefresh = true;
    }
    _onEventListenerAdded() {
        if (this._needsRefresh && this.listenerCount(LIST_CHANGED)) {
            // Make sure the list is updated once the client
            // needs to use the items of this list again.
            this.refresh();
        }
    }
    async _ensureAllPagesAreLoaded(limit) {
        if (this.status !== AssetListStatus.ReadyHasMorePages) {
            // No more pages to load. Bail out.
            return;
        }
        // Looks like the previous load didn't finish all the pages.
        // Note that if another prefetch is issued, we will just wait on the promise
        // created by the _runLoaders below via `this._previousLoadPromise`.
        await this._runLoaders((loaderState) => loaderState.loadAllPages(limit));
    }
    /**
     * @package -- only for use in SAM.js
     */
    _dispatchStateChangedEvents() {
        this._debug(`_dispatchStateChangedEvents status: ${AssetListStatus[this.status]}`);
        this.dispatch(SharedStateChangedEvent);
        // Dispatch a global event that can be used to handle global
        // state updates without adding individual events on all the item lists.
        this._core.dispatch(this._globalStateChangedEvent);
    }
    _updateListStatusFromItemLoaderStates() {
        var _a;
        let newStatus = this._pendingLoad ? AssetListStatus.Loading : AssetListStatus.NotStarted;
        // Remove any previous error.
        this._errors = undefined;
        for (const loaderState of this._loaderStates) {
            switch (loaderState.status) {
                case AssetListStatus.HadLoaderErrors:
                    // We only surface the error in cases when there's no loader pending to start.
                    if (this._pendingLoad) {
                        break;
                    }
                    // We surface errors immediately.
                    this._status = AssetListStatus.HadLoaderErrors;
                    this._errors = [loaderState.error];
                    // Return early to avoid cleaning previous generation items.
                    return;
                case AssetListStatus.ReadyHasMorePages:
                    if (newStatus !== AssetListStatus.Loading && !((_a = this._loadOptions) === null || _a === void 0 ? void 0 : _a.loadAllPages)) {
                        // If we don't have a loader that is still loading, and we're not loading all pages, then
                        // change status to ReadyHasMorePages
                        newStatus = AssetListStatus.ReadyHasMorePages;
                    }
                    break;
                case AssetListStatus.Loading:
                    // We always want to know when a page is still loading.
                    newStatus = AssetListStatus.Loading;
                    break;
                case AssetListStatus.ReadyFullyLoaded:
                    if (newStatus !== AssetListStatus.ReadyHasMorePages && newStatus !== AssetListStatus.Loading) {
                        // If we don't have a loader that still has pages to load and if we don't actually load something.
                        newStatus = AssetListStatus.ReadyFullyLoaded;
                    }
                    break;
            }
        }
        this._status = newStatus;
    }
    _dispatchItemsChangedEvent() {
        // Let the client know they have to read the item list again.
        this.dispatch(SharedListChangedEvent);
    }
    _updateListItemsFromItemLoaderStates() {
        this._applyItemsChangedEvents();
        const itemSet = new Set();
        let total;
        // Collect the items from all the loaders.
        for (const loaderState of this._loaderStates) {
            loaderState.collectAllItems(itemSet);
            if (loaderState.total !== undefined) {
                total = Math.max(total || 0, loaderState.total);
            }
        }
        // Collect any items that were changed on the client
        // side and might not be captured in the requests from
        // the server side yet.
        for (const itemGeneration of this._itemUpdatesByGeneration.values()) {
            for (const [item, state] of itemGeneration.entries()) {
                if (state) {
                    itemSet.add(item);
                }
                else {
                    itemSet.delete(item);
                }
            }
        }
        const items = Array.from(itemSet);
        // Sort the items based on the current ordering.
        this.order.sortItems(items);
        this._items = items;
        this._total = total;
        this._dispatchItemsChangedEvent();
    }
    /**
     * Handles changes injected through the item pool. These can be either local changes
     * made by the user, or changes detected while fetching other lists.
     *
     * We use this mechanism to propagate the changes immediately across the entire app.
     * For example, if a different call detects a Space has been updated, all the active
     * lists will get the notification and automatically apply the change to their own listing.
     *
     * We are only interested about additions and deletions. Note that items
     * can be added (or removed) to the list if the mutations of the item properties make the
     * updated item pass (or fail) the filter of the current list.
     */
    _applyItemsChangedEvents() {
        const pendingNotifications = this._pendingNotifications;
        if (!pendingNotifications) {
            return;
        }
        this._pendingNotifications = undefined;
        // Break down changes into their own generations of added/removed items.
        for (const notification of pendingNotifications) {
            const { event, generation } = notification;
            if (generation < this._completedGeneration) {
                // Ignore changes from completed generations. We already have all
                // the correct items received from the server.
                continue;
            }
            let itemGeneration = this._itemUpdatesByGeneration.get(generation);
            if (!itemGeneration) {
                itemGeneration = new Map();
                this._itemUpdatesByGeneration.set(generation, itemGeneration);
            }
            if (event.addedItems) {
                for (const item of event.addedItems) {
                    if (this.implicitFilter.matches(item) && this.filter.matches(item)) {
                        itemGeneration.set(item, true);
                    }
                }
            }
            if (event.changedItems) {
                for (const item of event.changedItems) {
                    // Check if we have any items that pass the filter test or not.
                    // We need to store both matching and non-matching, just in case
                    // an non-matching item was matching before the update and
                    // we now have to manually remove it from the list fetched from
                    // the server.
                    const included = this.implicitFilter.matches(item) && this.filter.matches(item);
                    itemGeneration.set(item, included);
                }
            }
            if (event.discardedItems) {
                for (const item of event.discardedItems) {
                    // Any discarded items must be removed entirely.
                    itemGeneration.set(item, false);
                }
            }
        }
    }
}
__decorate([
    observable$1(SharedStateChangedEvent)
], ItemList.prototype, "status", null);
__decorate([
    observable$1(SharedStateChangedEvent)
], ItemList.prototype, "errors", null);
__decorate([
    observable$1(SharedListChangedEvent)
], ItemList.prototype, "items", null);
__decorate([
    observable$1(SharedListChangedEvent)
], ItemList.prototype, "total", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Dummy implementation of the WeakRef interface to be used
 * in browsers that do not support WeakRefs natively.
 * Note that the associated objects will not be reclaimed by the
 * garbage collector. We don't expect this to be an actual issue
 * in practice for SAM though.
 */
class WeakRefPolyfill {
    constructor(_ref) {
        this._ref = _ref;
    }
    /**
     * Needed in order to fully implement the WeakRef interface.
     * The `Symbol.toStringTag` symbol is a property that
     * is used by the default implementation of the toString method.
     */
    get [Symbol.toStringTag]() {
        return 'WeakRef';
    }
    /**
     * Returns the WeakRef target object.
     * Note that this implementation emulates the API, but cannot
     * actually keep a weak reference.
     *
     * Based on MDN data, most modern browsers support WeakRef.
     */
    deref() {
        return this._ref;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var WeakRef$1 = typeof WeakRef !== 'undefined' ? WeakRef : WeakRefPolyfill;

/**
 * Returns a Promise that resolves when a List is loaded.
 * @param list to monitor for loading
 */
function waitForListLoad(list) {
    const listEventSource = list;
    return new Promise(resolve => {
        function onStatusChange() {
            if (list.status !== AssetListStatus.Loading) {
                listEventSource.off(STATE_CHANGED, onStatusChange);
                resolve();
            }
        }
        listEventSource.on(STATE_CHANGED, onStatusChange);
        // if List is already loaded, resolve now
        onStatusChange();
    });
}
function waitForListChange(list) {
    const listEventSource = list;
    return new Promise(resolve => {
        function onStatusChange() {
            listEventSource.off(LIST_CHANGED, onStatusChange);
            resolve();
        }
        listEventSource.on(LIST_CHANGED, onStatusChange);
    });
}

var waitForListLoad$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    waitForListLoad: waitForListLoad,
    waitForListChange: waitForListChange
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// TODO: change OrderDirection/Field to use SAM.cpp enums
// https://jira.corp.adobe.com/browse/SAM-1644
var OrderDirection;
(function (OrderDirection) {
    OrderDirection[OrderDirection["Ascending"] = 0] = "Ascending";
    OrderDirection[OrderDirection["Descending"] = 1] = "Descending";
})(OrderDirection || (OrderDirection = {}));
var OrderField;
(function (OrderField) {
    OrderField[OrderField["Name"] = 0] = "Name";
    OrderField[OrderField["Modified"] = 1] = "Modified";
    OrderField[OrderField["Created"] = 2] = "Created";
    OrderField[OrderField["Shared"] = 3] = "Shared";
})(OrderField || (OrderField = {}));
function candidateSort(a, b) {
    if (a.filterRelation !== b.filterRelation) {
        // We prefer to start from a list that contains as many items as possible,
        // so a list that can generate a complete `subset` must be moved to the left.
        return a.filterRelation === 'subset' ? -1 : 1;
    }
    if (a.generation !== b.generation) {
        // Newer generations must be moved to the left.
        // Return a negative number if a.generation is larger.
        return b.generation - a.generation;
    }
    // Lists with more items move left.
    // Return a negative number if a.length is larger.
    return b.length - a.length;
}
/**
 * ItemSource is the primary class and interface for interacting with lists of items
 * throughout SAM.js. It holds the only reference to the cache of lists which allows
 * SAM.js to be much more efficient when applying new filters and fetching new lists.
 *
 * @usage Instances of to this class must be cached so clients can
 * take advantage of shared cached lists.
 */
class ItemSource {
    // To ensure that we always have an implicit filter, we will use the EverythingFilter as a default
    constructor(_itemPool, _loaders, _implicitFilter = new EverythingFilter()) {
        this._itemPool = _itemPool;
        this._loaders = _loaders;
        this._implicitFilter = _implicitFilter;
        this._lists = new Map();
    }
    // To ensure that we always have an explicit filter, we will use the EverythingFilter as a default
    // eslint-disable-next-line no-dupe-class-members
    getList(order, filter = new EverythingFilter(), loadOptions) {
        if (typeof order === 'number' || typeof filter === 'number') {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'Using OrderDirection and OrderField is not implemented in SAM.js, and will be deprecated in SAM.cpp');
        }
        let list = this._getExistingList(order, filter);
        // If the list has been deactivated, then we cannot use the list anymore
        // and we have to create a new one.
        if (!list) {
            // If this is an internal list, then we can bootstrap the
            // contents of the list based on a similar list in the cache.
            // This way we don't have to reload the contents when changing
            // sort order.
            const mostCompleteList = this._getMostCompleteCompatibleList(filter);
            list = new ItemList(this._itemPool, this._loaders, order, this._implicitFilter, filter, mostCompleteList, loadOptions);
            // When a list fully loads, copy its items to other compatible lists
            list.on(LIST_FULLY_LOADED, () => this._onListFullyLoaded(list));
            this._lists.set(this._getListHash(order, filter), new WeakRef$1(list));
        }
        else {
            // The client may be passing in different loadOptions than what was specified for the
            // existing List. Try to accommodate these new options without negatively impacting
            // other clients of the same List. If the client did not explicitly specify refreshTimeout, assume
            // that the existing list should not be refreshed. This is for better backward-compatibility for
            // cases where clients expected that `getList()` would not automatically load data in order to make use
            // of a cached List.
            list._updateLoadOptions(Object.assign({ refreshTimeout: -1 }, loadOptions));
        }
        if (list.status === AssetListStatus.NotStarted) {
            // Start loading.
            list.refresh();
        }
        return list;
    }
    /**
     * @TODO_Deprecation will be marked as deprecated on or after 2024-10-01 and removed on or after 2025-01-01
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getListWithTypes(orderDir, orderField, types) {
        throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'getListWithTypes is not implemented in SAM.js and will be deprecated in SAM.cpp');
    }
    _getListHash(order, filter) {
        return `${filter.hash}:${order.hash}`;
    }
    /**
     * @package -- for use in SAM.js only
     */
    _getExistingList(order, filter) {
        const existingHash = this._getListHash(order, filter);
        const listWeakRef = this._lists.get(existingHash);
        if (listWeakRef) {
            return listWeakRef.deref();
        }
    }
    setNeedsRefresh() {
        for (const list of this._getLists()) {
            list.setNeedsRefresh();
        }
    }
    /**
     * Find an already loaded list that is a good candidate to borrow items for when creating a new list.
     *
     * For example, switching the sorting order of a list would have the same filter,
     * so it should be ok to just run that entirely on the client side.
     *
     * Another example is filtering down some items. If we already loaded a list that contained these items,
     * then we can build the filtered down list by just executing the same filter on the client side.
     *
     * @param requestedFilter Filter of the new list.
     * @returns The best candidate list that could be used as a starting point.
     */
    _getMostCompleteCompatibleList(requestedFilter) {
        var _a;
        const candidates = [];
        for (const list of this._getLists()) {
            if (list.status === AssetListStatus.ReadyFullyLoaded) {
                const filterRelation = getFiltersRelation(requestedFilter, list.filter);
                if (filterRelation !== 'disjoint') {
                    candidates.push({ list, filterRelation, generation: list.generation, length: list.items.length });
                }
            }
        }
        // We want to pick the item with the newest items, or the list that has the largest subset of items.
        candidates.sort(candidateSort);
        // The first item in the list is the best candidate.
        return (_a = candidates[0]) === null || _a === void 0 ? void 0 : _a.list;
    }
    /**
     * @package -- for use in SAM.js only
     */
    *_getLists() {
        const lists = this._lists;
        for (const [hash, listRef] of lists.entries()) {
            const list = listRef.deref();
            if (!list) {
                // The weak ref has expired, remove it from the map.
                // Note that JS Maps are ok with deletions during iteration.
                lists.delete(hash);
                continue;
            }
            yield list;
        }
    }
    /**
     * Copies fully loaded lists to compatible lists when load completes.
     */
    _onListFullyLoaded(loadedList) {
        if (loadedList.status !== AssetListStatus.ReadyFullyLoaded) {
            return;
        }
        for (const list of this._getLists()) {
            // Other lists that are subsets of the loaded list can be inferred to be fully loaded, too.
            if (list !== loadedList
                && getFiltersRelation(list.filter, loadedList.filter) === 'subset') {
                // Don't update lists that are loading, as it could interfere with its generation tracking
                waitForListLoad(list).then(() => {
                    // Skip lists that are fresher than the loaded list
                    if (list.completedGeneration >= loadedList.completedGeneration) {
                        return;
                    }
                    list._applyListItemsFrom(loadedList);
                });
            }
        }
    }
}
__decorate([
    keepAlive
], ItemSource.prototype, "getList", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AssetVersion extends ItemBase {
    constructor() {
        super(...arguments);
        // We are intentionally setting a static etag.
        // Using the HEAD version of the asset's etag will cause unintended side affects.
        this._etag = 'static-etag';
        // These fields come from the parent Asset
        this._assetId = '';
        this._assetEtag = '';
        // These fields come from the AssetVersionLoader
        this._createdAt = new Date();
        this._createdBy = '';
        this._manifest = new ManifestResource(this._core, this);
        this._name = '';
    }
    async _getHeadAssetInterface() {
        const assetContext = await this._core.getAssetContext();
        // NOTE: this AssetInterface is tied to the parent AdobeAsset for all AssetVersion instances. Where API
        // calls are version-specific, the links need to come from this.__links; if the API call is not specific to
        // a particular version, then the links need to come from `this._assetLinks`.
        return new AssetInterface(assetContext._rapi, this._assetId, this._assetLinks, 
        // etag only applies to the head version, and isn't needed
        // by version history R-API calls, but is required for AssetInterface.
        this._assetEtag);
    }
    async _getAssetInterface() {
        return new AssetInterface(this._core.hostAssetContext._rapi, this._assetId, this.__links, this._etag);
    }
    get assetId() {
        return this._assetId;
    }
    get created() {
        return this._createdAt;
    }
    get createdBy() {
        return this._createdBy;
    }
    get links() {
        // Make a copy to avoid the client accidentally manipulating the links
        return Object.assign({}, this.__links);
    }
    get manifest() {
        return this._manifest;
    }
    get milestone() {
        return this._label ? {
            label: this._label,
            description: this._description,
        } : undefined;
    }
    get name() {
        return this._name;
    }
    get versionId() {
        return this.id;
    }
    _getRenditionFetcher() {
        if (!this._renditionFetcher) {
            this._renditionFetcher = new RenditionFetcher(this._core, SUPPORTED_SIZES, async (size, type) => {
                const ai = await this._getAssetInterface();
                return ai.getRendition(size, type);
            });
            // Forward change events from the rendition fetcher
            // to this class.
            this._renditionFetcher.on('change', () => {
                this.dispatch({ type: 'change' });
            });
        }
        return this._renditionFetcher;
    }
    getRenditionURL(size, type = RenditionType.PNG) {
        const renditionFetcher = this._getRenditionFetcher();
        return renditionFetcher.getURL(size, type, this._etag);
    }
    renditionURLStatus(size, type) {
        const renditionFetcher = this._getRenditionFetcher();
        return renditionFetcher.renditionURLStatus(size, type, this._etag);
    }
    /**
     * See {@link AssetInterface#getCustomRendition} for usage
     */
    async getCustomRendition({ size, type, urlTemplateOptions, additionalHeaders } = {}) {
        const assetInterface = await this._getAssetInterface();
        return assetInterface.getCustomRendition({ size, type, urlTemplateOptions, additionalHeaders });
    }
    /**
     * See {@link AssetInterface#getCustomRendition} for usage
     */
    async getAllCustomRenditions({ type, urlTemplateOptions, additionalHeaders } = {}) {
        const assetInterface = await this._getAssetInterface();
        return assetInterface.getAllCustomRenditions({ type, urlTemplateOptions, additionalHeaders });
    }
    /**
     * Returns a pre-signed rendition url for the given size and type.
     * @param size The size of the asset version rendition    (e.g. 128, 256, 512, 1024)
     * @param type The type of the asset version rendition    (e.g. 'image/png', 'image/jpg', etc.)
     * see {@link https://git.corp.adobe.com/pages/caf/api-spec/chapters/common_resources/renditions_resources.html#media-types} for available types
     * @returns A pre-signed URL for the asset version rendition
     */
    async getPresignedRenditionURL({ size, type }) {
        const response = await this.getCustomRendition({
            size,
            type,
            additionalHeaders: {
                'Accept': 'application/vnd.adobecloud.download+json'
            }
        });
        const res = await response.json();
        return res.href;
    }
    async getPresignedURL() {
        const blockDownloadServiceURL = getURLFromLinks(this.__links, RelType.DOWNLOAD);
        const assetInterface = await this._getAssetInterface();
        return await assetInterface.getBlockDownloadURL(blockDownloadServiceURL);
    }
    async restore() {
        const assetContext = await this._core.getAssetContext();
        const asset = await assetContext.getAssetWithCloudID(this._assetId);
        const isComposite = asset.isComposite;
        if (isComposite) {
            const href = getURLFromLinks(this.__links, RelType.MANIFEST);
            const headInterface = await this._getHeadAssetInterface();
            await headInterface.restoreVersionManifest(href);
            await asset._load();
        }
        else {
            const target = getURLFromLinks(asset.links, RelType.PRIMARY);
            await this.copy(target);
        }
    }
    /**
     * Copy the asset version to the target asset using the target's asset
     * RelType.PRIMARY link.
     *
     * @deprecated Use {@link AssetVersion#copyPrimaryToAsset} instead.
     * @see {@link AssetVersion#copyPrimaryToAsset}
     *
     * @warning - Not currently functioning.
     *
     * @param target - The target HREF of the asset to copy the asset version to.
     * @returns A promise that resolves to the result of the copy operation.
     */
    async copy(target) {
        const assetContext = await this._core.getAssetContext();
        const asset = await assetContext.getAssetWithCloudID(this._assetId);
        const isComposite = asset.isComposite;
        const source = getURLFromLinks(this.__links, RelType.PRIMARY);
        if (isComposite) {
            // Copy for composite assets not yet implemented, JIRA: https://jira.corp.adobe.com/browse/ACPCSS-1875
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'AssetVersion.copy not implemented for composite assets');
        }
        else {
            const headInterface = await this._getHeadAssetInterface();
            const result = await headInterface.runOperation({
                op: 'copy',
                id: this._assetId,
                source: { 'href': source, 'if-match': '*' },
                target: { 'href': target, 'if-match': '*' }
            });
            return result;
        }
    }
    /**
     * Move this version of an asset to an existing asset identified by the targetAssetID.
     * Currently this is implemented by copying the asset version to the target asset and then
     * permanently deleting the version from the source asset. In the future we should ask
     * the platform to support this operation directly.
     *
     * @param targetAssetID - The target asset ID of the asset to move the asset version to.
     * @param deleteHeadAssetIfLastVersion - If true, delete the head asset when this version is the last. RAPI
     * won't allow the last version to be deleted, so if needed, this will delete the head asset which will
     * also delete the last version.
     */
    async moveToAsset(targetAssetID, deleteHeadAssetIfLastVersion = false) {
        await this.copyPrimaryToAsset(targetAssetID);
        await this.permanentlyDelete(deleteHeadAssetIfLastVersion);
    }
    /**
     * Permanently delete this version of an asset and it's representation
     * in the local asset pool (in memory cache).
     *
     * @param deleteHeadAssetIfLastVersion - If true, delete the head asset when this version is the last. RAPI
     * won't allow the last version to be deleted, so if needed, this will delete the head asset which will
     * also delete the last version.
     */
    async permanentlyDelete(deleteHeadAssetIfLastVersion = false) {
        const headInterface = await this._getHeadAssetInterface();
        const assetContext = await this._core.getAssetContext();
        const headAsset = assetContext._assetPool.getLocalItemById(this._assetId);
        try {
            await headInterface.patchVersion([{
                    op: VersionPatchTypes.remove,
                    path: `/children/version=${this.versionId}`
                }]);
        }
        catch (e) {
            if (!isSAMError(e)) {
                throw e;
            }
            const samError = e;
            /**
             * @TODO SAMJS-604: Once the actual response body is confirmed from RAPI
             * we can use that to check for the problem type instead of a blanket
             * check for ACCESS_DENIED.
             *
             * @note Seems odd that we would say it's ACCESS_DENIED when it's really
             * when it's really FORBIDDEN_OPERATION.
             */
            if (samError.code !== SAMErrorCode.ACCESS_DENIED
                || !deleteHeadAssetIfLastVersion) {
                throw e;
            }
            if (headAsset) {
                await headAsset.permanentlyDelete();
            }
        }
        // If the asset is not found, that means there isn't a version to delete.
        // since the head asset doesn't exist locally.
        if (!headAsset) {
            return;
        }
        const session = headAsset._versionPool.createUpdateSession();
        session.queueDiscardedItem(this);
        session.commit();
    }
    /**
     * Copy this version of an asset to an existing asset identified by the targetAssetID.
    * @deprecated Use {@link AssetVersion#copyPrimaryToAsset} instead.
     * @see {@link AssetVersion#copyPrimaryToAsset}
     *
     * @note this method does not fetch the repository metadata and other data
     * from the services for the targetAssetID. If the targetAssetID does not
     * exist the services will throw an error, which will bubble up to the caller.
     *
     * @param targetAssetID - The target asset ID of the asset to copy the asset version to.
     * @returns A promise that resolves to the result of the copy operation.
     */
    async copyToAsset(targetAssetID) {
        const headInterface = await this._getHeadAssetInterface();
        await headInterface.runOperationWithEmptyResponse({
            op: 'copy_resources',
            source: {
                'repo:assetId': this._assetId,
                'repo:version': this.versionId
            },
            target: {
                'repo:assetId': targetAssetID
            },
            resources: [
                {
                    reltype: RelType.PRIMARY
                },
            ]
        });
    }
    /**
     * Copy this version of an asset to an existing asset identified by the targetAssetID.
     *
     * @note this method does not fetch the repository metadata and other data
     * from the services for the targetAssetID. If the targetAssetID does not
     * exist the services will throw an error, which will bubble up to the caller.
     *
     * @param targetAssetID - The target asset ID of the asset to copy the asset version to.
     * @returns A promise that resolves to the result of the copy operation.
     */
    async copyPrimaryToAsset(targetAssetID) {
        await this.copyToAsset(targetAssetID);
    }
    /**
     * Copy this version of an asset to a new asset.
     *
     * @param newAssetPath - The path of the new asset.
     * @param newAssetName - The name of the new asset.
     * @param repositoryId - The repository ID of the new asset.
     * @returns A promise that resolves to the new asset as an AdobeAsset instance.
     */
    async copyToNewAsset(newAssetPath, newAssetName, repositoryId) {
        const headInterface = await this._getHeadAssetInterface();
        const result = await headInterface.runOperation({
            op: 'copy',
            source: {
                'repo:assetId': this._assetId,
                'repo:version': this.versionId
            },
            target: {
                'repo:path': newAssetPath + '/' + newAssetName,
                'repo:repositoryId': repositoryId
            }
        });
        if (!result.asset) {
            throw SAMError.create(SAMErrorCode.UNKNOWN, 'Failed to copy asset version');
        }
        const assetContext = await this._core.getAssetContext();
        const session = assetContext._assetPool.createUpdateSession();
        const asset = assetContext._adobeAssetUpdater.updateRemoteItem(session, result.asset);
        session.commit();
        return asset;
    }
    async setMilestone(_a) {
        var _b, _c;
        var { label = ((_b = this.milestone) === null || _b === void 0 ? void 0 : _b.label) || '', description = ((_c = this.milestone) === null || _c === void 0 ? void 0 : _c.description) || '' } = _a;
        const jsonParams = createMilestoneJsonParams(this.versionId, !!this.milestone, label, description);
        const headInterface = await this._getHeadAssetInterface();
        await headInterface.patchVersion(jsonParams);
        const assetContext = await this._core.getAssetContext();
        const asset = await assetContext.getAssetWithCloudID(this._assetId);
        const session = asset._versionPool.createUpdateSession();
        VersionUpdater.updateLocalItem(session, this, {
            milestone: {
                label,
                description
            }
        });
        session.commit();
    }
    async removeMilestone() {
        if (!this.milestone) {
            return;
        }
        const jsonParams = [{
                op: VersionPatchTypes.remove,
                path: `/children/version=${this.versionId}/milestone`,
            }];
        const headInterface = await this._getHeadAssetInterface();
        await headInterface.patchVersion(jsonParams);
        const assetContext = await this._core.getAssetContext();
        const asset = await assetContext.getAssetWithCloudID(this._assetId);
        const session = asset._versionPool.createUpdateSession();
        VersionUpdater.updateLocalItem(session, this, {
            milestone: {
                label: ''
            }
        });
        session.commit();
    }
}
__decorate([
    observable$1
], AssetVersion.prototype, "assetId", null);
__decorate([
    observable$1
], AssetVersion.prototype, "created", null);
__decorate([
    observable$1
], AssetVersion.prototype, "createdBy", null);
__decorate([
    observable$1
], AssetVersion.prototype, "links", null);
__decorate([
    observable$1
], AssetVersion.prototype, "milestone", null);
__decorate([
    observable$1
], AssetVersion.prototype, "name", null);
__decorate([
    observable$1
], AssetVersion.prototype, "versionId", null);
__decorate([
    observable$1
], AssetVersion.prototype, "getRenditionURL", null);
__decorate([
    observable$1
], AssetVersion.prototype, "renditionURLStatus", null);
const VersionUpdater = new ItemUpdater({
    localItemType: AssetVersion,
    remoteIdProperty: 'version',
    propertyUpdater: new PropertyUpdater({
        '_createdAt': { name: 'created', format: 'date' },
        '_createdBy': 'created_by',
        '_label': 'milestone.label',
        '_description': 'milestone.description',
        '_assetId': 'assetId',
        '_assetEtag': 'assetEtag',
        '_assetLinks': { name: 'assetLinks', format: 'object' },
        '__links': { name: '_links', format: 'object' },
        '_name': 'repo:deviceAssetName',
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AssetVersionLoader {
    constructor(_versionPool, _assetInterfacePromise) {
        this._versionPool = _versionPool;
        this._assetInterfacePromise = _assetInterfacePromise;
    }
    async loadPage(options, start) {
        return await this._loadPage(options, start);
    }
    async _loadPage(options, start) {
        var _a;
        const { limit } = options;
        // We will ignore the update if we had local changes sooner than this timestamp.
        const latency = this._versionPool._core._environment.getValue('VERSIONS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const assetInterface = await this._assetInterfacePromise;
        const filter = options.filter;
        const version = (filter === null || filter === void 0 ? void 0 : filter.version) || undefined;
        const result = await assetInterface.getVersions({ start, limit, version });
        const session = this._versionPool.createLoaderUpdateSession(mostRecentValidMutation);
        const versions = result.children.map((version) => (Object.assign(Object.assign({}, version), { 
            // assetId, assetEtag, assetLinks are needed to construct the AssetInterface for the AssetVersion
            assetId: assetInterface.assetID, assetEtag: assetInterface.etag, assetLinks: assetInterface.links })));
        const items = VersionUpdater.updateRemoteItems(session, versions);
        session.commit();
        // Check if we have another page to load.
        let loadNextPage;
        const currentCount = result.children.length;
        // TODO: unit test to ensure this doesn't throw an exception if there are 0 pages
        const nextStart = (_a = result.children[currentCount - 1]) === null || _a === void 0 ? void 0 : _a.created;
        if (nextStart && limit && currentCount === limit) {
            loadNextPage = (options) => this._loadPage(options, nextStart);
        }
        return {
            items,
            total: result.total_children,
            loadNextPage,
            mostRecentValidMutation
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function updateLastKnownClientMutationValues(item) {
    item.updateLastKnownClientMutation();
}
function updateLastKnownClientMutationKeys(_, item) {
    item.updateLastKnownClientMutation();
}
class UpdateSession {
    constructor(_core, _delegate, updateContext, mostRecentValidMutation, type = 'fetch') {
        this._core = _core;
        this._delegate = _delegate;
        this.updateContext = updateContext;
        this.mostRecentValidMutation = mostRecentValidMutation;
        this.type = type;
    }
    get hasChanges() {
        return Boolean(this._addedItems || this._changedItems || this._discardedItems);
    }
    get addedItems() {
        return this._addedItems && Array.from(this._addedItems.values());
    }
    get changedItems() {
        return this._changedItems && Array.from(this._changedItems.keys());
    }
    get discardedItems() {
        return this._discardedItems && Array.from(this._discardedItems);
    }
    get changedItemsWithEvents() {
        return this._changedItems && Array.from(this._changedItems);
    }
    checkIfItemAllowsMutations(item) {
        const { lastKnownClientMutation } = item;
        const { mostRecentValidMutation } = this;
        // Return false only when the item has a mutation time that is more recent than the
        // window of latency that the server APIs can guarantee.
        return !lastKnownClientMutation || !mostRecentValidMutation || lastKnownClientMutation < mostRecentValidMutation;
    }
    ensureItemIsAdded(item) {
        var _a;
        const { id } = item;
        if (((_a = this._addedItems) === null || _a === void 0 ? void 0 : _a.get(id)) === item) {
            // It was already part of this session.
            return;
        }
        // Check if we already had it in the pool. If it was discarded before,
        // then we want to recover it by adding it again.
        const delegate = this._delegate;
        const existingItem = delegate.getLocalItemById(id);
        if (existingItem && existingItem !== item) {
            // Note: This is typically caused by using updateLocalItem in an async function after some `await`
            //            statement. While waiting, some other process causes the item to be added to the ItemPool
            //            under the same ID. Using updateRemoteItem ensures that only the current item in the pool
            //            is updated; however, changing `updateLocalItem(session, this, ...)` to updateRemoteItem could cause
            //            an instance other than `this` to be updated.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Item with id ${id} does not match the item with this id in the item pool`);
        }
        if (existingItem && !delegate.isItemDiscarded(item)) {
            return;
        }
        // Finally, let's just add this item again.
        this.queueAddedItem(item);
    }
    reindexItem(item, oldId, newId) {
        item._setId(newId);
        this.queueChangedItem(item, [SharedChangeEvent]);
        // Updates the key in the key-item cache
        this._delegate.reindexItem(item, oldId, newId);
    }
    queueAddedItem(item) {
        var _a;
        let addedItems = this._addedItems;
        if (!addedItems) {
            addedItems = new Map();
            this._addedItems = addedItems;
        }
        addedItems.set(item.id, item);
        // Make sure we don't send any changed events on new items.
        (_a = this._changedItems) === null || _a === void 0 ? void 0 : _a.delete(item);
    }
    queueChangedItem(item, events = [SharedChangeEvent]) {
        var _a;
        if ((_a = this._addedItems) === null || _a === void 0 ? void 0 : _a.has(item.id)) {
            // We don't send any events on new items.
            return;
        }
        let changedItems = this._changedItems;
        if (!changedItems) {
            changedItems = new Map();
            this._changedItems = changedItems;
        }
        let itemEvents = changedItems.get(item);
        if (!itemEvents) {
            itemEvents = new Set();
            changedItems.set(item, itemEvents);
        }
        events.forEach((event) => itemEvents === null || itemEvents === void 0 ? void 0 : itemEvents.add(event));
    }
    /**
     * Marks an item for discard by adding it to a WeakSet holding pen.
     * - On `commit()`, the item is removed from lists and itemPool.
     * - The item is garbage collected once no direct references remain.
     * - Prevents undefined errors while async processes settle.
     *
     * **Scenario 1: When Clients Do NOT Need Notification (Standard Removal)**
     * - Use this when removing an item from a list, **but no explicit client notification is needed**.
     * - Example: Item no longer belongs in the list.
     * - The item is removed from lists but stays in the holden pen and pool temporarily for safety.
     *
     * **Scenario 2: When Clients DO Need Notification (Permanent Delete or Unshare)**
     * - If `updateLocal/RemoteItem()` is called first (e.g., setting `Permission.None` to revoke access),
     *   the item is **not** added to the holding pen and remains in the pool.
     * - This ensures clients (in 1Up or Editor views) get an event to handle permission loss.
     * - 🚨 In this case, **manually call `removeLocalItems([item.id])`** after to remove it from the pool.
     *
     * Note: If there is a new use case for removing an Item and notifying clients other than AdobeAsset access loss,
     * we should add a more generalized "access lost" status and event in ItemBase. Reach out to SAM.js core team if you run into this need.
     */
    queueDiscardedItem(item) {
        let discardedItems = this._discardedItems;
        if (!discardedItems) {
            discardedItems = new Set();
            this._discardedItems = discardedItems;
        }
        discardedItems.add(item);
    }
    getItemById(id) {
        var _a;
        return ((_a = this._addedItems) === null || _a === void 0 ? void 0 : _a.get(id)) || this._delegate.getLocalItemById(id);
    }
    commit() {
        var _a, _b;
        // Committing the update session first to make sure the pool is up-to-date
        // with the latest changes before we move control back to the client code.
        this._delegate.commitUpdateSession(this);
        // Dispatch all events on the changed items.
        const changedItems = this._changedItems;
        if (changedItems) {
            for (const [item, events] of changedItems.entries()) {
                for (const event of events) {
                    item.dispatch(event);
                }
            }
        }
        if (this.type === 'mutation') {
            // If this was the result of a mutation change, then we have to update the timestamps
            // of all the items that were used.
            (_a = this._addedItems) === null || _a === void 0 ? void 0 : _a.forEach(updateLastKnownClientMutationValues);
            (_b = this._discardedItems) === null || _b === void 0 ? void 0 : _b.forEach(updateLastKnownClientMutationValues);
            changedItems === null || changedItems === void 0 ? void 0 : changedItems.forEach(updateLastKnownClientMutationKeys);
        }
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const ITEMS_CHANGED = 'itemsChanged';
class ItemsChangedEvent extends SAMEvent {
    constructor(addedItems, changedItems, discardedItems, updateContext) {
        super(ITEMS_CHANGED);
        this.addedItems = addedItems;
        this.changedItems = changedItems;
        this.discardedItems = discardedItems;
        this.updateContext = updateContext;
    }
}
function compareDelegatesByPriority(a, b) {
    if (a.priority === b.priority) {
        return 0;
    }
    return a.priority === 'list' ? -1 : 1;
}
/**
 * The ItemPool class is used to keep unique references in memory for objects that
 * represent cloud items like assets, teams or spaces.
 * The ItemPool helps with mapping between a remote id and a local reference in memory.
 *
 * On supported browsers the pool uses the WeakRef object to keep the objects alive.
 * only as long as they are used by the application.
 */
class ItemPool extends TypedEventEmitter {
    constructor(_core, type) {
        super();
        this._core = _core;
        this.type = type;
        this._objectsById = new Map();
        this._discardedObjects = new WeakSet();
        this._delegates = [];
        this._hasUnsortedDelegates = false;
        /**
         * Looks up the item in the local in-memory storage.
         * The items are stored used WeakRef to avoid leaking. The client of this
         * method is responsible with keeping these objects alive for as long as
         * they are needed.
         * @param id
         * @returns
         */
        this.getLocalItemById = (id) => {
            const ref = this._getObjectsById().get(id);
            return ref === null || ref === void 0 ? void 0 : ref.deref();
        };
        /**
         * Fully removes items from the pool when `queueDiscardedItem()` alone is not sufficient.
         *
         * Normally, `queueDiscardedItem()` will remove an Item from the ItemPool, but it does not when it has been
         * modified in the same UpdateSession (using `updateLocalItem()` or `updateRemoteItem()`). When this occurs, you will need to call
         * `removeLocalItems()` afterwards to ensure the Item is fully removed from the pool.
         * This scenario typically occurs when an Item is permanently deleted or unshared
         * because we first need to update the permissions to None before removing in the same session.
         * Calling `removeLocalItems()` will prevent stale items from remaining in the pool after this update,
         * and ensure `getAssetWithCloudID()` returns `NOT_FOUND` instead of returning an item that has broken APIs.
         *
         * To ensure full removal, use:
         *     ```
         *     updateLocalItem(session, item, { effectivePermission: Permission.None });
         *     queueDiscardedItem(item);
         *     removeLocalItems([item.id]);  // Ensures full removal from the pool
         *     ```
         * If you are NOT updating the item in the same session, you only need to call `queueDiscardedItem()`.
         * 🚨 ** Calling `removeLocalItems()` without calling `queueDiscardedItem()` will NOT remove the Item from ItemLists. **
         */
        this.removeLocalItems = (ids) => {
            if (Array.isArray(ids)) {
                ids.forEach((id) => {
                    this._objectsById.delete(id);
                });
                return;
            }
            this._objectsById.delete(ids);
        };
        this.isItemDiscarded = (item) => {
            return this._discardedObjects.has(item);
        };
        this.reindexItem = (item, oldId, newId) => {
            if (oldId !== newId) {
                this._objectsById.set(newId, new WeakRef$1(item));
                this._objectsById.delete(oldId);
            }
        };
        this._updateSessionDelegate = () => {
            return {
                getLocalItemById: this.getLocalItemById,
                isItemDiscarded: this.isItemDiscarded,
                reindexItem: this.reindexItem,
                commitUpdateSession: (session) => {
                    if (!session.hasChanges) {
                        return;
                    }
                    const objectsById = this._objectsById;
                    const discardedObjects = this._discardedObjects;
                    // Make a note about discarded objects.
                    const { discardedItems } = session;
                    if (discardedItems) {
                        for (const item of discardedItems) {
                            discardedObjects.add(item);
                        }
                    }
                    // Inject the new items in the local map.
                    const { addedItems } = session;
                    if (addedItems) {
                        for (const item of addedItems) {
                            objectsById.set(item.id, new WeakRef$1(item));
                            discardedObjects.delete(item);
                        }
                    }
                    const event = new ItemsChangedEvent(session.addedItems, session.changedItems, session.discardedItems, session.updateContext);
                    const delegates = this._delegates;
                    if (this._hasUnsortedDelegates) {
                        delegates.sort(compareDelegatesByPriority);
                        this._hasUnsortedDelegates = false;
                    }
                    let hasEmptyWeakRefs = false;
                    for (const delegateRef of delegates) {
                        const delegate = delegateRef.delegate.deref();
                        if (!delegate) {
                            // Remember to filter out the expired weak refs.
                            hasEmptyWeakRefs = true;
                            continue;
                        }
                        //We wanted to add a custom IdType for type safety for combined id's, which is why there's an IdType on the ItemPool
                        //  However, to avoid piping the IdType through the entire ItemPool and UpdateSession, we're cutting off the
                        //  fanout from that change here.  It should be fine because IdType extends string.
                        //@ts-expect-error
                        delegate.onItemsUpdated(event, this);
                    }
                    if (hasEmptyWeakRefs) {
                        // Make another pass and keep only the delegates that are still alive.
                        this._delegates = delegates.filter((ref) => ref.delegate.deref());
                    }
                    this.dispatch(event);
                }
            };
        };
    }
    _getObjectsById() {
        return this._objectsById;
    }
    /**
     * Creates an UpdateSession instance for add/update/delete of models in the SAM system, outside of ItemLoaders.
     * UpdateSessions let you delay firing events until you're ready to notify clients via the commit--typically
     * right after updating the model with remote data via one or more ItemUpdaters.
     *
     * @param updateContext {string} (optional) Useful to identify what is causing a particular change, especially
     *        in ItemPool delegates.
     * @param mostRecentValidMutation {number} (optional) Determines if UpdateSession will allow the update (see
     *        {@link createLoaderUpdateSession})
     */
    createUpdateSession(updateContext, mostRecentValidMutation) {
        return new UpdateSession(this._core, this._updateSessionDelegate(), updateContext, mostRecentValidMutation);
    }
    /**
     * For use in USS-based ItemLoaders.
     *
     * @param mostRecentValidMutation {number} UpdateSession only allows changes to items that that have a
     *        `lastKnownClientMutation` before this timestamp. Since USS index lag can cause data to be 2-3 seconds
     *        stale, all USS-based ItemLoaders *must* pass `mostRecentValidMutation` of
     *        `Date.now() - core._environment.getValue('USS_LIST_UPDATE_LATENCY')`
     */
    createLoaderUpdateSession(mostRecentValidMutation) {
        return new UpdateSession(this._core, this._updateSessionDelegate(), LOADER_UPDATE_CONTEXT, mostRecentValidMutation);
    }
    /**
     * Creates an UpdateSession for add/update/delete of models in the SAM system that get tracked as
     * `item.lastKnownClientMutation`. Used when the data source is the "source of truth" for this model, in order to
     * prevent stale data from overwriting it. E.g., for AdobeAsset, it should be used when loading a single Asset
     * from R-API.
     */
    createMutationSession() {
        return new UpdateSession(this._core, this._updateSessionDelegate(), undefined, undefined, 'mutation');
    }
    /**
     * Creates an UpdateSession for ItemLoader implementations, as well as updates `item.lastKnownClientMutation`
     * when models are added/updated/deleted. Used when the data source is the "source of truth" for this model,
     * in order to prevent stale data from overwriting it via `create*UpdateSession()`.
     */
    createLoaderMutationSession() {
        return new UpdateSession(this._core, this._updateSessionDelegate(), LOADER_UPDATE_CONTEXT, undefined, 'mutation');
    }
    /**
     * Adds a delegate to receive notifications when items change.
     * The delegates cannot be removed, so the connection is alive
     * as long as both the pool and the delegate are still referenced.
     * The client must ensure the delegate is kept alive until the events
     * are not necessary anymore.
     *
     * Performance: Adding too many delegates can obviously hurt performance.
     * Make sure that the callbacks on the delegate are as fast as possible.
     * If the user is not interested in any updates, it is best to make a note
     * that the list is dirty and return as quick as possible. Make sure to delay
     * any of the actual work until the data is requested by the client.
     *
     * Note that we are not adding this on top of the event dispatcher to avoid
     * making the weak ref model a wide spread solution across the repo.
     *
     * @param delegate
     */
    addDelegate(delegate, priority) {
        this._delegates.push({ priority, delegate: new WeakRef$1(delegate) });
        this._hasUnsortedDelegates = true;
    }
    forEach(fn) {
        const objectsById = this._objectsById;
        for (const [key, itemRef] of objectsById) {
            const item = itemRef.deref();
            if (!item) {
                // Make sure to cleanup the interface while we do this.
                objectsById.delete(key);
                continue;
            }
            fn(item);
        }
    }
    map(fn) {
        const results = [];
        this.forEach((item) => {
            results.push(fn(item));
        });
        return results;
    }
    /**
     * Returns all items currently in the ItemPool as an Array
     */
    toArray() {
        return this.map(item => item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class FileContentResource extends AdobeAssetResource {
    constructor(_core, _parent) {
        super(_core, _parent, {
            parseResponse: async (response) => await response.blob()
        });
        this._core = _core;
        this._parent = _parent;
    }
    async _loadData() {
        await this._parent._ensureLink(RelType.PRIMARY);
        const assetInterface = await this._parent._getAssetInterface();
        await assetInterface.getContent(this);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AssetVersionFilter {
    constructor(options) {
        this._isMilestone = options === null || options === void 0 ? void 0 : options.isMilestone;
        this._createdAfter = options === null || options === void 0 ? void 0 : options.createdAfter;
        this._createdBefore = options === null || options === void 0 ? void 0 : options.createdBefore;
        this._createdBy = options === null || options === void 0 ? void 0 : options.createdBy;
        this._version = options === null || options === void 0 ? void 0 : options.version;
    }
    static AssetVersionFilter(isMilestone, createdAfter, createdBefore, createdBy, version) {
        return new AssetVersionFilter({
            createdBy,
            createdAfter,
            createdBefore,
            isMilestone,
            version
        });
    }
    get isMilestone() {
        return this._isMilestone;
    }
    get createdBy() {
        return this._createdBy;
    }
    get createdAfter() {
        return this._createdAfter;
    }
    get createdBefore() {
        return this._createdBefore;
    }
    get version() {
        return this._version;
    }
    get hash() {
        var _a, _b, _c;
        const collaborator = (_a = this.createdBy) === null || _a === void 0 ? void 0 : _a.join(',');
        const createdAfter = ((_b = this.createdAfter) === null || _b === void 0 ? void 0 : _b.getTime()) || 0;
        const createdBefore = ((_c = this.createdBefore) === null || _c === void 0 ? void 0 : _c.getTime()) || 0;
        const version = this.version || undefined;
        return String(this.isMilestone) + ':'
            + collaborator + ':'
            + createdAfter + ':' + createdBefore + ':' + version;
    }
    matches(item) {
        const matchesBookmark = this.isMilestone === undefined || this.isMilestone === Boolean(item.milestone);
        const matchesCollab = this.createdBy === undefined || this.createdBy.includes(item.createdBy);
        const matchesDateRange = (!this.createdAfter || item.created >= this.createdAfter) && (!this.createdBefore || item.created <= this.createdBefore);
        const matchesVersion = this.version === undefined || this.version === item.versionId;
        return matchesBookmark && matchesCollab && matchesDateRange && matchesVersion;
    }
    _getRelationWrtMilestone(other) {
        return this.isMilestone === other.isMilestone ? 'subset' : this.isMilestone === undefined || other.isMilestone === undefined ? 'unknown' : 'disjoint';
    }
    _getRelationWrtCreatedBy(other) {
        if (!this.createdBy && !other.createdBy) {
            return 'subset';
        }
        if (this.createdBy && other.createdBy) {
            const createdBy = new Set(this.createdBy);
            if (other.createdBy.every(user => createdBy.has(user))) {
                // Every user in the other filter is also in this filter, so this filter is a subset
                return 'subset';
            }
            if (!other.createdBy.some(user => createdBy.has(user))) {
                // No user in the other filter is in this filter, so the intersection is empty
                return 'disjoint';
            }
            return 'unknown';
        }
        return this.createdBy ? 'subset' : 'unknown';
    }
    _getRelationWrtDateRange(other) {
        var _a, _b, _c, _d;
        const thisRange = { start: ((_a = this.createdAfter) === null || _a === void 0 ? void 0 : _a.getTime()) || -Infinity, end: ((_b = this.createdBefore) === null || _b === void 0 ? void 0 : _b.getTime()) || Infinity };
        const otherRange = { start: ((_c = other.createdAfter) === null || _c === void 0 ? void 0 : _c.getTime()) || -Infinity, end: ((_d = other.createdBefore) === null || _d === void 0 ? void 0 : _d.getTime()) || Infinity };
        if (otherRange.start <= thisRange.start && otherRange.end >= thisRange.end) {
            // other contains all dates, or both ranges contain all dates
            return 'subset';
        }
        if (otherRange.start > thisRange.end || otherRange.end < thisRange.start) {
            // there is no overlap
            return 'disjoint';
        }
        // the only remaining possibility is that there's some overlap
        return 'unknown';
    }
    _getRelationWrtVersion(other) {
        if (this.version === other.version) {
            return 'subset';
        }
        if (this.version === undefined || other.version === undefined) {
            return 'unknown';
        }
        return 'disjoint';
    }
    getRelationToFilter(other) {
        const relations = [
            this._getRelationWrtMilestone(other),
            this._getRelationWrtCreatedBy(other),
            this._getRelationWrtDateRange(other),
            this._getRelationWrtVersion(other)
        ];
        if (relations.includes('disjoint')) {
            return 'disjoint';
        }
        if (relations.every(relation => relation === 'subset')) {
            return 'subset';
        }
        // only remaining possibility is 'unknown'
        return 'unknown';
    }
}
AssetVersionFilter.BookmarkedVersions = new AssetVersionFilter({
    isMilestone: true
});

var AssetVersionFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': AssetVersionFilter
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ImplicitDirectoryListingFilter extends ImplicitAdobeAssetFilterBase {
    constructor(options) {
        const { asset } = options, superOptions = __rest$2(options, ["asset"]);
        super(superOptions);
        this._asset = asset;
    }
    get asset() {
        return this._asset;
    }
    matches(item) {
        // Only check repositoryID if defined
        // TODO: this was to fix a USS bug that doesn't exist anymore, should it always verify repositoryID?
        if (this._asset.repositoryID && item.repositoryID
            && this._asset.repositoryID !== item.repositoryID) {
            return false;
        }
        // check item is a direct child of current asset
        const assetRepoPath = this._asset.repoPath;
        if (assetRepoPath && (assetRepoPath !== item.repoPath.substring(0, item.repoPath.lastIndexOf('/')))) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function addProjectIdToMetadata(metadata, parentId) {
    var _a, _b, _c, _d;
    metadata._embedded || (metadata._embedded = {});
    (_a = metadata._embedded)[_b = RelType.APP_METADATA] || (_a[_b] = {});
    (_c = metadata._embedded[RelType.APP_METADATA])['cc:inherited'] || (_c['cc:inherited'] = {});
    (_d = metadata._embedded[RelType.APP_METADATA]['cc:inherited'])['cc:team'] || (_d['cc:team'] = {});
    metadata._embedded[RelType.APP_METADATA]['cc:inherited']['cc:team']['repo:assetId'] = parentId;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class RepoMetadataResource extends AdobeAssetResource {
    constructor(_core, _parent) {
        super(_core, _parent, {
            onChange: async (repoMetadata) => {
                var _a;
                if (repoMetadata) {
                    try {
                        const assetId = repoMetadata['repo:assetId'];
                        const links = repoMetadata._links;
                        const etag = repoMetadata['repo:etag'];
                        // Update the persistent cache with the updated links (by ID, because paths change)
                        const resolveHref = this._core.hostAssetContext._rapi.getAssetResolveByIdHref(assetId);
                        await this._core._environment.cache.setItem(resolveHref, { links, etag });
                    }
                    catch (e) {
                        // it is not a failure if we're unable to update the persistent cache
                    }
                }
                await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._handleResourceUpdates({ repoMetadata }));
            },
            onError: async (error) => {
                var _a;
                await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._handleResourceUpdates({ error }));
            }
        });
        this._core = _core;
    }
    async _loadData() {
        var _a, _b;
        await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._ensureLink(RelType.REPO_METADATA));
        const assetInterface = await ((_b = this._parent) === null || _b === void 0 ? void 0 : _b._getAssetInterface());
        await (assetInterface === null || assetInterface === void 0 ? void 0 : assetInterface.getRepoMetadata(this));
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class EffectivePermissionsResource extends AdobeAssetResource {
    constructor(_core, _parent) {
        super(_core, _parent, {
            parseResponse: async (response) => parseEffectivePermissions(await response.json()),
            onChange: async (effectivePermission) => {
                var _a;
                await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._handleResourceUpdates({ effectivePermission }));
            },
            onError: async (error) => {
                var _a;
                await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._handleResourceUpdates({ error }));
                this._error = undefined; // If we got this far, the error was a 404/403, which is not fatal for permissions.
            }
        });
        this._core = _core;
    }
    async _loadData() {
        var _a, _b;
        await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._ensureLink(RelType.AC_EFFECTIVE));
        const assetInterface = await ((_b = this._parent) === null || _b === void 0 ? void 0 : _b._getAssetInterface());
        await (assetInterface === null || assetInterface === void 0 ? void 0 : assetInterface.getEffectivePermissions(this));
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * ACPLModelInterface interface wraps window.acplModel, which is available on some desktop surfaces:
 * - CCD, via SAM.cpp
 * - UXP, via SAM.cpp (or polyfilled in webviews)
 */
class ACPLModelInterface {
    constructor(_core) {
        this._core = _core;
        this.acplModel = getACPLModel();
        /**
         * @package -- only for use in SAM.js
         */
        this.localAssetUpdater = LocalAdobeAssetUpdater;
    }
    /**
     * Get an AdobeAsset from a localID or cloudID, if ACPL contains information about that asset.
     * On web, or if ACPL is not available, returns undefined.
     */
    async getLocalAsset(assetId) {
        var _a, _b;
        if (!this.acplModel) {
            return undefined;
        }
        const localAssets = await ((_b = (_a = this.acplModel).getLocalAssets) === null || _b === void 0 ? void 0 : _b.call(_a));
        const localAsset = localAssets === null || localAssets === void 0 ? void 0 : localAssets.find(asset => asset['repo:assetId'] === assetId || asset.localID === assetId);
        if (localAsset) {
            const session = this._core._getAssetPool().createUpdateSession();
            const asset = this.localAssetUpdater.updateRemoteItem(session, localAsset);
            session.commit();
            return asset;
        }
    }
    get supportsDownloadComposite() {
        var _a;
        return ((_a = this.acplModel) === null || _a === void 0 ? void 0 : _a.downloadComposite) !== undefined;
    }
    get supportsUnpin() {
        var _a;
        return ((_a = this.acplModel) === null || _a === void 0 ? void 0 : _a.unpin) !== undefined;
    }
    get supportsLocalAssets() {
        var _a;
        return ((_a = this.acplModel) === null || _a === void 0 ? void 0 : _a.getLocalAssets) !== undefined;
    }
    async downloadComposite(cloudID) {
        var _a, _b;
        return (_b = (_a = this.acplModel) === null || _a === void 0 ? void 0 : _a.downloadComposite) === null || _b === void 0 ? void 0 : _b.call(_a, cloudID);
    }
    async unpin(cloudID) {
        var _a, _b;
        return (_b = (_a = this.acplModel) === null || _a === void 0 ? void 0 : _a.unpin) === null || _b === void 0 ? void 0 : _b.call(_a, cloudID);
    }
    async getLocalAssets() {
        var _a, _b, _c;
        return ((_c = await ((_b = (_a = this.acplModel) === null || _a === void 0 ? void 0 : _a.getLocalAssets) === null || _b === void 0 ? void 0 : _b.call(_a))) !== null && _c !== void 0 ? _c : []);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class LocalAssetLoader {
    constructor(_assetPool, _core, acplModelInterface = new ACPLModelInterface(_core)) {
        this._assetPool = _assetPool;
        this._core = _core;
        this.acplModelInterface = acplModelInterface;
    }
    supportsFilter(filter) {
        return filter !== undefined;
    }
    async loadPage(_options) {
        const cachedAssets = await this.acplModelInterface.getLocalAssets();
        const mostRecentValidMutation = Date.now();
        const session = this._assetPool.createLoaderUpdateSession(mostRecentValidMutation);
        const items = this._core._adobeAssetFactory.assetsFromLocalMetadata(session, cachedAssets);
        session.commit();
        // Assets with only local data may be filtered out of active lists (e.g. a lack of repoPath in directory filters).
        // This puts them at risk of being garbage-collected before sibling loaders have a chance to fill out those models
        // with remote data. To prevent this, we keep a reference to them in memory, which persists until we reload the list.
        items.map(item => KeepAliveManager.getInstance().add(item));
        return {
            items
        };
    }
}

const isGenerationHistoryAsset = (asset) => {
    return [GENERATION_HISTORY_IMAGE_MEDIA_TYPE, GENERATION_HISTORY_VIDEO_MEDIA_TYPE].includes(asset.mediaType);
};
const getHistoryAssetType = (asset) => {
    return MEDIA_TO_HISTORY_ASSET_TYPE[asset.mediaType];
};
const makeComponentURL = async (componentData, asset, forceBlockDownload) => {
    await asset._ensureLink(RelType.COMPONENT);
    if (componentData.length < getBlockTransferThreshold(asset.links, DEFAULT_MAX_SINGLE_TRANSFER_SIZE) && !forceBlockDownload) {
        return {
            url: getURLFromLinks(asset.links, RelType.COMPONENT, { 'component_id': componentData.id, 'revision': componentData.revision }),
            isBlockDownload: false,
            componentId: componentData.id
        };
    }
    // Return block download URL for assets > BlockTransferThreshold, OR when client has requested to force a block download URL (this allow us to
    // return a presigned URL for assets < BlockTransferThreshold).
    await asset._ensureLink(RelType.DOWNLOAD);
    const downloadURL = getURLFromLinks(asset.links, RelType.DOWNLOAD, { resource: JSON.stringify({ 'component_id': componentData.id, 'revision': componentData.revision, reltype: RelType.COMPONENT }) });
    const assetInterface = await asset._getAssetInterface();
    return {
        url: await assetInterface.getBlockDownloadURL(downloadURL),
        isBlockDownload: true,
        componentId: componentData.id
    };
};
const getGenerationModelDisplayName = (asset) => {
    return asset._getGenerationModelDisplayName();
};
/******************** from app metadata *******************/
const getGenerationGroupId = (asset) => {
    var _a, _b;
    return (_b = (_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) === null || _b === void 0 ? void 0 : _b.generationGroupId;
};
const getPrompt = (asset) => {
    var _a, _b;
    return (_b = (_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) === null || _b === void 0 ? void 0 : _b.prompt;
};
/**
 * Name of the firefly module used to create the history asset.
 */
const getModule = (asset) => {
    var _a, _b;
    return (_b = (_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) === null || _b === void 0 ? void 0 : _b.module;
};
const isUpscaled = (asset) => {
    var _a, _b, _c;
    const { detailLevel } = (_c = (_b = (_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) === null || _b === void 0 ? void 0 : _b.generationModel) !== null && _c !== void 0 ? _c : {};
    if (!detailLevel) {
        return;
    }
    return detailLevel === 'full';
};
const getCancelUrl = (asset) => {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) === null || _b === void 0 ? void 0 : _b.status) === null || _c === void 0 ? void 0 : _c.links) === null || _d === void 0 ? void 0 : _d[RelType.MELVILLE_FIREFLY_GENERATION_CANCEL];
};
const getResultUrl = (asset) => {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) === null || _b === void 0 ? void 0 : _b.status) === null || _c === void 0 ? void 0 : _c.links) === null || _d === void 0 ? void 0 : _d[RelType.MELVILLE_FIREFLY_GENERATION_RESULT];
};
const getGenerationState = (asset) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) === null || _b === void 0 ? void 0 : _b.status) === null || _c === void 0 ? void 0 : _c.state;
};
const getSeedInfo = (asset) => {
    var _a, _b, _c, _d, _e, _f;
    if (((_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) && !((_c = (_b = asset.appMetadata.data) === null || _b === void 0 ? void 0 : _b.firefly) === null || _c === void 0 ? void 0 : _c.outputComponents)) {
        // provides a hint for anyone seeing errors for assets created before 2/3 as this data was not being populated
        // before then, and if this data is missing it will break the interface
        throw SAMError.create(SAMErrorCode.NOT_FOUND, `Resource for history asset ${asset.id} not found in app-metadata, asset is corrupt.`);
    }
    return (_f = (_e = (_d = asset.appMetadata.data) === null || _d === void 0 ? void 0 : _d.firefly) === null || _e === void 0 ? void 0 : _e.outputComponents[0]) === null || _f === void 0 ? void 0 : _f.seed;
};
const getGenerationModel = async (asset) => {
    var _a, _b;
    return (_b = (_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly) === null || _b === void 0 ? void 0 : _b.generationModel;
};
const getOutputComponentURL = (asset, forceBlockDownload) => {
    var _a, _b;
    // TODO: changing this to rely on the presence of firefly app metadata instead of isLoaded, as loading from the platform
    // doesn't seem to trigger `isLoaded = true` since it uses _mergeData instead of _setData
    if (!((_a = asset.appMetadata.data) === null || _a === void 0 ? void 0 : _a.firefly)) {
        return;
    }
    const { outputComponents } = ((_b = asset.appMetadata.data) === null || _b === void 0 ? void 0 : _b.firefly) || {};
    if (!outputComponents) {
        // provides a hint for anyone seeing errors for assets created before 2/3 as this data was not being populated
        // before then, and if this data is missing it will break the interface
        throw SAMError.create(SAMErrorCode.NOT_FOUND, `Resource for history asset ${asset.id} not found in app-metadata, asset is corrupt.`);
    }
    // There is only one output component for history assets for now
    // If this changes in the future we can update the return type to be Promise<Record<string, ComponentURL>>
    // to match getInputComponentURLs. We shouldn't do this now because app metadata does not contain the component name
    // which is what we'd want to use as a key for the response object
    const outputComponent = outputComponents[0];
    if (!outputComponent) {
        return;
    }
    // In the manifest the component id's key name is "id", but it is componentId in appMetadata to align with spec
    // schema definitions
    return makeComponentURL(Object.assign(Object.assign({}, outputComponent), { id: outputComponent.componentId }), asset, forceBlockDownload);
};
const getOutputComponentDownloadURL = async (asset, forceBlockDownload) => {
    const outputComponentURL = await getOutputComponentURL(asset, forceBlockDownload);
    if (!outputComponentURL) {
        return;
    }
    const generationHistoryInterface = asset._getGenerationHistoryInterface();
    return generationHistoryInterface.getOutputComponentDownloadURL(outputComponentURL);
};
/******************** from manifest *************************/
/**
 * Given a manifest, return the input component data.
 */
const getInputComponent = async (asset) => {
    var _a, _b;
    if (!asset.manifest.isLoaded) {
        await asset.manifest.load();
    }
    return (_b = (_a = asset.manifest.data) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.find((c) => c.path === 'input');
};
/**
 * Returns the creation payload object FF used to generate this asset, can be found in inputComponent.request
 */
const getGenerationInput = async (asset) => {
    const inputComponent = await getInputComponent(asset);
    // NOTE: this is intentionally left typed as any as we have no control/contract over the shape of this object
    // also the consumers (firefly) of this API are also the ones who create/manage the shape of it, this is just an
    // API to give it back to them for UI reconstruction purposes
    return inputComponent.request;
};
const getInputComponentURLs = async (asset) => {
    const inputComponent = await getInputComponent(asset);
    const response = {};
    if (inputComponent.components) {
        for (const componentData of inputComponent.components) {
            response[componentData.name] = await makeComponentURL(Object.assign(Object.assign({}, componentData), { revision: componentData.version }), asset);
        }
    }
    return response;
};

var utils$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isGenerationHistoryAsset: isGenerationHistoryAsset,
    getHistoryAssetType: getHistoryAssetType,
    makeComponentURL: makeComponentURL,
    getGenerationModelDisplayName: getGenerationModelDisplayName,
    getGenerationGroupId: getGenerationGroupId,
    getPrompt: getPrompt,
    getModule: getModule,
    isUpscaled: isUpscaled,
    getCancelUrl: getCancelUrl,
    getResultUrl: getResultUrl,
    getGenerationState: getGenerationState,
    getSeedInfo: getSeedInfo,
    getGenerationModel: getGenerationModel,
    getOutputComponentURL: getOutputComponentURL,
    getOutputComponentDownloadURL: getOutputComponentDownloadURL,
    getGenerationInput: getGenerationInput,
    getInputComponentURLs: getInputComponentURLs
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function parseLibraryAndElementID(libraryElementID) {
    const parts = libraryElementID.split(':');
    const elementID = parts.pop();
    const libraryID = parts.join(':');
    return [elementID, libraryID];
}
function getLibraryAccessOption(restrictEdit) {
    if (restrictEdit === true) {
        return 'team_view';
    }
    else if (restrictEdit === false) {
        return 'team_edit';
    }
    else {
        return '';
    }
}
/**
 * Given a libraries or elements listing URL, move the supported query params to headers.
 * This avoids extra CORS preflight OPTIONS requests per unique url.
 * @param melvilleUrl - supports both full url and path only, with query params
 * @returns tuple of [path, headers], with the path truncated of the query params that were moved to headers
 */
function moveUrlQueryParamsToHeaders(melvilleUrl) {
    // The below query params are supported as headers
    // Note: 'owner' is supported by libraries list, and 'type' and 'group' is supported for elements list
    const MelvilleParamsAsHeaders = ['start', 'limit', 'selector', 'type', 'orderBy', 'group', 'owner'];
    const [path, query] = melvilleUrl.split('?');
    const urlParams = new URLSearchParams(query); // create obj from query and encode params if they aren't already
    const headers = {};
    MelvilleParamsAsHeaders.forEach(paramAsHeader => {
        const value = urlParams.get(paramAsHeader);
        if (value) {
            headers[paramAsHeader] = value;
            urlParams.delete(paramAsHeader);
        }
    });
    const urlParamsString = `${urlParams}`;
    const url = urlParamsString.length > 0 ? `${path}?${urlParamsString}` : path;
    return [url, headers];
}
// Sort parameters so that the query string is stable, preventing unnecessary cache misses.
const sortParameters$2 = (parameters) => {
    return Object.fromEntries(Object.entries(parameters)
        .map(([key, value]) => {
        if (Array.isArray(value)) {
            return [key, value.sort()];
        }
        return [key, value];
    })
        .sort());
};
class LibraryInterface extends InterfaceBase {
    _getUrl(endpoint) {
        return `https://${this._core._environment.endpoints.MELVILLE_HOST}${endpoint}`;
    }
    async getLibraryData(libraryId, options) {
        const selectors = (options === null || options === void 0 ? void 0 : options.selectors) ? options.selectors : [];
        const isDiscarded = (options === null || options === void 0 ? void 0 : options.isDiscarded) || false;
        // dedupes, sorts, and ensures selectors contains rendition grid
        const sortedSelectors = Array.from(new Set(['rendition_grid', 'collaboration', ...selectors])).sort().join(',');
        const endpoint = isDiscarded ? 'archive' : 'libraries';
        return await this._getResponse(
        // Sort selectors so that the query string is stable, preventing unnecessary cache misses.
        this._getUrl(`/api/v1/${endpoint}/${libraryId}?selector=${sortedSelectors}`), {
            // Ensure browser doesn't automatically add If-None-Match, otherwise
            // service may respond with cached data for a library
            headers: { ['Cache-Control']: 'no-cache, no-store, max-age=0' }
        });
    }
    // Warning: the libraries listing returned from /libraries may have stale data due to USS indexing delays.
    // The exception to this is public libraries as those are fetched from platform, for now.
    // (Other calls, such as fetching library data by ID, will always return the latest data from platform.)
    // Update only LibrarySpecificData to avoid overwriting RAPI data if you are worried about this.
    async getLibraries(queryParams) {
        if ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.limit) && (queryParams === null || queryParams === void 0 ? void 0 : queryParams.start) === undefined) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, '[Melville] If limit is provided, start must also be provided.');
        }
        queryParams = sortParameters$2(queryParams);
        const urlWithQueryParams = fillURLTemplate$1(this._getUrl('/api/v1/libraries'), queryParams);
        // Pass as many parameters as headers as we can, to avoid extra CORS preflight OPTIONS requests per url.
        const [url, headers] = moveUrlQueryParamsToHeaders(urlWithQueryParams);
        // Ensure browser doesn't automatically add If-None-Match, otherwise
        // service may respond with cached data for a library
        const defaultHeaders = { ['Cache-Control']: 'no-cache, no-store, max-age=0' };
        const finalHeaders = Object.assign(Object.assign({}, defaultHeaders), headers);
        return await this._getResponse(url, { headers: finalHeaders });
    }
    // TODO[SHARED-975]: This will need to return the json response for pagination.
    async getLibrariesForProject(projectId) {
        const response = await this.getLibraries({ team: projectId, selector: 'rendition_grid,collaboration' });
        return response.libraries;
    }
    async getLibrariesWithLink(pageLink) {
        // The link will not include headers, so we will need switch query params to headers to reduce OPTIONS requests.
        const [url, headers] = moveUrlQueryParamsToHeaders(this._getUrl(pageLink.href));
        return await this._getResponse(url, { headers });
    }
    // The assetId's passed to restoreLibraryElement() and permanentlyDeleteLibraryElement() are in the
    // form 'LIBRARY_CLOUD_ID:ELEMENT_GUID', i.e:
    // 'urn:aaid:sc:us:2be71fea-f24b-4c10-a6a9-4f0926bda772:0fad1009-3bc1-4119-9227-5d1889ffcaf2'
    // I filed https://jira.corp.adobe.com/browse/SAM-2683 to support batch restore/permanentDelete operations which in
    // this workflow would allow us to make just one request to restore/permanentlyDelete multiple CCLibrary Elements that
    // belong to the same CCLibrary.
    async restoreLibraryElement(assetId) {
        const [elementID, libraryID] = parseLibraryAndElementID(assetId);
        const body = { self: { id: libraryID.toString(), elements: [elementID] } };
        await this._doPost(this._getUrl(`/api/v1/libraries/${libraryID}/archive`), { 'Content-Type': 'application/json' }, JSON.stringify(body), [200]);
    }
    async permanentlyDeleteLibraryElement(assetId) {
        const [elementID, libraryID] = parseLibraryAndElementID(assetId);
        await this._doDelete(this._getUrl(`/api/v1/libraries/${libraryID}/archive/${elementID}`), { 'Content-Type': 'application/json' }, [204]);
    }
    async discardLibrary(assetId) {
        await this._doDelete(this._getUrl(`/api/v1/libraries/${assetId}`), { 'Content-Type': 'application/json' }, [204]);
    }
    async permanentlyDeleteLibrary(assetId) {
        await this._doDelete(this._getUrl(`/api/v1/libraries/${assetId}?permanent=true`), { 'Content-Type': 'application/json' }, [204]);
    }
    async restoreLibrary(assetId) {
        const body = { self: `/api/v1/archive/${assetId}` };
        await this._doPost(this._getUrl(`/api/v1/libraries`), { 'Content-Type': 'application/json' }, JSON.stringify(body), [201]);
    }
    async copyLibrary(assetId, destName, parentAssetID, restrictEdit) {
        const accessString = getLibraryAccessOption(restrictEdit);
        const body = Object.assign(Object.assign(Object.assign({ source: assetId }, (destName && { name: destName })), (accessString && { access: accessString })), (parentAssetID && { parent_assetId: parentAssetID }));
        const response = await this._doPost(this._getUrl(`/api/v1/libraries`), { 'Content-Type': 'application/json' }, JSON.stringify(body), [200, 201]);
        return await response.json();
    }
    async moveLibrary(assetId, parentAssetID, restrictEdit) {
        const accessString = getLibraryAccessOption(restrictEdit);
        const body = {
            self: assetId,
            parent_assetId: parentAssetID,
            'repo:manifestPatch': [{ 'op': 'replace', 'path': '/id', 'value': assetId }]
        };
        if (accessString !== '') {
            body['access'] = accessString;
        }
        const headers = {
            'Content-type': 'application/json'
        };
        // If the client has not set the 'enable-x-bucket-move' feature flag to 'true', add the disable-x-bucket-move
        // header to the request to ensure that cross bucket moves are disabled in Melville.
        // Cross-bucket moves occur when the storage-assignee of the source and destination are different.
        const featureFlags = this._core._environment.getValue('FEATURE_FLAGS');
        if (!(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['enable-x-bucket-move'])) {
            headers['disable-x-bucket-move'] = 'true';
        }
        const response = await this._doPost(this._getUrl(`/api/v1/libraries`), headers, JSON.stringify(body), [200, 201]);
        return await response.json();
    }
    /**
     *
     * @param nameOrOptions - For backward compatability, this can be a string representing the name of the library to create.
     *                      If an object is passed, it should be a CreateLibraryOptions object.
     * @returns LibraryData - The created library data from the response. This will include the ID of the created library.
     */
    async createLibrary(nameOrOptions) {
        let options;
        let url = `/api/v1/libraries`;
        if (typeof nameOrOptions === 'string') {
            options = { name: nameOrOptions };
        }
        else if (typeof nameOrOptions === 'object') {
            options = nameOrOptions;
            url = options.syncCreate ? `/api/v1/libraries?invocation_mode=sync` : `/api/v1/libraries`;
        }
        else {
            throw new Error('Invalid arguments');
        }
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
        const requestOptions = __rest$2(options, ["syncCreate"]);
        const response = await this._doPost(this._getUrl(url), { 'Content-Type': 'application/json' }, JSON.stringify(requestOptions), [201, 200]);
        return await response.json();
    }
    /**
     * Follow aka bookmark one or more libraries.
     * @param bookmarks - array of BookmarkData objects
     * Required properties: In each bookmark, besides the id, you must include either urn for collaborated libraries or url for public libraries.
     * @returns BookmarksResponse - contains all the bookmarks for the user of the same type(s) that were created (public or collab or both)
     */
    async bookmarkLibraries(bookmarks) {
        bookmarks = bookmarks.map(bookmark => {
            if (!bookmark.id || (!bookmark.urn && !bookmark.url) || (bookmark.type === 'collab' && !bookmark.urn) || (bookmark.type === 'public' && !bookmark.url)) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, '[Melville] BookmarkData must include `id` and either `urn` for collaborated libraries or `url` for public libraries.');
            }
            bookmark.type = bookmark.type || (bookmark.url ? 'public' : 'collab');
            return bookmark;
        });
        const body = { bookmarks };
        // Will return 201 even if the library is already bookmarked
        const response = await this._doPost(this._getUrl(`/api/v1/libraries/bookmarks`), { 'Content-Type': 'application/json' }, JSON.stringify(body), [200, 201]);
        return await response.json();
    }
    /**
     * Get all bookmarks for the user from Melville.
     */
    async getBookmarks() {
        const response = await this._getResponse(this._getUrl(`/api/v1/libraries/bookmarks?useCache=false&ussCache=false`), { headers: { 'Content-Type': JSON_MIME_TYPE, 'Cache-Control': 'no-cache, no-store, max-age=0' } });
        return await response.bookmarks;
    }
    /**
     * Unfollow aka unbookmark the library. (User can always bookmark again as long as they maintain access.)
     */
    async unbookmarkLibrary(bookmarkId) {
        await this._doDelete(this._getUrl(`/api/v1/libraries/bookmarks/${bookmarkId}`), { 'Content-Type': 'application/json' }, [204]);
    }
    /**
     * Set metadata on a library - eg setting roles, renaming, etc.
     */
    async updateMetadata(libraryId, body) {
        await this._doPut(this._getUrl(`/api/v1/libraries/${libraryId}/metadata`), { 'Content-Type': 'application/json' }, JSON.stringify(body), [204, 200]);
    }
    /**
     * Search for Libraries (excluding elements).
     */
    async searchLibraries(searchQuery) {
        const body = {
            query_string: searchQuery,
            asset_type: ['library'],
            selector: 'rendition_grid,collaboration'
        };
        const response = await this._doPost(this._getUrl(`/api/v1/search`), { 'Content-Type': 'application/json' }, JSON.stringify(body), [200]);
        return await response.json();
    }
    /**
     * Search for next page of Libraries using the page link (excluding elements).
     */
    async searchLibrariesWithLink(searchQuery, pageLink) {
        // Move the query params to the body to avoid extra preflight requests.
        const [url, params] = moveUrlQueryParamsToHeaders(pageLink.href);
        const body = {
            query_string: searchQuery,
            asset_type: ['library'],
            selector: 'rendition_grid,collaboration',
            start: params['start'],
            limit: params['limit']
        };
        const response = await this._doPost(this._getUrl(url), { 'Content-Type': 'application/json' }, JSON.stringify(body), [200]);
        return await response.json();
    }
    async getRenditionTileImage(renditionUrl) {
        const newURL = new URL(renditionUrl);
        const response = await this._doGet(newURL.toString());
        return await response.blob();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class GenerationHistoryInterface extends InterfaceBase {
    _getUrl(endpoint) {
        return `https://${this._core._environment.endpoints.MELVILLE_HOST}${endpoint}`;
    }
    async getGenerationHistoryAssets(queryParams) {
        if ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.limit) && (queryParams === null || queryParams === void 0 ? void 0 : queryParams.start) === undefined) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, '[Melville] If limit is provided, start must also be provided.');
        }
        queryParams = sortParameters$1(queryParams);
        const urlWithQueryParams = fillURLTemplate$1(this._getUrl('/api/v1/firefly-generations'), queryParams);
        // Pass as many parameters as headers as we can, to avoid extra CORS preflight OPTIONS requests per url.
        const [url, headers] = moveUrlQueryParamsToHeaders(urlWithQueryParams);
        // Ensure browser doesn't automatically add If-None-Match, otherwise
        // service may respond with cached data for a library
        const defaultHeaders = { ['Cache-Control']: 'no-cache, no-store, max-age=0' };
        const finalHeaders = Object.assign(Object.assign({}, defaultHeaders), headers);
        return await this._getResponse(url, { headers: finalHeaders });
    }
    /**
   * @package -- only for use in SAM.js
   * Fetches the next page of history assets from Melville
   * @returns a list of history assets along with page information and links to the next page
   */
    async getGenerationHistoryAssetsUsingPageLink(pageLink) {
        const [url, headers] = moveUrlQueryParamsToHeaders(this._getUrl(pageLink.href));
        return this._getResponse(url, { headers });
    }
    /**
     * Fetches a history asset by ID
     *
     * @param assetId ID of custom model to be fetched
     * @returns the custom model
     */
    async getGenerationHistoryAssetById(assetId) {
        return await this._getResponse(this._getUrl(`/api/v1/firefly-generations/${assetId}`), { headers: { 'Content-Type': 'application/json' } });
    }
    async getOutputComponentDownloadURL(componentURL) {
        const { isBlockDownload, url } = componentURL;
        if (isBlockDownload) {
            return url;
        }
        const componentLinkResponse = await this._doGet(url);
        const blobUrl = URL.createObjectURL(await componentLinkResponse.blob());
        if (!(blobUrl === null || blobUrl === void 0 ? void 0 : blobUrl.length)) {
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Cannot convert blob to URL');
        }
        return blobUrl;
    }
}
// Sort parameters so that the query string is stable, preventing unnecessary cache misses.
const sortParameters$1 = (parameters) => {
    return Object.fromEntries(Object.entries(parameters)
        .map(([key, value]) => {
        if (Array.isArray(value)) {
            return [key, value.sort()];
        }
        return [key, value];
    })
        .sort());
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class PerUserMetadataResource extends AdobeAssetResource {
    constructor(_core, _parent) {
        super(_core, _parent, {
            onChange: async (perUserMetadata) => {
                var _a;
                await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._handleResourceUpdates({ perUserMetadata }));
            },
            onError: async (error) => {
                var _a;
                await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._handleResourceUpdates({ error }));
            }
        });
        this._core = _core;
    }
    async _loadData() {
        var _a, _b;
        await ((_a = this._parent) === null || _a === void 0 ? void 0 : _a._ensureLink(RelType.PERUSER_METADATA));
        const assetInterface = await ((_b = this._parent) === null || _b === void 0 ? void 0 : _b._getAssetInterface());
        await (assetInterface === null || assetInterface === void 0 ? void 0 : assetInterface.getPerUserMetadata(this));
    }
}

var RequestHeaders;
(function (RequestHeaders) {
    RequestHeaders["PREFER_RAPI"] = "X-Prefer-RAPI";
    RequestHeaders["SAM_VERSION"] = "X-Shared-Asset-Model-Version";
})(RequestHeaders || (RequestHeaders = {}));
function getSAMVersionRequestHeader() {
    return { [RequestHeaders.SAM_VERSION]: packageJSON.version };
}
// This is susceptible to breaking if the nesting of EDU assets change
const assignmentPath = '.*/classrooms/[^/]+/assignments/[^/]+$';
const assignmentPathRegex = new RegExp(assignmentPath);
// [ACPCEDU-3811] will replace the need for this function
function isAssignmentPath({ repoPath }) {
    return assignmentPathRegex.test(repoPath);
}
// This is susceptible to breaking if the nesting of EDU assets change
const materialsFilePath = assignmentPath.replace('$', '/materials/[^/]+$');
const materialsFilePathRegex = new RegExp(materialsFilePath);
// [ACPCEDU-3811] will replace the need for this function
function isMaterialsFilePath({ repoPath }) {
    return materialsFilePathRegex.test(repoPath);
}
// This is susceptible to breaking if the nesting of EDU assets change
const studentAssignmentPath = assignmentPath.replace('$', '/students/[^/]+$');
const studentAssignmentPathRegex = new RegExp(studentAssignmentPath);
// [ACPCEDU-3811] will replace the need for this function
function isStudentAssignmentPath({ repoPath }) {
    return studentAssignmentPathRegex.test(repoPath);
}
// [ACPCEDU-3811] will replace the need for this function
function getClassroomNameFromSAFPath(repoPath) {
    // Assumes [..., Classroom, Assignments, Assignment, Students, StudentAssignment, StudentAssignmentFile]
    // Example path: /content/assets/classrooms/${classroomName}/assignments/assignment-name/students/student-name/file-name
    if (!isStudentAssignmentFilePath({ repoPath })) {
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'repoPath provided is not a StudentAssignmentFile path');
    }
    // Verified expected length of repoPath array through the isStudentAssignmentFilePath check
    return repoPath.split('/').at(-6);
}
// [ACPCEDU-3811] will replace the need for this function
function getClassroomNameFromMaterialsFilePath(repoPath) {
    // Assumes [..., Classroom, Assignments, Assignment, Materials, Materials file]
    // Example path: /content/assets/classrooms/${classroomName}/assignments/assignment-name/materials/file-name
    if (!isMaterialsFilePath({ repoPath })) {
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'repoPath provided is not a MaterialsFile path');
    }
    // Verified expected length of repoPath array through the isMaterialsFilePath check
    return repoPath.split('/').at(-5);
}
// This is susceptible to breaking if the nesting of EDU assets change
const studentAssignmentFilePath = studentAssignmentPath.replace('$', '/[^/]+$');
const studentAssignmentFilePathRegex = new RegExp(studentAssignmentFilePath);
// [ACPCEDU-3811] will replace the need for this function
function isStudentAssignmentFilePath({ repoPath }) {
    return studentAssignmentFilePathRegex.test(repoPath);
}
// [ACPCEDU-3811] will replace the need for this function
function ussIsStudentAssignmentFilePath(item) {
    return studentAssignmentFilePathRegex.test(`${item.asset_name_path}/${item.asset_name}`);
}
function isAssetAWebsiteTemplate(asset) {
    const doesMediaTypeMatch = asset.mediaType === 'application/vnd.adobe.gneisswebpage.theme.document+dcx';
    const doesPathMatch = asset.name.endsWith('.webpagetheme');
    return doesMediaTypeMatch || doesPathMatch;
}
/**
 * Validates a string for type correctness and non-empty.
 * @param value The value to validate.
 * @param name The name of the value, only used when throwing errors.
 * @param shouldThrow True (default) if a specific error should be thrown; false to return a status.
 * @returns True if the value is a string and non-empty; false otherwise.
 */
function validateString(value, name, shouldThrow = true) {
    let result = true;
    if (Array.isArray(value)) {
        for (let index = 0; index < value.length; index++) {
            result = validateString(value[index], name, shouldThrow);
            if (!result) {
                break;
            }
        }
        return result;
    }
    if (!validateType(value, 'string', true)) {
        result = false;
        if (shouldThrow) {
            throw Error(`${name} is not a valid string`);
        }
    }
    if (value === '') {
        result = false;
        if (shouldThrow) {
            throw Error(`${name} is an empty string`);
        }
    }
    return result;
}
/**
 * Validates that a given piece of data is of the correct type
 * @returns true if the data is of the correct type, false otherwise
 */
function validateType(value, type, isRequired, ref) {
    if (!isRequired && (value === undefined || value === null)) {
        return true;
    }
    switch (type) {
        case 'string':
            return typeof value === 'string';
        case 'date':
            return typeof value === 'object' && value.toDateString !== undefined;
        case 'string[]':
            return Array.isArray(value) && value.every((item) => validateType(item, 'string', false));
        case 'enum':
            return Object.values(ref).some((enumValue) => enumValue === value);
        case 'blob':
            return value instanceof Blob;
        case 'object':
            return typeof value === 'object' && !Array.isArray(value) && value !== null;
    }
    // Not reachable through TS, but JS could hit this. Including for completeness.
    return false;
}
/**
 * Validates multiple pieces of data against a validation map
 * @returns an array of error messages for each piece of data that failed validation
 */
function validateTypes(validationMap, data) {
    return validationMap.reduce((errors, { key, type, ref, isRequired }) => {
        if (!validateType(data[key], type, isRequired, ref)) {
            const article = (type === 'enum' || type === 'object') ? 'an' : 'a';
            let errMsg = `${key.toString()} is not ${article} ${type}`;
            if (isRequired) {
                errMsg += ' or is missing';
            }
            errors.push(errMsg);
        }
        return errors;
    }, []);
}
function getMemberComputedKey(classroomId, userId) {
    return `${classroomId}-${userId}`;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Platform default limits on valid transfer size values.
 *
 * These are the default values for 'repo:minsingletransfersize' and 'repo:maxsingletransfersize'
 * from the RelType.BLOCK_INITIALIZE response. If we are unable to get these values from the
 * platform, we will use these defaults instead.
 *
 * DEFAULT_MAX_SINGLE_TRANSFER_SIZE is the default threshold for switching from direct to block upload,
 * if a custom threshold is not provided by the client.
 */
const DEFAULT_MAX_SINGLE_TRANSFER_SIZE = 10485760; // 10 MB
const DEFAULT_MIN_SINGLE_TRANSFER_SIZE = 1; // 1 byte
/**
 * @deprecated -- will be removed on or after 2024-10-01. Clients should use {@link AdobeAsset.isFolder} etc. instead.
 */
var AssetType;
(function (AssetType) {
    AssetType[AssetType["Folder"] = 256] = "Folder";
    AssetType[AssetType["File"] = 512] = "File";
    AssetType[AssetType["Composite"] = 1024] = "Composite";
})(AssetType || (AssetType = {}));
// This must be kept in sync with AdobeAsset.h
var AssetSyncStatus;
(function (AssetSyncStatus) {
    AssetSyncStatus[AssetSyncStatus["InSync"] = 0] = "InSync";
    AssetSyncStatus[AssetSyncStatus["OutOfSync"] = 1] = "OutOfSync";
    AssetSyncStatus[AssetSyncStatus["SyncConflict"] = 2] = "SyncConflict";
    AssetSyncStatus[AssetSyncStatus["SyncError"] = 3] = "SyncError";
    AssetSyncStatus[AssetSyncStatus["Syncing"] = 4] = "Syncing";
})(AssetSyncStatus || (AssetSyncStatus = {}));
// This must be kept in sync with AdobeAsset.h
var AssetSyncSuspensionReason;
(function (AssetSyncSuspensionReason) {
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["None"] = 0] = "None";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["CloudContentCorrupted"] = 1] = "CloudContentCorrupted";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["LocalContentCorrupted"] = 2] = "LocalContentCorrupted";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["HasTooManyComponents"] = 3] = "HasTooManyComponents";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["HasTooManyChildren"] = 4] = "HasTooManyChildren";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["MaximumSizeExceeded"] = 5] = "MaximumSizeExceeded";
    AssetSyncSuspensionReason[AssetSyncSuspensionReason["Unknown"] = 6] = "Unknown";
})(AssetSyncSuspensionReason || (AssetSyncSuspensionReason = {}));
/**
 * Response from the server for the commit request.
 **/
var CommitStatus;
(function (CommitStatus) {
    CommitStatus[CommitStatus["NoErr"] = 0] = "NoErr";
    CommitStatus[CommitStatus["Conflict"] = 1] = "Conflict";
    CommitStatus[CommitStatus["DeleteConflict"] = 2] = "DeleteConflict";
    CommitStatus[CommitStatus["ParentDeletedConflict"] = 3] = "ParentDeletedConflict";
})(CommitStatus || (CommitStatus = {}));
// It's unfortunate that SAM uses different constants for asset types than the R-API, but we need to be consistent with SAM-CPP
const assetClassToTypeMap = new Map([
    ['file', AssetType.File],
    ['composite', AssetType.Composite],
    ['directory', AssetType.Folder],
    // TODO: determine if this is needed, add to JS Bindings & AssetType
    // [ 'entity', 'Entity' ]
]);
// Do not refresh app metadata for root folders like / or /cloud-content or /cloud-content-archive etc. They do not
// show up in listings, but they can get loaded due to ONS notifications. Since the Filters prevent them from appearing
// in listings already, there's no need to load the app metadata to see that they should be hidden due to
// shell:visibility.
// TODO: also ignore root folders of ESM stores.
const APP_METADATA_REFRESH_IGNORE_REGEX = /^\/[^/]+$|^\/$/;
class AdobeAsset extends ShareableItem {
    get localID() {
        return this._localID;
    }
    get isAvailableOffline() {
        return Boolean(this._localID);
    }
    get downloadStatus() {
        return this._downloadStatus;
    }
    get uploadStatus() {
        return this._uploadStatus;
    }
    get syncStatus() {
        return this._syncStatus;
    }
    get syncSuspensionReason() {
        return this._syncSuspensionReason;
    }
    get xmpNumberOfPages() {
        return this._xmpNumberOfPages;
    }
    get downloadComposite() {
        if (this.isComposite && this._acplModelInterface.supportsDownloadComposite) {
            return () => this._acplModelInterface.downloadComposite(this.cloudID);
        }
        return undefined;
    }
    get unpin() {
        if (this.isAvailableOffline && this._acplModelInterface.supportsUnpin) {
            return () => this._acplModelInterface.unpin(this.cloudID);
        }
        return undefined;
    }
    constructor(_core, id, metadata) {
        super(_core, id);
        this._core = _core;
        this._name = ''; // don't change this in subclasses
        this._etag = '';
        this._repositoryID = '';
        this._path = '';
        this._storageRegion = '';
        this._type = '';
        this._size = 0;
        this._version = '';
        this._assetClass = 'file';
        this._assetState = 'ACTIVE';
        this._created = new Date();
        this._modified = new Date();
        this._createdBy = '';
        this._modifiedBy = '';
        // Assume user has full permissions for any Asset they run across, as it's better to
        // err on allowing an action in the UI and have it fail on the service. Sources that
        // require permission checks are responsible for ensuring the permissions are set
        // appropriately.
        this._permissions = PERMISSION_ALL;
        this._isPublished = false;
        this._storageAssignee = { id: '', type: 'user' };
        this._effectivePermissionsResource = new EffectivePermissionsResource(this._core, this);
        this._repoMetadataResource = new RepoMetadataResource(this._core, this);
        // Library Elements in USS discarded results are pseudo-Assets that are not in
        // /cloud-content-archive and do not have state=DISCARDED. This ensures that these items only appear in discarded
        // search results. In case Library Elements appear in other collections, we are not inferring that all Library
        // Elements are discarded just because today the discarded list is the only place they appear.
        this._isArchivedLibraryElement = false;
        this._representations = { file: undefined, composite: undefined, directory: undefined };
        /**
         * A flag that prevents Resources from independently triggering logic after updates
         * while we're explicitly loading via Asset._load().
         */
        this._isExplicitlyLoading = false;
        // Base implementation, subclasses should override if they need to return true.
        this._needsRepoMetadata = false;
        // SAM should never create an AdobeAsset for a project. Therefore isProject should always be false.
        this.isProject = false;
        this.isLibrary = false;
        this.isCustomModel = false;
        /**
         * @package -- only for use in SAM.js
         */
        this._versionPool = new ItemPool(this._core, 'version');
        /**
         * Determines if __links came from resolve API (true) or a listing (false)
         * @package -- only for use in SAM.js
         */
        this._linksCameFromResolveAPI = false;
        // This field isn't useful for feature-detection, so hard-coding as false, which is a sensible value for web
        this.isUserPinned = false;
        // Expecting that a data migration will occur that makes this field obsolete. If that doesn't happen, then
        // this field will need to be populated with an async call.
        /**
         * @deprecated -- will be removed on or after 2024-10-01
         */
        this.isNameDCTitle = false;
        /**
         * SAM.cpp Only - not available on web.
         * Downloads the  composite to the local cache
         * but also respects cache clearing policies so it may
         * be cleared at some point.
         */
        // end [SAM-2268][SAM-2494]
        this._acplModelInterface = new ACPLModelInterface(this._core);
        this._embeddedMetadata = new EmbeddedMetadataResource(_core, this);
        this._appMetadata = new AppMetadataResource(_core, this);
        this._perUserMetadataResource = new PerUserMetadataResource(_core, this);
        this._manifest = new ManifestResource(_core, this);
        this._effectivePermissionsResource = new EffectivePermissionsResource(this._core, this);
        this._repoMetadataResource = new RepoMetadataResource(this._core, this);
        this._fileContent = new FileContentResource(_core, this);
        this.__links = metadata === null || metadata === void 0 ? void 0 : metadata.links;
        this._etag = (metadata === null || metadata === void 0 ? void 0 : metadata.etag) || '';
        this._renditionFetcher = new RenditionFetcher(this._core, SUPPORTED_SIZES, async (size, type) => {
            const ai = await this._getAssetInterface();
            return ai.getRendition(size, type);
        });
        // Forward change events from the rendition fetcher
        // to this class.
        this._renditionFetcher.on('change', () => {
            this.dispatch({ type: 'change' });
        });
        // Create a weakReference to track if the
        // the object has been GC'd
        // Ensure working per https://jira.corp.adobe.com/browse/SAM-2677
        this.fr = new FinalizationRegistry(() => {
            this._finalizer();
        });
        this.fr.register(this, 'adobe-asset');
        LazyLoadManager.manageLazyLoading(this, [{
                event: SharedStorageAssigneeChangedEvent,
                fetchData: this._populateStorageAssignee
            }]);
    }
    /**
     * A property that indicates wether or not a file was created from upload. If it's undefined
     * that means it has not been set previously and doesn't necessarily mean
     * that it was not created from an upload action in an application. Only a 'true' value
     * can guarantee that this file was created from an upload action.
     */
    get createdFromUpload() {
        const ccCreatedFromUploadPropertyName = 'cc:createdFromUpload';
        // If the data was provided by a USS result, return that result.
        if (this.appMetadata.data && this.appMetadata.data[ccCreatedFromUploadPropertyName]) {
            return !!this.appMetadata.data[ccCreatedFromUploadPropertyName];
        }
        return this._createdFromUpload;
    }
    /**
     * The ID of the client who created the repository asset.
     */
    get createdByClientId() {
        return this._createdByClientId;
    }
    _getAssetContext() {
        const assetContext = this._core._getAssetContext();
        if (!assetContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'AdobeAsset was used outside of AssetContext and initializeSharedAssetModel() was not called first.');
        }
        // At this point we know for sure AssetContext exists
        return assetContext;
    }
    _finalizer() {
        this._renditionFetcher.release();
    }
    /**
     * @package -- for use in SAM.js only
     */
    _loadWithRetry() {
        return this._load();
    }
    /**
     * @package -- for use in SAM.js only
     */
    async _getAssetInterface() {
        const assetContext = this._getAssetContext();
        return new AssetInterface(assetContext._rapi, this.id, this.links, this.etag);
    }
    /**
     * @package -- for use in SAM.js only
     */
    _getGenerationHistoryInterface() {
        return new GenerationHistoryInterface(this._core);
    }
    /**
     * @package -- for use in SAM.js only
     */
    _getGenerationModelDisplayName() {
        return this._generationModelDisplayName;
    }
    // These secondary resources are refreshed after load. (It excludes permissions and repoMetadata.)
    get _resources() {
        return new Map([
            ['embeddedMetadata', this._embeddedMetadata],
            ['appMetadata', this._appMetadata],
            ['manifest', this._manifest],
            ['fileContent', this._fileContent],
        ]);
    }
    /**
     * @package -- for use in SAM.js only
     */
    _setResources(resources) {
        if (resources.appMetadataResource) {
            this._appMetadata = resources.appMetadataResource;
            this._appMetadata.setParent(this);
        }
        if (resources.repoMetadataResource) {
            this._repoMetadataResource = resources.repoMetadataResource;
            this._repoMetadataResource.setParent(this);
        }
        if (resources.effectivePermissionsResource) {
            this._effectivePermissionsResource = resources.effectivePermissionsResource;
            this._effectivePermissionsResource.setParent(this);
        }
        if (resources.perUserMetadataResource) {
            this._perUserMetadataResource = resources.perUserMetadataResource;
            this._perUserMetadataResource.setParent(this);
        }
    }
    async _reloadPermissions() {
        await this._effectivePermissionsResource.load();
    }
    /**
     * @package -- only for use in SAM.js
     */
    async _handleResourceUpdates({ repoMetadata, effectivePermission, perUserMetadata, error }) {
        if (this._isExplicitlyLoading) {
            return;
        }
        const assetMetadata = Object.assign({}, repoMetadata);
        if (!error) {
            if (repoMetadata) {
                this._linksCameFromResolveAPI = true;
            }
            if (effectivePermission) {
                assetMetadata.effectivePermission = effectivePermission;
            }
        }
        else {
            // Check for the asset missing (404) or having restricted access (403)
            if ([SAMErrorCode.NOT_FOUND, SAMErrorCode.ACCESS_DENIED].includes(error.code)) {
                assetMetadata.effectivePermission = (error.code === SAMErrorCode.ACCESS_DENIED ? Permission.Ack : Permission.None);
            }
            else {
                throw error;
            }
        }
        const assetContext = await this._getAssetContext();
        const hasLostAccess = [Permission.Ack, Permission.None].includes(assetMetadata.effectivePermission);
        if (hasLostAccess && assetContext._assetPool.isItemDiscarded(this)) {
            // The asset has already been removed from the asset pool so we can just
            // skip any further updates. This typically means it's been permanently deleted.
            this._isShared = false;
            this._isSharedWithYouAsset = false;
            this._shareFlagsAreDirty = false;
            LazyLoadManager.setLoadStatus(this, SharedCollaboratorChangedEvent, LoadStatus.Loaded);
            return;
        }
        const isFolder = assetMetadata['repo:assetClass'] === 'directory' || this.isFolder;
        // A "mutation" session is used here to track the time when a change is made to an Asset that is known to be
        // fresh (since it came from R-API). This helps avoid problems where fresh data from R-API gets overwritten by
        // stale data (e.g. from USS due to indexing lag).
        const session = assetContext._assetPool.createMutationSession();
        if (isFolder && assetMetadata['repo:path'] && assetMetadata['repo:path'] !== this.repoPath) {
            // If it's a directory, and its path changed, we also need to update the repo:path of all its children!
            updateCachedDescendents({
                assetContext,
                assetPool: assetContext._assetPool,
                asset: this,
                session,
                operation: { type: 'rename', newPath: assetMetadata['repo:path'] }
            });
        }
        if (perUserMetadata) {
            assetMetadata.perUserMetadata = perUserMetadata;
        }
        // We always update the asset with the new permissions even if it's
        // been permanently deleted or permissions have been removed. This
        // ensures subscribers to "change" events of AdobeAsset are notified
        // AssetLink being one example.
        if (hasLostAccess) {
            // If the user lost access, it is effectively not shared with them anymore
            assetMetadata.isShared = false;
            assetMetadata.sharedViaInvite = false;
            // Refreshing collaborators will likely fail, so clear the dirty flags to prevent the refresh.
            assetMetadata.shareFlagsAreDirty = false;
            LazyLoadManager.setLoadStatus(this, SharedCollaboratorChangedEvent, LoadStatus.Loaded);
            session.queueDiscardedItem(this);
        }
        else if (effectivePermission) {
            // Since we are explicitly reloading the permissions we want to mark
            // that the collaboration data is out of date which will
            // fetch new data when the ShareableItem.collaboratorArray is read.
            assetMetadata.shareFlagsAreDirty = true;
            LazyLoadManager.setLoadStatus(this, SharedCollaboratorChangedEvent, LoadStatus.NotLoaded);
        }
        // Mark storage:assignee as loaded, if it has been set from assetMetadata,
        // to avoid unnecessary lazy loading
        if (assetMetadata['storage:assignee'] && this._storageAssignee_NoLazyLoad.id === assetMetadata['storage:assignee'].id) {
            LazyLoadManager.updatedByItemUpdater(this, STORAGE_ASSIGNEE_CHANGED);
        }
        assetContext._adobeAssetUpdater.updateLocalItem(session, this, assetMetadata);
        session.commit();
    }
    /**
     * @param repoMetadata {RepositoryMetadata} If passed in, it will be used instead of loading from the service
     * @param appMetadata {any} If passed in, it will be used instead of loading from the service
     * @param effectivePermission {Permission} If passed in, it will be used instead of loading from the service
     *
     * @package -- only for use in SAM.js
     */
    async _load({ repoMetadata, appMetadata, effectivePermission, perUserMetadata } = {}) {
        var _a;
        let error;
        try {
            // When we update both repoMetadata and effectivePermission resources together, we don't want them
            // to independently handle the check for lost access in parallel. Instead, we just update the resources here,
            // and then handle the results of those updates in one go.
            this._isExplicitlyLoading = true;
            // In order to make sure that we have the links required to load individual resources,
            // If both repoMetadata and effectivePermissions are not provided, we will fetch the links first
            // to make sure we don't make parallel calls for getting the links while loading the resources.
            // we will use REPO_METADATA relType to ensure that the links are present.
            if (!repoMetadata && !effectivePermission) {
                await this._ensureLink(RelType.REPO_METADATA);
            }
            await Promise.allSettled([
                repoMetadata ? this._repoMetadataResource._setData(repoMetadata) : this._repoMetadataResource.load(),
                effectivePermission ? this._effectivePermissionsResource._setData(effectivePermission) : this._effectivePermissionsResource.load()
            ]);
        }
        catch (e) {
            error = e;
        }
        finally {
            this._isExplicitlyLoading = false;
        }
        error = (_a = error !== null && error !== void 0 ? error : this._repoMetadataResource.error) !== null && _a !== void 0 ? _a : this._effectivePermissionsResource.error;
        if (!error) {
            if (![Permission.Ack, Permission.None].includes(this._permissions)) {
                if (!perUserMetadata) {
                    await this._ensureLink(RelType.PERUSER_METADATA);
                }
                await Promise.all([
                    this._refreshLoadedResources(appMetadata),
                    perUserMetadata ? this._perUserMetadataResource._setData(perUserMetadata) : this._perUserMetadataResource.load()
                ]);
            }
            await this._handleResourceUpdates({
                repoMetadata: this._repoMetadataResource.data,
                effectivePermission: this._effectivePermissionsResource.data,
                perUserMetadata: this._perUserMetadataResource.data
            });
            // Now that repoMetadata has been fetched directly, we can clear the flag.
            this._needsRepoMetadata = false;
        }
        else {
            await this._handleResourceUpdates({
                error,
            });
        }
    }
    /** @package -- only for use in SAM.js */
    async _loadRepoMetadata() {
        await this._repoMetadataResource.load();
    }
    async _refreshLoadedResources(appMetadata) {
        // Refresh any resources that are already loaded
        const resourcesToReload = [...this._resources.values()].filter(resource => resource.isLoaded);
        // If shellVisibility is undefined, then app metadata must be loaded to ensures hidden Assets do not
        // appear in lists due to ONS notifications.
        if (this.shellVisibility === undefined
            // Root folders don't show up in lists anyway, so no need to check shell:visibility
            && !APP_METADATA_REFRESH_IGNORE_REGEX.test(this.repoPath)
            // Already scheduled to reload
            && !resourcesToReload.includes(this._appMetadata)
            // Do we have the permission (cannot use hasPermission() because Projects have separate permissions)
            && (this._permissions & Permission.ReadAppMetadata) === Permission.ReadAppMetadata) {
            resourcesToReload.push(this._appMetadata);
        }
        // If the app metadata is passed in, use it instead of loading it again
        if (appMetadata) {
            // setting the data also sets isLoaded to true
            await this._appMetadata._setData(appMetadata);
            // Remove the app metadata from the list of resources to reload
            const index = resourcesToReload.indexOf(this._appMetadata);
            if (index !== -1) {
                resourcesToReload.splice(index, 1);
            }
        }
        if (resourcesToReload.length) {
            // Use APP_METADATA to ensure that the links are present as it is probably the most common resource to load
            await this._ensureLink(RelType.APP_METADATA);
            await Promise.all(resourcesToReload.map(resource => resource.load()));
        }
    }
    /**
     * @TODO_Deprecation on or after 2025-01-01. Use {@link getVersions} instead
     */
    get versions() {
        const loader = new AssetVersionLoader(this._versionPool, this._ensureLink(RelType.PAGE).then(() => this._getAssetInterface()));
        return new ItemSource(this._versionPool, [loader], new AssetVersionFilter());
    }
    async getVersions() {
        return this.versions;
    }
    async getVersion(versionId) {
        const localVersion = this._versionPool.getLocalItemById(versionId);
        if (localVersion) {
            return localVersion;
        }
        await this._ensureLink(RelType.PAGE);
        const assetInterface = await this._getAssetInterface();
        const versionPageResults = await assetInterface.getVersion(versionId);
        // Because we are passing the versionId to the getVersion API, it will return
        // a page with only one version, if that version doesn't exist, it will return an empty
        // children result.
        const versionMetadata = versionPageResults.children[0];
        if (!versionMetadata) {
            return undefined;
        }
        const session = this._versionPool.createUpdateSession();
        const version = await VersionUpdater.updateRemoteItem(session, Object.assign(Object.assign({}, versionMetadata), { assetId: this.id, assetEtag: this.etag, assetLinks: this.links }));
        session.commit();
        return version;
    }
    /**
     * Sets a milestone on a specific version of the asset.
     * A milestone is a way to mark and label important versions of an asset.
     *
     * @param options - Configuration options for the milestone.
     * @param options.label - The label for the milestone (defaults to '').
     * @param options.description - The description for the milestone (defaults to '').
     * @param options.versionId - The version ID to set the milestone on (defaults to the current version).
     * @returns {Promise<void>} A promise that resolves when the milestone is set
     * @example
     * // Set milestone on current version with only a label
     * await asset.setVersionAsMilestone({ label: 'Final Version' });
     * @example
     * // Set milestone on specific version with label and description
     * await asset.setVersionAsMilestone({ label: 'Initial Design', description: 'First draft', versionId: '1' });
     * @example
     * // Set milestone on specific version with only a description
     * await asset.setVersionAsMilestone({ description: 'Approved', versionId: '2' });
     */
    async setVersionAsMilestone(options = {}) {
        const { label = '', description = '', versionId = this.version } = options;
        const assetInterface = await this._getAssetInterface();
        const jsonParams = createMilestoneJsonParams(versionId, 
        // Since we don't know if the version is a milestone or not, we set hasExistingMilestone to false
        // which will cause 'op: add' to be used in the patch. This works for both cases.
        false, label, description);
        await assetInterface.patchVersion(jsonParams);
        // Update the local version with the new milestone data it it's there.
        const existingVersion = this._versionPool.getLocalItemById(versionId);
        if (existingVersion) {
            const session = this._versionPool.createUpdateSession();
            VersionUpdater.updateLocalItem(session, existingVersion, {
                milestone: {
                    label,
                    description
                }
            });
            session.commit();
        }
    }
    async getCommentsResource() {
        const assetContext = this._getAssetContext();
        return assetContext.getCommentsResource(this.id);
    }
    /**
     * Note:  Clients should avoid using this field and instead rely on the "is*" properties, like `isFolder`,
     * `isFile`, `isComposite`, etc.
     *
     * @deprecated - will be removed on or after 2024-10-01
     */
    get assetType() {
        oneTimeWarning('AdobeAsset.assetType', 'AdobeAsset.assetType is deprecated and will be removed on or after 2024-10-01. Please use isFolder,'
            + ' isFile, isComposite, etc. instead');
        return assetClassToTypeMap.get(this._assetClass);
    }
    get isFolder() {
        return this._assetClass === 'directory';
    }
    get isAssignment() {
        // if appMetadata isn't loaded, it's not yet known
        return this.appMetadata.data ? this.appMetadata.data['project:directoryType'] === 'assignment' : undefined;
    }
    get isFile() {
        return this._assetClass === 'file';
    }
    get isStudentAssignment() {
        var _a, _b;
        // [ACPCEDU-3811] will determine longer-term approach to reliably getting this information
        return this.appMetadata.data ? !!((_b = (_a = this.appMetadata.data['cc:inheritable']) === null || _a === void 0 ? void 0 : _a['cc:studentAssignment']) === null || _b === void 0 ? void 0 : _b['repo:assetId']) : undefined;
    }
    get isComposite() {
        return this._assetClass === 'composite';
    }
    get isLibraryElement() {
        return this._assetClass === 'element';
    }
    get imageLength() {
        return this._imageLength;
    }
    get imageWidth() {
        return this._imageWidth;
    }
    // Similar to Project, we rely on app metadata to determine if an asset is a child of an assignment.
    // If app metadata is not loaded, then we don't know if it has a parent assignment id and it is undefined.
    get parentAssignmentID() {
        var _a, _b, _c;
        const parentAssignmentID = (_c = (_b = (_a = this.appMetadata.data) === null || _a === void 0 ? void 0 : _a['cc:inherited']) === null || _b === void 0 ? void 0 : _b['cc:assignment']) === null || _c === void 0 ? void 0 : _c['repo:assetId'];
        if (parentAssignmentID) {
            return parentAssignmentID;
        }
        // If inheritance metadata is missing, fallback to fetching the parent Assignment folder asset ID
        // This is susceptible to breaking if the nesting of EDU assets change
        // [ACPCEDU-3811] will determine longer-term approach
        if (this.ancestorIDs && this.ancestorIDs.length > 0) {
            if (isMaterialsFilePath({ repoPath: this.repoPath })) {
                // Assumes assignment material file asset ancestors are: [..., Assignment, Materials]
                return this.ancestorIDs.at(-2);
            }
            if (isStudentAssignmentFilePath({ repoPath: this.repoPath })) {
                // Assumes ancestors are: [..., Assignment, Students, StudentAssignment]
                return this.ancestorIDs.at(-3);
            }
        }
        return undefined;
    }
    // Similar to isChildOfProject
    get isChildOfAssignment() {
        return !!this.parentAssignmentID;
    }
    get parentClassroomId() {
        var _a, _b, _c;
        const parentClassroomId = (_c = (_b = (_a = this.appMetadata.data) === null || _a === void 0 ? void 0 : _a['cc:inherited']) === null || _b === void 0 ? void 0 : _b['cc:classroom']) === null || _c === void 0 ? void 0 : _c['repo:assetId'];
        if (parentClassroomId) {
            return parentClassroomId;
        }
        // If inheritance metadata is missing, fallback to fetching the parent Classroom folder asset ID
        // This is susceptible to breaking if the nesting of EDU assets change
        // [ACPCEDU-3811] will determine longer-term approach
        if (this.ancestorIDs && this.ancestorIDs.length > 0) {
            if (isStudentAssignmentFilePath({ repoPath: this.repoPath })) {
                // Assumes StudentAssignment asset ancestors are: [..., Classroom, Assignments, Assignment, Students, StudentAssignment]
                return this.ancestorIDs.at(-5);
            }
            if (isMaterialsFilePath({ repoPath: this.repoPath })) {
                // Assumes assignment material file asset ancestors are: [..., Classroom, Assignments, Assignment, Materials]
                return this.ancestorIDs.at(-4);
            }
        }
        return undefined;
    }
    get parentClassroomName() {
        var _a, _b, _c;
        const parentClassroomName = (_c = (_b = (_a = this.appMetadata.data) === null || _a === void 0 ? void 0 : _a['cc:inherited']) === null || _b === void 0 ? void 0 : _b['cc:classroom']) === null || _c === void 0 ? void 0 : _c['repo:name'];
        if (parentClassroomName) {
            return parentClassroomName;
        }
        // If inheritance metadata is missing, fallback to fetching the parent Classroom folder name from the path
        // This is susceptible to breaking if the nesting of EDU assets change
        // [ACPCEDU-3811] will determine longer-term approach
        if (isStudentAssignmentFilePath({ repoPath: this.repoPath })) {
            return getClassroomNameFromSAFPath(this.repoPath);
        }
        if (isMaterialsFilePath({ repoPath: this.repoPath })) {
            return getClassroomNameFromMaterialsFilePath(this.repoPath);
        }
        return undefined;
    }
    get isChildOfClassroom() {
        return !!this.parentClassroomId;
    }
    get parentAssignmentMaterialsId() {
        var _a, _b, _c;
        const parentAssignmentMaterialsId = (_c = (_b = (_a = this.appMetadata.data) === null || _a === void 0 ? void 0 : _a['cc:inherited']) === null || _b === void 0 ? void 0 : _b['cc:assignmentMaterials']) === null || _c === void 0 ? void 0 : _c['repo:assetId'];
        if (parentAssignmentMaterialsId) {
            return parentAssignmentMaterialsId;
        }
        // If inheritance metadata is missing, fallback to fetching the parent Materials folder asset ID
        // This is susceptible to breaking if the nesting of EDU assets change
        // This approach assumes that all Materials files live directly in the Materials folder
        // AND are the only children of a Materials folder
        // [ACPCEDU-3811] will determine longer-term approach
        if (this.ancestorIDs && this.ancestorIDs.length > 0 && isMaterialsFilePath({ repoPath: this.repoPath })) {
            // Assumes materials file asset ancestors are: [..., Materials]
            return this.ancestorIDs.at(-1);
        }
        return undefined;
    }
    get isChildOfAssignmentMaterials() {
        return !!this.parentAssignmentMaterialsId;
    }
    get parentStudentAssignmentId() {
        var _a, _b, _c;
        const parentStudentAssignmentId = (_c = (_b = (_a = this.appMetadata.data) === null || _a === void 0 ? void 0 : _a['cc:inherited']) === null || _b === void 0 ? void 0 : _b['cc:studentAssignment']) === null || _c === void 0 ? void 0 : _c['repo:assetId'];
        if (parentStudentAssignmentId) {
            return parentStudentAssignmentId;
        }
        // If inheritance metadata is missing, fallback to fetching the parent StudentAssignment asset ID
        // This is susceptible to breaking if the nesting of EDU assets change
        // This approach assumes that all StudentAssignment files live directly in the StudentAssignment folder
        // AND are the only children of a StudentAssignment
        // [ACPCEDU-3811] will determine longer-term approach
        if (this.ancestorIDs && this.ancestorIDs.length > 0 && isStudentAssignmentFilePath({ repoPath: this.repoPath })) {
            return this.ancestorIDs.at(-1);
        }
        return parentStudentAssignmentId;
    }
    /**
     * Assets that are StudentAssignmentFiles may start out cached
     * as an AdobeAsset when the asset initially exists outside EDU assets.
     * This getter is equivalent to parentStudentAssignmentId but will be used
     * when the client is working with a list of StudentAssignmentFiles and AdobeAssets
     * */
    get studentAssignmentId() {
        return this.parentStudentAssignmentId;
    }
    get isChildOfStudentAssignment() {
        return !!this.parentStudentAssignmentId;
    }
    /**
     * Returns true if the asset path is inside of a project, otherwise undefined.
     */
    _isPathInsideProject() {
        // It is assumed that the folder and filenames have already been validated
        // as these regular expressions allow for invalid characters.
        const projectChildPatterns = [
            '/projects/[^/]+/[^/]+',
            '/content/assets/projects/[^/]+/[^/]+',
            '/users/[^/]+/projects/[^/]+/[^/]+'
        ];
        return projectChildPatterns.some(pattern => new RegExp(pattern).test(this._path));
    }
    // We rely on app metadata to determine if an asset is a child of a project.
    // If app metadata is not loaded, then we don't know if it has a parent project id and it is undefined.
    get parentProjectID() {
        var _a, _b, _c;
        // EBroker handling will ensure that all descendants have the following, corresponding, application metadata property
        const parentProjectID = (_c = (_b = (_a = this.appMetadata.data) === null || _a === void 0 ? void 0 : _a['cc:inherited']) === null || _b === void 0 ? void 0 : _b['cc:team']) === null || _c === void 0 ? void 0 : _c['repo:assetId'];
        // [SAM-3590] If the parent project ID is not found in the app metadata or the ancestorIDs array,
        // and it's inside a project, call the Context API to obtain the parent projet ID.
        const parentIsMissingFromAncestorIDs = this._ancestorIDs && !this._ancestorIDs.includes(parentProjectID);
        if ((!parentProjectID || parentIsMissingFromAncestorIDs) && this._isPathInsideProject()) {
            this._fixParentProjectID();
        }
        return parentProjectID;
    }
    /**
     * Fix the parentProjectID in appMetadata and then notify clients.
     */
    async _fixParentProjectID() {
        const projectContext = await this._core.getProjectContext();
        const response = await projectContext._callContextAPI(this.cloudID, this.repositoryID);
        // Fix app metadata from response.
        const parentProjectID = response['repo:assetId'];
        if (parentProjectID) {
            // Update the app metadata with the parent project ID.
            this.appMetadata._mergeData({ 'cc:inherited': { 'cc:team': { 'repo:assetId': parentProjectID } } });
        }
    }
    get isChildOfProject() {
        return !!this.parentProjectID;
    }
    async isChildOfCSCProject() {
        if (!this.isChildOfProject) {
            return false;
        }
        const projectId = this.parentProjectID;
        const projectContext = await this._core.getProjectContext();
        const project = await projectContext.getProjectbyID(projectId);
        return [
            ProjectDirectorySubtype.WF_PROJECT,
            ProjectDirectorySubtype.WF_PORTFOLIO,
            ProjectDirectorySubtype.WF_PROGRAM
        ].includes(project.directorySubtype);
    }
    get isArtifact() {
        // if appMetadata isn't loaded, it's not yet known
        if (!this.appMetadata.data) {
            return undefined;
        }
        // if `review:sourceAsset` is present, then it's an Artifact
        return !!this.appMetadata.data['review:sourceAsset'];
    }
    /**
    * Determines if the repo metadata needs to be loaded.
    * @TODO_Deprecation - mark deprecated on/after 2025-03-01, remove on/after 2025-06-01
    * @package -- only for use in SAM.js.
    */
    get needsRepoMetadata() {
        // We may not have complete repoMetadata for the asset in two cases:
        // 1. The asset is a specialized subclass that requires the full repoMetadata
        // 2. The asset was loaded from ACPL and doesn't have a real repoPath yet.
        return this._needsRepoMetadata || !this.repoPath;
    }
    // NOTE: isReviewLink includes legacy items that are not Artifacts
    get isReviewLink() {
        // legacy reviews were published in /pubs but might not have review:sourceAsset app metadata
        if (this.repoPath.startsWith('/pubs/')) {
            return true;
        }
        return this.isArtifact;
    }
    /**
    * Returns the media type of the source document used to generate this Review Link. If not a Review Link, or no
    * source document can be identified, it will return ''
    * Hard coding these strings was a conscious decision to avoid enums and the hardening any logic around mediaTypes
    * because they are still evolving. The ideal solution is for no app-specific logic here, we want to simply reference
    * appMetadta['review:sourceAsset']['dc:format'] for all artifacts.
    */
    get reviewLinkSourceType() {
        var _a;
        if (!this.isReviewLink) {
            return '';
        }
        // current S4R-compliant artifacts store the source type in app metadata
        const dcFormat = (_a = this.appMetadata.data) === null || _a === void 0 ? void 0 : _a[AppMetadataField.REVIEW_SOURCE_ASSET]['dc:format']; // dcFormat equates to mediaType
        if (dcFormat) {
            return dcFormat;
        }
        // XD review links for "prototype" and "spec"
        if ([
            'application/vnd.adobe.xd.sharedartifact+dcx',
            'application/vnd.adobe.xd.cloudproject+dcx'
        ].includes(this.mediaType)) {
            // Assuming the source was "cloudproject" and not "sharedartifact" since it doesn't make sense to have an
            // artifact be the source of an artifact.
            return 'application/vnd.adobe.xd.cloudproject+dcx';
        }
        // legacy Aero links are in /pubs/aero/v5/ -- return Aero media type
        if (this.repoPath.startsWith('/pubs/aero/v5/')) {
            return 'application/vnd.adobe.real+dcx';
        }
        // Legacy InDesign artifacts may be in /pubs/id_review
        // TODO: not sure what the media type of the source docs for legacy artifacts are
        if (this.repoPath.startsWith('/pubs/id_review/')) {
            return 'legacy-INDD';
        }
        // legacy 3d scenes are in /pubs/<review creator ID> (to be confirmed) -- return media type (needs research)
        if (this.repoPath.startsWith('/pubs/')) {
            return '3d/vnd.adobe.asd+dcx';
        }
        return '';
    }
    // NOTE: this should only ever be the repo:name of the Asset. For user-friendly names, use `displayName`
    get name() {
        // NOTE: includes file extension
        return removeArchiveGuidFromName(this._name);
    }
    // Subclasses should override if the user-facing name is something other than repo:name. Do not return `this.name`
    // (the repo:name) as displayName, as in some cases, that might be a guid that the client may want to exclude, in
    // which case the client would have to write a regex to hide guids...but if a user chooses a guid as a file name,
    // that'd cause the user's legit file name to be hidden. Keeping these concepts distinct will ensure clients can
    // have full control over their UI.
    get displayName() {
        return undefined;
    }
    // NOTE: when _appMetadata changes, it won't trigger any observers of shellVisibility to update. But since
    // shellVisibility shouldn't change after initial load (from listing, or getAssetWith*()), this isn't currently
    // necessary. If it becomes necessary, we'll need to have AdobeAsset fire a change even when _appMetadata changes.
    get shellVisibility() {
        // If _appMetadata.data is undefined, then it has not been loaded from listings or
        // by _appMetadata.load(), so shell visibility is unknown.
        if (this._appMetadata.data === undefined) {
            return undefined;
        }
        // '' means that the shell:visibility is known to be visible
        return this._appMetadata.data['shell:visibility'] || '';
    }
    get ancestorIDs() {
        return this._ancestorIDs;
    }
    get storageAssignee() {
        return this._storageAssignee;
    }
    /**
     * @package, used internally by filters, tests, etc.
     */
    get _storageAssignee_NoLazyLoad() {
        return this._storageAssignee;
    }
    get extension() {
        // To match SAM C++, extension does not include the "."
        // Do not return extension if file name starts with '.'
        if (this.name.lastIndexOf('.') > 0 && !this.isFolder) {
            return this.name.substring(this.name.lastIndexOf('.') + 1);
        }
        else {
            return '';
        }
    }
    get mediaType() {
        return this._type;
    }
    get cloudID() {
        return this.id;
    }
    get repositoryID() {
        return this._repositoryID;
    }
    get repositoryName() {
        if (this._repositoryName === undefined) {
            this._populateRepositoryName();
        }
        return this._repositoryName;
    }
    get repoPath() {
        // TODO: Switch to new repo:relativePath once implemented by platform
        return this._path;
    }
    get storageRegion() {
        return this._storageRegion;
    }
    get created() {
        return this._created;
    }
    get modified() {
        return this._modified;
    }
    // returns the last access date for the user.
    // returns undefined if last access date is not set or the asset is not
    // populated via USS.
    get lastAccessed() {
        return this._lastAccessed;
    }
    get isFavorite() {
        return this._isFavorite;
    }
    async setIsFavorite(isFavorite) {
        const gqlManager = await this._core._getGQLManager();
        await gqlManager.setFavorite(this.id, isFavorite);
        const assetContext = this._getAssetContext();
        const assetPool = this._core._getAssetPool();
        const session = assetPool.createUpdateSession();
        assetContext._adobeAssetUpdater.updateLocalItem(session, this, { isFavorite });
        session.commit();
    }
    /**
     * Update lastAccessed Per User Per Asset (PUPA) metadata
     * @param {boolean} clear (optional) Pass `true` to clear the lastAccessedDate on folders
     * @returns {Promise<void>}
     */
    async updateLastAccessed(clear) {
        if (clear && !this.isFolder) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Can only clear lastAccessed for folders');
        }
        await this._ensureLink(RelType.PERUSER_METADATA);
        const assetInterface = await this._getAssetInterface();
        const accessDate = new Date();
        await assetInterface.patchLastAccessed(clear ? undefined : accessDate);
        const assetContext = this._getAssetContext();
        const assetPool = this._core._getAssetPool();
        const session = assetPool.createUpdateSession();
        assetContext._adobeAssetUpdater.updateLocalItem(session, this, {
            perUserMetadata: {
                'shell:lastAccessDate': clear ? null : accessDate.toISOString(),
            }
        });
        session.commit();
    }
    get shared() {
        return this._shared;
    }
    get sizeInBytes() {
        return this._size;
    }
    get isDiscarded() {
        return this._isArchivedLibraryElement
            || getRestorePath(this.repoPath) !== undefined
            || ['DISCARDED', 'DISCARDED_PARENT'].includes(this._assetState);
    }
    /**
     * @package -- for use in SAM.js only
     */
    _isDiscardedWithParent() {
        return this._assetState === 'DISCARDED_PARENT';
    }
    get assetRefString() {
        return JSON.stringify({
            cloud_id: this.cloudID,
            path: this.repoPath,
            display_name: this.name,
            repository_id: this.repositoryID
        });
    }
    get isPublished() {
        return this._isPublished;
    }
    get representations() {
        return this._representations;
    }
    get children() {
        if (!this.isFolder) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Children list can be fetched only for folder');
        }
        // https://jira.corp.adobe.com/browse/SAM-3206
        // We will embed permissions for projects and children of projects
        const embedPermissions = this.isProject || this.isChildOfProject;
        const loader = new AdobeAssetDirectoryLoader(this._core._getAssetPool(), this, this._core, embedPermissions);
        // Children of Project folders can be SWY items
        const implicitFilter = new ImplicitDirectoryListingFilter({ asset: this, _isSharedWithYou: true });
        const assetPool = this._core._getAssetPool();
        const localAssetLoader = new LocalAssetLoader(assetPool, this._core);
        return new ItemSource(assetPool, [loader, localAssetLoader], implicitFilter);
    }
    searchChildren(opts) {
        if (!this.isFolder) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Children can be searched only in the folder');
        }
        const { deepSearch, query } = opts;
        const implicitFilter = new AdobeAssetSearchFilter({ asset: this, deepSearch, query });
        const assetContext = this._getAssetContext();
        const loader = new AdobeAssetDirectorySearchLoader(this._core._getAssetPool(), this._core, assetContext._adobeAssetSearchInterface, this, implicitFilter);
        return new ItemSource(this._core._getAssetPool(), [loader], implicitFilter);
    }
    handleOnsChangedResources(changedResources) {
        // NOTE: if overriding this method in subclasses, please make a utility for parsing the
        // ONSChangedResources to encapsulate in case it changes/reduce errors in implementation.
        if (changedResources === null || changedResources === void 0 ? void 0 : changedResources.includes('api:metadata/repository')) {
            this._repoMetadataResource.isDirty = true;
            // TODO: bypass loading app metadata if changedResources includes api:metadata/application
            // TODO: bypass permission refresh if changedResources includes api:ac/policy
            // https://jira.corp.adobe.com/browse/SAM-3499
            this._loadWithRetry();
        }
        if (changedResources === null || changedResources === void 0 ? void 0 : changedResources.includes('api:metadata/application')) {
            this.appMetadata.load();
        }
        if (changedResources === null || changedResources === void 0 ? void 0 : changedResources.includes('api:ac/policy')) {
            // Load the permissions and set collaborator data dirty flags.
            this._effectivePermissionsResource.isDirty = true;
            this._reloadPermissions();
        }
    }
    /**
     * Discard the asset - this changes its repo:state to DISCARDED, but it's still present as an
     * asset, and can later be restored, or permanently deleted.
     */
    async discard() {
        if (this.isDiscarded) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Asset is already discarded');
        }
        const assetInterface = await this._getAssetInterface();
        const repoMetadata = await assetInterface.discard();
        const assetContext = this._getAssetContext();
        if (isGenerationHistoryAsset(this)) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'Generation History Assets do not currenlty support discard, use permanentlyDelete()');
        }
        // Artifacts are from Share For Review, for assets where you can create a Review artifact via the Share For Review workflow
        if (this._hasArtifacts) {
            // NOTE: this is done in the background and if it fails will not count as a failure
            // for discard. This also means when `discard()` resolves, the output folder may not
            // be deleted yet.
            assetContext._deleteAssetOutputsFolder(this);
        }
        if (repoMetadata) {
            const assetPool = this._core._getAssetPool();
            // Use response metadata to reflect the new state of the Asset
            const session = assetPool.createUpdateSession();
            assetContext._adobeAssetUpdater.updateLocalItem(session, this, repoMetadata);
            if (this.isFolder) {
                // If it's a directory, we also need to update the repo:state of all its children.
                updateCachedDescendents({
                    assetPool,
                    asset: this,
                    session,
                    operation: { type: 'discard' },
                    assetContext
                });
            }
            session.commit();
        }
    }
    /**
     * Simple getter to see if the flag for the outputs folder has been set
     * requires calling AssetContext.assetsHaveArtifacts() before reading this value.
     */
    get hasArtifacts() {
        return this._hasArtifacts;
    }
    /**
     * @package -- for use in SAM.js only
     */
    _clearRepositoryName() {
        this._repositoryName = undefined;
    }
    async _populateRepositoryName() {
        if (this._repositoryName) {
            return;
        }
        const assetContext = this._getAssetContext();
        const assetPool = this._core._getAssetPool();
        const repositoryName = await assetContext._repositoryNameFromID(this._repositoryID);
        if (repositoryName) {
            const session = assetPool.createUpdateSession();
            assetContext._adobeAssetUpdater.updateLocalItem(session, this, { repositoryName });
            session.commit();
        }
    }
    /**
     * @package -- for use in SAM.js only
     *
     */
    async _populateStorageAssignee() {
        const storageAssignee = await this._core.hostAssetContext._getStorageAssigneeFromID(this._repositoryID);
        if (storageAssignee) {
            this._storageAssignee = storageAssignee;
        }
    }
    /**
     * create a Folder asset - this create a empty Folder inside this Folder asset
     * returns the newly created folder asset
     */
    async createFolder(name, retryOnConflict = false, counter = 0) {
        if (!this.isFolder) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Asset is not Folder');
        }
        if (!validatePlatformRepoName(name)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for asset create folder operation.');
        }
        try {
            const relativePath = name;
            await this._ensureLink(RelType.CREATE);
            const assetInterface = await this._getAssetInterface();
            const newFolderMetaData = await assetInterface.createFolder(relativePath);
            const assetContext = this._getAssetContext();
            if (newFolderMetaData) {
                if (this.isProject || this.isChildOfProject) {
                    addProjectIdToMetadata(newFolderMetaData, this.isChildOfProject ? this.parentProjectID : this.id);
                }
                return assetContext._createAssetFromMetadata(newFolderMetaData);
            }
            return await assetContext.getAssetWithRepoPath(`${this.repoPath}/${relativePath}`, this.repositoryID);
        }
        catch (error) {
            if (error.code === SAMErrorCode.CONFLICT && retryOnConflict) {
                const formatFileResult = formatFileName(name, this._core._environment.getValue('ASSET_CONFLICT_NAME_FORMAT'), counter + 1);
                return this.createFolder(formatFileResult.newName, retryOnConflict, formatFileResult.countUsed);
            }
            throw error;
        }
    }
    /**
     * A small private helper to update the createdFromUpload data and PUPA.
     * @param uploadedAsset The asset that was newly created.
     * @package Used only internally.
     */
    async _setCreatedFromUploadData() {
        await this.patchAppMetadata([{ op: 'add', path: '/cc:createdFromUpload', value: true }]);
        // Update last accessed to make it easier for clients to sort/filter uploaded files.
        await this.updateLastAccessed();
    }
    /**
     * Imports content as a new file inside of the current folder
     *
     * Returns the newly created asset.  Will automatically choose between direct upload and block upload,
     * depending on file size.
     *
     */
    async importFile(file, name, mediaType, retryOnConflict = false, counter = 0, setCreatedFrom = true, preferredBlockTransferThreshold = DEFAULT_MAX_SINGLE_TRANSFER_SIZE) {
        if (!this.isFolder) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Asset is not Folder');
        }
        if (typeof file === 'string') {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Unsupported string for file to import');
        }
        if (!validatePlatformRepoName(name)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for file import operation.');
        }
        try {
            const relativePath = name;
            await this._ensureLink(RelType.CREATE);
            await this._ensureLink(RelType.BLOCK_INITIALIZE);
            const assetInterface = await this._getAssetInterface();
            const newFileMetaData = await assetInterface.importFile(file, relativePath, mediaType, preferredBlockTransferThreshold);
            let fileAsset;
            const assetContext = this._getAssetContext();
            if (newFileMetaData) {
                if (this.isProject || this.isChildOfProject) {
                    addProjectIdToMetadata(newFileMetaData, this.isChildOfProject ? this.parentProjectID : this.id);
                }
                fileAsset = assetContext._createAssetFromMetadata(newFileMetaData);
            }
            else {
                fileAsset = await assetContext.getAssetWithRepoPath(`${this.repoPath}/${relativePath}`, this.repositoryID);
            }
            // For performance reasons, we don't bother setting the createdFromUpload data for the asset if it's not
            // expected to be available in search or the Recents list.
            if (setCreatedFrom) {
                await fileAsset._setCreatedFromUploadData();
            }
            return fileAsset;
        }
        catch (error) {
            if (error.code === SAMErrorCode.CONFLICT && retryOnConflict) {
                const formatFileResult = formatFileName(name, this._core._environment.getValue('ASSET_CONFLICT_NAME_FORMAT'), counter + 1);
                return this.importFile(file, formatFileResult.newName, mediaType, retryOnConflict, counter + 1, setCreatedFrom, preferredBlockTransferThreshold);
            }
            throw error;
        }
    }
    /**
     * Updates the primary resource of the asset with the provided file.
     *
     * Will automatically choose between direct upload and block upload, depending on file size.
     *
     * @param file The file blob to update the asset with.
     * @param mediaType The type of the asset version rendition, required for updates (e.g. 'image/png', 'image/jpg',
     *     etc.) see
     *     {@link https://git.corp.adobe.com/pages/caf/api-spec/chapters/common_resources/renditions_resources.html#media-types} for available types
     * @returns A promise containing an AdobeAsset.
     */
    async updateFile(file, mediaType, preferredBlockTransferThreshold = DEFAULT_MAX_SINGLE_TRANSFER_SIZE) {
        if (this.isFolder) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Asset is a folder, not a file');
        }
        if (typeof file === 'string') {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Unsupported string for file to import');
        }
        await this._ensureLink(RelType.BLOCK_INITIALIZE);
        const assetInterface = await this._getAssetInterface();
        const newFileMetaData = await assetInterface.updateFile(file, mediaType, preferredBlockTransferThreshold);
        const assetContext = this._getAssetContext();
        if (newFileMetaData) {
            if (this.isProject || this.isChildOfProject) {
                addProjectIdToMetadata(newFileMetaData, this.isChildOfProject ? this.parentProjectID : this.id);
            }
            return assetContext._createAssetFromMetadata(newFileMetaData);
        }
        else {
            return this;
        }
    }
    /**
     * Returns the IBlockUploadInfoResult for clients to upload and finalize block uploads (for first time uploads and
     * updates). This is intended for the case where the caller does not have the contents of the file to be uploaded,
     * in which case they will also be responsible for calling finalizeBlockUpload after the client has uploaded the
     * file. To perform a first time upload, call this method with the reference to the parent folder. To perform an
     * update, call this method with the reference to the asset that needs to be updated.
     * @param name The name of the asset
     * @param size The size of the asset (e.g. 128, 256, 512, 1024)
     * @param mediaType The type of the asset version rendition, required for updates (e.g. 'image/png', 'image/jpg',
     *     etc.) see
     *     {@link https://git.corp.adobe.com/pages/caf/api-spec/chapters/common_resources/renditions_resources.html#media-types} for available types
     * @returns A IBlockUploadInfoResult object with the upload URL(s) and the finalize URL.
     */
    async getBlockUploadInfo(name, size, mediaType) {
        if (!validatePlatformRepoName(name)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for file import operation.');
        }
        await this._ensureLink(RelType.BLOCK_INITIALIZE);
        const assetInterface = await this._getAssetInterface();
        return assetInterface.getBlockUploadInfo(name, size, !this.isFolder, mediaType);
    }
    /**
     * Used by clients to finalize block uploads for updates/first time uploads after calling
     * getBlockUploadInfo to obtain the transfer urls and performing the uploads.
     * Creating a new file: call {@link getBlockUploadInfo}` on the target parent folder. Otherwise, to update
     *  an existing file, call {@link getBlockUploadInfo} on the file.
     * @param finalizeHref The href to finalize the block upload (returned by {@link getBlockUploadInfo}).
     * @param initResponse The response from the block upload initialization (returned by {@link getBlockUploadInfo}).
     * @param isUpdate A flag to indicate if the upload is an update or a first time upload.
     * @returns A RepositoryMetadata object for first time uploads, and undefined for updates.
     */
    async finalizeBlockUpload(finalizeHref, initResponse) {
        const assetInterface = await this._getAssetInterface();
        return assetInterface.finalizeBlockUpload(finalizeHref, initResponse, !this.isFolder);
    }
    async getDownloadURL(forceBlockDownload, preferredBlockTransferThreshold = DEFAULT_MAX_SINGLE_TRANSFER_SIZE) {
        await this._ensureLink(RelType.PRIMARY);
        await this._ensureLink(RelType.BLOCK_INITIALIZE);
        const assetInterface = await this._getAssetInterface();
        if (this._size < getBlockTransferThreshold(assetInterface.links, preferredBlockTransferThreshold) && !forceBlockDownload) {
            const blob = await this._fileContent.get({ forceRefresh: true });
            if (!blob) {
                throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Cannot fetch blob');
            }
            // For now we are leaking the memory allocated for the blob url.
            // Filed this ticket to address: https://jira.corp.adobe.com/browse/SAM-2996
            const blobUrl = URL.createObjectURL(blob);
            if (!(blobUrl === null || blobUrl === void 0 ? void 0 : blobUrl.length)) {
                throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Cannot convert blob to URL');
            }
            return blobUrl;
        }
        else {
            // If the download link is missing, we need to fetch the download link from the service (SAM-3396). This is a no-op if the link is already present.
            await this._ensureLink(RelType.DOWNLOAD);
            const blockDownloadServiceURL = getURLFromLinks(this.__links, RelType.DOWNLOAD);
            return await assetInterface.getBlockDownloadURL(blockDownloadServiceURL);
        }
    }
    /**
     * Contents of the file as a binary blob.
     */
    get fileContent() {
        if (!this.isFile) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Cannot get content of an asset that is not a file');
        }
        return this._fileContent;
    }
    /**
     * Commit the file
     *
     * For compatibility reasons, this will always perform a direct upload, regardless of file size.
     * If you would like block upload functionality, use {@link updateFile} instead.
     *
     * content are the changes that needs to be committed.
     * localETag is the ETag associated with the file on the server
     * Returns NoErr if successfully committed. Returns Conflict if committing the asset causes a conflict.
     */
    async commitFileChanges(file, localETag) {
        if (!this.isFile) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Asset is not File');
        }
        try {
            await this._ensureLink(RelType.PRIMARY);
            const assetInterface = await this._getAssetInterface();
            const newFileDetails = await assetInterface.commitFileChanges(file, localETag);
            if (this._fileContent.isLoaded) {
                await this._fileContent._setData(file, newFileDetails.eTag);
            }
            return { status: CommitStatus.NoErr, committedEtag: newFileDetails.eTag };
        }
        catch (error) {
            if (error instanceof SAMError) {
                if (error.code === SAMErrorCode.CONFLICT) {
                    return { status: CommitStatus.Conflict };
                }
                if (error.code === SAMErrorCode.NOT_FOUND) {
                    // The file has been deleted. We need to create a new asset and then provide that to the user.
                    const parentRepoPath = this.repoPath.substring(0, this.repoPath.lastIndexOf('/'));
                    let parentDeleted = false;
                    const parentAsset = await this._getAssetContext()
                        .getAssetWithRepoPath(parentRepoPath, this.repositoryID)
                        .catch(error => {
                        const samError = error;
                        if (SAMErrorCode.NOT_FOUND === samError.code) {
                            parentDeleted = true;
                            return undefined;
                        }
                        throw error;
                    });
                    if (parentDeleted) {
                        return { status: CommitStatus.ParentDeletedConflict };
                    }
                    const newFile = await (parentAsset === null || parentAsset === void 0 ? void 0 : parentAsset.importFile(file, this.name));
                    return { status: CommitStatus.DeleteConflict, newAsset: newFile };
                }
            }
            throw error;
        }
    }
    /**
     * Restore the asset - can be given an optional name to restore to, otherwise it
     * restores to the previous repo:name of the asset.
     * @param {string} name - name to use when restoring, defaults to current name
     */
    async restore(name, _counter) {
        var _a;
        if (!this.isDiscarded) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Cannot restore an asset that is not discarded');
        }
        const assetContext = this._getAssetContext();
        const assetPool = this._core._getAssetPool();
        if (this.isLibraryElement) {
            // If asset is a Library Element, we need to use the Melville service to restore
            await assetContext.restoreLibraryElement(this.cloudID);
            // We create fake AdobeAssets for Library Elements returned from the DiscardedSource so they can appear
            // in the discarded list with other Assets. They are not monitored by ONS and do not otherwise exist as Assets in SAM.
            // So when we restore them, rather than updating the state, we remove it from the assetPool and thereby the discardedSource lists.
            const session = assetPool.createUpdateSession();
            session.queueDiscardedItem(this);
            session.commit();
        }
        else {
            let repoMetadata;
            const restoreLocation = getRestorePath(this.repoPath, name);
            if (restoreLocation) {
                // If archived rather than discarded, we need to move to the restore location
                repoMetadata = await this._move(restoreLocation, true);
            }
            else {
                const assetInterface = await this._getAssetInterface();
                try {
                    repoMetadata = await assetInterface.restore(name || this.name);
                }
                catch (e) {
                    const error = e;
                    if (error.code === SAMErrorCode.CONFLICT) {
                        const { newName, countUsed } = formatFileName(name || this.name, this._core._environment.getValue('ASSET_CONFLICT_NAME_FORMAT'), (_counter || 0) + 1);
                        return this.restore(newName, countUsed);
                    }
                    else if (error.code === SAMErrorCode.ACCESS_DENIED) {
                        if ((_a = this.ancestorIDs) === null || _a === void 0 ? void 0 : _a.length) {
                            const parentId = this.ancestorIDs[this.ancestorIDs.length - 1];
                            const parentAsset = await assetContext.getAssetWithCloudID(parentId);
                            if (parentAsset.isDiscarded) {
                                throw SAMError.create(SAMErrorCode.PARENT_DISCARDED, 'Parent folder is discarded');
                            }
                        }
                    }
                    throw error;
                }
            }
            if (repoMetadata) {
                // Optimistically update repo state from operation result
                const session = assetPool.createUpdateSession();
                assetContext._adobeAssetUpdater.updateLocalItem(session, this, repoMetadata);
                if (this.isFolder && repoMetadata['repo:path']) {
                    // If it's a directory, optimistically update the repo state of any children assets.
                    // If it's a directory that was unarchived or had a naming conflict upon restore, we also need to update the repo:path of all its children.
                    const path = (restoreLocation || _counter) ? repoMetadata['repo:path'] : undefined;
                    updateCachedDescendents({
                        assetPool,
                        asset: this,
                        session,
                        operation: { type: 'restore', newPath: path },
                        assetContext
                    });
                }
                session.commit();
            }
        }
    }
    /**
     * Permanently delete the asset
     */
    async permanentlyDelete() {
        const assetContext = this._getAssetContext();
        const assetPool = this._core._getAssetPool();
        if (this.isLibraryElement) {
            await assetContext.permanentlyDeleteLibraryElement(this.cloudID);
            const session = assetPool.createUpdateSession();
            session.queueDiscardedItem(this);
            session.commit();
        }
        else {
            const resultItems = await assetContext.permanentlyDeleteAssets([this]);
            if (resultItems.failedResults.length) {
                throw resultItems.failedResults[0].error;
            }
        }
    }
    // Note - The APIs below aren't present in SAM-CPP:
    get etag() {
        return this._etag;
    }
    get version() {
        return this._version;
    }
    get createdBy() {
        return this._createdBy;
    }
    get modifiedBy() {
        return this._modifiedBy;
    }
    get discarded() {
        return this._discarded;
    }
    get discardedBy() {
        return this._discardedBy;
    }
    /**
     * Detect if the user has a specific permission or permissions
     * @param permissions
     * @usage
     *    // single permission check
     *    asset.hasPermission(Permission.Delete);
     *    // multiple
     *    asset.hasPermission(Permission.Write, Permission.Read);
     *    // multiple via bitwise OR
     *    asset.hasPermission(Permission.Write | Permission.Read);
     *    // multiple via spread operator
     *    asset.hasPermission(...permsToCheck);
     */
    hasPermission(...permissions) {
        return permissions.every((permission) => (this._permissions & permission) === permission);
    }
    get invitationServiceCapabilities() {
        let role = 'none';
        if (this.hasPermission(Permission.Read)) {
            if (this.hasPermission(Permission.Write)) {
                role = this.hasPermission(Permission.Ack) ? 'owner' : 'editor';
            }
            else {
                role = 'viewer';
            }
        }
        return {
            canComment: this.hasPermission(Permission.WriteComment),
            canShare: this.hasPermission(Permission.Share),
            role
        };
    }
    isReadOnly() {
        return this.hasPermission(Permission.Read) && !this.hasPermission(Permission.Write);
    }
    // SAM-CPP doesn't expose the embedded metadata directly - you need to access it via DCX-CPP. We should port this API
    // back to SAM. Since not everybody needs to load the embedded metadata, this returns an object that the user can
    // explicitly load.
    get embeddedMetadata() {
        return this._embeddedMetadata;
    }
    get appMetadata() {
        return this._appMetadata;
    }
    /**
     * Patches application metadata for an Asset.
     * CAUTION: SAM does not validate the JSONPatch array. Wherever possible, use a service that is responsible for
     * maintaining the app metadata fields you want to modify, rather then modifying them directly. E.g., to modify
     * Project related data, use the Projects Service; for Reviews, use the Review service; allow server-side events
     * to populate fields as needed; etc.
     *
     * @param patches {jsonpatch.OpPatch[]} JSONPatch array of operations (https://jsonpatch.com/).
     */
    async patchAppMetadata(patches) {
        await this._appMetadata._patch(patches);
    }
    get manifest() {
        if (!this.isComposite) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Cannot get manifest of an asset that is not a composite');
        }
        return this._manifest;
    }
    /**
     * For use internally to release renditions after
     * the asset has been deleted permanently.
     * @package
     */
    _releaseRenditions() {
        this._renditionFetcher.release();
    }
    // NOTE: this is only guaranteed to work as advertised on web. Clients writing for desktop and
    // web should use `AdobeAsset.thumbnailURL` instead
    getRenditionURL(size, type = RenditionType.PNG) {
        // Do not try to fetch rendition for folders, or LEs that have no rendition link
        if (this.isFolder || (this.isLibraryElement && !this.links[RelType.RENDITION])) {
            return '';
        }
        return this._renditionFetcher.getURL(size, type, this.etag);
    }
    get thumbnailURL() {
        return this.getRenditionURL(THUMBNAIL_SIZE, RenditionType.PNG);
    }
    get thumbnailStatus() {
        return this.renditionURLStatus(THUMBNAIL_SIZE, RenditionType.PNG);
    }
    /**
     * See {@link AssetInterface#getCustomRendition} for usage
     */
    async getCustomRendition({ size, type, urlTemplateOptions, additionalHeaders } = {}) {
        await this._ensureLink(RelType.RENDITION);
        const assetInterface = await this._getAssetInterface();
        return assetInterface.getCustomRendition({ size, type, urlTemplateOptions, additionalHeaders });
    }
    /**
     * See {@link AssetInterface#getCustomRendition} for usage
     */
    async getAllCustomRenditions({ type, urlTemplateOptions, additionalHeaders } = {}) {
        await this._ensureLink(RelType.RENDITION);
        const assetInterface = await this._getAssetInterface();
        return assetInterface.getAllCustomRenditions({ type, urlTemplateOptions, additionalHeaders });
    }
    /**
     * Clears the error status on the request rendition and sets it
     * back to RenditionStatus.NotStarted
     *
     * @note After attempting to fetch a thumbnail and an error has occurred during
     * the fetch request, we assign an error status to the rendition. At this
     * point, we won't try to refetch the thumbnail until this method is called.
     * It is meant to give clients a means to handle when they attempt to refresh
     * instead of SAM.js making that decisions internally which could cause thumbnails
     * to begin loading when that may not be the desired behavior. This is also
     * not meant to fix every issue with thumbnails fetching so in the case where
     * the user might be offline or something similar, it's not recommended for
     * clients to continue to call this indefinitely.
     *
     *
     * @param size Defaults to 512
     * @param type Defaults to PNG
     * @returns {void} If the rendition requested is not found or the etag requested is different
     * than the one that was already fetched, this method will do nothing.
     */
    clearRenditionError(size = THUMBNAIL_SIZE, type = RenditionType.PNG) {
        this._renditionFetcher.clearRenditionError(size, type, this.etag);
    }
    /**
     * Returns one the enumeration values of RenditionStatus.
     *
     * @returns {RenditionStatus}
     */
    renditionURLStatus(size, type) {
        // Do not try to fetch rendition for folders, or LEs that have no rendition link
        if (this.isFolder || (this.isLibraryElement && !this.links[RelType.RENDITION])) {
            return RenditionStatus.Done;
        }
        return this._renditionFetcher.renditionURLStatus(size, type, this.etag);
    }
    /**
     * @deprecated -- will be removed on or after 2024-10-01
     */
    get spaceID() {
        var _a, _b, _c;
        oneTimeWarning('AdobeAsset.spaceID', 'AdobeAsset.spaceID is deprecated and will be removed on or after 2024-10-01.');
        return (_c = (_b = (_a = this.appMetadata.data) === null || _a === void 0 ? void 0 : _a['cc:inherited']) === null || _b === void 0 ? void 0 : _b['cc:space']) === null || _c === void 0 ? void 0 : _c['repo:assetId'];
    }
    /**
     * @deprecated -- will be removed on or after 2024-10-01
     */
    get isSpaceAsset() {
        oneTimeWarning('AdobeAsset.isSpaceAsset', 'AdobeAsset.isSpaceAsset is deprecated and will be removed on or after 2024-10-01.');
        return !!this.spaceID;
    }
    /**
     * @deprecated -- will be removed on or after 2024-10-01
     */
    async getSpace() {
        oneTimeWarning('AdobeAsset.getSpace', 'AdobeAsset.getSpace is deprecated and will be removed on or after 2024-10-01.');
        const space = await this._core.spaceContext.getEnclosingSpace(this.cloudID);
        if (!space) {
            throw SAMError.create(SAMErrorCode.NOT_FOUND, 'Asset does not belong to a Space');
        }
        return space;
    }
    // Exposes the raw links for the underlying asset. This is so we can share them with clients like Fred, that don't have
    // access to SAM (since they're running in a web worker). SAM-CPP doesn't expose this.
    get links() {
        // Make a copy to avoid the client accidentally manipulating the links
        return Object.assign({}, this.__links);
    }
    /**
     * Whether or not ONS notifications for children not in the ItemPool cause that child to be loaded
     * @package -- internal use only
     */
    get _canLoadNewChildrenFromONSNotification() {
        return true;
    }
    /**
     * [SAM-2443] If missing links, then Asset probably came from USS, which doesn't have all R-API links
     *  (SEARCH-32676). In that case, try to update the links from R-API via the resolve API.
     * @package -- only for use in SAM.js
     */
    async _ensureLink(relType) {
        var _a;
        if ((_a = this.__links) === null || _a === void 0 ? void 0 : _a[relType]) {
            return;
        }
        const assetContext = this._getAssetContext();
        const assetPool = this._core._getAssetPool();
        const links = await assetContext._rapi.getAssetLinks(this.cloudID);
        const session = assetPool.createUpdateSession();
        assetContext._adobeAssetUpdater.updateLocalItem(session, this, { '_links': Object.assign(Object.assign({}, this.__links), links) });
        session.commit();
    }
    /**
     * Move within same repository
     *
     * @package -- for use in SAM.js only
     */
    async _move(newPath, retryOnConflict = false, counter = 0) {
        try {
            // In case of Asset created from USS response, repo id is not present
            // Jira on USS https://jira.corp.adobe.com/browse/SRCH-1989
            if (!this._repositoryID) {
                await this._load();
            }
            const operation = {
                op: 'move',
                source: {
                    'repo:assetId': this.id,
                    'repo:repositoryId': this._repositoryID
                },
                target: {
                    'repo:path': newPath,
                    'repo:repositoryId': this._repositoryID
                }
            };
            const assetInterface = await this._getAssetInterface();
            const result = await assetInterface.runOperation(operation);
            return result.asset;
        }
        catch (e) {
            if (e.code === SAMErrorCode.CONFLICT && retryOnConflict) {
                // If we can't restore because an asset already exists with the same name, we append a counter and try again
                const formatFileResult = formatFileName(newPath, this._core._environment.getValue('ASSET_CONFLICT_NAME_FORMAT'), counter + 1);
                return this._move(formatFileResult.newName, true, formatFileResult.countUsed);
            }
            throw e;
        }
    }
    async _copy(destFolder, destName, retryOnConflict = true, counter = 0, modelUpdater) {
        let resultOps = { failedResults: [], newModels: [] };
        await ItemBase.runExclusiveTask('copy', [this], async () => {
            const { path: newPath, counter: currCounter } = this._finalizePath(destFolder.repoPath, destName, counter);
            counter = currCounter;
            const assetsById = new Map();
            assetsById.set(this.id, this);
            if (!destFolder.repositoryID) {
                await destFolder._load();
            }
            const ops = this._getCopyOp(destFolder.repositoryID, newPath);
            const assetContext = this._getAssetContext();
            resultOps = await assetContext._runOperations([ops], assetsById, modelUpdater ? modelUpdater : (session, asset, remoteItem) => {
                if (!remoteItem) {
                    throw SAMError.create(SAMErrorCode.UNKNOWN, 'Missing metadata from asset copy operation.');
                }
                const newAsset = assetContext._adobeAssetUpdater.updateRemoteItem(session, remoteItem);
                return newAsset;
            });
        });
        if (resultOps.failedResults.length) {
            if (resultOps.failedResults[0].error.code === SAMErrorCode.CONFLICT && retryOnConflict === true) {
                return await this._copy(destFolder, destName, retryOnConflict, counter + 1);
            }
            throw resultOps.failedResults[0].error;
        }
        return resultOps.newModels[0];
    }
    /**
     * Make a copy of this Asset within the same repository using the dest folder metadata provided, when the dest
     * folder asset is not on hand.
     *
     * @param destFolderRepoId -- The destination folder's repository ID
     * @param destFolderRepoPath -- The destination folder's repo path
     * @param destName -- (not available on SAM.cpp) -- preferred name for the copy
     */
    async _copyWithDestMetadata(destFolderRepoId, destFolderRepoPath, destName, retryOnConflict = true, counter = 0, modelUpdater) {
        let resultOps = { failedResults: [], newModels: [] };
        const assetContext = await this._getAssetContext();
        await ItemBase.runExclusiveTask('copy', [this], async () => {
            const { path, counter: currCounter } = this._finalizePath(destFolderRepoPath, destName, counter);
            counter = currCounter;
            const assetsById = new Map();
            assetsById.set(this.id, this);
            const ops = this._getCopyOp(destFolderRepoId, path);
            resultOps = await assetContext._runOperations([ops], assetsById, modelUpdater ? modelUpdater : (session, asset, remoteItem) => {
                if (!remoteItem) {
                    throw SAMError.create(SAMErrorCode.UNKNOWN, 'Missing metadata from asset copy operation.');
                }
                const newAsset = assetContext._adobeAssetUpdater.updateRemoteItem(session, remoteItem);
                return newAsset;
            });
        });
        if (resultOps.failedResults.length) {
            if (resultOps.failedResults[0].error.code === SAMErrorCode.CONFLICT && retryOnConflict === true) {
                return await this._copyWithDestMetadata(destFolderRepoId, destFolderRepoPath, destName, retryOnConflict, counter + 1);
            }
            throw resultOps.failedResults[0].error;
        }
        return resultOps.newModels[0];
    }
    _finalizePath(destFolderRepoPath, destName, counter = 0) {
        let targetName = this.name;
        if (destName !== undefined) {
            if (!validatePlatformRepoName(destName)) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for asset copy operation.');
            }
            targetName = destName;
            if (counter) {
                const formatFileResult = formatFileName(targetName, this._core._environment.getValue('ASSET_CONFLICT_NAME_FORMAT'), counter);
                targetName = formatFileResult.newName;
                counter = formatFileResult.countUsed;
            }
        }
        else {
            // check if we are copying in the same folder
            // if yes, then it should follow ASSET_COPY_NAME_FORMAT i.e. %@ copy (%d)
            // if no and conflict, then it should follow ASSET_CONFLICT_NAME_FORMAT i.e. %@ (%d)
            const sameFolder = destFolderRepoPath === this.repoPath.substring(0, this.repoPath.lastIndexOf('/'));
            const formatFileResult = sameFolder ? formatFileName(targetName, this._core._environment.getValue('ASSET_COPY_NAME_FORMAT'), counter)
                : (counter > 0 ? formatFileName(targetName, this._core._environment.getValue('ASSET_CONFLICT_NAME_FORMAT'), counter) : { newName: targetName, countUsed: counter });
            targetName = formatFileResult.newName;
            counter = formatFileResult.countUsed;
        }
        return { path: `${destFolderRepoPath}/${targetName}`, counter };
    }
    _getCopyOp(destFolderRepoId, path) {
        // We only want to copy App metadata for PDFs and no other file format
        // This is a temporary solution and we will have a better solution on the service side
        const includeResources = [{ 'reltype': RelType.PRIMARY }];
        if (this.mediaType === 'application/pdf') {
            includeResources.push({ 'reltype': RelType.APP_METADATA });
        }
        const ops = {
            op: 'copy',
            id: this.id,
            source: {
                'repo:assetId': this.id
            },
            target: {
                'repo:path': path,
                'repo:repositoryId': destFolderRepoId
            },
            // The following copies Content Resources for all formats
            // and Application Metadata for PDFs only
            includeResources
        };
        if (this.repositoryID) {
            const source = ops.source;
            source['repo:repositoryId'] = this.repositoryID;
        }
        return ops;
    }
    /**
     * Make a copy of this Asset within the same repository. If you do not have the dest folder asset on hand consider
     * using _copyWithDestMetadata instead.
     *
     * @param destFolder -- AdobeAsset instance representing the folder in which the copy of this AdobeAsset will be
     *     made. If you do not have the destFolder asset on hand but do have its repo ID and path, consider using
     *     _copyWithDestMetadata instead to avoid an API call to fetch the dest folder.
     * @param destName -- (not available on SAM.cpp) -- preferred name for the copy
     */
    async copy(destFolder, destName) {
        return await this._copy(destFolder, destName);
    }
    /**
     * Duplicate this Asset within the same folder.
     *
     * @param destName -- (not available on SAM.cpp) -- preferred name for the duplicate
     */
    async duplicate(destName) {
        const parentId = this.ancestorIDs.slice(-1)[0];
        const parentAsset = await this._getAssetContext().getAssetWithCloudID(parentId);
        return await this._copy(parentAsset, destName);
    }
    async rename(newName) {
        if (!validatePlatformRepoName(newName)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for asset rename operation.');
        }
        const assetContext = this._getAssetContext();
        const assetPool = this._core._getAssetPool();
        const newPath = renameFileInPath(newName, this);
        const newMetadata = await this._move(newPath);
        if (newMetadata) {
            // Update the metadata after a rename, since both name and path have changed
            const session = assetPool.createUpdateSession();
            if (this.isFolder) {
                updateCachedDescendents({
                    assetPool,
                    asset: this,
                    session,
                    operation: { type: 'rename', newPath },
                    assetContext
                });
            }
            assetContext._adobeAssetUpdater.updateLocalItem(session, this, newMetadata);
            session.commit();
        }
        // If this asset has it's latest version already loaded, we should update the versioned name
        // property opportunistically.
        const latestVersion = this._versionPool.getLocalItemById(this.version);
        if (latestVersion) {
            const historySession = this._versionPool.createUpdateSession();
            VersionUpdater.updateRemoteItem(historySession, {
                version: this.version,
                'repo:deviceAssetName': newName
            });
            historySession.commit();
        }
    }
    /**
     * Moves the AdobeAsset to a new folder and/or renames it
     * @param destFolder AdobeAsset instance representing the folder to which the AdobeAsset will be moved
     * @param assetRenameMap allows renaming of the asset during the move operation
     */
    async move(destFolder, newAssetName) {
        let assetRenameMap;
        if (newAssetName) {
            assetRenameMap = new Map([[this.id, newAssetName]]);
        }
        const resultItems = await this._getAssetContext().moveAssets([this], destFolder, assetRenameMap);
        if (resultItems.failedResults.length) {
            throw resultItems.failedResults[0].error;
        }
    }
    /**
     * @deprecated -- will be removed on or after 2024-10-01
     */
    transferToSpace(target) {
        oneTimeWarning('AdobeAsset.transferToSpace', 'AdobeAsset.transferToSpace is deprecated and will be removed on or after 2024-10-01.');
        return this._getAssetContext().transfer(this, target);
    }
}
__decorate([
    observable$1
], AdobeAsset.prototype, "xmpNumberOfPages", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "createdFromUpload", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "createdByClientId", null);
__decorate([
    retry
], AdobeAsset.prototype, "_loadWithRetry", null);
__decorate([
    memoize$1
], AdobeAsset.prototype, "_getGenerationHistoryInterface", null);
__decorate([
    synchronized
], AdobeAsset.prototype, "_handleResourceUpdates", null);
__decorate([
    memoize$1
], AdobeAsset.prototype, "versions", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "assetType", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isFolder", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isAssignment", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isFile", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isStudentAssignment", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isComposite", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isLibraryElement", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "imageLength", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "imageWidth", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "parentAssignmentID", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isChildOfAssignment", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "parentClassroomId", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "parentClassroomName", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isChildOfClassroom", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "parentAssignmentMaterialsId", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isChildOfAssignmentMaterials", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "parentStudentAssignmentId", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "studentAssignmentId", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isChildOfStudentAssignment", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "parentProjectID", null);
__decorate([
    memoize$1
], AdobeAsset.prototype, "_fixParentProjectID", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isChildOfProject", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isArtifact", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "name", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "shellVisibility", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "ancestorIDs", null);
__decorate([
    lazyLoaded(SharedStorageAssigneeChangedEvent, '_storageAssignee')
], AdobeAsset.prototype, "storageAssignee", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "extension", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "mediaType", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "cloudID", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "repositoryID", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "repositoryName", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "repoPath", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "storageRegion", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "created", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "modified", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "lastAccessed", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isFavorite", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "shared", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "sizeInBytes", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isDiscarded", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "assetRefString", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "isPublished", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "representations", null);
__decorate([
    memoize$1
], AdobeAsset.prototype, "children", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "hasArtifacts", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "etag", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "version", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "createdBy", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "modifiedBy", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "discarded", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "discardedBy", null);
__decorate([
    observable$1
    /**
     * Detect if the user has a specific permission or permissions
     * @param permissions
     * @usage
     *    // single permission check
     *    asset.hasPermission(Permission.Delete);
     *    // multiple
     *    asset.hasPermission(Permission.Write, Permission.Read);
     *    // multiple via bitwise OR
     *    asset.hasPermission(Permission.Write | Permission.Read);
     *    // multiple via spread operator
     *    asset.hasPermission(...permsToCheck);
     */
], AdobeAsset.prototype, "hasPermission", null);
__decorate([
    observable$1
    /**
     * Returns an object of permissions and role for the current user in a similar format to
     * the Invitation Service GET /capabilities API.
     * Currently derived from the effective ACL of the user.
     * For simplicity, the role is defined very loosely to how Invitation Service does it today and there might be
     * usecases where this is not accurate. When those usecases arise, we can revisit this by tightening the definition
     * according to
     * https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=acp&title=Invitations+Service+V4#InvitationsServiceV4-MappingRoles/PermissionstoACEs
     * or calling the GET /capabilities API directly.
     * @returns {InvitationServiceCapabilities}
     */
], AdobeAsset.prototype, "invitationServiceCapabilities", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "appMetadata", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "getRenditionURL", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "thumbnailURL", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "thumbnailStatus", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "renditionURLStatus", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "spaceID", null);
__decorate([
    observable$1
], AdobeAsset.prototype, "links", null);
function getPermission$1(source) {
    var _a;
    // from Asset._load()
    if (source.effectivePermission !== undefined) {
        return source.effectivePermission;
    }
    // From R-API directory listing or USS listings
    if ((_a = source._embedded) === null || _a === void 0 ? void 0 : _a[RelType.AC_EFFECTIVE]) {
        return parseEffectivePermissions(source._embedded[RelType.AC_EFFECTIVE]);
    }
    // If the permissions are not present in the metadata then maintain the current value
    return NotFound;
}
const StorageAssigneeFormat = {
    parse: (value) => {
        return value;
    },
    isEqual: (a, b) => {
        return (a === null || a === void 0 ? void 0 : a.id) === (b === null || b === void 0 ? void 0 : b.id) && (a === null || a === void 0 ? void 0 : a.type) === (b === null || b === void 0 ? void 0 : b.type);
    }
};
// NOTE: LocalAssetMetadata is omitted from  the type definition below even though there are
// properties from it included in the PropertyUpdater. This is by design.
const AssetItemUpdaterOptions = {
    localItemType: AdobeAsset,
    // NOTE: for support of offline creation, where there is no `repo:assetId`
    getAlternateId(remoteItem) { return remoteItem.localID; },
    remoteIdProperty: 'repo:assetId',
    // We want the SharedCollaboratorChangedEvent to fire when these properties update
    // so that internally and externally we can response to this specific event to do
    // things like update collaborators etc.
    changeEventMap: new Map([
        ['_isShared', SharedCollaboratorChangedEvent],
        ['_isSharedWithYouAsset', SharedCollaboratorChangedEvent]
    ]),
    // Mapping AdobeAssetUpdaterMetadata | AssetReviewServiceData to AdobeAsset
    propertyUpdater: new PropertyUpdater({
        '_name': 'repo:name',
        '_etag': 'repo:etag',
        '_repositoryID': 'repo:repositoryId',
        '_repositoryName': 'repositoryName',
        '_path': 'repo:path',
        '_storageRegion': 'storage:region',
        '_type': 'dc:format',
        '_size': { name: 'repo:size', format: 'number' },
        '_version': 'repo:version',
        '_assetClass': { name: 'repo:assetClass', choices: AssetClassChoices },
        '_assetState': { name: 'repo:state', choices: AssetStateChoices },
        '_created': { name: 'storage:deviceCreateDate', format: 'date' },
        '_modified': { name: 'storage:deviceModifyDate', format: 'date' },
        '_lastAccessed': { name: 'perUserMetadata[shell:lastAccessDate]', format: 'date' },
        '_storageAssignee': { name: 'storage:assignee', format: StorageAssigneeFormat },
        '_discarded': { name: 'repo:discardDate', format: 'date' },
        '_createdBy': 'repo:createdBy',
        '_modifiedBy': 'repo:modifiedBy',
        '_discardedBy': 'repo:discardedBy',
        '_imageLength': { name: 'tiff:imageLength', format: 'number' },
        '_imageWidth': { name: 'tiff:imageWidth', format: 'number' },
        '_permissions': { get: getPermission$1, format: 'number' },
        '_isShared': { name: 'isShared', format: 'boolean' },
        '_isFavorite': { name: 'isFavorite', format: 'boolean' },
        '_isSharedWithYouAsset': { name: 'sharedViaInvite', format: 'boolean' },
        '_shareFlagsAreDirty': { name: 'shareFlagsAreDirty', format: 'boolean' },
        // NOTE: for LocalAsset use only
        '_localID': 'localID',
        '_downloadStatus': { name: 'downloadStatus', format: 'object' },
        '_uploadStatus': { name: 'uploadStatus', format: 'object' },
        '_syncStatus': { name: 'syncStatus', format: 'number' },
        '_syncSuspensionReason': { name: 'syncSuspensionReason', format: 'number' },
        // PropertyUpdater reads from _appMetadata._data for comparison
        '_appMetadata._data': {
            name: `_embedded[${RelType.APP_METADATA}]`,
            // Use object_subset format to avoid unnecessary change events. E.g., if _appMetadata.data is
            // `{ 'shell:visibility': 'hiddenSelf', foo: 32 }` and the listing contains
            // `{ 'shell:visibility': 'hiddenSelf' }` then the _mergeData will cause no change, but using format
            // 'object', isEqual() will see source and dest aren't equal and thus assume that a change did occur.
            format: 'object_subset',
            // Only update the appMetadata properties that are in the listing's embedded appMetadata
            set: (parsedSource, dest) => {
                const asset = dest;
                asset.appMetadata._mergeData(parsedSource);
            }
        },
        '_ancestorIDs': { name: 'repo:ancestors', isArray: true, format: 'string' },
        '__links': { name: '_links', format: 'object_subset' },
        '_hasArtifacts': { name: 'hasArtifacts', format: 'boolean' },
        '_createdByClientId': 'repo:createdByClientId',
        '_representations': { name: 'repo:representations', format: 'object' },
        '_xmpNumberOfPages': { name: 'xmpTPg:NPages', format: 'number' },
    })
};
const AdobeAssetUpdater = new ItemUpdater(AssetItemUpdaterOptions);
// Note: Only for use in code that updates SAM.js AdobeAssets from SAM.cpp cached Assets
const LocalAdobeAssetUpdater = new ItemUpdater(AssetItemUpdaterOptions);
function getUSSAssetType(source) {
    // uss type is 'application/x-sharedcloud-collection+json' for directory
    // changing it to standard mime directory type to abstract it for SAM clients
    if (source.type === FOLDER_ALTERNATE_TYPE) {
        return FOLDER_TYPE;
    }
    return source.type;
}
function getUSSAssetClass(source) {
    // for directories, asset_sub_type is not present in USS response
    if (source.type === FOLDER_ALTERNATE_TYPE || source.type === FOLDER_TYPE) {
        return 'directory';
    }
    // for files, asset_sub_type is not present in USS response
    // so we assign anything else that is not dcx or directory as file
    if (source.creative_cloud_asset_type !== 'dcx') {
        return 'file';
    }
    return source.asset_sub_type;
}
function getUSSLastAccessed(source) {
    var _a, _b;
    const lastAccessedISOString = (_b = (_a = source['api:metadata/peruser']) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b['shell:lastAccessDate'];
    // If the property is not present, the current value should be left alone
    if (lastAccessedISOString === undefined) {
        return NotFound;
    }
    // If the property is present, but empty, clear the current value
    if (lastAccessedISOString === '') {
        return undefined;
    }
    return lastAccessedISOString;
}
function getCreatedFromUpload(source) {
    var _a;
    return (_a = source['api:metadata/application']) === null || _a === void 0 ? void 0 : _a['cc:createdFromUpload'];
}
function getUSSStorageRegion(source) {
    var _a, _b;
    // USS stores 'region' as 'US', 'AP', 'EU' for some Assets, and 'va6c2', 'va7' for other Assets. According to USS
    // team, the US/AP/EU strings can be mapped to VA6/JPN3/IRL1, and the others match the R-API storage:region.
    switch ((_a = source.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) {
        case 'us':
            return 'VA6';
        case 'ap':
            return 'JPN3';
        case 'eu':
            return 'IRL1';
        default:
            return ((_b = source.region) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || '';
    }
}
// USS result item does not contain asset name in path, to keep it sync with repo path
// received from RAPI, we will add asset name in asset path while creating/updating asset
// from USS result
function getAssetPath(source) {
    if (source.asset_name_path && source.asset_name) {
        return pathBrowserify.join(source.asset_name_path, source.asset_name);
    }
    return source.asset_name_path || source.asset_name || '';
}
function getEtag(source) {
    var _a;
    return source.composite_manifest_etag || ((_a = source.etag) === null || _a === void 0 ? void 0 : _a.primary) || '';
}
const USSAssetItemUpdaterOptions = {
    localItemType: AdobeAsset,
    remoteIdProperty: 'asset_id',
    // We want the SharedCollaboratorChangedEvent to fire when these properties update
    // so that internally and externally we can respond to this specific event to do
    // things like update collaborators etc.
    changeEventMap: new Map([
        ['_isShared', SharedCollaboratorChangedEvent],
        ['_isSharedWithYouAsset', SharedCollaboratorChangedEvent],
        ['_isPublicLink', SharedCollaboratorChangedEvent],
        ['_directCollaboratorCount', SharedCollaboratorChangedEvent]
    ]),
    propertyUpdater: new PropertyUpdater({
        '_name': 'asset_name',
        '_etag': { get: getEtag },
        // NOTE: USS team added this field recently, so only some Assets will have this field until
        //       re-indexing is finished, which has ETA of Feb 28 2023
        '_repositoryID': 'repo:repositoryId',
        '_path': { get: getAssetPath, format: 'string' },
        '_type': { get: getUSSAssetType, format: 'string' },
        '_size': { name: 'size', format: 'number' },
        '_version': 'asset_version_id',
        '_assetClass': { get: getUSSAssetClass, choices: AssetClassChoices, format: 'string' },
        '_permissions': { get: getPermission$1, format: 'number' },
        '_created': { name: 'create_date', format: 'date' },
        '_modified': { name: 'modify_date', format: 'date' },
        '_shared': { name: 'collab_metadata#mine.shared_date', format: 'date_as_number' },
        '_discarded': { name: 'discarded_date', format: 'date' },
        '_discardedBy': 'discarded_by',
        '_assetState': { name: 'repo:state', choices: AssetStateChoices, format: 'string' },
        '_isArchivedLibraryElement': { name: 'isArchivedLibraryElement', format: 'boolean' },
        '_lastAccessed': { get: getUSSLastAccessed, format: 'date' },
        '_createdFromUpload': { get: getCreatedFromUpload, format: 'boolean' },
        '_storageAssignee': { name: 'storage:assignee', format: StorageAssigneeFormat },
        '_storageRegion': { name: 'region', get: getUSSStorageRegion, format: 'string' },
        '_createdBy': 'creative_cloud_creator_id',
        '_isSharedWithYouAsset': { name: 'sharedViaInvite', format: 'boolean' },
        '_isSWYGroup': { name: 'isSWYGroup', format: 'boolean' },
        '_isShared': { name: 'isShared', format: 'boolean' },
        '_isPublicLink': { name: 'isPublicLink', format: 'boolean' },
        '_directCollaboratorCount': { name: 'directCollaboratorCount', format: 'number' },
        '_isPublished': { name: 'published', format: 'boolean' },
        '_imageLength': { name: 'image_height', format: 'number' },
        '_imageWidth': { name: 'image_width', format: 'number' },
        '_shareFlagsAreDirty': { name: 'shareFlagsAreDirty', format: 'boolean' },
        // See notes in AdobeAssetUpdater
        '_appMetadata._data': {
            name: 'app_metadata',
            format: 'object_subset',
            set: (parsedSource, dest) => {
                const asset = dest;
                asset.appMetadata._mergeData(parsedSource);
            }
        },
        '_ancestorIDs': { name: 'path', isArray: true, format: 'string' },
        '__links': { name: '_links', format: 'object_subset' },
        '_createdByClientId': 'repo:createdByClientId',
        '_representations': { name: 'repo:representations', format: 'object' },
    })
};
const USSAdobeAssetUpdater = new ItemUpdater(USSAssetItemUpdaterOptions);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const reloadSpace = Symbol('reloadSpace');
const clearLastReloadError = Symbol('clearLastReloadError');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class SpaceSearchAssetLoader {
    constructor(assetPool, core, _asset, _ussInterface, _artifactFilter, _embedPermissions = false) {
        this._asset = _asset;
        this._ussInterface = _ussInterface;
        this._artifactFilter = _artifactFilter;
        this._embedPermissions = _embedPermissions;
        /**
         * @package -- for use by USSLoaderHelper
         */
        this._getItemData = this._getItemDataWithRepoId(this._asset.repositoryID);
        this._ussLoaderHelper = new USSLoaderHelper(assetPool, core, this);
    }
    supportsFilter(filter) {
        const supportedFilters = [];
        supportedFilters.push(filter);
        // Client can call getList with SpaceSearchAssetFilter.artifactFilter undefined, but can't pass
        // SSAF.artifactFilter that doesn't match this._artifactFilter
        if (!supportedFilters.every(f => (f.artifactFilter === this._artifactFilter || f.artifactFilter === undefined))) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'SpaceSearchAssetFilter.artifactFilter does not match SpaceSearchAssetLoader.artifactFilter');
        }
        return true;
    }
    loadPage(options) {
        return this._ussLoaderHelper.loadPage(options);
    }
    /**
     * @package -- for use by USSLoaderHelper
     */
    async _getUSSResults({ start, limit, order, mediaTypes }) {
        return this._ussInterface.searchSpace(this._asset.id, this._artifactFilter === 'onlyArtifacts', this._embedPermissions, {
            type: mediaTypes,
            sort_orderby: OrderByToUSSOrderBy[order.field],
            sort_order: order.direction === 'descending' ? 'desc' : 'asc',
            limit,
            start_index: start
        });
    }
    _getItemDataWithRepoId(repoID) {
        // TODO: Patching should be removed once https://jira.corp.adobe.com/browse/SRCH-1989 is fixed
        //       and re-indexing is finished, which has ETA of Feb 28 2023
        return (item) => {
            return Object.assign(Object.assign({}, item), { 'repo:repositoryId': repoID });
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class SpaceSearchAssetFilter extends ImplicitAdobeAssetFilterBase {
    constructor(options) {
        super({ _includeHiddenRecursive: options === null || options === void 0 ? void 0 : options._includeHiddenRecursive });
        this._asset = options === null || options === void 0 ? void 0 : options.asset;
        this.artifactFilter = options === null || options === void 0 ? void 0 : options.artifactFilter;
    }
    matches(item) {
        var _a;
        // check if item is a descendant of the space/working Files folder
        if (((_a = this._asset) === null || _a === void 0 ? void 0 : _a.repoPath) && !item.repoPath.startsWith(`${this._asset.repoPath}/`)) {
            return false;
        }
        // check item meets artifactFilter criteria
        if (item.isArtifact && this.artifactFilter === 'excludeArtifacts') {
            return false;
        }
        if (!item.isArtifact && this.artifactFilter === 'onlyArtifacts') {
            return false;
        }
        return super.matches(item);
    }
}
SpaceSearchAssetFilter.default = new SpaceSearchAssetFilter();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const TeamRoles = ['UNKNOWN', 'NONE', 'MEMBER'];
const SpaceAccessChoices = ['private', 'team'];
const SpaceRoleChoices = ['NONE', 'CONTRIBUTOR', 'REVIEWER'];
const SpaceStates = ['active', 'archived', 'in_progress'];
/// Represents the notion of a "space" where multiple Adobe account holders collaborate
class Space extends ShareableItem {
    constructor() {
        super(...arguments);
        this._name = '';
        this._repositoryID = '';
        this._repositoryName = '';
        this._pathName = '';
        this._created = new Date();
        this._modified = new Date();
        this._contributorCount = 0;
        this._role = 'NONE';
        this._color = '';
        this._isBookmarked = false;
        this._teamID = '';
        this._teamName = '';
        this._thumbnail = '';
        this._access = 'private';
        this._etag = '';
        this._version = 0;
        this._state = 'active';
        this._loadedGeneration = 0;
        // Note that we maintain this flag based on where the item was loaded from.
        // Spaces loaded via the teamAccess=false API will have teamRole='NONE', all other
        // spaces will assume a 'UNKNOWN' role until they are updated with the correct role
        // on the client side.
        this._teamRole = 'UNKNOWN';
    }
    /// The unique id that represents the space.
    get spaceID() {
        return this.id;
    }
    /// The user-visible name assigned to the space.
    get name() {
        return this._name;
    }
    get access() {
        return this._access;
    }
    get etag() {
        return this._etag;
    }
    get state() {
        return this._state;
    }
    /// The unique id of the repository that owns this space.
    get repositoryID() {
        return this._repositoryID;
    }
    /// The user-visible name of the repository (i.e. the organization name) that owns this space.
    get repositoryName() {
        return this._repositoryName;
    }
    /// The full path name for the space (e.g. "/content/assets/Everyone/Test Space").
    get pathName() {
        return this._pathName;
    }
    /// The created date of the space, relative to 00:00:00 UTC on Jan 1, 1970.
    get created() {
        return this._created;
    }
    /// The modified date of the space, relative to 00:00:00 UTC on Jan 1, 1970.
    get modified() {
        return this._modified;
    }
    /// Total number of contributors for this space. Any groups that are added as a Contributor
    /// count as 1 toward this total.
    get contributorCount() {
        return this._contributorCount;
    }
    /// Role on the space for the current user.
    get role() {
        return this._role;
    }
    /// The color assigned to the space.
    get color() {
        return this._color;
    }
    /// Indicates whether the space is bookmarked (i.e. followed) by the current user.
    get isBookmarked() {
        return this._isBookmarked;
    }
    /// The teamID of the parent team.
    get teamID() {
        return this._teamID;
    }
    /// The user-visible name of the parent team.
    get teamName() {
        return this._teamName;
    }
    /// Description of the space.
    get description() {
        return this._description;
    }
    /// Thumbnail URL of the space.
    get thumbnail() {
        return this._thumbnail;
    }
    get version() {
        return this._version;
    }
    get teamRole() {
        return this._teamRole;
    }
    get _links() {
        return this.__links;
    }
    async ensureDescription() {
        var _a;
        if (this._description === undefined) {
            await this.load({ refreshTimeout: -1 });
        }
        return (_a = this.description) !== null && _a !== void 0 ? _a : '';
    }
    async getChild(name) {
        var _a;
        if (!this._children) {
            // Retrieve the children of the space if needed.
            await this.load({ refreshTimeout: -1 });
        }
        return (_a = this._children) === null || _a === void 0 ? void 0 : _a.get(name);
    }
    // Only used for 1-Off Invitees.
    // Memoized so the same Source and its Lists can be reused.
    async searchWorkingFiles() {
        const { _assetPool, _ussInterface } = this._core.hostAssetContext;
        const workingFilesFolder = await this._core.hostAssetContext
            .getAssetWithRepoPath(`${this.pathName}/working_files`, this.repositoryID);
        const spaceSearchAssetLoader = new SpaceSearchAssetLoader(_assetPool, this._core, workingFilesFolder, _ussInterface, 'excludeArtifacts', true // always include permissions for 1-off invitees
        );
        const implicitFilter = new SpaceSearchAssetFilter({
            asset: workingFilesFolder,
            artifactFilter: 'excludeArtifacts'
        });
        return new ItemSource(_assetPool, [spaceSearchAssetLoader], implicitFilter);
    }
    // All Space members should use `searchArtifacts(false)`, as the UI can assume the user has
    // full permissions. For 1-Off Invitees, use `searchArtifacts(true)`
    // Memoized so the same Source and its Lists can be reused -- note that this means you
    // cannot switch between embedPermissions = true and = false.
    async searchArtifacts(embedPermissions = false) {
        const { _assetPool, _ussInterface } = this._core.hostAssetContext;
        const spaceAdobeAsset = await this._core.hostAssetContext.getAssetWithCloudID(this.id);
        const spaceSearchAssetLoader = new SpaceSearchAssetLoader(_assetPool, this._core, spaceAdobeAsset, _ussInterface, 'onlyArtifacts', embedPermissions);
        const implicitFilter = new SpaceSearchAssetFilter({
            asset: spaceAdobeAsset,
            artifactFilter: 'onlyArtifacts',
            // Some artifacts may be in hidden folders
            _includeHiddenRecursive: true
        });
        return new ItemSource(_assetPool, [spaceSearchAssetLoader], implicitFilter);
    }
    async getWorkingFiles() {
        // Assuming repo path of working_files rather than getting it via discovery so it is compatible
        // with SAM.cpp AssetContext. When all of Spaces can be handled in SAM.cpp, this should switch back
        // to using discovery.
        // const workingFiles = await this.getChild('working_files');
        // if (!workingFiles) {
        //     throw SAMError.create(SAMErrorCode.NOT_FOUND, 'could not load working_files');
        // }
        // const folder = await this._core.hostAssetContext.getAssetWithCloudID(workingFiles.id);
        const folder = await this._core.hostAssetContext
            .getAssetWithRepoPath(`${this.pathName}/working_files`, this.repositoryID);
        return folder.children;
    }
    async load(options) {
        var _a;
        const refreshTimeout = options === null || options === void 0 ? void 0 : options.refreshTimeout;
        let lastReload = this._lastReload;
        const canReuseLastReload = lastReload && (
        // The previous load is still pending execution, so we could reuse the same call.
        lastReload.pending
            // Just wanted to do at least one load.
            || refreshTimeout === -1
            // Just in case the data didn't expire already.
            || (refreshTimeout && lastReload.requestTime + refreshTimeout > Date.now()));
        if (!canReuseLastReload) {
            // Otherwise let's load the space again.
            // Note that generation of reloads, we want to make sure that only the very last reload
            // gets a chance to update the space.
            lastReload = this._lastReload = {
                pending: true,
                inProgress: true,
                generation: ((_a = lastReload === null || lastReload === void 0 ? void 0 : lastReload.generation) !== null && _a !== void 0 ? _a : this._loadedGeneration) + 1,
                requestTime: Date.now(),
                promise: new Promise((resolve, reject) => {
                    // Wait until the loop ends to avoid multiple queries on the same data.
                    setTimeout(() => this._executeReload(lastReload).finally(() => lastReload.error ? reject(lastReload.error) : resolve()), 0);
                })
            };
            // Notify the users we have a new loading session.
            this.dispatch(SharedChangeEvent);
        }
        await lastReload.promise;
    }
    async _executeReload(reload) {
        if (reload !== this._lastReload) {
            // The same reload will be used inside the load method up to the point when we actually execute the request.
            // However, there's a case when the `clearLastReloadError` was used while we were waiting. in the setTimeout above.
            // In that case we can just avoid fetching the request entirely.
            assert$1(!reload.pending, 'The pending flag must be false after the reload was cleared out.');
            return;
        }
        // Make a note that the request was executed.
        reload.pending = false;
        try {
            await this._core.spaceContext[reloadSpace](this);
        }
        catch (error) {
            reload.error = error;
        }
        // Check if the asset was removed. We will want to remove it from the lists.
        reload.inProgress = false;
        const lastReload = this._lastReload;
        if (lastReload !== reload && reload.generation <= this._loadedGeneration) {
            // This result is older than a newer request that was already applied to this object.
            // Ignore the results. This can happen if a particular request takes longer to execute
            // and a new reload was already good to go.
            return;
        }
        if (reload.error instanceof SAMError && reload.error.code === SAMErrorCode.NOT_FOUND) {
            const session = this._core.spaceContext.spacePool.createUpdateSession();
            session.queueDiscardedItem(this);
            session.commit();
        }
        // Notify about the end of the load sequence.
        this.dispatch(SharedChangeEvent);
    }
    /**
     * If the item gets updated through the listing API then we need to clear any errors from the previous reload.
     * This usually happens if the user gets re-invited to a space while the space is still in memory.
     * At that point, we need to clear the previous error when the listing API detects the new space.
     */
    [clearLastReloadError]() {
        const lastReload = this._lastReload;
        if (lastReload === null || lastReload === void 0 ? void 0 : lastReload.error) {
            lastReload.error = undefined;
            // Setting pending to false to be able to track it inside `_executeReload` above.
            lastReload.pending = false;
            this.dispatch(SharedChangeEvent);
        }
    }
    get isReloading() {
        var _a, _b;
        return (_b = (_a = this._lastReload) === null || _a === void 0 ? void 0 : _a.inProgress) !== null && _b !== void 0 ? _b : false;
    }
    get lastReloadError() {
        var _a;
        return (_a = this._lastReload) === null || _a === void 0 ? void 0 : _a.error;
    }
    async update(data) {
        await this._core.spaceContext.updateSpace(this, data);
    }
    async rename(newName) {
        await this._core.spaceContext.updateSpace(this, { name: newName });
    }
    async archive() {
        const resultItems = await this._core.spaceContext.archiveSpaces([this]);
        if (resultItems.failedResults.length) {
            throw resultItems.failedResults[0].error;
        }
    }
    async restore(name) {
        let nameMap;
        if (name !== undefined) {
            nameMap = new Map();
            nameMap.set(this, name);
        }
        const resultItems = await this._core.spaceContext.restoreSpaces([this], nameMap);
        if (resultItems.failedResults.length) {
            throw resultItems.failedResults[0].error;
        }
    }
}
__decorate([
    observable$1
], Space.prototype, "name", null);
__decorate([
    observable$1
], Space.prototype, "access", null);
__decorate([
    observable$1
], Space.prototype, "etag", null);
__decorate([
    observable$1
], Space.prototype, "state", null);
__decorate([
    observable$1
], Space.prototype, "repositoryID", null);
__decorate([
    observable$1
], Space.prototype, "repositoryName", null);
__decorate([
    observable$1
], Space.prototype, "pathName", null);
__decorate([
    observable$1
], Space.prototype, "created", null);
__decorate([
    observable$1
], Space.prototype, "modified", null);
__decorate([
    observable$1
], Space.prototype, "contributorCount", null);
__decorate([
    observable$1
], Space.prototype, "role", null);
__decorate([
    observable$1
], Space.prototype, "color", null);
__decorate([
    observable$1
], Space.prototype, "isBookmarked", null);
__decorate([
    observable$1
], Space.prototype, "teamID", null);
__decorate([
    observable$1
], Space.prototype, "teamName", null);
__decorate([
    observable$1
], Space.prototype, "description", null);
__decorate([
    observable$1
], Space.prototype, "thumbnail", null);
__decorate([
    observable$1
], Space.prototype, "version", null);
__decorate([
    observable$1
], Space.prototype, "teamRole", null);
__decorate([
    observable$1
], Space.prototype, "_links", null);
__decorate([
    memoize$1
], Space.prototype, "searchWorkingFiles", null);
__decorate([
    memoize$1
], Space.prototype, "searchArtifacts", null);
__decorate([
    memoize$1
], Space.prototype, "getWorkingFiles", null);
__decorate([
    observable$1
], Space.prototype, "isReloading", null);
__decorate([
    observable$1
], Space.prototype, "lastReloadError", null);
const SpaceChildFormat = {
    parse: (value) => {
        return {
            id: value.id,
            _links: value._links
        };
    },
    isEqual: (a, b) => {
        return a.id === b.id && isDeepEqual(a._links, b._links);
    }
};
const SpaceUpdater = new ItemUpdater({
    localItemType: Space,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_name': 'name',
        '_access': { name: 'access', choices: SpaceAccessChoices },
        '_etag': 'etag',
        '_repositoryID': 'repositoryId',
        '_repositoryName': 'repositoryName',
        '_pathName': 'pathName',
        '_created': { name: 'createdDate', format: 'date' },
        '_modified': { name: 'modifiedDate', format: 'date' },
        '_contributorCount': { name: 'contributorCount', format: 'number' },
        '_role': { name: 'role', choices: SpaceRoleChoices },
        '_color': { name: 'color' },
        '_isBookmarked': { name: 'bookmarked', format: 'boolean' },
        '_teamID': 'teamId',
        '_teamName': 'teamName',
        '_description': 'description',
        '_thumbnail': 'thumbnail',
        '_children': { name: 'children', mapByKey: 'name', format: SpaceChildFormat },
        '_version': { name: 'version', format: 'number' },
        '_teamRole': { name: 'teamRole', choices: TeamRoles },
        '_state': { name: 'state', choices: SpaceStates },
        '__links': { name: '_links', format: 'object' }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const REVIEW_SERVICE_LINKS = {
    [RelType.REVIEW_SERVICE_PROVISION]: [
        'documentId',
        'assetRegion',
        'repositoryId'
    ],
    [RelType.REVIEW_SERVICE_DISCARD]: ['assetId', 'assetRegion', 'repositoryId'],
    [RelType.REVIEW_SERVICE_OUTPUTS]: [
        'assetId',
        'assetRegion',
        'documentId',
        'embed',
        'limit',
        'orderBy',
        'outputType',
        'repositoryId',
        'start'
    ],
    [RelType.REVIEW_SERIVCE_HAS_OUTPUTS]: ['assetRegion']
};
const mapAssetsToAssetIndentifier = function (assets) {
    return assets.map((asset) => {
        return {
            'repo:assetId': asset.id,
            'repo:repositoryId': asset.repositoryID
        };
    });
};
function validateReviewServiceLinks(links) {
    return validateLinks(links, REVIEW_SERVICE_LINKS);
}
//  end parameters for frameLink endpoint
//--------------------------------------------------------------------
class AssetReviewServiceInterface extends InterfaceBase {
    constructor() {
        super(...arguments);
        this.baseURL = `https://${this._core._environment.endpoints.REVIEW_SERVICE_HOST}`;
        this.baseEndpoint = '/api/v1';
        this.indexEndpoint = this.baseEndpoint + '/index';
    }
    getEndpointURL(endpoint) {
        return `${this.baseURL}${endpoint}`;
    }
    async _discoverLinks(rootHref) {
        const response = await this._getResponse(rootHref, this._getHeaders());
        return response._links;
    }
    _getHeaders(contentType) {
        const headers = {};
        if (contentType) {
            headers['Content-Type'] = contentType;
        }
        return headers;
    }
    async discoverLinks() {
        return this._discoverLinks(this.getEndpointURL(this.indexEndpoint));
    }
    async discardOutputsForAsset(assetId, assetRegion, repositoryID) {
        const links = await this.discoverLinks();
        const url = getURLFromLinks(links, RelType.REVIEW_SERVICE_DISCARD, Object.assign(Object.assign({ assetId }, (assetRegion && { assetRegion })), (repositoryID && { repositoryID })));
        await this._doPost(url, this._getHeaders(), undefined, [204]);
    }
    async hasOutputs(assets, assetRegion) {
        const links = await this.discoverLinks();
        const url = getURLFromLinks(links, RelType.REVIEW_SERIVCE_HAS_OUTPUTS, Object.assign({}, (assetRegion && { assetRegion })));
        const response = await this._doPost(url, this._getHeaders(JSON_MIME_TYPE), JSON.stringify(assets), [200]);
        return await response.json();
    }
    _createFrameLinkUrl(params) {
        const url = new URL(`${this.baseURL}/api/v1/frameioLink`);
        Object.entries(params).forEach(([key, val]) => url.searchParams.set(key, val));
        return url.toString();
    }
    /*
     * See https://wiki.corp.adobe.com/display/CreativeCloudAssets/Proposal+v2%3A+CCARS+Frame+S4R+APIs
     *
     * We use the frameLink endpoint for all four CRUD operations, we just change the method:
     *  POST -> associate a new review with source document
     */
    async createReviewLink(param) {
        const { reviewLinkId, artifactId, projectId } = param, query = __rest$2(param, ["reviewLinkId", "artifactId", "projectId"]);
        const response = await this._doPost(this._createFrameLinkUrl(query), { 'Content-Type': 'application/json' }, JSON.stringify({
            reviewLinkId: `${reviewLinkId}`,
            artifactId: `${artifactId}`,
            projectId: `${projectId}`
        }));
        return await response.json();
    }
    /*
     * See https://wiki.corp.adobe.com/display/CreativeCloudAssets/Proposal+v2%3A+CCARS+Frame+S4R+APIs
     *
     * We use the frameLink endpoint for all four CRUD operations, we just change the method:
     *  GET -> return array of all reviews associated with source document
     */
    async getReviewLinks(param) {
        const response = await this._doGet(this._createFrameLinkUrl(param));
        return await response.json();
    }
    /*
     * See https://wiki.corp.adobe.com/display/CreativeCloudAssets/Proposal+v2%3A+CCARS+Frame+S4R+APIs
     *
     * We use the frameLink endpoint for all four CRUD operations, we just change the method:
     *  PUT -> update an existing review associated with source document
     */
    async updateReviewLink(param) {
        const { artifactId, projectId, etag = '*' } = param, query = __rest$2(param, ["artifactId", "projectId", "etag"]);
        const response = await this._doPut(this._createFrameLinkUrl(query), {
            'Content-Type': 'application/json',
            'If-Match': `${etag}`
        }, JSON.stringify({
            artifactId: `${artifactId}`,
            projectId: `${projectId}`
        }));
        return await response.json();
    }
    /*
     * See https://wiki.corp.adobe.com/display/CreativeCloudAssets/Proposal+v2%3A+CCARS+Frame+S4R+APIs
     *
     * We use the frameLink endpoint for all four CRUD operations, we just change the method:
     *  DELETE -> update an existing review associated with source document
     */
    async deleteReviewLink(param) {
        const { etag } = param, query = __rest$2(param, ["etag"]);
        let headers = {};
        if (etag) {
            headers = {
                'If-Match': `${etag}`
            };
        }
        // there is no reponse body to a DELETE returning status 204
        await this._doDelete(this._createFrameLinkUrl(query), headers, [204]);
    }
}
__decorate([
    cache(validateReviewServiceLinks),
    __param(0, key)
], AssetReviewServiceInterface.prototype, "_discoverLinks", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CommentInterface extends InterfaceBase {
    constructor(_core, _assetId) {
        super(_core);
        this._core = _core;
        this._assetId = _assetId;
    }
    _getUrl(endpoint) {
        // TODO: Should we be using a rel links ?
        //  const url = getURLFromLinks(links, RelType.ASSIGNMENTS_START, { assignmentId });
        return `https://${this._core._environment.endpoints.COMMENT_HOST}${endpoint}`;
    }
    _getCommonHeaders(etag) {
        const headers = {
            'Content-Type': 'application/ld+json; profile="https://www.w3.org/ns/anno.jsonld"',
            'Accept': 'application/ld+json; profile="https://www.w3.org/ns/anno.jsonld"',
            'Prefer': 'return=representation;include="https://www.w3.org/ns/oa#PreferContainedDescriptions"',
            'x-ccx-workflow': 'true'
        };
        etag && (headers['If-Match'] = etag);
        return headers;
    }
    /**
     * @description Get a list of the comments associated with an asset
     * from the Red Hawk Commenting Service.
     * @param etag The etag from the previous request, if available
     * @returns The server Response object
     *
     * A typical interface method would return a strongly typed
     * response.json() ( in this case, an IAnnotationCollection ).
     *
     * But we expect the caller to poll this endpoint, so we also
     * want to return response.headers.get('etag'), so it can be
     * used as a parameter in the next use of this endpoint,
     * which allows the server to provide a 206 response ( nothing changed ).
     *
     * So this returns the Response object, which lets the caller
     * obtain both values.
     */
    async getCommentList(etag) {
        const url = this._getUrl(`/assets/${this._assetId}/annots/?status=open%2Cresolved`);
        const headers = this._getCommonHeaders();
        etag && (headers['If-None-Match'] = etag);
        return this._doGet(url, {
            headers,
            successResponseCodes: [200, 208]
        });
    }
    /**
     * @description Get a comment from the Red Hawk Commenting Service.
     * @param data The information necessary for calling the create API.
     * @returns A promise that resolves to the server's response,
     * a CommentCore corresponding to the comment requested for by id.
     */
    async getComment(data) {
        const { annotationId, etag } = data;
        const url = this._getUrl(`/assets/${this._assetId}/annots/${annotationId}?recursive=true`);
        return this._getResponse(url, {
            headers: this._getCommonHeaders(etag)
        });
    }
    /**
     * @description Creates a comment by POST-ing to the Red Hawk Commenting Service.
     * @param data The information necessary for calling the create API.
     * @returns A promise that resolves to the server's response.
     * a CommentCore corresponding to the comment created.
     */
    async createComment(data) {
        // RE: https://git.corp.adobe.com/redhawk/native_client_sdk/blob/fddd524698ec5ad2cb4df23748c845a3c2129243/EurekaClientSDK/api/WebAnnotationsApi.cpp#L469
        // NOTE : CPP supports ANONBEARER, but for a first draft, we'll
        // only support BEARER, which we get for free from InterfaceBase
        // NOTE : We don't need to include User-Agent either
        // NOTE : Investigate whether we can get the URL from links
        const url = this._getUrl(`/assets/${this._assetId}/annots`);
        const response = await this._doPost(url, this._getCommonHeaders(), JSON.stringify(data));
        return response.json();
    }
    /**
     * @description Edit a comment from the Red Hawk Commenting Service.
     * @param data The information necessary for calling the API.
     * @returns A promise that resolves to the server's response,
     * a CommentCore corresponding to the updated comment.
     */
    async editComment(data) {
        const { annotationId, etag, body } = data;
        const url = this._getUrl(`/assets/${this._assetId}/annots/${annotationId}`);
        const response = await this._doPut(url, this._getCommonHeaders(etag), JSON.stringify(body), [200]);
        // response should be a new annotation.
        return response.json();
    }
    /**
     * @description Delete a comment from the Red Hawk Commenting Service.
     * @param data The information necessary for calling the delete API.
     * @returns A promise that resolves to void.
     */
    async deleteComment(data) {
        const { annotationId, etag } = data;
        const url = this._getUrl(`/assets/${this._assetId}/annots/${annotationId}?recursive=true`);
        await this._doDelete(url, this._getCommonHeaders(etag), [204]);
        return;
    }
    /**
     * @description Get the collection of ICommentMetadata for an asset
     * with the Red Hawk Commenting Service.
     * @returns A promise that resolves to the server's response.
     */
    async getMetadata() {
        const url = this._getUrl(`/assets/${this._assetId}?operation=fetch_user_comment_metadata`);
        return this._getResponse(url, {
            headers: this._getCommonHeaders()
        });
    }
    /**
     * @description Set the metadata for a comment with the Red Hawk Commenting Service.
     * @param data The information necessary for calling the API.
     * @returns A promise that resolves to the server's response.
     */
    async updateMetadata(data) {
        const { annotId, read } = data;
        const annotationId = annotId || '';
        const url = this._getUrl(`/assets/${this._assetId}/annots/${annotationId}/metadata?recursive=false`);
        const response = await this._doPut(url, {
            'Content-Type': 'application/vnd.adobe.dc+json;profile="https://comments.adobe.io/schemas/annots_metadata.jsonld"',
            'Accept': 'application/vnd.adobe.dc+json;profile="https://comments.adobe.io/schemas/annots_metadata.jsonld"',
            'x-ccx-workflow': 'true'
        }, JSON.stringify({
            annotId: `/assets/${this._assetId}/annots/${annotationId}`,
            read: read || false
        }), [200]);
        return response.json();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// RE: https://wiki.corp.adobe.com/display/ACPCSDK/Commenting+Service+Integration+Into+SAM
// TODO : Commenting can be used by Guest Users
// RE: https://git.corp.adobe.com/redhawk/native_client_sdk/blob/f0cd86aa3047c1392403b4444b5338189d7302e5/EurekaClientSDK/api/WebAnnotationsApi.cpp
//  I haven't researched how it's done, but the native code supports
//  AnonBearer tokens for guest users.
/**
 * Class representing the notion of a comment ( aka annotation ).
 * @extends ItemBase
 *
 * @example
 * // Instantiate list and load contents
 * const classroomsList = core.classroomContext.getClassrooms().getList(...options);
 * await waitForListLoad(classroomsList);
 *
 * // Get a specific classroom
 * const load = useMemo(() => core.classroomContext.getClassroomById(id), [classroomContext, id]);
 * const { value: classroom, error, loading } = useLoading<Classroom | undefined>(undefined, load);
 */
class Comment extends ItemBase {
    constructor() {
        super(...arguments);
        // WARNING: the server response for a comment includes
        //  "id": "/assets/${assetUrn}/annots/${annotationId}",
        //  "creationId": "${annotationId}",
        //
        // so we map "creationId" to comment.id
        // because ItemBase.id is expected to be the object's cloud-id,
        // and "id" to comment.uri to avoid a naming conflict.
        this._creator = undefined;
        this._created = new Date(0);
        this._bodyValue = undefined;
        this._motivation = undefined;
        this._generator = 'https://comments.acrobat.com/Comment';
        this._type = 'Annotation';
        this._target = undefined;
        this._mentions = undefined;
        this._modified = new Date(0);
        this._etag = undefined;
        this._uri = undefined;
        this._status = undefined;
        this._replies = undefined;
        this._readStatus = false;
    }
    //-----------------------------------------------------------------
    // Simple accessors
    get creator() {
        return this._creator;
    }
    get created() {
        return this._created;
    }
    get bodyValue() {
        return this._bodyValue || '';
    }
    get motivation() {
        // Possible values are ('commenting' | 'replying')
        return this._motivation || 'commenting';
    }
    get generator() {
        // Possible value is 'https://comments.acrobat.com/Comment'
        return this._generator || 'https://comments.acrobat.com/Comment';
    }
    get type() {
        // Possible value is 'Annotation'
        return this._type || 'Annotation';
    }
    get target() {
        return this._target;
    }
    get mentions() {
        return this._mentions;
    }
    get modified() {
        return this._modified;
    }
    get etag() {
        return this._etag || '';
    }
    get uri() {
        return this._uri || '';
    }
    get status() {
        // Possible values are ('open' | 'resolved')
        return this._status || 'open';
    }
    get replies() {
        // Possible values are ('open' | 'resolved')
        return this._replies;
    }
    get readStatus() {
        return this._readStatus;
    }
    toJSON() {
        // When an object implements toJSON()
        // JSON.stringify(object) serializes object.toJSON()
        // instead of object, allowing you to control
        // the keys and values written.
        //
        // This method is returning a Partial<CommentCore>
        // which can be used in a POST or PUT to the server.
        return {
            '@context': [
                'https://www.w3.org/ns/anno.jsonld',
                'https://comments.acrobat.com/ns/anno.jsonld'
            ],
            'creator': this._creator,
            'created': this.created.toISOString(),
            'bodyValue': this.bodyValue,
            'motivation': this.motivation,
            'generator': this.generator,
            'type': this.type,
            'target': this.target,
            /* TODO : 'mentions' : this.mentions */
            'modified': this.modified.toISOString(),
            'etag': this.etag,
            // Map ItemBase.id back to 'creationId',
            // and Comment.uri back to 'id'.
            'id': this.uri,
            'creationId': this.id,
            'status': this.status,
            /* TODO :  'replies': this.replies, */
        };
    }
    // Simple accessors
    //-----------------------------------------------------------------
    get assetUrn() {
        // Split "/assets/${assetUrn}/annots/${annotationId}"
        // into ['', 'assets', assetUrn, 'annots', annotationId]
        // so we can return assetUrn
        const uri = this.uri;
        const array = uri.split('/');
        return (array.length > 2) ? array[2] : '';
    }
    get _pool() {
        return this._commentsResource._commentPool;
    }
    get _interface() {
        return this._commentsResource._commentInterface;
    }
    //-----------------------------------------------------------------
    // Public methods
    async edit(changes) {
        const commentInterface = this._interface;
        const commentPool = this._pool;
        // Get our current state as a CommentCore
        const current = this.toJSON();
        // combine current with changes
        const body = Object.assign(Object.assign({}, current), changes);
        // update the server with the edited body
        const response = await commentInterface.editComment({
            annotationId: this.id,
            etag: this.etag,
            body
        });
        // update our local object with the server response, triggering notifications
        const session = commentPool.createUpdateSession();
        CommentUpdater.updateLocalItem(session, this, response);
        session.commit();
        return this;
    }
    async updateResolvedStatus(isResolved) {
        const status = isResolved ? 'resolved' : 'open';
        return this.edit({ status });
    }
    async updateReadStatus(isRead) {
        const commentInterface = this._interface;
        const commentPool = this._pool;
        const response = await commentInterface.updateMetadata({
            annotId: this.id,
            read: isRead
        });
        const session = commentPool.createUpdateSession();
        CommentUpdater.updateLocalItem(session, this, {
            creationId: this.id,
            readStatus: response.read
        });
        session.commit();
        return this;
    }
    async delete() {
        const commentInterface = this._interface;
        const commentPool = this._pool;
        const id = this.id;
        await commentInterface.deleteComment({
            annotationId: id,
            etag: this.etag
        });
        // after the server deletes the remote object,
        // discard our local object which triggers notifications
        const session = commentPool.createUpdateSession();
        session.queueDiscardedItem(this);
        session.commit();
        // the session doesn't actually remove the item from the pool
        commentPool.removeLocalItems([id]);
    }
    /**
     * @description Create a reply to this comment.
     * @param data The information necessary for calling the API.
     * @returns A promise that resolves to the newly created reply.
     */
    async reply(data) {
        const required = {
            motivation: 'replying',
            target: {
                source: this.uri
            }
        };
        // overwrite data with the reply required fields
        return this._commentsResource.createComment(Object.assign(Object.assign({}, data), required));
    }
}
__decorate([
    observable$1
], Comment.prototype, "creator", null);
__decorate([
    observable$1
], Comment.prototype, "created", null);
__decorate([
    observable$1
], Comment.prototype, "bodyValue", null);
__decorate([
    observable$1
], Comment.prototype, "motivation", null);
__decorate([
    observable$1
], Comment.prototype, "generator", null);
__decorate([
    observable$1
], Comment.prototype, "type", null);
__decorate([
    observable$1
], Comment.prototype, "target", null);
__decorate([
    observable$1
], Comment.prototype, "mentions", null);
__decorate([
    observable$1
], Comment.prototype, "modified", null);
__decorate([
    observable$1
], Comment.prototype, "etag", null);
__decorate([
    observable$1
], Comment.prototype, "uri", null);
__decorate([
    observable$1
], Comment.prototype, "status", null);
__decorate([
    observable$1
], Comment.prototype, "replies", null);
__decorate([
    observable$1
], Comment.prototype, "readStatus", null);
const CommentUpdater = new ItemUpdater({
    localItemType: Comment,
    // NOTE: We are using property 'creationId' in the response as the ItemBase.id
    remoteIdProperty: 'creationId',
    propertyUpdater: new PropertyUpdater({
        // TODO : create nested updater for CommentCreator ?
        _creator: { name: 'creator', format: 'object' },
        // TODO : this is a Date.toISOString(); should this be Date ?
        _created: { name: 'created', format: 'date' },
        _bodyValue: { name: 'bodyValue', format: 'string' },
        // should be ( 'commenting' | 'replying' ), but allow any string (future proof)
        _motivation: { name: 'motivation', format: 'string' },
        // should be 'https://comments.acrobat.com/Comment', but allow any string (future proof)
        _generator: { name: 'generator', format: 'string' },
        // should be 'Annotation', but allow any string (future proof)
        _type: { name: 'type', format: 'string' },
        // TODO : create nested updater for CommentTarget ?
        _target: { name: 'target', format: 'object' },
        // TODO : create nested updater for CommentMention[] ?
        _mentions: { name: 'mentions', format: 'object' },
        // TODO : this is a Date.toISOString(); should this be Date ?
        _modified: { name: 'modified', format: 'date' },
        _etag: { name: 'etag', format: 'string' },
        // NOTE: 'creationId' is mapped to ItemBase.id,
        // and 'id' is mapped to comment.uri.
        _uri: { name: 'id', format: 'string' },
        // should be ( 'open' | 'resolved' ), but allow any string (future proof)
        _status: { name: 'status', format: 'string' },
        // TODO : create nested updater for Comment[] ?
        _replies: { name: 'replies', format: 'object' },
        _readStatus: { name: 'readStatus', format: 'boolean' }
    }),
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CommentLoader {
    constructor(_commentsResource) {
        this._commentsResource = _commentsResource;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    get retryAfter() {
        // convert seconds:string into milliseconds:Number
        return +(this._retryAfter || '12') * 1000;
    }
    get _pool() {
        return this._commentsResource._commentPool;
    }
    get _interface() {
        return this._commentsResource._commentInterface;
    }
    async _loadPage(options, start) {
        var _a;
        // For the initial load(), this._etag is undefined.
        // When polling(), it's the etag from the last call.
        // NOTE: This makes the assumption the loader is only used for one list,
        // which is true in the CommentsResource case.
        const response = await this._interface.getCommentList(this._etag);
        // use (get() || undefined) to convert null into undefined
        this._retryAfter = response.headers.get('retry-after') || undefined;
        this._etag = response.headers.get('etag') || undefined;
        const status = response.status;
        // For (status === 200), the body is a list of comments.
        if (status === 200) {
            const result = await response.json();
            const items = result.first.items;
            const session = this._pool.createLoaderUpdateSession(Date.now());
            const comments = CommentUpdater.updateRemoteItems(session, items);
            session.commit();
            comments.forEach((comment) => {
                comment['_commentsResource'] = this._commentsResource;
            });
            return {
                items: comments,
                total: comments.length,
                loadNextPage: undefined
            };
        }
        // For (status === 208), the body is omitted because our local etag
        // matches the remote etag ( aka nothing has changed ).
        //
        // We are required to return a list of comments, and we've already
        // assumed CommentsResource has one list for one loader, so we'll
        // return the existing list of comments.
        const comments = ((_a = this._commentsResource.getCommentList()) === null || _a === void 0 ? void 0 : _a.items) || [];
        return {
            items: comments,
            total: comments.length,
            loadNextPage: undefined
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$n = {
    created(a, b) {
        return compareValues(a.created.getTime(), b.created.getTime());
    },
};
class CommentOrder extends createItemOrderFactory(OrderFieldToComparator$n) {
}
CommentOrder.default = new CommentOrder('ascending', 'created');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const COMMENTS_CHANGED = 'commentsChanged';
class CommentsResourceChangeEvent extends SAMEvent {
    constructor(annotationIds) {
        super(COMMENTS_CHANGED);
        this.annotationIds = annotationIds;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CommentsResource extends TypedEventEmitter {
    constructor(_core, _assetId) {
        super();
        this._core = _core;
        this._assetId = _assetId;
        /**
         * @package -- for SAM.js internal use only
         */
        this._commentInterface = new CommentInterface(this._core, this._assetId);
        /**
         * @package -- for SAM.js internal use only
         */
        this._commentPool = new ItemPool(this._core, 'comment');
        this._loader = new CommentLoader(this);
        this._source = new ItemSource(this._commentPool, [this._loader]);
    }
    /**
     * @description Get a list of the comments associated with an asset
     * from the Red Hawk Commenting Service.
     * @param data The information necessary for calling the API.
     * @returns A promise that resolves to the server's response,
     * an Array of CommentCore's listing the asset's comments.
     */
    async createComment(data) {
        // Update the remote object with our proposed edit
        const response = await this._commentInterface.createComment(data);
        // The server has successfully updated the remote object,
        // so update our local object to match the final state.
        const session = this._commentPool.createUpdateSession();
        const comment = CommentUpdater.updateRemoteItem(session, response);
        session.commit();
        comment['_commentsResource'] = this;
        return comment;
    }
    /**
     * @experimental API is not ready and mock data is being used
     *
     * @param data creation data (e.g. title, instructions, etc)
     *
     * @returns a promise that resolves to the assignment recently and successfully created
     */
    async getComment(data) {
        let comment = this._commentPool.getLocalItemById(data.annotationId);
        if (!comment) {
            // fetch remote asset with a server call
            const response = await this._commentInterface.getComment(data);
            const session = this._commentPool.createUpdateSession();
            comment = CommentUpdater.updateRemoteItem(session, response);
            session.commit();
            // @ts-expect-error : bit of a hack
            comment._commentsResource = this;
        }
        return comment;
    }
    getCommentList() {
        if (!this._list) {
            this._list = this._source.getList(CommentOrder.default, undefined, { refreshTimeout: -1 });
        }
        return this._list;
    }
    async _poll() {
        const list = this.getCommentList();
        // let the loader re-load the list of comments
        list.setNeedsRefresh();
        list.refresh();
        await waitForListLoad(list);
        // TODO: should this be done when polling? Or every N polls? Typically, read status is always going to be updated
        //     locally, so shouldn't need to sync with remote except on the first fetch. Maybe a PM question.
        // unfortunately, we'll have to explicitly load the metadata ourselves
        // to update the readStatus ( as it's per-user data ).
        const array = await this._commentInterface.getMetadata();
        const readStatuses = new Map(array.map(item => [item.annotId, item.read]));
        const session = this._commentPool.createLoaderUpdateSession(Date.now());
        // Only update comments in the pool. If a comment is added/removed between fetching the comment list and
        // the comment read statuses, there could be a mismatch. If so, it will eventually be consistent with the next
        // poll.
        this._commentPool.forEach((comment) => {
            // The Red Hawk service doesn't save metadata until it's been
            // explicitly set, so it's expected that a comment doesn't
            // always have corresponding metadata, in which case it's in
            // the default (readStatus === false) state.
            // Frustratingly, metadata.creationId looks like
            //  "d4bd6758-6234-4e67-aa6e-fcb6712304d9:8CF81E8A5CD449B40A49403E@c62f24cc5b5b7e0e0a494004"
            // but comment.creationId looks like
            //  "d4bd6758-6234-4e67-aa6e-fcb6712304d9"
            // So match using the annotId ( which has been rename uri in the comment ).
            const readStatus = readStatuses.get(comment.uri) || false;
            if (comment.readStatus !== readStatus) {
                CommentUpdater.updateRemoteItem(session, {
                    creationId: comment.id,
                    readStatus
                });
            }
        });
        session.commit();
        this._stopTimeout = setTimeout(() => this._poll(), this._loader.retryAfter);
    }
    startShortPoll() {
        if (!this._stopTimeout) {
            this._poll();
        }
    }
    stopShortPoll() {
        if (this._stopTimeout) {
            clearTimeout(this._stopTimeout);
            this._stopTimeout = undefined;
        }
    }
    get isShortPollActive() {
        return (this._stopTimeout !== undefined);
    }
    /**
     * @package -- for SAM.js internal use only
     */
    _onONSNotification(assetInfo) {
        var _a;
        this.emit(COMMENTS_CHANGED, new CommentsResourceChangeEvent(assetInfo.annotationIds || []));
        (_a = this._list) === null || _a === void 0 ? void 0 : _a.setNeedsRefresh();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Enum for network status currently only used with the Native Bindings
 * so this has been migrated from AssetContext to help avoid importing
 * AssetContext directly instead of by type.
 *
 * @note Must be kept in sync with NetworkStatus in AssetContext.h
 */
var NetworkStatus$1;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["Offline"] = 0] = "Offline";
    NetworkStatus[NetworkStatus["Wan"] = 1] = "Wan";
    NetworkStatus[NetworkStatus["Cellular"] = 2] = "Cellular";
    // on web, it might not be known if the connection is Wan or Cellular
    NetworkStatus[NetworkStatus["OnlineUnknown"] = 3] = "OnlineUnknown";
})(NetworkStatus$1 || (NetworkStatus$1 = {}));

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2025 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
/**
 * Creates a throttled version of the given function that only calls the original function
 * after the specified delay has passed, even if the throttled function is called multiple times.
 *
 * @example
 *   const throttled = throttle(() => console.log('Hello'), 1000);
 *   throttled();
 *   throttled(); // prints 'Hello' after 1 second, only once
 */
function throttle(fn, delay) {
    let timeout = null;
    return function (...args) {
        const self = this;
        if (!timeout) {
            timeout = setTimeout(() => {
                fn.apply(self, args);
                timeout = null;
            }, delay);
        }
    };
}

const SAM_CPP_ITEM_EVENTS = ['refreshed', 'movedAsset', 'addedAsset', 'removedAsset'];
const LIST_CHANGE_DELAY_MS = 120;
/*
NOTE when testing in UXP SAM Demo app:

When using Chrome debugger to refresh the JS source code, it does not destroy and recreate the SAM.cpp
JS prototypes, so any changes made to this file will not be applied despite appearing in the source
inspector. You have to quit the SAM.cpp demo app and restart.
*/
// Use a getter so that unit tests can inject a mock acplModel
function getACPLModel() {
    // NOTE: must use this syntax for accessing properties of `window`, or else it will break NodeJS clients
    // like Libraries.
    // @ts-expect-error
    return typeof window !== 'undefined' ? window === null || window === void 0 ? void 0 : window.acplModel : undefined;
}
// Convert semver into a padded string that can be compared lexically
function parseVersion(version = '') {
    // Old SAM.cpp versions looked like 2.0.0-main.1234, where the final number was the
    // patch version. Current SAM.cpp uses standard semver major.minor.patch.
    const parts = version.split('.');
    // Coerce old SAM.cpp version into a standard semver, like 2.0.1234, by
    // deleting the '0-main' element
    if (parts[2] === '0-main') {
        parts.splice(2, 1);
    }
    // Ensure each part has some value
    const [major = '0', minor = '0', patch = '0'] = parts;
    // '2.0.1234' becomes '000200001234'
    return [major, minor, patch].map(part => part.padStart(4, '0')).join('');
}
function isSAMCppVer(comparison, version) {
    var _a;
    const aVer = parseVersion((_a = getACPLModel()) === null || _a === void 0 ? void 0 : _a.version);
    const bVer = parseVersion(version);
    switch (comparison) {
        case 'lt': return aVer < bVer;
        case 'gte': return aVer >= bVer;
        default: return false;
    }
}
class ThumbnailChangeEvent extends SAMEvent {
    constructor() {
        super('thumbnailChange');
    }
}
const SharedThumbnailChangeEvent = new ThumbnailChangeEvent();
class PermissionsChangeEvent extends SAMEvent {
    constructor() {
        super('permissionsChange');
    }
}
const SharedPermissionsChangeEvent = new PermissionsChangeEvent();
// See note above about testing in UXP SAM demo app
function patchAssetContext(core) {
    const acplModel = getACPLModel();
    // TODO: expose SAM.cpp AssetContext as acplModel.AssetContext
    // https://jira.corp.adobe.com/browse/SAM-1365
    const AssetContextJS = acplModel.applicationAssetContext.constructor;
    // TODO: update actual version when the issues below are fixed
    if (isSAMCppVer('lt', '9999.9999.9999')) {
        ExtendClass({
            klass: AssetContextJS,
            core,
            overrides: {
                // SAM.cpp does not support optional param
                getAssetWithCloudID(id, confirmAccess = false) {
                    return this.getAssetWithCloudID.original(id, confirmAccess);
                },
                // SAM.cpp does not support optional param
                getAssetWithAssetRefString(assetRefString, confirmAccess = false) {
                    return this.getAssetWithAssetRefString.original(assetRefString, confirmAccess);
                }
            },
            extensions: {
                // SAM.cpp hasn't implemented AssetContext#getUserRepoId(). This method was added to
                // address *SAM-1888*. This patch can be removed when SamCpp supports AssetContext#getUserRepoId()
                getUserRepoID() {
                    // Can't use hostAssetContext.getUserRepoID() because it needs hostAssetContext.itemPool,
                    // which doesn't exist on SAM.cpp hostAssetContext.
                    if (!this._userRepoID) {
                        return this._core._AssetContextJS._rapi.getHomeDirectoryMetadata()
                            .then((homeDirectoryMetadata) => {
                            this._userRepoID = homeDirectoryMetadata['repo:repositoryId'];
                            return this._userRepoID;
                        });
                    }
                    return Promise.resolve(this._userRepoID);
                },
                transfer(source, target) {
                    return (async () => {
                        let targetId;
                        if (target instanceof Space) {
                            const workingFiles = await target.getChild('working_files');
                            if (!workingFiles) {
                                throw SAMError.create(SAMErrorCode.NOT_FOUND, 'unable to find working_files for provided space');
                            }
                            targetId = workingFiles.id;
                        }
                        else {
                            targetId = target.cloudID;
                        }
                        // ACPL substitutes ~ for user's repoID
                        let sourceRepoID = source.repositoryID;
                        let targetRepoID = target.repositoryID;
                        if (sourceRepoID === '~') {
                            sourceRepoID = await this.getUserRepoID();
                        }
                        if (targetRepoID === '~') {
                            targetRepoID = await this.getUserRepoID();
                        }
                        const payload = {
                            source: { assetId: source.cloudID, repositoryId: sourceRepoID },
                            target: { assetId: targetId, repositoryId: targetRepoID }
                        };
                        return this._core._AssetContextJS._assetTransferService.transfer(payload);
                    })();
                },
                // For code in SAM.js that needs to use the ItemPool from SAM.js, like SpaceContext.moveSpace()
                /**
                 * @deprecated To be removed on or after 2024-10-01.
                 */
                assetPool: {
                    get() {
                        oneTimeWarning('SAMCpp.ts _assetPool', 'AssetContext._assetPool is deprecated and will be'
                            + ' removed on or after 2024-10-01. ItemPools are not for use by clients.');
                        return this._core._AssetContextJS._assetPool;
                    }
                },
                /**
                 * @package -- for use in SAM.js only
                 */
                _assetPool: {
                    get() {
                        return this._core._AssetContextJS._assetPool;
                    }
                },
                isOnline: {
                    get() {
                        return this.networkStatus !== undefined ? this.networkStatus !== NetworkStatus$1.Offline : undefined;
                    }
                },
                // Most JS clients never used recentsSource, so use the SAM.js name
                recentAssetsSource: {
                    get() {
                        return this.recentsSource;
                    }
                },
                getRootFolder() {
                    return Promise.resolve(this.rootFolder);
                },
                assetsHaveArtifacts(assets) {
                    return (async () => {
                        // @ts-expect-error
                        if (assets.some((a) => !a.routesToAcplV2)) {
                            return false;
                        }
                        const assetReviewServiceInterface = new AssetReviewServiceInterface(core);
                        const assetIndentifiers = mapAssetsToAssetIndentifier(assets);
                        const results = await assetReviewServiceInterface.hasOutputs(assetIndentifiers);
                        if (results.length === 0) {
                            return false;
                        }
                        results.forEach((asset) => {
                            const foundAsset = assets.find((a) => a.id === asset['repo:assetId']);
                            if (!foundAsset) {
                                return;
                            }
                            foundAsset['_hasArtifacts'] = true;
                            foundAsset.dispatch({ type: 'change' });
                        });
                        return true;
                    })();
                }
            },
            observableMap: {
                'networkChanged': ['networkStatus'],
                'stateChanged': ['cloudSyncStatus']
            }
        });
        const onAssetsChanged = ({ properties, status, previews }) => {
            var _a, _b;
            for (const asset of [...properties, ...status]) {
                (_a = asset._onAssetChanged) === null || _a === void 0 ? void 0 : _a.call(asset);
            }
            for (const asset of previews) {
                (_b = asset === null || asset === void 0 ? void 0 : asset._onRenditionChanged) === null || _b === void 0 ? void 0 : _b.call(asset);
            }
        };
        // only subscribe once
        if (!acplModel.applicationAssetContext._isForwardingAssetChangeEvents) {
            acplModel.applicationAssetContext.on('changedAssets', onAssetsChanged);
            acplModel.applicationAssetContext._isForwardingAssetChangeEvents = true;
        }
    }
}
// See note above about testing in UXP SAM demo app
function patchAssetSource(core) {
    const acplModel = getACPLModel();
    const dirMap = {
        ascending: OrderDirection.Ascending,
        descending: OrderDirection.Descending
    };
    const fieldMap = {
        name: OrderField.Name,
        modified: OrderField.Modified,
        created: OrderField.Created,
        shared: OrderField.Shared
    };
    const AssetSource = acplModel.applicationAssetContext.rootFolder.children.constructor;
    // TODO: update actual version when the issues below are fixed
    if (isSAMCppVer('lt', '9999.9999.9999')) {
        ExtendClass({
            klass: AssetSource,
            core,
            overrides: {
                // SAM.cpp doesn't support Order/Filter objects that SAM.js clients are using. Meanwhile,
                // clients like CDO are expecting the SAM.cpp call signature, so both APIs are supported here.
                getList(maybeOrder, maybeFilter) {
                    var _a, _b;
                    let field;
                    let dir;
                    // if both `direction` and `field` are defined, then it is an AdobeAssetOrder instance
                    const order = maybeOrder;
                    if ((_b = (_a = order.direction) !== null && _a !== void 0 ? _a : order.field) !== null && _b !== void 0 ? _b : true) {
                        dir = dirMap[order.direction];
                        field = fieldMap[order.field];
                    }
                    else {
                        dir = maybeOrder;
                        field = maybeFilter;
                        maybeFilter = undefined;
                    }
                    // Fallback to safe defaults
                    dir = (dir in OrderDirection) ? dir : OrderDirection.Descending;
                    field = (field in OrderField) ? field : OrderField.Modified;
                    const filter = maybeFilter;
                    let list;
                    // Note: if mediaTypes is undefined, it should use the default filter (SAM.cpp only)
                    // If mediaTypes is an empty array, that means "show everything".
                    if (filter === null || filter === void 0 ? void 0 : filter.mediaTypes) {
                        list = this.getListWithTypes(dir, field, [...filter.mediaTypes]);
                    }
                    else {
                        list = this.getList.original(dir, field);
                    }
                    // Note: must patch AssetList before patching AssetSource or else next line will throw an exception
                    list._addEventInterceptors();
                    return list;
                }
            }
        });
    }
}
// See note above about testing in UXP SAM demo app
function patchAssetList(core) {
    const acplModel = getACPLModel();
    const SAM_CPP_ITEM_EVENTS = ['refreshed', 'movedAsset', 'addedAsset', 'removedAsset'];
    const SAM_CPP_STATUS_EVENT = 'statusChanged';
    // TODO: expose AssetSource, AssetList as acplModel.AssetSource, acplModel.AssetList
    // https://jira.corp.adobe.com/browse/SAM-1365
    const assetSource = acplModel.applicationAssetContext.rootFolder.children;
    const AssetList = assetSource.getList(OrderDirection.Descending, OrderField.Modified).constructor;
    // TODO: update actual version when the issues below are fixed
    if (isSAMCppVer('lt', '9999.9999.9999')) {
        ExtendClass({
            klass: AssetList,
            core,
            extensions: {
                // SAM.cpp doesn't have loadNextPage, so map to loadMoreItems
                loadNextPage() {
                    return this.loadMoreItems();
                },
                // TODO: deprecate SAM.cpp load() and add refresh()
                //       https://jira.corp.adobe.com/browse/SAM-2099
                refresh() {
                    return this.load();
                },
                // patchAssetSource calls this
                _addEventInterceptors() {
                    // only subscribe once
                    if (!this._onError) {
                        this._onError = (error) => {
                            this._errors = this._errors || [];
                            this._errors.push(error);
                            this.dispatch(SharedStateChangedEvent);
                        };
                        this.on('error', this._onError);
                    }
                    if (!this._onListNotification) {
                        this._onListNotification = throttle(() => {
                            // Invoke the SAM.cpp items getter
                            this._items = this[$OVERRIDDEN_GETTERS]['items'].call(this);
                            this.dispatch(SharedListChangedEvent);
                            // Also fire status change so that items list is at the expected contents
                            // when the status changes. Clients may post-process and cache list items
                            // from SharedListChangedEvent, so SharedStateChangeEvent must be fired
                            // afterward to ensure their cache has all expected items when the status changes.
                            this.dispatch(SharedStateChangedEvent);
                        }, LIST_CHANGE_DELAY_MS);
                        // SAM.cpp fires 4 different events for list change, but SAM.js clients only expect 1.
                        SAM_CPP_ITEM_EVENTS.forEach(eventName => this.on(eventName, this._onListNotification));
                    }
                    if (!this._onStatusChange) {
                        this._onStatusChange = () => {
                            // After calling getList, clients should immediately receive the Loading
                            // status change event
                            if (this.status === AssetListStatus.Loading) {
                                this.dispatch(SharedStateChangedEvent);
                            }
                            else {
                                this._onListNotification();
                            }
                        };
                        this.on(SAM_CPP_STATUS_EVENT, this._onStatusChange);
                    }
                },
                errors: {
                    get() {
                        // Mobx observes under the SAM.js status event, rather than the CPP events
                        this._core._environment.mobx.reportObserved(this, SharedStateChangedEvent.type);
                        return this._errors;
                    }
                }
            },
            overrides: {
                load() {
                    this._errors = undefined;
                    this.load.original();
                    this.dispatch(SharedStateChangedEvent);
                },
                loadMoreItems() {
                    this.loadMoreItems.original();
                    this.dispatch(SharedStateChangedEvent);
                },
                // SAM.cpp creates a new Array instance and populates it every time clients call `list.items`, which
                // adds a small (but non-zero) performance hit, and has unexpected behavior like
                // `list.items !== list.items`. This patch caches the SAM.cpp items Array.
                items: {
                    get() {
                        this._core._environment.mobx.reportObserved(this, SharedListChangedEvent.type);
                        if (!this._items) {
                            // Invoke the SAM.cpp getter
                            this._items = this[$OVERRIDDEN_GETTERS]['items'].call(this);
                        }
                        return this._items;
                    }
                }
            },
            observableMap: {
                // This makes 'status' property observable under the SAM.js SharedStateChangedEvent
                [SharedStateChangedEvent.type]: ['status']
                // The 'items' property is made observable in the getter override under the SharedListChangeEvent
            }
        });
    }
}
// See note above about testing in UXP SAM demo app
function patchAdobeAsset(core) {
    const acplModel = getACPLModel();
    const ACPLAsset = acplModel.applicationAssetContext.rootFolder.constructor;
    // TODO: update actual version when the issues below are fixed
    if (isSAMCppVer('lt', '9999.9999.9999')) {
        ExtendClass({
            klass: ACPLAsset,
            core,
            overrides: {
                restore(name) {
                    if (this.isLibraryElement) {
                        // SAM.cpp doesn't support restoring CCLibrary Elements
                        return this._core._AssetContextJS.restoreLibraryElement(this.cloudID);
                    }
                    else {
                        return this.restore.original(name);
                    }
                },
                permanentlyDelete() {
                    if (this.isLibraryElement) {
                        // SAM.cpp doesn't support permanently deleting CCLibrary Elements
                        return this._core._AssetContextJS.permanentlyDeleteLibraryElement(this.cloudID);
                    }
                    else {
                        return this.permanentlyDelete.original();
                    }
                },
                duplicate() {
                    return this.duplicate.original(false /*overWriteExisting*/);
                }
            },
            extensions: {
                // SAM.cpp doesn't have a `_setCollaboratorData`, which is called when the bulk fetch response is received in _handleBatchRequest.
                _setCollaboratorData(updatedCollaborators) {
                    AdobeAsset.prototype._setCollaboratorData.apply(this, [updatedCollaborators]);
                    this._isCollaboratorDataLoaded = true;
                    this.dispatch(SharedCollaboratorChangedEvent);
                },
                _queueCollaborators() {
                    if (!this._isCollaboratorDataLoaded) {
                        AdobeAsset.prototype._queueCollaborators.apply(this);
                    }
                },
                // SAM.cpp doesn't have a `isShared` property
                isShared: {
                    get() {
                        this._core._environment.mobx.reportObserved(this, COLLABORATOR_CHANGED);
                        // SWY Assets are shared, so no need to load collaborator data
                        // if isSharedWithYouAsset is false, it might not be known if it is a SWY item
                        if (this.isSharedWithYouAsset) {
                            return true;
                        }
                        this._queueCollaborators();
                        return this._isShared;
                    }
                },
                // SAM.cpp doesn't have a `directCollaboratorCount` property
                directCollaboratorCount: {
                    get() {
                        this._core._environment.mobx.reportObserved(this, COLLABORATOR_CHANGED);
                        this._queueCollaborators();
                        return this._directCollaboratorCount;
                    }
                },
                // SAM.cpp doesn't have a `collaboratorArray` property
                collaboratorArray: {
                    get() {
                        this._core._environment.mobx.reportObserved(this, COLLABORATOR_CHANGED);
                        this._queueCollaborators();
                        return this._collaboratorsArray;
                    }
                },
                // SAM.cpp doesn't have an `isPublicLink` property
                isPublicLink: {
                    get() {
                        this._core._environment.mobx.reportObserved(this, COLLABORATOR_CHANGED);
                        this._queueCollaborators();
                        return this._isPublicLink;
                    }
                },
                // SAM.cpp doesn't have an `id` property
                id: {
                    get() {
                        // `id` is observable because cloudID and localID are observable
                        // due to defaultObservableEvent
                        return this.cloudID || this.localID;
                    }
                },
                // SAM.cpp doesn't expose leave
                removeCurrentUserFromCollaborationList() {
                    return this._core.collaborationContext._removeCurrentUserFromCollaborationList(this);
                },
                // SAM.cpp doesn't expose discard
                discard() {
                    // For Projects items, archive() will do a discard
                    return this.archive().then(() => {
                        if (!this.routesToAcplV2) {
                            oneTimeWarning('discardAsArchive', `Asset.discard(): '${this.repoPath}' will be archived rather than discarded`
                                + ' because it routes to ACPL v1 rather than V2.');
                        }
                        // Archive might not be complete in the cloud yet, so monitor via event listener
                        const discardOutputs = () => {
                            // If the asset is not discarded or does not have artifacts
                            // or does not route to ACPLv2 we don't want to attempt to discard
                            // the outputs folder.
                            if (!this.isDiscarded || !this._hasArtifacts || !this.routesToAcplV2) {
                                return;
                            }
                            const assetReviewServiceInterface = new AssetReviewServiceInterface(this._core);
                            assetReviewServiceInterface.discardOutputsForAsset(this.id).then(() => {
                                this._hasArtifacts = false;
                                this.off(SharedChangeEvent.type, discardOutputs);
                            });
                        };
                        this.on(SharedChangeEvent.type, discardOutputs);
                        // in case it did complete in the cloud
                        if (this.isDiscarded && this._hasArtifacts) {
                            discardOutputs();
                        }
                    });
                },
                // SAM.cpp doesn't have `links`
                links: {
                    get() {
                        // Can't infer the real links because there's no way to know the real region the Asset is
                        // hosted. Can't use the generalized endpoints, because when the service redirects to the
                        // regionalized endpoint, it can drop the auth headers, causing the redirect to fail. For
                        // now, return empty object to prevent `undefined` errors.
                        return {};
                    }
                },
                hasPermission(...permissions) {
                    this._core._environment.mobx.reportObserved(this, SharedPermissionsChangeEvent.type);
                    const hasPermissions = !!this._permissions && AdobeAsset.prototype.hasPermission.apply(this, permissions);
                    if (!this._hasLoadedPermissions) {
                        // prevent loading when already loading
                        this._hasLoadedPermissions = true;
                        this._core._AssetContextJS._rapi.resolveById(this.cloudID)
                            .then(async (assetInterface) => {
                            const resource = new EffectivePermissionsResource(this._core);
                            await assetInterface.getEffectivePermissions(resource);
                            return resource.data;
                        })
                            .then((permissions) => {
                            this._permissions = permissions;
                            this.dispatch(SharedPermissionsChangeEvent);
                        });
                    }
                    return hasPermissions;
                },
                // SAM.cpp doesn't have thumbnailURL
                thumbnailURL: {
                    get() {
                        var _a;
                        this._core._environment.mobx.reportObserved(this, SharedThumbnailChangeEvent.type);
                        // Library Elements do not work on SAM.cpp at all
                        if (this.isFolder || this.isLibraryElement) {
                            return '';
                        }
                        if (this._refreshThumbnail || !this._thumbnailInfo) {
                            // Prevent multiple calls to getThumbnailRendition. ACPLAsset.ts didn't retry
                            // on reject, so this code shouldn't need to.
                            this._refreshThumbnail = false;
                            this._thumbnailStatus = RenditionStatus.Fetching;
                            this.getThumbnailRendition()
                                .then(({ file, hash }) => {
                                var _a, _b;
                                this._thumbnailStatus = RenditionStatus.Done;
                                if (((_a = this._thumbnailInfo) === null || _a === void 0 ? void 0 : _a.file) === file && ((_b = this._thumbnailInfo) === null || _b === void 0 ? void 0 : _b.hash) === hash) {
                                    return; // no change
                                }
                                // `#` and `^` must be encoded separately to work in UXP
                                file = file.replace('#', '%23').replace('^', '%5E');
                                const url = new URL(`file://${file}`);
                                setURLSearchParams(url, {
                                    force: hash
                                });
                                this._thumbnailInfo = {
                                    file,
                                    hash,
                                    url: url.href
                                };
                                this.dispatch(SharedThumbnailChangeEvent);
                            })
                                .catch(() => {
                                this._thumbnailStatus = RenditionStatus.Error;
                                // Use empty thumbnailInfo so that re-render due to the status change doesn't try to
                                // fetch, which will probably still fail, getting stuck in a loop.
                                this._thumbnailInfo = {};
                                this.dispatch(SharedThumbnailChangeEvent);
                            });
                        }
                        // While waiting for thumbnail, return existing thumbnail (if it exists) so the
                        // UI doesn't go blank while waiting.
                        return ((_a = this._thumbnailInfo) === null || _a === void 0 ? void 0 : _a.url) || '';
                    }
                },
                thumbnailStatus: {
                    get() { var _a; return (_a = this._thumbnailStatus) !== null && _a !== void 0 ? _a : RenditionStatus.NotStarted; }
                },
                getRenditionURL() {
                    oneTimeWarning('getRenditionURL', 'SAM.cpp does not support all options of getRenditionURL. Clients that run on web'
                        + ' and desktop should use AdobeAsset.thumbnailURL instead.');
                    return this.thumbnailURL;
                },
                renditionURLStatus() { return this.thumbnailStatus; },
                clearRenditionError() {
                    if (this._thumbnailStatus === RenditionStatus.Error) {
                        this._thumbnailStatus = RenditionStatus.NotStarted;
                        this._thumbnailInfo = undefined;
                        this._refreshThumbnail = true;
                        this.dispatch(SharedThumbnailChangeEvent);
                    }
                },
                // SAM.cpp fires Asset events via AssetContext, but SAM.js emits them from AdobeAsset
                _onAssetChanged() {
                    this.dispatch(SharedChangeEvent);
                },
                _onRenditionChanged() {
                    this._refreshThumbnail = true;
                    // Raise event so only clients that are observing will refresh the thumbnail
                    this.dispatch(SharedThumbnailChangeEvent);
                },
                transferToSpace(target) {
                    return this._core.hostAssetContext.transfer(this, target);
                },
                // SAM.cpp doesn't have versions
                versions: {
                    get() {
                        if (this._assetVersionSource) {
                            return this._assetVersionSource;
                        } // memoize
                        const versionPool = new ItemPool(this._core, 'version');
                        const getAssetInterface = this._core._AssetContextJS._rapi.resolveById(this.id);
                        const loader = new AssetVersionLoader(versionPool, getAssetInterface);
                        this._assetVersionSource = new ItemSource(versionPool, [loader], new EverythingFilter());
                        return this._assetVersionSource;
                    }
                },
                // SAM.cpp doesn't have getCommentsResource
                getCommentsResource() {
                    if (!this._commentsResource) {
                        // TODO: lazy-load CommentsResource module
                        this._commentsResource = new CommentsResource(this._core, this.id);
                    }
                    return this._commentsResource;
                },
                hasArtifacts: {
                    get() {
                        this._core._environment.mobx.reportObserved(this, 'change');
                        return this._hasArtifacts;
                    }
                }
            },
            // make all getter properties observable under the standard 'change' event
            defaultObservableEvent: SharedChangeEvent.type
        });
    }
}
function patchSpaceJS() {
    const acplModel = getACPLModel();
    const assetContext = acplModel.applicationAssetContext;
    // Prior to version 1524, SAM.cpp space search APIs were not working correctly
    // https://jira.corp.adobe.com/browse/SAM-1886
    // https://jira.corp.adobe.com/browse/SAM-2189
    if (isSAMCppVer('gte', '2.0.0-main.1524') && isSAMCppVer('lt', '9999.9999.9999')) {
        // Until SAM.cpp can supply everything needed from SpaceContext and Spaces UI is not
        // dependant on SAM.js internals, patching the Sources for Space contents to use SAM.cpp
        // Sources so Spaces UI can have caching/badging.
        Object.defineProperties(Space.prototype, {
            searchWorkingFiles: {
                value() {
                    if (this._searchWorkingFilesSource) {
                        return Promise.resolve(this._searchWorkingFilesSource);
                    }
                    this._searchWorkingFilesSource = new Promise((resolve, reject) => {
                        assetContext.spaceContext.lookupSpaceById(this.id)
                            .then((space) => {
                            // `space` is the SAM.cpp Space object
                            if (!space) {
                                reject(SAMError.create(SAMErrorCode.NOT_FOUND, `searchWorkingFiles could not find Space ${this.id}`));
                            }
                            resolve(space.searchWorkingFiles());
                        });
                    });
                    return this._searchWorkingFilesSource;
                }
            },
            searchArtifacts: {
                value(embedPermissions = false) {
                    if (this._searchArtifactsSource) {
                        return Promise.resolve(this._searchArtifactsSource);
                    }
                    this._searchArtifactsSource = new Promise((resolve, reject) => {
                        assetContext.spaceContext.lookupSpaceById(this.id)
                            .then((space) => {
                            // `space` is the SAM.cpp Space object
                            if (!space) {
                                reject(SAMError.create(SAMErrorCode.NOT_FOUND, `searchArtifacts could not find Space ${this.id}`));
                            }
                            resolve(space.searchArtifacts(embedPermissions));
                        });
                    });
                    return this._searchArtifactsSource;
                }
            }
        });
    }
    else if (isSAMCppVer('lt', '2.0.0-main.1524')) {
        // For the prior versions of SAM where we don't have space search
        // support in SAM.cpp we are using the temp code
        // to use _AssetContextJS for _assetPool, USSInterface;
        // use hostAssetContext for workingFilesFolder or spaceAdobeAsset
        Object.defineProperties(Space.prototype, {
            searchWorkingFiles: {
                async value() {
                    const assetContext = this._core._AssetContextJS;
                    const { _assetPool, _ussInterface } = assetContext;
                    // We need to use the hostAssetContext as we need to get updates from SAM.cpp AdobeAsset so that the search
                    // filter works fine in case of updates to the space.
                    const workingFilesFolder = await this._core.hostAssetContext
                        .getAssetWithRepoPath(`${this.pathName}/working_files`, this.repositoryID);
                    const spaceSearchAssetLoader = new SpaceSearchAssetLoader(_assetPool, this._core, workingFilesFolder, _ussInterface, 'excludeArtifacts', true // always include permissions for 1-off invitees
                    );
                    const implicitFilter = new SpaceSearchAssetFilter({
                        asset: workingFilesFolder,
                        artifactFilter: 'excludeArtifacts'
                    });
                    return new ItemSource(_assetPool, [spaceSearchAssetLoader], implicitFilter);
                }
            },
            searchArtifacts: {
                async value(embedPermissions = false) {
                    // SAM.cpp AssetContext doesn't expose _assetPool/_ussInterface, so need
                    // to fall back to the JS impl of AssetContext when present. This is
                    // required as SAM.cpp space search APIs are not patched for
                    // SAM versions prior to 1524
                    const assetContext = this._core._AssetContextJS;
                    const { _assetPool, _ussInterface } = assetContext;
                    // We need to use the hostAssetContext as we need to get updates from SAM.cpp AdobeAsset so that the search
                    // filter works fine in case of updates to the space.
                    const spaceAdobeAsset = await this._core.hostAssetContext.getAssetWithCloudID(this.id);
                    const spaceSearchAssetLoader = new SpaceSearchAssetLoader(_assetPool, this._core, spaceAdobeAsset, _ussInterface, 'onlyArtifacts', embedPermissions);
                    const implicitFilter = new SpaceSearchAssetFilter({
                        asset: spaceAdobeAsset,
                        artifactFilter: 'onlyArtifacts',
                        // Some artifacts may be in hidden folders
                        _includeHiddenRecursive: true
                    });
                    return new ItemSource(_assetPool, [spaceSearchAssetLoader], implicitFilter);
                }
            }
        });
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const libraryMediaTypeString = 'application/vnd.adobe.library+dcx';
function repoMetadataIsLibrary(repoMetadata) {
    return (repoMetadata === null || repoMetadata === void 0 ? void 0 : repoMetadata['dc:format']) === libraryMediaTypeString;
}
function repoMetadataIsGenerationHistoryAsset(repoMetadata) {
    return (repoMetadata === null || repoMetadata === void 0 ? void 0 : repoMetadata['dc:format']) === GENERATION_HISTORY_IMAGE_MEDIA_TYPE || (repoMetadata === null || repoMetadata === void 0 ? void 0 : repoMetadata['dc:format']) === GENERATION_HISTORY_VIDEO_MEDIA_TYPE;
}
function metadataIsAssignment({ repoMetadata, appMetadata }) {
    return appMetadataIsAssignment(appMetadata) || isAssignmentPath({ repoPath: repoMetadata['repo:path'] });
}
function appMetadataIsAssignment(app_metadata) {
    var _a, _b;
    return !!((_b = (_a = app_metadata === null || app_metadata === void 0 ? void 0 : app_metadata['cc:inheritable']) === null || _a === void 0 ? void 0 : _a['cc:assignment']) === null || _b === void 0 ? void 0 : _b['repo:assetId']);
}
function appMetadataIsProject(app_metadata) {
    var _a, _b;
    return !!((_b = (_a = app_metadata === null || app_metadata === void 0 ? void 0 : app_metadata['cc:inheritable']) === null || _a === void 0 ? void 0 : _a['cc:team']) === null || _b === void 0 ? void 0 : _b['repo:assetId']);
}
function ussV3ItemMetadataIsProject(item) {
    var _a, _b, _c;
    return !!((_c = (_b = (_a = item.am) === null || _a === void 0 ? void 0 : _a['cc:inheritable']) === null || _b === void 0 ? void 0 : _b['cc:team']) === null || _c === void 0 ? void 0 : _c['repo:assetId']);
}
function ussV3ItemMetadataIsLibrary(item) {
    var _a;
    return ((_a = item.rm) === null || _a === void 0 ? void 0 : _a['dc:format']) === libraryMediaTypeString;
}
function metadataIsStudentAssignment({ repoMetadata, appMetadata }) {
    return appMetadataIsStudentAssignment(appMetadata) || isStudentAssignmentPath({ repoPath: repoMetadata['repo:path'] });
}
function appMetadataIsStudentAssignment(app_metadata) {
    var _a, _b;
    return !!((_b = (_a = app_metadata === null || app_metadata === void 0 ? void 0 : app_metadata['cc:inheritable']) === null || _a === void 0 ? void 0 : _a['cc:studentAssignment']) === null || _b === void 0 ? void 0 : _b['repo:assetId']);
}
function ussMetadataIsLibrary(item) {
    return item.type === libraryMediaTypeString;
}
function ussMetadataIsCustomModel(item) {
    return item.type === CUSTOM_MODEL_MEDIA_TYPE;
}
function appMetadataIsStudentAssignmentFile(app_metadata) {
    var _a, _b;
    return !!((_b = (_a = app_metadata === null || app_metadata === void 0 ? void 0 : app_metadata['cc:inherited']) === null || _a === void 0 ? void 0 : _a['cc:studentAssignment']) === null || _b === void 0 ? void 0 : _b['repo:assetId']);
}
function metadataIsStudentAssignmentFile({ repoMetadata, appMetadata }) {
    return appMetadataIsStudentAssignmentFile(appMetadata) || isStudentAssignmentFilePath({ repoPath: repoMetadata['repo:path'] });
}
function repoToStudentAssignmentFileData(item, appMetadata) {
    return Object.assign(Object.assign({}, item), appMetadata);
}
/* Utils to translate incoming data to the type expected by the subclass's PropertyUpdater: */
// (This mapping is necessary at minimum to translate the id to the remoteIdProperty expected by the PropertyUpdater,
// because we use the updaters to indirectly create an instance of the subclass in the call to
// updater.updateRemoteItems({remoteIdProperty}), regardless of whether the updater supports the incoming data type.)
function ussV3ToProjectMetadata(item) {
    // TODO: Add more Project attributes here as they become available in USS.
    // Minimal data needed for ProjectUpdater. When additional Project metadata
    // is available from the USSv3 query result, add them here.
    return { 'repo:assetId': item.id };
}
function ussToProjectData(item) {
    var _a;
    return {
        'repo:assetId': item.asset_id,
        'repo:repositoryId': item['repo:repositoryId'],
        _embedded: {
            [RelType.AC_EFFECTIVE]: (_a = item._embedded) === null || _a === void 0 ? void 0 : _a[RelType.AC_EFFECTIVE],
            [RelType.APP_METADATA]: item.app_metadata
        }
    };
}
function ussToLibraryData(item) {
    return { 'library_urn': item.asset_id };
}
function ussToStudentAssignmentFileData(item) {
    var _a, _b, _c;
    const ancestors = item.path || [];
    const studentAssignmentId = ((_c = (_b = (_a = item.app_metadata) === null || _a === void 0 ? void 0 : _a['cc:inherited']) === null || _b === void 0 ? void 0 : _b['cc:studentAssignment']) === null || _c === void 0 ? void 0 : _c['repo:assetId']) || ancestors[ancestors.length - 1];
    return Object.assign(Object.assign({}, item), { 'repo:assetId': item['asset_id'], 'computedStudentAssignmentId': studentAssignmentId });
}
function ussV3ToStudentAssignmentFileData(item) {
    var _a, _b, _c, _d, _e;
    const ancestors = (_b = (_a = item.rm) === null || _a === void 0 ? void 0 : _a['repo:ancestors']) !== null && _b !== void 0 ? _b : [];
    const studentAssignmentId = ((_e = (_d = (_c = item.am) === null || _c === void 0 ? void 0 : _c['cc:inherited']) === null || _d === void 0 ? void 0 : _d['cc:studentAssignment']) === null || _e === void 0 ? void 0 : _e['repo:assetId']) || ancestors[ancestors.length - 1];
    return Object.assign(Object.assign(Object.assign({}, item.rm), item.am), { 'computedStudentAssignmentId': studentAssignmentId });
}
function ussToCustomModelData(item) {
    return Object.assign(Object.assign({}, item), { 'repo:assetId': item['asset_id'], 'application_metadata': item['app_metadata'], 'firefly#ffmodel': item['firefly#ffmodel'], 'repo:path': item['original_path'], 'repo:createDate': Math.floor((new Date(item['create_date'])).getTime() / 1000), 'repo:modifyDate': Math.floor((new Date(item['modify_date'])).getTime() / 1000), 'repo:version': item['asset_version_id'], 'storage:region': item['region'], 'repo:size': item['size'] });
}
function ussV3ToLibraryData(item) {
    return { 'library_urn': item.id };
}
function repoToLibraryData(item) {
    return { 'library_urn': item['repo:assetId'] };
}
function repoToAssignmentData(item, appMetadata) {
    return Object.assign(Object.assign(Object.assign({}, item), appMetadata), { 
        // Assignment specific links and correctly structured children assets are not available from an AdobeAsset
        _links: undefined, children: [] });
}
class AdobeAssetFactory {
    constructor(_core) {
        this._core = _core;
    }
    // Creates assets from a list of USSItemMetadata returned from USSv3
    // getItemData maps the repo metadata fields, as well as isShared, sharedViaInvite, and app metadata fields
    // from USSv3 format to RAPI format
    // NOTE: Caller is responsible for committing the session after this is called
    assetsFromUSSV3AppMetadata(session, itemMetadata, getItemData, libraryContext) {
        if (libraryContext) {
            libraryContext._libraryUpdater.updateRemoteItems(session, itemMetadata.filter(ussV3ItemMetadataIsLibrary).map(ussV3ToLibraryData));
        }
        this._core.classroomContext._studentAssignmentFileUpdater.updateRemoteItems(session, itemMetadata.filter((itemMetadata) => metadataIsStudentAssignmentFile({ repoMetadata: itemMetadata.rm, appMetadata: itemMetadata.am }))
            .map(ussV3ToStudentAssignmentFileData));
        this._core.projectContext._projectUpdater.updateRemoteItems(session, itemMetadata.filter(ussV3ItemMetadataIsProject).map(ussV3ToProjectMetadata));
        return this._core.hostAssetContext._adobeAssetUpdater.updateRemoteItems(session, 
        // allow Loader to provide additional item metadata (optional)
        itemMetadata.map((item) => {
            return getItemData(item);
        }));
    }
    // Create assets from a list of USSMetadata
    // getItemData allows the caller to add additional metadata
    // NOTE: Caller is responsible for committing the session after this is called
    assetsFromUSSMetadata(session, items, getItemData, libraryContext, customModelContext) {
        // Ensure that Projects are added to the discarded list as a "Project" instance.
        // ProjectUpdater creates a blank Project instance and relies on the USSAdobeAssetUpdater
        // to fill in the blanks.
        const projects = this._core.projectContext._projectUpdater.updateRemoteItems(session, items.filter(item => appMetadataIsProject(item.app_metadata)).map(ussToProjectData));
        // USS won't have all the permissions required for the deleted view
        // Loaders are responsible for populating the _canRestoreProject cache before it gets here.
        for (const project of projects) {
            project._applyRestorePermission(session);
        }
        this._core.classroomContext._studentAssignmentFileUpdater.updateRemoteItems(session, items.filter((item) => appMetadataIsStudentAssignmentFile(item.app_metadata) || ussIsStudentAssignmentFilePath(item))
            .map(ussToStudentAssignmentFileData));
        // Ensure that Libraries are added to the discarded list as a "Library" instance
        if (libraryContext) {
            libraryContext._libraryUpdater.updateRemoteItems(session, items.filter(ussMetadataIsLibrary).map(ussToLibraryData));
        }
        if (customModelContext) {
            customModelContext._customModelUpdaterMelville.updateRemoteItems(session, items.filter(ussMetadataIsCustomModel).map(ussToCustomModelData));
        }
        return USSAdobeAssetUpdater.updateRemoteItems(session, 
        // allow Loader to provide additional item metadata (optional)
        items.map(item => (getItemData === null || getItemData === void 0 ? void 0 : getItemData(item)) || item));
    }
    // Create assets from a list of RepositoryMetadata returned from RAPI
    // NOTE: Caller is responsible for committing the session after this is called
    assetsFromRepoMetadata(session, repoMetadatas, libraryContext) {
        return repoMetadatas.map(repoMetadata => {
            var _a, _b, _c;
            let permissions = {};
            if ((_a = repoMetadata._embedded) === null || _a === void 0 ? void 0 : _a[RelType.AC_EFFECTIVE]) {
                permissions = parseEffectivePermissions((_b = repoMetadata._embedded) === null || _b === void 0 ? void 0 : _b[RelType.AC_EFFECTIVE]);
            }
            return this.assetFromRepoMetadata(session, repoMetadata, permissions, (_c = repoMetadata._embedded) === null || _c === void 0 ? void 0 : _c[RelType.APP_METADATA], libraryContext);
        });
    }
    assetFromRepoMetadata(session, repoMetadata, permissions, appMetadata, libraryContext, projectMetadata, studentAssignmentMetadata, perUserMetadata, generationHistoryContext, generationHistoryMetadata) {
        var _a, _b;
        let asset;
        if (appMetadata && Object.keys(appMetadata).length > 0) {
            // We should have a better way to do this
            repoMetadata._embedded = Object.assign(Object.assign({}, repoMetadata._embedded), { [RelType.APP_METADATA]: appMetadata });
        }
        const assetMetadata = repoMetadata || {};
        if (permissions && Object.keys(permissions).length > 0) {
            assetMetadata.effectivePermission = permissions;
        }
        if (perUserMetadata) {
            assetMetadata.perUserMetadata = perUserMetadata;
        }
        if (projectMetadata && Object.keys(projectMetadata).length > 0) {
            asset = this._core.projectContext._projectUpdater.updateRemoteItem(session, projectMetadata);
            // Since ProjectUpdater doesn't handle all repo metadata fields, use AdobeAssetUpdater
            // For example we need the links coming in from the repoMetadata to be used in AdobeAsset
            this._core.hostAssetContext._adobeAssetUpdater.updateLocalItem(session, asset, assetMetadata);
            // Apply Project-specific metadata and overrides
            // An example of this is the createdBy field which is different for Projects
            this._core.projectContext._projectUpdater.updateLocalItem(session, asset, projectMetadata);
        }
        else if (repoMetadataIsLibrary(assetMetadata) && libraryContext) {
            const libraryData = repoToLibraryData(assetMetadata);
            libraryContext._libraryUpdater.updateRemoteItem(session, libraryData);
            // Update repo metadata fields that are not handled by LibraryUpdater with the AdobeAssetUpdater
            asset = this._core.hostAssetContext._adobeAssetUpdater.updateRemoteItem(session, assetMetadata);
        }
        else if (appMetadata && metadataIsStudentAssignmentFile({ repoMetadata, appMetadata })) {
            const studentAssignmentFileData = repoToStudentAssignmentFileData(assetMetadata, appMetadata);
            const ancestors = repoMetadata['repo:ancestors'];
            // Last ancestor is the student assignment id. This is susceptible to breaking if the nesting of EDU assets change
            // [ACPCEDU-3811] will determine longer-term approach for getting this information
            const studentAssignmentId = ((_b = (_a = appMetadata['cc:inherited']) === null || _a === void 0 ? void 0 : _a['cc:studentAssignment']) === null || _b === void 0 ? void 0 : _b['repo:assetId']) || ancestors[ancestors.length - 1];
            studentAssignmentFileData.computedStudentAssignmentId = studentAssignmentId;
            asset = this._core.classroomContext._studentAssignmentFileUpdater.updateRemoteItem(session, studentAssignmentFileData);
            this._core.hostAssetContext._adobeAssetUpdater.updateLocalItem(session, asset, assetMetadata);
        }
        else if (metadataIsStudentAssignment({ repoMetadata, appMetadata }) && studentAssignmentMetadata) {
            asset = this._core.classroomContext._studentAssignmentUpdater.updateRemoteItem(session, studentAssignmentMetadata);
            this._core.hostAssetContext._adobeAssetUpdater.updateLocalItem(session, asset, studentAssignmentMetadata);
        }
        else if (appMetadata && metadataIsAssignment({ repoMetadata, appMetadata })) {
            const assignmentData = repoToAssignmentData(assetMetadata, appMetadata);
            asset = this._core.classroomContext._assignmentUpdater.updateRemoteItem(session, assignmentData);
            // Update repo metadata fields that are not handled by AssignmentUpdater with the AdobeAssetUpdater
            this._core.hostAssetContext._adobeAssetUpdater.updateLocalItem(session, asset, assetMetadata);
        }
        else if (repoMetadataIsGenerationHistoryAsset(assetMetadata) && generationHistoryContext && generationHistoryMetadata) {
            asset = this._core.hostAssetContext._adobeAssetUpdater.updateRemoteItem(session, assetMetadata);
            generationHistoryContext._generationHistoryAssetUpdater.updateLocalItem(session, asset, generationHistoryMetadata);
        }
        else {
            asset = this._core.hostAssetContext._adobeAssetUpdater.updateRemoteItem(session, assetMetadata);
        }
        return asset;
    }
    assetsFromLocalMetadata(session, localMetadata) {
        return this.assetsFromRepoMetadata(session, localMetadata);
    }
    assetFromLocalMetadata(session, localMetadata) {
        return this.assetFromRepoMetadata(session, localMetadata);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Logger Log Level.
 *
 * Enum representing the levels of logging messages.
 *
 * @enum
 * @property NONE - No logging.
 * @property ERROR - Log only error messages.
 * @property WARN - Log warning and error messages.
 * @property INFO - Log informational, warning, and error messages.
 * @property DEBUG - Log all messages including debug information.
 */
var LogLevel$1;
(function (LogLevel) {
    LogLevel[LogLevel["NONE"] = 0] = "NONE";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
})(LogLevel$1 || (LogLevel$1 = {}));
const SOURCE_ID_LENGTH = 16;
function replacer(_key, value) {
    switch (true) {
        case value instanceof Map:
            return { 'Map': Array.from(value.entries()) };
        case value instanceof Set:
            return { 'Set': [...value] };
        default:
            return value;
    }
}
/**
 * Logger class.
 */
class Logger$2 {
    static _isoTime() { return new Date().toISOString().slice(11); }
    static _epochToIsoTimeString(epoch) { return new Date(epoch).toISOString().slice(11); }
    _formatMessage(message, source, ...optionalParams) {
        const timestamp = this.includeTimestamp ? `[${Logger$2._isoTime()}]` : '';
        if (optionalParams.length) {
            message += ' <<<DATA\n' + JSON.stringify(optionalParams, replacer, 2) + '\nDATA;';
        }
        source = source.padEnd(SOURCE_ID_LENGTH, ' ');
        return `[${this._prefix}]${timestamp}[${source}] ${message}`;
    }
    constructor(prefix, logSink = console) {
        this._logSink = console;
        this.includeTimestamp = true;
        this.logLevel = LogLevel$1.WARN;
        this._prefix = prefix;
        this._logSink = logSink;
    }
    /**
     * Logs a debug message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logDebug(message, source, ...optionalParams) {
        var _a;
        if (this.logLevel >= LogLevel$1.DEBUG) {
            message = this._formatMessage(message, source, ...optionalParams);
            (_a = this._logSink) === null || _a === void 0 ? void 0 : _a.debug(message);
        }
    }
    /**
     * Logs an info message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logInfo(message, source, ...optionalParams) {
        var _a;
        if (this.logLevel >= LogLevel$1.INFO) {
            message = this._formatMessage(message, source, ...optionalParams);
            (_a = this._logSink) === null || _a === void 0 ? void 0 : _a.info(message);
        }
    }
    /**
     * Logs a warning message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logWarn(message, source, ...optionalParams) {
        var _a;
        if (this.logLevel >= LogLevel$1.WARN) {
            message = this._formatMessage(message, source, ...optionalParams);
            (_a = this._logSink) === null || _a === void 0 ? void 0 : _a.warn(message);
        }
    }
    /**
     * Logs an error message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     * @remarks If the first optional parameter is an Error object, the message will be appended with the error message.
     * @remarks If the first optional parameter is a string value, that value will be used as cause in the error message.
     */
    logError(message, source, ...optionalParams) {
        var _a;
        if (this.logLevel >= LogLevel$1.ERROR) {
            if (optionalParams[0] instanceof Error) {
                const error = optionalParams[0];
                message += `(${error.message}`;
                if (error.cause) {
                    message += `: ${error.cause}`;
                }
                message += ')';
                optionalParams.shift();
            }
            else if (typeof optionalParams[0] === 'string') {
                const errorMessage = optionalParams[0];
                message += `(${errorMessage})`;
                optionalParams.shift();
            }
            message = this._formatMessage(message, source, ...optionalParams);
            (_a = this._logSink) === null || _a === void 0 ? void 0 : _a.error(message);
        }
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Axon Client Configuration class deals with Axon connection, authentication and logging settings.
 * Client must create AxonClientConfig and authenticate it against the Axon service before creating AxonClient.
 */
class AxonClientConfig {
    constructor(endpoint, authGet = fetch, logSink) {
        this.endpoint = endpoint;
        this._locale = 'en-US';
        this._logger = new Logger$2('Axon', logSink);
        this._authenticatedGet = authGet;
    }
    async _getSignedUrl(sessionId) {
        const requestUrl = 'https://' + this.endpoint + '/signed-url' + (sessionId ? '?sessionId=' + sessionId : '');
        let response;
        try {
            response = await this._authenticatedGet(requestUrl);
        }
        catch (e) {
            if (e instanceof TypeError) {
                return { code: 997, error: new Error('Failed to authenticate against Axon server', { cause: e.message }) };
            }
            else if (e instanceof Error) {
                return { code: 998, error: e };
            }
            else {
                return { code: 999, error: new Error('Unknown error while accessing Axon authentication service!') };
            }
        }
        try {
            const result = await response.json();
            switch (response.status) {
                case 200:
                    if ('websocketUrl' in result) {
                        return { code: response.status, signedUrl: result.websocketUrl };
                    }
                    else {
                        return { code: 994, error: new Error('Invalid response from Axon service!') };
                    }
                default:
                    return { code: response.status, error: new Error(result === null || result === void 0 ? void 0 : result.message) };
            }
        }
        catch (e) {
            if (e instanceof Error) {
                return { code: 995, error: e };
            }
            else {
                return { code: 996, error: new Error('Unknown error while accessing Axon authentication service!') };
            }
        }
    }
    /**
     * Sets locale.
     * @param locale - Locale to use for the Axon service.
     */
    set locale(id) {
        this._locale = id;
    }
    /**
     * Gets locale.
     */
    get locale() {
        return this._locale;
    }
    /**
     * Sets Preferred Axon Session Id.
     * @param [id] - Session Id to authenticate for; when undefined, or invalid, Axon client will reequest a new session.
     */
    set preferredSessionId(id) {
        this._preferredSessionId = id;
    }
    /**
     * Gets the preferred Axon Session Id.
     */
    get preferredSessionId() {
        return this._preferredSessionId;
    }
    /**
     * Gets the logger.
     */
    get logger() {
        return this._logger;
    }
    /**
     * Gets the Signed URL.
     */
    get signedUrl() {
        var _a;
        return ((_a = this === null || this === void 0 ? void 0 : this._authentication) === null || _a === void 0 ? void 0 : _a.signedUrl) || '';
    }
    /**
     * Request Axon Signed URL from the service.
     * @returns Promise resolving to either true, when an authenticated Signed URL was acquird, or false, upon an authentication error.
     */
    async authenticate() {
        // Clear existing authenitcation, if any.
        this._authentication = undefined;
        // Request Signed URL from the Axon service.
        this._authentication = await this._getSignedUrl(this._preferredSessionId);
        return this.isAuthenticated();
    }
    isAuthenticated() {
        if (!this._authentication) {
            return false;
        }
        if (this._authentication.code !== 200) {
            return false;
        }
        if (this._authentication.signedUrl === undefined) {
            return false;
        }
        try {
            new URL(this._authentication.signedUrl);
            return true;
        }
        catch (error) {
            return false;
        }
    }
}

// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js

var ws = null;

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket;
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket;
} else if (typeof global !== 'undefined') {
  ws = global.WebSocket || global.MozWebSocket;
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket;
} else if (typeof self !== 'undefined') {
  ws = self.WebSocket || self.MozWebSocket;
}

var WebSocket$2 = ws;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Axon Protocol frame types.
 */
var FrameType;
(function (FrameType) {
    FrameType["WsAck"] = "wsack";
    FrameType["CreateVc"] = "connect";
    FrameType["CreateVcAck"] = "connectack";
    FrameType["DeleteVc"] = "disconnect";
    FrameType["DeleteVcAck"] = "disconnectack";
    FrameType["Reconnect"] = "reconnect";
    FrameType["Closesession"] = "closesession";
    FrameType["Message"] = "message";
    FrameType["MessageAck"] = "messageack";
    FrameType["Error"] = "error";
})(FrameType || (FrameType = {}));
/**
 * Axon Virtual Connection states.
 */
var VcStatus;
(function (VcStatus) {
    VcStatus["Active"] = "active";
    VcStatus["CreateInprogress"] = "create_inprogress";
    VcStatus["DeleteInprogress"] = "delete_inprogress";
    VcStatus["Error"] = "error";
})(VcStatus || (VcStatus = {}));
/**
 * Reasons for requesting a Axon Session reconnection.
 */
var ReconnectReason;
(function (ReconnectReason) {
    ReconnectReason["AuthTokenExpired"] = "authTokenExpired";
    ReconnectReason["InstanceShuttingDown"] = "instanceShuttingDown";
    ReconnectReason["PeriodicReset"] = "periodicReset";
})(ReconnectReason || (ReconnectReason = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * StateMachineEventEmitter class.
 * @remarks This class is a base class for state machines that emit events when transitioning between states.
 * @remarks The class extends the EventEmitter class.
 * @remarks The class provides logging functionality.
 * @remarks The class provides a transitionTo() method to transition between states.
 * @remarks The class provides logDebug(), logInfo(), logWarn(), and logError() methods to log messages.
 * @remarks The class provides a logSourceId hook to uniquely identify the instance of the logging source component.
 * @remarks StateType is the type of the state machine state. It must be an enum type with key names representing to the states.
 * @remarks The StateType must have value of string type equivalent to the key names of the enum.
 */
class StateMachineEventEmitter extends EventEmitter {
    /**
     * Constructor for the StateMachineEventEmitter class.
     * @param initalState - Initial state of the state machine.
     * @param logger - Logger to use for logging.
     * @param logSourceName - Name of the source of the logs.
     * @remarks The logSourceName is used to identify the source of the logs. It prepends the logged messages.
     * @remarks The logSourceId is an optional hook that can be set by the logging component extending this class.
     * It is used to uniquely identify the instance of the logging source component.
     */
    constructor(initalState, logger, logSourceName = 'unknown') {
        super();
        /**
         * Optional Hook returning an Id string by the logging component extending this class.
         * See private member _logSourceString() for more details.
         * @returns a printable string uniquely identifying instance of the logging source component.
         */
        this.logSourceId = undefined;
        this._state = initalState;
        this._logger = logger;
        this._logSourceName = logSourceName;
        this.logDebug(`Created with an initial state ${this.state}.`);
    }
    _sourceString() {
        const logSourceId = this.logSourceId ? this.logSourceId() : '';
        return this._logSourceName + (logSourceId ? `:${logSourceId}` : '(pending)');
    }
    /**
     * Returns logger used by the state machine.
     */
    get logger() {
        return this._logger;
    }
    /**
     * Returns the current state of the state machine.
     * @returns The current state of the state machine.
     */
    get state() {
        return this._state;
    }
    /**
     * Transitions the client to a new state.
     * @param newState - New state to transition to.
     */
    transitionTo(newState) {
        const eventName = newState;
        this.logDebug(`State Transition: ${this.state} => ${newState}.`);
        this._state = newState;
        this.emit(eventName.toLowerCase());
    }
    /**
     * Logs a debug message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logDebug(message, ...optionalParams) {
        this._logger.logDebug(message, this._sourceString(), ...optionalParams);
    }
    /**
     * Logs an info message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logInfo(message, ...optionalParams) {
        this._logger.logInfo(message, this._sourceString(), ...optionalParams);
    }
    /**
     * Logs a warning message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logWarn(message, ...optionalParams) {
        this._logger.logWarn(message, this._sourceString(), ...optionalParams);
    }
    /**
     * Logs an error message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     * @remarks If the first optional parameter is an Error object, the message will be appended with the error message.
     */
    logError(message, ...optionalParams) {
        this._logger.logError(message, this._sourceString(), ...optionalParams);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AxonUtils {
    /**
     * Creates a new Axon frame.
     */
    static CreateFrame(frameType, frameId = uuid_1()) {
        return { frameType, frameId };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const AXON_VC_CREATION_TIMEOUT_MS = 2000;
/**
 * Enum value representing the internal state of AxonVirtualConnection instance.
 * Values must be equivalent to their respective key names for proper behavior of
 * StateMachineEventEmitter<AxonVirtualConnectionState> class.
 */
var AxonVirtualConnectionState;
(function (AxonVirtualConnectionState) {
    AxonVirtualConnectionState["CREATE_IN_PROGRESS"] = "CREATE_IN_PROGRESS";
    AxonVirtualConnectionState["CREATED"] = "CREATED";
    AxonVirtualConnectionState["DELETE_IN_PROGRESS"] = "DELETE_IN_PROGRESS";
    AxonVirtualConnectionState["DELETED"] = "DELETED";
})(AxonVirtualConnectionState || (AxonVirtualConnectionState = {}));
/**
 * Represents Axon Virtual Connection to specific Adobe service, i.e. ONS, ANS, etc.
 * @extends StateMachineEventEmitter<AxonVirtualConnectionState>
 * @emits AxonVirtualConnection#message
 */
class AxonVirtualConnection extends StateMachineEventEmitter {
    static VcIdToVcIndex(id) {
        const ids = id.split(':');
        if (ids.length !== 2) {
            return 0;
        }
        const idx = parseInt(ids[1]);
        return isNaN(idx) ? 0 : idx;
    }
    constructor(_session, _frameSenderHook, _vcIndex, _serviceName, _headers = {}) {
        super(AxonVirtualConnectionState.CREATE_IN_PROGRESS, _session.logger, 'VirConn');
        this._session = _session;
        this._frameSenderHook = _frameSenderHook;
        this._vcIndex = _vcIndex;
        this._serviceName = _serviceName;
        this._headers = _headers;
        this.logSourceId = () => this._vcIndex ? `${this._vcIndex} (${this._serviceName})` : '';
        const frame = Object.assign(Object.assign({}, AxonUtils.CreateFrame(FrameType.CreateVc)), { 'vcId': this.id, 'serviceName': this._serviceName, 'headers': this._headers });
        this.logDebug('Sending CreateVc frame', frame);
        this._frameSenderHook.trigger(frame);
    }
    get index() {
        return this._vcIndex;
    }
    get id() {
        return this._session.id + ':' + this._vcIndex;
    }
    isActive() {
        return this.isCreated() && this._session.isEstablished();
    }
    isCreated() {
        return this.state === AxonVirtualConnectionState.CREATED;
    }
    /**
     * Waits up to `timeoutMs` ms for the Axon Session to be created by the service and acknowledged to the client.
     * @param timeoutMs Amount of time to wait before returning resolved promise.
     * @returns Promise resolving to true if the Axon session was established, or false otherwise.
     */
    async ensureActive(timeoutMs = AXON_VC_CREATION_TIMEOUT_MS) {
        if (this.isActive()) {
            return true;
        }
        if (this.state === AxonVirtualConnectionState.DELETE_IN_PROGRESS) {
            return false;
        }
        if (this.state === AxonVirtualConnectionState.DELETED) {
            return false;
        }
        this.logDebug('Waiting for Virtual Connection to be active...');
        await new Promise(resolve => {
            const timer = setTimeout(() => { resolve(); }, timeoutMs);
            this.once('active', () => {
                clearTimeout(timer);
                resolve();
            });
        });
        return this.isActive();
    }
    handleAxonErrorFrame(frame) {
        this.logDebug('Received Error frame', frame);
        switch (this.state) {
            case AxonVirtualConnectionState.CREATE_IN_PROGRESS:
            case AxonVirtualConnectionState.DELETE_IN_PROGRESS:
                this.transitionTo(AxonVirtualConnectionState.DELETED);
                this.logError(`Virtual Connection creation failed (${frame.errorMessage.message})`);
                break;
            default:
                this.emit('error', frame.errorMessage);
        }
    }
    handleAxonMessageFrame(frame) {
        this.logDebug(`Received Message frame`, frame);
        try {
            const messageString = atob(frame.payload);
            const message = JSON.parse(messageString);
            this.sendMessageAck(frame.frameId);
            this.emit('message', message);
        }
        catch (error) {
            this.logError('Failed to decode message payload', error);
        }
    }
    handleAxonMessageAckFrame(frame) {
        this.logDebug('Received MessageAck frame', frame);
    }
    sendMessage(message) {
        if (!this.isActive()) {
            this.logError('Cannot send Message on non-active Virtual Connection!');
            return;
        }
        const payload = btoa(message);
        const frame = Object.assign(Object.assign({}, AxonUtils.CreateFrame(FrameType.Message)), { 'vcId': this.id, payload });
        this.logDebug('Sending Message frame', frame);
        this._frameSenderHook.trigger(frame);
    }
    sendMessageAck(messageFrameId) {
        if (!this.isActive()) {
            this.logError('Cannot send MessageAck on non-active Virtual Connection!');
            return;
        }
        const frame = Object.assign(Object.assign({}, AxonUtils.CreateFrame(FrameType.MessageAck)), { 'vcId': this.id, messageFrameId });
        this.logDebug('Sending MessageAck frame', frame);
        this._frameSenderHook.trigger(frame);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Enum value representing the internal state of AxonSession instance.
 * Values must be equivalent to their respective key names for proper behavior of
 * StateMachineEventEmitter<AxonSessionState> class.
 */
var AxonSessionState;
(function (AxonSessionState) {
    AxonSessionState["CONNECTION_IN_PROGRESS"] = "CONNECTION_IN_PROGRESS";
    AxonSessionState["DISCONNECTION_IN_PROGRESS"] = "DISCONNECTION_IN_PROGRESS";
    AxonSessionState["RECONNECTION_IN_PROGRESS"] = "RECONNECTION_IN_PROGRESS";
    AxonSessionState["ESTABLISHED"] = "ESTABLISHED";
    AxonSessionState["DISCONNECTED"] = "DISCONNECTED";
    AxonSessionState["CLOSED"] = "CLOSED";
})(AxonSessionState || (AxonSessionState = {}));
const AXON_SESSION_CREATION_TIMEOUT_MS = 2000;
const AXON_VIRTUAL_CONNECTION_DELETION_TIMEOUT_MS = 2000;
/**
 * Axon Session represent persistent set of active Axon Virtual Connections.
 */
class AxonSession extends StateMachineEventEmitter {
    constructor(_axonClient, _frameSenderHook) {
        super(AxonSessionState.DISCONNECTED, _axonClient.config.logger, 'Session');
        this._axonClient = _axonClient;
        this._frameSenderHook = _frameSenderHook;
        this._virtualConnections = new Map();
        this._lastVcMonotonicIndex = 0; // Valid Virtual Connection Index is a monotonic positive integer.
        this.logSourceId = () => this._sessionId ? this._sessionId.substring(0, 8) : '';
    }
    /**
     * Handles acknowledgement message upon establishment of the Axon session
     * @param frame object representing WebSocket connection acknowledgment frame.
     * Returns true if the frame was handled successfully and false otherwise.
     */
    _handleWsAckFrame(frame) {
        var _a;
        this.logDebug('Received WsAck frame', frame);
        const existingVirtualConnections = this._virtualConnections;
        this._virtualConnections = new Map();
        this._lastVcMonotonicIndex = 0;
        this._heartbeatIntervalInSec = undefined;
        if (this._sessionId !== frame.sessionId) {
            for (const vc of existingVirtualConnections.values()) {
                vc.transitionTo(AxonVirtualConnectionState.DELETED);
                this.logDebug(`Marking no longer valid Virtual Connection ${vc.id} as DELETED`);
            }
            existingVirtualConnections.clear();
        }
        this._sessionId = undefined;
        if (!frame.sessionId || !frame.heartbeatFrequencyInSec || frame.heartbeatFrequencyInSec <= 0) {
            this.logError('Rejecting invalid WsAckFrame. Session not established.', frame);
            this.transitionTo(AxonSessionState.CLOSED);
            return;
        }
        this._sessionId = frame.sessionId;
        this._axonClient.config.preferredSessionId = this._sessionId;
        this._heartbeatIntervalInSec = frame.heartbeatFrequencyInSec;
        for (const vcId of (_a = frame.vcIds) !== null && _a !== void 0 ? _a : []) {
            const vcIndex = AxonVirtualConnection.VcIdToVcIndex(vcId.id);
            if (!vcIndex) {
                this.logError(`Unexpected Virtual Connection with Vc Index (${vcIndex}).`);
                continue;
            }
            const existingVc = existingVirtualConnections.get(vcIndex);
            if ((existingVc === null || existingVc === void 0 ? void 0 : existingVc.isCreated()) && vcId.status === VcStatus.Active) {
                this._virtualConnections.set(vcIndex, existingVc);
                existingVirtualConnections.delete(vcIndex);
                if (this._lastVcMonotonicIndex < vcIndex) {
                    this._lastVcMonotonicIndex = vcIndex;
                }
                this.logInfo(`Re-connected to Virtual Connection with index ${vcIndex}.`);
            }
            else {
                this.logWarn(`Deleting unknown or inactive virtual connection with Vc Id (${vcId.id}).`);
                const frame = Object.assign(Object.assign({}, AxonUtils.CreateFrame(FrameType.DeleteVc)), { 'vcId': vcId.id });
                this._frameSenderHook.trigger(frame);
            }
        }
        for (const vc of existingVirtualConnections.values()) {
            vc.transitionTo(AxonVirtualConnectionState.DELETED);
            this.logDebug(`Marking pre-existing and no longer valid Virtual Connection (${vc.id}) as DELETED`);
        }
        this.transitionTo(AxonSessionState.ESTABLISHED);
        this.logDebug(`Axon session ${this._sessionId} established with heartbeat interval of ${this._heartbeatIntervalInSec} seconds.`);
    }
    /**
     * Handles acknowledgement message upon creating a Virtual Connection.
    */
    _handleCreateVcAckFrame(frame) {
        this.logDebug('Received CreateVcAck frame', frame);
        const vcIndex = AxonVirtualConnection.VcIdToVcIndex(frame.vcId);
        if (vcIndex && this._virtualConnections.has(vcIndex)) {
            const vc = this._virtualConnections.get(vcIndex);
            if (vc) {
                vc.transitionTo(AxonVirtualConnectionState.CREATED);
            }
            else {
                this.logError(`Failed to handle Virtual Connection Ack Frame (VC with index ${this._sessionId} not found).`);
            }
        }
        else {
            this.logError(`Ignoring frame for an invalid Vc Id (${frame.vcId}).`);
        }
    }
    /**
     * Handles acknowledgement message upon deleting a Virtual Connection.
    */
    _handleDeleteVcAckFrame(frame) {
        this.logDebug('Received DeleteVcAck frame', frame);
        const vcIndex = AxonVirtualConnection.VcIdToVcIndex(frame.vcId);
        const vc = this._virtualConnections.get(vcIndex);
        if (vc) {
            vc.transitionTo(AxonVirtualConnectionState.DELETED);
            if (!this._virtualConnections.delete(vcIndex)) {
                this.logError(`Failed to delete Virtual Connection (VC with index ${vcIndex} not found).`);
            }
        }
        else {
            this.logError(`Ignoring frame for an invalid Vc Id (${frame.vcId}).`);
        }
        if (this._virtualConnections.size === 0) {
            this.logDebug('All Virtual Connections deleted. Closing Axon Session...');
            this.close();
        }
    }
    /**
     * Reconnect frame handler.
     * @param frame - Axon Reconnect frame.
     */
    _handleReconnectFrame(frame) {
        // TODO: Implement Reconnect frame handling.
        this.logDebug('Received Reconnect frame', frame);
    }
    /**
     * CloseSession frame handler.
     * @param frame - Axon CloseSession frame.
     */
    _handleCloseSessionFrame(frame) {
        // TODO: Implement CloseSession frame handling.
        this.logDebug('Received CloseSession frame', frame);
    }
    /**
     * Virtual Channel frame handler.
     * Passes the frame to the appropriate Virtual Connection.
     * @param frame - Axon Error frame.
     */
    _handleVcFrame(frame) {
        const vcIndex = AxonVirtualConnection.VcIdToVcIndex(frame.vcId);
        if (vcIndex && this._virtualConnections.has(vcIndex)) {
            const vc = this._virtualConnections.get(vcIndex);
            if (vc) {
                switch (frame.frameType) {
                    case FrameType.Message:
                        return vc.handleAxonMessageFrame(frame);
                    case FrameType.MessageAck:
                        return vc.handleAxonMessageAckFrame(frame);
                    case FrameType.Error:
                        return vc.handleAxonErrorFrame(frame);
                    default:
                        this.logError(`Ignoring frame for Vc ${frame.vcId} (Unknown frame type: ${frame.frameType}).`);
                        return;
                }
            }
            else {
                this.logError(`Failed to access Virtual Connection # ${vcIndex} while handling frame ${frame.vcId}.`);
            }
        }
        else {
            this.logError(`Ignoring Axon frame for Vc ${frame.vcId} (No such VC exists).`);
        }
    }
    /**
     * Gets the Axon Session Id.
    */
    get id() {
        var _a;
        return (_a = this._sessionId) !== null && _a !== void 0 ? _a : '';
    }
    /**
     * Gets currently configured Axon Heartbeat interval in seconds.
     */
    get heartbeatIntervalInSec() {
        return this._heartbeatIntervalInSec;
    }
    /**
     * Handles Axon Frame by passing it to specific protocol handler, or throws an Error otherwise.
     * Note: An Error is thrown only for unsupported AxonFrame types, while the downstream protocol handlers
     * are not supposed handle errors via exceptions.
     * @param frame - JSON-serialized Axon protocol frame.
     */
    handleAxonFrame(frame) {
        switch (frame.frameType) {
            case FrameType.WsAck:
                return this._handleWsAckFrame(frame);
            case FrameType.CreateVcAck:
                return this._handleCreateVcAckFrame(frame);
            case FrameType.DeleteVcAck:
                return this._handleDeleteVcAckFrame(frame);
            case FrameType.Reconnect:
                return this._handleReconnectFrame(frame);
            case FrameType.Closesession:
                return this._handleCloseSessionFrame(frame);
            case FrameType.Message:
                return this._handleVcFrame(frame);
            case FrameType.MessageAck:
                return this._handleVcFrame(frame);
            case FrameType.Error:
                return this._handleVcFrame(frame);
            default:
                throw new Error(`Failed to parse data frame; unknown frame type`);
        }
    }
    /**
     * Returns true if the Axon session is established.
     */
    isEstablished() {
        return this.state === AxonSessionState.ESTABLISHED;
    }
    /**
     * Ensures that Axon Client is connected and its session is established.
     * @param timeoutMs Amount of time to wait before returning resolved promise.
     * @returns Promise resolving to true if the Axon session was established, or false otherwise.
     */
    async ensureEstablished(timeoutMs = AXON_SESSION_CREATION_TIMEOUT_MS) {
        const deadline = Date.now() + timeoutMs;
        if (!await this._axonClient.ensureConnected(timeoutMs)) {
            this.logError('Axon Client could not be connected!');
            return false;
        }
        if (this.isEstablished()) {
            return true;
        } // Session is already established.
        if (this.state === AxonSessionState.DISCONNECTED) {
            this.transitionTo(AxonSessionState.CONNECTION_IN_PROGRESS);
        }
        this.logDebug('Waiting for session to be established...');
        await new Promise(resolve => {
            const timer = setTimeout(() => { resolve(); }, deadline - Date.now());
            this.once('established', () => {
                clearTimeout(timer);
                resolve();
            });
        });
        return this.isEstablished();
    }
    /**
     * Marks Axon Session as being reconnected upon the Axon Client's active reconnection workflow.
     *
     */
    expectReconnection() {
        if (this.state === AxonSessionState.RECONNECTION_IN_PROGRESS) {
            return;
        }
        this.transitionTo(AxonSessionState.RECONNECTION_IN_PROGRESS);
    }
    /**
     * Marks Axon Session as being disconnected upon the Axon Client's active disconnection workflow.
     *
     */
    expectDisconnection() {
        if (this.state === AxonSessionState.DISCONNECTION_IN_PROGRESS) {
            return;
        }
        this.transitionTo(AxonSessionState.DISCONNECTION_IN_PROGRESS);
    }
    /**
     * Disconnects Axon Session.
     *
     */
    disconnect() {
        if (this.state === AxonSessionState.CLOSED || this.state === AxonSessionState.DISCONNECTED) {
            return;
        }
        this.transitionTo(AxonSessionState.DISCONNECTED);
    }
    /**
     * Closes Axon Session.
     */
    close() {
        if (this.state === AxonSessionState.CLOSED || this.state === AxonSessionState.DISCONNECTED) {
            return;
        }
        this.logDebug('Closing Axon Session...');
        this._frameSenderHook.trigger(AxonUtils.CreateFrame(FrameType.Closesession));
        this.transitionTo(AxonSessionState.CLOSED);
        this._virtualConnections.clear();
        this._lastVcMonotonicIndex = 0;
    }
    /**
     * Creates Virtual Connection.
     */
    async createVc(serviceName, headers) {
        if (!this.isEstablished()) {
            throw new Error('Axon Session is not established!');
        }
        const vcIndex = ++this._lastVcMonotonicIndex;
        const vc = new AxonVirtualConnection(this, this._frameSenderHook, vcIndex, serviceName, headers);
        this._virtualConnections.set(vc.index, vc);
        return vc;
    }
    /**
     * Deletes Virtual Connection.
     */
    async deleteVc(vc) {
        if (!this.isEstablished()) {
            throw new Error('Axon Session is not established!');
        }
        const frame = Object.assign(Object.assign({}, AxonUtils.CreateFrame(FrameType.DeleteVc)), { 'vcId': vc.id });
        this.logDebug('deleteVc', frame);
        vc.transitionTo(AxonVirtualConnectionState.DELETE_IN_PROGRESS);
        this._frameSenderHook.trigger(frame);
        this.logDebug('Waiting for VC to be deleted...');
        const deadline = Date.now() + AXON_VIRTUAL_CONNECTION_DELETION_TIMEOUT_MS;
        await new Promise(resolve => {
            const timer = setTimeout(() => { resolve(); }, deadline - Date.now());
            vc.once('deleted', () => {
                clearTimeout(timer);
                resolve();
            });
        });
        return vc.state === AxonVirtualConnectionState.DELETED;
    }
}
AxonSession.State = AxonSessionState;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Based on https://git.corp.adobe.com/sync-service/bifrost/blob/main/documentation/websocketframe/README.md
/**
 * Axon HTTP Protocol Upgrade Status Codes.
 */
var AxonHttpStatusCodes;
(function (AxonHttpStatusCodes) {
    /* HTTP Response Status 101 is the expected code upon successful protocol upgrade from HTTP to WebSocket. */
    AxonHttpStatusCodes[AxonHttpStatusCodes["SWITCHING_PROTOCOLS"] = 101] = "SWITCHING_PROTOCOLS";
    /* Although the HTTP standard specifies "unauthorized", semantically this response means "unauthenticated".
     * For Axon connection, this error means that the client presented expired IMS token. */
    AxonHttpStatusCodes[AxonHttpStatusCodes["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    /* The client does not have access rights to the resource. */
    AxonHttpStatusCodes[AxonHttpStatusCodes["FORBIDDEN"] = 403] = "FORBIDDEN";
    /* The server cannot find the requested resource. */
    AxonHttpStatusCodes[AxonHttpStatusCodes["NOT_FOUND"] = 404] = "NOT_FOUND";
    /* The server has encountered an unexpected error.
     * The client should retry once or create a new session. */
    AxonHttpStatusCodes[AxonHttpStatusCodes["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    /* Axon service is unavailable. The client should wait and reconnect using back-off algorithm. */
    AxonHttpStatusCodes[AxonHttpStatusCodes["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
})(AxonHttpStatusCodes || (AxonHttpStatusCodes = {}));
/**
 * Axon WebSocket Connection Status Codes.
 */
var AxonWebSocketStatusCodes;
(function (AxonWebSocketStatusCodes) {
    /* Normal WebSocket disconnection. */
    AxonWebSocketStatusCodes[AxonWebSocketStatusCodes["DISCONNECTED_NORMAL"] = 1000] = "DISCONNECTED_NORMAL";
    /* Server disconnected due to protocol error. */
    AxonWebSocketStatusCodes[AxonWebSocketStatusCodes["DISCONNECTED_ERROR"] = 1002] = "DISCONNECTED_ERROR";
    /* Server disconnected abnormally. */
    AxonWebSocketStatusCodes[AxonWebSocketStatusCodes["DISCONNECTED_ABNORMAL"] = 1006] = "DISCONNECTED_ABNORMAL";
    /* Server disconnected. The session has been closed and cannot be reconnected. */
    AxonWebSocketStatusCodes[AxonWebSocketStatusCodes["DISCONNECTED_SESSION_CLOSED"] = 4432] = "DISCONNECTED_SESSION_CLOSED";
    /* Server disconnected. The client may reconnect to the same session. */
    AxonWebSocketStatusCodes[AxonWebSocketStatusCodes["DISCONNECTED_SESSION_ACTIVE"] = 4433] = "DISCONNECTED_SESSION_ACTIVE";
})(AxonWebSocketStatusCodes || (AxonWebSocketStatusCodes = {}));
/**
 * Axon Protocol Error Codes.
 */
var AxonProtocolStatusCodes;
(function (AxonProtocolStatusCodes) {
    /* Server is about to close the web socket connection.
     * The Axon session will remain active and the client may reconnect. */
    AxonProtocolStatusCodes[AxonProtocolStatusCodes["AXON_SERVER_DISCONNECTING"] = 425] = "AXON_SERVER_DISCONNECTING";
    /* Malformed Virtual Connection identifier. */
    AxonProtocolStatusCodes[AxonProtocolStatusCodes["AXON_VC_MALFORMED_ID"] = 400] = "AXON_VC_MALFORMED_ID";
    /* Virtual Connection already exists for this session. */
    AxonProtocolStatusCodes[AxonProtocolStatusCodes["AXON_VC_ALREADY_EXISTS"] = 4409] = "AXON_VC_ALREADY_EXISTS";
    /* After receiving the following errors, the client must clear the VC at its end. */
    AxonProtocolStatusCodes[AxonProtocolStatusCodes["AXON_VC_INTERNAL_ERROR"] = 4500] = "AXON_VC_INTERNAL_ERROR";
    /* After receiving the following errors, the client must clear the VC at its end. */
    AxonProtocolStatusCodes[AxonProtocolStatusCodes["AXON_VC_SERVICE_TIMEOUT"] = 4503] = "AXON_VC_SERVICE_TIMEOUT";
})(AxonProtocolStatusCodes || (AxonProtocolStatusCodes = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const AXON_PROTOCOL_VERSION = 'axon-v1';
const AXON_PROTOCOL_HEARTBEAT_MESSAGE = '\n';
const WS_CONNECT_TIMEOUT_MS = 2000;
const WS_DISCONNECT_TIMEOUT_MS = 600;
const WS_TERMINATE_TIMEOUT_MS = 300;
const CLIENT_HEARTBEAT_INTERVAL_FACTOR = 800; // 80% of the heartbeat interval x 1000 (for ms to sec conversion).
const SERVER_HEARTBEAT_MONITORING_INTERVAL_FACTOR = 1300; // 130% of the heartbeat interval x 1000 (for ms to sec conversion).
const WS_RECONNECT_WITH_BACKOFF_MAX_ATTEMPTS = 2880; // That means 24 hours of attempts with 30 seconds interval.
const WS_RECONNECT_BACKOFF_INITIAL_DELAY_MS = 1000;
const WS_RECONNECT_BACKOFF_MAX_DELAY_MS = 30000;
/**
 * Enum value representing the internal state of AxonClient instance.
 * Values must be equivalent to their respective key names for proper behavior of
 * StateMachineEventEmitter<AxonClientState> class.
 */
var AxonClientState;
(function (AxonClientState) {
    AxonClientState["CONNECTING"] = "CONNECTING";
    AxonClientState["RECONNECTING"] = "RECONNECTING";
    AxonClientState["CONNECTED"] = "CONNECTED";
    AxonClientState["DISCONNECTING"] = "DISCONNECTING";
    AxonClientState["DISCONNECTED"] = "DISCONNECTED";
})(AxonClientState || (AxonClientState = {}));
/**
 * Represents a client to Adobe Axon service.
 * @emits AxonClient#connecting
 * @emits AxonClient#reconnecting
 * @emits AxonClient#connected
 * @emits AxonClient#disconnecting
 * @emits AxonClient#disconnected
 */
class AxonClient extends StateMachineEventEmitter {
    /**
     * Creates a sender hook allowing higher level protocols to transmit Axon frames over the WebSocket.
     */
    static _createAxonClientFrameSenderHook(target) {
        return {
            trigger: (frame) => {
                try {
                    const data = JSON.stringify(frame);
                    target.send(data, frame.frameType);
                }
                catch (error) {
                    target.logError('Invalid Axon frame passed to the sender hook', error);
                }
            },
        };
    }
    /**
     * Creates Axon Client.
     * @constructor
     * @param _config Client configuration; @see {@link AxonClientConfig} for details.
     */
    constructor(_config) {
        super(AxonClientState.DISCONNECTED, _config.logger, 'WebSock');
        this._config = _config;
        this._txBuffer = [];
        this._connectionIteration = 0;
        this._wsIndex = 0;
        this._reconnectWithBackoffAttempt = 0;
        /**
         * Handles WebSocket open event.
         * @param _event - WebSocket open event.
         */
        this._onWsOpen = (_event) => {
            this.logDebug(`WebSocket opened for ${this._config.endpoint}.`);
            if (this.state === AxonClientState.DISCONNECTED || this.state === AxonClientState.DISCONNECTING) {
                this.logWarn('WebSocket opened for a disconnectig/disconnected Axon client!');
                return;
            }
            if (this.state === AxonClientState.CONNECTING || this.state === AxonClientState.RECONNECTING) {
                this.transitionTo(AxonClientState.CONNECTED);
                if (this._reconnectBackoffTimer) {
                    clearTimeout(this._reconnectBackoffTimer);
                    this._reconnectBackoffTimer = undefined;
                }
            }
        };
        /**
         * Handles WebSocket close event.
         * @param event - WebSocket close event.
        */
        this._onWsClose = (event) => {
            this.logDebug(`WebSocket closed (code:${event.code})[reason:${event.reason}].`);
            if (this.state === AxonClientState.CONNECTING && !event.wasClean && this._config.preferredSessionId) {
                // If connection to the preferred Axon session was rejected, attempt to establish a new Axon session.
                this._config.preferredSessionId = undefined;
                this.reconnect();
                return;
            }
            if (this.isConnected()) {
                if (event.code === AxonWebSocketStatusCodes.DISCONNECTED_SESSION_CLOSED) {
                    this.logDebug('Axon server permanently closed the current session.');
                    this._config.preferredSessionId = undefined;
                }
                if (this.session.isEstablished()) {
                    this.logWarn('WebSocket closed unexpectedly. Will re-connect using an incremental backoff strategy.');
                    this._scheduleReconnectWithBackoffStrategy();
                    return;
                }
            }
            this.terminate();
        };
        /**
         * Handles WebSocket error event.
         * @param event - WebSocket error event.
         */
        this._onWsError = (event) => {
            if (this.state === AxonClientState.DISCONNECTING) {
                // Consider WebSocket errors during the client's DISCONNECTING state as warnings.
                this.logWarn(`Ignored WebSocket error event during Axon disconnecting workflow (${event})`);
            }
            else {
                this.logError(`WebSocket error`, event.error);
            }
        };
        /**
         * Handles WebSocket message event.
         * @param event - WebSocket message event.
         */
        this._onWsMessage = (event) => {
            if (typeof event.data === 'string') { // Handle text message.
                this._handleTextMessage(event.data);
            }
            else { // Handle binary message. Currently Unimplemented.
                this.logError('Unsupported binary message received (Unimplemented).');
            }
        };
        this.logSourceId = () => this._wsIndex.toString();
        this._session = new AxonSession(this, AxonClient._createAxonClientFrameSenderHook(this));
    }
    /**
     * Cancels the heartbeat monitoring.
     */
    _cancelHeartbeatMonitoring() {
        if (this._heartbeatMonitorTimeout) {
            clearTimeout(this._heartbeatMonitorTimeout);
            this._heartbeatMonitorTimeout = undefined;
        }
    }
    /**
     * Restarts the heartbeat monitoring.
    */
    _restartHeartbeatMonitoring() {
        this._cancelHeartbeatMonitoring();
        if (!this.isConnected() || !this.session.heartbeatIntervalInSec) {
            return;
        }
        const timeoutMs = this.session.heartbeatIntervalInSec * SERVER_HEARTBEAT_MONITORING_INTERVAL_FACTOR;
        this._heartbeatMonitorTimeout = setTimeout(() => {
            if (this.isConnected()) {
                this.logWarn('Missed heartbeat from Axon server! Client will reconnect using backoff strategy.');
                this._scheduleReconnectWithBackoffStrategy();
            }
        }, timeoutMs);
        this.logDebug(`Server heartbeat expected by ${Logger$2._epochToIsoTimeString(Date.now() + timeoutMs)}.`);
    }
    /**
     * Cancels the heartbeat message.
     */
    _cancelHeartbeatMessage() {
        if (this._heartbeatSenderTimeout) {
            clearTimeout(this._heartbeatSenderTimeout);
            this._heartbeatSenderTimeout = undefined;
        }
    }
    /**
     * Reschedules the heartbeat message.
     */
    _rescheduleHeartbeatMessage() {
        this._cancelHeartbeatMessage();
        if (!this.isConnected() || !this.session.heartbeatIntervalInSec) {
            return;
        }
        const timeoutMs = this.session.heartbeatIntervalInSec * CLIENT_HEARTBEAT_INTERVAL_FACTOR;
        this._heartbeatSenderTimeout = setTimeout(() => {
            if (this.isConnected()) {
                this.send(AXON_PROTOCOL_HEARTBEAT_MESSAGE);
            }
        }, timeoutMs);
        this.logDebug(`Client heartbeat scheduled at ${Logger$2._epochToIsoTimeString(Date.now() + timeoutMs)}.`);
    }
    /**
     * Handles WebSocket text message.
     * @param data - data containing raw message to parse and handle by appropriate protocol handlers.
     */
    _handleTextMessage(data) {
        this._reconnectWithBackoffAttempt = 0; // Assuming that client is properly connected; resetting the reconnect counter.
        if (data === AXON_PROTOCOL_HEARTBEAT_MESSAGE) {
            this.logDebug(`Server heartbeat received at ${Logger$2._epochToIsoTimeString(Date.now())}.`);
            this._restartHeartbeatMonitoring(); // Restarting Axon Protocol heartbeat monitoring.
            return;
        }
        this.logDebug(`Message of ${data.length} char(s) received.`);
        try {
            const frame = JSON.parse(data);
            this._session.handleAxonFrame(frame);
            if (!this._heartbeatSenderTimeout) {
                this._rescheduleHeartbeatMessage();
            } // Ensuring that the heartbeat is scheduled.
            this._restartHeartbeatMonitoring(); // Any valid Axon Frame is also considered a heartbeat.
        }
        catch (error) {
            this.logDebug('Received WebSocket text message', data);
            this.logError('Failed to handle WebSocket text message', error);
        }
    }
    /**
     * Transmits buffered messages over WebSocket.
     */
    _transmit() {
        if (!this._ws) {
            return;
        }
        if (this._ws.readyState !== WebSocket$2.OPEN) {
            return;
        }
        for (const item of this._txBuffer) {
            this._ws.send(item);
            if (item === AXON_PROTOCOL_HEARTBEAT_MESSAGE) {
                this.logDebug(`Client heartbeat sent at ${Logger$2._epochToIsoTimeString(Date.now())}.`);
            }
            else {
                this.logDebug(`Message of ${item.length} byte(s) sent.`);
            }
        }
        this._txBuffer = [];
        this._rescheduleHeartbeatMessage();
    }
    /**
     * Axon Config getter.
     */
    get config() {
        return this._config;
    }
    /**
     * Axon Config getter.
     */
    get session() {
        return this._session;
    }
    /**
     * Returns whether the client is connected to the Axon service.
     * @returns true if the client is connected, false otherwise.
     */
    isConnected() {
        return this.state === AxonClientState.CONNECTED;
    }
    /**
     * Connect to the Axon service and establish a session.
     * @returns promise, resolved to true upon successful authentication, client creation and connection, or false otherwise.
     */
    async connect() {
        if (this.state !== AxonClientState.RECONNECTING) {
            this._reconnectWithBackoffAttempt = 0;
        }
        if (this.state !== AxonClientState.DISCONNECTED && this.state !== AxonClientState.RECONNECTING) {
            this.logDebug(`Connection ignored; client not in DISCONNECTED or RECONNECTING state (current state: ${this.state}).`);
            return false;
        }
        const currentConnectionCycle = ++this._connectionIteration;
        this.transitionTo(AxonClientState.CONNECTING);
        this.logDebug(`Connection initiated; authenticating client before opening WebSocket.`);
        const isAuthenticated = await this._config.authenticate();
        if (currentConnectionCycle !== this._connectionIteration) {
            this.logDebug(`Connection aborted; client must have been simultaneously reconnected, disconnected or terminated.`);
            return false;
        }
        if (!isAuthenticated) {
            this.logError('Failed to authenticate against Axon service.');
            return false;
        }
        this._wsIndex++;
        this._ws = new WebSocket$2(this._config.signedUrl, AXON_PROTOCOL_VERSION);
        this._ws.binaryType = 'arraybuffer';
        this._ws.onerror = this._onWsError;
        this._ws.onopen = this._onWsOpen;
        this._ws.onclose = this._onWsClose;
        this._ws.onmessage = this._onWsMessage;
        this.logDebug('WebSocket initialized.');
        return this._waitForConnection();
    }
    /**
     * Ensures that the Axon connection is active and the associated session is established.
     * @param timeoutMs Amount of time to wait before returning resolved promise.
     * @returns Promise resolving to true if the Axon connection was made, or false otherwise.
     */
    async ensureConnected(timeoutMs = WS_CONNECT_TIMEOUT_MS) {
        if (this.state !== AxonClientState.DISCONNECTED) {
            if (await this._waitForConnection(timeoutMs)) {
                return true;
            }
        }
        await this.reconnect();
        return this.isConnected();
    }
    /**
     * Waits for the WebSocket connection to be established.
     * @param timeoutMs Amount of time to wait before returning resolved promise.
     * @returns Promise resolving to true if the WebSocket connection was made, or false otherwise.
     */
    async _waitForConnection(timeoutMs = WS_CONNECT_TIMEOUT_MS) {
        if (this.isConnected()) {
            return true;
        }
        this.logDebug('Waiting for WebSocket connection...');
        const deadline = Date.now() + timeoutMs;
        if (!this._ws) {
            // Handling the corner case of being within the authentication phase of ongoing connect().
            // Let's wait, within the allowed timeout, till the WebSocket is created.
            await new Promise(resolve => {
                const interval = setInterval(() => {
                    if (this._ws || Date.now() > deadline) {
                        resolve();
                        clearInterval(interval);
                    }
                }, 50);
            });
        }
        const ws = this._ws;
        if (!ws) {
            return false;
        }
        if (ws.readyState === WebSocket$2.CONNECTING) {
            await new Promise(resolve => {
                const timer = setTimeout(resolve, deadline - Date.now());
                this.once('connected', () => {
                    clearTimeout(timer);
                    resolve();
                });
            });
        }
        if (this.isConnected()) {
            this.logDebug('WebSocket connection established.');
            return true;
        }
        else {
            this.logDebug('WebSocket connection failed.');
            return false;
        }
    }
    /**
     * Deinitializes the WebSocket and disconnects the session.
     * @param timeoutMs - Amount of time, in ms, to allow for WebSocket closing.
     */
    async _deinitialize(timeoutMs) {
        this._cancelHeartbeatMonitoring();
        this._cancelHeartbeatMessage();
        const deadline = Date.now() + timeoutMs;
        const ws = this._ws;
        if (ws) {
            ws.onmessage = null;
            ws.onopen = null;
            ws.onclose = null;
            if (ws.readyState === WebSocket$2.OPEN && this.session.isEstablished()) {
                if (this.state === AxonClientState.RECONNECTING) {
                    this.session.disconnect();
                }
                else {
                    this.session.close();
                    // Wait for the Websocket to be closed upon session closure.
                    await new Promise(resolve => {
                        const timer = setTimeout(resolve, deadline - Date.now());
                        ws.addEventListener('close', () => {
                            this.logDebug('WebSocket closed by server.');
                            clearTimeout(timer);
                            resolve();
                        }, { once: true });
                    });
                }
            }
            if (ws.readyState === WebSocket$2.OPEN || ws.readyState === WebSocket$2.CONNECTING) {
                const wsCloseCode = AxonWebSocketStatusCodes.DISCONNECTED_NORMAL;
                ws.close(wsCloseCode);
                this.logDebug(`WebSocket closing initiated with code ${wsCloseCode} and timeout of ${timeoutMs} ms.`);
            }
            if (ws.readyState === WebSocket$2.CLOSING) {
                await new Promise(resolve => {
                    const timer = setTimeout(resolve, timeoutMs);
                    ws.addEventListener('close', () => {
                        this.logDebug('WebSocket closed by client.');
                        clearTimeout(timer);
                        resolve();
                    }, { once: true });
                });
            }
        }
        this._ws = undefined;
        this.logDebug('WebSocket deinitialized.');
    }
    /**
     * Sends WebSocket message to the Axon Server.
     * @param serializedFrameData - Serialized frame data to send.
     * @param frameType - Type of the frame being sent.
     */
    send(serializedFrameData, frameType) {
        if (frameType !== FrameType.Closesession) {
            // Handling the message based on the current state of the client.
            switch (this.state) {
                case AxonClientState.CONNECTING:
                case AxonClientState.RECONNECTING:
                    this._txBuffer.push(serializedFrameData);
                    break;
                case AxonClientState.CONNECTED:
                    this._txBuffer.push(serializedFrameData);
                    this._transmit();
                    break;
                case AxonClientState.DISCONNECTING:
                case AxonClientState.DISCONNECTED:
                    break;
            }
        }
        else { // CloseSession frame is sent without buffering.
            if (!this._ws) {
                return;
            } // No WebSocket to send the message.
            if (this._ws.readyState !== WebSocket$2.OPEN) {
                return;
            } // WebSocket is not open.
            this._ws.send(serializedFrameData);
            this.logDebug(`Close Session frame of ${serializedFrameData.length} bytes sent.`);
        }
    }
    /**
     * Reconnect to Axon server unconditionally.
     */
    async reconnect() {
        if (this.state === AxonClientState.RECONNECTING) {
            this.logDebug(`reconnect() aborted; client is already in RECONNECTING state.`);
            return;
        }
        this.session.expectReconnection();
        ++this._connectionIteration;
        if (this.state !== AxonClientState.DISCONNECTED) {
            this.transitionTo(AxonClientState.RECONNECTING);
            this.logInfo('WebSocket will reconnect now.');
            await this._deinitialize(WS_TERMINATE_TIMEOUT_MS);
        }
        await this.connect();
    }
    /**
     * Reconnect to Axon server using a backoff strategy.
     */
    _scheduleReconnectWithBackoffStrategy() {
        if (++this._reconnectWithBackoffAttempt < WS_RECONNECT_WITH_BACKOFF_MAX_ATTEMPTS) {
            const delay = Math.min(Math.pow(2, this._reconnectWithBackoffAttempt) * WS_RECONNECT_BACKOFF_INITIAL_DELAY_MS, WS_RECONNECT_BACKOFF_MAX_DELAY_MS);
            this._reconnectBackoffTimer = setTimeout(() => { this._scheduleReconnectWithBackoffStrategy(); }, delay);
            this.logInfo(`Reconnect attempt #${this._reconnectWithBackoffAttempt} starting now! The next attempt is scheduled in ${delay}ms.`);
        }
        else {
            this.logInfo(`Reconnect attempt #${this._reconnectWithBackoffAttempt} starting now! This is the last attempt!`);
        }
        this.reconnect();
    }
    /**
     * Forcibly drops the connection to the Axon server.
     * Ordinarily, use {@link disconnect} instead; @see {@link disconnect} for details.
     */
    async terminate(timeoutMs = WS_TERMINATE_TIMEOUT_MS) {
        if (this.state === AxonClientState.DISCONNECTED) {
            this.logDebug(`terminate() aborted; client is already in DISCONNECTED state.`);
            return;
        }
        if (this._reconnectBackoffTimer) {
            clearTimeout(this._reconnectBackoffTimer);
            this._reconnectBackoffTimer = undefined;
        }
        this._reconnectWithBackoffAttempt = 0;
        ++this._connectionIteration;
        if (this.state !== AxonClientState.DISCONNECTING) {
            this.transitionTo(AxonClientState.DISCONNECTING);
        }
        this._txBuffer = [];
        await this._deinitialize(timeoutMs);
        if (this.state === AxonClientState.DISCONNECTING) {
            this.transitionTo(AxonClientState.DISCONNECTED);
        }
    }
    /**
     * Gracefully disconnects from the Axon server. See {@link terminate} for details.
     * @param timeoutMs Amount of time, in ms, to allow proper WebSocket closing.
     */
    async disconnect(timeoutMs = WS_DISCONNECT_TIMEOUT_MS) {
        if (this.state === AxonClientState.DISCONNECTED) {
            this.logDebug(`disconnect() aborted; client is already in DISCONNECTED state.`);
            return;
        }
        this.session.expectDisconnection();
        this._config.preferredSessionId = undefined;
        ++this._connectionIteration;
        const deadline = Date.now() + timeoutMs;
        const ws = this._ws;
        this.logDebug(`disconnect() started with timeout of ${timeoutMs} ms.`);
        this.transitionTo(AxonClientState.DISCONNECTING);
        if (ws && ws.readyState === WebSocket$2.CONNECTING) {
            // Wait for a connecting Websocket to be properly open before closing it.
            await new Promise(resolve => {
                const timer = setTimeout(resolve, deadline - Date.now());
                ws.addEventListener('open', () => {
                    clearTimeout(timer);
                    resolve();
                }, { once: true });
            });
        }
        await this.terminate(Math.max(0, deadline - Date.now()));
    }
}
AxonClient.State = AxonClientState;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// TODO: Likely to be removed upon dynamic service name resolution via ANS Discovery workflow.
const ANS_SERVICE_NAME = 'ANS';
/**
 * Provides SAM context for Adobe Notification System (ANS).
 *
 * @experimental This API is in an experimental phase. This and related APIs are subject
 * to modifications during active development and until the maintenance phase is reached.
 */
class ANSContext {
    constructor(_core) {
        this._core = _core;
        this._logger = new Logger$2('ANS', _core._environment.logSink);
    }
    // TODO: Implement notificationSource.
    // public notificationSource(): AnsNotificationSource {
    //     if (!this._notificationSource) {
    //         this._notificationSource = new AnsNotificationSource(this);
    //     }
    //     return this._notificationSource;
    // }
    // public query(filter: string, pageSize: number) {
    //     this.logDebug(`Querying notifications with filter: '${filter}' and page size: ${pageSize}`);
    // }
    // private _notificationSource: AnsNotificationSource | undefined;
    async _ensureAxonVc() {
        if (this._axonVc) { // Maintain a singleton instance.
            if (await this._axonVc.ensureActive()) {
                return this._axonVc;
            }
            // If the VC is not active, log a message and invalidate the existing VC.
            this.logDebug('ANS Virtual Connection is not active. Will create a new one...');
            this._axonVc = undefined;
        }
        const axonClient = await this._core._getAxonClient();
        if (!await axonClient.session.ensureEstablished()) {
            throw new Error('Axon Session could not be established!');
        }
        const headers = Object.assign(Object.assign({}, this._core._environment.getValue('ANS_HEADERS')), { 'locale': axonClient.config.locale });
        this._axonVc = await axonClient.session.createVc(ANS_SERVICE_NAME, headers);
        return this._axonVc;
    }
    /**
     * Ensures that the ANS Context is initialized and the underlying connection to ANS is active.
     * @returns A promise that resolves to true if the ANS Context is initialized, false otherwise.
     */
    async ensureInitialized() {
        try {
            return (await this._ensureAxonVc()).ensureActive();
        }
        catch (error) {
            this.logError('Failed to create ANS Virtual Connection', error);
            return false;
        }
    }
    /**
     * Deinitializes the ANS Context and closes its underlying connection to ANS.
     * @returns A promise that resolves to true if the ANS Context is deinitialized, false otherwise.
     */
    async deinitialize() {
        if (!this._axonVc) {
            return true;
        } // VC is already deinitialized.
        let axonClient;
        const vc = this._axonVc;
        this._axonVc = undefined;
        try {
            axonClient = await this._core._getAxonClient();
            if (!axonClient.isConnected()) {
                return true; // Axon Client is already disconnected.
            }
            if (!await axonClient.session.ensureEstablished()) {
                throw new Error('Axon Session could not be established!');
            }
        }
        catch (error) {
            this.logWarn('ANS Virtual Connection deletion skipped', error);
            return true;
        }
        try {
            return await axonClient.session.deleteVc(vc);
        }
        catch (error) {
            this.logError('Failed to delete ANS Virtual Connection', error);
            return false;
        }
    }
    /**
     * Logs a debug message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logDebug(message, ...optionalParams) {
        this._logger.logDebug(message, 'Context', ...optionalParams);
    }
    /**
     * Logs an info message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logInfo(message, ...optionalParams) {
        this._logger.logInfo(message, 'Context', ...optionalParams);
    }
    /**
     * Logs a warning message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logWarn(message, ...optionalParams) {
        this._logger.logWarn(message, 'Context', ...optionalParams);
    }
    /**
     * Logs an error message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     * @remarks If the first optional parameter is an Error object, the message will be appended with the error message.
     */
    logError(message, ...optionalParams) {
        this._logger.logError(message, 'Context', ...optionalParams);
    }
}
__decorate([
    synchronized
], ANSContext.prototype, "ensureInitialized", null);
__decorate([
    synchronized
], ANSContext.prototype, "deinitialize", null);

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2025 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
function acplAssetToLocalAsset(adobeAsset) {
    var _a, _b;
    return {
        localID: adobeAsset.localID,
        syncStatus: adobeAsset.syncStatus,
        syncSuspensionReason: adobeAsset.syncSuspensionReason,
        downloadStatus: adobeAsset.downloadStatus,
        uploadStatus: adobeAsset.uploadStatus,
        // TODO: In ACPL, the repositoryID is "~" rather than a real ID.
        // Ignoring it here to prevent this value from propagating to SAM.js.
        // See followup for desktop workflows: https://jira.corp.adobe.com/browse/SAM-4812
        // 'repo:repositoryId': adobeAsset.repositoryID,
        // 'repo:path': adobeAsset.repoPath,
        'repo:assetId': adobeAsset.cloudID,
        'repo:size': adobeAsset.sizeInBytes,
        'repo:name': adobeAsset.name,
        'dc:format': adobeAsset.mediaType,
        // Even though created and modified are not optional, they are not always present on ACPL assets.
        'storage:deviceCreateDate': (_a = adobeAsset.created) === null || _a === void 0 ? void 0 : _a.toISOString(),
        'storage:deviceModifyDate': (_b = adobeAsset.modified) === null || _b === void 0 ? void 0 : _b.toISOString(),
        'repo:etag': adobeAsset.etag,
        'repo:createdBy': adobeAsset.createdBy,
        'repo:modifiedBy': adobeAsset.modifiedBy,
        'repo:version': adobeAsset.version,
        // We no longer propagate `repo:state`. SAM.js will treat service responses as authoritative.
    };
}
/**
 * A class that tracks the list of local assets, emitting "localAssetChange" events when that list changes.
 */
class LocalAssetUpdateTracker {
    constructor(applicationContext) {
        this.applicationContext = applicationContext;
        this.localAssets = new Map();
        this.updateAsset = (asset) => {
            if (asset.localID) {
                this.localAssets.set(asset.localID, acplAssetToLocalAsset(asset));
                this.emitUpdate(asset, asset.cloudID ? 'update' : 'add');
            }
            else if (asset.cloudID) {
                let previousLocalID;
                for (const [key, value] of this.localAssets) {
                    if (value['repo:assetId'] === asset.cloudID) {
                        previousLocalID = key;
                    }
                }
                if (previousLocalID) {
                    this.emitUpdate(asset, asset.cloudID ? 'update' : 'add');
                    this.localAssets.delete(previousLocalID);
                }
            }
        };
        this.onChangedAssets = ({ previews, properties, status }) => {
            // Seems like we don't need to distinguish the types of changes here?
            const changes = [...previews, ...properties, ...status];
            for (const asset of changes) {
                this.updateAsset(asset);
            }
        };
        this.onListChanged = throttle(() => {
            for (const item of this.recentsList.items) {
                this.updateAsset(item);
            }
        }, LIST_CHANGE_DELAY_MS);
        this.recentsList = applicationContext.recentsSource.getList(OrderDirection.Descending, OrderField.Modified);
        // SAM.cpp fires several different events for list change (SAM.js uses only one).
        SAM_CPP_ITEM_EVENTS.forEach(eventName => this.recentsList.on(eventName, this.onListChanged));
        applicationContext.on('changedAssets', this.onChangedAssets);
        // Populate the initial list. (Usually this is empty; we monitor for subsequent changes.)
        for (const item of this.recentsList.items) {
            this.updateAsset(item);
        }
    }
    getLocalAssets() {
        return Array.from(this.localAssets.values());
    }
    emitUpdate(asset, type) {
        const acplModel = getACPLModel();
        acplModel === null || acplModel === void 0 ? void 0 : acplModel.trigger('localAssetChange', JSON.stringify({
            type,
            localAsset: acplAssetToLocalAsset(asset),
        }));
    }
}
async function patchACPLNext(_core) {
    const acplModel = getACPLModel();
    if (!acplModel) {
        return;
    }
    if (!acplModel.getLocalAssets) {
        const initialLoadPromise = Promise.resolve().then(async () => {
            const applicationContext = await acplModel.waitForApplicationContextReady();
            return new LocalAssetUpdateTracker(applicationContext);
        });
        acplModel.getLocalAssets = async () => {
            const tracker = await initialLoadPromise;
            return tracker.getLocalAssets();
        };
    }
    const acplModelInterface = new ACPLModelInterface(_core);
    // We should always subscribe to localAssetChange: whether we polyfilled getLocalAssets ourselves
    // or we're on a compatible host implementation, we need to keep the local asset list in sync.
    acplModel.on('localAssetChange', async (eventData) => {
        const { type, localAsset } = JSON.parse(eventData);
        if (!localAsset) {
            return;
        }
        const assetContext = await _core.getAssetContext();
        const assetId = localAsset['repo:assetId'] || localAsset.localID;
        const asset = assetContext._assetPool.getLocalItemById(assetId);
        const session = _core._getAssetPool().createUpdateSession();
        if (type === 'delete' && asset) {
            session.queueDiscardedItem(asset);
        }
        else if (type === 'add' || type === 'update') {
            acplModelInterface.localAssetUpdater.updateRemoteItem(session, localAsset);
        }
        session.commit();
    });
    if (!acplModel.downloadComposite) {
        acplModel.downloadComposite = async (id) => {
            var _a;
            const asset = await acplModel.applicationAssetContext.getAssetWithCloudID(id);
            await ((_a = asset.downloadComposite) === null || _a === void 0 ? void 0 : _a.call(asset));
        };
    }
    if (!acplModel.unpin) {
        acplModel.unpin = async (id) => {
            var _a;
            const asset = await acplModel.applicationAssetContext.getAssetWithCloudID(id);
            await ((_a = asset.unpin) === null || _a === void 0 ? void 0 : _a.call(asset));
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// If multiple versions of SAM.js are loaded in the same app, they will have different
// contents in the closure of the module, so the Symbol used to store the global instances
// of SAMCore must be a global Symbol.
const $SAM_INSTANCE_MAP = Symbol.for('com.adobe.ccac-sam-js.instances');
// Matches ACPL log level enum
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Off"] = 0] = "Off";
    LogLevel[LogLevel["Err"] = 1] = "Err";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));
class SAMCore extends TypedEventEmitter {
    constructor(config, hooks = {}) {
        super();
        this._assetPool = new ItemPool(this, 'project or adobeasset');
        /**
         * @package -- for use in SAM.js only
         */
        this._adobeAssetFactory = new AdobeAssetFactory(this);
        this._fetchIndexState = {};
        this._environment = new Environment(this, config, hooks);
        if (config.CACHE_KEEP_ALIVE_TTL) {
            KeepAliveManager.setTTL(config.CACHE_KEEP_ALIVE_TTL);
        }
    }
    /**
     * The primary ItemPool used by any context and item that extends AdobeAsset.
     *
     * @package - Used internally only.
     */
    _getAssetPool() {
        return this._assetPool;
    }
    /**
     * @package -- Used for setting both the pure JS AssetContext,ts and the Native AssetContext
     * provided from the bindings.
     */
    async _setAssetContextFromBindings(nativeAssetContext) {
        if (this._AssetContext) {
            // If multiple SAM.js instances invoke this, only the first gets to set it. This
            // is likely a temporary condition while SAM.js clients converge on compatible versions.
            console.error('[SAMCore] AssetContext already initialized');
            return;
        }
        // Set the native context provided by the bindings.
        this._AssetContext = nativeAssetContext;
        // Set the pure JS Version of the context to be
        // accessed during patches to provide pure js functionality that
        // the native version doesn't provide.
        const AssetContext = (await Promise.resolve().then(function () { return AssetContext$1; })).default;
        this._AssetContextJS = new AssetContext(this, this._assetPool);
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of AssetContext.
     */
    _getAssetContext() {
        return this._AssetContext;
    }
    /**
     * Returns an instance of AssetContext.
     * @note this method can only be used when integrating with SAM.js sources
     * and first calling initializeSharedAssetModel().
     *
     * @throws {SAMErrorCode.UNSUPPORTED} When initializeSharedAssetModel() has not been called first.
     * @deprecated -  use getAssetContext()
     */
    get hostAssetContext() {
        if (!this._AssetContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'samCore.hostAssetContext cannot be used without first calling initializeSharedAssetModel()');
        }
        return this._AssetContext;
    }
    /** @package -- only for use in SAM.js */
    async _getGQLManager() {
        if (!this._gqlManager) {
            const GQLManager = (await Promise.resolve().then(function () { return GQLManager$1; })).default;
            this._gqlManager = new GQLManager(this);
            await this._gqlManager.initialize();
        }
        return this._gqlManager;
    }
    /**
     * Returns an instance of the AssetContext class which can be used
     * to get the root folder and various sources for SWY or recent
     * documents.
     *
     * @returns {AssetContext}
     */
    async getAssetContext() {
        if (this._AssetContext) {
            return this._AssetContext;
        }
        const AssetContext = (await Promise.resolve().then(function () { return AssetContext$1; })).default;
        this._AssetContext = new AssetContext(this, this._assetPool);
        await this._AssetContext._getONSContext(); // Ensure ONS Context is initialized.
        // @TODO https://jira.corp.adobe.com/browse/SAM-3580
        // Preload Collaboration Context since the ShareableItem.collaborators still requires some
        // work to fully separate the lazily loading of CollaborationContext only when  collaborators
        // and related features are required.
        await this.getCollaborationContext();
        return this._AssetContext;
    }
    /**
     * @deprecated use AssetContext.assetLinkManager going forward.
     *
     */
    get assetLinkManager() {
        if (!this._AssetContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'samCore.assetLinkManager and samCore.assetContext cannot be used without first calling initializeSharedAssetModel()');
        }
        if (!this._AssetContext._getAssetLinkManager()) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'samCore.assetLinkManager cannot be used without first calling initializeSharedAssetModel()');
        }
        return this._AssetContext._getAssetLinkManager();
    }
    /**
     * Returns an instance of SpaceContext.
     * @note this method can only be used when integrating with SAM.js sources
     * and first calling initializeSharedAssetModel().
     *
     * @throws {SAMErrorCode.UNSUPPORTED} When initializeSharedAssetModel() has not been called first.
     * @deprecated -- will be removed on or after 2024-10-01
     */
    get spaceContext() {
        oneTimeWarning('SAMCore.spaceContext', 'spaceContext is deprecated and will be removed on or after 2024-10-01');
        if (!this._SpaceContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'samCore.spaceContext cannot be used without first calling initializeSharedAssetModel()');
        }
        return this._SpaceContext;
    }
    /**
     *
     * @deprecated -- will be removed on or after 2024-10-01
     */
    async getSpaceContext() {
        if (this._SpaceContext) {
            return this._SpaceContext;
        }
        const SpaceContext = (await Promise.resolve().then(function () { return SpaceContext$1; })).default;
        this._SpaceContext = new SpaceContext(this);
        return this._SpaceContext;
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of SpaceContext.
     */
    _getSpaceContext() {
        return this._SpaceContext;
    }
    /**
     * Returns an instance of CollaborationContext.
     * @note this method can only be used when integrating with SAM.js sources
     * and first calling initializeSharedAssetModel().
     *
     * @throws {SAMErrorCode.UNSUPPORTED} When initializeSharedAssetModel() has not been called first.
     *
     * @deprecated - use getCollaborationContext()
     */
    get collaborationContext() {
        if (!this._CollaborationContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'samCore.collaborationContext cannot be used without first calling initializeSharedAssetModel()');
        }
        return this._CollaborationContext;
    }
    async getCollaborationContext() {
        if (this._CollaborationContext) {
            return this._CollaborationContext;
        }
        const CollaborationContext = (await Promise.resolve().then(function () { return CollaborationContext$1; })).default;
        this._CollaborationContext = new CollaborationContext(this);
        return this._CollaborationContext;
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of CollaborationContext.
     */
    _getCollaborationContext() {
        return this._CollaborationContext;
    }
    /**
     * Returns an instance of ProjectContext.
     * @note this method can only be used when integrating with SAM.js sources
     * and first calling initializeSharedAssetModel().
     *
     * @throws {SAMErrorCode.UNSUPPORTED} When initializeSharedAssetModel() has not been called first.
     * @deprecated - use getProjectContext()
     */
    get projectContext() {
        if (!this._ProjectContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'samCore.projectContext cannot be used without first calling initializeSharedAssetModel()');
        }
        return this._ProjectContext;
    }
    async getProjectContext() {
        if (this._ProjectContext) {
            return this._ProjectContext;
        }
        const ProjectContext = (await Promise.resolve().then(function () { return ProjectContext$1; })).default;
        this._ProjectContext = new ProjectContext(this, this._assetPool);
        return this._ProjectContext;
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of ProjectContext.
     */
    _getProjectContext() {
        return this._ProjectContext;
    }
    /**
     * Provides all Classroom related functionality.
     * @note this method can only be used when integrating with SAM.js sources
     * and first calling initializeSharedAssetModel().
     *
     * @throws {SAMErrorCode.UNSUPPORTED} When initializeSharedAssetModel() has not been called first.
     * @deprecated - Use getClassroomContext().
     */
    get classroomContext() {
        if (!this._ClassroomContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'samCore.classroomContext cannot be used without first calling initializeSharedAssetModel()');
        }
        return this._ClassroomContext;
    }
    /**
     * Get an instance of ClassroomContext
     */
    async getClassroomContext() {
        if (this._ClassroomContext) {
            return this._ClassroomContext;
        }
        const ClassroomContext = (await Promise.resolve().then(function () { return ClassroomContext$2; })).default;
        this._ClassroomContext = new ClassroomContext(this, this._assetPool);
        return this._ClassroomContext;
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of ClassroomContext.
     */
    _getClassroomContext() {
        return this._ClassroomContext;
    }
    /**
     * Get an instance of BoardsContext
     *
     * @experimental This API is in an experimental phase so expect that
     * APIs will not be final and there will be breaking changes
     * without bumping the major version until this comment is removed.
     *
     */
    async getBoardContext() {
        if (this._BoardContext) {
            return this._BoardContext;
        }
        const BoardContext = (await Promise.resolve().then(function () { return BoardContext$1; })).default;
        this._BoardContext = new BoardContext(this, this._assetPool);
        return this._BoardContext;
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of BoardContext.
     */
    _getBoardContext() {
        return this._BoardContext;
    }
    /**
     * Provides Axon Client, representing an authenticated Axon Session over WebSocket protocol,
     * which facilitates creation of Virtual Channels to Adobe Sync Servies such as ANS or ONS.
     * This is a synchronous, promise-returning method, handling endpoint resolution,
     * authentication, configuration and singleton initialization of the AxonClient object.
     *
     * @experimental This API is in an experimental phase. This and related APIs are subject
     * to modifications during active development and until the maintenance phase is reached.
     *
     * @package -- for use in SAM.js only
     */
    _getAxonClient() {
        if (this._AxonClient) { // Lazily initialized singleton instance.
            return this._AxonClient;
        }
        // Authenticated fetch function supporting abort signal and setting noApiKeyHeader.
        const authenticatedFetch = async (url) => this._environment.fetch(url, { noApiKeyHeader: true });
        const axonConfig = new AxonClientConfig(this._environment.endpoints.AXON_HOST, // Axon endpoint.
        authenticatedFetch, // Must be of AxonClientAuthenticatedGet type.
        this._environment.logSink);
        if (this._environment.getValue('ENVIRONMENT') === Env.Stage) {
            // While on Stage, elevate the default log-level to DEBUG.
            axonConfig.logger.logLevel = LogLevel$1.DEBUG;
        }
        const locale = this._environment.getValue('LOCALE');
        if (locale) {
            axonConfig.locale = locale;
        }
        this._AxonClient = Promise.resolve(new AxonClient(axonConfig));
        return this._AxonClient;
    }
    /**
     * Gets AnsContext, representing an always-connected client to the ANS service.
     *
     * @experimental This API is in an experimental phase. This and related APIs are subject
     * to modifications during active development and until the maintenance phase is reached.
     */
    get ansContext() {
        if (!this._AnsContext) {
            this._AnsContext = new ANSContext(this);
        }
        return this._AnsContext;
    }
    /**
    /**
     * Provides an instance of FrameioContext.
     *
     * @note this method can only be used when integrating with SAM.js sources
     * and first calling initializeSharedAssetModel().
     *
     * @throws {SAMErrorCode.UNSUPPORTED} When initializeSharedAssetModel() has not been called first.
     * @deprecated use getFrameioContext()
     */
    get frameioContext() {
        if (!this._FrameioContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'samCore.frameioContext cannot be used without first calling initializeSharedAssetModel()');
        }
        return this._FrameioContext;
    }
    /** @package -- for use in SAM.js only */
    async getANSContext() {
        return this.ansContext;
    }
    async getFrameioContext() {
        if (this._FrameioContext) {
            return this._FrameioContext;
        }
        const FrameioContext = (await Promise.resolve().then(function () { return FrameioContext$1; })).default;
        this._FrameioContext = new FrameioContext(this);
        return this._FrameioContext;
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of ProjectContext.
     */
    _getFrameioContext() {
        return this._FrameioContext;
    }
    async getLibraryContext() {
        if (this._LibraryContext) {
            return this._LibraryContext;
        }
        const LibraryContext = (await Promise.resolve().then(function () { return LibraryContext$1; })).default;
        this._LibraryContext = new LibraryContext(this, this._assetPool);
        return this._LibraryContext;
    }
    _getLibraryContext() {
        return this._LibraryContext;
    }
    async getCustomModelContext() {
        if (this._CustomModelContext) {
            return this._CustomModelContext;
        }
        const CustomModelContext = (await Promise.resolve().then(function () { return CustomModelContext$1; })).default;
        this._CustomModelContext = new CustomModelContext(this, this._assetPool);
        return this._CustomModelContext;
    }
    async getGenerationHistoryContext() {
        if (this._GenerationHistoryContext) {
            return this._GenerationHistoryContext;
        }
        const GenerationHistoryContext = (await Promise.resolve().then(function () { return GenerationHistoryContext$1; })).default;
        this._GenerationHistoryContext = new GenerationHistoryContext(this, this._assetPool);
        return this._GenerationHistoryContext;
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of ProjectContext.
     */
    _getCustomModelContext() {
        return this._CustomModelContext;
    }
    makeObservable(createAtom) {
        return this._environment.mobx.register(createAtom);
    }
    /**
     * @deprecated -- will be renamed for internal use on or after 2024-10-01
     */
    /**
     * @package -- for use in SAM.js only
     */
    get environment() {
        oneTimeWarning('SAMCore.environment', 'environment is deprecated and will be renamed for internal use on or after 2024-10-01');
        return this._environment;
    }
    updateConfig(config) {
        const keys = Object.keys(config);
        keys.forEach((key) => {
            const updatableKey = key;
            this._environment.setValue(updatableKey, config[updatableKey]);
        });
    }
    /**
     * @package -- Used internally to synchronously get the loaded and cached instance
     * of WorkfrontContext.
     */
    _getWorkfrontContext() {
        return this._WorkfrontContext;
    }
    async getWorkfrontContext() {
        if (this._WorkfrontContext) {
            return this._WorkfrontContext;
        }
        const WorkfrontContext = (await Promise.resolve().then(function () { return WorkfrontContext$1; })).default;
        this._WorkfrontContext = new WorkfrontContext(this);
        return this._WorkfrontContext;
    }
    async getKnowledgeWorkspaceContext() {
        if (this._KnowledgeWorkspaceContext) {
            return this._KnowledgeWorkspaceContext;
        }
        const KnowledgeWorkspaceContext = (await Promise.resolve().then(function () { return KnowledgeWorkspaceContext$1; })).default;
        this._KnowledgeWorkspaceContext = new KnowledgeWorkspaceContext(this);
        return this._KnowledgeWorkspaceContext;
    }
    /**
     * Get the AccessControlContext for the Workfront context.
     *
     * @service For now only internal and aservice clients use cases are suppported.
     * To share assets, use the CollaborationContext and ShareableItem.
     *
     * @returns The AccessControlContext for the Workfront context.
     */
    async getAccessControlContext() {
        const AccessControlContext = (await Promise.resolve().then(function () { return AccessControlContext$1; })).default;
        return new AccessControlContext(this);
    }
}
__decorate([
    synchronized
], SAMCore.prototype, "getAssetContext", null);
__decorate([
    memoize$1
], SAMCore.prototype, "assetLinkManager", null);
__decorate([
    synchronized
], SAMCore.prototype, "getSpaceContext", null);
__decorate([
    memoize$1
], SAMCore.prototype, "collaborationContext", null);
__decorate([
    synchronized
], SAMCore.prototype, "getCollaborationContext", null);
__decorate([
    memoize$1
], SAMCore.prototype, "frameioContext", null);
__decorate([
    memoize$1
], SAMCore.prototype, "getAccessControlContext", null);
async function initializeSharedAssetModel(config, hooks = {}) {
    var _a, _b, _c, _d;
    let samInstances = {};
    // SAM.js supports running in a node.js _environment, so we can't assume that window is defined.
    if (typeof window !== 'undefined') {
        if (!window[$SAM_INSTANCE_MAP]) {
            window[$SAM_INSTANCE_MAP] = samInstances;
        }
        else {
            samInstances = window[$SAM_INSTANCE_MAP];
        }
    }
    // Check to see if any versions of SAM.js have already been loaded that are compatible with us (using semantic versioning, the
    // major version must match, and the minor.patch version must be later than or equal to the one we need)
    const version = (config._VERSION_OVERRIDE_FOR_TEST !== undefined && config._VERSION_OVERRIDE_FOR_TEST !== '')
        ? config._VERSION_OVERRIDE_FOR_TEST
        : packageJSON.version;
    const [major, minor, patch] = version.split('.').map(Number);
    const loadedVersions = Object.keys(samInstances);
    const compatibleLoadedVersion = loadedVersions.find(loadedVersion => {
        if (loadedVersion === version) {
            return true;
        }
        // If it's not an exact version match, we parse the versions and do a semantic version comparison - note that if
        // the major version is 0, it's assumed that all changes are breaking.
        const [loadedMajor, loadedMinor, loadedPatch] = loadedVersion.split('.').map(Number);
        return major !== 0 && loadedMajor === major && (loadedMinor > minor || (loadedMinor === minor && loadedPatch >= patch));
    });
    // If there's a compatible version, use it!
    if (compatibleLoadedVersion) {
        return samInstances[compatibleLoadedVersion];
    }
    // If not, create a new version (warn if this means there will be multiple SAM.js versions)
    if (loadedVersions.length > 0) {
        console.warn(`An instance of SAM.js already exists, but is not compatible with the requested version: ${version}. `
            + `Because of this, a new instance of SAM.js will be created. Loaded versions: ${loadedVersions.join(', ')}.`);
    }
    // Wait for host asset context, and patch SAM.cpp as needed
    // Presence of global acplModel tells us SAM.cpp JS bindings are present
    // @ts-expect-error
    const acplModel = (typeof window !== 'undefined') && window.acplModel;
    const enableACPLNextPolyfills = (_b = (_a = config.FEATURE_FLAGS) === null || _a === void 0 ? void 0 : _a['enable-acpl-next-polyfills']) !== null && _b !== void 0 ? _b : false;
    const disableSamCppModels = (_d = (_c = config.FEATURE_FLAGS) === null || _c === void 0 ? void 0 : _c['disable-sam-cpp-models']) !== null && _d !== void 0 ? _d : false;
    const isPatchableVersion = () => {
        var _a, _b;
        // SAM.cpp 2.0.0-main.1301 is the earliest release that supports patching prototypes.
        const rootFolderProto = (_a = acplModel.applicationAssetContext) === null || _a === void 0 ? void 0 : _a.rootFolder.constructor.prototype;
        return Boolean(rootFolderProto) && ((_b = Object.getOwnPropertyDescriptor(rootFolderProto, 'name')) === null || _b === void 0 ? void 0 : _b.configurable) === true;
    };
    /**
     * Use before providing the core in order to
     * import and set contexts for use with clients who
     * are still integrating us by source.
     *
     * @param core {SAMCore}
     */
    const loadAndSetContexts = async (core) => {
        if (!core._getAssetContext()) {
            await core.getAssetContext();
            const loadedAssetContext = core._getAssetContext();
            if (!loadedAssetContext._getAssetLinkManager()) {
                await loadedAssetContext.getAssetLinkManager();
            }
        }
        if (enableACPLNextPolyfills) {
            await patchACPLNext(core);
        }
        if (!core._getProjectContext()) {
            await core.getProjectContext();
        }
        if (!core._getSpaceContext()) {
            await core.getSpaceContext();
        }
        if (!core._getClassroomContext()) {
            await core.getClassroomContext();
        }
        if (!core._getCollaborationContext()) {
            await core.getCollaborationContext();
        }
        if (!core._getLibraryContext()) {
            await core.getLibraryContext();
        }
        if (!core._getFrameioContext()) {
            await core.getFrameioContext();
        }
        if (!core._getCustomModelContext()) {
            await core.getCustomModelContext();
        }
        if (!core._getWorkfrontContext()) {
            await core.getWorkfrontContext();
        }
    };
    samInstances[version] = new Promise((resolve, reject) => {
        var _a;
        if (acplModel && !config._DISABLE_SAM_CPP) {
            // Either immediately resolve with existing applicationAssetContext, or wait for it
            Promise.race([
                (_a = acplModel.applicationAssetContext) !== null && _a !== void 0 ? _a : acplModel.waitForApplicationContextReady()
            ]).then(() => {
                try {
                    // If we can't (or shouldn't) patch this version of SAM.cpp, return a pure-JS implementation.
                    if (disableSamCppModels || !isPatchableVersion()) {
                        // This behavior is solidified by a test in SAMCore.spec.ts where "it should only patch SAM.ccp if it
                        // being patched".
                        const core = new SAMCore(config, hooks);
                        loadAndSetContexts(core)
                            .then(() => resolve(core));
                        return;
                    }
                    const core = new SAMCore(config, hooks);
                    // Patching should be done in this order, because the SAM.cpp prototypes aren't exposed in the global
                    // namespace, or on global `acplModel`, so the only way to get prototypes is to find an instance of
                    // the class and get a reference to `obj.constructor.prototype`. E.g., to patch AssetList, it needs
                    // to get it from `acplModel.applicationAssetContext.rootFolder.children.getList()`, so
                    // `AssetSource.getList()` cannot be patched yet.
                    patchAdobeAsset(core);
                    patchSpaceJS();
                    patchAssetList(core);
                    patchAssetSource(core);
                    patchAssetContext(core);
                    if (loadedVersions.length > 0) {
                        console.error('[initializeSharedAssetModel] SAM.cpp can only be observable by one'
                            + ' instance of SAMCore. Clients using SAM.js internal version ' + version + ' will not'
                            + ' see Mobx observables working. Clients on a host app should align on the same SAM.js'
                            + ' version before shipping to customers.');
                    }
                    // Provides the native context to SAM.js and creates a new
                    // instance of the pure JS AssetContext to also be used in the bindings.
                    core._setAssetContextFromBindings(acplModel.applicationAssetContext).then(() => {
                        resolve(core);
                    });
                }
                catch (e) {
                    console.error('[initializeSharedAssetModel] failed to patch SAM.cpp', e);
                    reject(e);
                }
            });
        }
        else {
            // No SAM.cpp present, use pure SAM.js implementation
            const samCore = new SAMCore(config, hooks);
            loadAndSetContexts(samCore)
                .then(() => resolve(samCore));
        }
    });
    // Do not cache failed initialization attempts
    try {
        await samInstances[version];
    }
    catch (e) {
        delete samInstances[version];
        throw e;
    }
    return samInstances[version];
}
/**
 * @deprecated Use {@link initializeSharedAssetModel} instead, will be removed on or after 2024-10-01.
 */
function createSharedAssetModel(config, hooks = {}) {
    oneTimeWarning('createSharedAssetModel', 'createSharedAssetModel is deprecated and will be removed on or after 2024-10-01. Use'
        + ' initializeSharedAssetModel instead.');
    return new SAMCore(config, hooks);
}

/** Returns true if the object has a key. Can be used as a replacement to `Object.hasOwnProperty` and `Object.hasOwn`. */
const hasProperty = (obj, key) => {
    return Object.getOwnPropertyDescriptor(obj, key) !== undefined;
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultSearchQuery = {
    scope: ['creative_cloud'],
    // Ensures assetIds in results are returned with the correct casing. E.g. ":US:" instead of ":us:"
    asset_id_opacity: true
};
class USSInterface extends InterfaceBase {
    _getEndpointHref(endpoint) {
        return `https://${this._core._environment.endpoints.USS_HOST}${endpoint}`;
    }
    async getQueryResponse(searchQuery, resource) {
        searchQuery = Object.assign(Object.assign({}, DefaultSearchQuery), searchQuery);
        const endpointHref = this._getEndpointHref('/universal-search/v2/search');
        const { PRODUCT_ID } = this._core._environment.getValue('HOST_PRODUCT_DATA');
        const response = await this._doPost(endpointHref, {
            'Content-Type': 'application/vnd.adobe.search-request+json',
            'X-Product': PRODUCT_ID,
            'X-Product-Location': `SAM.js/${packageJSON.version}`
        }, JSON.stringify(searchQuery), [200], false, resource);
        return response.json();
    }
    async searchSpace(parentFolderId, searchArtifacts, embedPermissions, options) {
        var _a, _b, _c, _d;
        const query = {
            hints: [{ acp_platform_v2: true, creative_cloud_rendition_v2: true }],
            fetch_fields: { includes: ['app_metadata', 'collaboration_metadata'] },
            sort_orderby: (_a = options === null || options === void 0 ? void 0 : options.sort_orderby) !== null && _a !== void 0 ? _a : 'modify_date',
            sort_order: (_b = options === null || options === void 0 ? void 0 : options.sort_order) !== null && _b !== void 0 ? _b : 'desc',
            limit: (_c = options === null || options === void 0 ? void 0 : options.limit) !== null && _c !== void 0 ? _c : 50,
            start_index: (_d = options === null || options === void 0 ? void 0 : options.start_index) !== null && _d !== void 0 ? _d : 0,
            [SearchProps.TYPE]: (options === null || options === void 0 ? void 0 : options.type) || [],
            container: { asset_id: [parentFolderId] },
        };
        if (!searchArtifacts) {
            query.op_none_of = [
                // exclude Artifacts
                { op_field_exists: [USS_ARTIFACT_MEDIATYPE] },
                // exclude hidden
                { [SearchProps.VISIBILITY]: ['hiddenSelf', 'hiddenRecursive'] }
            ];
        }
        else {
            // Only include artifacts
            query.op_field_exists = [USS_ARTIFACT_MEDIATYPE];
        }
        if (embedPermissions) {
            query.fetch_fields.includes.push('_embedded');
        }
        return this.getQueryResponse(query);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class InvitationInterface extends InterfaceBase {
    constructor() {
        super(...arguments);
        this._batchRequestLimit = 50;
    }
    get batchRequestLimit() {
        return this._batchRequestLimit;
    }
    _getUrl(endpoint) {
        return `https://${this._core._environment.endpoints.INVITATIONS_HOST}${endpoint}`;
    }
    async getCollaborators(urn) {
        // This allows piggybacking on a single request, so that we can support loading both the collaborators
        // and invitations at the same time, without making two separate requests (the data for both of these
        // is in the same response).
        return await this._getSharedResponse(this._getUrl(`/api/v4/share/${encodeURIComponent(urn)}?extraFeatures=direct_acl`));
    }
    async addCollaborators(urn, request) {
        await this._doPost(this._getUrl(`/api/v4/share/${encodeURIComponent(urn)}`), {}, JSON.stringify(request), [200]);
    }
    async modifyCollaborators(urn, request) {
        const response = await this._doPatch(
        // As per the invitation service API spec, mode (optional) If not specified, the API makes the effective ACL match
        // the specified role and permissions. If the value is "direct_acl", the API makes the direct ACL match the
        // specified role and permissions. Sharesheet is using this mode and we are expected to use it as well.
        this._getUrl(`/api/v4/share/${encodeURIComponent(urn)}?mode=direct_acl`), {}, JSON.stringify(request), [200]);
        return await response.json();
    }
    async getCollaboratorListForUrns(urns) {
        const request = {
            'operation': 'bulkGetShares',
            'parameters': {
                urns,
                'queryParams': {
                    'extraFeatures': 'direct_acl,legacy_role'
                }
            }
        };
        const response = await this._doPost(this._getUrl(`/ops/v4/shares`), { 'Content-Type': 'application/json' }, JSON.stringify(request), [200]);
        const result = await response.json();
        // response is 200, but result is not in proper format
        if (!result.result || !Array.isArray(result.result)) {
            throw SAMError.create(SAMErrorCode.UNKNOWN, 'Failed to parse response for Invitation Service bulk API.');
        }
        return result;
    }
    async confirmAccess(urn) {
        await this._doPost(this._getUrl(`/api/v4/invitations/urn/${encodeURIComponent(urn)}`), {}, undefined, [200]);
    }
    // might be able to remove this after invitation service handles https://jira.corp.adobe.com/browse/CPX-7447
    _shouldRetryMonitorResponse(asyncResponse, body) {
        if (asyncResponse.status === 200) {
            const responseBody = JSON.parse(body);
            if (responseBody.jobStatus !== 'completed') {
                return true;
            }
        }
        return false;
    }
    async declineAccess(urn) {
        await this._doDelete(this._getUrl(`/api/v4/invitations/urn/${encodeURIComponent(urn)}`), {}, [200]);
    }
    async getPendingInvitations() {
        const response = await this._doGet(this._getUrl('/api/v4/invitations'), { headers: { 'Content-Type': 'application/json' } });
        return await response.json();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const MAX_INDEX_RETRIES = 5;
class RepositoryInterface extends InterfaceBase {
    constructor() {
        super(...arguments);
        // Index document is a well-known endpoint, so does not need to come from discovery.
        // https://developers.corp.adobe.com/index-repository-api/docs/index-document.md
        this.repositoryIndex = `https://${this._core._environment.endpoints.ACP_CS_HOST}/index`;
        this.repositoryNameIndex = `https://${this._core._environment.endpoints.ACP_CS_HOST}/repositories`;
        this.workfrontRepositoryIndex = `https://${this._core._environment.endpoints.ACP_CS_HOST}/index-workfront`;
        this._useHighPriorityRequestsIfEnabled = true;
        this._cache = this._core._environment.cache;
    }
    get _fetchIndexState() { return this._core._fetchIndexState; }
    set _fetchIndexState(state) { this._core._fetchIndexState = state; }
    _getAndCacheDocument(href) {
        return this._getAllPages(href);
    }
    _getIndexHeaders() {
        return {
            // R-API returns an E-Tag which doesn't change when the content changes, causing the browser to
            // use stale cached data. Using Cache-Control header to disable browser cache so this doesn't happen.
            // [SAM-2952]
            'Cache-Control': 'no-cache, no-store, max-age=0',
            // SAMJS-467: calculating which regions the user has discoverable assets in is slow, but
            // no clients require this behavior, so disable calculation for better performance.
            'directive': 'index-skip-repo-regions'
        };
    }
    _getRepositoryHref(repositoryID) {
        return `https://${this._core._environment.endpoints.ACP_CS_HOST}/content/repo/${repositoryID}/repositoryResource`;
    }
    async getRootLink(relType, params = {}) {
        // The only thing uses in SAM.js from the `/` resource is the `_links` metadata, which is identical to the
        // `_links` in the `/index` resource, so use the `/index` resource for the root links
        const rootDocument = await this.getIndex();
        return getURLFromLinks(rootDocument._links, relType, params);
    }
    async getIndex() {
        var _a, _b;
        const fetchIndexState = this._fetchIndexState;
        // If something triggered clearing the cache, wait for it to finish
        if (fetchIndexState.pendingCacheClear) {
            await fetchIndexState.pendingCacheClear;
        }
        if (fetchIndexState.response && fetchIndexState.hasChildren) {
            // Data is complete, so return it now
            return fetchIndexState.response;
        }
        const existing = await this._cache.getItem(this.repositoryIndex);
        if (existing !== NotFound$1) {
            fetchIndexState.response = existing;
            fetchIndexState.hasChildren = Boolean((_b = (_a = fetchIndexState.response) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length);
        }
        // Refresh index in background if it hasn't been refreshed successfully this session. This allows typical
        // calls to return quickly from cache while still updating the cache regularly [SAM-3165].
        if (!fetchIndexState.promise) {
            fetchIndexState.promise = new Promise((resolve, reject) => {
                this._getResponse(this.repositoryIndex, {
                    headers: this._getIndexHeaders(),
                    // R-API might be temporarily returning 404 on the /index document for some users
                    additionalRetryErrorCodes: [404],
                }).then(async (indexJson) => {
                    var _a;
                    // Only cache /index if it has children [SAM-2952]
                    if ((_a = indexJson.children) === null || _a === void 0 ? void 0 : _a.length) {
                        await this._cache.setItem(this.repositoryIndex, indexJson);
                        fetchIndexState.hasChildren = true;
                    }
                    else {
                        // Allow getHomeDirectoryMetadata() to retry fetching /index if there were no children
                        fetchIndexState.hasChildren = false;
                        fetchIndexState.promise = undefined;
                    }
                    // Response can be used for _links even if there are no children
                    fetchIndexState.response = indexJson;
                    resolve(indexJson);
                })
                    .catch(reject);
            });
        }
        // If the /index is not in cache, or missing data, wait for fetch, otherwise use the
        // cache value while the index is refreshed in the background.
        if (fetchIndexState.promise && (!fetchIndexState.response || !fetchIndexState.hasChildren)) {
            try {
                await fetchIndexState.promise;
            }
            catch (e) {
                // Do not cache bad response, but let the original error bubble up
                fetchIndexState.promise = undefined;
                throw e;
            }
        }
        // The _links property of the response will still be usable even if children are not present.
        return fetchIndexState.response;
    }
    async getWorkfrontIndex(orgId) {
        const response = await this._getResponse(this.workfrontRepositoryIndex, {
            headers: Object.assign(Object.assign({}, this._getIndexHeaders()), { 'Org-Id': orgId }),
            // R-API might be temporarily returning 404 on the /index document for some users
            additionalRetryErrorCodes: [404]
        });
        return response;
    }
    /**
     * @package -- for use in SAM.js only
     */
    _clearIndexCache() {
        this._fetchIndexState.pendingCacheClear = new Promise(resolve => {
            // Allow pending request to complete before clearing the cache so the final state is
            // a clear cache.
            Promise.resolve(this._fetchIndexState.promise)
                .finally(() => {
                return this._cache.deleteItem(this.repositoryIndex);
            })
                .finally(() => {
                this._fetchIndexState = {};
                resolve();
            });
        });
    }
    async _getAndCacheLinksFromHref(href) {
        const response = await this._doGet(href);
        // The etag header from Links API no longer represents the Asset or its repo metadata, so it
        // isn't being stored in the SAM.js persistent cache.
        const { _links } = await response.json();
        return { links: _links };
    }
    getAssetResolveByIdHref(assetId) {
        // Links API is a "well-known endpoint" and so does not need to use discovery
        // https://developers.corp.adobe.com/storage-api/docs/reference/links.md
        const url = new URL(`https://${this._core._environment.endpoints.ACP_CS_HOST}/links`);
        setURLSearchParams(url, { assetId });
        return url.toString();
    }
    async getCloudQuotaUsedAndMax() {
        const metadata = await this.getHomeDirectoryMetadata();
        const url = getURLFromLinks(metadata._links, RelType.QUOTA);
        const responseJson = await this._getResponse(url);
        return { used: responseJson['storage:bytesUsed'], total: responseJson['storage:bytesLimit'] };
    }
    /**
     * Takes an asset id and returns the links for the resource.
     *
     * @param id {string} assetId of the object
     * @TODO_Deprecation to be removed after it is no longer used in SAMCpp.ts patchAdobeAsset
     */
    async resolveById(assetId) {
        const resolveHref = this.getAssetResolveByIdHref(assetId);
        const { links } = await this._getAndCacheLinksFromHref(resolveHref);
        return new AssetInterface(this, assetId, links, '');
    }
    async getRepoMetadataById(assetId, resource, assetLinks) {
        const resolveHref = assetLinks && assetLinks[RelType.REPO_METADATA]
            // we have a client-provided link for repo:metadata, use that instead of a resolve call.
            ? getURLFromLinks(assetLinks, RelType.REPO_METADATA)
            // GET on the resolve link will return the repo metadata
            : await this.getRootLink(RelType.RESOLVE_ID, { id: assetId });
        await this._doGet(resolveHref, { resource });
        return resource.data;
    }
    async getRepoMetadataByPath(repositoryId, path, resource, assetLinks) {
        const resolveHref = assetLinks && assetLinks[RelType.REPO_METADATA]
            // we have a client-provided link for repo:metadata, use that instead of a resolve call.
            ? getURLFromLinks(assetLinks, RelType.REPO_METADATA)
            // GET on the resolve link will return the repo metadata
            : await this.getRootLink(RelType.RESOLVE_PATH, { repositoryId, path, mode: 'id' });
        await this._doGet(resolveHref, { resource });
        return resource.data;
    }
    async getHomeDirectoryMetadata() {
        return await this._getHomeDirectoryMetadata(0);
    }
    async _getHomeDirectoryMetadata(retryCount) {
        var _a;
        // Fire off background refresh of index data
        let index = await this.getIndex();
        const featureFlags = this._core._environment.getValue('FEATURE_FLAGS');
        if ((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['enable-response-cache']) && retryCount === 0) ;
        else {
            // Wait for background refresh, which may or may not be the same as the cached value
            index = await ((_a = this._fetchIndexState.promise) !== null && _a !== void 0 ? _a : index);
        }
        // Likely cause: Enterprise user has not been granted quota by their administrator, but this error
        // could change. Host apps should verify that the user has quota before trying to get their home
        // directory info, and if they have none, show a message suggesting they contact their administrator.
        if (!index.children.length) {
            if (retryCount >= MAX_INDEX_RETRIES) {
                throw SAMError.create(SAMErrorCode.INVALID_OPERATION, `Home repository not found after ${MAX_INDEX_RETRIES} retries`);
            }
            else {
                // NOTE: assumes that getIndex() does not cache if there are no children, so no need to clear cache here
                this._core._environment.log(`/index has no children, ${MAX_INDEX_RETRIES - retryCount} retries left`);
                await new Promise(resolve => setTimeout(resolve, this._getRetryErrorDelay(undefined, retryCount)));
                return await this._getHomeDirectoryMetadata(retryCount + 1);
            }
        }
        return index.children[0]._embedded[RelType.REPO_METADATA];
    }
    /**
     * Run a cloud operation.
     * https://git.corp.adobe.com/pages/caf/api-spec/schemas/repository/operation.html
     *
     * @param ops {IOperationQuery}
     */
    async runOperation(ops) {
        var _a, _b, _c;
        const opHref = await this.getRootLink(RelType.OPS);
        const headers = {
            'Content-type': 'application/vnd.adobe.asset-operation+json'
        };
        const firstOp = Array.isArray(ops) ? ops[0] : ops;
        // If the operation is copy and SAM is configured to copy all resources
        // by default then we add the directive header in RAPI call as RAPI needs
        // this header to copy secondary resources by default.
        const copyResources = (firstOp === null || firstOp === void 0 ? void 0 : firstOp.op) === 'copy';
        copyResources && (headers['directive'] = 'ops-2021');
        // If the operation is move and the client has set the 'enable-x-bucket-move' feature flag to 'true',
        // add the enable-x-bucket-move header to the request to ensure that cross bucket moves are enabled
        // for the operation (SHARED-844). Cross-bucket moves will occur when the storage-assignee of the
        // source and destination are different.
        const moveResources = (firstOp === null || firstOp === void 0 ? void 0 : firstOp.op) === 'move';
        const featureFlags = this._core._environment.getValue('FEATURE_FLAGS');
        if (moveResources && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['enable-x-bucket-move'])) {
            headers['enable-x-bucket-move'] = 'true';
        }
        // If we send a single operation, then errors will fail the entire request.
        // If we send multiple operations, we always get a 200 and then separate error
        // codes inside the response. We want to normalize this behavior here, in order
        // to make it easier to handle the response.
        // Note that some errors are still going to return a proper array even
        // for single items, so we need to be prepared for both types of replies.
        // We are using 'any' below to disable the status code validation and allow
        // this method to handle the error codes.
        const response = await this._doPost(opHref, headers, JSON.stringify(ops), 'any');
        let result;
        try {
            result = await response.json();
        }
        catch (_d) {
            // Ignore the error here.
        }
        if (result && !Array.isArray(result) && response.status !== 200) {
            // If this was a single operation request, then sometimes the service will fail the entire request
            // instead of returning the array for the item. Try to normalize the reply to avoid bugs in the callers.
            // https://jira.corp.adobe.com/browse/ACPCSS-3613
            return [
                Object.assign(Object.assign({}, firstOp), { error: SAMError.createWithRepositoryCode(
                    // We cannot use the result.code as that uses non-standard HTTP error codes like 4041 instead of 404.
                    response.status, (_a = result.type) !== null && _a !== void 0 ? _a : ProblemType.OPERATION_FAILED, (_c = (_b = result.title) !== null && _b !== void 0 ? _b : result.message) !== null && _c !== void 0 ? _c : 'Operation failed') })
            ];
        }
        // If we don't actually get a response or if we get an array,
        // then we should expect to get a 200 response code.
        this._checkResponseStatus(response, opHref, [200]);
        if (!result) {
            // We've got a 200 status, but there's no actual result or the JSON parsing failed.
            throw SAMError.create(SAMErrorCode.UNKNOWN, 'Failed to parse response for repo bulk API.');
        }
        // Convert the result to ensure it is always an array.
        // If we have a single item, we know it cannot be an error as that was handled above already.
        const list = Array.isArray(result) ? result : [result];
        // Map errors to SAMErrors before returning.
        return list.map((item) => {
            const { error } = item;
            return Object.assign(Object.assign({}, item), { error: error ? SAMError.createWithRepositoryCode(error.status, error.type, error.title) : undefined });
        });
    }
    /**
     * Runs the runOperation API for any specific context
     * Initiate session of that context
     * Check every model operation's result and update model meta data
     * commit session
     * returns ILocalOperationResult array collected over all results collectively
     *
     * @param ops Opeartions to run
     * @param modelsById A map of model to it's id
     * @param itemPool ItemPool of the specific context used to create session
     * @param updateLocalModel for updating Model metaData
     * @param errorHandlers If needed to validate or check any specific error code, and respond differently
     */
    async runOperationsForContext(ops, modelsById, itemPool, updateLocalModel, errorHandlers) {
        var _a;
        const result = await this.runOperation(ops);
        const resultOps = { failedResults: [], newModels: [] };
        const session = itemPool.createMutationSession();
        const promises = [];
        for (const op of result) {
            const currentModel = op.id && modelsById.get(op.id);
            if (!currentModel) {
                continue;
            }
            const { asset: updatedModelMetaData, error } = op;
            if (error) {
                if (errorHandlers) {
                    const onError = (_a = (errorHandlers.find(errorHandler => errorHandler.match(error)))) === null || _a === void 0 ? void 0 : _a.action;
                    if (onError) {
                        promises.push(onError(currentModel, error).then(failedOp => {
                            if (failedOp) {
                                resultOps.failedResults.push(failedOp);
                            }
                        }));
                        continue;
                    }
                }
                resultOps.failedResults.push({ model: currentModel, error });
                continue;
            }
            try {
                const newModel = updateLocalModel(session, currentModel, updatedModelMetaData);
                if (newModel) {
                    resultOps.newModels.push(newModel);
                }
            }
            catch (error) {
                const samError = error;
                if (samError && samError.code === SAMErrorCode.UNKNOWN) {
                    resultOps.failedResults.push({ model: currentModel, error: samError });
                }
                else {
                    throw error;
                }
            }
        }
        session.commit();
        // Wait for any Promises from errorHandlers callback
        await Promise.all(promises);
        return resultOps;
    }
    /* Fetches data from the repositories endpoint.
     * These are all the repositories that contain at least one discoverable asset for this user.
     */
    async getRepositoriesData() {
        const fetchRepositories = () => this._getResponse(this.repositoryNameIndex);
        const dayInMs = 24 * 60 * 60 * 1000; //30 day expiration on cache entry
        return await this._cache.getItem(this.repositoryNameIndex, fetchRepositories, undefined, 30 * dayInMs);
    }
    async getRepositoryName(id) {
        var _a, _b;
        const response = await this.getRepositoriesData();
        if (!response) {
            return undefined;
        }
        const children = response.children;
        const data = children.find(data => data._embedded[RelType.PRIMARY]['repo:repositoryId'] === id);
        return (_b = (_a = data === null || data === void 0 ? void 0 : data._embedded[RelType.PRIMARY]['dc:title']) === null || _a === void 0 ? void 0 : _a['rdf:_1']) === null || _b === void 0 ? void 0 : _b['@value'];
    }
    async getStorageAssignee(id) {
        const response = await this.getRepositoriesData();
        const children = response.children;
        const data = children.find(data => data._embedded[RelType.PRIMARY]['repo:repositoryId'] === id);
        if (data === null || data === void 0 ? void 0 : data._embedded[RelType.PRIMARY]['storage:assignee']) {
            return data === null || data === void 0 ? void 0 : data._embedded[RelType.PRIMARY]['storage:assignee'];
        }
        else {
            return undefined;
        }
    }
    /**
     * Fetches and returns the owner details for a given list of repositoryIDs.
     * @returns A map where each key is a repositoryID and the value is an Owner object.
     */
    async getRepoOwnerMap() {
        const response = await this.getRepositoriesData();
        return new Map(response.children.map(repoData => {
            const primary = repoData._embedded[RelType.PRIMARY] || {};
            return [primary['repo:repositoryId'], primary['repo:owner']];
        }));
    }
    /* Call the Links API to get the asset links resulting in a service call instead of using local cache.
     * This is intended as an eventual replacement for resolveById which uses the local cache.
     * Fixes [SAM-3444]. NOTE: the /links API does not include the restore and discard links, but since
     * SAM.js uses the /ops API for these operations, it shouldn't be needed. Meanwhile, SAM.js
     * needs the download and block transfer links, which do not appear in the /:repometadata
     * body (they're only in the header), but do appear in the /links body.
     */
    async getAssetLinks(assetId) {
        const resolveHref = this.getAssetResolveByIdHref(assetId);
        const { _links } = await this._getResponse(resolveHref);
        return _links;
    }
    async getRepositoryLinks(repositoryID) {
        const href = this._getRepositoryHref(repositoryID);
        const { _links } = await this._getResponse(href);
        return _links;
    }
    /**
     * Creates a folder at the given path in the repository
     *
     * @param path The path to create the folder at.
     * @param repositoryID The repository id to create the folder in.
     * @param createIntermediates Whether to create intermediate folders if they don't exist.
     * @param links The repository links to use for the request. Workfront repositories can only be fetched through /index-workfront and not
     * from the /content/repo/:repositoryID endpoint.
     * @returns The created folder's repository metadata.
     */
    async createFolderByPath(path, repositoryID, createIntermediates = true, links) {
        const repositoryLinks = links !== null && links !== void 0 ? links : await this.getRepositoryLinks(repositoryID);
        const createHref = getURLFromLinks(repositoryLinks, RelType.CREATE, {
            path,
            intermediates: createIntermediates,
            respondWith: RelType.REPO_METADATA
        });
        const response = await this._doPost(createHref, {
            'Content-Type': FOLDER_TYPE
        }, undefined, [200, 201]);
        return response.json();
    }
}
__decorate([
    cache,
    __param(0, key)
], RepositoryInterface.prototype, "_getAndCacheDocument", null);
__decorate([
    cache,
    __param(0, key)
], RepositoryInterface.prototype, "_getAndCacheLinksFromHref", null);
__decorate([
    synchronized
], RepositoryInterface.prototype, "getRepositoriesData", null);
__decorate([
    cache,
    __param(0, key)
], RepositoryInterface.prototype, "getRepositoryLinks", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const ONS_FIRST_LONG_POLL_STARTED = 'firstLongPollStarted';
const ONS_FIRST_LONG_POLL_COMPLETED = 'firstLongPollCompleted';
class ONSAssetChangeEvent extends ChangeEvent {
    constructor(changedAssets) {
        super();
        this.changedAssets = changedAssets;
    }
}
class ONSFirstLongPollStartedEvent extends Event {
    constructor(cachedSubscriptionsUsed) {
        super(ONS_FIRST_LONG_POLL_STARTED);
        this.cachedSubscriptionsUsed = cachedSubscriptionsUsed;
    }
}
class ONSFirstLongPollCompletedEvent extends Event {
    constructor(expired) {
        super(ONS_FIRST_LONG_POLL_COMPLETED);
        this.expired = expired;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToISWYAdobeAssetOrderBy = {
    'name': 'asset_name',
    'created': 'create_date',
    'modified': 'modify_date',
    'shared': 'shared_date',
};
const OrderFieldToComparator$m = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    shared(a, b) {
        return compareValues(a.shared, b.shared);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    },
    modified(a, b) {
        return compareValues(a.modified, b.modified);
    }
};
class SWYAdobeAssetOrder extends createItemOrderFactory(OrderFieldToComparator$m) {
}
SWYAdobeAssetOrder.default = new SWYAdobeAssetOrder('descending', 'shared');

var SWYAdobeAssetOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    OrderFieldToISWYAdobeAssetOrderBy: OrderFieldToISWYAdobeAssetOrderBy,
    'default': SWYAdobeAssetOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class SWYAdobeAssetLoader {
    constructor(assetPool, _core, _swyInterface) {
        this._core = _core;
        this._swyInterface = _swyInterface;
        this._ussLoaderHelper = new USSLoaderHelper(assetPool, _core, this);
    }
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    async loadPage(options) {
        if (!this._libraryContext) {
            this._libraryContext = await this._core.getLibraryContext();
        }
        return this._ussLoaderHelper.loadPage(options);
    }
    /**
     * @package -- for use by USSLoaderHelper
     */
    async _getUSSResults({ start, limit, mediaTypes, excludeMediaTypes, order, resource }) {
        return this._swyInterface.getSWYAssets({
            orderBy: OrderFieldToISWYAdobeAssetOrderBy[order.field],
            orderDirection: order.direction,
            start,
            limit,
            mediaTypes,
            excludeMediaTypes,
            embedPermissions: true
        }, resource);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function updateAssetTypeForUSS(type) {
    // directories in uss contain mime type 'application/x-sharedcloud-collection+json'
    // adding it to the list if clients wants to search for directories
    if (type === null || type === void 0 ? void 0 : type.find((item) => { return item === FOLDER_TYPE; })) {
        type.push(FOLDER_ALTERNATE_TYPE);
    }
}
const EXPRESS_ARTIFACT_TYPE = 'application/vnd.adobe.hz.express+dcx';
function excludeExpressArtifacts(mediaTypes) {
    return (mediaTypes === null || mediaTypes === void 0 ? void 0 : mediaTypes.includes(EXPRESS_ARTIFACT_TYPE)) ? [] : [{
            [SearchProps.FIELD_MATCHES]: { [USS_ARTIFACT_MEDIATYPE]: EXPRESS_ARTIFACT_TYPE }
        }];
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultSBMAssetsListingOptions = {
    orderDirection: 'descending',
    orderBy: 'shared_date',
    start: 0,
    limit: 0
};
function getDirectionValue$7(userOptions) {
    const directionFlag = userOptions.orderDirection === 'ascending' ? 'asc' : 'desc';
    return directionFlag;
}
class SBMInterface extends InterfaceBase {
    async getSharedByMeAssets(parentId, options) {
        options = Object.assign(Object.assign({}, DefaultSBMAssetsListingOptions), options);
        updateAssetTypeForUSS(options.type);
        const filters = {
            hints: {
                acp_platform_v2: true,
            },
            'fetch_fields': {
                'includes': [
                    'collab_metadata$$collaborators'
                ]
            },
            'storage:assignee$$type': ['user'],
            op_none_of: [
                {
                    'app_metadata$$shell:visibility': 'hiddenSelf',
                },
            ],
            parent_id: [parentId],
            [SearchProps.TYPE]: options.type || [],
            sort_orderby: options.orderBy,
            sort_order: getDirectionValue$7(options),
            limit: options.limit,
            start_index: options.start
        };
        const response = await this._core.hostAssetContext._ussInterface.getQueryResponse(filters);
        return response;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultSWYAssetsListingOptions = {
    orderDirection: 'descending',
    orderBy: 'shared_date',
    start: 0,
    limit: 0,
    mediaTypes: [],
    excludeMediaTypes: [],
};
function getDirectionValue$6(userOptions) {
    const directionFlag = userOptions.orderDirection === 'ascending' ? 'asc' : 'desc';
    return directionFlag;
}
class SWYInterface extends InterfaceBase {
    async getSWYAssets(options, resource) {
        options = Object.assign(Object.assign({}, DefaultSWYAssetsListingOptions), options);
        updateAssetTypeForUSS(options.mediaTypes);
        options.excludeMediaTypes = [...new Set(options.excludeMediaTypes.concat(FOLDER_TYPE))];
        updateAssetTypeForUSS(options.excludeMediaTypes);
        const filters = {
            shared_via_invite: true,
            hints: {
                acp_platform_v2: true,
            },
            fetch_fields: { includes: getUSSFetchFields() },
            op_none_of: [
                {
                    op_field_exists: [
                        'app_metadata$$cc:inheritable$$cc:team$$repo:assetId',
                        // for excluding the older spaces and its children
                        // We would want to show project children, but not projects themselves in swy
                        'app_metadata$$cc:inherited$$cc:space$$repo:assetId',
                        'app_metadata$$cc:inheritable$$cc:space$$repo:assetId'
                    ],
                },
                {
                    [SearchProps.VISIBILITY]: ['hiddenSelf', 'hiddenRecursive'],
                },
                {
                    [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: 'appdata',
                },
                {
                    [SearchProps.TYPE]: options.excludeMediaTypes || [],
                },
                {
                    [SearchProps.STORAGE_ASSIGNEE_ID]: this._core._environment.getValue('USER_ID'),
                },
                ...excludeExpressArtifacts(options.mediaTypes),
            ],
            [SearchProps.TYPE]: options.mediaTypes || [],
            sort_orderby: options.orderBy,
            sort_order: getDirectionValue$6(options),
            limit: options.limit,
            start_index: options.start,
        };
        if (options.embedPermissions) {
            filters.fetch_fields.includes.push('_embedded');
        }
        const response = await this._core.hostAssetContext._ussInterface.getQueryResponse(filters, resource);
        return response;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultAssetsListingSearchOptions = {
    orderDirection: 'descending',
    orderBy: 'modify_date',
    start: 0,
    limit: 0
};
function getDirectionValue$5(userOptions) {
    const directionFlag = userOptions.orderDirection === 'ascending' ? 'asc' : 'desc';
    return directionFlag;
}
class AdobeAssetSearchInterface extends InterfaceBase {
    async getFilteredAssets(options) {
        options = Object.assign(Object.assign({}, DefaultAssetsListingSearchOptions), options);
        updateAssetTypeForUSS(options.mediaTypes);
        updateAssetTypeForUSS(options.excludeMediaTypes);
        const filters = Object.assign(Object.assign(Object.assign({ hints: {
                acp_platform_v2: true,
            }, fetch_fields: { includes: getUSSFetchFields() }, [SearchProps.STORAGE_ASSIGNEE_TYPE]: ['user'], op_none_of: [
                {
                    op_field_exists: [
                        'app_metadata$$cc:inheritable$$cc:team$$repo:assetId',
                        'app_metadata$$cc:inherited$$cc:team$$repo:assetId',
                    ],
                },
                {
                    [SearchProps.VISIBILITY]: ['hiddenSelf', 'hiddenRecursive'],
                },
                {
                    [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: 'appdata',
                },
                {
                    [SearchProps.TYPE]: options.excludeMediaTypes || [],
                },
            ] }, (options.assetId ? Object.assign({}, options.deepSearch ? { container: { 'asset_id': [options.assetId] } }
            : { parent_id: [options.assetId] }) : {})), { [SearchProps.TYPE]: options.mediaTypes || [], sort_orderby: options.orderBy, sort_order: getDirectionValue$5(options), limit: options.limit, start_index: options.start }), (options.query ? { q: options.query } : {}));
        const userId = options.userId;
        const uploadedFrom = options.uploadedFrom;
        if (userId) {
            filters.op_and = filters.op_and || [];
            filters.op_and.push({
                [SearchProps.STORAGE_ASSIGNEE_ID]: userId
            });
        }
        if (uploadedFrom) {
            filters.op_and = filters.op_and || [];
            filters.op_and.push({
                [SearchProps.CREATED_FROM_UPLOAD]: true
            });
            if (Array.isArray(uploadedFrom)) {
                const op_or = uploadedFrom.map((clientId) => {
                    return { [SearchProps.CREATED_BY_CLIENT_ID]: clientId };
                });
                filters.op_and.push({ [SearchProps.OP_OR]: op_or });
            }
        }
        const response = await this._core.hostAssetContext._ussInterface.getQueryResponse(filters);
        return response;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultAssetsListingGlobalSearchOptions = {
    orderDirection: 'descending',
    orderBy: 'modify_date',
    start: 0,
    limit: 0
};
function getDirectionValue$4(userOptions) {
    const directionFlag = userOptions.orderDirection === 'ascending' ? 'asc' : 'desc';
    return directionFlag;
}
class AdobeAssetGlobalSearchInterface extends InterfaceBase {
    /**
     * @TODO We should open this up to allow clients to configure the resctrictions
     * on this query through a filter.
     * https://jira.corp.adobe.com/browse/SAM-2542
     */
    async getFilteredAssets(options) {
        options = Object.assign(Object.assign({}, DefaultAssetsListingGlobalSearchOptions), options);
        updateAssetTypeForUSS(options.mediaTypes);
        updateAssetTypeForUSS(options.excludeMediaTypes);
        const filters = Object.assign({ hints: {
                acp_platform_v2: true,
            }, fetch_fields: { includes: getUSSFetchFields() }, [SearchProps.STORAGE_ASSIGNEE_TYPE]: ['user'], op_none_of: [
                {
                    op_field_exists: [
                        // for excluding the older spaces and its children
                        // We would want to show project and its children in global search
                        'app_metadata$$cc:inheritable$$cc:space$$repo:assetId',
                        'app_metadata$$cc:inherited$$cc:space$$repo:assetId',
                    ],
                },
                {
                    [SearchProps.VISIBILITY]: ['hiddenSelf', 'hiddenRecursive'],
                },
                {
                    [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: 'appdata',
                },
                {
                    [SearchProps.TYPE]: options.excludeMediaTypes || [],
                },
            ], op_or: [
                // TODO: Update _getItemData in AdobeAssetGlobalSearchLoader if we support Global
                // search loader to show other items as well. For e.g. projects
                {
                    [SearchProps.STORAGE_ASSIGNEE_ID]: this._core._environment.getValue('USER_ID')
                },
                {
                    [SearchProps.SHARED_VIA_INVITE]: true
                }
            ], [SearchProps.TYPE]: options.mediaTypes || [], sort_orderby: options.orderBy, sort_order: getDirectionValue$4(options), limit: options.limit, start_index: options.start }, (options.query ? { q: options.query } : {}));
        if (options.embedPermissions) {
            filters.fetch_fields.includes.push('_embedded');
        }
        const response = await this._core.hostAssetContext._ussInterface.getQueryResponse(filters);
        return response;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultRecentAssetsListingOptions = {
    start: 0,
    limit: 0,
    mediaTypes: [],
    excludeMediaTypes: [],
};
class RecentInterface extends InterfaceBase {
    _getCommonFilters(options) {
        options = Object.assign(Object.assign({}, DefaultRecentAssetsListingOptions), options);
        const { uploadedFrom } = options !== null && options !== void 0 ? options : {};
        updateAssetTypeForUSS(options.mediaTypes);
        updateAssetTypeForUSS(options.excludeMediaTypes);
        // Folders should never be included in Recents listing
        options.excludeMediaTypes = Array.from(new Set(['application/x-sharedcloud-collection+json', ...(options.excludeMediaTypes || [])]));
        const filters = {
            hints: {
                acp_platform_v2: true,
            },
            fetch_fields: { includes: getUSSFetchFields() },
            sort_order: 'desc',
            limit: options.limit,
            start_index: options.start,
            [SearchProps.TYPE]: options.mediaTypes || [],
            op_none_of: [
                {
                    [SearchProps.FIELD_EXISTS]: [
                        // for excluding the older spaces and its children
                        'app_metadata$$cc:inheritable$$cc:space$$repo:assetId',
                        'app_metadata$$cc:inherited$$cc:space$$repo:assetId',
                        // for excluding only the projects
                        'app_metadata$$cc:inheritable$$cc:team$$repo:assetId',
                    ],
                },
                {
                    [SearchProps.VISIBILITY]: ['hiddenSelf', 'hiddenRecursive'],
                },
                {
                    [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: ['appdata'],
                },
                {
                    [SearchProps.TYPE]: options.excludeMediaTypes || [],
                },
                {
                    // For excluding legacy artifacts.
                    [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: 'pubs'
                },
                {
                    // For excluding more modern artifacts.
                    [SearchProps.OP_AND]: [
                        {
                            [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: 'cloud-content'
                        },
                        {
                            [SearchProps.FIELD_EXISTS]: ['app_metadata$$review:sourceAsset$$dc:format']
                        }
                    ],
                }
            ],
        };
        if (options.embedPermissions) {
            filters.fetch_fields.includes.push('_embedded');
        }
        if (uploadedFrom) {
            filters.op_and = [];
            filters.op_and.push({
                [SearchProps.CREATED_FROM_UPLOAD]: true
            });
        }
        if (uploadedFrom && Array.isArray(uploadedFrom)) {
            const length = filters.op_and.push({
                [SearchProps.OP_OR]: []
            });
            uploadedFrom.forEach((value) => {
                const filter = filters.op_and[length - 1];
                filter[SearchProps.OP_OR].push({
                    [SearchProps.CREATED_BY_CLIENT_ID]: value
                });
            });
        }
        if (uploadedFrom && !Array.isArray(uploadedFrom) && uploadedFrom !== 'ALL') {
            filters.op_and.push({
                [SearchProps.CREATED_BY_CLIENT_ID]: uploadedFrom
            });
        }
        return filters;
    }
    async getRecentAssets(options) {
        const filters = this._getCommonFilters(options);
        const { userId } = options !== null && options !== void 0 ? options : {};
        // should not give order given by client in this request
        // because Recent assets mean descending direction of modified date
        filters.sort_orderby = 'modify_date';
        const storageAssigneeQuery = {
            [SearchProps.STORAGE_ASSIGNEE_ID]: userId !== null && userId !== void 0 ? userId : this._core._environment.getValue('USER_ID')
        };
        // If the userId is present we want to add this to the and
        // operation of the query.
        if (userId) {
            if (!filters.op_and) {
                filters.op_and = [];
            }
            filters.op_and.push(storageAssigneeQuery);
        }
        else {
            // If the userId is present then we don't want to include the
            // SHARED_VIA_INVITED as well since that will include results that are not
            // equal to the userId provided.
            if (!filters.op_or) {
                filters.op_or = [];
            }
            filters.op_or.push(storageAssigneeQuery);
            filters.op_or.push({
                [SearchProps.SHARED_VIA_INVITE]: true
            });
        }
        const response = await this._core.hostAssetContext._ussInterface.getQueryResponse(filters);
        return response;
    }
    async getMRUAssets(options) {
        const filters = this._getCommonFilters(options);
        filters.fetch_fields.includes.push(LastAccessedOrderField);
        const { userId } = options !== null && options !== void 0 ? options : {};
        if (userId) {
            if (!filters.op_and) {
                filters.op_and = [];
            }
            filters.op_and.push({
                [SearchProps.STORAGE_ASSIGNEE_ID]: userId
            });
        }
        // should not give order given by client in this request
        // because Recent assets mean descending direction of last accessed date
        filters.sort_orderby = LastAccessedOrderField;
        filters.op_field_exists = [LastAccessedOrderField];
        const response = await this._core.hostAssetContext._ussInterface.getQueryResponse(filters);
        return response;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AssetTransferInterface extends InterfaceBase {
    async transfer(data) {
        const links = await this.discoverLinks();
        const response = await this._doPost(getURLFromLinks(links, RelType.ATS_MOVE), { 'Content-Type': 'application/json' }, JSON.stringify(data), [200]);
        // Asset Transfer Service will return a 200 response when a dependent service fails.
        const json = await response.json();
        if (json.status && json.status !== 200) {
            throw SAMError.createWithResponse(response);
        }
        // Returns the transferred asset's Cloud ID.
        return json.assetId;
    }
    async discoverLinks() {
        const response = await this._getResponse(this.getUrl('/'));
        return response._links;
    }
    getUrl(endpoint) {
        return `https://${this._core._environment.endpoints.TRANSFER_SERVICE_HOST}${endpoint}`;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class RecentAdobeAssetLoader {
    constructor(assetPool, _core, _recentInterface, _implicitFilter) {
        this._core = _core;
        this._recentInterface = _recentInterface;
        this._implicitFilter = _implicitFilter;
        this._ussLoaderHelper = new USSLoaderHelper(assetPool, _core, this);
    }
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    async loadPage(options) {
        if (!this._libraryContext) {
            this._libraryContext = await this._core.getLibraryContext();
        }
        return this._ussLoaderHelper.loadPage(options);
    }
    /**
     * @package -- only for use by USSLoaderHelper
     */
    async _getUSSResults({ start, limit, mediaTypes, excludeMediaTypes, filter }) {
        const options = {
            start,
            limit,
            mediaTypes,
            excludeMediaTypes,
            embedPermissions: true
        };
        if (filter.name === USSAssetFilterName) {
            const ussFilter = filter;
            options.userId = ussFilter.userId;
            options.uploadedFrom = ussFilter.uploadedFrom;
        }
        return this._recentInterface.getRecentAssets(options);
    }
    /**
     * @package -- only for use by USSLoaderHelper
     */
    _postProcessPage(loaderOptions, page) {
        const { items } = page;
        // update modification time of last asset on implicit filter (assets are already sorted by modification time),
        // so that these items can be matched with this filter in ItemLoaderState before adding them in ItemLoaderState._pages
        if (items.length) {
            this._implicitFilter._lastModificationDate = items[items.length - 1].modified;
        }
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class RecentAdobeAssetFilter extends ImplicitAdobeAssetFilterBase {
    constructor() {
        super({ _isSharedWithYou: true });
    }
    matches(item) {
        // We don't want folders to match the Recents filter
        if (item.isFolder) {
            return false;
        }
        if (this._lastModificationDate && item.modified < this._lastModificationDate) {
            return false;
        }
        return super.matches(item);
    }
}

var RecentAdobeAssetFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': RecentAdobeAssetFilter
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Used by batch operations to retry failed ops and rename the conflicted assets
 * @param resultOps result for batch operation. Contains failed results and new models.
 * @param destination target asset location where the source assets are moved/copied
 * @param assetRenameMap allows renaming of assets in the batch operation
 * @param conflictMap saves the newName and count used for all files in batch
 * @param conflictRetryOp the original batch op method that is called after renaming conflicted assets
 * @returns the result for batch operation after retrying for failed assets.
 */
async function retryFailedOpsDueToConflict(resultOps, destination, assetRenameMap, conflictMap, conflictRetryOp) {
    const failedAssetsDueToConflict = [];
    const otherFailedOps = [];
    resultOps.failedResults.forEach((failedOp) => {
        if (failedOp.error.code === SAMErrorCode.CONFLICT) {
            failedAssetsDueToConflict.push(failedOp.model);
        }
        else {
            otherFailedOps.push(failedOp);
        }
    });
    if (failedAssetsDueToConflict.length) {
        for (const [key, value] of conflictMap) {
            conflictMap.set(key, { newName: value.newName, countUsed: value.countUsed + 1 });
        }
        const newResultOps = await conflictRetryOp(failedAssetsDueToConflict, destination, assetRenameMap, true, conflictMap);
        newResultOps.failedResults = [...newResultOps.failedResults, ...otherFailedOps];
        newResultOps.newModels = [...newResultOps.newModels, ...resultOps.newModels];
        return newResultOps;
    }
    return resultOps;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class MRUAdobeAssetLoader {
    constructor(assetPool, _core, _recentInterface) {
        this._recentInterface = _recentInterface;
        this._ussLoaderHelper = new USSLoaderHelper(assetPool, _core, this);
    }
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    async loadPage(options) {
        return this._ussLoaderHelper.loadPage(options);
    }
    /**
     * @package -- only for use by USSLoaderHelper
     */
    async _getUSSResults({ start, limit, mediaTypes, excludeMediaTypes }) {
        return this._recentInterface.getMRUAssets({
            start,
            limit,
            mediaTypes,
            excludeMediaTypes,
            embedPermissions: true
        });
    }
}

class MRUAdobeAssetFilter extends ImplicitAdobeAssetFilterBase {
    constructor() {
        super({ _isSharedWithYou: true });
    }
    matches(item) {
        // We don't want folders to match the Recents filter
        if (item.isFolder) {
            return false;
        }
        // do we need to allow certain items up to a threshold in the MRU list
        // as we do in the recents list by keeping record of lastModified
        if (item.lastAccessed === undefined) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const LIBRARY_DATA_CHANGED = 'library_data_changed';
class LibraryDataChangedEvent extends SAMEvent {
    constructor() {
        super(LIBRARY_DATA_CHANGED);
    }
}
const LibraryDataChangedEventInstance = new LibraryDataChangedEvent();

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2024 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
const RESTRICT_EDIT_CHANGED = 'restrict_edit_changed';
class RestrictEditChangedEvent extends SAMEvent {
    constructor() {
        super(RESTRICT_EDIT_CHANGED);
    }
}
const RestrictEditChangedEventInstance = new RestrictEditChangedEvent();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const IMG_TILE_SIZE = 200;
class RenditionTile extends TypedEventEmitter {
    constructor(data, index, _library) {
        super();
        this._library = _library;
        /**
         * @package -- for use in SAM.js only
         */
        this._index = -1;
        this._core = this._library._core;
        this.type = data.type;
        this._index = index;
        if (this.type === 'href') {
            // Only image renditions have _renditionUrl.
            this._renditionUrl = data.rendition;
            // Only image renditions need a _renditionFetcher.
            this._renditionFetcher = new RenditionFetcher(this._core, [IMG_TILE_SIZE], async () => {
                return this._library._libraryInterface.getRenditionTileImage(this._renditionUrl);
            });
            // Forward change events from the rendition fetcher
            // to this class (to catch the event from the fetcher).
            this._renditionFetcher.on('change', () => {
                this.dispatch({ type: 'change' });
            });
        }
        else {
            // Only non-image renditions have _renditionData and a mimetype.
            this._renditionData = data.rendition;
            this.mimetype = data.rendition_mimetype;
        }
        this.elementId = data.elementId;
        this.elementType = data.elementType;
    }
    /**
     * Returns a blob url of an image based rendition. Returns an empty string while loading, and will
     * notify observers when the image is done loading and the blobURL is ready.
     * @example
     * imageUrl only applies to image renditions.
     * if (tile.type === 'href') return <img src={tile.imageUrl} />;
     */
    get imageUrl() {
        if (this.type !== 'href') {
            throw SAMError.create(SAMErrorCode.UNKNOWN, 'Cannot fetch rendition for non-image renditions');
        }
        return this._renditionFetcher.getURL(IMG_TILE_SIZE, RenditionType.PNG, this._renditionUrl);
    }
    /**
     * Returns the rendition object for non-image based renditions (only applies to non-image renditions).
     * @example
     * if (tile.type !== 'href') return <div>{tile.data} </div>;
     */
    get data() {
        if (this.type !== 'href') {
            if (typeof this._renditionData === 'object') {
                return this._renditionData;
            }
            console.warn('Rendition data is not an object, returning default value.');
            return {};
        }
        else {
            throw SAMError.create(SAMErrorCode.UNKNOWN, 'Cannot get data for image renditions');
        }
    }
    /**
     * Returns one of the enumeration values of RenditionStatus.
     *
     * @returns {RenditionStatus}
     */
    get imageStatus() {
        return this._renditionFetcher.renditionURLStatus(IMG_TILE_SIZE, RenditionType.PNG, this._renditionUrl);
    }
    /**
     * For use internally to release renditions after
     * the asset has been deleted permanently.
     * @package
     */
    _releaseRenditions() {
        if (this._renditionFetcher) {
            this._renditionFetcher.release();
        }
    }
}
__decorate([
    observable$1
], RenditionTile.prototype, "imageUrl", null);
__decorate([
    observable$1
], RenditionTile.prototype, "imageStatus", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CustomModelInterface$1 extends InterfaceBase {
    _getMelvilleUrl(endpoint) {
        return `https://${this._core._environment.endpoints.MELVILLE_HOST}${endpoint}`;
    }
    /**
   * Fetches the list of custom models based on the options provided
   * @returns the list of custom models along with the page information and links to the next page
   */
    async getCustomModels(queryParams) {
        if ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.limit) && (queryParams === null || queryParams === void 0 ? void 0 : queryParams.start) === undefined) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, '[Melville] If limit is provided, start must also be provided.');
        }
        queryParams = sortParameters(queryParams);
        const urlWithQueryParams = fillURLTemplate$1(this._getMelvilleUrl('/api/v1/custom-models'), queryParams);
        // Pass as many parameters as headers as we can, to avoid extra CORS preflight OPTIONS requests per url.
        const [url, headers] = moveUrlQueryParamsToHeaders(urlWithQueryParams);
        // Ensure browser doesn't automatically add If-None-Match, otherwise
        // service may respond with cached data for a library
        const defaultHeaders = { ['Cache-Control']: 'no-cache, no-store, max-age=0' };
        const finalHeaders = Object.assign(Object.assign({}, defaultHeaders), headers);
        return await this._getResponse(url, { headers: finalHeaders });
    }
    /**
     * Fetches one custom model by ID
     *
     * @param customModelId ID of custom model to be fetched
     * @returns the custom model
     */
    async getCustomModelById(customModelId) {
        return await this._getResponse(this._getMelvilleUrl(`/api/v1/custom-models/${customModelId}`), { headers: { 'Content-Type': 'application/json' } });
    }
    /**
   * @package -- only for use in SAM.js
   * Fetches the next page of custom models from Melville
   * @returns a list of custom models along with page information and links to the next page
   */
    async getCustomModelsUsingPageLink(pageLink) {
        const [url, headers] = moveUrlQueryParamsToHeaders(this._getMelvilleUrl(pageLink.href));
        return this._getResponse(url, { headers });
    }
    /**
   * Create a training set to be used with a custom model. The training set is considered a child of the parent asset
   * specified by the parentAssetId.
   */
    async createTrainingSet(options) {
        // check for values under the deprecated firefly#ffmodel key
        const cmeOptions = options['firefly#cme'] || options['firefly#ffmodel'];
        if (!options.name) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid argument: missing required name');
        }
        if (!options.projectId) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid argument: missing required projectId. The parent must be a project');
        }
        if (!cmeOptions.schemaVersion) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid argument: missing required schemaVersion.');
        }
        if (!cmeOptions.trainingMode) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid argument: missing required trainingMode.');
        }
        const creationOptions = {
            name: options.name,
            parent_assetId: options.projectId,
            roles: [{
                    type: 'cm_training_set'
                }],
            'firefly#cme': Object.assign(Object.assign({}, cmeOptions), { 
                // Melville is temporarily looking at version, but will soon switch to schemaVersion
                version: cmeOptions.schemaVersion })
        };
        const libraryContext = await this._core.getLibraryContext();
        return libraryContext._createLibrary(creationOptions);
    }
    async getTrainingSetById(assetId) {
        const libraryContext = await this._core.getLibraryContext();
        return libraryContext._getLibraryRemotely(assetId, { selectors: ['details'] });
    }
    async createCustomModel(options) {
        const endpoint = `/api/v1/custom-models`;
        const response = await this._doPost(this._getMelvilleUrl(endpoint), { 'Content-Type': 'application/json' }, JSON.stringify(options), [201]);
        return response.json();
    }
    async updateCustomModel(assetId, options) {
        const endpoint = `/api/v1/custom-models/${assetId}`;
        await this._doPut(this._getMelvilleUrl(endpoint), { 'Content-Type': 'application/json' }, JSON.stringify(options), [204, 201, 200]);
    }
    async deleteCustomModel(assetId) {
        const endpoint = `/api/v1/custom-models/${assetId}`;
        await this._doDelete(this._getMelvilleUrl(endpoint), { 'Content-Type': 'application/json' }, [204]);
    }
    async discardCustomModel(assetId) {
        await this._doPost(this._getMelvilleUrl(`/api/v1/custom-models/${assetId}/discard`), { 'Content-Type': 'application/json' }, '', [204]);
    }
    async restoreCustomModel(assetId) {
        await this._doPost(this._getMelvilleUrl(`/api/v1/custom-models/${assetId}/restore`), { 'Content-Type': 'application/json' }, '', [204]);
    }
    async publish(assetID) {
        const endpoint = `/api/v1/custom-models/${assetID}/publish`;
        const response = await this._doPost(this._getMelvilleUrl(endpoint), undefined, undefined, [200]);
        return await response.json();
    }
    async unpublish(assetID) {
        const endpoint = `/api/v1/custom-models/${assetID}/unpublish`;
        const response = await this._doPost(this._getMelvilleUrl(endpoint), undefined, undefined, [200]);
        return await response.json();
    }
}
// Sort parameters so that the query string is stable, preventing unnecessary cache misses.
const sortParameters = (parameters) => {
    return Object.fromEntries(Object.entries(parameters)
        .map(([key, value]) => {
        if (Array.isArray(value)) {
            return [key, value.sort()];
        }
        return [key, value];
    })
        .sort());
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Finds the last "." in a string and removes it and everything after.
 * Used to strip the file extension from repo:name on custom model.
 *
 * @example <caption>Trim "My Model.ffmodel"</caption>
 * trimRepoName("My Model.ffmodel"); // returns "My Model"
 *
 * @param s {string} name to be stripped
 * @return {string} name stripped of its' extension
 */
const trimRepoName = (s) => {
    const index = s.lastIndexOf('.');
    return s.slice(0, index);
};
function isCustomModel(asset) {
    return asset.isCustomModel;
}
function getCustomModelPermission(value) {
    if (value.asset_acl !== undefined) {
        return parseEffectivePermissions(value.asset_acl);
    }
    // If asset_acl is not present then return NotFound
    return NotFound;
}
class CustomModel extends AdobeAsset {
    constructor(_core, id, metadata) {
        super(_core, id, metadata);
        this._core = _core;
        this.isCustomModel = true;
        this._displayName = '';
        this._conceptId = '';
        this._trainingMode = '';
        this._compression = '';
        this._schemaVersion = '';
        this._customModelInterface = new CustomModelInterface$1(this._core);
    }
    async trainingSet() {
        const libraryContext = await this._core.getLibraryContext();
        return await libraryContext.getLibraryByAssetId(this.trainingSetInfo.id);
    }
    /**
     * Deletes a custom model by its ID.
     * Will first check the local asset pool for the custom model to decide if we need to update the
     * local asset pool.
     */
    async permanentlyDelete() {
        await this._customModelInterface.deleteCustomModel(this.id);
        const assetPool = this._core.hostAssetContext._assetPool;
        const session = assetPool.createUpdateSession('Delete Custom Model');
        session.queueDiscardedItem(this);
        session.commit(); // fire notifications for tracked changes
        // The session doesn't actually remove the item from the pool
        assetPool.removeLocalItems([this.id]);
    }
    /**
     * Discard the custom model through melville.
     * This changes its repo:state to DISCARDED, but it can later be restored or permanently deleted.
     */
    async discard() {
        if (this.isDiscarded) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Asset is already discarded');
        }
        await this._customModelInterface.discardCustomModel(this.id);
        const customModelContext = await this._core.getCustomModelContext();
        const session = customModelContext._assetPool.createUpdateSession('discard custom model'); // tracks changes to the asset
        // Update the local item with values from the remote item
        const assetContext = await this._core.getAssetContext();
        assetContext._adobeAssetUpdater.updateLocalItem(session, this, { 'repo:state': 'DISCARDED' });
        session.commit(); // fire notifications for tracked changes
    }
    async restore() {
        if (!this.isDiscarded) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Cannot restore an asset that is not discarded');
        }
        const assetContext = await this._core.getAssetContext();
        await this._customModelInterface.restoreCustomModel(this.id);
        const assetPool = this._core._getAssetPool();
        const session = assetPool.createUpdateSession('restore custom model');
        assetContext._adobeAssetUpdater.updateLocalItem(session, this, { 'repo:state': 'ACTIVE' });
        session.commit();
    }
    async publish() {
        if (this.publishedState === 'published') {
            return;
        }
        const customModelData = await this._customModelInterface.publish(this.id);
        const customModelContext = await this._core.getCustomModelContext();
        const session = customModelContext._assetPool.createUpdateSession();
        customModelContext._customModelUpdaterMelville.updateRemoteItem(session, customModelData);
        session.commit();
        return;
    }
    async unpublish() {
        if (this.publishedState === 'unpublished') {
            return;
        }
        const customModelData = await this._customModelInterface.unpublish(this.id);
        const customModelContext = await this._core.getCustomModelContext();
        const session = customModelContext._assetPool.createUpdateSession();
        customModelContext._customModelUpdaterMelville.updateRemoteItem(session, customModelData);
        session.commit();
        return;
    }
    get displayName() {
        return this._displayName;
    }
    get inferenceReady() {
        return this.appMetadata.data['cme:inferenceReady'];
    }
    get publishedState() {
        return this.appMetadata.data['cme:publishedState'];
    }
    get category() {
        return this.appMetadata.data['cme:category'];
    }
    get signature() {
        return this.appMetadata.data['cme:signature'];
    }
    get baseModelName() {
        var _a;
        return (_a = this.appMetadata.data['cme:baseModel']) === null || _a === void 0 ? void 0 : _a['name'];
    }
    get baseModelVersion() {
        var _a;
        return (_a = this.appMetadata.data['cme:baseModel']) === null || _a === void 0 ? void 0 : _a['version'];
    }
    /**
   * Information related to the status of the training process for the Custom Model.
   */
    get trainingInfo() {
        return {
            trainingState: this.appMetadata.data['cme:training']['state'],
            progress: this.appMetadata.data['cme:training']['progress'],
            jobId: this.appMetadata.data['cme:training']['jobId'],
            errorMessage: this.appMetadata.data['cme:training']['errorMessage'],
            errorCode: this.appMetadata.data['cme:training']['errorCode'],
            links: this.appMetadata.data['cme:training']['links']
        };
    }
    /**
   * The ID and Version of the Training Set this Custom Model was trained from.
   */
    get trainingSetInfo() {
        return { id: this.appMetadata.data['cme:trainingSet']['repo:assetId'], version: this.appMetadata.data['cme:trainingSet']['repo:version'] };
    }
    get samplePrompt() {
        return this.appMetadata.data['cme:samplePrompt'];
    }
    get renditionUrl() {
        return super.getRenditionURL(THUMBNAIL_SIZE);
    }
    get conceptId() {
        return this._conceptId;
    }
    get trainingMode() {
        return this._trainingMode;
    }
    get baseModelSuperclass() {
        return this._baseModelSuperclass;
    }
    get deltaWeightsID() {
        return this._deltaWeightsID;
    }
    get contentType() {
        return this._contentType;
    }
    get compression() {
        return this._compression;
    }
    get schemaVersion() {
        return this._schemaVersion;
    }
    /* This is a heuristic.  It does not definitively give information about who is or isn't a generator for this custom model
     * However, given the default way we assign permissions, it's correct until we start adding new features to custom models
     * So this is what we're using for the sake of performance until we come up with something better.
     * Used in the dashboard source to determine which models we should show.
     */
    /** @package -- for use in SAM.js only */
    get hasDefaultGeneratorPermissions() {
        return this.hasPermission(Permission.Read)
            && !this.hasPermission(Permission.Write)
            && !this.hasPermission(Permission.WriteComment);
    }
    /**
     * Updates the Custom Model with the provided options.
     *
     * @param options CustomModelUpdateInfoMelville
     * @throws {SAMErrorCode.UNSUPPORTED}
     * @returns Promise<void>
     */
    async update(options) {
        const unsupportedKeys = Object.keys(options)
            .filter(key => CUSTOM_MODEL_RESTRICTED_METADATA_KEYS.includes(key));
        if (unsupportedKeys.length) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, `Update keys are unsupported: [${unsupportedKeys}]. Use CustomModel.patchAppMetadata`);
        }
        const context = await this._core.getCustomModelContext();
        await context.updateCustomModel(this.id, options);
    }
    /**
     * For exceptions that CustomModel.update doesn't cover,
     * this method can be used to update the application metadata directly.
     *
     * @param patches CustomModelAppMetadataPatch[]
     * @throws {SAMErrorCode.UNSUPPORTED}
     * @returns Promise<void>
     */
    patchAppMetadata(patches) {
        const unsupportedPatches = patches.map(patch => patch.path)
            .filter((path) => !CUSTOM_MODEL_RESTRICTED_METADATA_KEYS.includes(path.substring(1)));
        if (unsupportedPatches.length) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, `Patch paths are unsupported: [${unsupportedPatches}]. Use "CustomModel.update"`);
        }
        return super.patchAppMetadata(patches);
    }
}
__decorate([
    memoize$1,
    observable$1
], CustomModel.prototype, "trainingSet", null);
__decorate([
    observable$1
], CustomModel.prototype, "displayName", null);
__decorate([
    observable$1
], CustomModel.prototype, "inferenceReady", null);
__decorate([
    observable$1
], CustomModel.prototype, "publishedState", null);
__decorate([
    observable$1
], CustomModel.prototype, "category", null);
__decorate([
    observable$1
], CustomModel.prototype, "baseModelName", null);
__decorate([
    observable$1
], CustomModel.prototype, "baseModelVersion", null);
__decorate([
    observable$1
], CustomModel.prototype, "trainingInfo", null);
__decorate([
    observable$1
], CustomModel.prototype, "trainingSetInfo", null);
__decorate([
    observable$1
], CustomModel.prototype, "samplePrompt", null);
__decorate([
    observable$1
], CustomModel.prototype, "renditionUrl", null);
__decorate([
    observable$1
], CustomModel.prototype, "conceptId", null);
__decorate([
    observable$1
], CustomModel.prototype, "trainingMode", null);
__decorate([
    observable$1
], CustomModel.prototype, "deltaWeightsID", null);
__decorate([
    observable$1
], CustomModel.prototype, "contentType", null);
__decorate([
    observable$1
], CustomModel.prototype, "compression", null);
__decorate([
    observable$1
], CustomModel.prototype, "schemaVersion", null);
const CustomModelUpdaterMelville = new ItemUpdater({
    localItemType: CustomModel,
    remoteIdProperty: 'repo:assetId',
    propertyUpdater: new PropertyUpdater({
        '_appMetadata._data': {
            name: 'application_metadata',
            format: 'object_subset',
            set: (parsedSource, dest) => {
                const asset = dest;
                asset.appMetadata._mergeData(parsedSource);
            }
        },
        '_displayName': { name: 'repo:name', format: { parse: trimRepoName, isEqual: isStrictEqual } },
        '_conceptId': { name: 'firefly#ffmodel', format: { parse: (ffmodel) => ffmodel.conceptId, isEqual: isStrictEqual } },
        '_contentType': { name: 'firefly#ffmodel', format: { parse: (ffmodel) => ffmodel.contentType, isEqual: isStrictEqual } },
        '_trainingMode': { name: 'firefly#ffmodel', format: { parse: (ffmodel) => ffmodel.trainingMode, isEqual: isStrictEqual } },
        '_baseModelSuperclass': { name: 'firefly#ffmodel', format: { parse: (ffmodel) => ffmodel.baseModelSuperclass, isEqual: isStrictEqual } },
        '_deltaWeightsID': { name: 'firefly#ffmodel', format: { parse: (ffmodel) => ffmodel.deltaWeightsID, isEqual: isStrictEqual } },
        '_compression': { name: 'firefly#ffmodel', format: { parse: (ffmodel) => ffmodel.compression, isEqual: isStrictEqual } },
        '_permissions': { get: getCustomModelPermission, format: 'number' },
        '_schemaVersion': { name: 'firefly#ffmodel', format: { parse: (ffmodel) => ffmodel.schemaVersion, isEqual: isStrictEqual } },
        __links: { name: '_links', format: 'object' },
        _name: 'repo:name',
        _path: 'repo:path',
        _created: { name: 'repo:createDate', format: 'date_as_number' },
        _modified: { name: 'repo:modifyDate', format: 'date_as_number' },
        _createdBy: 'repo:createdBy',
        _version: 'version',
        _etag: 'repo:etag',
        _storageRegion: 'storage:region',
        _size: { name: 'repo:size', format: 'number' },
    }),
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ImplicitCustomModelFilter$1 extends ImplicitAdobeAssetFilterBase {
    constructor(options = {}) {
        const { trainingSetId, generatorOnly } = options, superOptions = __rest$2(options, ["trainingSetId", "generatorOnly"]);
        super(superOptions);
        this._trainingSetId = trainingSetId;
        this._generatorOnly = generatorOnly;
    }
    matches(item) {
        if (!isCustomModel(item)) {
            return false;
        }
        if (this._trainingSetId && this._trainingSetId !== item.trainingSetInfo.id) {
            return false;
        }
        if (this._generatorOnly && !item.hasDefaultGeneratorPermissions) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class TrainingSetCustomModelLoader {
    constructor(_assetPool, _core, _libraryId) {
        this._assetPool = _assetPool;
        this._core = _core;
        this._libraryId = _libraryId;
    }
    async loadPage() {
        return await this._loadPage();
    }
    async _loadPage() {
        // Fetch the training set library to make sure we have the latest list of custom models
        // and update the asset pool
        // Note: Libraries listings from Melville are considered "USS" sources (with the current exception of a public libraries-only listing),
        // and may have stale data. Which is why we use `createLoaderUpdateSession`, not `createLoaderMutationSession`.
        const libraryContext = await this._core.getLibraryContext();
        const trainingSetLibraryData = await libraryContext._libraryInterface.getLibraryData(this._libraryId);
        const latency = this._core._environment.getValue('USS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const session = this._assetPool.createLoaderUpdateSession(mostRecentValidMutation);
        libraryContext._libraryUpdater.updateRemoteItem(session, trainingSetLibraryData);
        session.commit();
        // Double check that we are dealing with a training set library
        // If so, update the asset pool with the custom models
        let items = [];
        if (trainingSetLibraryData.roles.some(role => role.type === 'cm_training_set')) {
            const customModels = trainingSetLibraryData.custom_models;
            if (!customModels) {
                return { items, total: 0 };
            }
            const cmSession = this._assetPool.createLoaderUpdateSession(mostRecentValidMutation);
            items = CustomModelUpdaterMelville.updateRemoteItems(cmSession, customModels);
            cmSession.commit();
        }
        return {
            items,
            total: items.length
        };
    }
}

/**
 * These utility functions are for the LibraryUpdater.
 *
 * class ShareableItem uses _shareFlagsAreDirty to decide when
 * to lazy load all of {  _isShared, _isSharedWithYouAsset,
 * _isPublicLink, _directCollaboratorCount } with a service
 * call to an Invitation Service endpoint.
 *
 * Melville uses the same endpoint to initialize its internal
 * data, and when a Melville request includes selector='collaboration',
 * the response will include collaboration data.
 *
 * Due to Melville re-arranging the data, a Melville Collaborator
 * is not the same data as an Invitation Service Collaborator,
 * so class Library cannot use the data to set ShareableItem._collaborationArray.
 *
 * But there is enough equivalent data for LibraryUpdater
 * to update all of the above properties and clear their dirty flag
 * when the optional collaboration data is present. When it's absent,
 * these getters return NotFound, so the ShareableItem properties
 * will be untouched by the update.
 */
function getLibraryIsShared(value) {
    if (value.collaboration) {
        // CollaborationContext._handleBatchRequest() injects isDirect:true
        // into Invitation Service Collaborator's being constructed for
        // directCollaborators.
        // DbLibraryCollaborationData.getFilteredCollaborators()
        // ( in Melville source ) sets inheritanceType:'DIRECT' for the
        // same condition.
        //
        // So the below handling of Melville Data is equivalent to
        // ShareableItem._setCollaboratorData()'s handling of
        // Invitation Service Data.
        const collaborators = value.collaboration.collaborators;
        return collaborators.some((collaborator) => {
            return (collaborator.inheritanceType === 'DIRECT');
        });
    }
    // When the response omits collaboration[], don't set ShareableItem properties
    return NotFound;
}
function getLibraryIsSharedWithYouAsset(value, dest) {
    if (value.collaboration) {
        // See above comment in getLibraryIsShared() to explain
        // collaborator.inheritanceType.
        //
        // Collaborator.imsUserId return this.id for imsUser's,
        // and this._additionalData?.linkedIdentity otherwise.
        //
        // DbLibraryCollaboratorData.getCollaborator() ( in Melville source )
        // returns an imsUser's id, or additionalData.linkedIdentity
        // for an Address Book Contact's.
        //
        // DbLibraryCollaborationData.getFilteredCollaborators() filters
        // the list to only be imsUser's or Address Book Contact.
        //
        // So the below handling of Melville Data is equivalent to
        // ShareableItem._setCollaboratorData()'s handling of
        // Invitation Service Data.
        const currentUser = dest._core._environment.getValue('USER_ID');
        const collaborators = value.collaboration.collaborators;
        return collaborators.some((collaborator) => {
            return (collaborator.inheritanceType === 'DIRECT') && (collaborator.collaborator === currentUser);
        });
    }
    // When the response omits collaboration[], don't set ShareableItem properties
    return NotFound;
}
function getLibraryIsPublicLink(value) {
    if (value.collaboration) {
        // Melville's already determined if the library has a public link.
        return !!value.collaboration.public;
    }
    // When the response omits collaboration[], don't set ShareableItem properties
    return NotFound;
}
function getLibraryDirectCollaboratorCount(value) {
    if (value.collaboration) {
        // See above comment in getLibraryIsShared() to explain
        // collaborator.inheritanceType, but this should be
        // equivalent to ShareableItem._setCollaboratorData(),
        // as we are counting the number of direct collaborators.
        const collaborators = value.collaboration.collaborators;
        return collaborators.filter((collaborator) => (collaborator.inheritanceType === 'DIRECT')).length;
    }
    // When the response omits collaboration[], don't set ShareableItem properties
    return NotFound;
}
function getLibraryShareFlagsAreDirty(value) {
    if (value.collaboration) {
        // If we've updated the properties (with the above methods),
        // then we need to clear the dirty flag as well.
        return false;
    }
    // When the response omits collaboration[], don't set ShareableItem properties
    return NotFound;
}

function isLibrary(asset) {
    return asset.isLibrary;
}
class Library extends AdobeAsset {
    constructor(_core, id, metadata) {
        super(_core, id, metadata);
        this._core = _core;
        this.isLibrary = true;
        this._libraryInterface = new LibraryInterface(this._core);
        this._libraryDataLoadInfo = {
            state: 'NOT_LOADED'
        };
        this._type = 'application/vnd.adobe.library+dcx';
        // Overridden property.
        // True to start with. If we have the metadata, we will update this.
        this._needsRepoMetadata = true;
        LazyLoadManager.manageLazyLoading(this, [{
                event: RestrictEditChangedEventInstance,
                fetchData: this._refreshEditingRestricted
            }]);
    }
    /**
     * Returns the LibraryContents API for the library.
     * LibraryContents controls and exposes the state of the library's contents, including elements and groups.
     * The LibraryContents instance is stored using WeakRef to avoid leaking.
     * Please note that the client is responsible for holding onto this reference if they do not want the contents to be garbage collected,
     * and make sure to remove the reference when it is no longer needed, as we only keep the reference alive for the 10 minute default.
     * @returns LibraryContents
     */
    async getContents() {
        if (!this._contents || !this._contents.deref()) { // deref() may return undefined if the object has been garbage collected
            // Load and initialize CC Libraries API, if it isn't already
            const libraryContext = await this._core.getLibraryContext();
            const CCLibraries = await libraryContext._getLibrariesModule();
            // Create a LibraryContents instance from the Library asset (this is
            // a subset of the existing Library interface in the CC Libraries API)
            this._contents = new WeakRef(CCLibraries.getLibraryContents(this));
        }
        return this._contents.deref(); // typescript doesn't recognize we already did an undefined check, so we have to typecast
    }
    /**
     * @package -- for use in SAM.js only
     * Use from inside library-contents code, where we know libraryContext and CCLibraries are already defined.
     * Note: This returns a hard reference, not a weak reference.
     */
    // TODO Later: Have a no-load version of this for use once load/change notifications set up.
    _getContentsSync() {
        // Contents should already be defined if calling this from the CCLibraries Module, but just in case, we can get it synchronously here.
        if (!this._contents || !this._contents.deref()) {
            const libraryContext = this._core._getLibraryContext();
            // Will throw error if CCLibraries is not defined, which is why this should only be accessed from inside /library-contents
            const CCLibraries = libraryContext._getLibrariesModule_NoLoad();
            this._contents = new WeakRef(CCLibraries.getLibraryContents(this));
        }
        return this._contents.deref();
    }
    /**
     * @package -- for use in SAM.js only
     */
    // Check if melville data is currently fully loaded
    get _libraryLoaded() {
        return this._libraryDataLoadInfo.state === 'LOADED';
    }
    /**
     * @package -- for use in SAM.js only
     * Set a promise to resolve when libraries are loaded.  Returns a resolve function that needs to be called after
     * the library is loaded, or undefined if something else is already calling for melville data.
     */
    _setLibraryLoadState(state) {
        const { state: priorState } = this._libraryDataLoadInfo;
        if (state === priorState) {
            return;
        }
        this._libraryDataLoadInfo.state = state;
        if (state === 'LOADED') {
            if (this._libraryDataLoadInfo.resolve) {
                this._libraryDataLoadInfo.resolve();
            }
        }
        else if (state === 'LOADING') {
            let resolve;
            this._libraryDataLoadInfo.promise = new Promise(r => { resolve = r; });
            this._libraryDataLoadInfo.resolve = resolve;
        }
        else if (state === 'NOT_LOADED') {
            // Transitioning to NOT_LOADED means the data still needs to be loaded. Notify listeners
            // in order to trigger lazy-loading. Unblock anything waiting on the Promise.
            // Use this also for when the data is stale and needs reloading.
            if (this._libraryDataLoadInfo.resolve) {
                this._libraryDataLoadInfo.resolve();
            }
            this.emit(LIBRARY_DATA_CHANGED);
        }
    }
    /**
     * Starts loading Melville data for a single Library, if it hasn't already been loaded, or waits
     * for in-flight load to complete.
     *
     * @parameter canRetry {boolean} (optional) For cases in Library that need to ensure Library
     *         data loads, but it may have failed from a listing, it can try one extra time.
     *
     * @package -- for use in SAM.js only
     */
    async _waitForLibraryLoad(canRetry = false) {
        this._populateLibraryDataIfNotLoading();
        await this._libraryDataLoadInfo.promise;
        if (canRetry && !this._libraryLoaded) {
            await this._waitForLibraryLoad(false);
        }
        return this._libraryDataLoadInfo.promise;
    }
    async _load({ repoMetadata, appMetadata, effectivePermission, perUserMetadata, requireLibraryDataFetch // e.g. newly created libraries need to load melville data to be filtered properly
     } = {}) {
        // When an ONS notification comes in, load the repoMetadata
        await super._load({ repoMetadata, appMetadata, effectivePermission, perUserMetadata });
        /* We need the melville reload to happen in all cases because the LibraryFilter won't match libraries without the melville data
        * There's a pathological case where:
        * - UI is currently showing libraries with a filter
        * - A library is created externally
        * - We receive a notification here to add the library
        * - We add the library, but it has no melville data
        * - The library doesn't pass the LibraryFilter without melville data
        * - We don't show the library to the UI
        * - The UI never requests any data that would trigger the lazy load, because it doesn't see the library
        * - The library is never populated with melville data and therefore is never shown
        */
        this._setLibraryLoadState('NOT_LOADED');
        if (requireLibraryDataFetch) {
            this._populateLibraryDataIfNotLoading();
            await this._waitForLibraryLoad();
        }
    }
    get elementsCount() {
        this._populateLibraryDataIfNotLoading();
        return this._elementsCount;
    }
    get displayName() {
        this._populateLibraryDataIfNotLoading();
        // Melville will always have the correct name, whereas the RAPI .name will not have the name for libraries in sync groups.
        return this._displayName;
    }
    get documentType() {
        this._populateLibraryDataIfNotLoading();
        return this._documentType;
    }
    /**
     * AssetID of Published Brand Artifact, if it exists
     */
    get publishedTo() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.appMetadata) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b['brand:publishedTo']) === null || _c === void 0 ? void 0 : _c['repo:assetId'];
    }
    /**
     * AssetID of the Source Brand, if the current Brand is a Published Artifact
     */
    get publishedFrom() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.appMetadata) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b['brand:publishedFrom']) === null || _c === void 0 ? void 0 : _c['repo:assetId'];
    }
    /**
     * Last Published Version of the current Brand
     */
    get lastPublishedVersion() {
        var _a, _b;
        return (_b = (_a = this.appMetadata) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b['brand:lastPublishedVersion'];
    }
    /**
     * AssetID of the extraction source pdfs
     */
    get extractedFrom() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.appMetadata) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b['brand:extractedFrom']) === null || _c === void 0 ? void 0 : _c.map((asset) => asset['repo:assetId']);
    }
    /**
     * Returns the Library's current roles.
     *
     */
    get roles() {
        this._populateLibraryDataIfNotLoading();
        return this._libraryRoles;
    }
    get customModelInfo() {
        this._populateLibraryDataIfNotLoading();
        return this._customModelInfo;
    }
    /**
     * Returns the Library's element renditions in a single array.
     * The main tile is at index 0.
     */
    get renditionGrid() {
        this._populateLibraryDataIfNotLoading();
        return this._renditionGridTiles;
    }
    /**
     * Makes a service request to update the Library's metadata, then updates local Library model.
     */
    async setRoles(roles) {
        const newRoles = { roles: Array.isArray(roles) ? roles : [roles] };
        await this._libraryInterface.updateMetadata(this.id, newRoles);
        this._setLibraryLoadState('NOT_LOADED');
        await this._populateLibraryDataIfNotLoading();
    }
    /**
     * Return whether the library is bookmarked (aka followed) by the user.
     * Will return undefined if data has not been loaded yet.
    */
    // Blocked by CCXB-20127: Bookmark data may currently be out of date due to a caching issue in Melville.
    // CCXC-20748: If we eventually support loading unbookmarked public libraries, bookmark data will already
    // be present in the library data when unbookmarked. Thus, we will need to separately load the user's bookmarks to verify isBookmarked.
    get isBookmarked() {
        this._populateLibraryDataIfNotLoading();
        return this._libraryLoaded ? !!this._bookmark : undefined;
    }
    get _isPublic() {
        // Warning: `ownership` is 'public' for a public library in most melville responses,
        // such as to the 'public' end points, or GET /libraries/<manifestId>.
        // However, GET /libraries/<assetId> will return 'incoming' for a public library,
        // and there's no way to tell it is public from the response
        // -- even the `id` is no longer the public library id but a new id.
        // But as long as we don't fetch public libraries that way, this definition is fine.
        // Warning2: `isPublicLink` from USS loaders is false for public libraries.
        return this._libraryLoaded ? this._ownership === 'public' : undefined;
    }
    get ownership() {
        this._populateLibraryDataIfNotLoading();
        return this._ownership;
    }
    /**
     * @experimental API subject to move in the future
     */
    async getCustomModels() {
        var _a;
        if (!((_a = this.roles) === null || _a === void 0 ? void 0 : _a.filter(role => role.type === 'cm_training_set'))) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Can only get custom models from training set libraries');
        }
        const assetPool = this._core._getAssetPool();
        return new ItemSource(assetPool, [
            new TrainingSetCustomModelLoader(assetPool, this._core, this.id)
        ], new ImplicitCustomModelFilter$1({ trainingSetId: this.id }));
    }
    /**
     * @deprecated -- will be removed on or after 2025-06-01 but not before durable links are available and used by all clients.
     * And not before its use is removed from the CCLibraries module internally.
     */
    // This legacy id is usually the dcx manifest id, but on public libraries, it will be a unique type of public library id.
    get libraryManifestId() {
        this._populateLibraryDataIfNotLoading();
        return this._legacyLibraryId;
    }
    // move calls moveLibrary without specifying restrictEdit, thus getting the default of "team_view"
    async move(destFolder) {
        return this.moveLibrary(destFolder);
    }
    /**
     * Duplicate this Asset within the same folder.
     *
     * @param destName -- (not available on SAM.cpp) -- preferred name for the duplicate
     */
    async duplicate(destName) {
        /* AdobeAsset.duplicate() is uses this._ancestorIDs!.slice(-1)[0]
         * to get the parent's asset id. _ancestorIDs is set with the
         * USSMetadata { path: string[] } or the RepositoryMetadata
         * { 'repo:ancestors': string[] }, and for other asset types
         * it's always been assigned before duplicate() is called
         * ( hence, _ancestorIDs! ).
         *
         * A Library updated with LibraryData sets _parentAssetId from
         * { parent_assetId?: ParentAssetId }, but it doesn't touch
         * _ancestorIDs.
         *
         * NOTE: setting _ancestorIDs = [ parent_assetId ] from LibraryData
         * would be a mistake because existing code assumes a non-empty
         * _ancestorIDs contains the entire path, not just the parent.
         */
        // prefer the original duplicate() if _ancestorIDs is non-empty
        if (this.ancestorIDs && this.ancestorIDs.length > 0) {
            return super.duplicate(destName);
        }
        // fallback on _parentAssetId if it's been set
        if (this._parentAssetId) {
            const assetContext = await this._core.getAssetContext();
            const parentAsset = await assetContext.getAssetWithCloudID(this._parentAssetId);
            return await this._copy(parentAsset, destName);
        }
        return Promise.reject(SAMError.create(SAMErrorCode.BAD_REQUEST, 'Library.duplicate() requires at least one of { this.ancestorIDs, this._parentAssetId } to be defined.'));
    }
    /**
     * Move a Library
     * Reqired properties
     * @param destFolder - The folder to move the library to
     * Optional properties
     * @param restrictEdit {boolean} (optional) If true, will tell Melville to move the library with TEAM_VIEW access.
     *      If false, will tell Melville to move with TEAM_EDIT access. If undefined, it is up to Melville to decide.
     */
    async moveLibrary(destFolder, restrictEdit) {
        const libraryData = await this._libraryInterface.moveLibrary(this.cloudID, destFolder.cloudID, restrictEdit);
        const assetContext = await this._core.getAssetContext();
        const session = assetContext._assetPool.createUpdateSession('move library');
        const libraryContext = await this._core.getLibraryContext();
        if (libraryData.library_urn !== this.id) {
            // Melville currently does a "fake" move using copy and delete.
            // Melville team hopes to eventually turn this into a real move.
            // For now we will just discard the old library and rely on ONS to create a new one in our pool.
            session.queueDiscardedItem(this);
        }
        else {
            // If the cloudID didn't change, then it needs to be updated to reflect its new location
            libraryContext._libraryUpdater.updateLocalItem(session, this, libraryData);
            this._setLibraryLoadState('LOADED');
        }
        session.commit();
    }
    async rename(newName) {
        await this._libraryInterface.updateMetadata(this.id, { name: newName });
        this._setLibraryLoadState('NOT_LOADED');
    }
    /**
     * Discard the library through melville, which also cleans up bookmarks.
     * This changes its repo:state to DISCARDED, but it can later be restored or permanently deleted.
     */
    async discard() {
        if (this.isDiscarded) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Asset is already discarded');
        }
        await this._libraryInterface.discardLibrary(this.cloudID);
        const libraryContext = await this._core.getLibraryContext();
        const session = libraryContext._assetPool.createUpdateSession('discard library'); // tracks changes to the asset
        // Update the local item with values from the remote item
        const assetContext = await this._core.getAssetContext();
        assetContext._adobeAssetUpdater.updateLocalItem(session, this, { 'repo:state': 'DISCARDED' });
        session.commit(); // fire notifications for tracked changes
    }
    async permanentlyDelete() {
        await this._libraryInterface.permanentlyDeleteLibrary(this.cloudID);
        const libraryContext = await this._core.getLibraryContext();
        const session = libraryContext._assetPool.createUpdateSession('permanently delete library'); // tracks changes to the asset
        session.queueDiscardedItem(this);
        session.commit(); // fire notifications for tracked changes
    }
    async restore() {
        if (!this.isDiscarded) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Cannot restore an asset that is not discarded');
        }
        const assetContext = await this._core.getAssetContext();
        await this._libraryInterface.restoreLibrary(this.cloudID);
        const assetPool = this._core._getAssetPool();
        const session = assetPool.createUpdateSession('restore library');
        assetContext._adobeAssetUpdater.updateLocalItem(session, this, { 'repo:state': 'ACTIVE' });
        session.commit();
    }
    /*
     * Override AdobeAsset._copy() so that both AdobeAsset.copy() and AdobeAsset.duplicate()
     * get handled by Melville. Melville handles rename on conflict.
     */
    async _copy(destFolder, destName) {
        return this.copyLibrary(destFolder, destName);
    }
    /**
     * Copy a Library
     * Optional properties
     * @param destFolder - If destFolder is undefined then the library will be copied in the User's personal library
     *     folder
     * @param destName - If destName is undefined then the current library name will be preserved
     * @param restrictEdit (optional) If true, copies the library with TEAM_VIEW access. If false, copies the library
     *      with TEAM_EDIT access. If undefined, Melville will determine the access.
     * @returns - The new copied Library
     */
    async copyLibrary(destFolder, destName, restrictEdit) {
        // When (!destName), we omit { name: destName } from the request body,
        // and when { name:destName } has been omitted from the request body,
        // Melville uses sourceComposite.getCompositeName() as the destination name.
        // Melville will fix any name conflicts, unlike R-API
        const libraryData = await this._libraryInterface.copyLibrary(this.cloudID, destName, destFolder === null || destFolder === void 0 ? void 0 : destFolder.cloudID, restrictEdit);
        const assetPool = this._core._getAssetPool();
        const session = assetPool.createUpdateSession('copy library');
        const libraryContext = await this._core.getLibraryContext();
        const library = libraryContext._libraryUpdater.updateRemoteItem(session, libraryData);
        library._setLibraryLoadState('LOADED');
        session.commit();
        return library;
    }
    /**
     * Makes a service request to bookmark the library, then updates local Library model.
     * Applies to project (aka team) and shared private libraries. Public libraries not yet supported.
     */
    async bookmark() {
        await this._waitForLibraryLoad(true);
        if (this.isBookmarked) {
            return;
        }
        let bookmarkData = {};
        if (this._isPublic) {
            return Promise.reject('Bookmarking public libraries not implemented.');
        }
        else {
            bookmarkData = {
                id: this._legacyLibraryId,
                type: 'collab',
                urn: this.cloudID
            };
        }
        const { bookmarks } = await this._libraryInterface.bookmarkLibraries([bookmarkData]);
        const bookmark = bookmarks.find(bookmark => bookmark.id === this._legacyLibraryId);
        const libraryContext = await this._core.getLibraryContext();
        const session = libraryContext._assetPool.createUpdateSession('bookmark library');
        libraryContext._libraryUpdater.updateLocalItem(session, this, { bookmark });
        session.commit();
    }
    /**
     * Makes a service request to remove a bookmark from the library, then updates local Library model.
     */
    async unbookmark() {
        var _a;
        await this._waitForLibraryLoad(true);
        const bookmarkId = (_a = this._bookmark) === null || _a === void 0 ? void 0 : _a.id;
        if (!bookmarkId) {
            return;
        }
        await this._libraryInterface.unbookmarkLibrary(bookmarkId); // 404 means it's already unbookmarked
        const libraryContext = await this._core.getLibraryContext();
        const session = libraryContext._assetPool.createUpdateSession('unbookmark library');
        libraryContext._libraryUpdater.updateLocalItem(session, this, { bookmark: undefined });
        session.commit();
    }
    /**
     * @package -- only for use in SAM.js
     */
    // calls out to melville to get the library data
    async _populateLibraryDataIfNotLoading() {
        if (this._libraryDataLoadInfo.state === 'NOT_LOADED') {
            this._setLibraryLoadState('LOADING');
            const libraryContext = await this._core.getLibraryContext();
            const libraryData = await this._libraryInterface.getLibraryData(this.id, { isDiscarded: this.isDiscarded });
            const assetPool = this._core._getAssetPool();
            const session = assetPool.createUpdateSession();
            libraryContext._libraryUpdater.updateLocalItem(session, this, libraryData);
            this._setLibraryLoadState('LOADED');
            session.commit();
        }
    }
    /**
     * Returns `true` if the Library has inherited editing/sharing rights blocked, `false` if it is not. Direct
     * collaborators and USM users are not affected.
     *
     * Lazy-loaded: the property will be `undefined` on initial access, and will contain the old value when it is being
     * updated. Use Mobx to monitor for changes, or subscribe to 'restrict_edit_changed' event.
     */
    get isEditingRestricted() {
        return this._isEditingRestricted;
    }
    get _isCCIProjectLibrary() {
        var _a, _b;
        return (_b = (this._ownership && this._ownership === 'team' && (this.storageAssignee.type === 'user') && ((_a = this.repoPath) === null || _a === void 0 ? void 0 : _a.startsWith('/projects/')))) !== null && _b !== void 0 ? _b : false;
    }
    // eslint-disable-next-line no-dupe-class-members
    async setEditingRestricted(restrictEdit, addCurrentUserAsEditor) {
        await this._ensureLink(RelType.AC_POLICY);
        const assetInterface = await this._getAssetInterface();
        await assetInterface.setEditingInheritanceRestricted(restrictEdit, addCurrentUserAsEditor);
        this._isEditingRestricted = restrictEdit;
        LazyLoadManager.updatedExternally(this, RESTRICT_EDIT_CHANGED);
    }
    async _refreshEditingRestricted() {
        await this._ensureLink(RelType.AC_POLICY);
        const assetInterface = await this._getAssetInterface();
        this._isEditingRestricted = await assetInterface.getEditingInheritanceRestricted();
    }
    /**
     * @package -- only for use in SAM.js
     */
    async _reloadPermissions() {
        // When policy change is detected, mark restrictEdit data stale. Meanwhile, leave the last known state of
        // _isEditingRestricted unchanged so it doesn't cause the UI to flash when the toggle is being changed.
        LazyLoadManager.setLoadStatus(this, RESTRICT_EDIT_CHANGED, LoadStatus.NotLoaded);
        return super._reloadPermissions();
    }
    /*  Internal data accessors are made public to prevent lazy loading, but are intended for use in SAM.js only. */
    /**
     * @package -- only for use in SAM.js
     */
    get _roles_NoLazyLoad() {
        return this._libraryRoles;
    }
    /**
     * @package -- only for use in SAM.js
     */
    get _ownership_NoLazyLoad() {
        return this._ownership;
    }
    /**
     * @package -- only for use in SAM.js
     */
    get _isBookmarked_NoLazyLoad() {
        return !!this._bookmark;
    }
    /**
     * @package -- for use in SAM.js
     */
    get _displayName_NoLazyLoad() {
        return this._displayName;
    }
    /**
     * @package -- for use in SAM.js
     */
    get _legacyLibraryId_NoLazyLoad() {
        return this._legacyLibraryId;
    }
}
__decorate([
    keepAlive
], Library.prototype, "getContents", null);
__decorate([
    keepAlive
    // TODO Later: Have a no-load version of this for use once load/change notifications set up.
], Library.prototype, "_getContentsSync", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
], Library.prototype, "elementsCount", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
], Library.prototype, "displayName", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
], Library.prototype, "documentType", null);
__decorate([
    observable$1
], Library.prototype, "publishedTo", null);
__decorate([
    observable$1
], Library.prototype, "publishedFrom", null);
__decorate([
    observable$1
], Library.prototype, "lastPublishedVersion", null);
__decorate([
    observable$1
], Library.prototype, "extractedFrom", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
], Library.prototype, "roles", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance, '_customModelInfo')
], Library.prototype, "customModelInfo", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
], Library.prototype, "renditionGrid", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
], Library.prototype, "isBookmarked", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
    // TODO: Not yet part of public interface, need to follow up to see if _isPublicLink can be set instead.
    // Warning: `this.isPublicLink` (from USSMetadata) is false for public libraries.
], Library.prototype, "_isPublic", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
], Library.prototype, "ownership", null);
__decorate([
    memoize$1
], Library.prototype, "getCustomModels", null);
__decorate([
    observable$1(LibraryDataChangedEventInstance)
], Library.prototype, "libraryManifestId", null);
__decorate([
    lazyLoaded(RestrictEditChangedEventInstance, '_isEditingRestricted')
], Library.prototype, "isEditingRestricted", null);
function updateRenditionGrid(source, library) {
    // The rendition grid data from Melville is an object with a main tile and an array of tiles.
    // The local representation of the rendition grid is an object with just one array of tiles, and we
    // want the main tile from Melville to be the first tile in the local rendition grid tiles array.
    // Melville currently limits the maximum number of tiles in the rendition grid to four tiles, although
    // this implementation will support any number of tiles in a rendition grid should that change.
    // The order of the tiles in the rendition grid is determined by Melville, so any tile reording as
    // a result of an update will be handled here.
    var _a, _b;
    let destTiles = (_a = library._renditionGridTiles) !== null && _a !== void 0 ? _a : (library._renditionGridTiles = []);
    // Combine the main tile and the tiles array into one source array, ensuring that the main tile is first, and that
    // no falsy tiles are included. The filter function is also used to narrow the tile type to LibraryRenditionData.
    const sourceTiles = [source.main, ...((_b = source.tiles) !== null && _b !== void 0 ? _b : [])].filter((tile) => !!tile);
    // Update existing tiles and create new tiles if they don't exist.
    sourceTiles.forEach((sourceTile, index) => {
        const destTile = destTiles.find(t => t.elementId === sourceTile.elementId);
        if (destTile) {
            destTile._index = index;
            if (sourceTile.type === 'href') {
                // Note: assumes `type` never changes.
                destTile._renditionUrl = sourceTile.rendition;
            }
            else {
                destTile._renditionData = sourceTile.rendition;
            }
        }
        else {
            destTiles.push(new RenditionTile(sourceTile, index, library));
        }
    });
    // Remove all deleted tiles (note: `filter` creates a new array instance).
    destTiles = destTiles.filter(destTile => {
        if (sourceTiles.find(sourceTile => sourceTile.elementId === destTile.elementId)) {
            return true;
        }
        destTile._releaseRenditions();
        return false;
    });
    // Re-sort by index that was assigned from sourceTiles in case the order changed.
    destTiles.sort((a, b) => a._index - b._index);
    library._renditionGridTiles = destTiles;
}
function getLibraryPermission(value) {
    if (value.asset_acl !== undefined) {
        return parseEffectivePermissions(value.asset_acl);
    }
    // If asset_acl is not present then try to deduce permissions according to the ownership.
    if (value.ownership === 'public') {
        return (Permission.Read | Permission.Ack | Permission.ReadAppMetadata);
    }
    else if (value.ownership === 'private') {
        return PERMISSION_ALL;
    }
    // If asset_acl is not present and we tried assigning permissions based on ownership, but weren't successful,
    // then do not change the current permissions.
    return NotFound;
}
// These are properties specific to melville that are always safe to update as they will not overwrite RAPI data.
// These properties should match LibrarySpecificData.
const safePropertyUpdaterTypes = {
    '_bookmark': { name: 'bookmark', format: 'object' },
    '_libraryRoles': { name: 'roles', format: 'object', isArray: true },
    '_ownership': 'ownership',
    '_legacyLibraryId': 'id',
    // "version" is soon to be deprecated in favor of schemaVersion, check for both and expose as schemaVersion
    '_customModelInfo': { name: 'firefly#cme', format: { parse: ffmodel => {
                const obj = Object.assign(Object.assign({}, ffmodel), { schemaVersion: (ffmodel.version ? ffmodel.version : ffmodel.schemaVersion) });
                delete obj.version;
                return obj;
            }, isEqual: isDeepEqual } },
    '_renditionGridRaw': {
        name: 'rendition_grid',
        format: 'object',
        set: (parsedSource, dest) => {
            const library = dest;
            updateRenditionGrid(parsedSource, library);
            library._renditionGridRaw = parsedSource;
        }
    },
    '_displayName': 'name',
    '_elementsCount': { name: 'elements_count', format: 'number' },
    '_parentAssetId': { name: 'parent_assetId', format: 'string' },
    '_documentType': { name: 'document_type', format: 'string' }
};
// These melville properties will overwrite RAPI data. This is not always safe to do.
// Melville libraries listings coming from USS may have stale data, but when we fetch a specific library, the data will be up-to-date.
// Know which melville call you are making (and what it is doing under the hood) to know if the data may be stale,
// in which which case you should only pass LibrarySpecificData to the PropertyUpdater.
// Note that safePropertyUpdaterTypes and rapiOverridesPropertyUpdaterTypes should be mutually exclusive.
const rapiOverridesPropertyUpdaterTypes = {
    '_etag': 'manifest_etag',
    '_repositoryID': 'repo:repositoryId',
    '_path': 'storage_path',
    '_version': 'version',
    '_created': { name: 'created_date', format: 'date_as_number' },
    '_modified': { name: 'modified_date', format: 'date_as_number' },
    '_discarded': { name: 'archived_date', format: 'date_as_number' },
    '_createdBy': 'created_by',
    '_modifiedBy': 'modified_by',
    '_discardedBy': 'archived_by',
    '_appMetadata._data': {
        name: 'application_metadata',
        // Use object_subset format to avoid unnecessary change events. E.g., if _appMetadata.data is
        // `{ 'shell:visibility': 'hiddenSelf', foo: 32 }` and the listing contains
        // `{ 'shell:visibility': 'hiddenSelf' }` then the _mergeData will cause no change, but using format
        // 'object', isEqual() will see source and dest aren't equal and thus assume that a change did occur.
        format: 'object_subset',
        // Only update the appMetadata fields that are available from this data source
        set: (parsedSource, dest) => {
            const asset = dest;
            asset.appMetadata._mergeData(parsedSource);
        }
    },
    '_storageAssignee': { name: 'storage_assignee', format: StorageAssigneeFormat },
    '_size': { name: 'storage_used', format: 'number' },
    '_permissions': { get: getLibraryPermission, format: 'number' },
    // The following block of properties are inherited from class ShareableItem.
    // When a Melville request includes selector collaboration, then the LibraryData
    // will include the optional member collaboration, and all of these will be set,
    // which avoids ShareableItem lazy loading the same information from the Invitation
    // Service. When collaboration is absent, none of them will be set by LibraryUpdater,
    // so ShareableItem will lazy load them on demand.
    '_isSharedWithYouAsset': { get: getLibraryIsSharedWithYouAsset, format: 'boolean' },
    '_isShared': { get: getLibraryIsShared, format: 'boolean' },
    '_directCollaboratorCount': { get: getLibraryDirectCollaboratorCount, format: 'number' },
    '_isPublicLink': { get: getLibraryIsPublicLink, format: 'boolean' },
    '_shareFlagsAreDirty': { get: getLibraryShareFlagsAreDirty, format: 'boolean' },
    // TODO [SHARED-2169] Fill in other properties as needed, for example:
    // '_storageRegion': { name: 'region', get: getUSSStorageRegion, format: 'string' }, // getUSSStorageRegion will uppercase 'va6c2' for consistency. are the rest of the values matching USS?
    // '__links': { name: '_links', format: 'object' },
};
const propertyUpdaterTypes$1 = Object.assign(Object.assign({}, safePropertyUpdaterTypes), rapiOverridesPropertyUpdaterTypes);
const libraryItemUpdaterOptions = {
    localItemType: Library,
    remoteIdProperty: 'library_urn',
    // Any changes to these properties from the update will trigger watchers of LIBRARY_DATA_CHANGED.
    // Other properties updated will trigger the  default 'change' event (which will affect observable Asset properties).
    changeEventMap: new Map([
        ['_libraryRoles', LibraryDataChangedEventInstance],
        ['_displayName', LibraryDataChangedEventInstance],
        ['_legacyLibraryId', LibraryDataChangedEventInstance],
        ['_bookmark', LibraryDataChangedEventInstance],
        ['_ownership', LibraryDataChangedEventInstance],
        ['_renditionGridRaw', LibraryDataChangedEventInstance],
        ['_elementsCount', LibraryDataChangedEventInstance],
        ['_documentType', LibraryDataChangedEventInstance],
    ]),
    // Mapping LibraryData to Library
    propertyUpdater: new PropertyUpdater(propertyUpdaterTypes$1)
};
// why is this uppercase by convention? They are instances and should be lowercase.
const LibraryUpdater = new ItemUpdater(libraryItemUpdaterOptions);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultPublishedAssetsListingOptions = {
    orderDirection: 'descending',
    orderBy: 'modify_date',
    start: 0,
    limit: 0,
    mediaTypes: [],
    excludeMediaTypes: [],
};
function getDirectionValue$3(userOptions) {
    return userOptions.orderDirection === 'ascending' ? 'asc' : 'desc';
}
class PublishedInterface extends InterfaceBase {
    async getPublishedAssets(options) {
        options = Object.assign(Object.assign({}, DefaultPublishedAssetsListingOptions), options);
        updateAssetTypeForUSS(options.mediaTypes);
        updateAssetTypeForUSS(options.excludeMediaTypes);
        const filters = {
            sort_orderby: options.orderBy,
            hints: {
                acp_platform_v2: true,
            },
            fetch_fields: { includes: ['app_metadata'] },
            op_or: [
                {
                    [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: 'pubs'
                },
                {
                    [SearchProps.OP_AND]: [
                        {
                            [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: 'cloud-content'
                        },
                        {
                            [SearchProps.FIELD_EXISTS]: ['app_metadata$$review:sourceAsset$$dc:format']
                        }
                    ],
                }
            ],
            op_none_of: [
                {
                    [SearchProps.TYPE]: options.excludeMediaTypes || [],
                },
                ...excludeExpressArtifacts(options.mediaTypes)
            ],
            [SearchProps.STORAGE_ASSIGNEE_ID]: this._core._environment.getValue('USER_ID'),
            asset_id_opacity: true,
            [SearchProps.TYPE]: options.mediaTypes || [],
            sort_order: getDirectionValue$3(options),
            limit: options.limit,
            start_index: options.start,
        };
        return await this._core.hostAssetContext._ussInterface.getQueryResponse(filters);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class PublishedAdobeAssetLoader {
    constructor(assetPool, core, _publishedInterface) {
        this._publishedInterface = _publishedInterface;
        this._ussLoaderHelper = new USSLoaderHelper(assetPool, core, this);
    }
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    async loadPage(options) {
        return this._ussLoaderHelper.loadPage(options);
    }
    /**
     * @package -- only for use inside USSLoaderHelper
     */
    async _getUSSResults({ start, limit, mediaTypes, excludeMediaTypes, order }) {
        return this._publishedInterface.getPublishedAssets({
            orderBy: OrderFieldToIUSSAdobeAssetOrderBy[order.field],
            orderDirection: order.direction,
            start,
            limit,
            mediaTypes,
            excludeMediaTypes
        });
    }
    /**
     * @package -- only for use inside USSLoaderHelper
     */
    _getItemData(item) {
        return Object.assign(Object.assign({}, item), { published: true });
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class PublishedAdobeAssetFilter extends ImplicitAdobeAssetFilterBase {
    constructor() {
        super({ _isPublished: true });
    }
}

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2023 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
class DiscardedAdobeAssetFilter extends ImplicitAdobeAssetFilterBase {
    constructor() {
        super({
            _isDiscarded: true,
            _isSharedWithYou: true
        });
    }
    matches(item) {
        if (this.isSyncedAsset(item) || this.isMobileCreation(item)) {
            return false;
        }
        // TODO: We should also handle this in the USS query when it's supported, but keep this check here for good measure.
        // https://jira.corp.adobe.com/browse/SEARCH-41079
        if (!item.hasPermission(Permission.Restore) && !item.hasPermission(Permission.Delete)) {
            return false;
        }
        return super.matches(item);
    }
    isSyncedAsset(item) {
        return item.repoPath.startsWith('/files/');
    }
    isMobileCreation(item) {
        return item.repoPath.startsWith('/assets/') && !item.repoPath.startsWith('/assets/adobe-libraries/');
    }
}

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2023 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
const DEFAULT_OPTIONS = {
    limit: 50,
    start: 0,
    orderDirection: 'descending',
    orderBy: 'modified',
    mediaTypes: [],
    excludeMediaTypes: []
};
const DISCARD_FETCH_FIELDS = [
    'creative_cloud_colortheme',
    'creative_cloud_gradient',
    '_embedded'
];
const MOBILE_CREATIONS_MIMETYPES = [
    'application/vnd.adobe.draw.project+dcx',
    'application/vnd.adobe.sketch.project+dcx',
    'application/vnd.adobe.photoshop-mix.composition+dcx',
    'application/vnd.adobe.photoshop-fix.composition+dcx',
    'application/vnd.adobe.line.sketchbook+dcx',
    'application/vnd.adobe.layup.project+dcx',
    'application/vnd.adobe.comp.project+dcx',
    'application/vnd.adobe.clip.project+dcx',
    'application/vnd.adobe.clsproject+dcx',
    'image/vnd.adobe.cls+dcx'
];
class DiscardedInterface extends InterfaceBase {
    async getDiscardedAssets(options, resource) {
        options = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
        updateAssetTypeForUSS(options.mediaTypes);
        updateAssetTypeForUSS(options.excludeMediaTypes);
        const sort_order = options.orderDirection === 'ascending' ? 'asc' : 'desc';
        const sort_orderby = OrderByToUSSOrderBy[options.orderBy || 'modified'];
        const userId = this._core._environment.getValue('USER_ID');
        const filters = {
            hints: { acp_platform_v2: true },
            creative_cloud_archive: true,
            creative_cloud_discarded_directly: true,
            [SearchProps.TYPE]: options.mediaTypes || [],
            fetch_fields: { includes: [
                    ...getUSSFetchFields(),
                    ...DISCARD_FETCH_FIELDS
                ] },
            // Asset must either be owned by the current user, or a Library (composite) that exists in /projects
            // and the current user has write access to it.
            op_or: [
                { [SearchProps.STORAGE_ASSIGNEE_ID]: userId },
                { op_and: [
                        { [SearchProps.STORAGE_ASSIGNEE_TYPE]: 'org' },
                        { [SearchProps.TYPE]: ['application/vnd.adobe.library+dcx'] },
                        {
                            [SearchProps.REPO_ACL_MODIFIER]: 'grant',
                            [SearchProps.REPO_ACL_PRIVILEGES]: ['write'],
                            [SearchProps.REPO_ACL_RELATIONS]: [RelType.PRIMARY]
                        }
                    ] },
                {
                    // we just want the projects that are either owned by the current user
                    // or are in shared-storage
                    op_and: [
                        { op_or: [
                                { [SearchProps.STORAGE_ASSIGNEE_ID]: userId },
                                { [SearchProps.STORAGE_ASSIGNEE_TYPE]: 'org' }
                            ] },
                        { op_field_exists: [
                                'app_metadata$$cc:inheritable$$cc:team$$repo:assetId',
                                'app_metadata$$cc:inherited$$cc:team$$repo:assetId',
                            ] }
                    ]
                }
            ],
            op_none_of: [
                { [SearchProps.TYPE]: options.excludeMediaTypes || [] },
                { [SearchProps.VISIBILITY]: ['hiddenSelf', 'hiddenRecursive'] },
                { [SearchProps.FIELD_EXISTS]: ['app_metadata$$review:sourceAsset$$dc:format'] },
                { [SearchProps.CREATIVE_CLOUD_TOPLEVEL_COLLECTION_NAME]: ['archive', 'files'] },
                { [SearchProps.TYPE]: MOBILE_CREATIONS_MIMETYPES }
            ],
            sort_orderby,
            sort_order,
            limit: options.limit,
            start_index: options.start
        };
        return this._core.hostAssetContext._ussInterface.getQueryResponse(filters, resource);
    }
}

class DiscardedAdobeAssetLoader {
    constructor(assetPool, _core, _discardedInterface) {
        this._core = _core;
        this._discardedInterface = _discardedInterface;
        this._ussLoaderHelper = new USSLoaderHelper(assetPool, _core, this);
    }
    supportsFilter(filter) {
        return filter !== undefined;
    }
    async loadPage(options) {
        if (!this._libraryContext) {
            this._libraryContext = await this._core.getLibraryContext();
        }
        // Check if the user can restore the project in the current repository
        // TODO: Not sure how to handle this for the Admin Console deleted view (if there is one)
        // Maybe we need to do this for the list of repositories the user has access to
        const repositories = await this._core.hostAssetContext._getListOfRepositoryIDs();
        repositories === null || repositories === void 0 ? void 0 : repositories.forEach(repository => this._core.projectContext._canRestoreProject(repository));
        return this._ussLoaderHelper.loadPage(options);
    }
    _getUSSResults({ start, limit, mediaTypes, excludeMediaTypes, order, resource }) {
        return this._discardedInterface.getDiscardedAssets({
            start,
            limit,
            orderBy: order.field,
            orderDirection: order.direction,
            mediaTypes,
            excludeMediaTypes
        }, resource);
    }
    _getItemData(item) {
        // TODO: come up with proposal for Melville to provide rendering service for non-image LEs
        // Colors/gradients have RENDITION links that cause 404 error. Clear them out so that
        // AdobeAsset does not try to fetch their renditions.
        var _a;
        const LERenditionURL = item.creative_cloud_colortheme || item.creative_cloud_gradient
            ? undefined
            : (_a = item._links) === null || _a === void 0 ? void 0 : _a[RelType.RENDITION];
        const isArchivedLibraryElement = item.asset_sub_type === 'element';
        if (isArchivedLibraryElement) {
            item._links = Object.assign(Object.assign({}, (item._links || {})), { [RelType.RENDITION]: LERenditionURL });
        }
        return Object.assign(Object.assign({}, item), { isArchivedLibraryElement });
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AdobeAssetGlobalSearchFilter extends ImplicitAdobeAssetFilterBase {
    constructor(options) {
        super({ _isSharedWithYou: true });
        this._query = '';
        /**
         * @package only for use by AdobeAssetGlobalSearchFilter/Loader
         */
        this._projectsOnly = false;
        this._query = (options === null || options === void 0 ? void 0 : options._query) || '';
        this._projectsOnly = (options === null || options === void 0 ? void 0 : options._projectsOnly) || false;
    }
    get query() {
        return this._query;
    }
    get projectsOnly() {
        return this._projectsOnly;
    }
    // The matching rules USS are deceptively complex, and could change over time. Attempting to
    // replicate here could result in items being incorrectly filtered out or incorrectly included.
    // Global search Lists should not try to share items from Lists with similar queries, other
    // than treating the queries as case-insensitive.
    matches(item) {
        // Check if the item's id is in the current filter's id list
        if (this._matchingIDsFromSearch && !this._matchingIDsFromSearch.has(item.id)) {
            return false;
        }
        // If the query exists but there's no id list, we probably haven't finished loading yet
        if ((this._query) && !this._matchingIDsFromSearch) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2023 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
const DEFAULT_MAX_LIMIT = 50;
// These are for USS internal tracing and are not secrets
const STAGE_APP_TOKEN = '4c7f3f73-27a6-48f9-8447-d2c8404661fa';
const PROD_APP_TOKEN = '4c988f33-6435-4469-b37b-7dbe33687bd8';
const USS_CONTENT_TYPE = 'application/vnd.adobe.search-request+json';
const DEFAULT_EXPERIENCE_ID = 'Default-Global-Search-Experience';
class USSv3Interface extends InterfaceBase {
    constructor() {
        super(...arguments);
        this.queryPath = '/uss/v3/query';
    }
    async getQueryResponse(queryEntry) {
        const url = `https://${this._core._environment.endpoints.USSv3_HOST}${this.queryPath}`;
        const queryEntryWithDefaults = Object.assign({ 'id': 'query1', 'scope': {
                'entities': ['AcpAsset']
            }, 'fetchFields': [FetchFields.SharedBy, FetchFields.LastAccessDate, FetchFields.CCInheritable, FetchFields.CCInherited, FetchFields.HzDocumentMetadata] }, queryEntry);
        const query = {
            experienceId: DEFAULT_EXPERIENCE_ID,
            queries: [queryEntryWithDefaults]
        };
        const response = await this._doPost(url, {
            'X-App-Token': this._core._environment.getValue('ENVIRONMENT') === Env.Stage
                ? STAGE_APP_TOKEN
                : PROD_APP_TOKEN,
            'content-type': USS_CONTENT_TYPE,
        }, JSON.stringify(query), [200]);
        return response.json();
    }
}

const DEFAULT_LIMIT = 50;
/**
 * AdobeAsset Loader classes should use this class to do the page loading. Using composition rather
 * than inheritance because a base USSLoader class was causing circular dependencies at runtime that
 * would cause the base USSLoader class to be undefined when the Loader class that was extending it
 * was declared.
 */
class USSv3LoaderHelper {
    constructor(_assetPool, _core, _loader) {
        this._assetPool = _assetPool;
        this._core = _core;
        this._loader = _loader;
        //curry this function to get the user id here
        this._getItemData = this._getItemDataWithUserId(this._core._environment.getUserId());
    }
    async loadPage(options, start) {
        var _a, _b;
        const { order, limit = DEFAULT_LIMIT, filter, implicitFilter, resource } = options;
        const latency = this._core._environment.getValue('USS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        start = start || 0;
        const { mediaTypes, excludeMediaTypes, excludeInheritanceTypes } = filter;
        const result = await this._loader._getUSSResults({
            order,
            limit,
            filter,
            implicitFilter,
            resource,
            start,
            mediaTypes: Array.from(mediaTypes !== null && mediaTypes !== void 0 ? mediaTypes : []),
            excludeMediaTypes: Array.from(excludeMediaTypes !== null && excludeMediaTypes !== void 0 ? excludeMediaTypes : []),
            excludeInheritanceTypes: Array.from(excludeInheritanceTypes !== null && excludeInheritanceTypes !== void 0 ? excludeInheritanceTypes : [])
        });
        const queryResult = result.queryResults[0];
        // TODO: it'd be nice if USS returned empty array when there are no matches
        const resultItems = queryResult.items || [];
        const session = this._assetPool.createLoaderUpdateSession(mostRecentValidMutation);
        const items = this._loader._extractItems ? this._loader._extractItems(session, resultItems) : this._extractItems(session, resultItems);
        let loadNextPage;
        const total = queryResult.metadata.totalHits || 0;
        const pageItemCount = resultItems.length;
        // [SEARCH-30755] -- May be caused by USS filtering out items due to permissions for the
        // current user, which aren't subtracted from the total. Try to ensure that the Loader paginates
        // as though the total_items is correct.
        const nextStartIndex = (pageItemCount === 0 ? start + limit : start + pageItemCount);
        if (nextStartIndex < total) {
            loadNextPage = (options) => this.loadPage(options, nextStartIndex);
        }
        const page = {
            items,
            total,
            loadNextPage,
            mostRecentValidMutation
        };
        // allow Loader to do additional internal state management (optional)
        (_b = (_a = this._loader)._postProcessPage) === null || _b === void 0 ? void 0 : _b.call(_a, options, page);
        session.commit();
        return page;
    }
    _getItemDataWithUserId(userId) {
        return (item) => {
            var _a, _b;
            return Object.assign(Object.assign(Object.assign(Object.assign({}, item.rm), { 
                // cm.sharedBy is an array of user IDs that have shared the asset
                // assuming that it is an ordered array, the first item is the first sharer
                // Even after this assumption we can't be sure that first sharer is the owner
                // We will need more info to figure out whether the asset is sharedViaInvite.
                // For example consider an asset inside a project that is not owned by the user
                // and that asset is 1-off shared with some user C by user B.
                // Now user A does not know whether this asset is shared via invite with him because
                // he is not the owner of the asset and cm.sharedBy will have user B's ID but it is not
                // shared via invite with user A.
                sharedViaInvite: ((_a = item.cm) === null || _a === void 0 ? void 0 : _a.sharedBy.length) > 0 && item.cm.sharedBy[0] !== userId, isShared: ((_b = item.cm) === null || _b === void 0 ? void 0 : _b.sharedBy.length) > 0 }), (item.am && { _embedded: { [RelType.APP_METADATA]: item.am } })), { 
                // No need to refresh collaborators for share flags, directCollaboratorCount, since they are computed
                // above. Not clearing the collaboratorDataIsDirty flag, because we cannot populate collaboratorArray
                // from USS.
                shareFlagsAreDirty: false });
        };
    }
    _extractItems(session, items) {
        var _a, _b;
        return this._core._adobeAssetFactory.assetsFromUSSV3AppMetadata(session, items, (_a = this._loader._getItemData) !== null && _a !== void 0 ? _a : this._getItemData, (_b = this._loader) === null || _b === void 0 ? void 0 : _b._libraryContext);
    }
}

class GlobalSearchLoader {
    constructor(assetPool, _core, _globalSearchInterface, _implicitFilter) {
        this._core = _core;
        this._globalSearchInterface = _globalSearchInterface;
        this._implicitFilter = _implicitFilter;
        this._ussLoaderHelper = new USSv3LoaderHelper(assetPool, this._core, this);
    }
    supportsFilter(filter) {
        return filter !== undefined;
    }
    async loadPage(options) {
        if (!this._libraryContext) {
            this._libraryContext = await this._core.getLibraryContext();
        }
        return this._ussLoaderHelper.loadPage(options);
    }
    _getUSSResults({ start, limit = DEFAULT_MAX_LIMIT, order, mediaTypes, excludeMediaTypes, excludeInheritanceTypes, }) {
        const { _query: query, _projectsOnly: projectsOnly } = this._implicitFilter;
        return this._globalSearchInterface.globalSearch({
            start,
            limit,
            query,
            order,
            mediaTypes: [...(mediaTypes || [])],
            excludeMediaTypes: [...(excludeMediaTypes || [])],
            excludeInheritanceTypes: [...(excludeInheritanceTypes || [])],
            projectsOnly
        });
    }
    _postProcessPage(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    { filter }, { items }) {
        this._implicitFilter._matchingIDsFromSearch = new Set([
            // copy existing
            ...(this._implicitFilter._matchingIDsFromSearch || []),
            ...(items.map(item => item.id))
        ]);
    }
}

class GlobalSearchInterface extends InterfaceBase {
    constructor(_core, _ussInterface) {
        super(_core);
        this._ussInterface = _ussInterface;
    }
    async globalSearch({ query, start = 0, limit = DEFAULT_MAX_LIMIT, order, mediaTypes, excludeInheritanceTypes, projectsOnly }) {
        var _a, _b;
        const { field = 'modified', direction = 'descending' } = order || {};
        const filters = [];
        if (projectsOnly) {
            // As per the recent discussions this is how the project:directoryType is defined as of now
            // The old spaces were identified with project:directoryType = project
            // The old workspaces were identified with project:directoryType = team
            // The new projects are now identified with project:directoryType = team
            filters.push({ [USSv3FilterField.DIRECTORY_TYPE]: ['team'] });
        }
        else {
            if ((_a = mediaTypes === null || mediaTypes === void 0 ? void 0 : mediaTypes.length) !== null && _a !== void 0 ? _a : 0 > 0) {
                filters.push({
                    [USSv3FilterField.MEDIA_TYPE]: mediaTypes,
                });
            }
            if ((_b = excludeInheritanceTypes === null || excludeInheritanceTypes === void 0 ? void 0 : excludeInheritanceTypes.length) !== null && _b !== void 0 ? _b : 0 > 0) {
                filters.push({
                    [USSv3FilterField.INHERITANCE_TYPE]: {
                        funcParams: { fields: excludeInheritanceTypes }
                    }
                });
            }
        }
        return this._ussInterface.getQueryResponse({
            start,
            limit,
            textQuery: query,
            sorts: [{
                    sortOrderBy: OrderFieldToUSSv3OrderField[field],
                    sortOrder: (direction === 'ascending' ? USSv3OrderDir.Ascending : USSv3OrderDir.Descending)
                }],
            // TODO: figure out how to exclude media types once USS v3 supports it
            filters
        });
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AdobeAssetGlobalSearchLoader {
    constructor(assetPool, _implicitFilter, _core, _adobeAssetGlobalSearchInterface) {
        this._implicitFilter = _implicitFilter;
        this._core = _core;
        this._adobeAssetGlobalSearchInterface = _adobeAssetGlobalSearchInterface;
        this._ussLoaderHelper = new USSLoaderHelper(assetPool, _core, this);
    }
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    async loadPage(options) {
        if (!this._libraryContext) {
            this._libraryContext = await this._core.getLibraryContext();
        }
        return this._ussLoaderHelper.loadPage(options);
    }
    /**
     * @package -- only for use by USSLoaderHelper
     */
    _getUSSResults({ start, limit, order, mediaTypes, excludeMediaTypes }) {
        var _a;
        const query = (_a = this._implicitFilter) === null || _a === void 0 ? void 0 : _a._query;
        return this._adobeAssetGlobalSearchInterface.getFilteredAssets({
            orderBy: OrderFieldToIUSSAdobeAssetOrderBy[order.field],
            orderDirection: order.direction,
            start,
            limit,
            mediaTypes,
            excludeMediaTypes,
            query,
            embedPermissions: true,
        });
    }
    /**
     * @package -- only for use by USSLoaderHelper
     */
    _postProcessPage(loaderOptions, page) {
        const { items } = page;
        this._implicitFilter._matchingIDsFromSearch = new Set([
            // copy existing, if needed
            ...(this._implicitFilter._matchingIDsFromSearch || []),
            ...(items.map(item => item.id))
        ]);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class SWYAdobeAssetFilter extends ImplicitAdobeAssetFilterBase {
    constructor() {
        super({
            _isSharedWithYou: true
        });
    }
    matches(item) {
        if (!item._isSWYAsset_NoLazyLoad) {
            return false;
        }
        if (item.isProject) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultEmbeddedResources = [
    RelType.AC_EFFECTIVE,
    RelType.APP_METADATA,
    RelType.PROJECTS_CREATOR,
    RelType.REPOSITORY
];
const DefaultProjectsListingOptions = {
    orderDirection: 'ascending',
    orderBy: 'repo:name',
    start: 0,
    limit: 0,
    // we want to embed all the resources by default
    embed: DefaultEmbeddedResources,
    // The default use case is to show all active project projects.
    isDiscarded: false
};
const DefaultRecentProjectsListingOptions = {
    first: 10,
    // we want to embed all the resources by default
    embed: DefaultEmbeddedResources
};
function getDirectionValue$2(userOptions) {
    const directionFlag = userOptions.orderDirection === 'ascending' ? '+' : '-';
    return directionFlag + userOptions.orderBy;
}
function createPageTemplate$2(options) {
    const templateValues = {};
    if (options.start) {
        templateValues.start = options.start;
    }
    if (options.limit) {
        templateValues.limit = options.limit;
    }
    return templateValues;
}
function getProjectsListingPath(links, options) {
    const userOptions = Object.assign(Object.assign({}, DefaultProjectsListingOptions), options);
    const templateValues = createPageTemplate$2(userOptions);
    templateValues.orderBy = getDirectionValue$2(userOptions);
    const { embed, view, repositoryId, ownerId, nameContains, isDiscarded, directorySubtypes } = userOptions;
    if (embed === null || embed === void 0 ? void 0 : embed.length) {
        templateValues.embed = embed.join(',');
    }
    if (view) {
        templateValues.view = view;
    }
    if (repositoryId) {
        templateValues.repositoryId = repositoryId;
    }
    // No default value for namContains so
    // just pull the value from the filter.
    if (nameContains) {
        templateValues.nameContains = nameContains;
    }
    if (ownerId) {
        templateValues.ownerId = ownerId;
    }
    if (isDiscarded) {
        templateValues.state = 'discarded';
    }
    if (directorySubtypes) {
        templateValues.directorySubtype = directorySubtypes.join(',');
    }
    return getURLFromLinks(links, RelType.PROJECTS_COLLECTION, templateValues);
}
function validateRequiredProjectLinks$1(links) {
    return validateLinks(links, PROJECTS_INDEX_LINKS);
}
/**
 * Small utility function that returns an OpPatch operation
 * for gradients. Seperated to make it easier to share here and
 * in tests.
 *
 * @param path
 * @param gradientID
 * @returns
 */
function getProjectGradientPatchOP(path, gradientID) {
    return {
        'op': 'replace',
        path,
        'value': gradientID
    };
}
function getRecentProjectsListingURL(links, options) {
    var _a;
    const userOptions = Object.assign(Object.assign({}, DefaultRecentProjectsListingOptions), options);
    const templateValues = {};
    if (userOptions.after) {
        templateValues.after = userOptions.after;
    }
    if (userOptions.first) {
        templateValues.first = userOptions.first;
    }
    if ((_a = userOptions.embed) === null || _a === void 0 ? void 0 : _a.length) {
        templateValues.embed = userOptions.embed.join(',');
    }
    return getURLFromLinks(links, RelType.PROJECTS_RECENT, templateValues);
}
// Exporting the path to make it easier to use in tests as well.
const CSC_PROJECT_CREATE_ENDPOINT_PATH = '/api/v3/internal/csc-projects/:create';
class ProjectsInterface extends InterfaceBase {
    constructor() {
        super(...arguments);
        this._gradientResourcesByLanguage = new Map();
    }
    async _discoverLinks(rootHref) {
        const response = await this._getResponse(rootHref);
        return response._links;
    }
    _getEndpointHref(endpoint) {
        return `https://${this._core._environment.endpoints.PROJECTS_HOST}${endpoint}`;
    }
    _getCreateEndpointHref() {
        // At the moment we don't need to worry about the region since
        // the services will likely not be located in various regions at the moment
        // so that optimizations is not necessary, it may change in the future if
        // those reqs arise.
        // This is also a well known URL
        return this._getEndpointHref(CSC_PROJECT_CREATE_ENDPOINT_PATH);
    }
    /**
     *
     * @package Internal use only
     */
    async _discoverProjectLinks() {
        return this._discoverLinks(this._getEndpointHref(`/api/v3/index`));
    }
    /**
     * Fetches the list of projects based on the options provided
     * @param options : options to sort and filter the projects listing
     * @returns the list of projects along with the page information and links to the next page
     */
    async getProjects(options, resource) {
        const links = await this._discoverProjectLinks();
        const url = getProjectsListingPath(links, options);
        return await this._getResponse(url, { resource });
    }
    /**
     * Fetches the list of recent projects based on the options provided
     * @param options : options limit and pagination
     * @returns the list of recent projects along with the page information
     */
    async getRecentProjects(options, resource) {
        const links = await this._discoverProjectLinks();
        const url = getRecentProjectsListingURL(links, options);
        return await this._getResponse(url, { resource });
    }
    async _getProjectLink(id, embed = DefaultEmbeddedResources) {
        const links = await this._discoverProjectLinks();
        const url = getURLFromLinks(links, RelType.PROJECTS_PRIMARY, Object.assign({ assetId: id }, (embed.length ? { embed: embed.join(',') } : undefined)));
        return url;
    }
    /**
     *
     * @param id Gets the project metadata for the given project id from the projects service
     * @param embed the resources that are to be embedded in the response. By default all the resources are embedded
     * @returns the project metadata for the given project id
     */
    async getProject(id, embed = DefaultEmbeddedResources) {
        const url = await this._getProjectLink(id, embed);
        return await this._getResponse(url);
    }
    async getProjectsWithLink(pageLink) {
        return await this._getResponse(pageLink.href);
    }
    async _getCreateLink(embed) {
        const links = await this._discoverProjectLinks();
        return getURLFromLinks(links, RelType.PROJECTS_CREATE, embed.length ? { embed: embed.join(',') } : undefined);
    }
    /**
     * Creates a new project
     * @param data needed to create a project like name and color
     * @param embed the resources to be returned in the response of the newly created project. By default all the
     *     resources are embedded
     * @returns the newly created project
     */
    async createProject(data, embed = DefaultEmbeddedResources) {
        const url = await this._getCreateLink(embed);
        // 403 is included as a success code below so we can special case it after _doPost returns.
        const response = await this._doPost(url, { 'Content-Type': JSON_MIME_TYPE }, JSON.stringify(data), [201, 403]);
        let jsonResponse = {};
        // Use try/catch in case body is empty or not JSON. It's expected that success cases will always return
        // JSON, but not sure about all error cases. Otherwise, it could throw an exception here and hide the
        // service call that caused the problem.
        try {
            jsonResponse = await response.json();
        }
        catch (_a) {
            // Ignore the error here.
        }
        if (jsonResponse.status === 403) {
            if (jsonResponse.type === ProblemType.CHILDREN_LIMIT_EXCEEDED) {
                throw SAMError.create(SAMErrorCode.PROJECT_LIMIT_EXCEEDED, 'Maximum number of Projects exceeded', { response, reqId: response.headers.get('x-request-id') || '' });
            }
            else {
                const error = SAMError.createWithResponse(response, response.url);
                this._core._environment.error(`ProjectsInterface error ${error}`);
                throw error;
            }
        }
        return jsonResponse;
    }
    /**
     * Creates a new CSC Project with the Projects Service
     *
     * The data interface is setup to only allow either a path or assetId
     * supplying both may work but fail in the services since only one of
     * these values are allowed.
     *
     */
    async createCSCProject(data, orgId, userId) {
        const { path, parentAssetId, projectDirectorySubType, name, appMetadata } = data;
        let projectCreateRepoData = Object.assign({ 'project:directorySubtype': projectDirectorySubType.toString(), 'repo:name': name }, (appMetadata ? {
            [RelType.APP_METADATA]: Object.assign({}, appMetadata)
        } : {}));
        const createLink = this._getCreateEndpointHref();
        if (path) {
            projectCreateRepoData = Object.assign(Object.assign({}, projectCreateRepoData), { 'repo:path': path });
        }
        else {
            projectCreateRepoData = Object.assign(Object.assign({}, projectCreateRepoData), { 'repo:assetId': parentAssetId });
        }
        // Currently there isn't a response from this API
        // in the future there may be.
        const response = await this._doPost(createLink, Object.assign({ 'Content-Type': JSON_MIME_TYPE, 'Org-Id': orgId }, (userId ? { 'User-Id': userId } : {})), JSON.stringify(projectCreateRepoData), [201]);
        const responseJson = await response.json();
        // Since there isn't a response from service, we need to return
        // a partial metadata structure using the properties returned
        // from the project service.
        return responseJson;
    }
    /**
     * Find the project that matches the given name, if available
     * @param path relative path of the project, which is the project name
     * @returns data associated with the project
     */
    async resolveProjectByName(path) {
        const url = await this._getResolveByPathLink(path);
        return this._getResponse(url);
    }
    /**
     * Renames the project with the new name
     * @param newName new name for the project
     * @param links links associated with the project. We use the rename link to rename the project
     */
    async renameProject(newName, links) {
        const href = getURLFromLinks(links, RelType.PROJECTS_RENAME);
        await this._doPost(href, { 'Content-Type': JSON_MIME_TYPE }, JSON.stringify({ 'repo:name': newName }), [204]);
    }
    async _getResolveByPathLink(path, repositoryID) {
        const links = await this._discoverProjectLinks();
        const url = getURLFromLinks(links, RelType.RESOLVE_PATH, Object.assign({ path }, (repositoryID ? { repositoryId: repositoryID } : {})));
        return url;
    }
    /**
     * Validate the project name either for creation or renaming a project.
     * If the head call responds with 404, it means the project name is valid
     * and no other project exists with the same name/path.
     * 200 and 403 responses are considered name conflicts.
     * Please refer https://wiki.corp.adobe.com/display/assetscollab/Proposal%3A+Project+API+V3+-+Resolve
     * for more details.
     * @param path The relative path or absolute path of a project. If the path is relative,
     * project service prepends a prefix to form an absolute path
     */
    async validateProjectName(path, repositoryID) {
        const url = await this._getResolveByPathLink(path, repositoryID);
        await this._doHead(url);
    }
    /**
     * Discards a project.
     */
    async discardProject(id, links) {
        if (!(links === null || links === void 0 ? void 0 : links[RelType.DISCARD])) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Discard link is missing for this project${id}`);
        }
        const href = getURLFromLinks(links, RelType.DISCARD);
        await this._doPost(href, undefined, undefined, [204]);
    }
    /**
     * Restores a project.
     */
    async restoreProject(id, links) {
        if (!(links === null || links === void 0 ? void 0 : links[RelType.RESTORE])) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Restore link is missing for this project${id}`);
        }
        const href = getURLFromLinks(links, RelType.RESTORE);
        await this._doPost(href, undefined, undefined, [204]);
    }
    /**
     * Get a Resource representing the gradients available for a given language.
     * By using separate resources for each language, we can more easily cache them,
     * rather than one Resource that can vary by language.
     */
    getGradientsResource(language) {
        let resource = this._gradientResourcesByLanguage.get(language);
        if (!resource) {
            let loadedOnceThisSession = false;
            resource = new Resource(this._core, {
                // Since gradients vary by language using the same URL,
                // we need to include the language in the cache key.
                getCacheKey: (method, href) => `${method}-${href}-${language}`,
                skipRevalidation: () => loadedOnceThisSession,
                onResponse: async (response, flags) => {
                    if (!flags.preliminary) {
                        loadedOnceThisSession = true;
                    }
                },
                loadData: async () => {
                    const url = await this._getGradientsLink();
                    await this._doGet(url, {
                        headers: {
                            'Content-Type': JSON_MIME_TYPE,
                            'Accept-Language': language
                        },
                        resource
                    });
                },
            });
            this._gradientResourcesByLanguage.set(language, resource);
        }
        return resource;
    }
    async _getGradientsLink() {
        const links = await this._discoverProjectLinks();
        const url = getURLFromLinks(links, RelType.PROJECTS_GRADIENTS_COLLECTION);
        return url;
    }
    async getGradients(languageCode) {
        const resource = this.getGradientsResource(languageCode);
        return await resource.get({});
    }
    async patchProject(links, data) {
        const jsonData = [];
        if (data.gradientID) {
            jsonData.push(getProjectGradientPatchOP(IProjectPatchKeys.GRADIENT_ID, data.gradientID));
        }
        const url = getURLFromLinks(links, RelType.APP_METADATA);
        await this._doPatch(url, { 'Content-Type': JSON_PATCH_MIME_TYPE, 'If-Match': '*' }, JSON.stringify(jsonData), [204]);
    }
    async _getCapabilityLink(capability, repositoryID) {
        const links = await this._discoverProjectLinks();
        return getURLFromLinks(links, RelType.PROJECTS_CAPABILITY, Object.assign({ privilege: capability }, (repositoryID ? { repositoryId: repositoryID } : {})));
    }
    async getCapability(capability, repositoryID) {
        const url = await this._getCapabilityLink(capability, repositoryID);
        try {
            await this._doGet(url);
        }
        catch (e) {
            // If the error is not a SAMError then we can
            // just throw it normally. We don't want to obfuscate a regular error
            // that could occur just because it's not a SAMError.
            if (!isSAMError(e)) {
                throw e;
            }
            const samError = e;
            const errorResponse = samError._additionalInfo.response;
            // If the response is not defined then let's just
            // throw the error as well since it's not an error created by
            // a response from a request in SAM.
            if (!errorResponse) {
                throw e;
            }
            const failedResponseCode = [404, 403];
            if (!failedResponseCode.includes(errorResponse.status)) {
                throw e;
            }
            const responseJson = await errorResponse.json();
            switch (responseJson.type) {
                case ProblemType.ADMIN_ONLY:
                    throw SAMError.create(SAMErrorCode.ACCESS_DENIED, 'Admin disabled creation of projects for user', undefined, SAMErrorSubCode.PROJECTS_ADMIN_ONLY);
                case ProblemType.NO_HOME_REPOSITORY:
                    throw SAMError.create(SAMErrorCode.NOT_FOUND, 'No home repository for the user', undefined, SAMErrorSubCode.PROJECTS_NO_HOME_REPOSITORY);
                case ProblemType.INVALID_HOME_REPOSITORY:
                    throw SAMError.create(SAMErrorCode.NOT_FOUND, 'Invalid home Repository for the user', undefined, SAMErrorSubCode.PROJECTS_INVALID_REPOSITORY);
                default:
                    throw e;
            }
        }
    }
    /**
     *
     * @package Internal use only
     *
     */
    async _issueContextAPIRequest(assetId, repoId, href) {
        const body = JSON.stringify({
            'repo:assetId': assetId,
            'repo:repositoryId': repoId
        });
        const response = await this._doPost(href, {
            'Content-Type': 'application/json'
        }, body, [200]);
        return response.json();
    }
    async _getOrganizationsCollectionLink() {
        const links = await this._discoverProjectLinks();
        return getURLFromLinks(links, RelType.ORGANIZATIONS_COLLECTION);
    }
    async getOrganizations(resource) {
        const url = await this._getOrganizationsCollectionLink();
        await this._doGet(url, { resource });
    }
}
__decorate([
    cache(validateRequiredProjectLinks$1),
    __param(0, key)
], ProjectsInterface.prototype, "_discoverLinks", null);
__decorate([
    synchronized
], ProjectsInterface.prototype, "getGradients", null);
__decorate([
    synchronized
], ProjectsInterface.prototype, "getOrganizations", null);

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2024 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
const ORGANIZATIONS_CHANGED = 'organizations_changed';
class OrganizationsChangedEvent extends SAMEvent {
    constructor() {
        super(ORGANIZATIONS_CHANGED);
    }
}
const OrganizationsChangedEventInstance = new OrganizationsChangedEvent();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const STUDENT_ASSIGNMENTS_INDEX_LINKS = {
    [RelType.STUDENT_ASSIGNMENTS_COLLECTION]: ['assignmentId', 'assignmentCode', 'includeStudentDocuments'],
    [RelType.STUDENT_ASSIGNMENTS_PRIMARY]: ['studentAssignmentId', 'includeStudentDocuments'],
};
var StudentAssignmentStatus;
(function (StudentAssignmentStatus) {
    StudentAssignmentStatus["NOT_STARTED"] = "NOT_STARTED";
    StudentAssignmentStatus["IN_PROGRESS"] = "IN_PROGRESS";
    StudentAssignmentStatus["RETURNED"] = "RETURNED";
    StudentAssignmentStatus["SUBMITTED"] = "SUBMITTED";
})(StudentAssignmentStatus || (StudentAssignmentStatus = {}));
const ALL_STATUSES = [StudentAssignmentStatus.IN_PROGRESS, StudentAssignmentStatus.NOT_STARTED, StudentAssignmentStatus.RETURNED, StudentAssignmentStatus.SUBMITTED];
var StudentAssignmentOwner;
(function (StudentAssignmentOwner) {
    StudentAssignmentOwner["Any"] = "ANY";
    StudentAssignmentOwner["Self"] = "SELF";
})(StudentAssignmentOwner || (StudentAssignmentOwner = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DefaultStudentAssignmentsListingOptions = {
    includeStudentDocuments: false,
};
function validateRequiredStudentAssignmentLinks(links) {
    return validateLinks(links, STUDENT_ASSIGNMENTS_INDEX_LINKS);
}
function getStudentAssignmentsListingPath(links, options) {
    // Use defaults first and then overwrite any provided options.
    const userOptions = Object.assign(Object.assign({}, DefaultStudentAssignmentsListingOptions), options);
    // Get appropriate link from collection and populate any templated options.
    const url = new URL(getURLFromLinks(links, RelType.STUDENT_ASSIGNMENTS_COLLECTION, userOptions));
    return url.toString();
}
const headers$3 = getSAMVersionRequestHeader();
class StudentAssignmentsInterface extends InterfaceBase {
    async _discoverLinks(rootHref) {
        const response = await this._getResponse(rootHref, { headers: headers$3 });
        return response._links;
    }
    _getEndpointHref(endpoint) {
        return `https://${this._core._environment.endpoints.ASSIGNMENTS_HOST}${endpoint}`;
    }
    async discoverStudentAssignmentLinks() {
        return this._discoverLinks(this._getEndpointHref('/api/v1/index'));
    }
    async getStudentAssignments(data) {
        let identifier = {};
        if (data.assignmentId) {
            identifier = { assignmentId: data.assignmentId };
        }
        else if (data.assignmentCode) {
            identifier = { assignmentCode: data.assignmentCode };
        }
        else {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Either assignmentCode or assignmentId must be provided');
        }
        const { loadDocuments = false } = data, otherData = __rest$2(data, ["loadDocuments"]);
        const dataForQuery = Object.assign({}, otherData);
        // remove `undefined` and empty values from the data object
        Object.keys(dataForQuery).forEach((key) => {
            const value = dataForQuery[key];
            if (value === '' || value === undefined || Array.isArray(value) && value.length === 0) {
                delete dataForQuery[key];
            }
        });
        // loadDocuments is deprecated on the Hume call; switch to includeStudentDocuments here.
        const options = Object.assign(Object.assign(Object.assign({}, identifier), dataForQuery), { includeStudentDocuments: loadDocuments });
        const links = await this.discoverStudentAssignmentLinks();
        const url = getStudentAssignmentsListingPath(links, options);
        const response = await this._getResponse(url, { headers: headers$3 });
        return response;
    }
    async getStudentAssignment(studentAssignmentId, options, additionalHeaders) {
        var _a;
        const loadDocuments = (_a = options === null || options === void 0 ? void 0 : options.loadDocuments) !== null && _a !== void 0 ? _a : false;
        const preparedOptions = Object.assign({ studentAssignmentId, includeStudentDocuments: loadDocuments }, options);
        const links = await this.discoverStudentAssignmentLinks();
        const url = getURLFromLinks(links, RelType.STUDENT_ASSIGNMENTS_PRIMARY, preparedOptions);
        return this._getResponse(url, { headers: Object.assign(Object.assign({}, headers$3), additionalHeaders) });
    }
    /**
     * @description Calls the return API for a student assignment.
     * @param data The information necessary for calling the return API.
     * @returns A promise that the assignment has been returned.
     */
    async return(data) {
        const { links, studentAssignmentId, submissionId } = data;
        const url = getURLFromLinks(links, RelType.ASSIGNMENTS_RETURN, { studentAssignmentId, submissionId });
        const response = await this._doPost(url, headers$3, undefined, [200]);
        return response.json();
    }
    /**
     * @description Calls the start API for a student assignment.
     * @param data The information necessary for calling the start API.
     * @returns A promise that resolves to the interface for the remote student assignment.
     */
    async start(data) {
        const { assignmentId, links } = data;
        const url = getURLFromLinks(links, RelType.ASSIGNMENTS_START, { assignmentId });
        const response = await this._doPost(url, headers$3, undefined, [200]);
        return response.json();
    }
    /**
     * @description Calls the submit API for a student assignment.
     * @param data The information necessary for calling the submit API.
     * @returns A promise that the assignment has been submitted.
     */
    async submit(data) {
        const { links, studentAssignmentId, submissionId } = data;
        const url = getURLFromLinks(links, RelType.ASSIGNMENTS_SUBMIT, { studentAssignmentId, submissionId });
        const response = await this._doPost(url, headers$3, undefined, [200]);
        return response.json();
    }
}
__decorate([
    cache(validateRequiredStudentAssignmentLinks),
    __param(0, key)
], StudentAssignmentsInterface.prototype, "_discoverLinks", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe Systems Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const ONS_SUBSCRIPTION_MIME_TYPE = 'application/vnd.adobecloud.subscription+json';
const ONS_SUBSCRIPTION_AUTH_HEADER = 'Authorization';
const MAX_RETRY_ATTEMPTS = 3;
const MIN_RETRY_INTERVAL_MS = 10; // 10 msec
/**
 * Properties used to configure each asset in the ONS subscription.
 *
 * directoryLevel
 *   self: Notified only when the directory asset itself changes.
 *   shallow: Notified when the directory asset or any of its immediate children change.
 *   deep: Notified when the directory asset or any of its children (recursively) change.
 * includeResources: Array of resources to monitor (if omitted, only repo metadata is monitored)
 */
// By default we want to monitor all resources that ONS supports:
const defaultONSObjectProperties = {
    includeResources: [
        { reltype: 'api:annotation' },
        { reltype: 'api:metadata/repository' },
        { reltype: 'api:metadata/application' },
        { reltype: 'api:ac/policy' }
    ]
};
function createObjectsRequestBody(assets) {
    const objects = [];
    assets.forEach((properties, id) => objects.push(Object.assign(Object.assign({ id }, defaultONSObjectProperties), properties)));
    return objects;
}
class ONSSubscriptionChangeEvent extends ChangeEvent {
    constructor(fromCache) {
        super();
        this.fromCache = fromCache;
    }
}
/**
* Interface to register ONS subscription and listen for change events.
*/
class ONSSubscription extends SAMObjectEventEmitter {
    constructor(_onsContext, cachedSubscription) {
        super(_onsContext._core);
        this._onsContext = _onsContext;
        this._assets = new Map();
        this._watchedAssets = new Map();
        this._initializedFromCache = false;
        if (cachedSubscription) {
            const { id, href, assets, expiresAt } = cachedSubscription;
            this._subscriptionId = id;
            this._subscriptionHref = href;
            this._expiresAt = expiresAt;
            this._watchedAssets = new Map(Object.entries(assets));
            // We check if we are given watchedAssetId's and this will
            // indicate that we are loading them from cache.
            this._initializedFromCache = this._watchedAssets.size > 0;
        }
    }
    get subscriptionId() { return this._subscriptionId; }
    get subscriptionHref() { return this._subscriptionHref; }
    get expiresAt() { var _a; return (_a = this._expiresAt) !== null && _a !== void 0 ? _a : 0; }
    get lastError() { return this._lastError; }
    get watchedAssets() { return this._watchedAssets; }
    abort() {
        if (this._retryTimeout) {
            clearTimeout(this._retryTimeout);
            this._retryTimeout = undefined;
            this.logInfo(`Subscription ${this.subscriptionId} retry got aborted`);
            return true;
        }
        return false;
    }
    get assets() { return this._assets; }
    set assets(assets) {
        this._assets = new Map(assets);
        this._update();
    }
    async _update(tryAttempt = 0) {
        var _a;
        // Abort any retry attempts as we might need to remove, add
        // or update subscriptions which may cancel out previous
        // requests.
        this.abort();
        const assets = this._assets;
        // This makes a comparison of the "new" id's just added and the
        // previous assets that were added (watchedAssets);
        if (isDeepEqual(assets, this._watchedAssets)) {
            if (this._lastError) {
                // If we had an error creating or updating the subscription, but then we revert back to the
                // previous state, we need to clear the error otherwise we'll be stuck with an error!
                this._lastError = undefined;
                // Emit a change event to tell ONSInterface that we can begin
                // the longpoll request.
                this.emit(CHANGE);
            }
            else if (this._initializedFromCache) {
                // If we initialized the subscription with information
                // from the cache and the assets being added by the client
                // are exactly the same, we still want to notify the ONSInterface
                // that it can begin the longpoll request otherwise it wont.
                this.emit(CHANGE, new ONSSubscriptionChangeEvent(true));
            }
            return;
        }
        this.logInfo(`Setting ${assets.size} asset Id(s) for ${this.subscriptionId || '<pending subscription id>'}`);
        try {
            if (assets.size === 0) {
                this.logInfo(`Deleting subscription ${this.subscriptionId} (requested assets no longer exist)`);
                await this._deleteSubscriptionFromServer();
            }
            else if (this._subscriptionHref) {
                this.logDebug(`Updating subscription ${this.subscriptionId} on the server with ${assets.size} asset(s):`, assets);
                await this._updateSubscriptionOnServer(assets);
            }
            else {
                this.logDebug(`Creating new subscription for ${assets.size} asset(s):`, assets);
                await this._createSubscriptionOnServer(assets);
            }
            // Add the new ids to the "old" ids list so we can track changes later on when even newer ids are added to this subscription.
            this._watchedAssets = assets;
            this._lastError = undefined;
            this.emit(CHANGE);
        }
        catch (err) {
            this.logError(`Error updating subscription ${this.subscriptionId}:`, err);
            this._lastError = err;
            this.emit(CHANGE);
            // Schedule a retry for later if there's an error
            if (tryAttempt < MAX_RETRY_ATTEMPTS) {
                let retryAfter = (getRetryAfterHeader((_a = err.response) === null || _a === void 0 ? void 0 : _a.headers) || ONSSubscription.DEFAULT_RETRY_INTERVAL_SEC) * 1000;
                retryAfter = Math.max(MIN_RETRY_INTERVAL_MS, retryAfter);
                this._retryTimeout = setTimeout(() => {
                    this._retryTimeout = undefined;
                    this._update(tryAttempt + 1);
                }, retryAfter);
            }
        }
    }
    async _parseSubscriptionResponse(operation, getResponse) {
        const response = await getResponse();
        if (response.status < 200 || response.status >= 300) {
            let errMsg = `operation ${operation} with http response.status: ${response.status}`;
            if (response.status === 403) {
                const jsonError = await response.json();
                if (jsonError.type === ProblemType.SUBSCRIPTION_COUNT) {
                    errMsg = `Maximum number of subscriptions per user per device exceeded (${jsonError.max})`;
                }
            }
            this.logError(errMsg);
            throw SAMError.createWithResponseAndDescription(response, errMsg);
        }
        const json = await response.json();
        if (!json.id || !json._links || !json._links.self || !json._links.self.href) {
            const errMsg = `No subscription ID or href was returned in subscribe response.`;
            this.logError(errMsg);
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, errMsg, { response });
        }
        this._subscriptionId = json.id;
        this._subscriptionHref = json._links.self.href;
        if (json.expiresAt) {
            this._expiresAt = json.expiresAt;
        }
    }
    async _createRequestBody(assets) {
        const objects = createObjectsRequestBody(assets !== null && assets !== void 0 ? assets : this.watchedAssets);
        const deviceId = await this._core._environment.getDeviceId();
        const requestBody = {
            id: this.subscriptionId,
            objects,
            device: { id: deviceId },
            expiresAt: Date.now() + this._core._environment.getValue('ONS_SUBSCRIPTION_TIME_TO_LIVE')
        };
        return JSON.stringify(requestBody);
    }
    async _createSubscriptionOnServer(assets) {
        const href = await this._onsContext.getLink(RelType.SUBSCRIPTION_CREATE);
        const requestBody = await this._createRequestBody(assets);
        return this._parseSubscriptionResponse('create', () => this._core._environment.fetch(href, {
            method: 'POST',
            body: requestBody,
            authHeader: ONS_SUBSCRIPTION_AUTH_HEADER,
            headers: {
                'Content-Type': ONS_SUBSCRIPTION_MIME_TYPE
            }
        }));
    }
    async _updateSubscriptionOnServer(assets) {
        // finding out which assetID(s) to add and which to remove
        const oldAssets = this._watchedAssets;
        const newAssets = assets;
        const operations = [];
        newAssets.forEach((properties, id) => {
            if (!oldAssets.has(id)) {
                const item = { 'op': 'add', 'path': '/objects/-', 'value': Object.assign(Object.assign({ id }, defaultONSObjectProperties), properties) };
                operations.push(item);
            }
        });
        oldAssets.forEach((properties, id) => {
            if (!newAssets.has(id)) {
                const item = { 'op': 'remove', 'path': `/objects/id=${id}` };
                operations.push(item);
            }
        });
        const requestBody = JSON.stringify(operations);
        try {
            await this._parseSubscriptionResponse('update', () => this._core._environment.fetch(this._subscriptionHref, {
                method: 'PATCH',
                body: requestBody,
                authHeader: ONS_SUBSCRIPTION_AUTH_HEADER,
                headers: {
                    'Content-Type': JSON_PATCH_MIME_TYPE
                }
            }));
            this.logDebug(`Updated subscription ${this._subscriptionId} on the server.`);
        }
        catch (err) {
            this.logError(`Error updating subscription ${this._subscriptionId} on the server:`, err);
            // If we get a 404 updating a subscription, we should fall back to creating a new subscription instead
            if (err.code === SAMErrorCode.NOT_FOUND) {
                this.logWarn(`Subscription ${this._subscriptionId} no longer exists`);
                this.logDebug(`Creating a new subscription for asset(s):`, assets);
                return this._createSubscriptionOnServer(assets);
            }
            throw err;
        }
    }
    async _deleteSubscriptionFromServer() {
        this.logInfo(`Deleting subscription ${this._subscriptionId}`);
        try {
            // Note: There's no way to reach this point with _subscriptionHref undefined, so we assert that it's defined
            await this._core._environment.fetch(this._subscriptionHref, {
                method: 'DELETE',
                authHeader: ONS_SUBSCRIPTION_AUTH_HEADER
            });
        }
        catch (error) {
            // We tried.
            this.logError(`Unable to delete subscription: ${this._subscriptionHref}`, error);
        }
        // We clear the subscription even if we fail to delete it - ONS will auto-delete orphaned subscriptions after some time anyway,
        // so we don't need to be aggressive about retrying
        this._subscriptionId = undefined;
        this._subscriptionHref = undefined;
        this._expiresAt = undefined;
    }
    async refreshSubscriptionExpiryDate() {
        this.logDebug(`Refreshing expiry date on subscription ${this.subscriptionId}`);
        const requestBody = await this._createRequestBody();
        return this._parseSubscriptionResponse('update', () => this._core._environment.fetch(this.subscriptionHref, {
            method: 'PUT',
            body: requestBody,
            authHeader: ONS_SUBSCRIPTION_AUTH_HEADER,
            headers: {
                'Content-Type': ONS_SUBSCRIPTION_MIME_TYPE
            }
        }))
            .catch(() => {
            // We tried to update the expiry date on the subscription and failed
            // Lets try and update
            return this._update();
        });
    }
    async _fetchChangeLogPage(changedAssets) {
        var _a, _b, _c, _d;
        const options = { subscriptionId: this._subscriptionId };
        const href = this._nextChangeLogLinks
            ? getURLFromLinks(this._nextChangeLogLinks, RelType.GENERIC_NEXT, options)
            : await this._onsContext.getLink(RelType.ONS_CHANGELOG, options);
        // Note: Unlike the other ONS calls, this uses the standard Authorization header (other ONS calls use X-User-Token)
        // This is confusing and error-prone, so I'd like them to standardize on the Authorization header for all calls, but
        // we have to live with this inconsistency for now.
        // ONS introduced a new directive header, all clients are expected to pass ons-repometa to
        // indicate they are ready to handle compact URI for repository metadata resource
        const response = await this._core._environment.fetch(href, { headers: { 'directive': 'ons-repometa' } });
        if (response.status !== 200) {
            let errMsg = `Unexpected response fetching change log: ${response.status}`;
            // In the case that it's 403 and the type is
            // ONS_PROBLEM_LIMIT_CHANGELOGRETENTION this should mean that the
            // the current Changelog Token is expired and the we should get
            // a new "next" link.
            if (response.status === 403) {
                const parsedResponse = await response.json();
                if (parsedResponse.type === ProblemType.LIMIT_CHANGELOGRETENTION) {
                    errMsg = `Changelog retention period expired, discarding "next" link and fetching changelog again.`;
                    // When we throw an error below, it will cause the caller
                    // to retry this call and by setting _nextChangeLogLinks to undefined
                    // it will then fetch a new "next" link above.
                    this._nextChangeLogLinks = undefined;
                }
            }
            this.logError(errMsg);
            throw SAMError.createWithResponseAndDescription(response, errMsg);
        }
        const json = await response.json();
        // From the response, determine which asset ids changed
        const changedSubscriptions = (_a = json['ons:changedSubscriptions']) !== null && _a !== void 0 ? _a : [];
        const changedSubscription = changedSubscriptions.find((subscriptionInfo) => subscriptionInfo['ons:subscriptionId'] === this._subscriptionId);
        const changes = (_b = changedSubscription === null || changedSubscription === void 0 ? void 0 : changedSubscription['ons:changes']) !== null && _b !== void 0 ? _b : [];
        changes.forEach((assetInfo) => {
            var _a, _b, _c;
            const assetId = assetInfo['repo:assetId'];
            const onsResourceInfo = (_a = assetInfo['ons:resources']) !== null && _a !== void 0 ? _a : [];
            const onsResourcesChanged = [...Object.keys(onsResourceInfo)];
            const parentAssetId = assetInfo['ons:subscribedDirectoryAssetId'];
            const annotationId = (_c = (_b = onsResourceInfo['api:annotation']) === null || _b === void 0 ? void 0 : _b['repo:resource']) === null || _c === void 0 ? void 0 : _c['annotation_id'];
            if (assetId) {
                // If the asset is already in changedAssets, merge the next changed resource so we
                // don't lose any previous resources that were added here.
                if (changedAssets.has(assetId)) {
                    const existingAsset = changedAssets.get(assetId);
                    existingAsset.changedResources = [...new Set([...existingAsset.changedResources, ...onsResourcesChanged])];
                    if (annotationId) {
                        existingAsset.annotationIds = [...new Set([...(existingAsset.annotationIds || []), ...[annotationId]])];
                    }
                    changedAssets.set(assetId, existingAsset);
                }
                else {
                    changedAssets.set(assetId, Object.assign({ parentAssetId, changedResources: onsResourcesChanged }, (annotationId && { annotationIds: [annotationId] })));
                }
            }
        });
        this._nextChangeLogLinks = json === null || json === void 0 ? void 0 : json._links;
        return (_d = (_c = this._nextChangeLogLinks) === null || _c === void 0 ? void 0 : _c.next) === null || _d === void 0 ? void 0 : _d.nextPage;
    }
    /**
     * Fetch the changed assets ids in the subscription, and emit a change event on the parent ONS Interface for any changed assets.
     * The reason this API emits events rather than just returning the changed assets is so we can have robust retry logic - if it fails
     * to fetch the change log it'll schedule a retry with an appropriate backoff, so it automatically recovers. The ONS Interface can
     * simply call fetchAndNotifyChanges on a subscription that it knows has changes, and the subscription will take responsibility for
     * eventually fetching and emitting notifications for these changes, even if it has to retry.
     *
     * This API is stateful, so if you call it when the subscription changed, it will emit a change event for those assets, but if you call it
     * again (and there are no further changes), it will not emit an event.
     */
    async fetchAndNotifyChanges(attempt = 0) {
        this.logInfo(`Fetching ChangeLog for subscription ${this._subscriptionId}...`);
        // If we got another notification of a change, this causes us to retry immediately, and cancels any pending retry
        if (this._retryChangeLogTimeout) {
            clearTimeout(this._retryChangeLogTimeout);
        }
        const retry = (error) => {
            var _a;
            const retryAfter = getRetryAfterHeader((_a = error.response) === null || _a === void 0 ? void 0 : _a.headers) * 1000;
            const interval = Math.max(retryAfter, this._core._environment.getRetryInterval(attempt));
            this.logInfo(`Retrying change log fetch in ${interval}ms`);
            this._retryChangeLogTimeout = setTimeout(() => this.fetchAndNotifyChanges(attempt + 1), interval);
        };
        const changedAssets = new Map();
        try {
            let hasMorePages = true;
            while (hasMorePages) {
                hasMorePages = await this._fetchChangeLogPage(changedAssets);
            }
        }
        catch (error) {
            this.logError(`Error fetching change log`, error);
            retry(error);
        }
        // Even if there's an error, we always notify of any changes we did manage to fetch - for example, if the
        // first page succeeded, but the second page didn't, when we retry we'll retry from the second page.
        if (changedAssets.size) {
            this.logDebug(`Changed asset(s):`, changedAssets);
            this._onsContext.emit(CHANGE, new ONSAssetChangeEvent(changedAssets));
        }
    }
    // This is called to check whether the subscription still exists on the server.
    // The ONS long poll will sometimes request the client to
    // validate its subscriptions. If the subscription was deleted, it'll recreate it.
    async validate() {
        if (!this._subscriptionHref) {
            // If we're requesting to watch at least one asset id, and don't have a subscription at all,
            // something must have gone wrong creating it - we attempt to create again.
            if (this._assets.size > 0) {
                this.logWarn(`Assets exist for subscription but no _subscriptionHref was found, trying to _update() again...`);
                return this._update();
            }
            this.logDebug(`Subscription has no assets and no _subscriptionHref set`);
            return;
        }
        let checkResponse;
        try {
            // ONS spec says to GET (vs HEAD). Why?
            checkResponse = await this._core._environment.fetch(this._subscriptionHref, {
                authHeader: ONS_SUBSCRIPTION_AUTH_HEADER
            });
            this.logInfo(`Subscription ${this._subscriptionId} exists on the server`);
        }
        catch (error) {
            this.logError(`Error checking ${this._subscriptionId}, it does not exist on the server`, error);
            return;
        }
        // If we can't find the subscription, we need to make a new one.
        if (![200, 201, 204].includes(checkResponse.status)) {
            this.logInfo(`ONS subscription has been invalidated. Creating new subscription...`);
            this._subscriptionHref = undefined;
            this._subscriptionId = undefined;
            this._watchedAssets = new Map();
            return this._update();
        }
    }
    /**
     * Logs a debug message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logDebug(message, ...optionalParams) {
        this._onsContext.logger.logDebug(message, 'Subscription', ...optionalParams);
    }
    /**
     * Logs an info message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logInfo(message, ...optionalParams) {
        this._onsContext.logger.logInfo(message, 'Subscription', ...optionalParams);
    }
    /**
     * Logs a warning message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logWarn(message, ...optionalParams) {
        this._onsContext.logger.logWarn(message, 'Subscription', ...optionalParams);
    }
    /**
     * Logs an error message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     * @remarks If the first optional parameter is an Error object, the message will be appended with the error message.
     */
    logError(message, ...optionalParams) {
        this._onsContext.logger.logError(message, 'Subscription', ...optionalParams);
    }
}
// Default interval between retry attempts in seconds if no Retry-After header value is available.
ONSSubscription.DEFAULT_RETRY_INTERVAL_SEC = 0;
__decorate([
    synchronized
], ONSSubscription.prototype, "_update", null);
__decorate([
    synchronized
], ONSSubscription.prototype, "fetchAndNotifyChanges", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe Systems Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Set the x-poll-timeout request header value (in seconds) for ONS long poll requests
// This controls the frequency of the ONS server long poll responses.
const ONS_POLLTIMEOUT_SECONDS = 160;
const cacheKey = 'ONS_SUBSCRIPTIONS';
const ONS_LONG_POLL_AUTH_HEADER = 'X-User-Token';
/**
 * Interface to register ONS subscription and listen for change events.
 * Design notes:
 * Polling will only happen when the following three conditions are ALL met:
 *  1. start() has been called (and stop() has not been called).
 *  2. watch() has been called with a non-empty set of asset ids.
 *  3. The document is visible (document.visibilityState === 'visible').
 */
class ONSLongPollWorker extends SAMObjectEventEmitter {
    constructor(_onsContext) {
        super(_onsContext._core);
        this._onsContext = _onsContext;
        this._subscriptions = [];
        this._maxAssetsPerSubscription = 5;
        this._cachedSubscriptionsUsed = false;
        this._assetIds = new Set();
        this._onSubscriptionChange = (event) => {
            // IF change are notified let's make sure to update the cache as well.
            if (!(event === null || event === void 0 ? void 0 : event.fromCache)) {
                this._cachedSubscriptionsUsed = false;
            }
            this._updateCachedSubscriptions();
            this._restartMonitoring();
        };
        this._cache = _onsContext._core._environment.cache;
    }
    get isActive() {
        return Boolean(this._abortController);
    }
    get subscriptions() {
        return this._subscriptions;
    }
    async ensureReady() {
        return true;
    }
    async deinitialize() {
        this.stop();
        return true;
    }
    /**
     * Start
     */
    start() {
        if (this.isActive) {
            this.logDebug(`ONS Long Poll worker is already started! Skipping this request!`);
            return;
        }
        this.logInfo(`Starting ONS Long Poll Worker...`);
        this._abortController = new AbortController();
        this._poll();
    }
    /**
     * Stop
     */
    stop() {
        if (!this.isActive) {
            this.logDebug(`ONS Long Poll worker is already stopped! Skipping this request!`);
            return;
        }
        this.logInfo(`Stopping ONS Long Poll Worker...`);
        this.subscriptions.forEach((sub) => sub.abort());
        const abortController = this._abortController;
        delete this._abortController;
        this._abortController = undefined;
        abortController === null || abortController === void 0 ? void 0 : abortController.abort();
    }
    async _restartMonitoring() {
        const activeSubscriptionIds = this._activeSubscriptionIds;
        // we don't want to create a bogus long pollURL if
        // there is no subscriptions...
        const newPollURL = activeSubscriptionIds.length === 0 ? undefined : await this._onsContext.getLink(RelType.NOTIFICATIONS_LONGPOLL, {
            includeJournal: 'false', subscriptionId: activeSubscriptionIds
        });
        const isUrlChanged = this._pollURL !== newPollURL;
        this._pollURL = newPollURL;
        if (this.isActive && isUrlChanged) {
            this.stop(); // Only stop if the URL has changed.
            this.start(); // Ensure polling is started.
        }
    }
    // This is used to notify the client that the initial long poll has been started along with the information
    // whether cached subscriptions were used or not. It can be used by the clients to avoid any refresh of its cached
    // data if cached subscriptions were used.
    _notifyFirstLongPollStarted() {
        this.emit(ONS_FIRST_LONG_POLL_STARTED, new ONSFirstLongPollStartedEvent(this._cachedSubscriptionsUsed));
    }
    // This is used to notify the client that the initial long poll has been completed along with the information
    // whether they were expired or not. It can be used by the clients to avoid any refresh of its cached
    // data if cached subscriptions were used.
    _notifyFirstLongPollCompleted(expired) {
        this.emit(ONS_FIRST_LONG_POLL_COMPLETED, new ONSFirstLongPollCompletedEvent(expired));
    }
    // ONS Subscriptions are more efficient if they are kept alive and updated so we check whether the subscription
    // is within 10% of its TTL and refresh as necessary
    _validateAndUpdateSubscriptionExpiration() {
        const now = Date.now();
        // We calculate the remaining time to live being within a 10% zone of the current time based
        // on environment set TTL with a minimum time remaining being 5 mins.
        const ttl = Math.max(this._core._environment.getValue('ONS_SUBSCRIPTION_TIME_TO_LIVE') * 0.1, this._core._environment.getValue('ONS_SUBSCRIPTION_RENEW_TIME'));
        this.subscriptions
            .filter(sub => sub.watchedAssets.size && (sub.expiresAt - now) < ttl)
            .forEach(sub => sub.refreshSubscriptionExpiryDate());
    }
    _truncateAssetIdsByMaxSizeIfNeeded(assetIds) {
        const maxTotalAssets = this._maxAssetsPerSubscription * this._subscriptions.length;
        if (assetIds.size > maxTotalAssets) {
            this.logInfo(`Number of assets ${assetIds.size} exceeds the maximum allowed by ONS. Limiting to ${maxTotalAssets}`);
            // TODO:
            //this._analytics.reportError('ONSSubscriptionError', `Requested assets exceed number allowed. Count: ${assetIds.length}, Max: ${maxTotalAssets}`);
            assetIds = new Set(Array.from(assetIds).slice(0, maxTotalAssets));
        }
        return assetIds;
    }
    async _getAndParseCachedSubscriptions() {
        // @TODO SAM-2845 Prevent data from being retrieved from cache
        // until it is enabled again in the future.
        if (!this._onsContext.cacheEnabled) {
            return [];
        }
        const existingCreatedSubscriptions = await this._cache.getItem(cacheKey);
        if (existingCreatedSubscriptions !== NotFound$1) {
            try {
                return JSON.parse(existingCreatedSubscriptions).subscriptions;
            }
            catch (e) {
                this.logInfo('error parsing cached subscriptions');
            }
        }
        return [];
    }
    get _activeSubscriptionIds() {
        return Array.from(this._subscriptions)
            .filter(sub => sub.subscriptionId && sub.watchedAssets.size > 0) // Note: watchedAssets not assets
            .map(sub => `${sub.subscriptionId}`)
            .sort();
    }
    async _updateCachedSubscriptions() {
        // @TODO SAM-2845 where this is defined for more information.
        // Prevent data from being written to cache
        // until it is enabled again in the future.
        if (!this._onsContext.cacheEnabled) {
            return;
        }
        const newCachedSubscriptions = [];
        this._subscriptions.forEach((subscription) => {
            const { subscriptionId, subscriptionHref, assets, expiresAt } = subscription;
            // If the ONSSubscription doesn't have an ID or Href
            // that means it wasn't created on the server and
            // it doesn't have any information to cache.
            if (!subscriptionId || !subscriptionHref) {
                return;
            }
            const updatedCache = {
                id: subscriptionId,
                href: subscriptionHref,
                assets: Object.fromEntries(assets),
                expiresAt: expiresAt || Date.now() + this._core._environment.getValue('ONS_SUBSCRIPTION_TIME_TO_LIVE')
            };
            newCachedSubscriptions.push(updatedCache);
        });
        await this._cache.setItem(cacheKey, JSON.stringify({ subscriptions: newCachedSubscriptions }), 
        // This ensures that the cached subscription will expire the same time
        // that the subscription expires on the server.
        this._core._environment.getValue('ONS_SUBSCRIPTION_TIME_TO_LIVE'));
    }
    async _ensureSubscriptions() {
        // This will create and store instances of ONSSubscription
        // the number created will be the number of MAX_SUBSCRIPTIONS
        // set by SAM.js or service (we don't actually create subscriptions
        // on the server though, unless they have any assets to monitor)
        const subscriptionConfig = await this._onsContext.getSubscriptionConfig();
        const maxSubscriptions = subscriptionConfig.maxSubscriptionPerLongPoll || this._core._environment.getValue('ONS_DEFAULT_MAX_SUBSCRIPTIONS');
        this._maxAssetsPerSubscription = subscriptionConfig.maxAssetsPerRequest || this._core._environment.getValue('ONS_DEFAULT_MAX_ASSETS_PER_SUBSCRIPTION');
        if (maxSubscriptions > this._subscriptions.length) {
            // Just because we are creating an ONSSubscription does not mean
            // we are creating a subscription on the service. We actually
            // create the max number of local ONSSubscription allowed by ONS but only
            // create the subscription on the service if there are assets on that subscription.
            const parsedCachedSubscriptions = await this._getAndParseCachedSubscriptions();
            this._cachedSubscriptionsUsed = parsedCachedSubscriptions.length > 0;
            // Add new subscriptions
            for (let i = this._subscriptions.length; i < maxSubscriptions; ++i) {
                // If we have a corresponding cached subscription
                // pull the information from cache and construct
                // the ONSSubscription with data from the cache.
                // If the cached subscription information is out of date,
                // it will be handled inside the ONSSubscription.
                const sub = new ONSSubscription(this._onsContext, parsedCachedSubscriptions[i]);
                this._subscriptions.push(sub);
                sub.on('change', this._onSubscriptionChange);
            }
        }
        else if (maxSubscriptions < this._subscriptions.length) {
            // Remove subscriptions over the limit
            for (let i = maxSubscriptions; i < this._subscriptions.length; ++i) {
                const sub = this._subscriptions[i];
                sub.assets = new Map();
                sub.off('change', this._onSubscriptionChange);
            }
            this._subscriptions.length = maxSubscriptions; // Removes the overflow from the array
        }
    }
    async watch(assetIdsToMonitor) {
        await this._ensureSubscriptions();
        this._assetIds = this._truncateAssetIdsByMaxSizeIfNeeded(assetIdsToMonitor);
        // Map from subscription id to current assets being monitored,
        // (in the form of a map from the asset id to its properties)
        // minus ones we no longer need to monitor:
        // Creates an array and each entry is a
        // Map() that represents the assets in the subscription.
        const existingAssetIds = new Set();
        const subscriptionToAssetIds = Array.from(this._subscriptions.map(sub => {
            const ids = new Map();
            sub.assets.forEach((properties, id) => {
                if (this._assetIds.has(id) && existingAssetIds.add(id)) {
                    ids.set(id, properties);
                }
            });
            return ids;
        }));
        // We assign assets to subscriptions such that we fill up the first subscription first
        // before creating new ones. Note that when this was first implemented in SAM.js, we
        // would try to spread assets across as many subscriptions as possible, because ONS didn't
        // tell us which asset in a subscription changed - but now that we have the changelog API,
        // it's better to concentrate assets in as few subscriptions as possible.
        let nextIndex = 0;
        this._assetIds.forEach(id => {
            // Skip any assets that are already part of a subscription
            if (existingAssetIds.has(id)) {
                return;
            }
            // Find the next subscription with space in it
            while (subscriptionToAssetIds[nextIndex].size >= this._maxAssetsPerSubscription) {
                nextIndex++;
            }
            // Determine if the asset is a directory or not - since we want to do a self monitor of directories:
            const asset = this._core.hostAssetContext._assetPool.getLocalItemById(id);
            subscriptionToAssetIds[nextIndex].set(id, (asset === null || asset === void 0 ? void 0 : asset.isFolder) ? { directoryLevel: 'shallow' } : {});
        });
        // Finally, update the actual subscriptions.
        this._subscriptions.forEach((sub, index) => {
            sub.assets = subscriptionToAssetIds[index];
            this.logDebug(`Subscription ${sub.subscriptionId} now has ${sub.assets.size} assets`);
        });
    }
    /**
     * _poll sets up the longpoll request with retries if needed.
     *
     * @param attempt This tracks the number of attempts already made so we can back off in needed.
     * @returns void;
     */
    async _poll(attempt = 0) {
        const retry = (error, interval = 0) => {
            interval = Math.max(this._core._environment.getRetryInterval(attempt), interval);
            const abortController = this._abortController;
            if (!abortController) {
                return;
            }
            this.logInfo(`Retrying long poll in ${interval}ms`);
            const timeout = setTimeout(() => this._poll(attempt + 1), interval);
            abortController.signal.addEventListener('abort', () => {
                if (abortController !== this._abortController) {
                    clearTimeout(timeout);
                }
            });
        };
        const abortController = this._abortController;
        if (!abortController) {
            this.logInfo(`No abort controller...`);
            return;
        }
        try {
            // this.pollURL can be undefined at start up when watch didn't have a time to build it yet,
            // also if we deleted all subscriptions calling watch with empty set.
            //
            // _pollURL is set by calling watch() which calls _ensureSubscriptions() which then sets
            // an event handler for a "change" event on each subscription created (ONSSubscription). The subscription
            // will emit a "change" event for various cases but mainly for when assetIds are updated on
            // the subscription. Once a change is emitted, the
            // the assigned _onSubscriptionChangeFun() is called and then calls _onSubScriptionChange().
            // then finally sets the URL. @TODO maybe we can streamline this process a bit more.
            if (this._pollURL === undefined) {
                this.logInfo(`Poll URL undefined...`);
                // just returning here because when pollUrl get populated it will call _stop(), _start()
                return;
            }
            // Go ahead and notify clients about first long poll.
            this._notifyFirstLongPollStarted();
            const href = this._pollURL;
            // Give the service a 20s buffer to respond on their end before terminating on our end
            const requestTimeoutMs = (ONS_POLLTIMEOUT_SECONDS + 20) * 1000;
            const response = await this._core._environment.fetch(href, {
                signal: abortController.signal,
                authHeader: ONS_LONG_POLL_AUTH_HEADER,
                headers: {
                    'x-poll-timeout': `${ONS_POLLTIMEOUT_SECONDS}`
                },
                requestTimeoutMs
            });
            if ([200, 201, 204].includes(response.status)) {
                const json = await response.json();
                this._notifyFirstLongPollCompleted(false);
                this.logInfo(`Successful long poll for ${href}`);
                // Sometimes (frequently) we get a 20x response, and nothing has changed.
                if (json && json.subscriptions && json.subscriptions.length > 0) {
                    this.logInfo(`Subscriptions changed: ${json.subscriptions.join(', ')}`);
                    // Trigger the changed subscriptions to fetch changes via the changelog API:
                    // Note that ONS does not yet support a single changelog for multiple subscriptions, so we have
                    // to call the changelog separately for each subscription right now.
                    json.subscriptions.forEach((id) => {
                        const subscription = this.subscriptions.find(sub => sub.subscriptionId === id);
                        subscription === null || subscription === void 0 ? void 0 : subscription.fetchAndNotifyChanges();
                    });
                    // After a successful long poll we should do a quick check on the expire times on the
                    // active subscriptions.
                    this._validateAndUpdateSubscriptionExpiration();
                    // We don't really need this as part of the public API, but it makes the tests much easier,
                    // so we can abort the polling.
                    this.emit('notified');
                }
                // If ONS is worried that our subscription is invalid, verify it is still there. (ONS will do this
                // every few hours no matter what.)
                if (json && json.checkSubscriptions && json.checkSubscriptions.length > 0) {
                    this.logInfo(`Checking subscriptions for subscriptions to check ${json.checkSubscriptions.length}`);
                    json.checkSubscriptions.forEach((id) => {
                        const subscription = this.subscriptions.find(sub => sub.subscriptionId === id);
                        if (subscription) {
                            subscription.validate();
                        }
                    });
                }
                this._pollURL = json && json._links && json._links.next && json._links.next.href;
                this._poll();
            }
            else if (response.status === 404) {
                this._notifyFirstLongPollCompleted(true);
                this.logInfo(`404 Response long poll for ${href}, subscription missing or expired`);
                // If the response is a 404, we've somehow lost the subscriptions. Make a new one.
                this.subscriptions.forEach((subscription) => {
                    if (subscription.subscriptionId) {
                        subscription.validate();
                    }
                });
                // We need to retry here because if subscription will be validated on the server
                // then 'change' event will not be emitted and we will stop polling here.
                retry(undefined, this._core._environment.getValue('MAX_RETRY_INTERVAL'));
            }
            else {
                this.logInfo(`Unexpected response, trying again ${href}`);
                // Otherwise, follow the retry logic defined by the ONS team.
                retry(undefined, getRetryAfterHeader(response.headers) * 1000);
            }
        }
        catch (error) {
            // If we aborted this request, we don't want to retry.
            // But only if we aborted it locally. If it was aborted elsewhere, we want to retry.
            // (AbortController is used for timeouts in Proxy#fetch)
            if (abortController.signal.aborted && abortController !== this._abortController) {
                this.emit('aborted');
                this._notifyFirstLongPollCompleted(true);
                return;
            }
            this.logInfo(`Error trying to create long poll request`);
            retry();
        }
    }
    /**
     * Logs a debug message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logDebug(message, ...optionalParams) {
        this._onsContext.logger.logDebug(message, 'Long Poll', ...optionalParams);
    }
    /**
     * Logs an info message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logInfo(message, ...optionalParams) {
        this._onsContext.logger.logInfo(message, 'Long Poll', ...optionalParams);
    }
    /**
     * Logs a warning message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logWarn(message, ...optionalParams) {
        this._onsContext.logger.logWarn(message, 'Long Poll', ...optionalParams);
    }
    /**
     * Logs an error message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     * @remarks If the first optional parameter is an Error object, the message will be appended with the error message.
     */
    logError(message, ...optionalParams) {
        this._onsContext.logger.logError(message, 'Long Poll', ...optionalParams);
    }
}
__decorate([
    synchronized
], ONSLongPollWorker.prototype, "_restartMonitoring", null);
__decorate([
    memoize$1
], ONSLongPollWorker.prototype, "_notifyFirstLongPollStarted", null);
__decorate([
    memoize$1
], ONSLongPollWorker.prototype, "_notifyFirstLongPollCompleted", null);
__decorate([
    synchronized
], ONSLongPollWorker.prototype, "_updateCachedSubscriptions", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe Systems Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const ONS_AUTH_HEADER = 'X-User-Token';

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe Systems Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ONSAxonWorker extends TypedEventEmitter {
    constructor(_onsContext) {
        super();
        this._onsContext = _onsContext;
        this._isActive = false;
        this._subscriptions = [];
        this._monitoredsubscriptions = [];
        this._maxAssetsPerSubscription = 100;
        this._assetIds = new Set();
        /**
         * Handles ONS Message event.
         * @param event - Message.
         */
        this._onVcMessage = (message) => {
            switch (message.operationName) {
                case 'notification':
                    this._handleNotification(message.body);
                    break;
                case 'error':
                    this.logError('ONS Error received', message);
                    break;
                default:
                    this.logWarn('Unknown Axon Message received', message);
                    break;
            }
        };
        /**
         * Handles ONS Error event.
         * @param event - Message.
         */
        this._onVcError = (event) => {
            this.logError('Axon Error received', event);
        };
        /**
         * Handles Deleted VC event.
         */
        this._onVcDeleted = () => {
            this.logInfo('Axon Virtual Connection has been deleted');
            this.deinitialize();
            this.ensureReady(); // Re-create the Virtual Connection.
        };
        this._onSubscriptionChange = (_event) => {
            this.logDebug('Subscriptions changed!');
            this._restartMonitoring();
        };
    }
    get isActive() {
        return this._isActive;
    }
    get subscriptions() {
        return this._subscriptions;
    }
    _handleNotification(notification) {
        var _a, _b;
        this.logDebug('Axon Notification received', notification);
        (_a = notification.subscriptions) === null || _a === void 0 ? void 0 : _a.forEach((sub) => {
            // Ensure the subscription exists in the monitored subscriptions list:
            // TODO: [SHARED-4061] Consider inncorporating monitored subscriptions into the ONSSubscription class.
            const existingMonitoredSubscription = this._monitoredsubscriptions.find(monitoredSub => monitoredSub.subscriptionId === sub.id);
            if (existingMonitoredSubscription) {
                // Update the continuation token.
                existingMonitoredSubscription.continuationToken = sub.continuationToken;
            }
            else {
                this.logInfo(`Subscription ${sub.id} not found in the monitored subscriptions list. Adding it now.`);
                this._monitoredsubscriptions.push({ subscriptionId: sub.id, continuationToken: sub.continuationToken });
            }
            // Trigger the changed subscription to fetch changes via the changelog API:
            // Note that ONS does not yet support a single changelog for multiple subscriptions, so we have
            // to call the changelog separately for each subscription right now.
            const activeSubscription = this.subscriptions.find(activeSub => activeSub.subscriptionId === sub.id);
            if (activeSubscription) {
                activeSubscription.fetchAndNotifyChanges();
            }
        });
        // Quick check on the expire times on the active subscriptions.
        this._validateAndUpdateSubscriptionExpiration();
        // If ONS is worried that our subscription is invalid, verify it is still there. (ONS will do this
        // every few hours no matter what.)
        (_b = notification.checkSubscriptions) === null || _b === void 0 ? void 0 : _b.forEach((checkSub) => {
            const subscription = this.subscriptions.find(sub => sub.subscriptionId === checkSub.id);
            if (subscription) {
                subscription.validate();
            }
        });
    }
    async _ensureAxonVc() {
        var _a;
        const axonClient = await this._onsContext._core._getAxonClient();
        if (!await axonClient.session.ensureEstablished()) {
            throw new Error('Axon Session could not be established!');
        }
        if (this._axonVc && await this._axonVc.ensureActive()) {
            return this._axonVc;
        }
        this.logDebug('ONS Virtual Connection is not active. Will create a new one...');
        this._deactivate();
        const onsSubscriptionConfig = await this._onsContext.getSubscriptionConfig();
        if (!((_a = onsSubscriptionConfig === null || onsSubscriptionConfig === void 0 ? void 0 : onsSubscriptionConfig.onsAxonServiceName) === null || _a === void 0 ? void 0 : _a.length)) {
            throw new Error('Failed to determine ONS Service Id');
        }
        const headers = {
            'x-api-key': this._onsContext._core._environment.getValue('CLIENT_ID'),
            'locale': axonClient.config.locale
        };
        this._axonVc = await axonClient.session.createVc(onsSubscriptionConfig.onsAxonServiceName, headers);
        this._axonVc.on('message', this._onVcMessage);
        this._axonVc.on('error', this._onVcError);
        this._axonVc.on('deleted', this._onVcDeleted);
        return this._axonVc;
    }
    // ONS Subscriptions are more efficient if they are kept alive and updated so we check whether the subscription
    // is within 10% of its TTL and refresh as necessary
    _validateAndUpdateSubscriptionExpiration() {
        const now = Date.now();
        // We calculate the remaining time to live being within a 10% zone of the current time based
        // on environment set TTL with a minimum time remaining being 5 mins.
        const ttl = Math.max(this._onsContext._core._environment.getValue('ONS_SUBSCRIPTION_TIME_TO_LIVE') * 0.1, this._onsContext._core._environment.getValue('ONS_SUBSCRIPTION_RENEW_TIME'));
        this.subscriptions
            .filter(sub => sub.watchedAssets.size && (sub.expiresAt - now) < ttl)
            .forEach(sub => sub.refreshSubscriptionExpiryDate());
    }
    _deactivate() {
        if (!this._axonVc) {
            return;
        }
        this._axonVc.off('message', this._onVcMessage);
        this._axonVc.off('error', this._onVcError);
        this._axonVc.off('deleted', this._onVcDeleted);
        this._axonVc = undefined;
        this._monitoredsubscriptions = [];
    }
    /**
     * Deinitializes the ONS Axon Worker and closes its underlying Virtual Connection to ONS.
     * @returns A promise that resolves to true if the worker is deinitialized, false otherwise.
     */
    async deinitialize() {
        if (!this._axonVc) {
            return true;
        } // VC is already deinitialized.
        const vc = this._axonVc;
        this._deactivate();
        let axonClient;
        if (!vc.isActive()) {
            return true;
        } // VC is inactive.
        try {
            axonClient = await this._onsContext._core._getAxonClient();
            if (!axonClient.isConnected()) {
                return true; // Axon Client is already disconnected.
            }
            if (!await axonClient.session.ensureEstablished()) {
                throw new Error('Axon Session could not be established!');
            }
        }
        catch (error) {
            this.logWarn('ONS Virtual Connection deletion skipped', error);
            return true;
        }
        try {
            return await axonClient.session.deleteVc(vc);
        }
        catch (error) {
            this.logError('Failed to delete ONS Virtual Connection', error);
            return false;
        }
    }
    /**
     * Ensures that the ONS Virtual Connection is created and active.
     * @returns A promise that resolves to true if the ONS Virtual Connection is ready, false otherwise.
     */
    async ensureReady() {
        try {
            const vc = await this._ensureAxonVc();
            if (!await vc.ensureActive()) {
                this.logError('Failed to cquire an active ONS Virtual Connection!');
                return false;
            }
            return true;
        }
        catch (error) {
            this.logError('Failed to get the ONS Virtual Connection', error);
            return false;
        }
    }
    async start() {
        if (!await this.ensureReady()) {
            this.logError(`Failed to acquire Axon virtual connection to the ONS! ONS Axon Worker will not be started.`);
            return;
        }
        if (this.isActive) {
            this.logDebug(`ONS Axon Worker is already started. Skipping this request!`);
            return;
        }
        this.logDebug('Starting ONS Axon Worker...');
        this._isActive = true;
        if (!await this._monitorActiveSubscriptions()) {
            this.logError('Failed to start monitoring of active subscriptions!');
        }
    }
    stop() {
        if (!this.isActive) {
            this.logDebug(`ONS Axon Worker is already stopped! Skipping this request!`);
            return;
        }
        this.logDebug('Stopping ONS Axon Worker...');
        this.subscriptions.forEach((sub) => sub.abort());
        this._isActive = false;
    }
    async _restartMonitoring() {
        if (!this.isActive) {
            this.logDebug('ONS Axon Worker is not active. Skipping this request!');
            return;
        }
        this.logDebug(`Re-starting ONS Monitoring over Axon for active subscriptions: [${this._activeSubscriptionIds.join(',')}].`);
        this.stop();
        this.start();
    }
    get _activeSubscriptionIds() {
        return Array.from(this._subscriptions)
            .filter(sub => sub.subscriptionId && sub.watchedAssets.size > 0) // Note: watchedAssets not assets
            .map(sub => `${sub.subscriptionId}`)
            .sort();
    }
    get _monitoredSubscriptionsIds() {
        return Array.from(this._monitoredsubscriptions)
            .map(sub => `${sub.subscriptionId}`)
            .sort();
    }
    async _monitorActiveSubscriptions() {
        const subscriptionIdsToMonitor = this._activeSubscriptionIds.filter(id => !this._monitoredsubscriptions.find(ms => ms.subscriptionId === id));
        if (subscriptionIdsToMonitor.length === 0) {
            this.logDebug(`No new subscriptions to register for monitoring. Currently monitoring: [${this._monitoredSubscriptionsIds.join(',')}].`);
            return true;
        }
        if (!await this.ensureReady()) {
            this.logError(`Failed to acquire Axon connection to ONS!`);
            return false;
        }
        this.logDebug(`Registering monitoring for new subscriptions: [${subscriptionIdsToMonitor.join(',')}]`);
        try {
            const message = {
                'operationName': 'register',
                'operationId': uuid_1(),
                'body': this._createMonitoringRegistrationRequest(subscriptionIdsToMonitor),
            };
            this.logDebug(`Sending subscription monitoring request over Axon`, message);
            this._axonVc.sendMessage(JSON.stringify(message));
            return true;
        }
        catch (error) {
            this.logError(`Failed to send subscription monitoring request over Axon`, error);
            return false;
        }
    }
    _createMonitoringRegistrationRequest(subscriptionIdsToMonitor) {
        const subscriptionsToRegister = this._subscriptions.filter(sub => sub.subscriptionId && subscriptionIdsToMonitor.includes(sub.subscriptionId));
        // Add the subscriptions to the monitored subscriptions list.
        subscriptionsToRegister.forEach(sub => {
            if (sub.subscriptionId && !this._monitoredsubscriptions.find(ms => ms.subscriptionId === sub.subscriptionId)) {
                this._monitoredsubscriptions.push({ subscriptionId: sub.subscriptionId });
            }
        });
        // Create the registration request for the monitored subscriptions.
        const registerationRequest = {
            'subscriptions': []
        };
        for (const sub of subscriptionsToRegister) {
            if (sub.subscriptionId) {
                registerationRequest.subscriptions.push({ 'id': sub.subscriptionId });
            }
        }
        return registerationRequest;
    }
    async _ensureSubscriptions() {
        // This will create and store instances of ONSSubscription
        // the number created will be the number of MAX_SUBSCRIPTIONS
        // set by SAM.js or service (we don't actually create subscriptions
        // on the server though, unless they have any assets to monitor)
        const maxSubscriptions = this._onsContext._core._environment.getValue('ONS_DEFAULT_MAX_SUBSCRIPTIONS');
        this._maxAssetsPerSubscription = this._onsContext._core._environment.getValue('ONS_DEFAULT_MAX_ASSETS_PER_SUBSCRIPTION');
        if (maxSubscriptions > this._subscriptions.length) {
            // Just because we are creating an ONSSubscription does not mean
            // we are creating a subscription on the service. We actually
            // create the max number of local ONSSubscription allowed by ONS but only
            // create the subscription on the service if there are assets on that subscription.
            // Add new subscriptions
            for (let i = this._subscriptions.length; i < maxSubscriptions; ++i) {
                // If we have a corresponding cached subscription
                // pull the information from cache and construct
                // the ONSSubscription with data from the cache.
                // If the cached subscription information is out of date,
                // it will be handled inside the ONSSubscription.
                const sub = new ONSSubscription(this._onsContext);
                this._subscriptions.push(sub);
                sub.on('change', this._onSubscriptionChange);
            }
        }
        else if (maxSubscriptions < this._subscriptions.length) {
            // Remove subscriptions over the limit
            for (let i = maxSubscriptions; i < this._subscriptions.length; ++i) {
                const sub = this._subscriptions[i];
                sub.assets = new Map();
                sub.off('change', this._onSubscriptionChange);
            }
            this._subscriptions.length = maxSubscriptions; // Removes the overflow from the array.
        }
    }
    _truncateAssetIdsByMaxSizeIfNeeded(assetIds) {
        const maxTotalAssets = this._maxAssetsPerSubscription * this._subscriptions.length;
        if (assetIds.size > maxTotalAssets) {
            this.logWarn(`Number of assets ${assetIds.size} exceeds the maximum allowed by ONS. Limiting to ${maxTotalAssets}`);
            // TODO:
            //this._analytics.reportError('ONSSubscriptionError', `Requested assets exceed number allowed. Count: ${assetIds.length}, Max: ${maxTotalAssets}`);
            assetIds = new Set(Array.from(assetIds).slice(0, maxTotalAssets));
        }
        return assetIds;
    }
    async watch(assetIdsToMonitor) {
        await this._ensureSubscriptions();
        this._assetIds = this._truncateAssetIdsByMaxSizeIfNeeded(assetIdsToMonitor);
        // Map from subscription id to current assets being monitored,
        // (in the form of a map from the asset id to its properties)
        // minus ones we no longer need to monitor:
        // Creates an array and each entry is a
        // Map() that represents the assets in the subscription.
        const existingAssetIds = new Set();
        const subscriptionToAssetIds = Array.from(this._subscriptions.map(sub => {
            const ids = new Map();
            sub.assets.forEach((properties, id) => {
                if (this._assetIds.has(id) && existingAssetIds.add(id)) {
                    ids.set(id, properties);
                }
            });
            return ids;
        }));
        // We assign assets to subscriptions such that we fill up the first subscription first
        // before creating new ones. Note that when this was first implemented in SAM.js, we
        // would try to spread assets across as many subscriptions as possible, because ONS didn't
        // tell us which asset in a subscription changed - but now that we have the changelog API,
        // it's better to concentrate assets in as few subscriptions as possible.
        let nextIndex = 0;
        this._assetIds.forEach(id => {
            // Skip any assets that are already part of a subscription
            if (existingAssetIds.has(id)) {
                return;
            }
            // Find the next subscription with space in it
            while (subscriptionToAssetIds[nextIndex].size >= this._maxAssetsPerSubscription) {
                nextIndex++;
            }
            // Determine if the asset is a directory or not - since we want to do a self monitor of directories:
            const asset = this._onsContext._core.hostAssetContext._assetPool.getLocalItemById(id);
            subscriptionToAssetIds[nextIndex].set(id, (asset === null || asset === void 0 ? void 0 : asset.isFolder) ? { directoryLevel: 'shallow' } : {});
        });
        // Finally, update the actual subscriptions.
        this._subscriptions.forEach((sub, index) => {
            sub.assets = subscriptionToAssetIds[index];
            if (sub.assets.size > 0) {
                this.logDebug(`Subscription #${index} (${sub.subscriptionId}) now has ${sub.assets.size} assets.`);
            }
        });
    }
    /**
     * Logs a debug message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logDebug(message, ...optionalParams) {
        this._onsContext.logger.logDebug(message, 'Axon', ...optionalParams);
    }
    /**
     * Logs an info message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logInfo(message, ...optionalParams) {
        this._onsContext.logger.logInfo(message, 'Axon', ...optionalParams);
    }
    /**
     * Logs a warning message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logWarn(message, ...optionalParams) {
        this._onsContext.logger.logWarn(message, 'Axon', ...optionalParams);
    }
    /**
     * Logs an error message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     * @remarks If the first optional parameter is an Error object, the message will be appended with the error message.
     */
    logError(message, ...optionalParams) {
        this._onsContext.logger.logError(message, 'Axon', ...optionalParams);
    }
}
__decorate([
    synchronized
], ONSAxonWorker.prototype, "deinitialize", null);
__decorate([
    synchronized
], ONSAxonWorker.prototype, "ensureReady", null);
__decorate([
    synchronized
], ONSAxonWorker.prototype, "start", null);
__decorate([
    synchronized
], ONSAxonWorker.prototype, "_restartMonitoring", null);
__decorate([
    synchronized
], ONSAxonWorker.prototype, "_monitorActiveSubscriptions", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const REQUIRED_LINKS = [RelType.SUBSCRIPTION_CREATE, RelType.ONS_CHANGELOG];
const validateRootDocument = (json) => json._links && REQUIRED_LINKS.every(key => json._links[key]);
/**
 * Provides SAM context for Object Notification System (ONS).
 *
 * @experimental This API is in an experimental phase. This and related APIs are subject
 * to modifications during active development and until the maintenance phase is reached.
 */
class ONSContext extends SAMObjectEventEmitter {
    constructor(core, 
    // @TODO SAM-2845 This may be enabled the same in the future but working
    // with the SharedWorker. For now we want to return undefined.
    _cacheEnabled = core._environment.getValue('ENABLE_ONS_CACHE')) {
        super(core);
        this._cacheEnabled = _cacheEnabled;
        this._isStarted = false;
        this._assetsIds = new Set();
        this._onVisibilityChange = () => {
            var _a;
            if (this._stopTimeout) {
                clearTimeout(this._stopTimeout);
                this._stopTimeout = undefined;
            }
            if (((_a = this._document) === null || _a === void 0 ? void 0 : _a.visibilityState) === 'visible') {
                this.worker.start(); // Won't do anything if we didn't stop yet, since still active.
            }
            else {
                // we're de-bouncing to avoid repeatedly stopping/restarting if the user switches between Web browser tabs frequently.
                this._stopTimeout = setTimeout(() => this.worker.stop(), this._core._environment.getValue('ONS_DOCUMENT_VISIBILITY_TIMEOUT')); // 10s
            }
        };
        this._useAxon = core._environment.getValue('ONS_OVER_AXON');
        this._logger = new Logger$2('ONS', core._environment.logSink);
        if (this._core._environment.getValue('ENVIRONMENT') === Env.Stage) {
            // While on Stage, elevate the default log-level to DEBUG.
            this._logger.logLevel = LogLevel$1.DEBUG;
        }
    }
    /**
     * Whether to use Axon as the transport mode for ONS.
     */
    get useAxon() {
        return this._useAxon;
    }
    /**
     * Enables or disables the use of Axon as the transport mode for ONS.
     * @param newValue A boolean indicating whether to use Axon Virtual Connection. If false, Long Poll is used.
     */
    set useAxon(newValue) {
        this.logInfo(`Setting ONS Context transport mode to ${newValue ? 'Axon' : 'Long Poll'}.`);
        if (this._useAxon === newValue) {
            return;
        }
        this._reinitialize(newValue);
    }
    /**
     * Gets the logger.
     */
    get logger() {
        return this._logger;
    }
    /**
     * Whhether the cache is enabled.
     */
    get cacheEnabled() {
        return this._cacheEnabled;
    }
    /**
     * Whether the ONS Worker is active.
     */
    get isActive() {
        if (this._useAxon && this._onsAxonWorker || !this._useAxon && this._onsLongPollWorker) {
            return this.worker.isActive;
        }
        return false;
    }
    /**
     * Whether the ONS Context is started.
     */
    get isStarted() {
        return this._isStarted;
    }
    // TODO: [SHARED-4061] Improve readability of the following code. Note that worker should not be initialize
    // only to check if it's active. This is a temporary solution until we have a better way to check if the worker is active.
    get worker() {
        return this._useAxon ? this._getAxonWorker() : this._getLongPollWorker();
    }
    get watchedAssetIds() {
        const assetIds = new Set();
        this.worker.subscriptions.forEach((sub) => {
            sub.watchedAssets.forEach((properties, assetId) => assetIds.add(assetId));
        });
        return assetIds;
    }
    get _document() {
        if (typeof window !== 'undefined') {
            return window.document;
        }
        return undefined;
    }
    _getAxonWorker() {
        if (this._onsAxonWorker) { // Ensure to maintain a singleton instance.
            return this._onsAxonWorker;
        }
        this._onsAxonWorker = new ONSAxonWorker(this);
        return this._onsAxonWorker;
    }
    _getLongPollWorker() {
        if (this._onsLongPollWorker) { // Ensure to maintain a singleton instance.
            return this._onsLongPollWorker;
        }
        this._onsLongPollWorker = new ONSLongPollWorker(this);
        this._onsLongPollWorker.on(CHANGE, (event) => {
            this.emit(CHANGE, event);
        });
        this._onsLongPollWorker.on(ONS_FIRST_LONG_POLL_STARTED, (event) => {
            this.emit(ONS_FIRST_LONG_POLL_STARTED, event);
        });
        this._onsLongPollWorker.on(ONS_FIRST_LONG_POLL_COMPLETED, (event) => {
            this.emit(ONS_FIRST_LONG_POLL_COMPLETED, event);
        });
        this._onsLongPollWorker.on('aborted', () => {
            this.emit('aborted');
        });
        this._onsLongPollWorker.on('notified', () => {
            this.emit('notified');
        });
        return this._onsLongPollWorker;
    }
    /**
     * Cleanly (re)initializes the ONS Context for the selected transport mode (Axon vs Long Poll).
     * @param useAxon A boolean indicating whether to use Axon Virtual Connection. If false, Long Poll is used.
     */
    async _reinitialize(useAxon) {
        const newModeName = useAxon ? 'Axon' : 'Long Poll';
        this.logInfo(`Reinitializing ONS Context Process for transport mode: ${newModeName}...`);
        const errorHandler = (error) => {
            const errorMessage = `Error initializing ONS Context for transport mode: ${newModeName}`;
            this.logError(errorMessage, error);
        };
        const wasStarted = this.isStarted;
        await this._deinitialize()
            .then((result) => {
            if (!result) {
                throw new Error('Failed to deinitialize ONS Context');
            }
            else {
                this.logInfo('ONS Context deinitialized.');
            }
        })
            .catch(errorHandler);
        this._useAxon = useAxon;
        await this.watch(this._assetsIds)
            .then(() => {
            this.logInfo('ONS Context reinitialized.');
        }).catch(errorHandler);
        if (wasStarted) {
            this.start();
        }
    }
    /**
     * Ensures that the ONS Context is initialized and the underlying connection to ONS is active.
     * @returns A promise that resolves to true if the ONS Context is initialized, false otherwise.
     */
    async ensureInitialized() {
        try {
            return this.worker.ensureReady();
        }
        catch (error) {
            this.logError('Failed to initialize ONS Axon Worker', error);
            return false;
        }
    }
    /**
     * Deinitializes the ONS Context and closes the underlying connection to ONS.
     * @returns A promise that resolves to true if the ONS Context is deinitialized, false otherwise.
     */
    async _deinitialize() {
        this.logInfo('Deinitializing ONS Context...');
        if (this.isStarted) {
            this.stop();
        }
        const result = this.worker.deinitialize();
        if (this._useAxon) {
            this._onsAxonWorker = undefined;
        }
        else {
            this._onsLongPollWorker = undefined;
        }
        return result;
    }
    /**
     * Activate ONS Context.
     */
    start() {
        var _a;
        if (this._isStarted) {
            this.logDebug('ONS Context is already active! Skipping activation call...');
            return;
        }
        this.logInfo('Activating ONS Context...');
        this._isStarted = true;
        (_a = this._document) === null || _a === void 0 ? void 0 : _a.addEventListener('visibilitychange', this._onVisibilityChange);
        if (!this._document || this._document.visibilityState === 'visible') {
            this.worker.start();
        }
    }
    /**
     * Deactivate ONS Context.
     */
    stop() {
        var _a;
        if (!this._isStarted) {
            this.logDebug('ONS Context is inactive! Skipping deactivation call...');
            return;
        }
        this.logInfo('Deactivating ONS Context...');
        this._isStarted = false;
        (_a = this._document) === null || _a === void 0 ? void 0 : _a.removeEventListener('visibilitychange', this._onVisibilityChange);
        if (this._stopTimeout) {
            clearTimeout(this._stopTimeout);
            this._stopTimeout = undefined;
        }
        this.worker.stop();
    }
    /**
     * Watches an array of assetIds.
     *
     * @param {Array} assetIds
     */
    async watch(assetIds) {
        const assetIdsToMonitor = new Set();
        assetIds.forEach(id => {
            var _a;
            const asset = this._core.hostAssetContext._assetPool.getLocalItemById(id);
            if (!asset || asset.isFolder) {
                assetIdsToMonitor.add(id);
                this.logDebug(`Will unconditionally monitor asset ${id} of type ${(asset === null || asset === void 0 ? void 0 : asset.isFolder) ? 'folder' : 'unknown'}.`);
                return;
            }
            // If we're also monitoring the parent, we'll skip adding the asset to ONS subscription,
            // since shallow directory monitoring of the parent covers all children.
            const parentId = (_a = asset === null || asset === void 0 ? void 0 : asset.ancestorIDs) === null || _a === void 0 ? void 0 : _a.at(-1);
            if (!parentId) {
                assetIdsToMonitor.add(id);
                this.logDebug(`Will monitor asset ${id} because it has no parent.`);
            }
            else if (!assetIds.has(parentId)) {
                assetIdsToMonitor.add(id);
                this.logDebug(`Will monitor asset ${id} because its parent is unknown.`);
            }
            else {
                this.logDebug(`Asset ${id} will be monitored via shallow monitoring of its parent ${parentId}`);
            }
        });
        this._assetsIds = assetIdsToMonitor;
        this.logDebug(`Watching ${this._assetsIds.size} asset(s):`, this._assetsIds);
        if (await this.ensureInitialized()) {
            return this.worker.watch(this._assetsIds);
        }
        else {
            this.logError('Failed to watch assets due to ONS Context initialization error.');
        }
    }
    async _getAndCacheDocument(href) {
        const response = await this._core._environment.fetch(href, {
            headers: {
                Accept: 'application/vnd.syncservice.v2.hal+json'
            },
            authHeader: ONS_AUTH_HEADER
        });
        return response.json();
    }
    async _getSyncServiceDiscovery() {
        var _a;
        const discovery = await this._getAndCacheDocument(`https://${this._core._environment.endpoints.SYNC_SERVICE_HOST}/api/v1`);
        if (!this.useAxon) {
            // Ensure that the discovery comes with necessary Long Poll link.
            if (!((_a = discovery === null || discovery === void 0 ? void 0 : discovery._links) === null || _a === void 0 ? void 0 : _a[RelType.NOTIFICATIONS_LONGPOLL])) {
                throw SAMError.create(SAMErrorCode.UNKNOWN, 'Invalid Sync Service Discovery (Missing the required link for Long Poll).');
            }
        }
        return discovery;
    }
    async getSubscriptionConfig() {
        var _a, _b;
        try {
            const rootDocument = await this._getSyncServiceDiscovery();
            return (_b = (_a = rootDocument === null || rootDocument === void 0 ? void 0 : rootDocument.config) === null || _a === void 0 ? void 0 : _a.subscriptions) !== null && _b !== void 0 ? _b : {};
        }
        catch (e) {
            this.logInfo(`Error fetching ONS subscription config from the Sync Service Discovery: ${e}`);
            return {};
        }
    }
    async getLink(key, options = {}) {
        const rootDocument = await this._getSyncServiceDiscovery();
        return getURLFromLinks(rootDocument._links, key, options);
    }
    /**
     * Logs a debug message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logDebug(message, ...optionalParams) {
        this._logger.logDebug(message, 'Context', ...optionalParams);
    }
    /**
     * Logs an info message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logInfo(message, ...optionalParams) {
        this._logger.logInfo(message, 'Context', ...optionalParams);
    }
    /**
     * Logs a warning message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     */
    logWarn(message, ...optionalParams) {
        this._logger.logWarn(message, 'Context', ...optionalParams);
    }
    /**
     * Logs an error message.
     * @param message - Message to log.
     * @param optionalParams - Optional objects to stringify and log after the message.
     * @remarks If the first optional parameter is an Error object, the message will be appended with the error message.
     */
    logError(message, ...optionalParams) {
        this._logger.logError(message, 'Context', ...optionalParams);
    }
}
__decorate([
    synchronized
], ONSContext.prototype, "ensureInitialized", null);
__decorate([
    synchronized
], ONSContext.prototype, "_deinitialize", null);
__decorate([
    synchronized
], ONSContext.prototype, "watch", null);
__decorate([
    cache(validateRootDocument),
    __param(0, key)
], ONSContext.prototype, "_getAndCacheDocument", null);

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2025 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
class LocalAdobeAssetFilter extends ImplicitAdobeAssetFilterBase {
    matches(item) {
        // Only show assets that are local (i.e. are available offline).
        if (!item.isAvailableOffline) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ImplicitFavoriteAdobeAssetFilter extends ImplicitAdobeAssetFilterBase {
    constructor() {
        super({ _isSharedWithYou: true });
    }
    matches(item) {
        return item.isFavorite === true;
    }
}

class FavoriteAdobeAssetLoader {
    constructor(_core) {
        this._core = _core;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    // fetch a page of assets from the service
    // use the data to instantiate assets
    // build next page link and recursively call _loadPage if necessary
    // return ILoadedPage<FavoriteAdobeAssetConfig>
    async _loadPage(options, after) {
        const gqlManager = await this._core._getGQLManager();
        const { mediaTypes } = options.filter;
        const { field, direction } = options.order;
        const { favorites, pageInfo } = await gqlManager.getFavorites({
            first: options.limit || 20,
            after,
            filter: mediaTypes ? { dc_format: [...mediaTypes].sort() } : undefined,
            orderBy: {
                field: field === 'name' ? 'NAME' : 'CREATE_DATE',
                direction: direction === 'ascending' ? 'ASCENDING' : 'DESCENDING'
            }
        });
        const latency = this._core._environment.getValue('GQL_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const session = this._core
            ._getAssetPool()
            .createLoaderUpdateSession(mostRecentValidMutation);
        const items = AdobeAssetUpdater.updateRemoteItems(session, favorites);
        session.commit();
        let loadNextPage;
        if (pageInfo.hasNextPage) {
            loadNextPage = (options) => this._loadPage(options, pageInfo.endCursor);
        }
        return {
            items,
            loadNextPage,
            // TODO: request total count come back as apart of AssetListConnection
            // total: data.total
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Must be kept in sync with CloudSyncStatus in CCAssetContext.h
var CloudSyncStatus;
(function (CloudSyncStatus) {
    CloudSyncStatus[CloudSyncStatus["Initializing"] = 0] = "Initializing";
    CloudSyncStatus[CloudSyncStatus["Offline"] = 1] = "Offline";
    CloudSyncStatus[CloudSyncStatus["NotStarted"] = 2] = "NotStarted";
    CloudSyncStatus[CloudSyncStatus["Disabled"] = 3] = "Disabled";
    CloudSyncStatus[CloudSyncStatus["Synchronized"] = 4] = "Synchronized";
    CloudSyncStatus[CloudSyncStatus["InProgress"] = 5] = "InProgress";
    CloudSyncStatus[CloudSyncStatus["ErrorQuotaExceeded"] = 6] = "ErrorQuotaExceeded";
    CloudSyncStatus[CloudSyncStatus["ErrorSyncDown"] = 7] = "ErrorSyncDown";
    CloudSyncStatus[CloudSyncStatus["ErrorOther"] = 8] = "ErrorOther";
})(CloudSyncStatus || (CloudSyncStatus = {}));
class AssetContext extends SAMObjectEventEmitter {
    constructor(_core, 
    /**
     * @package -- only for use in SAM.js
     */
    _assetPool) {
        super(_core);
        this._core = _core;
        this._assetPool = _assetPool;
        /**
         * @package -- for use in SAM.js only
         */
        this._rapi = new RepositoryInterface(this._core);
        /**
         * @package -- for use in SAM.js only
         */
        this._invitationInterface = new InvitationInterface(this._core);
        /**
         * @package -- for use in SAM.js only
         */
        this._ussInterface = new USSInterface(this._core);
        this._SBMInterface = new SBMInterface(this._core);
        /**
         * @package -- for use in SAM.js only
         */
        this._swyInterface = new SWYInterface(this._core);
        /**
         * @package -- for use in SAM.js only
         */
        this._recentInterface = new RecentInterface(this._core);
        /**
         * @package -- for use in SAM.js only
         */
        this._adobeAssetSearchInterface = new AdobeAssetSearchInterface(this._core);
        /**
         * @package -- for use in SAM.js only
         */
        this._adobeAssetGlobalSearchInterface = new AdobeAssetGlobalSearchInterface(this._core);
        this._assetTransferService = new AssetTransferInterface(this._core);
        this._assetReviewServiceInterface = new AssetReviewServiceInterface(this._core);
        /**
         * @package -- for use in SAM.js only
         */
        this._publishedInterface = new PublishedInterface(this._core);
        this._discardedInterface = new DiscardedInterface(this._core);
        /**
         * @package -- for use in SAM.js only
         */
        this.__ussInterfaceV3 = new USSv3Interface(this._core);
        /**
         * @package -- only for use in SAM.js
         */
        this._globalSearchInterfaceV3 = new GlobalSearchInterface(this._core, this.__ussInterfaceV3);
        /**
         * @package -- only for use in SAM.js
         */
        this._libraryInterface = new LibraryInterface(this._core);
        /**
         * @package -- only for use in SAM.js
         */
        this._acplModelInterface = new ACPLModelInterface(this._core);
        this._commentsById = new Map();
        /**
         * @package -- only for use in SAM.js
         * Updaters shouldn't be accessed directly.
         */
        this._adobeAssetUpdater = AdobeAssetUpdater;
        this._onHomeFolderChange = () => {
            // Clear cached /index so it gets refreshed on next request
            this._rapi._clearIndexCache();
        };
        // Called when we get a notification from ONS - we reload any assets when we find out they changed
        this._onOnsAssetChangeEvent = (event) => {
            // Update any assets in the pool
            event.changedAssets.forEach((assetInfo, assetID) => {
                // Route annotation notifications to corresponding CommentsResource.
                // Use the assetID instead of the asset, as it's possible to have the
                // comments without the asset, such as
                //      const comments = await assetContext.getCommentsResource(assetId);
                var _a, _b;
                if ((_a = assetInfo.changedResources) === null || _a === void 0 ? void 0 : _a.includes('api:annotation')) {
                    const commentsResource = (_b = this._commentsById.get(assetID)) === null || _b === void 0 ? void 0 : _b.deref();
                    if (commentsResource) {
                        commentsResource._onONSNotification(assetInfo);
                    }
                }
                const asset = this._assetPool.getLocalItemById(assetID);
                if (asset) {
                    asset.handleOnsChangedResources(assetInfo.changedResources);
                }
                else if (assetInfo.parentAssetId && this._assetPool.getLocalItemById(assetInfo.parentAssetId)) {
                    // Check for items that were added remotely to a folder that we're monitoring (e.g. move, restore, discard,\
                    // and copy can cause an item to appear in a folder that is being monitored). This will cause any list of children
                    // for the folder to be updated when a new asset is added to it.
                    //
                    // Note that we ONLY do this if the parent asset is loaded - in the case where we're monitoring asset ids
                    // directly via the link list, as the CC Library process does, no AdobeAssets are loaded (SAM is only used
                    // to get the notifications). So if we always loaded the asset here it would introduce unnecessary network
                    // calls. In the folder listing case, we always have the parent asset loaded, so this is safe.
                    const parentAsset = this._assetPool.getLocalItemById(assetInfo.parentAssetId);
                    if (parentAsset._canLoadNewChildrenFromONSNotification) {
                        this._getAssetById(assetID, undefined, true);
                    }
                }
            });
            // If AssetLinkManager hasn't been used, we don't need to
            // look through each list.
            const changedIDs = new Set(event.changedAssets.keys());
            const alm = this._getAssetLinkManager();
            if (alm) {
                // Also refresh any links that changed
                alm.lists.forEach(list => list._refreshLinksForChangedAssets(changedIDs));
            }
        };
        /**
         * Event handler for the ItemPool's ITEMS_CHANGED event
         *
         *  @package -- only for use in SAM.js
         */
        this._onAssetsChanged = (e) => {
            var _a;
            // ItemsChangedEvent should ignore assets queued for removal from the pool
            const excludeAssetIDs = (_a = e === null || e === void 0 ? void 0 : e.discardedItems) === null || _a === void 0 ? void 0 : _a.map(asset => asset.id);
            this._updateONSSubscriptions(excludeAssetIDs);
        };
        this._organizationsResource = new Resource(this._core, {
            onChange: async (organizationsResponse) => {
                this._defaultOrganizationId = organizationsResponse === null || organizationsResponse === void 0 ? void 0 : organizationsResponse.default;
                this._organizations = organizationsResponse === null || organizationsResponse === void 0 ? void 0 : organizationsResponse.children.map(org => ({
                    id: org['organization:id'],
                    name: org['organization:name'] || ''
                }));
            }
        });
        // We want to know all the asset ids that we care about, so we can register for change
        // notifications with ONS. This consists of all loaded assets in the asset pool.
        this._assetPool.on(ITEMS_CHANGED, this._onAssetsChanged);
        LazyLoadManager.manageLazyLoading(this, [{
                event: OrganizationsChangedEventInstance,
                fetchData: this._fetchOrganizations,
                // [SHARED-3811] there's no reason to allow cancelling lazy-loading of orgs
                prefetchTimeout: 0
            }]);
        // Handle dynamic configuration change.
        this._core.on(CONFIG_CHANGE, (event, sender, payload) => {
            switch (payload.configurationKeyName) {
                case 'ONS_OVER_AXON':
                    if (this._core._environment.getValue('ENVIRONMENT') === Env.Stage) {
                        if (this.onsContext) {
                            this.onsContext.useAxon = this._core._environment.getValue('ONS_OVER_AXON');
                        }
                    }
                    else {
                        console.warn('Runtime config update for ONS_OVER_AXON is only supported in the Stage environment.');
                    }
                    break;
            }
        });
    }
    /** @package -- for use in SAM.js only */
    async _getONSContext() {
        if (this._OnsContext) {
            return this._OnsContext;
        }
        this._OnsContext = new ONSContext(this._core);
        // When an ONS notification comes in, we go through and refresh any assets that changed
        this._OnsContext.on(CHANGE, this._onOnsAssetChangeEvent);
        this._OnsContext.on(ONS_FIRST_LONG_POLL_STARTED, data => {
            this.dispatch(new ONSFirstLongPollStartedEvent(data.cachedSubscriptionsUsed));
        });
        this._OnsContext.on(ONS_FIRST_LONG_POLL_COMPLETED, data => {
            this.dispatch(new ONSFirstLongPollCompletedEvent(data.expired));
        });
        return this._OnsContext;
    }
    /**
     * Gets OnsContext.
     * @package -- for use in SAM.js only
     */
    get onsContext() {
        return this._OnsContext;
    }
    /**
     * @package -- for use in SAM.js only
     * @deprecated -- will be removed on or after 2024-10-01.
     */
    get repoInterface() {
        oneTimeWarning('AssetContext.repoInterface', 'AssetContext.repoInterface is deprecated and will be removed'
            + ' on or after 2024-10-01. It is for internal SAM.js use only.');
        return this._rapi;
    }
    /**
     * @package -- for use in SAM.js only
     * @deprecated -- will be removed on or after 2024-10-01.
     */
    get ussInterface() {
        oneTimeWarning('AssetContext.ussInterface', 'AssetContext.ussInterface is deprecated and will be removed'
            + ' on or after 2024-10-01. It is for internal SAM.js use only.');
        return this._ussInterface;
    }
    /**
     * @package -- for use in SAM.js only
     * @deprecated -- will be removed on or after 2024-10-01.
     */
    get ussInterfaceV3() {
        oneTimeWarning('AssetContext.ussInterfaceV3', 'AssetContext.ussInterfaceV3 is deprecated and will be removed'
            + ' on or after 2024-10-01. It is for internal SAM.js use only.');
        return this.__ussInterfaceV3;
    }
    /**
     * @deprecated -- will be removed on or after 2024-10-01 with no replacement.
     */
    get sbmInterface() {
        oneTimeWarning('AssetContext.sbmInterface', 'AssetContext.sbmInterface is deprecated and will be removed'
            + ' on or after 2024-10-01.');
        return this._SBMInterface;
    }
    /**
     * @package -- for use in SAM.js only
     * @deprecated -- will be removed on or after 2024-10-01.
     */
    get swyInterface() {
        oneTimeWarning('AssetContext.swyInterface', 'AssetContext.swyInterface is deprecated and will be removed'
            + ' on or after 2024-10-01. It is for internal SAM.js use only.');
        return this._swyInterface;
    }
    /**
     * @package -- for use in SAM.js only
     * @deprecated -- will be removed on or after 2024-10-01.
     */
    get recentInterface() {
        oneTimeWarning('AssetContext.recentInterface', 'AssetContext.recentInterface is deprecated and will be removed'
            + ' on or after 2024-10-01. It is for internal SAM.js use only.');
        return this._recentInterface;
    }
    /**
     * @package -- for use in SAM.js only
     * @deprecated -- will be removed on or after 2024-10-01.
     */
    get invitationInterface() {
        oneTimeWarning('AssetContext.invitationInterface', 'AssetContext.invitationInterface is deprecated and will be removed'
            + ' on or after 2024-10-01. It is for internal SAM.js use only.');
        return this._invitationInterface;
    }
    /**
     * @package -- for use in SAM.js only
     * @deprecated -- will be removed on or after 2024-10-01.
     */
    get publishedInterface() {
        oneTimeWarning('AssetContext.publishedInterface', 'AssetContext.publishedInterface is deprecated and will be removed'
            + ' on or after 2024-10-01. It is for internal SAM.js use only.');
        return this._publishedInterface;
    }
    /**
     * @package -- for internal use only
     * @deprecated -- will be removed on or after 2024-10-01.
     */
    get assetPool() {
        oneTimeWarning('AsseContext._assetPool', 'AssetContext._assetPool is deprecated and will be removed on or after'
            + ' 2024-10-01. ItemPools are for internal SAM.js use only.');
        return this._assetPool;
    }
    get sharedSource() {
        const implicitFilter = new SWYAdobeAssetFilter();
        const swyloader = new SWYAdobeAssetLoader(this._assetPool, this._core, this._swyInterface);
        const localAssetsLoader = new LocalAssetLoader(this._assetPool, this._core);
        return new ItemSource(this._assetPool, [swyloader, localAssetsLoader], implicitFilter);
    }
    get recentAssetsSource() {
        const implicitFilter = new RecentAdobeAssetFilter();
        const recentAssetsLoader = new RecentAdobeAssetLoader(this._assetPool, this._core, this._recentInterface, implicitFilter);
        const localAssetsLoader = new LocalAssetLoader(this._assetPool, this._core);
        implicitFilter._lastModificationDate = new Date(9999, 0, 1);
        return new ItemSource(this._assetPool, [recentAssetsLoader, localAssetsLoader], implicitFilter);
    }
    get favoriteAssetsSource() {
        return new ItemSource(this._assetPool, [new FavoriteAdobeAssetLoader(this._core)], new ImplicitFavoriteAdobeAssetFilter());
    }
    get MRUAssetsSource() {
        const implicitFilter = new MRUAdobeAssetFilter();
        const MRUAssetsLoader = new MRUAdobeAssetLoader(this._assetPool, this._core, this._recentInterface);
        const localAssetsLoader = new LocalAssetLoader(this._assetPool, this._core);
        return new ItemSource(this._assetPool, [MRUAssetsLoader, localAssetsLoader], implicitFilter);
    }
    get publishedSource() {
        const implicitFilter = new PublishedAdobeAssetFilter();
        const publishedLoader = new PublishedAdobeAssetLoader(this._assetPool, this._core, this._publishedInterface);
        return new ItemSource(this._assetPool, [publishedLoader], implicitFilter);
    }
    get discardedSource() {
        const implicitFilter = new DiscardedAdobeAssetFilter();
        const loader = new DiscardedAdobeAssetLoader(this._assetPool, this._core, this._discardedInterface);
        return new ItemSource(this._assetPool, [loader], implicitFilter);
    }
    /**
     * A source that only contains local assets.
     */
    get localRecentsSource() {
        if (this._acplModelInterface.supportsLocalAssets) {
            const localAssetLoader = new LocalAssetLoader(this._assetPool, this._core);
            const implicitFilter = new LocalAdobeAssetFilter();
            return new ItemSource(this._assetPool, [localAssetLoader], implicitFilter);
        }
        else {
            return undefined;
        }
    }
    /**
     * Provides an instance of AssetLinkManager.
     */
    async getAssetLinkManager() {
        if (this._AssetLinkManager) {
            return this._AssetLinkManager;
        }
        const AssetLinkManager = (await Promise.resolve().then(function () { return AssetLinkManager$1; })).default;
        this._AssetLinkManager = new AssetLinkManager(this);
        return this._AssetLinkManager;
    }
    /**
     * @package - used internally to get the cached instance of
     * AssetLinkManager.
     */
    _getAssetLinkManager() {
        return this._AssetLinkManager;
    }
    getGlobalSearchAssetsSource(query) {
        const implicitFilter = new AdobeAssetGlobalSearchFilter({
            _query: query,
            _matchingIDsFromSearch: new Set()
        });
        const globalSearchLoader = new AdobeAssetGlobalSearchLoader(this._assetPool, implicitFilter, this._core, this._adobeAssetGlobalSearchInterface);
        return new ItemSource(this._assetPool, [globalSearchLoader], implicitFilter);
    }
    /**
     * Experimental -- this is for early integration by Project X and will be removed
     * in the future.  When the real API is ready, this method will be marked deprecated
     * at that time.
     */
    getGlobalSearchAssetsSourceV3(query) {
        const implicitFilter = new AdobeAssetGlobalSearchFilter({
            _query: query,
            _matchingIDsFromSearch: new Set()
        });
        const globalSearchLoader = new GlobalSearchLoader(this._assetPool, this._core, this._globalSearchInterfaceV3, implicitFilter);
        return new ItemSource(this._assetPool, [globalSearchLoader], implicitFilter);
    }
    /**
     * Clients should use isOnline() to determine online/offline status so that SAM is responsible for encapsulating
     * which values of NetworkStatus mean "online" vs "offline".
     */
    get isOnline() {
        oneTimeWarning('AssetContext.isOnline', 'AssetContext.isOnline() is not fully implemented for web');
        return this.networkStatus !== NetworkStatus$1.Offline;
    }
    /**
     * Use for fine-grain network status (WAN vs Cellular). For offline/online, use isOnline() above.
     */
    get networkStatus() {
        oneTimeWarning('AssetContext.networkStatus', 'AssetContext.networkStatus is not fully implemented for web');
        return NetworkStatus$1.OnlineUnknown;
    }
    /**
     * Gets an Asset from cache, or loads it from the cloud. If ONS is disabled, it will also refresh
     * cached Assets as well.
     *
     * Uses @synchronized to ensure only one request for a particular Asset can be serviced at a time,
     * which prevents race conditions due to multiple load requests for the same Asset stepping on
     * one another.
     *
     * @param assetId {string}
     * @param resolveMetadata {RepositoryMetadata} -- For getAssetWith* calls that have already resolved the
     *        Asset repo metadata to get the assetId, so additional resolve requests are unnecessary.
     * @returns Promise<AdobeAsset>
     * @private
     */
    async _getAssetById(assetId, repoMetadataResource, forONSNotification) {
        var _a, _b, _c;
        const asset = (_a = this._assetPool.getLocalItemById(assetId)) !== null && _a !== void 0 ? _a : await this._acplModelInterface.getLocalAsset(assetId);
        if (asset) {
            // Force refresh if ONS is disabled, because the data may be stale
            const forceRefresh = this._core._environment.getValue('DISABLE_ONS') || asset.needsRepoMetadata;
            if (forceRefresh) {
                // If the reload fails, we still return the asset but schedule a retry - that's equivalent to using the
                // cached data for the asset (e.g. if go offline), and having the asset update later.
                // @TODO Another potential optimisation here is to not load the project metadata again if we come to this
                // code path because the project lacks repo metadata and ONS is enabled.
                await asset._loadWithRetry();
            }
            else if (!asset._linksCameFromResolveAPI) {
                // No resolve metadata was passed in, or the links metadata came from listings,
                // which might be stale (esp. from USS). Assume that the metadata is likely up-to-date,
                // but refresh in the background in case it isn't.
                this._rapi.getAssetLinks(assetId).then((links) => {
                    const session = this._assetPool.createUpdateSession();
                    this._adobeAssetUpdater.updateLocalItem(session, asset, {
                        _links: links
                    });
                    asset._linksCameFromResolveAPI = true;
                    session.commit();
                });
            }
            return asset;
        }
        const appMetadataResource = new AppMetadataResource(this._core);
        const effectivePermissionsResource = new EffectivePermissionsResource(this._core);
        const perUserMetadataResource = new PerUserMetadataResource(this._core);
        let appMetadata = {};
        let permission;
        let repoMetadata;
        let assetPerUserMetadata;
        const useGraphQL = (_b = this._core._environment.getValue('FEATURE_FLAGS')) === null || _b === void 0 ? void 0 : _b['use-graphql'];
        if (!useGraphQL) {
            if (!repoMetadataResource) {
                repoMetadataResource = new RepoMetadataResource(this._core);
                await this._rapi.getRepoMetadataById(assetId, repoMetadataResource);
            }
            repoMetadata = repoMetadataResource.data;
            const assetInterface = new AssetInterface(this._rapi, assetId, repoMetadata._links, repoMetadata['repo:etag']);
            await assetInterface.getEffectivePermissions(effectivePermissionsResource);
            permission = effectivePermissionsResource.data;
            if ((permission & Permission.ReadAppMetadata) === Permission.ReadAppMetadata) {
                await assetInterface.getAppMetadata(appMetadataResource);
                appMetadata = appMetadataResource.data;
            }
        }
        else {
            const gqlManager = await this._core._getGQLManager();
            const _d = await gqlManager.getAssetById(assetId), { effectivePermission, perUserMetadata, _embedded } = _d, adobeAssetData = __rest$2(_d, ["effectivePermission", "perUserMetadata", "_embedded"]);
            repoMetadata = adobeAssetData;
            if (!repoMetadataResource) {
                repoMetadataResource = new RepoMetadataResource(this._core);
            }
            await repoMetadataResource._setData(repoMetadata);
            permission = effectivePermission;
            await effectivePermissionsResource._setData(permission);
            appMetadata = (_c = _embedded === null || _embedded === void 0 ? void 0 : _embedded[RelType.APP_METADATA]) !== null && _c !== void 0 ? _c : {};
            await appMetadataResource._setData(appMetadata);
            assetPerUserMetadata = perUserMetadata;
            await perUserMetadataResource._setData(assetPerUserMetadata);
        }
        const libraryContext = await this._core.getLibraryContext();
        const projectInterface = new ProjectsInterface(this._core);
        const studentAssignmentInterface = new StudentAssignmentsInterface(this._core);
        // Check if this is a Project and populate some params for assetFromRepoMetadata.
        let projectMetadata;
        let studentAssignmentMetadata = {};
        const isProject = appMetadataIsProject(appMetadata);
        const isStudentAssignment = metadataIsStudentAssignment({ appMetadata, repoMetadata });
        if (isProject) {
            projectMetadata = await projectInterface.getProject(repoMetadata['repo:assetId']);
        }
        else if (isStudentAssignment) {
            const remoteStudentAssignment = await studentAssignmentInterface.getStudentAssignment(assetId, undefined, { [RequestHeaders.PREFER_RAPI]: 'true' });
            studentAssignmentMetadata = this.repoToStudentAssignmentData(repoMetadata, Object.assign(Object.assign({}, appMetadata), remoteStudentAssignment));
        }
        // Check if this is a Generation History Asset and populate generationModelDisplayName
        let generationHistoryContext;
        const isGenerationHistoryAsset = repoMetadataIsGenerationHistoryAsset(repoMetadata);
        let generationHistoryMetadata = {};
        if (isGenerationHistoryAsset) {
            generationHistoryContext = await this._core.getGenerationHistoryContext();
            generationHistoryMetadata = (await generationHistoryContext._generationHistoryInterface.getGenerationHistoryAssetById(assetId));
        }
        const session = this._assetPool.createMutationSession();
        const newAsset = this._core._adobeAssetFactory.assetFromRepoMetadata(session, repoMetadata, permission, appMetadata, libraryContext, projectMetadata, isStudentAssignment ? studentAssignmentMetadata : undefined, assetPerUserMetadata, generationHistoryContext, isGenerationHistoryAsset ? generationHistoryMetadata : undefined);
        // Mark storage:assignee as loaded, if it is set from repo:metadata
        if (repoMetadata && repoMetadata['storage:assignee'] && newAsset._storageAssignee_NoLazyLoad.id === repoMetadata['storage:assignee'].id) {
            LazyLoadManager.updatedByItemUpdater(newAsset, STORAGE_ASSIGNEE_CHANGED);
        }
        session.commit();
        newAsset._setResources({
            repoMetadataResource,
            appMetadataResource,
            effectivePermissionsResource,
            perUserMetadataResource
        });
        if (isProject) {
            await newAsset._load({
                repoMetadata,
                appMetadata,
                effectivePermission: permission,
                projectMetadata,
                perUserMetadata: assetPerUserMetadata
            });
        }
        else if (isStudentAssignment) {
            await newAsset._load({
                repoMetadata: studentAssignmentMetadata,
                appMetadata,
                effectivePermission: permission,
                perUserMetadata: assetPerUserMetadata,
                // we don't need to fetch the student assignment metadata again
                doFetchStudentAssignmentMetadata: false
            });
        }
        else if (isLibrary(newAsset)) {
            await newAsset._load({
                repoMetadata,
                appMetadata,
                effectivePermission: permission,
                perUserMetadata: assetPerUserMetadata,
                requireLibraryDataFetch: forONSNotification
            });
        }
        else {
            await newAsset._load({
                repoMetadata,
                appMetadata,
                effectivePermission: permission,
                perUserMetadata: assetPerUserMetadata
            });
        }
        newAsset._linksCameFromResolveAPI = true;
        return newAsset;
    }
    /**
     * Returns the "/" folder for USM users and the "/users/<user-id>" folder for ESM user. For access to the
     * "/cloud-content" folder for the current user, use `getRootFolder()`
     */
    async getHomeFolder() {
        if (!this._homeFolder) {
            const homeDirectoryMetadata = await this._rapi.getHomeDirectoryMetadata();
            this._cacheHomeFolder(homeDirectoryMetadata);
        }
        return this._homeFolder;
    }
    _cacheHomeFolder(homeDirectoryMetadata) {
        const session = this._assetPool.createMutationSession();
        this._homeFolder = this._adobeAssetUpdater.updateRemoteItem(session, homeDirectoryMetadata);
        session.commit();
        this._homeFolder.on(CHANGE, this._onHomeFolderChange);
    }
    /**
     * Gets the current user's `/cloud-content` folder. If the folder does not exist, it will be
     * created.
     */
    async getRootFolder() {
        var _a;
        if (!this._rootFolder) {
            const useGraphQL = (_a = this._core._environment.getValue('FEATURE_FLAGS')) === null || _a === void 0 ? void 0 : _a['use-graphql'];
            if (useGraphQL) {
                const gqlManager = await this._core._getGQLManager();
                let rootFolderMetadata;
                // if home folder is cached, use it to get the root folder
                if (this._homeFolder) {
                    const assetPath = pathBrowserify.join(this._homeFolder.repoPath, CLOUD_CONTENT_ROOT_FOLDER);
                    rootFolderMetadata = (await gqlManager.getAssetByPath(assetPath, this._homeFolder.repositoryID)).assetData;
                }
                else {
                    // if home folder is not cached, get both the root folder and the home folder
                    const getAssetByPathResult = await gqlManager.getAssetByPath(CLOUD_CONTENT_ROOT_FOLDER);
                    rootFolderMetadata = getAssetByPathResult.assetData;
                    const homeFolderData = getAssetByPathResult.homeFolderData;
                    this._cacheHomeFolder(homeFolderData);
                }
                const session = this._assetPool.createUpdateSession();
                this._rootFolder = this._adobeAssetUpdater.updateRemoteItem(session, rootFolderMetadata);
                session.commit();
            }
            else {
                this._rootFolder = await this._getAssetWithRepoPathImpl(CLOUD_CONTENT_ROOT_FOLDER);
            }
        }
        return this._rootFolder;
    }
    async getUserRepoID() {
        return this.getHomeFolder().then((asset) => asset.repositoryID);
    }
    async getAssetWithCloudID(assetId, confirmAccess = false) {
        if (confirmAccess) {
            const collaborationContext = await this._core.getCollaborationContext();
            await collaborationContext.confirmAccess(assetId);
        }
        return this._getAssetById(assetId);
    }
    /**
     * @package -- only for use in SAM.js
     */
    async _getAssetRepoDataWithWithCloudID(assetId) {
        const repoMetadataResource = new RepoMetadataResource(this._core);
        await this._rapi.getRepoMetadataById(assetId, repoMetadataResource);
        return repoMetadataResource;
    }
    /**
     * Resolves the Asset at the given assetPath. If repositoryId is not passed, it will look up the repositoryId
     * for the current user, and assume that the path is relative to the user's home directory (`/` for USM users,
     * `/users/<userId>` for ESM users). If the repositoryId is passed, then the path is assumed to be absolute.
     *
     * @example <caption>Assuming 'xyz' is the current userId and 'abc' is the repositoryId</caption>
     *    getAssetWithRepoPath('/cloud-content');                  // returns /users/xyz/cloud-content
     *    getAssetWithRepoPath('/users/xyz/cloud-content', 'abc'); // "
     *    getAssetWithRepoPath('/users/xyz/cloud-content');        // NOT_FOUND error
     *
     * @param assetPath {string}
     * @param repositoryId {string} (optional)
     * @return AdobeAsset
     */
    async getAssetWithRepoPath(assetPath, repositoryId) {
        // cache and use the cloud-content folder
        if (assetPath === CLOUD_CONTENT_ROOT_FOLDER) {
            return this.getRootFolder();
        }
        return this._getAssetWithRepoPathImpl(assetPath, repositoryId);
    }
    /**
     * A small abstraction to get the repository metadata and resources for a given asset path and repository ID.
     * @package -- only for use in SAM.js
     *
     * @param assetPath The path to get the repository metadata for.
     * @param repositoryId The repository ID to get the repository metadata for.
     * @returns The repository metadata for the given asset path and repository ID.
     */
    async _getRepoDataByPath(assetPath, repositoryId) {
        const repoMetadataResource = new RepoMetadataResource(this._core);
        const data = await this._rapi.getRepoMetadataByPath(repositoryId, assetPath, repoMetadataResource);
        repoMetadataResource._setData(data);
        return repoMetadataResource;
    }
    /**
     * @package -- only for use in SAM.js
     */
    async _getAssetWithRepoPathImpl(assetPath, repositoryId) {
        if (!repositoryId) {
            // Since clients typically start by resolving a folder by path, also get the `/` folder so that it is
            // monitored for ONS changes.
            const homeFolder = await this.getHomeFolder();
            repositoryId = homeFolder.repositoryID;
            const userContentRootFolder = homeFolder.repoPath;
            assetPath = pathBrowserify.join(userContentRootFolder, assetPath);
        }
        try {
            let asset = undefined;
            const repoMetadataResource = await this._getRepoDataByPath(assetPath, repositoryId);
            const data = repoMetadataResource.data;
            asset = await this._getAssetById(data['repo:assetId'], repoMetadataResource);
            asset._setResources({ repoMetadataResource });
            return asset;
        }
        catch (e) {
            const topLevelFolders = ['cloud-content', 'temp'];
            for (const topLevelFolder of topLevelFolders) {
                const topLevelPath = `/${topLevelFolder}`;
                const appearsOnlyOnce = assetPath.indexOf(topLevelPath) === assetPath.lastIndexOf(topLevelPath);
                if (e.code === SAMErrorCode.NOT_FOUND && appearsOnlyOnce && assetPath.endsWith(topLevelPath)) {
                    const homeFolder = await this.getHomeFolder();
                    // return the promise to create the folder
                    return homeFolder.createFolder(topLevelFolder);
                }
            }
            throw e;
        }
    }
    // including confirmAccess to match Seal bindings.
    async getAssetWithAssetRefString(assetRefStr, confirmAccess = false) {
        let parsedAssetRef;
        try {
            parsedAssetRef = JSON.parse(assetRefStr);
        }
        catch (error) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Incorrectly formatted AssetRefString', { underlyingError: error });
        }
        if (parsedAssetRef.cloud_id) {
            return this.getAssetWithCloudID(parsedAssetRef.cloud_id, confirmAccess);
        }
        else if (parsedAssetRef.path) {
            return this.getAssetWithRepoPath(parsedAssetRef.path, parsedAssetRef.repository_id);
        }
        else {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid AssetRefString');
        }
    }
    /**
     * @package -- only for use in SAM.js
     */
    _createAssetFromMetadata(assetMetaData) {
        const session = this._assetPool.createUpdateSession();
        const localItem = this._adobeAssetUpdater.updateRemoteItem(session, assetMetaData);
        session.commit();
        return localItem;
    }
    async _repositoryNameFromID(id) {
        return await this._rapi.getRepositoryName(id);
    }
    /** @package -- only for use in SAM.js */
    async _getStorageAssigneeFromID(id) {
        return await this._rapi.getStorageAssignee(id);
    }
    /**
     * @package -- only for use in SAM.js
     */
    async _getListOfRepositoryIDs() {
        const response = await this._rapi.getRepositoriesData();
        if (!response) {
            return undefined;
        }
        const children = response.children;
        return children.map(repositoryInfo => repositoryInfo._embedded[RelType.PRIMARY]['repo:repositoryId']);
    }
    /**
     * XD layers their own artifact publishing system on top of CCAC Projects, backed by their own service. Clients like
     * CDO and Projects UI need to call this API in order to get metadata for rendering these special Artifacts.
     * @param assetId
     */
    async getXDCEData(assetId) {
        return this._core._environment.fetch(`https://${this._core._environment.endpoints.XDCE_HOST}/v2/document/${assetId}`)
            .then(response => response.json());
    }
    removeAssetsFromAssetsPool(assetIds) {
        this._assetPool.removeLocalItems(assetIds);
    }
    async permanentlyDeleteAssets(assets) {
        let assetResults;
        // If client wll try to resolve permanently deleted assets, SAM should not return the cached assets
        // from asset pool. Hence removing permanently deleted assets from asset pool.
        const onItemsChanged = (event) => {
            // Remove only successfully permanently deleted items from asset pool.
            if (event.discardedItems) {
                const permanentDeletedAssetsIds = event.discardedItems.filter(value => assets.includes(value)).map(item => item.id);
                if (permanentDeletedAssetsIds.length) {
                    this.removeAssetsFromAssetsPool(permanentDeletedAssetsIds);
                }
            }
        };
        // ITEMS_CHANGED event is triggered from item pool for all update/mutate sessions.
        // This event will be triggered by other sessions (sessions other than the session
        // created by this permanent delete operation) also. But in onItemsChanged we will
        // remove assets which were added in this session.
        this._assetPool.on(ITEMS_CHANGED, onItemsChanged);
        try {
            await ItemBase.runExclusiveTask('delete', assets, async () => {
                const assetsById = new Map();
                const ops = assets.map((asset) => {
                    assetsById.set(asset.id, asset);
                    const deleteOp = {
                        op: 'delete',
                        id: asset.id,
                        target: {
                            'repo:assetId': asset.id,
                        }
                    };
                    // repository id is optional field in target here
                    // because target is specified by assetId
                    if (asset.repositoryID) {
                        const target = deleteOp.target;
                        target['repo:repositoryId'] = asset.repositoryID;
                    }
                    deleteOp.recursive = asset.isFolder;
                    return deleteOp;
                });
                assetResults = await this._runOperations(ops, assetsById, (session, asset) => {
                    // Since we know the asset has been permanently deleted
                    // we should clear any renditions on it to prevent memory leaks.
                    asset._releaseRenditions();
                    // If the Asset was removed from the pool while the operation was underway (such as by ONS-
                    // triggered refresh), do not try to update it again, as it will get re-added to the pool.
                    if (!this._assetPool.getLocalItemById(asset.id)) {
                        return undefined;
                    }
                    // We update the effectivePermission here first to notify on "change" subscribers
                    // of AdobeAsset (such as AssetLink) that may need to know this assets permission is set to None before
                    // it gets discarded.
                    this._adobeAssetUpdater.updateLocalItem(session, asset, { effectivePermission: Permission.None });
                    session.queueDiscardedItem(asset);
                    return undefined;
                });
            });
        }
        finally {
            this._assetPool.off(ITEMS_CHANGED, onItemsChanged);
        }
        return assetResults;
    }
    async getCloudQuotaUsedAndMax() {
        return this._rapi.getCloudQuotaUsedAndMax();
    }
    // Note: Other props/methods in JS bindings that are only used in the SAM.cpp demo app have been removed.
    //       E.g. release(), appDidEnterBackground(), etc.
    // end [SAM-2245][SAM-2244][SAM-2242]
    async transfer(source, target) {
        let targetId;
        if (target instanceof Space) {
            const workingFiles = await target.getChild('working_files');
            if (!workingFiles) {
                throw SAMError.create(SAMErrorCode.NOT_FOUND, 'unable to find working_files for provided space');
            }
            targetId = workingFiles.id;
        }
        else {
            targetId = target.cloudID;
        }
        const payload = {
            source: { assetId: source.cloudID, repositoryId: source.repositoryID },
            target: { assetId: targetId, repositoryId: target.repositoryID }
        };
        const response = await this._assetTransferService.transfer(payload);
        const updater = this._assetPool.createUpdateSession();
        updater.queueDiscardedItem(source);
        updater.commit();
        return response;
    }
    /**
     * Internal helper method for moving assets (batch).
     * @param assets assets to be moved (in the same repository)
     * @param destFolder destination folder where assets are intended to be moved
     * @param assetRenameMap allows renaming of assets in the batch operation
     * @param retryOnConflict whether to retry the move op for failed assets in case of conflict
     * @param assetConflictMap map to save the newName and count used for all assets in batch
     * @returns the result for batch operation after retrying for failed assets if asked.
     */
    async _moveAssets(assets, destFolder, assetRenameMap = new Map(), retryOnConflict = true, assetConflictMap) {
        let resultOps = { failedResults: [], newModels: [] };
        await ItemBase.runExclusiveTask('move', assets, async () => {
            // In case of Asset created from USS response, repo id is not present
            // Jira on USS https://jira.corp.adobe.com/browse/SRCH-1989
            if (!destFolder.repositoryID) {
                await destFolder._load();
            }
            if (assetConflictMap === undefined) {
                assetConflictMap = new Map();
            }
            const assetsById = new Map();
            const ops = assets.map((asset) => {
                assetsById.set(asset.id, asset);
                let newPath = `${destFolder.repoPath}/${getBatchRenamedAssetName(asset, assetRenameMap)}`;
                newPath = batchFormatFileName(this._core, asset.id, newPath, false, assetConflictMap);
                const op = {
                    op: 'move',
                    id: asset.id,
                    source: {
                        'repo:assetId': asset.id
                    },
                    target: {
                        'repo:path': newPath,
                        'repo:repositoryId': destFolder.repositoryID
                    }
                };
                if (asset.repositoryID) {
                    const source = op.source;
                    source['repo:repositoryId'] = asset.repositoryID;
                }
                return op;
            });
            const updater = (session, asset, remoteItem) => {
                // trigger re-fetch repository name if the dest folder is in a different repository
                if (asset.repositoryID !== destFolder.repositoryID) {
                    asset._clearRepositoryName();
                }
                if (asset.isFolder) {
                    updateCachedDescendents({
                        assetPool: this._assetPool,
                        asset,
                        session,
                        operation: { type: 'rename', newPath: remoteItem['repo:path'] },
                        assetContext: this
                    });
                }
                this._adobeAssetUpdater.updateLocalItem(session, asset, remoteItem);
                return asset;
            };
            resultOps = await this._runOperations(ops, assetsById, updater);
        });
        if (retryOnConflict) {
            return await retryFailedOpsDueToConflict(resultOps, destFolder, assetRenameMap, assetConflictMap, this._moveAssets.bind(this));
        }
        return resultOps;
    }
    /**
     * Public method to move assets to a folder
     * @param assets assets to be moved
     * @param destFolder destination folder where spaces are intended to be moved
     * @param assetRenameMap allows renaming of assets in the batch operation
     * @returns the result for batch operation after retrying for failed assets.
     */
    async moveAssets(assets, destFolder, assetRenameMap = new Map()) {
        return this._moveAssets(assets, destFolder, assetRenameMap);
    }
    /**
     * Public method to check move assets capabilities to a target folder
     * @param assets List of assets to be moved
     * @param targetFolder destination folder where spaces are intended to be moved
     * @returns the move capability results for the assets to be moved.
     */
    async getMoveCapability(assets, targetFolder) {
        var _a;
        if (!targetFolder.isFolder) {
            return { canMove: false, reason: CannotMoveReason.NotAFolder };
        }
        if (!targetFolder.hasPermission(Permission.Write)) {
            return { canMove: false, reason: CannotMoveReason.PermissionDeniedDestination };
        }
        if (assets.some(asset => !asset.hasPermission(Permission.Move))) {
            return { canMove: false, reason: CannotMoveReason.PermissionDeniedSource };
        }
        // Ensure that storage assignee is loaded, as we need it for the following checks.
        await Promise.all([...assets, targetFolder].map(asset => LazyLoadManager.fetchIfNeeded(asset, STORAGE_ASSIGNEE_CHANGED)));
        // If they're the same assignee, they're in the same bucket, so no warning checks are needed.
        if (assets.every(asset => asset.storageAssignee.id === targetFolder.storageAssignee.id)) {
            return { canMove: true, warning: MoveWarning.None, warnings: [] };
        }
        const assetRepoOwnerById = await this._rapi.getRepoOwnerMap();
        const targetRepoOwner = assetRepoOwnerById.get(targetFolder.repositoryID);
        if (targetRepoOwner === undefined) {
            throw SAMError.create(SAMErrorCode.NOT_FOUND, 'target\'s repo owner detail is not available');
        }
        // SHARED-3744 : We expect (asset._repositoryID !== '') because
        // AdobeAsset's are always constructed with 'repo:repositoryId'.
        //
        // But subclasses of AdobeAsset, such as Library, can be
        // constructed data that omits 'repo:repositoryId', in which case
        //  (asset._needsRepoMetadata === true) && (asset._repositoryID === '')
        //
        // Let's try to recover from this by updating _repositoryID's
        // before proceeding.
        //
        // NOTE: If your code triggers this oneTimeWarning(), consider
        // getting your service to include 'repo:repositoryId' in responses,
        // so this doesn't happen. You can also make sure assets have
        // been load()-ed, for instance, with getAssetWithCloudID(),
        // before calling getMoveCapability().
        for (const asset of assets) {
            if (asset.repositoryID === '') {
                oneTimeWarning('AssetContext.getMoveCapability', 'getMoveCapability() requires asset._repositoryID to be set.');
                await asset._loadRepoMetadata();
            }
        }
        if (!((_a = this._core._environment.getValue('FEATURE_FLAGS')) === null || _a === void 0 ? void 0 : _a['enable-x-bucket-move'])) {
            return { canMove: false, reason: CannotMoveReason.CrossBucketMoveDisabled };
        }
        const warnings = [];
        if (assets.some(asset => {
            var _a, _b;
            const sourceOwner = assetRepoOwnerById.get(asset.repositoryID);
            // Allow moves between repositories if both owners are users (CCI to CCI move) and the feature flag is enabled
            if (((_b = (_a = this._core._environment.getValue('FEATURE_FLAGS')) === null || _a === void 0 ? void 0 : _a['move-capabilities']) === null || _b === void 0 ? void 0 : _b['enable-CCI-CCI-move'])
                && (sourceOwner === null || sourceOwner === void 0 ? void 0 : sourceOwner.type) === 'user' && targetRepoOwner.type === 'user') {
                warnings.push(MoveWarning.OwnerChange);
                return false; // Don't block the move
            }
            // Otherwise block if owners are different
            return (sourceOwner === null || sourceOwner === void 0 ? void 0 : sourceOwner.id) !== targetRepoOwner.id;
        })) {
            return { canMove: false, reason: CannotMoveReason.DifferentOwner };
        }
        // Cross-bucket moves (i.e., different assignee, same owner) can cause data loss if a collaborator is editing. To optimize
        // checking for the possibility of editors, we can assume Projects & their children have editors. Folders might have shared items,
        // but it are too expensive to exhaustively check, so assume they could have shared items. If isShared flag is already
        // populated, we will assume it probably has an editor without loading Collaborators.
        let maybeHasEditors = assets.some(asset => (asset.isFolder
            || asset.isProject
            || asset.isChildOfProject
            || asset._isShared_NoLazyLoad));
        if (maybeHasEditors) {
            warnings.push(MoveWarning.CollaboratorMaybeEditing);
            return { canMove: true, warning: MoveWarning.CollaboratorMaybeEditing, warnings };
        }
        // If the _isShared_NoLazyLoad flag is not populated, we have to fetch the Collaborator data to
        // see if we need to warn about editors. Since we're fetching the Collaborators anyway, might as
        // well check explicitly if there are direct editors, rather than assuming they exist.
        let needsProcessing = false;
        assets.forEach(asset => {
            if (!asset._isCollaboratorDataLoaded && asset.isShared === undefined) {
                LazyLoadManager.fetchIfNeeded(asset, COLLABORATOR_CHANGED);
                needsProcessing = true;
            }
        });
        if (needsProcessing) {
            const collaborationContext = await this._core.getCollaborationContext();
            await collaborationContext._collaboratorRequestQueue._processNow();
            maybeHasEditors = assets.some(asset => asset.isShared
                && asset.collaboratorArray.some(collab => collab.isDirect && collab.role === 'editor'));
            if (maybeHasEditors) {
                warnings.push(MoveWarning.CollaboratorMaybeEditing);
                return { canMove: true, warning: MoveWarning.CollaboratorMaybeEditing, warnings };
            }
        }
        // When there are multiple warnings, prefer CollaboratorMaybeEditing as the singular warning if present, for
        // backward compatibility. Otherwise, use the first warning.
        const warning = warnings.find(w => w === MoveWarning.CollaboratorMaybeEditing)
            || warnings[0]
            || MoveWarning.None;
        return { canMove: true, warning, warnings };
    }
    /**
     * Checks an array of the provided AdobeAssets have an outputs directory and returns true
     * if any of the assets have an output folder. This will also update each
     * AdobeAsset.hasArtifacts property to true if the asset does have it.
     *
     * Currently the UI is not expected
     * to show which folders have artificats individually but rather if any of the selected
     * assets contain artifacts.
     *
     * Usage of this API requires the user to have at least READ
     * permissions on the source document.
     *
     * @note This method is inteded to be a stop gap solution until simulated sub assets
     * are shipped. See https://wiki.corp.adobe.com/x/h8JNp
     *
     * @param assets {AdobeAsset}
     */
    async assetsHaveArtifacts(assets) {
        const assetIndentifiers = mapAssetsToAssetIndentifier(assets);
        const results = await this._assetReviewServiceInterface.hasOutputs(assetIndentifiers);
        if (results.length === 0) {
            return false;
        }
        const session = this._assetPool.createUpdateSession();
        this._adobeAssetUpdater.updateRemoteItems(session, results.map(result => {
            return { 'repo:assetId': result['repo:assetId'], 'hasArtifacts': true };
        }));
        session.commit();
        return true;
    }
    /**
     * The asset to delete the output folders for. Currently the
     * API only supports one asset at a time.
     *
     * @param asset Single asset to delete.
     * @package Only to be used within SAM.js
     */
    async _deleteAssetOutputsFolder(asset) {
        return this._assetReviewServiceInterface.discardOutputsForAsset(asset.id);
    }
    /**
     * @package -- Internal helper method for copying assets (batch).
     *
     * @param assets assets to be copied (in the same repository)
     * @param destFolder destination folder where assets are intended to be copied
     * @param assetRenameMap allows renaming of assets in the batch operation
     * @param retryOnConflict whether to retry the copy op for failed assets in case of conflict
     * @param assetConflictMap map to save the newName and count used for all assets in batch
     * @returns the result for batch operation after retrying for failed assets if asked.
     */
    async _copyAssets(assets, destFolder, assetRenameMap = new Map(), retryOnConflict = true, assetConflictMap) {
        let resultOps = { failedResults: [], newModels: [] };
        await ItemBase.runExclusiveTask('copy', assets, async () => {
            // In case of Asset created from USS response, repo id is not present
            // Jira on USS https://jira.corp.adobe.com/browse/SRCH-1989
            if (!destFolder.repositoryID) {
                await destFolder._load();
            }
            if (assetConflictMap === undefined) {
                assetConflictMap = new Map();
            }
            const assetsById = new Map();
            const ops = assets.map((asset) => {
                assetsById.set(asset.id, asset);
                let newPath = `${destFolder.repoPath}/${getBatchRenamedAssetName(asset, assetRenameMap)}`;
                const sameFolder = destFolder.repoPath === asset.repoPath.substring(0, asset.repoPath.lastIndexOf('/'));
                newPath = batchFormatFileName(this._core, asset.id, newPath, sameFolder, assetConflictMap);
                // We only want to copy App metadata for PDFs and no other file format
                // This is a temporary solution and we will have a better solution on the service side
                const includeResources = [{ 'reltype': RelType.PRIMARY }];
                if (asset.mediaType === 'application/pdf') {
                    includeResources.push({ 'reltype': RelType.APP_METADATA });
                }
                const operation = {
                    op: 'copy',
                    id: asset.id,
                    source: {
                        'repo:assetId': asset.id,
                    },
                    target: {
                        'repo:path': newPath,
                        'repo:repositoryId': destFolder.repositoryID
                    },
                    // The following copies Content Resources for all formats
                    // and Application Metadata for PDFs only
                    includeResources
                };
                if (asset.repositoryID) {
                    const source = operation.source;
                    source['repo:repositoryId'] = asset.repositoryID;
                }
                return operation;
            });
            resultOps = await this._runOperations(ops, assetsById, (session, asset, remoteItem) => {
                if (!remoteItem) {
                    throw SAMError.create(SAMErrorCode.UNKNOWN, 'Missing metadata from asset bulk operation.');
                }
                const newAsset = this._adobeAssetUpdater.updateRemoteItem(session, remoteItem);
                return newAsset;
            });
        });
        if (retryOnConflict) {
            return await retryFailedOpsDueToConflict(resultOps, destFolder, assetRenameMap, assetConflictMap, this._copyAssets.bind(this));
        }
        return resultOps;
    }
    /**
     * Public method to copy assets to a folder
     * @param assets assets to be copied
     * @param destFolder destination folder where spaces are intended to be copied
     * @param assetRenameMap allows renaming of assets in the batch operation
     * @returns the result for batch operation after retrying for failed assets.
     */
    async copyAssets(assets, destFolder, assetRenameMap = new Map()) {
        return await this._copyAssets(assets, destFolder, assetRenameMap);
    }
    async duplicateAssets(assets) {
        const parentRepoPath = assets[0].repoPath.substring(0, assets[0].repoPath.lastIndexOf('/'));
        const parentAsset = await this.getAssetWithRepoPath(parentRepoPath, assets[0].repositoryID);
        return await this._copyAssets(assets, parentAsset);
    }
    /**
     * Creates a folder at the given path in the provided repository.
     *
     * @service This API is intended as a "lower level" API in a service context to
     * prevent pre-loading unnessecary data for the caller once the folder is created.
     *
     * Use AdobeAsset.createFolder() to create a folder and get a full AdobeAsset object for the created folder.
     *
     * @param path The path to create the folder at.
     * @param repoisotory The repository data to use to create the folder.
     * @param createIntermediates Whether to create intermediate folders if they don't exist.
     * @returns The created folder's repository metadata.
     */
    async createFolderByPath(path, repository, createIntermediates = true) {
        const newFolderMetadata = await this._rapi.createFolderByPath(path, repository.id, createIntermediates, repository.links);
        const session = this._assetPool.createUpdateSession();
        const newFolder = this._core._adobeAssetFactory.assetFromRepoMetadata(session, newFolderMetadata);
        session.commit();
        return newFolder;
    }
    /**
     * @package -- for use in SAM.js only
     */
    async _runOperations(ops, assetsById, assetUpdater) {
        return await this._rapi.runOperationsForContext(ops, assetsById, this._assetPool, assetUpdater ? assetUpdater : (session, asset, updatedAssetMetaData) => {
            if (!updatedAssetMetaData) {
                throw SAMError.create(SAMErrorCode.UNKNOWN, 'Missing metadata from asset bulk operation.');
            }
            this._adobeAssetUpdater.updateLocalItem(session, asset, updatedAssetMetaData);
            return undefined;
        }, [
            {
                // If remote asset found to be SAMErrorCode.ACCESS_DENIED or SAMErrorCode.NOT_FOUND
                // that means we need to update local asset to get it in sync with remote
                match: (error) => error.code === SAMErrorCode.ACCESS_DENIED || error.code === SAMErrorCode.NOT_FOUND,
                action: async (asset, error) => {
                    await asset._load();
                    return { model: asset, error };
                }
            }
        ]);
    }
    /**
     * Called whenever any new assets are added to the asset pool, or when links / link
     * lists are modified. When this happens, we gather the set of all assets we need to
     *  monitor and trigger watching this with ONS.
     *
     *  @package -- only for use in SAM.js
     */
    _updateONSSubscriptions(excludeAssetIDs) {
        // Compute the set of asset ids to watch - start with an empty set.
        const assetIDs = new Set();
        // We want to monitor all assets in the asset pool (so they get updated when they change)
        this._assetPool.forEach((asset) => assetIDs.add(asset.id));
        // Ignore Assets queued for removal from the pool, if this is an ItemsChangedEvent
        excludeAssetIDs === null || excludeAssetIDs === void 0 ? void 0 : excludeAssetIDs.forEach((assetId) => assetIDs.delete(assetId));
        // If a local instance of AssetLinkManager doesn't exist, that means we don't
        // need to iterate through the links since a client has yet to use this feature.
        const alm = this._getAssetLinkManager();
        if (alm) {
            // And also any assets referenced by links (since the link might be broken and we want
            // to re-resolve when the asset comes in)
            alm.lists.forEach(list => list.monitoredAssetIDs.forEach(id => assetIDs.add(id)));
        }
        // It's possible to have comments without the asset, such as
        //      const comments = await assetContext.getCommentsResource(assetId);
        // vs   const comments = await asset.getCommentsResource();
        //
        // So also add assetID's from any comments
        this._commentsById.forEach((commentsRef, key) => {
            const comments = commentsRef.deref();
            if (comments) {
                assetIDs.add(comments._assetId);
            }
            else {
                this._commentsById.delete(key); // get rid of stale references
            }
        });
        // Update the list of assetIds that ONS is watching - note that this only modifies the
        // subscription if the list of assets changes, so calling ONS with the same assetIds won't
        // cause any new API calls.
        if (this.onsContext) {
            if (assetIDs.size > 0 && !this._core._environment.getValue('DISABLE_ONS')) {
                this.onsContext.watch(assetIDs);
                this.onsContext.start();
            }
            else {
                this.onsContext.stop();
            }
        }
    }
    /**
     * We are keeping the following library element methods here to support SAM.cpp and will
     * move them to LibraryContext after we get better support for library elements.
     */
    async restoreLibraryElement(elementId) {
        await this._libraryInterface.restoreLibraryElement(elementId);
    }
    async permanentlyDeleteLibraryElement(elementId) {
        await this._libraryInterface.permanentlyDeleteLibraryElement(elementId);
    }
    /**
     * @package -- for use in SAM.js only
     * @deprecated -- will be removed on or after after 2024-10-01
     */
    getAssetInterface(repoMetadata) {
        oneTimeWarning('AdobeAsset.getAssetInterface', 'AdobeAsset.getAssetInterface is deprecated and will be removed on or after 2024-10-01.');
        return new AssetInterface(this._rapi, repoMetadata['repo:assetId'], repoMetadata._links, repoMetadata['repo:etag']);
    }
    /**
     * Asynchronous method that returns the CommentsResource associated with the asset identified by assetId.
     *
     * Clients with an AdobeAsset instance should use AdobeAsset.getCommentsResource(),
     * but when the Commenting UI has ( SESSION_TYPE === 'logged-out' ),
     * it isn't possible to construct an AdobeAsset, so they will call this method directly.
     *
     * CommentsResource's are asset specific, and they are cached in a Map of WeakRef's,
     * so client code should ensure there is a pinning reference if they want the context
     * to be preserved.
     *
     * @param assetId {string}
     * @returns {Promise<CommentContent>}
     * @see {@link AdobeAsset.getCommentsResource}
     */
    async getCommentsResource(assetId) {
        var _a;
        let comments = (_a = this._commentsById.get(assetId)) === null || _a === void 0 ? void 0 : _a.deref();
        if (!comments) {
            comments = new CommentsResource(this._core, assetId);
            this._commentsById.set(assetId, new WeakRef$1(comments));
            this._updateONSSubscriptions(); // make sure we've subscribed to assetId
        }
        return comments;
    }
    /**
     * Returns a Promise that resolves when a List is loaded.
     */
    async waitForListLoad(list) {
        const { waitForListLoad } = await Promise.resolve().then(function () { return waitForListLoad$1; });
        return waitForListLoad(list);
    }
    /*
     * @package -- only for use in SAM.js
     * fetches the organizations for the user.
     */
    async _fetchOrganizations() {
        const projectInterface = new ProjectsInterface(this._core);
        await projectInterface.getOrganizations(this._organizationsResource);
    }
    /**
     * Lazy-loads the list of Organizations for the current user. Use {@link AssetContext.defaultOrganizationId} to
     * determine which is the home org. The name of the home org is what should be displayed in the UI for the "Yours"
     * view for ESM users.
     * @returns {Organization[] | undefined}
     */
    get organizations() {
        return this._organizations;
    }
    /**
     * Lazy-loads the "home organization" of the current user. See {@link AssetContext.organizations}
     * @returns {string | undefined}
     */
    get defaultOrganizationId() {
        return this._defaultOrganizationId;
    }
    /**
     * @experimental
     */
    async getAdobeAssetOrder(direction = 'descending', field = 'modified') {
        const { default: AdobeAssetOrder } = await Promise.resolve().then(function () { return AdobeAssetOrder$1; });
        return new AdobeAssetOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getSWYAdobeAssetOrder(direction = 'descending', field = 'shared') {
        const { default: SWYAdobeAssetOrder } = await Promise.resolve().then(function () { return SWYAdobeAssetOrder$1; });
        return new SWYAdobeAssetOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getUSSAdobeAssetOrder(direction = 'descending', field = 'modified') {
        const { default: USSAdobeAssetOrder } = await Promise.resolve().then(function () { return USSAdobeAssetOrder$1; });
        return new USSAdobeAssetOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getAssetVersionOrder(direction = 'descending', field = 'created') {
        const { default: AssetVersionOrder } = await Promise.resolve().then(function () { return AssetVersionOrder$1; });
        return new AssetVersionOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getAdobeAssetFilter(options) {
        const { default: AdobeAssetFilter } = await Promise.resolve().then(function () { return AdobeAssetFilter$1; });
        return new AdobeAssetFilter(options);
    }
    /**
     * @experimental
     */
    async getSWYAdobeAssetFilter() {
        // Filter not lazily loaded async as the sync `sharedSource` accessor requires it.
        return new SWYAdobeAssetFilter();
    }
    /**
     * @experimental
     */
    async getUSSAdobeAssetFilter(options) {
        const { default: USSAdobeAssetFilter } = await Promise.resolve().then(function () { return USSAdobeAssetFilter$1; });
        return new USSAdobeAssetFilter(options);
    }
    /**
     * @experimental
     */
    async getRecentAdobeAssetFilter() {
        const { default: RecentAdobeAssetFilter } = await Promise.resolve().then(function () { return RecentAdobeAssetFilter$1; });
        return new RecentAdobeAssetFilter();
    }
    /**
     * @experimental
     */
    async getAssetVersionFilter(options) {
        const { default: AssetVersionFilter } = await Promise.resolve().then(function () { return AssetVersionFilter$1; });
        return new AssetVersionFilter(options);
    }
    repoToStudentAssignmentData(item, additionalMetadata) {
        const { _links: _linksFromAdditionalMetadata } = additionalMetadata, restAdditionalMetadata = __rest$2(additionalMetadata, ["_links"]);
        const { _links: _linksFromItem } = item, restItem = __rest$2(item, ["_links"]);
        return Object.assign(Object.assign(Object.assign({}, restItem), restAdditionalMetadata), { _links: Object.assign(Object.assign({}, _linksFromItem), _linksFromAdditionalMetadata) });
    }
}
__decorate([
    synchronized
], AssetContext.prototype, "_getONSContext", null);
__decorate([
    memoize$1
], AssetContext.prototype, "sharedSource", null);
__decorate([
    memoize$1
], AssetContext.prototype, "recentAssetsSource", null);
__decorate([
    memoize$1
], AssetContext.prototype, "favoriteAssetsSource", null);
__decorate([
    memoize$1
], AssetContext.prototype, "MRUAssetsSource", null);
__decorate([
    memoize$1
], AssetContext.prototype, "publishedSource", null);
__decorate([
    memoize$1
], AssetContext.prototype, "discardedSource", null);
__decorate([
    memoize$1
], AssetContext.prototype, "localRecentsSource", null);
__decorate([
    synchronized
], AssetContext.prototype, "getAssetLinkManager", null);
__decorate([
    synchronized,
    __param(0, key)
], AssetContext.prototype, "_getAssetById", null);
__decorate([
    keepAlive,
    synchronized
], AssetContext.prototype, "getHomeFolder", null);
__decorate([
    keepAlive,
    synchronized
], AssetContext.prototype, "getRootFolder", null);
__decorate([
    keepAlive
], AssetContext.prototype, "getAssetWithCloudID", null);
__decorate([
    keepAlive,
    synchronized
], AssetContext.prototype, "getAssetWithRepoPath", null);
__decorate([
    synchronized
], AssetContext.prototype, "_getAssetWithRepoPathImpl", null);
__decorate([
    keepAlive
], AssetContext.prototype, "getAssetWithAssetRefString", null);
__decorate([
    lazyLoaded(OrganizationsChangedEventInstance, '_organizations')
], AssetContext.prototype, "organizations", null);
__decorate([
    lazyLoaded(OrganizationsChangedEventInstance, '_defaultOrganizationId')
], AssetContext.prototype, "defaultOrganizationId", null);

var AssetContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get CloudSyncStatus () { return CloudSyncStatus; },
    'default': AssetContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$l = {
    created(a, b) {
        return compareValues(a.created, b.created);
    }
};
class AssetVersionOrder extends createItemOrderFactory(OrderFieldToComparator$l) {
}
AssetVersionOrder.default = new AssetVersionOrder('descending', 'created');

var AssetVersionOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': AssetVersionOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var LibraryOrderBy;
(function (LibraryOrderBy) {
    LibraryOrderBy["MODIFIED_DATE"] = "modified_date";
    LibraryOrderBy["CREATED_DATE"] = "created_date";
    LibraryOrderBy["NAME"] = "name"; // actually displayName
})(LibraryOrderBy || (LibraryOrderBy = {}));
/**
 * Enum for library owner filter
 * (If you update this list, also update LibraryFilter.matches/getRelationToFilter.)
 * @enum {string}
 */
var LibraryOwnerFilter;
(function (LibraryOwnerFilter) {
    /**
     * Personal libraries created in User Storage that are specifically stored inside the sync group: `/assets/adobe-libraries`
     * Excludes CCI Project Libraries.
     */
    LibraryOwnerFilter["Personal"] = "private";
    /**
     * Bookmarked public libraries.
     * Currently will be ignored if combined with other ownership types.
     */
    LibraryOwnerFilter["Public"] = "public";
    /**
     * Bookmarked incoming libraries. This includes:
     * - Libraries shared directly with the user that the user has accepted the invite to
     * - CCI Project Libraries which live in User Storage (`/users/{userId}` in ESM, `/` in USM and for unified users)
     * - Project Libraries the user has followed (After SMU, these will all live in `/projects/{projectName}`)
     */
    LibraryOwnerFilter["Incoming"] = "incoming";
    /**
     * Everything the user has acccess to that is not in User Storage, except public libraries.
     * Includes: Project libraries, Incoming libraries (except CCI Project Libraries since they are in User Storage)
     * Excludes: Public libraries, CCI Project Libraries, Private Libraries
     */
    LibraryOwnerFilter["Discovery"] = "discovery";
    /**
     * A subset of 'discovery' that excludes already bookmarked libraries.
     */
    // Other = 'other',
    /**
     * All of the above except public libraries currently (until supported by USS).
     * If combined with other owner types, the others will be ignored.
     */
    LibraryOwnerFilter["All"] = "all";
})(LibraryOwnerFilter || (LibraryOwnerFilter = {}));
var LibraryProjectFilterEnum;
(function (LibraryProjectFilterEnum) {
    /**
     * Include all project libraries.
     */
    LibraryProjectFilterEnum["All"] = "all";
    /**
     * Do not include any project libraries.
     */
    LibraryProjectFilterEnum["None"] = "none";
    /**
     * Include project libraries that the user is NOT a member of.
     */
    // Other = 'other'
})(LibraryProjectFilterEnum || (LibraryProjectFilterEnum = {}));
var LibraryRolesFilter;
(function (LibraryRolesFilter) {
    /**
     * Include libraries that have no roles
     */
    LibraryRolesFilter["None"] = "none";
    /**
     * Include libraries that have at least one role where role.type === 'brand'
     */
    LibraryRolesFilter["Brand"] = "brand";
    /**
     * Include training set libraries. Currently the default, as it is the only option.
     */
    LibraryRolesFilter["TrainingSet"] = "cm_training_set";
})(LibraryRolesFilter || (LibraryRolesFilter = {}));
/**
 * This enum is used for filtering the library list view for brands specifically based on it's publishing related app metadata.
 * This filter is only usable if the brand role is true.
 *
 * There are three types of brands that exist in the data:
 * 1. Published brands -- These are the brands that have brand:publishedFrom in their app metadata.
 * Nobody is able to update these brands directly, they can only be updated by publishing changes from their draft brand counterpart (which is what brand:publishedFrom points to).
 *
 * 2. Draft brands with a published counterpart -- These are the brands that have brand:publishedTo in their app metadata.
 * These brands do NOT show up in the list of brands, but still can be accessed when a user goes to edit a published brand.
 * This is so we can maintain a "Draft" state for a published brand so brand creators can make revisions without updating the published copy that is currently in use.
 *
 * 3. Draft brands that are unpublished -- These are brands that are not part of a published brand in any way, and thus have neither brand:publishedFrom nor brand:publishedTo.
 * These brands are editable, and do show up in the brands listing view.
 */
var BrandPublishMetadataFilter;
(function (BrandPublishMetadataFilter) {
    /**
     * Includes: Published brands
     *
     * Excludes: Unpublished draft brands, Draft brands with a published counterpart
     */
    BrandPublishMetadataFilter["PublishedBrands"] = "publishedBrands";
    /**
     * Includes: Published brands, Unpublished draft brands
     *
     * Excludes: Draft brands with a published counterpart
     */
    BrandPublishMetadataFilter["AllBrands"] = "allBrands";
    /**
     * Includes: Unpublished draft brands, Draft brands with a published counterpart
     *
     * Excludes: Published brands
     */
    BrandPublishMetadataFilter["AllEditableBrands"] = "allEditableBrands";
})(BrandPublishMetadataFilter || (BrandPublishMetadataFilter = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToLibraryOrderBy = {
    'name': LibraryOrderBy.NAME,
    'created': LibraryOrderBy.CREATED_DATE,
    'modified': LibraryOrderBy.MODIFIED_DATE
};
// Appropriate comparator is used in order.sortItems when copying or updating ItemLists,
// which occurs when a page is loaded and the ItemLoaderState changes.
const OrderFieldToComparator$k = {
    name(a, b) {
        // LibraryOrder is only used on lists from LibrarySource, where LibraryData from melville should already be loaded.
        // (But just in case, this falls back to repoMetadata name, though this wouldn't work properly for libraries in sync groups.)
        return compareStrings(a.displayName || a.name, b.displayName || b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    },
    modified(a, b) {
        return compareValues(a.modified, b.modified);
    }
};
class LibraryOrder extends createItemOrderFactory(OrderFieldToComparator$k) {
}
LibraryOrder.default = new LibraryOrder('descending', 'modified');

var LibraryOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    OrderFieldToLibraryOrderBy: OrderFieldToLibraryOrderBy,
    'default': LibraryOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Equivalent to `setA.symmetricDifference(setB);`, but typescript is outdated and doesn't recognize the method.
 */
function symmetricDifference(setA, setB) {
    // Create a new set to store the non-overlapping values
    const diff = new Set();
    // Add values from setA that are not in setB
    for (const value of setA) {
        if (!setB.has(value)) {
            diff.add(value);
        }
    }
    // Add values from setB that are not in setA
    for (const value of setB) {
        if (!setA.has(value)) {
            diff.add(value);
        }
    }
    return diff;
}
/**
 * Equivalent to `setA.intersection(setB);` but typescript is outdated and doesn't recognize the method.
 */
function intersection(setA, setB) {
    return new Set([...setB].filter(x => setA.has(x)));
}

// Helper methods for IItemFilter.matches() when the filter uses LibraryFilterOptions.
function itemMatchesOwnerFilter(item, owner) {
    if (item._ownership_NoLazyLoad === undefined) {
        return false;
    }
    return owner.has(item._ownership_NoLazyLoad)
        // Public libraries are not returned by the 'all' owner filter
        || (owner.has(LibraryOwnerFilter.All) && !item._isPublicLink_NoLazyLoad)
        // 'ownership' field can be 'incoming' or 'team' for followed project libraries. We are trying to move away from relying on this field,
        // so this just checks for a collab bookmark.
        || (owner.has(LibraryOwnerFilter.Incoming) && !item._isPublicLink_NoLazyLoad && item._isBookmarked_NoLazyLoad)
        // Discovery includes everything the user has access to that is NOT in User Storage except public libraries.
        // * Includes: Incoming libraries, Project libraries (except CCI Project Libraries since they are in User Storage)
        // * Excludes: Public libraries, CCI Project Libraries, Private Libraries
        || (owner.has(LibraryOwnerFilter.Discovery) && (item._ownership_NoLazyLoad !== 'private') && !item._isPublicLink_NoLazyLoad && !item._isCCIProjectLibrary);
}
function itemMatchesRolesFilter(item, roles) {
    var _a;
    if (item._roles_NoLazyLoad === undefined) {
        return false;
    }
    return roles.has(LibraryRolesFilter.None) && (!item._roles_NoLazyLoad || item._roles_NoLazyLoad.length === 0)
        // one of the roles filters matches one of the roles on the library
        || ((_a = item._roles_NoLazyLoad) === null || _a === void 0 ? void 0 : _a.some(role => roles.has(role.type)));
}
function itemMatchesProjectFilter(item, project) {
    return (project === LibraryProjectFilterEnum.All && item.isChildOfProject)
        || (project === 'none' && !item.isChildOfProject)
        || (project === 'other' && item.isChildOfProject && !item._isBookmarked_NoLazyLoad)
        || (project === item.parentProjectID);
}
function itemMatchesPublishMetadataFilter(item, publishMetadata) {
    return (publishMetadata === BrandPublishMetadataFilter.AllBrands && !item.publishedTo)
        || (publishMetadata === BrandPublishMetadataFilter.PublishedBrands && item.publishedFrom)
        || (publishMetadata === BrandPublishMetadataFilter.AllEditableBrands && !item.publishedFrom);
}
// Helper methods for IItemFilter.getRelationToFilter() when the filter uses LibraryFilterOptions.
function checkOwnerRelation(newOwnerSet = new Set([LibraryOwnerFilter.All]), existingOwnerSet = new Set([LibraryOwnerFilter.All])) {
    const intersection = new Set([...existingOwnerSet].filter(x => newOwnerSet.has(x)));
    const subset = intersection.size === newOwnerSet.size;
    if (subset) {
        return 'subset';
    } // all new values are in existing values
    const difference = symmetricDifference(newOwnerSet, existingOwnerSet);
    //Public libraries don't overlap with anything, including 'all'
    if (difference.has(LibraryOwnerFilter.Public)) {
        return 'disjoint';
    }
    // all other combinations are subsets of 'all'
    if (existingOwnerSet.has(LibraryOwnerFilter.All)) {
        return 'subset';
    }
    // newOwnerSet is a superset of existing owner set, because all includes all libraries
    if (newOwnerSet.has(LibraryOwnerFilter.All)) {
        return 'unknown';
    }
    if (difference.has(LibraryOwnerFilter.Discovery) && difference.has(LibraryOwnerFilter.Incoming)) {
        // If one filter is 'incoming', it may partially overlap with a 'discovery' filter,
        // regardless of what other filters are present, or which is pre-existing.
        if (newOwnerSet.has(LibraryOwnerFilter.Discovery) && existingOwnerSet.has(LibraryOwnerFilter.Incoming)
            || existingOwnerSet.has(LibraryOwnerFilter.Discovery) && newOwnerSet.has(LibraryOwnerFilter.Incoming)) {
            return 'unknown';
        }
    }
    if (intersection.size > 0) {
        return 'unknown';
    } // some overlap
    return 'disjoint'; // no overlap since intersection.size === 0
}
function checkRolesRelation(newRolesSet, existingRolesSet) {
    if (newRolesSet && existingRolesSet) {
        return checkSetOverlap(newRolesSet, existingRolesSet);
    }
    if (newRolesSet || existingRolesSet) {
        return 'unknown';
    }
    // if both are undefined, we don't need to check roles. 'undefined' is equivalent to 'all roles'
    return 'subset';
}
function checkProjectRelation(newProjectFilter, existingProjectFilter) {
    if (newProjectFilter) {
        const checkIfIsProjId = (projectFilter) => {
            // Assume that any projectFilter that is not one of the enum values is a project id
            return !Object.values(LibraryProjectFilterEnum).includes(projectFilter);
        };
        const subset = !existingProjectFilter // if existing project filter is undefined, that means it includes libraries that may or may not be in a project
            || newProjectFilter === existingProjectFilter
            || (checkIfIsProjId(newProjectFilter) && existingProjectFilter === LibraryProjectFilterEnum.All); // if project filter is 'all', that means the library must be in a project
        return subset ? 'subset' : 'disjoint';
    }
    if (!newProjectFilter && existingProjectFilter) {
        return 'unknown';
    }
    return 'subset';
}
function checkPublishMetadataRelation(newPublishMetadataFilter, existingPublishMetadataFilter) {
    // If there was no filter before or the filter has not changed, we can assume that the new filter is a subset of the existing filter
    if (!existingPublishMetadataFilter || newPublishMetadataFilter === existingPublishMetadataFilter) {
        return 'subset';
    }
    // If the new filter is for published brands and the existing filter is for all editable brands, they are inverse of each other and there is no overlap
    if (newPublishMetadataFilter === BrandPublishMetadataFilter.PublishedBrands && existingPublishMetadataFilter === BrandPublishMetadataFilter.AllEditableBrands) {
        return 'disjoint';
    }
    // The inverse is also true -- if the new filter is for all editable brands and the existing filter is for published brands, they are inverse of each other and there is no overlap
    if (newPublishMetadataFilter === BrandPublishMetadataFilter.AllEditableBrands && existingPublishMetadataFilter === BrandPublishMetadataFilter.PublishedBrands) {
        return 'disjoint';
    }
    // The "All brands" publish metadata filter will always include all published brands as well
    if (existingPublishMetadataFilter === BrandPublishMetadataFilter.AllBrands && newPublishMetadataFilter === BrandPublishMetadataFilter.PublishedBrands) {
        return 'subset';
    }
    return 'unknown';
}
function checkSetOverlap(newValuesSet, existingValuesSet) {
    const intersection$1 = intersection(newValuesSet, existingValuesSet);
    const subset = intersection$1.size === newValuesSet.size;
    if (subset) {
        return 'subset';
    } // all new values are in existing values
    if (intersection$1.size > 0) {
        return 'unknown';
    } // some overlap
    return 'disjoint'; // no overlap since intersection.size === 0
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Internal filter that is for defining the ItemSource(s).
 * It contains both the parameters sent in the server request, and the filters used on the returned item data.
 * e.g. The LibrarySource should return libraries that are private, incoming, etc.
 */
class LibraryFilter {
    /**
     * This filter is used to fetch the brands of a brands editor, who can edit all brands in the given brands project.
     * This filter should return all published brands in the project, along with any draft brands that are not published.
     *
     * _NOTE: This does NOT include the draft brands that have a published counterpart, since those should not be listed in their main view._
     * @param brandsProjectId The project ID for the brands project.
     */
    static EditorBrands(brandsProjectId) {
        return new LibraryFilter({
            owner: [LibraryOwnerFilter.All],
            roles: [LibraryRolesFilter.Brand],
            publishMetadata: BrandPublishMetadataFilter.AllBrands,
            project: brandsProjectId
        });
    }
    constructor(filterOptions = {}) {
        this.filterOptions = filterOptions;
        this._project = filterOptions.project;
        if (filterOptions.roles && filterOptions.roles.length > 0) {
            this._roles = new Set([...(filterOptions.roles)]);
        }
        this._owner = filterOptions.owner ? new Set([...filterOptions.owner]) : LibraryFilter.DEFAULT._owner;
        if (this._owner.size > 1) {
            if (this._owner.has(LibraryOwnerFilter.Public)) {
                // This is the case temporarily until melville supports public libraries in the same query.
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Public libraries cannot be combined with other ownership types.');
            }
            if (this._owner.has(LibraryOwnerFilter.Discovery) && this._owner.has(LibraryOwnerFilter.Incoming)) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Discovery and Incoming are redundant, as Incoming is a subset of Discovery.');
            }
        }
        if (filterOptions.publishMetadata) {
            if (!this._roles || !this._roles.has(LibraryRolesFilter.Brand)) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'The publish metadata filter can only be used with the brands role.');
            }
            this._publishMetadata = filterOptions.publishMetadata;
        }
    }
    // Used in ItemSource._getListHash to identify the list.
    get hash() {
        if (!this._hash) {
            this._hash = [
                `owner=${[...this._owner].sort().join(',')}`,
                this._roles ? `roles=${[...this._roles].sort().join(',')}` : undefined,
                this._project ? `project=${this._project}` : undefined,
                this._publishMetadata ? `publishMetadata=${this._publishMetadata}` : undefined
            ].filter(x => x).join(':');
        }
        return this._hash;
    }
    /**
     * Checks if an item matches the filter. (May be used by ItemList and ItemLoaderState, and is called when asset change notifications
     * come in to check if the asset is still eligible to be on a particular list.)
     */
    matches(item) {
        // If a library has not loaded melville data, it is not considered a match.
        // We also make sure not to trigger lazy loading on an unloaded library, as that should only be triggered by the client.
        // If the data has been loaded once, we want the library to pass here (unless we get data that says it no longer passes) because
        //   we don't want it to disappear from listings after it's already been shown to the user
        if (!item.isLibrary) {
            return false;
        }
        if (this._owner && !itemMatchesOwnerFilter(item, this._owner)) {
            return false;
        }
        if (this._project && !itemMatchesProjectFilter(item, this._project)) {
            return false;
        }
        if (this._roles && !itemMatchesRolesFilter(item, this._roles)) {
            return false;
        }
        if (this._publishMetadata && !itemMatchesPublishMetadataFilter(item, this._publishMetadata)) {
            return false;
        }
        return true;
    }
    /**
     * This method determines the commonality between the already present filter (existing)
     * and the new filter to be applied (this). The point of this is to
     * see if the new filter (this) can build some, all, or none of it's items
     * from (existing) filter.
     *
     * Subset: Means that ALL items for this filter can be built from existing
     * Disjoint: No items for this filter can be built from existing.
     * Unknown: Some items for this filter can be built from existing.
     *
     * @note we should always determine disjoint cases first before other cases.
     * @note this = NEW FILTER, existing = EXISTING FILTER
     *
     * @param existing The existing filter that we are getting the relation to.
     * @returns { ItemFilterRelation }
     */
    getRelationToFilter(existing) {
        const relations = [
            // owner filter always exists
            checkOwnerRelation(this._owner, existing._owner),
            checkRolesRelation(this._roles, existing._roles),
            checkProjectRelation(this._project, existing._project),
            checkPublishMetadataRelation(this._publishMetadata, existing._publishMetadata),
        ];
        if (relations.includes('disjoint')) {
            return 'disjoint';
        }
        if (relations.every(relation => relation === 'subset')) {
            return 'subset';
        }
        // only remaining possibility is 'unknown'
        return 'unknown';
    }
}
/* Static filters that represent typical filters used in the UI. */
// Contains all of the user's libraries, including private, followed project libraries, and libraries the user has accepted an invite to.
// In the future, this will also include followed public libraries. (USS does not currently support adding public to the query.)
LibraryFilter.AllLibraries = new LibraryFilter({
    // we don't use LibraryOwnerFilter.All query param because it includes unfollowed business storage libraries
    owner: [LibraryOwnerFilter.Incoming, LibraryOwnerFilter.Personal]
});
/**
 * This filter is used to fetch the brands of a brands consumer, who can only see published brands (but not edit them).
 */
LibraryFilter.CollaboratorBrands = new LibraryFilter({
    owner: [LibraryOwnerFilter.All],
    roles: [LibraryRolesFilter.Brand],
    publishMetadata: BrandPublishMetadataFilter.PublishedBrands
});
LibraryFilter.DEFAULT = LibraryFilter.AllLibraries;

var LibraryFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': LibraryFilter
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var LearningManagementSystems;
(function (LearningManagementSystems) {
    LearningManagementSystems["GC"] = "GC";
})(LearningManagementSystems || (LearningManagementSystems = {}));
var LearningManagementSystemRoles;
(function (LearningManagementSystemRoles) {
    LearningManagementSystemRoles["STUDENT"] = "STUDENT";
    LearningManagementSystemRoles["TEACHER"] = "TEACHER";
})(LearningManagementSystemRoles || (LearningManagementSystemRoles = {}));
var RosterImportState;
(function (RosterImportState) {
    RosterImportState["BLOCKED"] = "BLOCKED";
    RosterImportState["INVITED"] = "INVITED";
    RosterImportState["JOINED"] = "JOINED";
    RosterImportState["NOT_ENROLLED"] = "NOT_ENROLLED";
    RosterImportState["REMOVED"] = "REMOVED";
})(RosterImportState || (RosterImportState = {}));
var ImportSourceType;
(function (ImportSourceType) {
    ImportSourceType["CLEVER"] = "clever";
    ImportSourceType["CLASS_LINK"] = "classlink";
})(ImportSourceType || (ImportSourceType = {}));
var ClassroomStatus;
(function (ClassroomStatus) {
    ClassroomStatus["ACTIVE"] = "ACTIVE";
    ClassroomStatus["ARCHIVED"] = "ARCHIVED";
})(ClassroomStatus || (ClassroomStatus = {}));
var ClassroomType;
(function (ClassroomType) {
    /** Allowed classrooms for Top Down organization users */
    ClassroomType["TRUE"] = "TRUE";
    /** Allowed classrooms for Bottom up organization users */
    ClassroomType["RESTRICTED"] = "RESTRICTED";
    /** Allowed classrooms for users on their personal account */
    ClassroomType["UNRESTRICTED"] = "UNRESTRICTED";
    /** Not allowed classrooms */
    ClassroomType["NONE"] = "NONE";
})(ClassroomType || (ClassroomType = {}));
var SubjectTypes;
(function (SubjectTypes) {
    SubjectTypes["noSubject"] = "";
    SubjectTypes["allsubjects"] = "allsubjects";
    SubjectTypes["careersTechnicalEducation"] = "careersTechnicalEducation";
    SubjectTypes["computerScience"] = "computerScience";
    SubjectTypes["english"] = "english";
    SubjectTypes["math"] = "math";
    SubjectTypes["otherLanguages"] = "otherLanguages";
    SubjectTypes["others"] = "others";
    SubjectTypes["science"] = "science";
    SubjectTypes["socialStudies"] = "socialStudies";
    SubjectTypes["visualPerformingArts"] = "visualPerformingArts";
})(SubjectTypes || (SubjectTypes = {}));
var ClassroomRole;
(function (ClassroomRole) {
    ClassroomRole["STUDENT"] = "STUDENT";
    ClassroomRole["TEACHER"] = "TEACHER";
})(ClassroomRole || (ClassroomRole = {}));
var BlockApiSuccessResponses;
(function (BlockApiSuccessResponses) {
    BlockApiSuccessResponses["REMOVE_STUDENT_SUCCESS"] = "REMOVE_STUDENT_SUCCESS";
    BlockApiSuccessResponses["BLOCK_STUDENT_SUCCESS"] = "BLOCK_STUDENT_SUCCESS";
    BlockApiSuccessResponses["UNBLOCK_STUDENT_SUCCESS"] = "UNBLOCK_STUDENT_SUCCESS";
    BlockApiSuccessResponses["DELETE_DOMAIN_MAPPING_ACCEPTED"] = "DELETE_DOMAIN_MAPPING_ACCEPTED";
})(BlockApiSuccessResponses || (BlockApiSuccessResponses = {}));
var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["OWNER"] = "OWNER";
    MembershipStatus["ACTIVE"] = "ACTIVE";
    MembershipStatus["INACTIVE"] = "INACTIVE";
    MembershipStatus["INVITED"] = "INVITED";
    MembershipStatus["IN_REVIEW"] = "IN_REVIEW";
    MembershipStatus["DECLINED"] = "DECLINED";
    MembershipStatus["NOT_A_MEMBER"] = "NOT_A_MEMBER";
})(MembershipStatus || (MembershipStatus = {}));
var CoTeacherEligibilityStatus;
(function (CoTeacherEligibilityStatus) {
    CoTeacherEligibilityStatus["ALLOWED"] = "ALLOWED";
    CoTeacherEligibilityStatus["NOT_ALLOWED"] = "NOT_ALLOWED";
})(CoTeacherEligibilityStatus || (CoTeacherEligibilityStatus = {}));
var CoTeacherIneligibilityReason;
(function (CoTeacherIneligibilityReason) {
    CoTeacherIneligibilityReason["ACCOUNT_NOT_FOUND"] = "ACCOUNT_NOT_FOUND";
    CoTeacherIneligibilityReason["STUDENT_IN_CLASSROOM"] = "STUDENT_IN_CLASSROOM";
    CoTeacherIneligibilityReason["TEACHER_IN_CLASSROOM"] = "TEACHER_IN_CLASSROOM";
})(CoTeacherIneligibilityReason || (CoTeacherIneligibilityReason = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var ClassroomMemberRole;
(function (ClassroomMemberRole) {
    ClassroomMemberRole["STUDENT"] = "student";
    ClassroomMemberRole["TEACHER"] = "teacher";
    ClassroomMemberRole["NONE"] = "none";
})(ClassroomMemberRole || (ClassroomMemberRole = {}));
var ClassroomMemberStatus;
(function (ClassroomMemberStatus) {
    ClassroomMemberStatus["ACTIVE"] = "ACTIVE";
    ClassroomMemberStatus["DECLINED"] = "DECLINED";
    ClassroomMemberStatus["INACTIVE"] = "INACTIVE";
    ClassroomMemberStatus["INVITED"] = "INVITED";
    ClassroomMemberStatus["IN_REVIEW"] = "IN_REVIEW";
    ClassroomMemberStatus["NOT_A_MEMBER"] = "NOT_A_MEMBER";
    ClassroomMemberStatus["OWNER"] = "OWNER";
})(ClassroomMemberStatus || (ClassroomMemberStatus = {}));
var ClassroomMemberInviteSource;
(function (ClassroomMemberInviteSource) {
    ClassroomMemberInviteSource["CLASSLINK"] = "CLASSLINK";
    ClassroomMemberInviteSource["CLEVER"] = "CLEVER";
    ClassroomMemberInviteSource["EMAIL"] = "EMAIL";
    ClassroomMemberInviteSource["GOOGLE_CLASSROOM"] = "GOOGLE_CLASSROOM";
    ClassroomMemberInviteSource["NONE"] = "NONE";
})(ClassroomMemberInviteSource || (ClassroomMemberInviteSource = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$j = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    created(a, b) {
        let value;
        if (!a.created && !b.created) {
            value = 0;
        }
        else if (!a.created) {
            value = 1; // Undefined date should be sorted last in ascending order
        }
        else if (!b.created) {
            value = -1;
        }
        else {
            value = compareValues(a.created.getTime(), b.created.getTime());
        }
        if (value === 0) {
            // Within the same created, sort by name
            return compareStrings(a.name, b.name);
        }
        return value;
    },
};
class ClassroomOrder extends createItemOrderFactory(OrderFieldToComparator$j) {
}
ClassroomOrder.default = new ClassroomOrder('ascending', 'name');

var ClassroomOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': ClassroomOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ClassroomMember extends ItemBase {
    constructor() {
        super(...arguments);
        this._classroomId = '';
        this._displayName = '';
        this._email = '';
        this._firstName = '';
        this._inviteSource = ClassroomMemberInviteSource.NONE;
        this._lastName = '';
        this._membershipStatus = ClassroomMemberStatus.NOT_A_MEMBER;
        this._role = ClassroomMemberRole.NONE;
        this._userId = '';
    }
    get classroomId() {
        return this._classroomId;
    }
    get displayName() {
        return this._displayName;
    }
    get email() {
        return this._email;
    }
    get firstName() {
        return this._firstName;
    }
    get inviteSource() {
        return this._inviteSource;
    }
    get lastName() {
        return this._lastName;
    }
    get membershipStatus() {
        return this._membershipStatus;
    }
    get role() {
        return this._role;
    }
    get userId() {
        return this._userId;
    }
}
__decorate([
    observable$1
], ClassroomMember.prototype, "classroomId", null);
__decorate([
    observable$1
], ClassroomMember.prototype, "displayName", null);
__decorate([
    observable$1
], ClassroomMember.prototype, "email", null);
__decorate([
    observable$1
], ClassroomMember.prototype, "firstName", null);
__decorate([
    observable$1
], ClassroomMember.prototype, "inviteSource", null);
__decorate([
    observable$1
], ClassroomMember.prototype, "lastName", null);
__decorate([
    observable$1
], ClassroomMember.prototype, "membershipStatus", null);
__decorate([
    observable$1
], ClassroomMember.prototype, "role", null);
__decorate([
    observable$1
], ClassroomMember.prototype, "userId", null);
const ClassroomMemberUpdater = new ItemUpdater({
    localItemType: ClassroomMember,
    // Note that ID of classroomMember is computed, and in the format of `{classroomId}-{role}`
    remoteIdProperty: 'computedKey',
    propertyUpdater: new PropertyUpdater({
        _classroomId: { name: 'classroomId', format: 'string' },
        _displayName: { name: 'displayName', format: 'string' },
        _email: { name: 'email', format: 'string' },
        _firstName: { name: 'firstName', format: 'string' },
        _inviteSource: { name: 'inviteSource', format: 'string', choices: Object.values(ClassroomMemberInviteSource) },
        _lastName: { name: 'lastName', format: 'string' },
        _membershipStatus: { name: 'membershipStatus', format: 'string', choices: Object.values(ClassroomMemberStatus) },
        _role: { name: 'role', format: 'string', choices: Object.values(ClassroomMemberRole) },
        _userId: { name: 'userId', format: 'string' },
    }),
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$i = {
    name(a, b) {
        return compareStrings(a.displayName, b.displayName);
    },
};
class ClassroomMemberOrder extends createItemOrderFactory(OrderFieldToComparator$i) {
}
ClassroomMemberOrder.default = new ClassroomMemberOrder('ascending', 'name');

var ClassroomMemberOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': ClassroomMemberOrder
});

/**
 * A filter for classroom members
 *
 * Example usage, to get just a list of students back:
 *
 * classroom.members.getList(ClassroomMemberOrder.default, new ClassroomMemberFilter({ classroomId: classroom.id, role: 'student' }), { refreshTimeout: -1 });
 */
class ClassroomMemberFilter {
    constructor(options) {
        this.classroomId = options.classroomId || '';
        this.role = options.role || ClassroomMemberRole.NONE;
    }
    matches(item) {
        // Can return immediately if the classroomId doesn't match
        if (this.classroomId !== item.classroomId) {
            return false;
        }
        // If we have a role, we're only loading students OR teachers
        if (this.role && this.role !== ClassroomMemberRole.NONE) {
            return item.role === this.role;
        }
        // If we don't have a role, we're loading all members, so check against either student or teacher
        return item.role === ClassroomMemberRole.STUDENT || item.role === ClassroomMemberRole.TEACHER;
    }
    /**
     * This method determines the commonality between the already present filter (other)
     * and the new filter to be applied (this). The point of this is to
     * see if the new filter (this) can build some, all, or none of it's items
     * from (other) filter.
     *
     * Subset: Means that ALL items for this filter can be built from other
     * Disjoint: No items for this filter can be built from other.
     * Unknown: Some items for this filter can be built from other.
     *
     * @note we should always determine disjoint cases first before other cases.
     * @note this = NEW FILTER, other = EXISTING FILTER
     *
     * @param other The existing filter that we are getting the relation to.
     * @returns { ItemFilterRelation }
     */
    getRelationToFilter(other) {
        // Consider disjoint cases before all others
        // If classroomId is different, relation is disjoint
        if (other.classroomId !== this.classroomId) {
            return 'disjoint';
        }
        // If role is different, and neither is NONE, relation is disjoint
        if (this.role !== other.role && this.role !== ClassroomMemberRole.NONE && other.role !== ClassroomMemberRole.NONE) {
            return 'disjoint';
        }
        // If role and classroomId are the same, relation is subset
        if (this.role === other.role) {
            return 'subset';
        }
        // If other role is NONE, it means the filter we're checking against has loaded all members, so we can be sure that it's a subset as either teacher or student is contained in the other filter.
        if (other.role === ClassroomMemberRole.NONE) {
            return 'subset';
        }
        return 'unknown';
    }
    get hash() {
        return `id=${this.classroomId}-${this.role}`;
    }
}

var ClassroomMemberFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': ClassroomMemberFilter
});

const ASSIGNMENTS_INDEX_LINKS = {
    [RelType.ASSIGNMENTS_COLLECTION]: ['classroomId'],
    [RelType.ASSIGNMENTS_CREATE]: ['classroomId'],
    [RelType.ASSIGNMENTS_PRIMARY]: ['assignmentId']
};
var AssignmentStatus;
(function (AssignmentStatus) {
    AssignmentStatus["DRAFT"] = "DRAFT";
    AssignmentStatus["ASSIGNED"] = "ASSIGNED";
})(AssignmentStatus || (AssignmentStatus = {}));
/**
 * A mapping of fields from the local assignment model to the remote assignment model
 * This is the inverse of AssignmentUpdater.
 */
const assignmentRemoteFieldMapping = {
    canClassroomReadSubmissions: 'assignment:canClassroomReadSubmissions',
    instructions: 'assignment:instructions',
    dueDate: 'assignment:dueDate',
    externalTemplateIds: 'assignment:externalTemplateIds',
    templateIds: 'assignment:templateIds',
    name: 'repo:name',
    tasks: 'assignment:tasks',
    status: 'assignment:status',
    referenceIds: 'assignment:referenceIds',
    externalTutorials: 'assignment:externalTemplateIds'
};
var AssignmentSubmissionOwnershipEnums;
(function (AssignmentSubmissionOwnershipEnums) {
    AssignmentSubmissionOwnershipEnums["ANY"] = "ANY";
    AssignmentSubmissionOwnershipEnums["NONE"] = "NONE";
    AssignmentSubmissionOwnershipEnums["SELF"] = "SELF";
})(AssignmentSubmissionOwnershipEnums || (AssignmentSubmissionOwnershipEnums = {}));

const StatusOrderValues$1 = {
    [AssignmentStatus.DRAFT]: 0,
    [AssignmentStatus.ASSIGNED]: 1,
};
const compareAssignmentNames = (a, b) => {
    return compareStrings(a.name || '', b.name || '');
};
const OrderFieldToComparator$h = {
    name(a, b) {
        return compareAssignmentNames(a, b);
    },
    dueDate(a, b) {
        let value;
        if (!a.dueDate && !b.dueDate) {
            value = 0;
        }
        else if (!a.dueDate) {
            value = 1; // Undefined date should be sorted last in ascending order
        }
        else if (!b.dueDate) {
            value = -1;
        }
        else {
            value = compareValues(a.dueDate.getTime(), b.dueDate.getTime());
        }
        if (value === 0) {
            // Within the same dueDate, sort by name
            return compareAssignmentNames(a, b);
        }
        return value;
    },
    status(a, b) {
        const value = compareValues(StatusOrderValues$1[a.status], StatusOrderValues$1[b.status]);
        if (value === 0) {
            // Within the same status, sort by name
            return compareAssignmentNames(a, b);
        }
        return value;
    }
};
class AssignmentOrder extends createItemOrderFactory(OrderFieldToComparator$h) {
}
AssignmentOrder.default = new AssignmentOrder('ascending', 'name');

var AssignmentOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': AssignmentOrder
});

class AssignmentFilter {
    constructor(options = {}) {
        this.classroomId = options.classroomId || '';
        this.submissions = options.submissions;
    }
    matches(item) {
        if (!item.isAssignment) {
            return false;
        }
        if (item.classroomId !== this.classroomId) {
            return false;
        }
        if (item.isDiscarded) {
            return false;
        }
        return true;
    }
    getRelationToFilter(other) {
        // Consider all disjoint cases first
        if (this.classroomId !== other.classroomId) {
            return 'disjoint';
        }
        else {
            // Classroom IDs match
            return 'subset';
        }
    }
    get hash() {
        return `classroomId=${this.classroomId}`;
    }
}

var AssignmentFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': AssignmentFilter
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class StudentAssignmentFilter {
    constructor(options = {}) {
        /**
         * @deprecated This parameter is deprecated and will be removed in the future. Provide currentUserId if only choose self student assignment.
         * This property will be removed on or after 2025-4-1 in ACPCEDU-3388
         */
        this.owner = StudentAssignmentOwner.Any;
        const { assignmentId, assignmentCode, currentUserId, loadDocuments, status } = options;
        this.assignmentId = assignmentId;
        this.assignmentCode = assignmentCode;
        this.loadDocuments = loadDocuments === undefined ? true : loadDocuments;
        this.status = status && status.length > 0 ? status : ALL_STATUSES;
        this.currentUserId = currentUserId;
    }
    matches(item) {
        // If we have items in the pool that extends beyond Self, then we filter to get only the assignments that currently logged in user submitted.
        // NOT_STARTED assignments would not attach a student so it would not be the users assignment.
        if (this.currentUserId && item.student.id !== this.currentUserId) {
            return false;
        }
        if (!this.status.includes(item.status)) {
            return false;
        }
        return true;
    }
    getRelationToFilter(other) {
        // --- Handle all the 'disjoint' cases first ---
        if (other.status.every(status => !this.status.includes(status))) {
            return 'disjoint';
        }
        // NOTE: There are no disjoint cases for loadDocuments yet.
        // --- Handle all 'unknown' cases next ---
        // This has some statuses that are not included with other, but we've ruled out disjoint, so there
        // could be more matches on the server
        if (!this.status.every(status => other.status.includes(status))) {
            return 'unknown';
        }
        // If this wants documents and other does not, then the other might have assignments, but it'll
        // still need to fetch documents.
        if (this.loadDocuments && !other.loadDocuments) {
            return 'unknown';
        }
        // This wants all owners, other only has current user
        if (!this.currentUserId && other.currentUserId) {
            return 'unknown';
        }
        // --- All 'disjoint' and 'unknown' cases are handled above, so it can only be 'subset'  ---
        return 'subset';
    }
    get hash() {
        const assignmentId = this.assignmentId || this.assignmentCode;
        const assignmentIdString = assignmentId ? `assignmentId=${assignmentId}&` : '';
        return `${assignmentIdString}status=${this.status.join()}&loadDocuments=${this.loadDocuments}${this.currentUserId ? `&currentUserId=${this.currentUserId}` : ''}`;
    }
}

var StudentAssignmentFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': StudentAssignmentFilter
});

// Prioritize assignments that require teacher attention: SUBMITTED, IN_PROGRESS, RETURNED, NOT_STARTED
const StatusOrderValues = {
    [StudentAssignmentStatus.SUBMITTED]: 0,
    [StudentAssignmentStatus.IN_PROGRESS]: 1,
    [StudentAssignmentStatus.RETURNED]: 2,
    [StudentAssignmentStatus.NOT_STARTED]: 3,
};
const compareStudentDisplayName = (a, b) => {
    return compareValues(a.student.displayName || '', b.student.displayName || '');
};
const OrderFieldToComparator$g = {
    studentDisplayName(a, b) {
        return compareStudentDisplayName(a, b);
    },
    submissionDate(a, b) {
        let value;
        if (!a.submissionDate && !b.submissionDate) {
            value = 0;
        }
        else if (!a.submissionDate) {
            value = 1; // Undefined date should be sorted last in ascending order
        }
        else if (!b.submissionDate) {
            value = -1;
        }
        else {
            value = compareValues(a.submissionDate.getTime(), b.submissionDate.getTime());
        }
        if (value === 0) {
            // If equal submission date (probably both are undefined), sort by student display name
            return compareStudentDisplayName(a, b);
        }
        return value;
    },
    status(a, b) {
        const value = compareValues(StatusOrderValues[a.status], StatusOrderValues[b.status]);
        if (value === 0) {
            // Within the same status, sort by student display name
            return compareStudentDisplayName(a, b);
        }
        return value;
    }
};
class StudentAssignmentOrder extends createItemOrderFactory(OrderFieldToComparator$g) {
}
StudentAssignmentOrder.default = new StudentAssignmentOrder('ascending', 'studentDisplayName');

var StudentAssignmentOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': StudentAssignmentOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class StudentAssignmentFileAppMetadataResource extends AppMetadataResource {
    constructor(_core, _parent) {
        super(_core, _parent);
        this._core = _core;
        this._parent = _parent;
    }
    async _loadData() {
        // Directly fetches app metadata from R-API since there is a chance app metadata
        // has been fetched external to Hume, such as the case the StudentAssignmentFile was fetched
        // with AssetContext.getAssetWithCloudID.
        await super._loadData();
        // Updates the StudentAssignmentFile to include the latest app metadata
        const session = this._core._getAssetPool().createMutationSession();
        StudentAssignmentFileUpdater.updateLocalItem(session, this._parent, this.data);
        session.commit();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Represents a file that is part of a student assignment.
 */
class StudentAssignmentFile extends AdobeAsset {
    constructor(_core, id, metadata) {
        super(_core, id, metadata);
        this._core = _core;
        this._studentAssignmentId = '';
        this._parentAssignmentId = '';
        this._parentClassroomId = '';
        /**
         * @TODO_Deprecation will be marked as deprecated once all SAM clients
         * have migrated over to linking using sourceAsset.
         */
        this._sourceAssets = [];
        this._sourceTasks = [];
        this._sourceTutorials = [];
        this._studentAssignmentFileAppMetadata = new StudentAssignmentFileAppMetadataResource(_core, this);
        this._needsRepoMetadata = true;
    }
    /**
     * @deprecated Do not use, this object is already an AdobeAsset. This is only in place for temporary compatibility.
     * This method will be removed on or after 2025-4-1 in ACPCEDU-3388
     */
    get adobeAsset() {
        return this;
    }
    get isChildOfStudentAssignment() {
        return true;
    }
    get studentAssignmentId() {
        return this._studentAssignmentId;
    }
    /**
     * Overrides AdobeAsset instance of parentStudentAssignmentId.
     * Equivalent to studentAssignmentId.
     * */
    get parentStudentAssignmentId() {
        return this._studentAssignmentId || super.parentStudentAssignmentId || '';
    }
    /**
     * Overrides AdobeAsset instance of parentAssignmentID.
     * */
    get parentAssignmentID() {
        return this._parentAssignmentId || super.parentAssignmentID || '';
    }
    /**
     * Overrides AdobeAsset instance of isChildOfAssignment.
     * */
    get isChildOfAssignment() {
        return true;
    }
    /**
     * Overrides AdobeAsset instance of isChildOfClassroom.
     * */
    get isChildOfClassroom() {
        return true;
    }
    /**
     * Overrides AdobeAsset instance of parentClassroomId.
     * */
    get parentClassroomId() {
        return this._parentClassroomId || super.parentClassroomId;
    }
    /**
     * Overrides AdobeAsset instance of isChildOfAssignmentMaterials.
     * */
    get isChildOfAssignmentMaterials() {
        return false;
    }
    /**
     * A link to the asset that this file was copied from.
     * Undefined if sourceAssets is set instead OR if this file
     * was NOT copied from an asset
     */
    get sourceAsset() {
        return this._sourceAsset;
    }
    /**
     * Use sourceAsset over sourceAssets if sourceAsset is defined
     * to access the link to the file's source asset.
     *
     * @TODO_Deprecation will be marked as deprecated once all SAM clients
     * have migrated over to linking using sourceAsset.
     */
    get sourceAssets() {
        return this._sourceAssets;
    }
    get sourceTasks() {
        return this._sourceTasks;
    }
    get sourceTutorials() {
        return this._sourceTutorials;
    }
    get appMetadata() {
        return this._studentAssignmentFileAppMetadata;
    }
    /**
     * Updates a StudentAssignmentFile with new metadata.
     *
     * @throws {Error} Incorrect parameters: sourceAsset, sourceTasks, or sourceTutorials parameter required
     *
     * @example <caption>Update a StudentAssignmentFile's sourceAsset</caption>
     * await studentAssignmentFile.update({ sourceAsset: {'repo:assetId': 'urn:mock-id'} });
     */
    async update({ sourceAsset, sourceAssets, sourceTasks, sourceTutorials }) {
        if (!sourceAsset && !sourceAssets && !sourceTasks && !sourceTutorials) {
            throw Error('Incorrect parameters: sourceAsset, sourceTasks, or sourceTutorials parameter required');
        }
        await this._core.classroomContext.updateStudentAssignmentFile(this, {
            sourceAsset,
            sourceAssets,
            sourceTasks,
            sourceTutorials
        });
        return this;
    }
}
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "isChildOfStudentAssignment", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "studentAssignmentId", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "parentStudentAssignmentId", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "parentAssignmentID", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "isChildOfAssignment", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "isChildOfClassroom", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "parentClassroomId", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "isChildOfAssignmentMaterials", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "sourceAsset", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "sourceAssets", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "sourceTasks", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "sourceTutorials", null);
__decorate([
    observable$1
], StudentAssignmentFile.prototype, "appMetadata", null);
const StudentAssignmentFileUpdater = new ItemUpdater({
    localItemType: StudentAssignmentFile,
    remoteIdProperty: 'repo:assetId',
    propertyUpdater: new PropertyUpdater({
        _repositoryID: 'repo:repositoryId',
        _name: 'repo:name',
        _path: 'repo:path',
        _type: 'dc:format',
        _assetClass: { name: 'repo:assetClass', choices: AssetClassChoices },
        _created: { name: 'repo:createDate', format: 'date' },
        _modified: { name: 'repo:modifyDate', format: 'date' },
        _createdBy: 'repo:createdBy',
        _modifiedBy: 'repo:modifiedBy',
        __links: { name: '_links', format: 'object' },
        _parentAssignmentId: { name: 'computedAssignmentId', format: 'string' },
        _parentClassroomId: { name: 'computedClassroomAssetId', format: 'string' },
        _studentAssignmentId: { name: 'computedStudentAssignmentId', format: 'string' },
        _sourceAsset: { name: 'assignment:sourceAsset', format: 'object' },
        /**
         * @TODO_Deprecation will be marked as deprecated once all SAM clients
         * have migrated over to linking using sourceAsset.
         */
        _sourceAssets: { isArray: true, name: 'assignment:sourceAssets', format: 'string' },
        _sourceTasks: { isArray: true, name: 'assignment:sourceTasks', format: 'string' },
        _sourceTutorials: { isArray: true, name: 'assignment:sourceTutorials', format: 'object' },
    })
});

const OrderFieldToComparator$f = {
    modified(a, b) {
        return compareValues(a.modified, b.modified);
    },
    name(a, b) {
        return compareValues(a.name, b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    },
};
class StudentAssignmentFileOrder extends createItemOrderFactory(OrderFieldToComparator$f) {
}
StudentAssignmentFileOrder.default = new StudentAssignmentFileOrder('descending', 'modified');

var StudentAssignmentFileOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': StudentAssignmentFileOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const AdobeAssetFilterName = 'AdobeAssetFilter';
/**
 * For ItemSources on AssetContext and AdobeAsset, the AdobeAssetFilter is the only one used by clients today.
 * Separately, we have the USSAdobeAssetFilter which is used by clients to filter USS assets,
 * and other external filters on other sources.
 * This filter can be used to filter AdobeAsset objects by mediaType and excludeMediaType.
 * If both mediaType and excludeMediaType are specified then only mediaType
 * will be considered for filtering. If neither mediaType nor excludeMediaType are specified then all mediaTypes
 * will be considered for filtering.
 */
class AdobeAssetFilter {
    constructor(options) {
        var _a, _b;
        this._mediaTypes = undefined;
        this._excludeMediaTypes = undefined;
        if (options === null || options === void 0 ? void 0 : options.mediaTypes) {
            this._mediaTypes = new Set(options.mediaTypes);
        }
        if (options === null || options === void 0 ? void 0 : options.excludeMediaTypes) {
            this._excludeMediaTypes = new Set(options.excludeMediaTypes);
        }
        if (((_a = options === null || options === void 0 ? void 0 : options.mediaTypes) === null || _a === void 0 ? void 0 : _a.length) && ((_b = options === null || options === void 0 ? void 0 : options.excludeMediaTypes) === null || _b === void 0 ? void 0 : _b.length)) {
            this._mediaTypes = new Set([]);
            console.warn('Both mediaTypes and excludeMediaTypes should not be specified while creating AdobeAssetFilter, setting default value for mediaTypes');
        }
    }
    get hash() {
        var _a, _b;
        let mediaTypeHashPart = 'mediatypes=' + (((_a = this._mediaTypes) === null || _a === void 0 ? void 0 : _a.size) ? `${[...this._mediaTypes].sort().join(',')}` : 'all-types');
        mediaTypeHashPart += ':excludemediatypes=' + (((_b = this._excludeMediaTypes) === null || _b === void 0 ? void 0 : _b.size) ? `${[...this._excludeMediaTypes].sort().join(',')}` : 'none');
        return mediaTypeHashPart;
    }
    get mediaTypes() {
        return this._mediaTypes;
    }
    get excludeMediaTypes() {
        return this._excludeMediaTypes;
    }
    get name() {
        return AdobeAssetFilterName;
    }
    matches(item) {
        var _a, _b, _c;
        // SAMJS-627: exclude Express artifacts unless Express media type is explicitly requested
        if (item.reviewLinkSourceType === EXPRESS_ARTIFACT_TYPE && !((_a = this._mediaTypes) === null || _a === void 0 ? void 0 : _a.has(EXPRESS_ARTIFACT_TYPE))) {
            return false;
        }
        return (!((_b = this._excludeMediaTypes) === null || _b === void 0 ? void 0 : _b.size) || !this._excludeMediaTypes.has(item.mediaType))
            && (!((_c = this._mediaTypes) === null || _c === void 0 ? void 0 : _c.size) || this._mediaTypes.has(item.mediaType));
    }
    getRelationToFilter(other) {
        var _a, _b;
        const mediaTypeRelation = this.getMediaRelationToFilter(other);
        if (mediaTypeRelation === 'disjoint') {
            return 'disjoint';
        }
        //----- All 'disjoint' cases must be handled above this line
        if (mediaTypeRelation === 'unknown') {
            // This filter shares some, but not all of the mediaTypes of other. They
            // could overlap, but can't know for sure.
            return 'unknown';
        }
        // SAMJS-627 when switching from no filtering by mediaType to filtering by Express artifacts,
        // a refresh most likely needs to be done since Express artifacts are filtered out by default in most USS
        // queries
        if (((_a = this._mediaTypes) === null || _a === void 0 ? void 0 : _a.has(EXPRESS_ARTIFACT_TYPE)) && !((_b = other.mediaTypes) === null || _b === void 0 ? void 0 : _b.size)) {
            return 'unknown';
        }
        //------ All 'unknown' cases must be handled above this line
        // Since the filters can't be 'disjoint', there must be some overlap, leaving
        // only 'unknown' and 'subset' as a possibility. Since all 'unknown' cases have
        // been eliminated, the only remaining possibility is 'subset'.
        // NOTE: Returns mediaTypeRelation for verification in unit tests.
        return mediaTypeRelation;
    }
    /*
    Cases to be handled for include and exclude filter:
    ---------------------------------------------------------------------------------
    this_include | this_exclude | other_include | other_exclude | case no,
                                                                    possible values
                                                                    s=subset,
                                                                    u=unknown,
                                                                    d=disjoint
    ---------------------------------------------------------------------------------
        0               0               0               0           case 1 - s
    ---------------------------------------------------------------------------------
        0               0               0               1           case 2 - u
    ---------------------------------------------------------------------------------
        0               0               1               0           case 3 - u
    ---------------------------------------------------------------------------------
        0               0               1               1           na
    ---------------------------------------------------------------------------------
        0               1               0               0           case 4 - s
    ---------------------------------------------------------------------------------
        0               1               0               1           case 5 - s & u
    ---------------------------------------------------------------------------------
        0               1               1               0           case 6 - u & d
    ---------------------------------------------------------------------------------
        0               1               1               1           na
    ---------------------------------------------------------------------------------
        1               0               0               0           case 7 - s
    ---------------------------------------------------------------------------------
        1               0               0               1           case 8 - s, u & d
    ---------------------------------------------------------------------------------
        1               0               1               0           case 9 - s, u & d
    ---------------------------------------------------------------------------------
        1               0               1               1           na
    ---------------------------------------------------------------------------------
        1               1               0               0           na
    ---------------------------------------------------------------------------------
        1               1               0               1           na
    ---------------------------------------------------------------------------------
        1               1               1               0           na
    ---------------------------------------------------------------------------------
        1               1               1               1           na
    ---------------------------------------------------------------------------------

    There are some cases which are not applicable(na) because for now it is not allowed to specify both include
    and exclude mediatypes on a filter
    */
    getMediaRelationToFilter(other) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        let mediaTypeRelation;
        (function (mediaTypeRelation) {
            mediaTypeRelation[mediaTypeRelation["uninitialized"] = 0] = "uninitialized";
            mediaTypeRelation[mediaTypeRelation["subset"] = 1] = "subset";
            mediaTypeRelation[mediaTypeRelation["disjoint"] = 2] = "disjoint";
            mediaTypeRelation[mediaTypeRelation["intersaction"] = 3] = "intersaction";
        })(mediaTypeRelation || (mediaTypeRelation = {}));
        function getMediaTypeRelation(current, other) {
            let subset = true;
            let intersaction = false;
            for (const item of current) {
                if (other.has(item)) {
                    intersaction = true;
                }
                else {
                    subset = false;
                }
            }
            if (!intersaction) {
                return mediaTypeRelation.disjoint;
            }
            else if (subset) {
                return mediaTypeRelation.subset;
            }
            return mediaTypeRelation.intersaction;
        }
        let thisIncludeOtherInclude = mediaTypeRelation.uninitialized;
        let thisIncludeOtherExclude = mediaTypeRelation.uninitialized;
        let otherIncludeThisExclude = mediaTypeRelation.uninitialized;
        let otherExcludethisExclude = mediaTypeRelation.uninitialized;
        if (((_a = this._mediaTypes) === null || _a === void 0 ? void 0 : _a.size) && ((_b = other._mediaTypes) === null || _b === void 0 ? void 0 : _b.size)) {
            thisIncludeOtherInclude = getMediaTypeRelation(this._mediaTypes, other._mediaTypes);
        }
        if (((_c = this._mediaTypes) === null || _c === void 0 ? void 0 : _c.size) && ((_d = other._excludeMediaTypes) === null || _d === void 0 ? void 0 : _d.size)) {
            thisIncludeOtherExclude = getMediaTypeRelation(this._mediaTypes, other._excludeMediaTypes);
        }
        if (((_e = this._excludeMediaTypes) === null || _e === void 0 ? void 0 : _e.size) && ((_f = other._mediaTypes) === null || _f === void 0 ? void 0 : _f.size)) {
            otherIncludeThisExclude = getMediaTypeRelation(other._mediaTypes, this._excludeMediaTypes);
        }
        if (((_g = this._excludeMediaTypes) === null || _g === void 0 ? void 0 : _g.size) && ((_h = other._excludeMediaTypes) === null || _h === void 0 ? void 0 : _h.size)) {
            otherExcludethisExclude = getMediaTypeRelation(other._excludeMediaTypes, this._excludeMediaTypes);
        }
        // handling disjoint for case 6, 8, 9
        if (otherIncludeThisExclude === mediaTypeRelation.subset
            || thisIncludeOtherExclude === mediaTypeRelation.subset
            || thisIncludeOtherInclude === mediaTypeRelation.disjoint) {
            return 'disjoint';
        }
        // handling unknown for case 5, 6, 8, 9
        if (otherExcludethisExclude === mediaTypeRelation.intersaction
            || otherIncludeThisExclude === mediaTypeRelation.intersaction
            || thisIncludeOtherExclude === mediaTypeRelation.intersaction
            || thisIncludeOtherInclude === mediaTypeRelation.intersaction) {
            return 'unknown';
        }
        // handling for case 2, 3 - only possible value 'unknown'
        if (!((_j = this._mediaTypes) === null || _j === void 0 ? void 0 : _j.size) && !((_k = this._excludeMediaTypes) === null || _k === void 0 ? void 0 : _k.size)
            && (((_l = other._mediaTypes) === null || _l === void 0 ? void 0 : _l.size) || ((_m = other._excludeMediaTypes) === null || _m === void 0 ? void 0 : _m.size))) {
            // If the other list has mediaType/excludeMediaType and this filter doesn't then
            // this list is going to have an unknown final state.
            return 'unknown';
        }
        // we have handled all possible disjoint/unknown cases above and can safely return subset from here
        return 'subset';
    }
}

var AdobeAssetFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': AdobeAssetFilter
});

/**
 * This file and filter may not be needed in the future.
 * @deprecated This can be removed with ClassroomContext.getStudentAssignmentFiles(). Will be removed in ACPCEDU-3305.
 */
// NOTE: This is used as an implicit filter in StudentAssignment.files, and internally as an explicit filter in
// ClassroomContext.getStudentAssignmentFiles(). In the latter case, it is used to filter AdobeAsset.children()
// so it must extend AdobeAssetFilter for type-checking purposes, even though none of the features of
// AdobeAssetFilter are used. This is preferable to allowing AdobeAsset.children take StudentAssignmentFilesListFilter
// as an explicit filter, as it shouldn't be part of the public interface.
class StudentAssignmentFilesListFilter extends AdobeAssetFilter {
    matches(item) {
        // Note: not calling super here, because this is only needed for the internal case
        // of using StudentAssignmentFilesListFilter as the explicit filter in
        // ClassroomContext.getStudentAssignmentFiles()
        return item.isChildOfStudentAssignment;
    }
}

class StudentAssignmentFileFilter {
    /**
     *
     * @param studentAssignmentId The ID of the StudentAssignment that the files returned are associated with
     * @param options Deprecated, further filtering of files is not supported at this time. This argument will be removed on or after 2025-7-1 in ACPCEDU-3393
     */
    constructor(studentAssignmentId, options) {
        var _a;
        this.studentAssignmentId = studentAssignmentId;
        this.loadDocuments = (_a = options === null || options === void 0 ? void 0 : options.loadDocuments) !== null && _a !== void 0 ? _a : true;
    }
    matches(item) {
        /**
         * Assets that are StudentAssignmentFiles may start out cached
         * as an AdobeAsset when the asset initially exists outside EDU assets.
         * Therefore this checks for SAFs using attributes that are also available through
         * the AdobeAsset interface.
         *
         * [ACPCEDU-3290] will introduce a longer-term approach for handling this behavior
         * to support other/future cases where the asset type changes over time
         * */
        return item.isChildOfStudentAssignment === true
            && item.studentAssignmentId === this.studentAssignmentId
            && !item.isFolder
            && item.mediaType !== FOLDER_TYPE // [ACPCEDU-3156]: Can be removed once hume is returning repo:assetClass
            && !isAssetAWebsiteTemplate(item);
    }
    getRelationToFilter(other) {
        if (this.loadDocuments !== other.loadDocuments) {
            return 'disjoint';
        }
        return this.studentAssignmentId === other.studentAssignmentId
            ? 'subset' : 'disjoint';
    }
    get hash() {
        return `studentAssignmentId=${this.studentAssignmentId}&loadDocuments=${this.loadDocuments}`;
    }
}

var StudentAssignmentFileFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': StudentAssignmentFileFilter
});

/*************************************************************************
   *
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2025 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by trade secret or copyright law.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
var BoardMemberRole;
(function (BoardMemberRole) {
    BoardMemberRole["OWNER"] = "Owner";
    BoardMemberRole["POSTER"] = "Poster";
    BoardMemberRole["VIEWER"] = "Viewer";
})(BoardMemberRole || (BoardMemberRole = {}));
var PostType;
(function (PostType) {
    PostType["Text"] = "text";
    PostType["AssetLink"] = "assetLink";
})(PostType || (PostType = {}));
const BOARDS_INDEX_LINKS = {
    [RelType.BOARDS_COLLECTION]: ['baseAssetId'],
    [RelType.BOARDS_CREATE]: ['baseAssetId'],
    [RelType.BOARDS_PRIMARY]: ['boardId']
};
var POST_REMOTE_DATA_TYPE;
(function (POST_REMOTE_DATA_TYPE) {
    POST_REMOTE_DATA_TYPE["TEXT"] = "application/vnd.adobe.post.text+dcx";
    POST_REMOTE_DATA_TYPE["ASSET_LINK"] = "application/vnd.adobe.post.assetlink+dcx";
})(POST_REMOTE_DATA_TYPE || (POST_REMOTE_DATA_TYPE = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/** Represents a post for a Board */
class Post extends ItemBase {
    constructor() {
        super(...arguments);
        this._name = undefined;
        this._created = undefined;
        this._modified = undefined;
        this._description = undefined;
        this._createdData = undefined;
        this._modifiedData = undefined;
        this._boardId = '';
    }
    get boardId() { return this._boardId; }
    get type() { return this._type; }
    get name() { return this._name; }
    get created() { return this._created ? new Date(this._created) : undefined; }
    get modified() { return this._modified ? new Date(this._modified) : undefined; }
    get description() { return this._description; }
    get createdData() { return this._createdData; }
    get modifiedData() { return this._modifiedData; }
    /** Returns whether the current post can be discarded */
    get isDeletable() {
        // only board owner or the post owner can delete the post
        return this.isOwner() || this._isBoardOwner();
    }
    /** Returns whether the current post can be edited */
    get isEditable() {
        // the post is editable only if the current user is the owner of the post or the board
        // this logic is the same as isDeletable
        return this.isDeletable;
    }
    /** Returns whether the current user is the owner of the post */
    isOwner() {
        var _a;
        return ((_a = this.createdData) === null || _a === void 0 ? void 0 : _a.userId) === this._core._environment.getUserId();
    }
    /** Returns whether the current user is the owner of the board */
    _isBoardOwner() {
        var _a;
        return ((_a = this._core._getAssetPool().getLocalItemById(this._boardId)) === null || _a === void 0 ? void 0 : _a.role) === BoardMemberRole.OWNER;
    }
}
__decorate([
    observable$1
], Post.prototype, "boardId", null);
__decorate([
    observable$1
], Post.prototype, "type", null);
__decorate([
    observable$1
], Post.prototype, "name", null);
__decorate([
    observable$1
], Post.prototype, "created", null);
__decorate([
    observable$1
], Post.prototype, "modified", null);
__decorate([
    observable$1
], Post.prototype, "description", null);
__decorate([
    observable$1
], Post.prototype, "createdData", null);
__decorate([
    observable$1
], Post.prototype, "modifiedData", null);
__decorate([
    observable$1
], Post.prototype, "isDeletable", null);
__decorate([
    observable$1
], Post.prototype, "isEditable", null);
const getChildPostUpdater = (map) => new PropertyUpdater(Object.assign({ _boardId: { name: 'computedBoardId', format: 'string' }, _name: { name: 'name', format: 'string' }, _type: { name: 'type', format: 'string', choices: Object.values(POST_REMOTE_DATA_TYPE) }, _description: { name: 'board#description', format: 'string' }, _modifiedData: { name: 'board#modifiedData', format: 'object' }, _modified: { name: 'board#modified', format: 'date' }, _createdData: { name: 'board#createdData', format: 'object' }, _created: { name: 'board#created', format: 'date' } }, map));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/** Represents a post for a Board which just contains text */
class TextPost extends Post {
    get text() {
        return this._text;
    }
}
const TextPostUpdater = new ItemUpdater({
    localItemType: TextPost,
    remoteIdProperty: 'id',
    propertyUpdater: getChildPostUpdater({
        _text: { name: 'board#text', format: 'string' },
    })
});

/*************************************************************************
   *
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2025 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by trade secret or copyright law.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
/**
 * This is a temporary file while the Hume service implements the Boards API.
 * It contains mock response objects that we expect Hume to provide us in the future.
 * This will be removed in ACPCEDU-3727
 */
const GetAssetByCloudIdResponse = {
    'repo:assetClass': 'composite',
    'repo:repositoryId': 'B34A1964668D032F0A49421B@AdobeOrg',
    'repo:id': 'urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb',
    'repo:assetId': 'urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb',
    'repo:name': 'Assignment S. test drawing 23 13.28.59.exdraw',
    'repo:path': '/content/assets/classrooms/280E19426706F8460A494118@AdobeOrg/assignments/test drawing 23/students/AFC3197E668D1EAE0A494129@af361967668d0331494131.e/Assignment S. test drawing 23 13.28.59.exdraw',
    'repo:ancestors': [
        'urn:aaid:directory:4827207b-2491-47ab-9db6-4d85655e66d5',
        'urn:aaid:directory:d527b150-4b57-499a-b165-39a950d6657a',
        'urn:aaid:sc:VA6C2:769c4b79-f4c0-4334-be87-19d576f995f4',
        'urn:aaid:sc:VA6C2:7b52cd2c-81d1-3729-a45f-4038280c6a29',
        'urn:aaid:sc:VA6C2:58721060-2e1b-305c-a621-3f01983a16d3',
        'urn:aaid:sc:VA6C2:33a7a14d-5ad6-3e98-8f29-187e6656b6f2',
        'urn:aaid:sc:VA6C2:885eb5af-565e-3869-a82b-eb285132318c',
        'urn:aaid:sc:VA6C2:996eb5af-565e-3869-a82b-eb285143429d',
        'urn:aaid:sc:AB1:a1234cd1-2b34-5678-910c-626262626262'
    ],
    'dc:format': 'document/vnd.adobe.expressdrawing+dcx',
    'repo:createDate': '2024-12-05T21:29:18.191Z',
    'repo:modifyDate': '2024-12-05T21:29:19.414Z',
    'storage:deviceCreateDate': '2024-12-05T21:29:05.027Z',
    'storage:deviceModifyDate': '2024-12-05T21:29:17.534Z',
    'repo:state': 'ACTIVE',
    'repo:createdBy': 'AFC3197E668D1EAE0A494129@af361967668d0331494131.e',
    'repo:modifiedBy': 'AFC3197E668D1EAE0A494129@af361967668d0331494131.e',
    'repo:createdByClientId': 'projectx_webapp',
    'repo:modifiedByClientId': 'projectx_webapp',
    'repo:representations': {
        'composite': true
    },
    'storage:assignee': {
        'id': 'B34A1964668D032F0A49421B@AdobeOrg',
        'type': 'org'
    },
    'storage:region': 'VA6C2',
    'repo:etag': '"7eb7ca4e6e5d48f9999a7b04683c9330"',
    'repo:size': 55370,
    'repo:version': '0',
    '_links': {
        'http://ns.adobe.com/adobecloud/rel/ac/check': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/acl/check/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb{?privilege,relation}',
                'templated': true
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/ac/effective': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/acl/effective/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/ac/policy': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/acl/policy/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/bulk': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb/:bulk',
                'mode': 'id'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw/:bulk',
                'mode': 'path'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/component': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/composite/component/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb{?component_id,revision,component_path}',
                'mode': 'id',
                'templated': true
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/composite/component/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw{?component_id,revision,component_path}',
                'mode': 'path',
                'templated': true
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/directory': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/id/urn:aaid:sc:VA6C2:06569d1b-bad3-3d88-8f83-7b33cad6d7da/:page{?resource,orderBy,start,limit,type,embed}',
                'mode': 'id',
                'templated': true
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/:page{?resource,orderBy,start,limit,type,embed}',
                'mode': 'path',
                'templated': true
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/manifest': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/composite/manifest/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb',
                'mode': 'id'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/composite/manifest/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw',
                'mode': 'path'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/metadata/application': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb/:applicationmetadata',
                'mode': 'id',
                'type': 'application/json'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw/:applicationmetadata',
                'mode': 'path',
                'type': 'application/json'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/metadata/embedded': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/composite/metadata/embedded/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb',
                'mode': 'id'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/composite/metadata/embedded/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw',
                'mode': 'path'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/metadata/peruser': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/metadata/peruser/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb',
                'mode': 'id',
                'type': 'application/json'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/metadata/peruser/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw',
                'mode': 'path',
                'type': 'application/json'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/metadata/repository': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb/:repometadata',
                'mode': 'id',
                'type': 'application/json'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw/:repometadata',
                'mode': 'path',
                'type': 'application/json'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/page': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb/resource:{resource}/:page{?orderBy,start,limit,property,version}',
                'mode': 'id',
                'templated': true,
                'type': 'application/vnd.adobe.versions+json'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw/resource:{resource}/:page{?orderBy,start,limit,property,version}',
                'mode': 'path',
                'templated': true,
                'type': 'application/vnd.adobe.versions+json'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/primary': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/composite/primary/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb',
                'mode': 'id'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/composite/primary/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw',
                'mode': 'path'
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/rendition': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/rendition/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb{?resource,component_id,fragment,size,type}',
                'mode': 'id',
                'templated': true
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/rendition/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw{?resource,component_id,fragment,size,type}',
                'mode': 'path',
                'templated': true
            }
        ],
        'http://ns.adobe.com/adobecloud/rel/repository': {
            'href': 'https://platform-cs-edge-stage.adobe.io/content/directory/repo/B34A1964668D032F0A49421B@AdobeOrg/repositoryResource'
        },
        'version-history': [
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/id/urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb/:versions',
                'mode': 'id'
            },
            {
                'href': 'https://platform-cs-edge-stage-va6c2.adobe.io/content/storage/path/urn:aaid:sc:VA6C2:c19b59e0-6d4e-4f81-93a1-e00168bc2c06/classrooms/280E19426706F8460A494118%40AdobeOrg/assignments/test%20drawing%2023/students/AFC3197E668D1EAE0A494129%40af361967668d0331494131.e/Assignment%20S.%20test%20drawing%2023%2013.28.59.exdraw/:versions',
                'mode': 'path'
            }
        ]
    }
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/** Represents a post for a Board which links to an Asset */
class AssetLinkPost extends Post {
    // TODO: Uncomment once the API is ready in ACPCEDU-3727
    // private _link!: ResourceReference;
    getLinkedAsset() {
        // TODO: Remove once the API is ready in ACPCEDU-3727
        // return this._core.hostAssetContext.getAssetWithCloudID(this._link['repo:assetId']);
        const session = this._core._getAssetPool().createUpdateSession();
        const asset = AdobeAssetUpdater.updateRemoteItem(session, GetAssetByCloudIdResponse);
        session.commit();
        return Promise.resolve(asset);
    }
}
const AssetLinkPostUpdater = new ItemUpdater({
    localItemType: AssetLinkPost,
    remoteIdProperty: 'id',
    propertyUpdater: getChildPostUpdater({
        _link: { name: 'link', format: 'object' },
    }),
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class PostListLoader {
    constructor(_remotePosts, _core) {
        this._remotePosts = _remotePosts;
        this._core = _core;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    /** @note api does not support pagination */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async _loadPage(options) {
        const { implicitFilter } = options;
        const textPosts = [];
        const assetLinkPosts = [];
        const postSession = (await this._core.getBoardContext()).postPool.createMutationSession();
        // Create TextPosts and AssetLinkPosts and add them to the non-asset pool
        this._remotePosts.forEach((remotePost) => {
            const remotePostWithComputedValues = Object.assign(Object.assign({}, remotePost), { computedBoardId: implicitFilter.boardId });
            if (remotePost['type'] === POST_REMOTE_DATA_TYPE.TEXT) {
                textPosts.push(TextPostUpdater.updateRemoteItem(postSession, remotePostWithComputedValues));
            }
            else if (remotePost['type'] === POST_REMOTE_DATA_TYPE.ASSET_LINK) {
                assetLinkPosts.push(AssetLinkPostUpdater.updateRemoteItem(postSession, remotePostWithComputedValues));
            }
        });
        // Fetch the assets for the AssetLinkPosts
        const fetchAssetPromises = assetLinkPosts.map((post) => {
            return post.getLinkedAsset();
        });
        Promise.all(fetchAssetPromises);
        postSession.commit();
        return {
            items: [...textPosts, ...assetLinkPosts],
            total: textPosts.length + assetLinkPosts.length,
            loadNextPage: undefined,
        };
    }
}

/*************************************************************************
   *
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2025 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by trade secret or copyright law.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
class PostFilter {
    constructor(options) {
        const { boardId } = options;
        this.boardId = boardId;
        if (this.boardId === '') {
            throw new Error('Board ID is required');
        }
    }
    getRelationToFilter(other) {
        // Consider all disjoint cases first
        if (this.boardId !== other.boardId) {
            return 'disjoint';
        }
        else {
            // Board IDs match
            return 'subset';
        }
    }
    matches(item) {
        if (!(item instanceof Post)) {
            return false;
        }
        // At this point, the item is a Post instance
        const post = item;
        if (post.boardId !== this.boardId) {
            return false;
        }
        return true;
    }
    get hash() {
        return `boardId=${this.boardId}`;
    }
}

/*************************************************************************
   *
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2025 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by trade secret or copyright law.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
class Board extends AdobeAsset {
    constructor(_core, id, metadata) {
        super(_core, id, metadata);
        this._core = _core;
        // TODO [ACPCEDU-3754]: Will use BoardsInterface in this ticket
        // private _boardsInterface = new BoardsInterface(this._core);
        this._description = '';
        this._remotePosts = [];
        this._memberRole = BoardMemberRole.VIEWER;
        this._core.getBoardContext().then((boardContext) => {
            this._boardContext = boardContext;
        });
        // Overridden property.
        // True to start with. If we have the metadata, we will update this.
        // Keep in mind that the board service does not include all Adobe
        // Asset metadata in its responses, hence why this is needed.
        this._needsRepoMetadata = true;
    }
    /**
     * Ensures that the board context has been fetched before using it
     * @throws {Error} if the board context is not initialized
     */
    _ensureBoardContext() {
        if (!this._boardContext) {
            throw new Error('Board context not initialized');
        }
        return this._boardContext;
    }
    /**
     * Gets the ItemSource for all posts in the pool
     * @package -- for SAM.js internal use only
     */
    _getPostsSource(implicitFilter) {
        const loader = new PostListLoader(this._remotePosts, this._core);
        return new ItemSource(this._ensureBoardContext().postPool, [loader], implicitFilter);
    }
    /**
     * Fetches the list of Posts for this Board
     *
     * @experimental
     * @example <caption>Get all posts for this board</caption>
     * const posts = board.posts.getList(PostOrder.default);
     */
    get posts() {
        return this._getPostsSource(new PostFilter({ boardId: this.id }));
    }
    get description() {
        return this._description;
    }
    /** The board name contains '.ccboard' suffix, so we need to remove it for display */
    get displayName() {
        return this._name.replace(Board.boardNameSuffix, '');
    }
    /**
     * The ID of the asset containing the 'boards' directory that contains the board.
     * In other words, the ID of the asset that is 2 levels up from the board.
     *
     * @package -- for SAM.js internal use only
     */
    get _idOfBaseAsset() {
        return this._baseAssetId;
    }
    /**
     * The role of the current user in the board.
     *
     * @example <caption>Get the role of the current user in the board</caption>
     * const role = board.role;
     */
    get role() {
        return this._memberRole;
    }
    /**
     * @experimental
     */
    async addPost(options) {
        return this._ensureBoardContext().addPost(Object.assign({ boardId: this.id }, options));
    }
    /**
     * @experimental
     */
    async removePost(postId) {
        await this._ensureBoardContext().removePost({ boardId: this.id, postId });
    }
    /**
     * Updates a post on the given board
     * @experimental
     */
    async updatePost(options) {
        await this._ensureBoardContext().updatePost(Object.assign({ boardId: this.id }, options));
    }
    /**
     * Update manifest metadata for the board. Use addPost() and removePost() to manage posts.
     *
     * @experimental
     */
    async update(options) {
        return this._ensureBoardContext().updateBoard(Object.assign({ boardId: this.id }, options));
    }
    async permanentlyDelete() {
        // TODO [ACPCEDU-3754]: call BoardContext.deleteBoard()
        return;
    }
    /**
     * @experimental
     */
    async discard() {
        // TODO [ACPCEDU-3754]: implement this function
        return;
    }
    /**
     * @experimental
     */
    async restore() {
        // TODO [ACPCEDU-3754]: implement this function
        return;
    }
    get links() {
        // Make a copy to avoid the client accidentally manipulating the links
        return Object.assign({}, this.__links);
    }
    async publish() {
        // TODO [ACPCEDU-3888]: call BoardContext.publishBoard()
        return Promise.resolve();
    }
    get canAddPost() {
        return this._memberRole === BoardMemberRole.OWNER || this._memberRole === BoardMemberRole.POSTER;
    }
}
Board.boardNameSuffix = '.ccboard';
__decorate([
    memoize$1
], Board.prototype, "posts", null);
__decorate([
    observable$1
], Board.prototype, "description", null);
__decorate([
    observable$1
], Board.prototype, "displayName", null);
__decorate([
    observable$1
], Board.prototype, "_idOfBaseAsset", null);
__decorate([
    observable$1
], Board.prototype, "role", null);
__decorate([
    observable$1
], Board.prototype, "links", null);
function getBoardPermission(source) {
    var _a;
    // From R-API directory listing or USS listings
    if ((_a = source._embedded) === null || _a === void 0 ? void 0 : _a[RelType.AC_EFFECTIVE]) {
        return parseEffectivePermissions(source._embedded[RelType.AC_EFFECTIVE]);
    }
    // TODO [ACPCEDU-3995]: remove the following switch block when "_embedded" is available
    switch (source.memberRole) {
        case BoardMemberRole.OWNER:
            return Permission$1.Write | Permission$1.Read | Permission$1.Delete;
        case BoardMemberRole.POSTER:
        case BoardMemberRole.VIEWER:
            return Permission$1.Read;
        default:
            return NotFound;
    }
}
const BoardUpdater = new ItemUpdater({
    localItemType: Board,
    remoteIdProperty: 'repo:assetId',
    propertyUpdater: new PropertyUpdater({
        _id: { name: 'repo:assetId', format: 'string' },
        _assetClass: { name: 'repo:assetClass', choices: AssetClassChoices },
        _description: { name: 'board#description', format: 'string' },
        _name: { name: 'repo:name', format: 'string' },
        _created: { name: 'repo:createDate', format: 'date' },
        _repositoryID: { name: 'repo:repositoryId', format: 'string' },
        __links: { name: '_links', format: 'object' },
        _createdBy: { name: 'repo:createdBy', format: 'string' },
        _modifiedBy: { name: 'repo:modifiedBy', format: 'string' },
        _modified: { name: 'repo:modifyDate', format: 'date' },
        _assetState: { name: 'repo:state', choices: AssetStateChoices },
        _type: { name: 'dc:format', format: 'string' },
        _path: { name: 'repo:path', format: 'string' },
        _remotePosts: {
            isArray: true,
            name: 'posts',
            format: 'object',
        },
        _baseAssetId: { name: 'board:context[baseAssetId]', format: 'string' },
        _memberRole: { name: 'memberRole', choices: Object.values(BoardMemberRole) },
        _permissions: { get: getBoardPermission, format: 'number' },
    }),
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$e = {
    // Preserve original order
    noop() {
        return 0;
    },
};
class PostOrder extends createItemOrderFactory(OrderFieldToComparator$e) {
}
/**
 * Default ordering - original order from the server (no sorting)
 */
PostOrder.default = new PostOrder('ascending', 'noop');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const compareBoardNames = (a, b) => compareStrings(a.displayName || '', b.displayName || '');
const compareBoardTimes = (a, b, field) => {
    let value;
    if (!a[field] && !b[field]) {
        value = 0;
    }
    else if (!a[field]) {
        value = 1;
    }
    else if (!b[field]) {
        value = -1;
    }
    else {
        value = compareValues(a[field].getTime(), b[field].getTime());
    }
    return value === 0 ? compareBoardNames(a, b) : value;
};
const OrderFieldToComparator$d = {
    name(a, b) {
        return compareBoardNames(a, b);
    },
    created(a, b) {
        return compareBoardTimes(a, b, 'created');
    },
    modified(a, b) {
        return compareBoardTimes(a, b, 'modified');
    }
};
class BoardOrder extends createItemOrderFactory(OrderFieldToComparator$d) {
}
BoardOrder.default = new BoardOrder('ascending', 'name');

var BoardOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': BoardOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class BoardFilter {
    constructor(options = {}) {
        this.baseAssetId = options.baseAssetId || '';
    }
    matches(item) {
        // TODO: Add check for Board instance type ACPCEDU-3983
        // Filter by baseAssetId and discard discarded boards
        if (item._idOfBaseAsset !== this.baseAssetId) {
            return false;
        }
        if (item.isDiscarded) {
            return false;
        }
        return true;
    }
    getRelationToFilter(other) {
        if (this.baseAssetId !== other.baseAssetId) {
            return 'disjoint';
        }
        else {
            return 'subset';
        }
    }
    get hash() {
        return `baseAssetId=${this.baseAssetId}`;
    }
}

var BoardFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': BoardFilter
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class OrgRepository extends ItemBase {
    constructor() {
        super(...arguments);
        this._repositoryID = '';
    }
    get repositoryID() {
        return this._repositoryID;
    }
    /**
     * Create a team under /content/assets folder.
     */
    async createTeam(data) {
        return await this._core.spaceContext.createTeam(this, data);
    }
}
__decorate([
    observable$1
], OrgRepository.prototype, "repositoryID", null);
const OrgRepositoryUpdater = new ItemUpdater({
    localItemType: OrgRepository,
    remoteIdProperty: 'repositoryId',
    propertyUpdater: new PropertyUpdater({
        '_repositoryID': 'repositoryId'
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var AvatarSizes;
(function (AvatarSizes) {
    AvatarSizes["Size50"] = "50";
    AvatarSizes["Size100"] = "100";
    AvatarSizes["Size115"] = "115";
    AvatarSizes["Size230"] = "230";
    AvatarSizes["Size138"] = "138";
    AvatarSizes["Size276"] = "276";
})(AvatarSizes || (AvatarSizes = {}));

class AddressBookContact extends ItemBase {
    constructor(core, id) {
        super(core, id);
        this._countryCode = '';
        this._displayName = '';
        this._email = '';
        this._firstName = '';
        this._lastName = '';
        this._addressBookIdent = '';
        this._images = {};
        this._linkedIdentity = '';
        this._urn = '';
    }
    get ident() {
        return this.id;
    }
    get countryCode() {
        return this._countryCode;
    }
    get displayName() {
        return this._displayName;
    }
    get email() {
        return this._email;
    }
    get firstName() {
        return this._firstName;
    }
    get lastName() {
        return this._lastName;
    }
    get addressBookIdent() {
        return this._addressBookIdent;
    }
    get images() {
        return this._images;
    }
    get linkPolicy() {
        return this._linkPolicy;
    }
    get linkedIdentity() {
        return this._linkedIdentity;
    }
    get urn() {
        return this._urn;
    }
}
__decorate([
    observable$1
], AddressBookContact.prototype, "countryCode", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "displayName", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "email", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "firstName", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "lastName", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "addressBookIdent", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "images", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "linkPolicy", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "linkedIdentity", null);
__decorate([
    observable$1
], AddressBookContact.prototype, "urn", null);
const AddressBookContactUpdater = new ItemUpdater({
    localItemType: AddressBookContact,
    remoteIdProperty: 'ident',
    propertyUpdater: new PropertyUpdater({
        _countryCode: 'countryCode',
        _displayName: 'displayName',
        _email: 'email',
        _firstName: 'firstName',
        _addressBookIdent: 'addressBookIdent',
        _images: { format: 'object', name: 'images' },
        _lastName: 'lastName',
        _linkPolicy: 'linkPolicy',
        _linkedIdentity: 'linkedIdentity',
        _urn: 'urn'
    })
});

class GroupMemberLoader {
    constructor(_addressBookUrl, _groupMemberPool, _addressBookInterface, _groupMemberUpdater) {
        this._addressBookUrl = _addressBookUrl;
        this._groupMemberPool = _groupMemberPool;
        this._addressBookInterface = _addressBookInterface;
        this._groupMemberUpdater = _groupMemberUpdater;
    }
    async loadPage(opts, nextPageLink) {
        const { limit = 100 } = opts || { limit: 100 };
        let result;
        if (!nextPageLink) {
            result = await this._addressBookInterface.getMembersFirstPage(this._addressBookUrl, limit);
        }
        else {
            result = await this._addressBookInterface.getMembersNextPage(nextPageLink);
        }
        const session = this._groupMemberPool.createLoaderMutationSession();
        const items = this._groupMemberUpdater.updateRemoteItems(session, result._embedded.contacts);
        session.commit();
        const loadNextPage = result._links.next
            ? () => this.loadPage(undefined, result._links.next.href)
            : undefined;
        return {
            items,
            loadNextPage,
            total: result.total
        };
    }
}

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2024 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
class AddressBookInterface extends InterfaceBase {
    constructor(_core) { super(_core); }
    get endpoint() {
        return `https://${this._core._environment.endpoints.ABS_HOST}`;
    }
    async getAddressBookURL(addressBookUrn) {
        const result = await this._getResponse(`${this.endpoint}/api/urns/resolve/${addressBookUrn}`);
        return result.url;
    }
    async getMembersFirstPage(addressBookUrl, limit = 100) {
        return this._getResponse(`${addressBookUrl}/members/flat?limit=${limit}`);
    }
    async getMembersNextPage(nextPageLink) {
        return this._getResponse(nextPageLink);
    }
    async getAddressBooks(limit = 100) {
        return this._getResponse(`${this.endpoint}/api/address-books?limit=${limit}`);
    }
    async getContactInAddressBook(addressBookIdent, userId) {
        return this._getResponse(`${this.endpoint}/api/address-books/${addressBookIdent}/contacts?linkedIdentity=${userId}`);
    }
}

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2024 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
function extractAddressBookIdent(url) {
    return (new URL(url)).pathname.match(/^\/api\/address-books\/[^/]+/)[1];
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const CollaboratorRoles = ['owner', 'viewer', 'editor', 'none'];
const ContributorRoles = ['editor', 'owner'];
const CollaboratorTypes = [
    'imsUser',
    'addressBookGroup',
    'addressBookContact',
    'predefinedPrincipal',
    'imsGroup',
];
const InheritanceTypes = ['self', 'deep', 'deep_override'];
/**
 * A Collaborator represents the relationship between the user and the
 * asset. Users have other Profile information that is unique to the user.
 *
 * Eventually we will offer a Profile class with a Profile context that
 * offers information unrelated to an asset.
 */
class Collaborator extends ItemBase {
    constructor() {
        super(...arguments);
        this._role = 'viewer';
        this._type = 'imsUser';
        this._isDirect = false;
        this._assetID = '';
        this._canDiscover = false;
        this._canShare = false;
        this._commentPermissions = [];
    }
    get assetId() {
        return this._assetID;
    }
    /**
     * Returns false if the Behance/PPS service
     * was unable to return a profile for this collaborator.
     * @deprecated -- clients should just check that profile info is not undefined (SAM-3420). Will be removed on or
     *                after 2024-10-01
     */
    get hasProfile() {
        oneTimeWarning('Collaborator.hasProfile', 'Collaborator.hasProfile is deprecated and will be'
            + ' removed on or after 2024-10-01');
        // This used to return the private property _hasProfile, but since _hasProfile was never
        // set correctly, we're just returning undefined here to avoid confusion.
        // This getter will eventually be removed by SAM-3420.
        return undefined;
    }
    // `imsUser id` if invited via user email directly
    // `addressBookContact id` (i.e urn.ab:contact:...) if members are invited via shareSheet's recommend dropdown
    // `addressBookGroup id` (i.e urn:ab:group:...) if groups are invited via shareSheet's recommend dropdown
    get collaboratorID() {
        return this.id;
    }
    // Track the imsUser id
    // - Same as 'id' for direct invited collaborators
    // - Represents the collaborator actual ims id for addressBookContact, which is useful to check (compare ims id)
    // for thing like if the logged in user is in the collaborator list ,...
    // - undefined for 'addressBookGroup'
    get imsUserId() {
        var _a;
        const type = this._type;
        if (type === 'imsUser') {
            return this.id;
        }
        return (_a = this._additionalData) === null || _a === void 0 ? void 0 : _a.linkedIdentity;
    }
    get email() {
        var _a;
        return (_a = this._additionalData) === null || _a === void 0 ? void 0 : _a.email;
    }
    // Collaborator name for imsUser and addressBookContact
    // Group name for addressBookGroup
    get name() {
        var _a, _b;
        const additionalData = this._additionalData;
        return ((_b = (_a = additionalData === null || additionalData === void 0 ? void 0 : additionalData.displayName) !== null && _a !== void 0 ? _a : additionalData === null || additionalData === void 0 ? void 0 : additionalData.groupName) !== null && _b !== void 0 ? _b : additionalData === null || additionalData === void 0 ? void 0 : additionalData.organizationName);
    }
    get role() {
        return this._role;
    }
    get type() {
        return this._type;
    }
    get commentPermissions() {
        return this._commentPermissions;
    }
    get inheritances() {
        return this._inheritances;
    }
    get isDirect() {
        return this._isDirect;
    }
    get hasContributorRole() {
        return ContributorRoles.includes(this._role);
    }
    get hasName() {
        return !!this.name;
    }
    get invited() {
        var _a;
        return (_a = this._inheritances) === null || _a === void 0 ? void 0 : _a.includes('deep');
    }
    get isAdmin() {
        var _a;
        return (_a = this._inheritances) === null || _a === void 0 ? void 0 : _a.includes('deep_override');
    }
    get canDiscover() {
        return this._canDiscover;
    }
    get canShare() {
        return this._canShare;
    }
    get additionalData() {
        return this._additionalData;
    }
    /**
     * Checks if this collaborator is the user that is currently logged in.
     *
     * **NOTE**: It is not safe to assume that Collaborator.id === currentUserId
     *           will work. Always use Collaborator.isCurrentUser instead.
     */
    get isCurrentUser() {
        return this._core._environment.getValue('USER_ID') === this.imsUserId;
    }
    /**
     * Returns a standard size of 138x138
     */
    get avatarURL() {
        return this.getAvatarURL(AvatarSizes.Size138);
    }
    getAvatarURL(size) {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._additionalData) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b[size]) !== null && _c !== void 0 ? _c : '';
    }
    get addressBookGroupUrn() {
        var _a;
        return ((_a = this._additionalData) === null || _a === void 0 ? void 0 : _a.groupUrn) || '';
    }
    /**
     * Lists AddressBookContacts for an AddressBook Group.
     *
     * @experimental -- given the way this feature was rushed in, and some gaps in knowledge
     * about ABS and GenAI, this may not be the final API. Backward-compatibility will not
     * be guaranteed.
     *
     * @returns {Promise<GroupMemberSource>}
     */
    async getGroupMemberSource() {
        if (this.type !== 'addressBookGroup') {
            throw SAMError.create(SAMErrorCode$1.BAD_REQUEST, 'groupMemberSource only applies to addressBookGroup Collaborator');
        }
        if (!this.addressBookGroupUrn) {
            throw SAMError.create(SAMErrorCode$1.BAD_REQUEST, 'addressBookGroupUrn is required');
        }
        const abs = new AddressBookInterface(this._core);
        const url = await abs.getAddressBookURL(this.addressBookGroupUrn);
        const addressBookIdent = extractAddressBookIdent(url);
        const pool = this._core.collaborationContext._getAddressBookContactPool(addressBookIdent);
        const loader = new GroupMemberLoader(url, pool, abs, AddressBookContactUpdater);
        return new ItemSource(pool, [loader]);
    }
}
__decorate([
    observable$1(SharedCollaboratorChangedEvent)
    // Collaborator email
], Collaborator.prototype, "email", null);
__decorate([
    observable$1(SharedCollaboratorChangedEvent)
], Collaborator.prototype, "name", null);
__decorate([
    observable$1(SharedCollaboratorChangedEvent)
], Collaborator.prototype, "avatarURL", null);
__decorate([
    observable$1(SharedCollaboratorChangedEvent)
], Collaborator.prototype, "getAvatarURL", null);
__decorate([
    observable$1(SharedCollaboratorChangedEvent)
], Collaborator.prototype, "addressBookGroupUrn", null);
__decorate([
    memoize$1
], Collaborator.prototype, "getGroupMemberSource", null);
const CollaboratorUpdater = new ItemUpdater({
    localItemType: Collaborator,
    remoteIdProperty: 'id',
    changeEvent: SharedCollaboratorChangedEvent,
    propertyUpdater: new PropertyUpdater({
        '_type': { name: 'type', choices: CollaboratorTypes },
        '_role': { name: 'role', choices: CollaboratorRoles },
        '_inheritances': { name: 'inheritances', isArray: true, choices: InheritanceTypes },
        '_additionalData': { name: 'additionalData', format: 'object' },
        '_isDirect': { name: 'isDirect', format: 'boolean' },
        '_avatarURLs': { name: 'avatarURLs', format: 'object' },
        '_assetID': { name: 'assetID', format: 'string' },
        '_canDiscover': { name: 'canDiscover', format: 'boolean' },
        '_canShare': { name: 'canShare', format: 'boolean' },
        '_commentPermissions': { name: 'commentPermissions', isArray: true },
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$c = {
    created(a, b) {
        return compareValues(a.created, b.created);
    },
    name(a, b) {
        return compareValues(a.name, b.name);
    }
};
// This sort order will eventually be moved to a generic sort order for all GraphQL sort options.
/**
 * @experimental
 */
class FavoriteAdobeAssetOrder extends createItemOrderFactory(OrderFieldToComparator$c) {
}
FavoriteAdobeAssetOrder.default = new FavoriteAdobeAssetOrder('descending', 'created');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class MRUAdobeAssetOrder extends USSAdobeAssetOrder {
}
MRUAdobeAssetOrder.default = new MRUAdobeAssetOrder('descending', 'lastAccessed');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class PublishedAdobeAssetOrder extends USSAdobeAssetOrder {
}
PublishedAdobeAssetOrder.default = new PublishedAdobeAssetOrder('descending', 'modified');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToIProjectsOrderBy = {
    'name': 'repo:name',
    'created': 'repo:createDate',
    'lastAccessed': LastAccessedOrderField
};
const OrderFieldToComparator$b = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    },
    lastAccessed(a, b) {
        return compareValues(a.lastAccessed, b.lastAccessed);
    }
};
class ProjectOrder extends createItemOrderFactory(OrderFieldToComparator$b) {
}
ProjectOrder.default = new ProjectOrder('ascending', 'name');
ProjectOrder.createdDesc = new ProjectOrder('descending', 'created');
ProjectOrder.lastAccessed = new ProjectOrder('descending', 'lastAccessed');

var ProjectOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    OrderFieldToIProjectsOrderBy: OrderFieldToIProjectsOrderBy,
    'default': ProjectOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToCustomModelOrderBy = {
    'name': CustomModelOrderBy$1.NAME,
    'created': CustomModelOrderBy$1.CREATE_DATE,
    'modified': CustomModelOrderBy$1.MODIFY_DATE
};
const OrderFieldToComparator$a = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    },
    modified(a, b) {
        return compareValues(a.modified, b.modified);
    }
};
class CustomModelOrder extends createItemOrderFactory(OrderFieldToComparator$a) {
}
CustomModelOrder.default = new CustomModelOrder('descending', 'modified');
const customModelOrderToUSSOrder = (itemOrder) => {
    const orderMap = {
        'name': 'asset_name',
        'created': 'create_date',
        'modified': 'modify_date'
    };
    return {
        sort_order: itemOrder.direction === 'ascending' ? 'asc' : 'desc',
        sort_orderby: orderMap[itemOrder.field]
    };
};

var CustomModelOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    OrderFieldToCustomModelOrderBy: OrderFieldToCustomModelOrderBy,
    'default': CustomModelOrder,
    customModelOrderToUSSOrder: customModelOrderToUSSOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$9 = {
    created(a, b) {
        return compareValues(a.created, b.created);
    },
};
class GenerationHistoryAssetOrder extends createItemOrderFactory(OrderFieldToComparator$9) {
}
GenerationHistoryAssetOrder.default = new GenerationHistoryAssetOrder('descending', 'created');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const LegacyOrderFieldToCustomModelOrderBy = {
    'name': CustomModelOrderBy.NAME,
    'created': CustomModelOrderBy.CREATE_DATE,
    'modified': CustomModelOrderBy.MODIFY_DATE
};
const OrderFieldToComparator$8 = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    },
    modified(a, b) {
        return compareValues(a.modified, b.modified);
    }
};
class LegacyCustomModelOrder extends createItemOrderFactory(OrderFieldToComparator$8) {
}
LegacyCustomModelOrder.default = new LegacyCustomModelOrder('descending', 'modified');

var LegacyCustomModelOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    LegacyOrderFieldToCustomModelOrderBy: LegacyOrderFieldToCustomModelOrderBy,
    'default': LegacyCustomModelOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$7 = {
    id(a, b) {
        return compareStrings(a.id, b.id);
    }
};
class OrgRepositoryOrder extends createItemOrderFactory(OrderFieldToComparator$7) {
}
OrgRepositoryOrder.default = new OrgRepositoryOrder('ascending', 'id');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToIProjectsTeamsOrderBy = {
    'name': 'name',
    'created': 'createDate',
};
const OrderFieldToComparator$6 = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    }
};
class TeamOrder extends createItemOrderFactory(OrderFieldToComparator$6) {
}
TeamOrder.default = new TeamOrder('ascending', 'name');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToIProjectsSpaceOrderBy = {
    'name': 'name',
    'created': 'createdDate',
};
const OrderFieldToComparator$5 = {
    name(a, b) {
        return compareStrings(a.name, b.name);
    },
    created(a, b) {
        return compareValues(a.created, b.created);
    }
};
class SpaceOrder extends createItemOrderFactory(OrderFieldToComparator$5) {
}
SpaceOrder.default = new SpaceOrder('ascending', 'name');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$4 = {
    name(a, b) {
        var _a, _b;
        return compareStrings((_a = a.name) !== null && _a !== void 0 ? _a : a.id, (_b = b.name) !== null && _b !== void 0 ? _b : a.id);
    }
};
class CollaboratorOrder extends createItemOrderFactory(OrderFieldToComparator$4) {
}
CollaboratorOrder.default = new CollaboratorOrder('ascending', 'name');

var CollaboratorOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': CollaboratorOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$3 = {
    email(a, b) {
        var _a, _b;
        return compareStrings((_a = a.email) !== null && _a !== void 0 ? _a : a.id, (_b = b.email) !== null && _b !== void 0 ? _b : a.id);
    }
};
class InvitedCollaboratorOrder extends createItemOrderFactory(OrderFieldToComparator$3) {
}
InvitedCollaboratorOrder.default = new InvitedCollaboratorOrder('ascending', 'email');

var InvitedCollaboratorOrder$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': InvitedCollaboratorOrder
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const OrderFieldToComparator$2 = {
    // there is nothing in collaboratorListByUrn to order, this will keep order same
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    noop(a, b) {
        return 0;
    }
};
class CollaboratorsByAssetIDOrder extends createItemOrderFactory(OrderFieldToComparator$2) {
}
CollaboratorsByAssetIDOrder.default = new CollaboratorsByAssetIDOrder('ascending', 'noop');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const whitespaceFilter = (w) => /\S/.test(w);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var ProjectStringRelationResult;
(function (ProjectStringRelationResult) {
    ProjectStringRelationResult[ProjectStringRelationResult["DISJOINTED"] = 0] = "DISJOINTED";
    ProjectStringRelationResult[ProjectStringRelationResult["SUPERSET"] = 1] = "SUPERSET";
    ProjectStringRelationResult[ProjectStringRelationResult["SUBSET"] = 2] = "SUBSET";
    ProjectStringRelationResult[ProjectStringRelationResult["UNKNOWN"] = 3] = "UNKNOWN";
    ProjectStringRelationResult[ProjectStringRelationResult["IDENTICAL"] = 4] = "IDENTICAL";
})(ProjectStringRelationResult || (ProjectStringRelationResult = {}));
const DIRECT_COMPARE_VIEWS = [ProjectViews$1.Yours, ProjectViews$1.SWY];
class ProjectFilter {
    constructor(options = {
        view: ProjectViews$1.All
    }) {
        this._view = ProjectViews$1.All;
        this._directorySubtypes = [
            // Default to CC_PROJECTS because the service just defaults to
            // returning CC_PROJECTS if no directorySubtypes are provided.
            ProjectDirectorySubtype.CC_PROJECTS
        ];
        const { _isDiscarded, view, repositoryID, organizationID, nameContains, isDiscarded, directorySubtypes } = options;
        this._isDiscarded = !!(_isDiscarded || isDiscarded);
        if (view !== undefined) {
            this._view = view;
        }
        this._repositoryID = repositoryID;
        this._organizationID = organizationID;
        // @TODO Eventually just store the sorted name with no whitespace in the array
        // so we don't have to do it in multiple places.
        this._nameContains = nameContains;
        this._directorySubtypes = directorySubtypes !== null && directorySubtypes !== void 0 ? directorySubtypes : this._directorySubtypes;
    }
    get hash() {
        var _a;
        return `discarded=${this._isDiscarded}view=${this._view}repositoryId=${this._repositoryID}`
            + `orgID=${this._organizationID || ''}nameContains=${this._nameContains}directorySubtype=${(_a = this._directorySubtypes) === null || _a === void 0 ? void 0 : _a.sort().join('')}`;
    }
    get view() {
        return this._view;
    }
    /**
     * @TODO_Deprecation will be marked as deprecated on or after 2025-01-01 and removed on or after 2025-03-01
     *    Use ownerIDs instead.
     */
    get repositoryID() {
        return this._repositoryID;
    }
    get nameContains() {
        return this._nameContains;
    }
    get isDiscarded() {
        return this._isDiscarded;
    }
    /**
     *
     * @NOTE this code is to be analyzed at a future date, we may want to remove this logic
     * or improve it so it can become a fast client side optimization for
     * all USS based lists. Will likely require some syncing with what the services provide.
     * @TODO https://jira.corp.adobe.com/browse/SHARED-3489
     *
     */
    _getRelationToNameContains(name = '', otherName = '') {
        if (name === otherName) {
            return ProjectStringRelationResult.IDENTICAL;
        }
        if (!name && otherName) {
            // `otherName` matches some names, while `name` matches all
            return ProjectStringRelationResult.UNKNOWN;
        }
        const nameTerms = name.toLowerCase()
            .split(' ').filter(whitespaceFilter).sort();
        const otherNameTerms = otherName.toLowerCase()
            .split(' ').filter(whitespaceFilter).sort();
        if (nameTerms.length === 0 && otherNameTerms.length === 0) {
            return ProjectStringRelationResult.IDENTICAL;
        }
        if (nameTerms.length === otherNameTerms.length
            && nameTerms.every((n, i) => n === otherNameTerms[i])) {
            return ProjectStringRelationResult.IDENTICAL;
        }
        let subsetMatches = 0;
        let supersetMatches = 0;
        nameTerms.forEach((nameTerm) => {
            const findMatch = otherNameTerms.find((otherTerm) => {
                const superSet = otherTerm.startsWith(nameTerm);
                const subSet = nameTerm.startsWith(otherTerm);
                return superSet || subSet;
            });
            if (findMatch) {
                if (nameTerm.length <= findMatch.length) {
                    supersetMatches++;
                }
                if (nameTerm.length > findMatch.length) {
                    subsetMatches++;
                }
            }
        });
        if (nameTerms.length === subsetMatches) {
            return ProjectStringRelationResult.SUBSET;
        }
        if (nameTerms.length === supersetMatches) {
            return ProjectStringRelationResult.SUPERSET;
        }
        if (subsetMatches === 0 && supersetMatches === 0) {
            return ProjectStringRelationResult.DISJOINTED;
        }
        return ProjectStringRelationResult.UNKNOWN;
    }
    /**
     *
     * @TODO https://jira.corp.adobe.com/browse/SHARED-3489
     */
    _searchTarget(searchString, targetString) {
        const searchTerms = searchString.toLowerCase().split(/\s+/);
        const targetTerms = targetString.toLowerCase().split(/\s+/);
        // Empty word or search term
        if (searchTerms.length === 0 || targetTerms.length === 0) {
            return false;
        }
        return searchTerms.every((searchTerm) => {
            return targetTerms.find((targetTerm) => {
                return targetTerm.startsWith(searchTerm);
            });
        });
    }
    get organizationID() {
        return this._organizationID;
    }
    get directorySubtypes() {
        return this._directorySubtypes;
    }
    matches(item) {
        // Note: ImplicitProjectFilter requires Project to be either _isRecent or _allowInLists
        var _a;
        // We don't want to allow any matching for the Recent project listing
        // TODO: once we have support for lastAccessDate from projects service, we should use that instead.
        if (this._view === ProjectViews$1.Recent && !item._isRecent) {
            return false;
        }
        // For views other than Recent, only allow _isRecent Project if it was also seen in some other listing from the
        // service (All, Yours, etc)
        if (this.view !== ProjectViews$1.Recent && item._isRecent && !item._allowInLists) {
            return false;
        }
        if (!item.isProject) {
            return false;
        }
        if (item.isDiscarded !== this._isDiscarded) {
            return false;
        }
        // For Admin view: If specified, match on repositoryID
        if (this._repositoryID && this._repositoryID !== item.repositoryID) {
            return false;
        }
        // For view = Organization or Admin, filter by organizationID
        if (this._organizationID && this._organizationID !== item.repositoryOwner.id) {
            return false;
        }
        if (!((_a = this._directorySubtypes) === null || _a === void 0 ? void 0 : _a.find((subType) => {
            return item.directorySubtype === subType;
        }))) {
            return false;
        }
        const nameContains = this._nameContains;
        if (nameContains
            && !this._searchTarget(nameContains, item.name)) {
            return false;
        }
        // Project.view computes Yours and SWY
        if (DIRECT_COMPARE_VIEWS.includes(this._view) && this._view !== item.view) {
            return false;
        }
        // this.view is undefined, All, or Admin
        return true;
    }
    /**
     * This method determines the commonality between the already present filter (other)
     * and the new filter to be applied (this). The point of this is to
     * see if the new filter (this) can build some, all, or none of it's items
     * from (other) filter.
     *
     * Subset: Means that ALL items for this filter can be built from other
     * Disjoint: No items for this filter can be built from other.
     * Unknown: Some items for this filter can be built from other.
     *
     * @note we should always determine disjoint cases first before other cases.
     * @note this = NEW FILTER, other = EXISTING FILTER
     *
     * @param other The existing filter that we are getting the relation to.
     * @returns { ItemFilterRelation }
     */
    getRelationToFilter(other) {
        if (this._repositoryID && other.repositoryID && this._repositoryID !== other.repositoryID) {
            return 'disjoint';
        }
        if (this._isDiscarded !== other._isDiscarded) {
            return 'disjoint';
        }
        // SWY and Yours are disjoint to each other.
        if (this._view !== other.view
            && DIRECT_COMPARE_VIEWS.includes(this._view)
            && DIRECT_COMPARE_VIEWS.includes(other.view)) {
            return 'disjoint';
        }
        let searchMatch;
        if (this.nameContains || other.nameContains) {
            searchMatch = this._getRelationToNameContains(this.nameContains, other.nameContains);
            if (searchMatch === ProjectStringRelationResult.DISJOINTED) {
                return 'disjoint';
            }
        }
        if (this._organizationID && other.organizationID && this._organizationID !== other.organizationID) {
            return 'disjoint';
        }
        const subTypeArrayComparison = compareFilterArrayValues(this._directorySubtypes, other._directorySubtypes);
        if (subTypeArrayComparison === 'none') {
            return 'disjoint';
        }
        // ------ All disjoint cases should be handled above this line ------
        if (searchMatch && searchMatch === ProjectStringRelationResult.SUPERSET
            || searchMatch === ProjectStringRelationResult.UNKNOWN) {
            return 'unknown';
        }
        // Other view contains one organization, but there could be more
        if (!this._organizationID && other.organizationID) {
            return 'unknown';
        }
        if ([ProjectViews$1.All, ProjectViews$1.Admin, undefined].includes(this._view)
            && DIRECT_COMPARE_VIEWS.includes(other.view)) {
            return 'unknown';
        }
        // Admin can contain projects that are excluded from All
        if (this.view === ProjectViews$1.Admin && other.view === ProjectViews$1.All) {
            return 'unknown';
        }
        if (this._view === ProjectViews$1.Recent) {
            switch (other.view) {
                // Recent view is a subset of All and Admin. For now we are setting the relation to be unknown.
                // TODO: once we have support for lastAccessDate from projects service, we can set the relation to be subset.
                case ProjectViews$1.Recent:
                case ProjectViews$1.All:
                case ProjectViews$1.Admin:
                    return 'unknown';
                // Recent view has an unknown relation with Yours, SWY, and Organization
                case ProjectViews$1.Yours:
                case ProjectViews$1.SWY:
                case ProjectViews$1.Organization:
                default:
                    return 'unknown';
            }
        }
        // If the other view is Recent, then this view has an unknown relation to it apart from Recent itself
        // which is handled above.
        if (other.view === ProjectViews$1.Recent) {
            return 'unknown';
        }
        if (subTypeArrayComparison === 'some') {
            return 'unknown';
        }
        // ------ All unknown cases should be handled above this line ------
        // If not disjoint or unknown, then it's a subset.
        return 'subset';
    }
}
ProjectFilter.YourProjects = new ProjectFilter({
    view: ProjectViews$1.Yours
});
ProjectFilter.AllProjects = new ProjectFilter({
    view: ProjectViews$1.All
});
ProjectFilter.SWYProjects = new ProjectFilter({
    view: ProjectViews$1.SWY
});
ProjectFilter.AdminProjects = new ProjectFilter({
    view: ProjectViews$1.Admin
});

var ProjectFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': ProjectFilter
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CustomModelFilter$1 {
    constructor(listingOptions) {
        this._listingOptions = {};
        if (listingOptions) {
            this._listingOptions = listingOptions;
        }
    }
    get listingOptions() {
        return this._listingOptions;
    }
    get hash() {
        return [
            this._listingOptions.publishedState ? `publishedState:${this._listingOptions.publishedState}` : undefined,
            this._listingOptions.createDateMin ? `createDateMin:${this._listingOptions.createDateMin.getTime()}` : undefined,
            this._listingOptions.createDateMax ? `createDateMax:${this._listingOptions.createDateMax.getTime()}` : undefined,
            this._listingOptions.modifyDateMin ? `modifyDateMin:${this._listingOptions.modifyDateMin.getTime()}` : undefined,
            this._listingOptions.modifyDateMax ? `modifyDateMax:${this._listingOptions.modifyDateMax.getTime()}` : undefined,
            this._listingOptions.createdBy ? `createdBy:${this._listingOptions.createdBy}` : undefined,
        ].filter(x => x).join(':');
    }
    matches(item) {
        if (this._listingOptions.publishedState
            && (item.publishedState !== this._listingOptions.publishedState)) {
            return false;
        }
        if (this._listingOptions.createdBy && (item.createdBy !== this._listingOptions.createdBy)) {
            return false;
        }
        if (this._listingOptions.createDateMin && (item.created < this._listingOptions.createDateMin)) {
            return false;
        }
        if (this._listingOptions.createDateMax && (item.created > this._listingOptions.createDateMax)) {
            return false;
        }
        if (this._listingOptions.modifyDateMin && (item.modified < this._listingOptions.modifyDateMin)) {
            return false;
        }
        if (this._listingOptions.modifyDateMax && (item.modified > this._listingOptions.modifyDateMax)) {
            return false;
        }
        return true;
    }
    /**
     * This method determines the commonality between the already present filter (other)
     * and the new filter to be applied (this). The point of this is to
     * see if the new filter (this) can build some, all, or none of it's items
     * from (other) filter.
     *
     * Subset: Means that ALL items for this filter can be built from other
     * Disjoint: No items for this filter can be built from other.
     * Unknown: Some items for this filter can be built from other.
     *
     * @note we should always determine disjoint cases first before other cases.
     * @note this = NEW FILTER, other = EXISTING FILTER
     *
     * @param other The existing filter that we are getting the relation to.
     * @returns { ItemFilterRelation }
     */
    getRelationToFilter(other) {
        const relationWrtPublishedState = this.getRelationPublishedState(other);
        const relationWrtCreatedBy = this.getRelationCreatedBy(other);
        const relationWrtCreatedAt = getDateRangeRelation(this._listingOptions.createDateMin, this._listingOptions.createDateMax, other._listingOptions.createDateMin, other._listingOptions.createDateMax);
        const relationWrtModifiedAt = getDateRangeRelation(this._listingOptions.modifyDateMin, this._listingOptions.modifyDateMax, other._listingOptions.modifyDateMin, other._listingOptions.modifyDateMax);
        //Check for any disjoint cases first
        if ([relationWrtPublishedState, relationWrtCreatedBy, relationWrtCreatedAt, relationWrtModifiedAt].some(x => x === 'disjoint')) {
            return 'disjoint';
        }
        //Then check for any unknown cases
        if ([relationWrtPublishedState, relationWrtCreatedBy, relationWrtCreatedAt, relationWrtModifiedAt].some(x => x === 'unknown')) {
            return 'unknown';
        }
        //All cases are subset
        return 'subset';
    }
    getRelationPublishedState(other) {
        if (!this._listingOptions.publishedState && other._listingOptions.publishedState) {
            return 'unknown';
        }
        if ((this._listingOptions.publishedState === other._listingOptions.publishedState) || !other._listingOptions.publishedState) {
            return 'subset';
        }
        return 'disjoint';
    }
    getRelationCreatedBy(other) {
        if (this._listingOptions.createdBy === other._listingOptions.createdBy) {
            return 'subset';
        }
        if (!other._listingOptions.createdBy) {
            return 'subset';
        }
        if (!this._listingOptions.createdBy) {
            return 'unknown';
        }
        return 'disjoint';
    }
}

var CustomModelFilter$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': CustomModelFilter$1
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class GenerationHistoryAssetFilter {
    constructor(listingOptions) {
        this._generationGroupId = listingOptions === null || listingOptions === void 0 ? void 0 : listingOptions.generationGroupId;
        this._historyAssetType = listingOptions === null || listingOptions === void 0 ? void 0 : listingOptions.historyAssetType;
    }
    get generationGroupId() {
        return this._generationGroupId;
    }
    get historyAssetType() {
        return this._historyAssetType;
    }
    get hash() {
        return [
            this._generationGroupId ? `generationGroupId:${this._generationGroupId}` : undefined,
            this._historyAssetType ? `historyAssetType:${this._historyAssetType}` : undefined,
        ].filter(x => x).join(':');
    }
    matches(item) {
        if (this._generationGroupId) {
            return getGenerationGroupId(item) === this._generationGroupId;
        }
        if (this._historyAssetType) {
            if (this._historyAssetType === GenerationHistoryAssetType.IMAGE) {
                return item.mediaType === GENERATION_HISTORY_IMAGE_MEDIA_TYPE;
            }
            if (this._historyAssetType === GenerationHistoryAssetType.VIDEO) {
                return item.mediaType === GENERATION_HISTORY_VIDEO_MEDIA_TYPE;
            }
        }
        return true;
    }
    /**
     * This method determines the commonality between the already present filter (previous)
     * and the new filter to be applied (this). The point of this is to
     * see if the new filter (this) can build some, all, or none of it's items
     * from (previous) filter.
     *
     * Subset: Means that ALL items for this filter can be built from previous
     * Disjoint: No items for this filter can be built from previous.
     * Unknown: Some items for this filter can be built from previous.
     *
     * @note we should always determine disjoint cases first before other cases.
     * @note this = NEW FILTER, previous = EXISTING FILTER
     *
     * @param previousFilter The existing filter that we are getting the relation to.
     * @returns { ItemFilterRelation }
     */
    getRelationToFilter(previousFilter) {
        const { _generationGroupId: previousGenerationGroupId, _historyAssetType: previousHistoryAssetType } = previousFilter;
        const { _generationGroupId, _historyAssetType } = this;
        if (previousGenerationGroupId && _generationGroupId && previousGenerationGroupId !== _generationGroupId) {
            return 'disjoint';
        }
        if (previousHistoryAssetType && _historyAssetType && previousHistoryAssetType !== _historyAssetType) {
            return 'disjoint';
        }
        if (!_generationGroupId && previousGenerationGroupId) {
            return 'unknown';
        }
        if (!_historyAssetType && previousHistoryAssetType) {
            return 'unknown';
        }
        return 'subset';
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CustomModelFilter {
    constructor(listingOptions) {
        this._listingOptions = {};
        if (listingOptions) {
            this._listingOptions = listingOptions;
        }
    }
    get listingOptions() {
        return this._listingOptions;
    }
    get hash() {
        return [
            this._listingOptions.publishedState ? `publishedState:${this._listingOptions.publishedState}` : undefined,
            this._listingOptions.createDateMin ? `createDateMin:${this._listingOptions.createDateMin.getTime()}` : undefined,
            this._listingOptions.createDateMax ? `createDateMax:${this._listingOptions.createDateMax.getTime()}` : undefined,
            this._listingOptions.modifyDateMin ? `modifyDateMin:${this._listingOptions.modifyDateMin.getTime()}` : undefined,
            this._listingOptions.modifyDateMax ? `modifyDateMax:${this._listingOptions.modifyDateMax.getTime()}` : undefined,
            this._listingOptions.createdBy ? `createdBy:${this._listingOptions.createdBy}` : undefined,
        ].filter(x => x).join(':');
    }
    matches(item) {
        if (this._listingOptions.publishedState
            && (item.publishedState !== this._listingOptions.publishedState)
            && this._listingOptions.publishedState !== CustomModelPublishedState.ALL) {
            return false;
        }
        if (this._listingOptions.createdBy && (item.createdBy !== this._listingOptions.createdBy)) {
            return false;
        }
        if (this._listingOptions.createDateMin && (item.created < this._listingOptions.createDateMin)) {
            return false;
        }
        if (this._listingOptions.createDateMax && (item.created > this._listingOptions.createDateMax)) {
            return false;
        }
        if (this._listingOptions.modifyDateMin && (item.modified < this._listingOptions.modifyDateMin)) {
            return false;
        }
        if (this._listingOptions.modifyDateMax && (item.modified > this._listingOptions.modifyDateMax)) {
            return false;
        }
        return true;
    }
    /**
     * This method determines the commonality between the already present filter (other)
     * and the new filter to be applied (this). The point of this is to
     * see if the new filter (this) can build some, all, or none of it's items
     * from (other) filter.
     *
     * Subset: Means that ALL items for this filter can be built from other
     * Disjoint: No items for this filter can be built from other.
     * Unknown: Some items for this filter can be built from other.
     *
     * @note we should always determine disjoint cases first before other cases.
     * @note this = NEW FILTER, other = EXISTING FILTER
     *
     * @param other The existing filter that we are getting the relation to.
     * @returns { ItemFilterRelation }
     */
    getRelationToFilter(other) {
        const relationWrtPublishedState = this.getRelationPublishedState(other);
        const relationWrtCreatedBy = this.getRelationCreatedBy(other);
        const relationWrtCreatedAt = getDateRangeRelation(this._listingOptions.createDateMin, this._listingOptions.createDateMax, other._listingOptions.createDateMin, other._listingOptions.createDateMax);
        const relationWrtModifiedAt = getDateRangeRelation(this._listingOptions.modifyDateMin, this._listingOptions.modifyDateMax, other._listingOptions.modifyDateMin, other._listingOptions.modifyDateMax);
        //Check for any disjoint cases first
        if ([relationWrtPublishedState, relationWrtCreatedBy, relationWrtCreatedAt, relationWrtModifiedAt].some(x => x === 'disjoint')) {
            return 'disjoint';
        }
        //Then check for any unknown cases
        if ([relationWrtPublishedState, relationWrtCreatedBy, relationWrtCreatedAt, relationWrtModifiedAt].some(x => x === 'unknown')) {
            return 'unknown';
        }
        //All cases are subset
        return 'subset';
    }
    getRelationPublishedState(other) {
        if (this._listingOptions.publishedState === other._listingOptions.publishedState) {
            return 'subset';
        }
        if (other._listingOptions.publishedState === CustomModelPublishedState.ALL || other._listingOptions.publishedState === undefined) {
            return 'subset';
        }
        if (this._listingOptions.publishedState === CustomModelPublishedState.ALL || this._listingOptions.publishedState === undefined) {
            return 'unknown';
        }
        return 'disjoint';
    }
    getRelationCreatedBy(other) {
        if (this._listingOptions.createdBy === other._listingOptions.createdBy) {
            return 'subset';
        }
        if (!other._listingOptions.createdBy) {
            return 'subset';
        }
        if (!this._listingOptions.createdBy) {
            return 'unknown';
        }
        return 'disjoint';
    }
}

var LegacyCustomModelFilter = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': CustomModelFilter
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * A Filter that extends AdobeAssetFilter and provides some USS Specific
 * filter options that don't apply to RAPI directory listings.
 */
class USSAdobeAssetFilter extends AdobeAssetFilter {
    constructor(options) {
        super(options);
        this._excludeInheritanceTypes = undefined;
        const { uploadedFrom, userId, excludeInheritanceTypes } = options !== null && options !== void 0 ? options : {};
        if (uploadedFrom !== undefined) {
            if (!uploadedFrom.length) {
                throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'Empty uploadedFrom array is not currently supported.');
            }
            this._uploadedFrom = uploadedFrom;
        }
        if (userId) {
            this._userId = userId;
        }
        if (excludeInheritanceTypes) {
            this._excludeInheritanceTypes = new Set(excludeInheritanceTypes);
        }
    }
    get name() {
        return USSAssetFilterName;
    }
    get hash() {
        var _a;
        let hash = `${super.hash}:${this._uploadedFrom}:${this._userId}`;
        hash += ':excludeinheritancetypes=' + (((_a = this._excludeInheritanceTypes) === null || _a === void 0 ? void 0 : _a.size) ? `${[...this._excludeInheritanceTypes].sort().join(',')}` : 'none');
        return hash;
    }
    get uploadedFrom() {
        return this._uploadedFrom;
    }
    /**
     * Matches the provided userId to the value of storage:assignee.id in the service.
     *
     * @TODO_Deprecation [SAM-3813] will be removed in future releases in favor of using AdobeAsset.searchChildren searching
     * for items in users /cloud-content.
     *
     * {@link AdobeAsset.searchChildren()}
     */
    get userId() {
        return this._userId;
    }
    /**
     * Excludes assets that are inherited or are inheritable of the types included. For example including
     * "am.cc:inherited.cc:studentAssignment.repo:assetId" would exclude all assets that are within student
     * assignment directories. Including "am.cc:inheritable.cc:studentAssignment.repo:assetId" would exclude
     * all assets that ARE student assignment directories.
     */
    get excludeInheritanceTypes() {
        return this._excludeInheritanceTypes;
    }
    matches(item) {
        var _a, _b;
        if (this._userId && this._userId !== item.storageAssignee.id) {
            return false;
        }
        /** Filter       Item         createdFromUpload    Return value
         * -----------------------------------------------------------
         * undefined    *            *                    super.matches()
         * 'ALL'        'xyz'        true                 super.matches()
         * ['xyz']      'xyz'        true                 super.matches()
         * 'ALL'        *            false                false
         * ['xyz']      undefined    *                    false
         * ['xyz']      'pdq'        *                    false
         * ['xyz']      *            false                false
         *
         * */
        if (Array.isArray(this._uploadedFrom)
            && item.createdFromUpload
            && !this._uploadedFrom.includes((_a = item.createdByClientId) !== null && _a !== void 0 ? _a : '')) {
            return false;
        }
        if ((this._uploadedFrom === 'ALL'
            || Array.isArray(this._uploadedFrom))
            && !item.createdFromUpload) {
            return false;
        }
        if (((_b = this._excludeInheritanceTypes) === null || _b === void 0 ? void 0 : _b.has(FetchFields.StudentAssignmentAssetId)) && item.isChildOfStudentAssignment) {
            return false;
        }
        return super.matches(item);
    }
    getRelationToFilter(existingFilter) {
        if (existingFilter.name !== USSAssetFilterName) {
            // Currently we don't support switching between the AdobeAssetFilter and the
            // USSAssetFilter.
            oneTimeWarning('USSAdobeAssetFilter', 'Cannot switch between an AdobeAssetFilter and a USSAdobeAssetFilter');
            return 'disjoint';
        }
        // If they both have ID's and they both are not equal we can assume
        // they are disjointed.
        if (this._userId && existingFilter.userId && this._userId !== existingFilter.userId) {
            return 'disjoint';
        }
        if (this._excludeInheritanceTypes && existingFilter._excludeInheritanceTypes) {
            // Convert to a format that can be easily compared
            const thisFilterExcludeInheritanceTypes = [...this._excludeInheritanceTypes].sort();
            const existingFilterExcludeInheritanceTypes = [...existingFilter._excludeInheritanceTypes].sort();
            if (thisFilterExcludeInheritanceTypes !== existingFilterExcludeInheritanceTypes) {
                return 'disjoint';
            }
        }
        if ((this.excludeInheritanceTypes && !existingFilter.excludeInheritanceTypes) || (!this.excludeInheritanceTypes && existingFilter.excludeInheritanceTypes)) {
            return 'unknown';
        }
        const isFiltersArray = Array.isArray(this.uploadedFrom)
            && Array.isArray(existingFilter.uploadedFrom);
        // If both the new filter and the existing filter are arrays
        // meaning they are requesting a specific applications client id
        // and they are both different, this means the list is disjoint because
        // if let's say the existing filter is app 'xyz' and the new one is 'zzz'
        // they cannot share any items.
        if (isFiltersArray) {
            const arrayRelationship = compareFilterArrayValues(this.uploadedFrom, existingFilter.uploadedFrom);
            if (arrayRelationship === 'none') {
                return 'disjoint';
            }
            // If there are some items that match between the two array values
            // and the new filter has more filer values that means there are
            // some items that could be borrowed from the existing list.
            if (arrayRelationship === 'some'
                && this.uploadedFrom.length >= existingFilter.uploadedFrom.length) {
                return 'unknown';
            }
        }
        /**
         * If the new filter has uploadedFrom undefined and the existing filter
         * is defined that means we could possibly borrow some items from the new list.
         */
        if (!this.uploadedFrom && existingFilter.uploadedFrom) {
            return 'unknown';
        }
        if (this.uploadedFrom === 'ALL' && Array.isArray(existingFilter.uploadedFrom)) {
            return 'unknown';
        }
        if (!this.userId && existingFilter.userId) {
            return 'unknown';
        }
        // Call into super to handle all implicit filter cases.
        return super.getRelationToFilter(existingFilter);
    }
}

var USSAdobeAssetFilter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': USSAdobeAssetFilter
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class SpaceFilter {
    constructor(options) {
        this._bookmarked = false;
        this._bookmarked = Boolean(options === null || options === void 0 ? void 0 : options.bookmarked);
        this._teamID = options === null || options === void 0 ? void 0 : options.teamID;
        this._teamRole = options === null || options === void 0 ? void 0 : options.teamRole;
        this._state = options === null || options === void 0 ? void 0 : options.state;
        this._teamRole = options === null || options === void 0 ? void 0 : options.teamRole;
    }
    static ActiveSpacesFromTeam(teamID) {
        return new SpaceFilter({
            state: 'active',
            teamID
        });
    }
    get bookmarked() {
        return this._bookmarked;
    }
    get teamID() {
        return this._teamID;
    }
    get teamRole() {
        return this._teamRole;
    }
    get state() {
        return this._state;
    }
    get hash() {
        var _a, _b;
        return String(this.bookmarked) + ':'
            + (this.teamID || 'all-teams') + ':'
            + ((_a = this._teamRole) !== null && _a !== void 0 ? _a : 'all-roles') + ':'
            + ((_b = this._state) !== null && _b !== void 0 ? _b : 'any-state');
    }
    matches(item) {
        if (this._bookmarked && !item.isBookmarked) {
            return false;
        }
        const teamID = this._teamID;
        if (teamID && item.teamID !== teamID) {
            return false;
        }
        const teamRole = this._teamRole;
        if (teamRole && item.teamRole !== teamRole) {
            return false;
        }
        const state = this._state;
        if (state && state !== item.state) {
            return false;
        }
        return true;
    }
    getRelationToFilter(other) {
        const otherSpaceFilter = other;
        if (this._teamRole !== otherSpaceFilter._teamRole) {
            if (this._teamRole && otherSpaceFilter._teamRole) {
                // If both filters specify a completely different teamRole then the
                // lists are entirely disjoint.
                return 'disjoint';
            }
            // If only one filter specifically looks for the team role, then the other might be
            // able to borrow some items from it.
            return 'unknown';
        }
        if (this.teamID && otherSpaceFilter.teamID && this.teamID !== otherSpaceFilter.teamID) {
            // Teams are entirely different, no shared elements are expected.
            return 'disjoint';
        }
        if (!this.teamID && otherSpaceFilter.teamID) {
            // If the other list has a teamID and this filter doesn't then
            // this is list is going to have an unknown final state.
            return 'unknown';
        }
        // If the other list filtered for only bookmarked items and this doesn't,
        // then this is list is going to have an unknown final state.
        if (!this.bookmarked && other.bookmarked) {
            return 'unknown';
        }
        if (this._state !== other._state) {
            // If both filters expect a state and the states do not match, then
            // the lists are not going to have any items in common.
            if (this._state && other._state) {
                return 'disjoint';
            }
            // If only one list expects a specific state and the other can take any state,
            // then we could possible share some items.
            return 'unknown';
        }
        return 'subset';
    }
}
SpaceFilter.ActiveSpaces = new SpaceFilter({
    state: 'active'
});
SpaceFilter.ArchivedSpaces = new SpaceFilter({
    state: 'archived'
});
SpaceFilter.ActiveBookmarkedSpaces = new SpaceFilter({
    state: 'active',
    bookmarked: true
});
SpaceFilter.ActiveSpacesFromOtherTeams = new SpaceFilter({
    state: 'active',
    teamRole: 'NONE'
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var StringRelationResult;
(function (StringRelationResult) {
    StringRelationResult[StringRelationResult["DISJOINTED"] = 0] = "DISJOINTED";
    StringRelationResult[StringRelationResult["SUPERSET"] = 1] = "SUPERSET";
    StringRelationResult[StringRelationResult["SUBSET"] = 2] = "SUBSET";
    StringRelationResult[StringRelationResult["UNKNOWN"] = 3] = "UNKNOWN";
    StringRelationResult[StringRelationResult["IDENTICAL"] = 4] = "IDENTICAL";
})(StringRelationResult || (StringRelationResult = {}));
/**
 * Available when M2 is released, M1 currently
 * does not support this filter.
 * @experimental
 */
class TeamFilter {
    constructor(options) {
        this._nameContains = options === null || options === void 0 ? void 0 : options.nameContains;
        this._state = options === null || options === void 0 ? void 0 : options.state;
    }
    static TeamsContainingName(name) {
        return new TeamFilter({
            nameContains: name
        });
    }
    get nameContains() {
        return this._nameContains;
    }
    get state() {
        return this._state;
    }
    get hash() {
        var _a, _b;
        return ((_a = this._nameContains) !== null && _a !== void 0 ? _a : 'any-name') + ':'
            + ((_b = this._state) !== null && _b !== void 0 ? _b : 'any-state');
    }
    _getRelationToNameContains(name, otherName) {
        if (name === otherName) {
            return StringRelationResult.IDENTICAL;
        }
        const nameTerms = name.toLowerCase()
            .split(' ').filter(whitespaceFilter).sort();
        const otherNameTerms = otherName.toLowerCase()
            .split(' ').filter(whitespaceFilter).sort();
        if (nameTerms.length === 0 && otherNameTerms.length === 0) {
            return StringRelationResult.IDENTICAL;
        }
        if (nameTerms.length === 0 || otherNameTerms.length === 0) {
            return StringRelationResult.DISJOINTED;
        }
        if (nameTerms.length === otherNameTerms.length
            && nameTerms.every((n, i) => n === otherNameTerms[i])) {
            return StringRelationResult.IDENTICAL;
        }
        let subsetMatches = 0;
        let supersetMatches = 0;
        nameTerms.forEach((nameTerm) => {
            const findMatch = otherNameTerms.find((otherTerm) => {
                const superSet = otherTerm.startsWith(nameTerm);
                const subSet = nameTerm.startsWith(otherTerm);
                return superSet || subSet;
            });
            if (findMatch) {
                if (nameTerm.length <= findMatch.length) {
                    supersetMatches++;
                }
                if (nameTerm.length > findMatch.length) {
                    subsetMatches++;
                }
            }
        });
        if (nameTerms.length === subsetMatches) {
            return StringRelationResult.SUBSET;
        }
        if (nameTerms.length === supersetMatches) {
            return StringRelationResult.SUPERSET;
        }
        if (subsetMatches === 0 && supersetMatches === 0) {
            return StringRelationResult.DISJOINTED;
        }
        return StringRelationResult.UNKNOWN;
    }
    _searchTarget(searchString, targetString) {
        const searchTerms = searchString.toLowerCase()
            .split(' ').filter(whitespaceFilter);
        const targetTerms = targetString.toLowerCase()
            .split(' ').filter(whitespaceFilter);
        // Empty word or search term
        if (searchTerms.length === 0 || targetTerms.length === 0) {
            return false;
        }
        return searchTerms.every((searchTerm) => {
            return targetTerms.find((targetTerm) => {
                return targetTerm.startsWith(searchTerm);
            });
        });
    }
    matches(item) {
        const state = this._state;
        if (state && state !== item.state) {
            return false;
        }
        const nameContains = this._nameContains;
        if (nameContains
            && !this._searchTarget(nameContains, item.name)) {
            return false;
        }
        return true;
    }
    getRelationToFilter(other) {
        let searchMatch;
        if (this.nameContains && other.nameContains) {
            searchMatch = this._getRelationToNameContains(this.nameContains, other.nameContains);
            if (searchMatch === StringRelationResult.DISJOINTED) {
                return 'disjoint';
            }
        }
        if (this.state && other.state && this.state !== other.state) {
            return 'disjoint';
        }
        if (!this.state && other.state) {
            return 'unknown';
        }
        if (!this.nameContains && other.nameContains) {
            return 'unknown';
        }
        if (searchMatch && searchMatch === StringRelationResult.SUPERSET
            || searchMatch === StringRelationResult.UNKNOWN) {
            return 'unknown';
        }
        //------ All 'unknown' cases must be handled above this line
        return 'subset';
    }
}
TeamFilter.ActiveTeams = new TeamFilter({
    state: 'active'
});
TeamFilter.DiscardedTeams = new TeamFilter({
    state: 'discarded'
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const RepositoryOwnerTypes = ['org', 'user'];
const TeamStates = ['active', 'discarded'];
/**
 * Represents the notion of a "team" of Adobe account
 * holders that collaborate on projects.
 *
 * @example
 * // Instatiate list and load contents
 * const teamsList = core.spaceContext.getTeams().getList(...options);
 * await waitForListLoad(teamsList);
 *
 * // Get the first team in the list as an example.
 * const team = teamsList.items[0];
 *
 * // Perform some actions on a team.
 * await team.rename('newName');
 * await team.archive();
 * await team.restore();
 *
 * // log the teamID
 * console.log(team.teamID)
 *
 */
class Team$1 extends ShareableItem {
    constructor() {
        super(...arguments);
        this._created = new Date();
        this._createdBy = '';
        this._name = '';
        this._repositoryID = '';
        this._repositoryName = '';
        this._state = 'active';
        this._role = 'none';
    }
    /**
     * The unique id that represents the team.
     */
    get teamID() {
        return this.id;
    }
    get created() {
        return this._created;
    }
    get createdBy() {
        return this._createdBy;
    }
    /**
     * The user-visible name assigned to the team
     */
    get name() {
        return this._name;
    }
    /**
     * The description property of this team.
     *
     * @note Only available after a call to ensureDescription()
     */
    get description() {
        return this._description;
    }
    /**
     * The unique id of the repository that owns this team
     */
    get repositoryID() {
        return this._repositoryID;
    }
    /**
     * The user-visible name of the repository (i.e. the organization name)
     * that owns this team
     */
    get repositoryName() {
        return this._repositoryName;
    }
    get repositoryOwnerID() {
        return this._repositoryOwnerID;
    }
    get repositoryOwnerEmail() {
        return this._repositoryOwnerEmail;
    }
    get repositoryOwnerType() {
        return this._repositoryOwnerType;
    }
    /**
     * The role or permissions of the user for this team.
     * 'editor' and 'owner' are combined for backward
     * compatibility.
     * @deprecated Use 'role' instead.
     */
    get collaboratorRole() {
        oneTimeWarning('collaboratorRoleDeprecated', 'The property collaboratorRole has been depecrated in favor of role.');
        return this._role === 'owner'
            ? 'editor' : this._role;
    }
    /**
     * The role or permissions of the user for this team.
     * can be any of the following values: 'editor', 'viewer'
     * 'owner'.
     *
     * @note The 'viewer' role is not set in any workflow currently.
     */
    get role() {
        return this._role;
    }
    get state() {
        return this._state;
    }
    /**
     * The links provided by the service for this team.
     *
     * @private
     */
    get _links() {
        return this.__links;
    }
    /**
     * Archive/Discard team
     *
     * @NOTE Currently there are some inconsistencies in how the API's are
     * named within Projects
     * Team API uses “discarded”, Project API uses “archived”
     */
    async archive() {
        await this._core.spaceContext.archiveTeam(this);
    }
    /**
     * Create a space for this team.
     *
     * @param data {IProjectsCreateData}
     */
    async createSpace(data) {
        return await this._core.spaceContext.createSpace(this, data);
    }
    /**
     * Permanently Delete a Team that has already been discarded.
     *
     */
    async permanentlyDelete() {
        await this._core.spaceContext.permanentlyDeleteTeam(this);
    }
    /**
     * Rename this Team.
     *
     * @param newName
     */
    async rename(newName) {
        await this._core.spaceContext.renameTeam(this, newName);
    }
    /**
     * Restore this Team
     */
    async restore() {
        await this._core.spaceContext.restoreTeam(this);
    }
    /**
     * Update properties on this team
     */
    async update(data) {
        await this._core.spaceContext.updateTeam(this, data);
    }
    /**
     * Ensures the description is loaded and available
     * on a team.
     */
    async ensureDescription() {
        await this._core.spaceContext.loadTeamProperties(this);
    }
}
__decorate([
    observable$1
], Team$1.prototype, "created", null);
__decorate([
    observable$1
], Team$1.prototype, "createdBy", null);
__decorate([
    observable$1
], Team$1.prototype, "name", null);
__decorate([
    observable$1
], Team$1.prototype, "description", null);
__decorate([
    observable$1
], Team$1.prototype, "repositoryID", null);
__decorate([
    observable$1
], Team$1.prototype, "repositoryName", null);
__decorate([
    observable$1
], Team$1.prototype, "repositoryOwnerID", null);
__decorate([
    observable$1
], Team$1.prototype, "repositoryOwnerEmail", null);
__decorate([
    observable$1
], Team$1.prototype, "repositoryOwnerType", null);
__decorate([
    observable$1
], Team$1.prototype, "collaboratorRole", null);
__decorate([
    observable$1
], Team$1.prototype, "role", null);
__decorate([
    observable$1
], Team$1.prototype, "state", null);
__decorate([
    observable$1
], Team$1.prototype, "_links", null);
const TeamUpdater = new ItemUpdater({
    localItemType: Team$1,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_created': { name: 'createDate', format: 'date' },
        '_createdBy': 'createdBy',
        '_description': 'description',
        '_name': 'name',
        '_repositoryID': 'repositoryId',
        '_repositoryName': 'repositoryName',
        '_repositoryOwnerID': 'repositoryOwner.id',
        '_repositoryOwnerEmail': 'repositoryOwner.email',
        '_repositoryOwnerType': { name: 'repositoryOwner.type', choices: RepositoryOwnerTypes },
        '_role': { name: 'role', choices: CollaboratorRoles },
        '_state': { name: 'state', choices: TeamStates },
        '__links': { name: '_links', format: 'object' }
    })
});

/*************************************************************************
*   ADOBE CONFIDENTIAL
*
*   Copyright 2024 Adobe
*   All Rights Reserved.
*
*   NOTICE:  All information contained herein is, and remains
*   the property of Adobe and its suppliers, if any. The intellectual
*   and technical concepts contained herein are proprietary to Adobe
*   and its suppliers and are protected by all applicable intellectual
*   property laws, including trade secret and copyright laws.
*   Dissemination of this information or reproduction of this material
*   is strictly forbidden unless prior written permission is obtained
*   from Adobe.
**************************************************************************/
const OrderFieldToComparator$1 = {
    displayName(a, b) {
        // List is sorted in order returned by service
        return compareStrings(a.displayName, b.displayName);
    }
};
class AddressBookContactOrder extends createItemOrderFactory(OrderFieldToComparator$1) {
}
AddressBookContactOrder.default = new AddressBookContactOrder('ascending', 'displayName');

const OrderFieldToComparator = {
    displayName(a, b) {
        return compareStrings(a.displayName, b.displayName);
    }
};
class AddressBookOrder extends createItemOrderFactory(OrderFieldToComparator) {
}
AddressBookOrder.default = new AddressBookOrder('ascending', 'displayName');

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class Gradient extends ItemBase {
    constructor() {
        super(...arguments);
        this._isDefault = false;
        this._type = '';
        this._angle = 0;
        this._stops = [];
        this._name = '';
        this._languageCode = '';
        this._gradientID = '';
        this._textAlpha = 1;
        this._textMode = 'RGB';
        this._textColorValue = { r: 0, g: 0, b: 0 };
        this._textType = 'process';
    }
    get isDefault() {
        return this._isDefault;
    }
    get type() {
        return this._type;
    }
    get angle() {
        return this._angle;
    }
    get stops() {
        return this._stops;
    }
    get name() {
        return this._name;
    }
    get languageCode() {
        return this._languageCode;
    }
    /**
     * The original non-computed gradient ID to be used when
     * assigning a gradient to a Project.
     */
    get gradientID() {
        return this._gradientID;
    }
    get textAlpha() {
        return this._textAlpha;
    }
    get textMode() {
        return this._textMode;
    }
    get textColorValue() {
        return this._textColorValue;
    }
    get textType() {
        return this._textType;
    }
}
const GradientUpdater = new ItemUpdater({
    localItemType: Gradient,
    /**
     * The computedID is property that is computed based on the
     * gradientId from the service, and the language code from the service.
     * It typically looks something like. 'FUSCHIA-en-US'. This helps
     * us store and retrieve the gradients by not just id but also language to
     * make it more performant if the user switches languages during runtime.
     * IGradientComputedItemResponse extends IGradientItemResponse to include
     * the computedID property.
     */
    remoteIdProperty: 'computedID',
    propertyUpdater: new PropertyUpdater({
        '_isDefault': { name: 'project:gradientData.isDefault', format: 'boolean' },
        '_type': { name: 'project:gradientData.type', format: 'string' },
        '_angle': { name: 'project:gradientData.angle', format: 'string' },
        '_name': { name: 'project:gradientName', format: 'string' },
        '_stops': { name: 'project:gradientData.stops', format: 'object' },
        '_languageCode': { name: 'project:gradientData.languageCode', format: 'string' },
        '_gradientID': 'project:gradientId',
        '_textAlpha': { name: 'project:gradientTextColor.alpha', format: 'number' },
        '_textMode': { name: 'project:gradientTextColor.mode', format: 'string' },
        '_textColorValue': { name: 'project:gradientTextColor.value', format: 'object' },
        '_textType': { name: 'project:gradientTextColor.type', format: 'string' }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const FRAMEIO_AUTHORIZATION_CHANGE = 'frameioAuthorizationChange';
class FrameioAuthorizationChangeEvent extends SAMEvent {
    constructor() {
        super(FRAMEIO_AUTHORIZATION_CHANGE);
    }
}
const SharedFrameioAuthorizationChangeEvent = new FrameioAuthorizationChangeEvent();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const FRAMEIO_REVIEW_LINKS_CHANGE = 'frameioReviewLinksChange';
class FrameioReviewLinksChangeEvent extends SAMEvent {
    constructor() {
        super(FRAMEIO_REVIEW_LINKS_CHANGE);
    }
}
const SharedFrameioReviewLinksChangeEvent = new FrameioReviewLinksChangeEvent();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Consolidate Frame.io links used by FrameioInterface into
// templated urls
const FRAMEIO_API_BASE = 'https://api.frame.io';
const FRAMEIO_LINKS = {
    ME: `${FRAMEIO_API_BASE}/v2/me`,
    ACCOUNT: `${FRAMEIO_API_BASE}/v2/accounts/{accountId}`,
    ACCOUNTS: `${FRAMEIO_API_BASE}/v2/accounts?join=collaborator`,
    TEAMS: `${FRAMEIO_API_BASE}/v2/accounts/{accountId}/teams?include=user_role&role=member`,
    TEAM: `${FRAMEIO_API_BASE}/v2/teams/{teamId}?include=account`,
    PROJECT: `${FRAMEIO_API_BASE}/v2/projects/{projectId}?include=string`,
    PROJECTS: `${FRAMEIO_API_BASE}/v2/teams/{teamId}/projects?filter[archived]`,
    SHAREDPROJECTS: `${FRAMEIO_API_BASE}/v2/projects/shared?filter[account_id]={accountId}`,
    REVIEWS: `${FRAMEIO_API_BASE}/v2/projects/{projectId}/review_links`,
    REVIEW: `${FRAMEIO_API_BASE}/v2/review_links/{reviewLinkId}`,
    ITEMCREATE: `${FRAMEIO_API_BASE}/v2/review_links/{reviewLinkId}/assets`,
    ASSETS: `${FRAMEIO_API_BASE}/v2/assets/{assetId}/children?include=cover_asset`,
    ASSET: `${FRAMEIO_API_BASE}/v2/assets/{assetId}?type=folder&include=cover_asset`,
    CREATEASSET: `${FRAMEIO_API_BASE}/v2/assets/{parentId}/children`,
    VERSION: `${FRAMEIO_API_BASE}/v2/assets/{assetId}/version`,
    CREATECOMMENT: `${FRAMEIO_API_BASE}/v2/assets/{assetId}/comments`,
    GETCOMMENT: `${FRAMEIO_API_BASE}/v2/comments/{commentId}?include=string`,
    GETCOMMENTS: `${FRAMEIO_API_BASE}/v2/assets/{assetId}/comments?include=string`,
    IMPRESSIONS: `${FRAMEIO_API_BASE}/v2/comments/{commentId}/impressions?include=string`,
    COMMENT: `${FRAMEIO_API_BASE}/v2/comments/{commentId}`,
    REPLY: `${FRAMEIO_API_BASE}/v2/comments/{commentId}/replies`,
    GETREPLIES: `${FRAMEIO_API_BASE}/v2/comments/{commentId}/replies?include=replies`,
    LIKE: `${FRAMEIO_API_BASE}/v2/comments/{commentId}/like`,
    COMPLETE: `${FRAMEIO_API_BASE}/v2/comments/{commentId}/complete`,
    FOLDERTREE: `${FRAMEIO_API_BASE}/v2/projects/{projectId}/folder_tree`,
    ANCESTORS: `${FRAMEIO_API_BASE}/v2/assets/{assetId}/ancestors`,
    ADOBE_SUSI_USER: `${FRAMEIO_API_BASE}/v2/auth/adobe/method`,
    ADOBE_SUSI: `${FRAMEIO_API_BASE}/v2/auth/adobe/callback`
};
function fillURLTemplate(url, params) {
    // such as fillURLTemplate('v2/accounts/{accountId}', { "accountId": "id-for-account"})
    const template = uriTemplates(url);
    return template.fill(params);
}
var IFrameioAuthenticationStatus;
(function (IFrameioAuthenticationStatus) {
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authLoggedOut"] = 0] = "authLoggedOut";
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authLoggedIn"] = 1] = "authLoggedIn";
    IFrameioAuthenticationStatus[IFrameioAuthenticationStatus["authExpired"] = 2] = "authExpired";
})(IFrameioAuthenticationStatus || (IFrameioAuthenticationStatus = {}));
// Values for credential caching.
const frameioCredentialsCacheKey = 'FRAMEIO_CREDENTIALS_';
// Local cache expires in 14 days (in ms)
const frameioCredentialsTTL = millisecondsPerHour * (24 * 14);
// Refresh token expiration (in second)
const frameioRefreshTokenDuration = secondsPerHour * (24 * 15);
// An Interface, in this context, is the RESTful interface implemented
// by a service, so most methods of FrameioInterface wrap an HTTP
// Request to Frame.io, and all requests we make to Frame.io should
// go through some method of FrameioInterface.
class FrameioInterface extends InterfaceBase {
    constructor(ctx) {
        super(ctx._core);
        this._frameioContext = ctx;
        // Set the Frame.io client ID used in request analytics.
        const { PRODUCT_ID } = this._core._environment.getValue('HOST_PRODUCT_DATA');
        const frameioClient = 'adobe+' + PRODUCT_ID;
        this._frameioClientId = frameioClient.toLowerCase();
    }
    /**
     * We use native code to login to Frame.io,
     * and authentication is specific to their service,
     * so we'll only access nativeContext methods
     * from FrameioInterface.
     */
    //----------------------------------------------------------------
    // Limit FrameioInterface to be the only client of IFrameioNativeContext,
    // the interface implementing the native support for frame.io.
    get nativeContext() {
        // @ts-expect-error
        const acplModel = (typeof window !== 'undefined') && window.acplModel;
        if (!this._nativeContext && acplModel) {
            const workflows = acplModel.Workflows;
            if (workflows.createShareForReviewWorkflow) {
                const shareForReviewWorkflow = workflows.createShareForReviewWorkflow(acplModel.applicationAssetContext);
                this._nativeContext = shareForReviewWorkflow.getFrameioAssetContext();
                if (this._nativeContext) {
                    const self = this;
                    this._nativeContext.addEventListener(FRAMEIO_REVIEW_LINKS_CHANGE, (json) => {
                        self._frameioContext._handleReviewLinksChangeEvent(json);
                    });
                    this._nativeContext.addEventListener(FRAMEIO_AUTHORIZATION_CHANGE, async () => {
                        const nativeAuthInfo = self.nativeContext.authenticationInfo();
                        if (nativeAuthInfo.frameioToken) {
                            // logged in, or refreshed
                            await self._cacheCredentials(JSON.stringify(nativeAuthInfo));
                            // when the id changes, the context will clear user data
                            self._frameioContext._updateCurrentUserId(nativeAuthInfo.frameioUserId);
                        }
                        else {
                            // logged out
                            await self._core._environment.cache.deleteItem(self._cachedCredentialsId());
                            // clear user specific information.
                            self._frameioContext._updateCurrentUserId(undefined);
                        }
                        self._frameioContext.dispatch(SharedFrameioAuthorizationChangeEvent);
                    });
                }
            }
            else {
                oneTimeWarning('FrameioInterface.nativeContext', 'Share for Review workflows are not enabled for this application');
            }
        }
        if (!this._nativeContext) {
            oneTimeWarning('FrameioInterface.nativeContext', 'native Frameio context does not exist, web/browser mode is utilized for testing only');
        }
        return this._nativeContext;
    }
    // ID value to use as a key for authentication credentials.
    get _authenticationId() {
        return this.adobeId;
    }
    _cachedCredentialsId() {
        return frameioCredentialsCacheKey + this._authenticationId;
    }
    _getRefreshTokenExpiration(lastRefresh) {
        const lastRefreshVal = parseInt(lastRefresh);
        if (lastRefreshVal) {
            return lastRefreshVal + frameioRefreshTokenDuration;
        }
        return 0;
    }
    // Retrieve the cached string.
    async _getCachedCredentials() {
        const credentialsId = this._cachedCredentialsId();
        const existingCredentials = await this._core._environment.cache.getItem(credentialsId);
        if (existingCredentials !== NotFound$1) {
            return existingCredentials;
        }
        return '';
    }
    // Persist the credenital string in the browser cache. Eventually this
    // may be transfered to the native side and persisted in the device keychain.
    async _cacheCredentials(credentials) {
        return this._core._environment.cache.setItem(this._cachedCredentialsId(), credentials, frameioCredentialsTTL);
    }
    get adobeId() {
        // This is expected to return the Adobe user GUID.
        return this._core._environment.getValue('USER_ID');
    }
    get ccUserId() {
        // This is expected to return the Adobe CC ID (email address use to login)
        return this._core._environment.getValue('USER_EMAIL') || '';
    }
    get imsToken() {
        return this._core._environment.getValue('ACCESS_TOKEN');
    }
    get xFrameioClient() {
        return this._frameioClientId;
    }
    get productKey() {
        const { PRODUCT_ID } = this._core._environment.getValue('HOST_PRODUCT_DATA');
        // The Frame.io native module expect the product code to be the 4CC
        // client product identifier.  However, SAM.js seems to use the whole
        // product name, so we need to do a conversion here.
        // Currently only Photoshop(PHXS), Illustrator(ILST), InDesign(IDSN) and
        // the `dev` key are supported.
        if (PRODUCT_ID.includes('Photoshop')) {
            return 'PHXS';
        }
        else if (PRODUCT_ID.includes('Illustrator')) {
            return 'ILST';
        }
        else if (PRODUCT_ID.includes('InDesign')) {
            return 'IDSN';
        }
        else if (PRODUCT_ID.includes('SAMJSDemoApp')) {
            return 'dev';
        }
        else if (PRODUCT_ID.includes('/')) {
            // According to the SAM.js comments, this should be passed in as
            // client name/version - but we only need the client name, so drop
            // the rest. This handles the case where the client may pass in the
            // 4CC code with the version (i.e. 'PHXS/25.0') instead of the full
            // name handled above.
            return PRODUCT_ID.slice(0, PRODUCT_ID.indexOf('/'));
        }
        // If its an unsupported or demo application, then default to dev key.
        return 'dev';
    }
    async checkForCachedCredentials() {
        // Quick check if we have already set credentials at least once
        // that have not expired.
        const cachedCredentials = await this._getCachedCredentials();
        if (cachedCredentials !== '') {
            const nativeContext = this.nativeContext;
            const parsedCredentials = JSON.parse(cachedCredentials);
            const refreshExpiration = this._getRefreshTokenExpiration(parsedCredentials.frameioLastRefresh);
            if (refreshExpiration) {
                const nowSec = Math.floor(Date.now() / 1000); // ms -> s
                const expired = refreshExpiration - nowSec;
                if (expired <= 0) {
                    return IFrameioAuthenticationStatus.authExpired;
                }
            }
            // Always use the current app version no matter what version was cached.
            parsedCredentials.xFrameioClient = this.xFrameioClient;
            if (nativeContext) {
                // Not expired refresh so auto login.
                const token = await nativeContext.authenticateUser(parsedCredentials);
                // Check to see if there was a refresh on the token, and refresh
                // the cached credentials if there was.
                if (token !== parsedCredentials.token) {
                    const nativeAuthInfo = nativeContext.authenticationInfo();
                    await this._cacheCredentials(JSON.stringify(nativeAuthInfo));
                    return IFrameioAuthenticationStatus.authLoggedIn;
                }
            }
            // else not supported for web so issue logout.
        }
        return IFrameioAuthenticationStatus.authLoggedOut;
    }
    async isAuthenticated() {
        const authStatus = await this.authenticationStatus();
        return (authStatus === IFrameioAuthenticationStatus.authLoggedIn);
    }
    async authenticationStatus() {
        var _a, _b, _c;
        const nativeContext = this.nativeContext;
        if (nativeContext) {
            let nativeAuthStatus = nativeContext.authenticationStatus(this._authenticationId);
            if (nativeAuthStatus === IFrameioAuthenticationStatus.authLoggedOut) {
                // If the state is logged out - check for previous cached info.
                nativeAuthStatus = await this.checkForCachedCredentials();
            }
            return nativeAuthStatus;
        }
        if ((_a = this._authenticationInfo) === null || _a === void 0 ? void 0 : _a.frameioLastRefresh) {
            // Check for the last refresh expiration.  Frame.io refresh tokens
            // expire in 15 day, so set refresh an hour before.
            const kExpiresHours = (15 * 24) - 1;
            const now = new Date();
            const lastRefresh = new Date(0);
            lastRefresh.setUTCSeconds(parseInt((_b = this._authenticationInfo) === null || _b === void 0 ? void 0 : _b.frameioLastRefresh));
            // The `valueOf` looks weird here but it is needed to avoid the Typescript
            // error of: "The left-hand side of an arithmetic operation must be of type
            //   'any', 'number', 'bigint' or an enum type."
            const deltaT = Math.abs(now.valueOf() - lastRefresh.valueOf()) / 36e5;
            if (deltaT >= kExpiresHours) {
                return IFrameioAuthenticationStatus.authExpired;
            }
            return (((_c = this._authenticationInfo) === null || _c === void 0 ? void 0 : _c.frameioToken) ? IFrameioAuthenticationStatus.authLoggedIn : IFrameioAuthenticationStatus.authLoggedOut);
        }
        // If auth refresh is not set - assume logged out.
        return IFrameioAuthenticationStatus.authLoggedOut;
    }
    async getToken() {
        var _a;
        const nativeContext = this.nativeContext;
        if (nativeContext) {
            // The native code caches the token and refreshes it
            // when it's stale, so don't persistently store the
            // token in javascript as it will break the refresh.
            return await nativeContext.getToken();
        }
        return ((_a = this._authenticationInfo) === null || _a === void 0 ? void 0 : _a.frameioToken) || '';
    }
    // Execute a force refresh of the authentication token.
    async refreshToken() {
        var _a;
        const nativeContext = this.nativeContext;
        if (nativeContext) {
            // The native code caches the token and refreshes it
            // when it's stale, so don't persistently store the
            // token in javascript as it will break the refresh.
            const token = await nativeContext.getToken(true);
            // After refreshing to token, the save the new info to the store.
            const nativeAuthInfo = nativeContext.authenticationInfo();
            if (token === nativeAuthInfo.frameioToken) {
                await this._cacheCredentials(JSON.stringify(nativeAuthInfo));
            }
            return token;
        }
        // not supported for web based, so only return what we currently have.
        return ((_a = this._authenticationInfo) === null || _a === void 0 ? void 0 : _a.frameioToken) || '';
    }
    async authenticate(info) {
        const nativeContext = this.nativeContext;
        if (nativeContext) {
            const adobeId = this.adobeId;
            const ccUserId = this.ccUserId;
            const productKey = this.productKey;
            const xFrameioClient = this.xFrameioClient;
            if (!nativeContext.isUserAuthenticated(this._authenticationId)) {
                const nativeInfo = {
                    adobeId,
                    ccUserId,
                    productKey,
                    xFrameioClient,
                };
                if (info !== undefined) {
                    nativeInfo.frameioToken = info.frameioToken;
                    // non-required parameters
                    nativeInfo.frameioRefreshToken = (info === null || info === void 0 ? void 0 : info.frameioRefreshToken) || undefined;
                    nativeInfo.frameioTokenExpires = (info === null || info === void 0 ? void 0 : info.frameioTokenExpires) || undefined;
                    nativeInfo.frameioUserId = (info === null || info === void 0 ? void 0 : info.frameioUserId) || undefined;
                    nativeInfo.frameioLastRefresh = (info === null || info === void 0 ? void 0 : info.frameioLastRefresh) || undefined;
                }
                // Removing the following block for now as PM has decided they dont want to have
                // single sign on for the moment as to allow the user to select login account rather
                // than limiting it to the Adobe associated account.  This is subject to change and
                // so its better to leave the SUSI block here for the time being.
                // } else {
                //     // check for SUSI availability.
                //     const susiInfo = await this.getAdobeSusiInfo();
                //     if (susiInfo.susiAvailable) {
                //         const susiAuthInfo = await this.authenticateAdobeSusi();
                //         nativeInfo.frameioToken = susiAuthInfo.frameioToken;
                //         // non-required parameters
                //         nativeInfo.frameioRefreshToken = susiAuthInfo?.frameioRefreshToken || undefined;
                //         nativeInfo.frameioTokenExpires = susiAuthInfo?.frameioTokenExpires || undefined;
                //         nativeInfo.frameioUserId = susiAuthInfo?.frameioUserId || undefined;
                //         nativeInfo.frameioLastRefresh = susiAuthInfo?.frameioLastRefresh || undefined;
                //     }
                // }
                const token = await nativeContext.authenticateUser(nativeInfo);
                if (token !== '') {
                    const nativeAuthInfo = nativeContext.authenticationInfo();
                    await this._cacheCredentials(JSON.stringify(nativeAuthInfo));
                }
                return token;
            }
        }
        else {
            this._authenticationInfo = info || undefined;
        }
        return await this.getToken();
    }
    async deauthenticate() {
        this._authenticationInfo = undefined;
        await this._core._environment.cache.deleteItem(this._cachedCredentialsId());
        const nativeContext = this.nativeContext;
        if (nativeContext) {
            await nativeContext.deauthenticateUser(this._authenticationId);
        }
        return;
    }
    async openFile(filename) {
        const nativeContext = this.nativeContext;
        if (nativeContext) {
            return await nativeContext.openFile(filename);
        }
        throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'Method is not supported in browser _environment.');
    }
    // end of IFrameioNativeContext
    //----------------------------------------------------------------
    dispatchReviewLinksChangeEvent(json) {
        const nativeContext = this.nativeContext;
        if (!nativeContext) {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'Method is not supported in browser _environment.');
        }
        nativeContext.dispatchReviewLinksChangeEvent(json);
    }
    // Methods related to using Adobe Single User Sign In (SUSI)
    async getAdobeSusiInfo() {
        const respJson = await this._adobeSusiUserRequest();
        const susiInfo = {
            userExists: respJson.exists,
            susiAvailable: (respJson.method === 'adobe'),
            restriction: respJson.restriction || undefined
        };
        return susiInfo;
    }
    async authenticateAdobeSusi() {
        const authInfo = await this._adobeSusiRequest();
        return authInfo;
    }
    async _adobeSusiUserRequest() {
        const response = await this._doPost(FRAMEIO_LINKS.ADOBE_SUSI_USER, { 'Content-Type': 'application/json' }, JSON.stringify({ access_token: this.imsToken }), [200]);
        return response.json();
    }
    async _adobeSusiRequest() {
        const response = await this._doPost(FRAMEIO_LINKS.ADOBE_SUSI, { 'Content-Type': 'application/json' }, JSON.stringify({ access_token: this.imsToken }), [200]);
        const respHeaders = response.headers;
        const respBody = await response.json();
        const token = respHeaders.get('authorization');
        const refreshToken = respHeaders.get('x-refresh-token');
        const tokenExpires = respHeaders.get('x-expires');
        const authInfo = {
            frameioToken: token ? token.replace('Bearer ', '') : '',
            frameioRefreshToken: refreshToken || undefined,
            frameioTokenExpires: tokenExpires || undefined,
            frameioUserId: respBody.id || undefined,
            frameioLastRefresh: Date.now().toString(),
            useAdobeSusi: true
        };
        return authInfo;
    }
    //----------------------------------------------------------------
    // InterfaceBase._fetch() lets subclasses adjust the fetch options
    // by calling _getFetchOptionOverrides().
    //
    // FrameioInterface specifies noOtherHeaders=true to block ACP
    // specific headers, such as _fetch() injecting it's own
    // ACP specific authorization token. Instead, we specify
    // the Frameio authorization token
    async _getFetchOptionOverrides(href, fetchOptions) {
        const token = await this.getToken();
        return {
            href,
            options: Object.assign(Object.assign({}, fetchOptions), { headers: Object.assign(Object.assign({}, fetchOptions.headers), { 
                    // Override Environment.fetch default auth header
                    'authorization': `Bearer ${token}`, 'x-frameio-client': this.xFrameioClient }), 
                // Do not allow Environment.fetch to supply its default headers
                noOtherHeaders: true })
        };
    }
    // Frameio endpoints that return Array<>'s can be paginated:
    //   https://developer.frame.io/docs/getting-started/key-concepts#h2-section-pagination
    //   NOTE: The default page size is 50.
    //
    // _getMultiPageResponse() will read each page in the response,
    // and return the result of combining them into one large array.
    async _getMultiPageResponse(href) {
        let result = [];
        const nextPageUri = (response) => {
            const linkHeader = response && response.headers && response.headers.get('Link');
            const link$1 = linkHeader && link.parse(linkHeader);
            const ref = link$1 && link$1.has('rel', 'next') && link$1.get('rel', 'next');
            const uri = ref && ref[0] && ref[0].uri;
            // For some reason, the link headers are specifying http,
            // but our requests fail with 403 unless we use https.
            return uri && uri.replace('http:', 'https:');
        };
        const readPage = async (url) => {
            const response = await this._doGet(url);
            const json = await response.json();
            const next = nextPageUri(response);
            // Accumulate the pages in result
            result = result.concat(json);
            // Use tail recursion to read the next page, or return
            // the final result if there are no more pages.
            return next ? readPage(next) : result;
        };
        return readPage(href);
    }
    //
    //----------------------------------------------------------------
    // See https://developer.frame.io/api/reference/operation/getMe/
    async getCurrentUser() {
        return this._getResponse(FRAMEIO_LINKS.ME);
    }
    // See https://developer.frame.io/api/reference/operation/getAccount/
    async getAccount(accountId) {
        return this._getResponse(fillURLTemplate(FRAMEIO_LINKS.ACCOUNT, { accountId }));
    }
    // See https://developer.frame.io/api/reference/operation/getAccounts/
    async getAccounts() {
        return this._getMultiPageResponse(FRAMEIO_LINKS.ACCOUNTS);
    }
    // See https://developer.frame.io/api/reference/operation/getTeamsByAccount/
    async getTeams(accountId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.TEAMS, { accountId }));
    }
    // See https://developer.frame.io/api/reference/operation/getTeam/
    async getTeam(teamId) {
        return this._getResponse(fillURLTemplate(FRAMEIO_LINKS.TEAM, { teamId }));
    }
    // See https://developer.frame.io/api/reference/operation/getProject/
    async getProject(projectId) {
        return this._getResponse(fillURLTemplate(FRAMEIO_LINKS.PROJECT, { projectId }));
    }
    // See https://developer.frame.io/api/reference/operation/getProjectsByTeam/
    async getProjects(teamId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.PROJECTS, { teamId }));
    }
    // See https://developer.frame.io/api/reference/operation/getSharedProjects/
    // NOTE: Using filter[account_id]={accountId} to restrict results to a specific account
    async getSharedProjects(accountId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.SHAREDPROJECTS, { accountId }));
    }
    // See https://developer.frame.io/api/reference/operation/reviewLinksList/
    async getReviewLinks(projectId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.REVIEWS, { projectId }));
    }
    // See https://developer.frame.io/api/reference/operation/reviewLinkGet/
    async getReviewLink(reviewLinkId) {
        return this._getResponse(fillURLTemplate(FRAMEIO_LINKS.REVIEW, { reviewLinkId }));
    }
    // See https://developer.frame.io/api/reference/operation/reviewLinkCreate/
    async createReviewLink(projectId, displayName) {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.REVIEWS, { projectId }), { 'Content-Type': 'application/json' }, JSON.stringify({ name: displayName }), [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/createAsset/
    async createFolder(parentId, displayName) {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.CREATEASSET, { parentId }), { 'Content-Type': 'application/json' }, JSON.stringify({ name: displayName, type: 'folder' }), [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/createAsset/
    // See also https://developer.frame.io/docs/workflows-assets/uploading-assets
    async createFile(parentId, displayName, fileSize, mimeType = 'application/pdf') {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.CREATEASSET, { parentId }), { 'Content-Type': 'application/json' }, JSON.stringify({
            name: displayName,
            type: 'file',
            filetype: mimeType,
            filesize: fileSize
        }), [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/createAsset/
    // See also https://developer.frame.io/docs/workflows-assets/uploading-assets
    async uploadFile(url, bytes, mimeType = 'application/pdf') {
        // !!@ The upload urls are to AWS, so I'm just using a raw fetch for now...
        const init = {
            method: 'PUT',
            headers: {
                'Content-Type': mimeType,
                'x-amz-acl': 'private'
            },
            body: bytes
        };
        await fetch(url, init);
    }
    // See https://developer.frame.io/api/reference/operation/reviewLinkItemCreate/
    async reviewLinkAddAsset(reviewLinkId, assetId) {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.ITEMCREATE, { reviewLinkId }), { 'Content-Type': 'application/json' }, JSON.stringify({ asset_ids: [assetId] }), [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/getAssets/
    async getChildren(assetId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.ASSETS, { assetId }));
    }
    // See https://developer.frame.io/api/reference/operation/getAsset/
    async getAsset(assetId) {
        return this._getResponse(fillURLTemplate(FRAMEIO_LINKS.ASSET, { assetId }));
    }
    // See https://developer.frame.io/api/reference/operation/addVersionToAsset/
    async addVersionToAsset(assetId, nextAssetId) {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.VERSION, { assetId }), { 'Content-Type': 'application/json' }, JSON.stringify({ next_asset_id: nextAssetId }), [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/createComment/
    async createComment(assetId, text) {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.CREATECOMMENT, { assetId }), { 'Content-Type': 'application/json' }, JSON.stringify({ text }), [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/getComment/
    async getComment(commentId) {
        return this._getResponse(fillURLTemplate(FRAMEIO_LINKS.GETCOMMENT, { commentId }));
    }
    // See https://developer.frame.io/api/reference/operation/getComments/
    async getComments(assetId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.GETCOMMENTS, { assetId }));
    }
    // See https://developer.frame.io/api/reference/operation/getCommentImpressions/
    async getImpressions(commentId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.IMPRESSIONS, { commentId }));
    }
    // See https://developer.frame.io/api/reference/operation/updateComment/
    async updateComment(commentId, text) {
        const response = await this._doPut(fillURLTemplate(FRAMEIO_LINKS.COMMENT, { commentId }), { 'Content-Type': 'application/json' }, JSON.stringify({ text }), [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/deleteComment/
    async deleteComment(commentId) {
        const response = await this._doDelete(fillURLTemplate(FRAMEIO_LINKS.COMMENT, { commentId }));
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/createReply/
    async createReply(commentId, text) {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.REPLY, { commentId }), { 'Content-Type': 'application/json' }, JSON.stringify({ text }), [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/getComments/
    async getReplies(commentId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.GETREPLIES, { commentId }));
    }
    // See https://developer.frame.io/api/reference/operation/createCommentImpressionLike/
    async createLike(commentId) {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.LIKE, { commentId }), {}, undefined, [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/deleteCommentImpressionLike/
    async deleteLike(commentId) {
        const response = await this._doDelete(fillURLTemplate(FRAMEIO_LINKS.LIKE, { commentId }));
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/completeComment/
    async completeComment(commentId) {
        const response = await this._doPost(fillURLTemplate(FRAMEIO_LINKS.COMPLETE, { commentId }), {}, undefined, [200]);
        return response.json();
    }
    // See https://developer.frame.io/api/reference/operation/uncompleteComment/
    async uncompleteComment(commentId) {
        const response = await this._doDelete(fillURLTemplate(FRAMEIO_LINKS.COMPLETE, { commentId }));
        return response.json();
    }
    // This is an undocumented interface. It will not work with developer tokens
    // Loosely speaking, a tree of assets gets stringify()'ed as a dictionary.
    //
    // Each folder in the tree is added to the dictionary using the folder id
    // as a key, and an array of objects describing the folder's immediate children
    // as the value. The description of a child includes { id, parent_id, name },
    // but is not a full asset description ( IFrameioAssetResponse ).
    //
    // As the root folder has no parent to describe it, the value of data["root"]
    // is an array containing the root folder's description.
    async getFolderTree(projectId) {
        return this._getResponse(fillURLTemplate(FRAMEIO_LINKS.FOLDERTREE, { projectId }));
    }
    // This is an undocumented interface. It will not work with developer tokens.
    //
    // The response is an array of assets.
    //
    // If the asset's path relative to it's project is ./folder/asset,
    // then the array would be:
    //
    // array[0] = root_asset
    // array[1] = folder
    // array[2] = asset
    async getAncestors(assetId) {
        return this._getMultiPageResponse(fillURLTemplate(FRAMEIO_LINKS.ANCESTORS, { assetId }));
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class FrameioBase extends ItemBase {
    // ItemBase implements this.id for us
    /**
     * @package - not yet decided if context is internal use only.
     *  In the meantime, I'm decorating them to discourage it's use.
     */
    get context() {
        return this._core.frameioContext;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getAccount/
//  for schema of the data FrameioAccount encapsulates.
class FrameioUser extends FrameioBase {
    constructor() {
        super(...arguments);
        this._accountId = '';
        this._email = '';
        this._name = '';
        this._profileImage = '';
        this._userDefaultColor = '';
    }
    get accountId() {
        return this._accountId;
    }
    get email() {
        return this._email;
    }
    get name() {
        return this._name;
    }
    get profileImage() {
        return this._profileImage;
    }
    get userDefaultColor() {
        return this._userDefaultColor;
    }
    async getAccount() {
        if (!this._account) {
            this._account = await this.context.getAccount(this.accountId);
        }
        return this._account;
    }
}
const FrameioUserUpdater = new ItemUpdater({
    localItemType: FrameioUser,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_accountId': 'account_id',
        '_email': 'email',
        '_name': 'name',
        '_profileImage': 'profile_image',
        '_userDefaultColor': 'user_default_color'
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getAsset/
//  for schema of IFrameioAssetResponse. FrameioFolder
//  encapsulates the data for assets of type="folder".
//
// See FrameioFile, FrameioVersionStack for other asset types.
class FrameioAsset extends FrameioBase {
    constructor() {
        super(...arguments);
        this._name = '';
        this._projectId = '';
        this._teamId = '';
    }
    /* All of a FrameioAsset's id's should be valid id's.
     *
     * But Frame.io indicates a root_asset folder with
     * (parent_id == null), as a root doesn't have a parent.
     *
     * SAM.js isn't a fan of the null's, so it's using
     * undefined for the same thing.
     */
    get insertedAt() {
        return this._insertedAt;
    }
    get name() {
        return this._name;
    }
    get parentId() {
        return this._parentId;
    }
    async getParent() {
        const ctx = this.context;
        const parentId = this.parentId;
        if (parentId) {
            return ctx.getAsset(parentId);
        }
        return undefined;
    }
    get projectId() {
        return this._projectId;
    }
    get teamId() {
        return this._teamId;
    }
    get updatedAt() {
        return this._updatedAt;
    }
    /*
     * If the path to an asset relative to it's project is
     *      ./folder/subfolder/asset
     *
     * Then
     *      ancestors[0] = folder : FrameioFolder
     *      ancestors[1] = subfolder : FrameioFolder
     *      ancestors[2] = asset : FrameioAsset
     */
    async getAncestors() {
        return this.context.getAncestors(this.id);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/createCommentImpressionLike/
//  for schema of IFrameioLikeResponse, aka response.type="like".
class FrameioLike extends FrameioBase {
    get anonymousUserId() {
        return this._anonymousUserId || '';
    }
    get comment() {
        return this._comment;
    }
    get commentId() {
        return this._commentId || '';
    }
    get deletedAt() {
        return this._deletedAt;
    }
    get insertedAt() {
        return this._insertedAt;
    }
    get updatedAt() {
        return this._updatedAt;
    }
    get userId() {
        return this._userId || '';
    }
}
const FrameioLikeUpdater = new ItemUpdater({
    localItemType: FrameioLike,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_anonymousUserId': 'anonymous_user_id',
        '_comment': {
            // The comment property of an IFrameioLikeResponse is a nested
            // object of type IFrameioCommentResponse, so let's update it!
            set: (comment, dest) => {
                const like = dest;
                const context = like.context;
                const pool = context._objectPool;
                const session = pool.createUpdateSession();
                like['_comment'] = FrameioCommentUpdater.updateRemoteItem(session, comment);
                session.commit();
            },
            name: 'comment',
            format: 'object'
        },
        '_commentId': 'comment_id',
        '_deletedAt': { name: 'deleted_at', format: 'date' },
        '_insertedAt': { name: 'inserted_at', format: 'date' },
        '_updatedAt': { name: 'updated_at', format: 'date' },
        '_userId': 'user_id'
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getAsset/
//  for schema of IFrameioAssetResponse. FrameioFile
//  encapsulates the data for assets of type="file".
//
// See FrameioFolder, FrameioVersionStack for other asset types.
class FrameioComment extends FrameioBase {
    constructor() {
        // Frame.io uses { myString : null } for unspecified
        // values, which causes our updater to set the string
        // property to undefined, but our getters substitute
        // '' for undefined, so our clients aren't exposed to this.
        super(...arguments);
        this._completed = false;
        this._hasReplies = false;
        this._likeCount = 0;
        this._private = false;
        this._readCount = 0;
        this._timestamp = 0;
        this._timestampMicroseconds = 0;
    }
    get assetId() {
        return this._assetId || '';
    }
    get completed() {
        return this._completed;
    }
    get completedAt() {
        return this._completedAt;
    }
    get completerId() {
        return this._completerId || '';
    }
    get deletedAt() {
        return this._deletedAt;
    }
    get hasReplies() {
        return this._hasReplies;
    }
    get insertedAt() {
        return this._insertedAt;
    }
    get likeCount() {
        return this._likeCount;
    }
    get owner() {
        return this._owner;
    }
    get ownerId() {
        return this._ownerId || '';
    }
    get page() {
        return this._page || '';
    }
    get parentId() {
        return this._parentId || '';
    }
    get private() {
        return this._private;
    }
    get readCount() {
        return this._readCount;
    }
    get reviewLinkId() {
        return this._reviewLinkId || '';
    }
    get targetAssetId() {
        return this._targetAssetId || '';
    }
    get text() {
        return this._text || '';
    }
    get textEditedAt() {
        return this._textEditedAt;
    }
    get timestamp() {
        return this._timestamp;
    }
    get timestampMicroseconds() {
        return this._timestampMicroseconds;
    }
    get updatedAt() {
        return this._updatedAt;
    }
    async updateComment(param) {
        const ctx = this.context;
        const response = await ctx._frameioInterface.updateComment(this.id, param.text);
        const session = ctx._objectPool.createUpdateSession();
        const comment = FrameioCommentUpdater.updateRemoteItem(session, response);
        session.commit();
        return comment;
    }
    async deleteComment() {
        const ctx = this.context;
        const response = await ctx._frameioInterface.deleteComment(this.id);
        const session = ctx._objectPool.createUpdateSession();
        const comment = FrameioCommentUpdater.updateRemoteItem(session, response);
        session.commit();
        return comment;
    }
    async createLike() {
        const ctx = this.context;
        const response = await ctx._frameioInterface.createLike(this.id);
        const session = ctx._objectPool.createUpdateSession();
        const like = FrameioLikeUpdater.updateRemoteItem(session, response);
        session.commit();
        return like;
    }
    async deleteLike() {
        const ctx = this.context;
        const response = await ctx._frameioInterface.deleteLike(this.id);
        const session = ctx._objectPool.createUpdateSession();
        const like = FrameioLikeUpdater.updateRemoteItem(session, response);
        session.commit();
        return like;
    }
    async createReply(param) {
        const ctx = this.context;
        const response = await ctx._frameioInterface.createReply(this.id, param.text);
        const session = ctx._objectPool.createUpdateSession();
        const reply = FrameioCommentUpdater.updateRemoteItem(session, response);
        session.commit();
        return reply;
    }
    async getReplies() {
        const ctx = this.context;
        const response = await ctx._frameioInterface.getReplies(this.id);
        const session = ctx._objectPool.createUpdateSession();
        const replies = FrameioCommentUpdater.updateRemoteItems(session, response);
        session.commit();
        return replies;
    }
    async completeComment() {
        const ctx = this.context;
        const response = await ctx._frameioInterface.completeComment(this.id);
        const session = ctx._objectPool.createUpdateSession();
        const comment = FrameioCommentUpdater.updateRemoteItem(session, response);
        session.commit();
        return comment;
    }
    async uncompleteComment() {
        const ctx = this.context;
        const response = await ctx._frameioInterface.uncompleteComment(this.id);
        const session = ctx._objectPool.createUpdateSession();
        const comment = FrameioCommentUpdater.updateRemoteItem(session, response);
        session.commit();
        return comment;
    }
}
const FrameioCommentUpdater = new ItemUpdater({
    localItemType: FrameioComment,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_assetId': 'asset_id',
        '_completed': { name: 'completed', format: 'boolean' },
        '_completedAt': { name: 'completed_at', format: 'date' },
        '_completerId': 'completer_id',
        '_deletedAt': { name: 'deleted_at', format: 'date' },
        '_hasReplies': { name: 'has_replies', format: 'boolean' },
        '_insertedAt': { name: 'inserted_at', format: 'date' },
        '_likeCount': { name: 'like_count', format: 'number' },
        '_owner': {
            // The owner property of an IFrameioComment is a nested
            // IFrameioUserResponse, so let's update it!
            set: (owner, dest) => {
                const comment = dest;
                const context = comment.context;
                const pool = context._objectPool;
                const session = pool.createUpdateSession();
                comment['_owner'] = FrameioUserUpdater.updateRemoteItem(session, owner);
                session.commit();
            },
            name: 'owner',
            format: 'object'
        },
        '_ownerId': 'owner_id',
        '_page': 'page',
        '_parentId': 'parent_id',
        '_private': { name: 'private', format: 'boolean' },
        '_readCount': { name: 'read_count', format: 'number' },
        '_reviewLinkId': 'review_link_id',
        '_targetAssetId': 'target_asset_id',
        '_text': 'text',
        '_textEditedAt': { name: 'text_edited_at', format: 'date' },
        '_timestamp': { name: 'timestamp', format: 'number' },
        '_timestampMicroseconds': { name: 'timestamp_microseconds', format: 'number' },
        '_updatedAt': { name: 'updated_at', format: 'date' }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getAsset/
//  for schema of IFrameioAssetResponse. FrameioFile
//  encapsulates the data for assets of type="file".
//
// See FrameioFolder, FrameioVersionStack for other asset types.
class FrameioFile extends FrameioAsset {
    async createComment(param) {
        const ctx = this.context;
        const response = await ctx._frameioInterface.createComment(this.id, param.text);
        const session = ctx._objectPool.createUpdateSession();
        const comment = FrameioCommentUpdater.updateRemoteItem(session, response);
        session.commit();
        this._comments = undefined; // force it to refresh the next time it's called.
        return comment;
    }
    // https://developer.frame.io/docs/workflows-projects/gather-all-comments-from-a-project
    //  implies that only a file can have comments, folders and version stacks should
    //  enumerate their children for files with comments
    async getComments() {
        let comments = this._comments;
        if (!comments) {
            const ctx = this.context;
            const response = await ctx._frameioInterface.getComments(this.id);
            const session = ctx._objectPool.createUpdateSession();
            comments = FrameioCommentUpdater.updateRemoteItems(session, response);
            session.commit();
            this._comments = comments;
        }
        return comments;
    }
}
const FrameioFileUpdater = new ItemUpdater({
    localItemType: FrameioFile,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_commentCount': 'comment_count',
        '_insertedAt': { name: 'inserted_at', format: 'date' },
        '_name': 'name',
        '_parentId': 'parent_id',
        '_projectId': 'project_id',
        '_teamId': 'team_id',
        '_updatedAt': { name: 'updated_at', format: 'date' }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getAsset/
//  for schema of IFrameioAssetResponse. FrameioFolder
//  encapsulates the data for assets of type="folder".
//
// See FrameioFile, FrameioVersionStack for other asset types.
class FrameioFolder extends FrameioAsset {
    // clients shouldn't need to deal with id's
    async getChildren() {
        if (!this._children) {
            const ctx = this.context;
            const response = await ctx._frameioInterface.getChildren(this.id);
            const session = ctx._objectPool.createUpdateSession();
            // IFrameioAssetResponse is a special case, as it corresponds to multiple classes
            // inheriting from FrameioAsset ( FrameioFile, FrameioFolder, FrameioVersionStack ),
            // so use a utility function to select the correct updater for the type.
            //
            // See also FrameioContext.getAncestors()
            this._children = response.map((asset) => frameioAssetUpdater(session, asset));
            session.commit();
        }
        return this._children;
    }
    async _uploadFile(urls, fp) {
        // Frame.io splits uploads into ~20MB chunks, whereas our expected
        // artifact size is ~5MB, so the most common case will be (numChunks == 1).
        const ctx = this.context;
        // limit the number of concurrent streams
        const maxStreams = 8;
        const fileSize = fp.size();
        const numChunks = urls.length;
        const chunkSize = Math.ceil(fileSize / numChunks); // round-down might lead to omitted bytes.
        let iChunk = 0;
        const nextChunk = async (bytes) => {
            const i = iChunk++;
            bytes = await fp.read((i) * chunkSize, bytes);
            return ctx._frameioInterface.uploadFile(urls[i], bytes).then(() => {
                return (iChunk < numChunks) ? nextChunk(bytes) : Promise.resolve();
            });
        };
        const limit = Math.min(numChunks, maxStreams);
        const promises = [];
        for (let i = 0; i < limit; i++) {
            promises.push(nextChunk(new ArrayBuffer(chunkSize)));
        }
        await Promise.all(promises);
    }
    async createFile(display_name, path) {
        const ctx = this.context;
        const fp = await ctx._frameioInterface.openFile(path);
        const fileSize = fp.size();
        // create the empty asset
        const response = await ctx._frameioInterface.createFile(this.id, display_name, fileSize);
        const session = ctx._objectPool.createUpdateSession();
        const file = FrameioFileUpdater.updateRemoteItem(session, response);
        session.commit();
        await this._uploadFile(response['upload_urls'], fp);
        fp.close();
        return file;
    }
    async createFolder(display_name) {
        const ctx = this.context;
        const response = await ctx._frameioInterface.createFolder(this.id, display_name);
        const session = ctx._objectPool.createUpdateSession();
        const folder = FrameioFolderUpdater.updateRemoteItem(session, response);
        session.commit();
        return folder;
    }
}
const FrameioFolderUpdater = new ItemUpdater({
    localItemType: FrameioFolder,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_insertedAt': { name: 'inserted_at', format: 'date' },
        '_name': 'name',
        '_parentId': 'parent_id',
        '_projectId': 'project_id',
        '_teamId': 'team_id',
        '_updatedAt': { name: 'updated_at', format: 'date' }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getTeamsByAccount/
//  for schema of the data FrameioTeam encapsulates.
class FrameioTeam extends FrameioBase {
    constructor() {
        super(...arguments);
        this._email = '';
        this._name = '';
    }
    get email() {
        return this._email;
    }
    get name() {
        return this._name;
    }
    async getProjects() {
        let projects = this._projects;
        if (!projects) {
            const ctx = this.context;
            const projectsResponse = await this._core.frameioContext._frameioInterface.getProjects(this.id);
            const session = ctx._objectPool.createUpdateSession();
            projects = FrameioProjectUpdater.updateRemoteItems(session, projectsResponse);
            session.commit();
            this._projects = projects;
        }
        return projects;
    }
}
const FrameioTeamUpdater = new ItemUpdater({
    localItemType: FrameioTeam,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_email': 'owner.email',
        '_name': 'name'
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getAsset/
//  for schema of IFrameioAssetResponse. FrameioVersionStack
//  encapsulates the data for assets of type="version_stack".
//
// See FrameioFile, FrameioFolder for other asset types.
class FrameioVersionStack extends FrameioAsset {
    constructor() {
        super(...arguments);
        this._coverAssetId = '';
        this._versions = 0;
    }
    get coverAssetId() {
        return this._coverAssetId;
    }
    async getCoverAsset() {
        if (!this._coverAsset) {
            this._coverAsset = await this.context.getAsset(this.coverAssetId);
        }
        return this._coverAsset;
    }
    get versions() {
        return this._versions;
    }
    set coverAsset(asset) {
        this._coverAsset = asset;
    }
    async getChildren() {
        if (!this._children) {
            const ctx = this.context;
            const response = await ctx._frameioInterface.getChildren(this.id);
            const session = ctx._objectPool.createUpdateSession();
            // IFrameioAssetResponse is a special case, as it corresponds to multiple classes
            // inheriting from FrameioAsset ( FrameioFile, FrameioFolder, FrameioVersionStack ),
            // so use a utility function to select the correct updater for the type.
            //
            // See also FrameioContext.getAncestors()
            this._children = response.map((asset) => frameioAssetUpdater(session, asset));
            session.commit();
        }
        return this._children;
    }
}
const FrameioVersionStackUpdater = new ItemUpdater({
    localItemType: FrameioVersionStack,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_coverAsset': {
            // when the update reads response.root_asset
            // ( which matches name: 'root_asset' ),
            // it will invoke set: with the child object
            //
            name: 'cover_asset',
            format: 'object',
            set: (response, dest) => {
                const stack = dest;
                const pool = stack.context._objectPool;
                const session = pool.createUpdateSession();
                const asset = frameioAssetUpdater(session, response);
                session.commit();
                stack.coverAsset = asset;
            },
        },
        '_coverAssetId': 'cover_asset_id',
        '_insertedAt': { name: 'inserted_at', format: 'date' },
        '_name': 'name',
        '_parentId': 'parent_id',
        '_projectId': 'project_id',
        '_teamId': 'team_id',
        '_updatedAt': { name: 'updated_at', format: 'date' },
        '_versions': { name: 'versions', format: 'number' }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getTeamsByAccount/
//  for schema of the data FrameioTeam encapsulates.
class FrameioReviewLink extends FrameioBase {
    constructor() {
        super(...arguments);
        this._name = '';
        this._shortUrl = '';
        this._ownerId = '';
        this._projectId = '';
        this._active = false;
        this._inviteOnly = false;
    }
    get name() {
        return this._name;
    }
    get shortUrl() {
        return this._shortUrl;
    }
    get ownerId() {
        return this._ownerId;
    }
    get projectId() {
        return this._projectId;
    }
    get active() {
        return this._active;
    }
    get inviteOnly() {
        return this._inviteOnly;
    }
    get itemId() {
        return this._itemId;
    }
    /*
     * Returns the number of artifacts currently in the review.
     */
    async getArtifactCount() {
        const item = await this.getItem();
        if (item instanceof FrameioVersionStack) {
            return item.versions;
        }
        return 1;
    }
    /*
    * Recents the most recently published artifact,
    * a FrameioFile containing a PDF.
    */
    async getArtifact() {
        const item = await this.getItem();
        if (item instanceof FrameioVersionStack) {
            return (await item.getCoverAsset());
        }
        return item;
    }
    async getItem() {
        if (!this._item) {
            if (!this._itemId) {
                return Promise.reject(SAMError.create(SAMErrorCode.BAD_REQUEST, `FrameioReviewLink.getItem() could not find item ${this._itemId}`));
            }
            this._item = await this.context.getAsset(this._itemId);
        }
        return this._item;
    }
    _dispatchReviewLinksChangeEvent(source) {
        const ctx = this.context;
        // After a successful updateReviewLink(),
        // we use SAM.cpp to dispatch an event to all DOM's,
        // so they can each update FrameioContext._reviewLinksForDocument
        //
        // For example, when ShareSheet creates a new review link,
        // ShareSheet and Commenting want to update their cache.
        //
        // See also FrameioContext._handleReviewLinksChangeEvent()
        const param = {
            source,
            reviewLink: {
                id: this.id,
                name: this._name,
                short_url: this._shortUrl,
                owner_id: this._ownerId,
                project_id: this._projectId,
                is_active: (this._active) ? true : false,
                access_control: {
                    invite_only: (this._inviteOnly) ? true : false
                },
                'frameio:artifactId': this._itemId,
                'repo:etag': this._etag
            }
        };
        ctx._frameioInterface.dispatchReviewLinksChangeEvent(JSON.stringify(param));
    }
    async updateReviewLink(source, parent, artifactPath) {
        const file = await parent.createFile(this.name, artifactPath);
        if (!this._itemId) {
            // (_itemId === undefined) means this review has never been updated,
            // so the file asset should be added as an item to the review and remembered.
            const ctx = this.context;
            const response = await ctx._frameioInterface.reviewLinkAddAsset(this.id, file.id);
            const session = ctx._objectPool.createUpdateSession();
            FrameioReviewLinkUpdater.updateRemoteItem(session, response); // updates this
            session.commit();
            // Notify the Review Service of the newly created review.
            const result = await ctx._reviewServiceInterface.createReviewLink(Object.assign(Object.assign({}, source), { projectId: this.projectId, reviewLinkId: this.id, artifactId: file.id }));
            this._etag = result['repo:etag'];
            this._item = file;
            this._itemId = file.id;
        }
        else {
            // (_itemId !== undefined) means this isn't the first update.
            //
            // For the second update, we'll version the original file
            // (this._itemId) with the new file to create a stack.
            // We'll overwrite this._itemId with the stack's id and notify
            // the Review Service.
            //
            // For any remaining calls, this._itemId is already a stack,
            // and versioning a stack with a new file just adds the file
            // to the stack. As the stack doesn't change, there's no
            // further need to update the Review Service.
            const ctx = this.context;
            const response = await ctx._frameioInterface.addVersionToAsset(this._itemId, file.id);
            const session = ctx._objectPool.createUpdateSession();
            const item = FrameioVersionStackUpdater.updateRemoteItem(session, response);
            session.commit();
            if (this._itemId !== item.id) {
                // Notify the Review Service that the file
                // has been replaced with a version stack.
                const result = await ctx._reviewServiceInterface.updateReviewLink(Object.assign(Object.assign({}, source), { projectId: this.projectId, reviewLinkId: this.id, artifactId: item.id, etag: this._etag }));
                this._etag = result['repo:etag'];
                this._item = item;
                this._itemId = item.id;
            }
        }
        this._dispatchReviewLinksChangeEvent(source);
    }
}
const FrameioReviewLinkUpdater = new ItemUpdater({
    localItemType: FrameioReviewLink,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_name': 'name',
        '_shortUrl': 'short_url',
        '_ownerId': 'owner_id',
        '_projectId': 'project_id',
        '_active': { name: 'is_active', format: 'boolean' },
        '_inviteOnly': { name: 'access_control.invite_only', format: 'boolean' },
        '_itemId': 'frameio:artifactId',
        '_etag': 'repo:etag'
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getProjectsByTeam/
//  for schema of the data FrameioProject encapsulates.
class FrameioProject extends FrameioBase {
    constructor() {
        super(...arguments);
        this._rootAssetId = '';
        this._name = '';
        this._ownerId = '';
        this._teamId = '';
    }
    get name() {
        return this._name;
    }
    get ownerId() {
        return this._ownerId;
    }
    get rootAssetId() {
        return this._rootAssetId;
    }
    get teamId() {
        return this._teamId;
    }
    async getTeam() {
        if (!this._team) {
            this._team = await this.context.getTeam(this.rootAssetId);
        }
        return this._team;
    }
    async getRootFolder() {
        if (!this._rootFolder) {
            this._rootFolder = await this.context.getAsset(this.rootAssetId);
        }
        return this._rootFolder;
    }
    async getReviewLinks() {
        let reviews = this._reviews;
        if (!reviews) {
            const ctx = this.context;
            const response = await ctx._frameioInterface.getReviewLinks(this.id);
            const session = ctx._objectPool.createUpdateSession();
            reviews = FrameioReviewLinkUpdater.updateRemoteItems(session, response);
            session.commit();
            this._reviews = reviews;
        }
        return reviews;
    }
    createFolder(data, folder) {
        const ctx = this.context;
        // IFrameioFolderTreeFolderResponse only contains
        //      { id, name, parent_id }
        //
        // but FrameioFolderUpdater expects to read
        //      { id, name, parent_id, project_id, team_id }
        //
        // from a IFrameioAssetResponse, so copy { project_id, team_id }
        // from this project into the response so we can use the
        // updater.
        const response = folder;
        response['project_id'] = this.id;
        response['team_id'] = this.teamId;
        const session = ctx._objectPool.createUpdateSession();
        const that = FrameioFolderUpdater.updateRemoteItem(session, response);
        session.commit();
        that['_children'] = data[response.id].map((folder) => this.createFolder(data, folder));
        return that;
    }
    async getFolderTree() {
        // returns the rootFolder, but only after constructing FrameioFolder's for all of the
        // folders in project using an undocumented API.
        const response = await this._core.frameioContext._frameioInterface.getFolderTree(this.id);
        this._rootFolder = this.createFolder(response.data, response.data['root'][0]);
        return this._rootFolder;
    }
    async createReviewLink(display_name) {
        const ctx = this.context;
        const response = await ctx._frameioInterface.createReviewLink(this.id, display_name);
        const session = ctx._objectPool.createUpdateSession();
        const review = FrameioReviewLinkUpdater.updateRemoteItem(session, response);
        session.commit();
        if (this._reviews) {
            // update the cache of reviews owned by this project
            // by adding the newly created review.
            this._reviews.push(review);
        }
        return review;
    }
}
const FrameioProjectUpdater = new ItemUpdater({
    localItemType: FrameioProject,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_name': 'name',
        '_ownerId': 'owner_id',
        '_rootAssetId': 'root_asset_id',
        '_rootFolder': {
            // when the update reads response.root_asset
            // ( which matches name: 'root_asset' ),
            // it will invoke set: with the child object
            //
            name: 'root_asset',
            format: 'object',
            set: (rootFolder, dest) => {
                const project = dest;
                const pool = project.context._objectPool;
                const session = pool.createUpdateSession();
                const folder = FrameioFolderUpdater.updateRemoteItem(session, rootFolder);
                session.commit();
                // @ts-expect-error
                project._rootFolder = folder;
            },
        },
        '_team': {
            // The owner property of an IFrameioAccountResponse is a nested
            // object of type IFrameioUserResponse, so let's construct that
            // while we are here.
            set: (team, dest) => {
                const project = dest;
                const context = project.context;
                const pool = context._objectPool;
                const session = pool.createUpdateSession();
                project['_team'] = FrameioTeamUpdater.updateRemoteItem(session, team);
                session.commit();
            },
            name: 'team',
            format: 'object'
        },
        '_teamId': 'team_id'
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// See https://developer.frame.io/api/reference/operation/getAccount/
//  for schema of the data FrameioAccount encapsulates.
class FrameioAccount extends FrameioBase {
    constructor() {
        super(...arguments);
        this._displayName = '';
        this._ownerId = '';
        this._version = 0;
    }
    /**
     * @package - not yet decided if id's are internal use only.
     *  In the meantime, I'm decorating them to discourage their use.
     */
    get ownerId() {
        return this._ownerId;
    }
    get owner() {
        return this._owner;
    }
    get displayName() {
        return this._displayName;
    }
    get version() {
        return this._version;
    }
    // getTeams() should really be a getter for property teams,
    // but then we'd need an async getter, and I'm not sure
    // of the convention for that.
    // https://medium.com/trabe/async-getters-and-setters-is-it-possible-c18759b6f7e4
    // see getProjectTree() below
    async getTeams() {
        let teams = this._teams;
        if (!teams) {
            const ctx = this.context;
            const teamsResponse = await ctx._frameioInterface.getTeams(this.id);
            const session = ctx._objectPool.createUpdateSession();
            teams = FrameioTeamUpdater.updateRemoteItems(session, teamsResponse);
            session.commit();
            this._teams = teams;
        }
        return teams;
    }
    async getSharedProjects() {
        let shared = this._sharedProjects;
        if (!shared) {
            const ctx = this.context;
            const projectsResponse = await ctx._frameioInterface.getSharedProjects(this.id);
            const session = ctx._objectPool.createUpdateSession();
            shared = FrameioProjectUpdater.updateRemoteItems(session, projectsResponse);
            session.commit();
            this._sharedProjects = shared;
        }
        return shared;
    }
    async getSharedTeams() {
        const projects = await this.getSharedProjects();
        const set = new Set();
        const teams = [];
        // The array we return should not contain duplicates,
        // but a team could have more than one shared projects,
        // so use a set to unique the teams we add to the array.
        for (const project of projects) {
            const id = project.teamId;
            if (!set.has(id)) {
                const team = await project.getTeam();
                set.add(id);
                teams.push(team);
            }
        }
        return teams;
    }
    // same return as getTeams(), but we pre-load the projects of each team
    // before resolving the promise.
    async getProjectTree() {
        const teams = await this.getTeams();
        const promises = [];
        teams.forEach((team) => {
            promises.push(team.getProjects());
        });
        await Promise.all(promises);
        return teams;
    }
}
const FrameioAccountUpdater = new ItemUpdater({
    localItemType: FrameioAccount,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_displayName': 'display_name',
        '_owner': {
            // The owner property of an IFrameioAccountResponse is a nested
            // object of type IFrameioUserResponse, so let's construct that
            // while we are here.
            set: (owner, dest) => {
                const account = dest;
                const context = account.context;
                const pool = context._objectPool;
                const session = pool.createUpdateSession();
                account['_owner'] = FrameioUserUpdater.updateRemoteItem(session, owner);
                session.commit();
            },
            name: 'owner',
            format: 'object'
        },
        '_ownerId': 'owner_id',
        '_version': { name: 'version', format: 'number' }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
//----------------------------------------------------------------
class FrameioContext extends TypedEventEmitter {
    constructor(_core) {
        super();
        this._core = _core;
        /**
         * @package - internal use only
         */
        this._objectPool = new ItemPool(this._core, 'frameio');
        /**
         * @package - internal use only
         */
        this._frameioInterface = new FrameioInterface(this);
        /**
         * @package - internal use only
         */
        this._reviewServiceInterface = new AssetReviewServiceInterface(this._core);
        this._reviewLinksForDocument = new Map();
    }
    /**
     * @package
     *
     * We _updateUserId() whenever the native FrameioAssetContext::authInfo_
     * changes, to allow us to reset any user specific data when the user id
     * changes.
     */
    _updateCurrentUserId(id) {
        if (!id || (this._currentUserId !== id)) {
            this._currentUserId = id;
            this._currentUser = undefined;
            this._accounts = undefined;
            this._reviewLinksForDocument.clear();
        }
    }
    _mapKeyForSourceDocument(source) {
        // We need a hash key for a Map<>,
        // so use the assetId of cloud documents,
        // and the documentId of local documents.
        if (source.documentId) {
            return source.documentId;
        }
        // ignore the optional assetRegion and repositoryId
        return source.assetId;
    }
    _retainUntilTimeout(weak, milliseconds = 2 * 60 * 1000) {
        const obj = weak.deref();
        // obj will be retained until the timeout fires
        // because it's referenced in the handler.
        setTimeout(function () { return obj; }, milliseconds);
    }
    _handleReviewLinksChangeEvent(json) {
        // after a successful FrameioReviewLink.updateReviewLink(),
        // we use SAM.cpp to dispatch an event to all DOM's,
        // so they can each update FrameioContext._reviewLinksForDocument
        //
        // For example, when ShareSheet creates a new review link,
        // ShareSheet and Commenting want to update their cache.
        //
        // See also FrameioReviewLink._dispatchReviewLinksChangeEvent()
        const param = JSON.parse(json);
        const response = param.reviewLink;
        const key = this._mapKeyForSourceDocument(param.source);
        const session = this._objectPool.createUpdateSession();
        const reviewLink = FrameioReviewLinkUpdater.updateRemoteItem(session, response);
        session.commit();
        const weak = new WeakRef([{ reviewLink }]);
        this._reviewLinksForDocument.set(key, weak);
        this._retainUntilTimeout(weak);
        // let client know the reviewLinksForDocument has changed.
        this.dispatch(SharedFrameioReviewLinksChangeEvent);
    }
    async isAuthenticated() {
        return await this._frameioInterface.isAuthenticated();
    }
    async authenticationStatus() {
        return await this._frameioInterface.authenticationStatus();
    }
    // !!@ Consider making this package scoped
    async getToken() {
        return this._frameioInterface.getToken();
    }
    async refreshToken() {
        return this._frameioInterface.refreshToken();
    }
    /* Call with void parameters to rely on native authentication.
     * The return is a token.
     */
    async authenticate(info) {
        return await this._frameioInterface.authenticate(info);
    }
    async deauthenticate() {
        return await this._frameioInterface.deauthenticate();
    }
    async getCurrentUser() {
        let user = this._currentUser;
        if (!user) {
            const response = await this._frameioInterface.getCurrentUser();
            const session = this._objectPool.createUpdateSession();
            user = FrameioUserUpdater.updateRemoteItem(session, response);
            session.commit();
            this._currentUser = user;
        }
        return user;
    }
    async getAccounts() {
        let accounts = this._accounts;
        if (!accounts) {
            const response = await this._frameioInterface.getAccounts();
            const session = this._objectPool.createUpdateSession();
            accounts = FrameioAccountUpdater.updateRemoteItems(session, response);
            session.commit();
            this._accounts = accounts;
        }
        return accounts;
    }
    _getLocalAncestors(id) {
        // Based on prior usage of the package, it's possible
        // we can build ancestors from already local objects
        // in the _objectPool. If so, return the completed
        // array so getAncestors() can avoid the server call.
        //
        // However, if not all of the ancestors are locally available,
        // make the server call to get the entire array.
        const ancestors = new Array();
        for (;;) {
            const asset = this._objectPool.getLocalItemById(id);
            if (asset === undefined) {
                // At least one item isn't local,
                // so we'll need to GET the ancestors from the server.
                return undefined;
            }
            // add latest ancestor to front of array
            ancestors.unshift(asset);
            // walk up one link of the ancestor chain
            if (asset.parentId) {
                id = asset.parentId;
                continue;
            }
            // we've reached the root asset of the project
            break;
        }
        return ancestors;
    }
    async getAncestors(id) {
        // ideally, the whole ancestor chain is already local,
        // and we can fulfill this promise without a server call.
        let ancestors = this._getLocalAncestors(id);
        if (!ancestors) {
            const response = await this._frameioInterface.getAncestors(id);
            const session = this._objectPool.createUpdateSession();
            // IFrameioAssetResponse is a special case, as it corresponds to multiple classes
            // inheriting from FrameioAsset ( FrameioFile, FrameioFolder, FrameioVersionStack ),
            // so use a utility function to select the correct updater for the type.
            //
            // See also FrameioFolder.getChildren()
            ancestors = response.map((asset) => frameioAssetUpdater(session, asset));
            session.commit();
        }
        return ancestors;
    }
    async getReviewLinksForDocument(source, refresh = true) {
        const key = this._mapKeyForSourceDocument(source);
        const weak = this._reviewLinksForDocument.get(key);
        let result = weak ? weak.deref() : undefined;
        if (!refresh && result) {
            this._retainUntilTimeout(weak); // non-null result means weak is also non-null
            return result; // return cached result
        }
        // compute result from scratch
        result = [];
        // The Review Service maintains a database of FrameioReview links we've
        // created maintained by our calls to ReviewServiceInterface.createReviewLinks()
        // and ReviewServiceInterface.updateReviewLinks().
        // Get the list of review links
        const reviews = await this._reviewServiceInterface.getReviewLinks(source);
        // I'm uncertain of the list ordering, so sort it by date.
        reviews.sort((a, b) => (b['repo:createdDate'] - a['repo:createdDate']));
        // The id's associated with a review link may no longer be valid
        // ( i.e. the link has been deleted ) or not currently valid
        // ( i.e. we've logged into the wrong account ), so we need
        // to filter the list to only containing currently valid
        // review links.
        //
        // NOTE: As we cannot distinquish between no longer valid and
        // not currently valid, it's not safe to
        // ReviewServiceInterface.deleteReviewLinks() to clean up the
        // list.
        for (let i = 0; i < reviews.length; i++) {
            const review = reviews[i];
            const projectId = review['frameio:projectId'];
            const reviewLinkId = review['frameio:reviewLinkId'];
            const itemId = review['frameio:artifactId'];
            const etag = review['repo:etag'];
            // review is valid if we can obtain a reviewLink using reviewLinkId,
            // and we can obtain an item using itemId.
            //
            // ShareSheet potentially shows toast when the most recent reviewLinks
            // are invalid, so we push FrameioReviewLinkForDocumentError into
            // result when there's an error validating review.
            //
            // Because validation is expensive, and because reviews[] grows
            // unbounded, and because ShareSheet only cares whether there is
            // 0 or 1 valid reviews, we stop after adding a valid reviewLink
            // to result.
            let reviewLink = undefined;
            // obtain the reviewLink directly from Frame.io
            try {
                const response = await this._frameioInterface.getReviewLink(reviewLinkId);
                const session = this._objectPool.createUpdateSession();
                reviewLink = FrameioReviewLinkUpdater.updateRemoteItem(session, response);
                session.commit();
            }
            catch (e) {
                // we expect it to throw when a review has been disabled.
            }
            try {
                if (!reviewLink) {
                    // disabled reviewLink's are known to throw 403 errors,
                    // so as a fallback, try to get the project, the project's
                    // list of reviewLinks, and find reviewLinkId in the list
                    // (disabled reviewLink's are known to be reachable this way)
                    // project is cached in the object pool,
                    // and project._reviewLinks is memoized,
                    // so although we are in a loop,
                    // each method should never hit the network more than once.
                    const project = await this.getProject(projectId);
                    const reviewLinks = await project.getReviewLinks();
                    reviewLink = reviewLinks.find(({ id }) => (id === reviewLinkId));
                }
                if (reviewLink) {
                    // Copy data that's on the Review Service and not Frame.io
                    // into the reviewLink.
                    reviewLink['_itemId'] = itemId;
                    reviewLink['_etag'] = etag;
                    // getItem() rejects when itemId isn't valid.
                    await reviewLink.getItem();
                    result.push({ reviewLink });
                    break;
                }
                else {
                    const error = SAMError.create(SAMErrorCode.NOT_FOUND, `frameio:reviewLinkId = ${reviewLinkId} not found in projectId = ${projectId}`);
                    result.push({ error });
                }
            }
            catch (e) {
                const error = e;
                result.push({ error });
            }
        }
        const ref = new WeakRef(result);
        // cache the newly computed result
        this._reviewLinksForDocument.set(key, ref);
        this._retainUntilTimeout(ref);
        return result;
    }
    async getAccount(id) {
        const accounts = await this.getAccounts();
        let account = accounts.find(element => (element.id === id));
        if (!account) {
            const response = await this._frameioInterface.getAccount(id);
            const session = this._objectPool.createUpdateSession();
            account = FrameioAccountUpdater.updateRemoteItem(session, response);
            session.commit();
        }
        return account;
    }
    async getAsset(id) {
        // avoid server call for local asset
        let asset = this._objectPool.getLocalItemById(id);
        if (!asset) {
            // fetch remote asset with a server call
            const response = await this._frameioInterface.getAsset(id);
            const session = this._objectPool.createUpdateSession();
            asset = frameioAssetUpdater(session, response);
            session.commit();
        }
        return asset;
    }
    async getTeam(id) {
        // avoid server call for local asset
        let team = this._objectPool.getLocalItemById(id);
        if (!team) {
            // fetch remote asset with a server call
            const response = await this._frameioInterface.getTeam(id);
            const session = this._objectPool.createUpdateSession();
            team = FrameioTeamUpdater.updateRemoteItem(session, response);
            session.commit();
        }
        return team;
    }
    async getProject(id) {
        // avoid server call for local asset
        let project = this._objectPool.getLocalItemById(id);
        if (!project) {
            // fetch remote asset with a server call
            const response = await this._frameioInterface.getProject(id);
            const session = this._objectPool.createUpdateSession();
            project = FrameioProjectUpdater.updateRemoteItem(session, response);
            session.commit();
        }
        return project;
    }
    async getComment(id) {
        // avoid server call for local asset
        let comment = this._objectPool.getLocalItemById(id);
        if (!comment) {
            // fetch remote asset with a server call
            const response = await this._frameioInterface.getComment(id);
            const session = this._objectPool.createUpdateSession();
            comment = FrameioCommentUpdater.updateRemoteItem(session, response);
            session.commit();
        }
        return comment;
    }
    async getAdobeSusiInfo() {
        return await this._frameioInterface.getAdobeSusiInfo();
    }
}
__decorate([
    keepAlive
], FrameioContext.prototype, "getAsset", null);
function frameioAssetUpdater(session, asset) {
    // frame.io multiplexes asset.type's 'file', 'folder', 'version_stack' and 'bundle' into IFrameioAssetResponse,
    // but we have separate FrameioFile, FrameioFolder, FrameioVersionStack classes that inherit from FrameioAsset.
    if (asset.type === 'file') {
        const fileSession = session;
        return FrameioFileUpdater.updateRemoteItem(fileSession, asset);
    }
    else if (asset.type === 'folder') {
        const folderSession = session;
        return FrameioFolderUpdater.updateRemoteItem(folderSession, asset);
    }
    else if (asset.type === 'version_stack') {
        const versionStackSession = session;
        return FrameioVersionStackUpdater.updateRemoteItem(versionStackSession, asset);
    }
    throw SAMError.create(SAMErrorCode.UNSUPPORTED, `Invalid Frameio asset type ${asset.type}`);
}

var FrameioContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': FrameioContext,
    frameioAssetUpdater: frameioAssetUpdater
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const AssignmentTaskIDEnums = AssignmentTaskIDEnums$1;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$2 = function(d, b) {
    extendStatics$2 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$2(d, b);
};

function __extends$3(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics$2(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$5 = function() {
    __assign$5 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$5.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray$5(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$2(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var genericMessage = "Invariant Violation";
var _a$2 = Object.setPrototypeOf, setPrototypeOf = _a$2 === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a$2;
var InvariantError = /** @class */ (function (_super) {
    __extends$2(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant$3(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant$3 || (invariant$3 = {}));

var version = "3.11.8";

function maybe$1(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}

var global$1 = (maybe$1(function () { return globalThis; }) ||
    maybe$1(function () { return window; }) ||
    maybe$1(function () { return self; }) ||
    maybe$1(function () { return global; }) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
maybe$1(function () {
    return maybe$1.constructor("return this")();
}));

var prefixCounts = new Map();
// These IDs won't be globally unique, but they will be unique within this
// process, thanks to the counter, and unguessable thanks to the random suffix.
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

function stringifyForDisplay(value, space) {
    if (space === void 0) { space = 0; }
    var undefId = makeUniqueId("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }, space)
        .split(JSON.stringify(undefId))
        .join("<undefined>");
}

function wrap$2(fn) {
    return function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof message === "number") {
            var arg0 = message;
            message = getHandledErrorMsg(arg0);
            if (!message) {
                message = getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [message].concat(args));
    };
}
var invariant$2 = Object.assign(function invariant(condition, message) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (!condition) {
        invariant$3(condition, getHandledErrorMsg(message, args) || getFallbackErrorMsg(message, args));
    }
}, {
    debug: wrap$2(invariant$3.debug),
    log: wrap$2(invariant$3.log),
    warn: wrap$2(invariant$3.warn),
    error: wrap$2(invariant$3.error),
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */
function newInvariantError(message) {
    var optionalParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        optionalParams[_i - 1] = arguments[_i];
    }
    return new InvariantError(getHandledErrorMsg(message, optionalParams) ||
        getFallbackErrorMsg(message, optionalParams));
}
var ApolloErrorMessageHandler = Symbol.for("ApolloErrorMessageHandler_" + version);
function stringify(arg) {
    if (typeof arg == "string") {
        return arg;
    }
    try {
        return stringifyForDisplay(arg, 2).slice(0, 1000);
    }
    catch (_a) {
        return "<non-serializable>";
    }
}
function getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) { messageArgs = []; }
    if (!message)
        return;
    return (global$1[ApolloErrorMessageHandler] &&
        global$1[ApolloErrorMessageHandler](message, messageArgs.map(stringify)));
}
function getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) { messageArgs = []; }
    if (!message)
        return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: version,
        message: message,
        args: messageArgs.map(stringify),
    })));
}

function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

function invariant$1(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant$1(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));
/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));
/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */

/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && isWhiteSpace(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || isWhiteSpace(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && isWhiteSpace(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(TokenKind || (TokenKind = {}));
/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === TokenKind.BANG ||
    kind === TokenKind.DOLLAR ||
    kind === TokenKind.AMP ||
    kind === TokenKind.PAREN_L ||
    kind === TokenKind.PAREN_R ||
    kind === TokenKind.SPREAD ||
    kind === TokenKind.COLON ||
    kind === TokenKind.EQUALS ||
    kind === TokenKind.AT ||
    kind === TokenKind.BRACKET_L ||
    kind === TokenKind.BRACKET_R ||
    kind === TokenKind.BRACE_L ||
    kind === TokenKind.PIPE ||
    kind === TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new Token(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if (isDigit(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if (isNameStart(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if (isDigit(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || isNameStart(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? TokenKind.FLOAT : TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while (isDigit(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        dedentBlockStringLines(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if (isNameContinue(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

/* c8 ignore next 3 */

const isProduction =
  globalThis.process && // eslint-disable-next-line no-undef
  process.env.NODE_ENV === 'production';
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  isProduction
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = inspect(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      devAssert(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      devAssert(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}

/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse$1(source, options) {
  const parser = new Parser$1(source, options);
  return parser.parseDocument();
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser$1 {
  constructor(source, options = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(TokenKind.NAME);
    return this.node(token, {
      kind: Kind.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Kind.DOCUMENT,
      definitions: this.many(
        TokenKind.SOF,
        this.parseDefinition,
        TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return OperationTypeNode.QUERY;

      case 'mutation':
        return OperationTypeNode.MUTATION;

      case 'subscription':
        return OperationTypeNode.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseVariableDefinition,
      TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return this.node(start, {
      kind: Kind.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Kind.SELECTION_SET,
      selections: this.many(
        TokenKind.BRACE_L,
        this.parseSelection,
        TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return this.node(start, {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.INT,
          value: token.value,
        });

      case TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.FLOAT,
          value: token.value,
        });

      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: Kind.NULL,
            });

          default:
            return this.node(token, {
              kind: Kind.ENUM,
              value: token.value,
            });
        }

      case TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(TokenKind.DOLLAR);

          if (this._lexer.token.kind === TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return this.node(start, {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: Kind.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(TokenKind.BANG)) {
      return this.node(start, {
        kind: Kind.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseFieldDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseInputValueDef,
      TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS)
      ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseInputValueDef,
      TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new Location(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== TokenKind.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = QueryDocumentKeys) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(Kind)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      isNode(node) || devAssert(false, `Invalid AST Node: ${inspect(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if (isNode(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print$1(ast) {
  return visit(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap$1('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap$1(' = ', defaultValue) +
      wrap$1(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap$1('', alias, ': ') + name;
      let argsLine = prefix + wrap$1('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap$1('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap$1(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap$1('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap$1('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap$1('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? printBlockString(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap$1('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap$1('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap$1('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap$1('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap$1('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap$1('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap$1('(\n', indent(join(args, '\n')), '\n)')
        : wrap$1('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap$1(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap$1('', description, '\n') +
      join(
        [name + ': ' + type, wrap$1('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap$1('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap$1('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap$1('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap$1('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap$1('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap$1('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap$1('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap$1('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap$1('(\n', indent(join(args, '\n')), '\n)')
        : wrap$1('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap$1('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap$1('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap$1('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap$1('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap$1(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap$1('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

function isSelectionNode(node) {
  return (
    node.kind === Kind.FIELD ||
    node.kind === Kind.FRAGMENT_SPREAD ||
    node.kind === Kind.INLINE_FRAGMENT
  );
}

function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue =
                variables && variables[ifArgument.value.name.value];
            invariant$2(evaledValue !== void 0, 70, directive.name.value);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    visit(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) {
                return BREAK;
            }
        },
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(["client", "export"], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            invariant$2(directiveArguments && directiveArguments.length === 1, 71, directiveName);
            var ifArgument = directiveArguments[0];
            invariant$2(ifArgument.name && ifArgument.name.value === "if", 72, directiveName);
            var ifValue = ifArgument.value;
            // means it has to be a variable value if this is a valid @skip or @include directive
            invariant$2(ifValue &&
                (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 73, directiveName);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}

// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData$1 = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: forEach$1, slice: slice$1 } = Array.prototype;
const { hasOwnProperty: hasOwnProperty$7 } = Object.prototype;
class Trie$1 {
    constructor(weakness = true, makeData = defaultMakeData$1) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        forEach$1.call(array, key => node = node.getChildTrie(key));
        return hasOwnProperty$7.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice$1.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray(slice$1.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) {
                    map.delete(head);
                }
            }
        }
        else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie$1(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && isObjRef$1(key)
            ? this.weak || (create ? this.weak = new WeakMap : void 0)
            : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function isObjRef$1(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

var isReactNative = maybe$1(function () { return navigator.product; }) == "ReactNative";
var canUseWeakMap = typeof WeakMap === "function" &&
    !(isReactNative && !global.HermesInternal);
var canUseWeakSet = typeof WeakSet === "function";
var canUseSymbol = typeof Symbol === "function" && typeof Symbol.for === "function";
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
typeof maybe$1(function () { return window.document.createElement; }) === "function";
// Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
maybe$1(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;

function isNonNullObject(obj) {
    return obj !== null && typeof obj === "object";
}

/**
 * Returns a query document which adds a single query operation that only
 * spreads the target fragment inside of it.
 *
 * So for example a document of:
 *
 * ```graphql
 * fragment foo on Foo { a b c }
 * ```
 *
 * Turns into:
 *
 * ```graphql
 * { ...foo }
 *
 * fragment foo on Foo { a b c }
 * ```
 *
 * The target fragment will either be the only fragment in the document, or a
 * fragment specified by the provided `fragmentName`. If there is more than one
 * fragment, but a `fragmentName` was not defined then an error will be thrown.
 */
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function (definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") {
            throw newInvariantError(
                74,
                definition.operation,
                definition.name ? " named '".concat(definition.name.value, "'") : ""
            );
        }
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") {
            fragments.push(definition);
        }
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        invariant$2(fragments.length === 1, 75, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = __assign$5(__assign$5({}, document), { definitions: __spreadArray$5([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
// Utility function that takes a list of fragment definitions and makes a hash out of them
// that maps the name of the fragment to the fragment definition.
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case "InlineFragment":
            return selection;
        case "FragmentSpread": {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            invariant$2(fragment, 76, fragmentName);
            return fragment || null;
        }
        default:
            return null;
    }
}

function defaultDispose$1() { }
class StrongCache {
    constructor(max = Infinity, dispose = defaultDispose$1) {
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key,
            value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

function noop() { }
const defaultDispose = noop;
const _WeakRef = typeof WeakRef !== "undefined"
    ? WeakRef
    : function (value) {
        return { deref: () => value };
    };
const _WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const _FinalizationRegistry = typeof FinalizationRegistry !== "undefined"
    ? FinalizationRegistry
    : function () {
        return {
            register: noop,
            unregister: noop,
        };
    };
const finalizationBatchSize = 10024;
class WeakCache {
    constructor(max = Infinity, dispose = defaultDispose) {
        this.max = max;
        this.dispose = dispose;
        this.map = new _WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = () => {
            const iterator = this.unfinalizedNodes.values();
            for (let i = 0; i < finalizationBatchSize; i++) {
                const node = iterator.next().value;
                if (!node)
                    break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new _WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) {
                queueMicrotask(this.finalize);
            }
            else {
                this.finalizationScheduled = false;
            }
        };
        this.registry = new _FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) {
            return (node.value = value);
        }
        node = {
            key,
            value,
            newer: null,
            older: this.newest,
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while (this.oldest && this.size > this.max) {
            this.deleteNode(this.oldest);
        }
    }
    deleteNode(node) {
        if (node === this.newest) {
            this.newest = node.older;
        }
        if (node === this.oldest) {
            this.oldest = node.newer;
        }
        if (node.newer) {
            node.newer.older = node.older;
        }
        if (node.older) {
            node.older.newer = node.newer;
        }
        this.size--;
        const key = node.key || (node.keyRef && node.keyRef.deref());
        this.dispose(node.value, key);
        if (!node.keyRef) {
            this.unfinalizedNodes.delete(node);
        }
        else {
            this.registry.unregister(node);
        }
        if (key)
            this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}

var scheduledCleanup = new WeakSet();
function schedule(cache) {
    if (cache.size <= (cache.max || -1)) {
        return;
    }
    if (!scheduledCleanup.has(cache)) {
        scheduledCleanup.add(cache);
        setTimeout(function () {
            cache.clean();
            scheduledCleanup.delete(cache);
        }, 100);
    }
}
/**
 * @internal
 * A version of WeakCache that will auto-schedule a cleanup of the cache when
 * a new item is added and the cache reached maximum size.
 * Throttled to once per 100ms.
 *
 * @privateRemarks
 * Should be used throughout the rest of the codebase instead of WeakCache,
 * with the notable exception of usage in `wrap` from `optimism` - that one
 * already handles cleanup and should remain a `WeakCache`.
 */
var AutoCleanedWeakCache = function (max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */
    var cache = new WeakCache(max, dispose);
    cache.set = function (key, value) {
        var ret = WeakCache.prototype.set.call(this, key, value);
        schedule(this);
        return ret;
    };
    return cache;
};
/**
 * @internal
 * A version of StrongCache that will auto-schedule a cleanup of the cache when
 * a new item is added and the cache reached maximum size.
 * Throttled to once per 100ms.
 *
 * @privateRemarks
 * Should be used throughout the rest of the codebase instead of StrongCache,
 * with the notable exception of usage in `wrap` from `optimism` - that one
 * already handles cleanup and should remain a `StrongCache`.
 */
var AutoCleanedStrongCache = function (max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */
    var cache = new StrongCache(max, dispose);
    cache.set = function (key, value) {
        var ret = StrongCache.prototype.set.call(this, key, value);
        schedule(this);
        return ret;
    };
    return cache;
};

var cacheSizeSymbol = Symbol.for("apollo.cacheSize");
/**
 *
 * The global cache size configuration for Apollo Client.
 *
 * @remarks
 *
 * You can directly modify this object, but any modification will
 * only have an effect on caches that are created after the modification.
 *
 * So for global caches, such as `parser`, `canonicalStringify` and `print`,
 * you might need to call `.reset` on them, which will essentially re-create them.
 *
 * Alternatively, you can set `globalThis[Symbol.for("apollo.cacheSize")]` before
 * you load the Apollo Client package:
 *
 * @example
 * ```ts
 * globalThis[Symbol.for("apollo.cacheSize")] = {
 *   parser: 100
 * } satisfies Partial<CacheSizes> // the `satisfies` is optional if using TypeScript
 * ```
 */
var cacheSizes = __assign$5({}, global$1[cacheSizeSymbol]);

var globalCaches = {};
function registerGlobalCache(name, getSize) {
    globalCaches[name] = getSize;
}
/**
 * For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
 * @internal
 */
var getApolloClientMemoryInternals = globalThis.__DEV__ !== false ?
    _getApolloClientMemoryInternals
    : undefined;
/**
 * For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
 * @internal
 */
var getInMemoryCacheMemoryInternals = globalThis.__DEV__ !== false ?
    _getInMemoryCacheMemoryInternals
    : undefined;
/**
 * For internal purposes only - please call `ApolloClient.getMemoryInternals` instead
 * @internal
 */
var getApolloCacheMemoryInternals = globalThis.__DEV__ !== false ?
    _getApolloCacheMemoryInternals
    : undefined;
function getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */,
        print: 2000 /* defaultCacheSizes["print"] */,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */,
    };
    return Object.fromEntries(Object.entries(defaults).map(function (_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            cacheSizes[k] || v,
        ];
    }));
}
function _getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false))
        throw new Error("only supported in development mode");
    return {
        limits: getCurrentCacheSizes(),
        sizes: __assign$5({ print: (_a = globalCaches.print) === null || _a === void 0 ? void 0 : _a.call(globalCaches), parser: (_b = globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call(globalCaches), canonicalStringify: (_c = globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call(globalCaches), links: linkInfo(this.link), queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: transformInfo(this["queryManager"].documentTransform),
            } }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d)),
    };
}
function _getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: getWrapperInformation(this["getFragmentDoc"]),
        },
    };
}
function _getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return __assign$5(__assign$5({}, _getApolloCacheMemoryInternals.apply(this)), { addTypenameDocumentTransform: transformInfo(this["addTypenameTransform"]), inMemoryCache: {
            executeSelectionSet: getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: getWrapperInformation(this["maybeBroadcastWatch"]),
        }, fragmentRegistry: {
            findFragmentSpreads: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform),
        } });
}
function isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function getWrapperInformation(f) {
    return isWrapper(f) ? f.size : undefined;
}
function isDefined(value) {
    return value != null;
}
function transformInfo(transform) {
    return recurseTransformInfo(transform).map(function (cache) { return ({ cache: cache }); });
}
function recurseTransformInfo(transform) {
    return transform ?
        __spreadArray$5(__spreadArray$5([
            getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
        ], recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter(isDefined)
        : [];
}
function linkInfo(link) {
    var _a;
    return link ?
        __spreadArray$5(__spreadArray$5([
            (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
        ], linkInfo(link === null || link === void 0 ? void 0 : link.left), true), linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter(isDefined)
        : [];
}

/**
 * Like JSON.stringify, but with object keys always sorted in the same order.
 *
 * To achieve performant sorting, this function uses a Map from JSON-serialized
 * arrays of keys (in any order) to sorted arrays of the same keys, with a
 * single sorted array reference shared by all permutations of the keys.
 *
 * As a drawback, this function will add a little bit more memory for every
 * object encountered that has different (more, less, a different order of) keys
 * than in the past.
 *
 * In a typical application, this extra memory usage should not play a
 * significant role, as `canonicalStringify` will be called for only a limited
 * number of object shapes, and the cache will not grow beyond a certain point.
 * But in some edge cases, this could be a problem, so we provide
 * canonicalStringify.reset() as a way of clearing the cache.
 * */
var canonicalStringify = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, stableObjectReplacer);
}, {
    reset: function () {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        sortingMap = new AutoCleanedStrongCache(cacheSizes.canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */);
    },
});
if (globalThis.__DEV__ !== false) {
    registerGlobalCache("canonicalStringify", function () { return sortingMap.size; });
}
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var sortingMap;
canonicalStringify.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every(everyKeyInOrder))
                return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = sortingMap.get(sortedKey) || keys;
                sortingMap.set(unsortedKey, sortedKeys);
                sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function (key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}

function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function isDocumentNode(value) {
    return (isNonNullObject(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === "StringValue";
}
function isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function isIntValue(value) {
    return value.kind === "IntValue";
}
function isFloatValue(value) {
    return value.kind === "FloatValue";
}
function isVariable(value) {
    return value.kind === "Variable";
}
function isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function isListValue(value) {
    return value.kind === "ListValue";
}
function isEnumValue(value) {
    return value.kind === "EnumValue";
}
function isNullValue(value) {
    return value.kind === "NullValue";
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw newInvariantError(85, name.value, value.kind);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive",
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var storeKeyNameStringify = canonicalStringify;
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives["connection"] &&
        directives["connection"]["key"]) {
        if (directives["connection"]["filter"] &&
            directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ?
                directives["connection"]["filter"]
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat(storeKeyNameStringify(filteredArgs_1), ")");
        }
        else {
            return directives["connection"]["key"];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(storeKeyNameStringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = storeKeyNameStringify;
        storeKeyNameStringify = s;
        return previous;
    },
});
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    var fragments;
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (isField(selection)) {
            if (selection.name.value === "__typename") {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else if (fragments) {
            fragments.push(selection);
        }
        else {
            fragments = [selection];
        }
    }
    if (typeof result.__typename === "string") {
        return result.__typename;
    }
    if (fragments) {
        for (var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++) {
            var selection = fragments_1[_b];
            var typename = getTypenameFromResult(result, getFragmentFromSelection(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === "string") {
                return typename;
            }
        }
    }
}
function isField(selection) {
    return selection.kind === "Field";
}
function isInlineFragment(selection) {
    return selection.kind === "InlineFragment";
}

// Checks the document for errors and throws an exception if there is an error.
function checkDocument(doc) {
    invariant$2(doc && doc.kind === "Document", 77);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== "FragmentDefinition"; })
        .map(function (definition) {
        if (definition.kind !== "OperationDefinition") {
            throw newInvariantError(78, definition.kind);
        }
        return definition;
    });
    invariant$2(operations.length <= 1, 79, operations.length);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
// Returns the FragmentDefinitions from a particular document as an array
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    invariant$2(queryDef && queryDef.operation === "query", 80);
    return queryDef;
}
function getFragmentDefinition(doc) {
    invariant$2(doc.kind === "Document", 81);
    invariant$2(doc.definitions.length <= 1, 82);
    var fragmentDef = doc.definitions[0];
    invariant$2(fragmentDef.kind === "FragmentDefinition", 83);
    return fragmentDef;
}
/**
 * Returns the first operation definition found in this document.
 * If no operation definition is found, the first fragment definition will be returned.
 * If no definitions are found, an error will be thrown.
 */
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" ||
                operation === "mutation" ||
                operation === "subscription") {
                return definition;
            }
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) {
            // we do this because we want to allow multiple fragment definitions
            // to precede an operation definition.
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw newInvariantError(84);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                valueToObjectRepresentation(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}

// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty: hasOwnProperty$6 } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, key => node = node.getChildTrie(key));
        return hasOwnProperty$6.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = this.weakness && isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
}
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const MISSING_VALUE = {};
let idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const makeSlotClass = () => class Slot {
    constructor() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    hasValue() {
        for (let context = currentContext; context; context = context.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    }
    getValue() {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    }
    withValue(value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        const slots = {
            __proto__: null,
            [this.id]: value,
        };
        const parent = currentContext;
        currentContext = { parent, slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    }
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    static bind(callback) {
        const context = currentContext;
        return function () {
            const saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    }
    // Immediately run a callback function without any captured context.
    static noContext(callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            const saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    }
};
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const globalKey = "@wry/context:Slot";
const host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(() => globalThis) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(() => global) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const globalHost = host;
const Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());

const parentEntrySlot = new Slot();

const { hasOwnProperty: hasOwnProperty$5, } = Object.prototype;
const arrayFromSet = Array.from ||
    function (set) {
        const array = [];
        set.forEach(item => array.push(item));
        return array;
    };
function maybeUnsubscribe(entryOrDep) {
    const { unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

const emptySetPool = [];
const POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    const len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
class Entry {
    constructor(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    peek() {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    }
    setDirty() {
        if (this.dirty)
            return;
        this.dirty = true;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, (parent, child) => {
            parent.setDirty();
            forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            arrayFromSet(this.deps).forEach(dep => dep.delete(this));
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
Entry.count = 0;
function rememberParent(child) {
    const parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) {
        oldValueCopy = valueCopy(entry.value);
    }
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !valueIs(oldValueCopy, entry.value)) {
            try {
                entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
            }
            catch (_a) {
                // If normalizeResult throws, just use the newer value, rather than
                // saving the exception as entry.value[1].
            }
        }
    }
    catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = arrayFromSet(child.parents);
        for (let i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    const parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach((_value, child) => {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

const EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true, // Fully remove parent Entry from LRU cache and computation graph
};
function dep(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = parentEntrySlot.getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) {
                depsByKey.set(key, dep = new Set);
            }
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = (entryMethodName &&
                hasOwnProperty$5.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            arrayFromSet(dep).forEach(entry => entry[m]());
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let defaultKeyTrie;
function defaultMakeCacheKey(...args) {
    const trie = defaultKeyTrie || (defaultKeyTrie = new Trie(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const caches = new Set();
function wrap(originalFunction, { max = Math.pow(2, 16), keyArgs, makeCacheKey = defaultMakeCacheKey, normalizeResult, subscribe, cache: cacheOption = StrongCache, } = Object.create(null)) {
    const cache = typeof cacheOption === "function"
        ? new cacheOption(max, entry => entry.dispose())
        : cacheOption;
    const optimistic = function () {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = () => cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(cache => cache.clean());
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: () => cache.size,
        configurable: false,
        enumerable: false,
    });
    Object.freeze(optimistic.options = {
        max,
        keyArgs,
        makeCacheKey,
        normalizeResult,
        subscribe,
        cache,
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}

function identity(document) {
    return document;
}
var DocumentTransform = /** @class */ (function () {
    function DocumentTransform(transform, options) {
        if (options === void 0) { options = Object.create(null); }
        this.resultCache = canUseWeakSet ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) {
            // Override default `getCacheKey` function, which returns [document].
            this.getCacheKey = options.getCacheKey;
        }
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function (document) {
        return [document];
    };
    DocumentTransform.identity = function () {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform(identity, { cache: false });
    };
    DocumentTransform.split = function (predicate, left, right) {
        if (right === void 0) { right = DocumentTransform.identity(); }
        return Object.assign(new DocumentTransform(function (document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, 
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: false }), { left: left, right: right });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */
    DocumentTransform.prototype.resetCache = function () {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new Trie$1(canUseWeakMap);
            this.performWork = wrap(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function (document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        invariant$2(Array.isArray(cacheKeys), 69);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: cacheSizes["documentTransform.cache"],
                cache: (WeakCache),
            });
        }
    };
    DocumentTransform.prototype.performWork = function (document) {
        checkDocument(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function (document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) {
            return document;
        }
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function (otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function (document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, 
        // Reasonably assume both transforms handle their own caching
        { cache: false }), {
            left: this,
            right: otherTransform,
        });
    };
    return DocumentTransform;
}());

var printCache;
var print = Object.assign(function (ast) {
    var result = printCache.get(ast);
    if (!result) {
        result = print$1(ast);
        printCache.set(ast, result);
    }
    return result;
}, {
    reset: function () {
        printCache = new AutoCleanedWeakCache(cacheSizes.print || 2000 /* defaultCacheSizes.print */);
    },
});
print.reset();
if (globalThis.__DEV__ !== false) {
    registerGlobalCache("print", function () { return (printCache ? printCache.size : 0); });
}

// A version of Array.isArray that works better with readonly arrays.
var isArray = Array.isArray;
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}

var TYPENAME_FIELD = {
    kind: Kind.FIELD,
    name: {
        kind: Kind.NAME,
        value: "__typename",
    },
};
function isEmpty(op, fragmentMap) {
    return (!op ||
        op.selectionSet.selections.every(function (selection) {
            return selection.kind === Kind.FRAGMENT_SPREAD &&
                isEmpty(fragmentMap[selection.name.value], fragmentMap);
        }));
}
function nullIfDocIsEmpty(doc) {
    return (isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))) ?
        null
        : doc;
}
function getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function (directive) {
        if (directive) {
            if (directive.name) {
                names.set(directive.name, directive);
            }
            else if (directive.test) {
                tests.set(directive.test, directive);
            }
        }
    });
    return function (directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) {
            tests.forEach(function (testConfig, test) {
                if (test(directive)) {
                    config = testConfig;
                }
            });
        }
        return config;
    };
}
function makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) { key = defaultKey; }
        var inUse = map.get(key);
        if (!inUse) {
            map.set(key, (inUse = {
                // Variable and fragment spread names used directly within this
                // operation or fragment definition, as identified by key. These sets
                // will be populated during the first traversal of the document in
                // removeDirectivesFromDocument below.
                variables: new Set(),
                fragmentSpreads: new Set(),
            }));
        }
        return inUse;
    };
}
function removeDirectivesFromDocument(directives, doc) {
    checkDocument(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = makeInUseGetterFunction("");
    var getInUseByFragmentName = makeInUseGetterFunction("");
    var getInUse = function (ancestors) {
        for (var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p) {
            if (isArray(ancestor))
                continue;
            if (ancestor.kind === Kind.OPERATION_DEFINITION) {
                // If an operation is anonymous, we use the empty string as its key.
                return getInUseByOperationName(ancestor.name && ancestor.name.value);
            }
            if (ancestor.kind === Kind.FRAGMENT_DEFINITION) {
                return getInUseByFragmentName(ancestor.name.value);
            }
        }
        globalThis.__DEV__ !== false && invariant$2.error(86);
        return null;
    };
    var operationCount = 0;
    for (var i = doc.definitions.length - 1; i >= 0; --i) {
        if (doc.definitions[i].kind === Kind.OPERATION_DEFINITION) {
            ++operationCount;
        }
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var shouldRemoveField = function (nodeDirectives) {
        return isNonEmptyArray(nodeDirectives) &&
            nodeDirectives
                .map(directiveMatcher)
                .some(function (config) { return config && config.remove; });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function (node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        },
    };
    var docWithoutDirectiveSubtrees = visit(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function () {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            },
        },
        Variable: {
            enter: function (node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.variables.add(node.name.value);
                }
            },
        },
        FragmentSpread: {
            enter: function (node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.fragmentSpreads.add(node.name.value);
                }
                // We might like to remove this FragmentSpread by returning null here if
                // the corresponding FragmentDefinition node is also going to be removed
                // by the logic below, but we can't control the relative order of those
                // events, so we have to postpone the removal of dangling FragmentSpread
                // nodes until after the current visit of the document has finished.
            },
        },
        FragmentDefinition: {
            enter: function (node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function (node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) {
                    // If the FragmentNode received by this leave function is identical to
                    // the one received by the corresponding enter function (above), then
                    // the visitor must not have made any changes within this
                    // FragmentDefinition node. This fragment definition may still be
                    // removed if there are no ...spread references to it, but it won't be
                    // removed just because it has only a __typename field.
                    return node;
                }
                if (
                // This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 &&
                    node.selectionSet.selections.every(function (selection) {
                        return selection.kind === Kind.FIELD &&
                            selection.name.value === "__typename";
                    })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
        Directive: {
            leave: function (node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
    });
    if (!firstVisitMadeChanges) {
        // If our first pass did not change anything about the document, then there
        // is no cleanup we need to do, and we can return the original doc.
        return doc;
    }
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function (inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) {
                inUse.fragmentSpreads.forEach(function (childFragmentName) {
                    populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function (varName) {
                        inUse.transitiveVars.add(varName);
                    });
                });
            }
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function (def) {
        if (def.kind === Kind.OPERATION_DEFINITION) {
            populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function (childFragmentName) {
                allFragmentNamesUsed.add(childFragmentName);
            });
        }
        else if (def.kind === Kind.FRAGMENT_DEFINITION &&
            // If there are no operations in the document, then all fragment
            // definitions count as usages of their own fragment names. This heuristic
            // prevents accidentally removing all fragment definitions from the
            // document just because it contains no operations that use the fragments.
            operationCount === 0 &&
            !getInUseByFragmentName(def.name.value).removed) {
            allFragmentNamesUsed.add(def.name.value);
        }
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function (fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function (childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function (fragmentName) {
        return !!(
        // A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) ||
            getInUseByFragmentName(fragmentName).removed));
    };
    var enterVisitor = {
        enter: function (node) {
            if (fragmentWillBeRemoved(node.name.value)) {
                return null;
            }
        },
    };
    return nullIfDocIsEmpty(visit(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function (node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(
                    // If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) {
                        return __assign$5(__assign$5({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                                return usedVariableNames_1.has(varDef.variable.name.value);
                            }) });
                    }
                }
            },
        },
    }));
}
var addTypenameToDocument = Object.assign(function (doc) {
    return visit(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent &&
                    parent.kind ===
                        Kind.OPERATION_DEFINITION) {
                    return;
                }
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function (selection) {
                    return (isField(selection) &&
                        (selection.name.value === "__typename" ||
                            selection.name.value.lastIndexOf("__", 0) === 0));
                });
                if (skip) {
                    return;
                }
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if (isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === "export"; })) {
                    return;
                }
                // Create and return a new SelectionSet with a __typename Field.
                return __assign$5(__assign$5({}, node), { selections: __spreadArray$5(__spreadArray$5([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
// If the incoming document is a query, return it as is. Otherwise, build a
// new document containing a query operation based on the selection set
// of the previous main operation.
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") {
        // Already a query, so return the existing document.
        return document;
    }
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = visit(document, {
        OperationDefinition: {
            enter: function (node) {
                return __assign$5(__assign$5({}, node), { operation: "query" });
            },
        },
    });
    return modifiedDoc;
}
// Remove fields / selection sets that include an @client directive.
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === "client"; },
            remove: true,
        },
    ], document);
    return modifiedDoc;
}

var hasOwnProperty$4 = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
// In almost any situation where you could succeed in getting the
// TypeScript compiler to infer a tuple type for the sources array, you
// could just use mergeDeep instead of mergeDeepArray, so instead of
// trying to convert T[] to an intersection type we just infer the array
// element type, which works perfectly when the sources array has a
// consistent element type.
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = /** @class */ (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = isNonNullObject;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if (isNonNullObject(source) && isNonNullObject(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (hasOwnProperty$4.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, __spreadArray$5([target,
                            source,
                            sourceKey], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if (isNonNullObject(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = __assign$5({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {

			if (typeof Symbol.for === 'function') {
				// This just needs to be something that won't trample other user's Symbol.for use
				// It also will guide people to the source of their issues, if this is problematic.
				// META: It's a resource locator!
				result = Symbol.for('https://github.com/benlesh/symbol-observable');
			} else {
				// Symbol.for didn't exist! The best we can do at this point is a totally 
				// unique symbol. Note that the string argument here is a descriptor, not
				// an identifier. This symbol is unique.
				result = Symbol('https://github.com/benlesh/symbol-observable');
			}
			try {
				Symbol.observable = result;
			} catch (err) {
				// Do nothing. In some environments, users have frozen `Symbol` for security reasons,
				// if it is frozen assigning to it will throw. In this case, we don't care, because
				// they will need to use the returned value from the ponyfill.
			}
		}
	} else {
		result = '@@observable';
	}

	return result;
}

/* global window */

var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

symbolObservablePonyfill(root);

// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var prototype = Observable.prototype;
var fakeObsSymbol = "@@observable";
if (!prototype[fakeObsSymbol]) {
    // @ts-expect-error
    prototype[fakeObsSymbol] = function () {
        return this;
    };
}

var toString$1 = Object.prototype.toString;
/**
 * Deeply clones a value to create a new instance.
 */
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (toString$1.call(val)) {
        case "[object Array]": {
            seen = seen || new Map();
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map();
            if (seen.has(val))
                return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}

function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if (isNonNullObject(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if (isNonNullObject(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
            // they all throw a TypeError when you try, so we re-throw any exceptions
            // that are not TypeErrors, since that would be unexpected.
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (globalThis.__DEV__ !== false) {
        deepFreeze(obj);
    }
    return obj;
}

function iterateObserversSafely(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}

// Like Observable.prototype.map, except that the mapping function can
// optionally return a Promise (or be async).
function asyncMap(observable, mapFn, catchFn) {
    return new Observable(function (observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, key) {
            return function (arg) {
                if (examiner) {
                    var both = function () {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ?
                            /* will be swallowed */ 0
                            : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) { return observer.next(result); }, function (error) { return observer.error(error); });
                }
                else {
                    observer[key](arg);
                }
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function () {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function () { return observer.complete(); });
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}

// Generic implementations of Observable.prototype methods like map and
// filter need to know how to create a new Observable from an Observable
// subclass (like Concast or ObservableQuery). Those methods assume
// (perhaps unwisely?) that they can call the subtype's constructor with a
// Subscriber function, even though the subclass constructor might expect
// different parameters. Defining this static Symbol.species property on
// the subclass is a hint to generic Observable code to use the default
// constructor instead of trying to do `new Subclass(observer => ...)`.
function fixObservableSubclass(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, { value: Observable });
    }
    if (canUseSymbol && Symbol.species) {
        set(Symbol.species);
    }
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}

function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var Concast = /** @class */ (function (_super) {
    __extends$3(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    iterateObserversSafely(_this.observers, "error", error);
                }
            },
            complete: function () {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        iterateObserversSafely(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return (_this.sub = obs.subscribe(_this.handlers)); }, _this.handlers.error);
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.error(reason);
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function (_) { });
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") {
            sources = [new Observable(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) {
            // In case there are still any listeners in this.nextResultListeners, and
            // no error or completion has been broadcast yet, make sure those
            // observers have a chance to run and then remove themselves from
            // this.observers.
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(Observable));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
fixObservableSubclass(Concast);

function isExecutionPatchIncrementalResult(value) {
    return "incremental" in value;
}
function isExecutionPatchInitialResult(value) {
    return "hasNext" in value && "data" in value;
}
function isExecutionPatchResult(value) {
    return (isExecutionPatchIncrementalResult(value) ||
        isExecutionPatchInitialResult(value));
}
// This function detects an Apollo payload result before it is transformed
// into a FetchResult via HttpLink; it cannot detect an ApolloPayloadResult
// once it leaves the link chain.
function isApolloPayloadResult(value) {
    return isNonNullObject(value) && "payload" in value;
}
function mergeIncrementalData(prevResult, result) {
    var mergedData = prevResult;
    var merger = new DeepMerger();
    if (isExecutionPatchIncrementalResult(result) &&
        isNonEmptyArray(result.incremental)) {
        result.incremental.forEach(function (_a) {
            var data = _a.data, path = _a.path;
            for (var i = path.length - 1; i >= 0; --i) {
                var key = path[i];
                var isNumericKey = !isNaN(+key);
                var parent_1 = isNumericKey ? [] : {};
                parent_1[key] = data;
                data = parent_1;
            }
            mergedData = merger.merge(mergedData, data);
        });
    }
    return mergedData;
}

function graphQLResultHasError(result) {
    var errors = getGraphQLErrorsFromResult(result);
    return isNonEmptyArray(errors);
}
function getGraphQLErrorsFromResult(result) {
    var graphQLErrors = isNonEmptyArray(result.errors) ? result.errors.slice(0) : [];
    if (isExecutionPatchIncrementalResult(result) &&
        isNonEmptyArray(result.incremental)) {
        result.incremental.forEach(function (incrementalResult) {
            if (incrementalResult.errors) {
                graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
            }
        });
    }
    return graphQLErrors;
}

/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}

function mergeOptions(defaults, options) {
    return compact(defaults, options, options.variables && {
        variables: compact(__assign$5(__assign$5({}, (defaults && defaults.variables)), options.variables)),
    });
}

function fromError(errorValue) {
    return new Observable(function (observer) {
        observer.error(errorValue);
    });
}

var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context",
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw newInvariantError(44, key);
        }
    }
    return operation;
}

function createOperation(starting, operation) {
    var context = __assign$5({}, starting);
    var setContext = function (next) {
        if (typeof next === "function") {
            context = __assign$5(__assign$5({}, context), next(context));
        }
        else {
            context = __assign$5(__assign$5({}, context), next);
        }
    };
    var getContext = function () { return (__assign$5({}, context)); };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext,
    });
    return operation;
}

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== "string" ?
                getOperationName(transformedOperation.query) || undefined
                : "";
    }
    return transformedOperation;
}

function filterOperationVariables(variables, query) {
    var result = __assign$5({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    visit(query, {
        Variable: function (node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent &&
                parent.kind !== "VariableDefinition") {
                unusedNames.delete(node.name.value);
            }
        },
    });
    unusedNames.forEach(function (name) {
        delete result[name];
    });
    return result;
}

function passthrough(op, forward) {
    return (forward ? forward(op) : Observable.of());
}
function toLink(handler) {
    return typeof handler === "function" ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var ApolloLink = /** @class */ (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return Observable.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        var ret;
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            ret = new ApolloLink(function (operation) {
                return test(operation) ?
                    leftLink.request(operation) || Observable.of()
                    : rightLink.request(operation) || Observable.of();
            });
        }
        else {
            ret = new ApolloLink(function (operation, forward) {
                return test(operation) ?
                    leftLink.request(operation, forward) || Observable.of()
                    : rightLink.request(operation, forward) || Observable.of();
            });
        }
        return Object.assign(ret, { left: leftLink, right: rightLink });
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && invariant$2.warn(36, firstLink);
            return firstLink;
        }
        var nextLink = toLink(second);
        var ret;
        if (isTerminating(nextLink)) {
            ret = new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || Observable.of(); }) || Observable.of();
            });
        }
        else {
            ret = new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || Observable.of();
                }) || Observable.of());
            });
        }
        return Object.assign(ret, { left: firstLink, right: nextLink });
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw newInvariantError(37);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

var from = ApolloLink.from;

var execute = ApolloLink.execute;

/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}

/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */
function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}

/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */
function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}

/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */
function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUseAsyncIteratorSymbol) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}

/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */
function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUseAsyncIteratorSymbol &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}

// This Symbol allows us to pass transport-specific errors from the link chain
// into QueryManager/client internals without risking a naming collision within
// extensions (which implementers can use as they see fit).
var PROTOCOL_ERRORS_SYMBOL = Symbol();
function graphQLResultHasProtocolErrors(result) {
    if (result.extensions) {
        return Array.isArray(result.extensions[PROTOCOL_ERRORS_SYMBOL]);
    }
    return false;
}
function isApolloError(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var generateErrorMessage = function (err) {
    var errors = __spreadArray$5(__spreadArray$5(__spreadArray$5([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError)
        errors.push(err.networkError);
    return (errors
        // The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
        .map(function (err) {
        return (isNonNullObject(err) && err.message) || "Error message not found.";
    })
        .join("\n"));
};
var ApolloError = /** @class */ (function (_super) {
    __extends$3(ApolloError, _super);
    // Constructs an instance of ApolloError given serialized GraphQL errors,
    // client errors, protocol errors or network errors.
    // Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        _this.cause =
            __spreadArray$5(__spreadArray$5(__spreadArray$5([
                networkError
            ], (graphQLErrors || []), true), (protocolErrors || []), true), (clientErrors || []), true).find(function (e) { return !!e; }) || null;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

var hasOwnProperty$3 = Object.prototype.hasOwnProperty;
function readMultipartBody(response, nextValue) {
    return __awaiter(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ?
                        contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [3 /*break*/, 3];
                    return [4 /*yield*/, iterator.next()];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while (bi > -1) {
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = parseHeaders(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 &&
                            contentType_1.toLowerCase().indexOf("application/json") === -1) {
                            throw new Error("Unsupported patch content type: application/json is required.");
                        }
                        body = message.slice(i);
                        if (body) {
                            result = parseJsonBody(response, body);
                            if (Object.keys(result).length > 1 ||
                                "data" in result ||
                                "incremental" in result ||
                                "errors" in result ||
                                "payload" in result) {
                                if (isApolloPayloadResult(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) {
                                            return [2 /*return*/];
                                        }
                                        next = __assign$5({}, result.payload);
                                    }
                                    if ("errors" in result) {
                                        next = __assign$5(__assign$5({}, next), { extensions: __assign$5(__assign$5({}, ("extensions" in next ? next.extensions : null)), (_c = {}, _c[PROTOCOL_ERRORS_SYMBOL] = result.errors, _c)) });
                                    }
                                    nextValue(next);
                                }
                                else {
                                    // for the last chunk with only `hasNext: false`
                                    // we don't need to call observer.next as there is no data/errors
                                    nextValue(result);
                                }
                            }
                            else if (
                            // If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 &&
                                "hasNext" in result &&
                                !result.hasNext) {
                                return [2 /*return*/];
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        throwServerError(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) {
        // if we don't call next, the UI can only show networkError
        // because AC didn't get any graphqlErrors this is graphql
        // execution result info (i.e errors and possibly data) this is
        // because there is no formal spec how errors should translate to
        // http status codes. So an auth error (401) could have both data
        // from a public field, errors from a private field, and a status
        // of 401
        // {
        //  user { // this will have errors
        //    firstName
        //  }
        //  products { // this is public so will have data
        //    cost
        //  }
        // }
        //
        // the result of above *could* look like this:
        // {
        //   data: { products: [{ cost: "$10" }] },
        //   errors: [{
        //      message: 'your session has timed out',
        //      path: []
        //   }]
        // }
        // status code of above would be a 401
        // in the UI you want to show data where you can, errors as data where you can
        // and use correct http status codes
        observer.next(err.result);
    }
    observer.error(err);
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (!Array.isArray(result) &&
                !hasOwnProperty$3.call(result, "data") &&
                !hasOwnProperty$3.call(result, "errors")) {
                // Data error
                throwServerError(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ?
                    operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = newInvariantError(40, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json",
};
var defaultOptions$1 = {
    method: "POST",
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions$1,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = __assign$5(__assign$5(__assign$5({}, options), config.options), { headers: __assign$5(__assign$5({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = __assign$5(__assign$5({}, http), config.http);
    });
    if (options.headers) {
        options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    }
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery)
        body.query = printer(query, print);
    return {
        options: options,
        body: body,
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = {};
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = {};
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name],
        };
    });
    var normalizedHeaders = {};
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === "undefined") {
        throw newInvariantError(38);
    }
};

var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === "function") {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || "/graphql";
    }
};

// For GET operations, returns the given URI rewritten with parameters, or a
// parse error.
function rewriteURIForGET(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) {
        addQueryParam("query", body.query);
    }
    if (body.operationName) {
        addQueryParam("operationName", body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, "Variables map");
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, "Extensions map");
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return { newURI: newURI };
}

var backupFetch = maybe$1(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, 
    // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? defaultPrinter : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = __rest$1(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (globalThis.__DEV__ !== false) {
        // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
        // defined, so requests won't fail at runtime.
        checkFetcher(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders["apollographql-client-name"] = name_1;
            }
            if (version) {
                clientAwarenessHeaders["apollographql-client-version"] = version;
            }
        }
        var contextHeaders = __assign$5(__assign$5({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        if (hasDirectives(["client"], operation.query)) {
            var transformedQuery = removeClientSetsFromDocument(operation.query);
            if (!transformedQuery) {
                return fromError(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            }
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = selectHttpOptionsAndBodyInternal(operation, print, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            body.variables = filterOperationVariables(body.variables, operation.query);
        }
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function (d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function (d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription(getMainDefinition(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = hasDirectives(["defer"], operation.query);
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = "GET";
        }
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) {
                globalThis.__DEV__ !== false && invariant$2.warn(39);
            }
            if (isSubscription) {
                acceptHeader +=
                    "boundary=graphql;subscriptionSpec=1.0,application/json";
            }
            else if (hasDefer) {
                acceptHeader += "deferSpec=20220824,application/json";
            }
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = rewriteURIForGET(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, "Payload");
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new Observable(function (observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || maybe$1(function () { return fetch; }) || backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return readMultipartBody(response, observerNext);
                }
                else {
                    return parseAndCheckHttpResponse(operation)(response).then(observerNext);
                }
            })
                .then(function () {
                controller = undefined;
                observer.complete();
            })
                .catch(function (err) {
                controller = undefined;
                handleError(err, observer);
            });
            return function () {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller)
                    controller.abort();
            };
        });
    });
};

var HttpLink = /** @class */ (function (_super) {
    __extends$3(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, createHttpLink(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(ApolloLink));

const { toString, hasOwnProperty: hasOwnProperty$2 } = Object.prototype;
const fnToStr = Function.prototype.toString;
const previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = toString.call(a);
    const bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            const aKeys = definedKeys(a);
            const bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            const keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (let k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty$2.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (let k = 0; k < keyCount; ++k) {
                const key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            const aIterator = a.entries();
            const isMap = aTag === '[object Map]';
            while (true) {
                const info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                const [aKey, aValue] = info.value;
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            let len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            const aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
const nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}

// Returns true if aResult and bResult are deeply equal according to the fields
// selected by the given query, ignoring any fields marked as @nonreactive.
function equalByQuery(query, _a, _b, variables) {
    var aData = _a.data, aRest = __rest$1(_a, ["data"]);
    var bData = _b.data, bRest = __rest$1(_b, ["data"]);
    return (equal(aRest, bRest) &&
        equalBySelectionSet(getMainDefinition(query).selectionSet, aData, bData, {
            fragmentMap: createFragmentMap(getFragmentDefinitions(query)),
            variables: variables,
        }));
}
function equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) {
        return true;
    }
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function (selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection))
            return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!shouldInclude(selection, context.variables))
            return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if (selectionHasNonreactiveDirective(selection))
            return true;
        if (isField(selection)) {
            var resultKey = resultKeyNameFromField(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) {
                // These are scalar values, so we can compare them with deep equal
                // without redoing the main recursive work.
                return equal(aResultChild, bResultChild);
            }
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray)
                return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) {
                    return false;
                }
                for (var i = 0; i < length_1; ++i) {
                    if (!equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) {
                        return false;
                    }
                }
                return true;
            }
            return equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        }
        else {
            var fragment = getFragmentFromSelection(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if (selectionHasNonreactiveDirective(fragment))
                    return true;
                return equalBySelectionSet(fragment.selectionSet, 
                // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function selectionHasNonreactiveDirective(selection) {
    return (!!selection.directives && selection.directives.some(directiveIsNonreactive));
}
function directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}

var ApolloCache = /** @class */ (function () {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = wrap(getFragmentQueryDocument, {
            max: cacheSizes["cache.fragmentQueryDocuments"] ||
                1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */,
            cache: WeakCache,
        });
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic
            : options.optimistic === false ? null
                : void 0;
        var updateResult;
        this.performTransaction(function () { return (updateResult = options.update(_this)); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read(__assign$5(__assign$5({}, options), { rootId: options.id || "ROOT_QUERY", optimistic: optimistic }));
    };
    /** {@inheritDoc @apollo/client!ApolloClient#watchFragment:member(1)} */
    ApolloCache.prototype.watchFragment = function (options) {
        var _this = this;
        var fragment = options.fragment, fragmentName = options.fragmentName, from = options.from, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, otherOptions = __rest$1(options, ["fragment", "fragmentName", "from", "optimistic"]);
        var query = this.getFragmentDoc(fragment, fragmentName);
        var diffOptions = __assign$5(__assign$5({}, otherOptions), { returnPartialData: true, id: 
            // While our TypeScript types do not allow for `undefined` as a valid
            // `from`, its possible `useFragment` gives us an `undefined` since it
            // calls` cache.identify` and provides that value to `from`. We are
            // adding this fix here however to ensure those using plain JavaScript
            // and using `cache.identify` themselves will avoid seeing the obscure
            // warning.
            typeof from === "undefined" || typeof from === "string" ?
                from
                : this.identify(from), query: query, optimistic: optimistic });
        var latestDiff;
        return new Observable(function (observer) {
            return _this.watch(__assign$5(__assign$5({}, diffOptions), { immediate: true, callback: function (diff) {
                    if (
                    // Always ensure we deliver the first result
                    latestDiff &&
                        equalByQuery(query, { data: latestDiff === null || latestDiff === void 0 ? void 0 : latestDiff.result }, { data: diff.result })) {
                        return;
                    }
                    var result = {
                        data: diff.result,
                        complete: !!diff.complete,
                    };
                    if (diff.missing) {
                        result.missing = mergeDeepArray(diff.missing.map(function (error) { return error.missing; }));
                    }
                    latestDiff = diff;
                    observer.next(result);
                } }));
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read(__assign$5(__assign$5({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = __rest$1(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = __rest$1(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery(__assign$5(__assign$5({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment(__assign$5(__assign$5({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());
if (globalThis.__DEV__ !== false) {
    ApolloCache.prototype.getMemoryInternals = getApolloCacheMemoryInternals;
}

var MissingFieldError = /** @class */ (function (_super) {
    __extends$3(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}
function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id }
                    : !isNullish(_id) ? { _id: _id }
                        : void 0;
        }
        // If there is no object.id, fall back to object._id.
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ?
                id
                : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false,
};
function normalizeConfig(config) {
    return compact(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return isReference(objectOrReference) ?
        store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if (isNonNullObject(result)) {
        return isArray(result) ?
            result.every(function (item) {
                return selectionSetMatchesResult(selectionSet, item, variables);
            })
            : selectionSet.selections.every(function (field) {
                if (isField(field) && shouldInclude(field, variables)) {
                    var key = resultKeyNameFromField(field);
                    return (hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables)));
                }
                // If the selection has been skipped with @skip(true) or
                // @include(false), it should not count against the matching. If
                // the selection is not a field, it must be a fragment (inline or
                // named). We will determine if selectionSetMatchesResult for that
                // fragment when we get to it, so for now we return true.
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return isNonNullObject(value) && !isReference(value) && !isArray(value);
}
function makeProcessedFieldsMerger() {
    return new DeepMerger();
}
function extractFragmentContext(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = createFragmentMap(getFragmentDefinitions(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}

var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = /** @class */ (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function (objectOrReference, storeFieldName) {
            return maybeDeepFreeze(isReference(objectOrReference) ?
                _this.get(objectOrReference.__ref, storeFieldName)
                : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function (objOrRef) {
            return isReference(objOrRef) ?
                _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return makeReference(objOrIdOrRef);
            }
            if (isReference(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = makeReference(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function () {
        return __assign$5({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (hasOwn.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && hasOwn.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            hasOwn.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (hasOwn.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if (isReference(older))
            older = older.__ref;
        if (isReference(newer))
            newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup((dataId = older)) : older;
        var incoming = typeof newer === "string" ? this.lookup((dataId = newer)) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming)
            return;
        invariant$2(typeof dataId === "string", 1);
        var merged = new DeepMerger(storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing ||
                        existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = fieldNameFromStoreName(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    // Since we return default root __typename strings
                    // automatically from store.get, we don't need to dirty the
                    // ROOT_QUERY.__typename field if merged.__typename is equal
                    // to the default string (usually "Query").
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: isReference,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ?
                        {
                            fieldName: fieldNameOrOptions,
                            from: from || makeReference(dataId),
                        }
                        : fieldNameOrOptions, { store: _this });
                },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = fieldNameFromStoreName(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function" ? fields : (fields[storeFieldName] || fields[fieldName]);
                if (modify) {
                    var newValue = modify === delModifier ? DELETE : (modify(maybeDeepFreeze(fieldValue), __assign$5(__assign$5({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) })));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function (ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && invariant$2.warn(2, ref);
                                        return true;
                                    }
                                };
                                if (isReference(newValue)) {
                                    checkReference(newValue);
                                }
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for (var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++) {
                                        var value = newValue_1[_i];
                                        if (isReference(value)) {
                                            seenReference = true;
                                            if (checkReference(value))
                                                break;
                                        }
                                        else {
                                            // Do not warn on primitive values, since those could never be represented
                                            // by a reference. This is a valid (albeit uncommon) use case.
                                            if (typeof value === "object" && !!value) {
                                                var id = _this.policies.identify(value)[0];
                                                // check if object could even be referenced, otherwise we are not interested in it for this warning
                                                if (id) {
                                                    someNonReference = value;
                                                }
                                            }
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && invariant$2.warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ?
                this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (hasOwn.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!hasOwn.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && hasOwn.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = __rest$1(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return (this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1);
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
            // always considered roots for garbage collection, regardless of
            // their retainment counts in this.rootIds.
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (hasOwn.call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!hasOwn.call(this.refs, dataId)) {
            var found_1 = (this.refs[dataId] = Object.create(null));
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function (obj) {
                if (isReference(obj)) {
                    found_1[obj.__ref] = true;
                    // In rare cases, a { __ref } Reference object may have other fields.
                    // This often indicates a mismerging of References with StoreObjects,
                    // but garbage collection should not be fooled by a stray __ref
                    // property in a StoreObject (ignoring all the other fields just
                    // because the StoreObject looks like a Reference). To avoid this
                    // premature termination of findChildRefIds recursion, we fall through
                    // to the code below, which will handle any other properties of obj.
                }
                if (isNonNullObject(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        // No need to add primitive values to the workSet, since they cannot
                        // contain reference objects.
                        if (isNonNullObject(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var CacheGroup = /** @class */ (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? dep() : null;
        this.keyMaker = new Trie$1(canUseWeakMap);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = fieldNameFromStoreName(storeFieldName);
            if (fieldName !== storeFieldName) {
                // Fields with arguments that contribute extra identifying
                // information to the fieldName (thus forming the storeFieldName)
                // depend not only on the full storeFieldName but also on the
                // short fieldName, so the field can be invalidated using either
                // level of specificity.
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), 
            // When storeFieldName === "__exists", that means the entity identified
            // by dataId has either disappeared from the cache or was newly added,
            // so the result caching system would do well to "forget everything it
            // knows" about that object. To achieve that kind of invalidation, we
            // not only dirty the associated result cache entry, but also remove it
            // completely from the dependency graph. For the optimism implementation
            // details, see https://github.com/benjamn/optimism/pull/195.
            storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        // We use this pseudo-field __exists elsewhere in the EntityStore code to
        // represent changes in the existence of the entity object identified by
        // entityId. This dependency gets reliably dirtied whenever an object with
        // this ID is deleted (or newly created) within this group, so any result
        // cache entries (for example, StoreReader#executeSelectionSet results) that
        // depend on __exists for this entityId will get dirtied as well, leading to
        // the eventual recomputation (instead of reuse) of those result objects the
        // next time someone reads them from the cache.
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ (function (_super) {
        __extends$3(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new Trie$1(canUseWeakMap);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var Layer = /** @class */ (function (_super) {
    __extends$3(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                // Dirty every ID we're removing. Technically we might be able to avoid
                // dirtying fields that have values in higher layers, but we don't have
                // easy access to higher layers here, and we're about to recreate those
                // layers anyway (see parent.addLayer below).
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        // The StoreObject identified by dataId was defined in this layer
                        // but will be undefined in the parent layer, so we can delete the
                        // whole entity using this.delete(dataId). Since we're about to
                        // throw this layer away, the only goal of this deletion is to dirty
                        // the removed fields.
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        // This layer had an entry for dataId but it was undefined, which
                        // means the entity was deleted in this layer, and it's about to
                        // become undeleted when we remove this layer, so we need to dirty
                        // all fields that are about to be reexposed.
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        // If ownStoreObject is not exactly the same as parentStoreObject,
                        // dirty any fields whose values will change as a result of this
                        // removal.
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!equal(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent)
            return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return __assign$5(__assign$5({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return hasOwn.call(this.data, dataId) ? __assign$5(__assign$5({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, 
        // @ts-expect-error
        arguments);
    };
    return Layer;
}(EntityStore));
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var Stump = /** @class */ (function (_super) {
    __extends$3(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function (older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return equal(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof EntityStore && store.group.caching);
}

function shallowCopy(value) {
    if (isNonNullObject(value)) {
        return isArray(value) ?
            value.slice(0)
            : __assign$5({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var ObjectCanon = /** @class */ (function () {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new (canUseWeakSet ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new Trie$1(canUseWeakMap);
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return isNonNullObject(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if (isNonNullObject(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if (isNonNullObject(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add((node.array = array));
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = (node.object = Object.create(proto_1));
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, (node.keys = { sorted: keys, json: json }));
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults,
    ];
}
var StoreReader = /** @class */ (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUseWeakMap ? WeakMap : Map)();
        this.config = compact(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: shouldCanonizeResults(config),
        });
        this.canon = config.canon || new ObjectCanon();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = wrap(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return __assign$5(__assign$5({}, other), { 
                        // If we previously read this result without canonizing it, we can
                        // reuse that result simply by canonizing it now.
                        result: _this.canon.admit(other.result) });
                }
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize ||
                cacheSizes["inMemoryCache.executeSelectionSet"] ||
                50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */,
            keyArgs: execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, isReference(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            },
        });
        this.executeSubSelectedArray = wrap(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize ||
                cacheSizes["inMemoryCache.executeSubSelectedArray"] ||
                10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            },
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new ObjectCanon();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = __assign$5(__assign$5({}, getDefaultValues(getQueryDefinition(query))), variables);
        var rootRef = makeReference(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: getMainDefinition(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: __assign$5({ store: store, query: query, policies: policies, variables: variables, varString: canonicalStringify(variables), canonizeResults: canonizeResults }, extractFragmentContext(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new MissingFieldError(firstMissing(execResult.missing), execResult.missing, query, variables),
            ];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, 
            // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if (isReference(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new DeepMerger();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            // Ensure we always include a default value for the __typename
            // field, if we have one, and this.config.addTypename is true. Note
            // that this field can be overridden by other merged objects.
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {},
                    _a[resultName] = result.missing,
                    _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!shouldInclude(selection, variables))
                return;
            if (isField(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = resultKeyNameFromField(selection);
                if (fieldValue === void 0) {
                    if (!addTypenameToDocument.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat(isReference(objectOrReference) ?
                                objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if (isArray(fieldValue)) {
                    if (fieldValue.length > 0) {
                        fieldValue = handleMissing(_this.executeSubSelectedArray({
                            field: selection,
                            array: fieldValue,
                            enclosingRef: enclosingRef,
                            context: context,
                        }), resultName);
                    }
                }
                else if (!selection.selectionSet) {
                    // If the field does not have a selection set, then we handle it
                    // as a scalar value. To keep this.canon from canonicalizing
                    // this value, we use this.canon.pass to wrap fieldValue in a
                    // Pass object that this.canon.admit will later unwrap as-is.
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    // In this case, because we know the field has a selection set,
                    // it must be trying to query a GraphQLObjectType, which is why
                    // fieldValue must be != null.
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: isReference(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = getFragmentFromSelection(selection, context.lookupFragment);
                if (!fragment && selection.kind === Kind.FRAGMENT_SPREAD) {
                    throw newInvariantError(9, selection.name.value);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = mergeDeepArray(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults ?
            this.canon.admit(finalResult)
            // Since this.canon is normally responsible for freezing results (only in
            // development), freeze them manually if canonization is disabled.
            : maybeDeepFreeze(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new DeepMerger();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            // null value in array
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse
            if (isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            // This is an object, run the selection set on it
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: isReference(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (globalThis.__DEV__ !== false) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());
function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if (isNonNullObject(value)) {
                invariant$2(
                    !isReference(value),
                    10,
                    getTypenameFromStoreObject(store, value),
                    field.name.value
                );
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

// Contextual Slot that acquires its value when custom read functions are
// called in Policies#readField.
var cacheSlot = new Slot();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, (info = {
            vars: new Set(),
            dep: dep(),
        }));
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
// Calling forgetCache(cache) serves to silence broadcasts and allows the
// cache to be garbage collected. However, the varsByCache WeakMap
// preserves the set of reactive variables that were previously associated
// with this cache, which makes it possible to "recall" the cache at a
// later time, by reattaching it to those variables. If the cache has been
// garbage collected in the meantime, because it is no longer reachable,
// you won't be able to call recallCache(cache), and the cache will
// automatically disappear from the varsByCache WeakMap.
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = (rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    });
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}

// Mapping from JSON-encoded KeySpecifier strings to associated information.
var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return (specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null)));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return (info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
            var extract = function (from, key) {
                return context.readField(key, from);
            };
            var keyObject = (context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
                var extracted = extractKeyPath(context.storeObject, schemaKeyPath, 
                // Using context.readField to extract paths from context.storeObject
                // allows the extraction to see through Reference objects and respect
                // custom read functions.
                extract);
                if (extracted === void 0 &&
                    object !== context.storeObject &&
                    hasOwn.call(object, schemaKeyPath[0])) {
                    // If context.storeObject fails to provide a value for the requested
                    // path, fall back to the raw result object, if it has a top-level key
                    // matching the first key in the path (schemaKeyPath[0]). This allows
                    // key fields included in the written data to be saved in the cache
                    // even if they are not selected explicitly in context.selectionSet.
                    // Not being mentioned by context.selectionSet is convenient here,
                    // since it means these extra fields cannot be affected by field
                    // aliasing, which is why we can use extractKey instead of
                    // context.readField for this extraction.
                    extracted = extractKeyPath(object, schemaKeyPath, extractKey);
                }
                invariant$2(extracted !== void 0, 4, schemaKeyPath.join("."), object);
                return extracted;
            }));
            return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
        }));
}
// The keyArgs extraction process is roughly analogous to keyFields extraction,
// but there are no aliases involved, missing fields are tolerated (by merely
// omitting them from the key), and drawing from field.directives or variables
// is allowed (in addition to drawing from the field's arguments object).
// Concretely, these differences mean passing a different key path extractor
// function to collectSpecifierPaths, reusing the shared extractKeyPath helper
// wherever possible.
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return (info.keyArgsFn ||
        (info.keyArgsFn = function (args, _a) {
            var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
            var collected = collectSpecifierPaths(specifier, function (keyPath) {
                var firstKey = keyPath[0];
                var firstChar = firstKey.charAt(0);
                if (firstChar === "@") {
                    if (field && isNonEmptyArray(field.directives)) {
                        var directiveName_1 = firstKey.slice(1);
                        // If the directive appears multiple times, only the first
                        // occurrence's arguments will be used. TODO Allow repetition?
                        // TODO Cache this work somehow, a la aliasMap?
                        var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                        // Fortunately argumentsObjectFromField works for DirectiveNode!
                        var directiveArgs = d && argumentsObjectFromField(d, variables);
                        // For directives without arguments (d defined, but directiveArgs ===
                        // null), the presence or absence of the directive still counts as
                        // part of the field key, so we return null in those cases. If no
                        // directive with this name was found for this field (d undefined and
                        // thus directiveArgs undefined), we return undefined, which causes
                        // this value to be omitted from the key object returned by
                        // collectSpecifierPaths.
                        return (directiveArgs &&
                            extractKeyPath(directiveArgs, 
                            // If keyPath.length === 1, this code calls extractKeyPath with an
                            // empty path, which works because it uses directiveArgs as the
                            // extracted value.
                            keyPath.slice(1)));
                    }
                    // If the key started with @ but there was no corresponding directive,
                    // we want to omit this value from the key object, not fall through to
                    // treating @whatever as a normal argument name.
                    return;
                }
                if (firstChar === "$") {
                    var variableName = firstKey.slice(1);
                    if (variables && hasOwn.call(variables, variableName)) {
                        var varKeyPath = keyPath.slice(0);
                        varKeyPath[0] = variableName;
                        return extractKeyPath(variables, varKeyPath);
                    }
                    // If the key started with $ but there was no corresponding variable, we
                    // want to omit this value from the key object, not fall through to
                    // treating $whatever as a normal argument name.
                    return;
                }
                if (args) {
                    return extractKeyPath(args, keyPath);
                }
            });
            var suffix = JSON.stringify(collected);
            // If no arguments were passed to this field, and it didn't have any other
            // field key contributions from directives or variables, hide the empty
            // :{} suffix from the field key. However, a field passed no arguments can
            // still end up with a non-empty :{...} suffix if its key configuration
            // refers to directives or variables.
            if (args || suffix !== "{}") {
                fieldName += ":" + suffix;
            }
            return fieldName;
        }));
}
function collectSpecifierPaths(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new DeepMerger();
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = (info.paths = []);
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if (isArray(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!isArray(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || extractKey;
    return normalize$1(path.reduce(function reducer(obj, key) {
        return isArray(obj) ?
            obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize$1(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if (isNonNullObject(value)) {
        if (isArray(value)) {
            return value.map(normalize$1);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) {
            return extractKeyPath(value, path);
        });
    }
    return value;
}

function argsFromFieldSpecifier(spec) {
    return (spec.args !== void 0 ? spec.args
        : spec.field ? argumentsObjectFromField(spec.field, spec.variables)
            : null);
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = /** @class */ (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = __assign$5({ dataIdFromObject: defaultDataIdFromObject }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = (partialContext &&
            (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename))) ||
            object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = (partialContext && partialContext.storeObject) || object;
        var context = __assign$5(__assign$5({}, partialContext), { typename: typename, storeObject: storeObject, readField: (partialContext && partialContext.readField) ||
                function () {
                    var options = normalizeReadFieldOptions(arguments, storeObject);
                    return policies.readField(options, {
                        store: policies.cache["data"],
                        variables: options.variables,
                    });
                } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = (policy && policy.keyFn) || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn(__assign$5(__assign$5({}, object), storeObject), context);
            if (isArray(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = __rest$1(_a, ["queryType", "mutationType", "subscriptionType"]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (hasOwn.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge
                    // Pass merge:true as a shorthand for a merge implementation
                    // that returns options.mergeObjects(existing, incoming).
                    : merge === true ? mergeTrueFn
                        // Pass merge:false to make incoming always replace existing
                        // without any warnings about data clobbering.
                        : merge === false ? mergeFalseFn
                            : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn =
            // Pass false to disable normalization for this typename.
            keyFields === false ? nullKeyFieldsFn
                // Pass an array of strings to use those fields to compute a
                // composite ID for objects of this typename.
                : isArray(keyFields) ? keyFieldsFnFromSpecifier(keyFields)
                    // Pass a function to take full control over identification.
                    : typeof keyFields === "function" ? keyFields
                        // Leave existing.keyFn unchanged if above cases fail.
                        : existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        // Pass false to disable argument-based differentiation of
                        // field identities.
                        keyArgs === false ? simpleKeyArgsFn
                            // Pass an array of strings to use named arguments to
                            // compute a composite identity for the field.
                            : isArray(keyArgs) ? keyArgsFnFromSpecifier(keyArgs)
                                // Pass a function to take full control over field identity.
                                : typeof keyArgs === "function" ? keyArgs
                                    // Leave existing.keyFn unchanged if above cases fail.
                                    : existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    // If we have both a read and a merge function, assume
                    // keyArgs:false, because read and merge together can take
                    // responsibility for interpreting arguments in and out. This
                    // default assumption can always be overridden by specifying
                    // keyArgs explicitly in the FieldPolicy.
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            invariant$2(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old)
                delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(TypeOrFieldNameRegExp);
                if (!match || match[0] !== subtype) {
                    // TODO Don't interpret just any invalid typename as a RegExp.
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!hasOwn.call(this.typePolicies, typename)) {
            var policy_1 = (this.typePolicies[typename] = Object.create(null));
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function (regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) {
                            fuzzySupertypes.forEach(function (supertype) {
                                return supertypes_1.add(supertype);
                            });
                        }
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) {
                supertypes_1.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = __rest$1(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            // Merge the pending policies into this.typePolicies, in the order they
            // were originally passed to addTypePolicy.
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return (fieldPolicies[fieldName] ||
                (createIfMissing && (fieldPolicies[fieldName] = Object.create(null))));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, (supertypeSet = new Set()));
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            globalThis.__DEV__ !== false && invariant$2.warn(6, typename, supertype);
                        }
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    // Start checking fuzzy subtypes only after exhausting all
                    // non-fuzzy subtypes (after the final iteration of the loop).
                    i === workQueue_1.length - 1 &&
                    // We could wait to compare fragment.selectionSet to result
                    // after we verify the supertype, but this check is often less
                    // expensive than that search, and we will have to do the
                    // comparison anyway whenever we find a potential match.
                    selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if (isArray(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName =
                fieldSpec.field ?
                    storeKeyNameFromField(fieldSpec.field, fieldSpec.variables)
                    : getStoreKeyName(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) {
            return fieldName;
        }
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === fieldNameFromStoreName(storeFieldName) ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = fieldNameFromStoreName(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage(isReference(objectOrReference) ?
                objectOrReference.__ref
                : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return cacheSlot.withValue(this.cache, read, [
                existing,
                readOptions,
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            // Instead of going to the trouble of creating a full
            // FieldFunctionOptions object and calling mergeTrueFn, we can
            // simply call mergeObjects, as mergeTrueFn would.
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            // Likewise for mergeFalseFn, whose implementation is even simpler.
            return incoming;
        }
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, 
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables,
        }, context, storage || Object.create(null)));
    };
    return Policies;
}());
function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: isReference,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            // Default to objectOrReference only when no second argument was
            // passed for the from parameter, not when undefined is explicitly
            // passed as the second argument.
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = __assign$5({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!hasOwn.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) {
        globalThis.__DEV__ !== false && invariant$2.warn(7, stringifyForDisplay(Array.from(readFieldArgs)));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if (isArray(existing) || isArray(incoming)) {
            throw newInvariantError(8);
        }
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if (isNonNullObject(existing) && isNonNullObject(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if (isReference(existing) && storeValueIsStoreObject(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if (storeValueIsStoreObject(existing) && isReference(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if (storeValueIsStoreObject(existing) &&
                storeValueIsStoreObject(incoming)) {
                return __assign$5(__assign$5({}, existing), incoming);
            }
        }
        return incoming;
    };
}

// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, (flavored =
            context.clientOnly === clientOnly && context.deferred === deferred ?
                context
                : __assign$5(__assign$5({}, context), { clientOnly: clientOnly, deferred: deferred })));
    }
    return flavored;
}
var StoreWriter = /** @class */ (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = getOperationDefinition(query);
        var merger = makeProcessedFieldsMerger();
        variables = __assign$5(__assign$5({}, getDefaultValues(operationDefinition)), variables);
        var context = __assign$5(__assign$5({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: canonicalStringify(variables) }, extractFragmentContext(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map(), clientOnly: false, deferred: false, flavors: new Map() });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map() },
            context: context,
        });
        if (!isReference(ref)) {
            throw newInvariantError(11, result);
        }
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = makeReference(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if (isReference(applied)) {
                    // Assume References returned by applyMerges have already been merged
                    // into the store. See makeMergeObjectsFunction in policies.ts for an
                    // example of how this can happen.
                    return;
                }
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[fieldNameFromStoreName(storeFieldName)] ===
                        true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, 
        // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            getTypenameFromResult(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if (isReference(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField(__assign$5(__assign$5({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, 
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = resultKeyNameFromField(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, 
                // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ?
                    getContextFlavor(context, false, false)
                    : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet &&
                    (isReference(incomingValue) || storeValueIsStoreObject(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        // TODO Check compatibility against any existing childTree.field?
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (globalThis.__DEV__ !== false &&
                !context.clientOnly &&
                !context.deferred &&
                !addTypenameToDocument.added(field) &&
                // If the field has a read function, it may be a synthetic field or
                // provide a default value, so its absence from the written data should
                // not be cause for alarm.
                !policies.getReadFunction(typename, field.name.value)) {
                globalThis.__DEV__ !== false && invariant$2.error(12, resultKeyNameFromField(field), result);
            }
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) {
                // TODO Reverse the order of the arguments?
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = makeReference(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader &&
                this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    // Save a reference to mergeTree only if it is not empty, because
                    // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                    // reused for entirely different parts of the result tree.
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            // In development, we need to clone scalar values so that they can be
            // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
            // it's cheaper to store the scalar values directly in the cache.
            return globalThis.__DEV__ !== false ? cloneDeep(value) : value;
        }
        if (isArray(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = getTypenameFromResult(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new Trie$1(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, 
            // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!shouldInclude(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (
                // Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) &&
                    isNonEmptyArray(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = argumentsObjectFromField(dir, context.variables);
                            // The @defer directive takes an optional args.if boolean
                            // argument, similar to @include(if: boolean). Note that
                            // @defer(if: false) does not make context.deferred false, but
                            // instead behaves as if there was no @defer directive.
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                            // TODO In the future, we may want to record args.label using
                            // context.deferred, if a label is specified.
                        }
                    });
                }
                if (isField(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = getFragmentFromSelection(selection, context.lookupFragment);
                    if (!fragment && selection.kind === Kind.FRAGMENT_SPREAD) {
                        throw newInvariantError(13, selection.name.value);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !isReference(incoming)) {
            var e_1 = 
            // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            (!isArray(incoming) &&
                // Likewise, existing must be either a Reference or a StoreObject
                // in order for its fields to be safe to merge with the fields of
                // the incoming object.
                (isReference(existing) || storeValueIsStoreObject(existing))) ?
                existing
                : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [isReference(e_1) ? e_1.__ref : e_1];
            }
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return (isArray(from) ?
                    typeof name === "number" ?
                        from[name]
                        : void 0
                    : context.store.getFieldValue(from, String(name)));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    invariant$2(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (isArray(i_1) ? i_1.slice(0) : __assign$5({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());
var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map() });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? __assign$5(__assign$5({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map()
        : left.map.size ? left.map
            : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if (isReference(existing))
        return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if (equal(existing, incoming))
        return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!isArray(existing) && !isArray(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" && !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    globalThis.__DEV__ !== false && invariant$2.warn(14, fieldName, parentType, childTypenames.length ?
        "either ensure all objects of type " +
            childTypenames.join(" and ") +
            " have an ID or a custom merge function, or "
        : "", typeDotName, __assign$5({}, existing), __assign$5({}, incoming));
}

var InMemoryCache = /** @class */ (function (_super) {
    __extends$3(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new DocumentTransform(addTypenameToDocument);
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = makeVar;
        _this.txCount = 0;
        _this.config = normalizeConfig(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = (this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        }));
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new StoreWriter(this, (this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: shouldCanonizeResults(this.config),
            canon: resetResultIdentities ? void 0 : (previousReader && previousReader.canon),
            fragments: fragments,
        })), fragments);
        this.maybeBroadcastWatch = wrap(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize ||
                cacheSizes["inMemoryCache.maybeBroadcastWatch"] ||
                5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */,
            makeCacheKey: function (c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, 
                    // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, canonicalStringify({ optimistic: optimistic, id: id, variables: variables }));
                }
            },
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([this.data.group, this.optimisticData.group]).forEach(function (group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var 
        // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, 
        // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return (this.storeReader.diffQueryAgainstStore(__assign$5(__assign$5({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null);
        }
        catch (e) {
            if (e instanceof MissingFieldError) {
                // Swallow MissingFieldError and return null, so callers do not need to
                // worry about catching "normal" exceptions resulting from incomplete
                // cache data. Unexpected errors will be re-thrown. If you need more
                // information about which fields were missing, use cache.diff instead,
                // and examine diffResult.missing.
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (hasOwn.call(options, "id") && !options.id) {
            // To my knowledge, TypeScript does not currently provide a way to
            // enforce that an optional property?:type must *not* be undefined
            // when present. That ability would be useful here, because we want
            // options.id to default to ROOT_QUERY only when no options.id was
            // provided. If the caller attempts to pass options.id with a
            // falsy/undefined value (perhaps because cache.identify failed), we
            // should not assume the goal was to modify the ROOT_QUERY object.
            // We could throw, but it seems natural to return false to indicate
            // that nothing was modified.
            return false;
        }
        var store = ((options.optimistic) // Defaults to false.
        ) ?
            this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore(__assign$5(__assign$5({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            // In case we previously called forgetCache(this) because
            // this.watches became empty (see below), reattach this cache to any
            // reactive variables on which it previously depended. It might seem
            // paradoxical that we're able to recall something we supposedly
            // forgot, but the point of calling forgetCache(this) is to silence
            // useless broadcasts while this.watches is empty, and to allow the
            // cache to be garbage collected. If, however, we manage to call
            // recallCache(this) here, this cache object must not have been
            // garbage collected yet, and should resume receiving updates from
            // reactive variables, now that it has a watcher to notify.
            recallCache(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) {
                forgetCache(_this);
            }
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        var _a;
        canonicalStringify.reset();
        print.reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 ? void 0 : _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function (object) {
        if (isReference(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            globalThis.__DEV__ !== false && invariant$2.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (hasOwn.call(options, "id")) {
                // See comment in modify method about why we return false when
                // options.id exists but is falsy/undefined.
                return false;
            }
            options = __assign$5(__assign$5({}, options), { id: "ROOT_QUERY" });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        canonicalStringify.reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            forgetCache(this);
        }
        else {
            // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
            // this.broadcastWatches() triggers a broadcast to every current watcher
            // (letting them know their data is now missing). This default behavior is
            // convenient because it means the watches do not have to be manually
            // reestablished after resetting the cache. To prevent this broadcast and
            // cancel all watches, pass true for options.discardWatches.
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return (updateResult = update(_this));
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            // If an options.onWatchUpdated callback is provided, we want to call it
            // with only the Cache.WatchOptions objects affected by options.update,
            // but there might be dirty watchers already waiting to be broadcast that
            // have nothing to do with the update. To prevent including those watchers
            // in the post-update broadcast, we perform this initial broadcast to
            // collect the dirty watchers, so we can re-dirty them later, after the
            // post-update broadcast, allowing them to receive their pending
            // broadcasts the next time broadcastWatches is called, just as they would
            // if we never called cache.batch.
            this.broadcastWatches(__assign$5(__assign$5({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === "string") {
            // Note that there can be multiple layers with the same optimistic ID.
            // When removeOptimistic(id) is called for that id, all matching layers
            // will be removed, and the remaining layers will be reapplied.
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            // Ensure both this.data and this.optimisticData refer to the root
            // (non-optimistic) layer of the cache during the update. Note that
            // this.data could be a Layer if we are currently executing an optimistic
            // update function, but otherwise will always be an EntityStore.Root
            // instance.
            perform(this.data);
        }
        else {
            // Otherwise, leave this.data and this.optimisticData unchanged and run
            // the update with broadcast batching.
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches(__assign$5(__assign$5({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        // Since onWatchUpdated did not return false, this diff is
                        // about to be broadcast to watch.callback, so we don't need
                        // to re-dirty it with the other alreadyDirty watches below.
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            // If alreadyDirty is empty or we don't have an onWatchUpdated
            // function, we don't need to go to the trouble of wrapping
            // options.onWatchUpdated.
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null,
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.addFragmentsToDocument = function (document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function (document) {
        if (this.addTypename) {
            return this.addTypenameTransform.transformDocument(document);
        }
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                // Returning false from the onWatchUpdated callback will prevent
                // calling c.callback(diff) for this watcher.
                return;
            }
        }
        if (!lastDiff || !equal(lastDiff.result, diff.result)) {
            c.callback((c.lastDiff = diff), lastDiff);
        }
    };
    return InMemoryCache;
}(ApolloCache));
if (globalThis.__DEV__ !== false) {
    InMemoryCache.prototype.getMemoryInternals = getInMemoryCacheMemoryInternals;
}

/**
 * The current status of a query’s execution in our system.
 */
var NetworkStatus;
(function (NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
/**
 * Returns true if there is currently a network request in flight according to a given network
 * status.
 */
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}

var assign = Object.assign, hasOwnProperty$1 = Object.hasOwnProperty;
var ObservableQuery = /** @class */ (function (_super) {
    __extends$3(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) {
                // Blindly catching here prevents unhandled promise rejections,
                // and is safe because the ObservableQuery handles this error with
                // this.observer.error, so we're not just swallowing the error by
                // ignoring it here.
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        _this.subscribeToMore = _this.subscribeToMore.bind(_this);
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, 
        // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, 
        // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : (fetchPolicy) : _f;
        _this.options = __assign$5(__assign$5({}, options), { 
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy, 
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = getOperationDefinition(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function () {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function (result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */
    ObservableQuery.prototype.resetDiff = function () {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            NetworkStatus.ready;
        var result = __assign$5(__assign$5({}, lastResult), { loading: isNetworkRequestInFlight(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        skipCacheDataFor(fetchPolicy) ||
            // If this.options.query has @client(always: true) fields, we cannot
            // trust diff.result, since it was read from the cache without running
            // local resolvers (and it's too late to run resolvers now, since we must
            // return a result synchronously).
            this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) {
            // This would usually be a part of `QueryInfo.getDiff()`.
            // which we skip in the waitForOwnResult case since we are not
            // interested in the diff.
            this.queryInfo["updateWatch"]();
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if (equal(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete &&
                    result.networkStatus === NetworkStatus.loading &&
                    (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = NetworkStatus.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (globalThis.__DEV__ !== false &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult, variables) {
        if (!this.last) {
            return true;
        }
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ?
            !equalByQuery(this.query, this.last.result, newResult, this.variables)
            : !equal(this.last.result, newResult);
        return (resultIsDifferent || (variables && !equal(this.last.variables, variables)));
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || equal(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0,
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === "no-cache") {
            reobserveOptions.fetchPolicy = "no-cache";
        }
        else {
            reobserveOptions.fetchPolicy = "network-only";
        }
        if (globalThis.__DEV__ !== false && variables && hasOwnProperty$1.call(variables, "variables")) {
            var queryDef = getQueryDefinition(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                globalThis.__DEV__ !== false && invariant$2.warn(
                    20,
                    variables,
                    ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef
                );
            }
        }
        if (variables && !equal(this.options.variables, variables)) {
            // Update the existing options with new variables
            reobserveOptions.variables = this.options.variables = __assign$5(__assign$5({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, NetworkStatus.refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = __assign$5(__assign$5({}, (fetchMoreOptions.query ? fetchMoreOptions : (__assign$5(__assign$5(__assign$5(__assign$5({}, this.options), { query: this.options.query }), fetchMoreOptions), { variables: __assign$5(__assign$5({}, this.options.variables), fetchMoreOptions.variables) })))), { 
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache" });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery =
            fetchMoreOptions.query ?
                this.transformDocument(this.options.query)
                : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = NetworkStatus.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        var updateQuery = fetchMoreOptions === null || fetchMoreOptions === void 0 ? void 0 : fetchMoreOptions.updateQuery;
        var isCached = this.options.fetchPolicy !== "no-cache";
        if (!isCached) {
            invariant$2(updateQuery, 21);
        }
        return this.queryManager
            .fetchQuery(qid, combinedOptions, NetworkStatus.fetchMore)
            .then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === NetworkStatus.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            if (isCached) {
                // Performing this cache update inside a cache.batch transaction ensures
                // any affected cache.watch watchers are notified at most once about any
                // updates. Most watchers will be using the QueryInfo class, which
                // responds to notifications by calling reobserveCacheFirst to deliver
                // fetchMore cache results back to this ObservableQuery.
                _this.queryManager.cache.batch({
                    update: function (cache) {
                        var updateQuery = fetchMoreOptions.updateQuery;
                        if (updateQuery) {
                            cache.updateQuery({
                                query: _this.query,
                                variables: _this.variables,
                                returnPartialData: true,
                                optimistic: false,
                            }, function (previous) {
                                return updateQuery(previous, {
                                    fetchMoreResult: fetchMoreResult.data,
                                    variables: combinedOptions.variables,
                                });
                            });
                        }
                        else {
                            // If we're using a field policy instead of updateQuery, the only
                            // thing we need to do is write the new data to the cache using
                            // combinedOptions.variables (instead of this.variables, which is
                            // what this.updateQuery uses, because it works by abusing the
                            // original field value, keyed by the original variables).
                            cache.writeQuery({
                                query: combinedOptions.query,
                                variables: combinedOptions.variables,
                                data: fetchMoreResult.data,
                            });
                        }
                    },
                    onWatchUpdated: function (watch) {
                        // Record the DocumentNode associated with any watched query whose
                        // data were updated by the cache writes above.
                        updatedQuerySet.add(watch.query);
                    },
                });
            }
            else {
                // There is a possibility `lastResult` may not be set when
                // `fetchMore` is called which would cause this to crash. This should
                // only happen if we haven't previously reported a result. We don't
                // quite know what the right behavior should be here since this block
                // of code runs after the fetch result has executed on the network.
                // We plan to let it crash in the meantime.
                //
                // If we get bug reports due to the `data` property access on
                // undefined, this should give us a real-world scenario that we can
                // use to test against and determine the right behavior. If we do end
                // up changing this behavior, this may require, for example, an
                // adjustment to the types on `updateQuery` since that function
                // expects that the first argument always contains previous result
                // data, but not `undefined`.
                var lastResult = _this.getLast("result");
                var data = updateQuery(lastResult.data, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
                _this.reportResult(__assign$5(__assign$5({}, lastResult), { data: data }), _this.variables);
            }
            return fetchMoreResult;
        })
            .finally(function () {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (isCached && !updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && invariant$2.error(22, err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function (newOptions) {
        var mergedOptions = compact(this.options, newOptions || {});
        assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */
    ObservableQuery.prototype.setVariables = function (variables) {
        if (equal(this.variables, variables)) {
            // If we have no observers, then we don't actually want to make a network
            // request. As soon as someone observes the query, the request will kick
            // off. For now, we just store any changes. (See #1077)
            return this.observers.size ? this.result() : Promise.resolve();
        }
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, NetworkStatus.setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, 
    // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") {
                // When someone chooses "cache-and-network" or "network-only" as their
                // initial FetchPolicy, they often do not want future cache updates to
                // trigger unconditional network requests, which is what repeatedly
                // applying the "cache-and-network" or "network-only" policies would
                // seem to imply. Instead, when the cache reports an update after the
                // initial network request, it may be desirable for subsequent network
                // requests to be triggered only if the cache result is incomplete. To
                // that end, the options.nextFetchPolicy option provides an easy way to
                // update options.fetchPolicy after the initial network request, without
                // having to call observableQuery.setOptions.
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval || !this.hasObservers()) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) {
            return;
        }
        invariant$2(pollInterval, 23);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!isNetworkRequestInFlight(_this.queryInfo.networkStatus) &&
                    !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) {
                    _this.reobserve({
                        // Most fetchPolicy options don't make sense to use in a polling context, as
                        // users wouldn't want to be polling the cache directly. However, network-only and
                        // no-cache are both useful for when the user wants to control whether or not the
                        // polled results are written to the cache.
                        fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ?
                            "no-cache"
                            : "network-only",
                    }, NetworkStatus.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !equal(variables, this.last.variables)) {
            error = void 0;
        }
        return (this.last = __assign$5({ result: this.queryManager.assumeImmutableResults ?
                newResult
                : cloneDeep(newResult), variables: variables }, (error ? { error: error } : null)));
    };
    ObservableQuery.prototype.reobserveAsConcast = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = 
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === NetworkStatus.refetch ||
            // The fetchMore method does not actually call the reobserve method, but,
            // if it did, it would definitely use a disposable Concast.
            newNetworkStatus === NetworkStatus.fetchMore ||
            // Polling uses a disposable Concast so the polling options (which force
            // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
            newNetworkStatus === NetworkStatus.poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = compact(this.options, newOptions || {});
        var options = useDisposableConcast ?
            // Disposable Concast fetches receive a shallow copy of this.options
            // (merged with newOptions), leaving this.options unmodified.
            mergedOptions
            : assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions &&
                newOptions.variables &&
                !equal(newOptions.variables, oldVariables) &&
                // Don't mess with the fetchPolicy if it's currently "standby".
                options.fetchPolicy !== "standby" &&
                // If we're changing the fetchPolicy anyway, don't try to change it here
                // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
                (options.fetchPolicy === oldFetchPolicy ||
                    // A `nextFetchPolicy` function has even higher priority, though,
                    // so in that case `applyNextFetchPolicy` must be called.
                    typeof options.nextFetchPolicy === "function")) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = NetworkStatus.setVariables;
                }
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function () {
            if (_this.concast === concast) {
                _this.waitForOwnResult = false;
            }
        };
        var variables = options.variables && __assign$5({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function (result) {
                if (equal(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function (error) {
                if (equal(_this.variables, variables)) {
                    // Coming from `getResultsFromLink`, `error` here should always be an `ApolloError`.
                    // However, calling `concast.cancel` can inject another type of error, so we have to
                    // wrap it again here.
                    if (!isApolloError(error)) {
                        error = new ApolloError({ networkError: error });
                    }
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            },
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus)
            .promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function () {
        this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) {
            this.updateLastResult(result, variables);
        }
        if (lastError || isDifferent) {
            iterateObserversSafely(this.observers, "next", result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = __assign$5(__assign$5({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: NetworkStatus.error, loading: false });
        this.updateLastResult(errorResult, variables);
        iterateObserversSafely(this.observers, "error", (this.last.error = error));
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function (document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}(Observable));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
fixObservableSubclass(ObservableQuery);
// Reobserve with fetchPolicy effectively set to "cache-first", triggering
// delivery of any new data from the cache, possibly falling back to the network
// if any cache data are missing. This allows _complete_ cache results to be
// delivered without also kicking off unnecessary network requests when
// this.options.fetchPolicy is "cache-and-network" or "network-only". When
// this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
// "standby", or "no-cache"), we call this.reobserve() as usual.
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            // Use a temporary nextFetchPolicy function that replaces itself with the
            // previous nextFetchPolicy value and returns the original fetchPolicy.
            nextFetchPolicy: function (currentFetchPolicy, context) {
                // Replace this nextFetchPolicy function in the options object with the
                // original this.options.nextFetchPolicy value.
                this.nextFetchPolicy = nextFetchPolicy;
                // If the original nextFetchPolicy value was a function, give it a
                // chance to decide what happens here.
                if (typeof this.nextFetchPolicy === "function") {
                    return this.nextFetchPolicy(currentFetchPolicy, context);
                }
                // Otherwise go back to the original this.options.fetchPolicy.
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && invariant$2.error(24, error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (globalThis.__DEV__ !== false && missing) {
        globalThis.__DEV__ !== false && invariant$2.debug(25, missing);
    }
}
function skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */) {
    return (fetchPolicy === "network-only" ||
        fetchPolicy === "no-cache" ||
        fetchPolicy === "standby");
}

var destructiveMethodCounts = new (canUseWeakMap ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        // @ts-expect-error this is just too generic to be typed correctly
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, 
            // The %1e15 allows the count to wrap around to 0 safely every
            // quadrillion evictions, so there's no risk of overflow. To be
            // clear, this is more of a pedantic principle than something
            // that matters in any conceivable practical scenario.
            (destructiveMethodCounts.get(cache) + 1) % 1e15);
            // @ts-expect-error this is just too generic to be typed correctly
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var QueryInfo = /** @class */ (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = (this.cache = queryManager.cache);
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || NetworkStatus.loading;
        if (this.variables &&
            this.networkStatus !== NetworkStatus.loading &&
            !equal(this.variables, query.variables)) {
            networkStatus = NetworkStatus.setVariables;
        }
        if (!equal(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function () {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function () {
        var options = this.getDiffOptions();
        if (this.lastDiff && equal(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff =
            diff ?
                {
                    diff: diff,
                    options: options || this.getDiffOptions(),
                }
                : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we are trying to deliver an incomplete cache result, we avoid
        // reporting it if the query has errored, otherwise we let the broadcast try
        // and repair the partial result by refetching the query. This check avoids
        // a situation where a query that errors and another succeeds with
        // overlapping data does not report the partial data result to the errored
        // query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && ((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.getLastError())) {
            return;
        }
        this.updateLastDiff(diff);
        if (!this.dirty && !equal(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add((this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    // If this diff came from an optimistic transaction, deliver the
                    // current cache data to the ObservableQuery, but don't perform a
                    // reobservation, since oq.reobserveCacheFirst might make a network
                    // request, and we never want to trigger network requests in the
                    // middle of optimistic updates.
                    oq["observe"]();
                }
                else {
                    // Otherwise, make the ObservableQuery "reobserve" the latest data
                    // using a temporary fetch policy of "cache-first", so complete cache
                    // results have a chance to be delivered without triggering additional
                    // network requests, even when options.fetchPolicy is "network-only"
                    // or "cache-and-network". All other fetch policies are preserved by
                    // this method, and are handled by calling oq.reobserve(). If this
                    // reobservation is spurious, isDifferentFromLastResult still has a
                    // chance to catch it before delivery to ObservableQuery subscribers.
                    reobserveCacheFirst(oq);
                }
            }));
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if (isNetworkRequestInFlight(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = __assign$5(__assign$5({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch || !equal(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch((this.lastWatch = watchOptions));
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            // If cache.evict has been called since the last time we wrote this
            // data into the cache, there's a chance writing this result into
            // the cache will repair what was evicted.
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            equal(variables, lastWrite.variables) &&
            equal(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new DeepMerger();
        var graphQLErrors = isNonEmptyArray(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && isNonEmptyArray(result.incremental)) {
            var mergedData = mergeIncrementalData(this.getDiff().result, result);
            result.data = mergedData;
            // Detect the first chunk of a deferred query and merge it with existing
            // cache data. This ensures a `cache-first` fetch policy that returns
            // partial cache data or a `cache-and-network` fetch policy that already
            // has full data in the cache does not complain when trying to merge the
            // initial deferred server data with existing cache data.
        }
        else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                // Using a transaction here so we have a chance to read the result
                // back from the cache before the watch callback fires as a result
                // of writeQuery, so we can store the new diff quietly and ignore
                // it when we receive it redundantly from the watch callback.
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        // If result is the same as the last result we received from
                        // the network (and the variables match too), avoid writing
                        // result into the cache again. The wisdom of skipping this
                        // cache write is far from obvious, since any cache write
                        // could be the one that puts the cache back into a desired
                        // state, fixing corruption or missing data. However, if we
                        // always write every network result into the cache, we enable
                        // feuds between queries competing to update the same data in
                        // incompatible ways, which can lead to an endless cycle of
                        // cache broadcasts and useless network requests. As with any
                        // feud, eventually one side must step back from the brink,
                        // letting the other side(s) have the last word(s). There may
                        // be other points where we could break this cycle, such as
                        // silencing the broadcast for cache.writeQuery (not a good
                        // idea, since it just delays the feud a bit) or somehow
                        // avoiding the network request that just happened (also bad,
                        // because the server could return useful new data). All
                        // options considered, skipping this cache write seems to be
                        // the least damaging place to break the cycle, because it
                        // reflects the intuition that we recently wrote this exact
                        // result into the cache, so the cache *should* already/still
                        // contain this data. If some other query has clobbered that
                        // data in the meantime, that's too bad, but there will be no
                        // winners if every query blindly reverts to its own version
                        // of the data. This approach also gives the network a chance
                        // to return new data, which will be written into the cache as
                        // usual, notifying only those queries that are directly
                        // affected by the cache updates, as usual. In the future, an
                        // even more sophisticated cache could perhaps prevent or
                        // mitigate the clobbering somehow, but that would make this
                        // particular cache write even less important, and thus
                        // skipping it would be even safer than it is today.
                        if (_this.lastDiff && _this.lastDiff.diff.complete) {
                            // Reuse data from the last good (complete) diff that we
                            // received, when possible.
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                        // If the previous this.diff was incomplete, fall through to
                        // re-reading the latest data with cache.diff, below.
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    // In case the QueryManager stops this QueryInfo before its
                    // results are delivered, it's important to avoid restarting the
                    // cache watch when markResult is called. We also avoid updating
                    // the watch if we are writing a result that doesn't match the current
                    // variables to avoid race conditions from broadcasting the wrong
                    // result.
                    if (!_this.stopped && equal(_this.variables, options.variables)) {
                        // Any time we're about to update this.diff, we need to make
                        // sure we've started watching the cache.
                        _this.updateWatch(options.variables);
                    }
                    // If we're allowed to write to the cache, and we can read a
                    // complete result from the cache, update result.data to be the
                    // result from the cache, rather than the raw network result.
                    // Set without setDiff to avoid triggering a notify call, since
                    // we have other ways of notifying for this result.
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return (this.networkStatus = NetworkStatus.ready);
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = NetworkStatus.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());
function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var IGNORE = Object.create(null);
var QueryManager = /** @class */ (function () {
    function QueryManager(options) {
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new AutoCleanedWeakCache(cacheSizes["queryManager.getDocumentInfo"] ||
            2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */);
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new Trie$1(false);
        var defaultDocumentTransform = new DocumentTransform(function (document) { return _this.cache.transformDocument(document); }, 
        // Allow the apollo cache to manage its own transform caches
        { cache: false });
        this.cache = options.cache;
        this.link = options.link;
        this.defaultOptions = options.defaultOptions;
        this.queryDeduplication = options.queryDeduplication;
        this.clientAwareness = options.clientAwareness;
        this.localState = options.localState;
        this.ssrMode = options.ssrMode;
        this.assumeImmutableResults = options.assumeImmutableResults;
        var documentTransform = options.documentTransform;
        this.documentTransform =
            documentTransform ?
                defaultDocumentTransform
                    .concat(documentTransform)
                    // The custom document transform may add new fragment spreads or new
                    // field selections, so we want to give the cache a chance to run
                    // again. For example, the InMemoryCache adds __typename to field
                    // selections and fragments from the fragment registry.
                    .concat(defaultDocumentTransform)
                : defaultDocumentTransform;
        this.defaultContext = options.defaultContext || Object.create(null);
        if ((this.onBroadcast = options.onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches(newInvariantError(26));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        invariant$2(mutation, 27);
                        invariant$2(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 28);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_j.sent());
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        isOptimistic = optimisticResponse &&
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        this.broadcastQueries();
                        self = this;
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, __assign$5(__assign$5({}, context), { optimisticResponse: isOptimistic ? optimisticResponse : void 0 }), variables, {}, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === "none") {
                                        throw new ApolloError({
                                            graphQLErrors: getGraphQLErrorsFromResult(result),
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = __assign$5({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === "ignore" && graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) {
                                            resolve(storeResult);
                                        }
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof ApolloError ? err : (new ApolloError({
                                            networkError: err,
                                        })));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            if (!isExecutionPatchIncrementalResult(result)) {
                cacheWrites.push({
                    result: result.data,
                    dataId: "ROOT_MUTATION",
                    query: mutation.document,
                    variables: mutation.variables,
                });
            }
            if (isExecutionPatchIncrementalResult(result) &&
                isNonEmptyArray(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true,
                });
                var mergedData = void 0;
                if (diff.result) {
                    mergedData = mergeIncrementalData(diff.result, result);
                }
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables,
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    // Read the current query result from the store.
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        // Run our reducer using the current query result and the mutation result.
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: (document && getOperationName(document)) || void 0,
                            queryVariables: variables,
                        });
                        // Write the modified result back into the store if we got a new result.
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: "ROOT_QUERY",
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            (mutation.refetchQueries || "").length > 0 ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !isExecutionPatchResult(result) ||
                        (isExecutionPatchIncrementalResult(result) && !result.hasNext);
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete) {
                                result = __assign$5(__assign$5({}, result), { data: diff.result });
                                if ("incremental" in result) {
                                    delete result.incremental;
                                }
                                if ("hasNext" in result) {
                                    delete result.hasNext;
                                }
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) {
                            update(cache, result, {
                                context: mutation.context,
                                variables: mutation.variables,
                            });
                        }
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) {
                        cache.modify({
                            id: "ROOT_MUTATION",
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                // Returning a promise here makes the mutation await that promise, so we
                // include results in that promise's work if awaitRefetchQueries or an
                // onQueryUpdated function was specified.
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ?
            optimisticResponse(mutation.variables, { IGNORE: IGNORE })
            : optimisticResponse;
        if (data === IGNORE) {
            return false;
        }
        this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult(__assign$5(__assign$5({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                globalThis.__DEV__ !== false && invariant$2.error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast
            .promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: hasClientExports(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: hasDirectives(["nonreactive"], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: removeDirectivesFromDocument([
                    { name: "client", remove: true },
                    { name: "connection" },
                    { name: "nonreactive" },
                ], document),
                defaultVars: getDefaultValues(getOperationDefinition(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: __assign$5(__assign$5({}, document), { definitions: document.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return __assign$5(__assign$5({}, def), { operation: "query" });
                        }
                        return def;
                    }) }),
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return __assign$5(__assign$5({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = __assign$5(__assign$5({}, options), { variables: this.getVariables(query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        invariant$2(options.query, 29);
        invariant$2(options.query.kind === "Document", 30);
        invariant$2(!options.returnPartialData, 31);
        invariant$2(!options.pollInterval, 32);
        return this.fetchQuery(queryId, __assign$5(__assign$5({}, options), { query: this.transform(options.query) })).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches(newInvariantError(33));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                // Set loading to true so listeners don't trigger unless they want
                // results with partial data.
                queryInfo.networkStatus = NetworkStatus.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if (isDocumentNode(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc), false);
                }
                else if (isNonNullObject(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                // We will be issuing a fresh network request for this query, so we
                // pre-allocate a new query ID here, using a special prefix to enable
                // cleaning up these temporary queries later, after fetching.
                var queryId = makeUniqueId("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: __assign$5(__assign$5({}, options), { fetchPolicy: "network-only" }),
                });
                invariant$2(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    globalThis.__DEV__ !== false && invariant$2.warn(typeof nameOrDoc === "string" ? 34 : 35, nameOrDoc);
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" && fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c, _d = _a.extensions, extensions = _d === void 0 ? {} : _d;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables, extensions).map(function (result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: "ROOT_SUBSCRIPTION",
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                var hasErrors = graphQLResultHasError(result);
                var hasProtocolErrors = graphQLResultHasProtocolErrors(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) {
                        errors.graphQLErrors = result.errors;
                    }
                    if (hasProtocolErrors) {
                        errors.protocolErrors = result.extensions[PROTOCOL_ERRORS_SYMBOL];
                    }
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) {
                        throw new ApolloError(errors);
                    }
                }
                if (errorPolicy === "ignore") {
                    delete result.errors;
                }
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState
                .addExportedVariables(query, variables, context)
                .then(makeObservable);
            return new Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return (sub = observable.subscribe(observer)); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, extensions, 
    // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: getOperationName(serverQuery) || void 0,
                context: this.prepareContext(__assign$5(__assign$5({}, context), { forceFetch: !deduplication })),
                extensions: extensions,
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = print(serverQuery);
                var varJson_1 = canonicalStringify(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new Concast([
                        execute(link, operation),
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function () {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            }
            else {
                observable = new Concast([
                    execute(link, operation),
                ]);
            }
        }
        else {
            observable = new Concast([Observable.of({ data: {} })]);
            context = this.prepareContext(context);
        }
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = (queryInfo.lastRequestId = this.generateRequestId());
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = getGraphQLErrorsFromResult(result);
            var hasErrors = graphQLErrors.length > 0;
            var errorPolicy = options.errorPolicy;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && errorPolicy === "none") {
                    // Throwing here effectively calls observer.error.
                    throw queryInfo.markError(new ApolloError({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: NetworkStatus.ready,
            };
            // In the case we start multiple network requests simulatenously, we
            // want to ensure we properly set `data` if we're reporting on an old
            // result which will not be caught by the conditional above that ends up
            // throwing the markError result.
            if (hasErrors && errorPolicy === "none") {
                aqr.data = void 0;
            }
            if (hasErrors && errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = NetworkStatus.error;
            }
            return aqr;
        }, function (networkError) {
            var error = isApolloError(networkError) ? networkError : (new ApolloError({ networkError: networkError }));
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function (queryId, options, 
    // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = NetworkStatus.loading; }
        if (query === void 0) { query = options.query; }
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? (defaults && defaults.fetchPolicy) || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? (defaults && defaults.errorPolicy) || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (
            // If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" &&
                // The "standby" policy currently returns [] from fetchQueryByPolicy, so
                // this is another way to detect when nothing was done/fetched.
                sourcesWithInfo.sources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new Concast(this.localState
                .addExportedVariables(normalized.query, normalized.variables, normalized.context)
                .then(fromVariables)
                .then(function (sourcesWithInfo) { return sourcesWithInfo.sources; }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        }
        else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new Concast(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink,
        };
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? makeUniqueId("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map();
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                // Since you can perform any combination of cache reads and/or writes in
                // the cache.batch update function, its optimistic option can be either
                // a boolean or a string, representing three distinct modes of
                // operation:
                //
                // * false: read/write only the root layer
                // * true: read/write the topmost layer
                // * string: read/write a fresh optimistic layer with that ID string
                //
                // When typeof optimistic === "string", a new optimistic layer will be
                // temporarily created within cache.batch with that string as its ID. If
                // we then pass that same string as the removeOptimistic option, we can
                // make cache.batch immediately remove the optimistic layer after
                // running the updateCache function, triggering only one broadcast.
                //
                // However, the refetchQueries method accepts only true or false for its
                // optimistic option (not string). We interpret true to mean a temporary
                // optimistic layer should be created, to allow efficiently rolling back
                // the effect of the updateCache function, which involves passing a
                // string instead of true as the optimistic option to cache.batch, when
                // refetchQueries receives optimistic: true.
                //
                // In other words, we are deliberately not supporting the use case of
                // writing to an *existing* optimistic layer (using the refetchQueries
                // updateCache function), since that would potentially interfere with
                // other optimistic updates in progress. Instead, you can read/write
                // only the root layer by passing optimistic: false to refetchQueries,
                // or you can read/write a brand new optimistic layer that will be
                // automatically removed by passing optimistic: true.
                optimistic: (optimistic && removeOptimistic) || false,
                // The removeOptimistic option can also be provided by itself, even if
                // optimistic === false, to remove some previously-added optimistic
                // layer safely and efficiently, like we do in markMutationResult.
                //
                // If an explicit removeOptimistic string is provided with optimistic:
                // true, the removeOptimistic string will determine the ID of the
                // temporary optimistic layer, in case that ever matters.
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo && watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            // Since we're about to handle this query now, remove it from
                            // includedQueriesById, in case it was added earlier because of
                            // options.include.
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                // The onQueryUpdated function requested the default refetching
                                // behavior by returning true.
                                result = oq.refetch();
                            }
                            // Record the result in the results Map, as long as onQueryUpdated
                            // did not return false to skip/ignore this result.
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            // Allow the default cache broadcast to happen, except when
                            // onQueryUpdated returns false.
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            // If we don't have an onQueryUpdated function, and onQueryUpdated
                            // was not disabled by passing null, make sure this query is
                            // "included" like any other options.include-specified query.
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                // If onQueryUpdated is provided, we want to use it for all included
                // queries, even the QueryOptions ones.
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset(); // Force info.getDiff() to read from cache.
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                // Otherwise, we fall back to refetching.
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            // In case no updateCache callback was provided (so cache.batch was not
            // called above, and thus did not already remove the optimistic layer),
            // remove it here. Since this is a no-op when the layer has already been
            // removed, we do it even if we called cache.batch above, since it's
            // possible this.cache is an instance of some ApolloCache subclass other
            // than InMemoryCache, and does not fully support the removeOptimistic
            // option for cache.batch.
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, 
    // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || NetworkStatus.loading; }
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !equal(data, {})) {
                logMissingFieldErrors(diff.missing);
            }
            var fromData = function (data) {
                return Observable.of(__assign$5({ data: data, loading: isNetworkRequestInFlight(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true })));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) {
                return _this.localState
                    .runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                })
                    .then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" &&
                networkStatus === NetworkStatus.refetch &&
                Array.isArray(diff.missing)) {
                return fromData(void 0);
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */
            // Watched queries must opt into overwriting existing data on refetch,
            // by passing refetchWritePolicy: "overwrite" in their WatchQueryOptions.
            : (networkStatus === NetworkStatus.refetch &&
                refetchWritePolicy !== "merge") ?
                1 /* CacheWriteBehavior.OVERWRITE */
                : 2 /* CacheWriteBehavior.MERGE */;
        var resultsFromLink = function () {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            isNetworkRequestInFlight(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return {
                        fromLink: false,
                        sources: [resultsFromCache(diff, queryInfo.markReady())],
                    };
                }
                if (returnPartialData || shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(diff), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(diff), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [resultsFromCache(readCache(), queryInfo.markReady())],
                };
            case "network-only":
                if (shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(readCache()), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "no-cache":
                if (shouldNotify) {
                    return {
                        fromLink: true,
                        // Note that queryInfo.getDiff() for no-cache queries does not call
                        // cache.diff, but instead returns a { complete: false } stub result
                        // when there is no queryInfo.diff already defined.
                        sources: [resultsFromCache(queryInfo.getDiff()), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "standby":
                return { fromLink: false, sources: [] };
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return __assign$5(__assign$5(__assign$5({}, this.defaultContext), newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

var LocalState = /** @class */ (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = mergeDeep(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return __generator(this, function (_d) {
                if (document) {
                    return [2 /*return*/, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return (__assign$5(__assign$5({}, remoteResult), { data: localResult.result })); })];
                }
                return [2 /*return*/, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function (document) {
        if (hasDirectives(["client"], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function (document) {
        return removeClientSetsFromDocument(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return __assign$5(__assign$5({}, context), { cache: cache, 
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function (document_1) {
        return __awaiter(this, arguments, void 0, function (document, variables, context) {
            if (variables === void 0) { variables = {}; }
            if (context === void 0) { context = {}; }
            return __generator(this, function (_a) {
                if (document) {
                    return [2 /*return*/, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return (__assign$5(__assign$5({}, variables), data.exportedVariables)); })];
                }
                return [2 /*return*/, __assign$5({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        visit(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === "always" &&
                                arg.value.kind === "BooleanValue" &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return BREAK;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: buildQueryFromSelectionSet(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document_1, rootValue_1) {
        return __awaiter(this, arguments, void 0, function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) { context = {}; }
            if (variables === void 0) { variables = {}; }
            if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
            if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
            return __generator(this, function (_b) {
                mainDefinition = getMainDefinition(document);
                fragments = getFragmentDefinitions(document);
                fragmentMap = createFragmentMap(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ?
                    definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: __assign$5(__assign$5({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                isClientFieldDescendant = false;
                return [2 /*return*/, this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return __awaiter(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return __generator(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return __awaiter(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return __generator(this, function (_a) {
                        if (!isClientFieldDescendant &&
                            !execContext.selectionsToResolve.has(selection)) {
                            // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [2 /*return*/];
                        }
                        if (!shouldInclude(selection, variables)) {
                            // Skip this entirely.
                            return [2 /*return*/];
                        }
                        if (isField(selection)) {
                            return [2 /*return*/, this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") {
                                        resultsToMerge.push((_a = {},
                                            _a[resultKeyNameFromField(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (isInlineFragment(selection)) {
                            fragment = selection;
                        }
                        else {
                            // This is a named fragment.
                            fragment = fragmentMap[selection.name.value];
                            invariant$2(fragment, 18, selection.name.value);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2 /*return*/, this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2 /*return*/];
                    });
                }); };
                return [2 /*return*/, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return mergeDeepArray(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, isClientFieldDescendant, rootValue, execContext) {
        return __awaiter(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return __generator(this, function (_a) {
                if (!rootValue) {
                    return [2 /*return*/, null];
                }
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = resultKeyNameFromField(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(
                            // In case the resolve function accesses reactive variables,
                            // set cacheSlot to the current cache instance.
                            cacheSlot.withValue(this.cache, resolve, [
                                rootValue,
                                argumentsObjectFromField(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2 /*return*/, resultPromise.then(function (result) {
                        var _a, _b;
                        if (result === void 0) { result = defaultResult; }
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === "export" && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === "as" && arg.value.kind === "StringValue") {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        // Handle all scalar types here.
                        if (!field.selectionSet) {
                            return result;
                        }
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) {
                            // Basically any field in a GraphQL response can be null, or missing
                            return result;
                        }
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function (d) { return d.name.value === "client"; })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        }
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse.
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            }
            // This is an object, run the selection set on it.
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
            }
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function (mainDefinition, fragmentMap) {
        var isSingleASTNode = function (node) { return !Array.isArray(node); };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                visit(definitionNode, {
                    Directive: function (node, _, __, ___, ancestors) {
                        if (node.name.value === "client") {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                        }
                    },
                    FragmentSpread: function (spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        invariant$2(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function (selection) {
                                matches_1.add(selection);
                            });
                        }
                    },
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}());

var hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */
var ApolloClient = /** @class */ (function () {
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) {
            throw newInvariantError(15);
        }
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, 
        // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? cache.assumeImmutableResults : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version, devtools = options.devtools;
        var link = options.link;
        if (!link) {
            link =
                uri ? new HttpLink({ uri: uri, credentials: credentials, headers: headers }) : ApolloLink.empty();
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        this.devtoolsConfig = __assign$5(__assign$5({}, devtools), { enabled: (devtools === null || devtools === void 0 ? void 0 : devtools.enabled) || connectToDevTools });
        if (this.devtoolsConfig.enabled === undefined) {
            this.devtoolsConfig.enabled = globalThis.__DEV__ !== false;
        }
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.watchFragment = this.watchFragment.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: this.devtoolsConfig.enabled ?
                function () {
                    if (_this.devToolsHookCb) {
                        _this.devToolsHookCb({
                            action: {},
                            state: {
                                queries: _this.queryManager.getQueryStore(),
                                mutations: _this.queryManager.mutationStore || {},
                            },
                            dataWithOptimisticResults: _this.cache.extract(true),
                        });
                    }
                }
                : void 0,
        });
        if (this.devtoolsConfig.enabled)
            this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function () {
        if (typeof window === "undefined") {
            return;
        }
        var windowWithDevTools = window;
        var devtoolsSymbol = Symbol.for("apollo.devtools");
        (windowWithDevTools[devtoolsSymbol] =
            windowWithDevTools[devtoolsSymbol] || []).push(this);
        windowWithDevTools.__APOLLO_CLIENT__ = this;
        /**
         * Suggest installing the devtools for developers who don't have them
         */
        if (!hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            hasSuggestedDevtools = true;
            if (window.document &&
                window.top === window.self &&
                /^(https?|file):$/.test(window.location.protocol)) {
                setTimeout(function () {
                    if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                        var nav = window.navigator;
                        var ua = nav && nav.userAgent;
                        var url = void 0;
                        if (typeof ua === "string") {
                            if (ua.indexOf("Chrome/") > -1) {
                                url =
                                    "https://chrome.google.com/webstore/detail/" +
                                        "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                            }
                            else if (ua.indexOf("Firefox/") > -1) {
                                url =
                                    "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                            }
                        }
                        if (url) {
                            globalThis.__DEV__ !== false && invariant$2.log("Download the Apollo DevTools for a better development " +
                                "experience: %s", url);
                        }
                    }
                }, 10000);
            }
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */
        get: function () {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through an observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = mergeOptions(this.defaultOptions.watchQuery, options);
        }
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === "network-only" ||
                options.fetchPolicy === "cache-and-network")) {
            options = __assign$5(__assign$5({}, options), { fetchPolicy: "cache-first" });
        }
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = mergeOptions(this.defaultOptions.query, options);
        }
        invariant$2(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") {
            options = __assign$5(__assign$5({}, options), { fetchPolicy: "cache-first" });
        }
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = mergeOptions(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Watches the cache store of the fragment according to the options specified
     * and returns an `Observable`. We can subscribe to this
     * `Observable` and receive updated results through an
     * observer when the cache store changes.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @since 3.10.0
     * @param options - An object of type `WatchFragmentOptions` that allows
     * the cache to identify the fragment and optionally specify whether to react
     * to optimistic updates.
     */
    ApolloClient.prototype.watchFragment = function (options) {
        return this.cache.watchFragment(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */
    ApolloClient.prototype.writeQuery = function (options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */
    ApolloClient.prototype.writeFragment = function (options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return execute(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager.clearStore({
                discardWatches: false,
            });
        })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager.clearStore({
                discardWatches: true,
            });
        })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function (error) {
            globalThis.__DEV__ !== false && invariant$2.debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function () {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}());
if (globalThis.__DEV__ !== false) {
    ApolloClient.prototype.getMemoryInternals = getApolloClientMemoryInternals;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$4 = function() {
    __assign$4 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$4.apply(this, arguments);
};

var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return __assign$4(__assign$4({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse$1(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;

function buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    // If we're jittering, baseDelay is half of the maximum delay for that
    // attempt (and is, on average, the delay we will encounter).
    // If we're not jittering, adjust baseDelay so that the first attempt
    // lines up with initialDelay, for everyone's sanity.
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) {
            // We opt for a full jitter approach for a mostly uniform distribution,
            // but bound it within initialDelay and delay for everyone's sanity.
            delay = Math.random() * delay;
        }
        return delay;
    };
}

function buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max)
            return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}

/**
 * Tracking and management of operations that may be (or currently are) retried.
 */
var RetryableOperation = /** @class */ (function () {
    function RetryableOperation(observer, operation, forward, delayFor, retryIf) {
        var _this = this;
        this.observer = observer;
        this.operation = operation;
        this.forward = forward;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.currentSubscription = null;
        this.onError = function (error) { return __awaiter(_this, void 0, void 0, function () {
            var shouldRetry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.retryCount += 1;
                        return [4 /*yield*/, this.retryIf(this.retryCount, this.operation, error)];
                    case 1:
                        shouldRetry = _a.sent();
                        if (shouldRetry) {
                            this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                            return [2 /*return*/];
                        }
                        this.observer.error(error);
                        return [2 /*return*/];
                }
            });
        }); };
        this.try();
    }
    /**
     * Stop retrying for the operation, and cancel any in-progress requests.
     */
    RetryableOperation.prototype.cancel = function () {
        if (this.currentSubscription) {
            this.currentSubscription.unsubscribe();
        }
        clearTimeout(this.timerId);
        this.timerId = undefined;
        this.currentSubscription = null;
    };
    RetryableOperation.prototype.try = function () {
        this.currentSubscription = this.forward(this.operation).subscribe({
            next: this.observer.next.bind(this.observer),
            error: this.onError,
            complete: this.observer.complete.bind(this.observer),
        });
    };
    RetryableOperation.prototype.scheduleRetry = function (delay) {
        var _this = this;
        if (this.timerId) {
            throw new Error("RetryLink BUG! Encountered overlapping retries");
        }
        this.timerId = setTimeout(function () {
            _this.timerId = undefined;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}());
var RetryLink = /** @class */ (function (_super) {
    __extends$3(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor =
            typeof delay === "function" ? delay : buildDelayFunction(delay);
        _this.retryIf =
            typeof attempts === "function" ? attempts : buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function (operation, nextLink) {
        var _this = this;
        return new Observable(function (observer) {
            var retryable = new RetryableOperation(observer, operation, nextLink, _this.delayFor, _this.retryIf);
            return function () {
                retryable.cancel();
            };
        });
    };
    return RetryLink;
}(ApolloLink));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const nonDirectoryFields = [
    'repo_size',
    'repo_version',
    {
        'renditionLink': ['href', 'templated']
    },
    {
        'blockDownloadLink': ['href', 'templated']
    },
    {
        'blockUploadLink': ['href', 'templated']
    }
];
const directoryFields = [
    {
        'pageLink': ['href', 'templated']
    },
    {
        'blockUploadLink': ['href', 'templated']
    }
];
const GQLSpecialFolderFields = [
    'dc_format',
    'repo_ancestors',
    'repo_assetClass',
    'repo_assetId',
    'repo_createDate',
    {
        'repo_createdBy': ['id']
    },
    'repo_modifiedBy',
    'repo_modifyDate',
    'repo_name',
    'repo_path',
    'repo_state',
    {
        'storage_assignee': ['id', 'type']
    },
    'storage_deviceCreateDate',
    'storage_deviceModifyDate',
    'storage_region',
    {
        'repository': [
            'repo_repositoryId',
            {
                'repo_owner': ['id', 'type']
            },
            'repo_repositoryType'
        ]
    },
    {
        'primaryLink': ['href', 'templated']
    },
    {
        operation: 'Directory',
        fields: directoryFields,
        fragment: true
    }
];
const baseAssetFields = [
    {
        'appMetadata': ['am: valueOf(key: "")']
    },
    'dc_format',
    {
        'labels': ['lastAccessDate', { favorite: ['isFavorite'] }]
    },
    {
        'effectivePermissions': ['default', 'primary', 'applicationMetadata', 'aclPolicy', 'directory', 'annotations']
    },
    'repo_ancestors',
    'repo_assetClass',
    'repo_assetId',
    'repo_createDate',
    {
        'repo_createdBy': ['id']
    },
    'repo_modifiedBy',
    'repo_modifyDate',
    'repo_name',
    'repo_path',
    'repo_state',
    {
        'storage_assignee': ['id', 'type']
    },
    'storage_deviceCreateDate',
    'storage_deviceModifyDate',
    'storage_region',
    {
        'repository': [
            'repo_repositoryId',
            {
                'repo_owner': ['id', 'type']
            },
            'repo_repositoryType'
        ]
    },
    {
        'primaryLink': ['href', 'templated']
    },
];
const GQLResolveAssetFields = [
    ...baseAssetFields,
    {
        operation: 'Composite',
        fields: nonDirectoryFields,
        fragment: true
    },
    {
        operation: 'File',
        fields: nonDirectoryFields,
        fragment: true
    },
    {
        operation: 'Directory',
        fields: directoryFields,
        fragment: true
    }
];
var Privelege;
(function (Privelege) {
    Privelege["READ"] = "READ";
    Privelege["WRITE"] = "WRITE";
    Privelege["ACK"] = "ACK";
    Privelege["DELETE"] = "DELETE";
})(Privelege || (Privelege = {}));

var build = {};

var adapters = {};

var DefaultAppSyncMutationAdapter$1 = {};

var OperationType$1 = {};

Object.defineProperty(OperationType$1, "__esModule", { value: true });
var OperationType;
(function (OperationType) {
    OperationType["Mutation"] = "mutation";
    OperationType["Query"] = "query";
    OperationType["Subscription"] = "subscription";
})(OperationType || (OperationType = {}));
OperationType$1.default = OperationType;

var Utils$1 = {};

var NestedField = {};

Object.defineProperty(NestedField, "__esModule", { value: true });
NestedField.isNestedField = void 0;
function isNestedField(object) {
    return ((typeof object === "object" &&
        object.hasOwnProperty("operation") &&
        object.hasOwnProperty("variables") &&
        object.hasOwnProperty("fields")) ||
        (typeof object === "object" &&
            object.hasOwnProperty("operation") &&
            object.hasOwnProperty("fragment") &&
            object.hasOwnProperty("fields")));
}
NestedField.isNestedField = isNestedField;

var __assign$3 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
Object.defineProperty(Utils$1, "__esModule", { value: true });
var NestedField_1 = NestedField;
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.resolveVariables = function (operations) {
        var ret = {};
        for (var _i = 0, operations_1 = operations; _i < operations_1.length; _i++) {
            var _a = operations_1[_i], variables = _a.variables, fields = _a.fields;
            ret = __assign$3(__assign$3(__assign$3({}, ret), variables), ((fields && Utils.getNestedVariables(fields)) || {}));
        }
        return ret;
    };
    // Convert object to name and argument map. eg: (id: $id)
    Utils.queryDataNameAndArgumentMap = function (variables) {
        return variables && Object.keys(variables).length
            ? "(".concat(Object.entries(variables).reduce(function (dataString, _a, i) {
                var key = _a[0], value = _a[1];
                return "".concat(dataString).concat(i !== 0 ? ", " : "").concat(value && value.name ? value.name : key, ": $").concat(key);
            }, ""), ")")
            : "";
    };
    Utils.queryFieldsMap = function (fields) {
        var _this = this;
        return fields
            ? fields
                .map(function (field) {
                if ((0, NestedField_1.isNestedField)(field)) {
                    return Utils.queryNestedFieldMap(field);
                }
                else if (typeof field === "object") {
                    var result_1 = "";
                    Object.entries(field).forEach(function (_a, index, array) {
                        var key = _a[0], values = _a[1];
                        result_1 += "".concat(key, " ").concat(values.length > 0
                            ? "{ " + _this.queryFieldsMap(values) + " }"
                            : "");
                        // If it's not the last item in array, join with comma
                        if (index < array.length - 1) {
                            result_1 += ", ";
                        }
                    });
                    return result_1;
                }
                else {
                    return "".concat(field);
                }
            })
                .join(", ")
            : "";
    };
    Utils.operationOrAlias = function (operation) {
        return typeof operation === "string"
            ? operation
            : "".concat(operation.alias, ": ").concat(operation.name);
    };
    Utils.isFragment = function (field) {
        var _a;
        return (_a = (field === null || field === void 0 ? void 0 : field.fragment) === true) !== null && _a !== void 0 ? _a : false;
    };
    Utils.operationOrFragment = function (field) {
        return Utils.isFragment(field)
            ? field.operation
            : Utils.operationOrAlias(field.operation);
    };
    Utils.getFragment = function (field) {
        return Utils.isFragment(field) ? "... on " : "";
    };
    Utils.queryNestedFieldMap = function (field) {
        return "".concat(Utils.getFragment(field)).concat(Utils.operationOrFragment(field), " ").concat(this.isFragment(field)
            ? ""
            : this.queryDataNameAndArgumentMap(field.variables), " ").concat(field.fields.length > 0
            ? "{ " + this.queryFieldsMap(field.fields) + " }"
            : "");
    };
    // Variables map. eg: { "id": 1, "name": "Jon Doe" }
    Utils.queryVariablesMap = function (variables, fields) {
        var variablesMapped = {};
        var update = function (vars) {
            if (vars) {
                Object.keys(vars).map(function (key) {
                    variablesMapped[key] =
                        typeof vars[key] === "object" ? vars[key].value : vars[key];
                });
            }
        };
        update(variables);
        if (fields && typeof fields === "object") {
            update(Utils.getNestedVariables(fields));
        }
        return variablesMapped;
    };
    Utils.getNestedVariables = function (fields) {
        var variables = {};
        function getDeepestVariables(innerFields) {
            innerFields === null || innerFields === void 0 ? void 0 : innerFields.forEach(function (field) {
                if ((0, NestedField_1.isNestedField)(field)) {
                    variables = __assign$3(__assign$3(__assign$3({}, field.variables), variables), (field.fields && getDeepestVariables(field.fields)));
                }
                else {
                    if (typeof field === "object") {
                        for (var _i = 0, _a = Object.entries(field); _i < _a.length; _i++) {
                            var _b = _a[_i], value = _b[1];
                            getDeepestVariables(value);
                        }
                    }
                }
            });
            return variables;
        }
        getDeepestVariables(fields);
        return variables;
    };
    Utils.queryDataType = function (variable) {
        var type = "String";
        var value = typeof variable === "object" ? variable.value : variable;
        if ((variable === null || variable === void 0 ? void 0 : variable.type) != null) {
            type = variable.type;
        }
        else {
            // TODO: Should handle the undefined value (either in array value or single value)
            var candidateValue = Array.isArray(value) ? value[0] : value;
            switch (typeof candidateValue) {
                case "object":
                    type = "Object";
                    break;
                case "boolean":
                    type = "Boolean";
                    break;
                case "number":
                    type = candidateValue % 1 === 0 ? "Int" : "Float";
                    break;
            }
        }
        // set object based variable properties
        if (typeof variable === "object") {
            if (variable.list === true) {
                type = "[".concat(type, "]");
            }
            else if (Array.isArray(variable.list)) {
                type = "[".concat(type).concat(variable.list[0] ? "!" : "", "]");
            }
            if (variable.required) {
                type += "!";
            }
        }
        return type;
    };
    return Utils;
}());
Utils$1.default = Utils;

Object.defineProperty(DefaultAppSyncMutationAdapter$1, "__esModule", { value: true });
var OperationType_1$4 = OperationType$1;
var Utils_1$4 = Utils$1;
var DefaultAppSyncMutationAdapter = /** @class */ (function () {
    function DefaultAppSyncMutationAdapter(options) {
        if (Array.isArray(options)) {
            this.variables = Utils_1$4.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields;
            this.operation = options.operation;
        }
    }
    DefaultAppSyncMutationAdapter.prototype.mutationBuilder = function () {
        return this.operationWrapperTemplate(this.variables, this.operationTemplate(this.operation));
    };
    DefaultAppSyncMutationAdapter.prototype.mutationsBuilder = function (mutations) {
        var _this = this;
        var content = mutations.map(function (opts) {
            _this.operation = opts.operation;
            _this.variables = opts.variables;
            _this.fields = opts.fields;
            return _this.operationTemplate(opts.operation);
        });
        return this.operationWrapperTemplate(Utils_1$4.default.resolveVariables(mutations), content.join("\n  "));
    };
    // Convert object to name and argument map. eg: (id: $id)
    DefaultAppSyncMutationAdapter.prototype.queryDataNameAndArgumentMap = function () {
        return this.variables && Object.keys(this.variables).length
            ? "(".concat(Object.keys(this.variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "").concat(key, ": $").concat(key);
            }, ""), ")")
            : "";
    };
    DefaultAppSyncMutationAdapter.prototype.queryDataArgumentAndTypeMap = function (variables) {
        return Object.keys(variables).length
            ? "(".concat(Object.keys(variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(Utils_1$4.default.queryDataType(variables[key]));
            }, ""), ")")
            : "";
    };
    // start of mutation building
    DefaultAppSyncMutationAdapter.prototype.operationWrapperTemplate = function (variables, content) {
        var operation = typeof this.operation === "string" ? this.operation : this.operation.name;
        return {
            query: "".concat(OperationType_1$4.default.Mutation, " ").concat(operation.charAt(0).toUpperCase() + operation.slice(1), " ").concat(this.queryDataArgumentAndTypeMap(variables), " {\n  ").concat(content, "\n}"),
            variables: Utils_1$4.default.queryVariablesMap(variables),
        };
    };
    DefaultAppSyncMutationAdapter.prototype.operationTemplate = function (operation) {
        var operationName = typeof operation === "string"
            ? operation
            : "".concat(operation.alias, ": ").concat(operation.name);
        return "".concat(operationName, " ").concat(this.queryDataNameAndArgumentMap(), " {\n    ").concat(this.queryFieldsMap(this.fields), "\n  }");
    };
    // Fields selection map. eg: { id, name }
    DefaultAppSyncMutationAdapter.prototype.queryFieldsMap = function (fields) {
        var _this = this;
        return Array.isArray(fields)
            ? fields
                .map(function (field) {
                return typeof field === "object"
                    ? "".concat(Object.keys(field)[0], " { ").concat(_this.queryFieldsMap(Object.values(field)[0]), " }")
                    : "".concat(field);
            })
                .join(", ")
            : "";
    };
    return DefaultAppSyncMutationAdapter;
}());
DefaultAppSyncMutationAdapter$1.default = DefaultAppSyncMutationAdapter;

var DefaultAppSyncQueryAdapter$1 = {};

Object.defineProperty(DefaultAppSyncQueryAdapter$1, "__esModule", { value: true });
var OperationType_1$3 = OperationType$1;
var Utils_1$3 = Utils$1;
var DefaultAppSyncQueryAdapter = /** @class */ (function () {
    function DefaultAppSyncQueryAdapter(options) {
        this.queryDataType = function (variable) {
            var type = "String";
            var value = typeof variable === "object" ? variable.value : variable;
            if (variable.type !== undefined) {
                type = variable.type;
            }
            else {
                switch (typeof value) {
                    case "object":
                        type = "Object";
                        break;
                    case "boolean":
                        type = "Boolean";
                        break;
                    case "number":
                        type = value % 1 === 0 ? "Int" : "Float";
                        break;
                }
            }
            if (typeof variable === "object" && variable.required) {
                type += "!";
            }
            return type;
        };
        if (Array.isArray(options)) {
            this.variables = Utils_1$3.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields || [];
            this.operation = options.operation;
        }
    }
    // kicks off building for a single query
    DefaultAppSyncQueryAdapter.prototype.queryBuilder = function () {
        return this.operationWrapperTemplate(this.operationTemplate());
    };
    // if we have an array of options, call this
    DefaultAppSyncQueryAdapter.prototype.queriesBuilder = function (queries) {
        var _this = this;
        var content = function () {
            var tmpl = [];
            queries.forEach(function (query) {
                if (query) {
                    _this.operation = query.operation;
                    _this.fields = query.fields;
                    _this.variables = query.variables;
                    tmpl.push(_this.operationTemplate());
                }
            });
            return tmpl.join(" ");
        };
        return this.operationWrapperTemplate(content());
    };
    // Convert object to name and argument map. eg: (id: $id)
    DefaultAppSyncQueryAdapter.prototype.queryDataNameAndArgumentMap = function () {
        return this.variables && Object.keys(this.variables).length
            ? "(".concat(Object.keys(this.variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "").concat(key, ": $").concat(key);
            }, ""), ")")
            : "";
    };
    // Convert object to argument and type map. eg: ($id: Int)
    DefaultAppSyncQueryAdapter.prototype.queryDataArgumentAndTypeMap = function () {
        var _this = this;
        return this.variables && Object.keys(this.variables).length
            ? "(".concat(Object.keys(this.variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(_this.queryDataType(_this.variables[key]));
            }, ""), ")")
            : "";
    };
    DefaultAppSyncQueryAdapter.prototype.operationWrapperTemplate = function (content) {
        var operation = typeof this.operation === "string" ? this.operation : this.operation.name;
        return {
            query: "".concat(OperationType_1$3.default.Query, " ").concat(operation
                .charAt(0)
                .toUpperCase()).concat(operation.slice(1), " ").concat(this.queryDataArgumentAndTypeMap(), " { ").concat(content, " }"),
            variables: Utils_1$3.default.queryVariablesMap(this.variables),
        };
    };
    // query
    DefaultAppSyncQueryAdapter.prototype.operationTemplate = function () {
        var operation = typeof this.operation === "string"
            ? this.operation
            : "".concat(this.operation.alias, ": ").concat(this.operation.name);
        return "".concat(operation, " ").concat(this.queryDataNameAndArgumentMap(), " { nodes { ").concat(Utils_1$3.default.queryFieldsMap(this.fields), " } }");
    };
    return DefaultAppSyncQueryAdapter;
}());
DefaultAppSyncQueryAdapter$1.default = DefaultAppSyncQueryAdapter;

Object.defineProperty(adapters, "__esModule", { value: true });
var DefaultAppSyncMutationAdapter_1 = DefaultAppSyncMutationAdapter$1;
var DefaultAppSyncQueryAdapter_1 = DefaultAppSyncQueryAdapter$1;
adapters.default = { DefaultAppSyncQueryAdapter: DefaultAppSyncQueryAdapter_1.default, DefaultAppSyncMutationAdapter: DefaultAppSyncMutationAdapter_1.default };

var DefaultMutationAdapter$1 = {};

var __assign$2 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
Object.defineProperty(DefaultMutationAdapter$1, "__esModule", { value: true });
var OperationType_1$2 = OperationType$1;
var Utils_1$2 = Utils$1;
var DefaultMutationAdapter = /** @class */ (function () {
    function DefaultMutationAdapter(options, configuration) {
        var _this = this;
        if (Array.isArray(options)) {
            this.variables = Utils_1$2.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields;
            this.operation = options.operation;
        }
        // Default configs
        this.config = {
            operationName: "",
        };
        if (configuration) {
            Object.entries(configuration).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                _this.config[key] = value;
            });
        }
    }
    DefaultMutationAdapter.prototype.mutationBuilder = function () {
        return this.operationWrapperTemplate(OperationType_1$2.default.Mutation, this.variables, this.operationTemplate(this.operation));
    };
    DefaultMutationAdapter.prototype.mutationsBuilder = function (mutations) {
        var _this = this;
        var content = mutations.map(function (opts) {
            _this.operation = opts.operation;
            _this.variables = opts.variables;
            _this.fields = opts.fields;
            return _this.operationTemplate(opts.operation);
        });
        return this.operationWrapperTemplate(OperationType_1$2.default.Mutation, Utils_1$2.default.resolveVariables(mutations), content.join("\n  "));
    };
    DefaultMutationAdapter.prototype.queryDataArgumentAndTypeMap = function (variablesUsed) {
        if (this.fields && typeof this.fields === "object") {
            variablesUsed = __assign$2(__assign$2({}, Utils_1$2.default.getNestedVariables(this.fields)), variablesUsed);
        }
        return variablesUsed && Object.keys(variablesUsed).length > 0
            ? "(".concat(Object.keys(variablesUsed).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(Utils_1$2.default.queryDataType(variablesUsed[key]));
            }, ""), ")")
            : "";
    };
    // start of mutation building
    DefaultMutationAdapter.prototype.operationWrapperTemplate = function (type, variables, content) {
        var query = "".concat(type, " ").concat(this.queryDataArgumentAndTypeMap(variables), " {\n      ").concat(content, "\n    }");
        if (this.config.operationName) {
            query = query.replace("mutation", "mutation ".concat(this.config.operationName));
        }
        return {
            query: query,
            variables: Utils_1$2.default.queryVariablesMap(variables, this.fields),
        };
    };
    DefaultMutationAdapter.prototype.operationTemplate = function (operation) {
        var operationName = typeof operation === "string"
            ? operation
            : "".concat(operation.alias, ": ").concat(operation.name);
        return "".concat(operationName, " ").concat(Utils_1$2.default.queryDataNameAndArgumentMap(this.variables), " ").concat(this.fields && this.fields.length > 0
            ? "{\n    ".concat(Utils_1$2.default.queryFieldsMap(this.fields), "\n  }")
            : "");
    };
    return DefaultMutationAdapter;
}());
DefaultMutationAdapter$1.default = DefaultMutationAdapter;

var DefaultQueryAdapter$1 = {};

var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(DefaultQueryAdapter$1, "__esModule", { value: true });
var OperationType_1$1 = OperationType$1;
var Utils_1$1 = Utils$1;
var DefaultQueryAdapter = /** @class */ (function () {
    function DefaultQueryAdapter(options, configuration) {
        var _this = this;
        // Default configs
        this.config = {
            operationName: "",
        };
        if (configuration) {
            Object.entries(configuration).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                _this.config[key] = value;
            });
        }
        if (Array.isArray(options)) {
            this.variables = Utils_1$1.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields || [];
            this.operation = options.operation;
        }
    }
    // kicks off building for a single query
    DefaultQueryAdapter.prototype.queryBuilder = function () {
        return this.operationWrapperTemplate(this.operationTemplate(this.variables));
    };
    // if we have an array of options, call this
    DefaultQueryAdapter.prototype.queriesBuilder = function (queries) {
        var _this = this;
        var content = function () {
            var tmpl = [];
            queries.forEach(function (query) {
                if (query) {
                    _this.operation = query.operation;
                    _this.fields = query.fields;
                    tmpl.push(_this.operationTemplate(query.variables));
                }
            });
            return tmpl.join(" ");
        };
        return this.operationWrapperTemplate(content());
    };
    // Convert object to argument and type map. eg: ($id: Int)
    DefaultQueryAdapter.prototype.queryDataArgumentAndTypeMap = function () {
        var variablesUsed = this.variables;
        if (this.fields && typeof this.fields === "object") {
            variablesUsed = __assign$1(__assign$1({}, Utils_1$1.default.getNestedVariables(this.fields)), variablesUsed);
        }
        return variablesUsed && Object.keys(variablesUsed).length > 0
            ? "(".concat(Object.keys(variablesUsed).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(Utils_1$1.default.queryDataType(variablesUsed[key]));
            }, ""), ")")
            : "";
    };
    DefaultQueryAdapter.prototype.operationWrapperTemplate = function (content) {
        var query = "".concat(OperationType_1$1.default.Query, " ").concat(this.queryDataArgumentAndTypeMap(), " { ").concat(content, " }");
        query = query.replace("query", "query".concat(this.config.operationName !== "" ? " " + this.config.operationName : ""));
        return {
            query: query,
            variables: Utils_1$1.default.queryVariablesMap(this.variables, this.fields),
        };
    };
    // query
    DefaultQueryAdapter.prototype.operationTemplate = function (variables) {
        var operation = typeof this.operation === "string"
            ? this.operation
            : "".concat(this.operation.alias, ": ").concat(this.operation.name);
        return "".concat(operation, " ").concat(variables ? Utils_1$1.default.queryDataNameAndArgumentMap(variables) : "", " ").concat(this.fields && this.fields.length > 0
            ? "{ " + Utils_1$1.default.queryFieldsMap(this.fields) + " }"
            : "");
    };
    return DefaultQueryAdapter;
}());
DefaultQueryAdapter$1.default = DefaultQueryAdapter;

var DefaultSubscriptionAdapter$1 = {};

Object.defineProperty(DefaultSubscriptionAdapter$1, "__esModule", { value: true });
var OperationType_1 = OperationType$1;
var Utils_1 = Utils$1;
var DefaultSubscriptionAdapter = /** @class */ (function () {
    function DefaultSubscriptionAdapter(options) {
        if (Array.isArray(options)) {
            this.variables = Utils_1.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields;
            this.operation = options.operation;
        }
    }
    DefaultSubscriptionAdapter.prototype.subscriptionBuilder = function () {
        return this.operationWrapperTemplate(OperationType_1.default.Subscription, this.variables, this.operationTemplate(this.operation));
    };
    DefaultSubscriptionAdapter.prototype.subscriptionsBuilder = function (subscriptions) {
        var _this = this;
        var content = subscriptions.map(function (opts) {
            _this.operation = opts.operation;
            _this.variables = opts.variables;
            _this.fields = opts.fields;
            return _this.operationTemplate(opts.operation);
        });
        return this.operationWrapperTemplate(OperationType_1.default.Subscription, Utils_1.default.resolveVariables(subscriptions), content.join("\n  "));
    };
    // Convert object to name and argument map. eg: (id: $id)
    DefaultSubscriptionAdapter.prototype.queryDataNameAndArgumentMap = function () {
        return this.variables && Object.keys(this.variables).length
            ? "(".concat(Object.keys(this.variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "").concat(key, ": $").concat(key);
            }, ""), ")")
            : "";
    };
    DefaultSubscriptionAdapter.prototype.queryDataArgumentAndTypeMap = function (variables) {
        return Object.keys(variables).length
            ? "(".concat(Object.keys(variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(Utils_1.default.queryDataType(variables[key]));
            }, ""), ")")
            : "";
    };
    // start of subscription building
    DefaultSubscriptionAdapter.prototype.operationWrapperTemplate = function (type, variables, content) {
        return {
            query: "".concat(type, " ").concat(this.queryDataArgumentAndTypeMap(variables), " {\n  ").concat(content, "\n}"),
            variables: Utils_1.default.queryVariablesMap(variables),
        };
    };
    DefaultSubscriptionAdapter.prototype.operationTemplate = function (operation) {
        var operationName = typeof this.operation === "string"
            ? this.operation
            : "".concat(this.operation.alias, ": ").concat(this.operation.name);
        return "".concat(operationName, " ").concat(this.queryDataNameAndArgumentMap(), " {\n    ").concat(this.queryFieldsMap(this.fields), "\n  }");
    };
    // Fields selection map. eg: { id, name }
    DefaultSubscriptionAdapter.prototype.queryFieldsMap = function (fields) {
        var _this = this;
        return fields
            ? fields
                .map(function (field) {
                return typeof field === "object"
                    ? "".concat(Object.keys(field)[0], " { ").concat(_this.queryFieldsMap(Object.values(field)[0]), " }")
                    : "".concat(field);
            })
                .join(", ")
            : "";
    };
    return DefaultSubscriptionAdapter;
}());
DefaultSubscriptionAdapter$1.default = DefaultSubscriptionAdapter;

Object.defineProperty(build, "__esModule", { value: true });
build.adapters = query = build.query = build.mutation = build.subscription = void 0;
var adapters_1 = adapters;
build.adapters = adapters_1.default;
var DefaultMutationAdapter_1 = DefaultMutationAdapter$1;
var DefaultQueryAdapter_1 = DefaultQueryAdapter$1;
var DefaultSubscriptionAdapter_1 = DefaultSubscriptionAdapter$1;
function queryOperation(options, adapter, config) {
    var defaultAdapter;
    if (Array.isArray(options)) {
        if (adapter) {
            var customAdapter = new adapter(options, config);
            return customAdapter.queriesBuilder(options);
        }
        defaultAdapter = new DefaultQueryAdapter_1.default(options, config);
        return defaultAdapter.queriesBuilder(options);
    }
    if (adapter) {
        var customAdapter = new adapter(options, config);
        return customAdapter.queryBuilder();
    }
    defaultAdapter = new DefaultQueryAdapter_1.default(options, config);
    return defaultAdapter.queryBuilder();
}
var query = build.query = queryOperation;
function mutationOperation(options, adapter, config) {
    var customAdapter;
    var defaultAdapter;
    if (Array.isArray(options)) {
        if (adapter) {
            // @ts-ignore
            customAdapter = new adapter(options, config);
            return customAdapter.mutationsBuilder(options);
        }
        defaultAdapter = new DefaultMutationAdapter_1.default(options, config);
        return defaultAdapter.mutationsBuilder(options);
    }
    if (adapter) {
        // @ts-ignore
        customAdapter = new adapter(options, config);
        return customAdapter.mutationBuilder();
    }
    defaultAdapter = new DefaultMutationAdapter_1.default(options, config);
    return defaultAdapter.mutationBuilder();
}
build.mutation = mutationOperation;
function subscriptionOperation(options, adapter) {
    var customAdapter;
    var defaultAdapter;
    if (Array.isArray(options)) {
        if (adapter) {
            // @ts-ignore
            customAdapter = new adapter(options);
            return customAdapter.subscriptionsBuilder(options);
        }
        defaultAdapter = new DefaultSubscriptionAdapter_1.default(options);
        return defaultAdapter.subscriptionsBuilder(options);
    }
    if (adapter) {
        // @ts-ignore
        customAdapter = new adapter(options);
        return customAdapter.subscriptionBuilder();
    }
    defaultAdapter = new DefaultSubscriptionAdapter_1.default(options);
    return defaultAdapter.subscriptionBuilder();
}
build.subscription = subscriptionOperation;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function isServerError(error) {
    return error && 'statusCode' in error && typeof error.statusCode === 'number';
}
class GQLInterface {
    /**
     * _addTypeName is for internal use only. Just for testing purposes.
     */
    constructor(_core) {
        this._core = _core;
    }
    async _client(_addTypeName = true) {
        var _a;
        const useEdge = this._core._environment.getValue('HIGH_PRIORITY_RAPI_REQUESTS');
        const httpLink = new HttpLink(Object.assign({ uri: useEdge ? `https://${this._core._environment.endpoints.ACPC_SUPERGRAPH_EDGE_HOST}` : `https://${this._core._environment.endpoints.ACPC_SUPERGRAPH_HOST}` }, (((_a = this._core._environment._hooks) === null || _a === void 0 ? void 0 : _a.fetch) ? { fetch: this._core._environment._hooks.fetch } : {})));
        // Refresh the access token before setting the context in case it's not valid
        await this._core._environment._refreshAccessToken();
        const authMiddleware = new ApolloLink((operation, forward) => {
            const token = this._core._environment.getValue('ACCESS_TOKEN');
            operation.setContext({
                headers: {
                    authorization: `Bearer ${token}`,
                    'x-api-key': this._core._environment.getValue('CLIENT_ID'),
                },
            });
            return forward(operation);
        });
        // On a 401 error, attempt to refresh the access token and retry the operation.
        const retryLink = new RetryLink({
            delay: (count, _operation, error) => {
                // On the first retry it's likely we haven't secured a user token yet, set delay to 0
                // Additionally, since Auth is handled in Environment.ts we will only hit this retry once
                if (count === 1) {
                    return 0;
                }
                const min = this._core._environment.getValue('MIN_RETRY_INTERVAL');
                const max = this._core._environment.getValue('MAX_RETRY_INTERVAL');
                const delay = clamp(Math.pow(2, count) * 1000, min, max);
                this._core._environment.log(`GQL: Retryable error ${error.statusCode} retrying in ${delay}ms, ${count} retries so far`);
                return delay;
            },
            attempts: async (count, _operation, error) => {
                const maxRetries = this._core._environment._maxNumberOfRetries;
                const hasExceededMaxRetries = count > maxRetries;
                const isUnauthorizedError = isServerError(error) && error.statusCode === 401;
                if (isUnauthorizedError) {
                    this._core._environment._isTokenInvalid = true;
                }
                if (hasExceededMaxRetries) {
                    this._core._environment.log(`GQL: Retryable error ${error.statusCode} attempt ${count} exceeded ${maxRetries} retries`);
                }
                if (hasExceededMaxRetries || !isUnauthorizedError) {
                    return false;
                }
                // refresh the access token as it is invalid.
                // This will trigger a new token to be fetched and the context to be updated.
                await this._core._environment._refreshAccessToken();
                return true;
            },
        });
        return new ApolloClient({
            // retryLink needs to be passed in before the authMiddleware link so that
            // the authMiddleware link will re-run on retry and update the
            // operation context with the new access token.
            link: from([retryLink, authMiddleware, httpLink]),
            cache: new InMemoryCache({
                addTypename: _addTypeName,
            }),
            // We don't want to use the apollo cache for the queries.
            // We would always want to fetch the latest data from the subgraph.
            defaultOptions: {
                query: {
                    fetchPolicy: 'no-cache',
                    // TODO: Need to understand various error policies that Apollo client offers and see which suits our needs
                    errorPolicy: 'all',
                },
            },
        });
    }
    /**
     * Initializes the Apollo client.
     * @param _addTypeName - Whether to add the typename to the query.
     */
    async initialize(_addTypeName = true) {
        await this._client(_addTypeName);
    }
    /**
      * Retrive a page of favorite assets for the user.
      */
    async getFavorites(gqlArgs) {
        var _a;
        const client = await this._client();
        let q;
        try {
            // gql-query-builder swallows errors, build query strings in a try-catch
            // TODO: propose just using graphql-tag
            q = query({
                operation: 'favorites',
                fields: [
                    'assetListId',
                    {
                        operation: 'assetListConnection',
                        variables: {
                            first: { value: gqlArgs.first, required: true },
                            after: gqlArgs.after,
                            filter: { value: gqlArgs.filter, type: 'AssetListFilter', required: false },
                            orderBy: { value: gqlArgs.orderBy, type: 'FavoriteOrderByInput', required: false }
                        },
                        fields: [
                            {
                                pageInfo: ['hasNextPage', 'endCursor'],
                            },
                            {
                                edges: [
                                    'cursor',
                                    {
                                        node: [{ operation: 'Asset', fragment: true, fields: GQLResolveAssetFields }]
                                    },
                                ],
                            },
                        ],
                    },
                ],
            }, null, {
                operationName: 'favorites',
            });
        }
        catch (err) {
            console.error('error building query string', err);
        }
        const response = q && await client
            .query({
            query: gql(q.query),
            variables: q.variables,
        })
            .catch((error) => {
            throw SAMError.createWithApolloError(error);
        });
        if ((_a = response.errors) === null || _a === void 0 ? void 0 : _a[0]) {
            throw SAMError.createWithGraphQLError(response.errors[0]);
        }
        return response.data;
    }
    /**
     * Marks or unmarks an asset as favorited.
     */
    async setFavorite(assetId, isFavorite) {
        const client = await this._client();
        try {
            await client.mutate({
                mutation: gql `
                    mutation updateLabel($assetId: ID!, $input: UpdateLabelInput!) {
                        updateLabel(assetId: $assetId, input: $input) {
                            favorite {
                                isFavorite
                            }
                        }
                    }
                `,
                variables: {
                    assetId,
                    input: {
                        favorite: {
                            isFavorite
                        }
                    },
                }
            });
        }
        catch (error) {
            if (error instanceof ApolloError) {
                throw SAMError.createWithApolloError(error);
            }
            // Only `ApolloErrors` should be thrown, but this is here just in case.
            throw SAMError.create(SAMErrorCode.UNKNOWN, 'No data or error returned from the query getAssetById');
        }
    }
    /**
     * Retrieves an asset by its ID
     * Additional loading parameters can be introduced in the future updates.
     * In the future, we might use codegen to generate types from the schema.
     */
    async getAssetById(assetId) {
        var _a, _b, _c;
        const client = await this._client();
        const resolveAssetById = query({
            operation: 'resolveAssetById',
            variables: {
                assetId: {
                    value: assetId,
                    name: 'assetId',
                    required: true,
                    type: 'ID',
                },
            },
            fields: GQLResolveAssetFields,
        }, null, {
            operationName: 'getAssetById',
        });
        const results = await client
            .query({
            query: gql(resolveAssetById.query),
            variables: resolveAssetById.variables,
        })
            .catch((error) => {
            throw SAMError.createWithApolloError(error);
        });
        // TODO: Need to understand various error policies that Apollo client offers and see which suits our needs
        if (!((_a = results.data) === null || _a === void 0 ? void 0 : _a.resolveAssetById)) {
            if (!((_b = results.errors) === null || _b === void 0 ? void 0 : _b[0])) {
                throw SAMError.create(SAMErrorCode.UNKNOWN, 'No data or error returned from the query getAssetById');
            }
            throw SAMError.createWithGraphQLError((_c = results.errors) === null || _c === void 0 ? void 0 : _c[0]);
        }
        return results.data;
    }
    async getAssetByPath(assetPath, repositoryId) {
        var _a, _b, _c, _d, _e, _f;
        const client = await this._client();
        // if repositoryId is provided, fetch the asset by path
        if (repositoryId) {
            const resolveAssetByPath = query({
                operation: 'resolveAssetByPath',
                variables: {
                    assetPath: {
                        value: assetPath,
                        name: 'assetPath',
                        required: true,
                        type: 'String',
                    },
                    repositoryId: {
                        value: repositoryId,
                        name: 'repositoryId',
                        required: true,
                        type: 'ID',
                    },
                },
                fields: GQLResolveAssetFields,
            }, null, {
                operationName: 'getAssetByPath',
            });
            const results = await client
                .query({
                query: gql(resolveAssetByPath.query),
                variables: resolveAssetByPath.variables,
            })
                .catch((error) => {
                throw SAMError.createWithApolloError(error);
            });
            // TODO: Need to understand various error policies that Apollo client offers and see which suits our needs
            if (!((_a = results.data) === null || _a === void 0 ? void 0 : _a.resolveAssetByPath)) {
                if (!((_b = results.errors) === null || _b === void 0 ? void 0 : _b[0])) {
                    throw SAMError.create(SAMErrorCode.UNKNOWN, 'No data or error returned from the query getAssetById');
                }
                throw SAMError.createWithGraphQLError((_c = results.errors) === null || _c === void 0 ? void 0 : _c[0]);
            }
            return results.data;
        }
        // if repositoryId is not provided, fetch the asset by relative path from the user's home repository
        // this query will return the home folder data and the asset data
        const resolveAssetByPath = query({
            operation: 'resolveUserHome',
            fields: [
                ...GQLSpecialFolderFields,
                {
                    operation: 'Directory',
                    fields: [
                        {
                            operation: 'assetByRelativePath',
                            variables: {
                                assetPath: {
                                    value: assetPath,
                                    name: 'relativePath',
                                    required: true,
                                    type: 'String',
                                },
                            },
                            fields: GQLResolveAssetFields,
                        },
                    ],
                    fragment: true,
                },
            ],
        }, null, {
            operationName: 'getAssetByPath',
        });
        const results = await client
            .query({
            query: gql(resolveAssetByPath.query),
            variables: resolveAssetByPath.variables,
        })
            .catch((error) => {
            throw SAMError.createWithApolloError(error);
        });
        // TODO: Need to understand various error policies that Apollo client offers and see which suits our needs
        if (!((_d = results.data) === null || _d === void 0 ? void 0 : _d.resolveUserHome)) {
            if (!((_e = results.errors) === null || _e === void 0 ? void 0 : _e[0])) {
                throw SAMError.create(SAMErrorCode.UNKNOWN, 'No data or error returned from the query getAssetById');
            }
            throw SAMError.createWithGraphQLError((_f = results.errors) === null || _f === void 0 ? void 0 : _f[0]);
        }
        return results.data;
    }
}
__decorate([
    memoize$1
], GQLInterface.prototype, "_client", null);
__decorate([
    synchronized
], GQLInterface.prototype, "initialize", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class GQLManager {
    constructor(_core) {
        this._core = _core;
        this._gqlInterface = new GQLInterface(this._core);
    }
    async initialize() {
        await this._gqlInterface.initialize();
    }
    /**
     * Get an asset by path.
     * @param assetPath - The path of the asset to get.
     * @param repositoryId - The repository ID of the asset to get(optional). If not provided, the asset will be fetched relative to the user's home repository.
     * @returns The asset data and the home folder data(if repositoryId is not provided).
     */
    async getAssetByPath(assetPath, repositoryId) {
        const data = await this._gqlInterface.getAssetByPath(assetPath, repositoryId);
        if (!repositoryId || repositoryId.length === 0) {
            const resolveUserHome = data.resolveUserHome;
            const homeFolderData = this._convertGQLAssetToAdobeAssetData(resolveUserHome);
            const assetData = this._convertGQLAssetToAdobeAssetData(resolveUserHome.assetByRelativePath);
            return {
                homeFolderData,
                assetData
            };
        }
        return {
            assetData: this._convertGQLAssetToAdobeAssetData(data.resolveAssetByPath),
        };
    }
    async getAssetById(assetId) {
        const data = await this._gqlInterface.getAssetById(assetId);
        return this._convertGQLAssetToAdobeAssetData(data.resolveAssetById);
    }
    async getFavorites(args) {
        const { favorites: { assetListConnection: { pageInfo, edges }, }, } = await this._gqlInterface.getFavorites(args);
        const favorites = edges.map((edge) => this._convertGQLAssetToAdobeAssetData(edge.node));
        return { favorites, pageInfo };
    }
    _parseEffectivePermissions(permissions) {
        const toLowerCase = (resource) => resource === null || resource === void 0 ? void 0 : resource.map(p => p.toLowerCase());
        const rapiPermissions = {};
        rapiPermissions['*'] = toLowerCase(permissions.default);
        rapiPermissions[RelType.PRIMARY] = toLowerCase(permissions.primary);
        rapiPermissions[RelType.AC_POLICY] = toLowerCase(permissions.aclPolicy);
        rapiPermissions[RelType.DIRECTORY] = toLowerCase(permissions.directory);
        rapiPermissions[RelType.APP_METADATA] = toLowerCase(permissions.applicationMetadata);
        rapiPermissions[RelType.ANNOTATIONS] = toLowerCase(permissions.annotations);
        return parseEffectivePermissions(rapiPermissions);
    }
    /**
     * Converts GraphQL query response  to Adobe asset data format.
     * In the future, we will add additional transformations to this data.
     * We might use codegen to generate types from the schema.
     */
    _convertGQLAssetToAdobeAssetData(data) {
        var _a, _b, _c, _d;
        return {
            'dc:format': data.dc_format,
            'repo:ancestors': data.repo_ancestors,
            'repo:assetClass': data.repo_assetClass.toLowerCase(),
            'repo:assetId': data.repo_assetId,
            'repo:createdBy': data.repo_createdBy.id,
            'repo:name': data.repo_name,
            'repo:path': data.repo_path,
            'repo:modifiedBy': data.repo_modifiedBy,
            'repo:repositoryId': data.repository.repo_repositoryId,
            'repo:state': data.repo_state,
            'repo:size': data.repo_size,
            'repo:version': data.repo_version,
            'storage:assignee': data.storage_assignee,
            'storage:deviceCreateDate': data.storage_deviceCreateDate,
            'storage:deviceModifyDate': data.storage_deviceModifyDate,
            effectivePermission: data.effectivePermissions ? this._parseEffectivePermissions(data.effectivePermissions) : undefined,
            perUserMetadata: {
                'shell:lastAccessDate': (_a = data.labels) === null || _a === void 0 ? void 0 : _a['lastAccessDate'],
            },
            _embedded: {
                [RelType.APP_METADATA]: ((_b = data.appMetadata) === null || _b === void 0 ? void 0 : _b.am) || {}
            },
            _links: {
                [RelType.PRIMARY]: data.primaryLink,
                [RelType.BLOCK_INITIALIZE]: data.blockUploadLink,
                [RelType.DOWNLOAD]: data.blockDownloadLink,
                [RelType.RENDITION]: data.renditionLink,
                [RelType.PAGE]: data.pageLink,
            },
            isFavorite: (_d = (_c = data.labels) === null || _c === void 0 ? void 0 : _c.favorite) === null || _d === void 0 ? void 0 : _d.isFavorite
            // @TODO_GQL things we need to consider more about
            // repository: data.repository,
        };
    }
    async setFavorite(assetId, isFavorite) {
        await this._gqlInterface.setFavorite(assetId, isFavorite);
    }
}
__decorate([
    synchronized
], GQLManager.prototype, "getAssetByPath", null);
__decorate([
    synchronized
], GQLManager.prototype, "getAssetById", null);
__decorate([
    synchronized
], GQLManager.prototype, "getFavorites", null);

var GQLManager$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': GQLManager
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const WORKSPACE_INDEX_LINKS = {
    [RelType.WORKSPACES_CONTEXT]: [],
    [RelType.TEAMS_PAGE]: ['start', 'limit'],
    [RelType.WORKSPACES_PRIMARY]: ['id', 'selector'],
    [RelType.WORKSPACES_PAGE]: ['orderBy', 'start', 'limit', 'teamId', 'bookmarkFilter', 'teamAccess'],
    [RelType.REPOSITORIES_PAGE]: [],
    [RelType.TEAMS_CREATE]: [],
    [RelType.TEAM_PROVISION]: [],
    [RelType.WORKSPACES_BOOKMARKS_BATCH]: []
};

// Team provisioning can return both 200 and 201 depending on if
// the user already had the team created or not. We check for this ahead of time,
// but there is a chance the user has a pending or simultaneous call to provision
// the team from a different tab or application. In SAM we don't actually
// care about 200 or 201, but we want to make sure they are both valid codes.
const TEAM_PROVISION_SUCCESS_CODES = [200, 201];
const SPACE_FULL_SELECTOR = ['FULL'];
const DefaultTeamListingOptions = {
    start: 0,
    limit: 0,
    orderDirection: 'ascending',
    orderBy: 'name'
};
const DefaultSpacesListingOptions = {
    orderDirection: 'ascending',
    orderBy: 'name',
    bookmarked: false,
    teamID: undefined,
    start: 0,
    limit: 0
};
function getDefaultOptions(Defaults, options) {
    return Object.assign({}, Defaults, options);
}
function getDirectionValue$1(userOptions) {
    const directionFlag = userOptions.orderDirection === 'ascending' ? '+' : '-';
    return directionFlag + userOptions.orderBy;
}
function createPageTemplate$1(options) {
    const templateValues = {};
    if (options.start) {
        templateValues.start = options.start;
    }
    if (options.limit) {
        templateValues.limit = options.limit;
    }
    return templateValues;
}
function getTeamListingPath(links, options) {
    const userOptions = getDefaultOptions(DefaultTeamListingOptions, options);
    const templateValues = createPageTemplate$1(userOptions);
    templateValues.orderBy = getDirectionValue$1(userOptions);
    templateValues.nameContains = userOptions.nameContains;
    templateValues.state = userOptions.state;
    return getURLFromLinks(links, RelType.TEAMS_PAGE, templateValues);
}
function getSpacesListingPath(links, options) {
    const userOptions = getDefaultOptions(DefaultSpacesListingOptions, options);
    const templateValues = createPageTemplate$1(userOptions);
    templateValues.orderBy = getDirectionValue$1(userOptions);
    // The service sets bookmarkFilter to "true" by default, so pass "false" if bookmarked is false or undefined.
    if (!userOptions.bookmarked) {
        templateValues.bookmarkFilter = false;
    }
    // The only value that is implemented by the server is teamAccess=undefined or teamAccess=false.
    // teamAccess=undefined -> all spaces are returned
    // teamAccess=false -> returns only the spaces that are from teams the user is not part of.
    if (userOptions.teamAccess === false) {
        templateValues.teamAccess = false;
    }
    const { teamID } = userOptions;
    if (teamID) {
        templateValues.teamId = teamID;
    }
    return getURLFromLinks(links, RelType.WORKSPACES_PAGE, templateValues);
}
function validateRequiredProjectLinks(links) {
    return validateLinks(links, WORKSPACE_INDEX_LINKS);
}
class WorkspacesInterface extends InterfaceBase {
    _getHeaders(contentType) {
        const headers = {
            'x-service-features': 'CanvasMigration',
            // NOTE: [SAM-1222] disabling cache because /projects/{spaceId} sets an etag header that
            //      does not change when the user's bookmark preference changes, causing browsers to
            //      automatically add the etag header on requests and get the cached value of the
            //      bookmark field rather than the actual value.
            'Cache-Control': 'no-cache'
        };
        if (contentType) {
            headers['Content-Type'] = contentType;
        }
        return headers;
    }
    async _discoverLinks(rootHref) {
        const response = await this._getResponse(rootHref, this._getHeaders());
        return response._links;
    }
    _getEndpointHref(endpoint) {
        return `https://${this._core._environment.endpoints.PROJECTS_HOST}${endpoint}`;
    }
    async discoverLinks() {
        return this._discoverLinks(this._getEndpointHref(`/api/v2/index`));
    }
    async getTeams(options) {
        const links = await this.discoverLinks();
        const url = getTeamListingPath(links, options);
        return await this._getResponse(url, this._getHeaders());
    }
    /**
     * Get repositories where user can create CC Team
     */
    async getOrgRepositories() {
        const links = await this.discoverLinks();
        const url = getURLFromLinks(links, RelType.REPOSITORIES_PAGE, {});
        return await this._getResponse(url, this._getHeaders());
    }
    /**
     * Create a team under /content/assets folder.
     */
    async createTeam(data) {
        const links = await this.discoverLinks();
        const url = getURLFromLinks(links, RelType.TEAMS_CREATE, {});
        const response = await this._doPost(url, this._getHeaders(JSON_MIME_TYPE), JSON.stringify(data));
        return response.json();
    }
    /**
     * Permanently Delete a Team
     */
    async permanentlyDeleteTeam(links) {
        const url = getURLFromLinks(links, RelType.TEAMS_PRIMARY);
        await this._doDelete(url, this._getHeaders(), [204]);
    }
    /**
     * Archive/Discard Team
     */
    async archiveTeam(links) {
        const url = getURLFromLinks(links, RelType.TEAMS_DISCARD);
        await this._doPost(url, this._getHeaders(), undefined, [204]);
    }
    /**
     * Restore Team.
     */
    async restoreTeam(teamLinks) {
        const url = getURLFromLinks(teamLinks, RelType.TEAMS_RESTORE);
        await this._doPost(url, this._getHeaders(), undefined, [204]);
    }
    /**
     * Rename Team.
     */
    async renameTeam(teamLinks, name) {
        const url = getURLFromLinks(teamLinks, RelType.TEAMS_RENAME);
        await this._doPost(url, this._getHeaders(JSON_MIME_TYPE), JSON.stringify({ name }), [204]);
    }
    /**
     * Patch a Team
     */
    async patchTeam(teamLinks, data) {
        const url = getURLFromLinks(teamLinks, RelType.TEAMS_PROPERTIES);
        await this._doPatch(url, Object.assign(Object.assign({}, this._getHeaders(JSON_PATCH_MIME_TYPE)), { 'If-Match': '*' }), JSON.stringify(data), [204]);
    }
    /**
     * Fetches Properties for a team.
     */
    async getTeamProperties(teamLinks) {
        const url = getURLFromLinks(teamLinks, RelType.TEAMS_PROPERTIES);
        return await this._getResponse(url, this._getHeaders());
    }
    /**
     * Provisions a Team folder within User storage for a Type 1 user only. The provisioned team name is in format:
     * "Team {{USER_FIRST_NAME}}" depending on the localization of the requesting user.
     */
    async provisionTeam() {
        const links = await this.discoverLinks();
        const url = getURLFromLinks(links, RelType.TEAM_PROVISION, {});
        const response = await this._doPost(url, this._getHeaders(), undefined, TEAM_PROVISION_SUCCESS_CODES);
        return response.json();
    }
    async getSpaces(options) {
        const links = await this.discoverLinks();
        const url = getSpacesListingPath(links, options);
        return await this._getResponse(url, this._getHeaders());
    }
    async getSpace(id, selector = SPACE_FULL_SELECTOR) {
        const links = await this.discoverLinks();
        const spaceLink = getURLFromLinks(links, RelType.WORKSPACES_PRIMARY, { id, selector });
        return await this._getResponse(spaceLink, this._getHeaders());
    }
    async reloadSpace(spaceLinks, selector = SPACE_FULL_SELECTOR) {
        const spaceLink = getURLFromLinks(spaceLinks, RelType.WORKSPACES_PRIMARY, { selector });
        return await this._getResponse(spaceLink, this._getHeaders());
    }
    async bookmarkOp(data) {
        const links = await this.discoverLinks();
        const url = getURLFromLinks(links, RelType.WORKSPACES_BOOKMARKS_BATCH);
        const response = await this._doPost(url, this._getHeaders(JSON_MIME_TYPE), JSON.stringify(data), [200]);
        return response.json();
    }
    async createSpace(teamLinks, data) {
        const url = getURLFromLinks(teamLinks, RelType.WORKSPACES_CREATE);
        const response = await this._doPost(url, this._getHeaders(JSON_MIME_TYPE), JSON.stringify(data));
        return response.json();
    }
    async patchSpace(spaceLinks, data) {
        const url = getURLFromLinks(spaceLinks, RelType.WORKSPACES_PRIMARY);
        await this._doPatch(url, this._getHeaders(JSON_PATCH_MIME_TYPE), JSON.stringify(data), [200, 204]);
    }
    async getEnclosingSpaces(data) {
        const links = await this.discoverLinks();
        const url = getURLFromLinks(links, RelType.WORKSPACES_CONTEXT);
        const response = await this._doPost(url, this._getHeaders(JSON_MIME_TYPE), JSON.stringify(data), [200]);
        return response.json();
    }
}
__decorate([
    cache(validateRequiredProjectLinks),
    __param(0, key)
], WorkspacesInterface.prototype, "_discoverLinks", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class SpaceLoader {
    constructor(_spacePool, _workspaceInterface, _teamRoleGetterFactory) {
        this._spacePool = _spacePool;
        this._workspaceInterface = _workspaceInterface;
        this._teamRoleGetterFactory = _teamRoleGetterFactory;
    }
    supportsFilter(filter) {
        // - only state === 'active' is supported.
        // - cannot handle teamRole === 'MEMBER' yet.
        if (!filter) {
            // If we don't provide a filter at all, then we cannot use the loader
            return false;
        }
        const { teamRole, state } = filter;
        return teamRole !== 'MEMBER' && state === 'active';
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, start) {
        const { order, filter, limit } = options;
        const teamRole = filter === null || filter === void 0 ? void 0 : filter.teamRole;
        if (teamRole === 'MEMBER') {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Filtering only for spaces with reamRole MEMBER is not supported.');
        }
        // We will ignore the update if we had local changes sooner than this timestamp.
        const latency = this._spacePool._core._environment.getValue('PROJECTS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const resultPromise = this._workspaceInterface.getSpaces({
            orderBy: OrderFieldToIProjectsSpaceOrderBy[order.field],
            orderDirection: order.direction,
            teamID: filter === null || filter === void 0 ? void 0 : filter.teamID,
            bookmarked: filter === null || filter === void 0 ? void 0 : filter.bookmarked,
            teamAccess: teamRole === 'NONE' ? false : undefined,
            start,
            limit
        });
        // If the teamRole was used in the request, then we trust the server resolved the correct value for the filter.
        // If we don't have teamRole in the filter, then we will lookup in the client side list of teams. If the teams are not
        // loaded yet, we will just fallback to 'NONE' until the teams are eventually loaded.
        // The team pool delegate in the space context will update the team role once the teams are known.
        const teamRoleFn = teamRole ? (() => teamRole) : await this._teamRoleGetterFactory();
        // Wait for the results after we start loading the role factory above. That will make the requests run in parallel when needed.
        const result = await resultPromise;
        const session = this._spacePool.createLoaderUpdateSession(mostRecentValidMutation);
        // Inject the teamRole in all the items that we load.
        const items = SpaceUpdater.updateRemoteItems(session, result.projects.map((item) => {
            return Object.assign(Object.assign({}, item), { teamRole: teamRoleFn(item.teamId), 
                // The `/projects` listing endpoint doesn't add the state property,
                // but it only returns active spaces anyways. We can inject
                // the property automatically to make sure any restored space,
                // gets back into the correct lists.
                state: 'active' });
        }));
        // Make sure we ignore any reload errors now that we have refreshed the listing of the space.
        for (const item of items) {
            item[clearLastReloadError]();
        }
        session.commit();
        // Check if we have another page to load.
        let loadNextPage;
        // Note that it is important to skip the entire page size,
        // even if we didn't get any items back.
        // The service is based on USS which might filter out items
        // on the fly when they are retrieved instead of ahead of time
        // when the total limit is computed. As a result, some pages might
        // even come in empty.
        const nextStart = result.pageSpec.start + result.pageSpec.limit;
        if (nextStart < result.pageSpec.totalLimit) {
            loadNextPage = (options) => this._loadPage(options, nextStart);
        }
        return {
            items,
            total: result.pageSpec.totalLimit,
            loadNextPage,
            mostRecentValidMutation
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class TeamLoader {
    constructor(_teamPool, _projectInterface) {
        this._teamPool = _teamPool;
        this._projectInterface = _projectInterface;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, start) {
        const { limit, filter, order } = options;
        // We will ignore the update if we had local changes sooner than this timestamp.
        const latency = this._teamPool._core._environment.getValue('PROJECTS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const result = await this._projectInterface.getTeams({
            orderBy: OrderFieldToIProjectsTeamsOrderBy[order.field],
            orderDirection: order.direction,
            start,
            limit,
            nameContains: filter === null || filter === void 0 ? void 0 : filter.nameContains,
            state: filter === null || filter === void 0 ? void 0 : filter.state
        });
        const session = this._teamPool.createLoaderUpdateSession(mostRecentValidMutation);
        const items = TeamUpdater.updateRemoteItems(session, result.teams);
        session.commit();
        // Check if we have another page to load.
        let loadNextPage;
        // Note that it is important to skip the entire page size,
        // even if we didn't get any items back.
        // The service is based on USS which might filter out items
        // on the fly when they are retrieved instead of ahead of time
        // when the total limit is computed. As a result, some pages might
        // even come in empty.
        const nextStart = result.pageSpec.start + result.pageSpec.limit;
        if (nextStart < result.pageSpec.totalLimit) {
            loadNextPage = (options) => this._loadPage(options, nextStart);
        }
        return {
            items,
            total: result.pageSpec.totalLimit,
            loadNextPage,
            mostRecentValidMutation
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class OrgRepositoryLoader {
    constructor(_orgRepositoryPool, _projectInterface) {
        this._orgRepositoryPool = _orgRepositoryPool;
        this._projectInterface = _projectInterface;
    }
    async loadPage() {
        const result = await this._projectInterface.getOrgRepositories();
        const session = this._orgRepositoryPool.createLoaderUpdateSession(Date.now());
        const items = OrgRepositoryUpdater.updateRemoteItems(session, result.repositories);
        session.commit();
        return { items };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// We want to refresh teams only if we didn't get the list in the past 5 minutes.
// This avoids loading teams again during auto-provisioning in case the client
// already fetched the teams.
const TEAM_REFRESH_TIMEOUT = 5 * 60 * 1000;
function createTeamRoleGetter(teams) {
    const map = new Set(teams.items.map((team) => team.id));
    return (teamID) => map.has(teamID) ? 'MEMBER' : 'NONE';
}
function getLinks(item) {
    const links = item._links;
    if (!links) {
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Object has not been loaded correctly, missing "_links" property.');
    }
    return links;
}
class SpaceContext {
    constructor(_core) {
        this._core = _core;
        this._orgRepositoryPool = new ItemPool(this._core, 'orgRepository');
        this._teamPool = new ItemPool(this._core, 'team');
        this._spacePool = new ItemPool(this._core, 'space');
        this._projectInterface = new WorkspacesInterface(this._core);
        this._rapi = new RepositoryInterface(this._core);
        this._hostAssetContext = this._core.hostAssetContext;
        this._teamRoleGetterFactory = async () => {
            const teams = await this._fetchTeams();
            return createTeamRoleGetter(teams);
        };
        this._teamPoolDelegate = {
            onItemsUpdated: () => {
                // Iterate on all the known spaces and update their teamRole based on what we know from the list of Teams.
                // Note that this might update spaces that have been discarded, but that's alright as they might be restored
                // at some point in the future. Since `this.getSpaces().getList()` will trigger fetching the Teams, it is
                // expected that the Team list will typically already be loaded, so it should not use `getTeams().getList()`
                // since that will cause it to fetch the Teams list again. Fetching teams as a side-effect of unit tests that
                // manipulate Teams using the teamPool will unexpectedly cause the teams list to load without any Nock mock
                // to provide it.
                // NOTE: _getExistingList requires an explicit filter, but this Teams list should not be filtered, so it
                // must pass in an EverythingFilter, which is not allowed as an explicit filter in the public interface,
                // so casting to `any` because it should not put EverythingFilter in the public API.
                const teams = this.getTeams()._getExistingList(TeamOrder.default, new EverythingFilter());
                // Teams List won't exist if manipulating the teamPool without loading the teams first.
                // Teams List will be empty when the TeamLoader converts the service response to Team models via
                // TeamUpdater.updateRemoteItems(), because it triggers ItemPool.onItemsUpdated() before it has actually
                // put the items in the List.
                if (!teams || !teams.items.length) {
                    this._core._environment.debug('[SpaceContext._teamPoolDelegate] skipping update of Space.teamRole -- no teams');
                    return;
                }
                const spacePool = this._spacePool;
                const getTeamRole = createTeamRoleGetter(teams);
                const spaceSession = spacePool.createUpdateSession('Updating teamRole across all spaces');
                this._spacePool.forEach((space) => {
                    const newTeamRole = getTeamRole(space.teamID);
                    if (space.teamRole !== newTeamRole) {
                        SpaceUpdater.updateLocalItem(spaceSession, space, { teamRole: newTeamRole });
                    }
                });
                spaceSession.commit();
            }
        };
        // Make sure we have a delegate to update all the teamRoles of the spaces once a new team is added.
        this._teamPool.addDelegate(this._teamPoolDelegate, 'context');
    }
    get projectInterface() {
        return this._projectInterface;
    }
    get orgRepositoryPool() {
        return this._orgRepositoryPool;
    }
    get teamPool() {
        return this._teamPool;
    }
    get spacePool() {
        return this._spacePool;
    }
    /**
     * Returns a cached list of links for the project service index route.
     */
    async discoverLinks() {
        return await this._projectInterface.discoverLinks();
    }
    getOrgRepositories() {
        const loader = new OrgRepositoryLoader(this._orgRepositoryPool, this._projectInterface);
        return new ItemSource(this._orgRepositoryPool, [loader]);
    }
    getTeams() {
        const loader = new TeamLoader(this._teamPool, this._projectInterface);
        return new ItemSource(this._teamPool, [loader], new TeamFilter());
    }
    getSpaces() {
        // Make sure that the space loader checks for team membership during load.
        const loader = new SpaceLoader(this._spacePool, this._projectInterface, this._teamRoleGetterFactory);
        return new ItemSource(this._spacePool, [loader], new SpaceFilter());
    }
    async _fetchTeams() {
        // Get the list with refreshTimeOut so that it will not immediately refresh if the list already exists
        const teams = this.getTeams().getList(TeamOrder.default, undefined, { refreshTimeout: TEAM_REFRESH_TIMEOUT });
        await waitForListLoad(teams);
        return teams;
    }
    async provisionType1Team() {
        // Auto-provision a team for CCI user if the user is not currently sponsoring a team.
        if (this._core._environment.getValue('ACCOUNT_TYPE') !== 'type1') {
            return undefined;
        }
        const teams = await this._fetchTeams();
        const userId = this._core._environment.getValue('USER_ID');
        let team = teams.items.find((team) => team.repositoryOwnerID === userId && team.repositoryOwnerType === 'user');
        if (!team) {
            // This should automatically add the team to the lists.
            const response = await this._projectInterface.provisionTeam();
            // The team might be just created, if we are refreshing the list of teams
            // it might not exist yet, so we have to keep it alive until USS is eventually consistent.
            const session = this._teamPool.createMutationSession();
            team = TeamUpdater.updateRemoteItem(session, response);
            session.commit();
        }
        return team;
    }
    async createTeam(orgRepository, data) {
        const response = await this._projectInterface.createTeam(Object.assign(Object.assign({}, data), { repositoryId: orgRepository.repositoryID }));
        const session = this._teamPool.createMutationSession();
        const team = TeamUpdater.updateRemoteItem(session, response);
        session.commit();
        return team;
    }
    async _renameAsset(id, newName) {
        if (!validatePlatformRepoName(newName)) {
            // Validate the name here to avoid resolving the asset if the name is invalid.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for the rename operation.');
        }
        // FIXME: `item._links[RelType.PRIMARY]` already has the resolved link for the asset.
        // We could reuse the link to avoid a separate resolve by id call.
        const asset = await this._hostAssetContext.getAssetWithCloudID(id);
        await asset.rename(newName);
        // Return the new name of the asset, just in case the server decided to change it.
        return asset;
    }
    async _renameTeam(team, update) {
        const name = update.name;
        if (!name) {
            return;
        }
        if (!validatePlatformRepoName(name)) {
            // Validate the name here to avoid resolving the asset if the name is invalid.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for the rename operation.');
        }
        const links = getLinks(team);
        await this._projectInterface.renameTeam(links, name);
        // Since the client could have both an instance to a Team
        // and the underlying AdobeAsset we should check that if the
        // AdobeAsset exists in the AssetContext ItemPool and if it does
        // update it and it's descendents as well.
        const adobeAssetPool = this._core._getAssetPool();
        const localAdobeAsset = adobeAssetPool.getLocalItemById(team.id);
        const assetContext = await this._core.getAssetContext();
        if (localAdobeAsset) {
            const newPath = renameFileInPath(name, localAdobeAsset);
            const adobeAssetSession = adobeAssetPool.createUpdateSession();
            updateCachedDescendents({
                assetPool: adobeAssetPool,
                asset: localAdobeAsset,
                session: adobeAssetSession,
                operation: { type: 'rename', newPath },
                assetContext
            });
            this._hostAssetContext._adobeAssetUpdater.updateLocalItem(adobeAssetSession, localAdobeAsset, {
                'repo:path': newPath,
                'repo:name': name
            });
            adobeAssetSession.commit();
        }
        const updateSession = this.teamPool.createMutationSession();
        TeamUpdater.updateLocalItem(updateSession, team, { name });
        updateSession.commit();
    }
    async renameTeam(team, newName) {
        await this.updateTeam(team, { name: newName });
    }
    async restoreTeam(team) {
        await ItemBase.runExclusiveTask('restore', [team], async () => {
            try {
                const links = getLinks(team);
                const updateSession = this.teamPool.createUpdateSession();
                await this._projectInterface.restoreTeam(links);
                TeamUpdater.updateLocalItem(updateSession, team, { state: 'active' });
                updateSession.commit();
            }
            catch (e) {
                // We want to avoid updating the pool if
                // there are errors like CONFLICT that could occur.
                throw SAMError.create(SAMErrorCode.UNKNOWN, 'An error occured restoring team', { underlyingError: e });
            }
        });
    }
    async archiveTeam(team) {
        await ItemBase.runExclusiveTask('archive', [team], async () => {
            // TODO: should this be createMutationSession?
            const updateSession = this.teamPool.createUpdateSession();
            try {
                const links = getLinks(team);
                await this._projectInterface.archiveTeam(links);
            }
            catch (error) {
                const e = error;
                // @TODO https://jira.corp.adobe.com/browse/SAM-2064
                // Temporary fallback, remove once M2 APIs are in prod
                if (e.code === SAMErrorCode.BAD_REQUEST) {
                    const asset = await this._hostAssetContext.getAssetWithCloudID(team.id);
                    await asset.discard();
                }
                else {
                    throw e;
                }
            }
            TeamUpdater.updateLocalItem(updateSession, team, { state: 'discarded' });
            updateSession.commit();
        });
    }
    /**
     * The Projects services accepts only
     * a string value with the length
     * less than or equal to 1000.
     */
    _validateDescription(value) {
        return value.length <= 1000;
    }
    _validateColor(value) {
        return /^#[A-Fa-f0-9]{6}$/.test(value);
    }
    _getPatchOP(value, path, existingValue, validator) {
        if (validator && !validator(value)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Property ${path} has invalid value`);
        }
        // If there was a description and now there
        // is none, we should "remove".
        if (value.length === 0
            && existingValue && existingValue.length > 0) {
            return {
                op: 'remove',
                path
            };
        }
        return {
            op: existingValue ? 'replace' : 'add',
            value,
            path
        };
    }
    async _patchTeam(team, update) {
        const { description } = update;
        const bodyData = [];
        const localUpdate = {};
        if (description !== undefined) {
            bodyData.push(this._getPatchOP(description, '/description', team.description, this._validateDescription));
            localUpdate.description = description;
        }
        if (!bodyData.length) {
            return;
        }
        const links = getLinks(team);
        await this._projectInterface.patchTeam(links, bodyData);
        const updateSession = this.teamPool.createMutationSession();
        TeamUpdater.updateLocalItem(updateSession, team, localUpdate);
        updateSession.commit();
    }
    async updateTeam(team, update) {
        await ItemBase.runExclusiveTask('update', [team], async () => {
            const results = await Promise.allSettled([
                this._patchTeam(team, update),
                this._renameTeam(team, update)
            ]);
            // Checks for rejection and calls the handler
            // to delete the item because it has not been
            // found.
            this._checkForRejection(results, () => {
                const session = this.teamPool.createUpdateSession();
                session.queueDiscardedItem(team);
                session.commit();
            });
        });
    }
    async loadTeamProperties(team) {
        const links = getLinks(team);
        const properties = await this._projectInterface.getTeamProperties(links);
        if (!properties || Object.keys(properties).length === 0) {
            return;
        }
        const updateSession = this.teamPool.createMutationSession();
        TeamUpdater.updateLocalItem(updateSession, team, Object.assign({}, properties));
        updateSession.commit();
    }
    async permanentlyDeleteTeam(team) {
        if (team.state === 'active') {
            throw SAMError.create(SAMErrorCode.UNSUPPORTED, 'Teams that are not \'discarded\' cannot be permanently deleted.');
        }
        const onItemsChanged = (event) => {
            if (event.discardedItems) {
                const permDeleteTeamIDs = event.discardedItems
                    .filter(item => item.id === team.id)
                    .map(item => item.id);
                if (permDeleteTeamIDs.length) {
                    this._teamPool.removeLocalItems(permDeleteTeamIDs);
                }
            }
        };
        this._teamPool.on(ITEMS_CHANGED, onItemsChanged);
        try {
            await ItemBase.runExclusiveTask('delete', [team], async () => {
                const links = getLinks(team);
                await this._projectInterface.permanentlyDeleteTeam(links);
                const updateSession = this.teamPool.createUpdateSession();
                updateSession.queueDiscardedItem(team);
                updateSession.commit();
            });
        }
        finally {
            this.teamPool.off(ITEMS_CHANGED, onItemsChanged);
        }
    }
    // Reload space is an implementation detail of the space context,
    // external projects should use space.load() instead.
    async [reloadSpace](space) {
        const latency = this._core._environment.getValue('PROJECTS_ITEM_UPDATE_LATENCY');
        await space.waitForMutationPropagationIfNeeded(latency);
        const links = getLinks(space);
        const result = await this._projectInterface.reloadSpace(links, SPACE_FULL_SELECTOR);
        const session = this._spacePool.createUpdateSession();
        SpaceUpdater.updateLocalItem(session, space, result);
        session.commit();
    }
    /**
     * Internal helper method for moving spaces.
     * @param spaces spaces to be moved
     * @param team destination team where spaces are intended to be moved
     * @param assetRenameMap allows renaming of assets in the batch operation
     * @param retryOnConflict whether to retry the move op for failed spaces in case of conflict
     * @param assetConflictMap map to save the newName and count used for all assets in batch
     * @returns the result for batch operation after retrying for failed assets if asked.
     */
    async _moveSpaces(spaces, team, assetRenameMap = new Map(), retryOnConflict = true, assetConflictMap) {
        let resultOps = { failedResults: [], newModels: [] };
        await ItemBase.runExclusiveTask('move', spaces, async () => {
            const targetAsset = await this._hostAssetContext.getAssetWithCloudID(team.id);
            if (assetConflictMap === undefined) {
                assetConflictMap = new Map();
            }
            const spacesById = new Map();
            const ops = spaces.map((space) => {
                spacesById.set(space.id, space);
                let newPath = `${targetAsset.repoPath}/${getBatchRenamedAssetName(space, assetRenameMap)}`;
                newPath = batchFormatFileName(this._core, space.id, newPath, false, assetConflictMap);
                return {
                    op: 'move',
                    id: space.id,
                    source: {
                        'repo:assetId': space.id,
                        'repo:repositoryId': space.repositoryID
                    },
                    target: {
                        'repo:path': newPath,
                        'repo:repositoryId': targetAsset.repositoryID
                    }
                };
            });
            resultOps = await this._runOperations(ops, spacesById, {
                teamId: team.id,
                teamName: team.name
            });
        });
        if (retryOnConflict) {
            return await retryFailedOpsDueToConflict(resultOps, team, assetRenameMap, assetConflictMap, this._moveSpaces.bind(this));
        }
        return resultOps;
    }
    /**
     * Public method to move spaces to a team
     * @param spaces spaces to be moved
     * @param team destination team where spaces are intended to be moved
     * @returns the result for batch operation after retrying for failed assets.
     */
    async moveSpaces(spaces, team) {
        return this._moveSpaces(spaces, team);
    }
    async archiveSpaces(spaces) {
        return await ItemBase.runExclusiveTask('archive', spaces, async () => {
            const spacesById = new Map();
            const ops = spaces.map((space) => {
                spacesById.set(space.id, space);
                return {
                    op: 'discard',
                    id: space.id,
                    target: {
                        'repo:assetId': space.id,
                        'repo:repositoryId': space.repositoryID
                    },
                };
            });
            return await this._runOperations(ops, spacesById);
        });
    }
    async restoreSpaces(spaces, restoreNameMap) {
        return await ItemBase.runExclusiveTask('restore', spaces, async () => {
            const spacesById = new Map();
            const ops = spaces.map((space) => {
                spacesById.set(space.id, space);
                return {
                    op: 'restore',
                    id: space.id,
                    target: {
                        'repo:assetId': space.id,
                        'repo:repositoryId': space.repositoryID
                    },
                    name: restoreNameMap === null || restoreNameMap === void 0 ? void 0 : restoreNameMap.get(space)
                };
            });
            return await this._runOperations(ops, spacesById);
        });
    }
    async _runOperations(ops, spacesById, additionalSpaceUpdates = {}) {
        const assetContext = await this._core.getAssetContext();
        return await this._rapi.runOperationsForContext(ops, spacesById, this._spacePool, (session, space, remoteItem) => {
            if (!remoteItem) {
                throw SAMError.create(SAMErrorCode.UNKNOWN, 'Missing metadata from asset bulk operation.');
            }
            // We want to update the repo:path of all the descendants of the space only in case of move/rename.
            const remoteRepoPath = remoteItem['repo:path'];
            if (space.pathName !== remoteRepoPath) {
                const adobeAssetPool = this._core._getAssetPool();
                const localAdobeAsset = adobeAssetPool.getLocalItemById(space.id);
                const assetSession = adobeAssetPool.createUpdateSession();
                if (localAdobeAsset) {
                    updateCachedDescendents({
                        assetPool: adobeAssetPool,
                        asset: localAdobeAsset,
                        session: assetSession,
                        operation: { type: 'rename', newPath: remoteRepoPath },
                        assetContext
                    });
                    assetContext._adobeAssetUpdater.updateLocalItem(assetSession, localAdobeAsset, {
                        'repo:path': remoteRepoPath
                    });
                    assetSession.commit();
                }
            }
            SpaceUpdater.updateLocalItem(session, space, Object.assign({ state: remoteItem['repo:state'] === 'ACTIVE' ? 'active' : 'archived', name: remoteItem['repo:name'], pathName: remoteItem['repo:path'] }, additionalSpaceUpdates));
            return undefined;
        }, [
            {
                // Refresh this space to make sure we have the latest version of it.
                // Note that we cannot use 404 - NOT_FOUND as a sign that the space has been
                // permanently deleted as we get that same error code when the space
                // is still active, just that the user is not allowed to archive/restore it.
                // It is better to just reload the space to validate we still have access to
                match: (error) => error.code === SAMErrorCode.ACCESS_DENIED || error.code === SAMErrorCode.NOT_FOUND,
                action: async (space) => {
                    return await space.load().catch((error) => {
                        return { model: space, error: error };
                    });
                }
            }
        ]);
    }
    async createSpaceBookmarks(spaces) {
        return this._bookmarkSpaces('ADD', spaces);
    }
    async removeSpaceBookmarks(spaces) {
        return this._bookmarkSpaces('REMOVE', spaces);
    }
    async _bookmarkSpaces(op, spaces) {
        await ItemBase.runExclusiveTask('bookmark', spaces, async () => {
            var _a;
            const userId = this._core._environment.getValue('USER_ID');
            // Attempt to make the change ahead of time.
            const change = {
                bookmarked: op === 'ADD'
            };
            const localSession = this.spacePool.createUpdateSession();
            const spaceById = new Map();
            const items = spaces.map((space) => {
                spaceById.set(space.id, { space, wasBookmarked: space.isBookmarked });
                SpaceUpdater.updateLocalItem(localSession, space, change);
                return {
                    projectUrn: space.id,
                    userId
                };
            });
            localSession.commit();
            let response;
            try {
                response = await this._projectInterface.bookmarkOp({ op, items });
            }
            finally {
                if (response) {
                    for (const item of response.responses) {
                        const info = spaceById.get((_a = item.request) === null || _a === void 0 ? void 0 : _a.projectUrn);
                        if (info) {
                            info.status = item.status;
                        }
                    }
                }
                // Revert all incomplete changes.
                const restoreSession = this.spacePool.createUpdateSession();
                const mutationSession = this.spacePool.createMutationSession();
                for (const { space, wasBookmarked, status } of spaceById.values()) {
                    if (status === 201) {
                        // Reapply the change, in case there was a different fetch in-between.
                        // This should also force the mutation timestamp to update on the space.
                        SpaceUpdater.updateLocalItem(mutationSession, space, change);
                    }
                    else {
                        // Revert the local change.
                        SpaceUpdater.updateLocalItem(restoreSession, space, {
                            bookmarked: wasBookmarked
                        });
                        // Check if the item was removed on a different device
                        // and remove it from internal lists too.
                        if (status === 404) {
                            restoreSession.queueDiscardedItem(space);
                        }
                    }
                }
                restoreSession.commit();
                mutationSession.commit();
            }
        });
    }
    _checkForRejection(results, onRemoveItem) {
        for (const result of results) {
            if (result.status === 'rejected') {
                const error = result.reason;
                // Remove the item entirely
                if (error instanceof SAMError && error.code === SAMErrorCode.NOT_FOUND) {
                    onRemoveItem();
                }
                throw error;
            }
        }
    }
    async updateSpace(space, update) {
        // Make both rename and patch go through the same exclusive task,
        // to allow them to execute in parallel.
        await ItemBase.runExclusiveTask('update', [space], async () => {
            const results = await Promise.allSettled([
                this._renameSpace(space, update),
                this._patchSpace(space, update)
            ]);
            this._checkForRejection(results, () => {
                const session = this.spacePool.createUpdateSession();
                session.queueDiscardedItem(space);
                session.commit();
            });
        });
    }
    async _renameSpace(space, update) {
        const { name } = update;
        if (name === undefined) {
            return;
        }
        const asset = await this._renameAsset(space.id, name);
        const updateSession = this.spacePool.createMutationSession();
        SpaceUpdater.updateLocalItem(updateSession, space, {
            name: asset.name,
            pathName: asset.repoPath
        });
        updateSession.commit();
    }
    async _patchSpace(space, update) {
        const { description, color } = update;
        const bodyData = [];
        const localUpdate = {};
        if (description !== undefined) {
            bodyData.push(this._getPatchOP(description, `/description`, space.description, this._validateDescription));
            localUpdate.description = description;
        }
        if (color !== undefined) {
            bodyData.push(this._getPatchOP(color, `/color`, space.color, this._validateColor));
            localUpdate.color = color;
        }
        if (!bodyData.length) {
            return;
        }
        const links = getLinks(space);
        // Ideally, the patch would return the updated state, but that's not the case here.
        await this._projectInterface.patchSpace(links, bodyData);
        // We will have to assume that a successful change means the changed values are the latest ones.
        const updateSession = this.spacePool.createMutationSession();
        SpaceUpdater.updateLocalItem(updateSession, space, localUpdate);
        updateSession.commit();
    }
    async createSpace(team, data) {
        const links = getLinks(team);
        this._validateColor(data.color);
        this._validateDescription(data.description);
        validatePlatformRepoName(data.name);
        const response = await this._projectInterface.createSpace(links, Object.assign(Object.assign({}, data), { parentId: team.id }));
        // A space might not show up until a few seconds later, so we must keep it alive during this time.
        const updateSession = this.spacePool.createMutationSession();
        const space = SpaceUpdater.updateRemoteItem(updateSession, Object.assign(Object.assign({}, response), { 
            // Make sure the service injects the teamId.
            teamId: team.id }));
        updateSession.commit();
        return space;
    }
    async getEnclosingSpace(assetId) {
        const spaceMap = await this.getEnclosingSpaces([assetId]);
        return spaceMap.get(assetId);
    }
    async getEnclosingSpaces(assetIds) {
        // The :context API uses the USS to lookup the enclosing space, so it suffers by the
        // same amount of latency as the listing APIs. We will ignore the info we get from this
        // API if the asset was mutated more recently than the maximum expected latency for USS.
        const latency = this._core._environment.getValue('PROJECTS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency; // We will ignore the update if we had local changes sooner than this timestamp.
        const result = await this._projectInterface.getEnclosingSpaces(assetIds.map((id) => ({ 'repo:assetId': id })));
        const map = new Map();
        const updateSession = this.spacePool.createUpdateSession('get enclosing spaces', mostRecentValidMutation);
        for (const item of result.responses) {
            if (item.status !== 200) {
                continue;
            }
            const id = item.request['repo:assetId'];
            const space = SpaceUpdater.updateRemoteItem(updateSession, item.body);
            map.set(id, space);
        }
        updateSession.commit();
        return map;
    }
    async lookupSpaceById(id) {
        let space = this._spacePool.getLocalItemById(id);
        if (!space) {
            // Note that we don't have a local space, so we don't have to worry about eventual consistency on this item.
            const response = await this._projectInterface.getSpace(id, SPACE_FULL_SELECTOR);
            const session = this._spacePool.createUpdateSession();
            space = SpaceUpdater.updateRemoteItem(session, response);
            session.commit();
        }
        return space;
    }
    /**
     * This API is temporary and it is specifically for Projects UI to use with SS workflows.
     * It will eventually be deprecated in favor of using notifications
     * @param teamId
     */
    onUserLeftTeam(teamId) {
        const team = this._teamPool.getLocalItemById(teamId);
        if (team) {
            const session = this._teamPool.createUpdateSession();
            session.queueDiscardedItem(team);
            session.commit();
        }
    }
}
__decorate([
    memoize$1
], SpaceContext.prototype, "getOrgRepositories", null);
__decorate([
    memoize$1
], SpaceContext.prototype, "getTeams", null);
__decorate([
    memoize$1
], SpaceContext.prototype, "getSpaces", null);

var SpaceContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': SpaceContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CollaboratorLoader {
    constructor(_collaboratorPool, _invitationInterface, _urn) {
        this._collaboratorPool = _collaboratorPool;
        this._invitationInterface = _invitationInterface;
        this._urn = _urn;
    }
    async loadPage() {
        // FIXME: Implement latency tracker once we move more collaborator operations into SAM.JS.
        // Note, this request is piggy-backed, so if we load both the collaborators and invited collaborators at the same
        // time, it only results in one network call
        const result = await this._invitationInterface.getCollaborators(this._urn);
        // Update the collaborators
        const collaboratorUpdateSession = this._collaboratorPool.createLoaderUpdateSession(Date.now());
        const directSet = new Set(result.directCollaborators.map(({ id }) => id));
        const collaboratorsWithComputedProps = result.collaborators.map(collaborator => {
            var _a, _b;
            const isDirect = directSet.has(collaborator.id);
            const canDiscover = isDirect
                ? (_b = (_a = result.directCollaborators.find(dc => dc.id === collaborator.id)) === null || _a === void 0 ? void 0 : _a.canDiscover) !== null && _b !== void 0 ? _b : false
                : false;
            return Object.assign(Object.assign({}, collaborator), { isDirect, canDiscover });
        });
        const collaborators = CollaboratorUpdater.updateRemoteItems(collaboratorUpdateSession, collaboratorsWithComputedProps);
        collaboratorUpdateSession.commit();
        return { items: collaborators };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class InvitedCollaborator extends ItemBase {
    constructor() {
        super(...arguments);
        this._email = '';
        this._role = 'viewer';
        this._canComment = false;
        this._canShare = false;
        this._acceptanceRequired = false;
        this._created = new Date;
    }
    get invitationID() {
        return this.id;
    }
    // Invited email
    get email() {
        return this._email;
    }
    get role() {
        return this._role;
    }
    get canComment() {
        return this._canComment;
    }
    get canShare() {
        return this._canShare;
    }
    get acceptanceRequired() {
        return this._acceptanceRequired;
    }
    get inheritance() {
        return this._inheritance;
    }
    get created() {
        return this._created;
    }
}
const InvitedCollaboratorUpdater = new ItemUpdater({
    localItemType: InvitedCollaborator,
    remoteIdProperty: 'id',
    propertyUpdater: new PropertyUpdater({
        '_email': 'email',
        '_role': { name: 'role', choices: CollaboratorRoles },
        '_canComment': { name: 'canComment', format: 'boolean' },
        '_canShare': { name: 'canShare', format: 'boolean' },
        '_acceptanceRequired': { name: 'acceptanceRequired', format: 'boolean' },
        '_inheritance': { name: 'inheritance', choices: InheritanceTypes },
        '_created': { name: 'created', format: 'date_as_number' }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class InvitedCollaboratorLoader {
    constructor(_invitedCollaboratorPool, _invitationInterface, _urn) {
        this._invitedCollaboratorPool = _invitedCollaboratorPool;
        this._invitationInterface = _invitationInterface;
        this._urn = _urn;
    }
    async loadPage() {
        // FIXME: Implement latency tracker once we move more collaborator operations into SAM.JS.
        // Note, this request is piggy-backed, so if we load both the collaborators and invited collaborators at the same
        // time, it only results in one network call
        const result = await this._invitationInterface.getCollaborators(this._urn);
        // Update the pending invitations
        const invitedCollaboratorUpdateSession = this._invitedCollaboratorPool.createLoaderUpdateSession(Date.now());
        const invitedCollaborators = InvitedCollaboratorUpdater.updateRemoteItems(invitedCollaboratorUpdateSession, result.invitations);
        invitedCollaboratorUpdateSession.commit();
        return { items: invitedCollaborators };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CollaboratorsByAssetID extends ItemBase {
    constructor() {
        super(...arguments);
        this._collaborators = [];
        this._error = undefined;
    }
    /**
     * Since collaborators are a model around the relationship of a
     * particular user and an asset, it should always have an AssetID.
     */
    get getAssetID() {
        return this.id;
    }
    get collaborators() {
        return this._collaborators;
    }
    get error() {
        return this._error;
    }
}
const CollaboratorFormat = {
    parse: (value) => {
        return value;
    },
    isEqual: (a, b) => {
        return isDeepEqual(a, b);
    }
};
function getCollaborators(source, dest) {
    const collaboratorPool = new ItemPool(dest._core, 'collaborator');
    const session = collaboratorPool.createUpdateSession();
    // failed to fetch collaborators for this asset
    if (source.statusCode !== 200) {
        return [];
    }
    const response = JSON.parse(source.response);
    // Add the assetID to the response from the URN provided by
    // the service so Collaborators are tied to an asset.
    const collaboratorsWithID = response.collaborators.map((collab) => {
        return Object.assign(Object.assign({}, collab), { assetID: source.urn });
    });
    const collaborators = CollaboratorUpdater.updateRemoteItems(session, collaboratorsWithID);
    session.commit();
    return collaborators;
}
const ErrorFormat = {
    parse: (value) => {
        return value;
    },
    isEqual: (a, b) => {
        return isDeepEqual(a, b);
    }
};
function getError(source) {
    if (source.statusCode === 200) {
        return undefined;
    }
    // this is how a sample response looks like (got it from the sam.js demo)
    // response: '{"statusCode":404,"error":"Not Found"}'
    const response = JSON.parse(source.response);
    return SAMError.createWithRepositoryCode(response.statusCode, '', response.error);
}
const CollaboratorsByAssetIDUpdater = new ItemUpdater({
    localItemType: CollaboratorsByAssetID,
    remoteIdProperty: 'urn',
    propertyUpdater: new PropertyUpdater({
        '_collaborators': { get: getCollaborators, format: CollaboratorFormat },
        '_error': { get: getError, format: ErrorFormat }
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CollaboratorsByAssetIDLoader {
    constructor(_collaboratorsByAssetIDPool, _invitationInterface, _assetIDs) {
        this._collaboratorsByAssetIDPool = _collaboratorsByAssetIDPool;
        this._invitationInterface = _invitationInterface;
        this._assetIDs = _assetIDs;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, start = 0) {
        let { limit } = options;
        limit = limit === undefined ? this._invitationInterface.batchRequestLimit : limit;
        // max limit supported by invitation service batch api is 50, capping limit
        limit = Math.min(limit, this._invitationInterface.batchRequestLimit);
        const slicedAssetIDs = this._assetIDs.slice(start, start + limit);
        const batchInvitationResponse = await this._invitationInterface.getCollaboratorListForUrns(slicedAssetIDs);
        const session = this._collaboratorsByAssetIDPool.createLoaderUpdateSession(Date.now());
        const collaboratorByAssetIDs = CollaboratorsByAssetIDUpdater.updateRemoteItems(session, batchInvitationResponse.result);
        session.commit();
        // Check if we have another page to load.
        let loadNextPage;
        if (start + collaboratorByAssetIDs.length < this._assetIDs.length) {
            loadNextPage = (options) => this._loadPage(options, start + collaboratorByAssetIDs.length);
        }
        return { items: collaboratorByAssetIDs, loadNextPage };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class BatchOperationQueue {
    constructor(_batchProcessor, _maxItemsPerBatch = 50, _delay = 50, _maxInFlightBatches = 3) {
        this._batchProcessor = _batchProcessor;
        this._maxItemsPerBatch = _maxItemsPerBatch;
        this._delay = _delay;
        this._maxInFlightBatches = _maxInFlightBatches;
        // Sets are guaranteed to be iterated in FIFO order
        this._itemQueue = new Set();
        this._itemPromises = new Map();
        this._inFlightBatches = new Set();
        this._processQueue = async () => {
            clearTimeout(this._timer);
            this._timer = undefined;
            try {
                if (this.inFlightCount >= this._maxInFlightBatches) {
                    await Promise.race([...this._inFlightBatches].map(inFlightBatch => inFlightBatch.promise));
                }
            }
            catch (e) {
                // Do nothing
            }
            while (this.inFlightCount <= this._maxInFlightBatches && this._itemQueue.size > 0) {
                const batch = new Set();
                while (this._itemQueue.size > 0 && batch.size < this._maxItemsPerBatch) {
                    const item = this._itemQueue.values().next().value;
                    this._itemQueue.delete(item);
                    batch.add(item);
                }
                // self-deleting batch Promise
                const inFlightBatch = {
                    batch,
                    promise: this._batchProcessor(batch)
                        .catch(() => { [...batch.values()].forEach((item) => this.rejectItemPromise(item)); })
                        .finally(() => {
                        this._inFlightBatches.delete(inFlightBatch);
                        [...batch.values()].forEach(item => this.resolveItemPromise(item));
                    })
                };
                this._inFlightBatches.add(inFlightBatch);
            }
            if (this._itemQueue.size > 0 && !this._timer) {
                this._timer = setTimeout(this._processQueue, this._delay);
            }
        };
    }
    enqueue(item) {
        // Already in progress
        if (this.isInQueue(item) || this.isInFlight(item)) {
            return this._itemPromises.get(item).promise;
        }
        this._itemQueue.add(item);
        const managedPromise = new ManagedPromise();
        this._itemPromises.set(item, managedPromise);
        if (!this._timer) {
            this._timer = setTimeout(this._processQueue, this._delay);
        }
        // Don't wait to process the batch if a max-size batch request can be made
        if (this._itemQueue.size >= this._maxItemsPerBatch) {
            this._processQueue();
        }
        return managedPromise.promise;
    }
    dequeue(item) {
        const hasItem = this._itemQueue.has(item);
        this._itemQueue.delete(item);
        // Only resolve if still pending, otherwise it is too late to dequeue and must wait for the batch result
        if (hasItem) {
            this._itemPromises.get(item).resolve();
            this._itemPromises.delete(item);
        }
        return hasItem;
    }
    /**
     * Called by batchProcessor implementation if it needs to mark some items in the batch as successes, and some
     * as failures. If it does neither, it will assume that resolving the batchProcessor means all succeeded, and
     * rejecting the batchProcessor will mean all failed.
     *
     * @param item {T}
     */
    resolveItemPromise(item) {
        var _a;
        (_a = this._itemPromises.get(item)) === null || _a === void 0 ? void 0 : _a.resolve();
        this._itemPromises.delete(item);
    }
    rejectItemPromise(item) {
        var _a;
        (_a = this._itemPromises.get(item)) === null || _a === void 0 ? void 0 : _a.reject();
        this._itemPromises.delete(item);
    }
    get size() {
        return this._itemQueue.size;
    }
    get inFlightCount() {
        return this._inFlightBatches.size;
    }
    isInQueue(item) {
        return this._itemQueue.has(item);
    }
    isInFlight(item) {
        return !![...this._inFlightBatches].find(inFlightBatch => inFlightBatch.batch.has(item));
    }
    /**
     * Forces the queue to run all batches as fast as possible.
     *
     * @package -- for internal SAM.js use only
     */
    async _processNow() {
        if (!this._itemQueue.size && !this._inFlightBatches.size) {
            // No work to do
            return;
        }
        do {
            this._processQueue();
            try {
                await Promise.race([...this._inFlightBatches].map(batch => batch.promise));
            }
            catch (e) {
                // do nothing
            }
        } while (this._itemQueue.size);
    }
}
var BatchOperationQueue$1 = BatchOperationQueue;

class AddressBook extends ItemBase {
    constructor(_core, id) {
        super(_core, id);
        this._displayName = '';
        this._ownerId = '';
    }
    get ident() {
        return this.id;
    }
    get displayName() {
        return this._displayName;
    }
    get ownerId() {
        return this._ownerId;
    }
    async getContactInAddressBook(adobeId) {
        return this._core.collaborationContext.getContactInAddressBook(this.ident, adobeId);
    }
}
__decorate([
    observable$1
], AddressBook.prototype, "ident", null);
__decorate([
    observable$1
], AddressBook.prototype, "displayName", null);
__decorate([
    observable$1
], AddressBook.prototype, "ownerId", null);
const AddressBookUpdater = new ItemUpdater({
    localItemType: AddressBook,
    remoteIdProperty: 'ident',
    propertyUpdater: new PropertyUpdater({
        _displayName: 'displayName',
        _ownerId: 'ownerId'
    })
});

class AddressBookLoader {
    constructor(_addressBookPool, _addressBookInterface, _addressBookUpdater) {
        this._addressBookPool = _addressBookPool;
        this._addressBookInterface = _addressBookInterface;
        this._addressBookUpdater = _addressBookUpdater;
    }
    async loadPage(options) {
        const { limit = 100 } = options || { limit: 100 };
        // Currently, pagination isn't supported because it is difficult to find a list of >1
        // AddressBooks to validate the pagination works
        const result = await this._addressBookInterface.getAddressBooks(limit);
        const session = this._addressBookPool.createLoaderMutationSession();
        const items = this._addressBookUpdater.updateRemoteItems(session, result._embedded.addressBooks);
        return { items, total: result.total };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CollaborationContext {
    constructor(_core) {
        this._core = _core;
        this._collaboratorSourceMap = new Map();
        this._invitationInterface = new InvitationInterface(this._core);
        this._collaboratorsByAssetIDPool = new ItemPool(this._core, 'collaboratorsByAssetID');
        this._accessConfirmedIDs = new Set();
        this._addressBookPool = new ItemPool(this._core, 'addressBook');
        // Note: presuming that AddressBookContact is unique to an AddressBook
        this._addressBookContactPoolMap = new Map();
        this._handleBatchRequest = async (items) => {
            const assetMap = new Map([...items].map(item => [item.id, item]));
            const batchInvitationResponse = await this._invitationInterface.getCollaboratorListForUrns([...assetMap.keys()]);
            const results = batchInvitationResponse.result;
            results.forEach((result) => {
                const assetId = result.urn;
                const asset = assetMap.get(assetId);
                if (!asset) {
                    return;
                }
                if (result.statusCode !== 200) {
                    // Reject the item promise so that the item can be fetched again later.
                    this._collaboratorRequestQueue.rejectItemPromise(asset);
                    return;
                }
                const sources = this._getCollaboratorSources(assetId);
                const invitationResponse = JSON.parse(result.response);
                // Add the assetId and isDirect to the returned data.
                const collaboratorsWithAssetIds = invitationResponse.collaborators.map((collaboratorData) => {
                    const isDirectCollaborator = invitationResponse.directCollaborators.find((c) => c.id === collaboratorData.id);
                    return Object.assign(Object.assign({}, collaboratorData), { assetID: assetId, isDirect: !!isDirectCollaborator });
                });
                const collaboratorUpdateSession = sources.collaboratorPool.createUpdateSession();
                const collaborators = CollaboratorUpdater.updateRemoteItems(collaboratorUpdateSession, collaboratorsWithAssetIds);
                collaboratorUpdateSession.commit();
                asset._setCollaboratorData(collaborators);
            });
        };
        this._collaboratorRequestQueue = new BatchOperationQueue$1(this._handleBatchRequest);
    }
    /**
     * For use-cases where we want to immediately fetch collaborators but using the batch system
     * instead of the collaborator listing.
     */
    async _getCollaboratorsNow(asset) {
        await this._collaboratorRequestQueue.enqueue(asset);
        await this._collaboratorRequestQueue._processNow();
        if (LazyLoadManager.hasManager(asset, SharedCollaboratorChangedEvent)) {
            LazyLoadManager.updatedExternally(asset, SharedCollaboratorChangedEvent);
        }
        else {
            // SAM.cpp doesn't have LazyLoadManager
            asset.dispatch(SharedCollaboratorChangedEvent);
        }
    }
    /**
     * get a list of Collaborators
     * @param assetsIDs list of assetIDs (including from Teams and Spaces, not just AdobeAssets)
     */
    /**
     * @deprecated -- will be removed on or after 2024-10-01
     *  Use {@link ShareableItem.collaboratorArray} instead.
     */
    getCollaboratorsForAssets(assetsIDs) {
        oneTimeWarning('getCollaboratorsForAssets', 'This method is deprecated and will be removed. Use ShareableItem.collaboratorArray instead.');
        const loader = new CollaboratorsByAssetIDLoader(this._collaboratorsByAssetIDPool, this._invitationInterface, assetsIDs);
        const source = new ItemSource(this._collaboratorsByAssetIDPool, [loader], new EverythingFilter());
        return source;
    }
    /**
     * Get's all the ItemSources for Collaborators and InvitedCollaborators.
     * @note ItemPools for collaborators can't be shared between assets because they may have different roles per asset.
     * @note This no longer stores and returns WeakRefs due to how we have to update the collaborators, it causes
     * the refs to be reclaimed before we are able to update the collaborators with new information and causes
     * new item pools to be created everytime.
     * @package used internally only
     */
    _getCollaboratorSources(assetID) {
        const sources = this._collaboratorSourceMap.get(assetID);
        if (sources) {
            return sources;
        }
        // We cannot share the pools for Collaborator/InvitedCollaborator objects between
        // assets as they might have different roles for the same IDs.
        const collaboratorPool = new ItemPool(this._core, 'collaborator');
        const collaboratorLoader = new CollaboratorLoader(collaboratorPool, this._invitationInterface, assetID);
        const collaboratorSource = new ItemSource(collaboratorPool, [collaboratorLoader], new EverythingFilter());
        const invitedCollaboratorPool = new ItemPool(this._core, 'invitedCollaborator');
        const invitedCollaboratorLoader = new InvitedCollaboratorLoader(invitedCollaboratorPool, this._invitationInterface, assetID);
        const invitedCollaboratorSource = new ItemSource(invitedCollaboratorPool, [invitedCollaboratorLoader], new EverythingFilter());
        const collaboratorSources = { collaboratorPool, collaboratorSource, invitedCollaboratorPool, invitedCollaboratorSource };
        this._collaboratorSourceMap.set(assetID, collaboratorSources);
        return collaboratorSources;
    }
    /**
     * @deprecated -- will be removed on or after 2024-10-01
     *    Use {@link ShareableItem.collaboratorArray} instead
     */
    getCollaborators(assetID) {
        oneTimeWarning('CollaborationContext.getCollaborators', 'This method is deprecated and will be removed. Use ShareableItem.collaboratorArray instead.');
        return this._getCollaboratorSources(assetID).collaboratorSource;
    }
    /**
     * @deprecated -- will be renamed for internal use on or after 2024-10-01.
     *   Use {@link ShareableItem.removeCollaborator} instead
     */
    async removeCollaborator(assetID, collaborator) {
        oneTimeWarning('CollaborationContext.removeCollaborator', 'This method is deprecated and will be removed on or after 2024-10-01. Use ShareableItem.removeCollaborator instead.');
        return this._removeCollaborator(assetID, collaborator);
    }
    /**
     * Removes the provided Collaborator and updates the ItemPools.
     *
     * This eventually performs a PATCH request to the invitations service and removes the provided invited
     * collaborator.
     *
     * @package -- for use in SAM.js only
     *
     * @throws If the request is not successful, an error is thrown.
     *
     * @param assetID
     * @param collaborator {Collaborator}
     */
    async _removeCollaborator(assetID, collaborator) {
        var _a, _b;
        const response = await this._invitationInterface.modifyCollaborators(assetID, {
            collaborators: [{ id: collaborator.id, action: 'remove' }]
        });
        const collaboratorResponse = (_a = response.collaborators) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === collaborator.id);
        if (!collaboratorResponse) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Collaborator patch request unsuccessful');
        }
        if (collaboratorResponse.statusCode !== 200) {
            throw SAMError.createWithRepositoryCode(collaboratorResponse.statusCode, (_b = collaboratorResponse.errorSubcode) !== null && _b !== void 0 ? _b : '', collaboratorResponse.statusText);
        }
        const { collaboratorPool } = this._getCollaboratorSources(assetID);
        const updateSession = collaboratorPool.createUpdateSession();
        updateSession.queueDiscardedItem(collaborator);
        // If the current user is being removed from the collaboration list, remove the asset from accessConfirmedIDs
        // in case the user is re-invited to the asset and needs to confirm access again.
        if (collaborator.isCurrentUser) {
            this._accessConfirmedIDs.delete(assetID);
        }
        updateSession.commit();
    }
    /**
     * Removes the provided InvitedCollaborator and updates the ItemPools.
     *
     * This eventually performs a PATCH request to the invitations service and removes the provided invited
     * collaborator.
     *
     * @throws If the request is not successful, an error is thrown.
     *
     * @param assetID
     * @param invitedCollaborator {InvitedCollaborator}
     */
    /**
     * @deprecated -- will be removed on or after 2025-01-01.
     */
    async removeInvitedCollaborator(assetID, invitedCollaborator) {
        var _a, _b;
        oneTimeWarning('CollaborationContext.removeInvitedCollaborator', 'This method is deprecated and will be removed on or after 2025-01-01.');
        const response = await this._invitationInterface.modifyCollaborators(assetID, {
            invitations: [{ id: invitedCollaborator.id, action: 'remove' }]
        });
        const collaboratorResponse = (_a = response.invitations) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === invitedCollaborator.id);
        if (!collaboratorResponse) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'InvitedCollaborator patch request unsuccessful');
        }
        if (collaboratorResponse.statusCode !== 200) {
            throw SAMError.createWithRepositoryCode(collaboratorResponse.statusCode, (_b = collaboratorResponse.errorSubcode) !== null && _b !== void 0 ? _b : '', collaboratorResponse.statusText);
        }
        const { invitedCollaboratorPool } = this._getCollaboratorSources(assetID);
        const updateSession = invitedCollaboratorPool.createUpdateSession();
        updateSession.queueDiscardedItem(invitedCollaborator);
        updateSession.commit();
    }
    /**
     * @deprecated -- will be removed on or after 2025-01-01.
     *    It may be possible to use {@link ShareableItem.collaboratorArray}. If this does not work, contact the
     *    SAM.js team before removal.
     */
    getInvitedCollaborators(assetID) {
        oneTimeWarning('CollaborationContext.getInvitedCollaborators', 'This method is deprecated and will be removed on or after 2025-01-01. Use'
            + ' ShareableItem.collaboratorArray instead.');
        return this._getCollaboratorSources(assetID).invitedCollaboratorSource;
    }
    /**
     * Used by ShareableItem and SAMCpp.ts patches
     *
     * @package -- only for use inside SAM.js
     */
    async _removeCurrentUserFromCollaborationList(asset) {
        // If collaborator array isn't loaded or needs refresh, load it immediately
        if (!asset._isCollaboratorDataLoaded) {
            await this._getCollaboratorsNow(asset);
        }
        const collaborator = asset.collaboratorArray.find(c => c.isCurrentUser);
        if (!collaborator) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Current user is not a collaborator on ${asset.id}`);
        }
        await this._removeCollaborator(asset.id, collaborator);
        // _removeCollaborator() will remove the Collaborator from the pools, but it also needs to be removed from the
        // collaboratorArray, and the collaboration flags need to be re-calculated, and collaboration event listeners
        // notified.
        if (asset.collaboratorArray.includes(collaborator)) {
            const updatedCollaborators = asset.collaboratorArray.filter(c => c !== collaborator);
            asset._setCollaboratorData(updatedCollaborators);
            if (LazyLoadManager.hasManager(asset, SharedCollaboratorChangedEvent)) {
                LazyLoadManager.updatedExternally(asset, SharedCollaboratorChangedEvent);
            }
            else {
                // SAM.cpp doesn't have LazyLoadManager
                asset.dispatch(SharedCollaboratorChangedEvent);
            }
        }
    }
    /**
     * @deprecated -- do not use, it does not work for users who were invited via an address book contact,
     * and may break for all use cases in the future. Instead, use
     * {@link ShareableItem.removeCurrentUserFromCollaborationList}. Will be removed on or after 2024-10-01.
     *
     *  https://jira.corp.adobe.com/browse/SAM-3564
     */
    removeCurrentUserFromCollaborationList(assetID) {
        oneTimeWarning('removeCurrentUserFromCollaborationList/getCollaborator', 'This method does not work correctly and will be removed. Use'
            + ' ShareableItem.removeCurrentUserFromCollaboratorList() insstead.');
        const collaborator = this.getCollaborator(assetID);
        return this._removeCollaborator(assetID, collaborator);
    }
    /**
     * @deprecated -- Do not use, it does not work unless collaborator data is already loaded, and the Collaborator
     * representing the current user was NOT invited via an address book contact. The Collaborator it returns in most
     * cases will have invalid data in it. Will be removed on or after 2024-10-01.
     *
     * https://jira.corp.adobe.com/browse/SAM-3564
     */
    getCollaborator(assetID) {
        var _a;
        oneTimeWarning('removeCurrentUserFromCollaborationList/getCollaborator', 'This method does not work correctly and will be removed. Use'
            + ' ShareableItem.collaboratorsArray.find(c => c.isCurrentUser()) instead.');
        const userID = this._core._environment.getValue('USER_ID');
        const collaborator = (_a = this._getCollaboratorSources(assetID).collaboratorPool.getLocalItemById(userID)) !== null && _a !== void 0 ? _a : new Collaborator(this._core, userID);
        return collaborator;
    }
    /**
     *
     * @package Used internally.
     *
     * @param assetID
     * @param collaborators List of collaborators to add
     * @param configuration Configuration for the invitation, for example useMounts and acceptanceRequired.
     * @param notification Notification for the invitation, @note undefined will not send any notifications.
     * @param captcha Captcha for the invitation.
     * @param inviterLabel Inviter label for the invitation.
     */
    async _addCollaborators(assetID, collaborators, configuration, 
    /**
     * Leaving this undefined will not send any notifications.
     */
    notification, captcha, 
    /**
     * Required for service principal token requests.
     */
    inviterLabel) {
        const request = Object.assign(Object.assign(Object.assign(Object.assign({ recipients: collaborators }, (!notification
            ? {
                notification: {
                    ans: {}
                }
            }
            : { notification })), (configuration ? { configuration } : {})), (captcha ? { captcha } : {})), (inviterLabel ? { inviterLabel } : {}));
        await this._invitationInterface.addCollaborators(assetID, request);
    }
    /**
     * @package -- Used internally.
     *
     * @param assetID Resources URN or AssetID of the resource to modify collaborators for.
     * @param collaborators List of collaborators to add.
     * @param configuration Configuration for the invitation, for example useMounts and acceptanceRequired.
     * @param notification Notification for the invitation, @note undefined will not send any notifications.
     */
    async _modifyCollaborators(assetID, collaborators, configuration, notification) {
        const request = Object.assign(Object.assign({ collaborators }, (configuration ? { configuration } : {})), (notification ? { notification } : {}));
        this._invitationInterface.modifyCollaborators(assetID, request);
    }
    getPendingInvitations() {
        return this._invitationInterface.getPendingInvitations();
    }
    /**
     * A method that confirms access for a resource or asset and keeps
     * track of that confirmation for this session to prevent
     * more than one call being made per session per asset.
     *
     * Confirming access is not about permissions per se, it's more
     * about accepting the invitation to a resource that requires acceptance.
     *
     * It also handles email/account ambiguity so let's say an email
     * has more than one adobe account associated with it, calling
     * confirm access will also resolve this issue at that time.
     *
     * @note This is really just a temporary measure until
     * the Invitations Service can provide a more efficient way
     * of checking multiple assets at a time to see if they
     * have already confirmed access for the current user token.
     *
     *
     * @param assetId Resource URN
     * @returns void
     */
    async confirmAccess(assetId) {
        // Skip confirm access call if we have already confirmed access, or if the user is using a guest access token.
        if (this._accessConfirmedIDs.has(assetId) || this._core._environment.getValue('SESSION_TYPE') === 'guest') {
            return;
        }
        await this._invitationInterface.confirmAccess(assetId);
        this._accessConfirmedIDs.add(assetId);
    }
    /**
     * Returns a list of AddressBooks for the current user.
     *
     * @experimental -- given the way this feature was rushed in, and some gaps in knowledge
     * about ABS and GenAI, this may not be the final API. Backward-compatibility will not
     * be guaranteed.
     *
     * @returns {AddressBookSource}
     */
    get addressBookSource() {
        const loader = new AddressBookLoader(this._addressBookPool, new AddressBookInterface(this._core), AddressBookUpdater);
        return new ItemSource(this._addressBookPool, [loader]);
    }
    /** @package -- for use in SAM.js only */
    _getAddressBookContactPool(addressBookIdent) {
        let pool = this._addressBookContactPoolMap.get(addressBookIdent);
        if (!pool) {
            pool = new ItemPool(this._core, 'addressBookContact');
            this._addressBookContactPoolMap.set(addressBookIdent, pool);
        }
        return pool;
    }
    /**
     * For a specified AddressBook, look up the Contact for a specified userId
     *
     * @experimental -- given the way this feature was rushed in, and some gaps in knowledge
     * about ABS and GenAI, this may not be the final API. Backward-compatibility will not
     * be guaranteed.
     *
     * @param {string} addressBookIdent
     * @param {string} userId
     * @returns {Promise<AddressBookContact>}
     */
    async getContactInAddressBook(addressBookIdent, userId) {
        const pool = this._getAddressBookContactPool(addressBookIdent);
        let contact = pool.getLocalItemById(userId);
        if (contact) {
            return contact;
        }
        const abs = new AddressBookInterface(this._core);
        const result = await abs.getContactInAddressBook(addressBookIdent, userId);
        const session = pool.createMutationSession();
        contact = AddressBookContactUpdater.updateRemoteItem(session, result);
        session.commit();
        return contact;
    }
    /**
     * @experimental
     */
    async getCollaboratorOrder(direction = 'ascending', field = 'name') {
        const { default: CollaboratorOrder } = await Promise.resolve().then(function () { return CollaboratorOrder$1; });
        return new CollaboratorOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getInvitedCollaboratorOrder(direction = 'ascending', field = 'email') {
        const { default: InvitedCollaboratorOrder } = await Promise.resolve().then(function () { return InvitedCollaboratorOrder$1; });
        return new InvitedCollaboratorOrder(direction, field);
    }
}
__decorate([
    memoize$1
], CollaborationContext.prototype, "addressBookSource", null);
__decorate([
    keepAlive
], CollaborationContext.prototype, "getContactInAddressBook", null);

var CollaborationContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': CollaborationContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function computeGradientID(rawGradientId, languageCode) {
    return `${rawGradientId}-${languageCode}`;
}
/**
 * Takes the response from the service and computes the result
 * to add additional properties.
 *
 * @param rawGradientData Data directly from the service.
 * @param defaultGradientId The default gradient from the service.
 * @param languageCode The language code.
 * @returns
 */
function computeGradients(rawGradientData, defaultGradientId, languageCode) {
    return rawGradientData.map((gradient) => {
        return Object.assign(Object.assign({}, gradient), { computedID: computeGradientID(gradient['project:gradientId'], languageCode), 'project:gradientData': Object.assign(Object.assign({}, gradient['project:gradientData']), { isDefault: defaultGradientId === gradient['project:gradientId'], languageCode }) });
    });
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ImplicitDirectoryListingAssetFilter {
    constructor(options) {
        const { asset, mediaTypes, excludeMediaTypes } = options, baseOpts = __rest$2(options, ["asset", "mediaTypes", "excludeMediaTypes"]);
        // ImplicitDirectoryListingFilter handles the ImplicitAdobeAssetFilterBase cases
        this._implicitDirectoryListingFilter = new ImplicitDirectoryListingFilter(Object.assign({ asset }, baseOpts));
        if (mediaTypes || excludeMediaTypes) {
            this._adobeAssetFilter = new AdobeAssetFilter({
                mediaTypes,
                excludeMediaTypes
            });
        }
    }
    matches(item) {
        if (this._adobeAssetFilter && !this._adobeAssetFilter.matches(item)) {
            return false;
        }
        if (this._implicitDirectoryListingFilter && !this._implicitDirectoryListingFilter.matches(item)) {
            return false;
        }
        // it matched both filters above
        return true;
    }
    get mediaTypes() {
        var _a;
        return (_a = this._adobeAssetFilter) === null || _a === void 0 ? void 0 : _a.mediaTypes;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class Project extends AdobeAsset {
    constructor(_core, id, metadata) {
        super(_core, id, metadata);
        this._core = _core;
        this.isProject = true;
        this._description = '';
        // We have separate permissions for a Project and AdobeAsset.
        // AdobeAsset permissions for a project are the permissions on the folder (i.e. representing the project)
        // ESM users might not have permission on the parent folder for Projects, so the permissions cannot be derived
        // from the parent folder like normal folders.
        this._projectPermissions = PERMISSION_ALL;
        this._projectInterface = new ProjectsInterface(this._core);
        this._repositoryOwner = { id: '', type: 'user' };
        this._directorySubtype = ProjectDirectorySubtype.CC_PROJECTS;
        this._assetClass = 'directory';
        /**
         * [SHARED-3832] Some Projects are available to the whole org but should not show up in the current user's listings
         * unless it is a recent Project. However, detecting this case is tricky in getProjectbyID, so it should assume the
         * Project is not allowed on lists until it is proven that it should be allowed.
         *
         * @package -- for use in SAM.js only
         */
        this._allowInLists = false;
        /**
         * @package -- only for use in SAM.js
         * TODO: once we have support for lastAccessDate from projects service, we can set remove this.
         */
        this._isRecent = false;
        this._projectLinks = metadata === null || metadata === void 0 ? void 0 : metadata.projectLinks;
        // Overridden property.
        // True to start with. If we have the metadata, we will update this.
        this._needsRepoMetadata = true;
        LazyLoadManager.manageLazyLoading(this, [{
                event: SharedChangeEvent,
                fetchData: this._getGradient
            }]);
    }
    get gradientID() {
        var _a;
        return (_a = this._gradientID) !== null && _a !== void 0 ? _a : '';
    }
    /**
     * Lazy loads and returns the Gradient belonging to this
     * Project.
     */
    get gradient() {
        return this._gradient;
    }
    async _getGradient() {
        this._gradient = await this._core.projectContext.getGradient(this.gradientID);
    }
    /**
     * @TODO@PROJECT
     * @experimental API may change.
     */
    get description() {
        oneTimeWarning('Description Not yet Supported', 'Currently the description field is not supported by the service.');
        return this._description;
    }
    /**
     * This property represents the "sub-type" of the project directory. There have been several
     * new types introduced to support CSC Projects.
     *
     * ACPC Project is the general term used to describe the "project" construct
     * in AUP, the CSC Project (Content Supply Chain) Project
     *
     * WFProject: Work Front Project
     * CCProject: Creative Cloud Project
     *
     */
    get directorySubtype() {
        return this._directorySubtype;
    }
    /**
     * @param repoMetadata {RepositoryMetadata} If passed in, it will be used instead of loading from the service
     * @param appMetadata {any} If passed in, it will be used instead of loading from the service
     *
     * @package -- only for use in SAM.js
     */
    async _load({ repoMetadata, appMetadata, effectivePermission, projectMetadata, perUserMetadata } = {}) {
        // First load the AdobeAsset so that once we get the project metadata we override any relevant
        // properties with the project metadata. One example of such field is createdBy. Etag is another one.
        // We need to take care of permissions. We will get the permissions from the project service
        // and we should handle them here as they are extended from RAPI effective permissions.
        // https://jira.corp.adobe.com/browse/SAM-3086
        // Also we need update the load method so that it does not load the permissions for a project
        // We can probably govern that with the help of an argument to the load method.
        await super._load({ repoMetadata, appMetadata, effectivePermission, perUserMetadata });
        // If we have the project metadata, then we will use that to update the project
        if (!projectMetadata) {
            // load the project metadata using the project service
            projectMetadata = await this._projectInterface.getProject(this.id);
        }
        const session = this._core.projectContext._assetPool.createMutationSession();
        this._core.projectContext._projectUpdater.updateRemoteItem(session, projectMetadata);
        session.commit();
    }
    // @TODO@PROJECT We should implement something similar to _ensureLink here.
    get projectLinks() {
        return this._projectLinks;
    }
    get creator() {
        return this._creator;
    }
    /**
     * The view that this project belongs to.
     */
    get view() {
        // repositoryOwner is not loaded yet
        if (!this._repositoryOwner.id) {
            return undefined;
        }
        const currentUserId = this._core._environment.getUserId();
        const { defaultOrganizationId, organizations } = this._core.hostAssetContext;
        const allOwners = [
            currentUserId,
            ...((organizations === null || organizations === void 0 ? void 0 : organizations.map(org => org.id)) || [])
        ];
        if (this._repositoryOwner.id === currentUserId || this._repositoryOwner.id === defaultOrganizationId) {
            return ProjectViews.Yours;
        }
        if (!allOwners.includes(this._repositoryOwner.id)) {
            return ProjectViews.SWY;
        }
        return undefined;
    }
    async move(destFolder) {
        oneTimeWarning('[MOVE_UNSUPPORTED]', `Move on a project is not supported ${destFolder}`);
        return;
    }
    async rename(newName) {
        var _a;
        if (!((_a = this._projectLinks) === null || _a === void 0 ? void 0 : _a[RelType.PROJECTS_RENAME])) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Rename link is missing for this project.');
        }
        if (!validatePlatformRepoName(newName)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for asset rename operation.');
        }
        await this._projectInterface.renameProject(newName, this._projectLinks);
        const projectPool = this._core.projectContext._assetPool;
        const assetContext = await this._core.getAssetContext();
        // Update the repo:name and repo:path after a rename
        const session = projectPool.createUpdateSession();
        const newPath = renameFileInPath(newName, this);
        updateCachedDescendents({
            assetPool: this._core._getAssetPool(),
            asset: this,
            session,
            operation: { type: 'rename', newPath },
            assetContext
        });
        this._core.projectContext._projectUpdater.updateLocalItem(session, this, { 'repo:name': newName, 'repo:path': newPath });
        session.commit();
    }
    /**
     * Discards a project through the Projects service instead of RAPI.
     *
     */
    async discard() {
        if (this.isDiscarded) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Asset is already discarded');
        }
        await this._ensureLink(RelType.DISCARD);
        await this._projectInterface.discardProject(this.id, this._projectLinks);
        const projectPool = this._core._getAssetPool();
        const assetContext = await this._core.getAssetContext();
        const session = projectPool.createUpdateSession();
        updateCachedDescendents({
            assetPool: projectPool,
            asset: this,
            session,
            operation: { type: 'discard' },
            assetContext
        });
        this._core.projectContext._projectUpdater.updateLocalItem(session, this, { 'repo:state': 'DISCARDED' });
        session.commit();
    }
    /**
     * Restores a project through the Projects service instead of RAPI.
     *
     */
    async restore() {
        if (!this.isDiscarded) {
            throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Cannot restore an asset that is not discarded');
        }
        await this._ensureLink(RelType.RESTORE);
        await this._projectInterface.restoreProject(this.id, this._projectLinks);
        const projectPool = this._core._getAssetPool();
        const assetContext = await this._core.getAssetContext();
        const session = projectPool.createUpdateSession();
        updateCachedDescendents({
            assetPool: projectPool,
            asset: this,
            session,
            operation: { type: 'restore' },
            assetContext
        });
        this._core.projectContext._projectUpdater.updateLocalItem(session, this, { 'repo:state': 'ACTIVE' });
        session.commit();
    }
    /**
     * @package
     **/
    async _updateProjectLinksFromService() {
        // load the project links using the project service
        const returnProject = await this._projectInterface.getProject(this.id);
        const { _links } = returnProject;
        const projectPool = this._core.projectContext._assetPool;
        const session = projectPool.createUpdateSession();
        this._core.projectContext._projectUpdater.updateLocalItem(session, this, { _links });
        session.commit();
    }
    /**
     * @package
     **/
    _isProjectLinkType(relType) {
        return _projectLinkKeys().includes(relType);
    }
    async _ensureLink(relType) {
        var _a;
        // if the link is in _projectLinks, copy the _projectLink into _links
        // relType is an AssetsLink index, it might be a link that isn't in IProjectLinks
        if (this._isProjectLinkType(relType)) {
            if (!((_a = this._projectLinks) === null || _a === void 0 ? void 0 : _a[relType])) {
                await this._updateProjectLinksFromService();
            }
            const links = Object.assign(Object.assign({}, this.__links), { [relType]: this._projectLinks[relType] });
            //using the AssetUpdater instead of ProjectUpdater because ProjectUpdater has no way to update _links
            const session = this._core.hostAssetContext._assetPool.createUpdateSession();
            this._core.hostAssetContext._adobeAssetUpdater.updateLocalItem(session, this, { '_links': links });
            session.commit();
            return;
        }
        //call out to fetch the missing link
        this._core._environment.debug(`ProjectLinkMissing ${relType} Link ${relType} missing on project, called out fetch it`);
        await super._ensureLink(relType);
    }
    /**
     * Validates whether this project can be renamed to the provided name
     * SAM will take in the name from the client and substitute this in the repo:path
     * of the project to get an absolute path. Project service would need the absolute
     * path to disambiguate between projects for accounts that contain projects in both
     * shared storage (/content/assets) and user storage (/projects). Right now both these
     * belong to the same repository and once we have the unified storage model they will
     * have separate repository ids and we will be able to identify them using repository id.
     * @param name name of the project to be validated for rename.
     */
    async validateProjectNameForRename(name) {
        if (name.toLowerCase() === this.name.toLowerCase()) {
            return true;
        }
        return await this._core.projectContext.validateProjectNameForCreate(name, this);
    }
    /**
     * @experimental API May change.
     * @deprecated - to be removed in a future major version on or after 2024-10-01. SAM-3333
     */
    async updateProperties( /* properties: IProjectProperties */) { }
    /**
     * Returns an enumeration with a more precise reason for why the user
     * can or cannot leave the Project. It may also return PENDING if we are still
     * loading collaborator information.
     *
     * @returns {ProjectLeaveReason} An enumeration of reasons why the user can or cannot leave.
     */
    leaveStatus() {
        // Note: queues collaborators if not fetched already
        const collaborators = this.collaboratorArray;
        if (!this._isCollaboratorDataLoaded) {
            return ProjectLeaveReason.PENDING;
        }
        // If there are no collaborators returned, they can't leave anyway
        if (collaborators.length === 0) {
            return ProjectLeaveReason.CANNOT_LEAVE_NO_COLLABORATORS;
        }
        const currentUserCollaborator = collaborators.find((c) => c.isCurrentUser);
        // If the user doesn't exist in the collaborators list
        // this user has inherited access to this project and thus they can't
        // leave and we should return the address book group member error response.
        if (!currentUserCollaborator) {
            return ProjectLeaveReason.CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER;
        }
        if (currentUserCollaborator.role === 'owner') {
            return ProjectLeaveReason.CANNOT_LEAVE_IS_OWNER;
        }
        // Admins of the org have access to all Projects. But sometimes, they can be directly invited by other members
        // to the Project, which in this case, they are allowed to leave the Project as direct collaborator.
        // This only removes their entry in the `directCollaborators` list, but won't change the permission as admin
        // still have access to all content. Without direct invite permission, on leave, we show toast message such
        // that admin can't leave Project.
        if (!currentUserCollaborator.isDirect && currentUserCollaborator.isAdmin) {
            return ProjectLeaveReason.CANNOT_LEAVE_IS_ADMIN_OF_PROJECT;
        }
        // At this point if they are the only collaborator then
        // they can't leave, this case happens when a CCI user creates
        // a Project and they are the only collaborator direct or not.
        if (collaborators.length === 1) {
            return ProjectLeaveReason.CANNOT_LEAVE_LAST_COLLABORATOR;
        }
        // User cannot leave if they are no more collaborators who can share.
        const anotherDirectCollabWithSharePermissions = collaborators.find((c) => c.canShare && c.isDirect && c !== currentUserCollaborator);
        // We also need to distinguish between whether it is a USM project or shared-storage project.
        // In shared-storage projects, the user can't leave if they are the last direct collaborator with share permissions.
        // In user storage projects, the user can leave as long as she is not the owner of the project.
        if (!anotherDirectCollabWithSharePermissions && this.storageAssignee.type !== 'user') {
            return ProjectLeaveReason.CANNOT_LEAVE_LAST_DIRECT_COLLAB_WITH_SHARE_PERMISSION;
        }
        // If the user is not a direct collaborator and is also
        // not and admin, they can't leave due to inheriting
        // access to this project and not getting directly invited.
        if (!currentUserCollaborator.isDirect) {
            return ProjectLeaveReason.CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER;
        }
        return ProjectLeaveReason.CAN_LEAVE;
    }
    /**
     * Returns a boolean based on the userCanLeaveReason() response above.
     *
     * @deprecated -- Use {@link Project.leaveStatus instead} -- will be removed on or after 2024-10-01
     *
     * @returns Undefined while fetching collaborator data.
     */
    userCanLeaveProject() {
        oneTimeWarning('userCanLeaveProject Deprecated', 'Use Project.leaveStatus instead.'
            + ' This will be removed on or after 2024-10-01.');
        const reason = this.leaveStatus();
        switch (reason) {
            case ProjectLeaveReason.PENDING:
                return;
            case ProjectLeaveReason.CAN_LEAVE:
                return true;
            case ProjectLeaveReason.CANNOT_LEAVE_NO_COLLABORATORS:
            case ProjectLeaveReason.CANNOT_LEAVE_ADDRESS_BOOK_GROUP_MEMBER:
            case ProjectLeaveReason.CANNOT_LEAVE_LAST_COLLABORATOR:
            case ProjectLeaveReason.CANNOT_LEAVE_LAST_DIRECT_COLLAB_WITH_SHARE_PERMISSION:
            case ProjectLeaveReason.CANNOT_LEAVE_IS_ADMIN_OF_PROJECT:
            case ProjectLeaveReason.CANNOT_LEAVE_IS_OWNER:
                return false;
        }
    }
    hasPermission(...permissions) {
        return permissions.every((permission) => (this._projectPermissions & permission) === permission);
    }
    /**
     * Updates project data like gradientID
     *
     * @param data Data to be updated on a project.
     */
    async updateProject(data) {
        await this._core.projectContext.updateProject(this.id, data);
    }
    /**
     * @package For SAM.js internal use only
     * checks and sets the permission to restore the project
     */
    _applyRestorePermission(updateSession) {
        // We don't get the project permissions from USS right now so we try to infer the restore permissions
        // A user has restore permissions if she can create a project in the repository.
        const canRestore = this._core.projectContext._getCachedRestoreCapability(this.repositoryID);
        canRestore ? (this._projectPermissions |= Permission.Restore) : (this._projectPermissions &= ~Permission.Restore);
        this._core.projectContext._projectUpdater.updateLocalItem(updateSession, this, { projectPermissions: this._projectPermissions });
    }
    /**
    * @package -- only for use in SAM.js
    */
    // TODO: SAM-3499 will allow us to make this more efficient.
    async _reloadPermissions() {
        await this._load();
        super._reloadPermissions();
    }
    get librariesSource() {
        const directoryLoader = new AdobeAssetDirectoryLoader(this._core.hostAssetContext._assetPool, this, this._core, true, true);
        const implicitFilter = new ImplicitDirectoryListingAssetFilter({
            asset: this,
            mediaTypes: [libraryMediaTypeString],
            // Any Asset in a Project can also be SWY
            _isSharedWithYou: true
        });
        return new ItemSource(this._core.hostAssetContext._assetPool, [directoryLoader], implicitFilter);
    }
    get repositoryOwner() {
        return this._repositoryOwner;
    }
    /**
     * Creates a Library in this Project.
     *
     * @example
     * const roles: LibraryRole[] = [{
     *      type: 'brand',
     *      usage: 'usage_brand',
     *      priority: 'priority_brand'
     * }];
     * const library = project.createLibrary({ name: 'test', restrictEdit: true, roles });
     *
     */
    async createLibrary(data) {
        const libraryContext = await this._core.getLibraryContext();
        const options = {
            name: data.name,
            parent_assetId: this.id,
            roles: data.roles
        };
        options.access = data.restrictEdit ? 'team_view' : 'team_edit';
        return libraryContext._createLibrary(options);
    }
    async updateLastAccessed(clear) {
        await super.updateLastAccessed(clear);
        const session = this._core.projectContext._assetPool.createUpdateSession();
        // [SHARED-3832] all Recent projects show in Recent list, but might not show in any other list, so only
        // set isRecent here.
        this._core.projectContext._projectUpdater.updateLocalItem(session, this, { isRecent: Boolean(this.lastAccessed) });
        session.commit();
    }
}
__decorate([
    observable$1
], Project.prototype, "gradientID", null);
__decorate([
    lazyLoaded(SharedChangeEvent, '_gradient')
], Project.prototype, "gradient", null);
__decorate([
    observable$1
], Project.prototype, "description", null);
__decorate([
    observable$1
], Project.prototype, "view", null);
__decorate([
    lazyLoaded(SharedCollaboratorChangedEvent, '_collaboratorsArray')
], Project.prototype, "leaveStatus", null);
__decorate([
    observable$1
], Project.prototype, "hasPermission", null);
__decorate([
    memoize$1
], Project.prototype, "librariesSource", null);
__decorate([
    observable$1
], Project.prototype, "repositoryOwner", null);
function getPermission(source) {
    var _a;
    // From Project listing
    if ((_a = source._embedded) === null || _a === void 0 ? void 0 : _a[RelType.AC_EFFECTIVE]) {
        return parseProjectEffectivePermissions(source._embedded[RelType.AC_EFFECTIVE]);
    }
    // If the permissions are not present in the metadata then maintain the current value
    return NotFound;
}
const ProjectUpdater = new ItemUpdater({
    localItemType: Project,
    remoteIdProperty: 'repo:assetId',
    propertyUpdater: new PropertyUpdater({
        '_repositoryID': 'repo:repositoryId',
        '_path': 'repo:path',
        '_etag': 'repo:etag',
        '_created': { name: 'repo:createDate', format: 'date' },
        '_description': 'description',
        '_name': 'repo:name',
        '_assetState': { name: 'repo:state', choices: AssetStateChoices },
        '_storageAssignee': { name: 'storage:assignee', format: StorageAssigneeFormat },
        '_projectLinks': { name: '_links', format: 'object' },
        '_creator': { name: `_embedded[${RelType.PROJECTS_CREATOR}]`, format: 'object' },
        '_createdBy': `_embedded[${RelType.PROJECTS_CREATOR}].id`,
        /**
         * @note Adding single quotes to ['project:rendition'] causes the property
         * name to be computed as ''project:rendition'' with two single quotes.
         * This obviously will cause the property updater to not find the requested property and
         * not update it so the property naming convention is [project:rendition]
         * without single quotes around the name.
         */
        '_gradientID': {
            name: `_embedded[${RelType.APP_METADATA}][project:rendition].gradientId`,
            set: (gradientID, dest) => {
                const project = dest;
                if (!gradientID) {
                    project['_gradientID'] = '';
                    return;
                }
                const computedGradientID = computeGradientID(gradientID, project._core._environment.getValue('LOCALE'));
                if (project['_gradientID'] !== computedGradientID) {
                    project['_gradientID'] = computedGradientID;
                    LazyLoadManager.setLoadStatus(project, CHANGE, LoadStatus.NotLoaded);
                }
            }
        },
        '_projectPermissions': { get: getPermission, format: 'number' },
        '_repositoryOwner': { name: `_embedded[${RelType.REPOSITORY}][repo:owner]`, format: StorageAssigneeFormat },
        '_isRecent': { name: 'isRecent', format: 'boolean' },
        '_allowInLists': { name: 'allowInLists', format: 'boolean' },
        '_directorySubtype': { name: 'project:directorySubtype', choices: projectDirectorySubTypes }
    })
});

class ProjectsListLoader {
    constructor(_projectPool, _projectInterface, _projectUpdater, _core) {
        this._projectPool = _projectPool;
        this._projectInterface = _projectInterface;
        this._projectUpdater = _projectUpdater;
        this._core = _core;
    }
    supportsFilter(filter) {
        return filter !== undefined;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, pageLink) {
        var _a, _b;
        const { order, limit, filter } = options;
        // We will ignore the update if we had local changes sooner than this timestamp.
        // This default latency is set to 3 seconds right now. We should revisit this value.
        const latency = this._projectPool._core._environment.getValue('PROJECTS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        let result;
        if (pageLink) {
            // We are loading the next page with the link provided.
            result = await this._projectInterface.getProjectsWithLink(pageLink);
        }
        else if ((filter === null || filter === void 0 ? void 0 : filter.view) === ProjectViews.Recent) {
            const recentOptions = limit ? { first: limit } : {};
            result = await this._projectInterface.getRecentProjects(recentOptions, options.resource);
        }
        else {
            // If ProjectFilter is not provided by the client, then it will be an EverythingFilter,
            // so each ProjectFilter property needs to be checked for existence.
            // Note: If `view` parameter is unspecified, the server uses All as the default
            const view = !filter.view ? {} : { view: PROJECT_VIEW_TO_SERVICE_MAP[filter.view] };
            const repositoryId = filter.repositoryID ? { repositoryId: filter.repositoryID } : {};
            const nameContains = filter.nameContains ? { nameContains: filter.nameContains } : {};
            const isDiscarded = filter.isDiscarded ? { isDiscarded: true } : {};
            const directorySubtypes = filter.directorySubtypes ? { directorySubtypes: filter.directorySubtypes } : {};
            const ownerIds = [];
            await LazyLoadManager.fetchIfNeeded(this._core.hostAssetContext, ORGANIZATIONS_CHANGED);
            const homeOrgId = this._core.hostAssetContext.defaultOrganizationId || '';
            if (filter.view === ProjectViews.Yours) {
                ownerIds.push(this._core._environment.getUserId());
                if (homeOrgId) {
                    ownerIds.push(homeOrgId);
                }
            }
            else if (filter.view === ProjectViews.Organization || filter.view === ProjectViews.Admin) {
                if (filter.organizationID) {
                    ownerIds.push(filter.organizationID);
                }
            }
            result = await this._projectInterface.getProjects(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ orderBy: OrderFieldToIProjectsOrderBy[order.field], orderDirection: order.direction, limit }, view), repositoryId), nameContains), isDiscarded), (ownerIds.length ? { ownerId: ownerIds.join(',') } : {})), directorySubtypes), options.resource);
        }
        const session = this._projectPool.createLoaderUpdateSession(mostRecentValidMutation);
        const projects = result.children.map((project) => filter.view === ProjectViews.Recent
            // [SAMJS-311] isRecent can only be set from Recent view; some Projects are only visible on Recent view
            ? Object.assign(Object.assign({}, project), { isRecent: true }) : Object.assign(Object.assign({}, project), { allowInLists: true }));
        const items = this._projectUpdater.updateRemoteItems(session, projects);
        session.commit();
        // Check if we have another page to load.
        let loadNextPage;
        const nextPageLink = (_a = result._links) === null || _a === void 0 ? void 0 : _a.next;
        if (nextPageLink) {
            loadNextPage = (options) => this._loadPage(options, nextPageLink);
        }
        return {
            items,
            total: (_b = result._page) === null || _b === void 0 ? void 0 : _b.total,
            loadNextPage,
            mostRecentValidMutation
        };
    }
}

class ImplicitProjectFilter {
    constructor() {
        this.view = ProjectViews$1.All;
    }
    matches(item) {
        // [SHARED-3832] Projects should not show in lists until they're proven to be part of a list
        // [SAMJS-311] All Projects flagged as _isRecent should show up in _isRecent view
        return item.isProject && (item._allowInLists || item._isRecent);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Provides all Project related functionality like getting
 * lists of projects among other features.
 *
 * @experimental This API is in an experimental phase so expect that
 * API"s will not be final and there will be breaking changes
 * without bumping the major version until this comment is removed.
 */
class ProjectContext {
    constructor(_core, 
    /**
     * @package -- For use in SAM.js only
     */
    _assetPool) {
        this._core = _core;
        this._assetPool = _assetPool;
        this._projectInterface = new ProjectsInterface(this._core);
        this._gradientPool = new ItemPool(this._core, 'gradient');
        this._canRestoreProjectCache = new Map();
        /**
         * @package -- only for use in SAM.js
         * Updaters shouldn't be accessed directly.
         */
        this._projectUpdater = ProjectUpdater;
        // If the language configuration changes lets
        // just start refetching the gradients automatically.
        this._core.on(CONFIG_CHANGE, (event, sender, payload) => {
            if (payload.configurationKeyName === 'LOCALE') {
                this._getGradients();
            }
        });
    }
    /**
     * @package -- only for use in SAM.js
     * @deprecated Will be removed on or after 10-01-2024.
     */
    get assetPool() {
        oneTimeWarning('ProjectContext._assetPool', 'This property is deprecated and will be removed on or after'
            + ' 10-01-2024. For internal use by SAM.js only.');
        return this._assetPool;
    }
    /**
     * @experimental API May change.
     *
     * @example
     * const projectContext = samCore.projectContext;
     * const projectsSource = projectsContext.projects;
     * const yourProjects = projectsSource.getList();
     *
     * @TODO SAM-2834
     */
    projects() {
        // Trigger lazy-loading of the organizations if they haven't been loaded yet.
        this._core.hostAssetContext.organizations;
        const loader = new ProjectsListLoader(this._assetPool, this._projectInterface, this._projectUpdater, this._core);
        return new ItemSource(this._assetPool, [loader], new ImplicitProjectFilter());
    }
    /**
     * @experimental API May change.
     */
    async createProject(data) {
        const { name, gradientID } = data;
        if (!validatePlatformRepoName(name)) {
            // Validate the name here to avoid resolving the asset if the name is invalid.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for the rename operation.');
        }
        // Get the gradient and use the original gradient ID
        // provided by the services when creating a project.
        // The id for gradients is computed to include the language
        // code as well.
        const originalGradient = await this.getGradient(gradientID);
        const response = await this._projectInterface.createProject({
            [RelType.APP_METADATA]: {
                'project:rendition': {
                    'gradientId': originalGradient.gradientID
                }
            },
            'repo:name': name
        });
        const session = this._assetPool.createMutationSession();
        const project = this._projectUpdater.updateRemoteItem(session, Object.assign(Object.assign({}, response), { allowInLists: true }));
        session.commit();
        return project;
    }
    /**
     * Resolves a given name to a Project, if one exists.
     * @param name name of the project to be resolved.
     * @returns a promise that resolves to the Project with the given name.
     */
    async resolveProjectByName(name) {
        const projectMetadata = await this._projectInterface.resolveProjectByName(name);
        const id = projectMetadata['repo:assetId'];
        this._core.collaborationContext.confirmAccess(id);
        const session = this._assetPool.createMutationSession();
        const project = this._projectUpdater.updateRemoteItem(session, projectMetadata);
        session.commit();
        return project;
    }
    /**
     * Validates whether the user can create a new project with the provided name.
     * Project service is able to determine where to create the project for a user hence
     * the name is sufficient for this validation.
     * @param name name of the project to be validated for creation.
     */
    async validateProjectNameForCreate(name, project, repositoryID) {
        if (!validatePlatformRepoName(name)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid project name.');
        }
        let updatedName = name;
        if (project) {
            updatedName = renameFileInPath(name, project);
        }
        try {
            await this._projectInterface.validateProjectName(updatedName, repositoryID);
        }
        catch (e) {
            const samError = e;
            if (samError.code === SAMErrorCode.NOT_FOUND) {
                return true;
            }
            else if (samError.code === SAMErrorCode.CONFLICT) {
                return false;
            }
            // At this point the error is something else entirely and
            // not related to the the availability of the name. Could
            // be a networking error or something similar.
            throw e;
        }
        return false;
    }
    /**
     * Gets a project with the given ID.
     *
     * @note This method will automatically determine if it should call
     * to confirm access with the invitations service.
     *
     * @param id ID of the project
     * @param confirmAccess Whether to confirm access with the invitations service. NOTE - only
     * to be used by services.
     * @returns a promise that resolves to the Project with the given ID
     */
    async getProjectbyID(id, confirmAccess = true) {
        let project = this._assetPool.getLocalItemById(id);
        if (project) {
            // Asynchronously confirm access since the user got here
            // from a list or confirmed it before since it's in the cache so
            // the call may not need to happen or may not affect the user.
            if (confirmAccess) {
                this._core.collaborationContext.confirmAccess(id);
            }
            return project;
        }
        if (confirmAccess) {
            await this._core.collaborationContext.confirmAccess(id);
        }
        const projectMetadata = await this._projectInterface.getProject(id);
        const session = this._assetPool.createMutationSession();
        project = this._projectUpdater.updateRemoteItem(session, projectMetadata);
        // [SHARED-3832] Read-only Org-owned Projects should not show on lists unless the user was invited
        // directly or invited via a group other than "Org Everybody". This is done in SAM.js rather than by Projects
        // Service so that the check can be done async so it does not block getting the Project for 1Up, badging.
        if (!project.hasPermission(Permission.Write) && project.repositoryOwner.type === 'org') {
            // Note: check is done async
            this._checkForInvite(project);
        }
        else {
            // otherwise, assume Project can be found on lists
            this._projectUpdater.updateLocalItem(session, project, { allowInLists: true });
        }
        session.commit();
        return project;
    }
    /**
     * [SHARED-3832] Checks if the Project is visible to the user due to invitation, whether by group or direct invite.
     * Uses USS rather than Invitation service because it is difficult to check if the user has access due to group
     * invite.
     *
     * @param {Project} project
     * @returns {Promise<void>}
     * @private
     */
    async _checkForInvite(project) {
        const ussInterface = new USSInterface(this._core);
        const response = await ussInterface.getQueryResponse({
            limit: 1,
            asset_id: project.id,
            [SearchProps.SHARED_VIA_INVITE]: true
        });
        // If there are any items, the user was invited to the Project
        if (response.result_sets[0].items.length) {
            const session = this._assetPool.createUpdateSession();
            this._projectUpdater.updateLocalItem(session, project, { allowInLists: true });
            session.commit();
        }
    }
    async _getGradients() {
        const locale = this._core._environment.getValue('LOCALE');
        const gradientData = await this._projectInterface.getGradients(locale);
        const defaultGradientId = gradientData.default;
        const session = this._gradientPool.createUpdateSession();
        const computedGradients = computeGradients(gradientData.children, defaultGradientId, locale);
        const gradients = GradientUpdater.updateRemoteItems(session, computedGradients);
        session.commit();
        return gradients;
    }
    /**
     * Returns the list of available gradients.
     */
    async getGradients() {
        return await this._getGradients();
    }
    /**
     * Gets a single gradient by ID if that gradient does not
     * locally we fetch all the gradients and if it still does not
     * exist then we return the default gradient provided.
     *
     * @param id
     * @returns
     */
    async getGradient(id) {
        const gradient = this._gradientPool.getLocalItemById(id);
        const locale = this._core._environment.getValue('LOCALE');
        if (gradient && gradient.languageCode === locale) {
            return gradient;
        }
        await this._getGradients();
        const newGradient = this._gradientPool.getLocalItemById(id);
        if (!newGradient) {
            if (this._defaultGradient && this._defaultGradient.languageCode === locale) {
                return this._defaultGradient;
            }
            this._gradientPool.forEach((gradient) => {
                if (gradient.isDefault) {
                    this._defaultGradient = gradient;
                }
            });
            if (this._defaultGradient) {
                return this._defaultGradient;
            }
            // There should always be a default gradient but in the case
            // where maybe it doesn't exist we should still throw an error
            throw SAMError.create(SAMErrorCode.UNKNOWN, `Gradient ID does not exist ${id}`);
        }
        return newGradient;
    }
    async updateProject(id, data) {
        let newData = {};
        if (data.gradientID) {
            const gradient = await this.getGradient(data.gradientID);
            const project = await this.getProjectbyID(id);
            const links = project.projectLinks;
            newData = Object.assign(Object.assign({}, newData), { gradientID: gradient.gradientID });
            await this._projectInterface.patchProject(links, newData);
            const session = this._assetPool.createMutationSession();
            this._projectUpdater.updateRemoteItem(session, {
                'repo:assetId': project.id,
                _embedded: {
                    [RelType.APP_METADATA]: {
                        'project:rendition': {
                            /**
                             * @note when updating the local model with
                             * "remote" data, we should use the raw gradientID
                             * instead of the computed one.
                             */
                            gradientId: gradient.gradientID
                        }
                    }
                }
            });
            session.commit();
        }
    }
    /**
     * Used to hide and show the create button for users who may or may not
     * have the required privileges to do so.
     * @note Does not throw errors, use canCreateProjectReason to determine the specific
     * reason behind why a user can or cannot create a project.
     *
     * @param repositoryID Optional repositoryID for admins for who have access to multiple repos.
     * @returns {boolean}
     */
    async canCreateProjects(repositoryID) {
        try {
            await this._projectInterface.getCapability(ProjectCapabilities.CREATE, repositoryID);
            return true;
        }
        catch (e) {
            // If it's not a sam error then something else happened
            // and we should throw that error.
            if (!isSAMError(e)) {
                throw e;
            }
            return false;
        }
    }
    /**
     * @package for internal SAM.js use only.
     * @param repositoryID the repository id of the project
     * Restoring capability is same as the capability to create a project.
     */
    async _canRestoreProject(repositoryID) {
        if (this._canRestoreProjectCache.has(repositoryID)) {
            return this._canRestoreProjectCache.get(repositoryID);
        }
        const canRestore = await this.canCreateProjects(repositoryID);
        this._canRestoreProjectCache.set(repositoryID, canRestore);
        return canRestore;
    }
    /**
     * @package for internal SAM.js use only.
     * @param repositoryID the repository id of the project
     */
    _getCachedRestoreCapability(repositoryID) {
        return this._canRestoreProjectCache.get(repositoryID) || false;
    }
    /**
     * Used to determine the specific reasoning behind why a user can't
     * create projects. Returns unknown if the error is unrelated to
     * one of the "known" reasons.
     *
     * @param repositoryID
     * @returns
     */
    async canCreateProjectReason(repositoryID) {
        try {
            await this._projectInterface.getCapability(ProjectCapabilities.CREATE, repositoryID);
            return CanCreateProjectReason.ALLOWED;
        }
        catch (error) {
            if (!isSAMError(error)) {
                return CanCreateProjectReason.UNKNOWN;
            }
            switch (error.subCode) {
                case SAMErrorSubCode.PROJECTS_ADMIN_ONLY:
                    return CanCreateProjectReason.ADMIN_DISABLED;
                case SAMErrorSubCode.PROJECTS_NO_HOME_REPOSITORY:
                    return CanCreateProjectReason.NO_HOME_REPOSITORY;
                case SAMErrorSubCode.PROJECTS_INVALID_REPOSITORY:
                    return CanCreateProjectReason.INVALID_REPOSITORY;
                default:
                    return CanCreateProjectReason.UNKNOWN;
            }
        }
    }
    /**
     * Provides a AdobeAssetGlobalSearchFilter that goes directly to USS for search results
     *
     * @note all project related properties will be lazily fetched in this case.
     *
     * @TODO https://jira.corp.adobe.com/browse/SHARED-3489
     * @param {string} query Query string for search.
     * @returns {AdobeAssetGlobalSearchFilter}
     */
    getProjectsSearchSource(query) {
        const implicitFilter = new AdobeAssetGlobalSearchFilter({
            _query: query,
            _projectsOnly: true
        });
        const globalSearchLoader = new GlobalSearchLoader(this._core.hostAssetContext._assetPool, this._core, this._core.hostAssetContext._globalSearchInterfaceV3, implicitFilter);
        return new ItemSource(this._assetPool, [globalSearchLoader], implicitFilter);
    }
    /**
     * It has been reported that sometimes a Project asset is missing the parent project id in the inherited property
     * of the app metadata [SAM-3590]. This method is used to call the Context API [CCXB-20015] which was implemented
     * to address the issue in the following ways:
     * 1. Returns the parent project id so SAM.js can fix the inherited property of the local child asset.
     * 2. Fixes the inheritable property of the parent project if it is missing data.
     * 3. Fixes the inherited property of the child asset if it is missing data.
     * @param assetId
     * @param repoId
     * @package -- only for use in SAM.js
     */
    async _callContextAPI(assetId, repoId) {
        const discoveryLinks = await this._projectInterface._discoverProjectLinks();
        const href = discoveryLinks[RelType.PROJECTS_CONTEXT].href;
        return await this._projectInterface._issueContextAPIRequest(assetId, repoId, href);
    }
    /**
     * @experimental
     */
    async getProjectOrder(direction = 'ascending', field = 'name') {
        const { default: ProjectOrder } = await Promise.resolve().then(function () { return ProjectOrder$1; });
        return new ProjectOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getProjectFilter(options) {
        const { default: ProjectFilter } = await Promise.resolve().then(function () { return ProjectFilter$1; });
        return new ProjectFilter(options);
    }
    /**
     * @experimental
     *
     * @internal This method requires Service Token Authentication
     * the associated IMS client ID must be allowlisted (Only the Workfront client ID
     * will be allowlisted for this API).
     * @param {string} name - The name of the project.
     * @param {CSCProjectDirectorySubtype} - The CSC Project SubType.
     * @param {string} path The path to be created relative to the Workfront top-level. Similar to RAPI create,
     * This does not represent the entire path, but only the directories that should be created
     * under the top-level "/workfront" directory returned by Index Workfront API.
     * This should include the Project name as the final segment of the path. If both
     * this parameter and the "repo:assetId" are provided or the provided "repo:path"
     * contains an existing Project, then an error will be returned (see Response).
     *
     * @param {string} orgId - The Organization ID that the Project will be created within.
     * @param {string} userId - The IMS User ID that the CSC Project creation is on behalf of. The "repo:createdBy"
     * will be set to this value when creating the CSC Project directory. The user will
     * also be given Editor permission to the CSC Project.
     *
     * @param {Record<string, any>} [appMetadata] - The app metadata to be set on the CSC Project.
     */
    async createCSCProjectByPath(name, subType, path, orgId, userId, appMetadata) {
        return this._createCSCProject({ name, subType, path, orgId, userId, appMetadata });
    }
    /**
     * @experimental
     *
     * @internal This method requires Service Token Authentication
     * the associated IMS client ID must be allowlisted (Only the Workfront client ID
     * will be allowlisted for this API).
     *
     * @throws {SAMError.BAD_REQUEST} if the parent is not a WF_PORTFOLIO or WF_PROGRAM.
     *
     * @param {string} name - The name of the project.
     * @param {CSCProjectDirectorySubtype} - The CSC Project SubType.
     * @param {string} orgId - The Organization ID that the Project will be created within.
     * @param {string} parentAssetId  - The asset ID of the Project that the new Project should be created within.
     * The Project will be validated to ensure that it is of subType "wfPortolio" or "wfProgram".
     * If this parameter is not provided, then the Project will be created starting from the top-level.
     * If both this parameter and the "repo:path" are provided, then an error will be returned (see Response).
     *
     * @param {string|undefined} [userId] - The IMS User ID that the CSC Project creation is on behalf of. The "repo:createdBy"
     * will be set to this value when creating the CSC Project directory. The user will
     * also be given Editor permission to the CSC Project.
     *
     * @param {Record<string, any>} [appMetadata] - The app metadata to be set on the CSC Project.
     */
    async createCSCProjectInParent(name, subType, parentAssetId, orgId, userId, appMetadata) {
        return this._createCSCProject({ name, subType, parentAssetId, orgId, userId, appMetadata });
    }
    /**
     *
     * The private implementation for the above public CSC Create* methods.
     *
     * @note Only accepts either a path or a parentAssetId, both will result in an error
     * from the services.
     */
    async _createCSCProject(opts) {
        const { name, subType, parentAssetId, path, orgId, userId, appMetadata } = opts;
        if (!validatePlatformRepoName(name)) {
            // Validate the name here to avoid resolving the asset if the name is invalid.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided');
        }
        const baseCSCCreateOptions = Object.assign({ name, projectDirectorySubType: subType }, (appMetadata ? {
            appMetadata: Object.assign({}, appMetadata)
        } : {}));
        let createData;
        if (parentAssetId) {
            createData = Object.assign(Object.assign({}, baseCSCCreateOptions), { parentAssetId });
        }
        else {
            createData = Object.assign(Object.assign({}, baseCSCCreateOptions), { path: path });
        }
        const cscProjectMetadata = await this._projectInterface.createCSCProject(createData, orgId, userId);
        const session = this._assetPool.createMutationSession();
        const cscProject = this._projectUpdater.updateRemoteItem(session, Object.assign(Object.assign({}, cscProjectMetadata), { allowInLists: true }));
        session.commit();
        // Ensure links and repository metadata is presents since Projects API doesn't provide any links or metadata
        // we can't call _Load() because it calls into permissions, PUPA which the service token may not have
        // access to for the time being.
        const resource = new RepoMetadataResource(this._core, cscProject);
        await resource.load();
        await cscProject._handleResourceUpdates({
            repoMetadata: resource.data,
        });
        return cscProject;
    }
}
__decorate([
    memoize$1
], ProjectContext.prototype, "projects", null);
__decorate([
    keepAlive
], ProjectContext.prototype, "createProject", null);
__decorate([
    consolidated,
    __param(0, key)
], ProjectContext.prototype, "validateProjectNameForCreate", null);
__decorate([
    keepAlive,
    synchronized,
    __param(0, key)
], ProjectContext.prototype, "getProjectbyID", null);

var ProjectContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': ProjectContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const API_ROOT = '/api/v1';
const headers$2 = { 'Content-Type': JSON_MIME_TYPE };
function validateClassroomData(data) {
    const errors = [];
    // Handle basic validation
    const classroomDataToValidate = [
        { key: 'subject', type: 'enum', isRequired: false, ref: SubjectTypes },
        { key: 'grades', type: 'string[]', isRequired: false },
        { key: 'period', type: 'string', isRequired: false },
        { key: 'teachers', type: 'string[]', isRequired: false },
    ];
    errors.push(...validateTypes(classroomDataToValidate, data));
    // Handle validation of virtual and non-virtual classrooms
    const hasName = typeof data.name === 'string' && data.name !== null;
    const hasId = typeof data.id === 'string' && data.id !== null;
    // One of these must be defined
    // Both _can_ be defined, but id will take precedence and name will be ignored
    if (!hasName && !hasId) {
        errors.push('name or id is missing');
    }
    return errors;
}
class ClassroomsInterface extends InterfaceBase {
    /** Overrides the default behavior for a 202 response */
    async _monitorResponse(response) {
        return response;
    }
    _getUrl(endpoint) {
        return `https://${this._core._environment.endpoints.CLASSROOMS_HOST}${endpoint}`;
    }
    /**
     * @description Creates a new Classroom
     *
     * @param data needed to create a Classroom like name and subject
     * @returns promise resolving to the newly created Classroom
    */
    async createClassroom(data) {
        var _a;
        const response = await this._doPost(this._getUrl(`${API_ROOT}/classrooms`), headers$2, JSON.stringify({
            className: data.name,
            subject: data.subject,
            grades: data.grades,
            period: data.period,
            teachers: ((_a = data.teachers) === null || _a === void 0 ? void 0 : _a.map(email => encodeURIComponent(email))) || []
        }), [201]);
        const jsonResponse = await response.json();
        return jsonResponse;
    }
    /**
     * Creates a new Classroom from a virtual class
     * @param id that maps to the virtual classroom being migrated to a real class
     * @returns promise resolving to the newly created Classroom
    */
    async createClassroomFromVirtual(virtualClassroomId) {
        const response = await this._doPost(this._getUrl(`${API_ROOT}/classrooms/virtual/${virtualClassroomId}/create`), { 'Content-Type': JSON_MIME_TYPE }, undefined, [201]);
        const jsonResponse = await response.json();
        return jsonResponse;
    }
    /**
     * Creates a new Classroom with updated metadata from a virtual class
     * @param id that maps to the virtual classroom being migrated to a real class
     * @param data that the real classroom will be created with
     * @returns promise resolving to the newly created Classroom
    */
    async updateClassroomFromVirtual(virtualClassroomId, data) {
        var _a;
        const response = await this._doPost(this._getUrl(`${API_ROOT}/classrooms/virtual/${virtualClassroomId}/update`), { 'Content-Type': JSON_MIME_TYPE }, JSON.stringify({
            className: data.name,
            subject: data.subject,
            grades: data.grades,
            period: data.period,
            teachers: ((_a = data.teachers) === null || _a === void 0 ? void 0 : _a.map(email => encodeURIComponent(email))) || []
        }), [201]);
        const jsonResponse = await response.json();
        return jsonResponse;
    }
    /**
     * @description Deletes a single classroom
     *
     * @param id Either the classId or the classCode.  The endpoint queries both.
    */
    async deleteClassroom(id) {
        await this._doDelete(this._getUrl(`${API_ROOT}/classrooms/${id}`), headers$2, [202]);
    }
    /**
     * @description Deletes a single virtual classroom
     *
     * @param id the classId
    */
    async deleteVirtualClassroom(id) {
        await this._doPost(this._getUrl(`${API_ROOT}/classrooms/virtual/${id}/delete`), headers$2, undefined, [202]);
    }
    /**
     * @description Gets a single classroom by class ID
     *
     * @param id Either the classId or the classCode.  The endpoint queries both.
     * @returns A promise that resolves to a classroom
     */
    async getClassroom(id) {
        const response = this._getResponse(this._getUrl(`${API_ROOT}/classrooms/${id}`));
        return response.then((classroom) => {
            var _a;
            // Handle the null value of importedFrom in ACPCEDU-1892
            (_a = classroom.importedFrom) !== null && _a !== void 0 ? _a : (classroom.importedFrom = {});
            return classroom;
        });
    }
    /**
     * @description Gets a list of all available classrooms
     *
     * @returns A promise that resolves to a list of classrooms
     */
    async getClassrooms() {
        const response = this._getResponse(this._getUrl(`${API_ROOT}/classrooms`));
        // Handle the null value of importedFrom in ACPCEDU-1892
        return response.then((classrooms) => {
            return classrooms.map((classroom) => {
                var _a;
                (_a = classroom.importedFrom) !== null && _a !== void 0 ? _a : (classroom.importedFrom = {});
                return classroom;
            });
        });
    }
    /**
     * @description Refreshes the classroom code for a given classroom
     *
     * @param id The classroom ID associated with a single classroom
     * @returns A promise that resolves to a classroom
     */
    async refreshClassroomCode(id) {
        return this._doPut(this._getUrl(`${API_ROOT}/classrooms/${id}/code/refresh`), undefined, undefined, [200]).then((response) => response.json());
    }
    /**
     * Updates a classroom with new data
     * @param id The classroom ID
     * @param data The new data that the classroom will be updated with
     * @returns A promise that resolves to the classroom with updated fields
     */
    async updateClassroom(id, data) {
        var _a;
        const response = await this._doPatch(this._getUrl(`${API_ROOT}/classrooms/${id}`), { 'Content-Type': JSON_MIME_TYPE }, JSON.stringify({
            className: data.name,
            subject: data.subject,
            grades: data.grades,
            period: data.period,
            teachers: ((_a = data.teachers) === null || _a === void 0 ? void 0 : _a.map(email => encodeURIComponent(email))) || [],
        }));
        return response.json();
    }
    /**
     * Gets the teachers of a classroom
     * @param id The classroom ID
     * @returns Teachers of a given classroom
     */
    async getClassroomTeachers(id) {
        return this.getClassroomMembers(id, ClassroomMemberRole.TEACHER);
    }
    /**
     * Gets the students of a classroom
     * @param id The classroom ID
     * @returns Students of a given classroom, wrapped in a classroom object for the list loader
     */
    async getClassroomStudents(id) {
        return await this.getClassroomMembers(id, ClassroomMemberRole.STUDENT);
    }
    /**
     * Gets the members of a classroom
     * @param id The classroom ID
     * @param filter The filter to apply to the members, either 'students' or 'teachers'. If not provided, all members are returned.
     * @returns Members of a given classroom
     */
    async getClassroomMembers(id, filter) {
        const urlFilter = filter === ClassroomMemberRole.NONE ? '' : `/${filter}s`;
        const url = `${API_ROOT}/classrooms/${id}/members${urlFilter}`;
        const classroomResponse = await this._getResponse(this._getUrl(url));
        // Response doesn't include classroomId on each member, so need to add it here
        classroomResponse.members.forEach((member) => {
            member.classroomId = id;
            member.computedKey = getMemberComputedKey(id, member.userId);
        });
        return classroomResponse.members;
    }
    /**
     * Gets the membership status of a user in a classroom
     * @param id The classroom ID
     *
     * @returns Membership status of the user in the classroom
     */
    async getMembership(id) {
        return this._getResponse(this._getUrl(`${API_ROOT}/classrooms/${id}/members/status`));
    }
    /**
     * Blocks a student from a classroom
     *
     * @param classroomId Class ID of the classroom to block the student from
     * @param studentId Student ID to block
     *
     * @returns A promise that resolves to the response from the server
     */
    async blockStudent(classroomId, studentId) {
        const response = await this._doPost(this._getUrl(`${API_ROOT}/classrooms/${classroomId}/members/students/block`), headers$2, JSON.stringify({
            studentId
        }), [200]);
        return await response.json();
    }
    /**
     * Unblocks a student from a classroom
     *
     * @param classroomId Class ID of the classroom to unblock the student from
     * @param studentId Student ID to unblock
     *
     * @returns A promise that resolves to the response from the server
     */
    async unblockStudent(classroomId, studentId) {
        const response = await this._doPost(this._getUrl(`${API_ROOT}/classrooms/${classroomId}/members/students/unblock`), headers$2, JSON.stringify({
            studentId
        }), [200]);
        return await response.json();
    }
    /**
     * Removes a student from a classroom
     *
     * @param classroomId Class ID of the classroom to remove the student from
     * @param studentId Student ID to remove
     *
     * @returns A promise that resolves to the response from the server
     */
    async removeStudent(classroomId, studentId) {
        const response = await this._doDelete(this._getUrl(`${API_ROOT}/classrooms/${classroomId}/members/students?studentId=${studentId}`), headers$2, [202]);
        return await response.json();
    }
    /**
     * Removes a teacher from a classroom
     *
     * @param classroomId Class ID of the classroom to remove the teacher from
     * @param userId Teacher's user ID to remove
     *
     * @returns A promise that resolves to the response from the server
     */
    async removeTeacher(classroomId, userId) {
        const response = await this._doDelete(this._getUrl(`${API_ROOT}/classrooms/${classroomId}/members/teachers?userId=${userId}`), headers$2, [202]);
        return await response.json();
    }
    /**
     * Checks eligibility of users to be added as co-teachers to a classroom
     *
     * @param options The options for checking co-teacher eligibility
     * @returns A promise that resolves to the eligibility response from the server
     */
    async checkCoTeacherEligibility(options) {
        const response = await this._doPost(this._getUrl(`${API_ROOT}/classrooms/users/eligibility`), headers$2, JSON.stringify({
            classroomId: options.classroomId,
            role: 'teacher',
            emails: options.emails,
        }), [200]);
        return await response.json();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ClassroomMemberListLoader {
    constructor(_ClassroomMemberPool, _classroomsInterface) {
        this._ClassroomMemberPool = _ClassroomMemberPool;
        this._classroomsInterface = _classroomsInterface;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options) {
        const { filter } = options;
        const classroomMemberFilter = filter;
        const result = await this._classroomsInterface.getClassroomMembers(classroomMemberFilter.classroomId, classroomMemberFilter.role);
        const session = this._ClassroomMemberPool.createLoaderUpdateSession(Date.now());
        const items = ClassroomMemberUpdater.updateRemoteItems(session, result);
        session.commit();
        return {
            items,
            total: items.length,
            loadNextPage: undefined,
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const SubjectChoices = Object.values(SubjectTypes);
/**
 * Class representing the notion of a "classroom".  This is currently a read-only object
 * but this may be extended to support CRUD operations in the future.
 * @extends ItemBase
 *
 * @example
 * // Instatiate list and load contents
 * const classroomsList = core.classroomContext.getClassrooms().getList(...options);
 * await waitForListLoad(classroomsList);
 *
 * // Get a specific classroom
 * const load = useMemo(() => core.classroomContext.getClassroomById(id), [classroomContext, id]);
 * const { value: classroom, error, loading } = useLoading<Classroom | undefined>(undefined, load);
 */
class Classroom extends ItemBase {
    constructor(_core, id) {
        super(_core, id);
        this._core = _core;
        this._code = '';
        this._createdBy = '';
        this._importSource = {};
        this._isDeleted = false;
        this._isVirtual = false;
        this._grades = [];
        this._memberRole = ClassroomMemberRole.NONE;
        this._name = '';
        this._period = '';
        this._status = ClassroomStatus.ACTIVE;
        this._subject = SubjectTypes.noSubject;
        this._classroomsInterface = new ClassroomsInterface(this._core);
        this._assetId = '';
        const loader = new ClassroomMemberListLoader(this._core.classroomContext._classroomMemberPool, this._classroomsInterface);
        this._members = new ItemSource(this._core.classroomContext._classroomMemberPool, [loader], new ClassroomMemberFilter({ classroomId: this.id }));
    }
    get code() {
        return this._code;
    }
    get created() {
        if (!this._created) {
            return undefined;
        }
        return new Date(this._created);
    }
    get createdBy() {
        return this._createdBy;
    }
    get importSource() {
        return this._importSource;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    get isVirtual() {
        return this._isVirtual;
    }
    get grades() {
        return this._grades;
    }
    /**
     * When getting the resulting list from the ClassroomMemberSource, include a role on the filter to get only students or teachers back
     *
     * @example <caption>Get all students</caption>
     * const studentList = classroom.members.getList(ClassroomMemberOrder.default, new ClassroomMemberFilter({ classroomId: classroom.id, role: ClassroomMemberRole.STUDENT }));
     * waitForListLoad(studentList);
     * const students: ClassroomMember[] = studentList.items;
     *
     * @example <caption>Get all members</caption>
     * const allMembersList = classroom.members.getList(ClassroomMemberOrder.default, new ClassroomMemberFilter({ classroomId: classroom.id}));
     * waitForListLoad(allMembersList);
     * const allMembers: ClassroomMember[] = allMembersList.items;
     */
    get members() {
        return this._members;
    }
    get memberRole() {
        return this._memberRole;
    }
    get name() {
        return this._name;
    }
    get period() {
        return this._period;
    }
    get status() {
        return this._status;
    }
    get subject() {
        return this._subject;
    }
    get type() {
        return this._type;
    }
    get userCount() {
        // For now, userCount is calculated as studentCount + 1.
        // In the future, this could give an inaccurate count if we allow multiple teachers to one classroom
        // Follow up on this field in [ACPCEDU-2333]
        return this._userCount;
    }
    /**
     * This is the asset ID of the classroom folder.
     * The classroom ID is the classroom org ID
     */
    get assetId() {
        return this._assetId;
    }
    /**
     * Deletes this classroom, along with all assignments and other child object
     *
     * @example <caption>Delete a classroom</caption>
     * await classroom.delete();
     */
    async delete() {
        await this._classroomsInterface.deleteClassroom(this.id);
    }
    /**
     * Refreshes the classroom code
     *
     * @example <caption>Refresh the classroom code</caption>
     * await classroom.refreshCode();
     */
    async refreshCode() {
        this._classroomsInterface.refreshClassroomCode(this.id);
    }
    /**
     * Updates a classroom's data
     *
     * @example <caption>Update a Classrooms name</caption>
     * await classroom.update({ name: 'New Name' });
     */
    async update(data) {
        return this._core.classroomContext.updateClassroom(this.id, data);
    }
    /**
     * Checks if the co-teacher is eligible to be added to the classroom
     *
     * @example <caption>Check if the co-teacher is eligible to be added to the classroom</caption>
     * await classroom.checkCoTeacherEligibility({ emails: ['test@test.com'] });
     */
    async checkCoTeacherEligibility(options) {
        return this._classroomsInterface.checkCoTeacherEligibility(Object.assign(Object.assign({}, options), { classroomId: this.id }));
    }
}
__decorate([
    observable$1
], Classroom.prototype, "code", null);
__decorate([
    observable$1
], Classroom.prototype, "created", null);
__decorate([
    observable$1
], Classroom.prototype, "createdBy", null);
__decorate([
    observable$1
], Classroom.prototype, "importSource", null);
__decorate([
    observable$1
], Classroom.prototype, "isDeleted", null);
__decorate([
    observable$1
], Classroom.prototype, "isVirtual", null);
__decorate([
    observable$1
], Classroom.prototype, "grades", null);
__decorate([
    observable$1
], Classroom.prototype, "members", null);
__decorate([
    observable$1
], Classroom.prototype, "memberRole", null);
__decorate([
    observable$1
], Classroom.prototype, "name", null);
__decorate([
    observable$1
], Classroom.prototype, "period", null);
__decorate([
    observable$1
], Classroom.prototype, "status", null);
__decorate([
    observable$1
], Classroom.prototype, "subject", null);
__decorate([
    observable$1
], Classroom.prototype, "type", null);
__decorate([
    observable$1
], Classroom.prototype, "userCount", null);
__decorate([
    observable$1
], Classroom.prototype, "assetId", null);
function getAlternateClassroomId(remoteItem) {
    return remoteItem.virtualId;
}
const ClassroomUpdater = new ItemUpdater({
    localItemType: Classroom,
    remoteIdProperty: 'classId',
    getAlternateId: getAlternateClassroomId,
    propertyUpdater: new PropertyUpdater({
        _assetId: { name: 'assetId', format: 'string' },
        _code: { name: 'classCode', format: 'string' },
        _created: { name: 'createdOn', format: 'string' },
        _createdBy: { name: 'createdBy', format: 'string' },
        _importSource: {
            name: 'importedFrom',
            format: 'object',
            set: (remoteImportSource, dest) => {
                const classroom = dest;
                classroom['_importSource'] = {
                    id: remoteImportSource.sourceId,
                    type: remoteImportSource.source,
                    synced: remoteImportSource.lastUpdatedAt ? new Date(remoteImportSource.lastUpdatedAt) : undefined,
                };
            },
        },
        _isDeleted: { name: 'deleted', format: 'boolean' },
        _isVirtual: { name: 'isVirtualClassroom', format: 'boolean' },
        _grades: { isArray: true, name: 'grades' },
        _memberRole: { name: 'memberRole', format: 'string' },
        _name: { name: 'className', format: 'string' },
        _period: { name: 'period', format: 'string' },
        _status: { name: 'status', format: 'string', choices: Object.values(ClassroomStatus) },
        _subject: { name: 'subject', format: 'string', choices: SubjectChoices },
        _type: { name: 'type', format: 'string', choices: Object.values(ClassroomType) },
        _userCount: { name: 'userCount', format: 'number' },
        _virtualId: { name: 'virtualId', format: 'string' },
    }),
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ClassroomListLoader {
    constructor(_classroomPool, _classroomsInterface) {
        this._classroomPool = _classroomPool;
        this._classroomsInterface = _classroomsInterface;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async _loadPage(options, start) {
        const result = await this._classroomsInterface.getClassrooms();
        const session = this._classroomPool.createLoaderUpdateSession(Date.now());
        const items = ClassroomUpdater.updateRemoteItems(session, result);
        session.commit();
        return {
            items,
            total: items.length,
            loadNextPage: undefined,
        };
    }
}

/*************************************************************************
   *
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2024 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by trade secret or copyright law.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
const headers$1 = getSAMVersionRequestHeader();
const DefaultAssignmentsListingOptions = {
    orderDirection: 'ascending',
    orderBy: 'repo:name',
    start: 0,
    limit: 0
};
function createPageTemplate(options) {
    const templateValues = {};
    if (options.start) {
        templateValues.start = options.start.toString();
    }
    if (options.limit) {
        templateValues.limit = options.limit.toString();
    }
    return templateValues;
}
function getDirectionValue(userOptions) {
    const directionFlag = userOptions.orderDirection === 'ascending' ? '+' : '-';
    return directionFlag + userOptions.orderBy;
}
function getAssignmentsListingPath(links, options) {
    const userOptions = Object.assign({}, DefaultAssignmentsListingOptions, options);
    const templateValues = createPageTemplate(userOptions);
    templateValues.orderBy = getDirectionValue(userOptions);
    const { classroomId, submissions, view } = userOptions;
    if (view) {
        // Remove in ACPCEDU-3388
        templateValues.view = view;
    }
    if (classroomId) {
        templateValues.classroomId = classroomId;
    }
    if (submissions) {
        templateValues.submissions = submissions;
    }
    return getURLFromLinks(links, RelType.ASSIGNMENTS_COLLECTION, templateValues);
}
function validateRequiredAssignmentLinks(links) {
    return validateLinks(links, ASSIGNMENTS_INDEX_LINKS);
}
/**
 * Validates that a Tutorial object has all of the required properties and they are the correct types
 * @returns An array of error messages if there are any validation errors
 */
function validateTutorialData(data) {
    return validateTypes([
        { key: 'surfaces', type: 'object', isRequired: true },
        { key: 'aem_id', type: 'string', isRequired: true },
        { key: 'metadata', type: 'object', isRequired: false },
    ], data);
}
/**
 * Validates that the object which will create an Assignment has all of the required properties and they are the correct types
 * @returns An array of error messages if there are any validation errors
 */
function validateAssignmentData(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const errors = [];
    // Handle basic type validation
    const assignmentDataToValidate = [
        { key: 'classroomId', type: 'string', isRequired: true },
        { key: 'createdBy', type: 'string', isRequired: false },
        { key: 'dueDate', type: 'date', isRequired: false },
        { key: 'externalTemplateIds', type: 'string[]', isRequired: false },
        { key: 'instructions', type: 'string', isRequired: false },
        { key: 'name', type: 'string', isRequired: true },
        { key: 'status', type: 'enum', isRequired: false, ref: AssignmentStatus },
        { key: 'tasks', type: 'string[]', isRequired: false },
        { key: 'templateIds', type: 'string[]', isRequired: false },
    ];
    errors.push(...validateTypes(assignmentDataToValidate, data));
    // Handle references since it can be multiple types
    (_a = data.references) === null || _a === void 0 ? void 0 : _a.forEach((reference, idx) => {
        if (typeof reference === 'object') {
            if (!validateType(reference.content, 'string', true) && !validateType(reference.content, 'blob', true)) {
                errors.push(`references[${idx}].content is not a string, Blob, or is missing`);
            }
            if (!validateType(reference.name, 'string', true)) {
                errors.push(`references[${idx}].name is not a string or is missing`);
            }
        }
        else if (typeof reference !== 'string') {
            errors.push(`references[${idx}] is not an string or ExternalAsset`);
        }
    });
    // Handle tutorials
    if (data.externalTutorials) {
        if (!Array.isArray(data.externalTutorials)) {
            errors.push('externalTutorials is not an array');
        }
        else {
            data.externalTutorials.forEach((tutorial, idx) => {
                validateTutorialData(tutorial).forEach((error) => {
                    errors.push(`externalTutorials[${idx}]: ${error}`);
                });
            });
        }
    }
    // Handle assignment material validation
    const hasTasks = ((_c = (_b = data.tasks) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
    const hasTemplates = ((_e = (_d = data.templateIds) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) > 0;
    const hasTutorials = ((_g = (_f = data.externalTutorials) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0) > 0;
    const hasExternalTemplates = ((_j = (_h = data.externalTemplateIds) === null || _h === void 0 ? void 0 : _h.length) !== null && _j !== void 0 ? _j : 0) > 0;
    const isDraft = data.status === AssignmentStatus.DRAFT;
    const hasStartingPoint = hasTasks || hasTemplates || hasTutorials || hasExternalTemplates;
    if (!isDraft && !hasStartingPoint) {
        errors.push('Assigned Assignment must have tasks, templates, externalTemplateIds, or tutorials');
    }
    return errors;
}
class AssignmentsInterface extends InterfaceBase {
    async _discoverLinks(rootHref) {
        const response = await this._getResponse(rootHref, { headers: headers$1 });
        return response._links;
    }
    _getEndpointHref(endpoint) {
        return `https://${this._core._environment.endpoints.ASSIGNMENTS_HOST}${endpoint}`;
    }
    async discoverLinks() {
        return this._discoverLinks(this._getEndpointHref(`/api/v1/index`));
    }
    /**
     * @description Fetches the list of Assignments based on the options provided
     * @param options : options to sort and filter the Assignments listing
     * @returns resolves to list of Assignments along with the page information and links to the next page
    */
    async getAssignments(options) {
        // options.classroomId is optional as the type is reused elsewhere, but really it's needed here to get assignments
        if (!options.classroomId) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'classroomId is required to fetch assignments');
        }
        const links = await this.discoverLinks();
        const url = getAssignmentsListingPath(links, options);
        return this._getResponse(url, { headers: headers$1 });
    }
    /**
     * Get an Assignment by id or code
     * @param identifierType What type of identifier we will fetch by
     * @param identifier The assignment ID or code depending on value of identifierType
     * @param submissions Use this if you want to include or exclude submissions from the assignment
     * @param additionalHeaders Additional headers to include in the request
     * @returns The fetched assignment
     */
    async getAssignmentBy(identifierType, identifier, submissions, additionalHeaders) {
        const links = await this.discoverLinks();
        const params = identifierType === 'id'
            ? { assignmentId: identifier }
            : { assignmentCode: identifier };
        const relType = identifierType === 'id' ? RelType.ASSIGNMENTS_PRIMARY : RelType.ASSIGNMENTS_CODE;
        if (submissions) {
            params.submissions = submissions;
        }
        const url = getURLFromLinks(links, relType, params);
        return this._getResponse(url, { headers: Object.assign(Object.assign({}, headers$1), additionalHeaders) });
    }
    /**
     * @description Gets the metadata for a single assignment
     * @param id asset id that uniquely identifies the assignment
     * @param submissions Use this if you want to include or exclude submissions from the assignment
     * @param additionalHeaders Additional headers to include in the request
     * @returns resolves to assignment metadata for the given id
    */
    async getAssignment(id, submissions, additionalHeaders) {
        return this.getAssignmentBy('id', id, submissions, additionalHeaders);
    }
    /**
     * @description Gets the metadata for a single assignment by code
     * @param code code that identifies assignment
     * @param submissions Use this if you want to include or exclude submissions from the assignment
     * @param additionalHeaders Additional headers to include in the request
     * @returns resolves to assignment metadata for the given code
    */
    async getAssignmentByCode(code, submissions, additionalHeaders) {
        return this.getAssignmentBy('code', code, submissions, additionalHeaders);
    }
    /**
     * Creates a new Assignment
     * @param data needed to create a Assignment like name and instructions
     * @returns the newly created Assignment
    */
    async createAssignment(data) {
        var _a, _b, _c, _d;
        // [ACPCEDU-444]: When specified, status always takes precedence; if tasks present then assignment is ASSIGNED, otherwise it is DRAFT.
        const hasTasks = ((_b = (_a = data.tasks) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
        const status = data.status || (hasTasks ? AssignmentStatus.ASSIGNED : AssignmentStatus.DRAFT);
        const links = await this.discoverLinks();
        const url = new URL(getURLFromLinks(links, RelType.ASSIGNMENTS_CREATE));
        setURLSearchParams(url, {
            classroomId: data.classroomId,
            assign: (status === AssignmentStatus.ASSIGNED).toString(),
        });
        const extTemplateIds = data.externalTemplateIds || [];
        const extTutorials = ((_c = data.externalTutorials) === null || _c === void 0 ? void 0 : _c.map(t => JSON.stringify(t))) || [];
        const response = await this._doPost(url.toString(), Object.assign(Object.assign({}, headers$1), { 'Content-Type': JSON_MIME_TYPE }), JSON.stringify({
            'assignment:canClassroomReadSubmissions': data.canClassroomReadSubmissions,
            'assignment:dueDate': (_d = data.dueDate) === null || _d === void 0 ? void 0 : _d.toISOString(),
            'assignment:instructions': data.instructions,
            'repo:name': data.name,
            'assignment:status': status,
            'assignment:tasks': data.tasks || [],
            'assignment:createdBy': data.createdBy,
            'assignment:externalTemplateIds': [...extTemplateIds, ...extTutorials],
        }), [201]);
        // TODO: https://jira.corp.adobe.com/browse/ACPCEDU-403 Add error handling
        const jsonResponse = await response.json();
        return jsonResponse;
    }
    /**
     * Updates an assignment's data
     * @param id The id of the Assignment to update
     * @param data The data to update the Assignment with. Currently only the instructions, dueDate, tasks, and templateIds can be modified.
     */
    async patchAssignment(id, ops) {
        const links = await this.discoverLinks();
        const url = getURLFromLinks(links, RelType.ASSIGNMENTS_PRIMARY, { assignmentId: id });
        const response = await this._doPatch(url, Object.assign(Object.assign({}, headers$1), { 'Content-Type': JSON_MIME_TYPE }), JSON.stringify(ops), [200, 204]);
        const jsonResponse = await response.json();
        return jsonResponse;
    }
    /**
     * Discards an assignment -- from the DISCARDED state, an assignment can be permanently deleted or restored
     * @param id The id of the Assignment to discard
     * @param links The links object containing valid actions this user has on the assignment
     */
    async discardAssignment(id, links) {
        if (!(links === null || links === void 0 ? void 0 : links[RelType.DISCARD])) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Discard link is missing for this assignment ${id}`);
        }
        const url = getURLFromLinks(links, RelType.DISCARD, { assignmentId: id });
        await this._doPost(url, headers$1, undefined, [204]);
    }
    /**
     * Restores a discarded assignment
     * @param id The id of the Assignment to restore
     * @param links The links object containing valid actions this user has on the assignment
     */
    async restoreAssignment(id, links) {
        if (!(links === null || links === void 0 ? void 0 : links[RelType.RESTORE])) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Restore link is missing for this assignment ${id}`);
        }
        const url = getURLFromLinks(links, RelType.RESTORE, { assignmentId: id });
        await this._doPost(url, headers$1, undefined, [204]);
    }
}
__decorate([
    cache(validateRequiredAssignmentLinks),
    __param(0, key)
], AssignmentsInterface.prototype, "_discoverLinks", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class StudentAssignmentAppMetadataResource extends AppMetadataResource {
    constructor(_core, _parent) {
        super(_core, _parent);
        this._core = _core;
        this._parent = _parent;
        this._studentAssignmentsInterface = new StudentAssignmentsInterface(this._core);
    }
    async _loadData() {
        // Get the core links from RAPI
        const rapiLinks = await this._core.hostAssetContext._rapi.getAssetLinks(this._parent.id);
        // Application specific links are within the Hume response, we will merge these with the core links
        const studentAssignmentMetadata = await this._studentAssignmentsInterface.getStudentAssignment(this._parent.id, undefined, { [RequestHeaders.PREFER_RAPI]: 'true' });
        const { _links: humeLinks } = studentAssignmentMetadata, rest = __rest$2(studentAssignmentMetadata, ["_links"]);
        await this._setData(Object.assign(Object.assign({}, rest), { _links: Object.assign(Object.assign({}, rapiLinks), humeLinks) }));
        // Updates the StudentAssignment to include the latest app metadata
        const session = this._core._getAssetPool().createMutationSession();
        StudentAssignmentUpdater.updateLocalItem(session, this._parent, this.data);
        session.commit();
    }
}

class StudentAssignmentFilesListLoader {
    constructor({ core, studentAssignmentsInterface }) {
        this._core = core;
        this._studentAssignmentsInterface = studentAssignmentsInterface;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: https://jira.corp.adobe.com/browse/ACPCEDU-405 add support for paging or remove this
    pageLink) {
        var _a;
        const mostRecentValidMutation = Date.now();
        const { studentAssignmentId } = options.implicitFilter;
        const cachedStudentAssignment = this._core._getAssetPool().getLocalItemById(studentAssignmentId);
        let studentAssignmentFiles = (_a = cachedStudentAssignment === null || cachedStudentAssignment === void 0 ? void 0 : cachedStudentAssignment.studentAssignmentFiles) !== null && _a !== void 0 ? _a : [];
        if (cachedStudentAssignment && cachedStudentAssignment._hasLoadedChildren) {
            /**
             * If we already have loaded both the StudentAssignment and its files,
             * then we can just link them since they are all already in the pool.
             *
             * Includes any relevant SAFs that have been cached as AdobeAssets
             * which occurs if the file was cached prior to being moved into
             * a StudentAssignment.
             * [ACPCEDU-3290] will introduce a longer-term approach for handling this behavior
             * to support other/future cases where the asset type changes over time
             */
            studentAssignmentFiles = this._core._getAssetPool().toArray().filter((item) => item.studentAssignmentId === studentAssignmentId);
        }
        else if (studentAssignmentFiles.length === 0) {
            // If the StudentAssignment was not yet loaded, or if it was loaded without
            // the files, then we need to fetch the files from the server.
            const studentAssignmentMetadata = await this._studentAssignmentsInterface.getStudentAssignment(studentAssignmentId, { loadDocuments: true });
            const assignmentId = studentAssignmentMetadata['classroom:context']['classroom:assignmentContext']['classroom:assignmentAssetId'];
            const classroomId = studentAssignmentMetadata['classroom:context']['classroom:classroomContext']['classroom:classroomAssetId'];
            const session = this._core._getAssetPool().createMutationSession();
            studentAssignmentFiles = this._core.classroomContext._updateStudentAssignmentFilesCache({ remoteStudentAssignmentFiles: studentAssignmentMetadata.children, session, assignmentId, classroomId, studentAssignmentId });
            if (cachedStudentAssignment) {
                cachedStudentAssignment._hasLoadedChildren = true;
            }
        }
        return {
            items: studentAssignmentFiles,
            total: studentAssignmentFiles.length,
            mostRecentValidMutation,
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class StudentAssignment extends AdobeAsset {
    constructor(_core, id, metadata) {
        super(_core, id, metadata);
        this._core = _core;
        this._assetClass = 'directory'; // this makes assignment a folder
        this._assignmentId = '';
        this._assignmentCode = '';
        this._parentClassroomId = '';
        this._inheritedClassroomId = '';
        // Have the associated SA Files been loaded into the pool?
        // Note: the odd "...Prop" naming is to avoid a conflict with the getter/setter
        this._hasLoadedChildrenProp = false;
        this._status = StudentAssignmentStatus.NOT_STARTED;
        this._student = { id: '', displayName: '', email: '' };
        this._studentAssignmentsInterface = new StudentAssignmentsInterface(this._core);
        // This field is intended to preserve child assets provided by the remote item that may not be available through the StudentAssignmentFileSource yet/that
        // a weak ref to the list does not exist yet until getList is called
        this._studentAssignmentFiles = [];
        this._studentAssignmentAppMetadata = new StudentAssignmentAppMetadataResource(_core, this);
        // Overridden property.
        // True to start with. If we have the metadata, we will update this.
        // Keep in mind that the submission service does not include all Adobe
        // Asset metadata in its responses, hence why this is needed.
        this._needsRepoMetadata = true;
    }
    get appMetadata() {
        return this._studentAssignmentAppMetadata;
    }
    /**
     * Were child assets fetched in parallel to this StudentAssignment.  This differentiates
     * when files were NOT fetched vs files were fetched but the files are not yet associated
     * with the StudentAssignment (i.e. the files are not present in this._studentAssignmentFiles)
     * @package Only for use in SAM.js.
     */
    get _hasLoadedChildren() {
        return this._hasLoadedChildrenProp;
    }
    /**
     * @package Only for use in SAM.js.
     */
    set _hasLoadedChildren(value) {
        this._hasLoadedChildrenProp = value;
    }
    /**
     * @package Only for use in SAM.js. Please use .files() instead.
     */
    get studentAssignmentFiles() {
        return this._studentAssignmentFiles;
    }
    get assignmentId() {
        return this._assignmentId;
    }
    get assignmentCode() {
        return this._assignmentCode;
    }
    /**
     * Overrides the default implementation in AdobeAsset
     */
    get parentClassroomId() {
        // We expect to always have classroom:context on hand
        // In the unexpected case that we don't, we can fall back to cc:inherited or the super call that will check appMetadata
        return this._parentClassroomId || this._inheritedClassroomId || super.parentClassroomId || '';
    }
    /**
     * Overrides the default implementation in AdobeAsset
     */
    get parentAssignmentId() {
        return this.assignmentId;
    }
    get status() {
        return this._status;
    }
    get student() {
        return this._student;
    }
    get studentDirectoryId() {
        return this._studentDirectoryId;
    }
    get submission() {
        return this._submission;
    }
    get submissionDate() {
        return this._submissionDate;
    }
    get isStudentAssignment() {
        return true;
    }
    /**
     * Returns the files in the student's assignment directory. Optional parameter to specify the order of the files.
     * @throws {Error} if the student directory asset is not a folder
     * @deprecated Use `.files` instead. Will be removed in ACPCEDU-3305.
     */
    async getFiles(options = {}) {
        if (!this._studentDirectoryId) {
            return [];
        }
        return this._core.classroomContext.getStudentAssignmentFiles({
            studentDirectoryId: this.studentDirectoryId, order: options.order
        });
    }
    /**
     * Returns undefined if the StudentAssignment is NOT_STARTED, otherwise
     * returns the StudentAssignmentsSource which contains a list of StudentAssignmentFile[].
     *
     * @example <caption>Get all StudentAssignmentFiles for this StudentAssignment</caption>
     * const safList = studentAssignment.files?.getList(StudentAssignmentFileOrder.default);
     * await waitForListLoad(safList);
     * const safs: StudentAssignmentFile[] = safList?.items || [];
     */
    get files() {
        if (!this._studentDirectoryId) {
            // The StudentAssignment is NOT_STARTED so there are no files to fetch
            return undefined;
        }
        if (!this._studentAssignmentFilesSource) {
            this._studentAssignmentFilesSource = new ItemSource(this._core._getAssetPool(), [new StudentAssignmentFilesListLoader({ core: this._core, studentAssignmentsInterface: this._studentAssignmentsInterface })], new StudentAssignmentFileFilter(this._studentDirectoryId));
        }
        return this._studentAssignmentFilesSource;
    }
    /**
     * @deprecated This getter is deprecated and clients should use the links() function instead moving forward.
     * This method will be removed on or after 2025-7-1 in ACPCEDU-3393
     */
    get studentAssignmentLinks() {
        return this.links;
    }
    get links() {
        // Make a copy to avoid the client accidentally manipulating the links
        return Object.assign({}, this.__links);
    }
    /**
     * Other students will have read access to this directory if the class gallery is enabled.
     * To reduce visibility to in-progress work, we do not want to load new work files from ONS notifications.
     * @package -- internal use only
     */
    get _canLoadNewChildrenFromONSNotification() {
        return this.hasPermission(Permission.Write);
    }
    /**
     * Checks if this StudentAssignment is able to be started
     *
     * @example <caption>Check if the StudentAssignment can be started</caption>
     * if (studentAssignment.canStart()) {
     *  // Do something
     * }
     */
    canStart() {
        return this._status === StudentAssignmentStatus.NOT_STARTED;
    }
    /**
     * Checks if this StudentAssignment can be returned by the teachers
     *
     * @example <caption>Check if the StudentAssignment can be returned</caption>
     * if (studentAssignment.canReturn()) {
     *  // Do something
     * }
     */
    canReturn() {
        return this._status === StudentAssignmentStatus.SUBMITTED;
    }
    // this _load will be extended in https://jira.corp.adobe.com/browse/ACPCEDU-2125 to account for cases where we don't need to fetch Assignment just to get StudentAssignment
    // Until then, we can assume StudentAssignments are coming from GET assignments
    /**
   * @param repoMetadata {RepositoryMetadata} If passed in, it will be used instead of loading from the service
   * @param appMetadata {any} If passed in, it will be used instead of loading from the service
   *
   * @package -- only for use in SAM.js
   */
    async _load({ repoMetadata, appMetadata, effectivePermission, perUserMetadata, doFetchStudentAssignmentMetadata = true, } = {}) {
        // Similar to what Project already has, first load the AdobeAsset so that once we get the student assignment metadata we override any relevant
        // properties with the student assignment metadata
        await super._load({ repoMetadata, appMetadata, effectivePermission, perUserMetadata });
        if (doFetchStudentAssignmentMetadata) {
            const studentAssignmentMetadata = await this._studentAssignmentsInterface.getStudentAssignment(this.id, undefined, { [RequestHeaders.PREFER_RAPI]: 'true' });
            const session = this._core._getAssetPool().createMutationSession();
            StudentAssignmentUpdater.updateRemoteItem(session, studentAssignmentMetadata);
            session.commit();
        }
    }
    /**
     * Marks this student assignment as returned.
     *
     * @example <caption>Return a StudentAssignment</caption>
     * await studentAssignment.return();
     */
    async return() {
        var _a;
        return this._core.classroomContext._returnAssignment({
            links: this.links,
            studentAssignmentId: this.studentDirectoryId,
            submissionId: (_a = this.submission) === null || _a === void 0 ? void 0 : _a['repo:assetId'],
        });
    }
    /**
     * Marks this student assignment as started.
     *
     * @example <caption>Start a StudentAssignment</caption>
     * await studentAssignment.start();
     */
    async start() {
        return this._core.classroomContext._startAssignment({
            assignmentId: this.assignmentId,
            links: this.links,
        });
    }
    /**
     * Marks this student assignment as submitted. Note that this should only be called by the student for
     * submitting their own assignment.
     * @param submissionId - The asset ID of the student's work to become the submission for this assignment.
     *
     * @example <caption>Submit a StudentAssignment</caption>
     * await studentAssignment.submit('submission-id');
     */
    async submit(submissionId) {
        await this._core.classroomContext.submitAssignment({
            assignmentId: this.assignmentId,
            links: this.links,
            status: this.status,
            studentAssignmentId: this.studentDirectoryId,
            submissionId,
        });
        return this;
    }
    /**
     * Returns true as the StudentAssignment is a child of Classroom
     * Overrides the default implementation in AdobeAsset
     */
    get isChildOfClassroom() {
        return true;
    }
    /**
     * Returns true as the StudentAssignment is a child of Assignment
     * Overrides the default implementation in AdobeAsset
     */
    get isChildOfAssignment() {
        return true;
    }
    /**
     * Returns false as the StudentAssignment is not a child of AssignmentMaterials
     * Overrides the default implementation in AdobeAsset
     */
    get isChildOfAssignmentMaterials() {
        return false;
    }
    /**
     * Returns false as the StudentAssignment is not a child of StudentAssignment
     * Overrides the default implementation in AdobeAsset
     */
    get isChildOfStudentAssignment() {
        return false;
    }
}
__decorate([
    observable$1
], StudentAssignment.prototype, "appMetadata", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "assignmentId", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "assignmentCode", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "parentClassroomId", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "parentAssignmentId", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "status", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "student", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "studentDirectoryId", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "submission", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "submissionDate", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "getFiles", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "studentAssignmentLinks", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "links", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "isChildOfClassroom", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "isChildOfAssignment", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "isChildOfAssignmentMaterials", null);
__decorate([
    observable$1
], StudentAssignment.prototype, "isChildOfStudentAssignment", null);
function getAlternateStudentAssignmentId(remoteItem) {
    var _a;
    // We expect to always have classroom:context on hand
    // In the unexpected case that we don't, we can fall back to cc:inherited or throw an error.
    let id;
    if (remoteItem['classroom:context'] !== undefined) {
        id = remoteItem['classroom:context']['classroom:assignmentContext']['classroom:assignmentAssetId'];
    }
    else if (remoteItem['cc:inherited'] !== undefined && remoteItem['cc:inherited']['cc:assignment'] !== undefined) {
        id = remoteItem['cc:inherited']['cc:assignment']['repo:assetId'];
    }
    else {
        throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, `Remote item does not have classroom:context or cc:inherited defined`);
    }
    return `${(_a = remoteItem['assignment:assignee']) === null || _a === void 0 ? void 0 : _a.id}-${id}`;
}
const StudentAssignmentUpdater = new ItemUpdater({
    remoteIdProperty: 'repo:assetId',
    getAlternateId: getAlternateStudentAssignmentId,
    localItemType: StudentAssignment,
    propertyUpdater: new PropertyUpdater({
        _assignmentId: { name: 'classroom:context[classroom:assignmentContext][classroom:assignmentAssetId]', format: 'string' },
        _assignmentCode: { name: 'computedAssignmentCode', format: 'string' },
        _parentClassroomId: { name: 'classroom:context[classroom:classroomContext][classroom:classroomAssetId]', format: 'string' },
        _inheritedClassroomId: { name: 'cc:inherited[cc:classroom][repo:assetId]', format: 'string' },
        _studentAssignmentFiles: {
            isArray: true,
            name: 'children',
            format: 'object',
            set: (remoteStudentAssignmentFiles, dest) => {
                const studentAssignment = dest;
                studentAssignment.studentAssignmentFiles.length = 0;
                const session = studentAssignment._core._getAssetPool().createMutationSession();
                const files = studentAssignment._core.classroomContext._updateStudentAssignmentFilesCache({ remoteStudentAssignmentFiles, session, assignmentId: studentAssignment.assignmentId, classroomId: studentAssignment.parentClassroomId, studentAssignmentId: studentAssignment.id });
                studentAssignment.studentAssignmentFiles.push(...files);
            }
        },
        __links: { name: '_links', format: 'object' },
        _status: { name: 'assignment:submissionStatus', format: 'string' },
        // if using 'object' in the format, the setter will be called  when the response omits displayName ( because undefined is different than the name it already has ).
        // This leads to the result of having the updater dispatches the change event whenever the setter is called.
        // Using 'object_subset' so the parse/isEqual's will only compare the members in the response with their corresponding values in the local object,
        // so it only calls the setter when something specified in the response differences from the existing value.
        _student: { name: 'assignment:assignee', format: 'object_subset', set: (remoteAssignee, dest) => {
                const studentAssignment = dest;
                // Hume will not provide displayName or email in start/submit/return API responses.
                // If we only pass through the object from Hume, missing/undefined required fields of display name and email will override the existing non-empty ones.
                studentAssignment['_student'] = Object.assign(Object.assign({}, studentAssignment['_student']), remoteAssignee);
            } },
        _studentDirectoryId: { name: 'repo:assetId', format: 'string' },
        _submission: { name: 'assignment:submission', format: 'object' },
        _submissionDate: { name: 'assignment:submissionDate', format: 'date' },
    }),
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AssignmentAppMetadataResource extends AppMetadataResource {
    constructor(_core, _parent) {
        super(_core, _parent);
        this._core = _core;
        this._parent = _parent;
    }
    async _loadData() {
        // Directly fetches app metadata from R-API since there is a chance app metadata
        // has been fetched external to Hume, such as the case the Assignment was fetched
        // with AssetContext.getAssetWithCloudID.
        await super._loadData();
        // Updates the Assignment to include the latest app metadata
        const session = this._core._getAssetPool().createMutationSession();
        AssignmentUpdater.updateLocalItem(session, this._parent, this.data);
        session.commit();
    }
}

class ImplicitStudentAssignmentFilter {
    // TODO [ACPCEDU-2702]: options will be made required in the future
    constructor(options) {
        const { assignmentCode, assignmentId } = options || {};
        // default values for assignment code and id are empty strings, match for ensuring comparisons work correctly
        this.assignmentCode = assignmentCode || '';
        this.assignmentId = assignmentId || '';
    }
    matches(item) {
        if (!this.assignmentId && !this.assignmentCode) {
            throw new Error('Getting StudentAssignments across Assignments is not supported at this time');
        }
        if (!item.isStudentAssignment) {
            return false;
        }
        const studentAssignmentItem = item;
        // either this.assignmentId or this.assignmentCode should be non-empty
        if (this.assignmentId && (this.assignmentId !== studentAssignmentItem.assignmentId)) {
            return false;
        }
        if (this.assignmentCode && (this.assignmentCode !== studentAssignmentItem.assignmentCode)) {
            return false;
        }
        return true;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const AssignmentStatusChoices = Object.values(AssignmentStatus);
class Assignment extends AdobeAsset {
    constructor(_core, id, metadata) {
        super(_core, id, metadata);
        this._core = _core;
        this._assetClass = 'directory'; // this makes assignment a folder
        this._assignmentInterface = new AssignmentsInterface(this._core);
        this._canClassroomReadSubmissions = false;
        this._classroomId = '';
        this._code = '';
        this._externalTemplateIds = [];
        /**
         * This is the raw data from remote, we need to parse it to get the actual external tutorials.
         * Storing the raw data allows the property updater to know if the data has changed.
         * Both externalTemplateIds and externalTutorials are derived from this data.
         */
        this._externalTemplateIdsRemote = [];
        this._instructions = '';
        this._isAutoCreated = false;
        this._studentAssignments = [];
        this._externalTutorials = [];
        this._isExternalTutorialsDirty = false;
        this._parentClassroomId = '';
        this._materialsAssetId = '';
        this._studentsAssetId = '';
        this._parentAssignmentsFolderAssetId = '';
        this._assignmentAppMetadata = new AssignmentAppMetadataResource(_core, this);
        // Overridden property.
        // True to start with. If we have the metadata, we will update this.
        // Keep in mind that the assignment service does not include all Adobe
        // Asset metadata in its responses, hence why this is needed.
        this._needsRepoMetadata = true;
    }
    get appMetadata() {
        return this._assignmentAppMetadata;
    }
    get canClassroomReadSubmissions() {
        return this._canClassroomReadSubmissions;
    }
    get classroomId() {
        return this._classroomId;
    }
    /**
     * Overrides default AdobeAsset check
     * */
    get isChildOfAssignment() {
        return false;
    }
    /**
     * Overrides default AdobeAsset check
     * */
    get isChildOfAssignmentMaterials() {
        return false;
    }
    /**
     * Overrides default AdobeAsset check
     * */
    get isChildOfClassroom() {
        return true;
    }
    /**
     * Overrides default AdobeAsset check
     * */
    get isChildOfStudentAssignment() {
        return false;
    }
    /**
     * Gets all student assignments for this assignment
     * @package Only for use in SAM.js. Please use `getStudentAssignments()` instead.
     */
    get studentAssignments() {
        return this._studentAssignments;
    }
    /**
     * Builds a StudentAssignmentFilter that is scoped to this Assignment ID
     * @package -- for use in SAM.js only
     */
    _getStudentAssignmentsFilter() {
        return new ImplicitStudentAssignmentFilter({
            assignmentId: this.id,
        });
    }
    /**
     * Fetches the list of StudentAssignments for this Assignment
     * @example <caption>Get all student assignments for this assignment</caption>
     * const studentAssignments = assignment.getStudentAssignments().getList(StudentAssignmentOrder.default);
     *
     * @example <caption>Get all student assignments for this assignment that are in progress</caption>
     * const filter = assignment.getStudentAssignmentsFilter({ status: [StudentAssignmentStatus.IN_PROGRESS] });
     * const studentAssignments = assignment.getStudentAssignments().getList(StudentAssignmentOrder.default, filter);
     */
    getStudentAssignments() {
        return this._core.classroomContext._getStudentAssignmentsSource(this._getStudentAssignmentsFilter());
    }
    // eslint-disable-next-line no-dupe-class-members
    getStudentAssignmentsByStatus(status) {
        if (Array.isArray(status)) {
            return this._studentAssignments.filter((sa) => status.includes(sa.status));
        }
        return this._studentAssignments.filter((sa) => sa.status === status);
    }
    /**
     * Gets all student assignments for this assignment that are not NOT_STARTED
     * @deprecated Use `getStudentAssignments()` instead
     * This method will be removed on or after 2025-4-1 in ACPCEDU-3388
     */
    get existingStudentAssignments() {
        const existsList = [
            StudentAssignmentStatus.IN_PROGRESS,
            StudentAssignmentStatus.SUBMITTED,
            StudentAssignmentStatus.RETURNED
        ];
        return this.getStudentAssignmentsByStatus(existsList);
    }
    get code() {
        return this._code;
    }
    get isAssignment() {
        return true;
    }
    get instructions() {
        return this._instructions;
    }
    get isAutoCreated() {
        return this._isAutoCreated;
    }
    get dueDate() {
        return this._dueDate;
    }
    get status() {
        return this._status;
    }
    get tasks() {
        var _a;
        return (_a = this._tasks) !== null && _a !== void 0 ? _a : [];
    }
    get templateIds() {
        var _a;
        return (_a = this._templateIds) !== null && _a !== void 0 ? _a : [];
    }
    get parentClassroomId() {
        return this._parentClassroomId;
    }
    get materialsAssetId() {
        return this._materialsAssetId;
    }
    get studentsAssetId() {
        return this._studentsAssetId;
    }
    /**
     * @package -- for use in SAM.js only
     */
    get _parentAssignmentsAssetId() {
        return this._parentAssignmentsFolderAssetId;
    }
    get externalTemplateIds() {
        if (this._isExternalTutorialsDirty) {
            this._externalTemplateIds = this._externalTemplateIdsRemote.filter((templateIdOrTutorial) => {
                try {
                    JSON.parse(templateIdOrTutorial);
                    // If it is an object then it is not a template ID, filter it out
                    return false;
                }
                catch (_a) {
                    return true;
                }
            });
        }
        return this._externalTemplateIds;
    }
    get externalTutorials() {
        if (this._isExternalTutorialsDirty) {
            this._externalTutorials = this._externalTemplateIdsRemote.reduce((acc, templateIdOrTutorial) => {
                try {
                    acc.push(JSON.parse(templateIdOrTutorial));
                }
                catch (_a) {
                    // Not a tutorial, ignore
                }
                return acc;
            }, []);
        }
        return this._externalTutorials;
    }
    get referenceIds() {
        var _a;
        return (_a = this._referenceIds) !== null && _a !== void 0 ? _a : [];
    }
    /**
     * @deprecated Please use @see {templateIds} instead
     * This method will be removed on or after 2025-4-1 in ACPCEDU-3388
     */
    get templates() {
        oneTimeWarning('Assignment.templates', 'Assignment.templates is deprecated and will be removed'
            + ' on or after 2024-10-01. Please use Assignment.templateIds instead.');
        return [];
    }
    /**
     * @package -- for use in SAM.js only
     * Will override any cached assignment with the latest data from the assignment service and R-API
     */
    _loadWithRetry() {
        return this._load();
    }
    /**
   * @param repoMetadata {RepositoryMetadata} If passed in, it will be used instead of loading from the service
   * @param appMetadata {any} If passed in, it will be used instead of loading from the service
   *
   * @package -- only for use in SAM.js
   */
    async _load({ repoMetadata, appMetadata, effectivePermission, } = {}) {
        // Similar to what Project already has, first load the AdobeAsset so that once we get the assignment metadata we override any relevant
        // properties with the assignment metadata
        await super._load({ repoMetadata, appMetadata, effectivePermission });
        // The Assignment asset must have the assignment links from Hume to be considered complete
        // Only checking for a single link. If we have this one we can assume we have others
        const didLinksComeFromHume = this.links[RelType$1.ASSIGNMENTS_PRIMARY] !== undefined;
        // A majority of the Assignment model has already been set at this point using an AdobeAsset
        // However the AdobeAsset does not include the expected children array so
        // we need to call Hume to fetch this info to preserve existing behavior.
        // Once all clients have moved onto lazy loading studentAssignments this can be removed.
        const isPartialAssignment = this.studentAssignments.length === 0;
        // The assignment model is constructed of a mix of repo and app metadata, if either are missing, refetch the assignment
        const isStaleAssignment = !repoMetadata || !appMetadata;
        if (isStaleAssignment || isPartialAssignment || !didLinksComeFromHume) {
            // load the assignment metadata using the assignment service
            const assignmentMetadata = await this._assignmentInterface.getAssignment(this.id, undefined, { [RequestHeaders.PREFER_RAPI]: 'true' });
            const session = this._core._getAssetPool().createMutationSession();
            AssignmentUpdater.updateRemoteItem(session, assignmentMetadata);
            session.commit();
        }
    }
    /**
     * Updates the metadata for an assignment. If template IDs are provided then they
     * will be cloned to the assignment's working folder with new asset IDs
     */
    async updateAssignment(data) {
        return this._core.classroomContext.updateAssignment(this.id, data);
    }
    /**
     * Clones the incoming assets to the assignment's working folder with new asset IDs
     * @param templateAssetIds - An array of asset IDs which will be used to copy the asset from the teacher to the assignment
     */
    async setTemplates(templateAssetIds) {
        return this._core.classroomContext.updateAssignment(this.id, { templateIds: templateAssetIds });
    }
    /**
     * Assigns an in-draft assignment to all students in the classroom
     * @deprecated Calls to this function should be replaced with updateAssignment(assignmentId, { status: AssignmentStatus.ASSIGNED })
     * This method will be removed on or after 2025-4-1 in ACPCEDU-3388
     */
    async assignAssignment() {
        return this._core.classroomContext.updateAssignment(this.id, { status: AssignmentStatus.ASSIGNED });
    }
    /**
     * Discards an assignment -- from discarded state, assignment can either be restored or permanently deleted.
     */
    async discard() {
        if (this.isDiscarded) {
            return;
        }
        await this._assignmentInterface.discardAssignment(this.id, this.links);
        const assignmentPool = this._core._getAssetPool();
        const session = assignmentPool.createUpdateSession();
        AssignmentUpdater.updateLocalItem(session, this, { 'repo:state': AssetStateChoices[1] });
        session.commit();
    }
    /**
     * Restores an assignment from the discarded state
     */
    async restore() {
        if (!this.isDiscarded) {
            return;
        }
        await this._assignmentInterface.restoreAssignment(this.id, this.links);
        const assignmentPool = this._core._getAssetPool();
        const session = assignmentPool.createUpdateSession();
        AssignmentUpdater.updateLocalItem(session, this, { 'repo:state': AssetStateChoices[0] });
        session.commit();
    }
    get links() {
        // Make a copy to avoid the client accidentally manipulating the links
        return Object.assign({}, this.__links);
    }
}
__decorate([
    observable$1
], Assignment.prototype, "appMetadata", null);
__decorate([
    observable$1
], Assignment.prototype, "canClassroomReadSubmissions", null);
__decorate([
    observable$1
], Assignment.prototype, "classroomId", null);
__decorate([
    observable$1
], Assignment.prototype, "isChildOfAssignment", null);
__decorate([
    observable$1
], Assignment.prototype, "isChildOfAssignmentMaterials", null);
__decorate([
    observable$1
], Assignment.prototype, "isChildOfClassroom", null);
__decorate([
    observable$1
], Assignment.prototype, "isChildOfStudentAssignment", null);
__decorate([
    observable$1
], Assignment.prototype, "studentAssignments", null);
__decorate([
    memoize$1
], Assignment.prototype, "getStudentAssignments", null);
__decorate([
    observable$1
], Assignment.prototype, "code", null);
__decorate([
    observable$1
], Assignment.prototype, "isAssignment", null);
__decorate([
    observable$1
], Assignment.prototype, "instructions", null);
__decorate([
    observable$1
], Assignment.prototype, "isAutoCreated", null);
__decorate([
    observable$1
], Assignment.prototype, "dueDate", null);
__decorate([
    observable$1
], Assignment.prototype, "status", null);
__decorate([
    observable$1
], Assignment.prototype, "tasks", null);
__decorate([
    observable$1
], Assignment.prototype, "templateIds", null);
__decorate([
    observable$1
], Assignment.prototype, "parentClassroomId", null);
__decorate([
    observable$1
], Assignment.prototype, "materialsAssetId", null);
__decorate([
    observable$1
], Assignment.prototype, "studentsAssetId", null);
__decorate([
    observable$1
], Assignment.prototype, "externalTemplateIds", null);
__decorate([
    observable$1
], Assignment.prototype, "externalTutorials", null);
__decorate([
    observable$1
], Assignment.prototype, "referenceIds", null);
__decorate([
    retry
], Assignment.prototype, "_loadWithRetry", null);
__decorate([
    observable$1
], Assignment.prototype, "links", null);
const AssignmentUpdater = new ItemUpdater({
    localItemType: Assignment,
    remoteIdProperty: 'repo:assetId',
    propertyUpdater: new PropertyUpdater({
        _canClassroomReadSubmissions: { name: 'assignment:canClassroomReadSubmissions', format: 'boolean' },
        _name: { name: 'repo:name', format: 'string' },
        _created: { name: 'repo:createDate', format: 'date' },
        _parentClassroomAssetId: { name: 'classroom:context[classroom:classroomContext][classroom:classroomAssetId]', format: 'string' },
        _parentAssignmentsFolderAssetId: { name: 'classroom:context[classroom:assignmentsContext][classroom:assignmentsAssetId]', format: 'string' },
        _materialsAssetId: { name: 'classroom:context[assignment:materialsContext][assignment:materialsAssetId]', format: 'string' },
        _studentsAssetId: { name: 'classroom:context[assignment:studentsContext][assignment:studentsAssetId]', format: 'string' },
        _repositoryID: { name: 'repo:repositoryId', format: 'string' },
        __links: { name: '_links', format: 'object' },
        // things TBD from Assignment service are below
        _studentAssignments: {
            isArray: true,
            name: 'children',
            format: 'object',
            set: (studentAssignments, dest) => {
                const assignment = dest;
                // Clearing the collection in case this updater is called twice, to avoid duplicate student assignments.
                assignment.studentAssignments.length = 0;
                const session = assignment._core._getAssetPool().createMutationSession();
                // Add computed values for each student assignment
                const studentAssignmentsWithComputedValues = studentAssignments.map(sa => (Object.assign(Object.assign({}, sa), { 'computedAssignmentCode': assignment.code, 'classroom:context': {
                        'classroom:assignmentContext': {
                            'classroom:assignmentAssetId': assignment.id
                        },
                        'classroom:classroomContext': {
                            'classroom:classroomAssetId': assignment.parentClassroomId
                        },
                        'classroom:assignmentsContext': {
                            'classroom:assignmentsAssetId': assignment._parentAssignmentsAssetId
                        },
                        'assignment:materialsContext': {
                            'assignment:materialsAssetId': assignment.materialsAssetId
                        },
                        'assignment:studentsContext': {
                            'assignment:studentsAssetId': assignment.studentsAssetId
                        }
                    } })));
                const cachedStudentAssignments = StudentAssignmentUpdater.updateRemoteItems(session, studentAssignmentsWithComputedValues);
                session.commit();
                // cannot do assignment.studentAssignments = cachedStudentAssignments instead because it mentioned assignment.studentAssignments is read-only
                assignment.studentAssignments.push(...cachedStudentAssignments);
                const order = StudentAssignmentOrder.default;
                order.sortItems(assignment.studentAssignments);
            }
        },
        _tasks: { isArray: true, name: 'assignment:tasks' },
        _code: { name: 'assignment:code', format: 'string' },
        _classroomId: { name: 'assignment:classroomId', format: 'string' },
        _createdBy: { name: 'repo:createdBy', format: 'string' },
        _status: { name: 'assignment:status', format: 'string', choices: AssignmentStatusChoices },
        _dueDate: { name: 'assignment:dueDate', format: 'date' },
        _instructions: { name: 'assignment:instructions', format: 'string' },
        _templateIds: { name: 'assignment:templateIds', isArray: true },
        _externalTemplateIdsRemote: {
            name: 'assignment:externalTemplateIds',
            isArray: true,
            set: (externalTemplateIdsAndTutorials, dest) => {
                const assignment = dest;
                assignment['_externalTemplateIdsRemote'] = externalTemplateIdsAndTutorials;
                assignment['_isExternalTutorialsDirty'] = true;
            }
        },
        _referenceIds: { name: 'assignment:referenceIds', isArray: true },
        _path: { name: 'repo:path', format: 'string' },
        _modifiedBy: { name: 'repo:modifiedBy', format: 'string' },
        _assetState: { name: 'repo:state', choices: AssetStateChoices },
        _isAutoCreated: { get: (source) => source['assignment:createdBy'] === 'adobe', format: 'boolean' },
    }),
});

class AssignmentsListLoader {
    constructor(_assignmentInterface, _core) {
        this._assignmentInterface = _assignmentInterface;
        this._core = _core;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    /**
     * Observe Assignments folder to get enable automatic ONS updates for assignments page.
     * @param assignment - assignment, which contains parent folder ID
     * @returns promise that resolves to students adobe asset instance
     */
    async observeAssignmentsFolder(assignment) {
        const assignmentsFolderId = assignment['classroom:context']['classroom:assignmentsContext']['classroom:assignmentsAssetId'];
        // This ticket [ACPCEDU-2563] will try to optimize this.
        return this._core.hostAssetContext.getAssetWithCloudID(assignmentsFolderId);
    }
    async _loadPage(options, 
    // TODO: https://jira.corp.adobe.com/browse/ACPCEDU-405 add support for paging or remove this
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    pageLink) {
        const filter = options.filter;
        const { classroomId, submissions } = filter;
        const result = await this._assignmentInterface.getAssignments(Object.assign(Object.assign({}, options), { classroomId, submissions: await this._core.classroomContext.validateStudentAssignmentsFilter(submissions, classroomId) }));
        const mostRecentValidMutation = Date.now(); // can add latency similar to what Project has
        // TBD: we probably want a "mutation" session here instead of "update" session
        // Details can be found in https://git.corp.adobe.com/torq/acpl-model/pull/3902#discussion_r7024503
        const session = this._core._getAssetPool().createLoaderUpdateSession(mostRecentValidMutation);
        const items = AssignmentUpdater.updateRemoteItems(session, result.children);
        session.commit();
        // All assignments will have the same parent folder ID, so we can observe the parent folder using just the first assignment
        if (result.children.length > 0) {
            this.observeAssignmentsFolder(result.children[0]).then((folder) => {
                // pin this to memory so Garbage Collector does not remove it as long as the list is still kept in memory
                filter._monitoredFolder = folder;
            });
        }
        return {
            items,
            total: result.children.length,
            mostRecentValidMutation,
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class StudentAssignmentListLoader {
    constructor(_StudentAssignmentsInterface, _core) {
        this._StudentAssignmentsInterface = _StudentAssignmentsInterface;
        this._core = _core;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    /**
     * Fetch and observe the students folder to track when its children NOT_STARTED Student assignments are changed to IN_PROGRESS ones.
     * @param studentsMetadata - metadata of the students folder
     * @returns promise that resolves to students adobe asset instance
     */
    async observeStudentsFolder({ remoteStudentAssignments }) {
        // Every remote student assignment has the same students asset id
        const firstRemoteStudentAssignment = remoteStudentAssignments[0];
        const studentsAssetId = firstRemoteStudentAssignment['classroom:context']['assignment:studentsContext']['assignment:studentsAssetId'];
        // Maintain a full-weight adobe asset representation of the students folder as of now since other client can request one of its attributes.
        // This ticket [ACPCEDU-2563] will try to optimize this.
        return this._core.hostAssetContext.getAssetWithCloudID(studentsAssetId);
    }
    /** @note api does not support pagination */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async _loadPage(options, start) {
        const { filter: explicitFilter, implicitFilter } = options;
        /**
         * Filter scenarios:
         *
         * From Assignment.getStudentAssignments() or ClassroomContext.getStudentAssignments():
         * implicitFilter = ImplicitStudentAssignmentFilter({assignmentId OR assignmentCode})
         * explicitFilter = StudentAssignmentFilter | EverythingFilter
         */
        // id and code should come from the implicit filter first, then from the explicit filter
        const { assignmentId: assignmentIdFromImplicitFilter, assignmentCode: assignmentCodeFromImplicitFilter } = implicitFilter;
        const { assignmentId: assignmentIdFromExplicitFilter, assignmentCode: assignmentCodeFromExplicitFilter, loadDocuments } = explicitFilter;
        // TODO [ACPCEDU-2702]: This if logic will be made required in the future
        // update assignment ID and code of the implicit filter if they are not set
        if (!assignmentIdFromImplicitFilter && !assignmentCodeFromImplicitFilter) {
            implicitFilter.assignmentId = assignmentIdFromExplicitFilter;
            implicitFilter.assignmentCode = assignmentCodeFromExplicitFilter;
        }
        const { assignmentId, assignmentCode } = implicitFilter;
        let studentAssignments = [];
        const result = await this._StudentAssignmentsInterface.getStudentAssignments({
            assignmentCode, assignmentId, loadDocuments
        });
        const remoteStudentAssignments = result.children;
        const session = this._core._getAssetPool().createUpdateSession();
        // Add computedAssignmentCode to each remote student assignment if present
        const studentAssignmentsWithCode = assignmentCode ? remoteStudentAssignments.map(sa => (Object.assign(Object.assign({}, sa), { 'computedAssignmentCode': assignmentCode }))) : remoteStudentAssignments;
        studentAssignments = StudentAssignmentUpdater.updateRemoteItems(session, studentAssignmentsWithCode);
        session.commit();
        if (loadDocuments) {
            for (const studentAssignment of studentAssignments) {
                // Since we are preloading the files before there is a StudentAssignment object to associate them with,
                // the SA and it's files may need to be linked up later by the file loader.
                studentAssignment._hasLoadedChildren = true;
            }
        }
        // No need to await, let this happen in parallel because we don't really care if it ends up failing
        // this is a nice-to-have for an ideal real-time experience for user, but is not needed by
        // the user at this moment so do not impact the performance of the current workflow
        // If there's no student assignments, which means we don't have students assigned to this assignment, we don't need to observe the students folder
        if (remoteStudentAssignments.length > 0) {
            this.observeStudentsFolder({ remoteStudentAssignments }).then((folder) => {
                // pin this to memory so Garbage Collector does not remove it as long as the list is still kept in memory
                implicitFilter._monitoredFolder = folder;
            });
        }
        return {
            items: studentAssignments,
            total: studentAssignments.length,
            loadNextPage: undefined,
        };
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */
/** only globals that common to node and browsers are allowed */
// eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var _globalThis = typeof globalThis === 'object'
    ? globalThis
    : typeof self === 'object'
        ? self
        : typeof window === 'object'
            ? window
            : typeof global === 'object'
                ? global
                : {};

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// this is autogenerated file, see scripts/version-update.js
var VERSION = '1.7.0';

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var re$1 = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
/**
 * Create a function to test an API version to see if it is compatible with the provided ownVersion.
 *
 * The returned function has the following semantics:
 * - Exact match is always compatible
 * - Major versions must match exactly
 *    - 1.x package cannot use global 2.x package
 *    - 2.x package cannot use global 1.x package
 * - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
 *    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
 *    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
 * - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
 * - Patch and build tag differences are not considered at this time
 *
 * @param ownVersion version which should be checked against
 */
function _makeCompatibilityCheck(ownVersion) {
    var acceptedVersions = new Set([ownVersion]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match(re$1);
    if (!myVersionMatch) {
        // we cannot guarantee compatibility so we always return noop
        return function () { return false; };
    }
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4],
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) {
        return function isExactmatch(globalVersion) {
            return globalVersion === ownVersion;
        };
    }
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) {
            return true;
        }
        if (rejectedVersions.has(globalVersion)) {
            return false;
        }
        var globalVersionMatch = globalVersion.match(re$1);
        if (!globalVersionMatch) {
            // cannot parse other version
            // we cannot guarantee compatibility so we always noop
            return _reject(globalVersion);
        }
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4],
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) {
            return _reject(globalVersion);
        }
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) {
            return _reject(globalVersion);
        }
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor &&
                ownVersionParsed.patch <= globalVersionParsed.patch) {
                return _accept(globalVersion);
            }
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) {
            return _accept(globalVersion);
        }
        return _reject(globalVersion);
    };
}
/**
 * Test an API version to see if it is compatible with this API.
 *
 * - Exact match is always compatible
 * - Major versions must match exactly
 *    - 1.x package cannot use global 2.x package
 *    - 2.x package cannot use global 1.x package
 * - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
 *    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
 *    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
 * - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
 * - Patch and build tag differences are not considered at this time
 *
 * @param version version of the API requesting an instance of the global API
 */
var isCompatible = _makeCompatibilityCheck(VERSION);

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var major = VERSION.split('.')[0];
var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
var _global = _globalThis;
function registerGlobal(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) { allowOverride = false; }
    var api = (_global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: VERSION,
    });
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== VERSION) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + VERSION);
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + VERSION + ".");
    return true;
}
function getGlobal(type) {
    var _a, _b;
    var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !isCompatible(globalVersion)) {
        return;
    }
    return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + VERSION + ".");
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) {
        delete api[type];
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read$4 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$4 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */
var DiagComponentLogger = /** @class */ (function () {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}());
function logProxy(funcName, namespace, args) {
    var logger = getGlobal('diag');
    // shortcut if logger not set
    if (!logger) {
        return;
    }
    args.unshift(namespace);
    return logger[funcName].apply(logger, __spreadArray$4([], __read$4(args), false));
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */
var DiagLogLevel;
(function (DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */
    DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */
    DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */
    DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */
    DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */
    DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */
    DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */
    DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createLogLevelDiagLogger(maxLevel, logger) {
    if (maxLevel < DiagLogLevel.NONE) {
        maxLevel = DiagLogLevel.NONE;
    }
    else if (maxLevel > DiagLogLevel.ALL) {
        maxLevel = DiagLogLevel.ALL;
    }
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) {
            return theFunc.bind(logger);
        }
        return function () { };
    }
    return {
        error: _filterFunc('error', DiagLogLevel.ERROR),
        warn: _filterFunc('warn', DiagLogLevel.WARN),
        info: _filterFunc('info', DiagLogLevel.INFO),
        debug: _filterFunc('debug', DiagLogLevel.DEBUG),
        verbose: _filterFunc('verbose', DiagLogLevel.VERBOSE),
    };
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read$3 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$3 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$4 = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */
var DiagAPI = /** @class */ (function () {
    /**
     * Private internal constructor
     * @private
     */
    function DiagAPI() {
        function _logProxy(funcName) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var logger = getGlobal('diag');
                // shortcut if logger not set
                if (!logger)
                    return;
                return logger[funcName].apply(logger, __spreadArray$3([], __read$3(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function (logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) { optionsOrLogLevel = { logLevel: DiagLogLevel.INFO }; }
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') {
                optionsOrLogLevel = {
                    logLevel: optionsOrLogLevel,
                };
            }
            var oldLogger = getGlobal('diag');
            var newLogger = createLogLevelDiagLogger((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : DiagLogLevel.INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return registerGlobal('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function () {
            unregisterGlobal(API_NAME$4, self);
        };
        self.createComponentLogger = function (options) {
            return new DiagComponentLogger(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */
    DiagAPI.instance = function () {
        if (!this._instance) {
            this._instance = new DiagAPI();
        }
        return this._instance;
    };
    return DiagAPI;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read$2 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var BaggageImpl = /** @class */ (function () {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function (key) {
        var entry = this._entries.get(key);
        if (!entry) {
            return undefined;
        }
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function () {
        return Array.from(this._entries.entries()).map(function (_a) {
            var _b = __read$2(_a, 2), k = _b[0], v = _b[1];
            return [k, v];
        });
    };
    BaggageImpl.prototype.setEntry = function (key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function (key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function () {
        var e_1, _a;
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function () {
        return new BaggageImpl();
    };
    return BaggageImpl;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
DiagAPI.instance();
/**
 * Create a new Baggage with optional entries
 *
 * @param entries An array of baggage entries the new baggage should contain
 */
function createBaggage(entries) {
    if (entries === void 0) { entries = {}; }
    return new BaggageImpl(new Map(Object.entries(entries)));
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Get a key to uniquely identify a context value */
function createContextKey(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var BaseContext = /** @class */ (function () {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */
    function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function (key) { return self._currentContext.get(key); };
        self.setValue = function (key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function (key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}());
/** The root context is used as the default parent context when there is no active context */
var ROOT_CONTEXT = new BaseContext();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */
var NoopMeter = /** @class */ (function () {
    function NoopMeter() {
    }
    /**
     * @see {@link Meter.createHistogram}
     */
    NoopMeter.prototype.createHistogram = function (_name, _options) {
        return NOOP_HISTOGRAM_METRIC;
    };
    /**
     * @see {@link Meter.createCounter}
     */
    NoopMeter.prototype.createCounter = function (_name, _options) {
        return NOOP_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */
    NoopMeter.prototype.createUpDownCounter = function (_name, _options) {
        return NOOP_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */
    NoopMeter.prototype.createObservableGauge = function (_name, _options) {
        return NOOP_OBSERVABLE_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */
    NoopMeter.prototype.createObservableCounter = function (_name, _options) {
        return NOOP_OBSERVABLE_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */
    NoopMeter.prototype.createObservableUpDownCounter = function (_name, _options) {
        return NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */
    NoopMeter.prototype.addBatchObservableCallback = function (_callback, _observables) { };
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */
    NoopMeter.prototype.removeBatchObservableCallback = function (_callback) { };
    return NoopMeter;
}());
var NoopMetric = /** @class */ (function () {
    function NoopMetric() {
    }
    return NoopMetric;
}());
var NoopCounterMetric = /** @class */ (function (_super) {
    __extends$1(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function (_value, _attributes) { };
    return NoopCounterMetric;
}(NoopMetric));
var NoopUpDownCounterMetric = /** @class */ (function (_super) {
    __extends$1(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function (_value, _attributes) { };
    return NoopUpDownCounterMetric;
}(NoopMetric));
var NoopHistogramMetric = /** @class */ (function (_super) {
    __extends$1(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function (_value, _attributes) { };
    return NoopHistogramMetric;
}(NoopMetric));
var NoopObservableMetric = /** @class */ (function () {
    function NoopObservableMetric() {
    }
    NoopObservableMetric.prototype.addCallback = function (_callback) { };
    NoopObservableMetric.prototype.removeCallback = function (_callback) { };
    return NoopObservableMetric;
}());
var NoopObservableCounterMetric = /** @class */ (function (_super) {
    __extends$1(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}(NoopObservableMetric));
var NoopObservableGaugeMetric = /** @class */ (function (_super) {
    __extends$1(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}(NoopObservableMetric));
var NoopObservableUpDownCounterMetric = /** @class */ (function (_super) {
    __extends$1(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}(NoopObservableMetric));
var NOOP_METER = new NoopMeter();
// Synchronous instruments
var NOOP_COUNTER_METRIC = new NoopCounterMetric();
var NOOP_HISTOGRAM_METRIC = new NoopHistogramMetric();
var NOOP_UP_DOWN_COUNTER_METRIC = new NoopUpDownCounterMetric();
// Asynchronous instruments
var NOOP_OBSERVABLE_COUNTER_METRIC = new NoopObservableCounterMetric();
var NOOP_OBSERVABLE_GAUGE_METRIC = new NoopObservableGaugeMetric();
var NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC = new NoopObservableUpDownCounterMetric();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var defaultTextMapGetter = {
    get: function (carrier, key) {
        if (carrier == null) {
            return undefined;
        }
        return carrier[key];
    },
    keys: function (carrier) {
        if (carrier == null) {
            return [];
        }
        return Object.keys(carrier);
    },
};
var defaultTextMapSetter = {
    set: function (carrier, key, value) {
        if (carrier == null) {
            return;
        }
        carrier[key] = value;
    },
};

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read$1 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$2 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var NoopContextManager = /** @class */ (function () {
    function NoopContextManager() {
    }
    NoopContextManager.prototype.active = function () {
        return ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function (_context, fn, thisArg) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return fn.call.apply(fn, __spreadArray$2([thisArg], __read$1(args), false));
    };
    NoopContextManager.prototype.bind = function (_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function () {
        return this;
    };
    NoopContextManager.prototype.disable = function () {
        return this;
    };
    return NoopContextManager;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$1 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var API_NAME$3 = 'context';
var NOOP_CONTEXT_MANAGER = new NoopContextManager();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */
var ContextAPI = /** @class */ (function () {
    /** Empty private constructor prevents end users from constructing a new instance of the API */
    function ContextAPI() {
    }
    /** Get the singleton instance of the Context API */
    ContextAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new ContextAPI();
        }
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */
    ContextAPI.prototype.setGlobalContextManager = function (contextManager) {
        return registerGlobal(API_NAME$3, contextManager, DiagAPI.instance());
    };
    /**
     * Get the currently active context
     */
    ContextAPI.prototype.active = function () {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */
    ContextAPI.prototype.with = function (context, fn, thisArg) {
        var _a;
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return (_a = this._getContextManager()).with.apply(_a, __spreadArray$1([context, fn, thisArg], __read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */
    ContextAPI.prototype.bind = function (context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function () {
        return getGlobal(API_NAME$3) || NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */
    ContextAPI.prototype.disable = function () {
        this._getContextManager().disable();
        unregisterGlobal(API_NAME$3, DiagAPI.instance());
    };
    return ContextAPI;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TraceFlags;
(function (TraceFlags) {
    /** Represents no flag set. */
    TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */
    TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INVALID_SPANID = '0000000000000000';
var INVALID_TRACEID = '00000000000000000000000000000000';
var INVALID_SPAN_CONTEXT = {
    traceId: INVALID_TRACEID,
    spanId: INVALID_SPANID,
    traceFlags: TraceFlags.NONE,
};

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */
var NonRecordingSpan = /** @class */ (function () {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) { _spanContext = INVALID_SPAN_CONTEXT; }
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function () {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function (_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function (_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function (_name, _attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function (_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function (_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function (_endTime) { };
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function () {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function (_exception, _time) { };
    return NonRecordingSpan;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * span key
 */
var SPAN_KEY = createContextKey('OpenTelemetry Context Key SPAN');
/**
 * Return the span if one exists
 *
 * @param context context to get span from
 */
function getSpan(context) {
    return context.getValue(SPAN_KEY) || undefined;
}
/**
 * Gets the span from the current context, if one exists.
 */
function getActiveSpan() {
    return getSpan(ContextAPI.getInstance().active());
}
/**
 * Set the span on a context
 *
 * @param context context to use as parent
 * @param span span to set active
 */
function setSpan(context, span) {
    return context.setValue(SPAN_KEY, span);
}
/**
 * Remove current span stored in the context
 *
 * @param context context to delete span from
 */
function deleteSpan(context) {
    return context.deleteValue(SPAN_KEY);
}
/**
 * Wrap span context in a NoopSpan and set as span in a new
 * context
 *
 * @param context context to set active span on
 * @param spanContext span context to be wrapped
 */
function setSpanContext(context, spanContext) {
    return setSpan(context, new NonRecordingSpan(spanContext));
}
/**
 * Get the span context of the span if it exists.
 *
 * @param context context to get values from
 */
function getSpanContext(context) {
    var _a;
    return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId(traceId) {
    return VALID_TRACEID_REGEX.test(traceId) && traceId !== INVALID_TRACEID;
}
function isValidSpanId(spanId) {
    return VALID_SPANID_REGEX.test(spanId) && spanId !== INVALID_SPANID;
}
/**
 * Returns true if this {@link SpanContext} is valid.
 * @return true if this {@link SpanContext} is valid.
 */
function isSpanContextValid(spanContext) {
    return (isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId));
}
/**
 * Wrap the given {@link SpanContext} in a new non-recording {@link Span}
 *
 * @param spanContext span context to be wrapped
 * @returns a new non-recording {@link Span} with the provided context
 */
function wrapSpanContext(spanContext) {
    return new NonRecordingSpan(spanContext);
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var contextApi = ContextAPI.getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */
var NoopTracer = /** @class */ (function () {
    function NoopTracer() {
    }
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function (name, options, context) {
        if (context === void 0) { context = contextApi.active(); }
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) {
            return new NonRecordingSpan();
        }
        var parentFromContext = context && getSpanContext(context);
        if (isSpanContext(parentFromContext) &&
            isSpanContextValid(parentFromContext)) {
            return new NonRecordingSpan(parentFromContext);
        }
        else {
            return new NonRecordingSpan();
        }
    };
    NoopTracer.prototype.startActiveSpan = function (name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) {
            return;
        }
        else if (arguments.length === 2) {
            fn = arg2;
        }
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        }
        else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = setSpan(parentContext, span);
        return contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}());
function isSpanContext(spanContext) {
    return (typeof spanContext === 'object' &&
        typeof spanContext['spanId'] === 'string' &&
        typeof spanContext['traceId'] === 'string' &&
        typeof spanContext['traceFlags'] === 'number');
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NOOP_TRACER = new NoopTracer();
/**
 * Proxy tracer provided by the proxy tracer provider
 */
var ProxyTracer = /** @class */ (function () {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function (name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function (_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */
    ProxyTracer.prototype._getTracer = function () {
        if (this._delegate) {
            return this._delegate;
        }
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) {
            return NOOP_TRACER;
        }
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */
var NoopTracerProvider = /** @class */ (function () {
    function NoopTracerProvider() {
    }
    NoopTracerProvider.prototype.getTracer = function (_name, _version, _options) {
        return new NoopTracer();
    };
    return NoopTracerProvider;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NOOP_TRACER_PROVIDER = new NoopTracerProvider();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */
var ProxyTracerProvider = /** @class */ (function () {
    function ProxyTracerProvider() {
    }
    /**
     * Get a {@link ProxyTracer}
     */
    ProxyTracerProvider.prototype.getTracer = function (name, version, options) {
        var _a;
        return ((_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new ProxyTracer(this, name, version, options));
    };
    ProxyTracerProvider.prototype.getDelegate = function () {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */
    ProxyTracerProvider.prototype.setDelegate = function (delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function (name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Entrypoint for context API */
var context = ContextAPI.getInstance();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Entrypoint for Diag API.
 * Defines Diagnostic handler used for internal diagnostic logging operations.
 * The default provides a Noop DiagLogger implementation which may be changed via the
 * diag.setLogger(logger: DiagLogger) function.
 */
var diag = DiagAPI.instance();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */
var NoopMeterProvider = /** @class */ (function () {
    function NoopMeterProvider() {
    }
    NoopMeterProvider.prototype.getMeter = function (_name, _version, _options) {
        return NOOP_METER;
    };
    return NoopMeterProvider;
}());
var NOOP_METER_PROVIDER = new NoopMeterProvider();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var API_NAME$2 = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */
var MetricsAPI = /** @class */ (function () {
    /** Empty private constructor prevents end users from constructing a new instance of the API */
    function MetricsAPI() {
    }
    /** Get the singleton instance of the Metrics API */
    MetricsAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new MetricsAPI();
        }
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */
    MetricsAPI.prototype.setGlobalMeterProvider = function (provider) {
        return registerGlobal(API_NAME$2, provider, DiagAPI.instance());
    };
    /**
     * Returns the global meter provider.
     */
    MetricsAPI.prototype.getMeterProvider = function () {
        return getGlobal(API_NAME$2) || NOOP_METER_PROVIDER;
    };
    /**
     * Returns a meter from the global meter provider.
     */
    MetricsAPI.prototype.getMeter = function (name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */
    MetricsAPI.prototype.disable = function () {
        unregisterGlobal(API_NAME$2, DiagAPI.instance());
    };
    return MetricsAPI;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Entrypoint for metrics API */
var metrics = MetricsAPI.getInstance();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * No-op implementations of {@link TextMapPropagator}.
 */
var NoopTextMapPropagator = /** @class */ (function () {
    function NoopTextMapPropagator() {
    }
    /** Noop inject function does nothing */
    NoopTextMapPropagator.prototype.inject = function (_context, _carrier) { };
    /** Noop extract function does nothing and returns the input context */
    NoopTextMapPropagator.prototype.extract = function (context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function () {
        return [];
    };
    return NoopTextMapPropagator;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Baggage key
 */
var BAGGAGE_KEY = createContextKey('OpenTelemetry Baggage Key');
/**
 * Retrieve the current baggage from the given context
 *
 * @param {Context} Context that manage all context values
 * @returns {Baggage} Extracted baggage from the context
 */
function getBaggage(context) {
    return context.getValue(BAGGAGE_KEY) || undefined;
}
/**
 * Retrieve the current baggage from the active/current context
 *
 * @returns {Baggage} Extracted baggage from the context
 */
function getActiveBaggage() {
    return getBaggage(ContextAPI.getInstance().active());
}
/**
 * Store a baggage in the given context
 *
 * @param {Context} Context that manage all context values
 * @param {Baggage} baggage that will be set in the actual context
 */
function setBaggage(context, baggage) {
    return context.setValue(BAGGAGE_KEY, baggage);
}
/**
 * Delete the baggage stored in the given context
 *
 * @param {Context} Context that manage all context values
 */
function deleteBaggage(context) {
    return context.deleteValue(BAGGAGE_KEY);
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var API_NAME$1 = 'propagation';
var NOOP_TEXT_MAP_PROPAGATOR = new NoopTextMapPropagator();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */
var PropagationAPI = /** @class */ (function () {
    /** Empty private constructor prevents end users from constructing a new instance of the API */
    function PropagationAPI() {
        this.createBaggage = createBaggage;
        this.getBaggage = getBaggage;
        this.getActiveBaggage = getActiveBaggage;
        this.setBaggage = setBaggage;
        this.deleteBaggage = deleteBaggage;
    }
    /** Get the singleton instance of the Propagator API */
    PropagationAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new PropagationAPI();
        }
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */
    PropagationAPI.prototype.setGlobalPropagator = function (propagator) {
        return registerGlobal(API_NAME$1, propagator, DiagAPI.instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */
    PropagationAPI.prototype.inject = function (context, carrier, setter) {
        if (setter === void 0) { setter = defaultTextMapSetter; }
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */
    PropagationAPI.prototype.extract = function (context, carrier, getter) {
        if (getter === void 0) { getter = defaultTextMapGetter; }
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */
    PropagationAPI.prototype.fields = function () {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */
    PropagationAPI.prototype.disable = function () {
        unregisterGlobal(API_NAME$1, DiagAPI.instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function () {
        return getGlobal(API_NAME$1) || NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Entrypoint for propagation API */
var propagation = PropagationAPI.getInstance();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */
var TraceAPI = /** @class */ (function () {
    /** Empty private constructor prevents end users from constructing a new instance of the API */
    function TraceAPI() {
        this._proxyTracerProvider = new ProxyTracerProvider();
        this.wrapSpanContext = wrapSpanContext;
        this.isSpanContextValid = isSpanContextValid;
        this.deleteSpan = deleteSpan;
        this.getSpan = getSpan;
        this.getActiveSpan = getActiveSpan;
        this.getSpanContext = getSpanContext;
        this.setSpan = setSpan;
        this.setSpanContext = setSpanContext;
    }
    /** Get the singleton instance of the Trace API */
    TraceAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new TraceAPI();
        }
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */
    TraceAPI.prototype.setGlobalTracerProvider = function (provider) {
        var success = registerGlobal(API_NAME, this._proxyTracerProvider, DiagAPI.instance());
        if (success) {
            this._proxyTracerProvider.setDelegate(provider);
        }
        return success;
    };
    /**
     * Returns the global tracer provider.
     */
    TraceAPI.prototype.getTracerProvider = function () {
        return getGlobal(API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */
    TraceAPI.prototype.getTracer = function (name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */
    TraceAPI.prototype.disable = function () {
        unregisterGlobal(API_NAME, DiagAPI.instance());
        this._proxyTracerProvider = new ProxyTracerProvider();
    };
    return TraceAPI;
}());

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Entrypoint for trace API */
var trace$1 = TraceAPI.getInstance();

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Default export.
var opentelemetry = {
    context: context,
    diag: diag,
    metrics: metrics,
    propagation: propagation,
    trace: trace$1,
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Decorator for capturing the class name that is included in the span name
 * We are unable to directly fetch the class name from the target due to minification of code
 * @param className - The name of the class.
 * @returns The decorated constructor.
 */
function traceableAs(className) {
    return function (constructor) {
        constructor.traceableAs = () => { return className; };
    };
}
/**
 * Decorator for instrumenting a method for emitting tracing spans and events.
 * @param target - The class or prototype of the class.
 * @param propertyKey - The name of the method.
 * @param descriptor - The property descriptor for the method.
 * @returns The decorated method.
 * @remarks ensure that OTel SDK version is compatible with OTel API that SAM.js depends on.
 */
function trace(target, propertyKey, descriptor) {
    var _a;
    let targetConstructor = undefined;
    if (typeof target === 'function' && ((_a = target.prototype) === null || _a === void 0 ? void 0 : _a.constructor)) {
        // target is a class
        targetConstructor = target.prototype.constructor;
    }
    else if (typeof target === 'object' && target.constructor) {
        // target is a class instance
        targetConstructor = target.constructor;
    }
    const method = descriptor.value;
    descriptor.value = function (...args) {
        let spanName = propertyKey;
        if (targetConstructor) {
            let className;
            if (typeof targetConstructor.traceableAs === 'function') {
                // If the class has a static method traceableAs, use it
                className = targetConstructor.traceableAs();
            }
            else {
                // Otherwise, fall back to the class name, which might be mangled by minifiers
                oneTimeWarning('Class name not provided', `Use the traceableAs decorator on the class of ${spanName} to ensure the class name does not get minified`);
                className = targetConstructor.name;
            }
            spanName = className + '.' + spanName;
        }
        const tracer = opentelemetry.trace.getTracer('sam-js');
        const span = tracer.startSpan(spanName);
        const ctx = opentelemetry.trace.setSpan(opentelemetry.context.active(), span);
        try {
            const result = opentelemetry.context.with(ctx, method, this, ...args);
            // Checking whether result is a JS Promise
            if (!!result && typeof result.then === 'function') {
                return result.catch((e) => {
                    if (e instanceof Error) {
                        span.recordException(e);
                    }
                    throw e;
                }).finally(() => {
                    span.end();
                });
            }
            else {
                span.end();
                return result;
            }
        }
        catch (e) {
            if (e instanceof Error) {
                span.recordException(e);
            }
            span.end();
            throw e;
        }
    };
    return descriptor;
}
/**
 * Sets an attribute on the active tracing span.
 * @param key - Tracing span attribute key.
 * @param value - Tracing span attribute value.
 */
function setTracingSpanAttribute(key, value) {
    var _a;
    (_a = opentelemetry.trace.getActiveSpan()) === null || _a === void 0 ? void 0 : _a.setAttribute(key, value || '');
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
let ClassroomContext = class ClassroomContext {
    constructor(_core, _assetPool) {
        this._core = _core;
        this._assetPool = _assetPool;
        this._assignmentInterface = new AssignmentsInterface(this._core);
        this._classroomsInterface = new ClassroomsInterface(this._core);
        this._studentAssignmentsInterface = new StudentAssignmentsInterface(this._core);
        this._studentAssignmentFileUpdater = StudentAssignmentFileUpdater;
        this._studentAssignmentUpdater = StudentAssignmentUpdater;
        this._assignmentUpdater = AssignmentUpdater;
        /**
         * @package -- for SAM.js internal use only
         */
        this._classroomPool = new ItemPool(this._core, 'classroom');
        /**
         * @package -- for SAM.js internal use only
         */
        this._classroomMemberPool = new ItemPool(this._core, 'classroomMember');
        this._core.getBoardContext().then((boardContext) => {
            this._boardContext = boardContext;
        });
    }
    /**
     * Ensures that the board context has been fetched before using it
     * @throws {Error} if the board context is not initialized
     */
    _ensureBoardContext() {
        if (!this._boardContext) {
            throw new Error('Board context not initialized');
        }
        return this._boardContext;
    }
    /**
     * @deprecated Use _core._getAssetPool(). Will be removed in ACPCEDU-3388.
     *
     * @package -- for SAM.js internal use only
     */
    get assignmentPool() {
        return this._assetPool;
    }
    /**
     * @description Gets a classroom with the given class ID.
     *
     * @param id The classroom ID (ex: '123@AdobeOrg')
     *
     * @example <caption>Fetch a classroom by ID</caption>
     * const classroom: Classroom = await classroomContext.getClassroomById('123@AdobeOrg');
     */
    async getClassroomById(id) {
        validateString(id, 'id');
        const classroomInterface = this._classroomsInterface;
        const pool = this._classroomPool;
        let classroom = pool.getLocalItemById(id);
        if (!classroom) {
            // Note that we don't have a local classroom, so we don't have to worry about eventual consistency on this item.
            const response = await classroomInterface.getClassroom(id);
            const session = pool.createUpdateSession();
            classroom = ClassroomUpdater.updateRemoteItem(session, this._processRemoteClassroomItem(id, response));
            session.commit();
        }
        return classroom;
    }
    /**
     * @description Gets a classroom with the given class code. Typically, using getClassroomById is preferred.
     *
     * @param classCode The classroom code (ex: 'ABCDEF')
     *
     * @example <caption>Fetch a classroom by ID</caption>
     * const classroom: Classroom = await classroomContext.getClassroomByCode('ABCDEF');
     */
    async getClassroomByCode(classCode) {
        validateString(classCode, 'classCode');
        // Check if the classroom is cached already
        // Since getLocalItemById only supports the primary ID,
        // not the code, iterate through the cached list
        const classroom = this._classroomPool.toArray().find((classroom) => classroom.code === classCode);
        if (classroom) {
            return classroom;
        }
        // The interface passes to ID or CODE through the same endpoint and param.
        return this.getClassroomById(classCode);
    }
    /**
     * @description Gets the list of Classrooms that this user has access to
     *
     * @example <caption>Get all Classrooms as an array</caption>
     * const classroomsList: IItemList<ClassroomConfig> = classroomContext.getClassrooms().getList(ClassroomOrder.default);
     * await waitForListLoad(classroomsList);
     * const classroomItems: Classroom[] = classroomsList.items;
     */
    getClassrooms() {
        return new ItemSource(this._classroomPool, [new ClassroomListLoader(this._classroomPool, this._classroomsInterface)]);
    }
    /**
     * Gets a list of Classroom Members. Use a ClassroomMemberFilter on the resulting getList call to filter down to a specific classroom / role.
     *
     * @example <caption>Get all Members of all Classrooms</caption>
     * const memberList: IItemList<ClassroomMemberConfig> = classroomContext.getClassroomMembers().getList(ClassroomMemberOrder.default);
     * await waitForListLoad(memberList);
     * const members: ClassroomMember[] = memberList.items;
     *
     * @example <caption>Get all Students in a single Classroom</caption>
     * const memberList: IItemList<ClassroomMemberConfig> = classroomContext.getClassroomMembers().getList(ClassroomMemberOrder.default, new ClassroomMemberFilter({ role: ClassroomMemberRole.STUDENT, classroomId: '123@AdobeOrg' }));
     * await waitForListLoad(memberList);
     * const members: ClassroomMember[] = memberList.items;
     */
    getClassroomMembers() {
        return new ItemSource(this._classroomMemberPool, [new ClassroomMemberListLoader(this._classroomMemberPool, this._classroomsInterface)]);
    }
    /**
     * Get a list of Assignments
     *
     * @example <caption>Get all Assignments</caption>
     * const assignmentsList = classroomContext.getAssignments().getList(AssignmentOrder.default);
     * await waitForListLoad(assignmentsList);
     * const assignments: Assignment[] = assignmentsList.items;
     *
     * @example <caption>Get all Assignments from a single Classrooms</caption>
     * const assignmentsList = classroomContext.getAssignments().getList(AssignmentOrder.default, new AssignmentFilter({ classroomId: '123@AdobeOrg' }));
     * await waitForListLoad(assignmentsList);
     * const assignments: Assignment[] = assignmentsList.items;
     *
     * @example <caption>Get all Assignments from a single Classrooms that the current user created</caption>
     * const assignmentsList = classroomContext.getAssignments().getList(AssignmentOrder.default, new AssignmentFilter({
     *  classroomId: '123@AdobeOrg',
     *  submissions: AssignmentSubmissionOwnershipEnums.SELF
     * }));
     * await waitForListLoad(assignmentsList);
     * const assignments: Assignment[] = assignmentsList.items;
     */
    getAssignments() {
        const loader = new AssignmentsListLoader(this._assignmentInterface, this._core);
        return new ItemSource(this._assetPool, [loader]);
    }
    /**
     * Gets the ItemSource for all StudentAssignments in the pool
     * @package -- for SAM.js internal use only
     */
    _getStudentAssignmentsSource(implicitFilter) {
        const loader = new StudentAssignmentListLoader(this._studentAssignmentsInterface, this._core);
        return new ItemSource(this._assetPool, [loader], implicitFilter);
    }
    /**
     * @description Gets all of the Student Assignments. Can be used to fetch the StudentAssignments for a single Assignment through ID or Code.
     *
     * @param [options] The optional parameter contains the assignmentId or assignmentCode to filter the StudentAssignments by. Will be made required in ACPCEDU-2702.
     * TODO [ACPCEDU-2702]: options will be made required in the future
     *
     * @example <caption>Fetch all Student Assignments for a given Assignment with an ID</caption>
     * const studentAssignmentsList = classroomContext.getStudentAssignments().getList(StudentAssignmentOrder.default, new StudentAssignmentFilter({ assignmentId: 'urn:aaid:sc:VA6C2:123456' }));
     * await waitForListLoad(studentAssignmentsList);
     * const studentAssignments: StudentAssignment[] = studentAssignmentsList.items;
     *
     * @example <caption>Fetch all Student Assignments for a given Assignment with a Code</caption>
     * const classroomContext = samCore.classroomContext;
     * const assignmentsSource = classroomContext.getStudentAssignments();
     * const studentAssignments = await assignmentsSource.getList(StudentAssignmentOrder.default, new StudentAssignmentFilter({ assignmentCode: 'WXYZ' }));
     */
    getStudentAssignments(options) {
        return this._getStudentAssignmentsSource(new ImplicitStudentAssignmentFilter(options));
    }
    cleanAssignmentName(name) {
        return name.trimEnd();
    }
    /**
     * Creates a new Classroom
     * @param data creation data (e.g. name, grade etc)
     * @throws {SAMError} If the data is invalid or the classroom cannot be created
     *
     * @example <caption>Create a new Classroom</caption>
     * const classroom: Classroom = await classroomContext.createClassroom({
     *  name: 'My Classroom',
     *  grades: ['K', '1'],
     *  subject: 'math',
     * });
     */
    async createClassroom(data) {
        var _a;
        const classroomValidationErrors = validateClassroomData(data);
        if (classroomValidationErrors.length > 0) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, JSON.stringify(classroomValidationErrors));
        }
        let response;
        // Class is being created from a virtual classroom
        if (data.id) {
            response = await this._classroomsInterface.createClassroomFromVirtual(data.id);
            // Preserve the old original identifier for the class to re-index the existing item under its preferred id
            response.virtualId = data.id;
        }
        else {
            const className = ((_a = data.name) === null || _a === void 0 ? void 0 : _a.trim()) || '';
            if (!validatePlatformRepoName(className)) {
                // Validate the name here to avoid resolving the asset if the name is invalid.
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid class name provided for the creation operation.');
            }
            response = await this._classroomsInterface.createClassroom(Object.assign(Object.assign({}, data), { name: className }));
        }
        // Cache new classroom
        const session = this._classroomPool.createMutationSession();
        const classroom = ClassroomUpdater.updateRemoteItem(session, response);
        session.commit();
        return classroom;
    }
    /**
     * Creates a new Assignment
     * @param data creation data (e.g. title, instructions, etc)
     * @throws {SAMError} If the data is invalid or the assignment cannot be created
     *
     * @example <caption>Create a new Assignment</caption>
     * const assignment: Assignment = await classroomContext.createAssignment({
     *  name: 'My Assignment',
     *  classroomId: '123@AdobeOrg',
     *  instructions: 'Do this and that',
     *  tasks: ['poster']
     * });
     */
    async createAssignment(data) {
        const assignmentValidateErrors = validateAssignmentData(data);
        if (assignmentValidateErrors.length > 0) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, JSON.stringify(assignmentValidateErrors));
        }
        const trimmedName = this.cleanAssignmentName(data.name);
        if (!validatePlatformRepoName(trimmedName)) {
            // Validate the name here to avoid resolving the asset if the name is invalid.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for the creation operation.');
        }
        let classroomId = data.classroomId;
        // See if the class ID given maps to a virtual class that has already been migrated recently
        // if not fetch the classroom and see if it is virtual which requires migrating the class to
        // a real class before an assignment can be created for it
        const recentMigratedClassroom = this._classroomPool.toArray().find((classroom) => classroom._virtualId === data.classroomId);
        if (recentMigratedClassroom) {
            classroomId = recentMigratedClassroom.id;
        }
        else {
            // Class that maps to given ID has not been migrated recently so fetch and see if it maps to a virtual class
            const classroom = await this.getClassroomById(data.classroomId);
            if (classroom.isVirtual) {
                const migratedClassroom = await this.createClassroom({ id: classroom.id });
                classroomId = migratedClassroom.id;
                // Check if the virtual class is still being referenced if so throw an error
                // The newly created real class is what is expected to be returned
                if (classroomId === data.classroomId) {
                    throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Cannot create an assignment with a virtual classroom.');
                }
            }
        }
        // We will not create the assignment with the incoming template IDs
        // Instead updateAssignment() will clone them and save new asset IDs to this assignment
        const { templateIds, references } = data, createData = __rest$2(data, ["templateIds", "references"]);
        createData.name = trimmedName;
        const incomingTemplateIds = templateIds !== null && templateIds !== void 0 ? templateIds : [];
        const incomingReferences = references !== null && references !== void 0 ? references : [];
        const hasMaterials = incomingTemplateIds.length + incomingReferences.length > 0;
        const status = createData.status || AssignmentStatus.DRAFT;
        let assignment = this._findAssignment(classroomId, trimmedName);
        const alreadyCreated = !!assignment;
        if (!assignment) {
            // If the assignment has materials, it should be created as a draft
            // and only be assigned when the materials are copied
            if (!hasProperty(createData, 'status') || hasMaterials) {
                createData.status = AssignmentStatus.DRAFT;
            }
            const response = await this._assignmentInterface.createAssignment(Object.assign(Object.assign({}, createData), { classroomId }));
            const session = this._assetPool.createMutationSession();
            assignment = AssignmentUpdater.updateRemoteItem(session, response);
            // Commit the session to ensure the assignment is available in the pool even if the updateAssignment() call fails.
            session.commit();
        }
        const materialsUpdateData = {};
        if (incomingTemplateIds.length > 0) {
            materialsUpdateData.templateIds = incomingTemplateIds;
        }
        if (incomingReferences.length > 0) {
            materialsUpdateData.references = incomingReferences;
        }
        // Only update with materials or if the assignment had already been created. Other data is able to
        // be assigned on creation but it may now be updated.
        if (hasMaterials || alreadyCreated) {
            try {
                await this.updateAssignment(assignment.id, Object.assign(Object.assign(Object.assign({}, materialsUpdateData), (alreadyCreated ? Object.assign(Object.assign({}, createData), { name: undefined }) : {})), { status }));
            }
            catch (error) {
                throw SAMError.wrapErrorIfNeeded(SAMErrorCode.INTERNAL_ERROR, 'Error updating assignment materials', error);
            }
        }
        return assignment;
    }
    /**
     * Finds an assignment in the asset pool
     * @param classroomId The classroom ID of the assignment
     * @param assignmentName The name of the assignment
     * @returns The assignment if found, otherwise undefined
     * @package Only for use in SAM.js
     */
    _findAssignment(classroomId, assignmentName) {
        return this._assetPool.toArray().find((item) => item instanceof Assignment
            && item.classroomId === classroomId
            && item.name === assignmentName);
    }
    /**
     * Assigns a draft assignment to each member of the classroom
     * @throws {SAMError} If the assignment cannot be found
     * @deprecated Calls to this function should be replaced with `updateAssignment(assignmentId, { status: AssignmentStatus.ASSIGNED })`
     * This property will be removed on or after 2025-4-1 in ACPCEDU-3388
     *
     * @param assignmentId ID of assignment to assign
     * @package Only for use in SAM.js
     */
    async _assignAssignment(assignmentId) {
        const assignment = this._assetPool.getLocalItemById(assignmentId);
        if (!assignment) {
            throw SAMError.create(SAMErrorCode.NOT_FOUND, `Could not find assignment to assign with ID of "${assignmentId}"`);
        }
        return this.updateAssignment(assignmentId, { status: AssignmentStatus.ASSIGNED });
    }
    /**
     * Gets a Assignment with the given ID.
     *
     * @note in the near future, we can call to check the access to this assignment given by an ID.
     *
     * @param id ID of the Assignment
     * @param data The data necessary to fetch correct assignments
     *
     * @example <caption>Fetch an Assignment by ID, fetching only the current user's StudentAssignments</caption>
     * const assignment: Assignment = await classroomContext.getAssignmentByID('urn:aaid:sc:VA6C2:123456', AssignmentSubmissionOwnershipEnums.SELF);
     *
     * @example <caption>Fetch an Assignment by ID, fetching all child StudentAssignments for all users. The classroomID must be passed in for this case. This will only work when called from a teacher's session.</caption>
     * const assignment: Assignment = await classroomContext.getAssignmentByID('urn:aaid:sc:VA6C2:123456', AssignmentSubmissionOwnershipEnums.ANY, '123@AdobeOrg');
     */
    async getAssignmentByID(id, submissions, classroomId) {
        validateString(id, 'id');
        if (classroomId) {
            validateString(classroomId, 'classroomId');
        }
        let assignment = this._assetPool.getLocalItemById(id);
        if (assignment) {
            return assignment;
        }
        const submissionsType = await this.validateStudentAssignmentsFilter(submissions, classroomId);
        const assignmentMetadata = await this._assignmentInterface.getAssignment(id, submissionsType);
        const session = this._assetPool.createMutationSession();
        assignment = AssignmentUpdater.updateRemoteItem(session, assignmentMetadata);
        session.commit();
        return assignment;
    }
    /**
     * This function gets an assignment by its code.
     *
     * @param code Code used to fetch assignment
     *
     * @example <caption>Fetch an Assignment by ID, fetching only the current user's StudentAssignments</caption>
     * const assignment: Assignment = await classroomContext.getAssignmentByCode('ABCDEF', AssignmentSubmissionOwnershipEnums.SELF);
     *
     * @example <caption>Fetch an Assignment by ID, fetching all child StudentAssignments for all users. The classroomID must be passed in for this case. This will only work when called from a teacher's session.</caption>
     * const assignment: Assignment = await classroomContext.getAssignmentByCode('ABCDEF', AssignmentSubmissionOwnershipEnums.ANY, '123@AdobeOrg');
     */
    async getAssignmentByCode(code, submissions, classroomId) {
        validateString(code, 'code');
        if (classroomId) {
            validateString(classroomId, 'classroomId');
        }
        // Check if the assignment is cached already
        // Since getLocalItemById only supports the primary ID,
        // not the code, iterate through the cached list
        let assignment = this._assetPool.toArray().find((assignment) => assignment.code === code);
        if (assignment) {
            return assignment;
        }
        const submissionsType = await this.validateStudentAssignmentsFilter(submissions, classroomId);
        const assignmentMetadata = await this._assignmentInterface.getAssignmentByCode(code, submissionsType);
        const session = this._assetPool.createMutationSession();
        assignment = AssignmentUpdater.updateRemoteItem(session, assignmentMetadata);
        session.commit();
        return assignment;
    }
    /**
     * @description Gets a student assignment with the given student assignment ID.
     * This function is not expected to call with the ID of not-started student assignment since it has no real asset ID.
     * If loadDocuments is enabled, the student assignment files will only be fetched IF the student assignment is NOT cached.
     * Otherwise the files will be lazy loaded when the client calls studentAssignment.files.getList(...)
     *
     * @param id of the student assignment that is being fetched
     *
     * @example <caption>Get a StudentAssignment by ID</caption>
     * const studentAssignment: StudentAssignment = await classroomContext.getStudentAssignmentById('urn:aaid:sc:VA6C2:123456:789');
     *
     * @example <caption>Get a StudentAssignment with the student assignment files loaded</caption>
     * const studentAssignment: StudentAssignment = await classroomContext.getStudentAssignmentById('urn:aaid:sc:VA6C2:123456:789', {loadDocuments: true});
     */
    async getStudentAssignmentById(studentAssignmentId, options) {
        var _a;
        const cachedStudentAssignment = this._assetPool.getLocalItemById(studentAssignmentId);
        if (cachedStudentAssignment) {
            return cachedStudentAssignment;
        }
        const studentAssignmentMetadata = await this._studentAssignmentsInterface.getStudentAssignment(studentAssignmentId, options);
        const session = this._assetPool.createMutationSession();
        const studentAssignment = StudentAssignmentUpdater.updateRemoteItem(session, studentAssignmentMetadata);
        studentAssignment._hasLoadedChildren = (_a = options === null || options === void 0 ? void 0 : options.loadDocuments) !== null && _a !== void 0 ? _a : false;
        session.commit();
        return studentAssignment;
    }
    /**
     * Discards the given assignment
     * This assignment will be eligible to be restored or permanentlyDeleted from this state
     * @param assignment Assignment to be discarded
     * @package Only for use in SAM.js
     */
    async _discardAssignment(assignment) {
        await assignment.discard();
    }
    /**
     * Restores the given assignment
     * @param assignment Assignment to be restored
     * @package Only for use in SAM.js
     */
    async _restoreAssignment(assignment) {
        await assignment.restore();
    }
    /**
     * Update the computedStudentAssignmentId of the remote student assignment files
     * @param remoteStudentAssignmentFiles The remote student assignment files to update the computedStudentAssignmentId with
     * @param studentAssignmentId The student assignment ID to update the remote student assignment files with
     * @package Only for use in SAM.js
     */
    _computeRemoteStudentAssignmentFiles({ assignmentId, classroomId, remoteStudentAssignmentFiles, studentAssignmentId }) {
        const remoteStudentAssignmentFilesWithComputedValues = [...remoteStudentAssignmentFiles];
        // attach the parent ID (Student assignment ID) to each file
        return remoteStudentAssignmentFilesWithComputedValues.map((remoteStudentAssignmentFileWithComputedValues) => {
            remoteStudentAssignmentFileWithComputedValues.computedStudentAssignmentId = studentAssignmentId;
            remoteStudentAssignmentFileWithComputedValues.computedAssignmentId = assignmentId;
            if (classroomId) {
                if (!classroomId.startsWith('urn')) {
                    // If this is hit, it is likely that the classroom primary ID,
                    // its org ID, is being passed in which is NOT the asset ID
                    throw SAMError.create(SAMErrorCode.BAD_REQUEST, `The classroomId provided, ${classroomId}, is NOT an asset ID`);
                }
                remoteStudentAssignmentFileWithComputedValues.computedClassroomAssetId = classroomId;
            }
            return remoteStudentAssignmentFileWithComputedValues;
        });
    }
    /**
     * Update the student assignment files cache given the remote student assignment files
     * @param remoteStudentAssignmentFiles The remote student assignment files to update the cache with
     * @param studentAssignment The student assignment to update the cache with
     * @package Only for use in SAM.js
     */
    _updateStudentAssignmentFilesCache({ assignmentId, classroomId, remoteStudentAssignmentFiles, session, studentAssignmentId }) {
        const remoteStudentAssignmentFilesWithComputedValues = this._computeRemoteStudentAssignmentFiles({ remoteStudentAssignmentFiles, assignmentId, classroomId, studentAssignmentId });
        const files = StudentAssignmentFileUpdater.updateRemoteItems(session, remoteStudentAssignmentFilesWithComputedValues);
        session.commit();
        return files;
    }
    /**
     * Returns a StudentAssignment.
     * @param data The data necessary to return the assignment.
     * @package Only for use in SAM.js
     */
    async _returnAssignment(data) {
        const remoteStudentAssignment = await this._studentAssignmentsInterface.return(data);
        // no need to provide assignmentID since the student work directory ID / repo ID is already provided
        const session = this._assetPool.createMutationSession();
        const studentAssignment = StudentAssignmentUpdater.updateRemoteItem(session, remoteStudentAssignment);
        session.commit();
        return studentAssignment;
    }
    /**
     * Starts a StudentAssignment.
     * @param data The data necessary to start the assignment.
     * @package Only for use in SAM.js
     */
    async _startAssignment(data) {
        const remoteStudentAssignment = await this._studentAssignmentsInterface.start(data);
        const session = this._assetPool.createMutationSession();
        const studentAssignment = StudentAssignmentUpdater.updateRemoteItem(session, remoteStudentAssignment);
        session.commit();
        return studentAssignment;
    }
    /**
     * Submits a StudentAssignment.
     * @param data The data necessary to submit the assignment.
     * @throws {SAMError} if the studentAssignmentId or assignmentId is not provided, or if the current user does not have write permission to the submission file when the file needs to be moved.
     * @deprecated Use `StudentAssignment.submit` instead
     * This property will be removed on or after 2025-7-1 in ACPCEDU-3393
     *
     * @example <caption>Submit an assignment by StudentAssignment ID</caption>
     * const studentAssignment: StudentAssignment = await classroomContext.submitAssignment({ studentAssignmentId: 'urn:aaid:sc:VA6C2:123456:789', submissionId: 'urn:aaid:sc:VA6C2:123456:789:submission' });
     */
    async submitAssignment(data) {
        const { assignmentId, status, studentAssignmentId, submissionId } = data;
        const validAssignmentId = validateString(assignmentId, 'assignmentId', false);
        // studentAssignmentId may be undefined (when NOT_STARTED) but otherwise must be valid.
        const validStudentAssignmentId = (validAssignmentId && studentAssignmentId === undefined)
            || validateString(studentAssignmentId, 'studentAssignmentId', false);
        if (!validAssignmentId && !validStudentAssignmentId) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Either studentAssignmentId or assignmentId is required to submit an assignment');
        }
        if (!validAssignmentId && status === StudentAssignmentStatus.NOT_STARTED) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'assignmentId is required when the assignment has not been started');
        }
        // Check the provided studentAssignmentId rather than the validStudentAssignmentId because while
        // validStudentAssignmentId can be true even when missing due to assignemtId being provided, it will
        // be an error condition if status is also not provided.
        if ((!studentAssignmentId && status && status !== StudentAssignmentStatus.NOT_STARTED)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'studentAssignmentId is required once the assignment has been started');
        }
        let studentAssignment;
        if (!status || status !== StudentAssignmentStatus.NOT_STARTED) {
            if (!studentAssignmentId) {
                // [ACPCEDU-4043]: Example of a place to add a try/catch block to handle errors when fetching the assignment.
                const assignment = await this.getAssignmentByID(assignmentId, AssignmentSubmissionOwnershipEnums.SELF);
                // It is ok to assume the first studentAssignment is available since the student is the one
                // submitting the assignment and SELF ownership was requested.
                studentAssignment = assignment.studentAssignments[0];
                // The original implementation was unable to start an assignment. In order to be consistent with the original
                // if not given a studentAssignmentId and it is determined that the assignment is not started, throw an error.
                // In the original the error would have been BAD_REQUEST: "Missing link for relationship type: <url>/rel/submit"
                // but the message is now more descriptive.
                if (studentAssignment.status === StudentAssignmentStatus.NOT_STARTED) {
                    throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'studentAssignmentId is required once the assignment has been started');
                }
            }
            else {
                studentAssignment = await this.getStudentAssignmentById(studentAssignmentId);
            }
        }
        else {
            studentAssignment = await this._startAssignment({
                assignmentId: assignmentId,
                links: data.links,
            });
        }
        const submittedAsset = await this._core.hostAssetContext.getAssetWithCloudID(submissionId);
        // If the submittedAsset is not already in the studentAssignment directory, it is a floating file and needs moved.
        // [ACPCEDU-4042]: Performance optimization to skip fetching children if we know the assignment was just started.
        if (await this._isFloating(studentAssignment, submittedAsset)) {
            // Intention is to move the file, check write permission.
            // Three cases to throw errors here
            // 1. Student does not have move and / or write permission on the submitted asset, so it will fail the subsequent move call if we don't throw an error opportunistically
            // 2. Catches a potential error when getting the parent asset, if the user does not have permission to get that asset.
            // 3. Source parent asset does not have write permission
            if (!submittedAsset.hasPermission(Permission.Move) || !submittedAsset.hasPermission(Permission.Write)) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Current user does not have permission to move and / or submit this asset: ${submittedAsset.id}`);
            }
            let parentAsset, parentRepoPath;
            try {
                parentRepoPath = submittedAsset.repoPath.substring(0, submittedAsset.repoPath.lastIndexOf('/'));
                // If this call results in an error, we want to throw a more specific error message
                parentAsset = await this._core.hostAssetContext.getAssetWithRepoPath(parentRepoPath, submittedAsset.repositoryID);
            }
            catch (error) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Unable to fetch the parent asset of the file being submitted using the path ${parentRepoPath}: ${error}`);
            }
            if (!parentAsset.hasPermission(Permission.Write)) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Current user is trying to submit an assignment from a folder that they do not have write permission on -- directory ID: ${parentAsset.id}`);
            }
            // Match date formatting when submitting an assignment
            const formattedDate = this._getFormattedCreatedDateHelper({ includeFormattedDate: false, date: new Date() });
            const assignment = await this.getAssignmentByID(assignmentId);
            const updatedName = `${studentAssignment.student.displayName} ${assignment.name} ${formattedDate}.${submittedAsset.extension}`;
            // Naming collision will not be a problem, move will rename the file to a unique name if needed
            await submittedAsset.move(studentAssignment, updatedName);
        }
        const { studentDirectoryId } = studentAssignment;
        const remoteStudentAssignment = await this._studentAssignmentsInterface.submit({
            links: studentAssignment.links,
            studentAssignmentId: studentDirectoryId,
            submissionId,
        });
        const session = this._assetPool.createMutationSession();
        StudentAssignmentUpdater.updateRemoteItem(session, remoteStudentAssignment);
        session.commit();
        return remoteStudentAssignment;
    }
    /**
     * Function to determine if a submitted file is floating; that is a file that is not currently within the student's assignment directory.
     * @param studentAssignment The StudentAssignment object being submitted.
     * @param submissionId The ID of the asset being submitted for the assignment.
     */
    async _isFloating(studentAssignment, submittedAsset) {
        var _a;
        // If the submitted asset's parent matches the student assignment, the file is not floating.
        if (submittedAsset.isChildOfStudentAssignment) {
            if (submittedAsset.parentStudentAssignmentId !== studentAssignment.id) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Submitted asset is already in a different assignment directory and has been submitted to another assignment -- directory ID: ${submittedAsset.parentStudentAssignmentId}, attempted to turn in to: ${studentAssignment.id}`);
            }
            return false;
        }
        // Fallback to looking in the student assignment's directory for the asset that was submitted; when it is not in the list
        // then the file is floating.
        try {
            const list = (_a = studentAssignment.children) === null || _a === void 0 ? void 0 : _a.getList(AdobeAssetOrder.default);
            if (list) {
                await waitForListLoad(list);
                return !list.items.some(asset => asset.id === submittedAsset.id);
            }
        }
        catch (error) {
            // We would not expect an error from the list load call here so this is a temporary precaution to help with debugging.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Error waiting for list load in floating file check: ${error}`);
        }
        return true; // This is a floating file because parent ID doesn't match and there are no files in the assignment directory.
    }
    /**
     * Function to update a StudentAssignmentFile
     * @throws {SAMError} if the deprecated interface is used alongside preferred interface
     *
     * @param studentAssignmentFile StudentAssignmentFile that will be updated. Either the object or the ID can be passed.
     * @param data Data to update the file with. Note that sourceAsset/sourceAssets OR sourceTasks are allowed, but not both in one update call.
     *
     * @example <caption>Link asset to an existing StudentAssignmentFile</caption>
     * const updatedStudentAssignmentFile: StudentAssignmentFile = await classroomContext.updateStudentAssignmentFile(studentAssignmentFile, { sourceAsset: {'repo:assetId': 'urn:mock-id'} });
     *
     * @example <caption>Add new tasks to an existing StudentAssignmentFile by ID</caption>
     * const updatedStudentAssignmentFile: StudentAssignmentFile = await classroomContext.updateStudentAssignmentFile('saf-ID', { sourceTasks: ['poster'] });
     */
    async updateStudentAssignmentFile(studentAssignmentFile, data) {
        var _a, _b, _c, _d, _e, _f;
        // Ensure clients are not using a mix of the deprecated interface (as of ACPCEDU-2214) and the preferred interface
        // Remove support of deprecated interface in this function and relevant unit tests once all clients have migrated to the preferred interface
        const isUsingPreferredInterface = data.sourceAsset || data.sourceTasks || data.sourceTutorials;
        const isUsingDeprecatedInterface = data.sourceAssets || data['assignment:sourceAssets'] || data['assignment:sourceTasks'] || data['assignment:sourceTutorials'];
        if (isUsingPreferredInterface && isUsingDeprecatedInterface) {
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, 'Do not use the deprecated interface.');
        }
        const sourceAssets = (_b = (_a = data.sourceAssets) !== null && _a !== void 0 ? _a : data['assignment:sourceAssets']) !== null && _b !== void 0 ? _b : [];
        const sourceTasks = (_d = (_c = data.sourceTasks) !== null && _c !== void 0 ? _c : data['assignment:sourceTasks']) !== null && _d !== void 0 ? _d : [];
        const sourceTutorials = (_f = (_e = data.sourceTutorials) !== null && _e !== void 0 ? _e : data['assignment:sourceTutorials']) !== null && _f !== void 0 ? _f : [];
        const patchData = [
            {
                op: 'add',
                path: '/assignment:sourceAssets',
                value: sourceAssets
            },
            {
                op: 'add',
                path: '/assignment:sourceTasks',
                value: sourceTasks
            },
            {
                op: 'add',
                path: '/assignment:sourceTutorials',
                value: sourceTutorials
            },
        ];
        if (data.sourceAsset) {
            patchData.push({
                op: 'add',
                path: '/assignment:sourceAsset',
                value: data.sourceAsset
            });
        }
        const assetToPatch = typeof studentAssignmentFile === 'string'
            ? await this._core.hostAssetContext.getAssetWithCloudID(studentAssignmentFile)
            : studentAssignmentFile;
        await assetToPatch.patchAppMetadata(patchData);
        return assetToPatch;
    }
    /**
     * Determine if the given name is valid for creating an assignment
     * @throws {SAMError} if the name is invalid
     *
     * @example <caption>Validate an assignment name before creating an assignment for a Classroom</caption>
     * try {
     *  await classroomContext.validateAssignmentNameForCreate('My Assignment', '123@AdobeOrg');
     * } catch (error) {}
     */
    async validateAssignmentNameForCreate(name, classroomId) {
        await this._validateAssignmentName(name, classroomId);
    }
    /**
     * Verifies the usage of submissions (representing Student Assignments) and
     * returns the Student Assignments submission type (either client specified or a default calculated based on membership role)
     * @param data The data necessary to check validity of submissions
     * @throws {SAMError} if the submissions type is invalid
     * @package Only for use in SAM.js
     */
    async validateStudentAssignmentsFilter(submissions, classroomId) {
        if (submissions && submissions === AssignmentSubmissionOwnershipEnums.ANY) {
            if (!classroomId) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Cannot fetch specified assignment submission type without classroomId');
            }
            const membershipStatus = await this.getClassroomMembership(classroomId);
            // If a submission type is specified as ANY and the membership role is 'Student'
            // throw an error (a student cannot request any assignment submissions other than their own)
            if (membershipStatus.role === ClassroomMemberRole.STUDENT) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Student role cannot request assignment submission type "ANY"');
            }
        }
        return submissions;
    }
    /**
     * Determine if the given name is valid when updating an assignment
     * @throws {SAMError} if the name is invalid
     *
     * @example <caption>Validate an assignment name before updating an assignment for a Classroom</caption>
     * try {
     *  await classroomContext.validateAssignmentNameForCreate('My Assignment', '123@AdobeOrg', 'assignment-id');
     * } catch (error) {}

     */
    async validateAssignmentNameForUpdate(name, classroomId, assignmentId) {
        await this._validateAssignmentName(name, classroomId, assignmentId);
    }
    /**
     * Determine if the given name is valid
     *  - Name cannot contain only whitespace
     *  - Name must adhere to asset naming rules
     *  - Name cannot end in a period
     *  - The name must be unique within the classroom
     * @throws {SAMError} if the name is invalid or not unique
     */
    async _validateAssignmentName(name, classroomId, assignmentId) {
        const trimmedName = name.trim();
        // Name cannot have leading or trailing whitespace
        if (trimmedName.length === 0) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'The assignment name cannot be blank.');
        }
        // Name must adhere to asset naming rules
        if (!validatePlatformRepoName(trimmedName)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'The assignment name is an invalid platform repo name.');
        }
        // Name cannot end in a period
        if (trimmedName.endsWith('.')) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'The assignment name cannot end with a period.');
        }
        // Name must be unique within the classroom
        if (!classroomId) {
            // Assignment does not map to a specific class yet so the name is valid for this case
            return;
        }
        const classroom = await this.getClassroomById(classroomId);
        if (classroom.isVirtual) {
            // No assignments exist in a virtual classroom
            return;
        }
        const assignments = this.getAssignments();
        const assignmentList = assignments.getList(await this.getAssignmentOrder(), await this.getAssignmentFilter({ classroomId }), {});
        await waitForListLoad(assignmentList);
        const locale = this._core._environment.getValue('LOCALE');
        const matchingAssignment = assignmentList.items.find(assignment => assignment.name.toLocaleLowerCase(locale) === trimmedName.toLocaleLowerCase(locale));
        if (matchingAssignment) {
            if (!assignmentId || matchingAssignment.id !== assignmentId) {
                throw SAMError.create(SAMErrorCode.CONFLICT, 'The assignment name must be unique within the classroom.');
            }
        }
    }
    /**
     * Updates an Assignment's name
     * @throws {SAMError} If the assignment could not be renamed
     * @param assignmentId The assignment ID
     * @param newName The new name
     */
    async _renameAssignment(assignmentId, newName) {
        const assignment = await this.getAssignmentByID(assignmentId);
        try {
            // repositoryID must be present for the rename operation to work
            if (!assignment.repositoryID) {
                await assignment._load();
            }
            return assignment.rename(newName);
        }
        catch (error) {
            if (error instanceof SAMError) {
                throw error;
            }
            throw SAMError.create(SAMErrorCode.INTERNAL_ERROR, `Could not rename asset "${assignmentId}"`);
        }
    }
    /**
     * Updates an Assignment's data and copies any given asset to the materials folder of the assignment
     * @param id The assignmentId of the Assignment to update
     * @param data The data to update the Assignment with
     *
     * @example <caption>Update an Assignment with new materials</caption>
     * await classroomContext.updateAssignment('assignmentID', { name: 'New Name', templateIds: ['templateID'], references: ['referenceID'] });
     */
    async updateAssignment(assignmentId, data) {
        validateString(assignmentId, 'assignmentId');
        // Extract references and templateIds because they should not be updated
        // unless _getUpdatedAssignmentMaterials determines that they should be
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { references, status, templateIds } = data, otherAssignmentData = __rest$2(data, ["references", "status", "templateIds"]);
        const materialUpdates = await this._getUpdatedAssignmentMaterials(assignmentId, data);
        const patchData = otherAssignmentData;
        if (materialUpdates.shouldUpdateTemplates) {
            patchData.templateIds = materialUpdates.updatedTemplateIds;
        }
        if (materialUpdates.shouldUpdateReferences) {
            patchData.referenceIds = materialUpdates.updatedReferenceIds;
        }
        const promises = [];
        const shouldRename = Boolean(data.name);
        // The update operation can happen in parallel with the rename operation
        if (shouldRename) {
            patchData.name = this.cleanAssignmentName(data.name);
            promises.push(this._renameAssignment(assignmentId, patchData.name));
        }
        if (status === AssignmentStatus.ASSIGNED) {
            patchData.status = status;
        }
        promises.push(this._updateAssignmentMetadata(assignmentId, patchData));
        await Promise.all(promises);
        // Cleaning up after setting the new templates in case the copy OR update fails
        // Note: If the discard operation fails on any asset then it will be orphaned forever
        // TODO: Determine how we can do a proper cleanup of any orphaned assets, not just on update
        this._discardAssets(materialUpdates.assetsToDiscard);
    }
    /**
     * Updates an Assignment's data
     * @param assignmentId The assignmentId of the Assignment to update
     * @param data The data to update the Assignment with
    */
    async _updateAssignmentMetadata(assignmentId, data) {
        if (Object.keys(data).length === 0) {
            // Nothing to update
            return;
        }
        const mappedData = Object.entries(assignmentRemoteFieldMapping).reduce((acc, [localKey, remoteKey]) => {
            const hasKey = hasProperty(data, localKey);
            if (hasKey) {
                const value = data[localKey];
                if (value instanceof Date) {
                    // @ts-expect-error
                    acc[remoteKey] = value.toISOString();
                }
                else if (localKey === 'dueDate' && !value) {
                    // @ts-expect-error
                    acc[remoteKey] = ''; // Set to an empty string in the case we want to remove the dueDate
                }
                else {
                    // @ts-expect-error
                    acc[remoteKey] = value;
                }
            }
            return acc;
        }, { 'repo:assetId': assignmentId });
        const ops = this._getUpdateAssignmentOps(mappedData);
        if (ops.length !== 0) {
            const response = await this._assignmentInterface.patchAssignment(assignmentId, ops);
            const session = this._assetPool.createMutationSession();
            AssignmentUpdater.updateRemoteItem(session, response);
            session.commit();
        }
    }
    /**
     * Gets the asset representing the materials folder of an assignment
     * @throws {SAMError} If the materials folder cannot be found
     * @param assignmentId
     */
    async _getAssignmentMaterialsFolderAsset(assignmentId) {
        const assignment = await this.getAssignmentByID(assignmentId);
        const materialsFolderPath = `${assignment.repoPath}/materials`;
        const materialsFolderAsset = await this._core.hostAssetContext.getAssetWithRepoPath(materialsFolderPath, assignment.repositoryID);
        if (!materialsFolderAsset) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, `Could not find materials folder with path of "${materialsFolderPath}"`);
        }
        return materialsFolderAsset;
    }
    /**
     * Gets a list of assets by ID
     * @throws {SAMError} If any asset cannot be found
     */
    async _getAssets(assetIds) {
        return (await Promise.allSettled(assetIds.map(assetId => this._core.hostAssetContext.getAssetWithCloudID(assetId)))).map((result, index) => {
            if (result.status === 'fulfilled') {
                return result.value;
            }
            throw SAMError.wrapErrorIfNeeded(SAMErrorCode.INTERNAL_ERROR, `Failed to get asset with ID of "${assetIds[index]}"`, result.reason);
        });
    }
    /** Discards a list of assets by ID */
    async _discardAssets(assetIds) {
        if (assetIds.length === 0) {
            return;
        }
        const assets = await this._getAssets(assetIds);
        await Promise.allSettled(assets.map((asset) => asset.discard()));
    }
    /** Returns a list of ops used to update an assignment */
    _getUpdateAssignmentOps(mappedData) {
        const ops = Object.entries(mappedData)
            .filter(([key]) => key.startsWith('assignment:')) // We can only update the assignment metadata, not the asset metadata
            .map(([key, value]) => ({ op: 'replace', path: `/${key}`, value }));
        return ops;
    }
    /**
     * Copies the given assets to the materials folder of the assignment
     * @param assignmentId The assignment ID to copy to
     * @param assetIds The assets to copy
     * @returns The asset IDs of the copied assets
     * @throws {SAMError} If any asset cannot be copied
     */
    async _copyAssetsToMaterialsFolder(assignmentId, assetIds) {
        if (assetIds.length === 0) {
            return [];
        }
        const assignment = await this.getAssignmentByID(assignmentId);
        const assetsToCopy = await this._getAssets(assetIds);
        // Copying the assets one at a time (but in parallel) because the batch copy cannot copy assets from different directories
        const copyPromises = assetsToCopy.map((asset, idx) => {
            const extension = asset.extension ? `.${asset.extension}` : '';
            return asset._copyWithDestMetadata(assignment.repositoryID, `${assignment.repoPath}/materials`, `${assignment.name} ${this._getFormattedCreatedDateHelper({ includeFormattedDate: true, date: new Date() })} ${idx}${extension}`);
        });
        const clonedAssets = (await Promise.allSettled(copyPromises))
            .map((result, index) => {
            if (result.status === 'fulfilled') {
                return result.value;
            }
            throw SAMError.wrapErrorIfNeeded(SAMErrorCode.INTERNAL_ERROR, `Failed to copy asset with ID of "${assetIds[index]}"`, result.reason);
        });
        return clonedAssets.map(asset => asset.id);
    }
    /**
     * Helper function to format the created date for the asset name
     * @package -- for SAM.js internal use only
     */
    _getFormattedCreatedDateHelper({ includeFormattedDate, date }) {
        const locale = this._core._environment.getValue('LOCALE');
        const dateTimeFormat = includeFormattedDate ? {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            fractionalSecondDigits: 3,
            hourCycle: 'h24'
        } : {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        };
        // Need to replace to convert from colons to periods, example: 14:28:00 to 14.28.00
        return new Intl.DateTimeFormat(locale, dateTimeFormat).format(date).replace(/[/:]/g, '.');
    }
    /** Determines which files need to be kept, cloned, and discarded when updating an assignment with new resources. */
    async _determineAssetDifferences(assignmentId, field, incomingAssetIds) {
        const assignment = await this.getAssignmentByID(assignmentId);
        if (!incomingAssetIds) {
            return {
                assetsToCopy: [],
                assetsToKeep: [],
                assetsToDiscard: assignment[field],
            };
        }
        const assetsToDiscard = assignment[field].filter(templateId => !incomingAssetIds.includes(templateId));
        const assetsToCopy = incomingAssetIds.filter(templateId => !assignment[field].includes(templateId));
        const assetsToKeep = assignment[field].filter(templateId => incomingAssetIds.includes(templateId));
        return {
            assetsToCopy,
            assetsToKeep,
            assetsToDiscard,
        };
    }
    /**
     * Based on incoming update data this will determine which assets need to be kept, cloned, and discarded.
     * Assets to be kept are returned as-is.
     * Assets to be cloned are copied to the materials folder of the assignment, and returned along with the kept asset IDs.
     * Assets to be discarded are returned and are expected to be discarded after calling this function.
     */
    async _getUpdatedAssignmentMaterials(assignmentId, data) {
        var _a, _b;
        const shouldUpdateTemplates = hasProperty(data, 'templateIds');
        const shouldUpdateReferences = hasProperty(data, 'references');
        const result = {
            assetsToDiscard: [],
            shouldUpdateReferences,
            shouldUpdateTemplates,
            updatedReferenceIds: [],
            updatedTemplateIds: [],
        };
        const assetsToCopy = [];
        let splitIdx = 0;
        const materialsPromises = [];
        if (shouldUpdateTemplates) {
            const templateDifferences = await this._determineAssetDifferences(assignmentId, 'templateIds', data.templateIds);
            result.assetsToDiscard.push(...templateDifferences.assetsToDiscard);
            assetsToCopy.push(...templateDifferences.assetsToCopy);
            result.updatedTemplateIds.push(...templateDifferences.assetsToKeep);
            splitIdx = assetsToCopy.length;
        }
        if (shouldUpdateReferences) {
            // Split the incoming references into IDs and ExternalAssets
            const { referenceIds, referencesToImport } = (_b = (_a = data.references) === null || _a === void 0 ? void 0 : _a.reduce((acc, cur) => {
                if (typeof cur === 'string') {
                    acc.referenceIds.push(cur);
                }
                else {
                    acc.referencesToImport.push(cur);
                }
                return acc;
            }, {
                referenceIds: [],
                referencesToImport: [],
            })) !== null && _b !== void 0 ? _b : { referenceIds: [], referencesToImport: [] };
            const referenceDifferences = await this._determineAssetDifferences(assignmentId, 'referenceIds', referenceIds);
            result.assetsToDiscard.push(...referenceDifferences.assetsToDiscard);
            assetsToCopy.push(...referenceDifferences.assetsToCopy);
            result.updatedReferenceIds.push(...referenceDifferences.assetsToKeep);
            // If there are any ExternalAssets to import then we need to import them into the materials folder
            // and store the new asset IDs in the references field
            if (referencesToImport.length > 0) {
                materialsPromises.push(async () => {
                    const importedReferenceAssetIds = [];
                    const importResults = await this.importNewReferencesForAssignment(assignmentId, referencesToImport);
                    importResults.forEach((result) => {
                        if (result.status === 'fulfilled') {
                            importedReferenceAssetIds.push(result.value.id);
                        }
                        else {
                            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Error importing reference asset', { underlyingError: result.reason });
                        }
                    });
                    result.updatedReferenceIds.push(...importedReferenceAssetIds);
                });
            }
        }
        let clonedAssetIds = [];
        // Copy all assets at once to avoid multiple API calls
        materialsPromises.push(async () => {
            clonedAssetIds = await this._copyAssetsToMaterialsFolder(assignmentId, assetsToCopy);
        });
        // Upload references and copy templates concurrently
        await Promise.all(materialsPromises.map((fn) => fn()));
        // Split the result into templates and references
        const [clonedTemplates, clonedReferences] = [clonedAssetIds.slice(0, splitIdx), clonedAssetIds.slice(splitIdx)];
        result.updatedTemplateIds.push(...clonedTemplates);
        result.updatedReferenceIds.push(...clonedReferences);
        return result;
    }
    /**
     * Imports each ExternalAsset as a file into the assignment's materials folder
     * @returns The AdobeAsset objects of the imported files
     */
    async importNewReferencesForAssignment(assignmentId, references) {
        const materialsFolder = await this._getAssignmentMaterialsFolderAsset(assignmentId);
        return Promise.allSettled(references.map(async (reference) => {
            return materialsFolder.importFile(reference.content, reference.name, reference.mediaType, true, 0, false);
        }));
    }
    /**
     * Function to get a list of StudentAssignmentFiles for a given StudentDirectoryId
     *
     * @param {} param Contains parameters for StudentDirectoryId and order for the list
     * @throws {Error} if the student directory asset is not a folder
     * @deprecated Use `StudentAssignment.files` instead. Will be removed in ACPCEDU-3305.
     */
    async getStudentAssignmentFiles({ studentDirectoryId, order }) {
        validateString(studentDirectoryId, 'studentDirectoryId');
        const folderAsset = await this._core.hostAssetContext.getAssetWithCloudID(studentDirectoryId);
        const list = folderAsset.children.getList(order || AdobeAssetOrder.default, new StudentAssignmentFilesListFilter(), { loadAllPages: true });
        // Waiting for the list because clients expect all files to be returned from this method without having to wait themselves
        await waitForListLoad(list);
        return list.items;
    }
    /**
     * Refreshes the classroom codes for the given classroom IDs
     *
     * @param classIds list of classroomIds to refresh
     *
     * @example <caption>Refresh classroom codes for a list of classroom IDs</caption>
     * await classroomContext.refreshClassroomCodes(['123@AdobeID']);
     */
    async refreshClassroomCodes(classIds) {
        validateString(classIds, 'classIds');
        // Attempt to refresh all codes
        const results = await Promise.allSettled(classIds.map(id => this._classroomsInterface.refreshClassroomCode(id)));
        // Filter out failing requests
        // @ts-expect-error -- TS can't infer the type of results after filtering. Will be fixed in TS 5.5
        const classroomsToUpdate = results.filter(result => result.status === 'fulfilled').map(result => result.value);
        // Fetch each classroom so that we have an IRemoteClassroom, update its code to the new one
        const updatedClassrooms = await Promise.allSettled(classroomsToUpdate.map(async ({ classroomId, classcode }) => {
            const classroom = await this._classroomsInterface.getClassroom(classroomId);
            classroom.classCode = classcode;
            return classroom;
        }));
        // Filter out any lookups that failed
        // @ts-expect-error -- TS can't infer the type of results after filtering. Will be fixed in TS 5.5
        const successfullyUpdatedClassrooms = updatedClassrooms.filter(result => result.status === 'fulfilled').map(result => result.value);
        const session = this._classroomPool.createMutationSession();
        ClassroomUpdater.updateRemoteItems(session, successfullyUpdatedClassrooms);
        session.commit();
    }
    /**
     * @description Deletes classrooms with the given class IDs.
     *
     * @param ids either an array or single string that maps to classIds or classCodes
     *
     * @example <caption>Delete a classroom by ID</caption>
     * await classroomContext.deleteClassrooms('123@AdobeID');
     */
    async deleteClassrooms(ids) {
        validateString(ids, 'ids');
        if (Array.isArray(ids)) {
            await Promise.all(ids.map(id => this.deleteClassrooms(id)));
        }
        else {
            const classroom = await this.getClassroomById(ids);
            if (classroom.isVirtual) {
                await this._classroomsInterface.deleteVirtualClassroom(ids);
            }
            else {
                await this._classroomsInterface.deleteClassroom(ids);
            }
            const session = this._classroomPool.createUpdateSession();
            session.queueDiscardedItem(classroom);
            session.commit();
            // The session doesn't actually remove the item from the pool
            this._classroomPool.removeLocalItems([classroom.id]);
        }
    }
    /**
     * Updates a classroom with new data
     *
     * @example <caption>Update a classroom by ID</caption>
     * await classroomContext.updateClassroom('123@AdobeID', { name: 'New Name' });
     */
    async updateClassroom(classroomId, data) {
        var _a;
        validateString(classroomId, 'classroomId');
        let updatedClassroomData;
        const classroom = await this.getClassroomById(classroomId);
        // Classroom name is required for the update operation
        // If it is not passed in then we can get it from the pool
        (_a = data.name) !== null && _a !== void 0 ? _a : (data.name = classroom.name);
        if (classroom.isVirtual) {
            updatedClassroomData = await this._classroomsInterface.updateClassroomFromVirtual(classroom.id, data);
            // Preserve the old original identifier for the class to re-index the existing item under its preferred id
            updatedClassroomData.virtualId = classroom.id;
        }
        else {
            updatedClassroomData = await this._classroomsInterface.updateClassroom(classroomId, data);
        }
        const session = this._classroomPool.createMutationSession();
        ClassroomUpdater.updateRemoteItem(session, this._processRemoteClassroomItem(classroomId, updatedClassroomData));
        session.commit();
    }
    _processRemoteClassroomItem(classroomId, remoteClassroom) {
        const cachedClassroom = this._classroomPool.getLocalItemById(classroomId);
        // Preserve the classroom's old virtual ID if it is set in this session
        if (cachedClassroom === null || cachedClassroom === void 0 ? void 0 : cachedClassroom._virtualId) {
            remoteClassroom.virtualId = cachedClassroom._virtualId;
        }
        return remoteClassroom;
    }
    /**
     * Returns the current user's (determined by bearer token of the request) membership status for a classroom
     *
     * @param classroomId ID of the classroom to check status of user for
     *
     * @example <caption>Get the current user's membership status for a classroom</caption>
     * const membershipStatus: IRemoteMembership = await this.getClassroomMembership('123@AdobeOrg');
     */
    async getClassroomMembership(classroomId) {
        validateString(classroomId, 'classroomId');
        return this._classroomsInterface.getMembership(classroomId);
    }
    /**
     * Blocks a student from a classroom
     *
     * @param classroomId Classroom ID to block student from
     * @param studentId Student ID to block
     *
     * @example <caption>Block a student from a classroom</caption>
     * await classroomContext.blockStudentFromClassroom('123@AdobeOrg', 'user@adobe.com');
     */
    async blockStudentFromClassroom(classroomId, studentId) {
        validateString(classroomId, 'classroomId');
        validateString(studentId, 'studentId');
        return this._classroomsInterface.blockStudent(classroomId, studentId);
    }
    /**
     * Unblocks a student from a classroom
     *
     * @param classroomId Classroom ID to unblock student from
     * @param studentId Student ID to unblock
     *
     * @example <caption>Block a student from a classroom</caption>
     * await classroomContext.unblockStudentFromClassroom('123@AdobeOrg', 'user@adobe.com');
     */
    async unblockStudentFromClassroom(classroomId, studentId) {
        validateString(classroomId, 'classroomId');
        validateString(studentId, 'studentId');
        return this._classroomsInterface.unblockStudent(classroomId, studentId);
    }
    /**
     * Removes a student from a classroom
     *
     * @param classroomId Classroom ID to remove student from
     * @param studentId Student ID to remove
     *
     * @example <caption>Remove a student from a classroom</caption>
     * await classroomContext.removeStudentFromClassroom('123@AdobeOrg', 'user@adobeId');
     */
    async removeStudentFromClassroom(classroomId, studentId) {
        validateString(classroomId, 'classroomId');
        validateString(studentId, 'studentId');
        const removeResponse = await this._classroomsInterface.removeStudent(classroomId, studentId);
        this.removeUserFromPool(classroomId, studentId);
        return removeResponse;
    }
    /**
     * Removes a teacher from a classroom
     *
     * @param classroomId Classroom ID to remove teacher from
     * @param teacherId Teacher's user ID to remove
     *
     * @example <caption>Remove a teacher from a classroom</caption>
     * await classroomContext.removeTeacherFromClassroom('123@AdobeOrg', 'user@adobeId');
     */
    async removeTeacherFromClassroom(classroomId, teacherId) {
        validateString(classroomId, 'classroomId');
        validateString(teacherId, 'teacherId');
        const removeResponse = await this._classroomsInterface.removeTeacher(classroomId, teacherId);
        this.removeUserFromPool(classroomId, teacherId);
        return removeResponse;
    }
    /**
     * Removes a user from the local pool
     * So long as the users were fetched initially from the Classroom.members.getList() method and added to the classroomMemberPool, they'll be present to remove.
     *
     * @param classroomId The classroom ID to remove the user from
     * @param userId The user ID to remove
     */
    removeUserFromPool(classroomId, userId) {
        const member = this._classroomMemberPool.getLocalItemById(getMemberComputedKey(classroomId, userId));
        if (member) {
            const session = this._classroomMemberPool.createUpdateSession();
            session.queueDiscardedItem(member);
            session.commit();
            this._classroomMemberPool.removeLocalItems([getMemberComputedKey(classroomId, userId)]);
        }
    }
    /**
     * Creates a ClassroomOrder object
     * @experimental
     *
     * @example <caption>Create a ClassroomOrder</caption>
     * const order: ClassroomOrder = await classroomContext.getClassroomOrder('descending', 'created');
     */
    async getClassroomOrder(direction = 'ascending', field = 'name') {
        const { default: ClassroomOrder } = await Promise.resolve().then(function () { return ClassroomOrder$1; });
        return new ClassroomOrder(direction, field);
    }
    /**
     * Creates a AssignmentOrder object
     * @experimental
     *
     * @example <caption>Create a AssignmentOrder</caption>
     * const order: AssignmentOrder = await classroomContext.getAssignmentOrder('descending', 'status');
     */
    async getAssignmentOrder(direction = 'ascending', field = 'name') {
        const { default: AssignmentOrder } = await Promise.resolve().then(function () { return AssignmentOrder$1; });
        return new AssignmentOrder(direction, field);
    }
    /**
     * Creates a AssignmentFilter object
     * @experimental
     *
     * @example <caption>Create a AssignmentFilter</caption>
     * const filter: AssignmentFilter = await classroomContext.getAssignmentFilter({ classroomId: '123@AdobeOrg' });
     */
    async getAssignmentFilter(options = {}) {
        const { default: AssignmentFilter } = await Promise.resolve().then(function () { return AssignmentFilter$1; });
        return new AssignmentFilter(options);
    }
    /**
     * Creates a StudentAssignmentOrder object
     * @experimental
     *
     * @example <caption>Create a StudentAssignmentOrder</caption>
     * const order: StudentAssignmentOrder = await classroomContext.getStudentAssignmentOrder('descending', 'studentDisplayName');
     */
    async getStudentAssignmentOrder(direction = 'ascending', field = 'studentDisplayName') {
        const { default: StudentAssignmentOrder } = await Promise.resolve().then(function () { return StudentAssignmentOrder$1; });
        return new StudentAssignmentOrder(direction, field);
    }
    /**
     * Creates a StudentAssignmentFilter object
     * @experimental
     *
     * @example <caption>Create a StudentAssignmentFilter</caption>
     * const filter: StudentAssignmentFilter = await classroomContext.getStudentAssignmentFilter({ assignmentId: 'assignmentID', status: [StudentAssignmentStatus.NOT_STARTED] });
     */
    async getStudentAssignmentFilter(options) {
        const { default: StudentAssignmentFilter } = await Promise.resolve().then(function () { return StudentAssignmentFilter$1; });
        return new StudentAssignmentFilter(options);
    }
    /**
     * Creates a StudentAssignmentFileOrder object
     * @experimental
     *
     * @example <caption>Create a StudentAssignmentFileOrder</caption>
     * const order: StudentAssignmentFileOrder = await classroomContext.getStudentAssignmentFileOrder('descending', 'modified');
     */
    async getStudentAssignmentFileOrder(direction = 'ascending', field = 'name') {
        const { default: StudentAssignmentFileOrder } = await Promise.resolve().then(function () { return StudentAssignmentFileOrder$1; });
        return new StudentAssignmentFileOrder(direction, field);
    }
    /**
     * Creates a StudentAssignmentFileFilter object
     * @experimental
     *
     * @param studentAssignmentId The ID of the StudentAssignment that the files returned are associated with
     * @param options Deprecated, further filtering of files is not supported at this time
     *
     * @example <caption>Create a StudentAssignmentFileFilter</caption>
     * const filter: StudentAssignmentFileFilter = await classroomContext.getStudentAssignmentFileFilter('student-assignment-id');
     */
    async getStudentAssignmentFileFilter(studentAssignmentId, options) {
        const { default: StudentAssignmentFileFilter } = await Promise.resolve().then(function () { return StudentAssignmentFileFilter$1; });
        return new StudentAssignmentFileFilter(studentAssignmentId, options);
    }
    /**
     * Creates a ClassroomMemberOrder object
     * @experimental
     *
     * @example <caption>Create a ClassroomMemberOrder</caption>
     * const order: ClassroomMemberOrder = await classroomContext.getClassroomMemberOrder('descending', 'name');
     */
    async getClassroomMemberOrder(direction = 'ascending', field = 'name') {
        const { default: ClassroomMemberOrder } = await Promise.resolve().then(function () { return ClassroomMemberOrder$1; });
        return new ClassroomMemberOrder(direction, field);
    }
    /**
     * Creates a ClassroomMemberFilter object
     * @experimental
     *
     * @example <caption>Create a ClassroomMemberFilter</caption>
     * const filter: ClassroomMemberFilter = await classroomContext.getClassroomMemberFilter({classroomId: '123@AdobeOrg'});
     */
    async getClassroomMemberFilter(options) {
        const { default: ClassroomMemberFilter } = await Promise.resolve().then(function () { return ClassroomMemberFilter$1; });
        return new ClassroomMemberFilter(options);
    }
    /**
     * Checks eligibility of users to be added as co-teachers to a classroom
     *
     * @example <caption>Check co-teacher eligibility</caption>
     * const eligibility = await classroomContext.checkCoTeacherEligibility({ emails: ['user@adobe.com'], classroomId: '123@AdobeOrg' });
     */
    async checkCoTeacherEligibility(options) {
        return this._classroomsInterface.checkCoTeacherEligibility(options);
    }
    /**
     * Gets a classroom by ID or code
     * @throws {SAMError} if neither classroomCode nor classroomId is provided
     */
    async _getClassroomByIdOrCode(options) {
        const { classroomCode, classroomId } = options;
        if (classroomId) {
            return this.getClassroomById(classroomId);
        }
        else if (classroomCode) {
            return this.getClassroomByCode(classroomCode);
        }
        else {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Either classroomCode or classroomId must be provided');
        }
    }
    /**
     * Gets an assignment by ID or code
     * @throws {SAMError} if neither assignmentCode nor assignmentId is provided
     */
    async _getAssignmentByIdOrCode(options) {
        const { assignmentCode, assignmentId } = options;
        if (assignmentId) {
            return this.getAssignmentByID(assignmentId);
        }
        else if (assignmentCode) {
            return this.getAssignmentByCode(assignmentCode);
        }
        else {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Either assignmentCode or assignmentId must be provided');
        }
    }
    /**
     * Gets the boards for a classroom given a classroom ID or classroom code
     * @experimental
     *
     * @example <caption>Get all Boards</caption>
     * const classroomBoardsList = (await classroomContext.getClassroomBoards({classroomId: '123@AdobeOrg'})).getList(BoardOrder.default);
     * await waitForListLoad(classroomBoardsList);
     * const classroomBoards: Board[] = classroomBoardsList.items;
     */
    async getClassroomBoards(options) {
        const classroom = await this._getClassroomByIdOrCode(options);
        return this._ensureBoardContext().getBoards(classroom.assetId);
    }
    /**
     * Gets the boards for an assignment given an assignment ID or assignment code
     * @experimental
     *
     * @example <caption>Get the boards for an assignment</caption>
     * const assignmentBoardsList = (await classroomContext.getAssignmentBoards({assignmentId: 'assignmentID'})).getList(BoardOrder.default);
     * await waitForListLoad(assignmentBoardsList);
     * const assignmentBoards: Board[] = assignmentBoardsList.items;
     */
    async getAssignmentBoards(options) {
        const assignment = await this._getAssignmentByIdOrCode(options);
        return this._ensureBoardContext().getBoards(assignment.id);
    }
    /**
     * Creates a board for a classroom
     * @experimental
     *
     * @example <caption>Create a board for a classroom</caption>
     * const board: Board = await classroomContext.createClassroomBoard({ name: 'My Classroom Board', classroomId: '123@AdobeOrg' });
     */
    async createClassroomBoard(_options) {
        // TODO[ACPCEDU-4012]: Implement this once the architecture is finalized
        // const { classroomId, classroomCode, ...rest } = options;
        // const classroomIdentifier: GetClassroomBoardsOptions = classroomId
        //     ? { classroomId }
        //     : { classroomCode: classroomCode! };
        // const { assetId, id } = await this._getClassroomByIdOrCode(classroomIdentifier);
        // return this._ensureBoardContext().createBoard({
        //     ...rest,
        //     baseAssetId: assetId,
        //     type: 'classroom',
        //     additionalData: {
        //         classroomId: id,
        //     }
        // });
        return Promise.resolve({});
    }
};
__decorate([
    keepAlive,
    synchronized,
    __param(0, key)
], ClassroomContext.prototype, "getClassroomById", null);
__decorate([
    keepAlive,
    synchronized,
    __param(0, key)
], ClassroomContext.prototype, "getClassroomByCode", null);
__decorate([
    memoize$1
], ClassroomContext.prototype, "getClassrooms", null);
__decorate([
    memoize$1
], ClassroomContext.prototype, "getClassroomMembers", null);
__decorate([
    memoize$1
], ClassroomContext.prototype, "getAssignments", null);
__decorate([
    keepAlive,
    weakCache,
    __param(0, key)
], ClassroomContext.prototype, "getStudentAssignments", null);
__decorate([
    trace,
    keepAlive,
    synchronized
], ClassroomContext.prototype, "createClassroom", null);
__decorate([
    trace,
    keepAlive,
    synchronized
], ClassroomContext.prototype, "createAssignment", null);
__decorate([
    keepAlive,
    synchronized,
    __param(0, key)
], ClassroomContext.prototype, "getAssignmentByID", null);
__decorate([
    keepAlive,
    synchronized,
    __param(0, key)
], ClassroomContext.prototype, "getAssignmentByCode", null);
__decorate([
    keepAlive,
    synchronized,
    __param(0, key)
], ClassroomContext.prototype, "getStudentAssignmentById", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "_discardAssignment", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "_restoreAssignment", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "_returnAssignment", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "_startAssignment", null);
__decorate([
    trace,
    synchronized
], ClassroomContext.prototype, "submitAssignment", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "_validateAssignmentName", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "_renameAssignment", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "updateAssignment", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "_updateAssignmentMetadata", null);
__decorate([
    synchronized
], ClassroomContext.prototype, "refreshClassroomCodes", null);
ClassroomContext = __decorate([
    traceableAs('ClassroomContext')
], ClassroomContext);
var ClassroomContext$1 = ClassroomContext;

var ClassroomContext$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': ClassroomContext$1
});

/*************************************************************************
   *
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2025 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by trade secret or copyright law.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
/**
 * This is a temporary file while the Hume service implements the Boards API.
 * It contains mock response objects that we expect Hume to provide us in the future.
 * This will be removed in ACPCEDU-3897
 */
const GetBoardByIdResponse = {
    'repo:name': 'Sample board name',
    'board#description': 'Board description',
    'board#type': 'classroom',
    'board:context': {
        'baseAssetId': 'urn:aaid:sc:VA6C2:af99f449-ea01-3e3e-aba5-fe57fd38364b',
        'boardsAssetId': 'urn:aaid:sc:VA6C2:af99f449-ea01-3e3e-aba5-fe57fd38364c'
    },
    'repo:assetId': 'urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdxyz',
    'repo:createDate': '2024-10-01T21:59:01.415Z',
    'repo:modifyDate': '2024-10-01T21:59:06.565Z',
    'repo:createdBy': '1916195E667CADAB0A12345D@AdobeID',
    'repo:modifiedBy': '1916195E667CADAB0A12345D@AdobeID',
    'posts': [
        {
            'id': 'af46a980-9cc5-4baf-935c-123fcb6ee615',
            'description': 'Text 1',
            'type': 'application/vnd.adobe.element.text+dcx',
            'postedBy': {
                'userId': 'BF44198F668D1EAE0A494021@af361967668d0331494131.e',
                'email': 'assignmentstudent1@itaw16.onmicrosoft.com',
                'firstName': 'John',
                'lastName': 'Doe',
                'displayName': 'John. Doe',
                'images': {
                    '50': 'https://example_50_pixel.com',
                    '100': 'https://example_100_pixel.com'
                }
            },
            'created': '2020-03-17T21:23:25.693Z',
            'modified': '2020-03-17T22:23:25.693Z',
            'board#createdData': {
                'userId': '0D522D2B5D7687E40A494215@AdobeID'
            },
            'board#modifiedData': {
                'userId': '0D522D2B5D7687E40A494215@AdobeID'
            }
        },
        {
            'id': 'af46a980-9cc5-4baf-935c-501fcb6ee616',
            'name': 'My poster',
            'description': 'My poster description',
            'type': 'application/vnd.adobe.element.assetlink+dcx',
            'link': {
                'repo:assetId': 'urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb',
                'repo:etag': '"167dd86b8f8d4ac88f40722210655c51"'
            },
            'postedBy': {
                'userId': 'BF44198F668D1EAE0A494021@af361967668d0331494131.e',
                'email': 'assignmentstudent1@itaw16.onmicrosoft.com',
                'firstName': 'John',
                'lastName': 'Doe',
                'displayName': 'John. Doe',
                'images': {
                    '50': 'https://example_50_pixel.com',
                    '100': 'https://example_100_pixel.com'
                }
            },
            'created': '2020-03-17T21:23:25.693Z',
            'modified': '2020-03-17T22:23:25.693Z',
            'board#createdData': {
                'userId': '0D522D2B5D7687E40A494215@AdobeID'
            },
            'board#modifiedData': {
                'userId': '0D522D2B5D7687E40A494215@AdobeID'
            }
        }
    ]
};

/*************************************************************************
   *
   * ADOBE CONFIDENTIAL
   * ___________________
   *
   *  Copyright 2025 Adobe Systems Incorporated
   *  All Rights Reserved.
   *
   * NOTICE:  All information contained herein is, and remains
   * the property of Adobe Systems Incorporated and its suppliers,
   * if any.  The intellectual and technical concepts contained
   * herein are proprietary to Adobe Systems Incorporated and its
   * suppliers and are protected by trade secret or copyright law.
   * Dissemination of this information or reproduction of this material
   * is strictly forbidden unless prior written permission is obtained
   * from Adobe Systems Incorporated.
   **************************************************************************/
const headers = getSAMVersionRequestHeader();
function validateRequiredBoardLinks(links) {
    return validateLinks(links, BOARDS_INDEX_LINKS);
}
class BoardsInterface extends InterfaceBase {
    async _discoverLinks(rootHref) {
        const response = await this._getResponse(rootHref, { headers });
        return response._links;
    }
    _getEndpointHref(endpoint) {
        return `https://${this._core._environment.endpoints.ASSIGNMENTS_HOST}${endpoint}`;
    }
    /**
     * Discovers and retrieves the available board-related API links and endpoints
     */
    async discoverLinks() {
        return this._discoverLinks(this._getEndpointHref(`/api/v1/index`));
    }
    /**
     * Creates a new board
     */
    async createBoard(data) {
        // TODO: Implement once the API is ready in ACPCEDU-3896
        // const dataToPost = {
        //     'repo:name': data.name,
        //     'board#description': data.description,
        //     'board#type': data.type,
        //     'additionalMetadata': data.additionalData,
        //     // posts: remotePostData, // Add support in ACPCEDU-3872
        // };
        // const response = await this._doPost(
        //     this._getEndpointHref(`/api/v1/boards?baseAssetId=${data.baseAssetId}`),
        //     {},
        //     JSON.stringify(dataToPost),
        //     [ 201 ]
        // );
        return Promise.resolve(GetBoardByIdResponse);
    }
    /**
     * Retrieves a specific board by its ID
     */
    async getBoardById(boardId) {
        return Promise.resolve(GetBoardByIdResponse);
        // TODO: Implement once the API is ready in ACPCEDU-3727
        // return this._getResponse(this._getEndpointHref(`/api/v1/boards/${boardId}`));
    }
    /**
     * Retrieves all boards associated with a specific linked asset
     */
    async getBoards(baseAssetId) {
        const clonedResponse = JSON.parse(JSON.stringify(GetBoardByIdResponse));
        clonedResponse['repo:name'] = 'Another board name';
        clonedResponse['repo:assetId'] = 'urn:aaid:sc:VA6C2:61b71cdc-4d42-5ac2-8d19-dede02efdbbb';
        clonedResponse['repo:createDate'] = new Date('2024-10-01T21:59:01.415Z').toISOString();
        clonedResponse['repo:modifyDate'] = new Date('2024-10-02T21:59:06.565Z').toISOString();
        return Promise.resolve([GetBoardByIdResponse, clonedResponse]);
        // TODO: Implement once the API is ready in ACPCEDU-3896
        // return this._getResponse(
        //     this._getEndpointHref(`/api/v1/boards?baseAssetId=${baseAssetId}`)
        // );
    }
    /**
     * Adds a new post to an existing board
     */
    async addPost(boardId, data) {
        // TODO: Implement once the API is ready in ACPCEDU-3729
        return Promise.resolve(GetBoardByIdResponse);
    }
    /**
     * Removes a post from an existing board
     */
    async removePost(boardId, data) {
        // TODO: Implement once the API is ready in ACPCEDU-3729
        return Promise.resolve(GetBoardByIdResponse);
    }
    /**
     * Updates an existing board's properties, including description and posts
     */
    async updateBoard(data) {
        const { description: boardDescription, postsToAdd, postsToRemove, postsToUpdate } = data;
        const patchData = [];
        if (boardDescription) {
            patchData.push({
                op: 'replace',
                path: '/dc:description',
                value: boardDescription
            });
        }
        postsToAdd === null || postsToAdd === void 0 ? void 0 : postsToAdd.forEach((post) => {
            patchData.push({
                op: 'add',
                path: '/board#posts',
                value: JSON.stringify(post)
            });
        });
        postsToRemove === null || postsToRemove === void 0 ? void 0 : postsToRemove.forEach((postId) => {
            patchData.push({
                op: 'remove',
                path: `/board#posts/${postId}`
            });
        });
        // User is only allowed to update post description
        postsToUpdate === null || postsToUpdate === void 0 ? void 0 : postsToUpdate.forEach((post) => {
            patchData.push({
                op: 'replace',
                path: `/board#post/${post.id}/board#description`,
                value: post.description
            });
        });
        return Promise.resolve(GetBoardByIdResponse);
        // TODO: Handle this once we know the format in ACPCEDU-3808, ACPCEDU-3729
        // TODO: Implement once the API is ready in ACPCEDU-3762
        // const response = await this._doPatch(
        //     this._getEndpointHref(`/api/v1/boards/${boardId}`),
        //     {},
        //     JSON.stringify(patchData)
        // );
        // return response.json();
    }
    /**
     * Updates the users who can modify a board
     */
    async updateUsers(boardId) {
        return Promise.resolve(GetBoardByIdResponse);
        // TODO: Handle this once we know the post body format ACPCEDU-3896
        // const patchData: jsonpatch.OpPatch[] = [];
        // const response = await this._doPatch(
        //     this._getEndpointHref(`/api/v1/boards/${boardId}/users`),
        //     {},
        //     JSON.stringify(patchData)
        // );
        // return response.json();
    }
    /**
     * Permanently deletes a specific board
     */
    async deleteBoard(boardId) {
        return Promise.resolve();
        // TODO: Implement once the API is ready in ACPCEDU-3731
        // await this._doDelete(this._getEndpointHref(`/api/v1/boards/${boardId}`));
    }
    /**
     * Deletes all boards associated with a specific linked asset
     */
    async deleteBoardsUnderParent(baseAssetId) {
        return Promise.resolve();
        // TODO: Implement once the API is ready in ACPCEDU-3731
        // await this._doDelete(this._getEndpointHref(`/api/v1/boards?baseAssetId=${baseAssetId}`));
    }
    /**
     * Publishes a board, making it available for viewing
     */
    async publishBoard(boardId) {
        return Promise.resolve();
        // TODO: Implement once the API is ready in ACPCEDU-3888
        // await this._doDelete(this._getEndpointHref(`/api/v1/boards/${boardId}/:publish`));
    }
}
__decorate([
    cache(validateRequiredBoardLinks),
    __param(0, key)
], BoardsInterface.prototype, "_discoverLinks", null);
/* eslint-enable @typescript-eslint/no-unused-vars */

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class BoardListLoader {
    constructor(core) {
        this._core = core;
        this._boardsInterface = new BoardsInterface(core);
    }
    async observeBoardsFolder(remoteBoards) {
        // We fetched boards by the parent asset ID so each board will have the same boardsAssetId, just observe one of them
        const boardsAssetId = remoteBoards[0]['board:context']['boardsAssetId'];
        return this._core.hostAssetContext.getAssetWithCloudID(boardsAssetId);
    }
    async loadPage(options) {
        return this._loadPage(options);
    }
    async _loadPage(options) {
        const { filter, implicitFilter } = options;
        const baseAssetId = implicitFilter.baseAssetId || filter.baseAssetId;
        const remoteBoards = await this._boardsInterface.getBoards(baseAssetId);
        const session = this._core._getAssetPool().createLoaderUpdateSession(Date.now());
        const boards = BoardUpdater.updateRemoteItems(session, remoteBoards);
        session.commit();
        if (remoteBoards.length > 0) {
            this.observeBoardsFolder(remoteBoards).then((folder) => {
                // pin this to memory so Garbage Collector does not remove it as long as the list is still kept in memory
                implicitFilter._monitoredFolder = folder;
            });
        }
        return {
            items: boards,
            total: boards.length,
            mostRecentValidMutation: Date.now(),
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * TODO:
 * - Implement SAM.BoardContext; Must do component-type changes first ACPCEDU-3892
 */
class BoardContext {
    constructor(_core, _assetPool) {
        this._core = _core;
        this._assetPool = _assetPool;
        this._boardsInterface = new BoardsInterface(this._core);
        this._postPool = new ItemPool(this._core, 'post');
    }
    get postPool() {
        return this._postPool;
    }
    /** Updates a board asset within the asset pool, returning the mapped local Board instance */
    async updateBoardInPool(remoteData) {
        const session = this._core._getAssetPool().createMutationSession();
        const updatedBoard = BoardUpdater.updateRemoteItem(session, remoteData);
        session.commit();
        return updatedBoard;
    }
    /**
     * Retrieves a board asset from the asset pool, or fetches it from the server if it doesn't exist locally
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3727
     */
    async getBoardById(boardId) {
        const existingBoard = this._core._getAssetPool().getLocalItemById(boardId);
        if (existingBoard) {
            return existingBoard;
        }
        const remoteBoard = await this._boardsInterface.getBoardById(boardId);
        return this.updateBoardInPool(remoteBoard);
    }
    /**
     * Creates a new board asset
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3896
     */
    async createBoard(data) {
        // TODO[ACPCEDU-3984]: Validate board name
        if (!validatePlatformRepoName(data.name)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for the creation operation.');
        }
        const remoteBoard = await this._boardsInterface.createBoard(data);
        return this.updateBoardInPool(remoteBoard);
    }
    /**
     * Retrieves the uploads folder for the current user.
     * If the uploads folder does not exist, it will be created.
     * @throws {SAMError} if the uploads folder cannot be retrieved or created
     */
    async _getUserHomeUploadsFolder() {
        const uploadsPath = `${CLOUD_CONTENT_ROOT_FOLDER}/Uploads`;
        try {
            return await this._core.hostAssetContext.getAssetWithRepoPath(uploadsPath);
        }
        catch (error) {
            if (error instanceof SAMError && error.code === SAMErrorCode.NOT_FOUND) {
                const rootFolder = await this._core.hostAssetContext.getRootFolder();
                return rootFolder.createFolder(uploadsPath.split('/').pop());
            }
            throw SAMError.wrapErrorIfNeeded(SAMErrorCode.INTERNAL_ERROR, 'Failed to get uploads folder', error);
        }
    }
    /**
     * Uploads a file. If no parentAssetId is provided, the file will be uploaded to the user's Uploads folder.
     * @throws {SAMError} if the file cannot be uploaded or the parent asset cannot be found
     */
    async _uploadFileForAssetLinkPost(post) {
        let destinationFolder;
        if (post.parentAssetId) {
            destinationFolder = await this._core.hostAssetContext.getAssetWithCloudID(post.parentAssetId);
        }
        else {
            destinationFolder = await this._getUserHomeUploadsFolder();
        }
        return destinationFolder.importFile(post.blob, post.fileName, post.mediaType);
    }
    /**
     * Adds a new post to a board.
     * - If the type is AssetLink:
     *   - If assetId is provided then the board will create a reference to that asset. The blob is ignored in this case
     *   - If a blob is provided then the file will be uploaded and a new asset will be created from it which the board will reference
     * - If the type is Text then the board will create a new text post with the provided text
     * @throws {SAMError} for AssetLink posts:
     *   - If the blob is provided without fileName
     *   - If the blob is provided and the parent folder cannot be found or created
     *   - If neither an assetId nor a blob is provided
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3729
     */
    async addPost(_a) {
        var { boardId } = _a, post = __rest$2(_a, ["boardId"]);
        if (post.type === PostType.AssetLink) {
            if (!post.assetId && post.blob) {
                if (!post.fileName) {
                    throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'File name is required for asset link posts with a blob');
                }
                const uploadOptions = {
                    blob: post.blob,
                    fileName: post.fileName,
                    mediaType: post.mediaType,
                    parentAssetId: post.parentAssetId
                };
                const uploadedAsset = await this._uploadFileForAssetLinkPost(uploadOptions);
                post.assetId = uploadedAsset.id;
            }
            else if (!post.assetId) {
                throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Asset ID is required for asset link posts');
            }
        }
        const updateData = {
            boardId,
            postsToAdd: [post]
        };
        const remoteBoard = await this._boardsInterface.updateBoard(updateData);
        return this.updateBoardInPool(remoteBoard);
    }
    /**
     * Removes a post from a board asset
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3729
     */
    async removePost({ boardId, postId }) {
        // TODO: Handle this once we know the format in ACPCEDU-3808
        const updateData = {
            boardId,
            postsToRemove: [postId]
        };
        const remoteBoard = await this._boardsInterface.updateBoard(updateData);
        await this.updateBoardInPool(remoteBoard);
    }
    /**
     * Updates a post on a board asset
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3729
     */
    async updatePost(_a) {
        var { boardId } = _a, data = __rest$2(_a, ["boardId"]);
        const updateData = {
            boardId,
            postsToUpdate: [data]
        };
        const remoteBoard = await this._boardsInterface.updateBoard(updateData);
        await this.updateBoardInPool(remoteBoard);
    }
    /**
     * Retrieves all boards under a parent asset
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3726
     */
    getBoards(baseAssetId) {
        const loader = new BoardListLoader(this._core);
        const implicitFilter = new BoardFilter({ baseAssetId });
        return new ItemSource(this._assetPool, [loader], implicitFilter);
    }
    _cleanBoardName(name) {
        return name.trimEnd();
    }
    /**
     * Updates an Assignment's name
     * @throws {SAMError} If the assignment could not be renamed
     * @param assignmentId The assignment ID
     * @param newName The new name
     */
    async _renameBoard(boardId, newName) {
        // TODO[ACPCEDU-3984]: Validate board name
        const board = await this.getBoardById(boardId);
        try {
            // repositoryID must be present for the rename operation to work
            if (!board.repositoryID) {
                await board._load();
            }
            return board.rename(newName);
        }
        catch (error) {
            throw SAMError.wrapErrorIfNeeded(SAMErrorCode.INTERNAL_ERROR, `Could not rename asset "${boardId}"`, error);
        }
    }
    async _updateBoardManifest({ boardId, description }) {
        const updateData = {
            boardId,
            description
        };
        const remoteBoard = await this._boardsInterface.updateBoard(updateData);
        await this.updateBoardInPool(remoteBoard);
    }
    /**
     * Updates the description along with other manifest metadata of a board asset. To add/remove post, use addPost or removePost instead
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3729
     */
    async updateBoard({ boardId, description, displayName }) {
        const promises = [];
        const shouldRenameBoard = Boolean(displayName);
        if (shouldRenameBoard) {
            const cleanBoardName = `${this._cleanBoardName(displayName)}${Board.boardNameSuffix}`;
            promises.push(this._renameBoard(boardId, cleanBoardName));
        }
        promises.push(this._updateBoardManifest({ boardId, description }));
        await Promise.all(promises);
    }
    /**
     * Deletes a board asset permanently
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3731
     */
    async deleteBoard(boardId) {
        const board = await this.getBoardById(boardId);
        await this._boardsInterface.deleteBoard(boardId);
        const session = this._core._getAssetPool().createUpdateSession();
        session.queueDiscardedItem(board);
        session.commit();
        this._core._getAssetPool().removeLocalItems([boardId]);
    }
    /**
     * Deletes all boards under a parent asset
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3731
     */
    async deleteBoardsUnderParent(baseAssetId) {
        await this._boardsInterface.deleteBoardsUnderParent(baseAssetId);
    }
    /**
     * Publishes a board asset
     * @experimental Boards functionality is still in progress, this method is subject to change ACPCEDU-3896
     */
    async publishBoard(boardId) {
        await this._boardsInterface.publishBoard(boardId);
    }
    /**
     * Creates a BoardOrder object
     * @experimental
     *
     * @example <caption>Create a BoardOrder</caption>
     * const order = await boardContext.getBoardOrder('descending', 'created');
     */
    async getBoardOrder(direction = 'ascending', field = 'name') {
        const { default: BoardOrder } = await Promise.resolve().then(function () { return BoardOrder$1; });
        return new BoardOrder(direction, field);
    }
    /**
     * Creates a BoardFilter object
     * @experimental
     *
     * @example <caption>Create a BoardFilter</caption>
     * const filter = await boardContext.getBoardFilter({ baseAssetId: 'base-asset-id });
     */
    async getBoardFilter(options) {
        const { default: BoardFilter } = await Promise.resolve().then(function () { return BoardFilter$1; });
        return new BoardFilter(options);
    }
}
__decorate([
    keepAlive,
    weakCache,
    __param(0, key)
], BoardContext.prototype, "getBoards", null);
__decorate([
    synchronized
], BoardContext.prototype, "_renameBoard", null);

var BoardContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': BoardContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Internal filter that is for ensuring only libraries that are not hidden, discarded, etc. are shown in Library lists.
 * The Implicit Filter determines the nature of the LibrarySource.
 */
class ImplicitLibraryFilter extends ImplicitAdobeAssetFilterBase {
    constructor(filterOptions) {
        super({ _isSharedWithYou: true });
        this.filterOptions = filterOptions;
        if ((filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.owner) && filterOptions.owner.length > 0) {
            this._owner = new Set([...filterOptions.owner]);
        }
        if ((filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.roles) && filterOptions.roles.length > 0) {
            this._roles = new Set([...filterOptions.roles]);
        }
    }
    // used by ItemList and ItemLoaderState and is called when asset change notifications come in to check if the asset is still eligible to be on a particular list
    matches(item) {
        if (!item.isLibrary) {
            return false;
        }
        if (this._owner && !itemMatchesOwnerFilter(item, this._owner)) {
            return false;
        }
        if (this._roles && !itemMatchesRolesFilter(item, this._roles)) {
            return false;
        }
        return super.matches(item);
    }
}
ImplicitLibraryFilter.TrainingSets = new ImplicitLibraryFilter({
    owner: [LibraryOwnerFilter.All], roles: [LibraryRolesFilter.TrainingSet]
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Load Libraries from Melville
class LibraryListLoader {
    constructor(_libraryPool, _libraryInterface, _libraryUpdater) {
        this._libraryPool = _libraryPool;
        this._libraryInterface = _libraryInterface;
        this._libraryUpdater = _libraryUpdater;
    }
    // only supports LibraryFilter
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, pageLink) {
        var _a;
        let result;
        if (pageLink) {
            if (options.limit) {
                pageLink.href = pageLink.href.replace(/limit=[0-9]*/, `limit=${options.limit}`);
            }
            result = await this._libraryInterface.getLibrariesWithLink(pageLink);
        }
        else {
            const { limit } = options;
            const filter = options.filter;
            const implicitFilter = options.implicitFilter;
            const order = options.order;
            // Give preference to the implicit filter. Use default if filter is EverythingFilter.
            const ownerFilter = implicitFilter._owner || filter._owner || LibraryFilter.DEFAULT._owner;
            const rolesFilter = implicitFilter._roles || filter._roles;
            // Move filters into query parameters, making sure to sort the arrays so that the eventual query string is deterministic.
            const queryParams = {};
            queryParams.owner = [...ownerFilter].sort().join(',');
            if (rolesFilter) {
                queryParams.roles = [...rolesFilter].sort().join(',');
            }
            if (filter._project) {
                queryParams.team = filter._project;
            }
            if (filter._publishMetadata) {
                queryParams.itemFilter = filter._publishMetadata;
            }
            queryParams.orderBy = order.direction === 'ascending' ? OrderFieldToLibraryOrderBy[order.field] : `-${OrderFieldToLibraryOrderBy[order.field]}`;
            if (limit) {
                queryParams.limit = limit;
                if (!queryParams.start) {
                    queryParams.start = 0;
                }
            }
            // The selector specifies what data will be returned on each library.
            queryParams.selector = 'rendition_grid,collaboration';
            result = await this._libraryInterface.getLibraries(queryParams);
        }
        // Libraries listings from Melville are considered "USS" sources (with the current exception of a public libraries-only listing), and may have stale data.
        // To prevent it from potentially overwriting fresh RAPI data within the USS latency window, we will use
        // 'createLoaderUpdateSession' instead of 'createLoaderMutationSession' and this update will be ignored if there were local changes later than this timestamp.
        const latency = this._libraryPool._core._environment.getValue('USS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const session = this._libraryPool.createLoaderUpdateSession(mostRecentValidMutation);
        const items = this._libraryUpdater.updateRemoteItems(session, result.libraries); // get or create Library instances
        items.forEach(library => library._setLibraryLoadState('LOADED'));
        // Mark storage_assignee as loaded, so that we do not trigger a lazy load of the value.
        items.forEach(library => LazyLoadManager.updatedByItemUpdater(library, STORAGE_ASSIGNEE_CHANGED));
        session.commit(); // put items in the pool
        // Check if we have another page to load.
        let loadNextPage;
        const nextPageLink = (_a = result._links) === null || _a === void 0 ? void 0 : _a.next;
        if (nextPageLink) {
            loadNextPage = (options) => this._loadPage(options, nextPageLink);
        }
        return {
            items,
            total: result.total_count,
            loadNextPage,
            mostRecentValidMutation
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class LibrarySearchLoader {
    constructor(_libraryPool, _libraryInterface, _libraryUpdater) {
        this._libraryPool = _libraryPool;
        this._libraryInterface = _libraryInterface;
        this._libraryUpdater = _libraryUpdater;
    }
    supportsFilter(filter) {
        return filter !== undefined;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, pageLink) {
        var _a, _b;
        const { implicitFilter } = options;
        const { _query } = implicitFilter;
        // We will ignore the update if we had local changes sooner than this timestamp.
        // This default latency is set to 3 seconds right now. We should revisit this value.
        const latency = this._libraryPool._core._environment.getValue('PROJECTS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        let result;
        if (pageLink) {
            if (options.limit) {
                // replace the limit value in the URL with the provided limit value from the options.
                pageLink.href = pageLink.href.replace(/limit=[0-9]*/, `limit=${options.limit}`);
            }
            result = await this._libraryInterface.searchLibrariesWithLink(_query, pageLink);
        }
        else {
            result = await this._libraryInterface.searchLibraries(_query);
        }
        const session = this._libraryPool.createLoaderUpdateSession(mostRecentValidMutation);
        const items = this._libraryUpdater.updateRemoteItems(session, (_a = result.libraries) !== null && _a !== void 0 ? _a : []);
        for (const item of items) {
            LazyLoadManager.updatedByItemUpdater(item, STORAGE_ASSIGNEE_CHANGED);
        }
        session.commit();
        // Check if we have another page to load.
        let loadNextPage;
        const nextPageLink = (_b = result._links) === null || _b === void 0 ? void 0 : _b.next;
        if (nextPageLink) {
            loadNextPage = (options) => this._loadPage(options, nextPageLink);
        }
        implicitFilter._matchingIDsFromSearch = new Set([
            // copy existing, if needed
            ...(implicitFilter._matchingIDsFromSearch || []),
            ...(items.map(item => item.id))
        ]);
        return {
            items,
            total: result.total_count,
            loadNextPage,
            mostRecentValidMutation
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class LibrarySearchFilter extends ImplicitAdobeAssetFilterBase {
    constructor(options) {
        var _a, _b;
        super();
        this._query = '';
        this._query = (_b = (_a = options.query) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
    }
    get query() {
        return this._query;
    }
    matches(item) {
        if (!item.isLibrary) {
            return false;
        }
        // Check if the item's id is in the current filter's id list
        if (this._matchingIDsFromSearch && !this._matchingIDsFromSearch.has(item.id)) {
            return false;
        }
        // If the query exists but there's no id list, we probably haven't finished loading yet
        if ((this._query) && !this._matchingIDsFromSearch) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Represents a location in the user storage which are required to exist for the LibraryContext to function properly.
 * It provides functions to ensure the existence of the location and to watch for changes in the location.
 */
class SubscriptionLocation extends EventEmitter {
    constructor(cacheKey, path) {
        super();
        this._asset = undefined;
        this._callback = () => {
            this.emit('change');
        };
        this._cacheKey = cacheKey;
        this._path = path;
    }
    get cacheKey() { return this._cacheKey; }
    get path() { return this._path; }
    get asset() { return this._asset; }
    async ensureExistence(context, libraryInterface) {
        const environment = context._core._environment;
        const cache = environment.cache;
        const cacheKey = this._cacheKey;
        const assetId = await cache.getItem(cacheKey);
        try {
            const asset = assetId !== NotFound$1 ? await context.getAssetWithCloudID(assetId) : await context.getAssetWithRepoPath(this._path);
            cache.setItem(cacheKey, asset.cloudID);
            return this._setAsset(asset, cache);
        }
        catch (e) {
            if (e.code === SAMErrorCode.NOT_FOUND) {
                environment.debug(`${this._path} not found, creating it now`);
                const asset = await this._create(context, libraryInterface);
                return this._setAsset(asset, cache);
            }
            throw e;
        }
    }
    async _setAsset(asset, cache) {
        this._asset = asset;
        await cache.setItem(this._cacheKey, asset.cloudID);
        this._setUpWatcher();
        return asset;
    }
}
class SyncGroupLocation extends SubscriptionLocation {
    constructor() {
        super('SYNC_GROUP_ID', '/assets/adobe-libraries');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async _create(context, libraryInterface) {
        return await (await context.getHomeFolder()).createFolder(this.path);
    }
    _setUpWatcher() {
        var _a;
        (_a = this._asset) === null || _a === void 0 ? void 0 : _a.on('change', this._callback);
    }
}
class BookmarkLocation extends SubscriptionLocation {
    constructor(cacheKey, path) {
        super(cacheKey, path);
    }
    async _create(context, libraryInterface) {
        // call to Melville's GET /bookmarks endpoint ensures that the bookmarks are created
        await libraryInterface.getBookmarks();
        return context.getAssetWithRepoPath(this.path);
    }
    _setUpWatcher() {
        var _a, _b;
        (_a = this._asset) === null || _a === void 0 ? void 0 : _a.on('change', this._callback);
        (_b = this._asset) === null || _b === void 0 ? void 0 : _b.appMetadata.on('change', this._callback);
    }
}
class CollabBookmarkLocation extends BookmarkLocation {
    constructor() {
        super('COLLAB_BOOKMARKS_ID', '/sync/adobe-libraries/collab-bookmarks.json');
    }
}
class PublicBookmarkLocation extends BookmarkLocation {
    constructor() {
        super('PUBLIC_BOOKMARKS_ID', '/sync/adobe-libraries/bookmarks.json');
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Provides all Library related functionality like getting
 * lists of libraries among other features.
 *
 * @experimental This API is in an experimental phase so expect that
 * APIs will not be final and there will be breaking changes
 * without bumping the major version until this comment is removed.
 */
class LibraryContext {
    constructor(_core, __assetPool) {
        this._core = _core;
        this.__assetPool = __assetPool;
        /**
         * @package -- only for use in SAM.js
         */
        this._libraryUpdater = LibraryUpdater;
        /**
         * @package -- only for use in SAM.js
         */
        this._libraryInterface = new LibraryInterface(this._core);
        /**
         * @package -- only for use in SAM.js
         */
        this._syncGroupLocation = new SyncGroupLocation();
        /**
         * @package -- only for use in SAM.js
         */
        this._publicBookmarkLocation = new PublicBookmarkLocation();
        /**
         * @package -- only for use in SAM.js
         */
        this._collabBookmarkLocation = new CollabBookmarkLocation();
    }
    /**
     * @package -- for use in SAM.js only
     */
    get _assetPool() {
        return this.__assetPool;
    }
    /**
     * Returns the LibrarySource which will return a list of the user's libraries.
     * To request a different set of libraries, create a new LibraryFilter and pass it to the getList method.
     * @example
     * const libraryContext = await core.getLibraryContext();
     * const order = new LibraryOrder('ascending', 'modified');
     * const filter = LibraryFilter.AllLibraries; // If no filter is provided, will default to all of the user's libraries.
     * const libraryList = libraryContext.librariesSource.getList(order, filter, loadOptions);
     * libraryList.on(STATE_CHANGED, () => {
     *     if (libraryList.status !== AssetListStatus.Loading) { const libraries = libraryList.items; }
     * });
     * Note: loadOptions.limit will be ignored on public libraries, which are not currently paginated.
     */
    get librariesSource() {
        const loader = new LibraryListLoader(this._assetPool, this._libraryInterface, this._libraryUpdater);
        this._ensureSubscriptionLocationExistence() // start listening for changes to subscription locations
            .then(() => {
            this._publicBookmarkLocation.on('change', this._onPublicBookmarksChanged.bind(this));
            this._collabBookmarkLocation.on('change', this._onCollabBookmarksChanged.bind(this));
        })
            .catch(error => {
            this._core._environment.error(`Error ensuring subscription location existence: ${error}`);
        });
        return new ItemSource(this._assetPool, [loader], new ImplicitLibraryFilter());
    }
    _onPublicBookmarksChanged() {
        for (const list of this.librariesSource._getLists()) {
            if (list.filter._owner.has(LibraryOwnerFilter.Public)) {
                list.refresh();
            }
        }
    }
    _onCollabBookmarksChanged() {
        for (const list of this.librariesSource._getLists()) {
            // Note: If LibraryOwnerFilter.Other is ever enabled, it should be included in this check.
            if (list.filter._owner.has(LibraryOwnerFilter.Incoming)) {
                list.refresh();
            }
        }
    }
    /**
     * @package -- for use in SAM.js only
     */
    async _createLibrary(options) {
        if (!validatePlatformRepoName(options.name)) {
            // Validate the name here to avoid resolving the asset if the name is invalid.
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid name provided for the createLibrary operation.');
        }
        const libraryData = await this._libraryInterface.createLibrary(options);
        const session = this._assetPool.createMutationSession();
        const library = this._libraryUpdater.updateRemoteItem(session, libraryData);
        library._setLibraryLoadState('LOADED');
        session.commit();
        return library;
    }
    /**
     * Provides the source to search for Libraries by a full or partial name.
     *
     * @param {string} query The full or partial Library name to search for.
     * @returns {LibrarySearchSource} The source on which getList() is called to get the list of libraries that match the query.
     * @example
     * const libraryContext = await core.getLibraryContext();
     * const librarySource = libraryContext.getLibrarySearchSource('full-or-partial-library-name');
     * const libraryList = librarySource.getList(LibraryOrder.default);
     */
    getLibrarySearchSource(query) {
        const implicitFilter = new LibrarySearchFilter({ query });
        const loader = new LibrarySearchLoader(this._assetPool, this._libraryInterface, this._libraryUpdater);
        return new ItemSource(this._assetPool, [loader], implicitFilter);
    }
    /**
     * Creates a personal library.
     *
     * @example
     * const libraryContext = await core.getLibraryContext();
     * const roles: LibraryRole[] = [{
     *      type: 'brand',
     *      usage: 'usage_brand',
     *      priority: 'priority_brand'
     * }];
     * const library = libraryContext.createLibrary({ name: 'test', roles });
     *
     */
    async createPersonalLibrary(data) {
        const options = { syncCreate: true, name: data.name, roles: data.roles };
        return this._createLibrary(options);
    }
    async _getLibraryLocally(assetId) {
        // Locate the library in the local pool
        const library = this._assetPool.getLocalItemById(assetId);
        if (!library) {
            // Library not found locally.
            return undefined;
        }
        // This will go to Melville only if the library is not fully loaded.
        await library._waitForLibraryLoad();
        return library;
    }
    /**
     * @package -- for use in SAM.js only
     */
    async _getLibraryRemotely(assetId, options) {
        // Load the library from Melville. There will be a network call here.
        const libraryData = await this._libraryInterface.getLibraryData(assetId, options);
        if (!libraryData) {
            return undefined;
        }
        const session = this._assetPool.createMutationSession();
        const updatedLibrary = this._libraryUpdater.updateRemoteItem(session, libraryData);
        session.commit();
        return updatedLibrary;
    }
    _isValidURN(id) {
        const urnRegex = /^urn:[a-zA-Z0-9][a-zA-Z0-9-]{0,31}:[a-zA-Z0-9()+,\-.:=@;$_!*'%/?#]+$/;
        return urnRegex.test(id);
    }
    // assetId can be LibraryAssetId or, currently, PublicLibraryId.
    // TODO: Once [CCXB-21655] is complete, this will support assetIDs for public libraries.
    // At that point, we can remove tryRemoteOnly.
    // TODO: This should actually be named getLibraryByID() per https://wiki.corp.adobe.com/display/ACPCSDK/SAM+and+CC+Libraries+Strategic+Direction
    async getLibraryByAssetId(assetId) {
        const tryLocalThenRemote = async (id) => {
            let library = await this._getLibraryLocally(id);
            if (!library) {
                library = await this._getLibraryRemotely(id);
            }
            return library;
        };
        const tryRemoteOnly = async (id) => {
            return await this._getLibraryRemotely(id);
        };
        // For private libraries, we first try to get the library locally and then remotely using the asset id.
        // For public libraries, we only try to get the libraries remotely using the public library id.
        const library = this._isValidURN(assetId)
            ? await tryLocalThenRemote(assetId)
            : await tryRemoteOnly(assetId);
        if (!library) {
            throw SAMError.create(SAMErrorCode.NOT_FOUND, `Library not found for the given ID: ${assetId}`);
        }
        return library;
    }
    /**
     * should be called once the client is interested in libraries listing
     * @package -- for use in SAM.js only
     * @returns Promise<void> - resolves when the special library locations are ensured to exist
     */
    async _ensureSubscriptionLocationExistence() {
        const assetContext = await this._core.getAssetContext();
        return Promise.allSettled([
            this._syncGroupLocation.ensureExistence(assetContext, this._libraryInterface),
            this._publicBookmarkLocation.ensureExistence(assetContext, this._libraryInterface),
            this._collabBookmarkLocation.ensureExistence(assetContext, this._libraryInterface)
        ]).then(results => {
            results.forEach(result => {
                if (result.status === 'rejected') {
                    throw result.reason;
                }
            });
            return;
        });
    }
    /**
     * @experimental
     */
    async getLibraryOrder(direction = 'descending', field = 'modified') {
        const { default: LibraryOrder } = await Promise.resolve().then(function () { return LibraryOrder$1; });
        return new LibraryOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getLibraryFilter(options) {
        const { default: LibraryFilter } = await Promise.resolve().then(function () { return LibraryFilter$1; });
        return new LibraryFilter(options);
    }
    /**
     * Called to obtain the CCLibraries instance.
     * @package -- for use in SAM.js only
     * @returns Promise<CCLibraries> - resolves with the CCLibraries instance.
     */
    async _getLibrariesModule() {
        if (!this._ccLibraries) {
            // TODO: Switch to using a common component config per [ACPCSDK-3]
            try {
                const { default: CCLibraries, CloudDriver } = await Promise.resolve().then(function () { return index; });
                const token = this._core._environment.getValue('ACCESS_TOKEN');
                const env = (this._core._environment.getValue('ENVIRONMENT') === Env.Production) ? 'production' : 'staging';
                const cloudDriver = new CloudDriver(this._core, async () => ({ env, token, options: {} }));
                await cloudDriver.init();
                const initializationOptions = { disableLocalFallthrough: true, skipConnectingOnInit: false, disablePreemptiveLibraryLoad: true };
                this._ccLibraries = new CCLibraries(this._core, this._assetPool, cloudDriver, initializationOptions);
            }
            catch (error) {
                this._core._environment.error(`Error loading CCLibraries module: ${error}`);
                throw error;
            }
        }
        return this._ccLibraries;
    }
    /**
     * Called to obtain the CCLibraries instance.
     * @package -- for use in SAM.js only
     * Use from within the CCLibraries Module code, where we know the instance is already available.
     */
    _getLibrariesModule_NoLoad() {
        return this._ccLibraries;
    }
}
__decorate([
    memoize$1
], LibraryContext.prototype, "librariesSource", null);
__decorate([
    keepAlive
], LibraryContext.prototype, "createPersonalLibrary", null);
__decorate([
    keepAlive
], LibraryContext.prototype, "getLibraryByAssetId", null);

var LibraryContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': LibraryContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CustomModelLoader$1 {
    constructor(_assetPool, _core, _customModelInterface) {
        this._assetPool = _assetPool;
        this._core = _core;
        this._customModelInterface = _customModelInterface;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, pageLink) {
        var _a;
        let result;
        if (pageLink) {
            // We are loading the next page with the link provided.
            result = await this._customModelInterface.getCustomModelsUsingPageLink(pageLink);
        }
        else {
            const { order, limit } = options;
            const field = order.field;
            const queryParams = {};
            queryParams.orderBy = order.direction === 'ascending' ? OrderFieldToCustomModelOrderBy[field] : `-${OrderFieldToCustomModelOrderBy[field]}`;
            if (limit) {
                queryParams.limit = limit;
                if (!queryParams.start) {
                    queryParams.start = 0;
                }
            }
            result = await this._customModelInterface.getCustomModels(queryParams);
        }
        const latency = this._core._environment.getValue('USS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const session = this._assetPool.createLoaderUpdateSession(mostRecentValidMutation);
        const items = CustomModelUpdaterMelville.updateRemoteItems(session, result.custom_models);
        session.commit();
        let loadNextPage;
        // Currently there is an issue where the next page info doesn't show for custom model listings
        // follow this pr: https://git.corp.adobe.com/Stormcloud/melville/pull/2051/files
        const nextPageLink = (_a = result._links) === null || _a === void 0 ? void 0 : _a.next;
        if (nextPageLink) {
            loadNextPage = (options) => this._loadPage(options, nextPageLink);
        }
        return {
            items,
            total: result.total_count,
            loadNextPage,
            mostRecentValidMutation
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const makeDateRange = (max, min) => {
    return ((max || min) ? { min: getDateString(min), max: getDateString(max) } : undefined);
};
const getDateString = (date) => {
    return (date ? date.toISOString() : date);
};

class CustomModelSearchLoader$1 {
    constructor(_core, _customModelContext) {
        this._core = _core;
        this._customModelContext = _customModelContext;
        this._ussInterface = this._core.hostAssetContext._ussInterface;
        this._ussLoaderHelper = new USSLoaderHelper(this._core.hostAssetContext._assetPool, _core, this);
    }
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    loadPage(options) {
        return this._ussLoaderHelper.loadPage(options);
    }
    /**
     * @package -- for use by USSLoaderHelper
     */
    async _getUSSResults(options) {
        var _a, _b;
        const { implicitFilter: { query }, filter: { listingOptions }, order: customModelOrder } = options;
        const createDateRange = makeDateRange(listingOptions === null || listingOptions === void 0 ? void 0 : listingOptions.createDateMax, listingOptions === null || listingOptions === void 0 ? void 0 : listingOptions.createDateMin);
        const modifyDateRange = makeDateRange(listingOptions === null || listingOptions === void 0 ? void 0 : listingOptions.modifyDateMax, listingOptions === null || listingOptions === void 0 ? void 0 : listingOptions.modifyDateMin);
        const ussQuery = Object.assign(Object.assign({ hints: [{ acp_platform_v2: true, creative_cloud_rendition_v2: true }], asset_name: query, limit: (_a = options.limit) !== null && _a !== void 0 ? _a : 100, start_index: (_b = options === null || options === void 0 ? void 0 : options.start) !== null && _b !== void 0 ? _b : 0, [SearchProps.TYPE]: [CUSTOM_MODEL_MEDIA_TYPE], creative_cloud_asset_type: 'dcx' }, customModelOrderToUSSOrder(customModelOrder)), { fetch_fields: {
                includes: [
                    '_embedded',
                    'stock_content',
                    'link_additional_metadata',
                    'app_metadata',
                    'firefly#cme$$baseModelName',
                    'firefly#cme$$baseModelVersion',
                    'firefly#cme$$conceptId',
                    'firefly#cme$$trainingMode',
                    'firefly#cme$$superclass',
                    'firefly#cme$$version',
                    'firefly#ffmodel'
                ]
            }, 'app_metadata$$cme:publishedState': listingOptions === null || listingOptions === void 0 ? void 0 : listingOptions.publishedState, sync_created_date: createDateRange ? { range: createDateRange } : undefined, sync_updated_date: modifyDateRange ? { range: modifyDateRange } : undefined });
        return this._ussInterface.getQueryResponse(ussQuery);
    }
    /**
     * @package -- only for use by USSLoaderHelper
     */
    _postProcessPage({ implicitFilter }, page) {
        const { items } = page;
        implicitFilter._matchingIDsFromSearch = new Set([
            // copy existing, if needed
            ...(implicitFilter._matchingIDsFromSearch || []),
            ...(items.map(item => item.id))
        ]);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CustomModelSearchFilter$1 extends ImplicitCustomModelFilter$1 {
    constructor(options) {
        const { query } = options, superOptions = __rest$2(options, ["query"]);
        super(superOptions);
        this._query = query.trim();
    }
    get query() {
        return this._query;
    }
    matches(item) {
        // Check if the item's id is in the current filter's id list
        if (this._matchingIDsFromSearch && !this._matchingIDsFromSearch.has(item.id)) {
            return false;
        }
        // If the query exists but there's no id list, we probably haven't finished loading yet
        if ((this._query) && !this._matchingIDsFromSearch) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class LegacyCustomModel extends AdobeAsset {
    constructor() {
        super(...arguments);
        this.isCustomModel = true;
        this._inferenceReady = false;
        this._publishedState = CustomModelPublishedState.UNPUBLISHED;
        this._samplePrompt = '';
        this._displayName = '';
        this._baseModelName = '';
        this._baseModelVersion = '';
        this._conceptId = '';
        this._trainingMode = '';
    }
    get inferenceReady() {
        return this._inferenceReady;
    }
    get publishedState() {
        return this._publishedState;
    }
    get samplePrompt() {
        return this._samplePrompt;
    }
    get renditionUrl() {
        return this._renditionUrl;
    }
    get displayName() {
        return this._displayName;
    }
    get baseModelName() {
        return this._baseModelName;
    }
    get baseModelVersion() {
        return this._baseModelVersion;
    }
    get conceptId() {
        return this._conceptId;
    }
    get trainingMode() {
        return this._trainingMode;
    }
}
__decorate([
    observable$1
], LegacyCustomModel.prototype, "inferenceReady", null);
__decorate([
    observable$1
], LegacyCustomModel.prototype, "publishedState", null);
__decorate([
    observable$1
], LegacyCustomModel.prototype, "samplePrompt", null);
__decorate([
    observable$1
], LegacyCustomModel.prototype, "renditionUrl", null);
__decorate([
    observable$1
], LegacyCustomModel.prototype, "displayName", null);
__decorate([
    observable$1
], LegacyCustomModel.prototype, "baseModelName", null);
__decorate([
    observable$1
], LegacyCustomModel.prototype, "baseModelVersion", null);
__decorate([
    observable$1
], LegacyCustomModel.prototype, "conceptId", null);
__decorate([
    observable$1
], LegacyCustomModel.prototype, "trainingMode", null);
const LegacyCustomModelUpdater = new ItemUpdater({
    localItemType: LegacyCustomModel,
    remoteIdProperty: 'assetId',
    propertyUpdater: new PropertyUpdater({
        '_inferenceReady': { name: 'inferenceReady', format: 'boolean' },
        // TODO: create a type with array of choices?
        '_publishedState': 'publishedState',
        '_samplePrompt': 'samplePrompt',
        '_renditionUrl': 'renditionUrl',
        '_displayName': 'displayName',
        '_baseModelName': 'baseModelName',
        '_baseModelVersion': 'baseModelVersion',
        '_conceptId': 'conceptId',
        '_trainingMode': 'trainingMode',
        // on AdobeAsset
        '_links': { name: '_links', format: 'object' },
        '_name': 'assetName',
        '_path': 'path',
        '_created': { name: 'createDate', format: 'date' },
        '_modified': { name: 'modifyDate', format: 'date' },
        '_createdBy': 'createdBy',
        '_version': 'version',
        '_etag': 'etag',
        '_storageRegion': 'region',
        '_size': { name: 'size', format: 'number' },
    }),
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CustomModelLoader {
    constructor(_assetPool, _core, _customModelInterface) {
        this._assetPool = _assetPool;
        this._core = _core;
        this._customModelInterface = _customModelInterface;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, startIndex) {
        var _a;
        const { order, limit, filter } = options;
        const customModelFilter = filter;
        const listingOptions = customModelFilter.listingOptions;
        const listOptions = Object.assign({ orderBy: LegacyOrderFieldToCustomModelOrderBy[order.field], limit }, listingOptions);
        const result = await this._customModelInterface.getCustomModels(startIndex ? Object.assign(Object.assign({}, listOptions), { startIndex }) : listOptions);
        const session = this._assetPool.createLoaderUpdateSession(Date.now() - this._core._environment.getValue('USS_LIST_UPDATE_LATENCY'));
        const items = LegacyCustomModelUpdater.updateRemoteItems(session, result.items);
        session.commit();
        // Check if we have another page to load.
        let loadNextPage;
        const nextPageLink = (_a = result.nextPage) === null || _a === void 0 ? void 0 : _a.startIndex;
        if (nextPageLink) {
            loadNextPage = (options) => this._loadPage(options, nextPageLink);
        }
        return {
            items,
            loadNextPage,
            total: result.total
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const REGION_MAP = {
    VA6C2: 'va6',
    VA6: 'va6',
    VA7: 'va6',
    JPN3: 'jpn3',
    IRL1: 'irl1',
};
class CustomModelInterface extends InterfaceBase {
    _getMelvilleUrl(endpoint) {
        return `https://${this._core._environment.endpoints.MELVILLE_HOST}${endpoint}`;
    }
    //
    async _getFetchOptionOverrides(originalHref, originalOptions) {
        const { href, options } = await super._getFetchOptionOverrides(originalHref, originalOptions);
        return {
            href,
            options: Object.assign(Object.assign({}, options), { headers: Object.assign(Object.assign({}, options.headers), { 'X-Product-Location': `SAM.js/${packageJSON.version}` }) })
        };
    }
    async _getUrl(endpoint) {
        const homeFolder = await this._core.hostAssetContext.getHomeFolder();
        const region = REGION_MAP[homeFolder.storageRegion];
        const acpHost = this._core._environment.endpoints.ACP_CS_HOST;
        const subdomain = acpHost.split('.')[0];
        const regionalizedSubdomain = `${subdomain}-${region}`;
        // Replaces non-regionalized subdomain with its' regionalized version, using the region of the homeFolder eg.
        //
        //   when storage region = 'JPN3':
        //     platform-cs-stage.adobe.io =>
        //     platform-cs-stage-${REGION_MAP[JPN3]}.adobe.com =>
        //     platform-cs-stage-jpn3.adobe.com
        //
        //   when storage region = 'IRL1':
        //     platform-cs-stage.adobe.io =>
        //     platform-cs-stage-${REGION_MAP[IRL1]}.adobe.com =>
        //     platform-cs-stage-irl1.adobe.com
        return `https://${acpHost.replace(subdomain, regionalizedSubdomain)}/fps/${endpoint}`;
    }
    /**
   * Fetches the list of custom models based on the options provided
   * @param options : options to sort and filter the projects listing
   * @returns the list of custom models along with the page information and links to the next page
   */
    async getCustomModels(options) {
        const queryParams = options
            ? JSON.parse(JSON.stringify(options))
            : {};
        const url = fillURLTemplate$1(await this._getUrl('customModels'), queryParams);
        return this._getResponse(url);
    }
    /**
     * Create a training set to be used with a custom model. The training set is considered a child of the parent asset
     * specified by the parentAssetId.
     */
    async createTrainingSet(options) {
        if (!options.name) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid argument: missing required name');
        }
        if (!options.projectId) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid argument: missing required projectId. The parent must be a project');
        }
        if (!options['firefly#ffmodel'].schemaVersion) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Invalid argument: missing required schemaVersion.');
        }
        const creationOptions = {
            name: options.name,
            parent_assetId: options.projectId,
            roles: [{
                    type: 'cm_training_set'
                }],
            // this key is not currently used by melville but will soon be enabled
            // sending it does not affect the request
            'firefly#ffmodel': options['firefly#ffmodel'],
            // TODO: remove this when melville switches to 'firefly#ffmodel'
            'firefly#cme': Object.assign(Object.assign({}, options['firefly#ffmodel']), { version: options['firefly#ffmodel'].schemaVersion })
        };
        const libraryContext = await this._core.getLibraryContext();
        return libraryContext._createLibrary(creationOptions);
    }
    async getTrainingSetById(assetId) {
        const libraryContext = await this._core.getLibraryContext();
        return libraryContext._getLibraryRemotely(assetId);
    }
    async createCustomModel(options) {
        const endpoint = `/api/v1/custom-models`;
        const response = await this._doPost(this._getMelvilleUrl(endpoint), { 'Content-Type': 'application/json' }, JSON.stringify(options), [201, 200]);
        const idString = response.headers.get('asset-id');
        if (!idString) {
            throw SAMError.create(SAMErrorCode.NOT_FOUND, 'Asset id for newly created custom model not returned by melville');
        }
        return { id: idString };
    }
}

class CustomModelSearchLoader {
    constructor(_assetPool, _core, _customModelInterface) {
        this._assetPool = _assetPool;
        this._core = _core;
        this._customModelInterface = _customModelInterface;
    }
    supportsFilter(filter) {
        // If we don't provide a filter at all, then we cannot use the loader
        return filter !== undefined;
    }
    async loadPage(options) {
        return this._loadPage(options);
    }
    async _loadPage(options, startIndex) {
        var _a;
        const { order, limit, implicitFilter, filter } = options;
        const customModelSearchFilter = implicitFilter;
        const customModelFilter = filter;
        const listingOptions = ('listingOptions' in customModelFilter && customModelFilter['listingOptions']) || [];
        const listOptions = Object.assign(Object.assign({ orderBy: LegacyOrderFieldToCustomModelOrderBy[order.field], limit }, listingOptions), { name: customModelSearchFilter.query });
        const result = await this._customModelInterface.getCustomModels(startIndex ? Object.assign(Object.assign({}, listOptions), { startIndex }) : listOptions);
        const session = this._assetPool.createLoaderUpdateSession(Date.now() - this._core._environment.getValue('USS_LIST_UPDATE_LATENCY'));
        const items = LegacyCustomModelUpdater.updateRemoteItems(session, result.items);
        session.commit();
        // Check if we have another page to load.
        let loadNextPage;
        const nextPageLink = (_a = result.nextPage) === null || _a === void 0 ? void 0 : _a.startIndex;
        if (nextPageLink) {
            loadNextPage = (options) => this._loadPage(options, nextPageLink);
        }
        implicitFilter._matchingIDsFromSearch = new Set([
            // copy existing, if needed
            ...(implicitFilter._matchingIDsFromSearch || []),
            ...(items.map(item => item.id))
        ]);
        return {
            items,
            loadNextPage,
            total: result.total
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ImplicitCustomModelFilter extends ImplicitAdobeAssetFilterBase {
    constructor(options) {
        super(options);
    }
    matches(item) {
        if (!item.isCustomModel) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CustomModelSearchFilter extends ImplicitCustomModelFilter {
    constructor(options) {
        const { query } = options, superOptions = __rest$2(options, ["query"]);
        super(superOptions);
        this._query = query.trim();
    }
    get query() {
        return this._query;
    }
    matches(item) {
        // Check if the item's id is in the current filter's id list
        if (this._matchingIDsFromSearch && !this._matchingIDsFromSearch.has(item.id)) {
            return false;
        }
        // If the query exists but there's no id list, we probably haven't finished loading yet
        if ((this._query) && !this._matchingIDsFromSearch) {
            return false;
        }
        return super.matches(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Provides Custom Model functionality such as listing.
 *
 * @experimental This API is in an experimental phase so expect that
 * API's will not be final and there will be breaking changes
 * without bumping the major version until this comment is removed.
 */
class LegacyCustomModelContext {
    constructor(
    /**
     * @package -- for use in SAM.js only
     */
    _core, 
    /**
     * @package -- for use in SAM.js only
     */
    _assetPool) {
        this._core = _core;
        this._assetPool = _assetPool;
        this._customModelInterface = new CustomModelInterface(this._core);
        /**
         * @package -- only for use in SAM.js
         * Updaters shouldn't be accessed directly.
         */
        this._customModelUpdater = LegacyCustomModelUpdater;
        /**
         * @package -- only for use in SAM.js
         */
        this._libraryInterface = new LibraryInterface(this._core);
    }
    /**
     * @experimental
     */
    async getCustomModelOrder(direction = 'descending', field = 'modified') {
        const { default: LegacyCustomModelOrder } = await Promise.resolve().then(function () { return LegacyCustomModelOrder$1; });
        return new LegacyCustomModelOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getCustomModelFilter(options) {
        const { default: LegacyCustomModelFilter$1 } = await Promise.resolve().then(function () { return LegacyCustomModelFilter; });
        return new LegacyCustomModelFilter$1(options);
    }
    /**
   * @example
   * const customModelContext = samCore.customModelContext;
   * const customModelSource = customModelContext.customModelSearchSource;
   *
   * Search custom models a user has access to by name. The set of assets returned in a list is static once the
   * search is executed - ie newly created items which fit a list will not be added, edits to items which qualify
   * them to be part of a list will not have any effect. However, discard/delete/permission loss will still be
   * reflected.
   */
    customModelSearchSource(query) {
        // declare an implicitFilter
        const implicitFilter = new CustomModelSearchFilter({ query });
        // declare a CustomModelSearchLoader
        return new ItemSource(this._assetPool, [
            new CustomModelSearchLoader(this._assetPool, this._core, this._customModelInterface),
        ], implicitFilter);
    }
    /**
   * @example
   * const customModelContext = samCore.customModelContext;
   * const customModelSource = customModelContext.customModelSource;
   *
   * Gets all custom models a user has access to
   */
    get customModelSource() {
        return new ItemSource(this._assetPool, [
            new CustomModelLoader(this._assetPool, this._core, this._customModelInterface),
        ], new ImplicitCustomModelFilter());
    }
    async createTrainingSet(options) {
        return this._customModelInterface.createTrainingSet(options);
    }
    /**
     * Returns the `TrainingSetSource` which will return a list of training set libraries the user has access to.
     * @example
     * const context = await core.getCustomModelContext();
     * const order = new LibraryOrder('ascending', 'modified');
     * const filter = TrainingSetFilter.DEFAULT;
     * const list = await context.trainingSetsSource().getList(order, filter, loadOptions);
     * list.on(STATE_CHANGED, () => {
     *     if (list.status !== AssetListStatus.Loading) { const trainingSets = list.items; }
     * });
     */
    async trainingSetsSource() {
        const libraryContext = await this._core.getLibraryContext();
        const loader = new LibraryListLoader(libraryContext._assetPool, this._libraryInterface, LibraryUpdater);
        return new ItemSource(libraryContext._assetPool, [loader], ImplicitLibraryFilter.TrainingSets);
    }
    /* We need to always fetch remotely because local training sets might have been populated by a melville listing,
     * and those training sets don't have custom model data.
     */
    async getTrainingSetById(assetId) {
        return this._customModelInterface.getTrainingSetById(assetId);
    }
    async createCustomModel(options) {
        return this._customModelInterface.createCustomModel(options);
    }
}
__decorate([
    memoize$1
], LegacyCustomModelContext.prototype, "customModelSource", null);
__decorate([
    memoize$1
], LegacyCustomModelContext.prototype, "trainingSetsSource", null);

class TrainingSetFilter extends LibraryFilter {
    constructor(options) {
        super(Object.assign(Object.assign({}, options), { owner: [LibraryOwnerFilter.All], roles: [LibraryRolesFilter.TrainingSet] }));
    }
}
TrainingSetFilter.DEFAULT = new TrainingSetFilter();

class ImplicitCustomModelDashboardFilter {
    constructor(options = {}) {
        this._customModelFilter = options.customModelFilter || new CustomModelFilter$1();
        this._trainingSetFilter = options.trainingSetFilter || new TrainingSetFilter();
    }
    get _owner() {
        return this._trainingSetFilter ? this._trainingSetFilter._owner : undefined;
    }
    get _roles() {
        return this._trainingSetFilter ? this._trainingSetFilter._roles : undefined;
    }
    matches(item) {
        if (isCustomModel(item)) {
            return !!this._customModelFilter && this._customModelFilter.matches(item);
        }
        if (isLibrary(item)) {
            return !!this._trainingSetFilter && this._trainingSetFilter.matches(item);
        }
        return false;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Provides Custom Model functionality such as listing.
 *
 * @experimental This API is in an experimental phase so expect that
 * API's will not be final and there will be breaking changes
 * without bumping the major version until this comment is removed.
 */
class CustomModelContext {
    constructor(
    /** @package -- for use in SAM.js only
     */
    _core, 
    /** @package -- for use in SAM.js only
     */
    _assetPool) {
        this._core = _core;
        this._assetPool = _assetPool;
        this._customModelInterface = new CustomModelInterface$1(this._core);
        /** @package -- only for use in SAM.js Updaters shouldn't be accessed directly.
         */
        this._customModelUpdaterMelville = CustomModelUpdaterMelville;
        /**
         * @package -- only for use in SAM.js
         */
        this._libraryInterface = new LibraryInterface(this._core);
    }
    /** @deprecated -- prefer use of CustomModelContext
     */
    get legacyCustomModelContext() {
        if (!this._LegacyCustomModelContext) {
            this._LegacyCustomModelContext = new LegacyCustomModelContext(this._core, this._assetPool);
        }
        return this._LegacyCustomModelContext;
    }
    /**
   * The accuracy of a search source is ephemeral in that after the search is executed, the collection of returned assets
   * returned can no longer be assumed to be the complete set of assets that meet the search criteria. ie as new assets
   * are added/removed which should alter assets in the source, the source will not be live updated and will need to be
   * recreated (refetched) from USS to get the latest set of qualifying assets.
   */
    customModelSearchSource(query) {
        const implicitFilter = new CustomModelSearchFilter$1({ query });
        return new ItemSource(this._assetPool, [new CustomModelSearchLoader$1(this._core, this)], implicitFilter);
    }
    /*This source contains:
     *  - All training sets a user has access to
     *  - All custom models for which the user is a generator
     * The only way to detect if the user is a generator is to filter out the custom models where the user DOES have access to the training set.
     * However, since that takes a very long time in cases where there are many training sets, we're going to instead use the heuristic
     * that a generator typically has read, but not write or comment permissions.
     * This is subject to change in the future, and hopefully we come up with a better solution for determining which custom models to include in this view.
     */
    customModelDashboardSource() {
        //don't use the same source as the full training set list, to leave open the possibility of a filter on the training sets
        const implicitFilter = new ImplicitCustomModelDashboardFilter({
            //filter out custom models where we have access to the training set id
            customModelFilter: new ImplicitCustomModelFilter$1({ generatorOnly: true }),
            trainingSetFilter: ImplicitLibraryFilter.TrainingSets
        });
        return new ItemSource(this._assetPool, [
            new CustomModelLoader$1(this._assetPool, this._core, this._customModelInterface),
            new LibraryListLoader(this._assetPool, this._libraryInterface, LibraryUpdater)
        ], implicitFilter);
    }
    /**
   * @example
   * const customModelContext = samCore.customModelContext;
   * const customModelSource = customModelContext.customModelSource;
   *
   * Gets all custom models a user has access to
   */
    get customModelSource() {
        return new ItemSource(this._assetPool, [
            new CustomModelLoader$1(this._assetPool, this._core, this._customModelInterface),
        ], new ImplicitCustomModelFilter$1());
    }
    async createTrainingSet(options) {
        return this._customModelInterface.createTrainingSet(options);
    }
    /**
     * Returns the `TrainingSetSource` which will return a list of training set libraries the user has access to.
     * @example
     * const context = await core.getCustomModelContext();
     * const order = new LibraryOrder('ascending', 'modified');
     * const filter = TrainingSetFilter.DEFAULT;
     * const list = await context.trainingSetsSource().getList(order, filter, loadOptions);
     * list.on(STATE_CHANGED, () => {
     *     if (list.status !== AssetListStatus.Loading) { const trainingSets = list.items; }
     * });
     */
    async trainingSetsSource() {
        const libraryContext = await this._core.getLibraryContext();
        const loader = new LibraryListLoader(libraryContext._assetPool, this._libraryInterface, LibraryUpdater);
        return new ItemSource(libraryContext._assetPool, [loader], ImplicitLibraryFilter.TrainingSets);
    }
    /* We need to always fetch remotely because local training sets might have been populated by a melville listing,
     * and those training sets don't have custom model data.
     */
    async getTrainingSetById(assetId) {
        return this._customModelInterface.getTrainingSetById(assetId);
    }
    /**
     * Update a training set's metadata
     * @param assetId Training set asset ID
     * @param metadata metadata object to update the training set with
     * @param overwrite boolean indicating whether to overwrite existing metadata or merge it with the new metadata.
     * To delete a metadata field, set overwrite to true and exclude the field from the metadata object.
     */
    async updateTrainingSet(assetId, metadata, overwrite = false) {
        // If overwrite is true and the metadata payload doesn't have all required fields, throw an error
        if (overwrite && (!metadata.schemaVersion || !metadata.trainingMode)) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Schema version and training mode are required fields on the training set metadata. To overwrite all metadata, these must be included in the payload.');
        }
        const trainingSet = await this.getTrainingSetById(assetId);
        if (!trainingSet) {
            throw SAMError.create(SAMErrorCode.NOT_FOUND, 'Training set not found');
        }
        let payload;
        // If overwrite is false, merge existing metadata with passed in metadata to make sure we don't overwrite old metadata fields
        if (!overwrite) {
            payload = {
                ['firefly#cme']: Object.assign(Object.assign({}, trainingSet.customModelInfo), metadata)
            };
        }
        else {
            payload = {
                ['firefly#cme']: Object.assign({}, metadata)
            };
        }
        await this._libraryInterface.updateMetadata(trainingSet.id, payload);
        // TODO: If Melville changes the PUT libraries metadata endpoint to return the updated item, we need to remove refetching the item
        // JIRA: https://jira.corp.adobe.com/browse/GLOW-467
        // `getTrainingSetById` will fetch from remote and update the local item
        await this.getTrainingSetById(trainingSet.id);
    }
    async createCustomModel(options) {
        const customModelData = await this._customModelInterface.createCustomModel(options);
        const session = this._assetPool.createMutationSession();
        const customModel = this._customModelUpdaterMelville.updateRemoteItem(session, customModelData);
        session.commit();
        return customModel;
    }
    /**
     * Fetch the custom model from the server, update the remote/local cache, and return it.
     * @param customModelId The ID of the custom model to fetch
     * @returns The updated custom model
     */
    async _fetchAndUpdateCustomModelById(customModelId) {
        const customModelData = await this._customModelInterface.getCustomModelById(customModelId);
        const session = this._assetPool.createMutationSession();
        const customModel = this._customModelUpdaterMelville.updateRemoteItem(session, customModelData);
        session.commit();
        return customModel;
    }
    /**
     * Fetches one custom model by its ID.
     * Will first check the local asset pool for the custom model and return it if found.
     * If not found, will fetch the custom model from the server and return it.
     * @param customModelId
     * @returns
     */
    async getCustomModelById(customModelId) {
        // Check if we have the custom model in the local item pool
        const customModel = this._assetPool.getLocalItemById(customModelId);
        if (customModel) {
            if (!customModel.isCustomModel) {
                throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Attempting to fetch asset type that is not a custom model');
            }
            return customModel;
        }
        // If not, fetch it from the server
        return this._fetchAndUpdateCustomModelById(customModelId);
    }
    /**
     * Given an id and CustomModelUpdateInfoMelville, update the custom model with the new data.
     * @param customModelId string
     * @param options CustomModelUpdateInfoMelville
     */
    async updateCustomModel(customModelId, options) {
        // Update the custom model in Melville
        await this._customModelInterface.updateCustomModel(customModelId, options);
        // Update the local custom model with the new data
        await this._fetchAndUpdateCustomModelById(customModelId);
    }
    /**
     * @experimental
     */
    async getCustomModelOrder(direction = 'descending', field = 'modified') {
        const { default: CustomModelOrder } = await Promise.resolve().then(function () { return CustomModelOrder$1; });
        return new CustomModelOrder(direction, field);
    }
    /**
     * @experimental
     */
    async getCustomModelFilter(options) {
        const { default: CustomModelFilter } = await Promise.resolve().then(function () { return CustomModelFilter$2; });
        return new CustomModelFilter(options);
    }
}
__decorate([
    memoize$1
], CustomModelContext.prototype, "customModelSource", null);
__decorate([
    keepAlive
], CustomModelContext.prototype, "createTrainingSet", null);
__decorate([
    memoize$1
], CustomModelContext.prototype, "trainingSetsSource", null);
__decorate([
    keepAlive
], CustomModelContext.prototype, "getTrainingSetById", null);
__decorate([
    keepAlive
], CustomModelContext.prototype, "createCustomModel", null);
__decorate([
    keepAlive
], CustomModelContext.prototype, "getCustomModelById", null);

var CustomModelContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': CustomModelContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const GenerationHistoryAssetUpdater = new ItemUpdater({
    localItemType: AdobeAsset,
    remoteIdProperty: 'asset_id',
    propertyUpdater: new PropertyUpdater({
        '_appMetadata._data': {
            name: 'applicationMetadata',
            format: 'object_subset',
            set: (parsedSource, dest) => {
                const asset = dest;
                // Melville will always return the complete set of application metadata, so it should use _setData instead of _mergeData
                asset.appMetadata._setData(parsedSource);
            }
        },
        _isFavorite: { name: 'isFavorite', format: 'boolean' },
        _assetClass: { get: () => 'composite' },
        _generationModelDisplayName: 'generationModelDisplayName',
        _name: 'repo:name',
        _size: { name: 'repo:size', format: 'number' },
        _type: { name: 'type', format: 'string', choices: [
                GENERATION_HISTORY_IMAGE_MEDIA_TYPE,
                GENERATION_HISTORY_VIDEO_MEDIA_TYPE
            ] },
        __links: { name: '_links', format: 'object' },
        _created: { name: 'createdDate', format: 'date' },
        _modified: { name: 'modifiedDate', format: 'date' },
        _etag: 'composite_manifest_etag',
        _path: 'asset_name_path'
    })
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ImplicitGenerationHistoryAssetFilter extends ImplicitAdobeAssetFilterBase {
    matches(item) {
        return isGenerationHistoryAsset(item);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const $GH_DIR_REF = Symbol('GenerationHistoryDirectoryRef');
const $GH_FAVORITES_LIST_REF = Symbol('GenerationHistoryFavoritesListRef');
class GenerationHistoryAssetLoader {
    constructor(_core, _generationHistoryInterface) {
        this._core = _core;
        this._generationHistoryInterface = _generationHistoryInterface;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options, pageLink) {
        var _a, _b;
        let result;
        if (pageLink) {
            // We are loading the next page with the link provided.
            result = await this._generationHistoryInterface.getGenerationHistoryAssetsUsingPageLink(pageLink);
        }
        else {
            const { limit, order } = options;
            const { generationGroupId, historyAssetType } = (_a = options.filter) !== null && _a !== void 0 ? _a : {};
            const queryParams = {};
            queryParams.orderBy = order.direction === 'ascending' ? 'created_date' : '-created_date';
            generationGroupId && (queryParams.generationGroupId = generationGroupId);
            historyAssetType && (queryParams.generationType = historyAssetType);
            // Note: most GHAs will likely exist in the ghaFolder. Keeping a ref to it let SAMs optimize ONS monitoring to
            // just the folder for most GHAs, and enables ONS notifications for new GHAs generated. Attaching to the
            // explicit filter ensures the ghaFolder gets GC'd with the list, then SAM can stop monitoring it via ONS.
            // @ts-expect-error -- if this a common pattern, find a way to generalize
            options.filter[$GH_DIR_REF] = await this.getDefaultGHAFolder();
            // Similar to above, keep reference to a fully loaded favorites list (filtered on the GHA mimetype)
            // Attaching the list to an instance of the filter allows those assets to be GC'd when GHAs from this loader
            // are no longer being referenced.
            // Fetching favorites allows us to instantiate assets in the item pool which include wether or not that
            // asset is a favorite (we need this as favorites data is not returned from Melville)
            // TODO: Once we can get the data from Melville, remove this list. Fetching two lists here
            // could cause bad performance. See https://jira.corp.adobe.com/browse/GLOW-890
            // @ts-expect-error -- if this a common pattern, find a way to generalize
            options.filter[$GH_FAVORITES_LIST_REF] = this._core.hostAssetContext.favoriteAssetsSource.getList(FavoriteAdobeAssetOrder.default, new AdobeAssetFilter({ mediaTypes: [GENERATION_HISTORY_IMAGE_MEDIA_TYPE, GENERATION_HISTORY_VIDEO_MEDIA_TYPE] }), { loadAllPages: true });
            // @ts-expect-error
            await waitForListLoad(options.filter[$GH_FAVORITES_LIST_REF]);
            if (limit) {
                queryParams.limit = limit;
                if (!queryParams.start) {
                    queryParams.start = 0;
                }
            }
            result = await this._generationHistoryInterface.getGenerationHistoryAssets(queryParams);
        }
        const latency = this._core._environment.getValue('USS_LIST_UPDATE_LATENCY');
        const mostRecentValidMutation = Date.now() - latency;
        const session = this._core._getAssetPool().createLoaderUpdateSession(mostRecentValidMutation);
        const items = GenerationHistoryAssetUpdater.updateRemoteItems(session, result.listings);
        session.commit();
        let loadNextPage;
        const nextPageLink = (_b = result._links) === null || _b === void 0 ? void 0 : _b.next;
        if (nextPageLink) {
            loadNextPage = (options) => this._loadPage(options, nextPageLink);
        }
        return {
            items,
            total: result.total_count,
            loadNextPage,
            mostRecentValidMutation
        };
    }
    async getDefaultGHAFolder() {
        const generationHistoryContext = await this._core.getGenerationHistoryContext();
        const { _fireflyGenerationsDirectoryID: _fireflyGenrationsDirectoryID } = generationHistoryContext;
        // attempt to resolve FIREFLY_GENERATIONS_DIRECTORY, create if needed
        const generationsDirectory = _fireflyGenrationsDirectoryID
            ? await this._core.hostAssetContext.getAssetWithCloudID(_fireflyGenrationsDirectoryID)
            : await this._core.hostAssetContext.getAssetWithRepoPath(`/${FIREFLY_GENERATIONS_DIRECTORY}`)
                .then(directory => directory)
                .catch(async (err) => {
                if (err.code === SAMErrorCode.NOT_FOUND) {
                    const homeFolder = await this._core.hostAssetContext.getHomeFolder();
                    const assetInterface = await homeFolder._getAssetInterface();
                    const assetData = await assetInterface.createFolder(FIREFLY_GENERATIONS_DIRECTORY);
                    const createdDirectory = this._core.hostAssetContext._createAssetFromMetadata(assetData);
                    return createdDirectory;
                }
                throw SAMError.create(SAMErrorCode.UNKNOWN, 'SAM was unable to resolve or create the firefly-generations directory');
            });
        generationHistoryContext._fireflyGenerationsDirectoryID = generationsDirectory.cloudID;
        return generationsDirectory;
    }
}

/**
 * Loads siblings of the same generationGroupId that are already in the assetPool, so they appear in
 * the UI right away even if SAM has to go to the server to check if there are more.
 */
class GenerationSiblingLoader {
    constructor(_core) {
        this._core = _core;
    }
    async loadPage(options) {
        return await this._loadPage(options);
    }
    async _loadPage(options) {
        var _a;
        const { generationGroupId } = (_a = options.filter) !== null && _a !== void 0 ? _a : {};
        if (!generationGroupId) {
            return { items: [] };
        }
        return { items: this._core._getAssetPool().toArray().filter(item => getGenerationGroupId(item) === generationGroupId) };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Provides Generation History functionality such as listing.
 *
 * @experimental This API is in an experimental phase so expect that
 * API's will not be final and there will be breaking changes
 * without bumping the major version until this comment is removed.
 */
class GenerationHistoryContext {
    constructor(
    /** @package -- for use in SAM.js only
     */
    _core, 
    /** @package -- for use in SAM.js only
     */
    _assetPool) {
        this._core = _core;
        this._assetPool = _assetPool;
        this._generationHistoryInterface = new GenerationHistoryInterface(this._core);
        this._generationHistoryAssetUpdater = GenerationHistoryAssetUpdater;
    }
    get generationHistorySource() {
        return new ItemSource(this._assetPool, [
            new GenerationHistoryAssetLoader(this._core, this._generationHistoryInterface),
            new GenerationSiblingLoader(this._core)
        ], new ImplicitGenerationHistoryAssetFilter());
    }
    async getGenerationHistoryAssetById(assetId) {
        const localAsset = this._assetPool.getLocalItemById(assetId);
        if (localAsset) {
            if (!isGenerationHistoryAsset(localAsset)) {
                throw SAMError.create(SAMErrorCode.INVALID_OPERATION, 'Attempting to fetch asset type that is not a generation history asset');
            }
            return localAsset;
        }
        // supplement get by ID with a call to graphql so we can acquire favorites data
        // TODO: would be better here if GQLManager exposed a method which takes a raw query string allowing us to just request:
        // gql`labels { favorite { isFavorite }}``
        const { isFavorite } = await (await this._core._getGQLManager()).getAssetById(assetId);
        const remoteHistoryAssetData = await this._generationHistoryInterface.getGenerationHistoryAssetById(assetId);
        const session = this._assetPool.createMutationSession();
        const historyAsset = this._generationHistoryAssetUpdater.updateRemoteItem(session, Object.assign(Object.assign({}, remoteHistoryAssetData), { isFavorite }));
        session.commit();
        return historyAsset;
    }
}
__decorate([
    memoize$1
], GenerationHistoryContext.prototype, "generationHistorySource", null);
__decorate([
    keepAlive
], GenerationHistoryContext.prototype, "getGenerationHistoryAssetById", null);

var GenerationHistoryContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': GenerationHistoryContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class WorkfrontInterface extends InterfaceBase {
    /**
     * @TODO [SAMJS-729] replace with prod/stage urls once available.
     */
    _getWorkfrontLinkURL() {
        return `https://${this._core._environment.endpoints.WORKFRONT_HOST}/esm-connector/api/v1/search`;
    }
    async getWorkfrontLink(assetId, ordId) {
        const url = new URL(`${this._getWorkfrontLinkURL()}?`);
        setURLSearchParams(url, { 'UID': assetId });
        const response = await this._doGet(url.toString(), {
            headers: {
                'x-gw-ims-org-id': ordId
            }
        });
        return response.json();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class WorkfrontContext {
    constructor(_core) {
        this._core = _core;
        this._workfrontInterface = new WorkfrontInterface(this._core);
    }
    /**
     * Get an AdobeAsset from a given asset path and repository ID. This method is optimized
     * to use to only get and build an asset based on repo-metadata without having to call
     * all the other services to get additional data up-front (PUPA). To get the full asset you can
     * still call either AssetContext.getAssetWithRepoPath or AssetContext.getAssetWithCloudID().
     *
     * @param assetPath The path to get the asset for.
     * @param repositoryId The repository ID to get the asset for.
     * @returns The AdobeAsset for the given asset path and repository ID.
     */
    async getAssetWithRepoPath(assetPath, repositoryId) {
        const assetContext = await this._core.getAssetContext();
        const { data } = await assetContext._getRepoDataByPath(assetPath, repositoryId);
        const session = assetContext._assetPool.createMutationSession();
        const newAsset = this._core._adobeAssetFactory.assetFromRepoMetadata(session, data);
        session.commit();
        return newAsset;
    }
    /**
     * Get the repository information from the RAPI index-workfront endpoint.
     * This is required to decouple workfront from SMU migration scenarios.
     *
     * @service Requires service principal token for authentication.
     * @param orgId The organization ID to get the repository for.
     * @returns The repository for the Workfront context.
     */
    async getRepository(orgId) {
        const assetContext = await this._core.getAssetContext();
        const repositoryInterface = assetContext._rapi;
        const workfrontRepositoryIndex = await repositoryInterface.getWorkfrontIndex(orgId);
        const repositoryData = workfrontRepositoryIndex.newWorkfrontParentDir._embedded[RelType.REPO_METADATA];
        return {
            id: repositoryData['repo:repositoryId'],
            path: repositoryData['repo:path'],
            name: repositoryData['repo:name'],
            links: repositoryData._links
        };
    }
    /**
     * Creates an AdobeAsset instance from a cloud ID. Note that this method always returns an AdobeAsset,
     * even for specialized asset types like Projects or Libraries. Do not use this method if you need
     * specialized asset behavior - for example, if you need Project-specific functionality, use the
     * ProjectContext instead. This is intended to be a lightweight way to get an asset when only minimal
     * metadata is needed.
     *
     * @param assetId The cloud ID of the asset
     * @returns An AdobeAsset instance
     */
    async getAssetWithCloudID(assetId) {
        const assetContext = await this._core.getAssetContext();
        const repoMetadataResource = await assetContext._getAssetRepoDataWithWithCloudID(assetId);
        const repoMetadata = repoMetadataResource.data;
        const session = this._core._getAssetPool().createUpdateSession('getAssetWithCloudID');
        const asset = this._core._adobeAssetFactory.assetFromRepoMetadata(session, repoMetadata);
        session.commit();
        return asset;
    }
    /**
     * Get the Workfront link for a given asset ID and organization ID.
     *
     * @param assetId The cloud ID of the asset
     * @param orgId Optional. The organization ID to get the Workfront link.
     * @returns The Workfront link for the given asset ID and organization ID
     */
    async getWorkfrontLink(assetId, orgId) {
        var _a;
        let org;
        if (orgId) {
            org = orgId;
        }
        else {
            const organizationsResource = new Resource(this._core);
            const projectInterface = new ProjectsInterface(this._core);
            await projectInterface.getOrganizations(organizationsResource);
            org = (_a = organizationsResource.data) === null || _a === void 0 ? void 0 : _a.default;
        }
        const workfrontLink = await this._workfrontInterface.getWorkfrontLink(assetId, org);
        return workfrontLink.workfrontURL;
    }
}

var WorkfrontContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': WorkfrontContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class KnowledgeWorkspaceContext {
    constructor(_core) {
        this._core = _core;
    }
    /**
     * Gets the Asset with the given assetId, loading the minimal amount of data needed to create an AdobeAsset instance.
     *
     * @remarks
     *
     * A minimal `AdobeAsset` instance is only populated with the repo:metadata of the asset.
     * No application metadata, effective permissions, or other properties are requested.
     *
     * If asset exists in the local cache, that existing instance will be returned.
     *
     * If asset does not exist in the local cache, a new minimal `AdobeAsset` instance will be created using the
     * `RelType.REPO_METADATA` link to fetch the repo:metadata for the asset.
     *
     * The provided `assetLinks` are only used for the initial fetching of the repo:metadata. The links in the
     * repo:metadata response will be used for future requests.
     *
     * Some AdobeAsset subtypes, such as Projects, Classrooms, etc., currently require application metadata to
     * determine the correct subtype instance to create. Only use this method if you know that the requested
     * asset is not one of these types. In the future, repo:metadata will contain the asset subtype, and
     * we can remove this restriction.
     *
     * @param assetId {string} assetId of the desired asset.
     * @param assetLinks {AssetLinks} set of asset links. `RelType.REPO_METADATA` link must be present to retrieve a minimal asset.
     * @return AdobeAsset
     */
    async getMinimalAssetWithAssetId(assetId, assetLinks) {
        return this._getMinimalAssetById(assetId, assetLinks);
    }
    async _getMinimalAssetById(assetId, assetLinks, repoMetadataResource) {
        const assetContext = await this._core.getAssetContext();
        const repositoryInterface = assetContext._rapi;
        const asset = assetContext._assetPool.getLocalItemById(assetId);
        if (asset) {
            // If no repo:metadata resource provided and ONS is disabled, force refresh repo:metadata, because the data may be stale
            const forceRefresh = this._core._environment.getValue('DISABLE_ONS');
            if (!repoMetadataResource && forceRefresh) {
                repoMetadataResource = new RepoMetadataResource(this._core);
                await repositoryInterface.getRepoMetadataById(assetId, repoMetadataResource, assetLinks);
            }
            if (repoMetadataResource) {
                const session = assetContext._assetPool.createMutationSession();
                assetContext._adobeAssetUpdater.updateRemoteItem(session, repoMetadataResource.data);
                session.commit();
            }
            return asset;
        }
        if (!repoMetadataResource) {
            repoMetadataResource = new RepoMetadataResource(this._core);
            await repositoryInterface.getRepoMetadataById(assetId, repoMetadataResource, assetLinks);
        }
        const repoMetadata = repoMetadataResource.data;
        const session = assetContext._assetPool.createMutationSession();
        const newAsset = this._core._adobeAssetFactory.assetFromRepoMetadata(session, repoMetadata);
        // Mark storage:assignee as loaded, if it is set from repo:metadata
        if (repoMetadata && repoMetadata['storage:assignee'] && newAsset._storageAssignee_NoLazyLoad.id === repoMetadata['storage:assignee'].id) {
            LazyLoadManager.updatedByItemUpdater(newAsset, STORAGE_ASSIGNEE_CHANGED);
        }
        session.commit();
        newAsset._setResources({
            repoMetadataResource,
            effectivePermissionsResource: undefined,
            appMetadataResource: undefined,
            perUserMetadataResource: undefined
        });
        return newAsset;
    }
    /**
     * Gets an Asset with the given assetPath and repositoryId, loading the minimal amount of data needed to create an AdobeAsset instance.
     *
     * @remarks
     *
     * A minimal `AdobeAsset` instance is only populated with the repo:metadata of the asset.
     * No application metadata, effective permissions, or other properties are requested.
     *
     * The provided path should be the full path to the asset. It cannot be a relative path, such as
     * a path relative to the user's /cloud-content folder.
     *
     * If the asset exists in the local cache, that existing instance will be returned. If the asset does not exist
     * in the local cache, a new minimal `AdobeAsset` instance will be created using the `RelType.REPO_METADATA`
     * link to fetch the repo:metadata for the asset.
     *
     * For performance reasons, if you have the assetId of the asset, you should use `getMinimalAssetWithAssetId()` instead. Because
     * our item pool maps assets by assetId, if you request an asset by path, we will need to fetch the repo:metadata to get
     * the assetId of the asset to see if it is in the local cache.
     *
     * The provided `assetLinks` are only used for the initial fetching of the repo:metadata. The links in the
     * repo:metadata response will be used for future requests.
     *
     * Some AdobeAsset subtypes, such as Projects, Classrooms, etc., currently require application metadata to
     * determine the correct subtype instance to create. Only use this method if you know that the requested
     * asset is not one of these types. In the future, repo:metadata will contain the asset subtype, and
     * we can remove this restriction.
     *
     * @param assetPath {string} full path for the asset
     * @param repositoryId {string} repositoryID of the asset
     * @param assetLinks {AssetLinks} set of asset links. `RelType.REPO_METADATA` link must be present to retrieve a minimal asset.
     * @return AdobeAsset
     */
    async getMinimalAssetWithRepoPath(assetPath, repositoryId, assetLinks) {
        return this._getMinimalAssetWithRepoPathImpl(assetPath, repositoryId, assetLinks);
    }
    /**
     * @package -- only for use in SAM.js
     */
    async _getMinimalAssetWithRepoPathImpl(assetPath, repositoryId, assetLinks) {
        const assetContext = await this._core.getAssetContext();
        const repositoryInterface = assetContext._rapi;
        let asset = undefined;
        const repoMetadataResource = new RepoMetadataResource(this._core);
        const repositoryMetadata = await repositoryInterface.getRepoMetadataByPath(repositoryId, assetPath, repoMetadataResource, assetLinks);
        asset = await this._getMinimalAssetById(repositoryMetadata['repo:assetId'], assetLinks, repoMetadataResource);
        return asset;
    }
}
__decorate([
    keepAlive,
    synchronized,
    __param(0, key)
], KnowledgeWorkspaceContext.prototype, "getMinimalAssetWithAssetId", null);
__decorate([
    synchronized,
    __param(0, key)
], KnowledgeWorkspaceContext.prototype, "_getMinimalAssetById", null);
__decorate([
    keepAlive,
    synchronized
], KnowledgeWorkspaceContext.prototype, "getMinimalAssetWithRepoPath", null);
__decorate([
    synchronized
], KnowledgeWorkspaceContext.prototype, "_getMinimalAssetWithRepoPathImpl", null);

var KnowledgeWorkspaceContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': KnowledgeWorkspaceContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AdobeACL {
    constructor(_core, _assetId, _etag, _aces = [], _assetInterface) {
        this._core = _core;
        this._assetId = _assetId;
        this._etag = _etag;
        this._aces = _aces;
        this._assetInterface = _assetInterface;
    }
    /**
     * Returns a copy of the ACEs as an array
     */
    get aces() {
        // Copy the ACEs to avoid mutating the original array
        return [...this._aces];
    }
    set aces(value) {
        // Copy the ACEs from the original data to ensure it doesn't get mutated
        this._aces = [...value];
    }
    get assetId() {
        return this._assetId;
    }
    get etag() {
        return this._etag;
    }
    set etag(value) {
        this._etag = value;
    }
    get isEmpty() {
        return this._aces.length === 0;
    }
    async _forceRefreshACL() {
        const accessControlContext = await this._core.getAccessControlContext();
        await accessControlContext.getACL(this.assetId, true /* forceRefresh */);
    }
    async _handleConflict(e) {
        if (isSAMError(e)) {
            if (e.code === SAMErrorCode.CONFLICT) {
                // If the ETag does not match the server's ETag, it will throw
                // a CONFLICT error. In this case, we should optimistically refresh
                // the ACL from the server and try again.
                await this._forceRefreshACL();
            }
        }
        throw e;
    }
    /**
     * Determines if there are any ACES with changes locally that have not been
     * pushed to the server.
     *
     * @returns - an array of ACEs that have been modified locally
     */
    hasDirtyACES() {
        return this._aces.some(ace => ace._isDirty);
    }
    /**
     * Removes the provided ACEs from the ACL.
     *
     * @param aces - The ACEs to remove from the ACL.
     * @returns - The updated ACL.
     */
    async removeACES(aces) {
        // if there are any dirty ACEs, throw an error since
        // this will clear the local changes and get new ACEs from the server
        // so we want to give the client a chance to update the local ACEs.
        if (this.hasDirtyACES()) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Cant delete ACEs with pending changes, these will be overwritten');
        }
        // Copy the ACEs to avoid mutating the original array
        const copiedAces = [...aces];
        copiedAces.sort((ace1, ace2) => ace1.id < ace2.id ? 0 : -1);
        try {
            await this._assetInterface.deleteAccessControlEntries(aces, this._etag);
        }
        catch (e) {
            await this._handleConflict(e);
        }
        // If we made it this far, the ACEs were deleted successfully so let's
        // fetch the new ACEs from the server and update the local ACEs.
        await this._forceRefreshACL();
        return this._aces;
    }
    /**
     * Adds the provided ACEs to the ACL.
     *
     * @param aces - The ACEs to add to the ACL.
     * @returns - The updated ACL.
     */
    async addACES(aces) {
        // if there are any dirty ACEs, throw an error since
        // this will clear the local changes and get new ACEs from the server
        // so we want to give the client a chance to update the local ACEs.
        if (this.hasDirtyACES()) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Cant add ACES with pending changes, these will be overwritten');
        }
        await this._assetInterface.addAccessControlEntries(aces, this._etag);
        // If we made it this far, the ACEs were added successfully so let's
        // fetch the new ACEs from the server and update the local ACEs.
        await this._forceRefreshACL();
        return this._aces;
    }
    /**
     * Commits and updates the local ACEs in this ACL with the servers ACL
     *
     * @throws {SAMErrorCode.CONFLICT} if the ETag does not match the server's ETag
     *
     */
    async updateACES() {
        if (!this.hasDirtyACES()) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'No changes to commit');
        }
        const dirtyACES = this._aces.filter(ace => ace._isDirty);
        try {
            await this._assetInterface.updateAccessControlList(dirtyACES, this._etag);
        }
        catch (e) {
            await this._handleConflict(e);
        }
        // If we made it this far, the ACEs were updated successfully so let's
        // fetch the new ACEs from the server and update the local ACEs.
        await this._forceRefreshACL();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var AccessControlPrincipalType;
(function (AccessControlPrincipalType) {
    AccessControlPrincipalType["USER"] = "https://ns.adobe.com/adobeaemcloud/aem/user";
    AccessControlPrincipalType["GROUP"] = "https://ns.adobe.com/adobeaemcloud/aem/group";
})(AccessControlPrincipalType || (AccessControlPrincipalType = {}));
var AccessControlPrivileges;
(function (AccessControlPrivileges) {
    /**
     * The existence of a resource can be checked.
     */
    AccessControlPrivileges["ACK"] = "ack";
    /**
     * The resource can be retrieved via a GET request.
     */
    AccessControlPrivileges["READ"] = "read";
    /**
     * The resource can be updated via a PUT request; and PATCH request where applicable.
     */
    AccessControlPrivileges["WRITE"] = "write";
    /**
     * The resource can be deleted via a DELETE request.
     */
    AccessControlPrivileges["DELETE"] = "delete";
    /**
     * @note
     * COMPATIBILITY NOTE: FULL and MODIFY are deprecated aliases to combinations of privileges.
     * New clients SHOULD NOT use these. They MAY continue to be used by existing clients to update policies,
     * but will always be expanded to the individual non-aliased privileges when the policy is returned to clients.
     * MODIFY privilege is translated to READ and WRITE.
     * FULL privilege is translated to ACK, READ, WRITE, DELETE.
     */
})(AccessControlPrivileges || (AccessControlPrivileges = {}));
var AccessControlModifier;
(function (AccessControlModifier) {
    AccessControlModifier["GRANT"] = "grant";
    AccessControlModifier["DENY"] = "deny";
})(AccessControlModifier || (AccessControlModifier = {}));
var AccessControlInheritance;
(function (AccessControlInheritance) {
    AccessControlInheritance["SELF"] = "self";
    AccessControlInheritance["DEEP"] = "deep";
    AccessControlInheritance["DEEP_OVERRIDE"] = "deep_override";
})(AccessControlInheritance || (AccessControlInheritance = {}));
var RelTypePlatform;
(function (RelTypePlatform) {
    RelTypePlatform["PRINCIPAL_TYPE_IMS_USER"] = "https://ns.adobe.com/adobecloudplatform/ims/user";
    RelTypePlatform["PRINCIPAL_TYPE_IMS_GROUP"] = "https://ns.adobe.com/adobecloudplatform/ims/group";
})(RelTypePlatform || (RelTypePlatform = {}));

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AdobeACE {
    constructor(_core, 
    /**
     * Corresponds to the index of the ACE in the ACL response array.
     */
    id, _privileges, _modifier, _inheritance, _relations, _principal // @TODO this should be specific values for "special" principals instead of strings.
    ) {
        this._core = _core;
        this.id = id;
        this._privileges = _privileges;
        this._modifier = _modifier;
        this._inheritance = _inheritance;
        this._relations = _relations;
        this._principal = _principal;
        this.__isDirty = false;
        this.__isDeleted = false;
    }
    _checkIfDeleted() {
        if (this.__isDeleted) {
            throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Cannot update a deleted ACE');
        }
    }
    /**
     * Whether this ACE has been modified since it was last committed to the server.
     * @package - This property is intended for internal use only.
     */
    get _isDirty() {
        return this.__isDirty;
    }
    /**
     * @package - This property is intended for internal use only.
     */
    set _isDirty(value) {
        this.__isDirty = value;
    }
    /**
     * @package - This property is intended for internal use only.
     */
    set _isDeleted(value) {
        this.__isDeleted = value;
    }
    /**
     * @package - This property is intended for internal use only.
     */
    get _isDeleted() {
        return this.__isDeleted;
    }
    get principal() {
        return this._principal;
    }
    set principal(value) {
        this._checkIfDeleted();
        this._principal = value;
        this._isDirty = true;
    }
    get privileges() {
        return this._privileges;
    }
    set privileges(value) {
        this._checkIfDeleted();
        this._privileges = value;
        this._isDirty = true;
    }
    get modifier() {
        return this._modifier;
    }
    set modifier(value) {
        this._checkIfDeleted();
        this._modifier = value;
        this._isDirty = true;
    }
    get inheritance() {
        return this._inheritance;
    }
    set inheritance(value) {
        this._checkIfDeleted();
        this._inheritance = value;
        this._isDirty = true;
    }
    get relations() {
        return this._relations;
    }
    set relations(value) {
        this._checkIfDeleted();
        this._relations = value;
        this._isDirty = true;
    }
    get isDeny() {
        return this._modifier === AccessControlModifier.DENY;
    }
    get isGrant() {
        return this._modifier === AccessControlModifier.GRANT;
    }
    get isDeepInheritance() {
        return this._inheritance === AccessControlInheritance.DEEP;
    }
    get isSelfInheritance() {
        return this._inheritance === AccessControlInheritance.SELF;
    }
    get isDeepOverrideInheritance() {
        return this._inheritance === AccessControlInheritance.DEEP_OVERRIDE;
    }
    get isUserPrincipal() {
        if (typeof this._principal === 'string') {
            return false;
        }
        return this._principal['@type'] === RelTypePlatform.PRINCIPAL_TYPE_IMS_USER;
    }
    get isGroupPrincipal() {
        if (typeof this._principal === 'string') {
            return false;
        }
        return this._principal['@type'] === RelTypePlatform.PRINCIPAL_TYPE_IMS_GROUP;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AccessControlContext {
    constructor(_core) {
        this._core = _core;
        this._aclCache = new Map();
    }
    _getCachedACL(assetId) {
        const localACL = this._aclCache.get(assetId);
        if (localACL) {
            const aclDeref = localACL.deref();
            if (aclDeref) {
                return aclDeref;
            }
        }
        return undefined;
    }
    /**
     * Get the asset interface for the asset using memoize to increase session performance.
     * If the AssetId is found locally in the asset pool we can just get
     * the asset interface from that, otherwise let's construct just the asset
     * interface we need to get the access control list. This way we won't have to
     * use the full getAssetWithCloudID method (which fetches a lot of data). And we
     * can avoid only creating an AdobeAsset when we only have RepoMetadata.
     *
     * @param assetId - The ID of the asset to get the asset interface for.
     * @returns The asset interface for the asset.
     */
    async _getAssetInterface(assetId) {
        // Get the asset interface for the asset
        const localAsset = this._core._getAssetPool().getLocalItemById(assetId);
        let assetInterface;
        if (localAsset) {
            assetInterface = await localAsset._getAssetInterface();
        }
        else {
            const assetContext = await this._core.getAssetContext();
            // Fetch a minimalist version of AdobeAsset if it doesn't exist already to
            // avoid fetching more data than we need.
            const assetRepoData = await assetContext._getAssetRepoDataWithWithCloudID(assetId);
            assetInterface = new AssetInterface(assetContext._rapi, assetId, assetRepoData.data._links, assetRepoData.data['repo:etag']);
        }
        return assetInterface;
    }
    /**
     * Get the access control list for an asset.
     *
     * @note An empty array returned means  ACEs have been set on the asset or this client-id user doesn't
     * have access to see the ACL.
     *
     * @param assetId - The ID of the asset to get the access control list.
     * @param forceRefresh - If true, the ACL and it's ACEs will be refreshed from the server and not pulled from the cache.
     * useful when the service returns a 200 response because the ACL was updated but the cache was not updated.
     *
     * @note with forceRefresh = true, local changes to ACE's will be overwritten without error.
     */
    async getACL(assetId, forceRefresh = false) {
        const localACL = this._getCachedACL(assetId);
        if (localACL && !forceRefresh) {
            return localACL;
        }
        const assetInterface = await this._getAssetInterface(assetId);
        const aclResponse = await assetInterface.getAccessControlList();
        const mapACES = (ace, index) => {
            return new AdobeACE(this._core, index, ace['repo:privileges'], ace['repo:modifier'], ace['repo:inheritance'], ace['repo:relations'], ace['repo:principal']);
        };
        // Clear the entire list of ACEs on the ACL if we are forcing a refresh
        // and after all the calls to the services have settled successfully this way we don't
        // prematurely remove local ACEs before we get new ones from the server.
        // We also set the _isDeleted property to true for each ACE so that clients
        // will get an error when they try to make any changes to a deleted ACE.
        if (localACL && forceRefresh) {
            localACL.aces.forEach((ace) => {
                ace._isDeleted = true;
            });
            localACL.aces = [];
        }
        if (localACL) {
            localACL.aces = aclResponse['repo:acl'].map(mapACES);
            localACL.etag = aclResponse['etag'];
            return localACL;
        }
        // ACL doesn't exist in the cache, create a new one.
        // and return it to the caller.
        const acl = new AdobeACL(this._core, assetId, aclResponse['etag'], aclResponse['repo:acl'].map(mapACES), assetInterface);
        this._aclCache.set(assetId, new WeakRef(acl));
        return acl;
    }
}
__decorate([
    cache,
    __param(0, key)
], AccessControlContext.prototype, "_getAssetInterface", null);

var AccessControlContext$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': AccessControlContext
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Properties of a link reference that correspond to mutable asset metadata properties (e.g. name, path etc).
// These are properties that can change on the asset, but don't correspond to a content change
// (i.e. the link state would be MetadataOutOfDate rather than OutOfDate)
const assetMetadataProperties = [
    'repo:repositoryId',
    'repo:name',
    'repo:etag',
    'stRef:relativePath',
    'stRef:documentID'
];
function isBrokenAsset(asset) {
    // Need to know if permission exactly matches Ack or None, rather than contains, so can't use
    // hasPermission() here.
    const permission = asset['_permissions'];
    return permission === Permission.Ack
        || permission === Permission.None;
}
// Illustrator (prior to MAX 2021) does not update the instance ID on save, so we need to fall back to the etag in this case
// See https://jira.corp.adobe.com/browse/AI-4251857
const typesWithUnreliableInstanceID = [
    'application/illustrator'
];
class AssetLink extends SAMObjectEventEmitter {
    constructor(_assetLinkList, _data) {
        super(_assetLinkList._core);
        this._assetLinkList = _assetLinkList;
        this._data = _data;
        this._resolutionErrors = [];
        this._onChange = () => {
            var _a, _b;
            // Check if any of the resolved assets broke, and transfer their errors to the link
            // so we get the right link state (broken or restricted)
            const brokenAssets = (_a = this._resolvedAssets) === null || _a === void 0 ? void 0 : _a.filter(isBrokenAsset);
            if (brokenAssets === null || brokenAssets === void 0 ? void 0 : brokenAssets.length) {
                this._resolutionErrors = brokenAssets.map(asset => SAMError.create(asset['_permissions'] === Permission.Ack ? SAMErrorCode.ACCESS_DENIED : SAMErrorCode.NOT_FOUND, 'lost access'));
                this._resolvedAssets = (_b = this._resolvedAssets) === null || _b === void 0 ? void 0 : _b.filter(asset => !brokenAssets.includes(asset));
            }
            this.emit('change');
            this._assetLinkList._onChange();
        };
    }
    async _setLinkData(linkData, asset) {
        this._data = linkData;
        if (asset) {
            this._resolvedAssets = [asset];
        }
        this._onChange();
        if (!this.adobeAsset || this.assetID !== this.adobeAsset.cloudID) {
            await this._resolveWithRetry();
        }
        // TODO: Check if relative path changed
        return this;
    }
    async _setLinkedAsset(asset) {
        const data = this._getLinkDataForAsset(asset);
        return this._setLinkData(data, asset);
    }
    _getLinkDataForAsset(asset) {
        var _a, _b;
        const linkData = {
            'repo:assetId': asset.cloudID,
            'repo:repositoryId': asset.repositoryID,
            'repo:etag': asset.etag,
            'dc:format': asset.mediaType,
            'repo:name': asset.name,
            'stRef:documentID': (_a = asset.embeddedMetadata.data) === null || _a === void 0 ? void 0 : _a['xmpMM:DocumentID'],
            'stRef:instanceID': (_b = asset.embeddedMetadata.data) === null || _b === void 0 ? void 0 : _b['xmpMM:InstanceID'],
            'stRef:manager': 'Adobe Cloud'
        };
        // Add relative path if it exists
        const parent = this._assetLinkList.containerAsset;
        if (parent && parent.repositoryID === asset.repositoryID) {
            linkData['stRef:relativePath'] = pathBrowserify.relative(pathBrowserify.dirname(parent.repoPath), asset.repoPath);
        }
        return linkData;
    }
    // Ensures that link reference strings are always serialized with the keys in the same order
    _serializeLinkData(linkData) {
        return JSON.stringify(linkData, Object.keys(linkData).sort());
    }
    _resolveWithRetry() {
        return this._resolve();
    }
    async _resolve() {
        var _a;
        const resolvedAssets = [];
        const resolutionErrors = [];
        const handleError = (e) => {
            if ([SAMErrorCode.NOT_FOUND, SAMErrorCode.ACCESS_DENIED].includes(e.code)) {
                resolutionErrors.push(e);
            }
            else {
                throw e;
            }
        };
        try {
            const asset = await this._context.getAssetWithCloudID(this.assetID);
            if (!asset.embeddedMetadata.isLoaded) {
                // First time, we need to load - after that, it'll get updated whenever the asset is refreshed
                await asset.embeddedMetadata.load();
            }
            resolvedAssets.push(asset);
        }
        catch (e) {
            this._core._environment.error(`Failed to resolve link by id (${this.assetID}): ${e}`);
            handleError(e);
        }
        const parent = this._assetLinkList.containerAsset;
        if (this.relativePath && parent && parent.repositoryID === this.repositoryID) {
            // Resolve by relative path, but this only makes sense if the container asset and linked
            // asset are in the same repository.
            const repoPath = pathBrowserify.join(pathBrowserify.dirname(parent.repoPath), this.relativePath);
            try {
                const asset = await this._context.getAssetWithRepoPath(repoPath, this.repositoryID);
                if (!asset.embeddedMetadata.isLoaded) {
                    // First time, we need to load - after that, it'll get updated whenever the asset is refreshed
                    await asset.embeddedMetadata.load();
                }
                // Most of the time, resolution by path will match resolution by asset id - only add an alternate
                // if they're different.
                if (!resolvedAssets[0] || resolvedAssets[0].cloudID !== asset.cloudID) {
                    if ((_a = resolvedAssets[0]) === null || _a === void 0 ? void 0 : _a.isDiscarded) {
                        // Special case if the resolution by id is discarded - we want the path-based resolution
                        // to become the primary adobeAsset
                        resolvedAssets.unshift(asset);
                    }
                    else {
                        resolvedAssets.push(asset);
                    }
                }
            }
            catch (e) {
                this._core._environment.error(`Failed to resolve link by path: ${this.repositoryID}, ${repoPath}`);
                handleError(e);
            }
        }
        // Attach event listeners so we can notify the link when the asset changes
        this._resolvedAssets && this._resolvedAssets.forEach(asset => asset.off('change', this._onChange));
        resolvedAssets.forEach(asset => asset.on('change', this._onChange));
        this._resolvedAssets = resolvedAssets;
        this._resolutionErrors = resolutionErrors;
        this._onChange();
    }
    get _context() {
        return this._assetLinkList._manager._context;
    }
    /**
     * The asset that the link resolves to - this will not be defined if the linkStatus
     * is Restricted or Broken.
     */
    get adobeAsset() {
        var _a;
        return (_a = this._resolvedAssets) === null || _a === void 0 ? void 0 : _a[0];
    }
    /**
     * An alternative asset which can be used as link, in case there is ambiguity resolving the link.
     * This will usually be undefined.
     */
    get alternativeAdobeAsset() {
        var _a;
        return (_a = this._resolvedAssets) === null || _a === void 0 ? void 0 : _a[1];
    }
    /**
     * The current state of the link (OutOfDate, UpToDate, Restricted or Broken).
     */
    get linkStatus() {
        if (!this._resolvedAssets) {
            return 'UpToDate';
        }
        if (!this.adobeAsset) {
            // If we get a 403 resolving an asset, we know it exists but the user doesn't have access
            // This corresponds to the Restricted state - we can direct the user to request access via assets web.
            return this._resolutionErrors.some(error => error.code === SAMErrorCode.ACCESS_DENIED) ? 'Restricted' : 'Broken';
        }
        if (this.adobeAsset.isDiscarded) {
            // If the primary asset resolved is discarded, it means that we don't have an undiscarded alternative
            // (otherwise it would be the primary asset). We therefore treat the link state as Discarded.
            // This means that the user can be presented the option to restore the asset to fix the link.
            return 'Discarded';
        }
        // Check to see if the asset has changed - we check the xmpMM:InstanceID, which should be modified on every save.
        // There are two exceptions:
        // 1) If the asset doesn't have any XMP metadata (and neither does the link), we fall back to compare the repo:etag
        // 2) Illustrator has a bug that it doesn't update the XMP metadata on save - so we also fall back to the repo:etag
        //    for Illustrator types, in case they were edited in an older version of Illustrator.
        const instanceID = this.adobeAsset.embeddedMetadata.data['xmpMM:InstanceID'] || '';
        const shouldCheckEtag = (!instanceID && !this.instanceID) || typesWithUnreliableInstanceID.includes(this.type);
        const assetHasChanged = instanceID !== this.instanceID || (shouldCheckEtag && this.etag !== this.adobeAsset.etag);
        if (this.alternativeAdobeAsset || assetHasChanged) {
            return 'OutOfDate';
        }
        // Check whether any metadata is out of date
        const assetLinkData = this._getLinkDataForAsset(this.adobeAsset);
        const hasMetadataChanges = assetMetadataProperties.some(key => assetLinkData[key] !== this._data[key]);
        return hasMetadataChanges ? 'MetadataOutOfDate' : 'UpToDate';
    }
    /**
     * The fragment specifier which can be used by the client to link to a fragment within the asset.
     */
    get fragmentIdentifier() {
        return this._data['stRef:fromPart'] || '';
    }
    /**
     * The version of the asset to which the link is referring to. This is only used if linking to a specific
     * version, and the version must be specified at the time of link creation.
     */
    get version() {
        return this._data['repo:version'] || '';
    }
    /**
     * The asset ID of the asset which the link refers to.
     */
    get assetID() {
        return this._data['repo:assetId'];
    }
    /**
     * The repository ID of the asset which the link refers to.
     */
    get repositoryID() {
        return this._data['repo:repositoryId'] || '';
    }
    /**
     * The owner ID of the asset which the link refers to.
     */
    // get ownerID(): string {
    //     return this._data['stRef:fromPart'] || '';
    // }
    /**
     * The name of the asset when the link was created or last updated.
     */
    get name() {
        return this._data['repo:name'] || '';
    }
    /**
     * The type of the asset when the link was created.
     */
    get type() {
        return this._data['dc:format'] || '';
    }
    /**
     * The etag of the asset when the link was created or last updated.
     */
    get etag() {
        return this._data['repo:etag'] || '';
    }
    /**
     * The relative path of the asset when the link was created or last updated.
     */
    get relativePath() {
        return this._data['stRef:relativePath'] || '';
    }
    /**
     * The document id as per the XMP metadata when the link was created or last updated.
     */
    get documentID() {
        return this._data['stRef:documentID'] || '';
    }
    /**
     * The instance id as per the XMP metadata when the link was created or last updated.
     */
    get instanceID() {
        return this._data['stRef:instanceID'] || '';
    }
    /**
     * Obtain the asset link reference to be stored in the container document for the link.
     * Note: Clients can choose to store this as a string by calling getAssetLinkRefString() instead.
     */
    getAssetLinkRef() {
        return Object.assign({}, this._data);
    }
    /**
     * Obtain the asset link reference string to be stored in the container document for the link.
     * Note: Clients can choose to store this as an object by calling getAssetLinkRef() instead.
     */
    getAssetLinkRefString() {
        return this._serializeLinkData(this._data);
    }
    /**
     * Obtain the asset link reference corresponding to the given asset. This is useful for knowing
     * the new link reference that would be obtained by updating to the given asset
     */
    getNewAssetLinkRef(asset) {
        return this._getLinkDataForAsset(asset);
    }
    /**
     * Obtain the asset link reference string corresponding to the given asset. This is useful for knowing
     * the new linkReference string that would be obtained by updating to the given asset
     */
    getNewAssetLinkRefString(asset) {
        return this._serializeLinkData(this.getNewAssetLinkRef(asset));
    }
    /**
     * Called by the clients to accept the latest changes and get the new asset link reference
     * @param asset The new asset to update to (or the current asset to accept an update)
     * @returns The new linkReference string.
     */
    async updateWithAsset(asset) {
        await this._setLinkedAsset(asset);
        return this.getAssetLinkRefString();
    }
    /**
     * Called by the clients to accept the latest changes and get the new asset link reference
     * @param linkRef A new link reference to update to
     * @returns The new link reference.
     */
    async updateWithLinkRef(linkRef) {
        await this._setLinkData(linkRef);
        return linkRef;
    }
    /**
     * Called by the clients to accept the latest changes and get the new asset link reference
     * @param linkRef A new link reference string to update to
     * @returns The new link reference string.
     */
    async updateWithLinkRefString(linkRefString) {
        await this._setLinkData(JSON.parse(linkRefString));
        return linkRefString;
    }
    /**
     * Called by the clients to accept metadata updates when the link is in the OutOfDate state.
     * If called when the link is in a different state, this does nothing.
     * @returns The new linkReference string.
     */
    acceptMetadataChanges() {
        if (this.adobeAsset && this.linkStatus === 'MetadataOutOfDate') {
            const assetLinkData = this._getLinkDataForAsset(this.adobeAsset);
            // Note that we substitute fields rather than replacing the whole link reference, because the link reference
            // may include fragment data that we don't want to delete
            this._data = Object.assign(Object.assign({}, this._data), assetLinkData);
            this._onChange();
        }
        return this.getAssetLinkRefString();
    }
}
__decorate([
    synchronized
], AssetLink.prototype, "_setLinkData", null);
__decorate([
    retry
], AssetLink.prototype, "_resolveWithRetry", null);
__decorate([
    observable$1
], AssetLink.prototype, "adobeAsset", null);
__decorate([
    observable$1
], AssetLink.prototype, "alternativeAdobeAsset", null);
__decorate([
    observable$1
], AssetLink.prototype, "linkStatus", null);
__decorate([
    observable$1
], AssetLink.prototype, "fragmentIdentifier", null);
__decorate([
    observable$1
], AssetLink.prototype, "version", null);
__decorate([
    observable$1
], AssetLink.prototype, "assetID", null);
__decorate([
    observable$1
], AssetLink.prototype, "repositoryID", null);
__decorate([
    observable$1
], AssetLink.prototype, "name", null);
__decorate([
    observable$1
], AssetLink.prototype, "type", null);
__decorate([
    observable$1
], AssetLink.prototype, "etag", null);
__decorate([
    observable$1
], AssetLink.prototype, "relativePath", null);
__decorate([
    observable$1
], AssetLink.prototype, "documentID", null);
__decorate([
    observable$1
], AssetLink.prototype, "instanceID", null);
__decorate([
    observable$1
], AssetLink.prototype, "getAssetLinkRef", null);
__decorate([
    observable$1
], AssetLink.prototype, "getAssetLinkRefString", null);
__decorate([
    observable$1
], AssetLink.prototype, "getNewAssetLinkRef", null);
__decorate([
    observable$1
], AssetLink.prototype, "getNewAssetLinkRefString", null);

class AssetLinkList extends SAMObjectUntypedEventEmitter {
    constructor(_manager, _containerAsset) {
        super(_manager._core);
        this._manager = _manager;
        this._containerAsset = _containerAsset;
        this._links = new Set();
        // We store directly monitored asset ids as a map, where the key is the lower case
        // asset id, and the value is the asset id passed in. This allows us to easily look
        // up the original case of the asset id passed in, so we can send notifications in
        // the correct case, in case a client passed it in with the wrong case
        this._directlyMonitoredAssetIDs = new Map();
        this._onChange = () => {
            this.emit('change');
        };
        this._refreshLinks = (changedIDs = new Set(this.monitoredAssetIDs)) => {
            this.forEach(link => {
                if (!link.adobeAsset && changedIDs.has(link.assetID)) {
                    // Link is broken, but asset id changed - try re-resolving
                    link._resolveWithRetry();
                }
                // Note - we do not need to refresh any assets; this will be handled by AssetContext
                // since it's updating all the assets in the asset pool.
            });
        };
        this._refreshLinksForChangedAssets = (changedIDs) => {
            this._refreshLinks(changedIDs);
            // As well as refreshing changed links, we emit a notified event, so clients can know that
            // we were notified of a change to these assets - this is useful if clients are only monitoring
            // asset ids directly, not via links.
            // Compute the intersection of changedIDs and the ones we're monitoring:
            const monitoredAssetIDs = this._monitoredAssetIDs;
            const monitoredChangedIDs = new Set();
            changedIDs.forEach(id => {
                if (monitoredAssetIDs.has(id)) {
                    monitoredChangedIDs.add(id);
                }
                // The client might have passed in an asset id in a different case to the normalized
                // platform case (e.g. clients like CC Libraries might have some older cached client
                // ids). We therefore need to map the asset id we get from the notification to the
                // one passed in.
                const normalizedId = this._directlyMonitoredAssetIDs.get(id.toLowerCase());
                if (normalizedId) {
                    monitoredChangedIDs.add(normalizedId);
                }
            });
            this.emit('notified', [...monitoredChangedIDs]);
        };
    }
    /**
     * Monitor an asset id directly, rather than going through an AssetLink. This allows you to monitor
     * a specific asset for changes without maintaining any state (i.e. it will not resolve the assetID
     * to an AdobeAsset).
     *
     * This is a lower-level API and should only be used if you're explicitly not wanting to load the
     * asset with SAM (for example, the CC Libraries API uses this since it fetches the asset data
     * from Melville, rather than R-API via SAM, so it just needs the raw notification).
     */
    addAssetID(assetID) {
        this._directlyMonitoredAssetIDs.set(assetID.toLowerCase(), assetID);
        this._onChange();
    }
    /**
     * Stop monitoring an asset id that was added via `addAssetId()`. Note that if any links in the list
     * also reference this asset id, this will not stop monitoring them.
     */
    removeAssetID(assetID) {
        this._directlyMonitoredAssetIDs.delete(assetID.toLowerCase());
        this._onChange();
    }
    /**
     * Add one or more existing links (from link reference or link reference strings) to the list.
     */
    add(linkReferences) {
        return Promise.all(linkReferences.map(async (linkRef) => {
            // TODO: Should check if already have duplicate link
            const linkReference = typeof linkRef === 'string' ? JSON.parse(linkRef) : linkRef;
            const link = new AssetLink(this, linkReference);
            this._links.add(link);
            this._onChange();
            // When adding an existing link we can always return an AssetLink even if it fails
            // We'll retry the resolution after which the link state will update.
            await link._resolveWithRetry();
            return link;
        }));
    }
    /**
     * Create a new link from an asset, and add it to the list.
     * @param asset
     * @param [fragmentSpecifier] An optional string containing the fragmentSpecifier within the asset.
     * @param [version] An optional string containing the version identifier of the Adobe asset.
     */
    async create(asset, fragmentSpecifier, version) {
        const assetID = typeof asset === 'string' ? asset : asset.cloudID;
        const link = new AssetLink(this, {
            'repo:assetId': assetID,
            'stRef:fromPart': fragmentSpecifier,
            'repo:version': version,
            'stRef:manager': 'Adobe Cloud'
        });
        this._links.add(link);
        this._onChange();
        // When creating a new link, we do _not_ retry on failure - this is because the link reference needs to be updated.
        // Errors are propagated to the client.
        await link._resolve();
        if (link.adobeAsset) {
            link._setLinkedAsset(link.adobeAsset);
        }
        return link;
    }
    /**
     * Remove an asset link from the list. This will cause it to stop being actively monitored for changes.
     */
    remove(link) {
        this._links.delete(link);
        this._onChange();
    }
    /**
     * Clear the whole list.
     */
    clear() {
        this._links.clear();
        this._onChange();
    }
    /**
     * Number of asset links in the list.
     */
    get count() {
        return this._links.size;
    }
    /**
     * Get an array of all the asset links in the list.
     */
    get links() {
        return [...this._links];
    }
    /**
     * Get a set of all the asset ids being monitored by the link list. This includes
     * asset ids in any links, as well as asset ids being directly monitored.
     */
    get _monitoredAssetIDs() {
        const assetIDs = new Set(this._directlyMonitoredAssetIDs.values());
        this.forEach(link => {
            assetIDs.add(link.assetID);
            // We also monitor the path-based resolution if it differs from asset-based:
            if (link.alternativeAdobeAsset) {
                assetIDs.add(link.alternativeAdobeAsset.cloudID);
            }
        });
        return assetIDs;
    }
    /**
     * Get an array of all the asset ids being monitored by the link list. This includes
     * asset ids in any links, as well as asset ids being directly monitored.
     */
    get monitoredAssetIDs() {
        return [...this._monitoredAssetIDs];
    }
    /**
     * Iterate through all the asset links in the list.
     */
    forEach(callback) {
        this._links.forEach(callback);
    }
    /**
     * Get the container asset for the link list (the document that contains the links)
     */
    get containerAsset() {
        return this._containerAsset;
    }
    /**
     * Marks a list as active so that the asset link manager can actively start monitoring all the asset links in it.
     * @param [duration] If a duration is specified (in ms), the list will automatically deactivate after this time. Otherwise it will remain active.
     * @deprecated This method is deprecated - lists are always monitored for notifications unless you pass in DISABLE_ONS when initializing SAM.
     *    Will be removed on or after 2024-10-01.
     */
    activate(duration = 0) {
        oneTimeWarning('AssetLinkList.activate', `AssetLinkList.activate(${duration}) is deprecated - lists are always monitored for notifications.`
            + `This method will be removed on or after 2024-10-01.`);
    }
    /**
     * Deactivate a list so that the asset link manager can stop monitoring all the asset links in it.
     * @deprecated This method is deprecated - lists are always monitored for notifications unless you pass in DISABLE_ONS when initializing SAM.
     *    Will be removed on or after 2024-10-01.
     */
    deactivate() {
        oneTimeWarning('AssetLinkList.deactivate', 'AssetLinkList.deactivate() is deprecated - lists are'
            + ' always monitored for notifications. This method will be removed on or after 2024-10-01.');
    }
    /**
     * Whether the list is active (asset links in it are actively monitored for changes or not).
     * @deprecated This method is deprecated - lists are always monitored for notifications unless you pass in DISABLE_ONS when initializing SAM.
     *    Will be removed on or after 2024-10-01.
     */
    get isActive() {
        oneTimeWarning('AssetLinkList.isActive', 'AssetLinkList.isActive is deprecated - lists are always'
            + ' monitored for notifications. This method will be removed on or after 2024-10-01.');
        return true;
    }
    /**
     * Change the container asset associated with this list (the document that contains the links in the list)
     * This will change relative path based resolution of the links
     */
    async updateContainerAsset(containerAsset) {
        this._containerAsset = containerAsset;
        this._onChange();
        // Need to resolve all the links again, because the relative path could have changed
        await Promise.all(Array.from(this._links).map(link => link._resolveWithRetry()));
    }
    /**
     * Clone the asset list for a another container asset (adding it to this list)
     */
    clone(assetLinkList) {
        // TODO: Need to trigger all links to re-resolve, since relative path resolution may have changed
        assetLinkList.links.forEach(link => this._links.add(link));
    }
}
__decorate([
    observable$1
], AssetLinkList.prototype, "count", null);
__decorate([
    observable$1
], AssetLinkList.prototype, "links", null);
__decorate([
    observable$1
], AssetLinkList.prototype, "monitoredAssetIDs", null);
__decorate([
    observable$1
], AssetLinkList.prototype, "forEach", null);
__decorate([
    observable$1
], AssetLinkList.prototype, "containerAsset", null);
__decorate([
    observable$1
], AssetLinkList.prototype, "isActive", null);

class AssetLinkManager extends SAMObjectEventEmitter {
    constructor(_context) {
        super(_context._core);
        this._context = _context;
        this._lists = new Set();
        this._onListChange = () => {
            // We need to notify the AssetContext whenever a list changes, so it can
            // update the asset ids it's subscribing to in ONS (if a link is broken,
            // we still want to get updates even if the asset isn't in the asset pool)
            this._context._updateONSSubscriptions();
        };
    }
    createList(containerAsset) {
        const list = new AssetLinkList(this, containerAsset);
        list.on('change', this._onListChange);
        this._lists.add(list);
        this.emit('change');
        return list;
    }
    removeList(list) {
        this._lists.delete(list);
        list.off('change', this._onListChange);
        this.emit('change');
    }
    /**
     * Get an array of all the asset link lists.
     */
    get lists() {
        return [...this._lists];
    }
}
__decorate([
    observable$1
], AssetLinkManager.prototype, "lists", null);

var AssetLinkManager$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': AssetLinkManager
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/*
    Constants
*/
const MIME_TYPE_MAP = {
    'application/andrew-inset': ['ez'],
    'application/applixware': ['aw'],
    'application/atom+xml': ['atom'],
    'application/atomcat+xml': ['atomcat'],
    'application/atomsvc+xml': ['atomsvc'],
    'application/ccxml+xml': ['ccxml'],
    'application/cdmi-capability': ['cdmia'],
    'application/cdmi-container': ['cdmic'],
    'application/cdmi-domain': ['cdmid'],
    'application/cdmi-object': ['cdmio'],
    'application/cdmi-queue': ['cdmiq'],
    'application/cu-seeme': ['cu'],
    'application/davmount+xml': ['davmount'],
    'application/docbook+xml': ['dbk'],
    'application/dssc+der': ['dssc'],
    'application/dssc+xml': ['xdssc'],
    'application/ecmascript': ['ecma'],
    'application/emma+xml': ['emma'],
    'application/epub+zip': ['epub'],
    'application/exi': ['exi'],
    'application/font-tdpfr': ['pfr'],
    'application/gml+xml': ['gml'],
    'application/gpx+xml': ['gpx'],
    'application/gxf': ['gxf'],
    'application/hyperstudio': ['stk'],
    'application/illustrator': ['ai'],
    'application/illustrator-text': ['ai'],
    'application/illustrator.template': ['ait'],
    'application/inkml+xml': ['ink', 'inkml'],
    'application/ipfix': ['ipfix'],
    'application/java-archive': ['jar'],
    'application/java-serialized-object': ['ser'],
    'application/java-vm': ['class'],
    'application/javascript': ['js'],
    'application/json': ['json'],
    'application/jsonml+json': ['jsonml'],
    'application/lost+xml': ['lostxml'],
    'application/mac-binhex40': ['hqx'],
    'application/mac-compactpro': ['cpt'],
    'application/mads+xml': ['mads'],
    'application/marc': ['mrc'],
    'application/marcxml+xml': ['mrcx'],
    'application/mathematica': ['ma', 'nb', 'mb'],
    'application/mathml+xml': ['mathml'],
    'application/mbox': ['mbox'],
    'application/mediaservercontrol+xml': ['mscml'],
    'application/metalink+xml': ['metalink'],
    'application/metalink4+xml': ['meta4'],
    'application/mets+xml': ['mets'],
    'application/mods+xml': ['mods'],
    'application/mp21': ['m21', 'mp21'],
    'application/mp4': ['mp4s'],
    'application/msword': ['doc', 'dot'],
    'application/mxf': ['mxf'],
    'application/octet-stream': [
        'bin',
        'dms',
        'lrf',
        'mar',
        'so',
        'dist',
        'distz',
        'pkg',
        'bpk',
        'dump',
        'elc',
        'deploy'
    ],
    'application/oda': ['oda'],
    'application/oebps-package+xml': ['opf'],
    'application/ogg': ['ogx'],
    'application/omdoc+xml': ['omdoc'],
    'application/onenote': ['onetoc', 'onetoc2', 'onetmp', 'onepkg'],
    'application/oxps': ['oxps'],
    'application/patch-ops-error+xml': ['xer'],
    'application/pdf': ['pdf'],
    'application/pgp-encrypted': ['pgp'],
    'application/pgp-signature': ['asc', 'sig'],
    'application/photoshop': ['psd'],
    'application/photoshop.large': ['psb'],
    'application/pics-rules': ['prf'],
    'application/pkcs10': ['p10'],
    'application/pkcs7-mime': ['p7m', 'p7c'],
    'application/pkcs7-signature': ['p7s'],
    'application/pkcs8': ['p8'],
    'application/pkix-attr-cert': ['ac'],
    'application/pkix-cert': ['cer'],
    'application/pkix-crl': ['crl'],
    'application/pkix-pkipath': ['pkipath'],
    'application/pkixcmp': ['pki'],
    'application/pls+xml': ['pls'],
    'application/postscript': ['ai', 'eps', 'ps'],
    'application/prs.cww': ['cww'],
    'application/pskc+xml': ['pskcxml'],
    'application/rdf+xml': ['rdf'],
    'application/reginfo+xml': ['rif'],
    'application/relax-ng-compact-syntax': ['rnc'],
    'application/resource-lists+xml': ['rl'],
    'application/resource-lists-diff+xml': ['rld'],
    'application/rls-services+xml': ['rs'],
    'application/rpki-ghostbusters': ['gbr'],
    'application/rpki-manifest': ['mft'],
    'application/rpki-roa': ['roa'],
    'application/rsd+xml': ['rsd'],
    'application/rss+xml': ['rss'],
    'application/rtf': ['rtf'],
    'application/sbml+xml': ['sbml'],
    'application/scvp-cv-request': ['scq'],
    'application/scvp-cv-response': ['scs'],
    'application/scvp-vp-request': ['spq'],
    'application/scvp-vp-response': ['spp'],
    'application/sdp': ['sdp'],
    'application/set-payment-initiation': ['setpay'],
    'application/set-registration-initiation': ['setreg'],
    'application/shf+xml': ['shf'],
    'application/smil+xml': ['smi', 'smil'],
    'application/sparql-query': ['rq'],
    'application/sparql-results+xml': ['srx'],
    'application/srgs': ['gram'],
    'application/srgs+xml': ['grxml'],
    'application/sru+xml': ['sru'],
    'application/ssdl+xml': ['ssdl'],
    'application/ssml+xml': ['ssml'],
    'application/tei+xml': ['tei', 'teicorpus'],
    'application/thraud+xml': ['tfi'],
    'application/timestamped-data': ['tsd'],
    'application/vnd.3gpp.pic-bw-large': ['plb'],
    'application/vnd.3gpp.pic-bw-small': ['psb'],
    'application/vnd.3gpp.pic-bw-var': ['pvb'],
    'application/vnd.3gpp2.tcap': ['tcap'],
    'application/vnd.3m.post-it-notes': ['pwn'],
    'application/vnd.accpac.simply.aso': ['aso'],
    'application/vnd.accpac.simply.imp': ['imp'],
    'application/vnd.acucobol': ['acu'],
    'application/vnd.acucorp': ['atc', 'acutc'],
    'application/vnd.adobe.ae.graphic+zip': ['aegraphic', 'mogrt'],
    'application/vnd.adobe.air-application-installer-package+zip': ['air'],
    'application/vnd.adobe.animate-xfl+zip': ['fla', 'xfl'],
    'application/vnd.adobe.animate-oam+zip': ['oam'],
    'application/vnd.adobe.animate-sym+zip': ['sym'],
    'application/vnd.adobe.animate-swf+zip': ['swa'],
    'application/vnd.adobe.characterstyle+json': ['style'],
    'application/vnd.adobe.characterstyle+snippet': ['idms'],
    'application/vnd.adobe.charts+zip': ['zip'],
    'application/vnd.adobe.ch.puppet+zip': ['puppet'],
    'application/vnd.adobe.color+json': ['ase'],
    'application/vnd.adobe.colortheme+json': ['ase'],
    'application/vnd.adobe.cube+txt': ['cube'],
    'application/vnd.adobe.element.agc+json': ['agc'],
    'application/vnd.adobe.exr.light+zip': ['exr'],
    'application/vnd.adobe.fbx.3d+zip': ['fbx'],
    'application/vnd.adobe.formscentral.fcdt': ['fcdt'],
    'application/vnd.adobe.fxp': ['fxp', 'fxpl'],
    'application/vnd.adobe.hz.express+dcxucf': ['dcxucf'],
    'application/vnd.adobe.ibl.light+zip': ['ibl', 'zip'],
    'application/vnd.adobe.illustrator.template': ['ait'],
    'application/vnd.adobe.indesign-idms': ['idms'],
    'application/vnd.adobe.indesign-idms-text': ['idms'],
    'application/vnd.adobe.indesign.template': ['indt'],
    'application/vnd.adobe.layerstyle': ['asl'],
    'application/vnd.adobe.look+xml': ['look'],
    'application/vnd.adobe.graphic+json': ['json'],
    'application/vnd.adobe.mdl.material+zip': ['mdl', 'zip'],
    'application/vnd.adobe.muse-collection': ['muse'],
    'application/vnd.adobe.obj.3d+zip': ['obj', 'zip'],
    'application/vnd.adobe.paragraphstyle+json': ['style'],
    'application/vnd.adobe.paragraphstyle+snippet': ['idms'],
    'application/vnd.adobe.photoshop.template': ['psdt'],
    'application/vnd.adobe.ppro.graphic+zip': ['prgraphic', 'mogrt'],
    'application/vnd.adobe.ribbon.brush+zip': ['brush'],
    'application/vnd.adobe.sbsar+zip': ['sbsar'],
    'application/vnd.adobe.scatter.brush+zip': ['brush'],
    'application/vnd.adobe.vector.brush+zip': ['brush'],
    'application/vnd.adobe.text+json': ['text-json'],
    'application/vnd.adobe.theo.document+dcxucf': ['dcxucf'],
    'application/vnd.adobe.xdp+xml': ['xdp'],
    'application/vnd.adobe.xfdf': ['xfdf'],
    'application/vnd.ahead.space': ['ahead'],
    'application/vnd.airzip.filesecure.azf': ['azf'],
    'application/vnd.airzip.filesecure.azs': ['azs'],
    'application/vnd.amazon.ebook': ['azw'],
    'application/vnd.americandynamics.acc': ['acc'],
    'application/vnd.amiga.ami': ['ami'],
    'application/vnd.android.package-archive': ['apk'],
    'application/vnd.anser-web-certificate-issue-initiation': ['cii'],
    'application/vnd.anser-web-funds-transfer-initiation': ['fti'],
    'application/vnd.antix.game-component': ['atx'],
    'application/vnd.apple.installer+xml': ['mpkg'],
    'application/vnd.apple.mpegurl': ['m3u8'],
    'application/vnd.aristanetworks.swi': ['swi'],
    'application/vnd.astraea-software.iota': ['iota'],
    'application/vnd.audiograph': ['aep'],
    'application/vnd.blueice.multipass': ['mpm'],
    'application/vnd.bmi': ['bmi'],
    'application/vnd.businessobjects': ['rep'],
    'application/vnd.chemdraw+xml': ['cdxml'],
    'application/vnd.chipnuts.karaoke-mmd': ['mmd'],
    'application/vnd.cinderella': ['cdy'],
    'application/vnd.claymore': ['cla'],
    'application/vnd.cloanto.rp9': ['rp9'],
    'application/vnd.clonk.c4group': ['c4g', 'c4d', 'c4f', 'c4p', 'c4u'],
    'application/vnd.cluetrust.cartomobile-config': ['c11amc'],
    'application/vnd.cluetrust.cartomobile-config-pkg': ['c11amz'],
    'application/vnd.commonspace': ['csp'],
    'application/vnd.contact.cmsg': ['cdbcmsg'],
    'application/vnd.cosmocaller': ['cmc'],
    'application/vnd.crick.clicker': ['clkx'],
    'application/vnd.crick.clicker.keyboard': ['clkk'],
    'application/vnd.crick.clicker.palette': ['clkp'],
    'application/vnd.crick.clicker.template': ['clkt'],
    'application/vnd.crick.clicker.wordbank': ['clkw'],
    'application/vnd.criticaltools.wbs+xml': ['wbs'],
    'application/vnd.ctc-posml': ['pml'],
    'application/vnd.cups-ppd': ['ppd'],
    'application/vnd.curl.car': ['car'],
    'application/vnd.curl.pcurl': ['pcurl'],
    'application/vnd.dart': ['dart'],
    'application/vnd.data-vision.rdz': ['rdz'],
    'application/vnd.dece.data': ['uvf', 'uvvf', 'uvd', 'uvvd'],
    'application/vnd.dece.ttml+xml': ['uvt', 'uvvt'],
    'application/vnd.dece.unspecified': ['uvx', 'uvvx'],
    'application/vnd.dece.zip': ['uvz', 'uvvz'],
    'application/vnd.denovo.fcselayout-link': ['fe_launch'],
    'application/vnd.dna': ['dna'],
    'application/vnd.dolby.mlp': ['mlp'],
    'application/vnd.dpgraph': ['dpg'],
    'application/vnd.dreamfactory': ['dfac'],
    'application/vnd.ds-keypoint': ['kpxx'],
    'application/vnd.dvb.ait': ['ait'],
    'application/vnd.dvb.service': ['svc'],
    'application/vnd.dynageo': ['geo'],
    'application/vnd.ecowin.chart': ['mag'],
    'application/vnd.enliven': ['nml'],
    'application/vnd.epson.esf': ['esf'],
    'application/vnd.epson.msf': ['msf'],
    'application/vnd.epson.quickanime': ['qam'],
    'application/vnd.epson.salt': ['slt'],
    'application/vnd.epson.ssf': ['ssf'],
    'application/vnd.eszigno3+xml': ['es3', 'et3'],
    'application/vnd.ezpix-album': ['ez2'],
    'application/vnd.ezpix-package': ['ez3'],
    'application/vnd.fdf': ['fdf'],
    'application/vnd.fdsn.mseed': ['mseed'],
    'application/vnd.fdsn.seed': ['seed', 'dataless'],
    'application/vnd.flographit': ['gph'],
    'application/vnd.fluxtime.clip': ['ftc'],
    'application/vnd.framemaker': ['fm', 'frame', 'maker', 'book'],
    'application/vnd.frogans.fnc': ['fnc'],
    'application/vnd.frogans.ltf': ['ltf'],
    'application/vnd.fsc.weblaunch': ['fsc'],
    'application/vnd.fujitsu.oasys': ['oas'],
    'application/vnd.fujitsu.oasys2': ['oa2'],
    'application/vnd.fujitsu.oasys3': ['oa3'],
    'application/vnd.fujitsu.oasysgp': ['fg5'],
    'application/vnd.fujitsu.oasysprs': ['bh2'],
    'application/vnd.fujixerox.ddd': ['ddd'],
    'application/vnd.fujixerox.docuworks': ['xdw'],
    'application/vnd.fujixerox.docuworks.binder': ['xbd'],
    'application/vnd.fuzzysheet': ['fzs'],
    'application/vnd.genomatix.tuxedo': ['txd'],
    'application/vnd.geogebra.file': ['ggb'],
    'application/vnd.geogebra.tool': ['ggt'],
    'application/vnd.geometry-explorer': ['gex', 'gre'],
    'application/vnd.geonext': ['gxt'],
    'application/vnd.geoplan': ['g2w'],
    'application/vnd.geospace': ['g3w'],
    'application/vnd.gmx': ['gmx'],
    'application/vnd.google-earth.kml+xml': ['kml'],
    'application/vnd.google-earth.kmz': ['kmz'],
    'application/vnd.grafeq': ['gqf', 'gqs'],
    'application/vnd.groove-account': ['gac'],
    'application/vnd.groove-help': ['ghf'],
    'application/vnd.groove-identity-message': ['gim'],
    'application/vnd.groove-injector': ['grv'],
    'application/vnd.groove-tool-message': ['gtm'],
    'application/vnd.groove-tool-template': ['tpl'],
    'application/vnd.groove-vcard': ['vcg'],
    'application/vnd.hal+xml': ['hal'],
    'application/vnd.handheld-entertainment+xml': ['zmm'],
    'application/vnd.hbci': ['hbci'],
    'application/vnd.hhe.lesson-player': ['les'],
    'application/vnd.hp-hpgl': ['hpgl'],
    'application/vnd.hp-hpid': ['hpid'],
    'application/vnd.hp-hps': ['hps'],
    'application/vnd.hp-jlyt': ['jlt'],
    'application/vnd.hp-pcl': ['pcl'],
    'application/vnd.hp-pclxl': ['pclxl'],
    'application/vnd.ibm.minipay': ['mpy'],
    'application/vnd.ibm.modcap': ['afp', 'listafp', 'list3820'],
    'application/vnd.ibm.rights-management': ['irm'],
    'application/vnd.ibm.secure-container': ['sc'],
    'application/vnd.iccprofile': ['icc', 'icm'],
    'application/vnd.igloader': ['igl'],
    'application/vnd.immervision-ivp': ['ivp'],
    'application/vnd.immervision-ivu': ['ivu'],
    'application/vnd.insors.igm': ['igm'],
    'application/vnd.intercon.formnet': ['xpw', 'xpx'],
    'application/vnd.intergeo': ['i2g'],
    'application/vnd.intu.qbo': ['qbo'],
    'application/vnd.intu.qfx': ['qfx'],
    'application/vnd.ipunplugged.rcprofile': ['rcprofile'],
    'application/vnd.irepository.package+xml': ['irp'],
    'application/vnd.is-xpr': ['xpr'],
    'application/vnd.isac.fcs': ['fcs'],
    'application/vnd.jam': ['jam'],
    'application/vnd.jcp.javame.midlet-rms': ['rms'],
    'application/vnd.jisp': ['jisp'],
    'application/vnd.joost.joda-archive': ['joda'],
    'application/vnd.kahootz': ['ktz', 'ktr'],
    'application/vnd.kde.karbon': ['karbon'],
    'application/vnd.kde.kchart': ['chrt'],
    'application/vnd.kde.kformula': ['kfo'],
    'application/vnd.kde.kivio': ['flw'],
    'application/vnd.kde.kontour': ['kon'],
    'application/vnd.kde.kpresenter': ['kpr', 'kpt'],
    'application/vnd.kde.kspread': ['ksp'],
    'application/vnd.kde.kword': ['kwd', 'kwt'],
    'application/vnd.kenameaapp': ['htke'],
    'application/vnd.kidspiration': ['kia'],
    'application/vnd.kinar': ['kne', 'knp'],
    'application/vnd.koan': ['skp', 'skd', 'skt', 'skm'],
    'application/vnd.kodak-descriptor': ['sse'],
    'application/vnd.las.las+xml': ['lasxml'],
    'application/vnd.llamagraphics.life-balance.desktop': ['lbd'],
    'application/vnd.llamagraphics.life-balance.exchange+xml': ['lbe'],
    'application/vnd.lotus-1-2-3': ['123'],
    'application/vnd.lotus-approach': ['apr'],
    'application/vnd.lotus-freelance': ['pre'],
    'application/vnd.lotus-notes': ['nsf'],
    'application/vnd.lotus-organizer': ['org'],
    'application/vnd.lotus-screencam': ['scm'],
    'application/vnd.lotus-wordpro': ['lwp'],
    'application/vnd.macports.portpkg': ['portpkg'],
    'application/vnd.mcd': ['mcd'],
    'application/vnd.medcalcdata': ['mc1'],
    'application/vnd.mediastation.cdkey': ['cdkey'],
    'application/vnd.mfer': ['mwf'],
    'application/vnd.mfmp': ['mfm'],
    'application/vnd.micrografx.flo': ['flo'],
    'application/vnd.micrografx.igx': ['igx'],
    'application/vnd.mif': ['mif'],
    'application/vnd.mobius.daf': ['daf'],
    'application/vnd.mobius.dis': ['dis'],
    'application/vnd.mobius.mbk': ['mbk'],
    'application/vnd.mobius.mqy': ['mqy'],
    'application/vnd.mobius.msl': ['msl'],
    'application/vnd.mobius.plc': ['plc'],
    'application/vnd.mobius.txf': ['txf'],
    'application/vnd.mophun.application': ['mpn'],
    'application/vnd.mophun.certificate': ['mpc'],
    'application/vnd.mozilla.xul+xml': ['xul'],
    'application/vnd.ms-artgalry': ['cil'],
    'application/vnd.ms-cab-compressed': ['cab'],
    'application/vnd.ms-excel': ['xls', 'xlm', 'xla', 'xlc', 'xlt', 'xlw'],
    'application/vnd.ms-excel.addin.macroenabled.12': ['xlam'],
    'application/vnd.ms-excel.sheet.binary.macroenabled.12': ['xlsb'],
    'application/vnd.ms-excel.sheet.macroenabled.12': ['xlsm'],
    'application/vnd.ms-excel.template.macroenabled.12': ['xltm'],
    'application/vnd.ms-fontobject': ['eot'],
    'application/vnd.ms-htmlhelp': ['chm'],
    'application/vnd.ms-ims': ['ims'],
    'application/vnd.ms-lrm': ['lrm'],
    'application/vnd.ms-officetheme': ['thmx'],
    'application/vnd.ms-pki.seccat': ['cat'],
    'application/vnd.ms-pki.stl': ['stl'],
    'application/vnd.ms-powerpoint': ['ppt', 'pps', 'pot'],
    'application/vnd.ms-powerpoint.addin.macroenabled.12': ['ppam'],
    'application/vnd.ms-powerpoint.presentation.macroenabled.12': ['pptm'],
    'application/vnd.ms-powerpoint.slide.macroenabled.12': ['sldm'],
    'application/vnd.ms-powerpoint.slideshow.macroenabled.12': ['ppsm'],
    'application/vnd.ms-powerpoint.template.macroenabled.12': ['potm'],
    'application/vnd.ms-project': ['mpp', 'mpt'],
    'application/vnd.ms-word.document.macroenabled.12': ['docm'],
    'application/vnd.ms-word.template.macroenabled.12': ['dotm'],
    'application/vnd.ms-works': ['wps', 'wks', 'wcm', 'wdb'],
    'application/vnd.ms-wpl': ['wpl'],
    'application/vnd.ms-xpsdocument': ['xps'],
    'application/vnd.mseq': ['mseq'],
    'application/vnd.musician': ['mus'],
    'application/vnd.muvee.style': ['msty'],
    'application/vnd.mynfc': ['taglet'],
    'application/vnd.neurolanguage.nlu': ['nlu'],
    'application/vnd.nitf': ['ntf', 'nitf'],
    'application/vnd.noblenet-directory': ['nnd'],
    'application/vnd.noblenet-sealer': ['nns'],
    'application/vnd.noblenet-web': ['nnw'],
    'application/vnd.nokia.n-gage.data': ['ngdat'],
    'application/vnd.nokia.radio-preset': ['rpst'],
    'application/vnd.nokia.radio-presets': ['rpss'],
    'application/vnd.novadigm.edm': ['edm'],
    'application/vnd.novadigm.edx': ['edx'],
    'application/vnd.novadigm.ext': ['ext'],
    'application/vnd.oasis.opendocument.chart': ['odc'],
    'application/vnd.oasis.opendocument.chart-template': ['otc'],
    'application/vnd.oasis.opendocument.database': ['odb'],
    'application/vnd.oasis.opendocument.formula': ['odf'],
    'application/vnd.oasis.opendocument.formula-template': ['odft'],
    'application/vnd.oasis.opendocument.graphics': ['odg'],
    'application/vnd.oasis.opendocument.graphics-template': ['otg'],
    'application/vnd.oasis.opendocument.image': ['odi'],
    'application/vnd.oasis.opendocument.image-template': ['oti'],
    'application/vnd.oasis.opendocument.presentation': ['odp'],
    'application/vnd.oasis.opendocument.presentation-template': ['otp'],
    'application/vnd.oasis.opendocument.spreadsheet': ['ods'],
    'application/vnd.oasis.opendocument.spreadsheet-template': ['ots'],
    'application/vnd.oasis.opendocument.text': ['odt'],
    'application/vnd.oasis.opendocument.text-master': ['odm'],
    'application/vnd.oasis.opendocument.text-template': ['ott'],
    'application/vnd.oasis.opendocument.text-web': ['oth'],
    'application/vnd.olpc-sugar': ['xo'],
    'application/vnd.oma.dd2+xml': ['dd2'],
    'application/vnd.openofficeorg.extension': ['oxt'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['pptx'],
    'application/vnd.openxmlformats-officedocument.presentationml.slide': ['sldx'],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': ['ppsx'],
    'application/vnd.openxmlformats-officedocument.presentationml.template': ['potx'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['xlsx'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': ['xltx'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['docx'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': ['dotx'],
    'application/vnd.osgeo.mapguide.package': ['mgp'],
    'application/vnd.osgi.dp': ['dp'],
    'application/vnd.osgi.subsystem': ['esa'],
    'application/vnd.palm': ['pdb', 'pqa', 'oprc'],
    'application/vnd.pawaafile': ['paw'],
    'application/vnd.pg.format': ['str'],
    'application/vnd.pg.osasli': ['ei6'],
    'application/vnd.picsel': ['efif'],
    'application/vnd.pmi.widget': ['wg'],
    'application/vnd.pocketlearn': ['plf'],
    'application/vnd.powerbuilder6': ['pbd'],
    'application/vnd.previewsystems.box': ['box'],
    'application/vnd.proteus.magazine': ['mgz'],
    'application/vnd.publishare-delta-tree': ['qps'],
    'application/vnd.pvi.ptid1': ['ptid'],
    'application/vnd.quark.quarkxpress': ['qxd', 'qxt', 'qwd', 'qwt', 'qxl', 'qxb'],
    'application/vnd.realvnc.bed': ['bed'],
    'application/vnd.recordare.musicxml': ['mxl'],
    'application/vnd.recordare.musicxml+xml': ['musicxml'],
    'application/vnd.rig.cryptonote': ['cryptonote'],
    'application/vnd.rim.cod': ['cod'],
    'application/vnd.rn-realmedia': ['rm'],
    'application/vnd.rn-realmedia-vbr': ['rmvb'],
    'application/vnd.route66.link66+xml': ['link66'],
    'application/vnd.sailingtracker.track': ['st'],
    'application/vnd.seemail': ['see'],
    'application/vnd.sema': ['sema'],
    'application/vnd.semd': ['semd'],
    'application/vnd.semf': ['semf'],
    'application/vnd.shana.informed.formdata': ['ifm'],
    'application/vnd.shana.informed.formtemplate': ['itp'],
    'application/vnd.shana.informed.interchange': ['iif'],
    'application/vnd.shana.informed.package': ['ipk'],
    'application/vnd.simtech-mindmapper': ['twd', 'twds'],
    'application/vnd.smaf': ['mmf'],
    'application/vnd.smart.teacher': ['teacher'],
    'application/vnd.solent.sdkm+xml': ['sdkm', 'sdkd'],
    'application/vnd.spotfire.dxp': ['dxp'],
    'application/vnd.spotfire.sfs': ['sfs'],
    'application/vnd.stardivision.calc': ['sdc'],
    'application/vnd.stardivision.draw': ['sda'],
    'application/vnd.stardivision.impress': ['sdd'],
    'application/vnd.stardivision.math': ['smf'],
    'application/vnd.stardivision.writer': ['sdw', 'vor'],
    'application/vnd.stardivision.writer-global': ['sgl'],
    'application/vnd.stepmania.package': ['smzip'],
    'application/vnd.stepmania.stepchart': ['sm'],
    'application/vnd.sun.xml.calc': ['sxc'],
    'application/vnd.sun.xml.calc.template': ['stc'],
    'application/vnd.sun.xml.draw': ['sxd'],
    'application/vnd.sun.xml.draw.template': ['std'],
    'application/vnd.sun.xml.impress': ['sxi'],
    'application/vnd.sun.xml.impress.template': ['sti'],
    'application/vnd.sun.xml.math': ['sxm'],
    'application/vnd.sun.xml.writer': ['sxw'],
    'application/vnd.sun.xml.writer.global': ['sxg'],
    'application/vnd.sun.xml.writer.template': ['stw'],
    'application/vnd.sus-calendar': ['sus', 'susp'],
    'application/vnd.svd': ['svd'],
    'application/vnd.symbian.install': ['sis', 'sisx'],
    'application/vnd.syncml+xml': ['xsm'],
    'application/vnd.syncml.dm+wbxml': ['bdm'],
    'application/vnd.syncml.dm+xml': ['xdm'],
    'application/vnd.tao.intent-module-archive': ['tao'],
    'application/vnd.tcpdump.pcap': ['pcap', 'cap', 'dmp'],
    'application/vnd.tmobile-livetv': ['tmo'],
    'application/vnd.trid.tpt': ['tpt'],
    'application/vnd.triscape.mxs': ['mxs'],
    'application/vnd.trueapp': ['tra'],
    'application/vnd.ufdl': ['ufd', 'ufdl'],
    'application/vnd.uiq.theme': ['utz'],
    'application/vnd.umajin': ['umj'],
    'application/vnd.unity': ['unityweb'],
    'application/vnd.uoml+xml': ['uoml'],
    'application/vnd.vcx': ['vcx'],
    'application/vnd.visio': ['vsd', 'vst', 'vss', 'vsw'],
    'application/vnd.visionary': ['vis'],
    'application/vnd.vsf': ['vsf'],
    'application/vnd.wap.wbxml': ['wbxml'],
    'application/vnd.wap.wmlc': ['wmlc'],
    'application/vnd.wap.wmlscriptc': ['wmlsc'],
    'application/vnd.webturbo': ['wtb'],
    'application/vnd.wolfram.player': ['nbp'],
    'application/vnd.wordperfect': ['wpd'],
    'application/vnd.wqd': ['wqd'],
    'application/vnd.wt.stf': ['stf'],
    'application/vnd.xara': ['xar'],
    'application/vnd.xfdl': ['xfdl'],
    'application/vnd.yamaha.hv-dic': ['hvd'],
    'application/vnd.yamaha.hv-script': ['hvs'],
    'application/vnd.yamaha.hv-voice': ['hvp'],
    'application/vnd.yamaha.openscoreformat': ['osf'],
    'application/vnd.yamaha.openscoreformat.osfpvg+xml': ['osfpvg'],
    'application/vnd.yamaha.smaf-audio': ['saf'],
    'application/vnd.yamaha.smaf-phrase': ['spf'],
    'application/vnd.yellowriver-custom-menu': ['cmp'],
    'application/vnd.zul': ['zir', 'zirz'],
    'application/vnd.zzazz.deck+xml': ['zaz'],
    'application/voicexml+xml': ['vxml'],
    'application/widget': ['wgt'],
    'application/winhlp': ['hlp'],
    'application/wsdl+xml': ['wsdl'],
    'application/wspolicy+xml': ['wspolicy'],
    'application/x-7z-compressed': ['7z'],
    'application/x-abiword': ['abw'],
    'application/x-ace-compressed': ['ace'],
    'application/x-apple-diskimage': ['dmg'],
    'application/x-authorware-bin': ['aab', 'x32', 'u32', 'vox'],
    'application/x-authorware-map': ['aam'],
    'application/x-authorware-seg': ['aas'],
    'application/x-bcpio': ['bcpio'],
    'application/x-bittorrent': ['torrent'],
    'application/x-blorb': ['blb', 'blorb'],
    'application/x-bzip': ['bz'],
    'application/x-bzip2': ['bz2', 'boz'],
    'application/x-cbr': ['cbr', 'cba', 'cbt', 'cbz', 'cb7'],
    'application/x-cdlink': ['vcd'],
    'application/x-cfs-compressed': ['cfs'],
    'application/x-chat': ['chat'],
    'application/x-chess-pgn': ['pgn'],
    'application/x-conference': ['nsc'],
    'application/x-cpio': ['cpio'],
    'application/x-csh': ['csh'],
    'application/x-debian-package': ['deb', 'udeb'],
    'application/x-dgc-compressed': ['dgc'],
    'application/x-director': ['dir', 'dcr', 'dxr', 'cst', 'cct', 'cxt', 'w3d', 'fgd', 'swa'],
    'application/x-doom': ['wad'],
    'application/x-dtbncx+xml': ['ncx'],
    'application/x-dtbook+xml': ['dtb'],
    'application/x-dtbresource+xml': ['res'],
    'application/x-dvi': ['dvi'],
    'application/x-envoy': ['evy'],
    'application/x-eva': ['eva'],
    'application/x-font-bdf': ['bdf'],
    'application/x-font-ghostscript': ['gsf'],
    'application/x-font-linux-psf': ['psf'],
    'application/x-font-otf': ['otf'],
    'application/x-font-pcf': ['pcf'],
    'application/x-font-snf': ['snf'],
    'application/x-font-ttf': ['ttf', 'ttc'],
    'application/x-font-type1': ['pfa', 'pfb', 'pfm', 'afm'],
    'application/font-woff': ['woff'],
    'application/x-freearc': ['arc'],
    'application/x-futuresplash': ['spl'],
    'application/x-gca-compressed': ['gca'],
    'application/x-glulx': ['ulx'],
    'application/x-gnumeric': ['gnumeric'],
    'application/x-gramps-xml': ['gramps'],
    'application/x-gtar': ['gtar'],
    'application/x-hdf': ['hdf'],
    'application/x-install-instructions': ['install'],
    'application/x-iso9660-image': ['iso'],
    'application/x-java-jnlp-file': ['jnlp'],
    'application/x-latex': ['latex'],
    'application/x-lzh-compressed': ['lzh', 'lha'],
    'application/x-mie': ['mie'],
    'application/x-mobipocket-ebook': ['prc', 'mobi'],
    'application/x-ms-application': ['application'],
    'application/x-ms-shortcut': ['lnk'],
    'application/x-ms-wmd': ['wmd'],
    'application/x-ms-wmz': ['wmz'],
    'application/x-ms-xbap': ['xbap'],
    'application/x-msaccess': ['mdb'],
    'application/x-msbinder': ['obd'],
    'application/x-mscardfile': ['crd'],
    'application/x-msclip': ['clp'],
    'application/x-msdownload': ['exe', 'dll', 'com', 'bat', 'msi'],
    'application/x-msmediaview': ['mvb', 'm13', 'm14'],
    'application/x-msmetafile': ['wmf', 'wmz', 'emf', 'emz'],
    'application/x-msmoney': ['mny'],
    'application/x-mspublisher': ['pub'],
    'application/x-msschedule': ['scd'],
    'application/x-msterminal': ['trm'],
    'application/x-mswrite': ['wri'],
    'application/x-netcdf': ['nc', 'cdf'],
    'application/x-nzb': ['nzb'],
    'application/x-pkcs12': ['p12', 'pfx'],
    'application/x-pkcs7-certificates': ['p7b', 'spc'],
    'application/x-pkcs7-certreqresp': ['p7r'],
    'application/x-rar-compressed': ['rar'],
    'application/x-research-info-systems': ['ris'],
    'application/x-sh': ['sh'],
    'application/x-shar': ['shar'],
    'application/x-shockwave-flash': ['swf'],
    'application/x-silverlight-app': ['xap'],
    'application/x-sql': ['sql'],
    'application/x-stuffit': ['sit'],
    'application/x-stuffitx': ['sitx'],
    'application/x-subrip': ['srt'],
    'application/x-sv4cpio': ['sv4cpio'],
    'application/x-sv4crc': ['sv4crc'],
    'application/x-t3vm-image': ['t3'],
    'application/x-tads': ['gam'],
    'application/x-tar': ['tar'],
    'application/x-tcl': ['tcl'],
    'application/x-tex': ['tex'],
    'application/x-tex-tfm': ['tfm'],
    'application/x-texinfo': ['texinfo', 'texi'],
    'application/x-tgif': ['obj'],
    'application/x-ustar': ['ustar'],
    'application/x-wais-source': ['src'],
    'application/x-x509-ca-cert': ['der', 'crt'],
    'application/x-xfig': ['fig'],
    'application/x-xliff+xml': ['xlf'],
    'application/x-xpinstall': ['xpi'],
    'application/x-xz': ['xz'],
    'application/x-zmachine': ['z1', 'z2', 'z3', 'z4', 'z5', 'z6', 'z7', 'z8'],
    'application/xaml+xml': ['xaml'],
    'application/xcap-diff+xml': ['xdf'],
    'application/xenc+xml': ['xenc'],
    'application/xhtml+xml': ['xhtml', 'xht'],
    'application/xml': ['xml', 'xsl'],
    'application/xml-dtd': ['dtd'],
    'application/xop+xml': ['xop'],
    'application/xproc+xml': ['xpl'],
    'application/xslt+xml': ['xslt'],
    'application/xspf+xml': ['xspf'],
    'application/xv+xml': ['mxml', 'xhvml', 'xvml', 'xvm'],
    'application/yang': ['yang'],
    'application/yin+xml': ['yin'],
    'application/zip': ['zip'],
    'audio/adpcm': ['adp'],
    'audio/aif': ['aif'],
    'audio/basic': ['au', 'snd'],
    'audio/m4a': ['m4a'],
    'audio/midi': ['mid', 'midi', 'kar', 'rmi'],
    'audio/mp4': ['mp4a'],
    'audio/mpeg': ['mpga', 'mp2', 'mp2a', 'm2a'],
    'audio/mpeg3': ['mp3', 'm3a'],
    'audio/ogg': ['oga', 'ogg', 'spx'],
    'audio/s3m': ['s3m'],
    'audio/silk': ['sil'],
    'audio/vnd.dece.audio': ['uva', 'uvva'],
    'audio/vnd.digital-winds': ['eol'],
    'audio/vnd.dra': ['dra'],
    'audio/vnd.dts': ['dts'],
    'audio/vnd.dts.hd': ['dtshd'],
    'audio/vnd.lucent.voice': ['lvp'],
    'audio/vnd.ms-playready.media.pya': ['pya'],
    'audio/vnd.nuera.ecelp4800': ['ecelp4800'],
    'audio/vnd.nuera.ecelp7470': ['ecelp7470'],
    'audio/vnd.nuera.ecelp9600': ['ecelp9600'],
    'audio/vnd.rip': ['rip'],
    'audio/wav': ['wav'],
    'audio/webm': ['weba'],
    'audio/x-aac': ['aac'],
    'audio/x-aiff': ['aiff', 'aifc'],
    'audio/x-caf': ['caf'],
    'audio/x-flac': ['flac'],
    'audio/x-matroska': ['mka'],
    'audio/x-mpegurl': ['m3u'],
    'audio/x-ms-wax': ['wax'],
    'audio/x-ms-wma': ['wma'],
    'audio/x-pn-realaudio': ['ram', 'ra'],
    'audio/x-pn-realaudio-plugin': ['rmp'],
    'audio/x-wav': ['wav'],
    'audio/xm': ['xm'],
    'chemical/x-cdx': ['cdx'],
    'chemical/x-cif': ['cif'],
    'chemical/x-cmdf': ['cmdf'],
    'chemical/x-cml': ['cml'],
    'chemical/x-csml': ['csml'],
    'chemical/x-xyz': ['xyz'],
    'image/bmp': ['bmp'],
    'image/cgm': ['cgm'],
    'image/dng': ['dng'],
    'image/g3fax': ['g3'],
    'image/gif': ['gif'],
    'image/heic': ['heic'],
    'image/heif': ['heif'],
    'image/ief': ['ief'],
    'image/jpeg': ['jpeg', 'jpg', 'jpe'],
    'image/jpg': ['jpeg', 'jpg'],
    'image/ktx': ['ktx'],
    'image/png': ['png'],
    'image/prs.btif': ['btif'],
    'image/sgi': ['sgi'],
    'image/svg+xml': ['svg', 'svgz'],
    'image/tiff': ['tiff', 'tif'],
    'image/vnd.adobe.photoshop': ['psd'],
    'image/vnd.adobe.photoshop.template': ['psdt'],
    'image/vnd.adobe.pattern+png': ['png'],
    'image/vnd.adobe.shape+svg': ['shape'],
    'image/vnd.dece.graphic': ['uvi', 'uvvi', 'uvg', 'uvvg'],
    'image/vnd.dvb.subtitle': ['sub'],
    'image/vnd.djvu': ['djvu', 'djv'],
    'image/vnd.dwg': ['dwg'],
    'image/vnd.dxf': ['dxf'],
    'image/vnd.fastbidsheet': ['fbs'],
    'image/vnd.fpx': ['fpx'],
    'image/vnd.fst': ['fst'],
    'image/vnd.fujixerox.edmics-mmr': ['mmr'],
    'image/vnd.fujixerox.edmics-rlc': ['rlc'],
    'image/vnd.ms-modi': ['mdi'],
    'image/vnd.ms-photo': ['wdp'],
    'image/vnd.net-fpx': ['npx'],
    'image/vnd.wap.wbmp': ['wbmp'],
    'image/vnd.xiff': ['xif'],
    'image/webp': ['webp'],
    'image/x-3ds': ['3ds'],
    'image/x-adobe-dng': ['dng'],
    'image/x-adobe-photoshop-brush': ['abr'],
    'image/x-cmu-raster': ['ras'],
    'image/x-cmx': ['cmx'],
    'image/x-freehand': ['fh', 'fhc', 'fh4', 'fh5', 'fh7'],
    'image/x-icon': ['ico'],
    'image/x-mrsid-image': ['sid'],
    'image/x-pcx': ['pcx'],
    'image/x-pict': ['pic', 'pct'],
    'image/x-portable-anymap': ['pnm'],
    'image/x-portable-bitmap': ['pbm'],
    'image/x-portable-graymap': ['pgm'],
    'image/x-portable-pixmap': ['ppm'],
    'image/x-rgb': ['rgb'],
    'image/x-tga': ['tga'],
    'image/x-xbitmap': ['xbm'],
    'image/x-xpixmap': ['xpm'],
    'image/x-xwindowdump': ['xwd'],
    'message/rfc822': ['eml', 'mime'],
    'model/gltf-binary': ['glb'],
    'model/gltf+json': ['gltf'],
    'model/iges': ['igs', 'iges'],
    'model/mesh': ['msh', 'mesh', 'silo'],
    'model/vnd.usdz+zip': ['usdz'],
    'model/vnd.adobe.dn+dcx': ['dn'],
    'model/vnd.adobe.dn+dcxucf': ['dn'],
    'model/vnd.collada+xml': ['dae'],
    'model/vnd.dwf': ['dwf'],
    'model/vnd.gdl': ['gdl'],
    'model/vnd.gtw': ['gtw'],
    'model/vnd.mts': ['mts'],
    'model/vnd.vtu': ['vtu'],
    'model/vrml': ['wrl', 'vrml'],
    'model/x3d+binary': ['x3db', 'x3dbz'],
    'model/x3d+vrml': ['x3dv', 'x3dvz'],
    'model/x3d+xml': ['x3d', 'x3dz'],
    'text/cache-manifest': ['appcache'],
    'text/calendar': ['ics', 'ifb'],
    'text/css': ['css'],
    'text/csv': ['csv'],
    'text/html': ['html', 'htm'],
    'text/n3': ['n3'],
    'text/plain': ['txt', 'text', 'conf', 'def', 'list', 'log', 'in'],
    'text/prs.lines.tag': ['dsc'],
    'text/richtext': ['rtx'],
    'text/sgml': ['sgml', 'sgm'],
    'text/tab-separated-values': ['tsv'],
    'text/troff': ['t', 'tr', 'roff', 'man', 'me', 'ms'],
    'text/turtle': ['ttl'],
    'text/uri-list': ['uri', 'uris', 'urls'],
    'text/vcard': ['vcard'],
    'text/vnd.curl': ['curl'],
    'text/vnd.curl.dcurl': ['dcurl'],
    'text/vnd.curl.scurl': ['scurl'],
    'text/vnd.curl.mcurl': ['mcurl'],
    'text/vnd.dvb.subtitle': ['sub'],
    'text/vnd.fly': ['fly'],
    'text/vnd.fmi.flexstor': ['flx'],
    'text/vnd.graphviz': ['gv'],
    'text/vnd.in3d.3dml': ['3dml'],
    'text/vnd.in3d.spot': ['spot'],
    'text/vnd.sun.j2me.app-descriptor': ['jad'],
    'text/vnd.wap.wml': ['wml'],
    'text/vnd.wap.wmlscript': ['wmls'],
    'text/x-asm': ['s', 'asm'],
    'text/x-c': ['c', 'cc', 'cxx', 'cpp', 'h', 'hh', 'dic'],
    'text/x-fortran': ['f', 'for', 'f77', 'f90'],
    'text/x-java-source': ['java'],
    'text/x-opml': ['opml'],
    'text/x-pascal': ['p', 'pas'],
    'text/x-nfo': ['nfo'],
    'text/x-setext': ['etx'],
    'text/x-sfv': ['sfv'],
    'text/x-uuencode': ['uu'],
    'text/x-vcalendar': ['vcs'],
    'text/x-vcard': ['vcf'],
    'video/3gpp': ['3gp'],
    'video/3gpp2': ['3g2'],
    'video/h261': ['h261'],
    'video/h263': ['h263'],
    'video/h264': ['h264'],
    'video/jpeg': ['jpgv'],
    'video/jpm': ['jpm', 'jpgm'],
    'video/mj2': ['mj2', 'mjp2'],
    'video/mp4': ['mp4', 'mp4v', 'mpg4'],
    'video/mpeg': ['mpeg', 'mpg', 'mpe', 'm1v', 'm2v'],
    'video/ogg': ['ogv'],
    'video/quicktime': ['mov', 'qt'],
    'video/vnd.dece.hd': ['uvh', 'uvvh'],
    'video/vnd.dece.mobile': ['uvm', 'uvvm'],
    'video/vnd.dece.pd': ['uvp', 'uvvp'],
    'video/vnd.dece.sd': ['uvs', 'uvvs'],
    'video/vnd.dece.video': ['uvv', 'uvvv'],
    'video/vnd.dvb.file': ['dvb'],
    'video/vnd.fvt': ['fvt'],
    'video/vnd.mpegurl': ['mxu', 'm4u'],
    'video/vnd.ms-playready.media.pyv': ['pyv'],
    'video/vnd.uvvu.mp4': ['uvu', 'uvvu'],
    'video/vnd.vivo': ['viv'],
    'video/webm': ['webm'],
    'video/x-f4v': ['f4v'],
    'video/x-fli': ['fli'],
    'video/x-flv': ['flv'],
    'video/x-m4v': ['m4v'],
    'video/x-matroska': ['mkv', 'mk3d', 'mks'],
    'video/x-mng': ['mng'],
    'video/x-ms-asf': ['asf', 'asx', 'wmv'],
    'video/x-ms-vob': ['vob'],
    'video/x-ms-wm': ['wm'],
    'video/x-ms-wmv': ['wmv'],
    'video/x-ms-wmx': ['wmx'],
    'video/x-ms-wvx': ['wvx'],
    'video/x-msvideo': ['avi'],
    'video/x-quicktime': ['mov'],
    'video/x-sgi-movie': ['movie'],
    'video/x-smv': ['smv'],
    'x-conference/x-cooltalk': ['ice'],
    '3d/vnd.adobe.dn+dcxucf': ['dn']
};
// Renditions: list of supported conversions
// Obtained from: https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=cloudservices&title=Format+support
// The Storage Service, which we use to perform conversions, uses the "SpeedOverQuality" mode to generate thumbnails.
// The following table lists all mime-types that can be rendered to PNG using the SpeedOverQuality mode.
const SUPPORTED_PNG_MIMETYPES = new Set([
    'application/x-indesign',
    'application/postscript',
    'application/illustrator',
    'application/pdf',
    'application/vnd.adobe.psremix',
    'application/vnd.adobe.pstouch',
    'application/vnd.adobe.ideas',
    'application/vnd.adobe.ase',
    'image/jpeg',
    'image/jpg',
    'image/pjpeg',
    'image/tiff',
    'image/gif',
    'image/bmp',
    'image/x-ms-bmp',
    'image/svg+xml',
    'image/png',
    'image/x-png',
    'image/jp2',
    'image/psd',
    'image/vnd.adobe.photoshop',
    'image/heic',
    'application/photoshop',
    'application/x-photoshop',
    'image/raw',
    'image/dng',
    'image/x-adobe-dng',
    'video/mp4',
    'video/mpeg',
    'video/x-ms-wmv',
    'video/3gpp',
    'video/3gpp2',
    'video/quicktime',
    'video/x-msvideo',
    'video/x-flv',
    'video/x-ms-asf',
    'video/x-m4v',
    'video/mp2t',
    'application/mxf',
    'application/x-shockwave-flash',
    'application/vnd.adobe.brushes.brush+ucf',
    'application/vnd.adobe.collage',
    'application/vnd.adobe.proto',
    'application/msword',
    'application/msexcel',
    'application/mspowerpoint',
    'application/vnd.ms-publisher',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'text/rtf',
    'application/illustrator.template',
    'application/vnd.adobe.indesign.template',
    'application/vnd.adobe.photoshop.template',
    // This is listed in the code in places. It's not clear if we actually need it.
    'image/vnd.adobe.photoshop.template'
]);
const EXTENSION_MAP = {};
function extensionForUnresolvedContentType(contentType) {
    const matches = contentType.match(/application\/x-adobe-libraries-(.+)/);
    return matches ? [matches[1]] : [];
}
function contentTypeForUnresolvedExtension(extension) {
    return [`application/x-adobe-libraries-${extension}`];
}
/*
    Public API
*/
function getExtensions(mimeType) {
    if (mimeType) {
        return MIME_TYPE_MAP[mimeType.toLowerCase()] || extensionForUnresolvedContentType(mimeType.toLowerCase());
    }
    return [];
}
function getMimeTypes(extension) {
    if (extension) {
        return EXTENSION_MAP[extension.toLowerCase()] || contentTypeForUnresolvedExtension(extension.toLowerCase());
    }
    return [];
}
function canComputeRenditionFromMimeType(mimeType) {
    return SUPPORTED_PNG_MIMETYPES.has(mimeType);
}
Object.keys(MIME_TYPE_MAP).forEach((mimeType) => {
    const extensions = MIME_TYPE_MAP[mimeType];
    extensions.forEach((extension) => {
        EXTENSION_MAP[extension] = EXTENSION_MAP[extension] || [];
        EXTENSION_MAP[extension].push(mimeType);
    });
});

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const placeholderPrefix = '@PLACEHOLDER';
const backoffIntervals = [1, 1, 2, 3, 5, 8, 13, 21, 34, 55];
const connectorTimeout = 10000;
const melvilleFirstUseEtag = '""';
const rapiMaxSingleTransferSize = 10 * 1024 * 1024; // 10 MB
const tlsDiscoveryPortRange = [45623, 45625];
const processDiscoveryRetryDelay = 1000; // ms
const processDiscoveryTimeout = 15000; // ms
// This constant is only used to estimate upload times. Since we have switched to R-API
// for uploads, we can remove this constant and revisit the upload time estimation.
const asimovMaxChunkSize = 5242880;
const maxSockets = 6;
const toolkitNames = {
    // Photoshop:
    photoshop: 'TOOLKIT_NAME_PHOTOSHOP',
    photoshop_swatches: 'TOOLKIT_NAME_PHOTOSHOP_SWATCHES',
    photoshop_brushes: 'TOOLKIT_NAME_PHOTOSHOP_BRUSHES',
    photoshop_gradients: 'TOOLKIT_NAME_PHOTOSHOP_GRADIENTS',
    photoshop_patterns: 'TOOLKIT_NAME_PHOTOSHOP_PATTERNS',
    photoshop_styles: 'TOOLKIT_NAME_PHOTOSHOP_STYLES',
    photoshop_shapes: 'TOOLKIT_NAME_PHOTOSHOP_SHAPES',
    // Photoshop Prerelease (only for private prerelease, a few hundred users):
    photoshop_swatches_prerelease: 'TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR',
    photoshop_brushes_prerelease: 'TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR',
    photoshop_gradients_prerelease: 'TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR',
    photoshop_patterns_prerelease: 'TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR',
    photoshop_styles_prerelease: 'TOOLKIT_NAME_PHOTOSHOP_STYLES_PR',
    photoshop_shapes_prerelease: 'TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR'
};
const ElementMimeTypeMap = {
    IMAGE_ELEMENT_TYPE: 'application/vnd.adobe.element.image+dcx',
    COLOR_ELEMENT_TYPE: 'application/vnd.adobe.element.color+dcx',
    COLOR_THEME_ELEMENT_TYPE: 'application/vnd.adobe.element.colortheme+dcx',
    BRUSH_ELEMENT_TYPE: 'application/vnd.adobe.element.brush+dcx',
    CHARACTER_STYLE_ELEMENT_TYPE: 'application/vnd.adobe.element.characterstyle+dcx',
    PARAGRAPH_STYLE_ELEMENT_TYPE: 'application/vnd.adobe.element.paragraphstyle+dcx',
    FONT_ELEMENT_TYPE: 'application/vnd.adobe.element.font+dcx',
    LAYER_STYLE_ELEMENT_TYPE: 'application/vnd.adobe.element.layerstyle+dcx',
    LOOK_ELEMENT_TYPE: 'application/vnd.adobe.element.look+dcx',
    CAPSULE_ELEMENT_TYPE: 'application/vnd.adobe.element.graphic+dcx',
    VIDEO_ELEMENT_TYPE: 'application/vnd.adobe.element.video+dcx',
    THREE_D_ELEMENT_TYPE: 'application/vnd.adobe.element.3d+dcx',
    LIGHT_ELEMENT_TYPE: 'application/vnd.adobe.element.light+dcx',
    MATERIAL_ELEMENT_TYPE: 'application/vnd.adobe.element.material+dcx',
    PATTERN_ELEMENT_TYPE: 'application/vnd.adobe.element.pattern+dcx',
    TEMPLATE_ELEMENT_TYPE: 'application/vnd.adobe.element.template+dcx',
    TEXT_ELEMENT_TYPE: 'application/vnd.adobe.element.text+dcx',
    ANIMATION_ELEMENT_TYPE: 'application/vnd.adobe.element.animation+dcx',
    LIBRARY_TYPE: 'application/vnd.adobe.library+dcx',
    GRADIENT_ELEMENT_TYPE: 'application/vnd.adobe.element.gradient+dcx',
    COMPONENT_ELEMENT_TYPE: 'application/vnd.adobe.element.component+dcx',
    AUDIO_ELEMENT_TYPE: 'application/vnd.adobe.element.audio+dcx'
};
// Library Configuration constants
const LibraryConstants = {
    MAX_ELEMENTS: 10000,
    MAX_REMOVED_ELEMENTS: 2000,
    MAX_COMPONENT_SIZE: 1024 * 1024 * 1024,
    DL_NAMESPACE: 'library',
    VALID_RELATIONS: ['primary', 'rendition', 'alternate'],
    DEFAULT_GROUP_CLASSIFIER: '$default',
    ELEMENT_ACTIONS: ['edit', 'openStock', 'editInSource'],
    LIBRARY_ACTIONS: ['editInSource'],
    DOCUMENT_LIBRARY_ACTION_PRODUCT_MAP: {
        types: {
            'application/vnd.adobe.xd.cloudproject+dcx': ['SPKR']
        },
        products: {}
    },
    ELEMENT_ACTION_PRODUCT_MAP: {
        types: {
            'application/vnd.adobe.element.image+dcx': {
                'application/illustrator': ['ILST_EDIT', 'ILST_PLACE', 'IDSN_PLACE'],
                'image/svg+xml': ['ILST_EDIT', 'ILST_PLACE'],
                'application/vnd.adobe.indesign-idms': ['IDSN_EDIT', 'IDSN_PLACE'],
                'image/vnd.adobe.photoshop': ['PHXS_EDIT', 'PHXS_PLACE', 'IDSN_PLACE'],
                'application/photoshop': ['PHXS_EDIT', 'PHXS_PLACE', 'IDSN_PLACE'],
                'application/photoshop.large': ['PHXS_EDIT', 'PHXS_PLACE', 'IDSN_PLACE'],
                'image/png': ['PHXS_EDIT', 'PHXS_PLACE', 'ILST_PLACE', 'IDSN_PLACE', 'PPRO_PLACE', 'AEFT_PLACE'],
                'image/jpeg': ['PHXS_EDIT', 'PHXS_PLACE', 'ILST_PLACE', 'IDSN_PLACE', 'PPRO_PLACE', 'AEFT_PLACE'],
                'image/jpg': ['PHXS_EDIT', 'PHXS_PLACE', 'IDSN_PLACE', 'ILST_PLACE', 'PPRO_PLACE', 'AEFT_PLACE'],
                'image/gif': ['PHXS_EDIT', 'PHXS_PLACE', 'ILST_PLACE', 'IDSN_PLACE', 'PPRO_PLACE', 'AEFT_PLACE'],
                'image/bmp': ['PHXS_EDIT', 'PHXS_PLACE', 'ILST_PLACE', 'IDSN_PLACE', 'PPRO_PLACE', 'AEFT_PLACE'],
                'image/x-portable-bitmap': ['PHXS_EDIT', 'PHXS_PLACE'],
                'image/x-pict': ['PHXS_EDIT', 'PHXS_PLACE'],
                'image/x-pcx': ['PHXS_EDIT', 'PHXS_PLACE'],
                'image/x-portable-graymap': ['PHXS_EDIT', 'PHXS_PLACE'],
                'image/x-portable-anymap': ['PHXS_EDIT', 'PHXS_PLACE'],
                'image/x-portable-pixmap': ['PHXS_EDIT', 'PHXS_PLACE'],
                'image/x-tga': ['PHXS_EDIT', 'PHXS_PLACE'],
                'image/tiff': ['PHXS_EDIT', 'PHXS_PLACE'],
                'image/vnd.wap.wbmp': ['PHXS_EDIT', 'PHXS_PLACE']
            },
            'application/vnd.adobe.element.text+dcx': {
                'application/illustrator-text': ['ILST_EDIT_TEXT'],
                'application/vnd.adobe.indesign-idms-text': ['IDSN_EDIT_TEXT']
            },
            'application/vnd.adobe.element.template+dcx': {
                'image/vnd.adobe.photoshop.template': ['PHXS_PLACE'],
                'application/illustrator.template': ['ILST_PLACE'],
                'application/vnd.adobe.indesign.template': ['IDSN_PLACE']
            },
            'application/vnd.adobe.element.3d+dcx': {
                'application/vnd.adobe.obj.3d+zip': ['ESHR_PLACE']
            },
            'application/vnd.adobe.element.material+dcx': {
                'application/vnd.adobe.mdl.material+zip': ['ESHR_PLACE']
            },
            'application/vnd.adobe.element.light+dcx': {
                'application/vnd.adobe.ibl.light+zip': ['ESHR_PLACE']
            },
            'application/vnd.adobe.element.animation+dcx': {
                'application/vnd.adobe.animate-xfl+zip': ['FLPR_EDIT'],
                'application/vnd.adobe.animate-sym+zip': ['FLPR_EDIT']
            }
        },
        products: {}
    },
    VECTOR_RENDITION_ELEMENT_TYPES: ['application/illustrator'],
    ANALYTICS_ENABLED: false
};
const vulcanLibrariesTargetSpecifier = 'cclibraries';
const vulcanLibrariesSAPCode = 'LIBS';
const vulcanQueryRequestPayload = JSON.stringify({ apiVersion: 12 });
const MelvilleParamsAsHeaders = ['start', 'limit', 'selector', 'type', 'orderBy', 'group', 'owner'];
const HttpStatus = {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,
    MULTIPLE_CHOICES: 300,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    PRECONDITION_FAILED: 412,
    UNSUPPOERTED_MEDIA_TYPE: 415,
    IM_A_TEAPOT: 418,
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503
};
const ABORT_ERROR = 'AbortError';
const REQUEST_NOT_NEEDED = 'REQUEST NOT NEEDED';
const syncGroupPath = '/assets/adobe-libraries';
const GenStudioProjectName = 'Adobe GenStudio Brands';

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const placeholderRegexString = `${placeholderPrefix}-[a-f0-9]{8}-(?:[a-f0-9]{4}-){3}[a-f0-9]{12}`;
const placeholderRegex = new RegExp(`^${placeholderRegexString}$`);
const containsPlaceholderRegex = new RegExp(`(${placeholderRegexString})`);
const getBaseLibraryData = () => ({
    ownership: 'private',
    groups: [],
    elements: [],
    documentationElements: [],
    deletable: true,
    removedElements: [],
    areElementsLoaded: true,
    isLibraryLoaded: true,
    isWritable: true,
    isParentWritable: true,
    details: {
        elementCount: 0,
        documentationElementCount: 0,
        removedElementCount: 0
    },
    removeType: 'delete'
});
const createPlaceholderId = () => `${placeholderPrefix}-${uuid_1.v4()}`;
// @TODO - string.indexOf is much faster of a placeholder verification if we are willing to give up the safety of a complete id match.
// Cannot do this just now as modifying has the side effect of not completing actions...
/**
 * Check if a given id is a placeholder id
 * @param {string} id id to check
 * @returns {boolean} true if given id is a placeholder id
 */
function isPlaceholder(id) {
    return placeholderRegex.test(id);
}
const extractPlaceholder = (path) => {
    const [placeholder] = containsPlaceholderRegex.exec(path) || [];
    return placeholder;
};
/**
 * Utility to create required data to create a library
 *
 * @param {Partial<LibraryData> & { id: string; name: string }} data Custom data to override base library data
 * @returns {LibraryData} Full data description for creating a library
 */
const createLibraryData = (data) => Object.assign(getBaseLibraryData(), data);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Check if a reference is in the new link schema format (aka valid JSON string or object).
 * Returns the parsed object if it is, and undefined if not.
 * @param reference A string reference that may be serialized JSON
 */
function parseNewLinkSchema(reference) {
    try {
        // If reference is already an object, return the object.
        if (reference && typeof reference === 'object' && !Array.isArray(reference)) {
            return reference;
        }
        const obj = JSON.parse(reference);
        // Handle non-exception-throwing cases by checking if object: e.g. 'false', '123', false, 123, null
        // Note: typeof null === "object" but luckily null is falsey
        if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
            return obj;
        }
    }
    catch (e) {
        return;
    }
}
/**
 * Check if a reference is in the new link schema format (aka valid JSON string or object).
 * Returns the serialized object if it is. Otherwise, parses the legacy reference into a partial new link schema
 * and returns the string that results from serializing that partial reference.
 * @param reference A serialized link reference object or a legacy link reference string.
 */
function serializeLinkReference(reference) {
    // Ensure we're working with an object.
    const linkRef = parseLinkReference(reference);
    if (!linkRef) {
        return '';
    }
    return JSON.stringify(linkRef, Object.keys(linkRef).sort());
}
const ELEMENT_REF_REGEXP = new RegExp('([^/]+);node=(.*)');
/**
 * Parse any element reference into an object, including legacy string-based references (though they will parse into partial references).
 * @param reference A link reference object or string.
 */
function parseLinkReference(reference) {
    return parseNewLinkSchema(reference) || parseLegacyLinkSchema(reference);
}
function parseLegacyLinkSchema(reference) {
    const matches = reference.match(ELEMENT_REF_REGEXP);
    if (!matches) {
        return;
    }
    const [, libraryId, elementId] = matches;
    return {
        'dc:format': 'application/vnd.adobe.library+dcx',
        'stRef:documentID': libraryId,
        'stRef:fromPart': `id=${elementId}`
    };
}
function getAssetAndFragmentIdFromReference(reference) {
    var _a;
    const linkRef = parseLinkReference(reference);
    if (!linkRef) {
        return;
    }
    // The library's assetId should always be available, except for legacy references.
    const libraryAssetId = linkRef['repo:assetId'];
    const libraryId = linkRef['stRef:documentID'];
    const elementId = (_a = linkRef['stRef:fromPart']) === null || _a === void 0 ? void 0 : _a.substring(3); // remove 'id='
    return { libraryAssetId, libraryId, elementId };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2014 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function getFileExtension(fileNameOrPath) {
    const fileName = fileNameOrPath && fileNameOrPath.replace(/^.*[\\/]/, '');
    const dotIndex = fileName ? fileName.lastIndexOf('.') : -1;
    if (dotIndex !== -1) {
        return fileName.substr(dotIndex + 1).toLowerCase();
    }
}
function getPrimaryMimetypeForFile(filename) {
    const extension = getFileExtension(filename);
    const [mimetype] = getMimeTypes(extension) || [];
    return mimetype || 'application/octet-stream';
}
/**
 * Split a given filelike list into 2 based on filesize being over the threshhold for Asimov api
 *
 * @param {Filelike[]} files list of files to separate
 * @returns {{standard: Filelike[], asimov: Filelike[]}} list split into standard upload api and asimov upload
 */
function _splitFileUploadsByApi(files) {
    return files.reduce((acc, val) => {
        val.size > asimovMaxChunkSize ? acc.asimov.push(val) : acc.standard.push(val);
        return acc;
    }, { standard: [], asimov: [] });
}
/**
 * Break files given into sizable chunks mimicing asimov uploads
 *
 * @param {Filelike[]} files list of files to upload via asimov (all files in this list should be greater than 5242880 bytes in size)
 * @returns {Filelike[]} list of chunks that would be used to upload to asimov
 */
function _chunkAsimovUploads(files) {
    return files
        .map(file => {
        const { size } = file;
        const fullChunks = Math.floor(size / asimovMaxChunkSize);
        const remainingChunk = size % asimovMaxChunkSize;
        const newChunks = fullChunks + (remainingChunk ? 1 : 0);
        return Array.from({ length: newChunks }, (_, idx) => ({
            size: idx === newChunks - 1 ? remainingChunk : asimovMaxChunkSize
        }));
    })
        .flat();
}
/**
 * Utility function to estimate how long it will take to upload a set of files
 *
 * @param {Filelike[]} files files to upload
 * @returns {number} estimated time to upload list of files given
 */
function _estimateTimeToUploadSortedArray(files) {
    // Sort in decending order by size
    files.sort((a, b) => b.size - a.size);
    // Number of batches we require to upload all files in the given array
    const numBatches = Math.ceil(files.length / maxSockets);
    // Assume worst case scenario that the largest files are shared equally across batches
    const largestFilesPerBatch = files.splice(0, numBatches);
    // According to automation data collection it currently takes approximately
    // 1 sec per 1Mb to upload. Use this as a marker
    return largestFilesPerBatch.reduce((acc, file) => (acc += Math.round((file.size / 1024) * 2.5)), 0);
}
/**
 * Some environments require showing a warning to the user if an upload
 * is estimated to take longer than a certain amount of time. Utility
 * estimates the time to upload assets so the UI can make a rough estimate
 * whether to display a message.
 *
 * Utility generates an estimated upload time for standard and asimov api uploaded
 * files and returns the highest estimate of the 2.
 *
 * @example
 * ```ts
 * import { utils } from '@cclibraries/cc-libraries-js';
 *
 * const estimate = utils.estimateUploadTime([{size: 1234567678}]);
 * ```
 * @param {Filelike[]} fileList list of files you want an estimated upload time for
 * @returns {number} estimated time to upload in milliseconds
 */
function estimateUploadTime(fileList) {
    // Split the list into 2 arrays. 1 for standard upload, the other for asimov uploads
    const { standard, asimov } = _splitFileUploadsByApi(fileList);
    // Calculate time to upload files and return the largest of the 2 results
    return Math.max(_estimateTimeToUploadSortedArray(standard), _estimateTimeToUploadSortedArray(_chunkAsimovUploads(asimov)));
}
function getImageDimensionsWeb(file) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = event => {
            var _a;
            const img = new Image();
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.onerror = () => {
                resolve(undefined);
            };
            img.src = (_a = event.target) === null || _a === void 0 ? void 0 : _a.result;
        };
        reader.readAsDataURL(file);
    });
}
/**
 * Asynchronously get the dimensions of an image file
 * @param {File} file
 * @param {string} type
 * @returns {Promise<undefined | Object>} the dimensions object, if it's possible to compute.
 */
async function getImageDimensions(file, type) {
    if (!canComputeRenditionFromMimeType(type)) {
        // If the file type cannot be interpreted as an image,
        // we can't compute its "width" and "height".
        return;
    }
    try {
        if (typeof window !== 'undefined' && window.FileReader && window.Image) {
            // For Web browser environment
            return getImageDimensionsWeb(file);
        }
        else {
            // TODO: This should also work in a Node.js environment.
            // See: https://git.corp.adobe.com/ProjectCentral/cc-libs-firefly-script#areas-to-fix
            return;
        }
    }
    catch (e) {
        return;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function isErrorLike(errorLikeObj) {
    const errLikeCast = errorLikeObj;
    return !!errLikeCast.code && !!errLikeCast.message;
}
function ConvertErrorCode$1(libraryErrorCode) {
    switch (libraryErrorCode) {
        case 'EXCEEDS_QUOTA':
            return SAMErrorCode.FULL_CLOUD_STORAGE;
        case 'LOGGED_OUT':
        case 'NOT_ALLOWED':
            return SAMErrorCode.AUTHORIZATION_ERROR;
        case 'NETWORK_ERROR':
            return SAMErrorCode.NETWORK_ERROR;
        case 'NOT_SUPPORTED':
        case 'NOT_IMPLEMENTED':
            return SAMErrorCode.UNSUPPORTED;
        case 'INVALID_DATA':
        case 'INVALID_PARAMETER':
        case 'CONNECTION_FAILED':
        case 'REQUEST_FAILED':
        case 'INVALID_RESPONSE':
        case 'INVALID_JSON':
        default:
            return SAMErrorCode.UNKNOWN;
    }
}
class LibraryError extends SAMError {
    constructor(codeOrErrorLikeObject, message, libraryId, underlyingError) {
        var _a;
        if (isErrorLike(codeOrErrorLikeObject)) {
            message = codeOrErrorLikeObject.message;
            libraryId = codeOrErrorLikeObject.libraryId;
            underlyingError = (_a = codeOrErrorLikeObject._additionalInfo) === null || _a === void 0 ? void 0 : _a.underlyingError;
            codeOrErrorLikeObject = codeOrErrorLikeObject.code;
        }
        super(ConvertErrorCode$1(codeOrErrorLikeObject), message || '', { underlyingError });
        this.libraryErrorCode = codeOrErrorLikeObject;
        this.libraryId = libraryId;
    }
    get underlyingError() {
        var _a;
        return (_a = this._additionalInfo) === null || _a === void 0 ? void 0 : _a.underlyingError;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Restrict the ability for clients of JSAPI to remove all listeners on an Event Emitter.
 * Adding the getter for DANGEROUS set of methods ensures the developer understands that
 * their actions could have unforeseen consequences.
 *
 * @export
 * @class RestrictedEventEmitter
 */
class RestrictedEventEmitter {
    constructor() {
        this._emitter = new EventEmitter();
    }
    get DANGEROUS() {
        return {
            removeAllListeners: (event) => {
                // This one is weird. Native EventEmitter has a conditional in the implementation
                // that checks for the length of arguments... an undefined value still counts as a
                // argument so it bypasses removal of all event listeners...
                event ? this._emitter.removeAllListeners(event) : this._emitter.removeAllListeners();
                return this;
            }
        };
    }
    /**
     * add a listener for a specified event
     *
     * @param {(string | symbol)} eventName name of the event to listen to
     * @param {(...args: any[]) => void} listener callback that is triggered when an event is emitted
     * @returns {this}
     * @memberof RestrictedEventEmitter
     */
    addListener(eventName, listener) {
        this._emitter.addListener(eventName, listener);
        return this;
    }
    /**
     * alias for addListener
     *
     * @param {(string | symbol)} eventName name of the event to listen to
     * @param {(...args: any[]) => void} listener callback that is triggered when an event is emitted
     * @returns {this}
     * @memberof RestrictedEventEmitter
     */
    on(eventName, listener) {
        return this.addListener(eventName, listener);
    }
    /**
     * add an event listener for a specified event. When that event fires and the given callback
     * is triggered, the listener will be removed.
     *
     * @param {(string | symbol)} eventName name of the event to listen to
     * @param {(...args: any[]) => void} listener callback that is triggered when an event is emitted
     * @returns {this}
     * @memberof RestrictedEventEmitter
     */
    once(eventName, listener) {
        this._emitter.once(eventName, listener);
        return this;
    }
    /**
     * Remove the listener for the given event name
     *
     * @param {(string | symbol)} eventName name of the event to listen to
     * @param {(...args: any[]) => void} listener callback that is to be removed
     * @returns {this}
     * @memberof RestrictedEventEmitter
     */
    removeListener(eventName, listener) {
        this._emitter.removeListener(eventName, listener);
        return this;
    }
    /**
     * Alias for removeListener
     *
     * @param {(string | symbol)} eventName name of the event to listen to
     * @param {(...args: any[]) => void} listener callback that is to be removed
     * @returns {this}
     * @memberof RestrictedEventEmitter
     */
    off(eventName, listener) {
        return this.removeListener(eventName, listener);
    }
    /**
     * By default EventEmitters will print a warning if more than 10 listeners are added for a particular event.
     * This is a useful default that helps finding memory leaks. The emitter.setMaxListeners() method allows the
     * limit to be modified for this specific EventEmitter instance. The value can be set toInfinity (or 0) to
     * indicate an unlimited number of listeners.
     *
     * Returns a reference to the EventEmitter, so that calls can be chained.
     *
     * @param {number} n Set the maximum amount of listeners that can be added to this instance of EventEmitter
     * @returns {this}
     * @memberof RestrictedEventEmitter
     */
    setMaxListeners(n) {
        this._emitter.setMaxListeners(n);
        return this;
    }
    /**
     * Returns the maximum number of listeners allowed
     *
     * @returns {number} The number of listeners allowed on on this instance of EventEmitter
     * @memberof RestrictedEventEmitter
     */
    getMaxListeners() {
        return this._emitter.getMaxListeners();
    }
    /**
     * Return an array of function references for a given event name
     *
     * @param {(string | symbol)} eventName name of the event we want to match when returning function array.
     * @returns {Function[]} array of function references that are triggered when an event is emitted
     * @memberof RestrictedEventEmitter
     */
    listeners(eventName) {
        return this._emitter.listeners(eventName);
    }
    /**
     * Returns a copy of the array of listeners for the event named eventName, including any wrappers (such as those created by .once()).
     *
     * @example
     * ```ts
     * const emitter = new EventEmitter();
     * emitter.once('log', () => console.log('log once'));
     *
     * // Returns a new Array with a function `onceWrapper` which has a property
     * // `listener` which contains the original listener bound above
     * const listeners = emitter.rawListeners('log');
     * const logFnWrapper = listeners[0];
     *
     * // Logs "log once" to the console and does not unbind the `once` event
     * logFnWrapper.listener();
     *
     * // Logs "log once" to the console and removes the listener
     * logFnWrapper();
     *
     * emitter.on('log', () => console.log('log persistently'));
     * // Will return a new Array with a single function bound by `.on()` above
     * const newListeners = emitter.rawListeners('log');
     *
     * // Logs "log persistently" twice
     * newListeners[0]();
     * emitter.emit('log');
     * ```
     *
     * @param {(string | symbol)} eventName
     * @returns {Function[]}
     * @memberof RestrictedEventEmitter
     */
    rawListeners(eventName) {
        return this._emitter.rawListeners(eventName);
    }
    /**
     * Synchronously calls each of the listeners registered for the event namedeventName, in the order they were registered, passing the supplied arguments to each.
     * Returns true if the event had listeners, false otherwise.
     *
     * @example
     * ```ts
     * const EventEmitter = require('events');
     * const myEmitter = new EventEmitter();
     *
     *
     * // First listener
     * myEmitter.on('event', function firstListener() {
     *   console.log('Helloooo! first listener');
     * });
     * // Second listener
     * myEmitter.on('event', function secondListener(arg1, arg2) {
     *   console.log(`event with parameters ${arg1}, ${arg2} in second listener`);
     * });
     * // Third listener
     * myEmitter.on('event', function thirdListener(...args) {
     *   const parameters = args.join(', ');
     *   console.log(`event with parameters ${parameters} in third listener`);
     * });
     *
     * console.log(myEmitter.listeners('event'));
     *
     * myEmitter.emit('event', 1, 2, 3, 4, 5);
     *
     * // Prints:
     * // [
     * //   [Function: firstListener],
     * //   [Function: secondListener],
     * //   [Function: thirdListener]
     * // ]
     * // Helloooo! first listener
     * // event with parameters 1, 2 in second listener
     * // event with parameters 1, 2, 3, 4, 5 in third listener
     * ```
     *
     * @param {(string | symbol)} eventName name of the event to trigger
     * @param {...any[]} args arguments to pass to the listener
     * @returns {boolean} Returns true if the event had listeners. False otherwise
     * @memberof RestrictedEventEmitter
     */
    emit(eventName, ...args) {
        return this._emitter.emit(eventName, ...args);
    }
    /**
     * Number of listeners for a given event name
     *
     * @param {(string | symbol)} eventName
     * @returns {number}
     * @memberof RestrictedEventEmitter
     */
    listenerCount(eventName) {
        return this._emitter.listenerCount(eventName);
    }
    /**
     * Adds the listener function to the beginning of the listeners array for the event named eventName. No checks are made to see if the listener has already been added. Multiple calls passing the same combination of eventNameand listener will result in the listener being added, and called, multiple times.
     *
     * @example
     * ```ts
     * server.prependListener('connection', (stream) => {
     *   console.log('someone connected!');
     * });
     * ```
     *
     * Returns a reference to the EventEmitter, so that calls can be chained.
     *
     * @param {(string | symbol)} eventName Name of the event to create a listener for
     * @param {(...args: any[]) => void} listener Function to call when given event name is triggered
     * @returns {this}
     * @memberof RestrictedEventEmitter
     */
    prependListener(eventName, listener) {
        this._emitter.prependListener(eventName, listener);
        return this;
    }
    /**
     * Adds a one-timelistener function for the event named eventName to the_beginning_ of the listeners array. The next time eventName is triggered, this listener is removed, and then invoked.
     *
     * @example
     * ```ts
     * server.prependOnceListener('connection', (stream) => {
     *   console.log('Ah, we have our first user!');
     * });
     * ```
     *
     * Returns a reference to the EventEmitter, so that calls can be chained.
     *
     * @param {(string | symbol)} eventName Name of the event to listen for
     * @param {(...args: any[]) => void} listener callback to fire when named event is triggered
     * @returns {this}
     * @memberof RestrictedEventEmitter
     */
    prependOnceListener(eventName, listener) {
        this._emitter.prependOnceListener(eventName, listener);
        return this;
    }
    /**
     * Returns an array listing the events for which the emitter has registered listeners. The values in the array are strings or Symbols.
     *
     * @example
     * ```ts
     * const EventEmitter = require('events');
     * const myEE = new EventEmitter();
     * myEE.on('foo', () => {});
     * myEE.on('bar', () => {});
     *
     * const sym = Symbol('symbol');
     * myEE.on(sym, () => {});
     *
     * console.log(myEE.eventNames());
     * // Prints: [ 'foo', 'bar', Symbol(symbol) ]
     * ```
     *
     * @returns {((string | symbol)[])} Array of event names that are being listened for
     * @memberof RestrictedEventEmitter
     */
    eventNames() {
        return this._emitter.eventNames();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class Logger {
    static get instance() {
        if (!Logger._loggerInstance) {
            Logger._loggerInstance = new Logger();
        }
        return Logger._loggerInstance;
    }
    setEventEmitter(eventEmitter) {
        this._eventEmitter = eventEmitter;
    }
    _loggerEvent(message, level) {
        var _a;
        (_a = this._eventEmitter) === null || _a === void 0 ? void 0 : _a.emit('messageLogged', new MessageLoggedEvent(`[SAMJS LibraryContents] ${message}`, level));
    }
    log(message) {
        this._loggerEvent(message, LogLevel.Info);
    }
    warn(message) {
        this._loggerEvent(message, LogLevel.Warn);
    }
    error(message) {
        this._loggerEvent(message, LogLevel.Err);
    }
    info(message) {
        this._loggerEvent(message, LogLevel.Info);
    }
    debug(message) {
        this._loggerEvent(message, LogLevel.Debug);
    }
}
var Logger$1 = Logger.instance;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class Configuration {
    constructor(data) {
        this.data = data;
    }
    get config() {
        return this.data.config;
    }
    get user() {
        return this.data.user;
    }
    get ignoreRenditionGrids() {
        return this.data.ignoreRenditionGrids;
    }
    get installedApps() {
        return this.data.installedApps || [];
    }
    get processInfo() {
        return this.data.processInfo;
    }
    get environment() {
        return this.data.environment;
    }
    get renditionSize() {
        return this.data.config.RENDITION_SIZES;
    }
    get fullRenditionConfig() {
        return this.data.config.FULL_RENDITION_CONFIG;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class BaseError extends Error {
    constructor(message) {
        super(message);
        // JS Errors break the prototype chain.
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function sleep(time, signal) {
    return new Promise((resolve, reject) => {
        const doReject = () => {
            clearTimeout(timeout);
            signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', doReject);
            reject(new DOMException('Request aborted', 'AbortError'));
        };
        const timeout = setTimeout(() => {
            signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', doReject);
            resolve();
        }, time);
        if (signal) {
            signal.addEventListener('abort', doReject);
            // Signal might already have been aborted
            if (signal.aborted) {
                doReject();
            }
        }
    });
}
function isUpperSnakeCase(value) {
    return /^[A-Z_]*$/.test(value);
}
function toLowerCamel(value) {
    if (!isUpperSnakeCase(value)) {
        throw new BaseError('String must be upper snake case to convert');
    }
    return value.toLowerCase().replace(/_([a-z])/g, (match, backReference) => {
        return backReference.toUpperCase();
    });
}
function getScopedStorageKey(user, mode) {
    return `CCLibraries_${user === null || user === void 0 ? void 0 : user.id}_${mode}`;
}
var SignalType;
(function (SignalType) {
    SignalType[SignalType["RESOLVE"] = 0] = "RESOLVE";
    SignalType[SignalType["REJECT"] = 1] = "REJECT";
})(SignalType || (SignalType = {}));
function timoutFutureFactory(signal, timeout) {
    let timeoutId;
    const future = new Promise((...args) => {
        timeoutId = setTimeout(args[signal], timeout);
    });
    return { future, cancel: () => clearTimeout(timeoutId) };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const combineSignals = (...signals) => {
    const controller = new AbortController();
    const onAbort = () => {
        controller.abort();
        signals.forEach(signal => signal.removeEventListener('abort', onAbort));
    };
    if (signals.some(signal => signal.aborted)) {
        onAbort();
    }
    else {
        signals.forEach(signal => signal.addEventListener('abort', onAbort));
    }
    return controller.signal;
};
class AbortSignalReasons {
    constructor() {
        this.signalToReasonMap = new WeakMap();
    }
    getSignal(aborter) {
        var _a;
        return (_a = aborter.signal) !== null && _a !== void 0 ? _a : aborter;
    }
    reason(aborter) {
        return this.signalToReasonMap.get(this.getSignal(aborter));
    }
    give(aborter, reason) {
        this.signalToReasonMap.set(this.getSignal(aborter), reason);
    }
}
const abortSignalReasons = new AbortSignalReasons();

/**
 * Utility that short term caches promises based on the provided arguments to produce
 * the promise from a factory function.
 *
 * @export
 * @param {(...args: Array<any>) => Promise<any>} _asyncFn Promise delivering function that we wish to cache using parameters as key
 * @returns {Promise<any>} Cached or fresh promise based on provided arguments
 */
function promiseCache(_asyncFn) {
    const _cache = new Map();
    return (...args) => {
        const serializedArgs = JSON.stringify(args);
        const cachedPromise = _cache.get(serializedArgs);
        if (cachedPromise) {
            return cachedPromise;
        }
        const newPromise = _asyncFn.apply(undefined, args);
        _cache.set(serializedArgs, newPromise);
        setTimeout(() => newPromise.finally(() => _cache.delete(serializedArgs)));
        return newPromise;
    };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var ConnectionState;
(function (ConnectionState) {
    ConnectionState["CONNECTED"] = "connected";
    ConnectionState["CONNECTING"] = "connecting";
    ConnectionState["LOADING"] = "loading";
    ConnectionState["ERROR"] = "error";
})(ConnectionState || (ConnectionState = {}));
async function collectAll(iterator) {
    var _a, e_1, _b, _c;
    const all = [];
    try {
        for (var _d = true, iterator_1 = __asyncValues(iterator), iterator_1_1; iterator_1_1 = await iterator_1.next(), _a = iterator_1_1.done, !_a;) {
            _c = iterator_1_1.value;
            _d = false;
            try {
                const page = _c;
                all.push(...page);
            }
            finally {
                _d = true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (!_d && !_a && (_b = iterator_1.return)) await _b.call(iterator_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return all;
}
/**
 * Interface for an API driver for use in the CC Libraries orchestration API.
 */
class Driver extends RestrictedEventEmitter {
    constructor(core, _connector) {
        super();
        this._connector = _connector;
        this._isConnected = false;
        this._failedConnectionAttempt = false;
        this._options = {};
        this._config = new Configuration({ config: {}, environment: 'production' });
        this._cachedFetch = promiseCache(fetch);
        this._loadElementsAbortController = new AbortController();
        this._core = core;
    }
    get config() {
        return this._config;
    }
    get environment() {
        return this._config.environment;
    }
    get token() {
        return this._token;
    }
    get isConnected() {
        return this._isConnected;
    }
    get connectionState() {
        if (this._failedConnectionAttempt) {
            return ConnectionState.ERROR;
        }
        if (this.isConnected) {
            return ConnectionState.CONNECTED;
        }
        if (this._connectionPromise) {
            return ConnectionState.CONNECTING;
        }
        return ConnectionState.LOADING;
    }
    resetAbortController() {
        this._abortController = new AbortController();
    }
    /**
     * @internal
     */
    get abortController() {
        return this._abortController;
    }
    init(options = {}, onConnect = () => undefined, onDisconnect = () => undefined) {
        this._options = Object.assign(Object.assign({}, this._options), options);
        this.on('connect', onConnect);
        this.on('disconnect', onDisconnect);
        if (this._options.skipConnectingOnInit) {
            return Promise.resolve();
        }
        return this.connect();
    }
    get _isConnectingOrConnected() {
        return Boolean(this._abortController && !this._abortController.signal.aborted);
    }
    connect() {
        if (this._isConnectingOrConnected) {
            return this._connectionPromise;
        }
        this.resetAbortController();
        this._connectionPromise = this._connect();
        this.emit('connecting');
        return this._connectionPromise;
    }
    //TODO: restructure this to use promises correctly after unit tests are in place
    //https://jira.corp.adobe.com/browse/SHARED-4386
    async _attemptToConnect(abortSignal) {
        const fn = async (resolve) => {
            try {
                // forcibly reject a timeout. This way we ensure we always catch and resolve a negative value.
                const { future, cancel } = timoutFutureFactory(SignalType.REJECT, connectorTimeout);
                // race between the connector getting the information we require and the rejecting timeout above.
                const abortController = new AbortController();
                const connectionInfo = (await Promise.race([this._connector(abortController.signal), future]).finally(() => {
                    abortController.abort();
                    cancel();
                }));
                // have we aborted in the time we have asked for connection information?
                if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
                    return resolve(false);
                }
                // subclass connection handlers (can also throw)
                await this._handleConnected(connectionInfo);
                // if we got here we can claim to be connected and resolve truthy
                this._isConnected = true;
                return resolve(true);
            }
            catch (e) {
                return resolve(false);
            }
        };
        return new Promise(resolve => fn(resolve)).then(state => {
            this._failedConnectionAttempt = !state;
            if (this._failedConnectionAttempt) {
                this.emit('failedConnection');
            }
            return state;
        });
    }
    async _connect() {
        var _a;
        const currentAbortSignal = (_a = this._abortController) === null || _a === void 0 ? void 0 : _a.signal;
        for (let i = 0; !(await this._attemptToConnect(currentAbortSignal)); i += 1) {
            if (this._options.retryCount !== undefined && this._options.retryCount <= i) {
                Logger$1.log(`[DRIVER] Failed to connect to server (Attempt: ${i}). Exceeded max retries.`);
                return;
            }
            const interval = backoffIntervals[Math.min(i, backoffIntervals.length - 1)] * 1000;
            Logger$1.log(`[DRIVER] Failed to connect to server (Attempt: ${i}). Will retry in ${interval}ms.`);
            try {
                await sleep(interval, currentAbortSignal);
            }
            catch (error) {
                if (error instanceof Error && error.name === 'AbortError') {
                    return;
                }
                throw error;
            }
        }
        this.emit('connect', this);
    }
    disconnect() {
        var _a, _b;
        (_a = this._abortController) === null || _a === void 0 ? void 0 : _a.abort();
        this._isConnected = false;
        this._failedConnectionAttempt = false;
        (_b = this._handleDisconnected) === null || _b === void 0 ? void 0 : _b.call(this);
        this.emit('disconnect', this);
    }
    async reconnect() {
        Logger$1.warn('Process restart. Attempting to reconnect');
        this.disconnect();
        await this.connect();
    }
    sleep(time, signal) {
        var _a, _b;
        return sleep(time, signal && ((_a = this._abortController) === null || _a === void 0 ? void 0 : _a.signal)
            ? combineSignals(signal, this._abortController.signal)
            : (_b = this._abortController) === null || _b === void 0 ? void 0 : _b.signal);
    }
    getAllLibraries(signal, getRenditionGrids) {
        return collectAll(this.getLibraries(signal, getRenditionGrids));
    }
    getAllElements(library, sort, etag) {
        return collectAll(this.getElements(library, sort, etag));
    }
    getAllDocumentationElements(library, sort, etag) {
        return collectAll(this.getDocumentationElements(library, sort, etag));
    }
    getAllRemovedElements(library, sort, etag) {
        return collectAll(this.getRemovedElements(library, sort, etag));
    }
    getAllGroups(libraryId) {
        return collectAll(this.getGroups(libraryId));
    }
    publishBrand(_brand) {
        throw new LibraryError('NOT_IMPLEMENTED', 'Driver.publishBrand is not implemented.');
    }
    unpublishBrand(_brand) {
        throw new LibraryError('NOT_IMPLEMENTED', 'Driver.unpublishBrand is not implemented.');
    }
    setRenditionCacheChangeListener(_cb) {
        return;
    }
    // Add a library to the list of assets being watched for changes.
    addWatchedLibrary(_library) {
        return;
    }
    // Remove a library from the list of assets being watched for changes.
    removeWatchedLibrary(_library) {
        return;
    }
    addLibrariesSyncGroupListener(_cb) {
        return;
    }
    removeLibrariesSyncGroupListener() {
        return;
    }
    operationFactory(Op, driver, library) {
        return new Op(driver, library);
    }
    getOperationTypes(_library) {
        return this._operationTypes;
    }
    /**
     * From an array of actions, form an atomic operation
     * @param actions
     */
    constructOperation(library) {
        var _a;
        if (library.actions.length === 0) {
            return undefined;
        }
        // If the driver is set as readOnly, don't allow any operations to be registered
        if (this._options.readOnly) {
            throw new LibraryError('NOT_ALLOWED', 'Cannot perform write action -- in read-only mode.');
        }
        const Op = (_a = this.getOperationTypes(library)) === null || _a === void 0 ? void 0 : _a.find(klass => klass.supportsAction(library.actions[0]));
        if (!Op) {
            // If the action cannot be mapped to an operation, we have a problem.
            // TODO: Error
            throw new Error();
        }
        const operation = this.operationFactory(Op, this, library);
        for (const action of library.actions) {
            if (!operation.addAction(action)) {
                break;
            }
        }
        return operation;
    }
    getLocalSettings() {
        var _a;
        const settings = (_a = this._localStorage) !== null && _a !== void 0 ? _a : new Map();
        return { config: Object.fromEntries(settings.entries()) };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AsyncOperation extends RestrictedEventEmitter {
    constructor() {
        super(...arguments);
        this._abortController = new AbortController();
        this._isComplete = false;
        this._progress = 0;
    }
    abort() {
        this.DANGEROUS.removeAllListeners();
        this._abortController.abort();
    }
    get isComplete() {
        return this.progress === 100;
    }
    get progress() {
        return this._progress;
    }
    set progress(progress) {
        this._progress = Math.min(progress, 100);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function ConvertErrorCode(requestErrorCode) {
    switch (requestErrorCode) {
        case 'UNAUTHORIZED':
        case 'INVALID_CREDENTIALS':
            return SAMErrorCode$1.AUTHORIZATION_ERROR;
        case 'REQUEST_TIMEOUT':
            return SAMErrorCode$1.REQUEST_TIMED_OUT;
        case 'OUT_OF_SPACE':
            return SAMErrorCode$1.FULL_LOCAL_DISK_SPACE;
        case 'NOT_FOUND':
        case 'ENOENT':
            return SAMErrorCode$1.NOT_FOUND;
        case 'PRECONDITION_FAILED':
        case 'GENERIC_ERROR':
        case 'UNEXPECTED_RESPONSE':
        case 'MALFORMED_RESPONSE':
        case 'NOT_MODIFIED':
        case 'FS_ERROR':
        case 'INVALID_DATA':
        default:
            return SAMErrorCode$1.UNKNOWN;
    }
}
class RequestError extends SAMError {
    static isRequestError(error) {
        return !!error.code;
    }
    constructor(code, message, response, underlyingError) {
        super(ConvertErrorCode(code), message, { underlyingError });
        this._requestErrorCode = code;
        this._response = response;
    }
    get requestErrorCode() {
        return this._requestErrorCode;
    }
    get response() {
        return this._response;
    }
    get underlyingError() {
        return this._additionalInfo.underlyingError;
    }
    set underlyingError(error) {
        this._additionalInfo.underlyingError = error;
    }
    setResponse(response) {
        if (!this.response) {
            this._response = response;
        }
        else {
            Logger$1.warn('Request Error response reference is already set.');
        }
        return this;
    }
}
function getRequestError(response, errorCode) {
    return getRequestErrorFromStatus(response === null || response === void 0 ? void 0 : response.status, errorCode).setResponse(response);
}
function getRequestErrorFromStatus(statusCode, errorCode) {
    switch (statusCode) {
        case 304:
            return new RequestError('NOT_MODIFIED', 'Response has not changed.');
        case 401:
            return new RequestError('UNAUTHORIZED', 'Token expired or invalid');
        case 403:
            return new RequestError('INVALID_CREDENTIALS', 'You do not have access to this resource.');
        case 404:
            return new RequestError(errorCode === 'ENOENT' ? errorCode : 'NOT_FOUND', 'Resource not found');
        case 408:
            return new RequestError('REQUEST_TIMEOUT', 'Server could not respond in a timely manner');
        case 412:
            return new RequestError('PRECONDITION_FAILED', 'This resource does not match the requisite conditions.');
        case 422:
            return new RequestError('INVALID_DATA', 'Library is corrupt, unzipping failed.');
        case 507:
            return new RequestError('OUT_OF_SPACE', 'Hard disk ran out of space.');
        default:
            return new RequestError('GENERIC_ERROR', `Something went wrong: ${statusCode}`);
    }
}
function getSAMRequestError(error) {
    const err = getRequestError(error._additionalInfo.response);
    err.underlyingError = error;
    return err;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Implements the Response structure used as a return value for
 * the `parseAsyncResponse` method below.
 *
 * The class only supports json() and text(), we should not require more than
 * text encoding for the APIs that support Async requests.
 */
class AsyncResponse$1 {
    constructor(url, headers, status, statusText, _text) {
        this.url = url;
        this.headers = headers;
        this.status = status;
        this.statusText = statusText;
        this._text = _text;
    }
    get ok() {
        const { status } = this;
        return status >= HttpStatus.OK && status < HttpStatus.MULTIPLE_CHOICES;
    }
    get redirected() {
        return false;
    }
    get type() {
        return 'basic';
    }
    async json() {
        try {
            return JSON.parse(this._text);
        }
        catch (err) {
            throw new LibraryError('INVALID_DATA', `Failed to parse JSON response from '${this.url}' async request.`, undefined, err);
        }
    }
    async text() {
        return this._text;
    }
    get trailer() {
        throw new LibraryError('NOT_IMPLEMENTED', 'AsyncResponse.trailer not implemented.');
    }
    clone() {
        const clonedHeaders = new Headers();
        this.headers.forEach((value, key) => clonedHeaders.set(key, value));
        return new AsyncResponse$1(this.url, clonedHeaders, this.status, this.statusText, this._text);
    }
    get bodyUsed() {
        throw new LibraryError('NOT_IMPLEMENTED', 'AsyncResponse.bodyUsed not implemented.');
    }
    get body() {
        throw new LibraryError('NOT_IMPLEMENTED', 'AsyncResponse.body not implemented.');
    }
    async arrayBuffer() {
        throw new LibraryError('NOT_IMPLEMENTED', 'AsyncResponse.arrayBuffer not implemented.');
    }
    async blob() {
        throw new LibraryError('NOT_IMPLEMENTED', 'AsyncResponse.blob not implemented.');
    }
    async formData() {
        throw new LibraryError('NOT_IMPLEMENTED', 'AsyncResponse.formData not implemented.');
    }
}
// https://www.w3.org/Protocols/rfc2616/rfc2616-sec2.html#sec2.1
// OCTET          = <any 8-bit sequence of data>
// CHAR           = <any US-ASCII character (octets 0 - 127)>
// CTL            = <any US-ASCII control character
//                  (octets 0 - 31) and DEL (127)>
// SP             = <US-ASCII SP, space (32)>
// HT             = <US-ASCII HT, horizontal-tab (9)>
// separators     = "(" | ")" | "<" | ">" | "@"
//                | "," | ";" | ":" | "\" | <">
//                | "/" | "[" | "]" | "?" | "="
//                | "{" | "}" | SP | HT
// token          = 1*<any CHAR except CTLs or separators>
// A header is just a <token>, the char ':' and the value.
function createHeaderRegexp() {
    const separators = '()<@,;:"/[]={}';
    // Start from the first character that is accepted by the <token>.
    let start = 33;
    const regexp = ['^(['];
    for (let i = 34; i <= 127; ++i) {
        // We know 127 is not accepted, so we use it as a terminator for our regexp segments.
        // None of the separators are allowed.
        if (i === 127 || separators.indexOf(String.fromCharCode(i)) !== -1) {
            regexp.push('\\' + start.toString(8));
            if (start < i - 1) {
                regexp.push('-\\' + (i - 1).toString(8));
            }
            start = i + 1;
        }
    }
    regexp.push(']+):(.*)$');
    return new RegExp(regexp.join(''));
}
const END_OF_LINE = '\n';
const CR = '\r';
const headerRegexp = createHeaderRegexp();
const statusRegexp = /^[^\s]+\s+(\d+)\s*(.*)$/;
class HttpResponseParser {
    constructor(_text) {
        this._text = _text;
        this._index = 0;
    }
    readLine() {
        const { _index, _text } = this;
        // The standard expects lines to end with CRLF by default.
        // However, it recommends to accept a single LF as well,
        // just in case some implementations do not implement the
        // standard correctly.
        // Async responses only use LF.
        const endOfLine = _text.indexOf(END_OF_LINE, _index);
        if (endOfLine === -1) {
            // We're done.
            return;
        }
        this._index = endOfLine + END_OF_LINE.length;
        let line = _text.slice(_index, endOfLine);
        if (line.endsWith(CR)) {
            // If we have the CR just before the LF, then we want to skip it too.
            line = line.slice(0, -1);
        }
        return line;
    }
    get remainderText() {
        return this._text.slice(this._index);
    }
}
/**
 * Implements parsing of the async response body.
 * https://git.corp.adobe.com/pages/caf/api-spec/chapters/advanced/asynchronous_invocation.html
 *
 * The caller should check for status code 202 then call this method to extract the contents
 * of final async result. The actual result is very similar to a nested HTTP reply inside the body
 * of the initial request.
 *
 */
function parseAsyncResponse(originalUrl, body) {
    if (!body) {
        throw new LibraryError('INVALID_DATA', 'Invalid async response body.');
    }
    const parser = new HttpResponseParser(body);
    let status;
    let statusText;
    const statusLine = parser.readLine();
    if (!statusLine) {
        // throw new SAMError('INVALID_DATA', 'Could not find async response status line.');
        // TODO: R-API does not return the status line for operations api. Any errors are reported in data section.
        // When this is fixed, then missing status line should be an error.
        // https://developers.corp.adobe.com/supplemental-resources/docs/async-invocation.md/#operations-api-exception
        status = HttpStatus.OK;
        statusText = '';
    }
    else {
        // The status line has 3 parts separated by spaces.
        // Example status line: HTTP/1.1 200 Status text
        const statusMatch = statusLine.match(statusRegexp);
        if (!statusMatch) {
            throw new LibraryError('INVALID_DATA', 'Invalid status line for async response.');
        }
        // The status code is the second element
        status = parseInt(statusMatch[1], 10);
        if (!status) {
            throw new LibraryError('INVALID_DATA', 'Could not find status code for async response.');
        }
        statusText = statusMatch[2];
    }
    // Now we extract the headers line by line.
    const headers = [];
    let headerName;
    let headerLine = parser.readLine();
    while (headerLine) {
        const match = headerLine.match(headerRegexp);
        if (!match) {
            if (headerName) {
                // If this is not a token, then we just continue with the value.
                headers.push([headerName, headerLine]);
            }
        }
        else {
            headerName = match[1];
            headers.push([headerName, match[2]]);
        }
        headerLine = parser.readLine();
    }
    // 1. The last `readLine()` call above will actually jump over the empty
    // line that separates the headers from the data section.
    // 2. The Headers constructor below takes care of multiple headers with the
    // same name and concatenates them as necessary.
    return new AsyncResponse$1(originalUrl, new Headers(headers), status, statusText, parser.remainderText);
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * AsyncResponse roughly mirrors AdobeLibraryOperation for interop reasons.
 * TODO: Clean this up
 */
class AsyncResponse extends AsyncOperation {
    constructor(_driver, request) {
        super();
        this._driver = _driver;
        this._handleResponse(request);
    }
    cancel() {
        this.abort();
        if (this._location) {
            this._driver.abortOperation(this._location);
            this._location = undefined;
        }
    }
    get error() {
        return this._error;
    }
    async _handleResponse(request) {
        var _a;
        try {
            const response = await request;
            if ([HttpStatus.NO_CONTENT, HttpStatus.OK].includes(response.status)) {
                this.progress = 100;
                let rawBody, jsonData, headers;
                if (response.status === HttpStatus.OK) {
                    // Async response completion from melville is raw http. We need to parse it out
                    // first and we use utility from SAMjs to do this. If there is an error parsing json data
                    // then we can assume this was a json response from local driver request to process
                    jsonData = await response
                        .text()
                        .then(body => {
                        rawBody = body;
                        return parseAsyncResponse('', body);
                    })
                        .then(res => {
                        headers = res.headers;
                        // Body is either JSON or empty, so if we fail to parse just return undefined
                        return res.json().catch(() => undefined);
                    })
                        .catch(() => JSON.parse(rawBody))
                        .catch(() => {
                        Logger$1.error(`Error parsing async response: ${response}`);
                    });
                }
                if (jsonData === null || jsonData === void 0 ? void 0 : jsonData.exception_code) {
                    // Example async error response:
                    // {
                    //     exception_code: "4000",
                    //     log_id: "5390a825-144a-429b-bf7d-9f1ae5b52728",
                    //     message: "unexpected error while copying asset - HttpProblemDetail{type='http://ns.adobe.com/adobecloud/problem/operation_failed', title='Unexpected response code when creating collection: 409 != 201', status=409, detail='null', instance='null', properties='{}'}",
                    //     status: 409,
                    //     type: "InputValidation"
                    // }
                    throw new RequestError(jsonData.status, jsonData.message, response, jsonData);
                }
                else {
                    this.emit('change', true, jsonData, headers);
                    this.DANGEROUS.removeAllListeners();
                    return;
                }
            }
            if (response.status === HttpStatus.ACCEPTED) {
                let json = {};
                try {
                    json = await response.json();
                }
                catch (_b) {
                    // R-API async responses don't have a body.
                }
                if (json.progress) {
                    this.progress = json.progress;
                    this.emit('change');
                }
                // R-API does not return a location from a monitor request.
                // Reuse the current location if there is not a location in the response.
                const newLocation = (_a = response.headers.get('location')) !== null && _a !== void 0 ? _a : json.href;
                if (newLocation) {
                    this._location = newLocation;
                }
                const retryAfter = response.headers.get('retry-after')
                    ? parseInt(response.headers.get('retry-after'), 10)
                    : 1;
                if (!this._location) {
                    throw new RequestError('MALFORMED_RESPONSE', 'Location header is missing from ops monitor response');
                }
                await this._driver.sleep(retryAfter * 1000, this._abortController.signal);
                return this._handleResponse(this._driver.fetch(this._location, {
                    signal: this._abortController.signal
                }));
            }
            throw new RequestError('UNEXPECTED_RESPONSE', `Unexpected response from ops monitor: ${response.status}`);
        }
        catch (error) {
            this._error = error;
            this.progress = 100;
            this.emit('change', true);
            this.DANGEROUS.removeAllListeners();
        }
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const configData = {
    staging: {
        hostname: 'ccx-melville-stage.adobe.io',
        invitation_hostname: 'invitations-stage.adobe.io',
        teams_hostname: 'ccprojects-stage.adobe.io',
        platform_hostname: 'platform-cs-stage.adobe.io'
    },
    production: {
        hostname: 'libraries.adobe.io',
        invitation_hostname: 'invitations.adobe.io',
        teams_hostname: 'ccprojects.adobe.io',
        platform_hostname: 'platform-cs.adobe.io'
    }
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function validatesOperation(target, propertyKey, propertyDescriptor) {
    const method = propertyDescriptor.value;
    propertyDescriptor.value = async function (...args) {
        if (this._actions.length === 0) {
            throw new LibraryError('NOT_SUPPORTED', 'Operation must have at least one action to be executed.', this._library.id);
        }
        Logger$1.log(`[OPERATION] Performing ${this._actions.length} actions.`);
        return method.apply(this, args);
    };
}
/**
 * An operation is an atomic API request. It contains some number of batchable actions.
 */
class Operation {
    /**
     * Is the action supported by this type of operation?
     * @param action
     */
    static supportsAction(action) {
        return this.prototype.supportsAction(action);
    }
    constructor(driver, library) {
        this._actions = [];
        this._driver = driver;
        this._library = library;
    }
    /**
     * Add an action to the operation, but only if it fits in the operation type.
     * @param action
     * @returns Did the operation accept the action?
     */
    addAction(action) {
        if (!this.supportsAction(action)) {
            return false;
        }
        this._actions.push(action);
        return true;
    }
    get actions() {
        return this._actions;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * SingleOperation
 *
 * An operation that can only contain one action.
 */
class SingleOperation$1 extends Operation {
    constructor() {
        super(...arguments);
        this._actionMappers = {};
    }
    get action() {
        return this._actions[0];
    }
    async execute() {
        // TODO: Clean me up
        const action = await this._actionMappers[this.action.name || ''](this.action);
        return { actions: [action] };
    }
    addAction(action) {
        if (this._actions.length === 1) {
            return false;
        }
        return super.addAction(action);
    }
}
__decorate([
    validatesOperation
], SingleOperation$1.prototype, "execute", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const PLATFORM = 'platform-cs';
const PLATFORM_EDGE = `${PLATFORM}-edge`;
const PLATFORM_DISCOVERY_ENDPOINTS = [
    `https://${PLATFORM}.adobe.io/index`,
    `https://${PLATFORM}-stage.adobe.io/index`
];
const PRIORITY_HEADER = { Priority: 'u=1' };
function decodeToken(token) {
    const parts = token.split('.');
    if (parts.length !== 3) {
        return undefined;
    }
    try {
        return JSON.parse(atob(parts[1]));
    }
    catch (e) {
        return undefined;
    }
}
function extractUserDataFromToken(token) {
    const decoded = decodeToken(token);
    if (decoded) {
        return {
            user: {
                id: decoded.user_id,
                clientId: decoded.client_id
            }
        };
    }
    return undefined;
}
function extractExpiryFromToken(token) {
    const decoded = decodeToken(token);
    if (decoded) {
        const elapsed = Date.now() - parseInt(decoded.created_at, 10);
        return Math.max(parseInt(decoded.expires_in, 10) - elapsed, 0);
    }
    return undefined;
}
/**
 * Utility function to inject use of ACP edge functionality with a
 * default priority of 3 set on optional request headers
 *
 * @export
 * @param {string} url URL client wants to promote to edge request
 * @returns modified edge url if provided url is a platform url and header object with set priority header
 */
function useEdge(url) {
    // Potential relative paths / url with no domain injected yet...
    let parsedUri;
    try {
        parsedUri = new URL(url);
    }
    catch (e) {
        return { url, headers: {} };
    }
    // Check if the url passed in is a platform endpoint
    if (!parsedUri.hostname.includes(PLATFORM)) {
        return { url, headers: {} };
    }
    // Check if the url is a discovery endpoint and replace hostname with edge endpoint if it is
    if (PLATFORM_DISCOVERY_ENDPOINTS.includes(url)) {
        parsedUri.hostname = parsedUri.hostname.replace(PLATFORM, PLATFORM_EDGE);
    }
    return { url: parsedUri.href, headers: Object.assign({}, PRIORITY_HEADER) };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function getRenditionCandidate(representations = []) {
    let candidate;
    let candidateSize = 0;
    for (const representation of representations) {
        const representationSize = representation.isFullSize
            ? Number.POSITIVE_INFINITY
            : Math.max(representation.height || 0, representation.width || 0);
        const replacementCandidate = !candidate ||
            (representation.isPreferredThumbnail && !candidate.isPreferredThumbnail) ||
            (representation.relationship === 'primary' && candidate.relationship !== 'primary') ||
            (representation.relationship === 'rendition' &&
                !['primary', 'rendition'].includes(candidate === null || candidate === void 0 ? void 0 : candidate.relationship)) ||
            (representation.relationship === 'rendition' &&
                candidate.relationship === 'rendition' &&
                representationSize > candidateSize);
        if (replacementCandidate && canComputeRenditionFromMimeType(representation.type)) {
            candidate = representation;
            candidateSize = representationSize;
        }
    }
    return candidate;
}
function getRenditionUrl(element, size = 200) {
    // @ts-expect-error TODO-R[SHARED-3961] element.data no longer exists.
    const { renditionUrl = {} } = element.data;
    const { template, substitutions = {} } = typeof renditionUrl === 'string' ? { template: renditionUrl } : renditionUrl;
    if (template) {
        const uriTemplate = uriTemplates(template);
        const populatedUrl = uriTemplate.fill(Object.assign(Object.assign({}, substitutions), { size: `${size}`, type: 'image/png' }));
        // Upgrade provided thumbnail url to ACP Edge (switch on http/2)
        const { url } = useEdge(populatedUrl);
        return url;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
var RapiLinkType;
(function (RapiLinkType) {
    RapiLinkType["DOWNLOAD"] = "http://ns.adobe.com/adobecloud/rel/download";
    RapiLinkType["MANIFEST"] = "http://ns.adobe.com/adobecloud/rel/manifest";
    RapiLinkType["APPLICATION"] = "http://ns.adobe.com/adobecloud/rel/metadata/application";
    RapiLinkType["EMBEDDED"] = "http://ns.adobe.com/adobecloud/rel/metadata/embedded";
    RapiLinkType["REPOSITORY"] = "http://ns.adobe.com/adobecloud/rel/metadata/repository";
    RapiLinkType["PRIMARY"] = "http://ns.adobe.com/adobecloud/rel/primary";
    RapiLinkType["RENDITION"] = "http://ns.adobe.com/adobecloud/rel/rendition";
    RapiLinkType["COMPONENT"] = "http://ns.adobe.com/adobecloud/rel/component";
    RapiLinkType["RESOLVE"] = "http://ns.adobe.com/adobecloud/rel/resolve/id";
    RapiLinkType["BLOCK_INIT"] = "http://ns.adobe.com/adobecloud/rel/block/init";
    RapiLinkType["BLOCK_TRANSFER"] = "http://ns.adobe.com/adobecloud/rel/block/transfer";
    RapiLinkType["BLOCK_FINALIZE"] = "http://ns.adobe.com/adobecloud/rel/block/finalize";
})(RapiLinkType || (RapiLinkType = {}));
function mapManifestToLibraryData(asset, manifest = asset.manifest.data) {
    var _a, _b, _c, _d, _e, _f, _g;
    const etag = (_a = asset.manifest) === null || _a === void 0 ? void 0 : _a.etag;
    const elements = getElementsFromDCXNode(asset, (_b = manifest.children) === null || _b === void 0 ? void 0 : _b.find(node => node.name === 'elements'));
    const removedElements = getElementsFromDCXNode(asset, (_c = manifest.children) === null || _c === void 0 ? void 0 : _c.find(node => node.name === 'removed_elements'));
    const documentationElements = getElementsFromDCXNode(asset, (_d = manifest.children) === null || _d === void 0 ? void 0 : _d.find(node => node.name === 'documentation_elements'));
    const groupsNode = (_e = manifest.children) === null || _e === void 0 ? void 0 : _e.find(node => node.name === 'groups');
    const groups = ((_f = groupsNode === null || groupsNode === void 0 ? void 0 : groupsNode.children) === null || _f === void 0 ? void 0 : _f.map(node => ({
        id: node.id,
        name: node.name,
        classifier: node['library#classifier'],
        order: node['library#order'],
        parentId: node['library#parentId'],
        sourceRef: node['library#sourceRef'],
        customData: getCustomDCXData(node)
    }))) || [];
    const libraryData = {
        id: manifest.id,
        name: manifest.name,
        etag,
        localizedNames: manifest['library#localizedName'],
        toolkitId: manifest['toolkit#id'],
        documentId: manifest['library#documentId'],
        documentType: manifest['library#documentType'],
        createdBy: asset.createdBy,
        modifiedBy: asset.modifiedBy,
        createdDate: asset.created.valueOf(),
        modifiedDate: asset.modified.valueOf(),
        version: manifest.components && manifest.components[0].version,
        roles: manifest['library#roles'],
        description: manifest['library#description'],
        details: {
            elementCount: elements.length,
            documentationElementCount: documentationElements.length,
            removedElementCount: removedElements.length
        },
        groups,
        elements,
        documentationElements,
        removedElements,
        customData: getCustomDCXData(manifest),
        isLibraryLoaded: true,
        areElementsLoaded: true,
        appMetadata: (_g = asset.appMetadata) === null || _g === void 0 ? void 0 : _g.data
        // default: can't get from manifest,
        // ownership: can't get from manifest,
        // collaboration: can't get from manifest,
        // assetId: can't get from manifest,
        // isWritable: can't get from manifest,
        // isParentWritable: can't get from manifest,
        // team: can't get from manifest,
        // owner: can't get from manifest,
        // ownerType: can't get from manifest
    }; // TODO
    if (manifest.components && manifest.components[0].version) {
        libraryData.version = manifest.components[0].version;
    }
    return libraryData;
}
function getElementsFromDCXNode(asset, node) {
    var _a;
    if (!node) {
        return [];
    }
    return (((_a = node.children) === null || _a === void 0 ? void 0 : _a.map(element => {
        const elementData = {
            id: element.id,
            name: element.name,
            isAutoNamed: element['library#autoName'],
            type: element.type,
            tags: element.tags || [],
            dependencyIds: element['library#dependencies'] || [],
            localizedNames: element['library#localizedName'],
            createdDate: element['library#created'],
            createdLocally: false,
            createdContext: element['library#createdData'] || {},
            modifiedDate: element['library#modified'],
            modifiedLocally: false,
            description: element['library#description'],
            descriptionModifiedLocally: false,
            removedLocally: false,
            representations: getRepresentationsFromDCXNode(asset, element),
            groups: element['library#groups']
                ? Object.entries(element['library#groups']).map(([key, { order }]) => {
                    // example key: $default#3c9fea12-e456-4d3f-b209-d76e52b2e89c
                    const [classifier, id] = key.split('#');
                    return { id, classifier, order };
                })
                : [],
            sourceRef: element['library#sourceRef'],
            roles: element['library#roles'],
            customData: getCustomDCXData(element)
        };
        // Attempt to set renditionUrl on elementData if a usable representation exists
        setRenditionUrl(asset, elementData);
        return elementData;
    })) || []);
}
function getComponentUrl(asset, representation) {
    var _a;
    // TODO: Get rendition urls from SAM.js
    const links = asset.links[RapiLinkType.COMPONENT];
    const templateString = (_a = links === null || links === void 0 ? void 0 : links[0]) === null || _a === void 0 ? void 0 : _a.href;
    const renditionTemplate = templateString && uriTemplates(templateString);
    return renditionTemplate === null || renditionTemplate === void 0 ? void 0 : renditionTemplate.fill({ revision: representation.version, component_id: representation.id });
}
function setRenditionUrl(asset, element) {
    var _a;
    const links = asset.links[RapiLinkType.RENDITION];
    const templateString = (_a = links === null || links === void 0 ? void 0 : links[0]) === null || _a === void 0 ? void 0 : _a.href;
    const candidate = getRenditionCandidate(element.representations);
    if (candidate) {
        element.renditionUrl = {
            template: templateString,
            substitutions: {
                fragment: `id=${candidate.id}`,
                size: 200
            }
        };
    }
}
function getRepresentationsFromDCXNode(asset, node) {
    var _a, _b;
    const components = ((_a = node.components) === null || _a === void 0 ? void 0 : _a.map(component => ({
        id: component.id,
        type: component.type,
        relationship: component.rel,
        url: getComponentUrl(asset, component),
        isFullSize: component['library#isFullSize'] || component['library#isfullSize'],
        isExternalLink: false,
        width: component.width,
        height: component.height,
        contentLength: component.length,
        isPreferredThumbnail: component['library#isPreferredThumbnail'],
        customData: getCustomDCXData(component)
    }))) || [];
    const children = ((_b = node.children) === null || _b === void 0 ? void 0 : _b.map(child => ({
        id: child.id,
        type: child.type,
        linktype: child['library#linktype'],
        relationship: child['library#rel'],
        isFullSize: false,
        isExternalLink: false,
        customData: getCustomDCXData(child)
    }))) || [];
    return [...components, ...children];
}
function getCustomDCXData(node) {
    const customData = {};
    for (const [key, value] of Object.entries(node)) {
        const [namespace, entry] = key.split('#');
        if (namespace !== 'library' && entry) {
            customData[key] = value;
        }
    }
    return customData;
}
function mapResponseToBlockDownloadData(blockDownloadResponse) {
    return {
        size: blockDownloadResponse.size,
        type: blockDownloadResponse.type,
        url: blockDownloadResponse.href
    };
}
function mapResponseToVersionData(assetId, response) {
    var _a;
    const templateString = (_a = response.links) === null || _a === void 0 ? void 0 : _a[RapiLinkType.MANIFEST].href;
    const manifestTemplate = templateString ? uriTemplates(templateString) : undefined;
    return {
        id: response.versionId,
        assetId,
        createdDate: response.created.getTime(),
        createdBy: response.createdBy,
        manifestUrl: manifestTemplate === null || manifestTemplate === void 0 ? void 0 : manifestTemplate.fill({})
    };
}
function mapResponseToCollaboratorData(assetId, collaborator) {
    return {
        id: collaborator.collaboratorID,
        assetId,
        imsUserId: collaborator.imsUserId,
        email: collaborator.email,
        name: collaborator.name,
        role: collaborator.role,
        type: collaborator.type,
        inheritances: collaborator.inheritances,
        isDirect: collaborator.isDirect,
        hasContributorRole: collaborator.hasContributorRole,
        hasName: collaborator.hasName,
        invited: collaborator.invited,
        isAdmin: collaborator.isAdmin
    };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const CC_STORAGE_ID_REGEX = /^[A-Z0-9]{30}$/;
// https://git.corp.adobe.com/Stormcloud/melville/blob/integration/src/main/java/com/adobe/melville/db/dto/element/DbLibraryElementRepresentationData.java
const allowedRepresentationCustomData = [
    'color#data',
    'colortheme#data',
    'channel#data',
    'imageguideline#data',
    'gradient#data',
    'audio#data',
    'font#data',
    'characterstyle#data',
    'paragraphstyle#data',
    'text#data',
    '3d#data',
    'video#data',
    'pattern#data',
    'candy#data',
    'graphic#data',
    // TODO: For Firefly POC purposes.
    'clio#data',
    'firefly#cme'
];
function isRepresentationPreflightResponse(data) {
    return ((data === null || data === void 0 ? void 0 : data.id) &&
        (data === null || data === void 0 ? void 0 : data.storage_href) &&
        (data === null || data === void 0 ? void 0 : data.asset_id) &&
        (data === null || data === void 0 ? void 0 : data.type) &&
        (data === null || data === void 0 ? void 0 : data.content_length) &&
        (data === null || data === void 0 ? void 0 : data.etag) &&
        (data === null || data === void 0 ? void 0 : data.version));
}
const isWritable = (libraryResponse) => {
    const permissions = libraryResponse.asset_acl;
    if (!permissions) {
        return undefined;
    }
    const primaryPermissions = permissions['http://ns.adobe.com/adobecloud/rel/primary'];
    if (primaryPermissions) {
        return primaryPermissions.includes('write');
    }
    const fullPermissions = permissions['*'];
    if (fullPermissions) {
        return fullPermissions.includes('write');
    }
    return false;
};
function stubRenditionGridElements(grid, gridGenerationEtag) {
    var _a;
    if (!grid || !grid.main) {
        return {};
    }
    const main = stubRenditionGridElement(grid.main);
    const tiles = ((_a = grid.tiles) === null || _a === void 0 ? void 0 : _a.filter(Boolean).map(stubRenditionGridElement)) || [];
    return {
        renditionGrid: {
            main: main ? { id: main.id } : undefined,
            tiles: tiles
                .map(tile => (tile ? { id: tile.id } : undefined))
                .filter(Boolean),
            gridGenerationEtag
        },
        elements: [main, ...tiles].filter(Boolean)
    };
}
function stubRenditionGridElement(rendition) {
    var _a, _b;
    const elementData = {
        id: (_a = rendition.elementId) !== null && _a !== void 0 ? _a : uuid_1.v4(),
        name: 'temp rendition element',
        type: rendition.type,
        createdDate: Date.now(),
        modifiedDate: Date.now(),
        representations: [
            {
                id: uuid_1.v4(),
                type: rendition.rendition_mimetype,
                relationship: 'primary',
                isFullSize: false,
                isExternalLink: false,
                isPreferredThumbnail: true
            }
        ],
        groups: []
    };
    // If representation type is 'href' just make an image element. Because who cares.
    // Melville is inconsistent and sometimes returns the element type rather than the rendition type
    // So check for either option. See https://git.corp.adobe.com/Stormcloud/melville/blob/integration/src/main/java/com/adobe/melville/storage/operations/RenditionUtils.java#L211
    // Ideally we can remove the element types after they phase out returning the dcx type in rendition_grid
    switch (rendition.type) {
        case 'application/vnd.adobe.gradient.noise+json':
        case 'href':
            elementData.type = 'application/vnd.adobe.element.image+dcx';
            elementData.renditionUrl = rendition.rendition;
            elementData.representations[0].type = 'image/png';
            elementData.representations[0].url = rendition.rendition;
            break;
        case 'application/vnd.adobe.color+json':
        case 'application/vnd.adobe.element.color+dcx':
            elementData.representations[0].customData = {
                // Rendition swatches will be empty if the color is missing color data (corrupt)
                'color#data': (_b = rendition.rendition.swatches[0]) === null || _b === void 0 ? void 0 : _b.find((swatch) => swatch.mode === 'RGB')
            };
            break;
        case 'application/vnd.adobe.colortheme+json':
        case 'application/vnd.adobe.element.colortheme+dcx':
            elementData.representations[0].type = 'application/vnd.adobe.colortheme+json';
            elementData.representations[0].customData = {
                'colortheme#data': rendition.rendition
            };
            break;
        case 'application/vnd.adobe.gradient+json':
        case 'application/vnd.adobe.element.gradient+dcx':
            // Gradient data in rendition often has the incorrect type of 'href' and won't hit this block
            // https://jira.corp.adobe.com/browse/CCXB-14786
            elementData.representations[0].customData = {
                'gradient#data': rendition.rendition
            };
            break;
        default:
            return undefined;
    }
    return elementData;
}
function hasCCStorageId(libraryResponse) {
    return libraryResponse.ownership === 'public' && CC_STORAGE_ID_REGEX.test(libraryResponse.id);
}
// Map data returned from melville to our internal data structure.
// This contains only library level metadata. The elements properties aren't returned here, as they are fetched separately by library.
// Don't initialize a non-existent property with default values here (including []),
// as we don't want to override pre-existing data with default values during the update of cached models.
// Put default values for underlying data in the Library constructor instead.
function mapResponseToLibraryData$1(libraryResponse, forceReadOnly = false, injectStubRenditionGridElements = false) {
    var _a, _b, _c, _d;
    const etag = libraryResponse.manifest_etag || melvilleFirstUseEtag;
    const isLibraryWritable = !forceReadOnly && isWritable(libraryResponse);
    const libraryData = Object.assign({ 
        // bookmark.id is used for public library v1 case, since the default id may not be unique
        id: (libraryResponse.ownership === 'public' && ((_a = libraryResponse.bookmark) === null || _a === void 0 ? void 0 : _a.id)) || libraryResponse.id, name: libraryResponse.name, ownership: libraryResponse.ownership === 'team' ? 'incoming' : libraryResponse.ownership, 
        // If there isn't a manifest_etag in the USS response, we can fill later 'If-None-Match' headers with any garbage
        // and they will still return 304. When the library gets updated, the USS response will return a manifest_etag,
        // the garbage 'If-None-Match' will return 200 instead of 304, and we will get the right etag.
        etag, version: libraryResponse.version, default: libraryResponse.default, localizedNames: libraryResponse.localized_names, toolkitId: libraryResponse.toolkit_id, documentId: libraryResponse.document_id, documentType: libraryResponse.document_type, createdDate: libraryResponse.created_date, modifiedDate: libraryResponse.modified_date, createdBy: libraryResponse.created_by, modifiedBy: libraryResponse.modified_by, groups: (_b = libraryResponse.groups) === null || _b === void 0 ? void 0 : _b.map(mapResponseToGroupData$1), details: {
            elementCount: libraryResponse.elements_count,
            documentationElementCount: 0,
            removedElementCount: libraryResponse.removed_elements_count
        }, appMetadata: libraryResponse.application_metadata, collaboration: libraryResponse.collaboration, assetId: libraryResponse.library_urn, isWritable: isLibraryWritable, isParentWritable: true, 
        // Melville discards libraries when removing them.
        removeType: isLibraryWritable ? 'discard' : 'none', deletable: isLibraryWritable, roles: libraryResponse.roles, description: libraryResponse.description, owner: (_c = libraryResponse.storage_assignee) === null || _c === void 0 ? void 0 : _c.id, ownerType: libraryResponse.ownership ? (libraryResponse.ownership === 'team' ? 'org' : 'user') : undefined, customData: getCustomDCXData(libraryResponse), isLibraryLoaded: true, 
        // TODO: Remove with Durable Links and Invitation Service V4 work
        publicLinkId: hasCCStorageId(libraryResponse) ? libraryResponse.id : undefined, bookmark: libraryResponse.bookmark }, (injectStubRenditionGridElements
        ? stubRenditionGridElements(libraryResponse.rendition_grid, etag)
        : {}));
    // If this is undefined, we don't want to override the current team data with undefined if it already exists.
    if (libraryResponse.workspace_urn || libraryResponse.parent_assetId) {
        libraryData.team = {
            id: (_d = libraryResponse.workspace_urn) !== null && _d !== void 0 ? _d : libraryResponse.parent_assetId
        };
    }
    return libraryData;
}
function mapResponseToElementData$1(elementResponse) {
    var _a, _b, _c, _d, _e;
    return {
        id: elementResponse.id,
        name: elementResponse.name,
        isAutoNamed: elementResponse.is_auto_named,
        type: elementResponse.type,
        tags: elementResponse.tags || [],
        dependencyIds: elementResponse.dependency_ids || [],
        localizedNames: elementResponse.localized_names || {},
        createdDate: elementResponse.created_date,
        createdLocally: false,
        createdContext: ((_a = elementResponse.details) === null || _a === void 0 ? void 0 : _a.created) || {},
        modifiedDate: elementResponse.modified_date,
        modifiedLocally: false,
        description: (_b = elementResponse.details) === null || _b === void 0 ? void 0 : _b.description,
        descriptionModifiedLocally: false,
        removedLocally: false,
        representations: ((_c = elementResponse.representations) === null || _c === void 0 ? void 0 : _c.map(mapResponseToRepresentationData$1)) || [],
        renditionUrl: ((_d = elementResponse.thumbnail) === null || _d === void 0 ? void 0 : _d.type) === 'href' && elementResponse.thumbnail.rendition,
        groups: ((_e = elementResponse.groups) === null || _e === void 0 ? void 0 : _e.map(mapResponseToGroupMembershipData$1)) || [],
        sourceRef: elementResponse.sourceRef,
        roles: elementResponse.roles,
        customData: getCustomDCXData(elementResponse)
    };
}
function mapResponseToGroupData$1(groupResponse) {
    return {
        id: groupResponse.id,
        classifier: groupResponse.classifier,
        name: groupResponse.name,
        order: groupResponse.order,
        parentId: groupResponse.parent_id,
        // localizedNames: groupResponse.localized_names,
        createdDate: groupResponse.created_date,
        modifiedDate: groupResponse.modified_date,
        // customData: {},
        sourceRef: groupResponse.sourceRef
    };
}
function mapResponseToGroupMembershipData$1(groupMembershipResponse) {
    // This is a no-op, but it is left as an example.
    return {
        id: groupMembershipResponse.id,
        classifier: groupMembershipResponse.classifier,
        order: groupMembershipResponse.order
    };
}
function mapResponseToRepresentationData$1(representationResponse) {
    var _a, _b, _c, _d;
    return {
        id: representationResponse.id,
        type: representationResponse.type,
        linktype: representationResponse.linktype,
        relationship: representationResponse.relationship,
        isFullSize: representationResponse.is_full_size,
        isExternalLink: representationResponse.is_external_link,
        height: representationResponse.height,
        width: representationResponse.width,
        contentLength: representationResponse.content_length,
        url: (_b = (_a = representationResponse._links) === null || _a === void 0 ? void 0 : _a['http://ns.adobe.com/melville/rel/primary']) === null || _b === void 0 ? void 0 : _b.href,
        blockDownloadUrl: (_d = (_c = representationResponse._links) === null || _c === void 0 ? void 0 : _c['http://ns.adobe.com/melville/rel/download']) === null || _d === void 0 ? void 0 : _d.href,
        customData: {
            'channel#data': representationResponse['channel#data'],
            'imageguideline#data': representationResponse['imageguideline#data'],
            'color#data': representationResponse['color#data'],
            'characterstyle#data': representationResponse['characterstyle#data'],
            'paragraphstyle#data': representationResponse['paragraphstyle#data'],
            'gradient#data': representationResponse['gradient#data'],
            'colortheme#data': representationResponse['colortheme#data'],
            'font#data': representationResponse['font#data'],
            'adobestock#trackingdata': representationResponse['adobestock#trackingdata'],
            'firefly#cme': representationResponse['firefly#cme']
        }
    };
}
function mapResponseToTeamData$1(teamResponse) {
    return {
        name: teamResponse.name,
        id: teamResponse.id,
        isWritable: teamResponse.collaboratorRole === 'editor',
        owner: teamResponse.repositoryOwner,
        ownerName: teamResponse.repositoryName
    };
}
function mapLibraryDataToRequest$1(libraryData) {
    return Object.assign({ name: libraryData.name, document_id: libraryData.documentId, roles: libraryData.roles, description: libraryData.description }, extractCustomData(libraryData.customData));
}
function mapElementDataToElementMetadata(elementData) {
    var _a;
    return Object.assign({ id: elementData.id, name: elementData.name, roles: elementData.roles, description: elementData.description, tags: elementData.tags, sourceRef: elementData.sourceRef, group: (_a = elementData.groups) === null || _a === void 0 ? void 0 : _a[0] }, extractCustomData(elementData.customData));
}
function mapSearchResponseToElementData(searchResponse) {
    return {
        id: searchResponse.id,
        libraryAssetId: searchResponse.parent_id,
        name: searchResponse.name,
        type: searchResponse.type,
        createdDate: searchResponse.created_date,
        modifiedDate: searchResponse.modified_date,
        renditionUrl: searchResponse.thumbnail.rendition,
        tags: searchResponse.tags,
        roles: searchResponse.roles,
        representations: searchResponse.representations.map(mapResponseToRepresentationData$1),
        groups: (searchResponse.groups || []).map(mapResponseToGroupMembershipData$1)
    };
}
function mapRepresentationDataToRequest$1(representationData) {
    var _a, _b, _c, _d, _e;
    const source = isRepresentationPreflightResponse(representationData.source) ? representationData.source : undefined;
    return Object.assign({ id: (_a = source === null || source === void 0 ? void 0 : source.id) !== null && _a !== void 0 ? _a : representationData.id, type: (_b = source === null || source === void 0 ? void 0 : source.type) !== null && _b !== void 0 ? _b : representationData.type, relationship: representationData.relationship, path: representationData.path, is_full_size: representationData.isFullSize, is_external_link: representationData.isExternalLink, width: (_c = source === null || source === void 0 ? void 0 : source.width) !== null && _c !== void 0 ? _c : representationData.width, height: (_d = source === null || source === void 0 ? void 0 : source.height) !== null && _d !== void 0 ? _d : representationData.height, content_length: (_e = source === null || source === void 0 ? void 0 : source.content_length) !== null && _e !== void 0 ? _e : representationData.contentLength, is_preferred_thumbnail: representationData.isPreferredThumbnail, name: source === null || source === void 0 ? void 0 : source.name, storage_href: source === null || source === void 0 ? void 0 : source.storage_href, asset_id: source === null || source === void 0 ? void 0 : source.asset_id, etag: source === null || source === void 0 ? void 0 : source.etag, md5: source === null || source === void 0 ? void 0 : source.md5, version: source === null || source === void 0 ? void 0 : source.version }, extractCustomData(representationData.customData, allowedRepresentationCustomData));
}
function extractCustomData(customData = {}, allowedKeys) {
    const result = {};
    for (const [key, value] of Object.entries(customData)) {
        // Typescript is just not that smart
        const typedKey = key;
        // Allow keys by default if allowedKeys is undefined.
        // Melville will reject any keys it doesn't recognize.
        if ((allowedKeys === null || allowedKeys === void 0 ? void 0 : allowedKeys.includes(typedKey)) || !allowedKeys) {
            result[typedKey] = value;
        }
    }
    return result;
}
function mapElementDataToRequest$1(elementData, clientInfo) {
    var _a;
    return Object.assign(Object.assign({}, mapElementDataToElementMetadata(elementData)), { client: clientInfo, type: elementData.type, representations: (_a = elementData.representations) === null || _a === void 0 ? void 0 : _a.map(mapRepresentationDataToRequest$1) });
}
function mapGroupDataToRequest$1(groupData, clientInfo) {
    return {
        group: {
            name: groupData.name,
            classifier: groupData.classifier,
            order: groupData.order,
            parent_id: groupData.parentId
        },
        client: clientInfo
    };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Modify attribute names to their full names when interfacing with the API
const resourceRefToPayload = (resourceRef) => {
    return resourceRef.map(r => {
        const { id, version } = r, rest = __rest$2(r, ["id", "version"]);
        return Object.assign(Object.assign({}, rest), { ['repo:assetId']: id, 'repo:version': version });
    });
};
const PERMISSION_INHERITANCE_MAP = {
    read: 'team_view',
    all: 'team_edit'
};
const supportedActionNames$2 = [
    'createLibrary',
    'removeLibrary',
    'unfollowLibrary',
    'leaveLibrary',
    'permanentlyDeleteLibrary',
    'copyLibrary',
    'moveLibrary'
];
let CloudSingleOperation = class CloudSingleOperation extends SingleOperation$1 {
    constructor() {
        super(...arguments);
        this._actionMappers = {
            createLibrary: (action) => this._createLibraryActionMap(action),
            copyLibrary: (action) => this._createLibraryActionMap(action),
            removeLibrary: async (action) => {
                await this._removeLibrary();
                return action;
            },
            permanentlyDeleteLibrary: async (action) => {
                await this._permanentlyDeleteLibrary();
                return action;
            },
            unfollowLibrary: async (action) => {
                await this._unfollowLibrary();
                return action;
            },
            leaveLibrary: async (action) => {
                await this._leaveLibrary();
                return action;
            },
            moveLibrary: async (action) => {
                const data = await this._moveLibrary();
                return Object.assign(Object.assign({}, action), { data, originalAction: action });
            }
        };
        this._createLibraryActionMap = async (action) => {
            const data = await this._createLibrary(action);
            return Object.assign(Object.assign({}, action), { type: 'update', data, originalAction: action });
        };
    }
    supportsAction(action) {
        return supportedActionNames$2.includes(action.name);
    }
    _createLibrary(action) {
        return new Promise((resolve, reject) => {
            var _a, _b;
            const { name, team, roles, documentExtractionData } = (_a = action.data) !== null && _a !== void 0 ? _a : {};
            const { permissionInheritance, source, includeAppMetadata: includeApplicationMetadata } = (_b = action.flags) !== null && _b !== void 0 ? _b : {};
            const payload = {
                name,
                roles,
                documentExtractionData: (documentExtractionData === null || documentExtractionData === void 0 ? void 0 : documentExtractionData.length) > 0 ? resourceRefToPayload(documentExtractionData) : undefined,
                // @ts-expect-error R-TODO
                source: source === null || source === void 0 ? void 0 : source.assetId,
                parent_assetId: team === null || team === void 0 ? void 0 : team.id,
                access: PERMISSION_INHERITANCE_MAP[permissionInheritance] || undefined,
                includeResources: includeApplicationMetadata
                    ? [
                        { relType: 'http://ns.adobe.com/adobecloud/rel/metadata/application' },
                        { relType: 'http://ns.adobe.com/adobecloud/rel/primary' }
                    ]
                    : undefined
            };
            const request = this._driver.fetch('/api/v1/libraries?invocation_mode=async', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const asyncResponse = new AsyncResponse(this._driver, request);
            asyncResponse.on('change', (done, response) => {
                if (done) {
                    if (asyncResponse.error) {
                        reject(asyncResponse.error);
                    }
                    else if (response) {
                        const libraryData = mapResponseToLibraryData$1(response);
                        // TEMPORARY WORKAROUND TO MANUALLY UPDATE APPMETADATA
                        // CCXB-21559 WILL DO THIS AUTOMATICALLY IN THE BACKEND SOON
                        if ((documentExtractionData === null || documentExtractionData === void 0 ? void 0 : documentExtractionData.length) > 0 && libraryData.assetId) {
                            this._patchBrandAppMetadata(libraryData.assetId, '/brand:extractedFrom', resourceRefToPayload(documentExtractionData));
                        }
                        // Implicitly, if we've created a library, we know it and its parent are writable.
                        // Melville does not return ACLs on create response.
                        libraryData.isWritable = true;
                        libraryData.isParentWritable = true;
                        resolve(libraryData);
                    }
                    else {
                        resolve(undefined);
                    }
                }
            });
        });
    }
    _removeLibrary() {
        return this._driver.fetch(`/api/v1/libraries/${this._library.assetId}`, { method: 'DELETE' });
    }
    _permanentlyDeleteLibrary() {
        return this._driver.fetch(`/api/v1/libraries/${this._library.assetId}?permanent=true`, { method: 'DELETE' });
    }
    _unfollowLibrary() {
        var _a;
        return this._driver.fetch(`/api/v1/libraries/bookmarks/${(_a = this._library.bookmark) === null || _a === void 0 ? void 0 : _a.id}`, { method: 'DELETE' });
    }
    async _leaveLibrary() {
        var _a, _b;
        const userId = (_a = this._driver.config.user) === null || _a === void 0 ? void 0 : _a.id;
        const response = await this._driver.fetch(`https://${this._driver.driverConfig.invitation_hostname}/api/v4/share/${this._library.assetId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                collaborators: [
                    {
                        action: 'remove',
                        id: userId
                    }
                ]
            })
        });
        const json = await response.json();
        const error = (_b = json.collaborators) === null || _b === void 0 ? void 0 : _b.find((collab) => collab.statusCode > 300);
        if (!error) {
            return this._unfollowLibrary();
        }
        else {
            throw getRequestError(response);
        }
    }
    _moveLibrary() {
        return this._driver.moveLibrary(this._library.assetId, this.action.data.team.id, this.action.data.owner);
    }
    async _patchBrandAppMetadata(assetId, path, newAppMetadata) {
        var _a;
        const asset = await ((_a = this._driver._core) === null || _a === void 0 ? void 0 : _a.hostAssetContext.getAssetWithCloudID(assetId));
        asset === null || asset === void 0 ? void 0 : asset.patchAppMetadata([{ op: 'add', path, value: newAppMetadata }]);
    }
};
__decorate([
    trace
], CloudSingleOperation.prototype, "_createLibrary", null);
CloudSingleOperation = __decorate([
    traceableAs('CloudSingleOperation')
], CloudSingleOperation);
var SingleOperation = CloudSingleOperation;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const stripWhitespace = (str) => str.replace(/ |\t|\n/g, '');
const elementRegex = /^(\$\.(?:elements|removedElements|documentationElements))\[\?\(@\.id=="([^"]+)"\)\]$/;
const groupRegex = /^\$\.groups\[\?\(@\.id=="([^"]+)"\)\]$/;
function extractElementId$1(path) {
    path = stripWhitespace(path);
    const [, , elementId] = elementRegex.exec(path) || [];
    return elementId;
}
function extractElementCollection(path) {
    path = stripWhitespace(path);
    const [, elementCollection] = elementRegex.exec(path) || [];
    return elementCollection;
}
function extractGroupId(path) {
    path = stripWhitespace(path);
    const [, groupId] = groupRegex.exec(path) || [];
    return groupId;
}
function getPlaceholderId(path) {
    const id = extractElementId$1(path) || extractGroupId(path);
    return isPlaceholder(id) && id;
}
function replaceId(path, oldId, newId) {
    return path.replace(oldId, newId);
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * A transfer operation is an operation to move or copy elements or groups.
 * Due to the cross-library nature of these operations, these operations may
 * need to act on two different libraries multiple times.
 */
class MoveCopyElementOperation extends Operation {
    supportsAction(action) {
        return ['moveElement', 'copyElement', 'dependent'].includes(action.name);
    }
    addAction(action) {
        // move/copy are batchable if:
        //  - the action is a supported action
        //  - the source and destination libraries are the same
        //  - the action is the same (move or copy)
        //  - the linked action is in the same queue position as the action
        //  - if the source and target libraries are the same:
        //    * the linked action is in the n+1 position
        var _a, _b, _c, _d, _e, _f;
        if (!this.supportsAction(action)) {
            return false;
        }
        const lastAction = this._actions[this._actions.length - 1];
        if (!lastAction && action.name !== 'dependent') {
            return super.addAction(action);
        }
        if (action.library === ((_a = action.link) === null || _a === void 0 ? void 0 : _a.library)) {
            if (action.name === 'dependent') {
                if (lastAction.link === action) {
                    this._actions.push(action);
                    return true;
                }
                return false;
            }
            // @ts-expect-error R-TODO
            const actionIndex = (_b = action.library) === null || _b === void 0 ? void 0 : _b.actions.indexOf(action);
            // @ts-expect-error R-TODO
            const linkedActionIndex = (_d = (_c = action.link) === null || _c === void 0 ? void 0 : _c.library) === null || _d === void 0 ? void 0 : _d.actions.indexOf(action.link);
            if (actionIndex + 1 !== linkedActionIndex) {
                return false;
            }
            return super.addAction(action);
        }
        if (((_e = lastAction.link) === null || _e === void 0 ? void 0 : _e.library) !== ((_f = action.link) === null || _f === void 0 ? void 0 : _f.library) || lastAction.type !== action.type) {
            return false;
        }
        return super.addAction(action);
    }
    async execute() {
        var _a;
        const isMove = this._actions[0].name === 'moveElement';
        const targetLibrary = (_a = this._actions[0].link) === null || _a === void 0 ? void 0 : _a.library;
        const actualActions = this._actions.filter(action => action.name !== 'dependent');
        const elementIds = actualActions.map(action => extractElementId$1(action.path));
        const { elements, etag, sourceEtag } = await this._doMoveCopyRequest(isMove, this._library, targetLibrary, elementIds);
        // The elements in the response should be 1:1 with the elements in the actions. If not, something has gone wrong.
        if (elements.length !== actualActions.length) {
            // TODO: Better error
            throw new Error();
        }
        let linkedActions;
        let actions;
        if (targetLibrary === this._library) {
            linkedActions = [];
            actions = this._actions.map(action => {
                if (action.name !== 'dependent') {
                    return action;
                }
                const index = actualActions.findIndex(a => a === action.link || a.originalAction === action.link);
                return Object.assign(Object.assign({}, action), { data: elements[index], originalAction: action });
            });
        }
        else {
            actions = this._actions;
            linkedActions = this._actions.map((action, index) => (Object.assign(Object.assign({}, action.link), { data: elements[index], originalAction: action.link })));
        }
        return {
            actions,
            etag: sourceEtag,
            linkedActions,
            linkedEtag: etag
        };
    }
}
__decorate([
    validatesOperation
], MoveCopyElementOperation.prototype, "execute", null);

/**
 * A transfer operation is an operation to move or copy elements or groups.
 * Due to the cross-library nature of these operations, these operations may
 * need to act on two different libraries multiple times.
 */
class CloudMoveCopyElementOperation extends MoveCopyElementOperation {
    async _doMoveCopyRequest(isMove, sourceLibrary, targetLibrary, elementIds) {
        const sourceAssetId = this._library.assetId;
        const targetAssetId = targetLibrary.assetId;
        const response = await this._driver.fetch(`/api/v1/libraries/${targetAssetId}/elements`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'If-Match': targetLibrary.etag
            },
            body: JSON.stringify({
                [isMove ? 'self' : 'source']: {
                    id: sourceAssetId,
                    elements: elementIds,
                    'if-match': this._library.etag
                }
            })
        });
        const json = await response.json();
        return {
            elements: json.elements.map(mapResponseToElementData$1),
            etag: response.headers.get('etag'),
            sourceEtag: response.headers.get('x-source-etag')
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function deepCopy(object) {
    // eslint-disable-next-line no-undef
    if (typeof structuredClone !== 'undefined') {
        return structuredClone(object);
    }
    return JSON.parse(JSON.stringify(object));
}
function replaceActionPlaceHolders(targetAction, idCache, placeholderReplacers) {
    var _a;
    const newAction = placeholderReplacers.reduce((action, replacer) => replacer(action, idCache), targetAction);
    if (newAction !== targetAction) {
        newAction.originalAction = targetAction;
    }
    if (newAction.type === 'aggregate') {
        newAction.actions = (_a = newAction.actions) === null || _a === void 0 ? void 0 : _a.map(action => replaceActionPlaceHolders(action, idCache, placeholderReplacers));
    }
    return newAction;
}
function replacePlaceholders(sourceActions, targetActions) {
    var _a, _b, _c;
    if (!targetActions) {
        targetActions = sourceActions;
    }
    // If an ID has changed between the original action and the response (placeholder substitution),
    // we need to replace that id in all pending actions. Otherwise the actions will be pointing at
    // an element that doesn't exist.
    const idCache = {};
    for (const sourceAction of sourceActions) {
        if (isPlaceholder((_b = (_a = sourceAction.originalAction) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.id)) {
            idCache[(_c = sourceAction.originalAction) === null || _c === void 0 ? void 0 : _c.data.id] = sourceAction.data;
        }
    }
    // Replace placeholder ids on queued actions
    const placeholderReplacers = [
        pathPlaceholderReplacer,
        groupDataPlaceholderReplacer,
        representationDataPlaceholderReplacer
    ];
    return targetActions.map(action => replaceActionPlaceHolders(action, idCache, placeholderReplacers));
}
function pathPlaceholderReplacer(action, idCache) {
    var _a;
    const placeholderId = action.path && getPlaceholderId(action.path);
    if (placeholderId) {
        const actualId = (_a = idCache[placeholderId]) === null || _a === void 0 ? void 0 : _a.id;
        if (actualId) {
            return Object.assign(Object.assign({}, action), { path: replaceId(action.path, placeholderId, actualId) });
        }
    }
    return action;
}
function groupDataPlaceholderReplacer(action, idCache) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    let hasReplacedGroups = false;
    const newGroups = [];
    (_b = (_a = action.data) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.forEach((group) => {
        var _a;
        if (group.id && isPlaceholder(group.id)) {
            const actualId = (_a = idCache[group.id]) === null || _a === void 0 ? void 0 : _a.id;
            if (actualId) {
                hasReplacedGroups = true;
                newGroups.push(Object.assign(Object.assign({}, group), { id: actualId }));
                return;
            }
        }
        newGroups.push(group);
    });
    if (hasReplacedGroups) {
        return Object.assign(Object.assign({}, action), { data: Object.assign(Object.assign({}, action.data), { groups: newGroups }) });
    }
    // Replacing potential placeholder Ids with actual Ids.
    if (((_c = action.data) === null || _c === void 0 ? void 0 : _c.id) && isPlaceholder((_d = action.data) === null || _d === void 0 ? void 0 : _d.id)) {
        const actualId = (_f = idCache[(_e = action.data) === null || _e === void 0 ? void 0 : _e.id]) === null || _f === void 0 ? void 0 : _f.id;
        if (actualId) {
            action.data.id = actualId;
        }
    }
    if (((_g = action.data) === null || _g === void 0 ? void 0 : _g.parentId) && isPlaceholder((_h = action.data) === null || _h === void 0 ? void 0 : _h.parentId)) {
        const actualId = (_k = idCache[(_j = action.data) === null || _j === void 0 ? void 0 : _j.parentId]) === null || _k === void 0 ? void 0 : _k.id;
        if (actualId) {
            action.data.parentId = actualId;
        }
    }
    return action;
}
function representationDataPlaceholderReplacer(action, idCache) {
    var _a, _b;
    const newRepresentations = [];
    let replacedRepresentations = false;
    const replaceRepresentation = (representation) => {
        let newRepresentation = Object.assign({}, representation);
        if (representation.id && isPlaceholder(representation.id)) {
            const actualData = idCache[representation.id];
            // We need to inject the entire representation data, the id alone is not sufficient.
            if (actualData) {
                newRepresentation = actualData;
                replacedRepresentations = true;
            }
        }
        return newRepresentation;
    };
    (_b = (_a = action.data) === null || _a === void 0 ? void 0 : _a.representations) === null || _b === void 0 ? void 0 : _b.forEach((representation) => {
        if (representation.source) {
            representation.source = replaceRepresentation(representation.source);
        }
        newRepresentations.push(replaceRepresentation(representation));
    });
    if (replacedRepresentations) {
        // Don't inject new fields into the action payload that weren't there before.
        return Object.assign(Object.assign({}, action), { data: Object.assign(Object.assign({}, action.data), { representations: newRepresentations }) });
    }
    return action;
}
function markSubstitutedPlaceholders(actions) {
    var _a, _b, _c;
    for (const action of actions) {
        if (action.data && isPlaceholder((_b = (_a = action.originalAction) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.id)) {
            action.data.previousPlaceholderId = (_c = action.originalAction) === null || _c === void 0 ? void 0 : _c.data.id;
        }
    }
}

function tokenizePlaceholders(requests) {
    var _a;
    const tokenMap = {};
    for (let i = 0; i < requests.length; i += 1) {
        const request = requests[i];
        const id = (_a = request.body) === null || _a === void 0 ? void 0 : _a.id;
        if (request.method === 'POST' && isPlaceholder(id)) {
            tokenMap[id] = `$${i}.id`;
            delete request.body.id;
        }
        // For PUT and DELETE check the path
        if (['PUT', 'DELETE'].includes(request.method)) {
            const placeholder = extractPlaceholder(request.path);
            if (placeholder) {
                if (!tokenMap[placeholder]) {
                    throw new Error(`Unmapped placeholder ID: ${placeholder}`);
                }
                request.path = request.path.replace(placeholder, tokenMap[placeholder]);
            }
        }
        // For PUT AND POST check the content
        if (['PUT', 'POST'].includes(request.method)) {
            if (request.path.startsWith('elements') && request.body.representations) {
                // Make sure representations in the outgoing requests have no placeholder ID values
                // Note: this only handles top-level representations. Child representations will be dealt with in this ticket: https://jira.corp.adobe.com/browse/CCXC-18482
                removeRepresentationPlaceholderIds(request.body.representations);
            }
            if (request.path.startsWith('elements') && request.body.groups) {
                for (const group of request.body.groups) {
                    if (!isPlaceholder(group.id)) {
                        continue;
                    }
                    if (!tokenMap[group.id]) {
                        throw new Error(`Unmapped placeholder ID: ${group.id}`);
                    }
                    group.id = tokenMap[group.id];
                }
            }
            if (request.path.startsWith('groups') && request.body.parent_id && isPlaceholder(request.body.parent_id)) {
                if (!tokenMap[request.body.parent_id]) {
                    throw new Error(`Unmapped placeholder ID: ${request.body.parent_id}`);
                }
                request.body.parent_id = tokenMap[request.body.parent_id];
            }
        }
    }
    return requests;
}
/**
 * Return an object equivalent to the given one but with any undefined values removed.
 * Exceptions can be made for certain keys, passed as second argument
 */
function omitUndefined(object, keys) {
    const result = {};
    for (const [key, val] of Object.entries(object)) {
        if (val !== undefined || (keys === null || keys === void 0 ? void 0 : keys.includes(key))) {
            result[key] = val;
        }
    }
    return result;
}
/**
 * Removes any placeholder IDs from top-level representations
 * This utility method is used to make sure that all outgoing requests have no placeholder IDs in them
 * Note: This needs to be modified to account for nested child representations (see https://jira.corp.adobe.com/browse/CCXC-18482)
 *
 * @param {RepresentationData[]} representations An array of representations associated with an outgoing element request
 * @returns {RepresentationData[]}
 */
function removeRepresentationPlaceholderIds(representations) {
    for (const representation of representations) {
        if (isPlaceholder(representation.id)) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            representation.id = undefined;
        }
    }
    return representations;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const supportedActionNames$1 = [
    'updateLibrary',
    'createElement',
    'updateElement',
    'removeElement',
    'restoreElement',
    'deleteElement',
    'createGroup',
    'removeGroup'
];
function isSupportedAction$1(action) {
    return supportedActionNames$1.includes(action.name);
}
function replaceData$1(action, data) {
    return Object.assign(Object.assign({}, action), { data, originalAction: action });
}
const RESPONSE_MAPPERS$1 = {
    updateLibrary: (action, data) => {
        // Melville does not return ACLs on patch response, so omit any data that is undefined/missing from response
        const responseData = omitUndefined(mapResponseToLibraryData$1(data, false, false), [
            'documentId',
            'documentType',
            'roles'
        ]);
        return replaceData$1(action, responseData);
    },
    createElement: (action, data) => replaceData$1(action, mapResponseToElementData$1(data.elements[0])),
    updateElement: (action, data) => replaceData$1(action, mapResponseToElementData$1(data.elements[0])),
    restoreElement: action => action,
    removeElement: action => action,
    deleteElement: action => action,
    createGroup: (action, data) => replaceData$1(action, mapResponseToGroupData$1(data)),
    removeGroup: action => action
};
let BatchOperation$1 = class BatchOperation extends Operation {
    constructor() {
        super(...arguments);
        this._baseLibraryOperationPath = `/api/v1/libraries/${this._library.assetId}`;
        this._actionMappers = {
            updateLibrary: (action) => ({
                method: 'PUT',
                path: `metadata`,
                body: mapLibraryDataToRequest$1(action.data)
            }),
            createElement: (action) => ({
                method: 'POST',
                path: `elements`,
                body: mapElementDataToRequest$1(action.data, this._driver.getClientInfo())
            }),
            updateElement: (action) => ({
                method: 'PUT',
                path: `elements/metadata`,
                body: {
                    elements: [
                        mapElementDataToElementMetadata(Object.assign({ id: extractElementId$1(action.path) }, action.data))
                    ]
                }
            }),
            removeElement: (action) => ({
                method: 'DELETE',
                path: `elements/${extractElementId$1(action.path)}`
            }),
            restoreElement: (action) => ({
                method: 'POST',
                path: `archive`,
                body: {
                    elementIds: [`${action.data.id}`]
                }
            }),
            deleteElement: (action) => ({
                method: 'DELETE',
                path: `elements/${extractElementId$1(action.path)}`,
                query_params: { permanent: 'true' }
            }),
            createGroup: (action) => ({
                method: 'POST',
                path: `groups`,
                body: mapGroupDataToRequest$1(action.data, this._driver.getClientInfo())
            }),
            removeGroup: (action) => {
                var _a;
                return ({
                    method: 'DELETE',
                    path: `groups/${extractGroupId(action.path)}`,
                    query_params: ((_a = action.flags) === null || _a === void 0 ? void 0 : _a.includeElements) ? { include_contents: 'true' } : undefined
                });
            }
        };
        this._actions = [];
    }
    async execute() {
        const payload = this._actions.map(action => this._actionMappers[action.name](action));
        const tokenizedPayload = tokenizePlaceholders(payload);
        const response = await this._driver.fetch(this._baseLibraryOperationPath, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'If-Match': this._library.etag
            },
            body: JSON.stringify({
                requests: tokenizedPayload.map(r => (Object.assign(Object.assign({}, r), { path: `${this._baseLibraryOperationPath}/${r.path}` })))
            })
        });
        const { responses } = await response.json();
        // Response should be an array that's the same size as the number of actions in the batch
        if (!Array.isArray(responses) || responses.length !== this._actions.length) {
            throw new LibraryError('INVALID_RESPONSE', 'Malformed batch response.', this._library.id);
        }
        // Given the responses, map the actual response onto actions and return the new actions.
        let newActions = this._actions.map((action, index) => {
            return RESPONSE_MAPPERS$1[action.name](action, responses[index]);
        });
        // Replace any placeholders that might exist in the new actions
        newActions = replacePlaceholders(newActions);
        return { actions: newActions, etag: response.headers.get('ETag') };
    }
    supportsAction(action) {
        return isSupportedAction$1(action);
    }
};
__decorate([
    validatesOperation,
    trace
], BatchOperation$1.prototype, "execute", null);
BatchOperation$1 = __decorate([
    traceableAs('BatchOperation')
], BatchOperation$1);
var BatchOperation$2 = BatchOperation$1;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Element content is always replaced entirely, so if we're doing a bunch of representation changes, it makes
 * sense to batch them together.
 *
 * Also, since this operation isn't supported by the batch API, we want to cut down on requests.
 */
let ContentOperation$1 = class ContentOperation extends Operation {
    supportsAction(action) {
        return action.name === 'updateElementContent';
    }
    addAction(action) {
        // Content operations must operate on the same element
        if (this._actions[0] && this._actions[0].path !== action.path) {
            return false;
        }
        return super.addAction(action);
    }
    async execute() {
        // The last content update action will always be the most up-to-date. We can omit all of the ones before it.
        const lastAction = this._actions[this._actions.length - 1];
        const response = await this._updateElementContent(extractElementId$1(lastAction.path), lastAction.data);
        const json = await response.json();
        const data = mapResponseToElementData$1(json.elements[0]);
        const actions = this._actions.map((action, index) => {
            if (index !== this._actions.length - 1) {
                return Object.assign(Object.assign({}, action), { type: 'no-op', originalAction: action });
            }
            else {
                return Object.assign(Object.assign({}, action), { data, originalAction: action });
            }
        });
        return { actions, etag: response.headers.get('ETag') };
    }
    _updateElementContent(elementId, data) {
        removeRepresentationPlaceholderIds(data.representations);
        return this._driver.fetch(`/api/v1/libraries/${this._library.assetId}/elements/${elementId}/representations`, {
            method: 'PUT',
            headers: {
                'If-Match': this._library.etag,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mapElementDataToRequest$1(data, this._driver.getClientInfo()))
        });
    }
};
__decorate([
    validatesOperation,
    trace
], ContentOperation$1.prototype, "execute", null);
ContentOperation$1 = __decorate([
    traceableAs('ContentOperation')
], ContentOperation$1);
var ContentOperation$2 = ContentOperation$1;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * ParallelOperation
 *
 * An operation that can execute several actions at the same time.
 *
 * Actions in a ParallelOperation should be able to run without affecting or
 * being affected by other actions that may run concurrently.
 */
class ParallelOperation extends Operation {
    constructor() {
        super(...arguments);
        this._actionMappers = {};
    }
    async execute() {
        const promises = this.actions.map(action => this._actionMappers[action.name](action));
        // TODO: What about allSettled?
        return { actions: await Promise.all(promises) };
    }
}
__decorate([
    validatesOperation
], ParallelOperation.prototype, "execute", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CloudParallelOperation extends ParallelOperation {
    constructor() {
        super(...arguments);
        this._actionMappers = {
            uploadComponent: async (action) => {
                const data = JSON.parse(await this._driver.stageRepresentationForCommit(action.library, action.data.file, action.data.type));
                return Object.assign(Object.assign({}, action), { data, originalAction: action });
            }
        };
    }
    supportsAction(action) {
        return action.name === 'uploadComponent';
    }
}

const isTeamsResponse$1 = (val) => {
    return val.teams !== undefined;
};
const isLibrariesResponse$1 = (val) => {
    return val.libraries !== undefined;
};

/**
 * Parses links returned from RAPI in response headers.
 *
 * @param linksList Comma-separated list of link relations.
 * @returns Record of links where the keys are the relation and the value is the link.
 *
 * @example
 * ```
 * const rapiResponse = await fetch('https://platform.adobe.io/some/path');
 * const links = parseLinks(rapiResponse.headers.get('link'));
 * const componentLink = links['http://ns.adobe.com/adobecloud/rel/component'];
 * ```
 */
function parseLinks(linksList) {
    const links = {};
    do {
        const firstLinkIndex = linksList.indexOf('<');
        if (firstLinkIndex === -1) {
            break;
        }
        let secondLinkIndex = linksList.indexOf('<', firstLinkIndex + 1);
        if (secondLinkIndex === -1) {
            secondLinkIndex = linksList.length;
        }
        const linkString = linksList.substring(firstLinkIndex, secondLinkIndex);
        const link = parseLink(linkString);
        if (link) {
            links[link.rel] = link;
        }
        linksList = linksList.substring(secondLinkIndex);
    } while (linksList.length > 0);
    return links;
}
function parseLink(linkString) {
    // A link string will be in the format:
    // <https://subdomain.adobe.io/path>; rel="http://ns.adobe.com/adobecloud/rel/relation"; key="value"
    // Get the href from the link string (the part surrounded with angle brackets).
    const hrefMatch = linkString.match(/^<(.*)>;/);
    if (!hrefMatch) {
        return undefined;
    }
    const link = { href: hrefMatch[1] };
    // Get each key-value pair from the link string.
    const matches = linkString.matchAll(/\s([\w:]*)="([^"]*)"[;,]?/g);
    for (const match of matches) {
        const key = match[1];
        const value = match[2];
        link[key] = convertToPrimitiveType(value);
    }
    return link;
}
function convertToPrimitiveType(str) {
    if (str === 'true' || str === 'false') {
        return str === 'true';
    }
    const strAsNumber = +str;
    const isNumber = !isNaN(strAsNumber);
    if (isNumber) {
        return strAsNumber;
    }
    return str;
}

var queryString = {};

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

var decodeUriComponent = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

var splitOnFirst = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};

var filterObj = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};

(function (exports) {
const strictUriEncode$1 = strictUriEncode;
const decodeComponent = decodeUriComponent;
const splitOnFirst$1 = splitOnFirst;
const filterObject = filterObj;

const isNullOrUndefined = value => value === null || value === undefined;

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode$1(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst$1(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst$1(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${encode(object.fragmentIdentifier, options)}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};
}(queryString));

var md5$1 = {exports: {}};

var crypt = {exports: {}};

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt$1 = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt$1.rotl(n, 8) & 0x00FF00FF | crypt$1.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt$1.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  crypt.exports = crypt$1;
})();

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

var charenc_1 = charenc;

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
var isBuffer_1 = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
};

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

(function(){
  var crypt$1 = crypt.exports,
      utf8 = charenc_1.utf8,
      isBuffer = isBuffer_1,
      bin = charenc_1.bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt$1.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt$1.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  md5$1.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt$1.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt$1.bytesToHex(digestbytes);
  };

})();

var md5 = md5$1.exports;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const defaultElementSort$2 = {
    field: 'modifiedDate',
    direction: 'descending'
};
const sortFieldMap$1 = {
    modifiedDate: 'modified_date',
    name: 'name'
};
// TODO: Remove with Durable Links and Invitation Service V4 work.
// This class intentionally left not DRY for ease of removal.
class LegacyPublicLibraryExtension {
    constructor(_driver) {
        this._driver = _driver;
    }
    routePublicLibraryRequestIfNeeded(library, publicFn, baseFn, ...args) {
        // TODO: [SHARED-5316] Expose publicLinkId at the libary level, in the meantime the following block needs to be commented out.
        // if (library.ownership === 'public' && library.data.publicLinkId) {
        //     return publicFn(library.data.publicLinkId as string, this.getLibraryParams(library), ...args);
        // }
        return baseFn(library.id, ...args);
    }
    getLibraryParams(library) {
        return {
            modifiedDate: library.modified,
            areElementsLoaded: library.areElementsLoaded,
            elements: library.data.elements
        };
    }
    getLibraryByPublicLinkId(publicLinkId, libraryParams, options = {}) {
        var _a, _b;
        return __asyncGenerator(this, arguments, function* getLibraryByPublicLinkId_1() {
            try {
                const libraryData = yield __await(this._getLibrary(publicLinkId));
                // ETags are not returning so we are constantly overriding
                // the elements array with an empty set.
                if (libraryParams === null || libraryParams === void 0 ? void 0 : libraryParams.areElementsLoaded) {
                    libraryData.elements = libraryParams.elements;
                }
                yield yield __await(libraryData);
                // If areElementsLoaded AND incoming modified data is the same, skip loading elements
                if ((libraryParams === null || libraryParams === void 0 ? void 0 : libraryParams.areElementsLoaded) && libraryParams.modifiedDate === libraryData.modifiedDate) {
                    return yield __await(void 0);
                }
                yield __await(yield* __asyncDelegator(__asyncValues(this._getAllElements(publicLinkId, Object.assign({}, options.elementParams)))));
            }
            catch (error) {
                // If it's an abort, eat it. Otherwise, throw it.
                if (!((_b = (_a = options.elementParams) === null || _a === void 0 ? void 0 : _a.abortController) === null || _b === void 0 ? void 0 : _b.signal.aborted)) {
                    throw error;
                }
            }
        });
    }
    getElementsByPublicLinkId(publicLinkId, libraryParams, sort = defaultElementSort$2, limit = 100, signal) {
        return __asyncGenerator(this, arguments, function* getElementsByPublicLinkId_1() {
            const responseMapper = (res) => res.elements.map(mapResponseToElementData$1);
            const orderBy = `${sort.direction === 'descending' ? '-' : ''}${sortFieldMap$1[sort.field]}`;
            const queryParams = {
                limit,
                orderBy,
                selector: ['default', 'representations', 'details']
            };
            yield __await(yield* __asyncDelegator(__asyncValues(this.fetchAllPages(`/api/v1/public/libraries/${publicLinkId}/elements?${queryString.stringify(queryParams, { arrayFormat: 'comma' })}`, responseMapper, signal))));
        });
    }
    getRemovedElementsByPublicLinkId(publicLinkId, libraryParams, _sort = defaultElementSort$2, _limit = 100, _signal) {
        return __asyncGenerator(this, arguments, function* getRemovedElementsByPublicLinkId_1() {
            // Data not available in Melville
            return yield __await(void 0);
        });
    }
    getDocumentationElementsByPublicLinkId(publicLinkId, libraryParams, _sort = defaultElementSort$2, _limit = 100, _signal) {
        return __asyncGenerator(this, arguments, function* getDocumentationElementsByPublicLinkId_1() {
            // Data not available in Melville
            return yield __await(void 0);
        });
    }
    getElement(publicLinkId, libraryParams, elementId) {
        return this.fetch(`/api/v1/public/libraries/${publicLinkId}/elements/${elementId}?selector=default,representations,details,tags`)
            .then(res => res.json())
            .then((res) => mapResponseToElementData$1(res));
    }
    _getLibrary(publicLinkId) {
        return this.fetch(`/api/v1/public/libraries/${publicLinkId}?selector=default,rendition_grid,details`)
            .then(res => res.json())
            .then((res) => mapResponseToLibraryData$1(res, true));
    }
    _getAllElements(publicLinkId, options) {
        var _a, _b, _c;
        return __asyncGenerator(this, arguments, function* _getAllElements_1() {
            var _d, e_1, _e, _f;
            const elementTypes = [
                ['elements', 'getElementsByPublicLinkId'],
                ['documentationElements', 'getDocumentationElementsByPublicLinkId'],
                ['removedElements', 'getRemovedElementsByPublicLinkId']
            ];
            // If the elements aren't loaded yet, update the library page by page
            // Otherwise, load them all at once.
            const updateData = {};
            // TODO: We want to run all element type iterators at the same time. Right now it doesn't matter since we only deal with normal elements.
            for (const [type, generator] of elementTypes) {
                if ((_a = options === null || options === void 0 ? void 0 : options.types) === null || _a === void 0 ? void 0 : _a.includes(type)) {
                    try {
                        for (var _g = true, _h = (e_1 = void 0, __asyncValues(this[generator](publicLinkId, undefined, options === null || options === void 0 ? void 0 : options.sort, undefined, (_b = options === null || options === void 0 ? void 0 : options.abortController) === null || _b === void 0 ? void 0 : _b.signal))), _j; _j = yield __await(_h.next()), _d = _j.done, !_d;) {
                            _f = _j.value;
                            _g = false;
                            try {
                                const page = _f;
                                updateData[type] = updateData[type] || [];
                                (_c = updateData[type]) === null || _c === void 0 ? void 0 : _c.push(...page);
                                if (options === null || options === void 0 ? void 0 : options.loadProgressively) {
                                    yield yield __await({ [type]: updateData[type] });
                                }
                            }
                            finally {
                                _g = true;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (!_g && !_d && (_e = _h.return)) yield __await(_e.call(_h));
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
            yield yield __await(Object.assign({ areElementsLoaded: true }, (options.loadProgressively ? {} : updateData)));
        });
    }
    fetchAllPages(firstUrl, responseMapper, signal) {
        var _a, _b;
        return __asyncGenerator(this, arguments, function* fetchAllPages_1() {
            let totalCount;
            let nextUrl = firstUrl;
            while (nextUrl) {
                const response = yield __await(this.fetch(nextUrl, { signal }).then(res => res.json()));
                yield yield __await(responseMapper(response));
                totalCount !== null && totalCount !== void 0 ? totalCount : (totalCount = response.total_count);
                const pageTemplateString = (_b = (_a = response._links) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.href;
                const pageData = response._page;
                const pageTemplate = pageTemplateString && uriTemplates(pageTemplateString);
                const nextStart = parseInt(pageData.start) + pageData.count;
                if (!pageTemplate || !pageData || nextStart > totalCount) {
                    return yield __await(void 0);
                }
                nextUrl = pageTemplate.fill({
                    orderBy: pageData.orderBy,
                    start: `${nextStart}`,
                    limit: `${pageData.count}`,
                    selector: 'default,representations,details'
                });
            }
        });
    }
    fetch(path, init) {
        var _a, _b;
        // Melville requires a gateway set header for full information to be provided for public libraries
        if ((_a = this._driver.config.user) === null || _a === void 0 ? void 0 : _a.id) {
            init = init || {};
            init.headers = init.headers || {};
            init.headers['x-gw-ims-user-id'] = (_b = this._driver.config.user) === null || _b === void 0 ? void 0 : _b.id;
        }
        return this._driver.fetch(path, init);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class AssetNotificationManager extends RestrictedEventEmitter {
    constructor(_driver) {
        super();
        this._driver = _driver;
        this._onChangeCallback = (event, sender, payload) => {
            var _a;
            const assetIds = payload;
            (_a = this._changeCallback) === null || _a === void 0 ? void 0 : _a.call(this, assetIds);
        };
    }
    connect() {
        var _a, _b;
        this._librariesToMonitor = (_a = this._driver._core) === null || _a === void 0 ? void 0 : _a.assetLinkManager.createList();
        (_b = this._librariesToMonitor) === null || _b === void 0 ? void 0 : _b.on('notified', this._onChangeCallback);
    }
    disconnect() {
        var _a, _b;
        this._changeCallback = undefined;
        (_a = this._librariesToMonitor) === null || _a === void 0 ? void 0 : _a.clear();
        (_b = this._librariesToMonitor) === null || _b === void 0 ? void 0 : _b.off('notified', this._onChangeCallback);
        this._librariesToMonitor = undefined;
    }
    get isConnected() {
        return !!this._librariesToMonitor;
    }
    async setWatchedLibraries(libraries, callback) {
        // No-op if we haven't been initialized.
        if (!this._librariesToMonitor) {
            return;
        }
        const librariesToMonitor = this._librariesToMonitor;
        const assetIds = new Set(libraries.map(library => library.assetId));
        // Remove any links no longer being watched
        librariesToMonitor.monitoredAssetIDs.forEach(id => !assetIds.has(id) && librariesToMonitor.removeAssetID(id));
        // Make sure we're watching all the assets we need to watch (this is a no-op if already being monitored)
        assetIds.forEach(id => id && librariesToMonitor.addAssetID(id));
        this._changeCallback = callback;
    }
    async addWatchedLibrary(library) {
        var _a;
        library.assetId && ((_a = this._librariesToMonitor) === null || _a === void 0 ? void 0 : _a.addAssetID(library.assetId));
    }
    removeWatchedLibrary(library) {
        var _a;
        library.assetId && ((_a = this._librariesToMonitor) === null || _a === void 0 ? void 0 : _a.removeAssetID(library.assetId));
    }
    // Shallow watch of libraries sync group so we can tell when libraries are added/deleted/renamed/moved
    // Note: Shallow watch is not working, it's actually a deep watch until eTag propogation is turned off.
    async addLibrariesSyncGroupListener(cb) {
        var _a;
        // ensure listener is only added once
        if (this._syncGroupListener || !cb) {
            return;
        }
        this._syncGroupListener = { notify: cb };
        // SAM keeps weak references to AdobeAssets/Lists, so clients must keep a strong reference to stop SAM from garbage collecting them.
        // Otherwise SAM would hear the ONS event but the AdobeAsset notification would not occur. (See SAM-2711)
        let syncGroupDirectory = undefined;
        try {
            syncGroupDirectory = await ((_a = this._driver._core) === null || _a === void 0 ? void 0 : _a.hostAssetContext.getAssetWithRepoPath(syncGroupPath));
        }
        catch (error) {
            if (error.code === 21) {
                // If the sync group directory (assets/adobe-libraries) does not exist, we can't listen for changes.
                // This is expected if the user has not yet created a library.
                return;
            }
            throw error;
        }
        if (!syncGroupDirectory) {
            delete this._syncGroupListener;
            return;
        }
        this._syncGroupListener.asset = syncGroupDirectory;
        syncGroupDirectory.on('change', cb);
    }
    removeLibrariesSyncGroupListener() {
        if (this._syncGroupListener) {
            const { asset, notify } = this._syncGroupListener;
            asset === null || asset === void 0 ? void 0 : asset.off('change', notify);
            delete this._syncGroupListener;
        }
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function _fetchNext(generator, index) {
    return generator.next().then(result => ({ result, index }));
}
/**
 * Utility to allow combining async generators in a way that runs their tasks in parallel
 *
 * @export
 * @template T
 * @param {...Array<AsyncGenerator<T>>} generators generators to combine
 * @returns {AsyncGenerator<T>} A combined generator that runs individual generators in parallel
 */
function combineGenerators(...generators) {
    return __asyncGenerator(this, arguments, function* combineGenerators_1() {
        const results = generators.map(_fetchNext);
        let finalized = results.length;
        while (finalized) {
            const yielded = yield __await(Promise.race(results));
            if (!yielded.result.done) {
                yield yield __await(yielded.result.value);
                results[yielded.index] = _fetchNext(generators[yielded.index], yielded.index);
            }
            else {
                results[yielded.index] = new Promise(() => {
                    /* NOOP */
                });
                finalized--;
            }
        }
    });
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Fallback implementation of localStorage in case we're not running in a standard browser environment (e.g. node.js)
class InMemoryStorage {
    constructor() {
        this._data = new Map();
    }
    get length() {
        return this._data.size;
    }
    key(index) {
        return Array.from(this._data.keys())[index];
    }
    getItem(key) {
        return this._data.get(key);
    }
    setItem(key, value) {
        this._data.set(key, value);
    }
    removeItem(key) {
        this._data.delete(key);
    }
    clear() {
        this._data.clear();
    }
}
/**
 * Local/Session Storage interface.
 * Allows getting and setting persistent settings that are local to the
 * current user session of the Libraries JS API.
 * Local Storage: Stores data to disk which is available across tabs/windows to the same user in the same browser.
 * Session Storage: Stores data to memory which is available only to the current tab.
 */
class StorageInterface {
    constructor(storageKey, storage) {
        this._settings = new Map();
        this._storageKey = storageKey;
        this._storage = storage !== null && storage !== void 0 ? storage : (typeof window !== 'undefined' ? window.localStorage : new InMemoryStorage());
        // Restore any previous settings saved to this storage key.
        this._load();
    }
    // Expose the storage values
    entries() {
        return this._settings.entries();
    }
    setItem(key, value) {
        this._settings.set(key, value);
        // Write the current settings to storage.
        this._save();
    }
    getItem(key) {
        return this._settings.get(key);
    }
    _setItem(key, value) {
        this._storage.setItem(key, value);
    }
    _load() {
        const settingsStr = this._storage.getItem(this._storageKey);
        if (settingsStr) {
            try {
                this._settings = new Map(JSON.parse(settingsStr));
            }
            catch (e) {
                Logger$1.error('Error restoring previous settings.');
                // Remove the invalid settings.
                this._storage.removeItem(this._storageKey);
            }
        }
    }
    _save() {
        const settingsStr = JSON.stringify(Array.from(this._settings.entries()));
        this._setItem(this._storageKey, settingsStr);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function mapProjectToTeamData(project) {
    var _a;
    return {
        name: project.name,
        id: project.id,
        owner: project.storageAssignee,
        // This should always be defined now, but SAM.js typed it as optional for backward compatibility.
        ownerName: (_a = project.storageAssignee.displayName) !== null && _a !== void 0 ? _a : '',
        // All project users can edit the project.
        isWritable: true
    };
}
function mapGradientToGradientData(gradientData) {
    return {
        type: gradientData.type,
        angle: gradientData.angle,
        stops: gradientData.stops
    };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const defaultElementSort$1 = {
    field: 'modifiedDate',
    direction: 'descending'
};
const sortFieldMap = {
    modifiedDate: 'modified_date',
    name: 'name'
};
let CloudDriver = class CloudDriver extends Driver {
    constructor() {
        super(...arguments);
        this._fetch = fetch;
        this._notificationManager = new AssetNotificationManager(this);
        this._operationTypes = [
            CloudMoveCopyElementOperation,
            SingleOperation,
            BatchOperation$2,
            ContentOperation$2,
            CloudParallelOperation
        ];
        this._publicExt = new LegacyPublicLibraryExtension(this);
    }
    // TODO-R[SHARED-5281]: will be removed
    getLibrary(library, options) {
        return this._publicExt.routePublicLibraryRequestIfNeeded(library, this._publicExt.getLibraryByPublicLinkId.bind(this._publicExt), this.getLibraryByAssetId.bind(this), options);
    }
    // TODO-R[SHARED-5281]: will be removed
    getElements(library, ...args) {
        return this._publicExt.routePublicLibraryRequestIfNeeded(library, this._publicExt.getElementsByPublicLinkId.bind(this._publicExt), this._getElementsByAssetId.bind(this), ...args);
    }
    // TODO-R[SHARED-5281]: will be removed
    getRemovedElements(library, ...args) {
        return this._publicExt.routePublicLibraryRequestIfNeeded(library, this._publicExt.getRemovedElementsByPublicLinkId.bind(this._publicExt), this._getRemovedElementsByAssetId.bind(this), ...args);
    }
    // TODO-R[SHARED-5281]: will be removed
    getDocumentationElements(library, ...args) {
        return this._publicExt.routePublicLibraryRequestIfNeeded(library, this._publicExt.getDocumentationElementsByPublicLinkId.bind(this._publicExt), this._getDocumentationElementsByAssetId.bind(this), ...args);
    }
    getElement(library, elementId) {
        return this._publicExt.routePublicLibraryRequestIfNeeded(library, this._publicExt.getElement.bind(this._publicExt), this._getElement.bind(this), elementId);
    }
    async _handleConnected(data) {
        var _a, _b, _c, _d, _e, _f;
        const userData = extractUserDataFromToken(data.token);
        this._localStorage = new StorageInterface(getScopedStorageKey(userData === null || userData === void 0 ? void 0 : userData.user, 'cloud'), data.localStorage);
        this._env = data.env;
        this._token = data.token;
        this._refreshAccessToken = data.refreshAccessToken;
        this._clientId = (_a = userData === null || userData === void 0 ? void 0 : userData.user) === null || _a === void 0 ? void 0 : _a.clientId;
        this._analyticsEnabled = ((_c = (_b = data.config) === null || _b === void 0 ? void 0 : _b.processInfo) === null || _c === void 0 ? void 0 : _c.analyticsEnabled) || false;
        this._ignoreRenditionGrids = ((_d = data.config) === null || _d === void 0 ? void 0 : _d.ignoreRenditionGrids) || false;
        this._codeVersion = (_f = (_e = data.config) === null || _e === void 0 ? void 0 : _e.processInfo) === null || _f === void 0 ? void 0 : _f.codeVersion;
        this._fetch = data.fetch || fetch.bind(globalThis);
        this._notificationManager.connect();
        // This is synchronous, but we want the signature to be the same as the LocalDriver, which is not.
        await this.getConfiguration();
    }
    _handleDisconnected() {
        var _a;
        (_a = this._notificationManager) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    async getConfiguration() {
        const configurationData = this.getLocalSettings();
        const userData = extractUserDataFromToken(this._token);
        this._config = new Configuration(Object.assign(Object.assign(Object.assign({}, configurationData), userData), { environment: this._env, processInfo: {
                analyticsEnabled: this._analyticsEnabled,
                codeVersion: this._codeVersion,
                syncingEnabled: true
            }, ignoreRenditionGrids: this._ignoreRenditionGrids }));
        return this.config;
    }
    get driverConfig() {
        return configData[this._env];
    }
    updateOptions(options) {
        this._options = options;
    }
    fetchAccessToken(_userId, _clientId, _clientSecret, _scopes) {
        // NOTE: This will always return the access token for the host, which means we need to make sure
        // all of the client IDs used in the panel match the host's client ID
        return Promise.resolve({
            access_token: this._token,
            expires_in: extractExpiryFromToken(this._token)
        });
    }
    /* Library operations */
    // Note that fetching by library id is not recommended, as melville has to make an additional request to find the assetId.
    // Using the id also only works on private libraries. So use the assetId whenever possible.
    async getLibraryById(id) {
        if (!id) {
            return;
        }
        const { value } = await this.getLibraryByAssetId(id).next();
        return value;
    }
    getLibraryByAssetId(assetId, options = {}) {
        var _a, _b;
        return __asyncGenerator(this, arguments, function* getLibraryByAssetId_1() {
            // If we are a new library, attempting to load our contents will just throw errors. Wait till we have a valid ID/assetId
            // before refreshing ourselves
            if (!assetId) {
                return yield __await({});
            }
            let etag = options.etag;
            const selector = ['default'];
            if (options.getRenditionGrid) {
                selector.push('rendition_grid');
            }
            if (options.getAppMetadata) {
                selector.push('app_metadata');
            }
            // Case 1: Not requesting elements. Load library via Melville.
            if (!options.elementParams) {
                try {
                    yield yield __await(this._getLibrary(assetId, etag, selector));
                }
                catch (error) {
                    if (!(error instanceof RequestError && error.requestErrorCode === 'NOT_MODIFIED')) {
                        throw error;
                    }
                }
                return yield __await(void 0);
            }
            // Case 2: Want to load elements for the first time. Use Melville AND manifest. If manifest finishes first,
            // cancel Melville requests.
            const manifestPromise = this._getManifest(assetId, options);
            manifestPromise.then(() => {
                var _a;
                const controller = (_a = options.elementParams) === null || _a === void 0 ? void 0 : _a.abortController;
                if (controller) {
                    controller.abort();
                    abortSignalReasons.give(controller, REQUEST_NOT_NEEDED);
                }
            });
            if ((_a = options.elementParams) === null || _a === void 0 ? void 0 : _a.loadProgressively) {
                try {
                    try {
                        const libraryResponse = yield __await(this._getLibrary(assetId, etag, selector));
                        etag = libraryResponse.etag;
                        yield yield __await(libraryResponse);
                    }
                    catch (error) {
                        if (!(error instanceof RequestError && error.requestErrorCode === 'NOT_MODIFIED' && options.elementParams)) {
                            throw error;
                        }
                    }
                    yield __await(yield* __asyncDelegator(__asyncValues(this._getAllElements(assetId, Object.assign(Object.assign({}, options.elementParams), { etag })))));
                }
                catch (error) {
                    // If it's an abort, eat it. Otherwise, throw it.
                    // Also swallow the 404. If melville 404s, R-API may still succeed. If R-API fails, it will then throw.
                    if (!((_b = options.elementParams.abortController) === null || _b === void 0 ? void 0 : _b.signal.aborted)
                        && !(error instanceof RequestError && error.requestErrorCode === 'NOT_FOUND')) {
                        throw error;
                    }
                }
            }
            // Case 3: Elements are loaded. Use only manifest to update (do not call Melville)
            yield yield __await(manifestPromise);
        });
    }
    _getLibrary(assetId, etag, selector = ['default']) {
        const headers = {};
        // If there is no etag, we need to manually override if-none-match so it does not use the etag
        headers['if-none-match'] = etag || '*';
        const searchParams = new URLSearchParams({ selector });
        if (selector.includes('app_metadata')) {
            // TODO: Remove this once Melville allows Cache-Control in their CORS settings
            // When fetching app_metadata, set a random query param to bypass the browser cache
            searchParams.set('randomizer', uuid_1.v4());
        }
        const url = `/api/v1/libraries/${assetId}?${searchParams.toString()}`;
        return this.fetch(url, { headers })
            .then(res => res.json())
            .then((res) => mapResponseToLibraryData$1(res, this._options.readOnly, selector === null || selector === void 0 ? void 0 : selector.includes('rendition_grid')));
    }
    /**
     * Loads the manifest for the given library, if necessary.
     * @param assetId The cloud ID of the asset.
     * @returns The LibraryData derived from the loaded manifest.
     */
    async _getManifest(assetId, options) {
        var _a;
        let asset;
        try {
            asset = await ((_a = this._core) === null || _a === void 0 ? void 0 : _a.hostAssetContext.getAssetWithCloudID(assetId));
        }
        catch (error) {
            throw getSAMRequestError(error);
        }
        if (!asset || (asset === null || asset === void 0 ? void 0 : asset.isDiscarded)) {
            // Though it's possible to read a manifest on an discarded Asset,
            // we want to throw a 404 to let library.load() know to remove the model from the cache
            throw getRequestErrorFromStatus(404);
        }
        try {
            const resources = [asset.manifest];
            if (options.getAppMetadata) {
                resources.push(asset.appMetadata);
            }
            // Load all resources in parallel.
            await Promise.all(resources.map(resource => !resource.isLoaded && resource.load()));
            const libraryData = mapManifestToLibraryData(asset);
            // Since we're using asset events from ONS directly to refresh the library, we need to unload the manifest after fetching it.
            // Otherwise, when we get a notification, we'll use the stale data of the previous manifest before SAM has refreshed it.
            // (Previously we could just keep the manifest loaded since we were listening to change events on the SAM model, but that's
            // more expensive since it requires resolving every library to an AdobeAsset in order to get notifications).
            asset.manifest.unload();
            return libraryData;
        }
        catch (error) {
            throw getSAMRequestError(error);
        }
    }
    /**
     * Fetch libraries and optionally rendition grids
     */
    getLibraries(signal, getRenditionGrids = true) {
        return __asyncGenerator(this, arguments, function* getLibraries_1() {
            if (this._options.enableBrandLifecycleManagement) {
                // Fetch project data
                const project = yield __await(this.getProjectByName(GenStudioProjectName));
                if (!project) {
                    Logger$1.error('[CLOUD DRIVER] M3 - Adobe GenStudio Brands project not found.');
                    // Mo without access to the project.
                    // Sally account without project created yet.
                    const publishedFilters = {
                        itemFilter: ['publishedBrands'],
                        roles: ['brand']
                    };
                    yield __await(yield* __asyncDelegator(__asyncValues(this.getLibrariesList(signal, publishedFilters))));
                    return yield __await(void 0);
                }
                else {
                    Logger$1.info('[CLOUD DRIVER] M3 - Loading brands inside project.');
                    const projectFilter = {
                        team: [project.id],
                        roles: ['brand']
                    };
                    yield __await(yield* __asyncDelegator(__asyncValues(this.getLibrariesList(signal, projectFilter))));
                    return yield __await(void 0);
                }
            }
            else {
                Logger$1.info('[CLOUD DRIVER] M2 - Loading all libraries.');
                const personalFilters = {
                    owner: ['private', 'incoming'],
                    // rendition_grid response contains all the same 'default' properties for each library, plus "rendition_grid" and `"renditionGridMissing": false`
                    selector: getRenditionGrids ? ['rendition_grid'] : ['default']
                };
                const publicFilters = {
                    owner: ['public'],
                    selector: getRenditionGrids ? ['rendition_grid', 'details'] : ['default', 'details']
                };
                // To avoid waiting for one generator to finish before the other begins (i.e. private before public libraries),
                // we combine them so they run in parallel, and yield each page as soon as it's available.
                const pageGenerators = [
                    this.getLibrariesList(signal, personalFilters),
                    this.getLibrariesList(signal, publicFilters)
                ];
                if (this._options.includeApprovedBrandsInLibraries) {
                    Logger$1.info('[CLOUD DRIVER] M2 - Loading approved brands.');
                    pageGenerators.push(this.getApprovedBrandLibraries(signal));
                }
                yield __await(yield* __asyncDelegator(__asyncValues(combineGenerators(...pageGenerators))));
            }
        });
    }
    getApprovedBrandLibraries(signal) {
        return __asyncGenerator(this, arguments, function* getApprovedBrandLibraries_1() {
            yield __await(yield* __asyncDelegator(__asyncValues(this.fetchAllApprovedBrandPages('/api/v1/search', this._getLibrariesResponseMapper(), signal))));
        });
    }
    fetchAllApprovedBrandPages(firstUrl, responseMapper, signal) {
        var _a, _b;
        return __asyncGenerator(this, arguments, function* fetchAllApprovedBrandPages_1() {
            let nextUrl = firstUrl;
            while (nextUrl) {
                const response = yield __await(this.fetch(nextUrl, {
                    signal,
                    method: 'POST',
                    body: JSON.stringify({
                        library_roles_type: ['approvedbrand']
                    }),
                    headers: {
                        owner: 'all',
                        'content-type': 'application/json'
                    }
                }).then(res => res.json()));
                yield yield __await(responseMapper(response));
                nextUrl = (_b = (_a = response._links) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.href;
            }
        });
    }
    getLibrariesList(signal, filters) {
        return __asyncGenerator(this, arguments, function* getLibrariesList_1() {
            yield __await(yield* __asyncDelegator(__asyncValues(this.fetchAllPages(this._getLibrariesURL(filters), {}, this._getLibrariesResponseMapper(filters), signal))));
        });
    }
    getLibrariesPage(signal, filters) {
        return __asyncGenerator(this, arguments, function* getLibrariesPage_1() {
            // For the single-page case, we should send query params in the URL rather than headers
            // to avoid the browser seeing the requests as the same resource
            yield __await(yield* __asyncDelegator(__asyncValues(this.fetchOnePage(this._getLibrariesURL(filters), this._getLibrariesResponseMapper(filters), signal, false))));
        });
    }
    async getPresignedDownloadUrl(blockDownloadUrl) {
        const response = await this.fetch(blockDownloadUrl);
        const responseJson = await response.json();
        const presignedUrlData = mapResponseToBlockDownloadData(responseJson);
        return presignedUrlData;
    }
    async loadVersionHistory(assetId) {
        const asset = await this._core.hostAssetContext.getAssetWithCloudID(assetId);
        let versionList;
        await new Promise((resolve, reject) => {
            versionList = asset.versions.getList(AssetVersionOrder.default, undefined, { loadAllPages: true });
            function listStateChange() {
                if ((versionList === null || versionList === void 0 ? void 0 : versionList.status) !== AssetListStatus.Loading) {
                    versionList === null || versionList === void 0 ? void 0 : versionList.off(STATE_CHANGED, listStateChange);
                    if (versionList === null || versionList === void 0 ? void 0 : versionList.errors) {
                        reject();
                    }
                    resolve();
                }
            }
            versionList.on(STATE_CHANGED, listStateChange);
        });
        return versionList === null || versionList === void 0 ? void 0 : versionList.items.map((child) => mapResponseToVersionData(assetId, child));
    }
    async loadVersion(libraryAssetId, manifestUrl) {
        const hostContext = this._core.hostAssetContext;
        const asset = await hostContext.getAssetWithCloudID(libraryAssetId);
        // This is unfortunate, since the manifest rel doesn't include a version parameter.
        // The component rel does, but that won't be future-proof, so we're left with just passing in the URL
        // we got from loadVersions
        const response = await this.fetch(manifestUrl);
        const data = await response.json();
        return mapManifestToLibraryData(asset, data);
    }
    async getCollaborators(assetId) {
        const collaboratorSource = this._core.collaborationContext.getCollaborators(assetId);
        let collaboratorList;
        await new Promise((resolve, reject) => {
            collaboratorList = collaboratorSource === null || collaboratorSource === void 0 ? void 0 : collaboratorSource.getList(CollaboratorOrder.default, undefined, {
                loadAllPages: true
            });
            function listStateChange() {
                if ((collaboratorList === null || collaboratorList === void 0 ? void 0 : collaboratorList.status) !== AssetListStatus.Loading) {
                    collaboratorList === null || collaboratorList === void 0 ? void 0 : collaboratorList.off(STATE_CHANGED, listStateChange);
                    if (collaboratorList === null || collaboratorList === void 0 ? void 0 : collaboratorList.errors) {
                        reject();
                    }
                    else {
                        resolve();
                    }
                }
            }
            collaboratorList === null || collaboratorList === void 0 ? void 0 : collaboratorList.on(STATE_CHANGED, listStateChange);
        });
        return collaboratorList === null || collaboratorList === void 0 ? void 0 : collaboratorList.items.map(collaborator => mapResponseToCollaboratorData(assetId, collaborator));
    }
    followLibrary(assetId, libraryId) {
        return this.fetch('/api/v1/libraries/bookmarks', {
            method: 'POST',
            body: JSON.stringify({
                bookmarks: [
                    {
                        type: 'collab',
                        id: libraryId,
                        urn: assetId
                    }
                ]
            }),
            headers: {
                'content-type': 'application/json'
            }
        }).then(( /** bookmark */) => {
            // The bookmark data is basically a copy of the request body.
            // It doesn't have anything useful to the caller, so we won't send it back.
            return;
        });
    }
    moveLibrary(assetId, folderId, organizationId) {
        return new Promise((resolve, reject) => {
            const queryParams = {
                invocation_mode: 'async'
            };
            const headers = { 'content-type': 'application/json' };
            if (organizationId) {
                headers['x-organization-id'] = organizationId;
            }
            const request = this.fetch(`/api/v1/libraries?${queryString.stringify(queryParams)}`, {
                method: 'POST',
                body: JSON.stringify({
                    self: assetId,
                    repository: folderId
                }),
                headers
            });
            const asyncResponse = new AsyncResponse(this, request);
            asyncResponse.on('change', (isDone, libraryResponse) => {
                if (isDone) {
                    if (asyncResponse.error) {
                        reject(asyncResponse.error);
                    }
                    else {
                        resolve(omitUndefined(mapResponseToLibraryData$1(libraryResponse)));
                    }
                }
            });
        });
    }
    importLibrary(_file) {
        throw new Error('Not implemented');
    }
    exportLibrary(_library, _path) {
        throw new Error('Not implemented');
    }
    publishBrand(brand) {
        if (!brand.assetId) {
            throw new LibraryError('INVALID_PARAMETER', 'Brand asset id must be defined for publishing. Please wait before trying again.');
        }
        return this.fetch(`/api/v1/brands/${brand.assetId}/publish`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            }
        });
    }
    unpublishBrand(brand) {
        let publishedAssetId;
        if (brand.publishedTo) {
            publishedAssetId = brand.publishedTo;
        }
        else if (brand.publishedFrom) {
            publishedAssetId = brand.assetId;
        }
        else {
            throw new LibraryError('INVALID_PARAMETER', 'Brand must be publsihed before unpublishing. Please wait before trying again.');
        }
        return this.fetch(`/api/v1/brands/${publishedAssetId}/unpublish`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            }
        });
    }
    async abortOperation(_operationId) {
        throw new Error('Not supported in cloud mode.');
    }
    setLibraryChangeListener(libraries, callback) {
        this._notificationManager.setWatchedLibraries(libraries, (assetIds) => callback(assetIds, 'assetId'));
    }
    setSyncStateListener() {
        // NO-OP
    }
    removeLibraryChangeListener() {
        this._notificationManager.disconnect();
    }
    removeSyncStateListener() {
        // NO-OP
    }
    removeFontDataChangeListeners() {
        // NO-OP
    }
    addWatchedLibrary(library) {
        this._notificationManager.addWatchedLibrary(library);
    }
    removeWatchedLibrary(library) {
        this._notificationManager.removeWatchedLibrary(library);
    }
    addLibrariesSyncGroupListener(cb) {
        this._notificationManager.addLibrariesSyncGroupListener(cb);
    }
    removeLibrariesSyncGroupListener() {
        this._notificationManager.removeLibrariesSyncGroupListener();
    }
    _getLibrariesURL(filters) {
        return `/api/v1/libraries?${new URLSearchParams(filters).toString()}`;
    }
    _getLibrariesResponseMapper(filters) {
        return (response) => {
            if (!isLibrariesResponse$1(response)) {
                return [];
            }
            return response.libraries.map(data => {
                var _a, _b;
                return mapResponseToLibraryData$1(data, this._options.readOnly, (_b = (_a = filters === null || filters === void 0 ? void 0 : filters.selector) === null || _a === void 0 ? void 0 : _a.includes('rendition_grid')) !== null && _b !== void 0 ? _b : true);
            });
        };
    }
    /* Element operations */
    _getElement(assetId, elementId) {
        return this.fetch(`/api/v1/libraries/${assetId}/elements/${elementId}?selector=default,representations,details,tags`)
            .then(res => res.json())
            .then((res) => mapResponseToElementData$1(res));
    }
    _getAllElements(assetId, options) {
        var _a, _b;
        return __asyncGenerator(this, arguments, function* _getAllElements_1() {
            var _c, e_1, _d, _e;
            const elementTypes = [
                ['elements', '_getElementsByAssetId'],
                ['documentationElements', '_getDocumentationElementsByAssetId'],
                ['removedElements', '_getRemovedElementsByAssetId']
            ];
            // If the elements aren't loaded yet, update the library page by page
            // Otherwise, load them all at once.
            const updateData = {};
            // TODO: We want to run all element type iterators at the same time. Right now it doesn't matter since we only deal with normal elements.
            for (const [type, generator] of elementTypes) {
                if (options.types.includes(type)) {
                    try {
                        for (var _f = true, _g = (e_1 = void 0, __asyncValues(this[generator](assetId, options.sort, options.etag, undefined, (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal))), _h; _h = yield __await(_g.next()), _c = _h.done, !_c;) {
                            _e = _h.value;
                            _f = false;
                            try {
                                const page = _e;
                                updateData[type] = updateData[type] || [];
                                (_b = updateData[type]) === null || _b === void 0 ? void 0 : _b.push(...page);
                                if (options.loadProgressively) {
                                    yield yield __await({ [type]: updateData[type] });
                                }
                            }
                            finally {
                                _f = true;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (!_f && !_c && (_d = _g.return)) yield __await(_d.call(_g));
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
            yield yield __await(Object.assign({ areElementsLoaded: true }, (options.loadProgressively ? {} : updateData)));
        });
    }
    _getElementsByAssetId(assetId, sort = defaultElementSort$1, etag, limit = 100, signal) {
        return __asyncGenerator(this, arguments, function* _getElementsByAssetId_1() {
            yield __await(yield* __asyncDelegator(__asyncValues(this._getElementsOfTypeByAssetId('elements', assetId, sort, etag, limit, signal))));
        });
    }
    _getRemovedElementsByAssetId(assetId, sort = defaultElementSort$1, etag, limit = 100, signal) {
        return __asyncGenerator(this, arguments, function* _getRemovedElementsByAssetId_1() {
            yield __await(yield* __asyncDelegator(__asyncValues(this._getElementsOfTypeByAssetId('archive', assetId, sort, etag, limit, signal))));
        });
    }
    _getDocumentationElementsByAssetId(assetId, _sort = defaultElementSort$1, etag, _limit = 100, _signal) {
        return __asyncGenerator(this, arguments, function* _getDocumentationElementsByAssetId_1() {
            yield yield __await(Promise.resolve([]));
        });
    }
    _getElementsOfTypeByAssetId(type, assetId, sort = defaultElementSort$1, etag, limit = 100, signal) {
        return __asyncGenerator(this, arguments, function* _getElementsOfTypeByAssetId_1() {
            const responseMapper = (res) => res.elements.map(element => {
                // The no-etag-set-on-library-response-yet case
                if ((!element.manifest_etag && etag === melvilleFirstUseEtag) || element.manifest_etag === etag) {
                    return mapResponseToElementData$1(element);
                }
                throw new RequestError('PRECONDITION_FAILED', `An element did not match the provided etag: ${etag}`);
            });
            const orderBy = `${sort.direction === 'descending' ? '-' : ''}${sortFieldMap[sort.field]}`;
            const queryParams = {
                limit,
                orderBy,
                selector: ['default', 'representations', 'details']
            };
            yield __await(yield* __asyncDelegator(__asyncValues(this.fetchAllPages(`/api/v1/libraries/${assetId}/${type}?${queryString.stringify(queryParams, { arrayFormat: 'comma' })}`, {}, responseMapper, signal))));
        });
    }
    getSearchResults(searchQuery, filters, elementSort, signal) {
        return __asyncGenerator(this, arguments, function* getSearchResults_1() {
            const { field, direction } = elementSort;
            let orderBy = field === 'modifiedDate' ? 'modified_date' : 'name';
            if (direction === 'descending') {
                orderBy = `-${orderBy}`;
            }
            yield __await(yield* __asyncDelegator(__asyncValues(this.fetchAllPages('/api/v1/search', {
                method: 'POST',
                signal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query_string: searchQuery,
                    library_id: filters.library_id,
                    asset_type: ['element'],
                    orderBy,
                    limit: 300
                })
            }, (res) => {
                return res.elements.map(mapSearchResponseToElementData);
            }))));
        });
    }
    /* Team operations */
    async getTeams() {
        const response = await this.fetch(`https://${this.driverConfig.teams_hostname}/api/v2/teams`);
        const teamData = await response.json();
        if (!isTeamsResponse$1(teamData)) {
            return [];
        }
        // Remove all CCI teams, as this feature has STILL not shipped.
        return teamData.teams.filter(team => team.repositoryOwner.type === 'org').map(mapResponseToTeamData$1);
    }
    async getProjects() {
        if (!this._core) {
            return [];
        }
        const projectList = await this._core.projectContext
            .projects()
            .getList(ProjectOrder.default, ProjectFilter.AllProjects, { loadAllPages: true });
        await waitForListLoad(projectList);
        return projectList.items.map(mapProjectToTeamData);
    }
    async getProjectByName(name) {
        if (!this._core) {
            return undefined;
        }
        const project = await this._core.projectContext.resolveProjectByName(name);
        if (!project) {
            return undefined;
        }
        return mapProjectToTeamData(project);
    }
    async getProjectGradient(project) {
        if (!this._core) {
            return;
        }
        // The project should be cached so this should return immediately.
        const samProject = await this._core.projectContext.getProjectbyID(project.id);
        return this._core.projectContext.getGradient(samProject.gradientID).then(mapGradientToGradientData);
    }
    /* Group operations */
    getGroups(_assetId) {
        return __asyncGenerator(this, arguments, function* getGroups_1() {
            yield yield __await(Promise.resolve(undefined));
        });
    }
    /* Rendition operations */
    getRenditionUrl(element, size) {
        let url;
        try {
            const urlString = getRenditionUrl(element, size);
            if (!urlString) {
                return '';
            }
            // cannot initialize URL with undefined
            url = new URL(urlString);
        }
        catch (error) {
            Logger$1.log(String(error));
            return '';
        }
        setURLSearchParams(url, {
            api_key: this._clientId,
            user_token: this._token
        });
        return url.toString();
    }
    getAuthenticatedThumbnailURL(element, size) {
        return Promise.resolve(this.getRenditionUrl(element, size));
    }
    getRenditionPath(_assetId, _elementId, _size) {
        return Promise.resolve('');
    }
    getRendition(element, size) {
        return this.fetch(getRenditionUrl(element, size));
    }
    async getRepresentationContent(representation) {
        let representationUrl;
        // 10mb ACP API limit on download via `primary` link, otherwise use `download` to get presigned URL
        if (representation.contentLength < rapiMaxSingleTransferSize) {
            representationUrl = representation._data.url;
        }
        else {
            const blockDownloadData = await this.getPresignedDownloadUrl(representation._data.blockDownloadUrl);
            representationUrl = blockDownloadData && blockDownloadData.url;
            if (!representationUrl) {
                representationUrl = representation._data.url;
            }
        }
        return this.fetch(representationUrl);
    }
    /* Local Settings */
    async setLocalSetting(key, value) {
        var _a;
        value = JSON.stringify(value);
        (_a = this._localStorage) === null || _a === void 0 ? void 0 : _a.setItem(key, value);
    }
    getLocalSetting(key) {
        var _a;
        const value = (_a = this._localStorage) === null || _a === void 0 ? void 0 : _a.getItem(key);
        const result = value && JSON.parse(value);
        return result;
    }
    getInstalledVersion(_appCode) {
        throw new Error('Not supported in cloud mode.');
    }
    setFontDataChangeListener(_callback) {
        // No-op
    }
    /**
     * Moves query params to headers, for those that are in the MelvilleParamsAsHeaders list
     * @param melvillePath
     * @returns tuple of [path, headers], with the path truncated of the query params that were moved to headers
     */
    moveUrlQueryParamsToHeaders(melvillePath, headers = {}) {
        const [path, query] = melvillePath.split('?');
        const urlParams = new URLSearchParams(query);
        for (const headerParamKey of MelvilleParamsAsHeaders) {
            const headerParamValue = urlParams.get(headerParamKey);
            if (headerParamValue) {
                headers[headerParamKey] = headerParamValue;
                urlParams.delete(headerParamKey);
            }
        }
        return [`${path}${[...urlParams].length > 0 ? '?' : ''}${urlParams}`, headers];
    }
    async sendAction(applicationAction) {
        throw new LibraryError('NOT_SUPPORTED', 'Application actions are not supported in a cloud environment', applicationAction.item.id);
    }
    async openInCCD(_path) {
        throw new Error('Not supported in cloud mode.');
    }
    async fetch(path, init, options = {}) {
        var _a, _b, _c;
        setTracingSpanAttribute('path', path);
        init = init || {};
        init.headers = init.headers || {};
        init.headers['x-api-key'] = this._clientId;
        // Include the auth header, unless the options specifically say not to include it.
        if (options.includeAuthHeader !== false) {
            init.headers.Authorization = `Bearer ${this._token}`;
        }
        // Attempt to upgrade platform urls to use edge workflow
        // Turns on http/2 for ACP
        const { url, headers } = useEdge(path);
        path = url;
        init.headers = Object.assign(Object.assign({}, headers), init.headers);
        init.signal = init.signal
            ? combineSignals(init.signal, (_a = this._abortController) === null || _a === void 0 ? void 0 : _a.signal)
            : (_b = this._abortController) === null || _b === void 0 ? void 0 : _b.signal;
        if (path.startsWith('/')) {
            path = `https://${this.driverConfig.hostname}${path}`;
        }
        const startTime = Date.now();
        const response = await this._fetch(path, init).catch(e => {
            if (e.name === ABORT_ERROR) {
                return new Response('{}');
            }
            Logger$1.info(`Error - ${e} (${Date.now() - startTime}ms)`);
            throw e;
        });
        const requestId = response.headers.get('X-Request-Id') || 'no requestId';
        Logger$1.info(`[${requestId}] ${init.method || 'GET'} ${path} ${response.status} (${Date.now() - startTime}ms)`);
        if (response.status >= 300) {
            const requestError = getRequestError(response);
            // If the fetch fails because it is unauthorized, we want to refresh the access token to make sure we have a valid tokenZXGBVH
            if (requestError.requestErrorCode === 'UNAUTHORIZED') {
                (_c = this._refreshAccessToken) === null || _c === void 0 ? void 0 : _c.call(this);
            }
            throw await this._getFetchError(response);
        }
        return response;
    }
    async _getFetchError(response) {
        // Melville may include error details in the response body.
        if (response.status === 403) {
            try {
                const json = await response.json();
                if (typeof json.type === 'string' && json.type.toLowerCase() === 'quota') {
                    return new LibraryError('EXCEEDS_QUOTA', json.problem_type_message || 'Storage quota exceeded');
                }
            }
            catch (_a) {
                // If the JSON is invalid, ignore it.
            }
        }
        return getRequestError(response);
    }
    fetchAllPages(firstUrl, init, responseMapper, signal, paramsAsHeaders = true) {
        var _a, _b;
        return __asyncGenerator(this, arguments, function* fetchAllPages_1() {
            let nextUrl = firstUrl;
            while (nextUrl) {
                const { headers = {} } = init, rest = __rest$2(init, ["headers"]);
                if (paramsAsHeaders) {
                    [nextUrl] = this.moveUrlQueryParamsToHeaders(nextUrl, headers);
                }
                const response = yield __await(this.fetch(nextUrl, Object.assign(Object.assign({ signal }, rest), { headers })).then(res => res.json()));
                yield yield __await(responseMapper(response));
                nextUrl = (_b = (_a = response._links) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.href;
            }
        });
    }
    fetchOnePage(firstUrl, responseMapper, signal, paramsAsHeaders = true) {
        return __asyncGenerator(this, arguments, function* fetchOnePage_1() {
            let headers;
            if (paramsAsHeaders) {
                [firstUrl, headers] = this.moveUrlQueryParamsToHeaders(firstUrl);
            }
            const response = yield __await(this.fetch(firstUrl, { signal, headers }).then(res => res.json()));
            yield yield __await(responseMapper(response));
        });
    }
    async copyFile(_source, _destination, _allowOverride) {
        throw new Error('Not supported in cloud mode.');
    }
    async getFileSize(_path) {
        throw new Error('Not supported in cloud mode.');
    }
    getRenditionGrid(_library) {
        throw new Error('Not supported in cloud mode.');
    }
    async stageRepresentationForCommit(library, file, type) {
        var _a;
        const fileType = type || file.type;
        // Get a link for uploading components to the library.
        const links = await this._fetchLibraryLinks(library);
        const componentLink = links[RapiLinkType.COMPONENT];
        // This is the link for uploading a component in chunks.
        const blockUploadLink = links[RapiLinkType.BLOCK_INIT];
        const maxSingleTransferSize = (blockUploadLink === null || blockUploadLink === void 0 ? void 0 : blockUploadLink['repo:maxSingleTransferSize']) || rapiMaxSingleTransferSize;
        if (!componentLink) {
            throw new LibraryError('NOT_ALLOWED', 'Library is missing component upload link', library.id);
        }
        // Use the component link template to get the URL to the new component.
        const componentId = uuid_1.v4();
        const template = uriTemplates(componentLink.href);
        const componentUrl = template.fill({ component_id: componentId });
        const dimensions = await getImageDimensions(file, fileType);
        const preflightResponse = {
            id: componentId,
            storage_href: componentUrl,
            asset_id: library.assetId,
            type: fileType,
            content_length: file.size,
            name: file.name,
            width: dimensions === null || dimensions === void 0 ? void 0 : dimensions.width,
            height: dimensions === null || dimensions === void 0 ? void 0 : dimensions.height
        };
        if (file.size > maxSingleTransferSize && blockUploadLink) {
            const transferDocument = await this._initializeBlockUpload(blockUploadLink, componentId, file, fileType);
            await this._transferBlocks(transferDocument, file);
            const result = await this._finalizeBlockUpload(transferDocument);
            Object.assign(preflightResponse, result);
            return JSON.stringify(preflightResponse);
        }
        // Upload the new component.
        const uploadResponse = await this.fetch(componentUrl, {
            method: 'PUT',
            headers: {
                'Content-Type': fileType
            },
            body: await file.arrayBuffer()
        });
        Object.assign(preflightResponse, {
            etag: uploadResponse.headers.get('etag'),
            md5: (_a = uploadResponse.headers.get('content-md5')) !== null && _a !== void 0 ? _a : undefined,
            version: uploadResponse.headers.get('revision')
        });
        return JSON.stringify(preflightResponse);
    }
    // This entire method could be replaced by a call to the Links API, except for a CORS issue
    // between the Links API and Express.
    // CORS Ticket: https://jira.corp.adobe.com/browse/ACPSDS-4864
    // Links API: https://developers.corp.adobe.com/storage-api/docs/reference/links.md
    async _fetchLibraryLinks(library) {
        if (!library.assetId) {
            throw new LibraryError('NOT_SUPPORTED', 'Library does not have an assetId', library.id);
        }
        // Get a link from the index for resolving assets.
        // This could be improved by caching links so we don't need a new request each time.
        // Link caching - https://developers.corp.adobe.com/supplemental-resources/docs/caching-links.md
        const indexResponse = await this.fetch(`https://${this.driverConfig.platform_hostname}`);
        const indexLinks = (await indexResponse.json())._links;
        const resolveLink = indexLinks[RapiLinkType.RESOLVE];
        // Resolve the library to get the links for the library.
        const resolveTemplate = uriTemplates(resolveLink.href);
        const resolveUrl = resolveTemplate.fill({ id: library.assetId });
        const resolveResponse = await this.fetch(resolveUrl, { method: 'HEAD' });
        // Links are returned in the response headers as a comma-separated list of link relations.
        // The links also appear in the response body of a GET request, but the block/init relation
        // is not included for some reason. That's why we parse the response headers instead.
        const linkList = resolveResponse.headers.get('link');
        return linkList ? parseLinks(linkList) : {};
    }
    // See: https://developers.corp.adobe.com/storage-api/docs/reference/block-transfer.md
    async _initializeBlockUpload(blockUploadLink, componentId, file, fileType) {
        const transferDocument = {
            'repo:size': file.size,
            'repo:blocksize': blockUploadLink['repo:maxSingleTransferSize'] || rapiMaxSingleTransferSize,
            'repo:reltype': RapiLinkType.COMPONENT,
            component_id: componentId,
            'dc:format': fileType
        };
        const initResponse = await this.fetch(blockUploadLink.href, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/vnd.adobecloud.bulk-transfer+json'
            },
            body: JSON.stringify(transferDocument)
        });
        // Returns an updated transfer document
        return await initResponse.json();
    }
    async _transferBlocks(transferDocument, file) {
        const blockSize = transferDocument['repo:blocksize'];
        const transferLinks = transferDocument._links[RapiLinkType.BLOCK_TRANSFER];
        let offset = 0;
        const blockUploads = [];
        for (let i = 0; offset <= file.size; i += 1) {
            const end = Math.min(offset + blockSize, file.size);
            blockUploads.push(this.fetch(transferLinks[i].href, {
                method: 'PUT',
                headers: {
                    'Content-Length': String(end - offset)
                },
                body: file.slice(offset, end),
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error - this is a new addition to the fetch standard and required when the body is a ReadableStream (enforced by node.js). See https://github.com/whatwg/fetch/blob/main/fetch.bs#L7510.
                duplex: 'half'
            }, { includeAuthHeader: false }));
            offset += blockSize;
        }
        return await Promise.all(blockUploads);
    }
    async _finalizeBlockUpload(transferDocument) {
        var _a;
        const finalizeLink = transferDocument._links[RapiLinkType.BLOCK_FINALIZE];
        let finalizeUrl = finalizeLink.href;
        if (finalizeLink.templated) {
            const template = uriTemplates(finalizeLink.href);
            finalizeUrl = template.fill({});
        }
        const finalizeRequest = this.fetch(finalizeUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/vnd.adobecloud.bulk-transfer+json'
            },
            body: JSON.stringify(transferDocument)
        });
        const response = await finalizeRequest;
        // If the response is 202, the request was accepted for asynchronous processing.
        // Handoff to the AsyncResponse class to handle monitoring the request.
        if (response.status === HttpStatus.ACCEPTED) {
            return new Promise((resolve, reject) => {
                const asyncResponse = new AsyncResponse(this, finalizeRequest);
                asyncResponse.on('change', (isDone, json, headers) => {
                    var _a;
                    if (isDone) {
                        if (asyncResponse.error) {
                            reject(asyncResponse.error);
                        }
                        else {
                            resolve({
                                etag: headers.get('etag'),
                                md5: (_a = headers.get('content-md5')) !== null && _a !== void 0 ? _a : undefined,
                                version: headers.get('version')
                            });
                        }
                    }
                });
            });
        }
        // Otherwise, the request was processed synchronously.
        return {
            etag: response.headers.get('etag'),
            md5: (_a = response.headers.get('content-md5')) !== null && _a !== void 0 ? _a : undefined,
            version: response.headers.get('version')
        };
    }
    getLocalDriver() {
        const connector = () => {
            return this._requestProcessToUploadData(uuid_1.v4(), Date.now());
        };
        return new LocalDriver(this._core, connector);
    }
    async _requestProcessToUploadData(uuid, originalTimeStamp) {
        var _a;
        if (Date.now() - originalTimeStamp > processDiscoveryTimeout) {
            Logger$1.log('Timed out and no response received from process and/or server');
            throw new Error('Unable to get process connection info (timed out)');
        }
        const userHash = md5((_a = this.config.user) === null || _a === void 0 ? void 0 : _a.id);
        // make Urls.
        const urlWithoutPort = `https://${uuid}.${userHash}.adobelocalhost.com`;
        const urls = [];
        for (let port = tlsDiscoveryPortRange[0]; port <= tlsDiscoveryPortRange[1]; port += 1) {
            urls.push(`${urlWithoutPort}:${port}`);
        }
        // reset the abort controller since we were disconnected
        this.resetAbortController();
        await Promise.allSettled(urls.map(url => fetch(url)));
        try {
            const [result] = await Promise.all([
                this._fetchProcessConnectInfo(uuid).catch(() => undefined),
                sleep(processDiscoveryRetryDelay)
            ]);
            if (!result) {
                throw new RequestError('MALFORMED_RESPONSE', `Invalid response retrieving process connection data for uuid: ${uuid}`);
            }
            return result;
        }
        catch (error) {
            Logger$1.error(String(error));
            return this._requestProcessToUploadData(uuid, originalTimeStamp);
        }
    }
    async _fetchProcessConnectInfo(id) {
        const url = `https://${this.driverConfig.hostname}/api/v1/client-tokens/${id}`;
        const data = await this.fetch(url).then(res => res.json(), err => Logger$1.error(err));
        const { restApiToken, restApiPort } = JSON.parse(data.token);
        if (!restApiToken || !restApiPort) {
            throw new RequestError('MALFORMED_RESPONSE', 'Response did not include necessary process connection data');
        }
        return { hostname: `http://127.0.0.1:${restApiPort}`, token: restApiToken };
    }
    getClientInfo() {
        var _a;
        return {
            deviceId: `${this._clientId}-${(_a = this.config.user) === null || _a === void 0 ? void 0 : _a.id}`,
            device: typeof window !== 'undefined' ? window.navigator.userAgent : 'node-js',
            app: this._clientId
        };
    }
    async getTempDir(_library) {
        throw new Error('Not supported in cloud mode.');
    }
    ignoreLocalSyncEvents() {
        // For Cloud driver the sync status is based on the local operations.
        return false;
    }
};
__decorate([
    trace
], CloudDriver.prototype, "getLibraryById", null);
__decorate([
    trace
], CloudDriver.prototype, "_getAllElements", null);
__decorate([
    trace
], CloudDriver.prototype, "_getElementsOfTypeByAssetId", null);
__decorate([
    trace
], CloudDriver.prototype, "getTeams", null);
__decorate([
    trace
], CloudDriver.prototype, "getProjects", null);
__decorate([
    trace
], CloudDriver.prototype, "getProjectByName", null);
__decorate([
    trace
], CloudDriver.prototype, "getProjectGradient", null);
__decorate([
    trace
], CloudDriver.prototype, "getRendition", null);
__decorate([
    trace
], CloudDriver.prototype, "fetch", null);
__decorate([
    trace
], CloudDriver.prototype, "stageRepresentationForCommit", null);
CloudDriver = __decorate([
    traceableAs('CloudDriver')
], CloudDriver);
var CloudDriver$1 = CloudDriver;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class LibraryAbortController {
    static getInstance(libraryId) {
        let instance = this.libAbortControllerMap.get(libraryId);
        if (!instance) {
            instance = new AbortController();
            this.libAbortControllerMap.set(libraryId, instance);
        }
        return instance;
    }
    static removeInstance(libraryId) {
        return this.libAbortControllerMap.delete(libraryId);
    }
}
LibraryAbortController.libAbortControllerMap = new Map();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const getPublicLinkId = (url) => {
    return url === null || url === void 0 ? void 0 : url.substring(url.lastIndexOf('/') + 1);
};
function mapResponseToLibraryData(libraryResponse, forceReadOnly = false) {
    var _a;
    const isWritable = forceReadOnly ? false : libraryResponse.is_writable;
    const data = {
        id: libraryResponse.id,
        etag: libraryResponse.etag,
        name: libraryResponse.name,
        ownership: libraryResponse.ownership,
        default: libraryResponse.default,
        localizedNames: libraryResponse.localized_names,
        toolkitId: libraryResponse.toolkit_id,
        documentId: libraryResponse.document_id,
        documentType: libraryResponse.document_type,
        createdDate: libraryResponse.created_date,
        modifiedDate: libraryResponse.modified_date,
        groups: (libraryResponse.groups || []).map(mapResponseToGroupData),
        details: {
            elementCount: libraryResponse.details.num_elements,
            documentationElementCount: libraryResponse.details.num_documentation_elements,
            removedElementCount: libraryResponse.details.num_archived_elements
        },
        renditionGrid: libraryResponse.rendition_grid,
        collaboration: libraryResponse.collaboration,
        assetId: libraryResponse.asset_id,
        isWritable,
        isParentWritable: forceReadOnly ? false : libraryResponse.is_parent_writable,
        team: libraryResponse.team_id
            ? {
                id: libraryResponse.team_id
            }
            : undefined,
        roles: libraryResponse.roles,
        owner: libraryResponse.owner,
        ownerType: libraryResponse.owner_type,
        customData: libraryResponse.custom_data,
        isLibraryLoaded: true,
        storageUsed: libraryResponse.storage_used,
        publicLinkId: getPublicLinkId(libraryResponse.public_link),
        locallyManaged: libraryResponse.locally_managed,
        bookmark: libraryResponse.bookmark,
        // If `remove_type` is not in the response, then we are connected to an older version
        // of the process that did not support discard. We can assume the remove type is delete.
        removeType: (_a = libraryResponse.remove_type) !== null && _a !== void 0 ? _a : (isWritable ? 'delete' : 'none'),
        deletable: isWritable
    };
    if (libraryResponse.elements) {
        data.elements = libraryResponse.elements.map(mapResponseToElementData);
    }
    return data;
}
function mapLibraryDataToRequest(libraryData) {
    var _a, _b;
    return {
        id: libraryData.id,
        name: libraryData.name,
        ownership: libraryData.ownership,
        default: libraryData.default,
        localized_names: libraryData.localizedNames,
        toolkit_id: libraryData.toolkitId,
        document_id: libraryData.documentId,
        document_type: libraryData.documentType,
        groups: (_a = libraryData.groups) === null || _a === void 0 ? void 0 : _a.map(mapGroupDataToRequest),
        collaboration: libraryData.collaboration,
        details: {
            num_elements: 0,
            num_documentation_elements: 0,
            num_archived_elements: 0 // TODO
        },
        // asset_id: '',
        // isWritable: true,
        // isParentWritable: true,
        team_id: (_b = libraryData.team) === null || _b === void 0 ? void 0 : _b.id,
        roles: libraryData.roles,
        custom_data: libraryData.customData
    };
}
function mapResponseToElementData(elementResponse) {
    var _a, _b, _c;
    return {
        id: elementResponse.id,
        name: elementResponse.name,
        isAutoNamed: elementResponse.is_auto_named,
        autoName: elementResponse.auto_name,
        type: elementResponse.type,
        libraryId: (_a = elementResponse.library) === null || _a === void 0 ? void 0 : _a.id,
        sourceRef: elementResponse.source_ref,
        sourceModifiedDate: elementResponse.source_modified_date,
        tags: elementResponse.tags,
        dependencyIds: elementResponse.dependency_ids,
        localizedNames: elementResponse.localized_names,
        createdDate: elementResponse.created_date,
        createdLocally: elementResponse.created_locally,
        createdBy: elementResponse.created_by,
        createdContext: elementResponse.created_context,
        modifiedDate: elementResponse.modified_date,
        modifiedLocally: elementResponse.modified_locally,
        modifiedBy: elementResponse.modified_by,
        modifiedContext: elementResponse.modified_context,
        description: elementResponse.description,
        descriptionModifiedDate: elementResponse.description_modified_date,
        descriptionModifiedLocally: elementResponse.description_modified_locally,
        descriptionModifiedBy: elementResponse.description_modified_by,
        descriptionModifiedContext: elementResponse.description_modified_context,
        removedDate: elementResponse.removed_date,
        removedLocally: elementResponse.removed_locally,
        removedBy: elementResponse.removed_by,
        removedContext: elementResponse.removed_context,
        representations: (_b = elementResponse.representations) === null || _b === void 0 ? void 0 : _b.map(mapResponseToRepresentationData),
        groups: (_c = elementResponse.groups) === null || _c === void 0 ? void 0 : _c.map(mapResponseToGroupMembershipData),
        roles: elementResponse.roles,
        customData: elementResponse.custom_data,
        elementRef: elementResponse.element_ref
    };
}
function mapElementDataToRequest(elementData) {
    var _a, _b;
    return {
        id: elementData.id,
        name: elementData.name,
        is_auto_named: elementData.isAutoNamed,
        auto_name: elementData.autoName,
        type: elementData.type,
        source_ref: elementData.sourceRef,
        description: elementData.description,
        tags: elementData.tags,
        dependency_ids: elementData.dependencyIds,
        localized_names: elementData.localizedNames,
        created_date: elementData.createdDate,
        modified_date: elementData.modifiedDate,
        representations: (_a = elementData.representations) === null || _a === void 0 ? void 0 : _a.map(rep => mapRepresentationDataToRequest(rep, false)),
        groups: (_b = elementData.groups) === null || _b === void 0 ? void 0 : _b.map(mapGroupMembershipDataToRequest),
        roles: elementData.roles,
        custom_data: elementData.customData
    };
}
function mapResponseToGroupData(groupResponse) {
    return {
        id: groupResponse.id,
        classifier: groupResponse.classifier,
        name: groupResponse.name,
        order: groupResponse.order,
        parentId: groupResponse.parent_id,
        localizedNames: groupResponse.localized_names,
        createdDate: groupResponse.created_date,
        createdBy: groupResponse.created_by,
        createdContext: groupResponse.created_context,
        createdLocally: groupResponse.created_locally,
        modifiedDate: groupResponse.modified_date,
        modifiedBy: groupResponse.modified_by,
        modifiedContext: groupResponse.modified_context,
        modifiedLocally: groupResponse.modified_locally,
        sourceRef: groupResponse.source_ref,
        customData: groupResponse.custom_data
    };
}
function mapGroupDataToRequest(groupData) {
    return {
        id: groupData.id,
        classifier: groupData.classifier,
        name: groupData.name,
        order: groupData.order,
        parent_id: groupData.parentId,
        localized_names: groupData.localizedNames,
        created_date: groupData.createdDate,
        modified_date: groupData.modifiedDate,
        source_ref: groupData.sourceRef,
        custom_data: groupData.customData
    };
}
function mapResponseToGroupMembershipData(groupMembershipResponse) {
    // This is a no-op, but it is left as an example.
    return {
        id: groupMembershipResponse.id,
        classifier: groupMembershipResponse.classifier,
        order: groupMembershipResponse.order
    };
}
function mapGroupMembershipDataToRequest(groupMembershipData) {
    // This is a no-op, but it is left as an example.
    return {
        id: groupMembershipData.id,
        classifier: groupMembershipData.classifier,
        order: groupMembershipData.order
    };
}
function mapResponseToRepresentationData(representationResponse) {
    var _a;
    return {
        id: representationResponse.id,
        type: representationResponse.type,
        relationship: representationResponse.relationship,
        isFullSize: representationResponse.is_full_size,
        isExternalLink: representationResponse.is_external_link,
        isPreferredThumbnail: representationResponse.is_preferred_thumbnail,
        customData: representationResponse.custom_data,
        path: representationResponse.path,
        width: representationResponse.width,
        height: representationResponse.height,
        contentLength: representationResponse.content_length,
        url: representationResponse.url,
        children: (_a = representationResponse.children) === null || _a === void 0 ? void 0 : _a.map(mapResponseToRepresentationData)
    };
}
function mapRepresentationDataToRequest(representationData, isChild = false) {
    var _a;
    return {
        id: representationData.id,
        type: representationData.type,
        relationship: (isChild ? undefined : representationData.relationship),
        is_full_size: false,
        is_external_link: false,
        source: representationData.source,
        children: (_a = representationData.children) === null || _a === void 0 ? void 0 : _a.map(child => mapRepresentationDataToRequest(child, true)),
        custom_data: representationData.customData
    };
}
function mapResponseToTeamData(teamData) {
    return {
        name: teamData.name,
        id: teamData.id,
        owner: {
            type: teamData.ownerType,
            id: teamData.ownerId
        },
        ownerName: teamData.ownerName,
        isWritable: teamData.permissions.includes('write')
    };
}
function mapProjectsResponseToTeamData(projectData) {
    return {
        name: projectData.name,
        id: projectData.id,
        owner: {
            type: projectData.storageAssignee.type,
            id: projectData.storageAssignee.id
        },
        ownerName: projectData.storageAssignee.displayName,
        // SHARED-3702 - Cleanup use of isReadOnly vs isWritable
        isReadOnly: projectData.isReadOnly,
        // All project users can edit the project.
        isWritable: true
    };
}
function mapResponseToGradientData(gradient) {
    return {
        type: gradient.type,
        angle: gradient.angle,
        stops: gradient.stops
    };
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function compareVersions$1(version1, version2) {
    //After effects does not use semver. They append a x before the build number.
    //We need to replace that with a .
    version1 = (version1 || '0')
        .toString()
        .replace(/(\.0)*$/, '')
        .replace(/[^.0-9]+/gim, '.');
    version2 = (version2 || '0')
        .toString()
        .replace(/(\.0)*$/, '')
        .replace(/[^.0-9]+/gim, '.');
    //Workaround for Illustrator CS6 & Illustrator CC returning version as CS6 and the build number instead of semver
    if (isNaN(parseInt(version1, 10)) || parseInt(version1, 10) > 250) {
        version1 = '0';
    }
    if (isNaN(parseInt(version2, 10)) || parseInt(version2, 10) > 250) {
        version2 = '0';
    }
    if (version1 === version2) {
        return 0;
    }
    const a1 = version1.split('.');
    const a2 = version2.split('.');
    let diff;
    for (let i = 0; i < a1.length && i < a2.length; i++) {
        diff = parseInt(a1[i], 10) - parseInt(a2[i], 10);
        if (isNaN(diff)) {
            if (isNaN(parseInt(a1[i], 10))) {
                return 1;
            }
            return -1;
        }
        if (diff > 0) {
            return -1;
        }
        if (diff < 0) {
            return +1;
        }
    }
    diff = a1.length - a2.length;
    return diff > 0 ? -1 : diff < 0 ? 1 : 0;
}

const isTeamsResponse = (val) => {
    return val.teams !== undefined;
};
const isLibrariesResponse = (val) => {
    return val.libraries !== undefined;
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const supportedActionNames = [
    'updateLibrary',
    'createElement',
    'updateElement',
    'removeElement',
    'restoreElement',
    'deleteElement',
    'createGroup',
    'updateGroup',
    'removeGroup'
];
function isSupportedAction(action) {
    return supportedActionNames.includes(action.name);
}
function replaceData(action, data) {
    return Object.assign(Object.assign({}, action), { data, originalAction: action });
}
const RESPONSE_MAPPERS = {
    updateLibrary: (action, data) => replaceData(action, mapResponseToLibraryData(data)),
    createElement: (action, data) => replaceData(action, mapResponseToElementData(data)),
    updateElement: (action, data) => replaceData(action, mapResponseToElementData(data)),
    restoreElement: (action, data) => replaceData(action, mapResponseToElementData(data)),
    removeElement: action => action,
    deleteElement: action => action,
    createGroup: (action, data) => replaceData(action, mapResponseToGroupData(data)),
    updateGroup: (action, data) => replaceData(action, mapResponseToGroupData(data)),
    removeGroup: action => action
};
class BatchOperation extends Operation {
    constructor() {
        super(...arguments);
        this._actionMappers = {
            updateLibrary: (action) => ({
                method: 'PUT',
                path: '',
                body: mapLibraryDataToRequest(action.data)
            }),
            createElement: (action) => ({
                method: 'POST',
                path: 'elements',
                body: mapElementDataToRequest(action.data)
            }),
            updateElement: (action) => ({
                method: 'PUT',
                path: `elements/${extractElementId$1(action.path)}`,
                body: mapElementDataToRequest(action.data)
            }),
            removeElement: (action) => ({
                method: 'DELETE',
                path: `elements/${extractElementId$1(action.path)}`
            }),
            restoreElement: (action) => ({
                method: 'POST',
                path: `removed_elements/${action.data.id}/restore`
            }),
            deleteElement: (action) => ({
                method: 'DELETE',
                path: `elements/${extractElementId$1(action.path)}?permanent=true`
            }),
            createGroup: (action) => ({
                method: 'POST',
                path: 'groups',
                body: mapGroupDataToRequest(action.data)
            }),
            updateGroup: (action) => ({
                method: 'PUT',
                path: `groups/${extractGroupId(action.path)}`,
                body: mapGroupDataToRequest(action.data)
            }),
            removeGroup: (action) => {
                var _a;
                return ({
                    method: 'DELETE',
                    path: `groups/${extractGroupId(action.path)}${((_a = action.flags) === null || _a === void 0 ? void 0 : _a.includeElements) ? '?include_contents=true' : ''}`
                });
            }
        };
        this._actions = [];
    }
    async execute() {
        const payload = this._actions.map(action => this._actionMappers[action.name](action));
        const tokenizedPayload = tokenizePlaceholders(payload);
        const response = await this._driver.fetch(`/libraries/${this._library.id}`, {
            method: 'PATCH',
            headers: {
                'If-Match': this._library.etag
            },
            body: JSON.stringify(tokenizedPayload)
        });
        const json = await response.json();
        // Response should be an array that's the same size as the number of actions in the batch
        if (!Array.isArray(json) || json.length !== this._actions.length) {
            throw new LibraryError('INVALID_RESPONSE', 'Malformed batch response.', this._library.id);
        }
        // Given the responses, map the actual response onto actions and return the new actions.
        let newActions = this._actions.map((action, index) => {
            return RESPONSE_MAPPERS[action.name](action, json[index]);
        });
        // TODO: Bug here. Any placeholders that need to be replaced not in batch will be missed. We shouldn't do this here.
        // Replace any placeholders that might exist in the new actions
        newActions = replacePlaceholders(newActions);
        return { actions: newActions, etag: response.headers.get('ETag') };
    }
    supportsAction(action) {
        return isSupportedAction(action);
    }
}
__decorate([
    validatesOperation
], BatchOperation.prototype, "execute", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Element content is always replaced entirely, so if we're doing a bunch of representation changes, it makes
 * sense to batch them together.
 *
 * Also, since this operation isn't supported by the batch API, we want to cut down on requests.
 */
class ContentOperation extends Operation {
    supportsAction(action) {
        return action.name === 'updateElementContent';
    }
    addAction(action) {
        // Content operations must operate on the same element
        if (this._actions[0] && this._actions[0].path !== action.path) {
            return false;
        }
        return super.addAction(action);
    }
    async execute() {
        // The last content update action will always be the most up-to-date. We can omit all of the ones before it.
        const lastAction = this._actions[this._actions.length - 1];
        const response = await this._updateElementContent(extractElementId$1(lastAction.path), lastAction.data);
        const json = await response.json();
        const data = mapResponseToElementData(json);
        const actions = this._actions.map((action, index) => {
            if (index !== this._actions.length - 1) {
                return Object.assign(Object.assign({}, action), { type: 'no-op', originalAction: action });
            }
            else {
                return Object.assign(Object.assign({}, action), { data, originalAction: action });
            }
        });
        return { actions, etag: response.headers.get('ETag') };
    }
    _updateElementContent(elementId, data) {
        // The REST API requires that all new representations not have an ID. If the ID isn't found, then the API
        // returns an error.
        const cleanedData = Object.assign(Object.assign({}, data), { representations: removeRepresentationPlaceholderIds(deepCopy(data.representations)) });
        return this._driver.fetch(`/libraries/${this._library.id}/elements/${elementId}`, {
            method: 'PUT',
            headers: {
                'If-Match': this._library.etag
            },
            body: JSON.stringify(mapElementDataToRequest(cleanedData))
        });
    }
}
__decorate([
    validatesOperation
], ContentOperation.prototype, "execute", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class LocalSingleOperation extends SingleOperation$1 {
    constructor() {
        super(...arguments);
        this._actionMappers = {
            createLibrary: (action) => this._createLibraryActionMap(action),
            copyLibrary: (action) => this._createLibraryActionMap(action),
            permanentlyDeleteLibrary: (action) => this._permanentlyDeleteLibrary(action),
            removeLibrary: async (action) => {
                await this._removeLibrary();
                return action;
            },
            unfollowLibrary: async (action) => {
                await this._removeLibrary('unfollow');
                return action;
            },
            leaveLibrary: async (action) => {
                await this._removeLibrary('leave');
                return action;
            },
            moveLibrary: async (action) => {
                const data = await this._moveLibrary();
                return Object.assign(Object.assign({}, action), { data, originalAction: action });
            }
        };
    }
    supportsAction(action) {
        return [
            'createLibrary',
            'removeLibrary',
            'permanentlyDeleteLibrary',
            'unfollowLibrary',
            'leaveLibrary',
            'copyLibrary',
            'moveLibrary'
        ].includes(action.name);
    }
    async _createLibraryActionMap(action) {
        const data = await this._createLibrary(action);
        return Object.assign(Object.assign({}, action), { type: 'update', data, originalAction: action });
    }
    _createLibrary(action) {
        const { data = {}, flags = {} } = action;
        return new Promise((resolve, reject) => {
            var _a, _b;
            const request = this._driver.fetch('/libraries', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: data.name,
                    team_id: (_a = data.team) === null || _a === void 0 ? void 0 : _a.id,
                    roles: data.roles,
                    team_permission_inheritance: flags.permissionInheritance,
                    source: (_b = flags.source) === null || _b === void 0 ? void 0 : _b.id
                })
            });
            const asyncResponse = new AsyncResponse(this._driver, request);
            asyncResponse.on('change', (isDone, libraryResponse) => {
                if (isDone) {
                    if (asyncResponse.error) {
                        reject(asyncResponse.error);
                    }
                    const libraryData = libraryResponse ? mapResponseToLibraryData(libraryResponse) : undefined;
                    resolve(libraryData);
                }
            });
        });
    }
    _permanentlyDeleteLibrary(_) {
        throw new Error('permanentlyDeleteLibrary not supported by LocalDriver, use removeLibrary instead');
    }
    _removeLibrary(action = 'remove') {
        // Prevent unnecessary refetching of deleted libraries
        if (action === 'remove') {
            LibraryAbortController.getInstance(this._library.id).abort();
        }
        const actionPromise = this._driver.fetch(`/libraries/${this._library.id}?action=${action}`, { method: 'DELETE' }).then(() => {
            // SHARED-2544: Remove instace of library from abort controller's cache after library removal
            // as this will interfere with fetching restored libraries
            if (action === 'remove') {
                LibraryAbortController.removeInstance(this._library.id);
            }
        });
        return actionPromise;
    }
    _moveLibrary() {
        return this._driver.moveLibrary(this._library.id, this.action.data.team.id);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class LocalParallelOperation extends ParallelOperation {
    constructor() {
        super(...arguments);
        this._actionMappers = {
            uploadComponent: async (action) => {
                const path = await this._driver.stageRepresentationForCommit(action.library, action.data.file, action.data.type);
                return Object.assign(Object.assign({}, action), { data: { path }, originalAction: action });
            }
        };
    }
    supportsAction(action) {
        return action.name === 'uploadComponent';
    }
}

/**
 * A transfer operation is an operation to move or copy elements or groups.
 * Due to the cross-library nature of these operations, these operations may
 * need to act on two different libraries multiple times.
 */
class LocalMoveCopyElementOperation extends MoveCopyElementOperation {
    async _doMoveCopyRequest(isMove, sourceLibrary, targetLibrary, elementIds) {
        const sourceId = this._library.id;
        const targetId = targetLibrary.id;
        const response = await this._driver.fetch(`/libraries/${targetId}/elements`, {
            method: 'POST',
            headers: {
                'If-Match': targetLibrary.etag
            },
            body: JSON.stringify({
                [isMove ? 'self' : 'source']: {
                    id: sourceId,
                    elements: elementIds,
                    etag: this._library.etag
                }
            })
        });
        const json = await response.json();
        return {
            elements: json.elements.map(mapResponseToElementData),
            etag: response.headers.get('ETag'),
            sourceEtag: response.headers.get('Source-ETag')
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class MoveCopyGroupOperation extends Operation {
    get action() {
        return this._actions[0];
    }
    supportsAction(action) {
        return ['moveGroup', 'copyGroup', 'dependent'].includes(action.name);
    }
    addAction(action) {
        if (!this.supportsAction(action)) {
            return false;
        }
        const lastAction = this._actions[this._actions.length - 1];
        if (!lastAction && action.name !== 'dependent') {
            return super.addAction(action);
        }
        if (action.name !== 'dependent') {
            return false;
        }
        return super.addAction(action);
    }
    async execute() {
        var _a, _b;
        const isMove = this.action.name === 'moveGroup';
        const sourceId = this._library.id;
        const targetLibrary = (_a = this.action.link) === null || _a === void 0 ? void 0 : _a.library;
        const targetId = targetLibrary === null || targetLibrary === void 0 ? void 0 : targetLibrary.id;
        const groupId = extractGroupId(this.action.path);
        const response = await this._driver.fetch(`/libraries/${targetId}/groups`, {
            method: 'POST',
            headers: {
                'If-Match': targetLibrary === null || targetLibrary === void 0 ? void 0 : targetLibrary.etag
            },
            body: JSON.stringify({
                [isMove ? 'self' : 'source']: {
                    id: sourceId,
                    group_id: groupId,
                    include_contents: (_b = this.action.flags) === null || _b === void 0 ? void 0 : _b.includeElements,
                    etag: this._library.etag
                }
            })
        });
        const newGroupData = await response.json();
        let linkedActions;
        let actions;
        if (targetLibrary === this._library) {
            linkedActions = [];
            actions = this._actions.map(action => {
                if (action.name !== 'dependent') {
                    return action;
                }
                return Object.assign(Object.assign({}, action), { data: newGroupData, originalAction: action });
            });
        }
        else {
            actions = this._actions;
            linkedActions = this._actions.map(action => (Object.assign(Object.assign({}, action.link), { data: newGroupData, originalAction: action.link })));
        }
        // If this operation succeeds, we wait for the change notification to update the target library.
        // This operation is only performed optimistically on the source library for now. The reason for this
        // is that the moveGroup/copyGroup APIs do not provide us the feedback needed to display and reconcile
        // the optimistic state on that target library. This may change in the future.
        // The result of this is that there will be a lag between when the elements disappear from one library
        // and appear in the other. This is considered an acceptable compromise in the short-term.
        // linkedEtag intentionally left blank, because we are relying on the pull to update the library to the
        // correct state.
        return { actions, etag: response.headers.get('Source-ETag'), linkedActions };
    }
}
__decorate([
    validatesOperation
], MoveCopyGroupOperation.prototype, "execute", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const MAX_SILENT_RETRIES = 3;
class SSENotificationEventSource extends EventEmitter {
    constructor(url) {
        super();
        this._listenedEvents = new Set();
        this._errorCount = 0;
        this._eventSource = new EventSource(url);
        this._eventSource.onopen = () => {
            this._errorCount = 0;
        };
        this._eventSource.onerror = (error) => {
            this._errorCount += 1;
            if (this._errorCount >= MAX_SILENT_RETRIES) {
                this.close();
                this.emit('error', error);
            }
        };
    }
    on(eventName, callback) {
        super.on(eventName, callback);
        if (!this._listenedEvents.has(eventName)) {
            this._listenedEvents.add(eventName);
            // We should probably clean this up, but on the other hand ¯\_(ツ)_/¯
            this._eventSource.addEventListener(eventName, (message) => {
                Logger$1.log(`[NOTIFICATIONS] Received event: ${eventName}`);
                try {
                    this.emit(eventName, JSON.parse(message.data));
                }
                catch (_a) {
                    if (!message.data) {
                        this.emit('error', new LibraryError('INVALID_RESPONSE', 'Received invalid response (no data)'));
                    }
                    else {
                        this.emit('error', new LibraryError('INVALID_JSON', 'Received invalid JSON'));
                    }
                }
            });
        }
        return this;
    }
    close() {
        this.removeAllListeners();
        this._eventSource.close();
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class WebsocketNotificationEventSource extends EventEmitter {
    constructor(url) {
        super();
        // Make sure the url has right protocol for websocket connection.
        const wsUrl = url.replace(/http(s?):\/\//, 'ws$1://');
        this._ws = new WebSocket(wsUrl);
        this._ws.addEventListener('message', (event) => {
            try {
                const { type, message } = JSON.parse(event.data);
                Logger$1.log(`[NOTIFICATIONS] Received event: ${type}`);
                this.emit(type, message);
            }
            catch (_a) {
                this.emit('error', new LibraryError('INVALID_JSON', 'Received invalid JSON'));
            }
        });
        this._ws.addEventListener('error', (error) => {
            this.close();
            this.emit('error', error);
        });
    }
    get isOpen() {
        return this._ws.readyState === this._ws.OPEN;
    }
    close() {
        if (this.isOpen) {
            this.removeAllListeners();
            this._ws.close();
        }
    }
}

var browser = function () {
  throw new Error(
    'ws does not work in the browser. Browser clients must use the native ' +
      'WebSocket object'
  );
};

var WebSocket$1 = browser;

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class NodeWebsocketNotificationEventSource extends EventEmitter {
    constructor(url) {
        super();
        // Make sure the url has right protocol for websocket connection.
        const wsUrl = url.replace(/http(s?):\/\//, 'ws$1://');
        this._ws = new WebSocket$1(wsUrl);
        this._ws.addEventListener('message', (event) => {
            try {
                const { type, message } = JSON.parse(event.data);
                Logger$1.log(`[NOTIFICATIONS] Received event: ${type}`);
                this.emit(type, message);
            }
            catch (_a) {
                this.emit('error', new LibraryError('INVALID_JSON', 'Received invalid JSON'));
            }
        });
        this._ws.addEventListener('error', (error) => {
            this.close();
            this.emit('error', error);
        });
    }
    get isOpen() {
        return this._ws.readyState === this._ws.OPEN;
    }
    close() {
        if (this.isOpen) {
            this.removeAllListeners();
            this._ws.close();
        }
    }
}

var _a$1, _b, _c;
var NotificationEventSource = typeof window === 'undefined'
    ? NodeWebsocketNotificationEventSource
    : ((_c = (_b = (_a$1 = window === null || window === void 0 ? void 0 : window.navigator) === null || _a$1 === void 0 ? void 0 : _a$1.userAgent) === null || _b === void 0 ? void 0 : _b.startsWith) === null || _c === void 0 ? void 0 : _c.call(_b, 'Adobe UXP Runtime'))
        ? WebsocketNotificationEventSource
        : SSENotificationEventSource;

function isUpdateRequiredInfo(info) {
    return 'updateRequired' in info;
}
class Connector {
    constructor(vulcanInterface, vulcanMessage, timeout = 2000, launchTimeout = 8000) {
        this.vulcanInterface = vulcanInterface;
        this.VulcanMessage = vulcanMessage;
        this._timeout = timeout;
        this._launchTimeout = launchTimeout;
    }
    _generateListener(callback, type) {
        const listener = (message) => {
            clearTimeout(this._timeoutId);
            this.removeListener(listener, type);
            callback(message);
        };
        return listener;
    }
    async _connectionInfoHandler(message, abortSignal) {
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            // At this point the overarching connect workflow has timed out.
            // So we do not want to throw here
            return;
        }
        if (!message) {
            throw new LibraryError('REQUEST_FAILED', 'No Vulcan response received');
        }
        try {
            const payload = JSON.parse(this.getPayload(message));
            const apiVersionInfo = {
                apiVersion: payload.apiVersion,
                apiMinVersion: payload.apiMinVersion,
                apiMaxVersion: payload.apiMaxVersion
            };
            if (payload.updateRequired) {
                return Object.assign(Object.assign({}, apiVersionInfo), { updateRequired: payload.updateRequired });
            }
            if (payload.serviceToken && payload.serviceHostname) {
                return Object.assign(Object.assign({}, apiVersionInfo), { token: payload.serviceToken, hostname: payload.serviceHostname });
            }
            throw new LibraryError('INVALID_RESPONSE', 'Incorrect data was returned via Vulcan');
        }
        catch (error) {
            throw new LibraryError('INVALID_RESPONSE', 'Incorrect data was returned via Vulcan', undefined, error);
        }
    }
    async _launchProcessHandler(message, abortSignal) {
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            // At this point the overarching connect workflow has timed out.
            // So we do not want to throw here
            return;
        }
        if (!message) {
            throw new LibraryError('REQUEST_FAILED', 'No Vulcan response received');
        }
        return this._requestConnectionInfo(abortSignal);
    }
    _launchProcess(abortSignal) {
        return new Promise(resolve => {
            const launchProcessCallback = this._generateListener((message) => resolve(this._launchProcessHandler(message, abortSignal)), this.getMessageType('INITIALIZE'));
            this._timeoutId = setTimeout(launchProcessCallback, this._launchTimeout);
            this.sendMessage(launchProcessCallback, this.getMessageType('INITIALIZE'));
            this.launchApp(launchProcessCallback);
        });
    }
    _requestConnectionInfo(abortSignal) {
        return new Promise(resolve => {
            const connectionInfoCallback = this._generateListener((message) => {
                resolve(this._connectionInfoHandler(message, abortSignal));
            });
            this._timeoutId = setTimeout(connectionInfoCallback, this._timeout);
            this.sendMessage(connectionInfoCallback);
        });
    }
    async connect(abortSignal) {
        // Always try connecting first. (local process running bug where connection info is not broadcasted)
        return this._requestConnectionInfo(abortSignal).catch(async (err) => {
            if (!(await this.isAppRunning().catch(() => false))) {
                return this._launchProcess(abortSignal);
            }
            throw err;
        });
    }
    getMessageType(key) {
        return this.messageTypes[key];
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const defaultElementSort = {
    field: 'modifiedDate',
    direction: 'descending'
};
const DEFAULT_FETCH_OPTIONS = {
    reconnectOnErrors: [401, 403],
    reconnectOnNoResponse: true
};
class LocalDriver extends Driver {
    constructor(core, connector, options = {}) {
        super(core, connector);
        this._libraryChangeListener = () => {
            return;
        };
        this._renditionCacheChangeListener = () => {
            /**/
        };
        this._lastNotificationPayload = {};
        this._operationTypes = [
            BatchOperation,
            ContentOperation,
            LocalSingleOperation,
            LocalMoveCopyElementOperation,
            MoveCopyGroupOperation,
            LocalParallelOperation
        ];
        this._handleConfigurationMutation = (data) => {
            const configurationUpdate = new Configuration(data);
            if (this._needToReconnect(configurationUpdate)) {
                this.reconnect();
            }
            this._config = configurationUpdate;
            this.emit('configChange');
            return this.config;
        };
        this._handleRenditionCacheMutation = (data) => {
            this._renditionCacheChangeListener(mapResponseToElementData(data));
        };
        this._handleLibraryMutation = (payload) => {
            if (!payload) {
                return;
            }
            // See what changed / was removed
            const responseKeys = new Set(Object.keys(payload));
            const libraryIds = Object.keys(this._lastNotificationPayload).filter(libraryId => {
                const libraryResponseEntry = payload[libraryId];
                responseKeys.delete(libraryId);
                return (!libraryResponseEntry
                    || (typeof libraryResponseEntry !== 'number' && typeof libraryResponseEntry !== 'string'));
            });
            // Add in any new libraries
            libraryIds.push(...responseKeys);
            this._lastNotificationPayload = Object.keys(payload).reduce((memo, key) => {
                const value = payload[key];
                if (typeof value === 'number' || typeof value === 'string') {
                    if (value) {
                        // deleted libraries have empty string values
                        memo[key] = value;
                    }
                }
                else {
                    memo[key] = value.modified_date;
                }
                return memo;
            }, {});
            this._libraryChangeListener(libraryIds);
        };
        this._options = options;
    }
    getLibrary(library, options) {
        return this._getLibraryById(library.id, options);
    }
    getElements(library, ...args) {
        return this._getElementsByLibraryId(library.id, ...args);
    }
    getRemovedElements(library, ...args) {
        return this._getRemovedElementsByLibraryId(library.id, ...args);
    }
    getDocumentationElements(library, ...args) {
        return this._getDocumentationElementsByLibraryId(library.id, ...args);
    }
    getElement(library, elementId) {
        return this._getElement(library.id, elementId);
    }
    reconnect() {
        var _a;
        (_a = this._notificationEventSource) === null || _a === void 0 ? void 0 : _a.close();
        if (this.isConnected) {
            return super.reconnect();
        }
        return Promise.resolve();
    }
    async _handleConnected(data) {
        if (isUpdateRequiredInfo(data)) {
            this._handleConfigurationMutation({
                config: {},
                environment: this._config.environment,
                processInfo: {
                    updateRequired: data.updateRequired,
                    apiVersion: data.apiVersion
                }
            });
            throw new LibraryError('CONNECTION_FAILED', `LocalDriver failed to connect - ${data.updateRequired} update required`);
        }
        this._hostname = data.hostname;
        this._token = data.token;
        this._cloudParams = data.cloudParams;
        this._notificationEventSource = new NotificationEventSource(`${this._hostname}/notifications?token=${this._token}`);
        this._notificationEventSource.on('error', (error) => {
            if (error instanceof LibraryError && error.libraryErrorCode === 'INVALID_JSON') {
                Logger$1.log('[NOTIFICATIONS] Received invalid JSON object.');
                return;
            }
            this.reconnect();
        });
        await this.getConfiguration();
        this._notificationEventSource.on('configurationMutation', this._handleConfigurationMutation.bind(this));
        this._notificationEventSource.on('libraryMutation', this._handleLibraryMutation.bind(this));
        this._notificationEventSource.on('renditionCacheMutation', this._handleRenditionCacheMutation.bind(this));
    }
    _handleDisconnected() {
        var _a;
        (_a = this._notificationEventSource) === null || _a === void 0 ? void 0 : _a.close();
    }
    get cloudParams() {
        var _a, _b;
        if (!this._cloudParams || !((_a = this.config.user) === null || _a === void 0 ? void 0 : _a.id)) {
            return undefined;
        }
        return Object.assign(Object.assign({}, this._cloudParams), { userId: (_b = this.config.user) === null || _b === void 0 ? void 0 : _b.id });
    }
    getCloudDriver() {
        if (!this.cloudParams) {
            return undefined;
        }
        const connector = async () => {
            const { userId, clientId, clientSecret, scopes, core } = this.cloudParams;
            const { access_token } = await this.fetchAccessToken(userId, clientId, clientSecret, scopes);
            return {
                env: this.config.environment,
                core,
                token: access_token
            };
        };
        return new CloudDriver$1(this._core, connector);
    }
    fetchAccessToken(userId, clientId, clientSecret, scopes) {
        var _a;
        return this.fetch('/configuration/access_token', {
            method: 'POST',
            body: JSON.stringify({ userId: (_a = this._config.user) === null || _a === void 0 ? void 0 : _a.id, clientId, clientSecret, scopes })
        }).then(res => res.json());
    }
    _getElement(libraryId, elementId) {
        return this.fetch(`/libraries/${libraryId}/elements/${elementId}`)
            .then(res => res.json())
            .then(mapResponseToElementData);
    }
    _getElementsOfType(type, libraryId, _sort = defaultElementSort, etag, signal) {
        return __asyncGenerator(this, arguments, function* _getElementsOfType_1() {
            // TODO: Sort
            const headers = {};
            if (etag) {
                headers['if-none-match'] = etag;
            }
            const res = yield __await(this.fetch(`/libraries/${libraryId}/${type}`, { headers, signal }));
            const json = yield __await(res.json());
            yield yield __await(json.elements.map(mapResponseToElementData));
        });
    }
    _getElementsByLibraryId(libraryId, sort = defaultElementSort, etag, limit, signal) {
        return __asyncGenerator(this, arguments, function* _getElementsByLibraryId_1() {
            yield __await(yield* __asyncDelegator(__asyncValues(this._getElementsOfType('elements', libraryId, sort, etag, signal))));
        });
    }
    getSearchResults(searchQuery, filters, elementSort, signal) {
        return __asyncGenerator(this, arguments, function* getSearchResults_1() {
            filters.elements_only = true;
            let orderBy = elementSort.field === 'name' ? 'name' : 'modified_date';
            if (elementSort.direction === 'descending') {
                orderBy = `-${orderBy}`;
            }
            const responseMapper = (response) => { var _a, _b; return (_b = (_a = response.results) === null || _a === void 0 ? void 0 : _a.map(mapResponseToElementData)) !== null && _b !== void 0 ? _b : []; };
            const headers = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                signal
            };
            const limit = 300;
            // We only group search results by type so if the section type is anything
            // other than "type" we just do a normal search of all types
            if (elementSort.sectionType !== 'type') {
                headers.body = JSON.stringify({
                    q: searchQuery,
                    order_by: orderBy,
                    filters,
                    limit
                });
                yield __await(yield* __asyncDelegator(__asyncValues(this.fetchAllPages('/search', headers, responseMapper))));
            }
            else {
                // If there is a list of type sections we want to fetch search results for each type separately
                // so that we get our results as a list of ordered elements grouped by element type.
                for (const section of elementSort.sections) {
                    filters.element_types = filters.element_types = [section];
                    headers.body = JSON.stringify({
                        q: searchQuery,
                        order_by: orderBy,
                        filters,
                        limit
                    });
                    yield __await(yield* __asyncDelegator(__asyncValues(this.fetchAllPages('/search', headers, responseMapper))));
                }
            }
        });
    }
    fetchAllPages(firstUrl, headers, responseMapper) {
        var _a, _b, _c, _d;
        return __asyncGenerator(this, arguments, function* fetchAllPages_1() {
            let nextUrl = firstUrl;
            while (nextUrl) {
                const response = yield __await(this.fetch(nextUrl, headers).then(res => res.json()));
                yield yield __await(responseMapper(response));
                nextUrl = (_b = (_a = response._links) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.uri;
                const newBody = (_d = (_c = response._links) === null || _c === void 0 ? void 0 : _c.next) === null || _d === void 0 ? void 0 : _d.body;
                if (newBody) {
                    headers.body = JSON.stringify(newBody);
                }
            }
        });
    }
    _getDocumentationElementsByLibraryId(libraryId, sort = defaultElementSort, etag) {
        return __asyncGenerator(this, arguments, function* _getDocumentationElementsByLibraryId_1() {
            yield __await(yield* __asyncDelegator(__asyncValues(this._getElementsOfType('documentation_elements', libraryId, sort, etag))));
        });
    }
    _getRemovedElementsByLibraryId(libraryId, sort = defaultElementSort, etag) {
        return __asyncGenerator(this, arguments, function* _getRemovedElementsByLibraryId_1() {
            yield __await(yield* __asyncDelegator(__asyncValues(this._getElementsOfType('removed_elements', libraryId, sort, etag))));
        });
    }
    async getTeams() {
        const response = await this.fetch('/teams');
        const data = await response.json();
        return isTeamsResponse(data) ? data.teams.map(mapResponseToTeamData) : [];
    }
    async getProjects() {
        var _a, _b;
        const response = await this.fetch('/projects');
        const data = await response.json();
        return (_b = (_a = data === null || data === void 0 ? void 0 : data.projects) === null || _a === void 0 ? void 0 : _a.map(mapProjectsResponseToTeamData)) !== null && _b !== void 0 ? _b : [];
    }
    async getProjectGradient(project) {
        const response = await this.fetch(`/projects/${project.id}/gradient`);
        const data = await response.json();
        return data.gradient ? mapResponseToGradientData(data.gradient) : undefined;
    }
    getGroups(_libraryId) {
        return __asyncGenerator(this, arguments, function* getGroups_1() {
            yield yield __await(Promise.resolve(undefined));
        });
    }
    getLibraries() {
        return __asyncGenerator(this, arguments, function* getLibraries_1() {
            // The includeRenditionGrid flag on this endpoint will include only elements in the rendition grid, but setting it to false will not cause all elements to be returned.
            // The paths of renditions for image elements in the rendition grid will only be returned when cached.
            // This flag will not cause the imaging service to generate renditions like getRenditionPath would.
            let endpoint = '/libraries';
            if (!this._options.ignoreRenditionGrids) {
                endpoint += '?includeRenditionGrid=true';
            }
            yield yield __await(this.fetch(endpoint)
                .then(res => res.json())
                .then((res) => isLibrariesResponse(res)
                ? res.libraries.map(data => mapResponseToLibraryData(data, this._options.readOnly))
                : []));
        });
    }
    getLibrariesList() {
        return __asyncGenerator(this, arguments, function* getLibrariesList_1() {
            yield yield __await(Promise.resolve(undefined));
        });
    }
    getLibrariesPage() {
        return __asyncGenerator(this, arguments, function* getLibrariesPage_1() {
            yield yield __await(Promise.resolve(undefined));
        });
    }
    _getAllElements(libraryId, options) {
        var _a, _b;
        return __asyncGenerator(this, arguments, function* _getAllElements_1() {
            var _c, e_1, _d, _e;
            const elementTypes = [
                ['elements', '_getElementsByLibraryId'],
                ['documentationElements', '_getDocumentationElementsByLibraryId'],
                ['removedElements', '_getRemovedElementsByLibraryId']
            ];
            // If the elements aren't loaded yet, update the library page by page
            // Otherwise, load them all at once.
            const updateData = {};
            // TODO: We want to run all element type iterators at the same time. Right now it doesn't matter since we only deal with normal elements.
            for (const [type, generator] of elementTypes) {
                if (options.types.includes(type)) {
                    try {
                        for (var _f = true, _g = (e_1 = void 0, __asyncValues(this[generator](libraryId, options.sort, options.etag, undefined, (_a = options.abortController) === null || _a === void 0 ? void 0 : _a.signal))), _h; _h = yield __await(_g.next()), _c = _h.done, !_c;) {
                            _e = _h.value;
                            _f = false;
                            try {
                                const page = _e;
                                updateData[type] = updateData[type] || [];
                                (_b = updateData[type]) === null || _b === void 0 ? void 0 : _b.push(...page);
                                if (options.loadProgressively) {
                                    yield yield __await({ [type]: updateData[type] });
                                }
                            }
                            finally {
                                _f = true;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (!_f && !_c && (_d = _g.return)) yield __await(_d.call(_g));
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
            yield yield __await(Object.assign({ areElementsLoaded: true }, (options.loadProgressively ? {} : updateData)));
        });
    }
    async getLibraryById(libraryId, options) {
        const { value } = await this._getLibraryById(libraryId, options).next();
        return value;
    }
    _getLibraryById(libraryId, options = {}) {
        var _a;
        return __asyncGenerator(this, arguments, function* _getLibraryById_1() {
            const etag = options.etag;
            try {
                const headers = {};
                if (etag) {
                    headers['if-none-match'] = etag;
                }
                let fetchOptions;
                if (options.optimisticFetch !== undefined) {
                    fetchOptions = { optimisticFetch: options.optimisticFetch };
                }
                // The includeRenditionGrid flag on this endpoint is equivalent to saying do not include elements except those in the rendition grid
                let endpoint = `/libraries/${libraryId}`;
                if (!this._options.ignoreRenditionGrids) {
                    endpoint += '?includeRenditionGrid=true';
                }
                const res = yield __await(this.fetch(endpoint, { headers }, fetchOptions));
                // If we receive a 202 here, the process is optimistically loading the library to disk...
                // we can return early
                if (res.status === 202) {
                    return yield __await(void 0);
                }
                const json = yield __await(res.json());
                json.etag = res.headers.get('ETag');
                // We do not care about the updated elements from this call unless they are rendition grid elements.
                // If all elements need to be updated, that will be done by this._getAllElements.
                if (options.elementParams) {
                    delete json.elements;
                }
                else {
                    // Elements path should exist on library data to append new elements, in case of empty library
                    (_a = json.elements) !== null && _a !== void 0 ? _a : (json.elements = []);
                }
                const libraryResponse = mapResponseToLibraryData(json, this._options.readOnly);
                yield yield __await(libraryResponse);
            }
            catch (error) {
                if (!(error instanceof RequestError && error.requestErrorCode === 'NOT_MODIFIED' && options.elementParams)) {
                    throw error;
                }
            }
            if (options.elementParams) {
                yield __await(yield* __asyncDelegator(__asyncValues(this._getAllElements(libraryId, Object.assign(Object.assign({}, options.elementParams), { etag: options.firstElementsLoad ? undefined : etag })))));
            }
        });
    }
    followLibrary(assetId, libraryId) {
        return this.fetch('/libraries', {
            method: 'POST',
            body: JSON.stringify({
                follow: true,
                type: 'collab',
                id: libraryId,
                assetId
            })
        }).then(( /** bookmark */) => {
            // The bookmark data is basically a copy of the request body.
            // It doesn't have anything useful to the caller, so we won't send it back.
            return;
        });
    }
    moveLibrary(libraryId, folderId) {
        return new Promise((resolve, reject) => {
            const request = this.fetch('/libraries', {
                method: 'POST',
                body: JSON.stringify({
                    self: libraryId,
                    team_id: folderId
                })
            });
            const asyncResponse = new AsyncResponse(this, request);
            asyncResponse.on('change', (isDone, libraryResponse) => {
                if (isDone) {
                    if (asyncResponse.error) {
                        reject(asyncResponse.error);
                    }
                    else if (libraryResponse) {
                        resolve(mapResponseToLibraryData(libraryResponse));
                    }
                    else {
                        resolve();
                    }
                }
            });
        });
    }
    importLibrary(file, callback = () => undefined) {
        if (typeof file !== 'string') {
            throw new Error('Input must be a local path in local mode.');
        }
        const request = this.fetch('/libraries', {
            method: 'POST',
            body: JSON.stringify({
                source: {
                    path: file
                }
            })
        });
        const asyncResponse = new AsyncResponse(this, request);
        asyncResponse.on('change', (isDone, libraryResponse) => {
            if (isDone) {
                const libraryData = libraryResponse ? mapResponseToLibraryData(libraryResponse) : undefined;
                callback(asyncResponse.error, libraryData);
            }
        });
        return asyncResponse;
    }
    exportLibrary(library, path, callback = () => undefined) {
        if (!path) {
            // TODO
            throw new Error('Destination path is required in local mode.');
        }
        const request = this.fetch(`/libraries/${library.id}/export`, {
            method: 'POST',
            body: JSON.stringify({ path })
        });
        const asyncResponse = new AsyncResponse(this, request);
        asyncResponse.on('change', (isDone) => {
            if (isDone) {
                callback(asyncResponse.error);
            }
        });
        return asyncResponse;
    }
    async abortOperation(operationId) {
        return this.fetch(operationId, {
            method: 'DELETE'
        });
    }
    getRenditionUrl(element, size) {
        return `${this._hostname}/libraries/${element.library.id}/elements/${element.elementId}/renditions/${size}?token=${this._token}`;
    }
    getAuthenticatedThumbnailURL(element, size) {
        return this.fetch(`/libraries/${element.library.id}/elements/${element.elementId}/renditions/${size}/url`, {
            headers: {
                'cache-control': 'none'
            }
        })
            .then(res => res.json())
            .then(res => res.url);
    }
    getRenditionPath(libraryId, elementId, size) {
        const controllerInstance = LibraryAbortController.getInstance(libraryId);
        return this.fetch(`/libraries/${libraryId}/elements/${elementId}/renditions/${size}/path`, {
            headers: {
                'cache-control': 'none' // if the rendition does not exist, it will be generated and added to the cache
            },
            signal: controllerInstance.signal
        })
            .then(res => res.json())
            .then(res => res.path);
    }
    getRendition(element, size) {
        return this.fetch(`/libraries/${element.library.id}/elements/${element.elementId}/renditions/${size}`);
    }
    getRepresentationContent(representation) {
        return this.fetch(`/libraries/${representation.library.id}/elements/${representation.element.elementId}/representations/${representation.id}`);
    }
    setLibraryChangeListener(libraries, callback) {
        this._libraryChangeListener = callback;
    }
    setRenditionCacheChangeListener(callback) {
        this._renditionCacheChangeListener = callback;
    }
    setFontDataChangeListener(callback) {
        var _a;
        this.removeFontDataChangeListeners();
        (_a = this._notificationEventSource) === null || _a === void 0 ? void 0 : _a.on('fontDataMutation', callback);
    }
    setSyncStateListener(callback) {
        var _a, _b;
        (_a = this._notificationEventSource) === null || _a === void 0 ? void 0 : _a.removeAllListeners('syncMutation');
        (_b = this._notificationEventSource) === null || _b === void 0 ? void 0 : _b.on('syncMutation', callback);
    }
    removeLibraryChangeListener() {
        var _a;
        (_a = this._notificationEventSource) === null || _a === void 0 ? void 0 : _a.removeAllListeners('libraryMutation');
    }
    removeFontDataChangeListeners() {
        var _a;
        (_a = this._notificationEventSource) === null || _a === void 0 ? void 0 : _a.removeAllListeners('fontDataMutation');
    }
    removeSyncStateListener() {
        var _a;
        (_a = this._notificationEventSource) === null || _a === void 0 ? void 0 : _a.removeAllListeners('syncMutation');
    }
    removeRenditionCacheChangeListener() {
        var _a;
        (_a = this._notificationEventSource) === null || _a === void 0 ? void 0 : _a.removeAllListeners('renditionCacheMutation');
    }
    _needToReconnect(configUpdate) {
        var _a, _b, _c;
        return (
        // We were previously authenticated with 1 user and that information has changed in the process....
        // Reconnect
        (((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.id) && this.config.user.id !== ((_c = configUpdate.user) === null || _c === void 0 ? void 0 : _c.id)) || false);
    }
    async getConfiguration() {
        const response = await this.fetch('/configuration');
        const json = await response.json();
        this._handleConfigurationMutation(json);
        return this.config;
    }
    async updateRenditionCacheConfiguration(renditionSizes, fullRenditionConfig) {
        if (!renditionSizes && !fullRenditionConfig) {
            return this.config;
        }
        await this.updateConfiguration({
            RENDITION_SIZES: renditionSizes,
            FULL_RENDITION_CONFIG: fullRenditionConfig
        }).catch(err => {
            Logger$1.error(`Unable to update process configuration. ${err}`);
        });
        return this.config;
    }
    async updateConfiguration(update) {
        if (Object.keys(update).length) {
            const response = await this.fetch('/configuration', {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(update)
            });
            const json = await response.json();
            this._handleConfigurationMutation(json);
        }
        return this.config;
    }
    async setLocalSetting(key, value) {
        if (value === undefined) {
            value = null;
        }
        await this.updateConfiguration(Object.fromEntries([[key, value]]));
        this._config.config[key] = value;
    }
    getLocalSetting(key) {
        var _a;
        return (_a = this._config.config) === null || _a === void 0 ? void 0 : _a[key];
    }
    getInstalledVersion(appCode) {
        return this._config.installedApps
            .filter(app => app.code.toLowerCase() === appCode.toLowerCase())
            .map(version => version.version)
            .sort(compareVersions$1)[0];
    }
    async sendAction(applicationAction) {
        return this.fetch('/action', { method: 'POST', body: applicationAction.toJSON() });
    }
    async openInCCD(path) {
        return this.fetch('/action/open_ccd', { method: 'POST', body: JSON.stringify({ path }) });
    }
    async fetch(path, init, options = {}) {
        var _a, _b, _c, _d;
        init = init || {};
        init.headers = init.headers || {};
        init.headers.token = this._token;
        init.headers['Content-Type'] = init.headers['Content-Type'] || 'application/json';
        // TODO: Get actual client version
        init.headers['x-client-version'] = '15';
        options = Object.assign(Object.assign({}, DEFAULT_FETCH_OPTIONS), options);
        if (this._options.optimistic && (options.optimisticFetch === undefined || options.optimisticFetch === true)) {
            init.headers['x-optimism'] = 'true';
        }
        init.signal = init.signal
            ? combineSignals(init.signal, (_a = this._abortController) === null || _a === void 0 ? void 0 : _a.signal)
            : (_b = this._abortController) === null || _b === void 0 ? void 0 : _b.signal;
        try {
            const response = await fetch(`${/^https?:\/\//.test(path) ? '' : this._hostname}${path}`, init);
            if (response.status >= 300) {
                const responseBody = await response.text();
                const errorCode = responseBody.replace(/["]+/g, '');
                throw getRequestError(response, errorCode);
            }
            return response;
        }
        catch (e) {
            if (RequestError.isRequestError(e)) {
                // By default, reconnect on 401 and 403.
                // Process REST API can throw 401 (invalid process token) or 403 (If no library collections are loaded).
                // At this point we assume that the process has restarted or the authenticated user state has changed.
                const shouldReconnect = ((_c = options === null || options === void 0 ? void 0 : options.reconnectOnErrors) === null || _c === void 0 ? void 0 : _c.includes((_d = e.response) === null || _d === void 0 ? void 0 : _d.status))
                    && this.isConnected;
                if (shouldReconnect) {
                    this.reconnect();
                }
                else if (!shouldReconnect && e.name === ABORT_ERROR) {
                    return new Response('{}');
                }
            }
            else if (e.message === 'Failed to fetch' && (options === null || options === void 0 ? void 0 : options.reconnectOnNoResponse)) {
                // More than likely, libraries process shut down.
                Logger$1.warn(`Fetch request failed to respond: ${e}`);
                this.reconnect();
            }
            else if (e.message === 'Network request failed') {
                // Throws when Process REST API is disconnected in UXP
                Logger$1.warn(`Network request failed to respond: ${e}`);
                this.reconnect();
            }
            throw e;
        }
    }
    async copyFile(source, destination, allowOverride = false) {
        const result = await this.fetch('/util/file/copy', {
            method: 'POST',
            body: JSON.stringify({ source, destination, allowOverride: Boolean(allowOverride) })
        }, { reconnectOnNoResponse: true, reconnectOnErrors: [401] });
        const json = await result.json();
        return json.path;
    }
    async getFileSize(path) {
        const result = await this.fetch('/util/file/size', {
            method: 'POST',
            body: JSON.stringify({ path })
        });
        const json = await result.json();
        return json.size;
    }
    getRenditionGrid(library) {
        return library.renditionGrid;
    }
    async stageRepresentationForCommit(library, file, _type) {
        var _a, _b, _c;
        try {
            if (file instanceof File) {
                const result = await this.fetch('/util/file', {
                    method: 'POST',
                    headers: {
                        'Content-Type': (_b = getMimeTypes((_a = file.name) === null || _a === void 0 ? void 0 : _a.split('.')[1])) === null || _b === void 0 ? void 0 : _b[0]
                    },
                    body: file
                });
                const json = await result.json();
                return json.path;
            }
        }
        catch (error) {
            // if the fetch request explicitly failed we want to reject the promise
            if (((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status) === HttpStatus.INTERNAL_SERVER_ERROR) {
                return Promise.reject(error);
            }
            // otherwise, it might be a general uncaught exception from accessing File in UXP (undefined), so do nothing
        }
        return file.path;
    }
    async isSystemFontAvailable(fontName, matchFamily) {
        const result = await this.fetch(`/util/font/available`, {
            method: 'POST',
            body: JSON.stringify({ font_name: fontName, match_family: matchFamily })
        });
        const json = await result.json();
        return json.is_font_available;
    }
    async getFontData(fontId) {
        const result = await this.fetch(`/util/font/data`, {
            method: 'POST',
            body: JSON.stringify({ font_id: fontId })
        });
        const json = await result.json();
        return json.font_data;
    }
    async getTempDir(library) {
        if (!library || !library.id) {
            throw new LibraryError('INVALID_PARAMETER', 'Need to pass a library with an ID');
        }
        const result = await this.fetch(`/libraries/${library.id}/temp_dir`);
        const json = await result.json();
        return json.path;
    }
    getCollaborators(_assetId) {
        throw new LibraryError('NOT_IMPLEMENTED', 'LocalDriver.getCollaborators not implemented.');
    }
    ignoreLocalSyncEvents() {
        // For Local driver the sync status should only be driven by what process is doing.
        return true;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class HybridDriver extends CloudDriver$1 {
    constructor(core, _localConnector, _cloudConnector, options = {}) {
        super(core, () => _cloudConnector().then(p => (Object.assign({ samDisableOns: true }, p))));
        this._localConnector = _localConnector;
        this._cloudConnector = _cloudConnector;
        this._localDriver = new LocalDriver(core, _localConnector, Object.assign(Object.assign({}, options), { optimistic: true }));
    }
    connect() {
        return Promise.all([this.localDriver.connect(), super.connect()]).then(() => {
            /** empty **/
        });
    }
    get localDriver() {
        return this._localDriver;
    }
    call(library, fn, ...args) {
        return library.locallyManaged ? this._localDriver[fn](...args) : super[fn](...args);
    }
    _handleDisconnected() {
        super._handleDisconnected();
        if (this.localDriver.isConnected) {
            this.localDriver.disconnect();
        }
    }
    setLibraryChangeListener(libraries, callback) {
        this.localDriver.setLibraryChangeListener(libraries, callback);
    }
    setFontDataChangeListener(callback) {
        this.localDriver.setFontDataChangeListener(callback);
    }
    removeFontDataChangeListeners() {
        this.localDriver.removeFontDataChangeListeners();
    }
    getLibraries() {
        return this.localDriver.getLibraries();
    }
    getLibrary(library, options) {
        // If the library is locally managed, or we want to download the library locally
        // utilize the local driver to return library data from disk
        if (library.locallyManaged || (options === null || options === void 0 ? void 0 : options.optimisticFetch)) {
            return this.localDriver.getLibrary(library, options);
        }
        // otherwise return the cloud drivers library response
        return super.getLibrary(library, options);
    }
    getElements(library, sort, etag, limit, signal) {
        return this.call(library, 'getElements', sort, etag, limit, signal);
    }
    getElement(library, elementId) {
        return this.call(library, 'getElement', library, elementId);
    }
    async getLibraryById(id, options) {
        // Introducing the idea of passing locallManaged to options here
        // to allow for utilizing the local driver if we know the library is local.
        // Current use cases for this utility are situations where we do not know
        // the library yet so we fall back to cloud driver in these cases.
        if ((options === null || options === void 0 ? void 0 : options.optimisticFetch) || (options === null || options === void 0 ? void 0 : options.locallyManaged)) {
            return this._localDriver._getLibraryById(id, options).next();
        }
        return super.getLibraryById(id);
    }
    getRenditionUrl(element, size) {
        return this.call(element.library, 'getRenditionUrl', element, size);
    }
    getRendition(element, size) {
        return this.call(element.library, 'getRendition', element, size);
    }
    getRepresentationContent(representation) {
        return this.call(representation.library, 'getRepresentationContent', representation);
    }
    getOperationTypes(library) {
        return library.locallyManaged ? this._localDriver.getOperationTypes(library) : super.getOperationTypes(library);
    }
    operationFactory(Op, driver, library) {
        return new Op((library.locallyManaged ? this._localDriver : this), library);
    }
    ignoreLocalSyncEvents() {
        return this.localDriver.isConnected ? this.localDriver.ignoreLocalSyncEvents() : super.ignoreLocalSyncEvents();
    }
}

class VulcanInterface {
}

function getVulcanInterface(vulcanInterface) {
    if (isVulcan7(vulcanInterface)) {
        return new Vulcan7(vulcanInterface);
    }
    return new Vulcan5(vulcanInterface);
}
function isVulcan7(vulcan) {
    return vulcan.launchAppEx !== undefined;
}
class Vulcan extends VulcanInterface {
    constructor(vulcanInterface) {
        super();
        this._specifer = vulcanLibrariesTargetSpecifier;
        this._vulcanInterface = vulcanInterface;
    }
    addMessageListener(type, callback, obj) {
        this.vulcanInterface.addMessageListener(type, callback, obj);
    }
    removeMessageListener(type, callback, obj) {
        this.vulcanInterface.removeMessageListener(type, callback, obj);
    }
    dispatchMessage(message) {
        this.vulcanInterface.dispatchMessage(message);
    }
    getPayload(message) {
        return this.vulcanInterface.getPayload(message);
    }
}
class Vulcan5 extends Vulcan {
    constructor(vulcanInterface) {
        super(vulcanInterface);
        this._vulcanInterface = vulcanInterface;
        this._specifer = vulcanLibrariesTargetSpecifier;
    }
    get vulcanInterface() {
        return this._vulcanInterface;
    }
    getTargetSpecifiers() {
        return this.vulcanInterface.getTargetSpecifiers();
    }
    launchApp(focus, cmdLine) {
        return this.vulcanInterface.launchApp(this._specifer, focus, cmdLine);
    }
    isAppRunning() {
        return this.vulcanInterface.isAppRunning(this._specifer);
    }
    isAppInstalled() {
        return this.vulcanInterface.isAppInstalled(this._specifer);
    }
    getAppPath() {
        return this.vulcanInterface.getAppPath(this._specifer);
    }
}
class Vulcan7 extends Vulcan {
    constructor(vulcanInterface) {
        super(vulcanInterface);
        this._specifer = vulcanLibrariesSAPCode;
    }
    get vulcanInterface() {
        return this._vulcanInterface;
    }
    getTargetSpecifiers() {
        return this.vulcanInterface.getTargetSpecifiersEx();
    }
    launchApp(focus, cmdLine) {
        return this.vulcanInterface.launchAppEx(this._specifer, focus, cmdLine);
    }
    isAppRunning() {
        return this.vulcanInterface.isAppRunningEx(this._specifer);
    }
    isAppInstalled() {
        return this.vulcanInterface.isAppInstalledEx(this._specifer);
    }
    getAppPath() {
        return this.vulcanInterface.getAppPathEx(this._specifer);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CEPConnector extends Connector {
    constructor(vulcanInterface, vulcanMessage, timeout) {
        super(getVulcanInterface(vulcanInterface), vulcanMessage, timeout);
        this.messageTypes = {
            REQUEST: 'vulcan.SuiteMessage.cclibraries.api.QueryRequest',
            RESPONSE: 'vulcan.SuiteMessage.cclibraries.api.QueryResponse',
            INITIALIZE: 'vulcan.SuiteMessage.cclibraries.service.Initialized'
        };
    }
    removeListener(callback, type) {
        return this.vulcanInterface.removeMessageListener(type || this.messageTypes.RESPONSE, callback);
    }
    sendMessage(callback, type) {
        // Add listener
        this.vulcanInterface.addMessageListener(type || this.messageTypes.RESPONSE, callback);
        // Send the request
        if (type !== this.messageTypes.INITIALIZE) {
            const request = new this.VulcanMessage(this.messageTypes.REQUEST);
            request.setPayload(vulcanQueryRequestPayload);
            this.vulcanInterface.dispatchMessage(request);
        }
    }
    async isAppRunning() {
        return this.vulcanInterface.isAppRunning();
    }
    launchApp(_callback) {
        this.vulcanInterface.launchApp();
    }
    getPayload(message) {
        return this.vulcanInterface.getPayload(message);
    }
}
var cepConnector = (VulcanInterface, VulcanMessage, timeout = 8000) => {
    const connector = new CEPConnector(VulcanInterface, VulcanMessage, timeout);
    return (abortSignal) => connector.connect(abortSignal);
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class CCDConnector extends Connector {
    constructor(vulcanInterface, vulcanMessage, timeout) {
        super(getVulcanInterface(vulcanInterface), vulcanMessage, timeout);
        this.messageTypes = {
            REQUEST: 'cclibraries.api.QueryRequest',
            RESPONSE: 'cclibraries.api.QueryResponse',
            INITIALIZE: 'cclibraries.service.Initialized'
        };
    }
    _wrapHandler(callback) {
        return (type, message) => callback(message);
    }
    removeListener(callback, type) {
        return this.vulcanInterface.removeMessageListener(type || this.messageTypes.RESPONSE, callback);
    }
    sendMessage(callback, type) {
        // Add listener
        this.vulcanInterface.addMessageListener(type || this.messageTypes.RESPONSE, this._wrapHandler(callback));
        // Send the request
        if (type !== this.messageTypes.INITIALIZE) {
            const request = new this.VulcanMessage(this.messageTypes.REQUEST);
            request.data = vulcanQueryRequestPayload;
            this.vulcanInterface.dispatchMessage(request);
        }
    }
    async isAppRunning() {
        return this.vulcanInterface.isAppRunning();
    }
    launchApp(_callback) {
        this.vulcanInterface.launchApp();
    }
    getPayload(message) {
        return message;
    }
}
var ccdConnector = (VulcanInterface, VulcanMessage, timeout = 8000) => {
    const connector = new CCDConnector(VulcanInterface, VulcanMessage, timeout);
    return (abortSignal) => connector.connect(abortSignal);
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// This NodeConnector is for the node-js vulcan implementation used by Stager
// To debug vulcan messages in Stager you can add the flag SG_DEBUG_VULCAN=1 when opening Stager
class NodeConnector extends Connector {
    constructor(vulcanInterface, vulcanMessage, timeout) {
        super(getVulcanInterface(vulcanInterface), vulcanMessage, timeout);
        this.messageTypes = {
            REQUEST: 'cclibraries.api.QueryRequest',
            RESPONSE: 'cclibraries.api.QueryResponse',
            INITIALIZE: 'cclibraries.service.Initialized'
        };
    }
    _wrapHandler(callback) {
        return (message, _processName) => callback(message);
    }
    removeListener(callback, type) {
        return this.vulcanInterface.removeMessageListener(type || this.messageTypes.RESPONSE, callback);
    }
    sendMessage(callback, type) {
        // Add listener
        this.vulcanInterface.addMessageListener(type || this.messageTypes.RESPONSE, this._wrapHandler(callback));
        // Send the request
        if (type !== this.messageTypes.INITIALIZE) {
            const request = { message: vulcanQueryRequestPayload, type: type || this.messageTypes.REQUEST };
            this.vulcanInterface.dispatchMessage(request);
        }
    }
    async isAppRunning() {
        return this.vulcanInterface.isAppRunning();
    }
    launchApp(_callback) {
        this.vulcanInterface.launchApp();
    }
    getPayload(message) {
        return message;
    }
}
var nodeConnector = (VulcanInterface, VulcanMessage, timeout = 8000) => {
    const connector = new NodeConnector(VulcanInterface, VulcanMessage, timeout);
    return (abortSignal) => connector.connect(abortSignal);
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const LAUNCH_APP_RESPONSE = 'launched';
class UXPConnector extends Connector {
    constructor() {
        super(...arguments);
        this.messageTypes = {
            REQUEST: 'vulcan.SuiteMessage.cclibraries.api.QueryRequest',
            RESPONSE: 'vulcan.SuiteMessage.cclibraries.api.QueryResponse',
            INITIALIZE: null
        };
    }
    get _installedAppsFn() {
        const { getInstalledApps, getInstalledAppsEx } = this.vulcanInterface.control;
        if (getInstalledAppsEx) {
            return getInstalledAppsEx.bind(this.vulcanInterface.control);
        }
        return getInstalledApps.bind(this.vulcanInterface.control);
    }
    async _getCCLibrariesInstall() {
        return (await this._installedAppsFn()).find(app => app.name === vulcanLibrariesTargetSpecifier || app.sapCode === vulcanLibrariesSAPCode);
    }
    removeListener(callback, type) {
        if (type === null) {
            return;
        }
        this.vulcanInterface.dispatcher.removeEventListener(this.messageTypes.RESPONSE, callback);
    }
    sendMessage(callback, type) {
        if (type === null) {
            return;
        }
        this.vulcanInterface.dispatcher.addEventListener(this.messageTypes.RESPONSE, callback);
        this.vulcanInterface.dispatcher.broadcastMessage(
        // eslint-disable-next-line new-cap
        new this.vulcanInterface.message(this.messageTypes.REQUEST, vulcanQueryRequestPayload));
    }
    async isAppRunning() {
        var _a;
        return (_a = (await this._getCCLibrariesInstall())) === null || _a === void 0 ? void 0 : _a.isRunning();
    }
    async launchApp(callback) {
        const ccLibrariesInstall = await this._getCCLibrariesInstall();
        if (ccLibrariesInstall) {
            await ccLibrariesInstall.launch();
            callback(LAUNCH_APP_RESPONSE);
        }
    }
    getPayload(message) {
        return message.payload;
    }
}
var uxpConnector = (vulcanInterface, timeout = 8000) => {
    const connector = new UXPConnector(vulcanInterface, undefined, timeout);
    return (abortSignal) => connector.connect(abortSignal);
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class ProgressiveLoader extends AsyncOperation {
    constructor(_generator) {
        super();
        this._generator = _generator;
        this._results = [];
        this._getPages();
    }
    async _getPages() {
        var _a, e_1, _b, _c;
        try {
            for (var _d = true, _e = __asyncValues(this._generator(this._abortController.signal)), _f; _f = await _e.next(), _a = _f.done, !_a;) {
                _c = _f.value;
                _d = false;
                try {
                    const page = _c;
                    this._results.push(...page);
                    this.emit('change', false);
                }
                finally {
                    _d = true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (!_d && !_a && (_b = _e.return)) await _b.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.progress = 100;
        this.emit('change', true);
    }
    get results() {
        return this._results;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class MobXRegistry {
    constructor() {
        this._contexts = new Map();
    }
    register(createAtom, transaction) {
        const id = uuid_1.v4();
        this._contexts.set(id, { createAtom, transaction });
        return () => this._contexts.delete(id);
    }
    transaction(fn) {
        const nestedTransaction = Array.from(this._contexts.values()).reduce((memo, { transaction }) => {
            return () => transaction(() => memo());
        }, fn);
        return nestedTransaction();
    }
    reportObserved(target, event) {
        for (const [id, { createAtom }] of this._contexts) {
            const key = `_atom_${id}_${event}`;
            let atom = target[key];
            if (!atom) {
                const onChange = () => atom.reportChanged();
                atom = createAtom(`${target.constructor.name}${key}`, () => target.on(event, onChange), () => target.off(event, onChange));
                target[key] = atom;
            }
            atom.reportObserved();
        }
    }
}
var mobXRegistry = new MobXRegistry();

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const isDecoratorArgs = (args) => typeof args[0] !== 'string';
function getObservableDecorator(...events) {
    return function (target, key, descriptor) {
        const bindingKey = descriptor.get ? 'get' : descriptor.value ? 'value' : undefined;
        if (bindingKey) {
            const method = descriptor[bindingKey];
            descriptor[bindingKey] = function (...args) {
                for (const event of events) {
                    // The mobX target observed will be the 'this' context (i.e. the class containing the method being decorated)
                    mobXRegistry.reportObserved(this, event);
                }
                return method.apply(this, args);
            };
        }
    };
}
// Implementation overload: observable([target, key, descriptor]) or observable(['event1', 'event2']);
function observable(...args) {
    if (isDecoratorArgs(args)) {
        // Default to listening to change events on the target
        return getObservableDecorator('change')(...args);
    }
    return getObservableDecorator(...args);
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Model
 * @packageDocumentation
 * @module Model
 * @internal
 *
 * Contains placeholder logic for Elements, Groups, and Representations, including when updating.
 * Model extends ItemBase, but given that there are some Model subclasses that don't use the ItemUpdater pattern,
 * because they exist in simple Arrays rather than the item pool, such as Representation,
 * the update logic has been moved down to the subclasses, other than the placeholder logic.
 */
/**
 * REFACTOR TODOs:
 * - When supporting CRUD Operations on Elements: replace commented out calls to this._modelCache with calls to this._itemPool<model>
 *
 * WHAT WORKS:
 * - getters
 *
 * WHAT DOES NOT YET WORK:
 * - updates/commits
 */
// TODO-R[SHARED-4609]: Handle this when refactoring change notifications. It propagates change events on children to the parent.
// We need to find out whether SAM has the same pattern.
// export function initializesCaches<D extends ModelData, B extends { new(...args: any[]): Model<D> }>(base: B): B {
//     return class extends base {
//         constructor(...args: any[]) {
//             super(...args);
//             for (const { cache } of Object.values(this._childModelCaches)) {
//                 cache.on('change', () => this.emit('change'));
//                 cache.on('modelChange', () => this.emit('change'));
//             }
//             this._updateChildren();
//         }
//     };
// }
class Model extends ItemBase {
    /**
     * @package -- only for use in SAM.js
     * It is OK for this to return a new Array instance as this is only used internally for data manipulation.
     */
    get _childrenData() { return this._children.map(child => child._data); }
    constructor(core, id) {
        super(core, id);
        this.core = core;
        this._isCommitted = false;
        this._waitingForCommit = false;
        /**
         * @package -- only for use in SAM.js
         * This should always return the same Array instance and the same Representation instances,
         * to ensure MobX does not think there was a change when there wasn't.
         */
        this._children = [];
        // Synchronously get the LibraryContext and ICCLibraries from the core,
        // as the async `core.getLibraryContext()` should already have been called.
        this._libraryContext = core._getLibraryContext();
        this._apiRoot = this._libraryContext._getLibrariesModule_NoLoad();
        this._driver = this._apiRoot.driver;
        // If the model is a placeholder without a real ID, we need to wait for it to be committed.
        this._commitFuture = new Promise((resolve, reject) => {
            this._commitResolver = () => {
                this._isCommitted = true;
                resolve();
            };
            if (!isPlaceholder(id)) {
                this._commitResolver();
            }
            // After 'remove' all event listeners are cleared, so we don't need to clean up here.
            this.on('remove', () => {
                if (this._waitingForCommit && !this._isCommitted) {
                    // If we're removing the model, make sure we reject any promises
                    // that are waiting for it to be committed, so that callers don't hang indefinitely.
                    reject();
                }
            });
        });
    }
    /**
     * Update the model with new data. (Models only have local data.)
     * @param data
     * @returns
     *
     * @package -- only for use in SAM.js
     */
    // TODO-R[SHARED-4149]: This no longer returns data since that property is gone. We need to check that this won't break anything during CRUD operations.
    _update(data) {
        const committed = isPlaceholder(this.id) && data.id && this.id !== data.id;
        this._updateImplementation(data); // Could use ItemUpdater pattern (e.g. element/group) or not (e.g. Representation)
        if (committed && this._commitResolver) {
            this._commitResolver();
        }
    }
    /**
     * @package -- only for use in SAM.js
     */
    // Update children aka Representations, which do not use the ItemUpdater pattern as they exist as an array on the Element.
    _updateChildren(data) {
        if (!this._children) {
            return;
        } // Only Element and Representations have children defined.
        // Find representation that matches data.id/previousPlaceholderId and update *before* doing any removals
        const upsertItems = () => {
            data.forEach(childData => {
                let model = this._children.find(child => child.id === childData.id || child.id === childData.previousPlaceholderId);
                if (model) {
                    // TODO-R[SHARED-5159]: Diff old/new data with deep object equality to check if an update is needed.
                    // Old data can be accessed through model._data since children are always Representations
                    model._update(childData);
                    model.emit('change');
                }
                else {
                    model = new this._ChildClass(this._core, this, childData);
                    this._children.push(model);
                }
            });
        };
        const removeItems = () => {
            // 1. Get a set of IDs from new data
            const currentDataIds = new Set(data.map(data => data.id));
            // 2. Find the models that are not included in the updated set
            const oldData = this._childrenData;
            const removedItems = oldData.filter(data => !currentDataIds.has(data.id));
            // 3. Remove those models from the pool
            removedItems.forEach(data => {
                const model = this._children.find(child => child.id === data.id);
                if (model) {
                    // Emit a remove event so that the model can clean itself up.
                    model.emit('remove');
                    model.removeAllListeners();
                }
            });
        };
        upsertItems();
        removeItems();
    }
    // When resolved, we know this element is no longer a placeholder.
    // TODO-R: Might be clearer to name this waitForCommit().
    get committed() {
        this._waitingForCommit = true;
        return this._commitFuture;
    }
    // TODO-R: It might be clearer to switch this around and name it `isPlaceholder`, and the util can become isPlaceholderId
    get isCommitted() {
        return this._isCommitted;
    }
}

function hasLibrary(object) {
    return !!object.library;
}

function requiresWrite(target, propertyKey, propertyDescriptor) {
    const key = propertyDescriptor.set ? 'set' : propertyDescriptor.value ? 'value' : undefined;
    if (key) {
        const method = propertyDescriptor[key];
        propertyDescriptor[key] = function (...args) {
            const library = hasLibrary(this) ? this.library : this;
            if (!library.isWritable) { //TODO-R: Will need to check Library.isReadOnly moving forwards
                throw new LibraryError('NOT_ALLOWED', `${propertyKey} requires write access`, this.id);
            }
            return method.apply(this, args);
        };
    }
}
function requiresCloudDriver(target, propertyKey, propertyDescriptor) {
    const key = propertyDescriptor.set ? 'set' : propertyDescriptor.value ? 'value' : undefined;
    if (key) {
        const method = propertyDescriptor[key];
        propertyDescriptor[key] = function (...args) {
            if (!this.apiRoot.cloudDriver) {
                throw new LibraryError('NOT_ALLOWED', `${propertyKey} requires a cloud driver`);
            }
            return method.apply(this, args);
        };
    }
}
function requiresLocalDriver(target, propertyKey, propertyDescriptor) {
    const key = propertyDescriptor.set ? 'set' : propertyDescriptor.value ? 'value' : undefined;
    if (key) {
        const method = propertyDescriptor[key];
        propertyDescriptor[key] = function (...args) {
            if (!(this.apiRoot.driver instanceof LocalDriver)) {
                throw new LibraryError('NOT_ALLOWED', `${propertyKey} requires a local driver`);
            }
            return method.apply(this, args);
        };
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function findMatchingRepresentationData(target, candidates) {
    for (const candidate of candidates) {
        if (candidate.id === target.id) {
            return candidate;
        }
        if (candidate.children) {
            const result = findMatchingRepresentationData(target, candidate.children);
            if (result) {
                return result;
            }
        }
    }
}
function replaceRepresentationsOnTarget(target, newChildren) {
    if (target instanceof Element) {
        return newChildren;
    }
    const representations = deepCopy(target.element._childrenData);
    const targetData = findMatchingRepresentationData(target, representations);
    if (targetData) {
        targetData.children = newChildren;
    }
    return representations;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// Converts all the non library related DCXData values to any Array of Objects.
function mapAttributesToArray(customData) {
    customData = customData !== null && customData !== void 0 ? customData : {};
    const ret = [];
    for (const [customKey, value] of Object.entries(customData)) {
        const [namespace, key] = customKey.split('#', 2);
        ret.push({ namespace, key, value });
    }
    return ret;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class Representation extends Model {
    // Because Representation is not updated through the ItemUpdater, we can define more parameters,
    // including passing data in directly.
    constructor(core, parent, 
    /**
     * @package -  -- for use in SAM.js only
     * Preserving the data object makes it easy to do updates and also to serialize data back.
     */
    _data) {
        super(core, _data.id); // TODO-R[SHARED-4623]: Later, refactor to use abstract/composable classes so that Representation does not need to inherit from Item to get the Model's placeholder logic. It has no other need for core.
        this.core = core;
        this._data = _data;
        /**
         * @package -- only for use in SAM.js
         */
        this._ChildClass = Representation;
        // TODO-R: Not ideal to use arrow function property instead of a method. Takes more memory than methods on the prototype.
        // Solution is to refactor to use Abstract/composable classes.
        this._updateImplementation = (data) => {
            this._data = Object.assign(this._data, data);
            this._updateChildren(this._data.children || []); // child array is expected to be full list
            // TODO-R: Need to ensure this gets squelched during Store.begin/endOperation
            this.emit('change');
        };
        this._parent = parent;
    }
    // We have 3 representation types: json, file, multi-state components.
    // Multi-state components utilize child representations.
    // e.g. PS and Fresco have brushes with a file/component for the tip of the brush,
    // and another for the pattern.
    // Reference: https://wiki.corp.adobe.com/display/ccexperience/Multi-state+Components
    get children() {
        return this._children;
    }
    get parent() {
        return this._parent;
    }
    get element() {
        let element = this._parent;
        while (element instanceof Representation) {
            element = element._parent;
        }
        return element;
    }
    get library() {
        return this.element.library;
    }
    get isWritable() {
        return this.element.isWritable;
    }
    get type() {
        const type = this._data.type;
        if (type === 'application/vnd.adobe.library.link+dcx') {
            return this._data.linktype;
        }
        return type;
    }
    get relationship() {
        return this._data.relationship;
    }
    set relationship(relationship) {
        this._updateActionDispatch({ relationship });
    }
    get width() {
        return this._data.width;
    }
    set width(width) {
        this._updateActionDispatch({ width });
    }
    get height() {
        return this._data.height;
    }
    set height(height) {
        this._updateActionDispatch({ height });
    }
    get isFullSize() {
        return this._data.isFullSize;
    }
    set isFullSize(isFullSize) {
        this._updateActionDispatch({ isFullSize });
    }
    get isPreferredThumbnail() {
        return this._data.isPreferredThumbnail;
    }
    set isPreferredThumbnail(isPreferredThumbnail) {
        this._updateActionDispatch({ isPreferredThumbnail });
    }
    get contentLength() {
        return this._data.contentLength;
    }
    set contentLength(contentLength) {
        this._updateActionDispatch({ contentLength });
    }
    /**
     * @deprecated
     */
    get isDeletedLocally() {
        return false;
    }
    get isExternalLink() {
        return this._data.isExternalLink;
    }
    isCompatibleType(type) {
        const path = this.getCachedContentPath();
        // Check that the representation's component matches the requested type.
        // Elements sourced from external links don't reference components so we can't enforce this check.
        if (path && !this.isExternalLink) {
            const extension = getFileExtension(path);
            const extensions = getExtensions(type);
            if (extensions.indexOf(extension) === -1) {
                return false; // Extension and content-type doesn't match therefore not compatible.
            }
        }
        // Fall back to ensuring the requested type matches the actual representation type.
        return type === this.type;
    }
    getValue(namespace, key) {
        var _a;
        return (_a = this._data.customData) === null || _a === void 0 ? void 0 : _a[`${namespace}#${key}`];
    }
    getValues() {
        return mapAttributesToArray(this._data.customData);
    }
    setValue(namespace, key, value, _isMetadata) {
        this._updateActionDispatch({
            customData: Object.assign(Object.assign({}, this._data.customData), { [`${namespace}#${key}`]: value })
        });
    }
    removeValue(namespace, key, isMetadata) {
        this.setValue(namespace, key, null, isMetadata);
    }
    setContent(content, encoding, filename) {
        if (content instanceof Blob) {
            return this._driver
                .stageRepresentationForCommit(this.library, new File([content], filename, {
                type: content instanceof File ? content.type : getPrimaryMimetypeForFile(filename)
            }))
                .then(payload => {
                return this.setStagedContent(payload);
            });
        }
        let data;
        if (typeof content === 'string' && ['base64', 'utf8'].includes(encoding)) {
            data = content;
        }
        else {
            throw new Error('Not implemented');
        }
        return this._updateActionDispatch({ source: { filename, data } });
    }
    setContentFromPath(path, _moveFile) {
        if (!this.library.locallyManaged) {
            // Not supported in this mode
            throw new Error();
        }
        return this._updateActionDispatch({ source: { path, moveFile: false } });
    }
    setStagedContent(payload) {
        try {
            const source = JSON.parse(payload);
            if (!isRepresentationPreflightResponse(source)) {
                // Should accept placeholder representations staged to commit.
                if (!source || !isPlaceholder(source.id)) {
                    // Caught immediately below
                    throw new Error();
                }
            }
            return this._updateActionDispatch({ source });
        }
        catch (e) {
            throw new LibraryError('INVALID_PARAMETER', 'Payload is not consumable by remote target', this.library.id, e);
        }
    }
    setContentFromURL(createLink, url, headers) {
        return this._updateActionDispatch({ source: { url, createLink, headers } });
    }
    getContentPath() {
        return Promise.resolve(this.getCachedContentPath());
    }
    getCachedContentPath() {
        return this._data.path;
    }
    /**
     * Get the data stored in the content of the representation, by reading the file from disk (in a filesystem environment), or by
     * downloading it (in a browser environment). This is the content set by calling
     * Representation.setContent, Representation.setContentFromPath, or Representation.setContentFromURL.
     */
    getContent() {
        return this._driver.getRepresentationContent(this).then(res => res.blob());
    }
    getContentURL() {
        return this._data.url;
    }
    getAuthenticatedContentURL() {
        return Promise.resolve('');
    }
    /**
     * @package -- only for use in SAM.js
     */
    _createChild(type) {
        const id = createPlaceholderId();
        const children = this._data.children ? [...this._data.children] : [];
        children.push({
            id,
            type,
            isFullSize: false,
            isExternalLink: false
        });
        this.element._actionDispatch({
            name: 'updateElementContent',
            type: 'update',
            data: {
                representations: replaceRepresentationsOnTarget(this, children)
            }
        });
        return this._children.find(child => child.id === id);
    }
    /**
     * @package -- only for use in SAM.js
     */
    _removeChild(representation) {
        const children = this._data.children ? [...this._data.children] : [];
        const index = children.findIndex(rep => rep.id === representation.id);
        if (index === -1) {
            return;
        }
        children.splice(index, 1);
        this.element._actionDispatch({
            name: 'updateElementContent',
            type: 'update',
            data: {
                representations: replaceRepresentationsOnTarget(this, children)
            }
        });
    }
    testExternalLink() {
        return Promise.resolve(false);
    }
    clearCachedExternalLink() {
        // TODO
    }
    getCachedExternalLinkError() {
        return undefined;
    }
    /**
     * Get the download progress for a representation that is an external link
     * keyed in sync state via `libraryId.elementId.representationId`
     * returns -1 when an error occurs
     * returns undefined if no progress
     * returns 0 - 100 specifying percentage of download complete otherwise
     */
    getExternalLinkDownloadProgress() {
        if (this.isExternalLink) {
            const key = `${this.library.id}.${this.element.elementId}.${this.id}`;
            return this.library.apiRoot.syncState.getExternalLinkDownloadProgressByKey(key);
        }
    }
    get _childrenData() {
        return this._data.children || [];
    }
    _updateActionDispatch(updatedData) {
        const representations = this.parent._childrenData;
        const filteredRepresentations = representations.filter((rep) => rep.id !== this.id);
        this.element._actionDispatch({
            name: 'updateElementContent',
            type: 'update',
            data: {
                representations: replaceRepresentationsOnTarget(this.parent, [
                    ...filteredRepresentations,
                    Object.assign(Object.assign({}, this._data), updatedData)
                ])
            }
        });
        return Promise.resolve();
    }
}
__decorate([
    requiresWrite
], Representation.prototype, "relationship", null);
__decorate([
    requiresWrite
], Representation.prototype, "width", null);
__decorate([
    requiresWrite
], Representation.prototype, "height", null);
__decorate([
    requiresWrite
], Representation.prototype, "isFullSize", null);
__decorate([
    requiresWrite
], Representation.prototype, "isPreferredThumbnail", null);
__decorate([
    requiresWrite
], Representation.prototype, "contentLength", null);
__decorate([
    requiresWrite
], Representation.prototype, "setValue", null);
__decorate([
    requiresWrite
], Representation.prototype, "removeValue", null);
__decorate([
    requiresWrite
], Representation.prototype, "setContent", null);
__decorate([
    requiresWrite
], Representation.prototype, "setContentFromPath", null);
__decorate([
    requiresWrite
], Representation.prototype, "setStagedContent", null);
__decorate([
    requiresWrite
], Representation.prototype, "setContentFromURL", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// @TODO
// This needs a little more thought. The test cases and real world cases are not clear
// replacing words in the string with a dot(.) does not make a lot of sense to me
// and the removal of the last .0 is also a little strange.
// This can be cleaned up and should be but this is pulled directly from cc-libraries-api-js and its well tested
// https://git.corp.adobe.com/ProjectCentral/cc-libraries-api-js/blob/80ebed61ec41b980495c485fe17a6f1bbd5d1b5c/src/utils/AdobeLibraryGeneralUtils.js#L74
function sanitizeVersionInput(version) {
    // After effects does not use semver. They append a x before the build number.
    // We need to replace that with a .
    version = version
        .toString()
        .replace(/(\.0)*$/, '')
        .replace(/[^.0-9]+/gim, '.');
    // Workaround for Illustrator CS6 & Illustrator CC returning version as CS6 and the build number instead of semver
    if (isNaN(parseInt(version, 10)) || parseInt(version, 10) > 250) {
        version = '0';
    }
    return version;
}
function compareVersions(version1 = '0', version2 = '0') {
    if (version1 === version2) {
        return 0;
    }
    const a1 = sanitizeVersionInput(version1).split('.');
    const a2 = sanitizeVersionInput(version2).split('.');
    let diff;
    for (let i = 0; i < a1.length && i < a2.length; i++) {
        const a1Part = parseInt(a1[i], 10);
        diff = a1Part - parseInt(a2[i], 10);
        if (isNaN(diff)) {
            if (isNaN(a1Part)) {
                return 1;
            }
            return -1;
        }
        if (diff > 0) {
            return -1;
        }
        if (diff < 0) {
            return 1;
        }
    }
    diff = a1.length - a2.length;
    return diff > 0 ? -1 : diff < 0 ? 1 : 0;
}

class ApplicationAction {
    constructor(_item, _applicationActionData) {
        this._item = _item;
        this._applicationActionData = _applicationActionData;
    }
    get item() {
        return this._item;
    }
    get minVersion() {
        return this._applicationActionData.minVersion;
    }
    get appCode() {
        return this._applicationActionData.appCode;
    }
    get appName() {
        return this._applicationActionData.appName;
    }
    get action() {
        return this._applicationActionData.action;
    }
    get installedVersions() {
        const { installedApps } = this.item.apiRoot.driver.config;
        return installedApps
            .filter((app) => app.code === this._applicationActionData.appCode)
            .map((app) => app.version)
            .sort(compareVersions);
    }
    isCompatibleVersionInstalled() {
        return (this.installedVersions.length &&
            compareVersions(this._applicationActionData.minVersion, this.installedVersions[0]) >= 0);
    }
    async invoke() {
        if (!this.isCompatibleVersionInstalled()) {
            throw new LibraryError('NOT_SUPPORTED', 'A compatible version of the application is needed for this action', this.item instanceof Element ? this.item.library.id : this.item.id);
        }
        return this.item.apiRoot.driver.sendAction(this);
    }
    toJSON() {
        return JSON.stringify(Object.assign(Object.assign({}, this._applicationActionData), (this.item instanceof Element
            ? { libraryId: this.item.library.id, elementId: this.item.id }
            : { libraryId: this.item.id })));
    }
}
function constructActions(item, action, codes, products) {
    return codes
        .map(code => {
        const currentAction = products[code];
        if (currentAction && (!action || action === currentAction.action)) {
            return new ApplicationAction(item, currentAction);
        }
        return undefined;
    })
        .filter(Boolean)
        .sort((a, b) => {
        if ((a === null || a === void 0 ? void 0 : a.isCompatibleVersionInstalled) && !(b === null || b === void 0 ? void 0 : b.isCompatibleVersionInstalled)) {
            return -1;
        }
        else if (!(a === null || a === void 0 ? void 0 : a.isCompatibleVersionInstalled) && (b === null || b === void 0 ? void 0 : b.isCompatibleVersionInstalled)) {
            return 1;
        }
        return 0;
    });
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DEFAULT_SRGB_PROFILE = 'sRGB IEC61966-2.1';
const isRGB = (data) => data.mode === 'RGB';
const isSRGB = (data) => isRGB(data) && (!data.profileName || data.profileName === DEFAULT_SRGB_PROFILE);
// Convert RGB values to a hex string (e.g. rgbToHex(50, 50, 50) = '#323232')
const rgbToHex = (r, g, b) => {
    let str = ((Math.round(r) << 16) | (Math.round(g) << 8) | Math.round(b)).toString(16);
    while (str.length < 6) {
        str = '0' + str;
    }
    return `#${str}`.toUpperCase();
};
// Convert color data to a hex string. (With a few other color utils encapsulated inside.)
const colorDataToHexString = (color) => {
    // If data is a swatch array of colorData, get the sRGB data
    const data = Array.isArray(color) ? color.find(isSRGB) || color.find(isRGB) : color;
    return data && data.value ? rgbToHex(data.value.r, data.value.g, data.value.b) : '';
};
const getData = (element, namespace, filter) => {
    const type = `application/vnd.adobe.${namespace}+json`;
    for (let i = 0; i < element.representations.length; i++) {
        const representation = element.representations[i];
        if (representation.type === type) {
            const data = representation.getValue(namespace, 'data');
            if (data && (!filter || filter(data))) {
                return data;
            }
        }
    }
};
const getColorName = (element) => {
    // Note: Some colors have an RGB representation that's not sRGB. That's technically not allowed,
    // but we fall back to picking the first RGB representation (regardless of mode) if there's no sRGB
    // representation
    const color = getData(element, 'color', isSRGB) || getData(element, 'color', isRGB);
    return colorDataToHexString(color);
};
const getFontName = (element) => {
    const font = getData(element, 'font');
    return (font === null || font === void 0 ? void 0 : font.name) || '';
};
const getStyleName = (namespace) => (element) => {
    const style = getData(element, namespace);
    if (style) {
        const fontStyle = style.adbeFont && style.adbeFont.style.toLowerCase();
        if (fontStyle && !fontStyle.includes('normal') && !fontStyle.includes('regular')) {
            return `${style.fontFamily} ${style.adbeFont.style}`;
        }
        return style.fontFamily;
    }
};
const generateNameMap = {
    'application/vnd.adobe.element.color+dcx': getColorName,
    // Note: character and paragraph styles now require names, but some older elements are nameless:
    'application/vnd.adobe.element.characterstyle+dcx': getStyleName('characterstyle'),
    'application/vnd.adobe.element.paragraphstyle+dcx': getStyleName('paragraphstyle'),
    'application/vnd.adobe.element.font+dcx': getFontName
};
const getGeneratedName = (element) => {
    const getName = generateNameMap[element.type];
    return getName ? getName(element) : '';
};

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Defines library items that may have been created by publishing a document's assets.
 * At the time of this writing, that includes only Elements and Groups.
 * @packageDocumentation
 * @module Published
 */
class Published extends Model {
    /**
     * A string reference to where the element or group came from.
     *
     * This should be in the new migrated link format, of a serialized JSON string storing link data:
     * https://git.corp.adobe.com/caf/xcm/blob/master/schemas/cc/link/link.schema.json
     * However, the getter will return whatever any legacy string stored as well, without modification.
     *
     * @type {Stringified<LinkReference> | undefined}
     */
    get sourceRefString() {
        return this._sourceRef;
    }
    /**
     * An object reference to where the element or group came from.
     *
     * This should be in the new migrated link format, of an expanded JSON object storing link data:
     * https://git.corp.adobe.com/caf/xcm/blob/master/schemas/cc/link/link.schema.json
     * The getter will convert a legacy reference format into an object.
     * The sourceRef should be read and written as an object but stored in the manifest as a serialized string.
     * The stringified JSON will also be available to read through sourceRefString.
     *
     * It's highly encouraged to set the sourceRef when creating an element, so that we can trace it back later.
     *
     * @type {LinkReference|undefined}
     */
    get sourceRef() {
        if (!this.sourceRefString) {
            return undefined;
        }
        let newLinkSchema = parseNewLinkSchema(this.sourceRefString);
        if (!newLinkSchema) {
            // Return legacy sourceRef in the new link schema.
            // The actual migration of the sourceRef should be handled by the client.
            const [urn, fragment] = this.sourceRefString.split('#');
            newLinkSchema = {
                'repo:assetId': urn,
                'stRef:fromPart': fragment
            };
            const legacySourceModified = this._sourceModifiedDate;
            if (legacySourceModified) {
                // fromPartInstanceID should be a uuid string, sourceModified is a number.
                newLinkSchema['stRef:fromPartInstanceID'] = `${legacySourceModified}`;
            }
        }
        return newLinkSchema;
    }
    set sourceRef(sourceRef) {
        if (typeof sourceRef !== 'object' || !parseNewLinkSchema(sourceRef)) {
            const parent = this._parent;
            throw new LibraryError('INVALID_PARAMETER', 'sourceRef must be a valid JSON object', parent.library.id);
        }
        this._actionDispatch({
            name: this._updateAction,
            type: 'update',
            data: {
                // The sourceRef should be read and written as an object but stored in the manifest as a serialized string.
                sourceRef: JSON.stringify(sourceRef, Object.keys(sourceRef).sort())
            }
        });
    }
}
__decorate([
    observable
], Published.prototype, "sourceRefString", null);
__decorate([
    observable,
    requiresWrite
], Published.prototype, "sourceRef", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const extractElementId = (path) => {
    return path.split('#')[1];
};
function getCombinedId(data) {
    return `${data.libraryAssetId}#${data.id}`;
}
function getCombinedIdOrPlaceholder(data) {
    if (!data.id) {
        throw SAMError.create(SAMErrorCode.BAD_REQUEST, 'Element data requires an id');
    }
    return isPlaceholder(data.id) ? data.id : getCombinedId(data);
}
// @initializesCaches
class Element extends Published {
    // TODO-R: Because element may be created by UpdateSession, we cannot expect parent to be passed in.
    // However, we should probably refactor the remoteUpdate to handle passing in the parent to avoid the issues noted below in libraryContents
    constructor(core, id) {
        super(core, id);
        // The following properties are not optional in ElementData, so we added
        // default values to avoid undefined checks, with the assumption being that these values
        // should be defined through _update() before calling dependent code.
        // If you run into these default unexpectedly, then you are failing to update the element properly.
        // (Previously defaults were not required because ElementData was required by the constructor.)
        this._groups = [];
        /**
         * @package -- for use in SAM.js only
         */
        this._name = '';
        this._type = '';
        this.isElement = true;
        this._updateAction = 'updateElement';
        this._lastLocalUpdateDate = 0;
        /**
         * @package -- only for use in SAM.js
         */
        this._ChildClass = Representation;
        // TODO-R[SHARED-4623]: Not ideal to use arrow function property instead of a method. Takes more memory than methods on the prototype.
        // Solution is to refactor to use Abstract/composable classes.
        this._updateImplementation = (data) => {
            const session = this._itemPool.createUpdateSession();
            this._updater.updateLocalItem(session, this, data); // will also call this._updateChildren, which emits change events
            session.commit(); // emits a change event
        };
        this._updater = this._apiRoot.elementUpdater;
        this._itemPool = this._apiRoot.elementPool;
        this._elementId = isPlaceholder(id) ? id : extractElementId(id);
    }
    // Note: Previously, we could pass the parent directly into the Element constructor.
    // With the ItemUpdater pattern, only the id is passed in upon instantiation, and the data, including the parent id, is updated later.
    // In order to avoid breaking APIs depending on the library (or libraryContents) APIs being defined,
    // we need to throw an error here if the libraryAssetId is undefined. We can revisit this strategy if it becomes a problem.
    // In other words, we assume that in production the libraryAssetId will always be defined in an Element Response.
    // TODO-R: Need to verify Melville response format to ensure this assumption is correct.
    get libraryContents() {
        if (!this._parent) {
            if (!this._libraryAssetId) {
                throw Error('Element._libraryAssetId is not defined, so we cannot find the Library or LibraryContents.');
            }
            const library = this._core._getAssetPool().getLocalItemById(this._libraryAssetId);
            this._parent = library._getContentsSync(); // We assume LibraryContents is already loaded given this Element wouldn't exist otherwise.
        }
        return this._parent;
    }
    get library() {
        // Rather than holding a reference to the library directly, the element holds a reference to its parent LibraryContents,
        // which in turn points to its parent library.
        return this.libraryContents.library;
    }
    get elementId() {
        return this._elementId;
    }
    /**
     * The mimetype of the library element
     */
    get type() {
        return this._type;
    }
    /**
     * The date the library element was modified
     */
    get modified() {
        return new Date(Math.max(this._modifiedDate, this._lastLocalUpdateDate));
    }
    /**
     * The date the library element was created
     */
    get created() {
        return new Date(this._createdDate);
    }
    /**
     * The instanceID (in the case of a library) or fromPartInstanceID (in the case of a fragment),
     * is used to tell if the content of a link is out of date in the new link reference schema.
     * For elements, we use the primary representation id, which changes every time a change is made to the element.
     * Since there is no content that can change when there's no representation, this will be undefined in that case.
     *
     * Note that the InstanceID has to be a guid as per XMP semantics -- modified dates are not unique enough.
     * This is important primarily for references to library elements,
     * since they will be exposed in XMP as well, as part of the content graph.
     *
     */
    get instanceId() {
        const primaryRepresentation = this.getPrimaryRepresentation();
        return primaryRepresentation === null || primaryRepresentation === void 0 ? void 0 : primaryRepresentation.id;
    }
    /**
     * Get a unique link reference for the element, which is a JSON object using the [link schema](https://git.corp.adobe.com/caf/xcm/blob/master/schemas/cc/link/link.schema.json).
     * This reference can be used anytime to retrieve this element.
     * For more information on linking architecture, see [here](https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=ccexperience&title=Linking+Architecture).
     */
    getReference() {
        const linkData = {
            'dc:format': this.library.mediaType,
            'repo:assetId': this._libraryAssetId,
            'repo:name': this.library.displayName,
            'stRef:manager': 'Adobe Cloud',
            'stRef:documentID': this.library.libraryManifestId,
            'stRef:fromPart': `id=${this.id}`,
            'stRef:fromPartName': this.name
        };
        if (this.instanceId) {
            linkData['stRef:fromPartInstanceID'] = this.instanceId;
        }
        if (this.sourceRef) {
            // If this element is derived from a different cloud asset, include the reference to it as well.
            // But if the element is derived from the Firefly mimetype, then avoid sending this field
            // because the Firefly mimetype is still being developed and so the sourceRef is still incomplete
            if (this.sourceRef['dc:format'] !== 'application/vnd.adobe.firefly-recipe+dcx') {
                linkData['stRef:fromPartDerivedFrom'] = this.sourceRef;
            }
        }
        return linkData;
    }
    /**
     * Get the serialized version of the unique link reference for the element, returned from getReference()
     * Getting the object through getReference() is typically more useful and skips serialization steps,
     * but the serialized string is useful to compare reference equality, since we take care of sorting the object.
     */
    getReferenceString() {
        const reference = this.getReference();
        return serializeLinkReference(reference);
    }
    // Legacy references are still used by clients that have not migrated to the new link format yet.
    getLegacyReference() {
        var _a;
        return (_a = this._elementRef) !== null && _a !== void 0 ? _a : `cloud-asset://${this.library.id};node=${this.id}`;
    }
    /**
     * The display name of the element
     */
    get name() {
        if (this.isAutoNamed) {
            return getGeneratedName(this);
        }
        return this._name;
    }
    set name(name) {
        this._actionDispatch({
            name: 'updateElement',
            type: 'update',
            data: {
                name: name === null || name === void 0 ? void 0 : name.normalize()
            }
        });
    }
    /**
     * Was this element named automatically?
     */
    get isAutoNamed() {
        const name = this._name;
        const autoName = this._autoName;
        // An element is auto-named if it doesn't have a name, or its auto-name equals its name.
        // This lets us detect if older clients renamed an element without updating its name,
        // since they wouldn't update the autoName field.
        return !name || name === autoName;
    }
    /**
     * Is the element editable?
     */
    get isWritable() {
        return this.library.hasPermission(Permission.Write);
    }
    /**
     * The tags (strings) associated with the element
     */
    get tags() {
        return this._tags || [];
    }
    set tags(tags) {
        this._actionDispatch({
            name: 'updateElement',
            type: 'update',
            data: { tags }
        });
    }
    /**
     * The dependencies for the element (other elements)
     */
    async getDependencies() {
        const elements = [];
        // TODO-R[SHARED-5423] Optimize Element.getDependencies fetches
        if (this._dependencyIds) {
            for (const dependencyID of this._dependencyIds) {
                const element = await this.libraryContents.getElementById(dependencyID);
                if (element !== this) {
                    elements.push(element);
                }
            }
        }
        return elements;
    }
    setDependencies(elements) {
        const dependencyIds = elements.map(element => element.id);
        this._actionDispatch({
            name: 'updateElement',
            type: 'update',
            data: { dependencyIds }
        });
    }
    /**
     * Why does this exist?
     * @deprecated
     */
    createGroup() {
        // TODO
    }
    getGroups(_classifier = '$default') {
        // TODO: Implement this once new groups API decided
        // return this.library.getGroups(classifier).filter(group => {
        //     return this._groups.find(membership => membership.id === group.id);
        // });
        return [];
    }
    getOrderInGroup(group) {
        if (group.library !== this.library) {
            return;
        }
        const groupMembership = this._groups.find(membership => membership.classifier === group.classifierName && membership.id === group.id);
        return groupMembership && groupMembership.order;
    }
    setOrderInGroup(group, order, removeExistingGroups = true) {
        const groups = removeExistingGroups
            ? this._groups.filter(gr => gr.classifier !== group.classifierName)
            : [...this._groups];
        const index = this._groups.findIndex(({ id }) => id === group.id);
        const groupMembership = {
            id: group.id,
            classifier: group.classifierName,
            order
        };
        if (!order && index !== -1) {
            groups.splice(index, 1);
        }
        else if (order && index !== -1) {
            groups.splice(index, 1, groupMembership);
        }
        else if (index === -1) {
            groups.push(groupMembership);
        }
        this._actionDispatch({
            name: 'updateElement',
            type: 'update',
            data: { groups }
        });
    }
    get description() {
        return this._description;
    }
    set description(description) {
        this._actionDispatch({
            name: 'updateElement',
            type: 'update',
            data: { description }
        });
    }
    get descriptionModified() {
        return new Date(this._descriptionModifiedDate);
    }
    get descriptionModifiedBy() {
        return this._descriptionModifiedBy;
    }
    get descriptionModifiedContext() {
        return this._descriptionModifiedContext;
    }
    get wasDescriptionModifiedLocally() {
        return this._descriptionModifiedLocally;
    }
    get modifiedBy() {
        return this._modifiedBy;
    }
    get modifiedContext() {
        return this._modifiedContext;
    }
    get wasModifiedLocally() {
        return this._modifiedLocally;
    }
    get createdBy() {
        return this._createdBy;
    }
    get createdContext() {
        return this._createdContext;
    }
    get wasCreatedLocally() {
        return this._createdLocally;
    }
    get isDeletedLocally() {
        return false;
    }
    beginOperation() {
        return this.libraryContents.beginOperation();
    }
    endOperation(callback) {
        return this.libraryContents.endOperation(callback);
    }
    get representations() {
        return this._children;
    }
    getPrimaryRepresentation() {
        return this.representations.find(representation => representation.relationship === 'primary');
    }
    getRepresentationById(id) {
        return this.representations.find(representation => representation.id === id);
    }
    createRepresentation(type, relationship, _index, _preserveThumbnail) {
        const id = createPlaceholderId();
        const representations = [...this._childrenData];
        representations.splice(1, 0, {
            id,
            type,
            relationship,
            isFullSize: false,
            isExternalLink: false
        });
        this._actionDispatch({
            name: 'updateElementContent',
            type: 'update',
            data: {
                representations
            }
        });
        return this.getRepresentationById(id);
    }
    removeRepresentation(representation) {
        const representations = [...this._childrenData];
        const index = representations.findIndex(rep => rep.id === representation.id);
        if (index === -1) {
            return;
        }
        representations.splice(index, 1);
        this._actionDispatch({
            name: 'updateElementContent',
            type: 'update',
            data: {
                representations
            }
        });
    }
    removeAllRepresentations() {
        this._actionDispatch({
            name: 'updateElementContent',
            type: 'update',
            data: {
                renditionUrl: {},
                representations: []
            }
        });
    }
    getValue(namespace, key) {
        var _a;
        return (_a = this._customData) === null || _a === void 0 ? void 0 : _a[`${namespace}#${key}`];
    }
    getValues() {
        return mapAttributesToArray(this._customData);
    }
    setValue(namespace, key, value) {
        this._actionDispatch({
            name: 'updateElement',
            type: 'update',
            data: {
                customData: {
                    [`${namespace}#${key}`]: value
                }
            }
        });
    }
    removeValue(namespace, key) {
        this.setValue(namespace, key, null);
    }
    getThumbnailURL(size) {
        return this._driver.getRenditionUrl(this, size);
    }
    async getThumbnailPath(size = 'full') {
        await this.committed;
        return this._driver.getRenditionPath(this.library.id, this.id, size);
    }
    getThumbnailContent(size) {
        return this._driver.getRendition(this, size).then(res => res.blob());
    }
    supportsVectorThumbnail() {
        const primary = this.getPrimaryRepresentation();
        if (primary) {
            return LibraryConstants.VECTOR_RENDITION_ELEMENT_TYPES.includes(primary.type);
        }
        return false;
    }
    getActions(actionId) {
        const representation = this.getPrimaryRepresentation();
        if (!representation) {
            return [];
        }
        if (this.library.documentType) {
            const docProductMap = this._apiRoot.getOption('DOCUMENT_LIBRARY_ACTION_PRODUCT_MAP');
            const docCodes = docProductMap.types[this.library.documentType] || [];
            return constructActions(this.library, actionId, docCodes, docProductMap.products);
        }
        const productMap = this._apiRoot.getOption('ELEMENT_ACTION_PRODUCT_MAP');
        const representationTypeMap = productMap.types[this.type] || {};
        const codes = representationTypeMap[representation.type] || [];
        return constructActions(this, actionId, codes, productMap.products);
    }
    get roles() {
        return this._roles || [];
    }
    set roles(roles) {
        this._actionDispatch({
            name: 'updateElement',
            type: 'update',
            data: { roles }
        });
    }
    get isStockAsset() {
        const isSupportedElementType = Object.values(ElementMimeTypeMap).includes(this.type);
        const hasStockData = this.getStockDataForElement() !== undefined;
        return isSupportedElementType && hasStockData;
    }
    get isLicensed() {
        var _a;
        return ((_a = this.getStockDataForElement()) === null || _a === void 0 ? void 0 : _a.state) === 'purchased';
    }
    getStockDataForElement(index) {
        // First try the primary representation
        const representation = index === undefined ? this.getPrimaryRepresentation() : this.representations[index];
        let stockData = representation === null || representation === void 0 ? void 0 : representation.getValue('adobestock', 'trackingdata');
        // If the contentURL is blank, then do not consider it as a download failure
        if (stockData
            && (representation === null || representation === void 0 ? void 0 : representation.isExternalLink)
            && (representation === null || representation === void 0 ? void 0 : representation.getCachedExternalLinkError())
            && (representation === null || representation === void 0 ? void 0 : representation.getContentURL()) !== '') {
            // It's an external link, but the external link isn't valid: See if there's a comp representation to try:
            const compStockData = this.getStockDataForElement(index === undefined ? 0 : index + 1);
            if (compStockData) {
                // Use the comp representation's comp data, because the primary isn't licensed
                stockData = compStockData;
            }
            else {
                // The primary isn't licensed, and we don't have a comp - oh no!
                // Let's be tricksy and reconstruct the unlicensed stock data
                stockData = Object.assign(Object.assign({}, stockData), { state: 'not_purchased' });
            }
        }
        return stockData;
    }
    /**
     * @package -- only for use in SAM.js
     */
    _actionDispatch(action) {
        if (!action.path) {
            action.path = `$.elements[?(@.id == "${this.id}")]`;
        }
        this._lastLocalUpdateDate = Date.now();
        this.libraryContents._actionDispatch(action);
    }
}
__decorate([
    observable
], Element.prototype, "modified", null);
__decorate([
    observable
], Element.prototype, "created", null);
__decorate([
    observable,
    requiresWrite
], Element.prototype, "name", null);
__decorate([
    observable
], Element.prototype, "isAutoNamed", null);
__decorate([
    observable
], Element.prototype, "isWritable", null);
__decorate([
    observable
], Element.prototype, "tags", null);
__decorate([
    observable,
    requiresWrite
], Element.prototype, "getDependencies", null);
__decorate([
    requiresWrite
], Element.prototype, "createGroup", null);
__decorate([
    observable
], Element.prototype, "getGroups", null);
__decorate([
    observable
], Element.prototype, "getOrderInGroup", null);
__decorate([
    requiresWrite
], Element.prototype, "setOrderInGroup", null);
__decorate([
    observable,
    requiresWrite
], Element.prototype, "description", null);
__decorate([
    observable
], Element.prototype, "descriptionModified", null);
__decorate([
    observable
], Element.prototype, "descriptionModifiedBy", null);
__decorate([
    observable
], Element.prototype, "descriptionModifiedContext", null);
__decorate([
    observable
], Element.prototype, "wasDescriptionModifiedLocally", null);
__decorate([
    observable
], Element.prototype, "modifiedBy", null);
__decorate([
    observable
], Element.prototype, "modifiedContext", null);
__decorate([
    observable
], Element.prototype, "wasModifiedLocally", null);
__decorate([
    observable
], Element.prototype, "createdBy", null);
__decorate([
    observable
], Element.prototype, "createdContext", null);
__decorate([
    observable
], Element.prototype, "wasCreatedLocally", null);
__decorate([
    observable
], Element.prototype, "isDeletedLocally", null);
__decorate([
    observable
], Element.prototype, "representations", null);
__decorate([
    observable
], Element.prototype, "getPrimaryRepresentation", null);
__decorate([
    observable
], Element.prototype, "getRepresentationById", null);
__decorate([
    requiresWrite
], Element.prototype, "createRepresentation", null);
__decorate([
    requiresWrite
], Element.prototype, "removeRepresentation", null);
__decorate([
    requiresWrite
], Element.prototype, "removeAllRepresentations", null);
__decorate([
    observable
], Element.prototype, "getValue", null);
__decorate([
    observable
], Element.prototype, "getValues", null);
__decorate([
    requiresWrite
], Element.prototype, "setValue", null);
__decorate([
    requiresWrite
], Element.prototype, "removeValue", null);
__decorate([
    observable
], Element.prototype, "supportsVectorThumbnail", null);
__decorate([
    observable
], Element.prototype, "getActions", null);
__decorate([
    observable,
    requiresWrite
], Element.prototype, "roles", null);
const propertyUpdaterTypes = {
    '_roles': { name: 'roles', format: 'object', isArray: true },
    '_name': 'name',
    '_libraryAssetId': 'libraryAssetId',
    '_children': {
        name: 'representations',
        format: 'object',
        set: (representationsData, dest) => {
            const element = dest;
            element._updateChildren(representationsData); // updates this._children with the full list of representations
        }
    },
    '_elementId': 'id',
    '_type': 'type',
    '_modifiedDate': { name: 'modifiedDate', format: 'number' },
    '_createdDate': { name: 'createdDate', format: 'number' },
    // '_tags': 'tags',
    // '_groups': 'groups',
    '_dependencyIds': { name: 'dependencyIds', format: 'object', isArray: true },
    '_description': 'description',
    '_descriptionModifiedDate': { name: 'descriptionModifiedDate', format: 'number' },
    '_descriptionModifiedBy': 'descriptionModifiedBy',
    '_descriptionModifiedContext': { name: 'descriptionModifiedContext', format: 'object' },
    '_descriptionModifiedLocally': { name: 'descriptionModifiedLocally', format: 'boolean' },
    '_modifiedBy': 'modifiedBy',
    '_modifiedContext': { name: 'modifiedContext', format: 'object' },
    '_modifiedLocally': { name: 'modifiedLocally', format: 'boolean' },
    '_createdBy': 'createdBy',
    '_createdContext': { name: 'createdContext', format: 'object' },
    '_createdLocally': { name: 'createdLocally', format: 'boolean' },
    '_customData': { name: 'customData', format: 'object' },
    // '_autoName': 'autoName',
    // '_elementRef': 'elementRef',
    // '_sourceRef': 'sourceRef',
    // '_sourceModifiedDate': 'sourceModifiedDate',
};
function getPreviousPlaceholderId(remoteItem) {
    return remoteItem.previousPlaceholderId;
}
const elementItemUpdaterOptions = {
    //@ts-expect-error -- Element constructor has a more strict string type parameter than ItemBase requires
    localItemType: Element,
    getRemoteId: (data) => getCombinedIdOrPlaceholder(data),
    getAlternateId: getPreviousPlaceholderId,
    // TODO: implement ELEMENT_DATA_CHANGED if necessary
    // Any changes to these properties from the update will trigger watchers of ELEMENT_DATA_CHANGED.
    // Other properties updated will trigger the  default 'change' event
    changeEventMap: new Map([]),
    // Mapping ElementData to Element
    propertyUpdater: new PropertyUpdater(propertyUpdaterTypes)
};
// TODO-R: ElementData to match melville response specifically rather than our internal data model
const ElementUpdater = new ItemUpdaterBase(elementItemUpdaterOptions);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function isInsertAction(action) {
    return action.type === 'insert';
}
function isUpdateAction(action) {
    return action.type === 'update';
}
function isRemoveAction(action) {
    return action.type === 'remove';
}
function isAggregateAction(action) {
    return action.type === 'aggregate';
}
function isAnyRemoveLibraryAction(action) {
    return ['removeLibrary', 'unfollowLibrary', 'leaveLibrary', 'permanentlyDeleteLibrary'].includes(action.name);
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
//TODO: fix this linter error when unit tests are in place
//https://jira.corp.adobe.com/browse/SHARED-4388
// eslint-disable-next-line no-useless-escape
const PATH_REGEX = /(\.[a-zA-Z0-9]+)|(\[\?\(([^\[\]]+)\)\])/g;
// eslint-disable-next-line no-useless-escape
const VALID_PATH_REGEX = /^\$(?:(\.[a-zA-Z0-9]+)|(\[\?\(([^\[\]]+)\)\]))*$/;
const EXPRESSION_REGEX = /^([^ ]+) *== *"(.+)"$/;
function validatesPath() {
    return function (target, propertyKey, descriptor) {
        const original = descriptor.value;
        descriptor.value = function (object, path, ...otherArgs) {
            if (!VALID_PATH_REGEX.test(path)) {
                throw new LibraryError('INVALID_PARAMETER', 'JSON Path is not valid');
            }
            return original.apply(this, [object, path, ...otherArgs]);
        };
        return descriptor;
    };
}
class JSONPath {
    static get(object, path) {
        var _a;
        if (path === '$') {
            return object;
        }
        return (_a = path
            .match(PATH_REGEX)) === null || _a === void 0 ? void 0 : _a.reduce((memo, part) => memo && this._handlePathPart(memo, part), object);
    }
    static set(object, path, value) {
        if (path === '$') {
            throw new LibraryError('INVALID_PARAMETER', 'Cannot set in root of object');
        }
        const parts = path.match(PATH_REGEX);
        if (parts) {
            const lastPart = parts.pop();
            const parentPath = parts.join('');
            if (!lastPart) {
                throw new LibraryError('INVALID_PARAMETER', 'JSON path must end in a field');
            }
            let parent = object;
            if (parentPath) {
                parent = this.get(object, `$${parentPath}`);
                if (!parent) {
                    throw new LibraryError('INVALID_PARAMETER', 'JSON path parent does not exist');
                }
            }
            parent[lastPart.substring(1)] = value;
            return value;
        }
    }
    static insert(object, path, value) {
        var _a;
        const array = (_a = this.get(object, path)) !== null && _a !== void 0 ? _a : this.set(object, path, []);
        if (!Array.isArray(array)) {
            Logger$1.warn('JSONPath.insert failed to insert into non-array');
            return;
        }
        array.push(value);
    }
    static remove(object, path) {
        const parts = path === null || path === void 0 ? void 0 : path.match(PATH_REGEX);
        const lastPart = parts === null || parts === void 0 ? void 0 : parts.pop();
        const parentArray = (parts === null || parts === void 0 ? void 0 : parts.reduce((memo, part) => memo && this._handlePathPart(memo, part), object)) || [];
        if (!(lastPart === null || lastPart === void 0 ? void 0 : lastPart.startsWith('[?('))) {
            throw new LibraryError('INVALID_PARAMETER', 'JSON Path must end in a filter');
        }
        if (!Array.isArray(parentArray)) {
            return;
        }
        const value = this._handleFilterExpression(parentArray, lastPart.substring(3, lastPart.length - 2));
        const index = parentArray.indexOf(value);
        if (index !== -1) {
            parentArray.splice(index, 1);
        }
    }
    static _handlePathPart(object, part) {
        if (part.startsWith('[?(')) {
            return this._handleFilterExpression(object, part.substring(3, part.length - 2));
        }
        return object[part.substring(1)];
    }
    static _handleFilterExpression(object, expression) {
        const [, a, b] = EXPRESSION_REGEX.exec(expression) || [];
        const path = a.replace(/^@/, '$');
        if (!Array.isArray(object)) {
            return undefined;
        }
        return object.find((item) => this.get(item, path) === b);
    }
}
__decorate([
    validatesPath()
], JSONPath, "get", null);
__decorate([
    validatesPath()
], JSONPath, "set", null);
__decorate([
    validatesPath()
], JSONPath, "insert", null);
__decorate([
    validatesPath()
], JSONPath, "remove", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
function insertObject(state, action) {
    JSONPath.insert(state, action.path, action.data);
    return state;
}
function updateObject(state, action) {
    const itemData = JSONPath.get(state, action.path);
    // TODO: Deep
    Object.assign(itemData, action.data);
    return state;
}
function removeObject(state, action) {
    JSONPath.remove(state, action.path);
    return state;
}
// Given a state and an Action, use the Action's path and data to update the state
function reducer(state, action) {
    if (isAggregateAction(action)) {
        return action.actions.reduce((memo, subAction) => reducer(memo, subAction), state);
    }
    if (isInsertAction(action)) {
        return insertObject(state, action);
    }
    if (isUpdateAction(action)) {
        return updateObject(state, action);
    }
    if (isRemoveAction(action)) {
        return removeObject(state, action);
    }
    return state;
}

// keeps `capacity` most recently added strings
class FIFOStringSet {
    constructor(capacity = 10) {
        this._cache = new Map();
        this._capacity = capacity;
    }
    has(key) {
        if (this._cache.get(key)) {
            return key;
        }
        return undefined;
    }
    add(key) {
        if (this._cache.has(key)) {
            this._cache.delete(key); // update timestamp if key already exists
        }
        else if (this._cache.size >= this._capacity) {
            // remove least recently added item
            const oldestKey = Array.from(this._cache.entries()).reduce((oldest, entry) => {
                return oldest[1] < entry[1] ? oldest : entry;
            })[0];
            this._cache.delete(oldestKey);
        }
        this._cache.set(key, Date.now());
    }
}

const richTypes = { Date: true, RegExp: true, String: true, Number: true };
function diff(
	obj,
	newObj,
	options = { cyclesFix: true },
	_stack = []
) {
	let diffs = [];
	const isObjArray = Array.isArray(obj);
	for (const key in obj) {
		const objKey = obj[key];
		const path = isObjArray ? +key : key;
		if (!(key in newObj)) {
			diffs.push({
				type: "REMOVE",
				path: [path],
				oldValue: obj[key],
			});
			continue;
		}
		const newObjKey = newObj[key];
		const areObjects =
			typeof objKey === "object" && typeof newObjKey === "object";
		if (
			objKey &&
			newObjKey &&
			areObjects &&
			!richTypes[Object.getPrototypeOf(objKey).constructor.name] &&
			(!options.cyclesFix || !_stack.includes(objKey))
		) {
			const nestedDiffs = diff(
				objKey,
				newObjKey,
				options,
				options.cyclesFix ? _stack.concat([objKey]) : []
			);
			diffs.push.apply(
				diffs,
				nestedDiffs.map((difference) => {
					difference.path.unshift(path);
					return difference;
				})
			);
		} else if (
			objKey !== newObjKey &&
			!(
				areObjects &&
				(isNaN(objKey)
					? objKey + "" === newObjKey + ""
					: +objKey === +newObjKey)
			)
		) {
			diffs.push({
				path: [path],
				type: "CHANGE",
				value: newObjKey,
				oldValue: objKey,
			});
		}
	}
	const isNewObjArray = Array.isArray(newObj);
	for (const key in newObj) {
		if (!(key in obj)) {
			diffs.push({
				type: "CREATE",
				path: [isNewObjArray ? +key : key],
				value: newObj[key],
			});
		}
	}
	return diffs;
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const ACTION_TYPE_HANDLERS = [
    {
        test: (action) => isAggregateAction(action) && ['moveGroup', 'copyGroup'].includes(action.name),
        handler: rebaseGroupActionWithContents
    },
    {
        test: (action) => isUpdateAction(action) && action.name === 'updateElementContent',
        handler: rebaseContentAction
    },
    {
        test: (action) => isUpdateAction(action) && action.name === 'updateGroup',
        handler: rebaseUpdateGroupAction
    },
    {
        test: (action) => isUpdateAction(action) && action.name === 'updateElement',
        handler: rebaseUpdateElementMetadataAction
    },
    {
        test: (action) => isAggregateAction(action) && action.name === 'removeElement',
        handler: rebaseRemoveElementAction
    },
    {
        test: (action) => isRemoveAction(action),
        handler: rebaseRemoveAction
    }
];
function rebaseContentAction(data, action) {
    const newBaseData = JSONPath.get(data, action.path);
    // 1. If a change to this element has been applied since this action was created
    if (newBaseData && newBaseData.modifiedDate !== action.baseData.modifiedDate) {
        if (!diff(newBaseData.representations, action.baseData.representations, {
            cyclesFix: false
        }).find(d => 
        // Disregard changes in id
        d.path[1] !== 'id' &&
            // Check if changes to representations are only additive
            d.type !== 'CREATE' &&
            // Disregard removals of undefined values
            !(d.oldValue === undefined && d.type === 'REMOVE'))) {
            // If this diff is only additive or a no-op, we will do nothing.
            return [action];
        }
    }
    // 2. If newBaseData does not exist recreate the element
    // OR if base modified dates have changed and the changes were more than additive, fork element
    if (!newBaseData || newBaseData.modifiedDate !== action.baseData.modifiedDate) {
        return [
            {
                name: 'createElement',
                type: 'insert',
                path: extractElementCollection(action.path),
                data: deepCopy(Object.assign(Object.assign(Object.assign({}, action.baseData), action.data), { id: createPlaceholderId() }))
            }
        ];
    }
    // 3. Otherwise, nothing to do
    return [action];
}
function rebaseGroupActionWithContents(data, action) {
    var _a;
    const actions = [];
    const groupId = extractGroupId(action.path);
    const oldElements = action.actions.map(subAction => subAction.name === 'removeElement' && subAction.baseData);
    const newElements = ((_a = data.elements) === null || _a === void 0 ? void 0 : _a.filter(el => el.groups.find(group => group.id === groupId))) || [];
    // 1. If a group member has been added, remove the element from the group before moving.
    // - Preprend action removing the element from the group
    const addedElements = newElements.filter(element => !oldElements.find(oldElement => oldElement.id === element.id));
    for (const element of addedElements) {
        actions.push({
            name: 'updateElement',
            type: 'update',
            path: `$.elements[?(@.id == "${element.id}")]`,
            data: {
                groups: element.groups.filter(group => group.id !== groupId)
            }
        });
    }
    // 2. If a group member has been removed, leave the element removed from the group.
    // - Remove element from aggregate's local actions
    const removedElements = oldElements.filter(element => !newElements.find(newElement => newElement.id === element.id));
    for (let i = action.actions.length - 1; i >= 0; i -= 1) {
        const subAction = action.actions[i];
        if (removedElements.find(element => element.id === subAction.baseData.id)) {
            action.actions.splice(i, 1);
        }
    }
    // 3. If a group member has been changed, remove the changed element from group, create a new element based on the original in group, move group
    // - Prepend createElement
    // - Prepend updateElement
    // - Replace old element with new element in aggregate's local actions
    actions.push(action);
    return actions;
}
function rebaseRemoveElementAction(data, action) {
    const newBaseData = JSONPath.get(data, action.path);
    const removeAction = action.actions.find(subAction => subAction.name === 'removeElement');
    // if element is changed, dont want to delete or create in removedElements
    if (!newBaseData || newBaseData.modifiedDate !== (removeAction === null || removeAction === void 0 ? void 0 : removeAction.baseData.modifiedDate)) {
        return [];
    }
    return [action];
}
function rebaseUpdateGroupAction(data, action) {
    const newBaseData = JSONPath.get(data, action.path);
    // If the target no longer exists, restore the target (group)
    // TODO: How do we restore the group members?
    if (!newBaseData) {
        return [
            {
                name: 'createGroup',
                type: 'insert',
                path: '$.groups',
                data: deepCopy(Object.assign(Object.assign(Object.assign({}, action.baseData), action.data), { id: createPlaceholderId() }))
            }
        ];
    }
    // Otherwise rebase the action. This doesn't really matter for a metadata update, but we might as well.
    return [
        Object.assign(Object.assign({}, action), { baseData: deepCopy(newBaseData) })
    ];
}
function rebaseUpdateElementMetadataAction(data, action) {
    const newBaseData = JSONPath.get(data, action.path);
    // If the target no longer exists, delete the action (element metadata)
    if (!newBaseData) {
        return [];
    }
    // Otherwise rebase the action. This doesn't really matter for a metadata update, but we might as well.
    return [
        Object.assign(Object.assign({}, action), { baseData: deepCopy(newBaseData) })
    ];
}
function rebaseRemoveAction(data, action) {
    const newBaseData = JSONPath.get(data, action.path);
    // If the target no longer exists, delete the action (nothing to delete)
    // If the element has been changed, delete the action (keep the changed element/group)
    if (!newBaseData || newBaseData.modifiedDate !== action.baseData.modifiedDate) {
        return [];
    }
    // Otherwise, keep the action (remove element/group)
    return [action];
}
function rebaseAction(data, action) {
    for (const { test, handler } of ACTION_TYPE_HANDLERS) {
        if (test(action)) {
            return handler(data, action);
        }
    }
    return [action];
}
function isTrainingSetLibrary(library) {
    var _a;
    return !!((_a = library.roles) === null || _a === void 0 ? void 0 : _a.some(role => role.type === 'cm_training_set'));
}
function isLibraryLoadedByDefault(library, enableBrandLifecycleManagement) {
    var _a, _b;
    if (!library || isTrainingSetLibrary(library)) {
        return false;
    }
    const isTeam = library.ownership === 'incoming';
    const isPersonal = library.ownership === 'private' || library.ownership === 'outgoing';
    const ownershipFilter = enableBrandLifecycleManagement ? isTeam : isPersonal;
    const isBookmarked = !!((_a = library.bookmark) === null || _a === void 0 ? void 0 : _a.id);
    const isApprovedBrand = !!((_b = library.roles) === null || _b === void 0 ? void 0 : _b.find(role => role.type === 'approvedbrand'));
    // A library is a loaded by default group if it is personal or bookmarked.
    // Training Set Libraries are currently excluded from the default listing.
    return ownershipFilter || isBookmarked || isApprovedBrand;
}

class Store extends TypedEventEmitter {
    constructor(_core, 
    /**
     * @internal
     * @package -- for use in SAM.js only
     */
    // TODO: Later, move internal API to using underscores.
    _apiRoot, library // holds a hard reference to the parent library
    ) {
        super();
        this._core = _core;
        this._apiRoot = _apiRoot;
        this.library = library;
        this._actions = [];
        this._reducer = reducer;
        this._operation = undefined;
        this._isSquelched = false;
        this._receivedEventDuringSquelchPeriod = false;
        this._pendingActionSemaphore = 0; // Track calls to beginOperation()
        this._pendingOperationResolvers = [];
        this._lastLocalUpdateDate = 0;
        this._previouslySeenEtags = new FIFOStringSet();
        /**
         * Pending actions are applied to the current state, but aren't yet ready to be committed.
         * Actions are added to this queue when an operation is in progress.
         */
        this._pendingActions = [];
        this._mergeBaseData = (newBase, progressiveLoad) => {
            // In the case of progressive loading, we should only add/update elements,
            // and not remove any elements in baseData that are missing from the newBase
            if (progressiveLoad === true) {
                const mergeElements = (newElements, baseElements) => {
                    const newElementIds = new Set(newElements.map(el => el.id));
                    const unchangedElements = baseElements.filter(el => !newElementIds.has(el.id));
                    return unchangedElements.concat(newElements);
                };
                const newElements = newBase.elements || [];
                const baseElements = this._baseData.elements || [];
                newBase.elements = mergeElements(newElements, baseElements);
            }
            this._baseData = Object.assign(Object.assign({}, this._baseData), newBase); // in case the newBase is a partial object, rather than replace baseData, we merge it in.
        };
        // TODO-R: Consider paring down LibraryContentsData to only these. Might need time stamps though.
        const startingState = {
            // Elements/groups need to be initialized even when the data is not yet available,
            // so that they can be referred to by JSONPath (e.g. '$.elements').
            groups: [],
            elements: [],
            // Not sure if I need these
            assetId: library.id,
            id: library._legacyLibraryId_NoLazyLoad,
        };
        this._baseData = startingState;
        this._currentData = deepCopy(startingState);
        this._assetPool = _apiRoot.assetPool;
        // shared pools across all libraries:
        this._elementPool = _apiRoot.elementPool;
        this._elementUpdater = _apiRoot.elementUpdater;
    }
    // local data (current state in UI)
    get data() {
        return this._currentData;
    }
    // last known remote or process state (regardless of whether the process has pushed the change to the server)
    get baseData() {
        return this._baseData;
    }
    get actions() {
        return this._actions;
    }
    /**
     * @internal
     * @package -- for use in SAM.js only
     */
    _revert() {
        // Clear any remaining actions
        this._actions = [];
        this._pendingActions = [];
        this._pendingActionSemaphore = 0;
        // Revert data back to last committed stable state
        const oldData = this._currentData;
        this._currentData = deepCopy(this._baseData);
        this._updateChildren(oldData, this._currentData);
        this.emit('change');
    }
    /**
     * Enqueue the user-initiated action to make the request to the remote server/process.
     * Also update the local state (currentData) optimistically, so the user sees the change immediately.
     *
     * Specifically this will:
     * 1. Put the action in the pendingActions queue
     * 2. LibraryContents - update currentData using reducer pattern.
     * 3. Children - update (local) data using the ItemUpdater pattern
     * 4. Emit a change event
     *
     * @param action
     * @package -- only for use in SAM.js
     */
    // uses a reducer to update currentData on libraryContents and propagate to the children using the ItemUpdater pattern.
    // However, since the Library class does not support optimistic updates, the Library should NOT be updated here.
    // It will continue to reflect the equivalent of baseData (last known server/process state).
    _actionDispatch(action) {
        // TODO: Optimistic updates are not currently supported on the Library itself in SAM.
        // But SAM does support viewing discarded assets. Therefore, we need to consider preventing actions except for restore on a discarded library.
        // if (this.isDeletedLocally) {
        //     Logger.log(`[LIBRARY] Cannot actionDispatch action on deleted library unless it is for a restore: ${this.id}`);
        //     return;
        // }
        var _a;
        if (!action.path) {
            action.path = '$';
        }
        // TODO: Where should we inject this data? Probably not here.
        if (action.type === 'aggregate') {
            (_a = action.actions) === null || _a === void 0 ? void 0 : _a.map(subAction => {
                if (subAction.type === 'remove') {
                    const item = JSONPath.get(this._currentData, action.path);
                    subAction.baseData = {
                        modifiedDate: item.modifiedDate
                    };
                }
                return subAction;
            });
        }
        if (action.type === 'remove') {
            const item = JSONPath.get(this._currentData, action.path);
            action.baseData = {
                modifiedDate: item.modifiedDate
            };
        }
        if (action.type === 'update') {
            action.baseData = deepCopy(JSONPath.get(this._currentData, action.path));
        }
        // Deep copy the data here so it doesn't get updated via reference.
        if (isInsertAction(action) || isUpdateAction(action)) {
            action.data = deepCopy(action.data);
        }
        const currentData = this._reducer(this._currentData, action);
        if (this.isOperationInProgress) {
            this._pendingActions.push(action);
        }
        else {
            this._actions.push(action);
        }
        this._currentData = currentData;
        this._lastLocalUpdateDate = Date.now();
        // If the action is a no-op, then the state hasn't changed. No need to update caches
        // or emit a change event since the data didn't actually change.
        if (action.type !== 'no-op') {
            // TODO-R[SHARED-5159]: A 'no-op' action.type from _actionDispatch will not define old/baseData. We need to account for this when implementing CRUD updates, and diffing, in _updateChildren.
            this._updateChildren(action.baseData, currentData);
            // Need to call change listener after caches have been updated. Otherwise we may end up in an inconsistent state.
            this.emit('change');
        }
    }
    /**
     * Post remote modification (on server or process), merge the new data into the store.
     *
     * Specifically this will update:
     * 1. LibraryContents - use reducer pattern to update baseData, then rebase currentData and actions (and placeholderIDs) on top.
     * 2. Children - update using ItemUpdater pattern (Reflects currentData rebased on top of baseData)
     * @param actions   The actions that were committed.
     * @param [etag]    The new etag for the library.
     */
    _commit(actions, etag) {
        if (!this._confirmActionsAtHead(actions)) ;
        markSubstitutedPlaceholders(actions);
        // The same actions that have been replayed on the baseData to get the currentData
        // are now replayed on baseData to get the new baseData,
        // effectively bringing baseData up to date with the currentData at commit().
        let newBaseData = Object.assign({}, this._baseData);
        for (const action of actions) {
            // The actions contain the returned json from each operation in the data property,
            // so we can use that to update the baseData
            newBaseData = this._reducer(newBaseData, action);
            this._actions.shift();
        }
        this._actions = replacePlaceholders(actions, this._actions);
        // All commits should have an etag from the server. We want to update it now for this batch of committed actions.
        if (etag) {
            this._previouslySeenEtags.add(this.etag);
            newBaseData.etag = etag;
        }
        this._lastLocalUpdateDate = Date.now();
        this._update(newBaseData, false);
        actions.forEach(action => {
            // If locally removed/unfollowed library, remove from cache
            // Remotely removed libs are handled in the top level listener (e.g. sync group listener)
            if (isAnyRemoveLibraryAction(action)) ;
        });
        this.emit('action', ...actions.map(action => ({ type: 'commit', action })));
        this.emit('commit');
    }
    _confirmActionsAtHead(actions) {
        if (this._actions.length < actions.length) {
            return false;
        }
        for (const i in actions) {
            if (actions[i] !== this._actions[i]) {
                return false;
            }
        }
        return true;
    }
    // Delay dispatching actions until the outermost endOperation() call, which should result in one atomic batch request, for less server traffic.
    // Note: A more appropriate name at this point would be something like 'startBatchingActions'/'endBatchingActions'
    // since we now have a separate 'Operation' concept, which is a portion of the Driver that represents an atomic API request
    // containing batchable actions, and technically the Operation is not constructed until a _actionDispatch occurs.
    // Meaning the driver Operation doesn't actually exist until the outermost endOperation() is called.
    /**
     * @package -- only for use in SAM.js
     */
    beginOperation() {
        this._squelchChangeEvents();
        this._pendingActionSemaphore += 1;
        Logger$1.log(`[STORE] Starting operation (Depth: ${this._pendingActionSemaphore})`);
    }
    // On the outermost endOperation call, dispatch all pending actions
    // After the orchestrator has made the server request(s) and called library._commit,
    // resolve all endOperation promises.
    endOperation(_callback) {
        this._pendingActionSemaphore = Math.max(0, this._pendingActionSemaphore - 1);
        Logger$1.log(`[STORE] Ending operation (Depth: ${this._pendingActionSemaphore})`);
        if (this._pendingActionSemaphore === 0) {
            Logger$1.log(`[STORE] Reached end of operation stack. Adding actions to queue...`);
            const collapsedActions = this._collapseActions(this._pendingActions);
            this._actions = this.actions.concat(collapsedActions);
            this._pendingActions = [];
            this.emit('action', ...collapsedActions.map(action => ({ type: 'dispatch', action })));
            this._unsquelchChangeEvents();
            return new Promise(resolve => {
                const onCommit = () => {
                    if (this._actions.length) {
                        return; // we still need to listen for 'commit' events
                    }
                    // We only want to resolve all operations' promises after all actions have been committed
                    this._pendingOperationResolvers.forEach(resolve => resolve());
                    this._pendingOperationResolvers = [];
                    resolve();
                    // all side effects following 'commit' events have been handled
                    this.off('commit', onCommit);
                };
                this.on('commit', onCommit);
            });
        }
        return new Promise(resolve => {
            this._pendingOperationResolvers.push(resolve);
        });
    }
    /**
     * @package -- only for use in SAM.js
     */
    // TODO-R: Need to make sure that the refactored change events can be squelched.
    // That means session.commit() for itemUpdater pattern models such as element
    // and emit('change') for Representation and Store
    _squelchChangeEvents() {
        this._isSquelched = true;
    }
    /**
     * @package -- only for use in SAM.js
     */
    _unsquelchChangeEvents() {
        this._isSquelched = false;
        if (this._receivedEventDuringSquelchPeriod) {
            this._receivedEventDuringSquelchPeriod = false;
            this.emit('change');
        }
    }
    emit(eventName, ...args) {
        if (this._isSquelched && eventName === 'change') {
            this._receivedEventDuringSquelchPeriod = true;
            return this.listenerCount(eventName) > 0;
        }
        return super.emit(eventName, ...args);
    }
    get etag() {
        return this._baseData.etag;
    }
    set etag(value) {
        this._baseData.etag = value;
    }
    /*
        Note: This is a Library operation. (i.e. wait to dispatch until the operation closes)
     */
    get isOperationInProgress() {
        return this._pendingActionSemaphore !== 0;
    }
    /*
        Note: This is an Orchestrator operation. (i.e. batch these compatible dispatched actions)
     */
    set operation(operation) {
        this._operation = operation;
    }
    get operation() {
        return this._operation;
    }
    // TODO: I believe we can deprecate this, as I don't see it being used anywhere.
    // Also, should probably consolidate with library.locallyManaged which comes from data.locallyManaged
    // get isLocallyManaged(): boolean {
    //     return this._apiRoot.isLocallyManaged;
    // }
    /**
     * Iterates through all of the passed-in actions, combines actions that contain changes upon the same element into one action
     * This helps reduce the number of requests we send out
     *
     * @param {DisaptchAction[]} actions An array of actions to execute within the current operation.
     * @returns {Action[]} newActions
     */
    _collapseActions(actions) {
        // For now, all we really need to collapse are create element actions and their subsequent updates
        const newActions = [];
        const newElementActions = {};
        const updateElementContentActions = {};
        for (const action of actions) {
            if (['updateElement', 'updateElementContent'].includes(action.name) && isUpdateAction(action)) {
                const elementId = extractElementId$1(action.path);
                const newElementAction = newElementActions[elementId];
                if (newElementAction) {
                    Logger$1.log('[LIBRARY] Identified collapsible action (updateElement). Combining with (createElement)');
                    newElementAction.data = Object.assign(Object.assign({}, newElementAction.data), action.data);
                    continue;
                }
                const updateElementContentAction = updateElementContentActions[elementId];
                if (updateElementContentAction) {
                    updateElementContentAction.data = Object.assign(Object.assign({}, updateElementContentAction.data), action.data);
                    continue;
                }
            }
            if (action.name === 'createElement' && isInsertAction(action)) {
                newElementActions[action.data.id] = action;
            }
            if (action.name === 'updateElementContent' && isUpdateAction(action)) {
                updateElementContentActions[extractElementId$1(action.path)] = action;
            }
            newActions.push(action);
        }
        return newActions;
    }
    /**
     * Model APIs
     */
    /**
     * @internal
     * @package -- for use in SAM.js only
     */
    /**
     * When new remote data from the server/process arrives, update the base state, and rebase the current state and action queue on top of it.
     *
     * Specifically this will update the state of:
     * LibraryContents - overwrite the baseData, then rebase the currentData and actions using the reducer pattern
     * Children - update (local) data using the ItemUpdater pattern
     *
     * It will NOT update:
     * Library - When the server update came in, lazy loading library data would already be handled by the Library._load.
     * (Also fyi, since the Library class does not yet support optimistic updates, there is no currentData to rebase in Library.)
     * @param newBase - the newest data from the server
     * @param progressiveLoad
     *  - should be true if the newBase contains an incomplete elements array (e.g. when loading elements page by page in the ElementLoader).
     *    Only handles adding/updating elements. Will not result in deleting any elements (from either base or current data).
     *  - should be false if the newBase contains a full elements array (e.g. when fetching the manifest after a change notification).
     *    Will delete elements that are not in the newBase, in addition to adding/updating elements.
     * @returns the updated base data
    */
    // TODO-R[SHARED-4629]: Also look into why this returns the baseData, unlike on Model. Ideally we can remove this if not needed to keep the API the same.
    _update(newBase, progressiveLoad) {
        // Shallow copy newBase data into existing baseData
        this._mergeBaseData(newBase, progressiveLoad);
        // Rebase action queue (e.g. if an element has been removed, remove the removeElement action) and currentData on top of updated baseData
        this._rebaseCurrentDataAndActions();
        // Unlike the children which use the UpdateSession to emit notifications on the Items upon commit,
        // the Store should just emit a change.
        this.emit('change');
    }
    // Rebase currentData and actions on top of the new baseData
    // See the Library conflicts tests and LibraryUtils.rebaseAction tests for more information
    _rebaseCurrentDataAndActions() {
        let newCurrentData = deepCopy(this._baseData);
        this._actions = this._actions
            .map(action => {
            const rebasedActions = rebaseAction(newCurrentData, action);
            newCurrentData = rebasedActions.reduce((memo, rebasedAction) => this._reducer(newCurrentData, rebasedAction), newCurrentData);
            return rebasedActions;
        })
            .flat();
        this._pendingActions = this._pendingActions
            .map(action => {
            const rebasedActions = rebaseAction(newCurrentData, action);
            newCurrentData = rebasedActions.reduce((memo, rebasedAction) => this._reducer(newCurrentData, rebasedAction), newCurrentData);
            return rebasedActions;
        })
            .flat();
        // This is the local state of models in the pool prior to being updated, which is kept temporarily to diff the latest current data and make appropriate changes to the children.
        // TODO-R[SHARED-4711]: Later on, when we remove this._currentData after updating the children (since it duplicates the same data now saved in the item),
        // we won't have this old data available for this short cut. Getting existing currentData would require finding the
        // elements in the pool for this library, then serializing them into current Data.
        const oldCurrentData = this._currentData;
        // Update local state on the Store.
        // TODO-R[SHARED-4711]: This actually duplicates the data that will be saved in the child Items next.
        // To de-dupe memory usage, we can get rid of this. BUT, currentData will need to be recreated above and in actionDispatch().
        // For more info: https://wiki.corp.adobe.com/display/ACPCSDK/Additional+Changes+to+State+Management
        this._currentData = newCurrentData;
        // Update local state of children using diff of current and previous local data from the Store
        this._updateChildren(oldCurrentData, newCurrentData);
    }
    /**
     * Diff previous and new currentData to determine what has changed.
     * Then update, add, or remove elements accordingly. (Groups to be supported in the future.)
     * Note: oldData and newData are both expected to have a *full* list of elements, (as far as we have fetched so far in the baseData,
     * with any local changes (which may include deletes) rebased on top).
     */
    _updateChildren(oldData, newData) {
        // TODO-R[SHARED-5159]: A 'no-op' action.type from _actionDispatch will not define old/baseData. We need to account for this when implementing CRUD updates, and diffing.
        const elementPool = this._elementPool;
        const session = elementPool.createUpdateSession();
        const newElementsData = newData.elements;
        const oldElementsData = oldData.elements;
        // Find model that matches data.id/previousPlaceholderId and update *before* doing any removals
        const upsertItems = () => {
            /* Note: It would be nice if we could just call `updater.updateRemoteItems(session, newElementsData);`
                to handle both creating and updating items, but it doesn't handle everything that Model._update does,
                such as custom placeholder logic and updating children. In theory, it *could* though.
                We could optimize to combine the compoundId and placeholder logic, and when data comes through the model/elementUpdater,
                it can call a function to do special handling for the id and for child properties like 'representations'. */
            newElementsData.forEach(data => {
                // TODO-R[SHARED-4488]: Use compound id once supported.
                // TODO-R[SHARED-4970]: Make sure placeholderId updates working as expected.
                // TODO-R[SHARED-4971]: When we support CRUD updates, make sure this item has not been deleted locally before updating it.
                const item = data.previousPlaceholderId ? elementPool.getLocalItemById(data.previousPlaceholderId) : elementPool.getLocalItemById(getCombinedId(data));
                if (item) {
                    // Update existing items in the pool
                    // TODO-R[SHARED-5159]: Diff old/new data with deep object equality to check if an update is needed
                    item._update(data); // TODO-R[SHARED-4970]: Ensure this updates the placeholderId to the real id in the Updater
                }
                else {
                    // Create new items in the pool
                    // TODO-R[SHARED-4970]: Consider whether placeholder IDs will ever need to be considered here.
                    // I believe that if the change is always coming from the server, there won't be any placeholder IDs.
                    // But we need to analyze each use case of updateChildren() to be sure.
                    this._elementUpdater.updateRemoteItem(session, data);
                }
            });
        };
        const removeItems = () => {
            // 1. Get a set of IDs from new data
            const currentDataIds = new Set(newElementsData.map(data => data.id));
            // 2. Find the models that are not included in the updated set
            const removedItems = oldElementsData.filter(data => !currentDataIds.has(data.id)); // May include some that had placeholder IDs
            // 3. Remove those models from the pool
            removedItems.forEach(data => {
                const item = elementPool.getLocalItemById(getCombinedId(data)); // Should not return an item if using its old placeholder id
                if (item) {
                    session.queueDiscardedItem(item);
                }
                // Note: It is sufficient to call queueDiscardedItem and not elementPool.removeLocalItem(item) because
                // the item should not be updated in upsertItems() as there should be no overlap between the removedItems and newElementsData.
            });
        };
        upsertItems();
        removeItems();
        session.commit();
    }
    /**
     * @internal
     * @package -- for use in SAM.js only
     */
    get _driver() {
        return this._apiRoot.driver;
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Manager for LibraryContents (Elements, Groups, etc.) which exposes public APIs for fetching elements and groups.
 * This class can be thought of like an ElementContext, except that it has the additional responsibility of managing state.
 * Inherits from Store, which holds the data and updates the state for the library's contents.
 */
class LibraryContents extends Store {
    // async _load() - When there's a change notification, reloads all elements, groups, and applies update
    // elementsSource - Returns ElementSource for fetching element lists
    // groupsSource	 - Returns GroupSource for fetching group lists
    // getElementById(id) - Loads a single element. (Note: For the time being, elements will only be kept up to date by ONS notifications when all the elements are loaded in a library.)
    async getElementById(elementId) {
        const combinedId = `${this.library.id}#${elementId}`;
        let element = this._elementPool.getLocalItemById(combinedId);
        if (!element) {
            const elementData = await this._driver.getElement(this.library, elementId);
            this._update({ elements: [elementData] }, true);
            element = this._elementPool.getLocalItemById(combinedId);
        }
        if (!element) {
            throw new LibraryError('INVALID_PARAMETER', 'Need to pass a valid element ID');
        }
        return Promise.resolve(element);
    }
    /* Store API Overrides */
    /**
     * @internal
     * @package -- for use in SAM.js only
     */
    // TODO: Move this into Store._actionDispatch
    _actionDispatch(action) {
        if (!action.library) {
            action.library = this.library;
        }
        if (!action.libraryContents) {
            action.libraryContents = this;
        }
        super._actionDispatch(action);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class Group extends Published {
    constructor() {
        super(...arguments);
        this.isGroup = true;
        this._isDeletedLocally = false;
        this._updateAction = 'updateGroup';
        // TODO-R: Temporarily avoids breaking code. When updating this file to use ItemUpdater Pattern, remove this.
        this._data = {};
    }
    get data() {
        return this._data;
    }
    get classifierName() {
        return this.data.classifier;
    }
    get name() {
        return this.data.name;
    }
    set name(name) {
        this._actionDispatch({
            name: 'updateGroup',
            type: 'update',
            data: { name }
        });
    }
    get order() {
        return this.data.order;
    }
    set order(order) {
        this._actionDispatch({
            name: 'updateGroup',
            type: 'update',
            data: { order }
        });
    }
    get modified() {
        return this.data.modifiedDate;
    }
    get modifiedBy() {
        return this.data.modifiedBy;
    }
    get modifiedContext() {
        return this.data.modifiedContext;
    }
    get wasModifiedLocally() {
        return this.data.modifiedLocally;
    }
    get created() {
        return this.data.createdDate;
    }
    get createdBy() {
        return this.data.createdBy;
    }
    get createdContext() {
        return this.data.createdContext;
    }
    get wasCreatedLocally() {
        return this.data.createdLocally;
    }
    getValue(namespace, key) {
        var _a;
        return (_a = this.data.customData) === null || _a === void 0 ? void 0 : _a[`${namespace}#${key}`];
    }
    getValues() {
        return mapAttributesToArray(this.data.customData);
    }
    get children() {
        // @ts-expect-error // TODO: Fix this
        return this.library.getGroups(this.classifierName).filter(group => group.parent && group.parent.id === this.id);
    }
    getFilteredChildren(predicate) {
        return this.children.filter(predicate);
    }
    get elements() {
        const elements = [];
        const processElement = (element) => element.getOrderInGroup(this) !== undefined && elements.push(element);
        this.library.elements.forEach(processElement);
        this.library.documentationElements.forEach(processElement);
        return elements;
    }
    /**
     * Returns true if the group has no child groups and no elements associated
     */
    isEmpty() {
        return this.elements.length === 0 && this.children.length === 0;
    }
    setValue(namespace, key, value, _isMetadata) {
        this._actionDispatch({
            name: 'updateGroup',
            type: 'update',
            data: {
                customData: Object.assign(Object.assign({}, this.data.customData), { [`${namespace}#${key}`]: value })
            }
        });
    }
    removeValue(namespace, key, isMetadata) {
        this.setValue(namespace, key, null, isMetadata);
    }
    /**
     * @deprecated
     */
    get isDeletedLocally() {
        return this._isDeletedLocally;
    }
    set isDeletedLocally(isDeletedLocally) {
        this._isDeletedLocally = isDeletedLocally;
        this.emit('change');
    }
    get library() {
        return this._parent;
    }
    getLocalizedName(locale = 'en_US') {
        var _a;
        return (_a = this.data.localizedNames) === null || _a === void 0 ? void 0 : _a[locale];
    }
    getLocalizedNames() {
        return this.data.localizedNames || {};
    }
    setLocalizedName(locale, name) {
        return this._actionDispatch({
            name: 'updateGroup',
            type: 'update',
            data: {
                localizedNames: Object.assign(Object.assign({}, this.data.localizedNames), { [locale]: name })
            }
        });
    }
    get parent() {
        return this.library.getGroupById(this._data.parentId);
    }
    set parent(group) {
        this._actionDispatch({
            name: 'updateGroup',
            type: 'update',
            data: { parentId: (group === null || group === void 0 ? void 0 : group.id) || null }
        });
    }
    /**
     * @package -- only for use in SAM.js
     */
    _createChild(name, order) {
        const id = createPlaceholderId();
        this._actionDispatch({
            name: 'createGroup',
            type: 'insert',
            data: { id, name, order, classifier: this.classifierName, parentId: this.id },
            path: '$.groups'
        });
        return this.library.getGroupById(id);
    }
    /**
     * @package -- only for use in SAM.js
     */
    _actionDispatch(action) {
        if (!action.path) {
            action.path = `$.groups[?(@.id == "${this.id}")]`;
        }
        this.library._actionDispatch(action);
    }
}
__decorate([
    observable,
    requiresWrite
], Group.prototype, "name", null);
__decorate([
    observable,
    requiresWrite
], Group.prototype, "order", null);
__decorate([
    observable
], Group.prototype, "modified", null);
__decorate([
    observable
], Group.prototype, "modifiedBy", null);
__decorate([
    observable
], Group.prototype, "modifiedContext", null);
__decorate([
    observable
], Group.prototype, "wasModifiedLocally", null);
__decorate([
    observable
], Group.prototype, "created", null);
__decorate([
    observable
], Group.prototype, "createdBy", null);
__decorate([
    observable
], Group.prototype, "createdContext", null);
__decorate([
    observable
], Group.prototype, "wasCreatedLocally", null);
__decorate([
    observable
], Group.prototype, "getValue", null);
__decorate([
    observable
], Group.prototype, "getValues", null);
__decorate([
    observable
], Group.prototype, "children", null);
__decorate([
    observable
], Group.prototype, "getFilteredChildren", null);
__decorate([
    observable
], Group.prototype, "elements", null);
__decorate([
    observable
], Group.prototype, "isEmpty", null);
__decorate([
    requiresWrite
], Group.prototype, "setValue", null);
__decorate([
    requiresWrite
], Group.prototype, "removeValue", null);
__decorate([
    observable
], Group.prototype, "isDeletedLocally", null);
__decorate([
    observable
], Group.prototype, "getLocalizedName", null);
__decorate([
    observable
], Group.prototype, "getLocalizedNames", null);
__decorate([
    requiresWrite
], Group.prototype, "setLocalizedName", null);
__decorate([
    requiresWrite,
    observable
], Group.prototype, "parent", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
class Team extends Model {
    constructor() {
        super(...arguments);
        // TODO-R: Temporarily avoids breaking code. When updating this file to use ItemUpdater Pattern, remove this.
        this._data = {};
    }
    get data() {
        return this._data;
    }
    get name() {
        return this._data.name;
    }
    get owner() {
        return this._data.owner;
    }
    get ownerName() {
        return this._data.ownerName;
    }
    get isReadOnly() {
        return this._data.isReadOnly;
    }
    get isWritable() {
        return this._data.isWritable;
    }
    async _refreshGradient() {
        // Don't refetch the gradient.
        if (this._data.gradient) {
            return this._data.gradient;
        }
        const gradient = await this._apiRoot.driver.getProjectGradient(this);
        this._update({ gradient });
    }
    get gradientData() {
        this._refreshGradient();
        return this._data.gradient;
    }
}
__decorate([
    observable
], Team.prototype, "gradientData", null);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};

var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}

// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: milliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

// @generated from regex-gen.ts
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = __assign(__assign(__assign({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = __assign(__assign(__assign({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return (__assign(__assign({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = __assign(__assign({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = __assign(__assign({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = __assign(__assign({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = __assign(__assign({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = __assign(__assign({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData['001'];
    return hourCycles[0];
}

var _a;
var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, __assign({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = __assign({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    __extends(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));
var InvalidValueError = /** @class */ (function (_super) {
    __extends(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));
var InvalidValueTypeError = /** @class */ (function (_super) {
    __extends(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));
var MissingValueError = /** @class */ (function (_super) {
    __extends(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));

var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && isLiteralElement(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if (isLiteralElement(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if (isPoundElement(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new MissingValueError(varName, originalMessage);
        }
        var value = values[varName];
        if (isArgumentElement(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (isDateElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTimeElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : isDateTimeSkeleton(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isNumberElement(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : isNumberSkeleton(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if (isTagElement(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new InvalidValueTypeError(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if (isSelectElement(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if (isPluralElement(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new InvalidValueError(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return __assign(__assign(__assign({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = __assign(__assign({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, __assign({}, defaultConfig));
}
function createFastMemoizeCache$1(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache$1(cache.number),
            strategy: strategies.variadic,
        }),
        getDateTimeFormat: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache$1(cache.dateTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: memoize(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache$1(cache.pluralRules),
            strategy: strategies.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== PART_TYPE.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return formatToParts(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () {
            var _a;
            return ({
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) ||
                    Intl.NumberFormat.supportedLocalesOf(_this.locales)[0],
            });
        };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            var _a = opts || {}; _a.formatters; var parseOpts = __rest(_a, ["formatters"]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, __assign(__assign({}, parseOpts), { locale: this.resolvedLocale }));
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        if (typeof Intl.Locale === 'undefined') {
            return;
        }
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = parse;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    __extends(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception
            ? exception instanceof Error
                ? exception
                : new Error(String(exception))
            : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
            // @ts-ignore just so we don't need to declare dep on @types/node
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));
var UnsupportedFormatterError = /** @class */ (function (_super) {
    __extends(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));
var InvalidConfigError = /** @class */ (function (_super) {
    __extends(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));
var MissingDataError = /** @class */ (function (_super) {
    __extends(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));
var IntlFormatError = /** @class */ (function (_super) {
    __extends(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}(IntlError));
var MessageFormatError = /** @class */ (function (_super) {
    __extends(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError));
var MissingTranslationError = /** @class */ (function (_super) {
    __extends(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage
            ? "default message (".concat(typeof descriptor.defaultMessage === 'string'
                ? descriptor.defaultMessage
                : descriptor.defaultMessage
                    .map(function (e) { var _a; return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e); })
                    .join(), ")")
            : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));

function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return allowlist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (process.env.NODE_ENV !== 'production') {
        console.error(error);
    }
};
var defaultWarnHandler = function (warning) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (process.env.NODE_ENV !== 'production') {
        console.warn(warning);
    }
};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = memoize(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: strategies.variadic,
    });
    var getNumberFormat = memoize(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: strategies.variadic,
    });
    var getPluralRules = memoize(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: strategies.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: memoize(function (message, locales, overrideFormats, opts) {
            return new IntlMessageFormat(message, locales, overrideFormats, __assign({ formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                } }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: strategies.variadic,
        }),
        getRelativeTimeFormat: memoize(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: strategies.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: memoize(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: strategies.variadic,
        }),
        getDisplayNames: memoize(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, __spreadArray([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: strategies.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new UnsupportedFormatterError("No ".concat(type, " format named: ").concat(name)));
}

function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}
memoize(function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Intl.NumberFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
}, {
    strategy: strategies.variadic,
});
memoize(function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
}, {
    strategy: strategies.variadic,
});
memoize(function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Intl.PluralRules).bind.apply(_a, __spreadArray([void 0], args, false)))();
}, {
    strategy: strategies.variadic,
});
memoize(function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Intl.Locale).bind.apply(_a, __spreadArray([void 0], args, false)))();
}, {
    strategy: strategies.variadic,
});
memoize(function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return new ((_a = Intl.ListFormat).bind.apply(_a, __spreadArray([void 0], args, false)))();
}, {
    strategy: strategies.variadic,
});

function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = __assign({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys(__assign(__assign({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = __assign(__assign({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = IntlMessageFormat.formats;
    return __assign(__assign(__assign({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
var formatMessage = function (_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    invariant(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = 
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === TYPE.literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = __assign(__assign({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
            return message;
        }
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new MissingTranslationError(messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new MessageFormatError("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, __assign({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new MessageFormatError("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new MessageFormatError("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
};

var DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits',
];
function getFormatter$2(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = __assign(__assign({}, (timeZone && { timeZone: timeZone })), (format && getNamedFormat(formats, type, format, onError)));
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = __assign(__assign({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter$2(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new IntlFormatError('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter$2(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new IntlFormatError('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new IntlFormatError('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter$2(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    }
    catch (e) {
        config.onError(new IntlFormatError('Error formatting date.', config.locale, e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return getFormatter$2(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    }
    catch (e) {
        config.onError(new IntlFormatError('Error formatting time.', config.locale, e));
    }
    return [];
}

var DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new FormatError("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", ErrorCode.MISSING_INTL_API));
    }
    var filteredOptions = filterProps(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new IntlFormatError('Error formatting display name.', locale, e));
    }
}

var LIST_FORMAT_OPTIONS = [
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) { options = {}; }
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
            all.push(val);
        }
        else if (typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += val;
        }
        else {
            all.push(val);
        }
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new FormatError("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", ErrorCode.MISSING_INTL_API));
    }
    var filteredOptions = filterProps(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions)
            .formatToParts(serializedValues)
            .map(function (part) {
            return part.type === 'literal'
                ? part
                : __assign(__assign({}, part), { value: richValues_1[part.value] || part.value });
        });
    }
    catch (e) {
        onError(new IntlFormatError('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

var PLURAL_FORMAT_OPTIONS = ['type'];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", ErrorCode.MISSING_INTL_API));
    }
    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new IntlFormatError('Error formatting plural.', locale, e));
    }
    return 'other';
}

var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function getFormatter$1(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && getNamedFormat(formats, 'relative', format, onError)) || {};
    var filteredOptions = filterProps(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new FormatError("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", ErrorCode.MISSING_INTL_API));
    }
    try {
        return getFormatter$1(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new IntlFormatError('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

var NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        getNamedFormat(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new IntlFormatError('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new IntlFormatError('Error formatting number.', config.locale, e));
    }
    return [];
}

function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn &&
        config.defaultRichTextElements &&
        messagesContainString(config.messages || {})) {
        config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl(config, cache) {
    var formatters = createFormatters(cache);
    var resolvedConfig = __assign(__assign({}, DEFAULT_INTL_CONFIG), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new InvalidConfigError("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new MissingDataError("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new MissingDataError("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    verifyConfigMessages(resolvedConfig);
    return __assign(__assign({}, resolvedConfig), { formatters: formatters, formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), 
        // @ts-expect-error TODO: will get to this later
        formatMessage: formatMessage.bind(null, resolvedConfig, formatters), 
        // @ts-expect-error TODO: will get to this later
        $t: formatMessage.bind(null, resolvedConfig, formatters), formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const DEFAULT_LOCALE = 'en-US';
/**
 * Set of supported locales that the jsapi has predefinds translations for.
 * Falls back on English if the locale requested does not exist in the list below.
 *
 * This may seem a little disgusting but with the typescript update (v4.9.5)
 * The ES5 target throws a wedge in dynamic imports. E.g.
 *
 * This:
 * ```
 * const locale = 'en-US';
 * async import(`./locale/${en-US}.json`)
 * ```
 *
 * Gets converted into this:
 * ```
 * var locale = 'en-US';
 * var path = './locale/'.concat(locale, '.json');
 * return Promise.resolve().then(() => require(path))
 * ```
 *
 * This breaks Webpack's dynamic import flow. It is raised as a warning but webpack attempts to
 * load the locale data from the wrong location. We then end up in a perpetual loop.
 * This needs to stay as is so the dynamic import knows exactly where to pull the files from.
 * At least till the underlying transformation is fixed.
 */
const SUPPORTED_LOCALES = {
    'cs-CZ': () => Promise.resolve().then(function () { return csCZ$1; }),
    'da-DK': () => Promise.resolve().then(function () { return daDK$1; }),
    'de-DE': () => Promise.resolve().then(function () { return deDE$1; }),
    'en-US': () => Promise.resolve().then(function () { return enUS$1; }),
    'es-ES': () => Promise.resolve().then(function () { return esES$1; }),
    'fi-FI': () => Promise.resolve().then(function () { return fiFI$1; }),
    'fr-CA': () => Promise.resolve().then(function () { return frCA$1; }),
    'fr-FR': () => Promise.resolve().then(function () { return frFR$1; }),
    'fr-MA': () => Promise.resolve().then(function () { return frMA$1; }),
    'hu-HU': () => Promise.resolve().then(function () { return huHU$1; }),
    'it-IT': () => Promise.resolve().then(function () { return itIT$1; }),
    'ja-JP': () => Promise.resolve().then(function () { return jaJP$1; }),
    'ko-KR': () => Promise.resolve().then(function () { return koKR$1; }),
    'nb-NO': () => Promise.resolve().then(function () { return nbNO$1; }),
    'nl-NL': () => Promise.resolve().then(function () { return nlNL$1; }),
    'pl-PL': () => Promise.resolve().then(function () { return plPL$1; }),
    'pt-BR': () => Promise.resolve().then(function () { return ptBR$1; }),
    'ru-RU': () => Promise.resolve().then(function () { return ruRU$1; }),
    'sv-SE': () => Promise.resolve().then(function () { return svSE$1; }),
    'tr-TR': () => Promise.resolve().then(function () { return trTR$1; }),
    'uk-UA': () => Promise.resolve().then(function () { return ukUA$1; }),
    'zh-CN': () => Promise.resolve().then(function () { return zhCN$1; }),
    'zh-TW': () => Promise.resolve().then(function () { return zhTW$1; }),
    'zu-ZU': () => Promise.resolve().then(function () { return zuZU$1; }),
    'zz-ZZ': () => Promise.resolve().then(function () { return zzZZ$1; })
};
class IntlInterface {
    constructor(locale = DEFAULT_LOCALE) {
        this.setLocale(locale);
    }
    get locale() {
        return this._locale;
    }
    async setLocale(locale) {
        if (!SUPPORTED_LOCALES[locale]) {
            Logger$1.log(`[INTL] ${locale} is not a supported language. Falling back to en-US`);
            locale = DEFAULT_LOCALE;
        }
        const { messages, locale: _locale } = await this._loadLocaleData(locale);
        // We load the localized strings manually, but we still need to specify `locale`
        // for localization of non-string values like numbers, dates, etc.
        // We give a fallback `defaultLocale` to use if the given `locale` doesn't have a
        // defined localization configuration for those non-string values.
        this._intl = createIntl({ locale, messages, defaultLocale: DEFAULT_LOCALE }, createIntlCache());
        this._locale = _locale;
        return locale;
    }
    _loadLocaleData(locale) {
        return SUPPORTED_LOCALES[locale]()
            .then(messages => ({ messages, locale }))
            .catch(_e => this._loadLocaleData(DEFAULT_LOCALE));
    }
    formatMessage(id, values) {
        if (!this._intl) {
            Logger$1.log(`[INTL] no localization data loaded`);
            return;
        }
        return this._intl.formatMessage({ id }, values);
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Element
 * @packageDocumentation
 * @module FontManager
 */
class FontManager extends RestrictedEventEmitter {
    constructor(_driver) {
        super();
        this._driver = _driver;
        this._fontsCache = {};
    }
    /**
     * Returns the cached font data else goes ahead and fetches it
     */
    async getFontData(fontId) {
        const fontData = this._fontsCache[fontId];
        if (fontData) {
            // Already exists in the cache
            return fontData;
        }
        const data = await this._driver.getFontData(fontId);
        this._updateFontData(fontId, data);
        return data;
    }
    _updateFontData(fontId, fontData) {
        this._fontsCache[fontId] = fontData;
    }
    /**
     * Returns whether the given font is installed on the system (this queries the CC Library Process).
     */
    async isSystemFontAvailable(fontName, matchFamily) {
        return await this._driver.isSystemFontAvailable(fontName, matchFamily);
    }
    _clearCache() {
        this._fontsCache = {};
        this.emit('change');
    }
}
__decorate([
    observable
], FontManager.prototype, "getFontData", null);
__decorate([
    observable
], FontManager.prototype, "isSystemFontAvailable", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * Utility for creating limited map objects with observable getters
 * and that emit change events when they're modified.
 */
class ObservableMap extends RestrictedEventEmitter {
    constructor() {
        super(...arguments);
        this._map = new Map();
    }
    set(key, value) {
        this._map.set(key, value);
        this.emit('change');
    }
    delete(key) {
        this._map.delete(key);
        this.emit('change');
    }
    clear() {
        this._map.clear();
        this.emit('change');
    }
    entries() {
        return this._map.entries();
    }
    get(key) {
        return this._map.get(key);
    }
}
__decorate([
    observable('change')
], ObservableMap.prototype, "entries", null);
__decorate([
    observable('change')
], ObservableMap.prototype, "get", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2025 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
// @deprecated: This file is a stub and kept for build compatibility only.
// DO NOT use or extend this class in new code.
class ModelCache {
    constructor(_parent, _Class, _driver) {
        // console.warn('ModelCache is a stub and should not be used.');÷
    }
    registerIndex(_key) {
        // console.warn('ModelCache.registerIndex() is a stub and should not be used.');
    }
    updateIndices(_model, _newData) {
        // console.warn('ModelCache.updateIndices() is a stub and should not be used.');
    }
    get(_id) {
        // console.warn('ModelCache.get() is a stub and should not be used.');
        return undefined;
    }
    getByIndex(_index, _key) {
        // console.warn('ModelCache.getByIndex() is a stub and should not be used.');
        return undefined;
    }
    add(data, _shouldNotify = true) {
        // console.warn('ModelCache.add() is a stub and should not be used.');
        return {};
    }
    remove(idOrModel, _shouldNotify = true) {
        // console.warn('ModelCache.remove() is a stub and should not be used.');
    }
    replace(data, _shouldNotify = true) {
        // console.warn('ModelCache.replace() is a stub and should not be used.');
    }
    upsert(..._dataArray) {
        // console.warn('ModelCache.upsert() is a stub and should not be used.');
    }
    all() {
        // console.warn('ModelCache.all() is a stub and should not be used.');
        return [];
    }
    get length() {
        // console.warn('ModelCache.length is a stub and should not be used.');
        return 0;
    }
    get driver() {
        // console.warn('ModelCache.driver is a stub and should not be used.');
        return undefined;
    }
    get changes() {
        // console.warn('ModelCache.changes is a stub and should not be used.');
        return [];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    on(event, _listener) {
        // console.warn(`ModelCache.on('${event}', listener) is a stub and should not be used.`);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    off(event, _listener) {
        // console.warn(`ModelCache.off('${event}', listener) is a stub and should not be used.`);
    }
}

class Orchestrator extends EventEmitter {
    constructor(_parent, _driver, _options = {}) {
        super();
        // console.warn('Orchestrator is stubbed and does not perform actual operations.');
    }
    // Placeholder for changeDriver method
    async changeDriver(_newDriver) {
        // console.warn('changeDriver is called on a stubbed Orchestrator.');
    }
    // Placeholder for initialLibrariesLoad method
    initialLibrariesLoad() {
        // console.warn('initialLibrariesLoad is called on a stubbed Orchestrator.');
    }
    // Placeholder for all method
    all() {
        // console.warn('all is called on a stubbed Orchestrator.');
        return [];
    }
    // Placeholder for loadList method
    async loadList(_filters) {
        // console.warn('loadList is called on a stubbed Orchestrator.');
        return [];
    }
    // Placeholder for loadPage method
    async loadPage(_filters, _signal) {
        // console.warn('loadPage is called on a stubbed Orchestrator.');
        return [];
    }
    // Placeholder for isLoaded property
    get isLoaded() {
        // console.warn('Accessing isLoaded on a stubbed Orchestrator.');
        return false;
    }
    // Placeholder for isLoading property
    get isLoading() {
        // console.warn('Accessing isLoading on a stubbed Orchestrator.');
        return false;
    }
    // Placeholder for changes property
    get changes() {
        // console.warn('Accessing changes on a stubbed Orchestrator.');
        return [];
    }
    // Placeholder for syncStatus property
    get syncStatus() {
        // console.warn('Accessing syncStatus on a stubbed Orchestrator.');
        return {};
    }
    // Placeholder for pause method
    pause(_halt = false) {
        // console.warn('pause is called on a stubbed Orchestrator.');
    }
    // Placeholder for resume method
    resume() {
        // console.warn('resume is called on a stubbed Orchestrator.');
    }
    // Placeholder for waitForHydrate method
    async waitForHydrate() {
        // console.warn('waitForHydrate is called on a stubbed Orchestrator.');
    }
    /**
     * Stub for retrieving a library by ID.
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    get(libraryId) {
        // console.warn(`Stub: Orchestrator.get() called for libraryId: ${libraryId}.`);
        return { syncStatus: {} };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getByIndex(indexType, assetId) {
        // console.warn(`Stub: Orchestrator.getByIndex() called for assetId: ${assetId}.`);
        return { syncStatus: {} };
    }
    /**
     * Stub for simulating operations.
     */
    doOperations() {
        // console.warn('Stub: Orchestrator.doOperations() called.');
    }
    /**
     * Stub for emitting events (e.g., syncChange).
     */
    onSyncChange(_listener) {
        // console.warn('Stub: Orchestrator.onSyncChange() called.');
    }
    /**
     * Stub for removing listeners for events (e.g., syncChange).
     */
    offSyncChange(_listener) {
        // console.warn('Stub: Orchestrator.offSyncChange() called.');
    }
    get DANGEROUS() {
        return { removeAllListeners: (_s) => { } };
    }
    add(_lib) {
        // console.warn('Stub: Orchestrator.add() called.');
        return {};
    }
    upsert(_libraryData) {
        // console.warn('Stub: Orchestrator.upsert() called.');
        return {};
    }
    hydrate() {
    }
    remove(_id) {
    }
    _halt() {
    }
}

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
/**
 * The main entry point for the Creative Cloud Libraries Javascript API is available via the default export.
 *
 * This class provides methods for configuring and initialising the API.
 *
 * @packageDocumentation
 * @module CCLibraries
 */
/*
    AdobePatentID="P5086-US"
    AdobePatentID="P5087-US"
*/
// Polyfill for global in the browser environment
if (typeof window !== 'undefined' && typeof global === 'undefined') {
    window.global = window;
}
const defaultOptions = {
    enableBrandLifecycleManagement: false,
    includeApprovedBrandsInLibraries: false,
    elementTypes: ['elements'],
    readOnly: false,
    skipConnectingOnInit: false
};
//TODO-R [SHARED-4137]: change to TypedEventEmitter wherever RestrictedEventEmitter is used
class CCLibraries extends RestrictedEventEmitter {
    constructor(_core, assetPool, driver, options = {}) {
        var _a;
        super();
        this._core = _core;
        this.assetPool = assetPool;
        this._missingResolutionTargetsMap = new ObservableMap();
        this._resolutionProgressMap = new Map();
        this._teamsCache = new ModelCache(this, Team); // R-TODO[SHARED-4223]: Remove
        this.elementUpdater = ElementUpdater; // This is an instance, not a class
        this._handleDriverConnect = (driver) => {
            if (driver instanceof CloudDriver$1) {
                return this._handleCloudDriverConnect(driver);
            }
            if (driver instanceof LocalDriver) {
                return this._handleLocalDriverConnect(driver);
            }
        };
        this._handleDriverDisconnect = (driver) => {
            if (driver instanceof LocalDriver) {
                return this._handleLocalDriverDisconnect();
            }
        };
        this.translate = (messageId, values) => {
            return this._intl.formatMessage(messageId, values);
        };
        // Provide window level access to the JSAPI
        globalThis.CCLIBS = (_a = globalThis.CCLIBS) !== null && _a !== void 0 ? _a : this;
        this._options = Object.assign(Object.assign({}, defaultOptions), options);
        this._driver = driver;
        if (this._options.mobXCreateAtom && this._options.mobXTransaction) {
            mobXRegistry.register(this._options.mobXCreateAtom, this._options.mobXTransaction);
        }
        if (driver instanceof CloudDriver$1) {
            this._cloudDriver = driver;
        }
        else if (this._options.cloudDriver instanceof CloudDriver$1) {
            this._cloudDriver = this._options.cloudDriver;
        }
        if (driver instanceof LocalDriver) {
            this._fontManager = new FontManager(driver);
        }
        this.utils = Object.assign(Object.assign({}, CCLibraries.utils), { copyFile: this.copyFile.bind(this), getInstalledVersion: this.getInstalledVersion.bind(this), getFileSize: this.getFileSize.bind(this), getRenditionGrid: this.getRenditionGrid.bind(this), extractElementId: extractElementId$1,
            extractGroupId });
        this._elementPool = new ItemPool(this._core, 'element');
        this._teamsCache.on('change', () => this.emit('teamChange'));
        // Emit an event when cached element resolution data changes.
        this._missingResolutionTargetsMap.on('change', () => this.emit('resolutionStatusChange'));
        // _handleDriverConnect only applies to the initial driver (not subsequent changes)
        this._driver.on('connect', this._handleDriverConnect);
        this._driver.on('disconnect', this._handleDriverDisconnect);
        this._bindDriverEvents();
        this._intl = new IntlInterface(this._options.locale);
        this._libraryCache = new Orchestrator(this, this._driver, {
            readOnly: this._options.readOnly,
            skipConnectingOnInit: this._options.skipConnectingOnInit,
            fileSystemCache: this._options.fileSystemCache,
            enableBrandLifecycleManagement: this._options.enableBrandLifecycleManagement,
            includeApprovedBrandsInLibraries: this._options.includeApprovedBrandsInLibraries
        });
        this._bindLibraryCacheEvents();
        //Set the core as the event emitter on the Logger instance so we can emit message events via the SAMJS core
        Logger$1.setEventEmitter(this._core);
    }
    /* New APIs */
    get elementPool() {
        return this._elementPool;
    }
    /**
     * Creates the LibraryContents API instance for a given library.
     * LibraryContents controls and exposes the state of the library's contents, including elements and groups.
     * Warning: This creates a new instance on each call. Call library.getContents() instead to access the cached instance stored on the library.
     * @param library
     * @returns LibraryContents
     */
    getLibraryContents(library) {
        return new LibraryContents(this._core, this, library);
    }
    /* Old APIs */
    /**
     * Changes out the current driver for a new one. Any data in memory will be kept
     * and refreshed when the new driver connects. This will wait for any in-flight
     * operations to finish before switching to the new driver.
     * @param newDriver The new driver to use.
     * @returns A promise that resolves once the new driver has connected.
     */
    async changeDriver(newDriver) {
        await this._libraryCache.changeDriver(newDriver);
        this._driver = newDriver;
        if (this._driver instanceof LocalDriver) {
            this._fontManager = new FontManager(this._driver);
        }
        this._driver.on('connect', this._handleDriverConnect);
        this._driver.on('disconnect', this._handleDriverDisconnect);
        this._bindDriverEvents();
        // Return a promise that tracks when the new driver has connected.
        let driverConnectResolver;
        const driverConnectPromise = new Promise(resolve => (driverConnectResolver = resolve));
        this._driver.once('connect', () => driverConnectResolver());
        return driverConnectPromise;
    }
    _handleCloudDriverConnect(driver) {
        if (this.driver instanceof HybridDriver || this._options.disableLocalFallthrough) {
            this.emit('change');
            this.emit('driverConnect');
            return;
        }
        driver
            .getLocalDriver()
            .init({ retryCount: 3, skipConnectingOnInit: this._options.skipConnectingOnInit }, (localDriver) => {
            // Unbind old cache and driver
            this._libraryCache.pause(true);
            this._libraryCache.DANGEROUS.removeAllListeners();
            this._driver.DANGEROUS.removeAllListeners();
            // Bind new cache
            this._libraryCache = new Orchestrator(this, localDriver, {
                readOnly: this._options.readOnly,
                skipConnectingOnInit: this._options.skipConnectingOnInit
            });
            this._bindLibraryCacheEvents();
            // Bind new driver
            this._driver = localDriver;
            this._bindDriverEvents();
            this.emit('change');
        });
    }
    _handleLocalDriverConnect(driver) {
        var _a;
        driver.updateRenditionCacheConfiguration(this.options.renditionSizes, this.options.fullRenditionConfig);
        const cloudDriver = (_a = this.cloudDriver) !== null && _a !== void 0 ? _a : driver.getCloudDriver();
        cloudDriver === null || cloudDriver === void 0 ? void 0 : cloudDriver.init({ readOnly: true }, (cloudDriver) => {
            this._cloudDriver = cloudDriver;
        });
        this.emit('driverConnect');
    }
    _handleLocalDriverDisconnect() {
        this.emit('driverDisconnect');
    }
    _bindDriverEvents() {
        this._driver.on('configChange', () => this.emit('configChange'));
        this._driver.on('connecting', () => this.emit('connecting'));
        this._driver.on('failedConnection', () => this.emit('failedConnection'));
    }
    _bindLibraryCacheEvents() {
        this._libraryCache.on('connect', () => this.emit('connect'));
        this._libraryCache.on('loaded', () => this.emit('loaded'));
        this._libraryCache.on('hydrate', () => this.emit('restore'));
        this._libraryCache.on('sync', () => this.emit('sync'));
        this._libraryCache.on('report', (...args) => this.emit('report', ...args));
        this._libraryCache.on('change', this._libraryCacheChangeHandler.bind(this));
        this._libraryCache.on('modelChange', this._libraryCacheChangeHandler.bind(this));
        this._libraryCache.on('fontDataChange', () => { var _a; return (_a = this.fontManager) === null || _a === void 0 ? void 0 : _a._clearCache(); });
    }
    _libraryCacheChangeHandler() {
        this.emit('change', { libraries: this._libraryCache.changes });
    }
    /**
     * For MobX clients.
     * Hook up the JS API to your MobX instance so that it's observable.
     * This is equivalent to passing mobXCreateAtom and mobXTransaction to the constructor.
     * This simply allows clients other than the API constructor to hook up their own MobX instances.
     * Make sure to call the returned disposer function during teardown to avoid memory leaks.
     * @param createAtom mobx#createAtom
     * @param transaction mobx#transaction
     * @returns {Function} disposer function - Make sure to call it during teardown to avoid memory leaks.
     */
    makeObservable(createAtom, transaction) {
        return mobXRegistry.register(createAtom, transaction);
    }
    /**
     * @internal
     */
    get apiRoot() {
        return this;
    }
    get apiVersion() {
        return 2;
    }
    /**
     * May include loading options, and so is expected to be set in the constructor.
     *  @internal
     */
    get options() {
        return this._options;
    }
    /**
     * @internal
     */
    updateOptions(options) {
        this._options = options;
    }
    /**
     * @internal
     */
    get driver() {
        return this._driver;
    }
    /**
     * @internal
     */
    get cloudDriver() {
        return this._cloudDriver;
    }
    get libraries() {
        this._libraryCache.initialLibrariesLoad();
        return this._libraryCache.all().filter(lib => {
            const isDeleted = lib.isDeletedLocally;
            // The client may have used CCLibraries.getLibraries() to load libraries that
            // wouldn't normally appear in the user's default collection.
            // Make sure we don't include any of those here.
            return !isDeleted && isLibraryLoadedByDefault(lib.data, this._options.enableBrandLifecycleManagement);
        });
    }
    async getLibraries(filters) {
        return this._libraryCache.loadList(filters);
    }
    async getLibrariesPage(filters, signal) {
        return this._libraryCache.loadPage(filters, signal);
    }
    get connected() {
        return Boolean(this.driver.isConnected);
    }
    get areLibrariesLoaded() {
        var _a;
        return Boolean((_a = this._libraryCache) === null || _a === void 0 ? void 0 : _a.isLoaded);
    }
    get areLibrariesLoading() {
        var _a;
        return (_a = this._libraryCache) === null || _a === void 0 ? void 0 : _a.isLoading;
    }
    get userQuota() {
        var _a;
        return (_a = this.driver.config.user) === null || _a === void 0 ? void 0 : _a.quota;
    }
    get processInfo() {
        return Object.assign(Object.assign({}, this.driver.config.processInfo), { environment: this.driver.config.environment });
    }
    get storageUsed() {
        return this.libraries.reduce((memo, library) => {
            if (library.ownership === 'private') {
                return memo + library.storageUsed;
            }
            return memo;
        }, 0);
    }
    async _refreshTeams() {
        var _a;
        try {
            const projectsEnabled = (_a = this._options.featureFlags) === null || _a === void 0 ? void 0 : _a.enableProjects;
            const getTeams = (projectsEnabled ? this._driver.getProjects : this._driver.getTeams).bind(this._driver);
            const teams = await getTeams();
            this._teamsCache.replace(teams);
        }
        catch (err) {
            if (err.name !== ABORT_ERROR) {
                throw err;
            }
        }
        return this._teamsCache.all();
    }
    /**
     * @deprecated
     * Will be removed with https://jira.corp.adobe.com/browse/CCXC-20136
     */
    async refreshTeams() {
        if (this.driver.config.environment === 'staging') {
            Logger$1.warn('CCLibraries.refreshTeams is deprecated. Use CCLibraries.refreshProjects instead.');
        }
        return this._refreshTeams();
    }
    async refreshProjects() {
        return this._refreshTeams();
    }
    /**
     * @deprecated
     * Will be removed with https://jira.corp.adobe.com/browse/CCXC-20136
     */
    get teams() {
        if (this.driver.config.environment === 'staging') {
            Logger$1.warn('CCLibraries.teams is deprecated. Use CCLibraries.projects instead.');
        }
        return this._teamsCache.all();
    }
    get projects() {
        // For now, Project data is wrapped using Team models.
        // Later on, we will rename it everything that says "team" to "project".
        // https://jira.corp.adobe.com/browse/CCXC-20136
        return this._teamsCache.all();
    }
    get userId() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this._driver) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.id;
    }
    /**
     * Create a library. Optionally, a team library.
     * @param name  Name of the library
     * @param team  The team where the library should be created
     */
    createLibrary(name, opts = {}) {
        var _a;
        // First, we want to create the object locally. So create the minimum necessary data object that we need to
        // render the library. This create the Library object and also the **action queue** for the Library.
        const library = this._libraryCache.add(createLibraryData({
            id: createPlaceholderId(),
            name,
            documentExtractionData: opts.documentExtractionData,
            roles: opts.roles,
            team: (_a = opts.team) === null || _a === void 0 ? void 0 : _a.data,
            bookmark: opts.team
                ? {
                    // When the user creates a team library, it is automatically bookmarked.
                    id: createPlaceholderId()
                }
                : undefined
        }));
        // Second, we want to tell the backend to actually create the library, so we enqueue an action to make
        // the request.
        library.actionDispatch({
            name: 'createLibrary',
            type: 'no-op',
            data: library.data,
            flags: {
                lockNewLibraries: true,
                permissionInheritance: opts.permissionInheritance
            }
        });
        return library;
    }
    /**
     * Fires an action to delete a library. While the asynchronous action is
     * taking place, JSAPI sets the library as locally deleted.
     *
     * @example
     * Get a reference to the library object you want to delete
     * and fire the remove library action.
     *
     * ```ts
     * const libToDelete = CCLIBS.getLibraryById('abc123');
     * CCLIBS.removeLibrary(libToDelete);
     * ```
     *
     * @param library   Library to remove.
     */
    removeLibrary(library) {
        library.actionDispatch({
            name: 'removeLibrary',
            type: 'no-op',
            path: '$'
        });
        // isDeletedLocally causes the libraries getter to filter these libraries from view.
        // However, actually removing the library from the cache is handled by the change listeners.
        library.isDeletedLocally = true;
    }
    /**
     * NOTE: This action is not supported when using the LocalDriver
     *
     * Fires an action to permanently delete a library. While the asynchronous action is
     * taking place, JSAPI sets the library as locally deleted.
     *
     * @example
     * Get a reference to the library object you want to delete
     * and fire the remove library action.
     *
     * ```ts
     * const libToDelete = CCLIBS.getLibraryById('abc123');
     * CCLIBS.removeLibrary(libToDelete);
     * ```
     *
     * @param library   Library to remove.
     */
    permanentlyDeleteLibrary(library) {
        library.actionDispatch({
            name: 'permanentlyDeleteLibrary',
            type: 'no-op',
            path: '$'
        });
        library.isDeletedLocally = true;
    }
    /**
     * Leave a library.
     * @param library   Library to leave.
     */
    leaveLibrary(library) {
        library.actionDispatch({
            name: 'leaveLibrary',
            type: 'no-op',
            path: '$'
        });
        library.isDeletedLocally = true;
    }
    /**
     * Follow a library.
     * @param assetId   assetId of the library to follow.
     * @param libraryId id of the library to follow.
     */
    followLibrary(assetId, libraryId) {
        return this._driver.followLibrary(assetId, libraryId);
    }
    /**
     * Unfollow a library.
     * @param library   Library to unfollow.
     */
    unfollowLibrary(library) {
        library.actionDispatch({
            name: 'unfollowLibrary',
            type: 'no-op',
            path: '$'
        });
        library.isDeletedLocally = true;
    }
    importLibrary(path, callback = () => undefined) {
        const asyncResponse = this._driver.importLibrary(path, (error, libraryData) => {
            if (error) {
                return callback(error);
            }
            this._libraryCache.upsert(libraryData);
            const library = this._libraryCache.get(libraryData === null || libraryData === void 0 ? void 0 : libraryData.id);
            callback(undefined, library);
        });
        return asyncResponse;
    }
    exportLibrary(library, path, callback = () => undefined) {
        return this._driver.exportLibrary(library, path, callback);
    }
    getLibraryById(libraryId) {
        return this._libraryCache.get(libraryId);
    }
    getLibraryByAssetId(assetId) {
        return this._libraryCache.getByIndex('assetId', assetId);
    }
    copyLibrary(library, opts = {}) {
        var _a, _b, _c;
        const libraryCopy = this._libraryCache.add(createLibraryData({
            id: createPlaceholderId(),
            name: (_a = opts.newName) !== null && _a !== void 0 ? _a : library.name,
            roles: library.roles,
            team: (_b = opts.team) === null || _b === void 0 ? void 0 : _b.data,
            bookmark: opts.team
                ? {
                    // When the user copies a library into a team, it is automatically bookmarked.
                    id: createPlaceholderId()
                }
                : undefined
        }));
        libraryCopy.actionDispatch({
            name: 'copyLibrary',
            type: 'no-op',
            data: {
                name: opts.newName,
                team: (_c = opts.team) === null || _c === void 0 ? void 0 : _c.data,
                documentExtractionData: opts.documentExtractionData
            },
            flags: {
                lockNewLibraries: true,
                permissionInheritance: opts.permissionInheritance,
                source: library,
                includeAppMetadata: opts.includeAppMetadata
            }
        });
        return libraryCopy;
    }
    /**
     * Promote private library to team library
     * @param library   Library to promote.
     */
    moveLibrary(library, team) {
        library.actionDispatch({
            name: 'moveLibrary',
            type: 'update',
            data: {
                team: {
                    id: team.id,
                    name: team.name
                },
                bookmark: {
                    // When a personal library is moved to a team, it is automatically bookmarked.
                    id: createPlaceholderId()
                },
                ownership: 'incoming',
                ownerType: 'org',
                owner: team.owner.id
            }
        });
    }
    getHybridSearchResults(searchQuery, filters, elementSort) {
        const generator = function (abort) {
            return __asyncGenerator(this, arguments, function* () {
                var _a, e_1, _b, _c;
                // Firstly, lets return Elements that have already been loaded in this instance.
                const rex = new RegExp(searchQuery, 'ig');
                const currentLoadedMatchingElements = this.libraries
                    .filter(l => (filters === null || filters === void 0 ? void 0 : filters.library_id) === l.id || !(filters === null || filters === void 0 ? void 0 : filters.library_id))
                    .reduce((acc, lib) => {
                    const matches = lib.elements.filter((e) => rex.test(e.name));
                    acc.push(...matches);
                    return acc;
                }, []);
                yield yield __await(currentLoadedMatchingElements);
                // Keep tabs of the already found elements so we do not repeat results
                const previouslyMatchedElementIds = currentLoadedMatchingElements.map((e) => e.id);
                // Melville search needs the asset id of the library. not its legacy id
                if (filters === null || filters === void 0 ? void 0 : filters.library_id) {
                    const searchWithinLibrary = this.getLibraryById(filters.library_id);
                    filters = Object.assign(Object.assign({}, filters), { library_id: searchWithinLibrary === null || searchWithinLibrary === void 0 ? void 0 : searchWithinLibrary.assetId });
                }
                try {
                    // Use USS to return the rest of the elements for us
                    for (var _d = true, _e = __asyncValues(this.driver.getSearchResults(searchQuery, filters, elementSort, abort)), _f; _f = yield __await(_e.next()), _a = _f.done, !_a;) {
                        _c = _f.value;
                        _d = false;
                        try {
                            const searchResults = _c;
                            yield yield __await(searchResults
                                .map((e) => {
                                if (previouslyMatchedElementIds.includes(e.id)) {
                                    return;
                                }
                                const library = this.getLibraryByAssetId(e.libraryAssetId);
                                // Due to a limitation with USS right now we cannot assume that a result will
                                // be part of a users set of libraries. For now we can ignore this
                                if (!library) {
                                    return;
                                }
                                const el = new Element(this._core, getCombinedId(e));
                                el._update(e);
                                return el;
                            })
                                .filter(Boolean));
                        }
                        finally {
                            _d = true;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (!_d && !_a && (_b = _e.return)) yield __await(_b.call(_e));
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            });
        }.bind(this);
        this._searchLoader = new ProgressiveLoader(generator);
        return this._searchLoader;
    }
    getSearchResults(searchQuery, filters, elementSort) {
        this.abortSearch();
        filters = filters || {};
        const filteredLibraryId = filters && filters.library_id;
        if (this._driver instanceof HybridDriver) {
            return this.getHybridSearchResults(searchQuery, filters, elementSort);
        }
        const generator = function (signal) {
            return __asyncGenerator(this, arguments, function* () {
                var _a, e_2, _b, _c;
                const elementsToLoadPerLibrary = new Map();
                // Need to store libraryIds for libraries we have cleared so we dont clear any search results we have loaded from previous pages
                const cleared = [];
                try {
                    for (var _d = true, _e = __asyncValues(this._driver.getSearchResults(searchQuery, filters, elementSort, signal)), _f; _f = yield __await(_e.next()), _a = _f.done, !_a;) {
                        _c = _f.value;
                        _d = false;
                        try {
                            const page = _c;
                            yield __await(page.forEach((elementData) => {
                                const libraryId = elementData.libraryId || filteredLibraryId;
                                let library = this.getLibraryById(libraryId);
                                // If the library and its elements are already loaded, we don't need to do anything
                                if (library && library.areElementsLoaded) {
                                    return elementData;
                                }
                                if (!library) {
                                    library = this._libraryCache.add(createLibraryData({
                                        id: libraryId,
                                        name: libraryId,
                                        areElementsLoaded: false,
                                        isLibraryLoaded: false
                                    }));
                                    // We don't need to clear the library elements since we are creating this library, so we know it's empty
                                    cleared.push(libraryId);
                                }
                                // We only want to clear the library elements once so we dont clear any search results we have loaded from previous pages
                                // We also want to abort the loadElements here so that we dont continue to load elements
                                if (!cleared.includes(libraryId)) {
                                    library.abortLoadElements();
                                    library.clearElements(false);
                                    cleared.push(libraryId);
                                }
                                // Add this as an element to load for the library
                                const elementsToLoad = elementsToLoadPerLibrary.get(library) || [];
                                elementsToLoad.push(elementData);
                                elementsToLoadPerLibrary.set(library, elementsToLoad);
                                return elementData;
                            }));
                            for (const [library, elements] of elementsToLoadPerLibrary) {
                                yield __await(library.loadGivenElements(elements, false, false));
                            }
                            elementsToLoadPerLibrary.clear();
                            yield yield __await(page.map((elementData) => {
                                const libraryId = elementData.libraryId || filteredLibraryId;
                                if (!libraryId) {
                                    return;
                                }
                                const library = this.getLibraryById(libraryId);
                                return library === null || library === void 0 ? void 0 : library.getElementById(elementData.id);
                            }));
                        }
                        finally {
                            _d = true;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (!_d && !_a && (_b = _e.return)) yield __await(_b.call(_e));
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
        }.bind(this);
        this._searchLoader = new ProgressiveLoader(generator);
        return this._searchLoader;
    }
    abortSearch() {
        if (this._searchLoader) {
            this._searchLoader.abort();
        }
    }
    copyFile(source, destination, allowOverride) {
        return this.driver.copyFile(source, destination, allowOverride);
    }
    getInstalledVersion(appCode) {
        return this.driver.getInstalledVersion(appCode);
    }
    getFileSize(path) {
        return this.driver.getFileSize(path);
    }
    getRenditionGrid(library) {
        return this.driver.getRenditionGrid(library);
    }
    /* Configuration and Settings */
    /**
     * Get a value from the current configuration
     *
     * @param {String} option The name of the option.
     * @returns {*} The value of the option.
     * @memberof CCLibraries
     */
    getOption(key) {
        var _a, _b, _c;
        const lowerCamelKey = toLowerCamel(key);
        // Prefer options provided from the REST API, fall back onto library constants
        return ((_c = (_b = (_a = this._driver) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.processInfo) === null || _c === void 0 ? void 0 : _c[lowerCamelKey]) || LibraryConstants[key];
    }
    /**
     * Store a local setting. In shared local storage mode, this persists to the local machine via the CCLibrary process, and is shared across apps.
     *
     * @param {String} key The key for the setting.
     * @param {*} value The value of the setting (must be serializable to JSON)
     * @throws {LibraryError.INVALID_PARAMETER}
     * @memberof CCLibraries
     */
    async setLocalSetting(key, value) {
        try {
            JSON.stringify(value);
        }
        catch (e) {
            throw new LibraryError('INVALID_PARAMETER', 'Value must be serializable to JSON');
        }
        await this._driver.setLocalSetting(key, value);
    }
    /**
     * Retrieve a local setting. (In Shared Local Storage mode, this is a setting on disk shared with other apps.)
     *
     * @param {String} key The key for the setting.
     * @returns {*} The value of the setting.
     * @memberof CCLibraries
     */
    getLocalSetting(key) {
        return this._driver.getLocalSetting(key);
    }
    /**
     * Get the current locale of the API (there are a few strings internal to the API that depend on this locale) - this can be configured
     * via {@link CCLibraries.setLocale}.
     *
     * @returns {SupportedLocale} The current locale (e.g. `'en-US'`)
     * @memberof CCLibraries
     */
    getLocale() {
        return this._intl.locale;
    }
    /**
     * Set the current locale of the API (there are a few strings internal to the API that depend on this locale).
     *
     * @returns {Promise<SupportedLocale>} a promise resolving to the locale that was set (could be different than locale requested if not supported).
     * @memberof CCLibraries
     */
    setLocale(locale) {
        return this._intl.setLocale(locale);
    }
    /* (Shared Local Storage) CC Libraries Process */
    /**
     * Test whether the API is connected to the shared local storage service.
     *
     * This is only supported if the `SHARED_LOCAL_STORAGE` option is enabled.
     *
     * @returns {Boolean} Whether or not the API is connected to the shared local storage service.
     * @throws {LibraryError.NOT_SUPPORTED}
     * @memberof CCLibraries
     */
    isConnected() {
        return Boolean(this.driver.isConnected);
    }
    get connectionState() {
        return this.driver.connectionState;
    }
    /**
     * Try to reconnect to the shared local storage service, if the connection was broken.
     *
     * This is only supported if the `SHARED_LOCAL_STORAGE` option is enabled.
     *
     * @throws {LibraryError.NOT_SUPPORTED}
     * @memberof CCLibraries
     */
    reconnect() {
        var _a;
        if (this.isConnected()) {
            return;
        }
        (_a = this._driver) === null || _a === void 0 ? void 0 : _a.connect();
    }
    /**
     * Disconnect from shared local storage service.
     *
     * This is only supported if the `SHARED_LOCAL_STORAGE` option is enabled.
     *
     * @throws {LibraryError.NOT_SUPPORTED}
     * @memberof CCLibraries
     */
    disconnect() {
        var _a;
        (_a = this._driver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    /**
     * Returns `true` if library syncing is enabled. If syncing is disabled, libraries will not be automatically pushed
     * when modified and we will not get remote updates.
     */
    isSyncingEnabled() {
        var _a;
        return (_a = this._driver.config.processInfo) === null || _a === void 0 ? void 0 : _a.syncingEnabled;
    }
    /**
     * Turn on library syncing, if it's not already enabled. This causes all loaded libraries to be pulled.
     * Any queued actions will be pushed.
     */
    enableSyncing() {
        this._libraryCache.resume();
        return this._setSyncEnabledConfig(true);
    }
    /**
     * Turn off library syncing. In-flight requests will be allowed to finish, unless explicitly specified.
     *
     * @param halt  Should in-flight requests be aborted?
     */
    async disableSyncing(halt = false) {
        await this._setSyncEnabledConfig(false);
        this._libraryCache.pause(halt);
    }
    async _setSyncEnabledConfig(enabled) {
        return this.setLocalSetting('processInfo', Object.assign(Object.assign({}, this._driver.config.processInfo), { syncingEnabled: enabled }));
    }
    async _resolveLibrary(idOrAssetId) {
        const resolutionKey = `library#${idOrAssetId}`;
        // If we're already resolving this library, return the existing promise.
        if (!this._resolutionProgressMap.has(resolutionKey)) {
            const resolveLibrary = this.driver
                .getLibraryById(idOrAssetId)
                .then(libraryData => {
                // Add the library to the cache so we can find it synchronously next time.
                this._libraryCache.upsert(libraryData);
                return this._libraryCache.get(libraryData.id);
            })
                .catch(error => {
                if (error.requestErrorCode !== 'NOT_FOUND') {
                    // If we got an error other than 404, make sure we log it and let it float for handling.
                    Logger$1.log(String(error));
                    throw error;
                }
            })
                .finally(() => {
                // Remove the promise from the map so we can try again next time.
                this._resolutionProgressMap.delete(resolutionKey);
            });
            this._resolutionProgressMap.set(resolutionKey, resolveLibrary);
        }
        return this._resolutionProgressMap.get(resolutionKey);
    }
    async _resolveElementById(library, elementId, includeRemovedElements = false) {
        if (!library) {
            return;
        }
        // First try to get locally.
        const element = library.getElementById(elementId, !includeRemovedElements);
        if (element) {
            return element;
        }
        // Otherwise, fetch the element from the services.
        try {
            const elementData = await this.driver.getElement(library, elementId);
            // Add it to the library for next time.
            library.loadGivenElements([elementData], false, true);
            return library.getElementById(elementId, !includeRemovedElements);
        }
        catch (error) {
            if (error.requestErrorCode !== 'NOT_FOUND') {
                // If we got an error other than 404, make sure we log it and let it float for handling.
                Logger$1.log(String(error));
                throw error;
            }
            return;
        }
    }
    /**
     * Resolve the given library id against cloud storage.
     * This is different from {@link CCLibraries.getLibraryById} in that
     * a resolved value of `undefined` means that the library does not exist in cloud storage, not merely in the local cache.
     * @param {string} id
     * @returns {Promise<Library | undefined>}
     */
    async resolveLibraryById(id) {
        // If the library is loaded and cached, return it.
        await this._libraryCache.waitForHydrate();
        const cachedLibrary = this.getLibraryById(id);
        if (cachedLibrary) {
            return cachedLibrary;
        }
        // Otherwise, fetch the library from the services.
        return this._resolveLibrary(id);
    }
    /**
     * Resolve the given asset id against cloud storage.
     * This is different from {@link CCLibraries.getLibraryByAssetId} in that
     * a resolved value of `undefined` means that the library does not exist in cloud storage, not merely in the local cache.
     * @param {string} assetId
     * @returns {Promise<Library | undefined>}
     */
    async resolveLibraryByAssetId(assetId) {
        // If the library is loaded and cached, return it.
        await this._libraryCache.waitForHydrate();
        const cachedLibrary = this.getLibraryByAssetId(assetId);
        if (cachedLibrary) {
            return cachedLibrary;
        }
        // Otherwise, fetch the library from the services.
        return this._resolveLibrary(assetId);
    }
    /**
     * Resolve the given asset id by fetching it from cloud storage.
     * This bypasses the cache to force and element to be re-fetched.
     * @param {string} assetId
     * @returns {Promise<Library | undefined>}
     */
    async resolveLibraryWithoutCache(assetId) {
        return this._resolveLibrary(assetId);
    }
    /**
     * Resolve the given library reference to a library object using the libraries in memory.
     * If the reference cannot be resolved against the cache, a background request will be made to
     * {@link CCLibraries#resolveLibraryReference} to attempt resolving the reference against Library services;
     * if resolved in the background, the library will be entered into the cache and a 'change' event will be emitted,
     * making this method observable with respect to the libraries list/libraries cache.
     * While the remote resolution request is in progress, this method will return `undefined`;
     * if the remote resolution comes back empty, the return value will be `null`. Additionally,
     * once the state of the reference is known, a 'resolutionStatusChange' event will be emitted,
     * making this method observable with respect to that as well.
     * Usually it's better to call {@link CCLibraries#resolveLibraryReference} directly.
     * @param libraryRef library reference to be resolved
     * @returns {Library} The library object that is represented with the given library reference (or `undefined` if library cannot be found).
     * @memberof CCLibraries
     */
    resolveCachedLibraryReference(linkRef) {
        if (!linkRef) {
            return;
        }
        const { libraryId } = getAssetAndFragmentIdFromReference(linkRef);
        if (!libraryId) {
            return;
        }
        const cachedLibrary = this.getLibraryById(libraryId);
        if (cachedLibrary) {
            return cachedLibrary;
        }
        // No cached match was found, return the status of the reference and trigger an async resolution in the background, if unknown.
        return this._getLinkReferenceStatus(linkRef);
    }
    /**
     * Resolve the given library reference to a library, if it exists. This is useful if {@link CCLibraries#resolveElementReference} returns
     * undefined (i.e. the element doesn't exist), since it lets you check whether the library exists.
     * A reference for an element can be retrieved using {@link Element.getReference}.
     * Compatible with legacy element references, and the parsed and stringified new link schemas.
     *
     * @param libraryRef element reference to be resolved
     */
    async resolveLibraryReference(libraryRef) {
        if (!libraryRef) {
            return;
        }
        const { libraryAssetId, libraryId } = getAssetAndFragmentIdFromReference(libraryRef);
        if (!libraryAssetId && !libraryId) {
            return;
        }
        if (this.isLocallyManaged) {
            // The LocalDriver resolver handles only libraryIds.
            return this.resolveLibraryById(libraryId);
        }
        // The CloudDriver resolver handles assetIds, it can also handle libraryIds but only for libraries in personal storage.
        // A link reference should always have an assetId. The exception are legacy links, but we only support those on desktop.
        return this.resolveLibraryByAssetId(libraryAssetId);
    }
    /**
     * Resolve the given element reference to an element object if exists.
     * A reference for an element can be retrieved using {@link Element#getReference}.
     *
     * @param reference of an element that is requested to be resolved.
     * @param includeRemovedElements whether to allow resolving to an available removed element.
     * @returns {Element} The element object that is represented with the given element reference (or `undefined` if element cannot be found).
     * @memberof CCLibraries
     */
    async resolveElementReference(elementRef, includeRemovedElements = false) {
        if (!elementRef) {
            return;
        }
        const { elementId } = getAssetAndFragmentIdFromReference(elementRef);
        if (!elementId) {
            return;
        }
        const library = await this.resolveElementReferenceToLibrary(elementRef);
        if (!library) {
            return;
        }
        return this._resolveElementById(library, elementId, includeRemovedElements);
    }
    /**
     * Resolve the given element reference to an element object using the libraries and elements in memory.
     * If the reference cannot be resolved against the cache, a background request will be made to
     * {@link CCLibraries#resolveElementReference} to attempt resolving the reference against Library services;
     * if resolved in the background, the element will be entered into the cache and a 'change' event will be emitted,
     * making this method observable with respect to the libraries model.
     * While the remote resolution request is in progress, this method will return `undefined`;
     * if the remote resolution comes back empty, the return value will be `null`. Additionally,
     * once the state of the reference is known, a 'resolutionStatusChange' event will be emitted,
     * making this method observable with respect to that as well.
     * Usually it's better to call {@link CCLibraries#resolveElementReference} directly.
     * @param elementRef element reference to be resolved
     * @param reference of an element that is requested to be resolved.
     * @param includeRemovedElements whether to allow resolving to an available removed element.
     * @returns {Element} The element object that is represented with the given element reference (or `undefined` if element cannot be found).
     * @memberof CCLibraries
     */
    resolveCachedElementReference(elementRef, includeRemovedElements = false) {
        if (!elementRef) {
            return;
        }
        const { libraryId, elementId } = getAssetAndFragmentIdFromReference(elementRef);
        if (!libraryId || !elementId) {
            return;
        }
        const cachedLibrary = this.getLibraryById(libraryId);
        const cachedElement = cachedLibrary === null || cachedLibrary === void 0 ? void 0 : cachedLibrary.getElementById(elementId, !includeRemovedElements);
        if (cachedElement) {
            return cachedElement;
        }
        // No cached match was found, return the status of the reference and trigger an async resolution in the background, if unknown.
        return this._getLinkReferenceStatus(elementRef, true, includeRemovedElements);
    }
    /**
     * Resolve the given element reference to a library, if it exists. This is useful if {@link CCLibraries#resolveElementReference} returns
     * undefined (i.e. the element doesn't exist), since it lets you check whether the library exists.
     * A reference for an element can be retrieved using {@link Element.getReference}.
     * Compatible with legacy element references, and the parsed and stringified new link schemas.
     *
     * @param elementRef element reference to be resolved
     */
    async resolveElementReferenceToLibrary(elementRef) {
        if (!elementRef) {
            return;
        }
        const { libraryAssetId, libraryId } = getAssetAndFragmentIdFromReference(elementRef);
        if (!libraryAssetId && !libraryId) {
            return;
        }
        if (this.isLocallyManaged) {
            // The LocalDriver resolver handles only libraryIds.
            return this.resolveLibraryById(libraryId);
        }
        // The CloudDriver resolver handles assetIds, it can also handle libraryIds but only for libraries in personal storage.
        // A link reference should always have an assetId. The exception are legacy links, but we only support those on desktop.
        return this.resolveLibraryByAssetId(libraryAssetId);
    }
    /**
     * Resolve the given element reference to the library, using libraries in memory.
     * If the reference cannot be resolved against the cache, a background request will be made to
     * {@link CCLibraries#resolveElementReferenceToLibrary} to attempt resolving the reference against Library services;
     * if resolved in the background, the library will be entered into the cache and a 'change' event will be emitted,
     * making this method observable with respect to the libraries model.
     * While the remote resolution request is in progress, this method will return `undefined`;
     * if the remote resolution comes back empty, the return value will be `null`. Additionally,
     * once the state of the reference is known, a 'resolutionStatusChange' event will be emitted,
     * making this method observable with respect to that as well.
     * Usually it's better to call {@link CCLibraries#resolveElementReferenceToLibrary} directly.
     * @param elementRef element reference to be resolved
     */
    resolveCachedElementReferenceToLibrary(elementRef) {
        return this.resolveCachedLibraryReference(elementRef);
    }
    /**
     * Returns whether an element reference is known to be missing for the given resolution target.
     * If the reference is known to be missing, `null` will be returned.
     * Otherwise, `undefined` will be returned and an async resolution request will be performed against Libraries services
     * to clarify the status of the element reference.
     */
    _getLinkReferenceStatus(linkRef, resolveToElement = false, includeRemovedElements = false) {
        // We need to distinguish between the three resolution target cases (libraries, elements, elements including removed)
        // so that we don't mark a resolution target as "missing" just because the same reference can't be resolved to a different resolution target.
        const resolutionTargetKey = resolveToElement ? 'element' : 'library';
        const includeRemovedKey = includeRemovedElements && 'removed';
        const resolutionKey = `${serializeLinkReference(linkRef)}#${resolutionTargetKey}#${includeRemovedKey}`;
        const isMissing = this._missingResolutionTargetsMap.get(resolutionKey);
        // If we've already attempted to resolve this reference asynchronously and failed, we know that the target really is missing,
        // so no point in searching again. Because the cached resolution methods are observable with respect to changes to the libraries model,
        // if the target does come in later, watchers will get notified to retry the cache and they'll get a hit.
        if (isMissing) {
            return null;
        }
        // Status unknown, return `undefined` and trigger an async resolution in the background.
        this._resolveElementReferenceAndNotify(linkRef, resolutionKey, resolveToElement, includeRemovedElements);
        return undefined;
    }
    /**
     * Performs a previously failed cached element reference resolution asynchronously in the background.
     * After the async resolution is performed, if a match was found, a 'change' event will be emitted to
     * notify watchers that they should recompute any values dependent on the result of this resolution.
     * See {@link CCLibraries#resolveCachedElementReference} and {@link CCLibraries#resolveCachedElementReferenceToLibrary}
     */
    _resolveElementReferenceAndNotify(elementRef, resolutionKey, resolveToElement = false, includeRemovedElements = false) {
        // Don't make the same request more than once at the same time.
        if (!this._resolutionProgressMap.has(resolutionKey)) {
            const resolveMethod = resolveToElement
                ? this.resolveElementReference.bind(this)
                : this.resolveElementReferenceToLibrary.bind(this);
            // A successful resolution will result in a 'change' event that watchers can use to know they should re-attempt the cached resolution.
            const resolveReference = resolveMethod(elementRef, includeRemovedElements)
                .then((item) => {
                // Mark whether we were able to resolve the reference asynchronously, so that we don't try again.
                this._missingResolutionTargetsMap.set(resolutionKey, !item);
            })
                .finally(() => {
                // Remove the operation from the in-progress map.
                this._resolutionProgressMap.delete(resolutionKey);
            });
            // Add this resolution to an in-progress map, to avoid the same request being performed at the same time.
            this._resolutionProgressMap.set(resolutionKey, resolveReference);
        }
        return this._resolutionProgressMap.get(resolutionKey);
    }
    /**
     * Opens a specific view in Creative Cloud Desktop
     * @param path
     */
    openInCCD(path) {
        return this._driver.openInCCD(path);
    }
    /**
     * Does the libraries API have a connection to the local system process?
     */
    get canAccessLocalProcess() {
        return this._driver instanceof LocalDriver;
    }
    getAccessToken(userId, clientId, clientSecret, scopes) {
        return this._driver.fetchAccessToken(userId, clientId, clientSecret, scopes);
    }
    getLibraryByToolkitId(toolkitId) {
        let [toolkitLibrary] = this.libraries
            .filter(library => library.toolkitId === toolkitId)
            .sort((t1, t2) => t1.created - t2.created);
        if (!toolkitLibrary) {
            const toolkitName = this.translate(toolkitNames[toolkitId]);
            toolkitLibrary = this.createLibrary(toolkitName);
            toolkitLibrary.toolkitId = toolkitId;
        }
        return toolkitLibrary;
    }
    /**
     * Get the default library - this is the oldest library that belongs to you, or a custom default library
     * set via {@link CCLibraries#setDefaultLibrary}. If a custom default library is set and we need to load it asynchronously,
     * then while the resolution request is in progress, this method will return `undefined`, and if
     * the remote resolution comes back empty, the return value will fall back to the oldest library.
     * A custom default library can be any library, as long as the user has write access to it,
     * but only personal libraries can be the fallback default library, so it's possible to have a non-zero number of libraries, but no default library.
     *
     * @returns {Library|undefined|null} The default library, `undefined` if trying to resolve the custom default, or `null` if there is no default library
     */
    getDefaultLibrary() {
        // This call makes `getDefaultLibrary` observable with respect to `configChange` events.
        const customDefaultLibrary = this.getLocalSetting('defaultLibrary');
        if (customDefaultLibrary) {
            const { id, assetId } = customDefaultLibrary;
            // The custom default library may not have been loaded yet.
            // We use `resolveCachedElementReferenceToLibrary` to try and find the library in the cache,
            // triggering a fetch on the library if not found. By using `resolveCachedElementReferenceToLibrary` we
            // make `getDefaultLibrary` observable with respect to a potential resolution attempt,
            // allowing this function to remain synchronous while enabling observers to react to an asynchronous resolution.
            const result = this.resolveCachedElementReferenceToLibrary({
                'repo:assetId': assetId,
                'stRef:documentID': id,
                'stRef:fromPart': ''
            });
            if (result === undefined || (result === null || result === void 0 ? void 0 : result.isWritable)) {
                // If we're still trying to resolve the library, inform the caller by returning undefined.
                return result;
            }
        }
        // If we've reached this point, the user has no library selected as the default library or the selected
        // default library is deleted.
        // If the "disableFallbackDefaultLibrary" option is true, then we are configured to return nothing
        if (this._options.disableFallbackDefaultLibrary) {
            return null;
        }
        // If the user has no default library selected and the application is configured to always return a library,
        // then find and return the oldest private library as the default library
        return this.libraries.reduce((defaultLibrary, library) => {
            const isOlder = !defaultLibrary || (defaultLibrary.created || 0) > (library.created || 0);
            return library.ownership === 'private' && isOlder ? library : defaultLibrary;
        }, null);
    }
    /**
     * Set a custom default library - this overrides the default value returned by {@link CCLibraries#getDefaultLibrary}
     * Only libraries that the user has edit access to can be marked as the default library.
     * Passing a falsy value will result in the default library being reset.
     */
    setDefaultLibrary(library) {
        if (library && !library.isWritable) {
            throw new LibraryError('INVALID_PARAMETER', 'Read-only libraries cannot be set as default');
        }
        this.setLocalSetting('defaultLibrary', { id: library === null || library === void 0 ? void 0 : library.id, assetId: library === null || library === void 0 ? void 0 : library.assetId });
        // We need to monitor the library for id changes, so that we can keep the local setting entry up to date.
        this._setDefaultLibraryMonitor();
    }
    _setDefaultLibraryMonitor() {
        var _a;
        // Clear any existing monitor.
        (_a = this._disposeDefaultLibraryMonitor) === null || _a === void 0 ? void 0 : _a.call(this);
        const defaultLibrary = this.getDefaultLibrary();
        if (defaultLibrary) {
            const { id, assetId } = defaultLibrary;
            const defaultLibraryMonitor = () => {
                if (defaultLibrary.id !== id || defaultLibrary.assetId !== assetId) {
                    // If the default library identifiers have changed, update the local setting entry.
                    this.setDefaultLibrary(defaultLibrary);
                }
            };
            // Keep a reference to the monitor so we can dispose of it later.
            this._disposeDefaultLibraryMonitor = () => defaultLibrary.off('change', defaultLibraryMonitor);
            defaultLibrary.on('change', defaultLibraryMonitor);
        }
    }
    /**
     * Sync Status information including overarching state and progress information
     *
     * @readonly
     * @type {SyncStatus}
     * @memberof CCLibraries
     */
    get syncState() {
        return this._libraryCache.syncStatus;
    }
    /**
     * @deprecated
     */
    get retryTime() {
        return undefined;
    }
    /**
     * @deprecated
     */
    getTempDir(library) {
        return this.driver.getTempDir(library);
    }
    /*
     * END: Sync stubs
     */
    get fontManager() {
        return this._fontManager;
    }
    get isLocallyManaged() {
        return this.driver instanceof LocalDriver;
    }
    /**
     * Publishes a brand.
     * NOTE: The brand role must be set on a brand's app metadata before it can be published.
     * @param brand The brand that should be published
     */
    publishBrand(brand) {
        return this._driver.publishBrand(brand);
    }
    /**
     * Unpublish a brand.
     * @param brand The brand that should be unpublished.
     */
    unpublishBrand(brand) {
        return this._driver.unpublishBrand(brand);
    }
}
/* Utils */
/**
 * The {@link LibraryError} class, which gives you access to all the error codes.
 *
 * @type {LibraryError}
 * @memberof CCLibraries
 */
CCLibraries.errors = LibraryError;
/**
 * @memberof CCLibraries
 */
CCLibraries.utils = {
    getExtensions,
    getMimeTypes
};
__decorate([
    observable
], CCLibraries.prototype, "options", null);
__decorate([
    observable
], CCLibraries.prototype, "libraries", null);
__decorate([
    observable
], CCLibraries.prototype, "getLibraries", null);
__decorate([
    observable
], CCLibraries.prototype, "getLibrariesPage", null);
__decorate([
    observable('driverConnect', 'driverDisconnect', 'loaded')
], CCLibraries.prototype, "connected", null);
__decorate([
    observable('loaded')
], CCLibraries.prototype, "areLibrariesLoaded", null);
__decorate([
    observable('loaded', 'sync')
], CCLibraries.prototype, "areLibrariesLoading", null);
__decorate([
    observable('configChange')
], CCLibraries.prototype, "userQuota", null);
__decorate([
    requiresLocalDriver,
    observable('configChange')
], CCLibraries.prototype, "processInfo", null);
__decorate([
    observable
], CCLibraries.prototype, "storageUsed", null);
__decorate([
    observable('teamChange')
], CCLibraries.prototype, "refreshTeams", null);
__decorate([
    observable('teamChange')
], CCLibraries.prototype, "refreshProjects", null);
__decorate([
    observable('teamChange')
], CCLibraries.prototype, "teams", null);
__decorate([
    observable('teamChange')
], CCLibraries.prototype, "projects", null);
__decorate([
    observable('configChange')
], CCLibraries.prototype, "userId", null);
__decorate([
    observable('configChange')
], CCLibraries.prototype, "getOption", null);
__decorate([
    observable('configChange')
], CCLibraries.prototype, "getLocalSetting", null);
__decorate([
    observable('driverConnect', 'driverDisconnect', 'loaded')
], CCLibraries.prototype, "isConnected", null);
__decorate([
    observable('driverConnect', 'driverDisconnect', 'loaded', 'connecting', 'failedConnection')
], CCLibraries.prototype, "connectionState", null);
__decorate([
    observable('configChange')
], CCLibraries.prototype, "isSyncingEnabled", null);
__decorate([
    observable('change', 'resolutionStatusChange')
], CCLibraries.prototype, "resolveCachedLibraryReference", null);
__decorate([
    observable('change', 'resolutionStatusChange')
], CCLibraries.prototype, "resolveCachedElementReference", null);
__decorate([
    observable('change', 'resolutionStatusChange')
], CCLibraries.prototype, "resolveCachedElementReferenceToLibrary", null);
__decorate([
    observable('sync')
], CCLibraries.prototype, "syncState", null);
__decorate([
    requiresLocalDriver
], CCLibraries.prototype, "fontManager", null);
__decorate([
    requiresCloudDriver
], CCLibraries.prototype, "publishBrand", null);
__decorate([
    requiresCloudDriver
], CCLibraries.prototype, "unpublishBrand", null);

/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/
const utils = {
    mimeTypeToExtensions: getExtensions,
    extensionToMimeTypes: getMimeTypes,
    canComputeRenditionFromMimeType,
    getSNISettings: () => ({
        TLS_DISCOVERY_PORT_RANGE: tlsDiscoveryPortRange
    }),
    isPlaceholderId: isPlaceholder,
    parseLinkReference,
    serializeLinkReference,
    estimateUploadTime
};

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    utils: utils,
    LocalDriver: LocalDriver,
    CloudDriver: CloudDriver$1,
    HybridDriver: HybridDriver,
    cepConnector: cepConnector,
    ccdConnector: ccdConnector,
    nodeConnector: nodeConnector,
    uxpConnector: uxpConnector,
    ProgressiveLoader: ProgressiveLoader,
    Element: Element,
    LibraryContents: LibraryContents,
    Representation: Representation,
    Group: Group,
    'default': CCLibraries
});

var TOOLKIT_NAME_DEFAULT$o = "Vaše sada nástrojů";
var TOOLKIT_NAME_PHOTOSHOP$o = "Vaše knihovna aplikace Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$o = "Vaše vzorníky v aplikaci Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$o = "Vaše štětce v aplikaci Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$o = "Vaše přechody v aplikaci Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$o = "Vaše vzory v aplikaci Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$o = "Vaše styly v aplikaci Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$o = "Vaše tvary v aplikaci Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$o = "Vzorky barev předběžné verze aplikace Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$o = "Štětce předběžné verze aplikace Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$o = "Přechody předběžné verze aplikace Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$o = "Vzory předběžné verze aplikace Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$o = "Styly předběžné verze aplikace Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$o = "Tvary předběžné verze aplikace Ps";
var csCZ = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$o,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$o,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$o,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$o,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$o,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$o,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$o,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$o,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$o,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$o,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$o,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$o,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$o,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$o
};

var csCZ$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$o,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$o,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$o,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$o,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$o,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$o,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$o,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$o,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$o,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$o,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$o,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$o,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$o,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$o,
    'default': csCZ
});

var TOOLKIT_NAME_DEFAULT$n = "Din værktøjspakke";
var TOOLKIT_NAME_PHOTOSHOP$n = "Dit Photoshop-bibliotek";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$n = "Dine Photoshop-farveprøver";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$n = "Dine Photoshop-pensler";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$n = "Dine Photoshop-farveforløb";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$n = "Dine Photoshop-mønstre";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$n = "Dine Photoshop-typer";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$n = "Dine Photoshop-former";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$n = "Dine Ps Prerelease-farveprøver";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$n = "Dine Ps Prerelease-pensler";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$n = "Dine Ps Prerelease-farveforløb";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$n = "Dine Ps Prerelease-mønstre";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$n = "Dine Ps Prerelease-typer";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$n = "Dine Ps Prerelease-former";
var daDK = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$n,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$n,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$n,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$n,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$n,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$n,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$n,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$n,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$n,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$n,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$n,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$n,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$n,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$n
};

var daDK$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$n,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$n,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$n,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$n,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$n,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$n,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$n,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$n,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$n,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$n,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$n,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$n,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$n,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$n,
    'default': daDK
});

var TOOLKIT_NAME_DEFAULT$m = "Ihr Toolkit";
var TOOLKIT_NAME_PHOTOSHOP$m = "Ihre Photoshop-Bibliothek";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$m = "Ihre Photoshop-Farbfelder";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$m = "Ihre Photoshop-Pinsel";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$m = "Ihre Photoshop-Verläufe";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$m = "Ihre Photoshop-Muster";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$m = "Ihre Photoshop-Stile";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$m = "Ihre Photoshop-Formen";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$m = "Ihre Ps Prerelease-Farbfelder";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$m = "Ihre Ps Prerelease-Pinsel";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$m = "Ihre Ps Prerelease-Verläufe";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$m = "Ihre Ps Prerelease-Muster";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$m = "Ihre Ps Prerelease-Stile";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$m = "Ihre Ps Prerelease-Formen";
var deDE = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$m,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$m,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$m,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$m,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$m,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$m,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$m,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$m,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$m,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$m,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$m,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$m,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$m,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$m
};

var deDE$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$m,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$m,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$m,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$m,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$m,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$m,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$m,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$m,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$m,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$m,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$m,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$m,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$m,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$m,
    'default': deDE
});

var TOOLKIT_NAME_DEFAULT$l = "Your Toolkit";
var TOOLKIT_NAME_PHOTOSHOP$l = "Your Photoshop Library";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$l = "Your Photoshop Swatches";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$l = "Your Photoshop Brushes";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$l = "Your Photoshop Gradients";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$l = "Your Photoshop Patterns";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$l = "Your Photoshop Styles";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$l = "Your Photoshop Shapes";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$l = "Your Ps Prerelease Swatches";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$l = "Your Ps Prerelease Brushes";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$l = "Your Ps Prerelease Gradients";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$l = "Your Ps Prerelease Patterns";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$l = "Your Ps Prerelease Styles";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$l = "Your Ps Prerelease Shapes";
var enUS = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$l,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$l,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$l,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$l,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$l,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$l,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$l,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$l,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$l,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$l,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$l,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$l,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$l,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$l
};

var enUS$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$l,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$l,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$l,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$l,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$l,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$l,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$l,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$l,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$l,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$l,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$l,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$l,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$l,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$l,
    'default': enUS
});

var TOOLKIT_NAME_DEFAULT$k = "Su kit de herramientas";
var TOOLKIT_NAME_PHOTOSHOP$k = "Su biblioteca de Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$k = "Sus muestras de Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$k = "Sus pinceles de Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$k = "Sus degradados de Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$k = "Sus motivos de Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$k = "Sus estilos de Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$k = "Sus formas de Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$k = "Sus muestras de la versión previa de Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$k = "Sus pinceles de la versión previa de Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$k = "Sus degradados de la versión previa de Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$k = "Sus motivos de la versión previa de Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$k = "Sus estilos de la versión previa de Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$k = "Sus formas de la versión previa de Ps";
var esES = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$k,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$k,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$k,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$k,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$k,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$k,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$k,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$k,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$k,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$k,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$k,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$k,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$k,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$k
};

var esES$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$k,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$k,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$k,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$k,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$k,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$k,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$k,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$k,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$k,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$k,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$k,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$k,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$k,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$k,
    'default': esES
});

var TOOLKIT_NAME_DEFAULT$j = "Oma työkalusarja";
var TOOLKIT_NAME_PHOTOSHOP$j = "Oma Photoshop-kirjasto";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$j = "Omat Photoshop-värimallit";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$j = "Omat Photoshop-siveltimet";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$j = "Omat Photoshop-liukuvärit";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$j = "Omat Photoshop-kuviot";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$j = "Omat Photoshop-tyylit";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$j = "Omat Photoshop-muodot";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$j = "Omat Ps Prerelease -värimallit";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$j = "Omat Ps Prerelease -siveltimet";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$j = "Omat Ps Prerelease -liukuvärit";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$j = "Omat Ps Prerelease -kuviot";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$j = "Omat Ps Prerelease -tyylit";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$j = "Omat Ps Prerelease -muodot";
var fiFI = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$j,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$j,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$j,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$j,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$j,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$j,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$j,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$j,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$j,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$j,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$j,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$j,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$j,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$j
};

var fiFI$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$j,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$j,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$j,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$j,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$j,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$j,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$j,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$j,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$j,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$j,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$j,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$j,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$j,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$j,
    'default': fiFI
});

var TOOLKIT_NAME_DEFAULT$i = "Votre boîte à outils";
var TOOLKIT_NAME_PHOTOSHOP$i = "Votre bibliothèque Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$i = "Vos nuances Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$i = "Vos pinceaux Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$i = "Vos dégradés Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$i = "Vos motifs Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$i = "Vos styles Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$i = "Vos formes Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$i = "Vos nuances Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$i = "Vos pinceaux Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$i = "Vos dégradés Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$i = "Vos motifs Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$i = "Vos styles Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$i = "Vos formes Version préliminaire Ps";
var frCA = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$i,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$i,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$i,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$i,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$i,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$i,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$i,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$i,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$i,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$i,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$i,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$i,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$i,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$i
};

var frCA$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$i,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$i,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$i,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$i,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$i,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$i,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$i,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$i,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$i,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$i,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$i,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$i,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$i,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$i,
    'default': frCA
});

var TOOLKIT_NAME_DEFAULT$h = "Votre boîte à outils";
var TOOLKIT_NAME_PHOTOSHOP$h = "Votre bibliothèque Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$h = "Vos nuances Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$h = "Vos pinceaux Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$h = "Vos dégradés Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$h = "Vos motifs Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$h = "Vos styles Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$h = "Vos formes Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$h = "Vos nuances Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$h = "Vos pinceaux Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$h = "Vos dégradés Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$h = "Vos motifs Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$h = "Vos styles Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$h = "Vos formes Version préliminaire Ps";
var frFR = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$h,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$h,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$h,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$h,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$h,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$h,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$h,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$h,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$h,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$h,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$h,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$h,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$h,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$h
};

var frFR$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$h,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$h,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$h,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$h,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$h,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$h,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$h,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$h,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$h,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$h,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$h,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$h,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$h,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$h,
    'default': frFR
});

var TOOLKIT_NAME_DEFAULT$g = "Votre boîte à outils";
var TOOLKIT_NAME_PHOTOSHOP$g = "Votre bibliothèque Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$g = "Vos nuances Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$g = "Vos pinceaux Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$g = "Vos dégradés Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$g = "Vos motifs Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$g = "Vos styles Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$g = "Vos formes Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$g = "Vos nuances Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$g = "Vos pinceaux Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$g = "Vos dégradés Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$g = "Vos motifs Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$g = "Vos styles Version préliminaire Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$g = "Vos formes Version préliminaire Ps";
var frMA = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$g,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$g,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$g,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$g,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$g,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$g,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$g,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$g,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$g,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$g,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$g,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$g,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$g,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$g
};

var frMA$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$g,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$g,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$g,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$g,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$g,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$g,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$g,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$g,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$g,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$g,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$g,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$g,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$g,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$g,
    'default': frMA
});

var TOOLKIT_NAME_DEFAULT$f = "Az Ön eszköztára";
var TOOLKIT_NAME_PHOTOSHOP$f = "Az Ön Photoshop könyvtára";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$f = "Az Ön Photoshop színtárai";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$f = "Az Ön Photoshop ecsetei";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$f = "Az Ön Photoshop színátmenetei";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$f = "Az Ön Photoshop mintái";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$f = "Az Ön Photoshop stílusai";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$f = "Az Ön Photoshop alakzatai";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$f = "PS előzetes kiadás – színtárak";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$f = "PS előzetes kiadás – ecsetek";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$f = "PS előzetes kiadás – színátmenetek";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$f = "PS előzetes kiadás – minták";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$f = "PS előzetes kiadás – stílusok";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$f = "PS előzetes kiadás – alakzatok";
var huHU = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$f,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$f,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$f,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$f,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$f,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$f,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$f,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$f,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$f,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$f,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$f,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$f,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$f,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$f
};

var huHU$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$f,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$f,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$f,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$f,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$f,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$f,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$f,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$f,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$f,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$f,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$f,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$f,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$f,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$f,
    'default': huHU
});

var TOOLKIT_NAME_DEFAULT$e = "Il vostro toolkit";
var TOOLKIT_NAME_PHOTOSHOP$e = "La vostra Libreria Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$e = "Campioni di Photoshop personali";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$e = "Pennelli di Photoshop personali";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$e = "Sfumature di Photoshop personali";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$e = "Pattern di Photoshop personali";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$e = "Stili di Photoshop personali";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$e = "Forme di Photoshop personali";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$e = "I campioni Ps Prerelease";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$e = "I pennelli Ps Prerelease";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$e = "Le sfumature Ps Prerelease";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$e = "I pattern Ps Prerelease";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$e = "Gli stili Ps Prerelease";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$e = "Le forme Ps Prerelease";
var itIT = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$e,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$e,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$e,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$e,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$e,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$e,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$e,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$e,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$e,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$e,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$e,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$e,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$e,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$e
};

var itIT$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$e,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$e,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$e,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$e,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$e,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$e,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$e,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$e,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$e,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$e,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$e,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$e,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$e,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$e,
    'default': itIT
});

var TOOLKIT_NAME_DEFAULT$d = "自分の Toolkit";
var TOOLKIT_NAME_PHOTOSHOP$d = "Photoshop ライブラリ";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$d = "あなたの Photoshop スウォッチ";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$d = "あなたの Photoshop ブラシ";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$d = "あなたの Photoshop グラデーション";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$d = "あなたの Photoshop パターン";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$d = "あなたの Photoshop スタイル";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$d = "あなたの Photoshop シェイプ";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$d = "Ps プレリリースのサンプル";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$d = "Ps プレリリースのブラシ";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$d = "Ps プレリリースのグラデーション";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$d = "Ps プレリリースのパターン";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$d = "Ps プレリリースのスタイル";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$d = "Ps プレリリースのシェイプ";
var jaJP = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$d,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$d,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$d,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$d,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$d,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$d,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$d,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$d,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$d,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$d,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$d,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$d,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$d,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$d
};

var jaJP$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$d,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$d,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$d,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$d,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$d,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$d,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$d,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$d,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$d,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$d,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$d,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$d,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$d,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$d,
    'default': jaJP
});

var TOOLKIT_NAME_DEFAULT$c = "툴킷";
var TOOLKIT_NAME_PHOTOSHOP$c = "Photoshop Library";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$c = "Photoshop 견본";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$c = "Photoshop 브러시";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$c = "Photoshop 그래디언트";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$c = "Photoshop 패턴";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$c = "Photoshop 스타일";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$c = "Photoshop 모양";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$c = "Ps 사전 릴리스 견본";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$c = "Ps 사전 릴리스 브러시";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$c = "Ps 사전 릴리스 그래디언트";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$c = "Ps 사전 릴리스 패턴";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$c = "Ps 사전 릴리스 스타일";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$c = "Ps 사전 릴리스 모양";
var koKR = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$c,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$c,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$c,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$c,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$c,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$c,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$c,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$c,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$c,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$c,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$c,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$c,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$c,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$c
};

var koKR$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$c,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$c,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$c,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$c,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$c,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$c,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$c,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$c,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$c,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$c,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$c,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$c,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$c,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$c,
    'default': koKR
});

var TOOLKIT_NAME_DEFAULT$b = "Ditt verktøysett";
var TOOLKIT_NAME_PHOTOSHOP$b = "Ditt Photoshop-bibliotek";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$b = "Dine Photoshop-fargekart";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$b = "Dine Photoshop-pensler";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$b = "Dine Photoshop-graderinger";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$b = "Dine Photoshop-mønstre";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$b = "Dine Photoshop-stiler";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$b = "Dine Photoshop-former";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$b = "Dine forhåndsutgivelsesfargekart for Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$b = "Dine forhåndsutgivelsespensler for Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$b = "Dine forhåndsutgivelsesgraderinger for Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$b = "Dine forhåndsutgivelsesmønstre for Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$b = "Dine forhåndsutgivelsesstiler for Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$b = "Dine forhåndsutgivelsesformer for Ps";
var nbNO = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$b,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$b,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$b,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$b,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$b,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$b,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$b,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$b,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$b,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$b,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$b,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$b,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$b,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$b
};

var nbNO$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$b,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$b,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$b,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$b,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$b,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$b,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$b,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$b,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$b,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$b,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$b,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$b,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$b,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$b,
    'default': nbNO
});

var TOOLKIT_NAME_DEFAULT$a = "Uw toolkit";
var TOOLKIT_NAME_PHOTOSHOP$a = "Uw Photoshop-bibliotheek";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$a = "Uw Photoshop-stalen";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$a = "Uw Photoshop-penselen";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$a = "Uw Photoshop-verlopen";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$a = "Uw Photoshop-patronen";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$a = "Uw Photoshop-stijlen";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$a = "Uw Photoshop-vormen";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$a = "Ps Prerelease-stalen";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$a = "Ps Prerelease-penselen";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$a = "Ps Prerelease-verlopen";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$a = "Ps Prerelease-patronen";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$a = "Ps Prerelease-stijlen";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$a = "Ps Prerelease-vormen";
var nlNL = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$a,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$a,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$a,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$a,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$a,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$a,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$a,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$a,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$a,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$a,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$a,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$a,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$a,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$a
};

var nlNL$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$a,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$a,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$a,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$a,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$a,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$a,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$a,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$a,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$a,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$a,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$a,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$a,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$a,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$a,
    'default': nlNL
});

var TOOLKIT_NAME_DEFAULT$9 = "Twój zestaw narzędzi";
var TOOLKIT_NAME_PHOTOSHOP$9 = "Biblioteka programu Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$9 = "Próbki programu Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$9 = "Pędzle programu Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$9 = "Gradienty programu Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$9 = "Wzory programu Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$9 = "Style programu Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$9 = "Kształty programu Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$9 = "Próbki we wstępnym wydaniu Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$9 = "Pędzle we wstępnym wydaniu Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$9 = "Gradienty we wstępnym wydaniu Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$9 = "Wzory we wstępnym wydaniu Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$9 = "Style we wstępnym wydaniu Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$9 = "Kształty we wstępnym wydaniu Ps";
var plPL = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$9,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$9,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$9,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$9,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$9,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$9,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$9,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$9,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$9,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$9,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$9,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$9,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$9,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$9
};

var plPL$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$9,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$9,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$9,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$9,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$9,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$9,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$9,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$9,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$9,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$9,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$9,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$9,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$9,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$9,
    'default': plPL
});

var TOOLKIT_NAME_DEFAULT$8 = "Seu kit de ferramentas";
var TOOLKIT_NAME_PHOTOSHOP$8 = "Sua biblioteca do Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$8 = "Suas amostras do Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$8 = "Seus pincéis do Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$8 = "Seus gradientes do Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$8 = "Seus padrões do Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$8 = "Seus estilos do Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$8 = "Suas formas do Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$8 = "Suas amostras de pré-lançamento do Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$8 = "Seus pincéis de pré-lançamento do Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$8 = "Seus gradientes de pré-lançamento do Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$8 = "Seus padrões de pré-lançamento do Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$8 = "Seus estilos de pré-lançamento do Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$8 = "Suas formas de pré-lançamento do Ps";
var ptBR = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$8,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$8,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$8,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$8,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$8,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$8,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$8,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$8,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$8,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$8,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$8,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$8,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$8,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$8
};

var ptBR$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$8,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$8,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$8,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$8,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$8,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$8,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$8,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$8,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$8,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$8,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$8,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$8,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$8,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$8,
    'default': ptBR
});

var TOOLKIT_NAME_DEFAULT$7 = "Инструменты";
var TOOLKIT_NAME_PHOTOSHOP$7 = "Библиотека Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$7 = "Ваши образцы Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$7 = "Ваши кисти Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$7 = "Ваши градиенты Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$7 = "Ваши узоры Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$7 = "Ваши стили Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$7 = "Ваши фигуры Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$7 = "Ваши образцы предв. версии Ps";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$7 = "Ваши кисти предв. версии Ps";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$7 = "Ваши градиенты предв. версии Ps";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$7 = "Ваши узоры предв. версии Ps";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$7 = "Ваши стили предв. версии Ps";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$7 = "Ваши фигуры предв. версии Ps";
var ruRU = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$7,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$7,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$7,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$7,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$7,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$7,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$7,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$7,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$7,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$7,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$7,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$7,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$7,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$7
};

var ruRU$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$7,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$7,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$7,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$7,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$7,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$7,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$7,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$7,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$7,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$7,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$7,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$7,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$7,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$7,
    'default': ruRU
});

var TOOLKIT_NAME_DEFAULT$6 = "Ditt Toolkit";
var TOOLKIT_NAME_PHOTOSHOP$6 = "Ditt Photoshop-bibliotek";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$6 = "Dina Photoshop-färgrutor";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$6 = "Dina Photoshop-penslar";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$6 = "Dina Photoshop-övertoningar";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$6 = "Dina Photoshop-mönster";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$6 = "Dina Photoshop-format";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$6 = "Dina Photoshop-former";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$6 = "Färgrutor i den tidiga Ps-versionen";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$6 = "Penslar i den tidiga Ps-versionen";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$6 = "Övertoningar i den tidiga Ps-versionen";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$6 = "Mönster i den tidiga Ps-versionen";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$6 = "Format i den tidiga Ps-versionen";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$6 = "Former i den tidiga Ps-versionen";
var svSE = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$6,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$6,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$6,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$6,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$6,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$6,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$6,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$6,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$6,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$6,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$6,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$6,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$6,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$6
};

var svSE$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$6,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$6,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$6,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$6,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$6,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$6,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$6,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$6,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$6,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$6,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$6,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$6,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$6,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$6,
    'default': svSE
});

var TOOLKIT_NAME_DEFAULT$5 = "Araç Setiniz";
var TOOLKIT_NAME_PHOTOSHOP$5 = "Photoshop Kitaplığınız";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$5 = "Photoshop Renk Örnekleriniz";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$5 = "Photoshop Fırçalarınız";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$5 = "Photoshop Degradeleriniz";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$5 = "Photoshop Desenleriniz";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$5 = "Photoshop Stilleriniz";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$5 = "Photoshop Şekilleriniz";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$5 = "Ps Ön Sürüm Renk Örnekleriniz";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$5 = "Ps Ön Sürüm Fırçalarınız";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$5 = "Ps Ön Sürüm Degradeleriniz";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$5 = "Ps Ön Sürüm Desenleriniz";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$5 = "Ps Ön Sürüm Stilleriniz";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$5 = "Ps Ön Sürüm Şekilleriniz";
var trTR = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$5,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$5,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$5,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$5,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$5,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$5,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$5,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$5,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$5,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$5,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$5,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$5,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$5,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$5
};

var trTR$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$5,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$5,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$5,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$5,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$5,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$5,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$5,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$5,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$5,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$5,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$5,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$5,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$5,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$5,
    'default': trTR
});

var TOOLKIT_NAME_DEFAULT$4 = "Мій інструментарій";
var TOOLKIT_NAME_PHOTOSHOP$4 = "Моя бібліотека Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$4 = "Ваші зразки робіт, створені за допомогою Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$4 = "Ваші пензлі Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$4 = "Ваші градієнти Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$4 = "Ваші візерунки Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$4 = "Ваші стилі Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$4 = "Ваші фігури Photoshop";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$4 = "Ваші зразки Ps, доступні напередодні випуску";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$4 = "Ваші пензлі Ps, доступні напередодні випуску";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$4 = "Ваші градієнти Ps, доступні напередодні випуску";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$4 = "Ваші візерунки Ps, доступні напередодні випуску";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$4 = "Ваші стилі Ps, доступні напередодні випуску";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$4 = "Ваші фігури Ps, доступні напередодні випуску";
var ukUA = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$4,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$4,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$4,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$4,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$4,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$4,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$4,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$4,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$4,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$4,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$4,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$4,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$4,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$4
};

var ukUA$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$4,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$4,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$4,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$4,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$4,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$4,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$4,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$4,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$4,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$4,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$4,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$4,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$4,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$4,
    'default': ukUA
});

var TOOLKIT_NAME_DEFAULT$3 = "您的工具箱";
var TOOLKIT_NAME_PHOTOSHOP$3 = "您的 Photoshop 库";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$3 = "您的 Photoshop 色板";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$3 = "您的 Photoshop 画笔";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$3 = "您的 Photoshop 渐变";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$3 = "您的 Photoshop 图案";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$3 = "您的 Photoshop 样式";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$3 = "您的 Photoshop 形状";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$3 = "您的 PS Prerelease 色板";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$3 = "您的 PS Prerelease 画笔";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$3 = "您的 PS Prerelease 渐变";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$3 = "您的 PS Prerelease 图案";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$3 = "您的 PS Prerelease 样式";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$3 = "您的 PS Prerelease 形状";
var zhCN = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$3,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$3,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$3,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$3,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$3,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$3,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$3,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$3,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$3,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$3,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$3,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$3,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$3,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$3
};

var zhCN$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$3,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$3,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$3,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$3,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$3,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$3,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$3,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$3,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$3,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$3,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$3,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$3,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$3,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$3,
    'default': zhCN
});

var TOOLKIT_NAME_DEFAULT$2 = "您的工具組。";
var TOOLKIT_NAME_PHOTOSHOP$2 = "您的 Photoshop 資料庫";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$2 = "您的 Photoshop 色票";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$2 = "您的 Photoshop 筆刷";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$2 = "您的 Photoshop 漸層";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$2 = "您的 Photoshop 圖樣圖樣";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$2 = "您的 Photoshop 樣式";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$2 = "您的 Photoshop 形狀";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$2 = "您的 Ps 預先發佈色票";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$2 = "您的 Ps 預先發佈筆刷";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$2 = "您的 Ps 預先發佈漸層";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$2 = "您的 Ps 預先發佈圖樣";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$2 = "您的 Ps 預先發佈樣式";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$2 = "您的 Ps 預先發佈形狀";
var zhTW = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$2,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$2,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$2,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$2,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$2,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$2,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$2,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$2,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$2,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$2,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$2,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$2,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$2,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$2
};

var zhTW$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$2,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$2,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$2,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$2,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$2,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$2,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$2,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$2,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$2,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$2,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$2,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$2,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$2,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$2,
    'default': zhTW
});

var TOOLKIT_NAME_DEFAULT$1 = "Your Toolkit";
var TOOLKIT_NAME_PHOTOSHOP$1 = "Your Photoshop Library";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES$1 = "Your Photoshop Swatches";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES$1 = "Your Photoshop Brushes";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$1 = "Your Photoshop Gradients";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS$1 = "Your Photoshop Patterns";
var TOOLKIT_NAME_PHOTOSHOP_STYLES$1 = "Your Photoshop Styles";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES$1 = "Your Photoshop Shapes";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$1 = "Your Ps Prerelease Swatches";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$1 = "Your Ps Prerelease Brushes";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$1 = "Your Ps Prerelease Gradients";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$1 = "Your Ps Prerelease Patterns";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$1 = "Your Ps Prerelease Styles";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$1 = "Your Ps Prerelease Shapes";
var zuZU = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$1,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$1,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$1,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$1,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$1,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$1,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$1,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$1,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$1,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$1,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$1,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$1,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$1,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$1
};

var zuZU$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT$1,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP$1,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES$1,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES$1,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS$1,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS$1,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES$1,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES$1,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR$1,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR$1,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR$1,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR$1,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR$1,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR$1,
    'default': zuZU
});

var TOOLKIT_NAME_DEFAULT = "[u] ćčŁįb_Your Toolkit";
var TOOLKIT_NAME_PHOTOSHOP = "[t] ćčŁįb_Your Photoshop Library";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES = "[m] ćčŁįb_Your Photoshop Swatches";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES = "[i] ćčŁįb_Your Photoshop Brushes";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS = "[h] ćčŁįb_Your Photoshop Gradients";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS = "[j] ćčŁįb_Your Photoshop Patterns";
var TOOLKIT_NAME_PHOTOSHOP_STYLES = "[l] ćčŁįb_Your Photoshop Styles";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES = "[k] ćčŁįb_Your Photoshop Shapes";
var TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR = "[qB] ćčŁįb_Your Ps Prerelease Swatches";
var TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR = "[p+] ćčŁįb_Your Ps Prerelease Brushes";
var TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR = "[p8] ćčŁįb_Your Ps Prerelease Gradients";
var TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR = "[p9] ćčŁįb_Your Ps Prerelease Patterns";
var TOOLKIT_NAME_PHOTOSHOP_STYLES_PR = "[qA] ćčŁįb_Your Ps Prerelease Styles";
var TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR = "[p/] ćčŁįb_Your Ps Prerelease Shapes";
var zzZZ = {
	TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT,
	TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS,
	TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES,
	TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR,
	TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR,
	TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR,
	TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR,
	TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR,
	TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR
};

var zzZZ$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TOOLKIT_NAME_DEFAULT: TOOLKIT_NAME_DEFAULT,
    TOOLKIT_NAME_PHOTOSHOP: TOOLKIT_NAME_PHOTOSHOP,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES: TOOLKIT_NAME_PHOTOSHOP_SWATCHES,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES: TOOLKIT_NAME_PHOTOSHOP_BRUSHES,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS: TOOLKIT_NAME_PHOTOSHOP_PATTERNS,
    TOOLKIT_NAME_PHOTOSHOP_STYLES: TOOLKIT_NAME_PHOTOSHOP_STYLES,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES: TOOLKIT_NAME_PHOTOSHOP_SHAPES,
    TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR: TOOLKIT_NAME_PHOTOSHOP_SWATCHES_PR,
    TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR: TOOLKIT_NAME_PHOTOSHOP_BRUSHES_PR,
    TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR: TOOLKIT_NAME_PHOTOSHOP_GRADIENTS_PR,
    TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR: TOOLKIT_NAME_PHOTOSHOP_PATTERNS_PR,
    TOOLKIT_NAME_PHOTOSHOP_STYLES_PR: TOOLKIT_NAME_PHOTOSHOP_STYLES_PR,
    TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR: TOOLKIT_NAME_PHOTOSHOP_SHAPES_PR,
    'default': zzZZ
});

export { AddressBookOrder, AdobeAssetFilter, USSAdobeAssetOrder as AdobeAssetGlobalSearchOrder, AdobeAssetOrder, AssetLinkPost, AssetListStatus, AssetSyncStatus, AssetSyncSuspensionReason, AssetType, AssetVersion, AssetVersionFilter, AssetVersionOrder, AssignmentFilter, AssignmentOrder, AssignmentStatus, AssignmentSubmissionOwnershipEnums, AssignmentTaskIDEnums, AvatarSizes, Board, BoardFilter, BoardOrder, BrandPublishMetadataFilter, CHANGE, COLLABORATOR_CHANGED, COMMENTS_CHANGED, CanCreateProjectReason, CannotMoveReason, ClassroomMember, ClassroomMemberFilter, ClassroomMemberOrder, ClassroomMemberRole, ClassroomOrder, ClassroomStatus, ClassroomType, CloudSyncStatus, CollaboratorOrder, CollaboratorUpdater, CollaboratorsByAssetIDOrder, Comment, CommentsResource, CommitStatus, CustomModelFilter$1 as CustomModelFilter, CustomModelOrder, CustomModelPublishedState$1 as CustomModelPublishedState, DEFAULT_CACHE_KEEP_ALIVE_TTL, Env, FRAMEIO_REVIEW_LINKS_CHANGE, FavoriteAdobeAssetOrder, FrameioContext, GenerationHistoryAssetFilter, GenerationHistoryAssetOrder, GenerationHistoryAssetState, GenerationHistoryAssetType, Gradient, AddressBookContactOrder as GroupMemberOrder, IFrameioAuthenticationStatus, ITEM_LIST_STATE_CHANGED, ImportSourceType, InvitedCollaboratorOrder, ItemBase, LIBRARY_DATA_CHANGED, LIST_CHANGED, LearningManagementSystems, CustomModelFilter as LegacyCustomModelFilter, LegacyCustomModelOrder, CustomModelPublishedState as LegacyCustomModelPublishedState, LibraryFilter, LibraryOrder, LibraryOwnerFilter, LibraryProjectFilterEnum, LibraryRolesFilter, LogLevel, MESSAGE_LOGGED, MRUAdobeAssetOrder, MembershipStatus, MoveWarning, NetworkStatus$1 as NetworkStatus, OrderDirection, OrderField, OrgRepositoryOrder, OrgRepositoryUpdater, PERMISSION_ALL, Permission, PostOrder, PostType, ProjectDirectorySubtype, ProjectFilter, ProjectLeaveReason, ProjectOrder, ProjectViews, USSAdobeAssetOrder as ProjectsSearchOrder, PublishedAdobeAssetOrder, RESTRICT_EDIT_CHANGED, USSAdobeAssetOrder as RecentAdobeAssetOrder, RelType, RenditionSize, RenditionStatus, RenditionTile, RenditionType, RosterImportState, SAMError, SAMErrorCode, SAMErrorSubCode, STATE_CHANGED, SWYAdobeAssetOrder, USSAdobeAssetOrder as SearchAdobeAssetOrder, SpaceFilter, SpaceOrder, SpaceUpdater, StudentAssignmentFile, StudentAssignmentFileFilter, StudentAssignmentFileOrder, StudentAssignmentFilesListFilter, StudentAssignmentFilter, StudentAssignmentOrder, StudentAssignmentOwner, StudentAssignmentStatus, SubjectTypes, Team$1 as Team, TeamFilter, TeamOrder, TextPost, USSAdobeAssetFilter, createSharedAssetModel, utils$1 as generationHistoryUtils, getURLFromLinks, hasProperty, initializeSharedAssetModel, parseAsyncResponse$1 as parseAsyncResponse, samJsUuid };
//# sourceMappingURL=index.js.map
